
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire82b7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire82b7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2nzLi", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $1bb9784afa87e369$export$ffb0004e005737fa; }, function (v) { return $1bb9784afa87e369$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $1bb9784afa87e369$export$34b9dba7ce09269b; }, function (v) { return $1bb9784afa87e369$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $1bb9784afa87e369$export$25062201e9e25d76; }, function (v) { return $1bb9784afa87e369$export$25062201e9e25d76 = v; });
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bb9784afa87e369$export$ffb0004e005737fa;
var $1bb9784afa87e369$export$34b9dba7ce09269b;
var $1bb9784afa87e369$export$25062201e9e25d76;
"use strict";
parcelRequire("013Yp");

var $7fPBF = parcelRequire("7fPBF");
var $1bb9784afa87e369$var$g = 60103;
$1bb9784afa87e369$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $1bb9784afa87e369$var$h = Symbol.for;
    $1bb9784afa87e369$var$g = $1bb9784afa87e369$var$h("react.element");
    $1bb9784afa87e369$export$ffb0004e005737fa = $1bb9784afa87e369$var$h("react.fragment");
}
var $1bb9784afa87e369$var$m = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $1bb9784afa87e369$var$n = Object.prototype.hasOwnProperty, $1bb9784afa87e369$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1bb9784afa87e369$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$1bb9784afa87e369$var$n.call(a, b) && !$1bb9784afa87e369$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $1bb9784afa87e369$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $1bb9784afa87e369$var$m.current
    };
}
$1bb9784afa87e369$export$34b9dba7ce09269b = $1bb9784afa87e369$var$q;
$1bb9784afa87e369$export$25062201e9e25d76 = $1bb9784afa87e369$var$q;

});
parcelRegister("013Yp", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $00332d224329ec89$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $00332d224329ec89$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $00332d224329ec89$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $00332d224329ec89$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $00332d224329ec89$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $00332d224329ec89$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $00332d224329ec89$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($00332d224329ec89$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($00332d224329ec89$var$getOwnPropertySymbols) {
            symbols = $00332d224329ec89$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($00332d224329ec89$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("7fPBF", function(module, exports) {
"use strict";

module.exports = (parcelRequire("fSPLm"));

});
parcelRegister("fSPLm", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $b9040d2deeb360f4$export$ffb0004e005737fa; }, function (v) { return $b9040d2deeb360f4$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b9040d2deeb360f4$export$5f8d39834fd61797; }, function (v) { return $b9040d2deeb360f4$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Profiler", function () { return $b9040d2deeb360f4$export$e2c29f18771995cb; }, function (v) { return $b9040d2deeb360f4$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "Suspense", function () { return $b9040d2deeb360f4$export$74bf444e3cd11ea5; }, function (v) { return $b9040d2deeb360f4$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "Children", function () { return $b9040d2deeb360f4$export$dca3b0875bd9a954; }, function (v) { return $b9040d2deeb360f4$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $b9040d2deeb360f4$export$16fa2f45be04daa8; }, function (v) { return $b9040d2deeb360f4$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "PureComponent", function () { return $b9040d2deeb360f4$export$221d75b3f55bb0bd; }, function (v) { return $b9040d2deeb360f4$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b9040d2deeb360f4$export$ae55be85d98224ed; }, function (v) { return $b9040d2deeb360f4$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $b9040d2deeb360f4$export$e530037191fcd5d7; }, function (v) { return $b9040d2deeb360f4$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $b9040d2deeb360f4$export$fd42f52fd3ae1109; }, function (v) { return $b9040d2deeb360f4$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $b9040d2deeb360f4$export$c8a8987d4410bf2d; }, function (v) { return $b9040d2deeb360f4$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $b9040d2deeb360f4$export$d38cd72104c1f0e9; }, function (v) { return $b9040d2deeb360f4$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43; }, function (v) { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $b9040d2deeb360f4$export$257a8862b851cb5b; }, function (v) { return $b9040d2deeb360f4$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $b9040d2deeb360f4$export$a8257692ac88316c; }, function (v) { return $b9040d2deeb360f4$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $b9040d2deeb360f4$export$488013bae63b21da; }, function (v) { return $b9040d2deeb360f4$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $b9040d2deeb360f4$export$7c73462e0d25e514; }, function (v) { return $b9040d2deeb360f4$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "useCallback", function () { return $b9040d2deeb360f4$export$35808ee640e87ca7; }, function (v) { return $b9040d2deeb360f4$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $b9040d2deeb360f4$export$fae74005e78b1a27; }, function (v) { return $b9040d2deeb360f4$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e; }, function (v) { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useEffect", function () { return $b9040d2deeb360f4$export$6d9c69b0de29b591; }, function (v) { return $b9040d2deeb360f4$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $b9040d2deeb360f4$export$d5a552a76deda3c2; }, function (v) { return $b9040d2deeb360f4$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $b9040d2deeb360f4$export$e5c5a5f917a5871c; }, function (v) { return $b9040d2deeb360f4$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $b9040d2deeb360f4$export$1538c33de8887b59; }, function (v) { return $b9040d2deeb360f4$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $b9040d2deeb360f4$export$13e3392192263954; }, function (v) { return $b9040d2deeb360f4$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $b9040d2deeb360f4$export$b8f5890fc79d6aca; }, function (v) { return $b9040d2deeb360f4$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $b9040d2deeb360f4$export$60241385465d0a34; }, function (v) { return $b9040d2deeb360f4$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "version", function () { return $b9040d2deeb360f4$export$83d89fbfd8236492; }, function (v) { return $b9040d2deeb360f4$export$83d89fbfd8236492 = v; });
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b9040d2deeb360f4$export$ffb0004e005737fa;
var $b9040d2deeb360f4$export$5f8d39834fd61797;
var $b9040d2deeb360f4$export$e2c29f18771995cb;
var $b9040d2deeb360f4$export$74bf444e3cd11ea5;
var $b9040d2deeb360f4$export$dca3b0875bd9a954;
var $b9040d2deeb360f4$export$16fa2f45be04daa8;
var $b9040d2deeb360f4$export$221d75b3f55bb0bd;
var $b9040d2deeb360f4$export$ae55be85d98224ed;
var $b9040d2deeb360f4$export$e530037191fcd5d7;
var $b9040d2deeb360f4$export$fd42f52fd3ae1109;
var $b9040d2deeb360f4$export$c8a8987d4410bf2d;
var $b9040d2deeb360f4$export$d38cd72104c1f0e9;
var $b9040d2deeb360f4$export$7d1e3a5e95ceca43;
var $b9040d2deeb360f4$export$257a8862b851cb5b;
var $b9040d2deeb360f4$export$a8257692ac88316c;
var $b9040d2deeb360f4$export$488013bae63b21da;
var $b9040d2deeb360f4$export$7c73462e0d25e514;
var $b9040d2deeb360f4$export$35808ee640e87ca7;
var $b9040d2deeb360f4$export$fae74005e78b1a27;
var $b9040d2deeb360f4$export$dc8fbce3eb94dc1e;
var $b9040d2deeb360f4$export$6d9c69b0de29b591;
var $b9040d2deeb360f4$export$d5a552a76deda3c2;
var $b9040d2deeb360f4$export$e5c5a5f917a5871c;
var $b9040d2deeb360f4$export$1538c33de8887b59;
var $b9040d2deeb360f4$export$13e3392192263954;
var $b9040d2deeb360f4$export$b8f5890fc79d6aca;
var $b9040d2deeb360f4$export$60241385465d0a34;
var $b9040d2deeb360f4$export$83d89fbfd8236492;
"use strict";

var $013Yp = parcelRequire("013Yp");
var $b9040d2deeb360f4$var$n = 60103, $b9040d2deeb360f4$var$p = 60106;
$b9040d2deeb360f4$export$ffb0004e005737fa = 60107;
$b9040d2deeb360f4$export$5f8d39834fd61797 = 60108;
$b9040d2deeb360f4$export$e2c29f18771995cb = 60114;
var $b9040d2deeb360f4$var$q = 60109, $b9040d2deeb360f4$var$r = 60110, $b9040d2deeb360f4$var$t = 60112;
$b9040d2deeb360f4$export$74bf444e3cd11ea5 = 60113;
var $b9040d2deeb360f4$var$u = 60115, $b9040d2deeb360f4$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $b9040d2deeb360f4$var$w = Symbol.for;
    $b9040d2deeb360f4$var$n = $b9040d2deeb360f4$var$w("react.element");
    $b9040d2deeb360f4$var$p = $b9040d2deeb360f4$var$w("react.portal");
    $b9040d2deeb360f4$export$ffb0004e005737fa = $b9040d2deeb360f4$var$w("react.fragment");
    $b9040d2deeb360f4$export$5f8d39834fd61797 = $b9040d2deeb360f4$var$w("react.strict_mode");
    $b9040d2deeb360f4$export$e2c29f18771995cb = $b9040d2deeb360f4$var$w("react.profiler");
    $b9040d2deeb360f4$var$q = $b9040d2deeb360f4$var$w("react.provider");
    $b9040d2deeb360f4$var$r = $b9040d2deeb360f4$var$w("react.context");
    $b9040d2deeb360f4$var$t = $b9040d2deeb360f4$var$w("react.forward_ref");
    $b9040d2deeb360f4$export$74bf444e3cd11ea5 = $b9040d2deeb360f4$var$w("react.suspense");
    $b9040d2deeb360f4$var$u = $b9040d2deeb360f4$var$w("react.memo");
    $b9040d2deeb360f4$var$v = $b9040d2deeb360f4$var$w("react.lazy");
}
var $b9040d2deeb360f4$var$x = "function" === typeof Symbol && Symbol.iterator;
function $b9040d2deeb360f4$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b9040d2deeb360f4$var$x && a[$b9040d2deeb360f4$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $b9040d2deeb360f4$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b9040d2deeb360f4$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $b9040d2deeb360f4$var$B = {};
function $b9040d2deeb360f4$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$B;
    this.updater = c || $b9040d2deeb360f4$var$A;
}
$b9040d2deeb360f4$var$C.prototype.isReactComponent = {};
$b9040d2deeb360f4$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($b9040d2deeb360f4$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$b9040d2deeb360f4$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $b9040d2deeb360f4$var$D() {}
$b9040d2deeb360f4$var$D.prototype = $b9040d2deeb360f4$var$C.prototype;
function $b9040d2deeb360f4$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$B;
    this.updater = c || $b9040d2deeb360f4$var$A;
}
var $b9040d2deeb360f4$var$F = $b9040d2deeb360f4$var$E.prototype = new $b9040d2deeb360f4$var$D;
$b9040d2deeb360f4$var$F.constructor = $b9040d2deeb360f4$var$E;
$013Yp($b9040d2deeb360f4$var$F, $b9040d2deeb360f4$var$C.prototype);
$b9040d2deeb360f4$var$F.isPureReactComponent = !0;
var $b9040d2deeb360f4$var$G = {
    current: null
}, $b9040d2deeb360f4$var$H = Object.prototype.hasOwnProperty, $b9040d2deeb360f4$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b9040d2deeb360f4$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$b9040d2deeb360f4$var$H.call(b, e) && !$b9040d2deeb360f4$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $b9040d2deeb360f4$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $b9040d2deeb360f4$var$G.current
    };
}
function $b9040d2deeb360f4$var$K(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $b9040d2deeb360f4$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b9040d2deeb360f4$var$n;
}
function $b9040d2deeb360f4$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $b9040d2deeb360f4$var$M = /\/+/g;
function $b9040d2deeb360f4$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $b9040d2deeb360f4$var$escape("" + a.key) : b.toString(36);
}
function $b9040d2deeb360f4$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $b9040d2deeb360f4$var$n:
                case $b9040d2deeb360f4$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $b9040d2deeb360f4$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($b9040d2deeb360f4$var$M, "$&/") + "/"), $b9040d2deeb360f4$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($b9040d2deeb360f4$var$L(d) && (d = $b9040d2deeb360f4$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($b9040d2deeb360f4$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $b9040d2deeb360f4$var$N(k, g);
        h += $b9040d2deeb360f4$var$O(k, b, c, f, d);
    }
    else if (f = $b9040d2deeb360f4$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $b9040d2deeb360f4$var$N(k, g++), h += $b9040d2deeb360f4$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($b9040d2deeb360f4$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $b9040d2deeb360f4$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $b9040d2deeb360f4$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $b9040d2deeb360f4$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $b9040d2deeb360f4$var$R = {
    current: null
};
function $b9040d2deeb360f4$var$S() {
    var a = $b9040d2deeb360f4$var$R.current;
    if (null === a) throw Error($b9040d2deeb360f4$var$z(321));
    return a;
}
var $b9040d2deeb360f4$var$T = {
    ReactCurrentDispatcher: $b9040d2deeb360f4$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $b9040d2deeb360f4$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $013Yp
};
$b9040d2deeb360f4$export$dca3b0875bd9a954 = {
    map: $b9040d2deeb360f4$var$P,
    forEach: function(a, b, c) {
        $b9040d2deeb360f4$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $b9040d2deeb360f4$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $b9040d2deeb360f4$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$b9040d2deeb360f4$var$L(a)) throw Error($b9040d2deeb360f4$var$z(143));
        return a;
    }
};
$b9040d2deeb360f4$export$16fa2f45be04daa8 = $b9040d2deeb360f4$var$C;
$b9040d2deeb360f4$export$221d75b3f55bb0bd = $b9040d2deeb360f4$var$E;
$b9040d2deeb360f4$export$ae55be85d98224ed = $b9040d2deeb360f4$var$T;
$b9040d2deeb360f4$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($b9040d2deeb360f4$var$z(267, a));
    var e = $013Yp({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $b9040d2deeb360f4$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$b9040d2deeb360f4$var$H.call(b, f) && !$b9040d2deeb360f4$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $b9040d2deeb360f4$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$b9040d2deeb360f4$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $b9040d2deeb360f4$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $b9040d2deeb360f4$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$b9040d2deeb360f4$export$c8a8987d4410bf2d = $b9040d2deeb360f4$var$J;
$b9040d2deeb360f4$export$d38cd72104c1f0e9 = function(a) {
    var b = $b9040d2deeb360f4$var$J.bind(null, a);
    b.type = a;
    return b;
};
$b9040d2deeb360f4$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$b9040d2deeb360f4$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$t,
        render: a
    };
};
$b9040d2deeb360f4$export$a8257692ac88316c = $b9040d2deeb360f4$var$L;
$b9040d2deeb360f4$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $b9040d2deeb360f4$var$Q
    };
};
$b9040d2deeb360f4$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$b9040d2deeb360f4$export$35808ee640e87ca7 = function(a, b) {
    return $b9040d2deeb360f4$var$S().useCallback(a, b);
};
$b9040d2deeb360f4$export$fae74005e78b1a27 = function(a, b) {
    return $b9040d2deeb360f4$var$S().useContext(a, b);
};
$b9040d2deeb360f4$export$dc8fbce3eb94dc1e = function() {};
$b9040d2deeb360f4$export$6d9c69b0de29b591 = function(a, b) {
    return $b9040d2deeb360f4$var$S().useEffect(a, b);
};
$b9040d2deeb360f4$export$d5a552a76deda3c2 = function(a, b, c) {
    return $b9040d2deeb360f4$var$S().useImperativeHandle(a, b, c);
};
$b9040d2deeb360f4$export$e5c5a5f917a5871c = function(a, b) {
    return $b9040d2deeb360f4$var$S().useLayoutEffect(a, b);
};
$b9040d2deeb360f4$export$1538c33de8887b59 = function(a, b) {
    return $b9040d2deeb360f4$var$S().useMemo(a, b);
};
$b9040d2deeb360f4$export$13e3392192263954 = function(a, b, c) {
    return $b9040d2deeb360f4$var$S().useReducer(a, b, c);
};
$b9040d2deeb360f4$export$b8f5890fc79d6aca = function(a) {
    return $b9040d2deeb360f4$var$S().useRef(a);
};
$b9040d2deeb360f4$export$60241385465d0a34 = function(a) {
    return $b9040d2deeb360f4$var$S().useState(a);
};
$b9040d2deeb360f4$export$83d89fbfd8236492 = "17.0.2";

});



parcelRegister("6EA3T", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";

var $7fPBF = parcelRequire("7fPBF");

var $013Yp = parcelRequire("013Yp");

var $33s19 = parcelRequire("33s19");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$7fPBF) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $013Yp({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $7fPBF.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $013Yp({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $013Yp({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $013Yp({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $33s19.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $33s19.unstable_scheduleCallback($33s19.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $33s19.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $33s19.unstable_UserBlockingPriority, ed = $33s19.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $013Yp(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $013Yp({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $013Yp({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $013Yp({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $013Yp({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $013Yp({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $013Yp({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $013Yp({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $013Yp({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $013Yp({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $013Yp({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $013Yp({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $013Yp({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $013Yp({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $33s19.unstable_runWithPriority, Of = $33s19.unstable_scheduleCallback, Pf = $33s19.unstable_cancelCallback, Qf = $33s19.unstable_shouldYield, Rf = $33s19.unstable_requestPaint, Sf = $33s19.unstable_now, Tf = $33s19.unstable_getCurrentPriorityLevel, Uf = $33s19.unstable_ImmediatePriority, Vf = $33s19.unstable_UserBlockingPriority, Wf = $33s19.unstable_NormalPriority, Xf = $33s19.unstable_LowPriority, Yf = $33s19.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $013Yp({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $013Yp({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $7fPBF.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $013Yp({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $013Yp({}, e, {
                    value: void 0
                });
                d = $013Yp({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $013Yp({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("33s19", function(module, exports) {
"use strict";

module.exports = (parcelRequire("a0C75"));

});
parcelRegister("a0C75", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $749777fefd570b40$export$c4744153514ff05d; }, function (v) { return $749777fefd570b40$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $749777fefd570b40$export$b5836b71941fa3ed; }, function (v) { return $749777fefd570b40$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $749777fefd570b40$export$d66a1c1c77bd778b; }, function (v) { return $749777fefd570b40$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $749777fefd570b40$export$3e506c1ccc9cc1a7; }, function (v) { return $749777fefd570b40$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $749777fefd570b40$export$e26fe2ed2fa76875; }, function (v) { return $749777fefd570b40$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $749777fefd570b40$export$502329bbf4b505b1; }, function (v) { return $749777fefd570b40$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $749777fefd570b40$export$6e3807111c4874c4; }, function (v) { return $749777fefd570b40$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $749777fefd570b40$export$c27134553091fb3a; }, function (v) { return $749777fefd570b40$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $749777fefd570b40$export$33ee1acdc04fd2a2; }, function (v) { return $749777fefd570b40$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $749777fefd570b40$export$b00a404bbd5edef2; }, function (v) { return $749777fefd570b40$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $749777fefd570b40$export$8352ce38b91d0c62; }, function (v) { return $749777fefd570b40$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $749777fefd570b40$export$d3dfb8e4810cb555; }, function (v) { return $749777fefd570b40$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $749777fefd570b40$export$839f9183b0465a69; }, function (v) { return $749777fefd570b40$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $749777fefd570b40$export$72fdf0e06517287b; }, function (v) { return $749777fefd570b40$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $749777fefd570b40$export$4b844e58a3e414b4; }, function (v) { return $749777fefd570b40$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $749777fefd570b40$export$816d2913ae6b83b1; }, function (v) { return $749777fefd570b40$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $749777fefd570b40$export$61bcfe829111a1d0; }, function (v) { return $749777fefd570b40$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $749777fefd570b40$export$7ee8c9beb337bc3f; }, function (v) { return $749777fefd570b40$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $749777fefd570b40$export$cf845f2c119da08a; }, function (v) { return $749777fefd570b40$export$cf845f2c119da08a = v; });
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $749777fefd570b40$export$c4744153514ff05d;
var $749777fefd570b40$export$b5836b71941fa3ed;
var $749777fefd570b40$export$d66a1c1c77bd778b;
var $749777fefd570b40$export$3e506c1ccc9cc1a7;
var $749777fefd570b40$export$e26fe2ed2fa76875;
var $749777fefd570b40$export$502329bbf4b505b1;
var $749777fefd570b40$export$6e3807111c4874c4;
var $749777fefd570b40$export$c27134553091fb3a;
var $749777fefd570b40$export$33ee1acdc04fd2a2;
var $749777fefd570b40$export$b00a404bbd5edef2;
var $749777fefd570b40$export$8352ce38b91d0c62;
var $749777fefd570b40$export$d3dfb8e4810cb555;
var $749777fefd570b40$export$839f9183b0465a69;
var $749777fefd570b40$export$72fdf0e06517287b;
var $749777fefd570b40$export$4b844e58a3e414b4;
var $749777fefd570b40$export$816d2913ae6b83b1;
var $749777fefd570b40$export$61bcfe829111a1d0;
var $749777fefd570b40$export$7ee8c9beb337bc3f;
var $749777fefd570b40$export$cf845f2c119da08a;
"use strict";
var $749777fefd570b40$var$f, $749777fefd570b40$var$g, $749777fefd570b40$var$h, $749777fefd570b40$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $749777fefd570b40$var$l = performance;
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$l.now();
    };
} else {
    var $749777fefd570b40$var$p = Date, $749777fefd570b40$var$q = $749777fefd570b40$var$p.now();
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$p.now() - $749777fefd570b40$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $749777fefd570b40$var$t = null, $749777fefd570b40$var$u = null, $749777fefd570b40$var$w = function() {
        if (null !== $749777fefd570b40$var$t) try {
            var a = $749777fefd570b40$export$c4744153514ff05d();
            $749777fefd570b40$var$t(!0, a);
            $749777fefd570b40$var$t = null;
        } catch (b) {
            throw setTimeout($749777fefd570b40$var$w, 0), b;
        }
    };
    $749777fefd570b40$var$f = function(a) {
        null !== $749777fefd570b40$var$t ? setTimeout($749777fefd570b40$var$f, 0, a) : ($749777fefd570b40$var$t = a, setTimeout($749777fefd570b40$var$w, 0));
    };
    $749777fefd570b40$var$g = function(a, b) {
        $749777fefd570b40$var$u = setTimeout(a, b);
    };
    $749777fefd570b40$var$h = function() {
        clearTimeout($749777fefd570b40$var$u);
    };
    $749777fefd570b40$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $749777fefd570b40$var$k = $749777fefd570b40$export$d66a1c1c77bd778b = function() {};
} else {
    var $749777fefd570b40$var$x = window.setTimeout, $749777fefd570b40$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $749777fefd570b40$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $749777fefd570b40$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $749777fefd570b40$var$A = !1, $749777fefd570b40$var$B = null, $749777fefd570b40$var$C = -1, $749777fefd570b40$var$D = 5, $749777fefd570b40$var$E = 0;
    $749777fefd570b40$export$b5836b71941fa3ed = function() {
        return $749777fefd570b40$export$c4744153514ff05d() >= $749777fefd570b40$var$E;
    };
    $749777fefd570b40$var$k = function() {};
    $749777fefd570b40$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $749777fefd570b40$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $749777fefd570b40$var$F = new MessageChannel, $749777fefd570b40$var$G = $749777fefd570b40$var$F.port2;
    $749777fefd570b40$var$F.port1.onmessage = function() {
        if (null !== $749777fefd570b40$var$B) {
            var a = $749777fefd570b40$export$c4744153514ff05d();
            $749777fefd570b40$var$E = a + $749777fefd570b40$var$D;
            try {
                $749777fefd570b40$var$B(!0, a) ? $749777fefd570b40$var$G.postMessage(null) : ($749777fefd570b40$var$A = !1, $749777fefd570b40$var$B = null);
            } catch (b) {
                throw $749777fefd570b40$var$G.postMessage(null), b;
            }
        } else $749777fefd570b40$var$A = !1;
    };
    $749777fefd570b40$var$f = function(a) {
        $749777fefd570b40$var$B = a;
        $749777fefd570b40$var$A || ($749777fefd570b40$var$A = !0, $749777fefd570b40$var$G.postMessage(null));
    };
    $749777fefd570b40$var$g = function(a, b) {
        $749777fefd570b40$var$C = $749777fefd570b40$var$x(function() {
            a($749777fefd570b40$export$c4744153514ff05d());
        }, b);
    };
    $749777fefd570b40$var$h = function() {
        $749777fefd570b40$var$y($749777fefd570b40$var$C);
        $749777fefd570b40$var$C = -1;
    };
}
function $749777fefd570b40$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $749777fefd570b40$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $749777fefd570b40$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $749777fefd570b40$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $749777fefd570b40$var$I(n, c)) void 0 !== r && 0 > $749777fefd570b40$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $749777fefd570b40$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $749777fefd570b40$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $749777fefd570b40$var$L = [], $749777fefd570b40$var$M = [], $749777fefd570b40$var$N = 1, $749777fefd570b40$var$O = null, $749777fefd570b40$var$P = 3, $749777fefd570b40$var$Q = !1, $749777fefd570b40$var$R = !1, $749777fefd570b40$var$S = !1;
function $749777fefd570b40$var$T(a) {
    for(var b = $749777fefd570b40$var$J($749777fefd570b40$var$M); null !== b;){
        if (null === b.callback) $749777fefd570b40$var$K($749777fefd570b40$var$M);
        else if (b.startTime <= a) $749777fefd570b40$var$K($749777fefd570b40$var$M), b.sortIndex = b.expirationTime, $749777fefd570b40$var$H($749777fefd570b40$var$L, b);
        else break;
        b = $749777fefd570b40$var$J($749777fefd570b40$var$M);
    }
}
function $749777fefd570b40$var$U(a) {
    $749777fefd570b40$var$S = !1;
    $749777fefd570b40$var$T(a);
    if (!$749777fefd570b40$var$R) {
        if (null !== $749777fefd570b40$var$J($749777fefd570b40$var$L)) $749777fefd570b40$var$R = !0, $749777fefd570b40$var$f($749777fefd570b40$var$V);
        else {
            var b = $749777fefd570b40$var$J($749777fefd570b40$var$M);
            null !== b && $749777fefd570b40$var$g($749777fefd570b40$var$U, b.startTime - a);
        }
    }
}
function $749777fefd570b40$var$V(a, b) {
    $749777fefd570b40$var$R = !1;
    $749777fefd570b40$var$S && ($749777fefd570b40$var$S = !1, $749777fefd570b40$var$h());
    $749777fefd570b40$var$Q = !0;
    var c = $749777fefd570b40$var$P;
    try {
        $749777fefd570b40$var$T(b);
        for($749777fefd570b40$var$O = $749777fefd570b40$var$J($749777fefd570b40$var$L); null !== $749777fefd570b40$var$O && (!($749777fefd570b40$var$O.expirationTime > b) || a && !$749777fefd570b40$export$b5836b71941fa3ed());){
            var d = $749777fefd570b40$var$O.callback;
            if ("function" === typeof d) {
                $749777fefd570b40$var$O.callback = null;
                $749777fefd570b40$var$P = $749777fefd570b40$var$O.priorityLevel;
                var e = d($749777fefd570b40$var$O.expirationTime <= b);
                b = $749777fefd570b40$export$c4744153514ff05d();
                "function" === typeof e ? $749777fefd570b40$var$O.callback = e : $749777fefd570b40$var$O === $749777fefd570b40$var$J($749777fefd570b40$var$L) && $749777fefd570b40$var$K($749777fefd570b40$var$L);
                $749777fefd570b40$var$T(b);
            } else $749777fefd570b40$var$K($749777fefd570b40$var$L);
            $749777fefd570b40$var$O = $749777fefd570b40$var$J($749777fefd570b40$var$L);
        }
        if (null !== $749777fefd570b40$var$O) var m = !0;
        else {
            var n = $749777fefd570b40$var$J($749777fefd570b40$var$M);
            null !== n && $749777fefd570b40$var$g($749777fefd570b40$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $749777fefd570b40$var$O = null, $749777fefd570b40$var$P = c, $749777fefd570b40$var$Q = !1;
    }
}
var $749777fefd570b40$var$W = $749777fefd570b40$var$k;
$749777fefd570b40$export$3e506c1ccc9cc1a7 = 5;
$749777fefd570b40$export$e26fe2ed2fa76875 = 1;
$749777fefd570b40$export$502329bbf4b505b1 = 4;
$749777fefd570b40$export$6e3807111c4874c4 = 3;
$749777fefd570b40$export$c27134553091fb3a = null;
$749777fefd570b40$export$33ee1acdc04fd2a2 = 2;
$749777fefd570b40$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$749777fefd570b40$export$8352ce38b91d0c62 = function() {
    $749777fefd570b40$var$R || $749777fefd570b40$var$Q || ($749777fefd570b40$var$R = !0, $749777fefd570b40$var$f($749777fefd570b40$var$V));
};
$749777fefd570b40$export$d3dfb8e4810cb555 = function() {
    return $749777fefd570b40$var$P;
};
$749777fefd570b40$export$839f9183b0465a69 = function() {
    return $749777fefd570b40$var$J($749777fefd570b40$var$L);
};
$749777fefd570b40$export$72fdf0e06517287b = function(a) {
    switch($749777fefd570b40$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $749777fefd570b40$var$P;
    }
    var c = $749777fefd570b40$var$P;
    $749777fefd570b40$var$P = b;
    try {
        return a();
    } finally{
        $749777fefd570b40$var$P = c;
    }
};
$749777fefd570b40$export$4b844e58a3e414b4 = function() {};
$749777fefd570b40$export$816d2913ae6b83b1 = $749777fefd570b40$var$W;
$749777fefd570b40$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $749777fefd570b40$var$P;
    $749777fefd570b40$var$P = a;
    try {
        return b();
    } finally{
        $749777fefd570b40$var$P = c;
    }
};
$749777fefd570b40$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $749777fefd570b40$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $749777fefd570b40$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $749777fefd570b40$var$H($749777fefd570b40$var$M, a), null === $749777fefd570b40$var$J($749777fefd570b40$var$L) && a === $749777fefd570b40$var$J($749777fefd570b40$var$M) && ($749777fefd570b40$var$S ? $749777fefd570b40$var$h() : $749777fefd570b40$var$S = !0, $749777fefd570b40$var$g($749777fefd570b40$var$U, c - d))) : (a.sortIndex = e, $749777fefd570b40$var$H($749777fefd570b40$var$L, a), $749777fefd570b40$var$R || $749777fefd570b40$var$Q || ($749777fefd570b40$var$R = !0, $749777fefd570b40$var$f($749777fefd570b40$var$V)));
    return a;
};
$749777fefd570b40$export$cf845f2c119da08a = function(a) {
    var b = $749777fefd570b40$var$P;
    return function() {
        var c = $749777fefd570b40$var$P;
        $749777fefd570b40$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $749777fefd570b40$var$P = c;
        }
    };
};

});



parcelRegister("lTQU8", function(module, exports) {

$parcel$export(module.exports, "zeroPad", function () { return zeroPad; });
$parcel$export(module.exports, "calcTimeDelta", function () { return calcTimeDelta; });
$parcel$export(module.exports, "formatTimeDelta", function () { return formatTimeDelta; });
$parcel$export(module.exports, "default", function () { return $ff17c5bba6173ed5$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    return _assertThisInitialized(self);
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return _possibleConstructorReturn(this, result);
    };
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function zeroPad(value) {
    var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    var strValue = String(value);
    if (length === 0) return strValue;
    var match = strValue.match(/(.*?)([0-9]+)(.*)/);
    var prefix = match ? match[1] : "";
    var suffix = match ? match[3] : "";
    var strNo = match ? match[2] : strValue;
    var paddedNo = strNo.length >= length ? strNo : (_toConsumableArray(Array(length)).map(function() {
        return "0";
    }).join("") + strNo).slice(length * -1);
    return "".concat(prefix).concat(paddedNo).concat(suffix);
}
var timeDeltaFormatOptionsDefaults = {
    daysInHours: false,
    zeroPadTime: 2
};
function calcTimeDelta(date) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$now = options.now, now = _options$now === void 0 ? Date.now : _options$now, _options$precision = options.precision, precision = _options$precision === void 0 ? 0 : _options$precision, controlled = options.controlled, _options$offsetTime = options.offsetTime, offsetTime = _options$offsetTime === void 0 ? 0 : _options$offsetTime, overtime = options.overtime;
    var startTimestamp;
    if (typeof date === "string") startTimestamp = new Date(date).getTime();
    else if (date instanceof Date) startTimestamp = date.getTime();
    else startTimestamp = date;
    if (!controlled) startTimestamp += offsetTime;
    var timeLeft = controlled ? startTimestamp : startTimestamp - now();
    var clampedPrecision = Math.min(20, Math.max(0, precision));
    var total = Math.round(parseFloat(((overtime ? timeLeft : Math.max(0, timeLeft)) / 1000).toFixed(clampedPrecision)) * 1000);
    var seconds = Math.abs(total) / 1000;
    return {
        total: total,
        days: Math.floor(seconds / 86400),
        hours: Math.floor(seconds / 3600 % 24),
        minutes: Math.floor(seconds / 60 % 60),
        seconds: Math.floor(seconds % 60),
        milliseconds: Number((seconds % 1 * 1000).toFixed()),
        completed: total <= 0
    };
}
function formatTimeDelta(timeDelta, options) {
    var days = timeDelta.days, hours = timeDelta.hours, minutes = timeDelta.minutes, seconds = timeDelta.seconds;
    var _Object$assign = Object.assign(Object.assign({}, timeDeltaFormatOptionsDefaults), options), daysInHours = _Object$assign.daysInHours, zeroPadTime = _Object$assign.zeroPadTime, _Object$assign$zeroPa = _Object$assign.zeroPadDays, zeroPadDays = _Object$assign$zeroPa === void 0 ? zeroPadTime : _Object$assign$zeroPa;
    var zeroPadTimeLength = Math.min(2, zeroPadTime);
    var formattedHours = daysInHours ? zeroPad(hours + days * 24, zeroPadTime) : zeroPad(hours, zeroPadTimeLength);
    return {
        days: daysInHours ? "" : zeroPad(days, zeroPadDays),
        hours: formattedHours,
        minutes: zeroPad(minutes, zeroPadTimeLength),
        seconds: zeroPad(seconds, zeroPadTimeLength)
    };
}
var Countdown = function(_React$Component) {
    _inherits(Countdown, _React$Component);
    var _super = _createSuper(Countdown);
    function Countdown() {
        var _this;
        _classCallCheck(this, Countdown);
        _this = _super.apply(this, arguments);
        _this.state = {
            count: _this.props.count || 3
        };
        _this.startCountdown = function() {
            _this.interval = window.setInterval(function() {
                var count = _this.state.count - 1;
                if (count === 0) {
                    _this.stopCountdown();
                    _this.props.onComplete && _this.props.onComplete();
                } else _this.setState(function(prevState) {
                    return {
                        count: prevState.count - 1
                    };
                });
            }, 1000);
        };
        _this.stopCountdown = function() {
            clearInterval(_this.interval);
        };
        _this.addTime = function(seconds) {
            _this.stopCountdown();
            _this.setState(function(prevState) {
                return {
                    count: prevState.count + seconds
                };
            }, _this.startCountdown);
        };
        return _this;
    }
    _createClass(Countdown, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startCountdown();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                clearInterval(this.interval);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.props.children ? (0, $7fPBF.cloneElement)(this.props.children, {
                    count: this.state.count
                }) : null;
            }
        }
    ]);
    return Countdown;
}((0, $7fPBF.Component));
Countdown.propTypes = {
    count: (0, $2oXYc.number),
    children: (0, $2oXYc.element),
    onComplete: (0, $2oXYc.func)
};
var Countdown$1 = function(_React$Component) {
    _inherits(Countdown$1, _React$Component);
    var _super = _createSuper(Countdown$1);
    function Countdown$1(props) {
        var _this;
        _classCallCheck(this, Countdown$1);
        _this = _super.call(this, props);
        _this.mounted = false;
        _this.initialTimestamp = _this.calcOffsetStartTimestamp();
        _this.offsetStartTimestamp = _this.props.autoStart ? 0 : _this.initialTimestamp;
        _this.offsetTime = 0;
        _this.legacyMode = false;
        _this.legacyCountdownRef = null;
        _this.tick = function() {
            var timeDelta = _this.calcTimeDelta();
            var callback = timeDelta.completed && !_this.props.overtime ? undefined : _this.props.onTick;
            _this.setTimeDeltaState(timeDelta, undefined, callback);
        };
        _this.setLegacyCountdownRef = function(ref) {
            _this.legacyCountdownRef = ref;
        };
        _this.start = function() {
            if (_this.isStarted()) return;
            var prevOffsetStartTimestamp = _this.offsetStartTimestamp;
            _this.offsetStartTimestamp = 0;
            _this.offsetTime += prevOffsetStartTimestamp ? _this.calcOffsetStartTimestamp() - prevOffsetStartTimestamp : 0;
            var timeDelta = _this.calcTimeDelta();
            _this.setTimeDeltaState(timeDelta, "STARTED", _this.props.onStart);
            if (!_this.props.controlled && (!timeDelta.completed || _this.props.overtime)) {
                _this.clearTimer();
                _this.interval = window.setInterval(_this.tick, _this.props.intervalDelay);
            }
        };
        _this.pause = function() {
            if (_this.isPaused()) return;
            _this.clearTimer();
            _this.offsetStartTimestamp = _this.calcOffsetStartTimestamp();
            _this.setTimeDeltaState(_this.state.timeDelta, "PAUSED", _this.props.onPause);
        };
        _this.stop = function() {
            if (_this.isStopped()) return;
            _this.clearTimer();
            _this.offsetStartTimestamp = _this.calcOffsetStartTimestamp();
            _this.offsetTime = _this.offsetStartTimestamp - _this.initialTimestamp;
            _this.setTimeDeltaState(_this.calcTimeDelta(), "STOPPED", _this.props.onStop);
        };
        _this.isStarted = function() {
            return _this.isStatus("STARTED");
        };
        _this.isPaused = function() {
            return _this.isStatus("PAUSED");
        };
        _this.isStopped = function() {
            return _this.isStatus("STOPPED");
        };
        _this.isCompleted = function() {
            return _this.isStatus("COMPLETED");
        };
        if (props.date) {
            var timeDelta = _this.calcTimeDelta();
            _this.state = {
                timeDelta: timeDelta,
                status: timeDelta.completed ? "COMPLETED" : "STOPPED"
            };
        } else _this.legacyMode = true;
        return _this;
    }
    _createClass(Countdown$1, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.legacyMode) return;
                this.mounted = true;
                if (this.props.onMount) this.props.onMount(this.calcTimeDelta());
                if (this.props.autoStart) this.start();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (this.legacyMode) return;
                if (this.props.date !== prevProps.date) {
                    this.initialTimestamp = this.calcOffsetStartTimestamp();
                    this.offsetStartTimestamp = this.initialTimestamp;
                    this.offsetTime = 0;
                    this.setTimeDeltaState(this.calcTimeDelta());
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.legacyMode) return;
                this.mounted = false;
                this.clearTimer();
            }
        },
        {
            key: "calcTimeDelta",
            value: function calcTimeDelta$1() {
                var _this$props = this.props, date = _this$props.date, now = _this$props.now, precision = _this$props.precision, controlled = _this$props.controlled, overtime = _this$props.overtime;
                return calcTimeDelta(date, {
                    now: now,
                    precision: precision,
                    controlled: controlled,
                    offsetTime: this.offsetTime,
                    overtime: overtime
                });
            }
        },
        {
            key: "calcOffsetStartTimestamp",
            value: function calcOffsetStartTimestamp() {
                return Date.now();
            }
        },
        {
            key: "addTime",
            value: function addTime(seconds) {
                this.legacyCountdownRef.addTime(seconds);
            }
        },
        {
            key: "clearTimer",
            value: function clearTimer() {
                window.clearInterval(this.interval);
            }
        },
        {
            key: "isStatus",
            value: function isStatus(status) {
                return this.state.status === status;
            }
        },
        {
            key: "setTimeDeltaState",
            value: function setTimeDeltaState(timeDelta, status, callback) {
                var _this2 = this;
                if (!this.mounted) return;
                var completing = timeDelta.completed && !this.state.timeDelta.completed;
                var completedOnStart = timeDelta.completed && status === "STARTED";
                if (completing && !this.props.overtime) this.clearTimer();
                var onDone = function onDone() {
                    if (callback) callback(_this2.state.timeDelta);
                    if (_this2.props.onComplete && (completing || completedOnStart)) _this2.props.onComplete(timeDelta, completedOnStart);
                };
                return this.setState(function(prevState) {
                    var newStatus = status || prevState.status;
                    if (timeDelta.completed && !_this2.props.overtime) newStatus = "COMPLETED";
                    else if (!status && newStatus === "COMPLETED") newStatus = "STOPPED";
                    return {
                        timeDelta: timeDelta,
                        status: newStatus
                    };
                }, onDone);
            }
        },
        {
            key: "getApi",
            value: function getApi() {
                return this.api = this.api || {
                    start: this.start,
                    pause: this.pause,
                    stop: this.stop,
                    isStarted: this.isStarted,
                    isPaused: this.isPaused,
                    isStopped: this.isStopped,
                    isCompleted: this.isCompleted
                };
            }
        },
        {
            key: "getRenderProps",
            value: function getRenderProps() {
                var _this$props2 = this.props, daysInHours = _this$props2.daysInHours, zeroPadTime = _this$props2.zeroPadTime, zeroPadDays = _this$props2.zeroPadDays;
                var timeDelta = this.state.timeDelta;
                return Object.assign(Object.assign({}, timeDelta), {
                    api: this.getApi(),
                    props: this.props,
                    formatted: formatTimeDelta(timeDelta, {
                        daysInHours: daysInHours,
                        zeroPadTime: zeroPadTime,
                        zeroPadDays: zeroPadDays
                    })
                });
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.legacyMode) {
                    var _this$props3 = this.props, count = _this$props3.count, _children = _this$props3.children, onComplete = _this$props3.onComplete;
                    return (0, $7fPBF.createElement)(Countdown, {
                        ref: this.setLegacyCountdownRef,
                        count: count,
                        onComplete: onComplete
                    }, _children);
                }
                var _this$props4 = this.props, className = _this$props4.className, overtime = _this$props4.overtime, children = _this$props4.children, renderer = _this$props4.renderer;
                var renderProps = this.getRenderProps();
                if (renderer) return renderer(renderProps);
                if (children && this.state.timeDelta.completed && !overtime) return (0, $7fPBF.cloneElement)(children, {
                    countdown: renderProps
                });
                var _renderProps$formatte = renderProps.formatted, days = _renderProps$formatte.days, hours = _renderProps$formatte.hours, minutes = _renderProps$formatte.minutes, seconds = _renderProps$formatte.seconds;
                return (0, $7fPBF.createElement)("span", {
                    className: className
                }, renderProps.total < 0 ? "-" : "", days, days ? ":" : "", hours, ":", minutes, ":", seconds);
            }
        }
    ]);
    return Countdown$1;
}((0, $7fPBF.Component));
Countdown$1.defaultProps = Object.assign(Object.assign({}, timeDeltaFormatOptionsDefaults), {
    controlled: false,
    intervalDelay: 1000,
    precision: 0,
    autoStart: true
});
Countdown$1.propTypes = {
    date: (0, $2oXYc.oneOfType)([
        (0, $2oXYc.instanceOf)(Date),
        (0, $2oXYc.string),
        (0, $2oXYc.number)
    ]),
    daysInHours: (0, $2oXYc.bool),
    zeroPadTime: (0, $2oXYc.number),
    zeroPadDays: (0, $2oXYc.number),
    controlled: (0, $2oXYc.bool),
    intervalDelay: (0, $2oXYc.number),
    precision: (0, $2oXYc.number),
    autoStart: (0, $2oXYc.bool),
    overtime: (0, $2oXYc.bool),
    className: (0, $2oXYc.string),
    children: (0, $2oXYc.element),
    renderer: (0, $2oXYc.func),
    now: (0, $2oXYc.func),
    onMount: (0, $2oXYc.func),
    onStart: (0, $2oXYc.func),
    onPause: (0, $2oXYc.func),
    onStop: (0, $2oXYc.func),
    onTick: (0, $2oXYc.func),
    onComplete: (0, $2oXYc.func)
};
var $ff17c5bba6173ed5$export$2e2bcd8739ae039 = Countdown$1;

});
parcelRegister("2oXYc", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bfc5778dcd4841a$var$ReactIs, $1bfc5778dcd4841a$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("iDep4"))();

});
parcelRegister("iDep4", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $7KQqJ = parcelRequire("7KQqJ");
function $d9070abd96403449$var$emptyFunction() {}
function $d9070abd96403449$var$emptyFunctionWithReset() {}
$d9070abd96403449$var$emptyFunctionWithReset.resetWarningCache = $d9070abd96403449$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $7KQqJ) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $d9070abd96403449$var$emptyFunctionWithReset,
        resetWarningCache: $d9070abd96403449$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("7KQqJ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $5a557fcd99e4c0a9$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $5a557fcd99e4c0a9$var$ReactPropTypesSecret;

});




var $824c049f32d4395d$exports = {};
"use strict";

$824c049f32d4395d$exports = (parcelRequire("2nzLi"));




var $7fPBF = parcelRequire("7fPBF");
var $b4ba1c853f6e1116$exports = {};
"use strict";
function $b4ba1c853f6e1116$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b4ba1c853f6e1116$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b4ba1c853f6e1116$var$checkDCE();

$b4ba1c853f6e1116$exports = (parcelRequire("6EA3T"));




// packages/react/accessible-icon/src/AccessibleIcon.tsx

var $7fPBF = parcelRequire("7fPBF");
// packages/react/visually-hidden/src/VisuallyHidden.tsx

var $7fPBF = parcelRequire("7fPBF");
// packages/react/primitive/src/Primitive.tsx

var $7fPBF = parcelRequire("7fPBF");

// packages/react/slot/src/Slot.tsx

var $7fPBF = parcelRequire("7fPBF");
// packages/react/compose-refs/src/composeRefs.tsx

var $7fPBF = parcelRequire("7fPBF");
function $2d44b7cb84ff0f1c$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $2d44b7cb84ff0f1c$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$2d44b7cb84ff0f1c$var$setRef(ref, node));
}
function $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05(...refs) {
    return $7fPBF.useCallback($2d44b7cb84ff0f1c$export$43e446d32b3d21af(...refs), refs);
}



var $089057084dfb92a4$export$8c6ed5c666ac1360 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = $7fPBF.Children.toArray(children);
    const slottable = childrenArray.find($089057084dfb92a4$var$isSlottable);
    if (slottable) {
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                if ($7fPBF.Children.count(newElement) > 1) return $7fPBF.Children.only(null);
                return $7fPBF.isValidElement(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($089057084dfb92a4$var$SlotClone, {
            ...slotProps,
            ref: forwardedRef,
            children: $7fPBF.isValidElement(newElement) ? $7fPBF.cloneElement(newElement, void 0, newChildren) : null
        });
    }
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($089057084dfb92a4$var$SlotClone, {
        ...slotProps,
        ref: forwardedRef,
        children: children
    });
});
$089057084dfb92a4$export$8c6ed5c666ac1360.displayName = "Slot";
var $089057084dfb92a4$var$SlotClone = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if ($7fPBF.isValidElement(children)) {
        const childrenRef = $089057084dfb92a4$var$getElementRef(children);
        return $7fPBF.cloneElement(children, {
            ...$089057084dfb92a4$var$mergeProps(slotProps, children.props),
            // @ts-ignore
            ref: forwardedRef ? (0, $2d44b7cb84ff0f1c$export$43e446d32b3d21af)(forwardedRef, childrenRef) : childrenRef
        });
    }
    return $7fPBF.Children.count(children) > 1 ? $7fPBF.Children.only(null) : null;
});
$089057084dfb92a4$var$SlotClone.displayName = "SlotClone";
var $089057084dfb92a4$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
        children: children
    });
};
function $089057084dfb92a4$var$isSlottable(child) {
    return $7fPBF.isValidElement(child) && child.type === $089057084dfb92a4$export$d9f1ccf0bdb05d45;
}
function $089057084dfb92a4$var$mergeProps(slotProps, childProps) {
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
function $089057084dfb92a4$var$getElementRef(element) {
    var _Object_getOwnPropertyDescriptor, _Object_getOwnPropertyDescriptor1;
    let getter = (_Object_getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor(element.props, "ref")) === null || _Object_getOwnPropertyDescriptor === void 0 ? void 0 : _Object_getOwnPropertyDescriptor.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = (_Object_getOwnPropertyDescriptor1 = Object.getOwnPropertyDescriptor(element, "ref")) === null || _Object_getOwnPropertyDescriptor1 === void 0 ? void 0 : _Object_getOwnPropertyDescriptor1.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
var $089057084dfb92a4$export$be92b6f5f03c0fe9 = $089057084dfb92a4$export$8c6ed5c666ac1360;



var $4b1a25a893812cc7$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
];
var $4b1a25a893812cc7$export$250ffa63cdc0d034 = $4b1a25a893812cc7$var$NODES.reduce((primitive, node)=>{
    const Node = $7fPBF.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, $089057084dfb92a4$export$8c6ed5c666ac1360) : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(Comp, {
            ...primitiveProps,
            ref: forwardedRef
        });
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
function $4b1a25a893812cc7$export$6d1a0317bde7de7f(target, event) {
    if (target) $b4ba1c853f6e1116$exports.flushSync(()=>target.dispatchEvent(event));
}
var $4b1a25a893812cc7$export$be92b6f5f03c0fe9 = $4b1a25a893812cc7$export$250ffa63cdc0d034;



var $28c8fa82e4cfdc1a$var$NAME = "VisuallyHidden";
var $28c8fa82e4cfdc1a$export$439d29a4e110a164 = $7fPBF.forwardRef((props, forwardedRef)=>{
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).span, {
        ...props,
        ref: forwardedRef,
        style: {
            // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
            position: "absolute",
            border: 0,
            width: 1,
            height: 1,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            wordWrap: "normal",
            ...props.style
        }
    });
});
$28c8fa82e4cfdc1a$export$439d29a4e110a164.displayName = $28c8fa82e4cfdc1a$var$NAME;
var $28c8fa82e4cfdc1a$export$be92b6f5f03c0fe9 = $28c8fa82e4cfdc1a$export$439d29a4e110a164;



var $72d653f67b66328c$var$NAME = "AccessibleIcon";
var $72d653f67b66328c$export$5aec92af04ace2d2 = ({ children: children, label: label })=>{
    const child = $7fPBF.Children.only(children);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            $7fPBF.cloneElement(child, {
                // accessibility
                "aria-hidden": "true",
                focusable: "false"
            }),
            /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($28c8fa82e4cfdc1a$export$be92b6f5f03c0fe9, {
                children: label
            })
        ]
    });
};
$72d653f67b66328c$export$5aec92af04ace2d2.displayName = $72d653f67b66328c$var$NAME;
var $72d653f67b66328c$export$be92b6f5f03c0fe9 = $72d653f67b66328c$export$5aec92af04ace2d2;





var $7fPBF = parcelRequire("7fPBF");
var $039fe4ac9c9107fb$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    var nativeCodeString = "[native code]";
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
                    classes.push(arg.toString());
                    continue;
                }
                for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
            }
        }
        return classes.join(" ");
    }
    if (0, $039fe4ac9c9107fb$exports) {
        classNames.default = classNames;
        $039fe4ac9c9107fb$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $7fPBF = parcelRequire("7fPBF");
// packages/react/context/src/createContext.tsx

var $7fPBF = parcelRequire("7fPBF");

function $d0e15db24766ddfc$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $7fPBF.createContext(defaultContext);
    function Provider(props) {
        const { children: children, ...context } = props;
        const value = $7fPBF.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    }
    function useContext2(consumerName) {
        const context = $7fPBF.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext2
    ];
}
function $d0e15db24766ddfc$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $7fPBF.createContext(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope, children: children, ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const value = $7fPBF.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        }
        function useContext2(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = $7fPBF.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext2
        ];
    }
    const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $7fPBF.createContext(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return $7fPBF.useMemo(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $d0e15db24766ddfc$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
function $d0e15db24766ddfc$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = ()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes2,
                    ...currentScope
                };
            }, {});
            return $7fPBF.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        };
    };
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}




var $7fPBF = parcelRequire("7fPBF");
// packages/core/primitive/src/primitive.tsx
function $b40b207d83279ebf$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 ? void 0 : originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}




// packages/react/id/src/id.tsx

var $7fPBF = parcelRequire("7fPBF");
// packages/react/use-layout-effect/src/useLayoutEffect.tsx

var $7fPBF = parcelRequire("7fPBF");
var $191a4e5730438e92$var$_globalThis;
var $191a4e5730438e92$export$e5c5a5f917a5871c = Boolean(($191a4e5730438e92$var$_globalThis = globalThis) === null || $191a4e5730438e92$var$_globalThis === void 0 ? void 0 : $191a4e5730438e92$var$_globalThis.document) ? $7fPBF.useLayoutEffect : ()=>{};


var $8a8e9b94c33ba6d6$var$useReactId = $7fPBF["useId".toString()] || (()=>void 0);
var $8a8e9b94c33ba6d6$var$count = 0;
function $8a8e9b94c33ba6d6$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $7fPBF.useState($8a8e9b94c33ba6d6$var$useReactId());
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId !== null && reactId !== void 0 ? reactId : String($8a8e9b94c33ba6d6$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}


// packages/react/use-controllable-state/src/useControllableState.tsx

var $7fPBF = parcelRequire("7fPBF");
// packages/react/use-callback-ref/src/useCallbackRef.tsx

var $7fPBF = parcelRequire("7fPBF");
function $4ea47b3abe83764c$export$25bec8c6f54ee79a(callback) {
    const callbackRef = $7fPBF.useRef(callback);
    $7fPBF.useEffect(()=>{
        callbackRef.current = callback;
    });
    return $7fPBF.useMemo(()=>(...args)=>{
            var _callbackRef_current;
            return (_callbackRef_current = callbackRef.current) === null || _callbackRef_current === void 0 ? void 0 : _callbackRef_current.call(callbackRef, ...args);
        }, []);
}


function $915387e6ab4d88b1$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = $915387e6ab4d88b1$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(onChange);
    const setValue = $7fPBF.useCallback((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value2 = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value2 !== prop) handleChange(value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value,
        setValue
    ];
}
function $915387e6ab4d88b1$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const uncontrolledState = $7fPBF.useState(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = $7fPBF.useRef(value);
    const handleChange = (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(onChange);
    $7fPBF.useEffect(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}



var $7fPBF = parcelRequire("7fPBF");




// packages/react/use-escape-keydown/src/useEscapeKeydown.tsx

var $7fPBF = parcelRequire("7fPBF");

function $ff83476db5457737$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = (()=>{
    var _globalThis;
    return (_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : _globalThis.document;
})()) {
    const onEscapeKeyDown = (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    $7fPBF.useEffect(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}



"use client";
var $251340165f4765e5$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
var $251340165f4765e5$var$CONTEXT_UPDATE = "dismissableLayer.update";
var $251340165f4765e5$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var $251340165f4765e5$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var $251340165f4765e5$var$originalBodyPointerEvents;
var $251340165f4765e5$var$DismissableLayerContext = $7fPBF.createContext({
    layers: /* @__PURE__ */ new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
    branches: /* @__PURE__ */ new Set()
});
var $251340165f4765e5$export$177fb62ff3ec1f22 = $7fPBF.forwardRef((props, forwardedRef)=>{
    var _globalThis;
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = $7fPBF.useContext($251340165f4765e5$var$DismissableLayerContext);
    const [node, setNode] = $7fPBF.useState(null);
    var _node_ownerDocument;
    const ownerDocument = (_node_ownerDocument = node === null || node === void 0 ? void 0 : node.ownerDocument) !== null && _node_ownerDocument !== void 0 ? _node_ownerDocument : (_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : _globalThis.document;
    const [, force] = $7fPBF.useState({});
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, (node2)=>setNode(node2));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1);
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled);
    const index = node ? layers.indexOf(node) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $251340165f4765e5$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside === null || onPointerDownOutside === void 0 ? void 0 : onPointerDownOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 ? void 0 : onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
    }, ownerDocument);
    const focusOutside = $251340165f4765e5$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside === null || onFocusOutside === void 0 ? void 0 : onFocusOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 ? void 0 : onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
    }, ownerDocument);
    (0, $ff83476db5457737$export$3a72a57244d6e765)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown === null || onEscapeKeyDown === void 0 ? void 0 : onEscapeKeyDown(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    $7fPBF.useEffect(()=>{
        if (!node) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $251340165f4765e5$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node);
        }
        context.layers.add(node);
        $251340165f4765e5$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $251340165f4765e5$var$originalBodyPointerEvents;
        };
    }, [
        node,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    $7fPBF.useEffect(()=>{
        return ()=>{
            if (!node) return;
            context.layers.delete(node);
            context.layersWithOutsidePointerEventsDisabled.delete(node);
            $251340165f4765e5$var$dispatchUpdate();
        };
    }, [
        node,
        context
    ]);
    $7fPBF.useEffect(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($251340165f4765e5$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($251340165f4765e5$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
        ...layerProps,
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0,
            ...props.style
        },
        onFocusCapture: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    });
});
$251340165f4765e5$export$177fb62ff3ec1f22.displayName = $251340165f4765e5$var$DISMISSABLE_LAYER_NAME;
var $251340165f4765e5$var$BRANCH_NAME = "DismissableLayerBranch";
var $251340165f4765e5$export$4d5eb2109db14228 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const context = $7fPBF.useContext($251340165f4765e5$var$DismissableLayerContext);
    const ref = $7fPBF.useRef(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $7fPBF.useEffect(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
        ...props,
        ref: composedRefs
    });
});
$251340165f4765e5$export$4d5eb2109db14228.displayName = $251340165f4765e5$var$BRANCH_NAME;
function $251340165f4765e5$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = (()=>{
    var _globalThis;
    return (_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : _globalThis.document;
})()) {
    const handlePointerDownOutside = (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = $7fPBF.useRef(false);
    const handleClickRef = $7fPBF.useRef(()=>{});
    $7fPBF.useEffect(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                let handleAndDispatchPointerDownOutsideEvent2 = function() {
                    $251340165f4765e5$var$handleAndDispatchCustomEvent($251340165f4765e5$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                };
                var handleAndDispatchPointerDownOutsideEvent = handleAndDispatchPointerDownOutsideEvent2;
                const eventDetail = {
                    originalEvent: event
                };
                if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent2();
            } else ownerDocument.removeEventListener("click", handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
function $251340165f4765e5$var$useFocusOutside(onFocusOutside, ownerDocument = (()=>{
    var _globalThis;
    return (_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : _globalThis.document;
})()) {
    const handleFocusOutside = (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = $7fPBF.useRef(false);
    $7fPBF.useEffect(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $251340165f4765e5$var$handleAndDispatchCustomEvent($251340165f4765e5$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $251340165f4765e5$var$dispatchUpdate() {
    const event = new CustomEvent($251340165f4765e5$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $251340165f4765e5$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $4b1a25a893812cc7$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
var $251340165f4765e5$export$be92b6f5f03c0fe9 = $251340165f4765e5$export$177fb62ff3ec1f22;
var $251340165f4765e5$export$aecb2ddcb55c95be = $251340165f4765e5$export$4d5eb2109db14228;



var $7fPBF = parcelRequire("7fPBF");




"use client";
var $0d555b2b0a3ffff1$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var $0d555b2b0a3ffff1$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var $0d555b2b0a3ffff1$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $0d555b2b0a3ffff1$var$FOCUS_SCOPE_NAME = "FocusScope";
var $0d555b2b0a3ffff1$export$20e40289641fbbb6 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { loop: loop = false, trapped: trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp, ...scopeProps } = props;
    const [container, setContainer] = $7fPBF.useState(null);
    const onMountAutoFocus = (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = $7fPBF.useRef(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContainer(node));
    const focusScope = $7fPBF.useRef({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current;
    $7fPBF.useEffect(()=>{
        if (trapped) {
            let handleFocusIn2 = function(event) {
                if (focusScope.paused || !container) return;
                const target = event.target;
                if (container.contains(target)) lastFocusedElementRef.current = target;
                else $0d555b2b0a3ffff1$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleFocusOut2 = function(event) {
                if (focusScope.paused || !container) return;
                const relatedTarget = event.relatedTarget;
                if (relatedTarget === null) return;
                if (!container.contains(relatedTarget)) $0d555b2b0a3ffff1$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleMutations2 = function(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $0d555b2b0a3ffff1$var$focus(container);
            };
            var handleFocusIn = handleFocusIn2, handleFocusOut = handleFocusOut2, handleMutations = handleMutations2;
            document.addEventListener("focusin", handleFocusIn2);
            document.addEventListener("focusout", handleFocusOut2);
            const mutationObserver = new MutationObserver(handleMutations2);
            if (container) mutationObserver.observe(container, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn2);
                document.removeEventListener("focusout", handleFocusOut2);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container,
        focusScope.paused
    ]);
    $7fPBF.useEffect(()=>{
        if (container) {
            $0d555b2b0a3ffff1$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($0d555b2b0a3ffff1$var$AUTOFOCUS_ON_MOUNT, $0d555b2b0a3ffff1$var$EVENT_OPTIONS);
                container.addEventListener($0d555b2b0a3ffff1$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $0d555b2b0a3ffff1$var$focusFirst($0d555b2b0a3ffff1$var$removeLinks($0d555b2b0a3ffff1$var$getTabbableCandidates(container)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $0d555b2b0a3ffff1$var$focus(container);
                }
            }
            return ()=>{
                container.removeEventListener($0d555b2b0a3ffff1$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($0d555b2b0a3ffff1$var$AUTOFOCUS_ON_UNMOUNT, $0d555b2b0a3ffff1$var$EVENT_OPTIONS);
                    container.addEventListener($0d555b2b0a3ffff1$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $0d555b2b0a3ffff1$var$focus(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
                        select: true
                    });
                    container.removeEventListener($0d555b2b0a3ffff1$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $0d555b2b0a3ffff1$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]);
    const handleKeyDown = $7fPBF.useCallback((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container2 = event.currentTarget;
            const [first, last] = $0d555b2b0a3ffff1$var$getTabbableEdges(container2);
            const hasTabbableElementsInside = first && last;
            if (!hasTabbableElementsInside) {
                if (focusedElement === container2) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $0d555b2b0a3ffff1$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $0d555b2b0a3ffff1$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
        tabIndex: -1,
        ...scopeProps,
        ref: composedRefs,
        onKeyDown: handleKeyDown
    });
});
$0d555b2b0a3ffff1$export$20e40289641fbbb6.displayName = $0d555b2b0a3ffff1$var$FOCUS_SCOPE_NAME;
function $0d555b2b0a3ffff1$var$focusFirst(candidates, { select: select = false } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $0d555b2b0a3ffff1$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
function $0d555b2b0a3ffff1$var$getTabbableEdges(container) {
    const candidates = $0d555b2b0a3ffff1$var$getTabbableCandidates(container);
    const first = $0d555b2b0a3ffff1$var$findVisible(candidates, container);
    const last = $0d555b2b0a3ffff1$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
function $0d555b2b0a3ffff1$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode);
    return nodes;
}
function $0d555b2b0a3ffff1$var$findVisible(elements, container) {
    for (const element of elements){
        if (!$0d555b2b0a3ffff1$var$isHidden(element, {
            upTo: container
        })) return element;
    }
}
function $0d555b2b0a3ffff1$var$isHidden(node, { upTo: upTo }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        if (upTo !== void 0 && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
function $0d555b2b0a3ffff1$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
function $0d555b2b0a3ffff1$var$focus(element, { select: select = false } = {}) {
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement;
        element.focus({
            preventScroll: true
        });
        if (element !== previouslyFocusedElement && $0d555b2b0a3ffff1$var$isSelectableInput(element) && select) element.select();
    }
}
var $0d555b2b0a3ffff1$var$focusScopesStack = $0d555b2b0a3ffff1$var$createFocusScopesStack();
function $0d555b2b0a3ffff1$var$createFocusScopesStack() {
    let stack = [];
    return {
        add (focusScope) {
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope === null || activeFocusScope === void 0 ? void 0 : activeFocusScope.pause();
            stack = $0d555b2b0a3ffff1$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            var _stack_;
            stack = $0d555b2b0a3ffff1$var$arrayRemove(stack, focusScope);
            (_stack_ = stack[0]) === null || _stack_ === void 0 ? void 0 : _stack_.resume();
        }
    };
}
function $0d555b2b0a3ffff1$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
function $0d555b2b0a3ffff1$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
var $0d555b2b0a3ffff1$export$be92b6f5f03c0fe9 = $0d555b2b0a3ffff1$export$20e40289641fbbb6;



var $7fPBF = parcelRequire("7fPBF");




"use client";
var $57c7abe8fecdeb41$var$PORTAL_NAME = "Portal";
var $57c7abe8fecdeb41$export$602eac185826482c = $7fPBF.forwardRef((props, forwardedRef)=>{
    var _globalThis_document, _globalThis;
    const { container: containerProp, ...portalProps } = props;
    const [mounted, setMounted] = $7fPBF.useState(false);
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>setMounted(true), []);
    const container = containerProp || mounted && ((_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : (_globalThis_document = _globalThis.document) === null || _globalThis_document === void 0 ? void 0 : _globalThis_document.body);
    return container ? (0, (/*@__PURE__*/$parcel$interopDefault($b4ba1c853f6e1116$exports))).createPortal(/* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
        ...portalProps,
        ref: forwardedRef
    }), container) : null;
});
$57c7abe8fecdeb41$export$602eac185826482c.displayName = $57c7abe8fecdeb41$var$PORTAL_NAME;
var $57c7abe8fecdeb41$export$be92b6f5f03c0fe9 = $57c7abe8fecdeb41$export$602eac185826482c;



var $7fPBF = parcelRequire("7fPBF");



"use client";
function $e9ce08b8e6e14786$var$useStateMachine(initialState, machine) {
    return $7fPBF.useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}
// packages/react/presence/src/Presence.tsx
var $e9ce08b8e6e14786$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $e9ce08b8e6e14786$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : $7fPBF.Children.only(children);
    const ref = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(presence.ref, $e9ce08b8e6e14786$var$getElementRef(child));
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? $7fPBF.cloneElement(child, {
        ref: ref
    }) : null;
};
$e9ce08b8e6e14786$export$99c2b779aa4e8b8b.displayName = "Presence";
function $e9ce08b8e6e14786$var$usePresence(present) {
    const [node, setNode] = $7fPBF.useState();
    const stylesRef = $7fPBF.useRef({});
    const prevPresentRef = $7fPBF.useRef(present);
    const prevAnimationNameRef = $7fPBF.useRef("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $e9ce08b8e6e14786$var$useStateMachine(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    $7fPBF.useEffect(()=>{
        const currentAnimationName = $e9ce08b8e6e14786$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $e9ce08b8e6e14786$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || (styles === null || styles === void 0 ? void 0 : styles.display) === "none") send("UNMOUNT");
            else {
                const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        if (node) {
            const handleAnimationEnd = (event)=>{
                const currentAnimationName = $e9ce08b8e6e14786$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node && isCurrentAnimation) $b4ba1c853f6e1116$exports.flushSync(()=>send("ANIMATION_END"));
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node) prevAnimationNameRef.current = $e9ce08b8e6e14786$var$getAnimationName(stylesRef.current);
            };
            node.addEventListener("animationstart", handleAnimationStart);
            node.addEventListener("animationcancel", handleAnimationEnd);
            node.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                node.removeEventListener("animationstart", handleAnimationStart);
                node.removeEventListener("animationcancel", handleAnimationEnd);
                node.removeEventListener("animationend", handleAnimationEnd);
            };
        } else send("ANIMATION_END");
    }, [
        node,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: $7fPBF.useCallback((node2)=>{
            if (node2) stylesRef.current = getComputedStyle(node2);
            setNode(node2);
        }, [])
    };
}
function $e9ce08b8e6e14786$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || "none";
}
function $e9ce08b8e6e14786$var$getElementRef(element) {
    var _Object_getOwnPropertyDescriptor, _Object_getOwnPropertyDescriptor1;
    let getter = (_Object_getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor(element.props, "ref")) === null || _Object_getOwnPropertyDescriptor === void 0 ? void 0 : _Object_getOwnPropertyDescriptor.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = (_Object_getOwnPropertyDescriptor1 = Object.getOwnPropertyDescriptor(element, "ref")) === null || _Object_getOwnPropertyDescriptor1 === void 0 ? void 0 : _Object_getOwnPropertyDescriptor1.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}




var $7fPBF = parcelRequire("7fPBF");
"use client";
var $38bbe2f1de23f200$var$count = 0;
function $38bbe2f1de23f200$export$ac5b58043b79449b(props) {
    $38bbe2f1de23f200$export$b7ece24a22aeda8c();
    return props.children;
}
function $38bbe2f1de23f200$export$b7ece24a22aeda8c() {
    $7fPBF.useEffect(()=>{
        const edgeGuards = document.querySelectorAll("[data-radix-focus-guard]");
        var _edgeGuards_;
        document.body.insertAdjacentElement("afterbegin", (_edgeGuards_ = edgeGuards[0]) !== null && _edgeGuards_ !== void 0 ? _edgeGuards_ : $38bbe2f1de23f200$var$createFocusGuard());
        var _edgeGuards_1;
        document.body.insertAdjacentElement("beforeend", (_edgeGuards_1 = edgeGuards[1]) !== null && _edgeGuards_1 !== void 0 ? _edgeGuards_1 : $38bbe2f1de23f200$var$createFocusGuard());
        $38bbe2f1de23f200$var$count++;
        return ()=>{
            if ($38bbe2f1de23f200$var$count === 1) document.querySelectorAll("[data-radix-focus-guard]").forEach((node)=>node.remove());
            $38bbe2f1de23f200$var$count--;
        };
    }, []);
}
function $38bbe2f1de23f200$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none";
    return element;
}
var $38bbe2f1de23f200$export$be92b6f5f03c0fe9 = $38bbe2f1de23f200$export$ac5b58043b79449b;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $1e2082910c54650f$var$extendStatics = function(d, b) {
    $1e2082910c54650f$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $1e2082910c54650f$var$extendStatics(d, b);
};
function $1e2082910c54650f$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $1e2082910c54650f$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $1e2082910c54650f$export$18ce0697a983be9b = function() {
    $1e2082910c54650f$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $1e2082910c54650f$export$18ce0697a983be9b.apply(this, arguments);
};
function $1e2082910c54650f$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $1e2082910c54650f$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $1e2082910c54650f$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $1e2082910c54650f$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $1e2082910c54650f$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $1e2082910c54650f$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $1e2082910c54650f$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $1e2082910c54650f$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $1e2082910c54650f$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $1e2082910c54650f$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $1e2082910c54650f$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $1e2082910c54650f$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $1e2082910c54650f$export$45d3717a4c69092e(o, m, p);
}
function $1e2082910c54650f$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $1e2082910c54650f$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $1e2082910c54650f$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($1e2082910c54650f$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $1e2082910c54650f$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $1e2082910c54650f$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $1e2082910c54650f$export$10c90e4f7922046c(v) {
    return this instanceof $1e2082910c54650f$export$10c90e4f7922046c ? (this.v = v, this) : new $1e2082910c54650f$export$10c90e4f7922046c(v);
}
function $1e2082910c54650f$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $1e2082910c54650f$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $1e2082910c54650f$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $1e2082910c54650f$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $1e2082910c54650f$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $1e2082910c54650f$export$19a8beecd37a4c45 === "function" ? $1e2082910c54650f$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $1e2082910c54650f$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $1e2082910c54650f$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $1e2082910c54650f$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $1e2082910c54650f$export$45d3717a4c69092e(result, mod, k);
    }
    $1e2082910c54650f$var$__setModuleDefault(result, mod);
    return result;
}
function $1e2082910c54650f$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $1e2082910c54650f$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $1e2082910c54650f$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $1e2082910c54650f$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $1e2082910c54650f$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $1e2082910c54650f$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $1e2082910c54650f$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $1e2082910c54650f$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $1e2082910c54650f$export$2e2bcd8739ae039 = {
    __extends: $1e2082910c54650f$export$a8ba968b8961cb8a,
    __assign: $1e2082910c54650f$export$18ce0697a983be9b,
    __rest: $1e2082910c54650f$export$3c9a16f847548506,
    __decorate: $1e2082910c54650f$export$29e00dfd3077644b,
    __param: $1e2082910c54650f$export$d5ad3fd78186038f,
    __metadata: $1e2082910c54650f$export$f1db080c865becb9,
    __awaiter: $1e2082910c54650f$export$1050f835b63b671e,
    __generator: $1e2082910c54650f$export$67ebef60e6f28a6,
    __createBinding: $1e2082910c54650f$export$45d3717a4c69092e,
    __exportStar: $1e2082910c54650f$export$f33643c0debef087,
    __values: $1e2082910c54650f$export$19a8beecd37a4c45,
    __read: $1e2082910c54650f$export$8d051b38c9118094,
    __spread: $1e2082910c54650f$export$afc72e2116322959,
    __spreadArrays: $1e2082910c54650f$export$6388937ca91ccae8,
    __spreadArray: $1e2082910c54650f$export$1216008129fb82ed,
    __await: $1e2082910c54650f$export$10c90e4f7922046c,
    __asyncGenerator: $1e2082910c54650f$export$e427f37a30a4de9b,
    __asyncDelegator: $1e2082910c54650f$export$bbd80228419bb833,
    __asyncValues: $1e2082910c54650f$export$e3b29a3d6162315f,
    __makeTemplateObject: $1e2082910c54650f$export$4fb47efe1390b86f,
    __importStar: $1e2082910c54650f$export$c21735bcef00d192,
    __importDefault: $1e2082910c54650f$export$da59b14a69baef04,
    __classPrivateFieldGet: $1e2082910c54650f$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $1e2082910c54650f$export$d40a35129aaff81f,
    __classPrivateFieldIn: $1e2082910c54650f$export$81fdc39f203e4e04,
    __addDisposableResource: $1e2082910c54650f$export$88ac25d8e944e405,
    __disposeResources: $1e2082910c54650f$export$8f076105dc360e92
};



var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
var $576cbb0e2c42ea12$export$1da7500147d4bc3 = "right-scroll-bar-position";
var $576cbb0e2c42ea12$export$898e37bbd2a0ae4e = "width-before-scroll-bar";
var $576cbb0e2c42ea12$export$bb813dfbbc432abc = "with-scroll-bars-hidden";
var $576cbb0e2c42ea12$export$63d0edf80fea83b1 = "--removed-body-scroll-bar-size";



var $7fPBF = parcelRequire("7fPBF");
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $b92e63d00f44a32a$export$d734136a7b018efe(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $7fPBF = parcelRequire("7fPBF");
function $9852bc1860f56139$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $7fPBF.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


var $3aa02bc85fadbfb9$var$useIsomorphicLayoutEffect = typeof window !== "undefined" ? $7fPBF.useLayoutEffect : $7fPBF.useEffect;
var $3aa02bc85fadbfb9$var$currentValues = new WeakMap();
function $3aa02bc85fadbfb9$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $9852bc1860f56139$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $b92e63d00f44a32a$export$d734136a7b018efe)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $3aa02bc85fadbfb9$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $3aa02bc85fadbfb9$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $b92e63d00f44a32a$export$d734136a7b018efe)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $b92e63d00f44a32a$export$d734136a7b018efe)(ref, current_1);
            });
        }
        $3aa02bc85fadbfb9$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $2c4a9384fea955aa$var$extendStatics = function(d, b) {
    $2c4a9384fea955aa$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $2c4a9384fea955aa$var$extendStatics(d, b);
};
function $2c4a9384fea955aa$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $2c4a9384fea955aa$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $2c4a9384fea955aa$export$18ce0697a983be9b = function() {
    $2c4a9384fea955aa$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2c4a9384fea955aa$export$18ce0697a983be9b.apply(this, arguments);
};
function $2c4a9384fea955aa$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $2c4a9384fea955aa$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $2c4a9384fea955aa$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $2c4a9384fea955aa$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $2c4a9384fea955aa$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $2c4a9384fea955aa$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $2c4a9384fea955aa$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $2c4a9384fea955aa$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $2c4a9384fea955aa$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $2c4a9384fea955aa$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $2c4a9384fea955aa$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $2c4a9384fea955aa$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $2c4a9384fea955aa$export$45d3717a4c69092e(o, m, p);
}
function $2c4a9384fea955aa$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $2c4a9384fea955aa$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $2c4a9384fea955aa$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($2c4a9384fea955aa$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $2c4a9384fea955aa$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $2c4a9384fea955aa$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $2c4a9384fea955aa$export$10c90e4f7922046c(v) {
    return this instanceof $2c4a9384fea955aa$export$10c90e4f7922046c ? (this.v = v, this) : new $2c4a9384fea955aa$export$10c90e4f7922046c(v);
}
function $2c4a9384fea955aa$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $2c4a9384fea955aa$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $2c4a9384fea955aa$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $2c4a9384fea955aa$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $2c4a9384fea955aa$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $2c4a9384fea955aa$export$19a8beecd37a4c45 === "function" ? $2c4a9384fea955aa$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $2c4a9384fea955aa$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $2c4a9384fea955aa$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $2c4a9384fea955aa$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2c4a9384fea955aa$export$45d3717a4c69092e(result, mod, k);
    }
    $2c4a9384fea955aa$var$__setModuleDefault(result, mod);
    return result;
}
function $2c4a9384fea955aa$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $2c4a9384fea955aa$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $2c4a9384fea955aa$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $2c4a9384fea955aa$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $2c4a9384fea955aa$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $2c4a9384fea955aa$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $2c4a9384fea955aa$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $2c4a9384fea955aa$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
var $2c4a9384fea955aa$export$2e2bcd8739ae039 = {
    __extends: $2c4a9384fea955aa$export$a8ba968b8961cb8a,
    __assign: $2c4a9384fea955aa$export$18ce0697a983be9b,
    __rest: $2c4a9384fea955aa$export$3c9a16f847548506,
    __decorate: $2c4a9384fea955aa$export$29e00dfd3077644b,
    __param: $2c4a9384fea955aa$export$d5ad3fd78186038f,
    __metadata: $2c4a9384fea955aa$export$f1db080c865becb9,
    __awaiter: $2c4a9384fea955aa$export$1050f835b63b671e,
    __generator: $2c4a9384fea955aa$export$67ebef60e6f28a6,
    __createBinding: $2c4a9384fea955aa$export$45d3717a4c69092e,
    __exportStar: $2c4a9384fea955aa$export$f33643c0debef087,
    __values: $2c4a9384fea955aa$export$19a8beecd37a4c45,
    __read: $2c4a9384fea955aa$export$8d051b38c9118094,
    __spread: $2c4a9384fea955aa$export$afc72e2116322959,
    __spreadArrays: $2c4a9384fea955aa$export$6388937ca91ccae8,
    __spreadArray: $2c4a9384fea955aa$export$1216008129fb82ed,
    __await: $2c4a9384fea955aa$export$10c90e4f7922046c,
    __asyncGenerator: $2c4a9384fea955aa$export$e427f37a30a4de9b,
    __asyncDelegator: $2c4a9384fea955aa$export$bbd80228419bb833,
    __asyncValues: $2c4a9384fea955aa$export$e3b29a3d6162315f,
    __makeTemplateObject: $2c4a9384fea955aa$export$4fb47efe1390b86f,
    __importStar: $2c4a9384fea955aa$export$c21735bcef00d192,
    __importDefault: $2c4a9384fea955aa$export$da59b14a69baef04,
    __classPrivateFieldGet: $2c4a9384fea955aa$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $2c4a9384fea955aa$export$d40a35129aaff81f,
    __classPrivateFieldIn: $2c4a9384fea955aa$export$81fdc39f203e4e04,
    __addDisposableResource: $2c4a9384fea955aa$export$88ac25d8e944e405,
    __disposeResources: $2c4a9384fea955aa$export$8f076105dc360e92
};


function $efceb32ecd78f18d$var$ItoI(a) {
    return a;
}
function $efceb32ecd78f18d$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $efceb32ecd78f18d$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $efceb32ecd78f18d$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $efceb32ecd78f18d$var$ItoI;
    return $efceb32ecd78f18d$var$innerCreateMedium(defaults, middleware);
}
function $efceb32ecd78f18d$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $efceb32ecd78f18d$var$innerCreateMedium(null);
    medium.options = (0, $2c4a9384fea955aa$export$18ce0697a983be9b)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $fbab39904a684810$export$e27363444bedfeac = (0, $efceb32ecd78f18d$export$e13ec7dd7a14088d)();


var $25d27fc5e29f9d4f$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $25d27fc5e29f9d4f$export$22940b497e769dee = $7fPBF.forwardRef(function(props, parentRef) {
    var ref = $7fPBF.useRef(null);
    var _a = $7fPBF.useState({
        onScrollCapture: $25d27fc5e29f9d4f$var$nothing,
        onWheelCapture: $25d27fc5e29f9d4f$var$nothing,
        onTouchMoveCapture: $25d27fc5e29f9d4f$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? "div" : _b, gapMode = props.gapMode, rest = (0, $1e2082910c54650f$export$3c9a16f847548506)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $3aa02bc85fadbfb9$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $1e2082910c54650f$export$18ce0697a983be9b)((0, $1e2082910c54650f$export$18ce0697a983be9b)({}, rest), callbacks);
    return $7fPBF.createElement($7fPBF.Fragment, null, enabled && $7fPBF.createElement(SideCar, {
        sideCar: (0, $fbab39904a684810$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $7fPBF.cloneElement($7fPBF.Children.only(children), (0, $1e2082910c54650f$export$18ce0697a983be9b)((0, $1e2082910c54650f$export$18ce0697a983be9b)({}, containerProps), {
        ref: containerRef
    })) : $7fPBF.createElement(Container, (0, $1e2082910c54650f$export$18ce0697a983be9b)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$25d27fc5e29f9d4f$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$25d27fc5e29f9d4f$export$22940b497e769dee.classNames = {
    fullWidth: (0, $576cbb0e2c42ea12$export$898e37bbd2a0ae4e),
    zeroRight: (0, $576cbb0e2c42ea12$export$1da7500147d4bc3)
};




var $7fPBF = parcelRequire("7fPBF");
var $e6d091439ffe4730$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $2c4a9384fea955aa$export$3c9a16f847548506)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error("Sidecar: please provide `sideCar` property to import the right car");
    var Target = sideCar.read();
    if (!Target) throw new Error("Sidecar medium not found");
    return $7fPBF.createElement(Target, (0, $2c4a9384fea955aa$export$18ce0697a983be9b)({}, rest));
};
$e6d091439ffe4730$var$SideCar.isSideCarExport = true;
function $e6d091439ffe4730$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $e6d091439ffe4730$var$SideCar;
}




var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $9f919e109ac196c0$var$currentNonce;
var $9f919e109ac196c0$export$c5f670b24c0ae95a = function(nonce) {
    $9f919e109ac196c0$var$currentNonce = nonce;
};
var $9f919e109ac196c0$export$2b85b721e524d74b = function() {
    if ($9f919e109ac196c0$var$currentNonce) return $9f919e109ac196c0$var$currentNonce;
    if (typeof __webpack_nonce__ !== "undefined") return __webpack_nonce__;
    return undefined;
};


function $5ffdb52866173f3a$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement("style");
    tag.type = "text/css";
    var nonce = (0, $9f919e109ac196c0$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute("nonce", nonce);
    return tag;
}
function $5ffdb52866173f3a$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $5ffdb52866173f3a$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName("head")[0];
    head.appendChild(tag);
}
var $5ffdb52866173f3a$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $5ffdb52866173f3a$var$makeStyleTag()) {
                    $5ffdb52866173f3a$var$injectStyles(stylesheet, style);
                    $5ffdb52866173f3a$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $8227302f574dc881$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $5ffdb52866173f3a$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $7fPBF.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $6c29cb1f12180b44$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $8227302f574dc881$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $f97eaa4d6e878789$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $f97eaa4d6e878789$var$parse = function(x) {
    return parseInt(x || "", 10) || 0;
};
var $f97eaa4d6e878789$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
    var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
    var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
    return [
        $f97eaa4d6e878789$var$parse(left),
        $f97eaa4d6e878789$var$parse(top),
        $f97eaa4d6e878789$var$parse(right)
    ];
};
var $f97eaa4d6e878789$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = "margin";
    if (typeof window === "undefined") return $f97eaa4d6e878789$export$efed13b5d0ca3386;
    var offsets = $f97eaa4d6e878789$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $d74ee05d1ffdc30c$var$Style = (0, $6c29cb1f12180b44$export$c1248ee86ba532c8)();
var $d74ee05d1ffdc30c$export$65254d5f26cb9564 = "data-scroll-locked";
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $d74ee05d1ffdc30c$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = "margin";
    return "\n  .".concat((0, $576cbb0e2c42ea12$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($d74ee05d1ffdc30c$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(""), "\n  }\n  \n  .").concat((0, $576cbb0e2c42ea12$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $576cbb0e2c42ea12$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $576cbb0e2c42ea12$export$1da7500147d4bc3), " .").concat((0, $576cbb0e2c42ea12$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $576cbb0e2c42ea12$export$898e37bbd2a0ae4e), " .").concat((0, $576cbb0e2c42ea12$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($d74ee05d1ffdc30c$export$65254d5f26cb9564, "] {\n    ").concat((0, $576cbb0e2c42ea12$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $d74ee05d1ffdc30c$var$getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute($d74ee05d1ffdc30c$export$65254d5f26cb9564) || "0", 10);
    return isFinite(counter) ? counter : 0;
};
var $d74ee05d1ffdc30c$export$a1939b1f9f9b02dc = function() {
    $7fPBF.useEffect(function() {
        document.body.setAttribute($d74ee05d1ffdc30c$export$65254d5f26cb9564, ($d74ee05d1ffdc30c$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $d74ee05d1ffdc30c$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($d74ee05d1ffdc30c$export$65254d5f26cb9564);
            else document.body.setAttribute($d74ee05d1ffdc30c$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
var $d74ee05d1ffdc30c$export$9aa43b459c5ae9b9 = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? "margin" : _b;
    $d74ee05d1ffdc30c$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $7fPBF.useMemo(function() {
        return (0, $f97eaa4d6e878789$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $7fPBF.createElement($d74ee05d1ffdc30c$var$Style, {
        styles: $d74ee05d1ffdc30c$var$getStyles(gap, !noRelative, gapMode, !noImportant ? "!important" : "")
    });
};







var $cf3d467337310f3d$var$passiveSupported = false;
if (typeof window !== "undefined") try {
    var $cf3d467337310f3d$var$options = Object.defineProperty({}, "passive", {
        get: function() {
            $cf3d467337310f3d$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener("test", $cf3d467337310f3d$var$options, $cf3d467337310f3d$var$options);
    // @ts-ignore
    window.removeEventListener("test", $cf3d467337310f3d$var$options, $cf3d467337310f3d$var$options);
} catch (err) {
    $cf3d467337310f3d$var$passiveSupported = false;
}
var $cf3d467337310f3d$export$10a6e88623fa9454 = $cf3d467337310f3d$var$passiveSupported ? {
    passive: false
} : false;


var $c5b91173956af4fd$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === "TEXTAREA";
};
var $c5b91173956af4fd$var$elementCanBeScrolled = function(node, overflow) {
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== "hidden" && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$c5b91173956af4fd$var$alwaysContainsScroll(node) && styles[overflow] === "visible"));
};
var $c5b91173956af4fd$var$elementCouldBeVScrolled = function(node) {
    return $c5b91173956af4fd$var$elementCanBeScrolled(node, "overflowY");
};
var $c5b91173956af4fd$var$elementCouldBeHScrolled = function(node) {
    return $c5b91173956af4fd$var$elementCanBeScrolled(node, "overflowX");
};
var $c5b91173956af4fd$export$9ec64480cae49817 = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $c5b91173956af4fd$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $c5b91173956af4fd$var$getScrollVariables(axis, current), s = _a[1], d = _a[2];
            if (s > d) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $c5b91173956af4fd$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $c5b91173956af4fd$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $c5b91173956af4fd$var$elementCouldBeScrolled = function(axis, node) {
    return axis === "v" ? $c5b91173956af4fd$var$elementCouldBeVScrolled(node) : $c5b91173956af4fd$var$elementCouldBeHScrolled(node);
};
var $c5b91173956af4fd$var$getScrollVariables = function(axis, node) {
    return axis === "v" ? $c5b91173956af4fd$var$getVScrollVariables(node) : $c5b91173956af4fd$var$getHScrollVariables(node);
};
var $c5b91173956af4fd$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === "h" && direction === "rtl" ? -1 : 1;
};
var $c5b91173956af4fd$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $c5b91173956af4fd$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        var _a = $c5b91173956af4fd$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($c5b91173956af4fd$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        if (target instanceof ShadowRoot) target = target.host;
        else target = target.parentNode;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $0905ffb48d1f80f5$export$6e085704a79f4f56 = function(event) {
    return "changedTouches" in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $0905ffb48d1f80f5$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $0905ffb48d1f80f5$var$extractRef = function(ref) {
    return ref && "current" in ref ? ref.current : ref;
};
var $0905ffb48d1f80f5$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $0905ffb48d1f80f5$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $0905ffb48d1f80f5$var$idCounter = 0;
var $0905ffb48d1f80f5$var$lockStack = [];
function $0905ffb48d1f80f5$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $7fPBF.useRef([]);
    var touchStartRef = $7fPBF.useRef([
        0,
        0
    ]);
    var activeAxis = $7fPBF.useRef();
    var id = $7fPBF.useState($0905ffb48d1f80f5$var$idCounter++)[0];
    var Style = $7fPBF.useState((0, $6c29cb1f12180b44$export$c1248ee86ba532c8))[0];
    var lastProps = $7fPBF.useRef(props);
    $7fPBF.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $7fPBF.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $1e2082910c54650f$export$1216008129fb82ed)([
                props.lockRef.current
            ], (props.shards || []).map($0905ffb48d1f80f5$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $7fPBF.useCallback(function(event, parent) {
        if ("touches" in event && event.touches.length === 2) return !lastProps.current.allowPinchZoom;
        var touch = $0905ffb48d1f80f5$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ("touches" in event && moveDirection === "h" && target.type === "range") return false;
        var canBeScrolledInMainDirection = (0, $c5b91173956af4fd$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === "v" ? "h" : "v";
            canBeScrolledInMainDirection = (0, $c5b91173956af4fd$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $c5b91173956af4fd$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $7fPBF.useCallback(function(_event) {
        var event = _event;
        if (!$0905ffb48d1f80f5$var$lockStack.length || $0905ffb48d1f80f5$var$lockStack[$0905ffb48d1f80f5$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = "deltaY" in event ? $0905ffb48d1f80f5$export$39efaa2ca254a28d(event) : $0905ffb48d1f80f5$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && $0905ffb48d1f80f5$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($0905ffb48d1f80f5$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $7fPBF.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: $0905ffb48d1f80f5$var$getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $7fPBF.useCallback(function(event) {
        touchStartRef.current = $0905ffb48d1f80f5$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $7fPBF.useCallback(function(event) {
        shouldCancel(event.type, $0905ffb48d1f80f5$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $7fPBF.useCallback(function(event) {
        shouldCancel(event.type, $0905ffb48d1f80f5$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $7fPBF.useEffect(function() {
        $0905ffb48d1f80f5$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener("wheel", shouldPrevent, (0, $cf3d467337310f3d$export$10a6e88623fa9454));
        document.addEventListener("touchmove", shouldPrevent, (0, $cf3d467337310f3d$export$10a6e88623fa9454));
        document.addEventListener("touchstart", scrollTouchStart, (0, $cf3d467337310f3d$export$10a6e88623fa9454));
        return function() {
            $0905ffb48d1f80f5$var$lockStack = $0905ffb48d1f80f5$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener("wheel", shouldPrevent, (0, $cf3d467337310f3d$export$10a6e88623fa9454));
            document.removeEventListener("touchmove", shouldPrevent, (0, $cf3d467337310f3d$export$10a6e88623fa9454));
            document.removeEventListener("touchstart", scrollTouchStart, (0, $cf3d467337310f3d$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $7fPBF.createElement($7fPBF.Fragment, null, inert ? $7fPBF.createElement(Style, {
        styles: $0905ffb48d1f80f5$var$generateStyle(id)
    }) : null, removeScrollBar ? $7fPBF.createElement((0, $d74ee05d1ffdc30c$export$9aa43b459c5ae9b9), {
        gapMode: props.gapMode
    }) : null);
}
function $0905ffb48d1f80f5$var$getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}



var $cc925483b10fccaa$export$2e2bcd8739ae039 = (0, $e6d091439ffe4730$export$6cacc8fb0a9b94ce)((0, $fbab39904a684810$export$e27363444bedfeac), (0, $0905ffb48d1f80f5$export$a09dbff87b5da2d));


var $ef57a4b421076988$var$ReactRemoveScroll = $7fPBF.forwardRef(function(props, ref) {
    return $7fPBF.createElement((0, $25d27fc5e29f9d4f$export$22940b497e769dee), (0, $1e2082910c54650f$export$18ce0697a983be9b)({}, props, {
        ref: ref,
        sideCar: (0, $cc925483b10fccaa$export$2e2bcd8739ae039)
    }));
});
$ef57a4b421076988$var$ReactRemoveScroll.classNames = (0, $25d27fc5e29f9d4f$export$22940b497e769dee).classNames;
var $ef57a4b421076988$export$2e2bcd8739ae039 = $ef57a4b421076988$var$ReactRemoveScroll;


var $2950574f4b60c018$var$getDefaultParent = function(originalTarget) {
    if (typeof document === "undefined") return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $2950574f4b60c018$var$counterMap = new WeakMap();
var $2950574f4b60c018$var$uncontrolledNodes = new WeakMap();
var $2950574f4b60c018$var$markerMap = {};
var $2950574f4b60c018$var$lockCount = 0;
var $2950574f4b60c018$var$unwrapHost = function(node) {
    return node && (node.host || $2950574f4b60c018$var$unwrapHost(node.parentNode));
};
var $2950574f4b60c018$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $2950574f4b60c018$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error("aria-hidden", target, "in not contained inside", parent, ". Doing nothing");
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $2950574f4b60c018$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $2950574f4b60c018$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$2950574f4b60c018$var$markerMap[markerName]) $2950574f4b60c018$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $2950574f4b60c018$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else try {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== "false";
                var counterValue = ($2950574f4b60c018$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $2950574f4b60c018$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $2950574f4b60c018$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, "true");
                if (!alreadyHidden) node.setAttribute(controlAttribute, "true");
            } catch (e) {
                console.error("aria-hidden: cannot operate on ", node, e);
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $2950574f4b60c018$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $2950574f4b60c018$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $2950574f4b60c018$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$2950574f4b60c018$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $2950574f4b60c018$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $2950574f4b60c018$var$lockCount--;
        if (!$2950574f4b60c018$var$lockCount) {
            // clear
            $2950574f4b60c018$var$counterMap = new WeakMap();
            $2950574f4b60c018$var$counterMap = new WeakMap();
            $2950574f4b60c018$var$uncontrolledNodes = new WeakMap();
            $2950574f4b60c018$var$markerMap = {};
        }
    };
};
var $2950574f4b60c018$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-aria-hidden";
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $2950574f4b60c018$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide ariaLive elements - https://github.com/theKashey/aria-hidden/issues/10
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll("[aria-live]")));
    return $2950574f4b60c018$var$applyAttributeToOthers(targets, activeParentNode, markerName, "aria-hidden");
};
var $2950574f4b60c018$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-inert-ed";
    var activeParentNode = parentNode || $2950574f4b60c018$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $2950574f4b60c018$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, "inert");
};
var $2950574f4b60c018$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== "undefined" && HTMLElement.prototype.hasOwnProperty("inert");
};
var $2950574f4b60c018$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = "data-suppressed";
    return ($2950574f4b60c018$export$cc95fea82d705fca() ? $2950574f4b60c018$export$59151cc8db999a24 : $2950574f4b60c018$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};




"use client";
var $eff5647826d6bc5d$var$DIALOG_NAME = "Dialog";
var [$eff5647826d6bc5d$var$createDialogContext, $eff5647826d6bc5d$export$cc702773b8ea3e41] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)($eff5647826d6bc5d$var$DIALOG_NAME);
var [$eff5647826d6bc5d$var$DialogProvider, $eff5647826d6bc5d$var$useDialogContext] = $eff5647826d6bc5d$var$createDialogContext($eff5647826d6bc5d$var$DIALOG_NAME);
var $eff5647826d6bc5d$export$3ddf2d174ce01153 = (props)=>{
    const { __scopeDialog: __scopeDialog, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = true } = props;
    const triggerRef = $7fPBF.useRef(null);
    const contentRef = $7fPBF.useRef(null);
    const [open = false, setOpen] = (0, $915387e6ab4d88b1$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($eff5647826d6bc5d$var$DialogProvider, {
        scope: __scopeDialog,
        triggerRef: triggerRef,
        contentRef: contentRef,
        contentId: (0, $8a8e9b94c33ba6d6$export$f680877a34711e37)(),
        titleId: (0, $8a8e9b94c33ba6d6$export$f680877a34711e37)(),
        descriptionId: (0, $8a8e9b94c33ba6d6$export$f680877a34711e37)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: $7fPBF.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal,
        children: children
    });
};
$eff5647826d6bc5d$export$3ddf2d174ce01153.displayName = $eff5647826d6bc5d$var$DIALOG_NAME;
var $eff5647826d6bc5d$var$TRIGGER_NAME = "DialogTrigger";
var $eff5647826d6bc5d$export$2e1e1122cf0cba88 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...triggerProps } = props;
    const context = $eff5647826d6bc5d$var$useDialogContext($eff5647826d6bc5d$var$TRIGGER_NAME, __scopeDialog);
    const composedTriggerRef = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).button, {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $eff5647826d6bc5d$var$getState(context.open),
        ...triggerProps,
        ref: composedTriggerRef,
        onClick: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    });
});
$eff5647826d6bc5d$export$2e1e1122cf0cba88.displayName = $eff5647826d6bc5d$var$TRIGGER_NAME;
var $eff5647826d6bc5d$var$PORTAL_NAME = "DialogPortal";
var [$eff5647826d6bc5d$var$PortalProvider, $eff5647826d6bc5d$var$usePortalContext] = $eff5647826d6bc5d$var$createDialogContext($eff5647826d6bc5d$var$PORTAL_NAME, {
    forceMount: void 0
});
var $eff5647826d6bc5d$export$dad7c95542bacce0 = (props)=>{
    const { __scopeDialog: __scopeDialog, forceMount: forceMount, children: children, container: container } = props;
    const context = $eff5647826d6bc5d$var$useDialogContext($eff5647826d6bc5d$var$PORTAL_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($eff5647826d6bc5d$var$PortalProvider, {
        scope: __scopeDialog,
        forceMount: forceMount,
        children: $7fPBF.Children.map(children, (child)=>/* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $e9ce08b8e6e14786$export$99c2b779aa4e8b8b), {
                present: forceMount || context.open,
                children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $57c7abe8fecdeb41$export$602eac185826482c), {
                    asChild: true,
                    container: container,
                    children: child
                })
            }))
    });
};
$eff5647826d6bc5d$export$dad7c95542bacce0.displayName = $eff5647826d6bc5d$var$PORTAL_NAME;
var $eff5647826d6bc5d$var$OVERLAY_NAME = "DialogOverlay";
var $eff5647826d6bc5d$export$bd1d06c79be19e17 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const portalContext = $eff5647826d6bc5d$var$usePortalContext($eff5647826d6bc5d$var$OVERLAY_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...overlayProps } = props;
    const context = $eff5647826d6bc5d$var$useDialogContext($eff5647826d6bc5d$var$OVERLAY_NAME, props.__scopeDialog);
    return context.modal ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $e9ce08b8e6e14786$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($eff5647826d6bc5d$var$DialogOverlayImpl, {
            ...overlayProps,
            ref: forwardedRef
        })
    }) : null;
});
$eff5647826d6bc5d$export$bd1d06c79be19e17.displayName = $eff5647826d6bc5d$var$OVERLAY_NAME;
var $eff5647826d6bc5d$var$DialogOverlayImpl = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...overlayProps } = props;
    const context = $eff5647826d6bc5d$var$useDialogContext($eff5647826d6bc5d$var$OVERLAY_NAME, __scopeDialog);
    return(// Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $ef57a4b421076988$export$2e2bcd8739ae039), {
        as: (0, $089057084dfb92a4$export$8c6ed5c666ac1360),
        allowPinchZoom: true,
        shards: [
            context.contentRef
        ],
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
            "data-state": $eff5647826d6bc5d$var$getState(context.open),
            ...overlayProps,
            ref: forwardedRef,
            style: {
                pointerEvents: "auto",
                ...overlayProps.style
            }
        })
    }));
});
var $eff5647826d6bc5d$var$CONTENT_NAME = "DialogContent";
var $eff5647826d6bc5d$export$b6d9565de1e068cf = $7fPBF.forwardRef((props, forwardedRef)=>{
    const portalContext = $eff5647826d6bc5d$var$usePortalContext($eff5647826d6bc5d$var$CONTENT_NAME, props.__scopeDialog);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $eff5647826d6bc5d$var$useDialogContext($eff5647826d6bc5d$var$CONTENT_NAME, props.__scopeDialog);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $e9ce08b8e6e14786$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: context.modal ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($eff5647826d6bc5d$var$DialogContentModal, {
            ...contentProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($eff5647826d6bc5d$var$DialogContentNonModal, {
            ...contentProps,
            ref: forwardedRef
        })
    });
});
$eff5647826d6bc5d$export$b6d9565de1e068cf.displayName = $eff5647826d6bc5d$var$CONTENT_NAME;
var $eff5647826d6bc5d$var$DialogContentModal = $7fPBF.forwardRef((props, forwardedRef)=>{
    const context = $eff5647826d6bc5d$var$useDialogContext($eff5647826d6bc5d$var$CONTENT_NAME, props.__scopeDialog);
    const contentRef = $7fPBF.useRef(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, context.contentRef, contentRef);
    $7fPBF.useEffect(()=>{
        const content = contentRef.current;
        if (content) return (0, $2950574f4b60c018$export$6e33d16126ed003c)(content);
    }, []);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($eff5647826d6bc5d$var$DialogContentImpl, {
        ...props,
        ref: composedRefs,
        trapFocus: context.open,
        disableOutsidePointerEvents: true,
        onCloseAutoFocus: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            var _context_triggerRef_current;
            event.preventDefault();
            (_context_triggerRef_current = context.triggerRef.current) === null || _context_triggerRef_current === void 0 ? void 0 : _context_triggerRef_current.focus();
        }),
        onPointerDownOutside: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            if (isRightClick) event.preventDefault();
        }),
        onFocusOutside: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault())
    });
});
var $eff5647826d6bc5d$var$DialogContentNonModal = $7fPBF.forwardRef((props, forwardedRef)=>{
    const context = $eff5647826d6bc5d$var$useDialogContext($eff5647826d6bc5d$var$CONTENT_NAME, props.__scopeDialog);
    const hasInteractedOutsideRef = $7fPBF.useRef(false);
    const hasPointerDownOutsideRef = $7fPBF.useRef(false);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($eff5647826d6bc5d$var$DialogContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            var _props_onCloseAutoFocus;
            (_props_onCloseAutoFocus = props.onCloseAutoFocus) === null || _props_onCloseAutoFocus === void 0 ? void 0 : _props_onCloseAutoFocus.call(props, event);
            if (!event.defaultPrevented) {
                var _context_triggerRef_current;
                if (!hasInteractedOutsideRef.current) (_context_triggerRef_current = context.triggerRef.current) === null || _context_triggerRef_current === void 0 ? void 0 : _context_triggerRef_current.focus();
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            var _props_onInteractOutside, _context_triggerRef_current;
            (_props_onInteractOutside = props.onInteractOutside) === null || _props_onInteractOutside === void 0 ? void 0 : _props_onInteractOutside.call(props, event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            }
            const target = event.target;
            const targetIsTrigger = (_context_triggerRef_current = context.triggerRef.current) === null || _context_triggerRef_current === void 0 ? void 0 : _context_triggerRef_current.contains(target);
            if (targetIsTrigger) event.preventDefault();
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    });
});
var $eff5647826d6bc5d$var$DialogContentImpl = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, ...contentProps } = props;
    const context = $eff5647826d6bc5d$var$useDialogContext($eff5647826d6bc5d$var$CONTENT_NAME, __scopeDialog);
    const contentRef = $7fPBF.useRef(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, contentRef);
    (0, $38bbe2f1de23f200$export$b7ece24a22aeda8c)();
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $0d555b2b0a3ffff1$export$20e40289641fbbb6), {
                asChild: true,
                loop: true,
                trapped: trapFocus,
                onMountAutoFocus: onOpenAutoFocus,
                onUnmountAutoFocus: onCloseAutoFocus,
                children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $251340165f4765e5$export$177fb62ff3ec1f22), {
                    role: "dialog",
                    id: context.contentId,
                    "aria-describedby": context.descriptionId,
                    "aria-labelledby": context.titleId,
                    "data-state": $eff5647826d6bc5d$var$getState(context.open),
                    ...contentProps,
                    ref: composedRefs,
                    onDismiss: ()=>context.onOpenChange(false)
                })
            }),
            /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($eff5647826d6bc5d$var$TitleWarning, {
                        titleId: context.titleId
                    }),
                    /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($eff5647826d6bc5d$var$DescriptionWarning, {
                        contentRef: contentRef,
                        descriptionId: context.descriptionId
                    })
                ]
            })
        ]
    });
});
var $eff5647826d6bc5d$var$TITLE_NAME = "DialogTitle";
var $eff5647826d6bc5d$export$16f7638e4a34b909 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...titleProps } = props;
    const context = $eff5647826d6bc5d$var$useDialogContext($eff5647826d6bc5d$var$TITLE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).h2, {
        id: context.titleId,
        ...titleProps,
        ref: forwardedRef
    });
});
$eff5647826d6bc5d$export$16f7638e4a34b909.displayName = $eff5647826d6bc5d$var$TITLE_NAME;
var $eff5647826d6bc5d$var$DESCRIPTION_NAME = "DialogDescription";
var $eff5647826d6bc5d$export$94e94c2ec2c954d5 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...descriptionProps } = props;
    const context = $eff5647826d6bc5d$var$useDialogContext($eff5647826d6bc5d$var$DESCRIPTION_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).p, {
        id: context.descriptionId,
        ...descriptionProps,
        ref: forwardedRef
    });
});
$eff5647826d6bc5d$export$94e94c2ec2c954d5.displayName = $eff5647826d6bc5d$var$DESCRIPTION_NAME;
var $eff5647826d6bc5d$var$CLOSE_NAME = "DialogClose";
var $eff5647826d6bc5d$export$fba2fb7cd781b7ac = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeDialog: __scopeDialog, ...closeProps } = props;
    const context = $eff5647826d6bc5d$var$useDialogContext($eff5647826d6bc5d$var$CLOSE_NAME, __scopeDialog);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).button, {
        type: "button",
        ...closeProps,
        ref: forwardedRef,
        onClick: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    });
});
$eff5647826d6bc5d$export$fba2fb7cd781b7ac.displayName = $eff5647826d6bc5d$var$CLOSE_NAME;
function $eff5647826d6bc5d$var$getState(open) {
    return open ? "open" : "closed";
}
var $eff5647826d6bc5d$var$TITLE_WARNING_NAME = "DialogTitleWarning";
var [$eff5647826d6bc5d$export$69b62a49393917d6, $eff5647826d6bc5d$var$useWarningContext] = (0, $d0e15db24766ddfc$export$fd42f52fd3ae1109)($eff5647826d6bc5d$var$TITLE_WARNING_NAME, {
    contentName: $eff5647826d6bc5d$var$CONTENT_NAME,
    titleName: $eff5647826d6bc5d$var$TITLE_NAME,
    docsSlug: "dialog"
});
var $eff5647826d6bc5d$var$TitleWarning = ({ titleId: titleId })=>{
    const titleWarningContext = $eff5647826d6bc5d$var$useWarningContext($eff5647826d6bc5d$var$TITLE_WARNING_NAME);
    const MESSAGE = `\`${titleWarningContext.contentName}\` requires a \`${titleWarningContext.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${titleWarningContext.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${titleWarningContext.docsSlug}`;
    $7fPBF.useEffect(()=>{
        if (titleId) {
            const hasTitle = document.getElementById(titleId);
            if (!hasTitle) console.error(MESSAGE);
        }
    }, [
        MESSAGE,
        titleId
    ]);
    return null;
};
var $eff5647826d6bc5d$var$DESCRIPTION_WARNING_NAME = "DialogDescriptionWarning";
var $eff5647826d6bc5d$var$DescriptionWarning = ({ contentRef: contentRef, descriptionId: descriptionId })=>{
    const descriptionWarningContext = $eff5647826d6bc5d$var$useWarningContext($eff5647826d6bc5d$var$DESCRIPTION_WARNING_NAME);
    const MESSAGE = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${descriptionWarningContext.contentName}}.`;
    $7fPBF.useEffect(()=>{
        var _contentRef_current;
        const describedById = (_contentRef_current = contentRef.current) === null || _contentRef_current === void 0 ? void 0 : _contentRef_current.getAttribute("aria-describedby");
        if (descriptionId && describedById) {
            const hasDescription = document.getElementById(descriptionId);
            if (!hasDescription) console.warn(MESSAGE);
        }
    }, [
        MESSAGE,
        contentRef,
        descriptionId
    ]);
    return null;
};
var $eff5647826d6bc5d$export$be92b6f5f03c0fe9 = $eff5647826d6bc5d$export$3ddf2d174ce01153;
var $eff5647826d6bc5d$export$41fb9f06171c75f4 = $eff5647826d6bc5d$export$2e1e1122cf0cba88;
var $eff5647826d6bc5d$export$602eac185826482c = $eff5647826d6bc5d$export$dad7c95542bacce0;
var $eff5647826d6bc5d$export$c6fdb837b070b4ff = $eff5647826d6bc5d$export$bd1d06c79be19e17;
var $eff5647826d6bc5d$export$7c6e2c02157bb7d2 = $eff5647826d6bc5d$export$b6d9565de1e068cf;
var $eff5647826d6bc5d$export$f99233281efd08a0 = $eff5647826d6bc5d$export$16f7638e4a34b909;
var $eff5647826d6bc5d$export$393edc798c47379d = $eff5647826d6bc5d$export$94e94c2ec2c954d5;
var $eff5647826d6bc5d$export$f39c2d165cd861fe = $eff5647826d6bc5d$export$fba2fb7cd781b7ac;





"use client";
var $3ca1ba55f468f447$var$ROOT_NAME = "AlertDialog";
var [$3ca1ba55f468f447$var$createAlertDialogContext, $3ca1ba55f468f447$export$b8891880751c2c5b] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)($3ca1ba55f468f447$var$ROOT_NAME, [
    (0, $eff5647826d6bc5d$export$cc702773b8ea3e41)
]);
var $3ca1ba55f468f447$var$useDialogScope = (0, $eff5647826d6bc5d$export$cc702773b8ea3e41)();
var $3ca1ba55f468f447$export$de466dd8317b0b75 = (props)=>{
    const { __scopeAlertDialog: __scopeAlertDialog, ...alertDialogProps } = props;
    const dialogScope = $3ca1ba55f468f447$var$useDialogScope(__scopeAlertDialog);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($eff5647826d6bc5d$export$be92b6f5f03c0fe9, {
        ...dialogScope,
        ...alertDialogProps,
        modal: true
    });
};
$3ca1ba55f468f447$export$de466dd8317b0b75.displayName = $3ca1ba55f468f447$var$ROOT_NAME;
var $3ca1ba55f468f447$var$TRIGGER_NAME = "AlertDialogTrigger";
var $3ca1ba55f468f447$export$6edd7a623ef0f40b = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog, ...triggerProps } = props;
    const dialogScope = $3ca1ba55f468f447$var$useDialogScope(__scopeAlertDialog);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($eff5647826d6bc5d$export$41fb9f06171c75f4, {
        ...dialogScope,
        ...triggerProps,
        ref: forwardedRef
    });
});
$3ca1ba55f468f447$export$6edd7a623ef0f40b.displayName = $3ca1ba55f468f447$var$TRIGGER_NAME;
var $3ca1ba55f468f447$var$PORTAL_NAME = "AlertDialogPortal";
var $3ca1ba55f468f447$export$660f2bfdb986706c = (props)=>{
    const { __scopeAlertDialog: __scopeAlertDialog, ...portalProps } = props;
    const dialogScope = $3ca1ba55f468f447$var$useDialogScope(__scopeAlertDialog);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($eff5647826d6bc5d$export$602eac185826482c, {
        ...dialogScope,
        ...portalProps
    });
};
$3ca1ba55f468f447$export$660f2bfdb986706c.displayName = $3ca1ba55f468f447$var$PORTAL_NAME;
var $3ca1ba55f468f447$var$OVERLAY_NAME = "AlertDialogOverlay";
var $3ca1ba55f468f447$export$a707a4895ce23256 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog, ...overlayProps } = props;
    const dialogScope = $3ca1ba55f468f447$var$useDialogScope(__scopeAlertDialog);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($eff5647826d6bc5d$export$c6fdb837b070b4ff, {
        ...dialogScope,
        ...overlayProps,
        ref: forwardedRef
    });
});
$3ca1ba55f468f447$export$a707a4895ce23256.displayName = $3ca1ba55f468f447$var$OVERLAY_NAME;
var $3ca1ba55f468f447$var$CONTENT_NAME = "AlertDialogContent";
var [$3ca1ba55f468f447$var$AlertDialogContentProvider, $3ca1ba55f468f447$var$useAlertDialogContentContext] = $3ca1ba55f468f447$var$createAlertDialogContext($3ca1ba55f468f447$var$CONTENT_NAME);
var $3ca1ba55f468f447$export$94e6af45f0af4efd = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog, children: children, ...contentProps } = props;
    const dialogScope = $3ca1ba55f468f447$var$useDialogScope(__scopeAlertDialog);
    const contentRef = $7fPBF.useRef(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, contentRef);
    const cancelRef = $7fPBF.useRef(null);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($eff5647826d6bc5d$export$69b62a49393917d6, {
        contentName: $3ca1ba55f468f447$var$CONTENT_NAME,
        titleName: $3ca1ba55f468f447$var$TITLE_NAME,
        docsSlug: "alert-dialog",
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($3ca1ba55f468f447$var$AlertDialogContentProvider, {
            scope: __scopeAlertDialog,
            cancelRef: cancelRef,
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)($eff5647826d6bc5d$export$7c6e2c02157bb7d2, {
                role: "alertdialog",
                ...dialogScope,
                ...contentProps,
                ref: composedRefs,
                onOpenAutoFocus: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(contentProps.onOpenAutoFocus, (event)=>{
                    var _cancelRef_current;
                    event.preventDefault();
                    (_cancelRef_current = cancelRef.current) === null || _cancelRef_current === void 0 ? void 0 : _cancelRef_current.focus({
                        preventScroll: true
                    });
                }),
                onPointerDownOutside: (event)=>event.preventDefault(),
                onInteractOutside: (event)=>event.preventDefault(),
                children: [
                    /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $089057084dfb92a4$export$d9f1ccf0bdb05d45), {
                        children: children
                    }),
                    /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($3ca1ba55f468f447$var$DescriptionWarning, {
                        contentRef: contentRef
                    })
                ]
            })
        })
    });
});
$3ca1ba55f468f447$export$94e6af45f0af4efd.displayName = $3ca1ba55f468f447$var$CONTENT_NAME;
var $3ca1ba55f468f447$var$TITLE_NAME = "AlertDialogTitle";
var $3ca1ba55f468f447$export$225e0da62d314b7 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog, ...titleProps } = props;
    const dialogScope = $3ca1ba55f468f447$var$useDialogScope(__scopeAlertDialog);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($eff5647826d6bc5d$export$f99233281efd08a0, {
        ...dialogScope,
        ...titleProps,
        ref: forwardedRef
    });
});
$3ca1ba55f468f447$export$225e0da62d314b7.displayName = $3ca1ba55f468f447$var$TITLE_NAME;
var $3ca1ba55f468f447$var$DESCRIPTION_NAME = "AlertDialogDescription";
var $3ca1ba55f468f447$export$a23b55cde55ad9a5 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog, ...descriptionProps } = props;
    const dialogScope = $3ca1ba55f468f447$var$useDialogScope(__scopeAlertDialog);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($eff5647826d6bc5d$export$393edc798c47379d, {
        ...dialogScope,
        ...descriptionProps,
        ref: forwardedRef
    });
});
$3ca1ba55f468f447$export$a23b55cde55ad9a5.displayName = $3ca1ba55f468f447$var$DESCRIPTION_NAME;
var $3ca1ba55f468f447$var$ACTION_NAME = "AlertDialogAction";
var $3ca1ba55f468f447$export$b454f818c58ee85d = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog, ...actionProps } = props;
    const dialogScope = $3ca1ba55f468f447$var$useDialogScope(__scopeAlertDialog);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($eff5647826d6bc5d$export$f39c2d165cd861fe, {
        ...dialogScope,
        ...actionProps,
        ref: forwardedRef
    });
});
$3ca1ba55f468f447$export$b454f818c58ee85d.displayName = $3ca1ba55f468f447$var$ACTION_NAME;
var $3ca1ba55f468f447$var$CANCEL_NAME = "AlertDialogCancel";
var $3ca1ba55f468f447$export$2f67a923571aaea0 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeAlertDialog: __scopeAlertDialog, ...cancelProps } = props;
    const { cancelRef: cancelRef } = $3ca1ba55f468f447$var$useAlertDialogContentContext($3ca1ba55f468f447$var$CANCEL_NAME, __scopeAlertDialog);
    const dialogScope = $3ca1ba55f468f447$var$useDialogScope(__scopeAlertDialog);
    const ref = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, cancelRef);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($eff5647826d6bc5d$export$f39c2d165cd861fe, {
        ...dialogScope,
        ...cancelProps,
        ref: ref
    });
});
$3ca1ba55f468f447$export$2f67a923571aaea0.displayName = $3ca1ba55f468f447$var$CANCEL_NAME;
var $3ca1ba55f468f447$var$DescriptionWarning = ({ contentRef: contentRef })=>{
    const MESSAGE = `\`${$3ca1ba55f468f447$var$CONTENT_NAME}\` requires a description for the component to be accessible for screen reader users.

You can add a description to the \`${$3ca1ba55f468f447$var$CONTENT_NAME}\` by passing a \`${$3ca1ba55f468f447$var$DESCRIPTION_NAME}\` component as a child, which also benefits sighted users by adding visible context to the dialog.

Alternatively, you can use your own component as a description by assigning it an \`id\` and passing the same value to the \`aria-describedby\` prop in \`${$3ca1ba55f468f447$var$CONTENT_NAME}\`. If the description is confusing or duplicative for sighted users, you can use the \`@radix-ui/react-visually-hidden\` primitive as a wrapper around your description component.

For more information, see https://radix-ui.com/primitives/docs/components/alert-dialog`;
    $7fPBF.useEffect(()=>{
        var _contentRef_current;
        const hasDescription = document.getElementById((_contentRef_current = contentRef.current) === null || _contentRef_current === void 0 ? void 0 : _contentRef_current.getAttribute("aria-describedby"));
        if (!hasDescription) console.warn(MESSAGE);
    }, [
        MESSAGE,
        contentRef
    ]);
    return null;
};
var $3ca1ba55f468f447$export$be92b6f5f03c0fe9 = $3ca1ba55f468f447$export$de466dd8317b0b75;
var $3ca1ba55f468f447$export$41fb9f06171c75f4 = $3ca1ba55f468f447$export$6edd7a623ef0f40b;
var $3ca1ba55f468f447$export$602eac185826482c = $3ca1ba55f468f447$export$660f2bfdb986706c;
var $3ca1ba55f468f447$export$c6fdb837b070b4ff = $3ca1ba55f468f447$export$a707a4895ce23256;
var $3ca1ba55f468f447$export$7c6e2c02157bb7d2 = $3ca1ba55f468f447$export$94e6af45f0af4efd;
var $3ca1ba55f468f447$export$e19cd5f9376f8cee = $3ca1ba55f468f447$export$b454f818c58ee85d;
var $3ca1ba55f468f447$export$848c9b7ead0df967 = $3ca1ba55f468f447$export$2f67a923571aaea0;
var $3ca1ba55f468f447$export$f99233281efd08a0 = $3ca1ba55f468f447$export$225e0da62d314b7;
var $3ca1ba55f468f447$export$393edc798c47379d = $3ca1ba55f468f447$export$a23b55cde55ad9a5;


const $b302dbddfdac9d75$export$1e7c0b54c65e0280 = {
    asChild: {
        type: "boolean"
    }
};


const $b6a742bf1f02ee7d$export$18e5dbe2c243731 = {
    width: {
        type: "string",
        className: "rt-r-w",
        customProperties: [
            "--width"
        ],
        responsive: !0
    },
    minWidth: {
        type: "string",
        className: "rt-r-min-w",
        customProperties: [
            "--min-width"
        ],
        responsive: !0
    },
    maxWidth: {
        type: "string",
        className: "rt-r-max-w",
        customProperties: [
            "--max-width"
        ],
        responsive: !0
    }
};


const $a66fc9f2b041fa5d$export$e039c83f102b25e2 = {
    height: {
        type: "string",
        className: "rt-r-h",
        customProperties: [
            "--height"
        ],
        responsive: !0
    },
    minHeight: {
        type: "string",
        className: "rt-r-min-h",
        customProperties: [
            "--min-height"
        ],
        responsive: !0
    },
    maxHeight: {
        type: "string",
        className: "rt-r-max-h",
        customProperties: [
            "--max-height"
        ],
        responsive: !0
    }
};


const $2f4552c9a33a7df5$var$a = [
    "start",
    "center"
], $2f4552c9a33a7df5$var$r = [
    "1",
    "2",
    "3",
    "4"
], $2f4552c9a33a7df5$export$cde45305589709cc = {
    ...(0, $b302dbddfdac9d75$export$1e7c0b54c65e0280),
    align: {
        type: "enum",
        className: "rt-r-align",
        values: [
            "start",
            "center"
        ],
        default: "center"
    },
    size: {
        type: "enum",
        className: "rt-r-size",
        values: $2f4552c9a33a7df5$var$r,
        default: "3",
        responsive: !0
    },
    width: (0, $b6a742bf1f02ee7d$export$18e5dbe2c243731).width,
    minWidth: (0, $b6a742bf1f02ee7d$export$18e5dbe2c243731).minWidth,
    maxWidth: {
        ...(0, $b6a742bf1f02ee7d$export$18e5dbe2c243731).maxWidth,
        default: "600px"
    },
    ...(0, $a66fc9f2b041fa5d$export$e039c83f102b25e2)
};





var $7fPBF = parcelRequire("7fPBF");



const $e914ebf2ce406d8c$export$8d1fb2aae3e7d457 = [
    "gray",
    "gold",
    "bronze",
    "brown",
    "yellow",
    "amber",
    "orange",
    "tomato",
    "red",
    "ruby",
    "crimson",
    "pink",
    "plum",
    "purple",
    "violet",
    "iris",
    "indigo",
    "blue",
    "cyan",
    "teal",
    "jade",
    "green",
    "grass",
    "lime",
    "mint",
    "sky"
], $e914ebf2ce406d8c$export$10473e9ffc331ca1 = [
    "auto",
    "gray",
    "mauve",
    "slate",
    "sage",
    "olive",
    "sand"
], $e914ebf2ce406d8c$export$8255b018f448be13 = {
    color: {
        type: "enum",
        values: $e914ebf2ce406d8c$export$8d1fb2aae3e7d457,
        default: void 0
    }
}, $e914ebf2ce406d8c$export$d0261b42be231f92 = {
    color: {
        type: "enum",
        values: $e914ebf2ce406d8c$export$8d1fb2aae3e7d457,
        default: ""
    }
};


const $f41c61290c2a7125$export$2f84412d299def33 = {
    highContrast: {
        type: "boolean",
        className: "rt-high-contrast",
        default: void 0
    }
};


const $748529190ac30cea$var$e = [
    "normal",
    "start",
    "end",
    "both"
], $748529190ac30cea$export$9fbb19586d60aa6c = {
    trim: {
        type: "enum",
        className: "rt-r-lt",
        values: $748529190ac30cea$var$e,
        responsive: !0
    }
};


const $a0febf40c6d2ed69$var$e = [
    "left",
    "center",
    "right"
], $a0febf40c6d2ed69$export$877e8504eac56d25 = {
    align: {
        type: "enum",
        className: "rt-r-ta",
        values: $a0febf40c6d2ed69$var$e,
        responsive: !0
    }
};


const $738dfabf5e38f576$var$e = [
    "wrap",
    "nowrap",
    "pretty",
    "balance"
], $738dfabf5e38f576$export$d1dbebac82aee34d = {
    wrap: {
        type: "enum",
        className: "rt-r-tw",
        values: $738dfabf5e38f576$var$e,
        responsive: !0
    }
};


const $2c64e4634b053e6a$export$b51caa9f475eecbe = {
    truncate: {
        type: "boolean",
        className: "rt-truncate"
    }
};


const $ec44dfa8e04fe2ae$var$e = [
    "light",
    "regular",
    "medium",
    "bold"
], $ec44dfa8e04fe2ae$export$959a85f577d21089 = {
    weight: {
        type: "enum",
        className: "rt-r-weight",
        values: $ec44dfa8e04fe2ae$var$e,
        responsive: !0
    }
};


const $7beb7185a5ec4195$var$m = [
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6"
], $7beb7185a5ec4195$var$a = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9"
], $7beb7185a5ec4195$export$afd796394ec86743 = {
    as: {
        type: "enum",
        values: $7beb7185a5ec4195$var$m,
        default: "h1"
    },
    ...(0, $b302dbddfdac9d75$export$1e7c0b54c65e0280),
    size: {
        type: "enum",
        className: "rt-r-size",
        values: $7beb7185a5ec4195$var$a,
        default: "6",
        responsive: !0
    },
    ...(0, $ec44dfa8e04fe2ae$export$959a85f577d21089),
    ...(0, $a0febf40c6d2ed69$export$877e8504eac56d25),
    ...(0, $748529190ac30cea$export$9fbb19586d60aa6c),
    ...(0, $2c64e4634b053e6a$export$b51caa9f475eecbe),
    ...(0, $738dfabf5e38f576$export$d1dbebac82aee34d),
    ...(0, $e914ebf2ce406d8c$export$8255b018f448be13),
    ...(0, $f41c61290c2a7125$export$2f84412d299def33)
};



const $8c4c249de5100129$export$d07517a676ce386f = [
    "initial",
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];


function $2d0c17ec07db5087$export$5a15a386532a5ea4(n, r) {
    return Object.prototype.hasOwnProperty.call(n, r);
}



function $c6ece7257d84b419$export$b36c9337e1b25cc0(e) {
    return typeof e == "object" && Object.keys(e).some((s)=>(0, $8c4c249de5100129$export$d07517a676ce386f).includes(s));
}


function $6e74cfda01acbc32$export$10dac92f1edafe3b({ className: r, customProperties: n, ...t }) {
    const p = $6e74cfda01acbc32$export$d03033efad57dbbf({
        allowArbitraryValues: !0,
        className: r,
        ...t
    }), e = $6e74cfda01acbc32$export$537e389aa953ab8f({
        customProperties: n,
        ...t
    });
    return [
        p,
        e
    ];
}
function $6e74cfda01acbc32$export$d03033efad57dbbf({ allowArbitraryValues: r, value: n, className: t, propValues: p, parseValue: e = (s)=>s }) {
    const s = [];
    if (n) {
        if (typeof n == "string" && p.includes(n)) return $6e74cfda01acbc32$var$l(t, n, e);
        if ((0, $c6ece7257d84b419$export$b36c9337e1b25cc0)(n)) {
            const i = n;
            for(const o in i){
                if (!(0, $2d0c17ec07db5087$export$5a15a386532a5ea4)(i, o) || !(0, $8c4c249de5100129$export$d07517a676ce386f).includes(o)) continue;
                const u = i[o];
                if (u !== void 0) {
                    if (p.includes(u)) {
                        const f = $6e74cfda01acbc32$var$l(t, u, e), v = o === "initial" ? f : `${o}:${f}`;
                        s.push(v);
                    } else if (r) {
                        const f = o === "initial" ? t : `${o}:${t}`;
                        s.push(f);
                    }
                }
            }
            return s.join(" ");
        }
        if (r) return t;
    }
}
function $6e74cfda01acbc32$var$l(r, n, t) {
    const p = r ? "-" : "", e = t(n), s = e === null || e === void 0 ? void 0 : e.startsWith("-"), i = s ? "-" : "", o = s ? e === null || e === void 0 ? void 0 : e.substring(1) : e;
    return `${i}${r}${p}${o}`;
}
function $6e74cfda01acbc32$export$537e389aa953ab8f({ customProperties: r, value: n, propValues: t, parseValue: p = (e)=>e }) {
    let e = {};
    if (!(!n || typeof n == "string" && t.includes(n))) {
        if (typeof n == "string" && (e = Object.fromEntries(r.map((s)=>[
                s,
                n
            ]))), (0, $c6ece7257d84b419$export$b36c9337e1b25cc0)(n)) {
            const s = n;
            for(const i in s){
                if (!(0, $2d0c17ec07db5087$export$5a15a386532a5ea4)(s, i) || !(0, $8c4c249de5100129$export$d07517a676ce386f).includes(i)) continue;
                const o = s[i];
                if (!t.includes(o)) for (const u of r)e = {
                    [i === "initial" ? u : `${u}-${i}`]: o,
                    ...e
                };
            }
        }
        for(const s in e){
            const i = e[s];
            i !== void 0 && (e[s] = p(i));
        }
        return e;
    }
}



function $f71bfc9c84797302$export$e618dc39ac9ad607(...t) {
    let e = {};
    for (const n of t)n && (e = {
        ...e,
        ...n
    });
    return Object.keys(e).length ? e : void 0;
}


function $ef0737d72702ceb3$var$N(...r) {
    return Object.assign({}, ...r);
}
function $ef0737d72702ceb3$export$7782f98975e2d28f(r, ...m) {
    let t, l;
    const a = {
        ...r
    }, f = $ef0737d72702ceb3$var$N(...m);
    for(const n in f){
        let s = a[n];
        const e = f[n];
        if (e.default !== void 0 && s === void 0 && (s = e.default), e.type === "enum" && ![
            e.default,
            ...e.values
        ].includes(s) && !(0, $c6ece7257d84b419$export$b36c9337e1b25cc0)(s) && (s = e.default), a[n] = s, "className" in e && e.className) {
            delete a[n];
            const u = "responsive" in e;
            if (!s || (0, $c6ece7257d84b419$export$b36c9337e1b25cc0)(s) && !u) continue;
            if ((0, $c6ece7257d84b419$export$b36c9337e1b25cc0)(s) && (e.default !== void 0 && s.initial === void 0 && (s.initial = e.default), e.type === "enum" && ([
                e.default,
                ...e.values
            ].includes(s.initial) || (s.initial = e.default))), e.type === "enum") {
                const i = (0, $6e74cfda01acbc32$export$d03033efad57dbbf)({
                    allowArbitraryValues: !1,
                    value: s,
                    className: e.className,
                    propValues: e.values,
                    parseValue: e.parseValue
                });
                t = (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))(t, i);
                continue;
            }
            if (e.type === "string" || e.type === "enum | string") {
                const i = e.type === "string" ? [] : e.values, [d, y] = (0, $6e74cfda01acbc32$export$10dac92f1edafe3b)({
                    className: e.className,
                    customProperties: e.customProperties,
                    propValues: i,
                    parseValue: e.parseValue,
                    value: s
                });
                l = (0, $f71bfc9c84797302$export$e618dc39ac9ad607)(l, y), t = (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))(t, d);
                continue;
            }
            if (e.type === "boolean" && s) {
                t = (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))(t, e.className);
                continue;
            }
        }
    }
    return a.className = (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))(t, r.className), a.style = (0, $f71bfc9c84797302$export$e618dc39ac9ad607)(l, r.style), a;
}


const $df06be8448ff4f3c$var$e = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "-1",
    "-2",
    "-3",
    "-4",
    "-5",
    "-6",
    "-7",
    "-8",
    "-9"
], $df06be8448ff4f3c$export$83503616c7a463e3 = {
    m: {
        type: "enum | string",
        values: $df06be8448ff4f3c$var$e,
        responsive: !0,
        className: "rt-r-m",
        customProperties: [
            "--m"
        ]
    },
    mx: {
        type: "enum | string",
        values: $df06be8448ff4f3c$var$e,
        responsive: !0,
        className: "rt-r-mx",
        customProperties: [
            "--ml",
            "--mr"
        ]
    },
    my: {
        type: "enum | string",
        values: $df06be8448ff4f3c$var$e,
        responsive: !0,
        className: "rt-r-my",
        customProperties: [
            "--mt",
            "--mb"
        ]
    },
    mt: {
        type: "enum | string",
        values: $df06be8448ff4f3c$var$e,
        responsive: !0,
        className: "rt-r-mt",
        customProperties: [
            "--mt"
        ]
    },
    mr: {
        type: "enum | string",
        values: $df06be8448ff4f3c$var$e,
        responsive: !0,
        className: "rt-r-mr",
        customProperties: [
            "--mr"
        ]
    },
    mb: {
        type: "enum | string",
        values: $df06be8448ff4f3c$var$e,
        responsive: !0,
        className: "rt-r-mb",
        customProperties: [
            "--mb"
        ]
    },
    ml: {
        type: "enum | string",
        values: $df06be8448ff4f3c$var$e,
        responsive: !0,
        className: "rt-r-ml",
        customProperties: [
            "--ml"
        ]
    }
};


const $a81a142737c4a792$export$a8a3e93435678ff9 = $7fPBF.forwardRef((p, t)=>{
    const { children: e, className: s, asChild: a, as: n = "h1", color: i, ...m } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(p, (0, $7beb7185a5ec4195$export$afd796394ec86743), (0, $df06be8448ff4f3c$export$83503616c7a463e3));
    return $7fPBF.createElement((0, $089057084dfb92a4$export$8c6ed5c666ac1360), {
        "data-accent-color": i,
        ...m,
        ref: t,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-Heading", s)
    }, a ? e : $7fPBF.createElement(n, null, e));
});
$a81a142737c4a792$export$a8a3e93435678ff9.displayName = "Heading";



var $7fPBF = parcelRequire("7fPBF");












const $939a59e6188a93b9$var$m = [
    "span",
    "div",
    "label",
    "p"
], $939a59e6188a93b9$var$a = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9"
], $939a59e6188a93b9$export$b40167f842021a8 = {
    as: {
        type: "enum",
        values: $939a59e6188a93b9$var$m,
        default: "span"
    },
    ...(0, $b302dbddfdac9d75$export$1e7c0b54c65e0280),
    size: {
        type: "enum",
        className: "rt-r-size",
        values: $939a59e6188a93b9$var$a,
        responsive: !0
    },
    ...(0, $ec44dfa8e04fe2ae$export$959a85f577d21089),
    ...(0, $a0febf40c6d2ed69$export$877e8504eac56d25),
    ...(0, $748529190ac30cea$export$9fbb19586d60aa6c),
    ...(0, $2c64e4634b053e6a$export$b51caa9f475eecbe),
    ...(0, $738dfabf5e38f576$export$d1dbebac82aee34d),
    ...(0, $e914ebf2ce406d8c$export$8255b018f448be13),
    ...(0, $f41c61290c2a7125$export$2f84412d299def33)
};


const $83db9e82a643d7a4$export$5f1af8db9871e1d6 = $7fPBF.forwardRef((t, r)=>{
    const { children: e, className: s, asChild: m, as: a = "span", color: n, ...P } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(t, (0, $939a59e6188a93b9$export$b40167f842021a8), (0, $df06be8448ff4f3c$export$83503616c7a463e3));
    return $7fPBF.createElement((0, $089057084dfb92a4$export$8c6ed5c666ac1360), {
        "data-accent-color": n,
        ...P,
        ref: r,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-Text", s)
    }, m ? e : $7fPBF.createElement(a, null, e));
});
$83db9e82a643d7a4$export$5f1af8db9871e1d6.displayName = "Text";



var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");
/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ const $f56410848bcbe11b$export$832b6fa47fa053d2 = [
    "top",
    "right",
    "bottom",
    "left"
];
const $f56410848bcbe11b$export$27b07d8a310ed8b5 = [
    "start",
    "end"
];
const $f56410848bcbe11b$export$803cd8101b6c182b = /*#__PURE__*/ $f56410848bcbe11b$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $f56410848bcbe11b$export$27b07d8a310ed8b5[0], side + "-" + $f56410848bcbe11b$export$27b07d8a310ed8b5[1]), []);
const $f56410848bcbe11b$export$96ec731ed4dcb222 = Math.min;
const $f56410848bcbe11b$export$8960430cfd85939f = Math.max;
const $f56410848bcbe11b$export$2077e0241d6afd3c = Math.round;
const $f56410848bcbe11b$export$a3fe094919f356fd = Math.floor;
const $f56410848bcbe11b$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $f56410848bcbe11b$var$oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
const $f56410848bcbe11b$var$oppositeAlignmentMap = {
    start: "end",
    end: "start"
};
function $f56410848bcbe11b$export$7d15b64cf5a3a4c4(start, value, end) {
    return $f56410848bcbe11b$export$8960430cfd85939f(start, $f56410848bcbe11b$export$96ec731ed4dcb222(value, end));
}
function $f56410848bcbe11b$export$fef61f332f2c0afc(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function $f56410848bcbe11b$export$3c915306cb7fc97a(placement) {
    return placement.split("-")[0];
}
function $f56410848bcbe11b$export$f0989780f32bfcda(placement) {
    return placement.split("-")[1];
}
function $f56410848bcbe11b$export$8a000a963141ac32(axis) {
    return axis === "x" ? "y" : "x";
}
function $f56410848bcbe11b$export$320bd9d53520c68a(axis) {
    return axis === "y" ? "height" : "width";
}
function $f56410848bcbe11b$export$f28e8f882010718a(placement) {
    return [
        "top",
        "bottom"
    ].includes($f56410848bcbe11b$export$3c915306cb7fc97a(placement)) ? "y" : "x";
}
function $f56410848bcbe11b$export$2b57e0052a6d6d4c(placement) {
    return $f56410848bcbe11b$export$8a000a963141ac32($f56410848bcbe11b$export$f28e8f882010718a(placement));
}
function $f56410848bcbe11b$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $f56410848bcbe11b$export$f0989780f32bfcda(placement);
    const alignmentAxis = $f56410848bcbe11b$export$2b57e0052a6d6d4c(placement);
    const length = $f56410848bcbe11b$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $f56410848bcbe11b$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $f56410848bcbe11b$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $f56410848bcbe11b$export$496432a3699e50b1(placement) {
    const oppositePlacement = $f56410848bcbe11b$export$9c5e28bad23365fa(placement);
    return [
        $f56410848bcbe11b$export$2b182c584985588b(placement),
        oppositePlacement,
        $f56410848bcbe11b$export$2b182c584985588b(oppositePlacement)
    ];
}
function $f56410848bcbe11b$export$2b182c584985588b(placement) {
    return placement.replace(/start|end/g, (alignment)=>$f56410848bcbe11b$var$oppositeAlignmentMap[alignment]);
}
function $f56410848bcbe11b$var$getSideList(side, isStart, rtl) {
    const lr = [
        "left",
        "right"
    ];
    const rl = [
        "right",
        "left"
    ];
    const tb = [
        "top",
        "bottom"
    ];
    const bt = [
        "bottom",
        "top"
    ];
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rl : lr;
            return isStart ? lr : rl;
        case "left":
        case "right":
            return isStart ? tb : bt;
        default:
            return [];
    }
}
function $f56410848bcbe11b$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $f56410848bcbe11b$export$f0989780f32bfcda(placement);
    let list = $f56410848bcbe11b$var$getSideList($f56410848bcbe11b$export$3c915306cb7fc97a(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($f56410848bcbe11b$export$2b182c584985588b));
    }
    return list;
}
function $f56410848bcbe11b$export$9c5e28bad23365fa(placement) {
    return placement.replace(/left|right|bottom|top/g, (side)=>$f56410848bcbe11b$var$oppositeSideMap[side]);
}
function $f56410848bcbe11b$export$1c66dbf1a9e34223(padding) {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...padding
    };
}
function $f56410848bcbe11b$export$598c291c29bc2e71(padding) {
    return typeof padding !== "number" ? $f56410848bcbe11b$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $f56410848bcbe11b$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $b8d321edac7a7d95$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $f56410848bcbe11b$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $f56410848bcbe11b$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $f56410848bcbe11b$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === "y";
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $f56410848bcbe11b$export$f0989780f32bfcda)(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $b8d321edac7a7d95$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform } = config;
    const validMiddleware = middleware.filter(Boolean);
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $b8d321edac7a7d95$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let middlewareData = {};
    let resetCount = 0;
    for(let i = 0; i < validMiddleware.length; i++){
        const { name: name, fn: fn } = validMiddleware[i];
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platform,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData = {
            ...middlewareData,
            [name]: {
                ...middlewareData[name],
                ...data
            }
        };
        if (reset && resetCount <= 50) {
            resetCount++;
            if (typeof reset === "object") {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $b8d321edac7a7d95$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $b8d321edac7a7d95$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = "clippingAncestors", rootBoundary: rootBoundary = "viewport", elementContext: elementContext = "floating", altBoundary: altBoundary = false, padding: padding = 0 } = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $f56410848bcbe11b$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === "floating" ? "reference" : "floating";
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $f56410848bcbe11b$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === "floating" ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $f56410848bcbe11b$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $b8d321edac7a7d95$export$f2120bbfa5450bd2 = (options)=>({
        name: "arrow",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $f56410848bcbe11b$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $f56410848bcbe11b$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $f56410848bcbe11b$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === "y";
            const minProp = isYAxis ? "top" : "left";
            const maxProp = isYAxis ? "bottom" : "right";
            const clientProp = isYAxis ? "clientHeight" : "clientWidth";
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $f56410848bcbe11b$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $f56410848bcbe11b$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: {
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset,
                    ...shouldAddOffset && {
                        alignmentOffset: alignmentOffset
                    }
                },
                reset: shouldAddOffset
            };
        }
    });
function $b8d321edac7a7d95$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $f56410848bcbe11b$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $f56410848bcbe11b$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $f56410848bcbe11b$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $f56410848bcbe11b$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $b8d321edac7a7d95$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "autoPlacement",
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $f56410848bcbe11b$export$803cd8101b6c182b), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $f56410848bcbe11b$export$803cd8101b6c182b) ? $b8d321edac7a7d95$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await $b8d321edac7a7d95$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $f56410848bcbe11b$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $f56410848bcbe11b$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $f56410848bcbe11b$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $f56410848bcbe11b$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $b8d321edac7a7d95$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = "bestFit", fallbackAxisSideDirection: fallbackAxisSideDirection = "none", flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $f56410848bcbe11b$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $f56410848bcbe11b$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $f56410848bcbe11b$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $f56410848bcbe11b$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $f56410848bcbe11b$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await $b8d321edac7a7d95$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $f56410848bcbe11b$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) // Try next placement and re-run the lifecycle.
                return {
                    data: {
                        index: nextIndex,
                        overflows: overflowsData
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case "bestFit":
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $f56410848bcbe11b$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === "y";
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case "initialPlacement":
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $b8d321edac7a7d95$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $b8d321edac7a7d95$var$isAnySideFullyClipped(overflow) {
    return (0, $f56410848bcbe11b$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $b8d321edac7a7d95$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        async fn (state) {
            const { rects: rects } = state;
            const { strategy: strategy = "referenceHidden", ...detectOverflowOptions } = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state);
            switch(strategy){
                case "referenceHidden":
                    {
                        const overflow = await $b8d321edac7a7d95$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            elementContext: "reference"
                        });
                        const offsets = $b8d321edac7a7d95$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $b8d321edac7a7d95$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case "escaped":
                    {
                        const overflow = await $b8d321edac7a7d95$export$37b6bde19b108ecc(state, {
                            ...detectOverflowOptions,
                            altBoundary: true
                        });
                        const offsets = $b8d321edac7a7d95$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $b8d321edac7a7d95$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $b8d321edac7a7d95$var$getBoundingRect(rects) {
    const minX = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $f56410848bcbe11b$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $f56410848bcbe11b$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $b8d321edac7a7d95$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $f56410848bcbe11b$export$ee05aea0aeecbad4)($b8d321edac7a7d95$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $b8d321edac7a7d95$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: "inline",
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $b8d321edac7a7d95$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $f56410848bcbe11b$export$ee05aea0aeecbad4)($b8d321edac7a7d95$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $f56410848bcbe11b$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $f56410848bcbe11b$export$f28e8f882010718a)(placement) === "y") {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement) === "top";
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement) === "left";
                    const maxRight = (0, $f56410848bcbe11b$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $b8d321edac7a7d95$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $f56410848bcbe11b$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $f56410848bcbe11b$export$f28e8f882010718a)(placement) === "y";
    const mainAxisMulti = [
        "left",
        "top"
    ].includes(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === "number" ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $b8d321edac7a7d95$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $b8d321edac7a7d95$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: {
                    ...diffCoords,
                    placement: placement
                }
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $b8d321edac7a7d95$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement } = state;
            const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            }, ...detectOverflowOptions } = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await $b8d321edac7a7d95$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const crossAxis = (0, $f56410848bcbe11b$export$f28e8f882010718a)((0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $f56410848bcbe11b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === "y" ? "top" : "left";
                const maxSide = mainAxis === "y" ? "bottom" : "right";
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $f56410848bcbe11b$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === "y" ? "top" : "left";
                const maxSide = crossAxis === "y" ? "bottom" : "right";
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $f56410848bcbe11b$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn({
                ...state,
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            });
            return {
                ...limitedCoords,
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            };
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $b8d321edac7a7d95$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $f56410848bcbe11b$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $f56410848bcbe11b$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...rawOffset
            };
            if (checkMainAxis) {
                const len = mainAxis === "y" ? "height" : "width";
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === "y" ? "width" : "height";
                const isOriginSide = [
                    "top",
                    "left"
                ].includes((0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $b8d321edac7a7d95$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, $f56410848bcbe11b$export$fef61f332f2c0afc)(options, state);
            const overflow = await $b8d321edac7a7d95$export$37b6bde19b108ecc(state, detectOverflowOptions);
            const side = (0, $f56410848bcbe11b$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $f56410848bcbe11b$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $f56410848bcbe11b$export$f28e8f882010718a)(placement) === "y";
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === "top" || side === "bottom") {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
            } else {
                widthSide = side;
                heightSide = alignment === "end" ? "top" : "bottom";
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $f56410848bcbe11b$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $f56410848bcbe11b$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $f56410848bcbe11b$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $f56410848bcbe11b$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $f56410848bcbe11b$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $f56410848bcbe11b$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply({
                ...state,
                availableWidth: availableWidth,
                availableHeight: availableHeight
            });
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $d0eb1ce7e5ffa070$var$hasWindow() {
    return typeof window !== "undefined";
}
function $d0eb1ce7e5ffa070$export$651544f548703224(node) {
    if ($d0eb1ce7e5ffa070$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || "").toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return "#document";
}
function $d0eb1ce7e5ffa070$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $d0eb1ce7e5ffa070$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($d0eb1ce7e5ffa070$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $d0eb1ce7e5ffa070$export$8ee0fc9ee280b4ee(value) {
    if (!$d0eb1ce7e5ffa070$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $d0eb1ce7e5ffa070$export$38b2d434cce3ea22(value).Node;
}
function $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d(value) {
    if (!$d0eb1ce7e5ffa070$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $d0eb1ce7e5ffa070$export$38b2d434cce3ea22(value).Element;
}
function $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa(value) {
    if (!$d0eb1ce7e5ffa070$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $d0eb1ce7e5ffa070$export$38b2d434cce3ea22(value).HTMLElement;
}
function $d0eb1ce7e5ffa070$export$af51f0f06c0f328a(value) {
    if (!$d0eb1ce7e5ffa070$var$hasWindow() || typeof ShadowRoot === "undefined") return false;
    return value instanceof ShadowRoot || value instanceof $d0eb1ce7e5ffa070$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $d0eb1ce7e5ffa070$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $d0eb1ce7e5ffa070$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
        "inline",
        "contents"
    ].includes(display);
}
function $d0eb1ce7e5ffa070$export$71535ffaa902797f(element) {
    return [
        "table",
        "td",
        "th"
    ].includes($d0eb1ce7e5ffa070$export$651544f548703224(element));
}
function $d0eb1ce7e5ffa070$export$89e651af02346cd4(element) {
    return [
        ":popover-open",
        ":modal"
    ].some((selector)=>{
        try {
            return element.matches(selector);
        } catch (e) {
            return false;
        }
    });
}
function $d0eb1ce7e5ffa070$export$d6c4e8150c35fed1(elementOrCss) {
    const webkit = $d0eb1ce7e5ffa070$export$78551043582a6a98();
    const css = $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d(elementOrCss) ? $d0eb1ce7e5ffa070$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    return css.transform !== "none" || css.perspective !== "none" || (css.containerType ? css.containerType !== "normal" : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit && (css.filter ? css.filter !== "none" : false) || [
        "transform",
        "perspective",
        "filter"
    ].some((value)=>(css.willChange || "").includes(value)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((value)=>(css.contain || "").includes(value));
}
function $d0eb1ce7e5ffa070$export$940d8225183e1404(element) {
    let currentNode = $d0eb1ce7e5ffa070$export$4e12058fc4d51d56(element);
    while($d0eb1ce7e5ffa070$export$1b3bfaa9684536aa(currentNode) && !$d0eb1ce7e5ffa070$export$d1162fb0b6d4cd51(currentNode)){
        if ($d0eb1ce7e5ffa070$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($d0eb1ce7e5ffa070$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $d0eb1ce7e5ffa070$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $d0eb1ce7e5ffa070$export$78551043582a6a98() {
    if (typeof CSS === "undefined" || !CSS.supports) return false;
    return CSS.supports("-webkit-backdrop-filter", "none");
}
function $d0eb1ce7e5ffa070$export$d1162fb0b6d4cd51(node) {
    return [
        "html",
        "body",
        "#document"
    ].includes($d0eb1ce7e5ffa070$export$651544f548703224(node));
}
function $d0eb1ce7e5ffa070$export$3735103072e4a80(element) {
    return $d0eb1ce7e5ffa070$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $d0eb1ce7e5ffa070$export$dc8fc79fa2800137(element) {
    if ($d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $d0eb1ce7e5ffa070$export$4e12058fc4d51d56(node) {
    if ($d0eb1ce7e5ffa070$export$651544f548703224(node) === "html") return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $d0eb1ce7e5ffa070$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $d0eb1ce7e5ffa070$export$e495491855dc5418(node);
    return $d0eb1ce7e5ffa070$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $d0eb1ce7e5ffa070$export$7cd01a57c8ca906c(node) {
    const parentNode = $d0eb1ce7e5ffa070$export$4e12058fc4d51d56(node);
    if ($d0eb1ce7e5ffa070$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($d0eb1ce7e5ffa070$export$1b3bfaa9684536aa(parentNode) && $d0eb1ce7e5ffa070$export$989e911fa9af580a(parentNode)) return parentNode;
    return $d0eb1ce7e5ffa070$export$7cd01a57c8ca906c(parentNode);
}
function $d0eb1ce7e5ffa070$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $d0eb1ce7e5ffa070$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $d0eb1ce7e5ffa070$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $d0eb1ce7e5ffa070$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $d0eb1ce7e5ffa070$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $d0eb1ce7e5ffa070$export$3b57c1601291186b(frameElement) : []);
    }
    return list.concat(scrollableAncestor, $d0eb1ce7e5ffa070$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $d0eb1ce7e5ffa070$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $28b5c677ea6a5d8a$var$getCssDimensions(element) {
    const css = (0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $f56410848bcbe11b$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $f56410848bcbe11b$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $28b5c677ea6a5d8a$var$unwrapElement(element) {
    return !(0, $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $28b5c677ea6a5d8a$var$getScale(element) {
    const domElement = $28b5c677ea6a5d8a$var$unwrapElement(element);
    if (!(0, $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa)(domElement)) return (0, $f56410848bcbe11b$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $28b5c677ea6a5d8a$var$getCssDimensions(domElement);
    let x = ($ ? (0, $f56410848bcbe11b$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $f56410848bcbe11b$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $28b5c677ea6a5d8a$var$noOffsets = /*#__PURE__*/ (0, $f56410848bcbe11b$export$a397704b5e280835)(0);
function $28b5c677ea6a5d8a$var$getVisualOffsets(element) {
    const win = (0, $d0eb1ce7e5ffa070$export$38b2d434cce3ea22)(element);
    if (!(0, $d0eb1ce7e5ffa070$export$78551043582a6a98)() || !win.visualViewport) return $28b5c677ea6a5d8a$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $28b5c677ea6a5d8a$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $d0eb1ce7e5ffa070$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $28b5c677ea6a5d8a$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $28b5c677ea6a5d8a$var$unwrapElement(element);
    let scale = (0, $f56410848bcbe11b$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d)(offsetParent)) scale = $28b5c677ea6a5d8a$var$getScale(offsetParent);
        } else scale = $28b5c677ea6a5d8a$var$getScale(element);
    }
    const visualOffsets = $28b5c677ea6a5d8a$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $28b5c677ea6a5d8a$var$getVisualOffsets(domElement) : (0, $f56410848bcbe11b$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $d0eb1ce7e5ffa070$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $d0eb1ce7e5ffa070$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $d0eb1ce7e5ffa070$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $28b5c677ea6a5d8a$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $d0eb1ce7e5ffa070$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $d0eb1ce7e5ffa070$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $f56410848bcbe11b$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function $28b5c677ea6a5d8a$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === "fixed";
    const documentElement = (0, $d0eb1ce7e5ffa070$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $d0eb1ce7e5ffa070$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $f56410848bcbe11b$export$a397704b5e280835)(1);
    const offsets = (0, $f56410848bcbe11b$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $d0eb1ce7e5ffa070$export$651544f548703224)(offsetParent) !== "body" || (0, $d0eb1ce7e5ffa070$export$989e911fa9af580a)(documentElement)) scroll = (0, $d0eb1ce7e5ffa070$export$dc8fc79fa2800137)(offsetParent);
        if ((0, $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa)(offsetParent)) {
            const offsetRect = $28b5c677ea6a5d8a$var$getBoundingClientRect(offsetParent);
            scale = $28b5c677ea6a5d8a$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
    };
}
function $28b5c677ea6a5d8a$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $28b5c677ea6a5d8a$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $d0eb1ce7e5ffa070$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $28b5c677ea6a5d8a$var$getBoundingClientRect((0, $d0eb1ce7e5ffa070$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $28b5c677ea6a5d8a$var$getDocumentRect(element) {
    const html = (0, $d0eb1ce7e5ffa070$export$e495491855dc5418)(element);
    const scroll = (0, $d0eb1ce7e5ffa070$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $f56410848bcbe11b$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $f56410848bcbe11b$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $28b5c677ea6a5d8a$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(body).direction === "rtl") x += (0, $f56410848bcbe11b$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $28b5c677ea6a5d8a$var$getViewportRect(element, strategy) {
    const win = (0, $d0eb1ce7e5ffa070$export$38b2d434cce3ea22)(element);
    const html = (0, $d0eb1ce7e5ffa070$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $d0eb1ce7e5ffa070$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $28b5c677ea6a5d8a$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $28b5c677ea6a5d8a$var$getBoundingClientRect(element, true, strategy === "fixed");
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa)(element) ? $28b5c677ea6a5d8a$var$getScale(element) : (0, $f56410848bcbe11b$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $28b5c677ea6a5d8a$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === "viewport") rect = $28b5c677ea6a5d8a$var$getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = $28b5c677ea6a5d8a$var$getDocumentRect((0, $d0eb1ce7e5ffa070$export$e495491855dc5418)(element));
    else if ((0, $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $28b5c677ea6a5d8a$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $28b5c677ea6a5d8a$var$getVisualOffsets(element);
        rect = {
            ...clippingAncestor,
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y
        };
    }
    return (0, $f56410848bcbe11b$export$ee05aea0aeecbad4)(rect);
}
function $28b5c677ea6a5d8a$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $d0eb1ce7e5ffa070$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d)(parentNode) || (0, $d0eb1ce7e5ffa070$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(parentNode).position === "fixed" || $28b5c677ea6a5d8a$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $28b5c677ea6a5d8a$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $d0eb1ce7e5ffa070$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d)(el) && (0, $d0eb1ce7e5ffa070$export$651544f548703224)(el) !== "body");
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(element).position === "fixed";
    let currentNode = elementIsFixed ? (0, $d0eb1ce7e5ffa070$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d)(currentNode) && !(0, $d0eb1ce7e5ffa070$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $d0eb1ce7e5ffa070$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && [
            "absolute",
            "fixed"
        ].includes(currentContainingBlockComputedStyle.position) || (0, $d0eb1ce7e5ffa070$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $28b5c677ea6a5d8a$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $d0eb1ce7e5ffa070$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $28b5c677ea6a5d8a$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === "clippingAncestors" ? (0, $d0eb1ce7e5ffa070$export$89e651af02346cd4)(element) ? [] : $28b5c677ea6a5d8a$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstClippingAncestor = clippingAncestors[0];
    const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
        const rect = $28b5c677ea6a5d8a$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
        accRect.top = (0, $f56410848bcbe11b$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $f56410848bcbe11b$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $28b5c677ea6a5d8a$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
    return {
        width: clippingRect.right - clippingRect.left,
        height: clippingRect.bottom - clippingRect.top,
        x: clippingRect.left,
        y: clippingRect.top
    };
}
function $28b5c677ea6a5d8a$var$getDimensions(element) {
    const { width: width, height: height } = $28b5c677ea6a5d8a$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $28b5c677ea6a5d8a$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $d0eb1ce7e5ffa070$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === "fixed";
    const rect = $28b5c677ea6a5d8a$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $f56410848bcbe11b$export$a397704b5e280835)(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $d0eb1ce7e5ffa070$export$651544f548703224)(offsetParent) !== "body" || (0, $d0eb1ce7e5ffa070$export$989e911fa9af580a)(documentElement)) scroll = (0, $d0eb1ce7e5ffa070$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $28b5c677ea6a5d8a$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
        // Firefox with layout.scrollbar.side = 3 in about:config to test this.
        offsets.x = $28b5c677ea6a5d8a$var$getWindowScrollBarX(documentElement);
    }
    let htmlX = 0;
    let htmlY = 0;
    if (documentElement && !isOffsetParentAnElement && !isFixed) {
        const htmlRect = documentElement.getBoundingClientRect();
        htmlY = htmlRect.top + scroll.scrollTop;
        htmlX = htmlRect.left + scroll.scrollLeft - // RTL <body> scrollbar.
        $28b5c677ea6a5d8a$var$getWindowScrollBarX(documentElement, htmlRect);
    }
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlX;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlY;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $28b5c677ea6a5d8a$var$isStaticPositioned(element) {
    return (0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(element).position === "static";
}
function $28b5c677ea6a5d8a$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa)(element) || (0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $d0eb1ce7e5ffa070$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $28b5c677ea6a5d8a$var$getOffsetParent(element, polyfill) {
    const win = (0, $d0eb1ce7e5ffa070$export$38b2d434cce3ea22)(element);
    if ((0, $d0eb1ce7e5ffa070$export$89e651af02346cd4)(element)) return win;
    if (!(0, $d0eb1ce7e5ffa070$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $d0eb1ce7e5ffa070$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $d0eb1ce7e5ffa070$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$28b5c677ea6a5d8a$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $d0eb1ce7e5ffa070$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $28b5c677ea6a5d8a$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $d0eb1ce7e5ffa070$export$71535ffaa902797f)(offsetParent) && $28b5c677ea6a5d8a$var$isStaticPositioned(offsetParent))offsetParent = $28b5c677ea6a5d8a$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $d0eb1ce7e5ffa070$export$d1162fb0b6d4cd51)(offsetParent) && $28b5c677ea6a5d8a$var$isStaticPositioned(offsetParent) && !(0, $d0eb1ce7e5ffa070$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $d0eb1ce7e5ffa070$export$940d8225183e1404)(element) || win;
}
const $28b5c677ea6a5d8a$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $28b5c677ea6a5d8a$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $28b5c677ea6a5d8a$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $28b5c677ea6a5d8a$var$isRTL(element) {
    return (0, $d0eb1ce7e5ffa070$export$3735103072e4a80)(element).direction === "rtl";
}
const $28b5c677ea6a5d8a$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $28b5c677ea6a5d8a$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $d0eb1ce7e5ffa070$export$e495491855dc5418,
    getClippingRect: $28b5c677ea6a5d8a$var$getClippingRect,
    getOffsetParent: $28b5c677ea6a5d8a$var$getOffsetParent,
    getElementRects: $28b5c677ea6a5d8a$var$getElementRects,
    getClientRects: $28b5c677ea6a5d8a$var$getClientRects,
    getDimensions: $28b5c677ea6a5d8a$var$getDimensions,
    getScale: $28b5c677ea6a5d8a$var$getScale,
    isElement: $d0eb1ce7e5ffa070$export$45a5e7f76e0caa8d,
    isRTL: $28b5c677ea6a5d8a$var$isRTL
};
// https://samthor.au/2021/observing-dom/
function $28b5c677ea6a5d8a$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $d0eb1ce7e5ffa070$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $f56410848bcbe11b$export$a3fe094919f356fd)(top);
        const insetRight = (0, $f56410848bcbe11b$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $f56410848bcbe11b$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $f56410848bcbe11b$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $f56410848bcbe11b$export$8960430cfd85939f)(0, (0, $f56410848bcbe11b$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, {
                ...options,
                // Handle <iframe>s
                root: root.ownerDocument
            });
        } catch (e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $28b5c677ea6a5d8a$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === "function", layoutShift: layoutShift = typeof IntersectionObserver === "function", animationFrame: animationFrame = false } = options;
    const referenceEl = $28b5c677ea6a5d8a$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $d0eb1ce7e5ffa070$export$3b57c1601291186b)(referenceEl) : [],
        ...(0, $d0eb1ce7e5ffa070$export$3b57c1601291186b)(floating)
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    const cleanupIo = referenceEl && layoutShift ? $28b5c677ea6a5d8a$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $28b5c677ea6a5d8a$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $28b5c677ea6a5d8a$var$getBoundingClientRect(reference);
        if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $28b5c677ea6a5d8a$export$37b6bde19b108ecc = (0, $b8d321edac7a7d95$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $28b5c677ea6a5d8a$export$cc800923e997bb8 = (0, $b8d321edac7a7d95$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $28b5c677ea6a5d8a$export$91fb6ecbd551914 = (0, $b8d321edac7a7d95$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $28b5c677ea6a5d8a$export$fba63a578e423eb = (0, $b8d321edac7a7d95$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $28b5c677ea6a5d8a$export$8a83211c878a3f1f = (0, $b8d321edac7a7d95$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $28b5c677ea6a5d8a$export$346677f925de839c = (0, $b8d321edac7a7d95$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $28b5c677ea6a5d8a$export$fe8985bb6374093c = (0, $b8d321edac7a7d95$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $28b5c677ea6a5d8a$export$f2120bbfa5450bd2 = (0, $b8d321edac7a7d95$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $28b5c677ea6a5d8a$export$18c8ad048e32c7d5 = (0, $b8d321edac7a7d95$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $28b5c677ea6a5d8a$export$7bf07e38f3dc4b69 = (0, $b8d321edac7a7d95$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $28b5c677ea6a5d8a$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = {
        platform: $28b5c677ea6a5d8a$export$722a64dea1b767dc,
        ...options
    };
    const platformWithCache = {
        ...mergedOptions.platform,
        _c: cache
    };
    return (0, $b8d321edac7a7d95$export$48a53dcb22e581d0)(reference, floating, {
        ...mergedOptions,
        platform: platformWithCache
    });
};



var $7fPBF = parcelRequire("7fPBF");

var $3eff8043e65df9b2$var$index = typeof document !== "undefined" ? (0, $7fPBF.useLayoutEffect) : (0, $7fPBF.useEffect);
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $3eff8043e65df9b2$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === "function" && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === "object") {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$3eff8043e65df9b2$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!$3eff8043e65df9b2$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $3eff8043e65df9b2$var$getDPR(element) {
    if (typeof window === "undefined") return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $3eff8043e65df9b2$var$roundByDPR(element, value) {
    const dpr = $3eff8043e65df9b2$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $3eff8043e65df9b2$var$useLatestRef(value) {
    const ref = $7fPBF.useRef(value);
    $3eff8043e65df9b2$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $3eff8043e65df9b2$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = "bottom", strategy: strategy = "absolute", middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $7fPBF.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $7fPBF.useState(middleware);
    if (!$3eff8043e65df9b2$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $7fPBF.useState(null);
    const [_floating, _setFloating] = $7fPBF.useState(null);
    const setReference = $7fPBF.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $7fPBF.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $7fPBF.useRef(null);
    const floatingRef = $7fPBF.useRef(null);
    const dataRef = $7fPBF.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $3eff8043e65df9b2$var$useLatestRef(whileElementsMounted);
    const platformRef = $3eff8043e65df9b2$var$useLatestRef(platform);
    const openRef = $3eff8043e65df9b2$var$useLatestRef(open);
    const update = $7fPBF.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $28b5c677ea6a5d8a$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = {
                ...data,
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            };
            if (isMountedRef.current && !$3eff8043e65df9b2$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $b4ba1c853f6e1116$exports.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $3eff8043e65df9b2$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>({
                    ...data,
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $7fPBF.useRef(false);
    $3eff8043e65df9b2$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $3eff8043e65df9b2$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $7fPBF.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $7fPBF.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $7fPBF.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $3eff8043e65df9b2$var$roundByDPR(elements.floating, data.x);
        const y = $3eff8043e65df9b2$var$roundByDPR(elements.floating, data.y);
        if (transform) return {
            ...initialStyles,
            transform: "translate(" + x + "px, " + y + "px)",
            ...$3eff8043e65df9b2$var$getDPR(elements.floating) >= 1.5 && {
                willChange: "transform"
            }
        };
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $7fPBF.useMemo(()=>({
            ...data,
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $3eff8043e65df9b2$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, "current");
    }
    return {
        name: "arrow",
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === "function" ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $28b5c677ea6a5d8a$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $28b5c677ea6a5d8a$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $3eff8043e65df9b2$export$cc800923e997bb8 = (options, deps)=>({
        ...(0, $28b5c677ea6a5d8a$export$cc800923e997bb8)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $3eff8043e65df9b2$export$fba63a578e423eb = (options, deps)=>({
        ...(0, $28b5c677ea6a5d8a$export$fba63a578e423eb)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $3eff8043e65df9b2$export$7bf07e38f3dc4b69 = (options, deps)=>({
        ...(0, $28b5c677ea6a5d8a$export$7bf07e38f3dc4b69)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $3eff8043e65df9b2$export$8a83211c878a3f1f = (options, deps)=>({
        ...(0, $28b5c677ea6a5d8a$export$8a83211c878a3f1f)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $3eff8043e65df9b2$export$346677f925de839c = (options, deps)=>({
        ...(0, $28b5c677ea6a5d8a$export$346677f925de839c)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $3eff8043e65df9b2$export$91fb6ecbd551914 = (options, deps)=>({
        ...(0, $28b5c677ea6a5d8a$export$91fb6ecbd551914)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $3eff8043e65df9b2$export$fe8985bb6374093c = (options, deps)=>({
        ...(0, $28b5c677ea6a5d8a$export$fe8985bb6374093c)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $3eff8043e65df9b2$export$18c8ad048e32c7d5 = (options, deps)=>({
        ...(0, $28b5c677ea6a5d8a$export$18c8ad048e32c7d5)(options),
        options: [
            options,
            deps
        ]
    });
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $3eff8043e65df9b2$export$f2120bbfa5450bd2 = (options, deps)=>({
        ...$3eff8043e65df9b2$var$arrow$1(options),
        options: [
            options,
            deps
        ]
    });


// packages/react/arrow/src/Arrow.tsx

var $7fPBF = parcelRequire("7fPBF");


var $00150e9d341c8d35$var$NAME = "Arrow";
var $00150e9d341c8d35$export$21b07c8f274aebd5 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { children: children, width: width = 10, height: height = 5, ...arrowProps } = props;
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).svg, {
        ...arrowProps,
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none",
        children: props.asChild ? children : /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("polygon", {
            points: "0,0 30,0 15,10"
        })
    });
});
$00150e9d341c8d35$export$21b07c8f274aebd5.displayName = $00150e9d341c8d35$var$NAME;
var $00150e9d341c8d35$export$be92b6f5f03c0fe9 = $00150e9d341c8d35$export$21b07c8f274aebd5;







// packages/react/use-size/src/useSize.tsx

var $7fPBF = parcelRequire("7fPBF");

function $0560b0618278acc0$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = $7fPBF.useState(void 0);
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        if (element) {
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"];
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else setSize(void 0);
    }, [
        element
    ]);
    return size;
}



"use client";
var $7952cd297982b588$export$36f0086da09c4b9f = [
    "top",
    "right",
    "bottom",
    "left"
];
var $7952cd297982b588$export$3671ffab7b302fc9 = [
    "start",
    "center",
    "end"
];
var $7952cd297982b588$var$POPPER_NAME = "Popper";
var [$7952cd297982b588$var$createPopperContext, $7952cd297982b588$export$722aac194ae923] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)($7952cd297982b588$var$POPPER_NAME);
var [$7952cd297982b588$var$PopperProvider, $7952cd297982b588$var$usePopperContext] = $7952cd297982b588$var$createPopperContext($7952cd297982b588$var$POPPER_NAME);
var $7952cd297982b588$export$badac9ada3a0bdf9 = (props)=>{
    const { __scopePopper: __scopePopper, children: children } = props;
    const [anchor, setAnchor] = $7fPBF.useState(null);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor,
        children: children
    });
};
$7952cd297982b588$export$badac9ada3a0bdf9.displayName = $7952cd297982b588$var$POPPER_NAME;
var $7952cd297982b588$var$ANCHOR_NAME = "PopperAnchor";
var $7952cd297982b588$export$ecd4e1ccab6ed6d = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopePopper: __scopePopper, virtualRef: virtualRef, ...anchorProps } = props;
    const context = $7952cd297982b588$var$usePopperContext($7952cd297982b588$var$ANCHOR_NAME, __scopePopper);
    const ref = $7fPBF.useRef(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $7fPBF.useEffect(()=>{
        context.onAnchorChange((virtualRef === null || virtualRef === void 0 ? void 0 : virtualRef.current) || ref.current);
    });
    return virtualRef ? null : /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
        ...anchorProps,
        ref: composedRefs
    });
});
$7952cd297982b588$export$ecd4e1ccab6ed6d.displayName = $7952cd297982b588$var$ANCHOR_NAME;
var $7952cd297982b588$var$CONTENT_NAME = "PopperContent";
var [$7952cd297982b588$var$PopperContentProvider, $7952cd297982b588$var$useContentContext] = $7952cd297982b588$var$createPopperContext($7952cd297982b588$var$CONTENT_NAME);
var $7952cd297982b588$export$bc4ae5855d3c4fc = $7fPBF.forwardRef((props, forwardedRef)=>{
    var _middlewareData_arrow, _middlewareData_arrow1, _middlewareData_arrow2, _middlewareData_transformOrigin, _middlewareData_transformOrigin1, _middlewareData_hide;
    const { __scopePopper: __scopePopper, side: side = "bottom", sideOffset: sideOffset = 0, align: align = "center", alignOffset: alignOffset = 0, arrowPadding: arrowPadding = 0, avoidCollisions: avoidCollisions = true, collisionBoundary: collisionBoundary = [], collisionPadding: collisionPaddingProp = 0, sticky: sticky = "partial", hideWhenDetached: hideWhenDetached = false, updatePositionStrategy: updatePositionStrategy = "optimized", onPlaced: onPlaced, ...contentProps } = props;
    const context = $7952cd297982b588$var$usePopperContext($7952cd297982b588$var$CONTENT_NAME, __scopePopper);
    const [content, setContent] = $7fPBF.useState(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const [arrow, setArrow] = $7fPBF.useState(null);
    const arrowSize = (0, $0560b0618278acc0$export$1ab7ae714698c4b8)(arrow);
    var _arrowSize_width;
    const arrowWidth = (_arrowSize_width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize_width !== void 0 ? _arrowSize_width : 0;
    var _arrowSize_height;
    const arrowHeight = (_arrowSize_height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize_height !== void 0 ? _arrowSize_height : 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        ...collisionPaddingProp
    };
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($7952cd297982b588$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { refs: refs, floatingStyles: floatingStyles, placement: placement, isPositioned: isPositioned, middlewareData: middlewareData } = (0, $3eff8043e65df9b2$export$4e02a5c1d08bac65)({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: desiredPlacement,
        whileElementsMounted: (...args)=>{
            const cleanup = (0, $28b5c677ea6a5d8a$export$deee3a793edee05f)(...args, {
                animationFrame: updatePositionStrategy === "always"
            });
            return cleanup;
        },
        elements: {
            reference: context.anchor
        },
        middleware: [
            (0, $3eff8043e65df9b2$export$cc800923e997bb8)({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions && (0, $3eff8043e65df9b2$export$fba63a578e423eb)({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === "partial" ? (0, $3eff8043e65df9b2$export$7bf07e38f3dc4b69)() : void 0,
                ...detectOverflowOptions
            }),
            avoidCollisions && (0, $3eff8043e65df9b2$export$8a83211c878a3f1f)({
                ...detectOverflowOptions
            }),
            (0, $3eff8043e65df9b2$export$346677f925de839c)({
                ...detectOverflowOptions,
                apply: ({ elements: elements, rects: rects, availableWidth: availableWidth, availableHeight: availableHeight })=>{
                    const { width: anchorWidth, height: anchorHeight } = rects.reference;
                    const contentStyle = elements.floating.style;
                    contentStyle.setProperty("--radix-popper-available-width", `${availableWidth}px`);
                    contentStyle.setProperty("--radix-popper-available-height", `${availableHeight}px`);
                    contentStyle.setProperty("--radix-popper-anchor-width", `${anchorWidth}px`);
                    contentStyle.setProperty("--radix-popper-anchor-height", `${anchorHeight}px`);
                }
            }),
            arrow && (0, $3eff8043e65df9b2$export$f2120bbfa5450bd2)({
                element: arrow,
                padding: arrowPadding
            }),
            $7952cd297982b588$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached && (0, $3eff8043e65df9b2$export$fe8985bb6374093c)({
                strategy: "referenceHidden",
                ...detectOverflowOptions
            })
        ]
    });
    const [placedSide, placedAlign] = $7952cd297982b588$var$getSideAndAlignFromPlacement(placement);
    const handlePlaced = (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(onPlaced);
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        if (isPositioned) handlePlaced === null || handlePlaced === void 0 ? void 0 : handlePlaced();
    }, [
        isPositioned,
        handlePlaced
    ]);
    const arrowX = (_middlewareData_arrow = middlewareData.arrow) === null || _middlewareData_arrow === void 0 ? void 0 : _middlewareData_arrow.x;
    const arrowY = (_middlewareData_arrow1 = middlewareData.arrow) === null || _middlewareData_arrow1 === void 0 ? void 0 : _middlewareData_arrow1.y;
    const cannotCenterArrow = ((_middlewareData_arrow2 = middlewareData.arrow) === null || _middlewareData_arrow2 === void 0 ? void 0 : _middlewareData_arrow2.centerOffset) !== 0;
    const [contentZIndex, setContentZIndex] = $7fPBF.useState();
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("div", {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
            ...floatingStyles,
            transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
            // keep off the page when measuring
            minWidth: "max-content",
            zIndex: contentZIndex,
            ["--radix-popper-transform-origin"]: [
                (_middlewareData_transformOrigin = middlewareData.transformOrigin) === null || _middlewareData_transformOrigin === void 0 ? void 0 : _middlewareData_transformOrigin.x,
                (_middlewareData_transformOrigin1 = middlewareData.transformOrigin) === null || _middlewareData_transformOrigin1 === void 0 ? void 0 : _middlewareData_transformOrigin1.y
            ].join(" "),
            // hide the content if using the hide middleware and should be hidden
            // set visibility to hidden and disable pointer events so the UI behaves
            // as if the PopperContent isn't there at all
            ...((_middlewareData_hide = middlewareData.hide) === null || _middlewareData_hide === void 0 ? void 0 : _middlewareData_hide.referenceHidden) && {
                visibility: "hidden",
                pointerEvents: "none"
            }
        },
        dir: props.dir,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$var$PopperContentProvider, {
            scope: __scopePopper,
            placedSide: placedSide,
            onArrowChange: setArrow,
            arrowX: arrowX,
            arrowY: arrowY,
            shouldHideArrow: cannotCenterArrow,
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
                "data-side": placedSide,
                "data-align": placedAlign,
                ...contentProps,
                ref: composedRefs,
                style: {
                    ...contentProps.style,
                    // if the PopperContent hasn't been placed yet (not all measurements done)
                    // we prevent animations so that users's animation don't kick in too early referring wrong sides
                    animation: !isPositioned ? "none" : void 0
                }
            })
        })
    });
});
$7952cd297982b588$export$bc4ae5855d3c4fc.displayName = $7952cd297982b588$var$CONTENT_NAME;
var $7952cd297982b588$var$ARROW_NAME = "PopperArrow";
var $7952cd297982b588$var$OPPOSITE_SIDE = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
};
var $7952cd297982b588$export$79d62cd4e10a3fd0 = $7fPBF.forwardRef(function PopperArrow2(props, forwardedRef) {
    const { __scopePopper: __scopePopper, ...arrowProps } = props;
    const contentContext = $7952cd297982b588$var$useContentContext($7952cd297982b588$var$ARROW_NAME, __scopePopper);
    const baseSide = $7952cd297982b588$var$OPPOSITE_SIDE[contentContext.placedSide];
    return(// we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: "absolute",
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: "",
                right: "0 0",
                bottom: "center 0",
                left: "100% 0"
            }[contentContext.placedSide],
            transform: {
                top: "translateY(100%)",
                right: "translateY(50%) rotate(90deg) translateX(-50%)",
                bottom: `rotate(180deg)`,
                left: "translateY(50%) rotate(-90deg) translateX(50%)"
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($00150e9d341c8d35$export$be92b6f5f03c0fe9, {
            ...arrowProps,
            ref: forwardedRef,
            style: {
                ...arrowProps.style,
                // ensures the element can be measured correctly (mostly for if SVG)
                display: "block"
            }
        })
    }));
});
$7952cd297982b588$export$79d62cd4e10a3fd0.displayName = $7952cd297982b588$var$ARROW_NAME;
function $7952cd297982b588$var$isNotNull(value) {
    return value !== null;
}
var $7952cd297982b588$var$transformOrigin = (options)=>({
        name: "transformOrigin",
        options: options,
        fn (data) {
            var _middlewareData_arrow, _middlewareData_arrow1, _middlewareData_arrow2;
            const { placement: placement, rects: rects, middlewareData: middlewareData } = data;
            const cannotCenterArrow = ((_middlewareData_arrow = middlewareData.arrow) === null || _middlewareData_arrow === void 0 ? void 0 : _middlewareData_arrow.centerOffset) !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $7952cd297982b588$var$getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: "0%",
                center: "50%",
                end: "100%"
            }[placedAlign];
            var _middlewareData_arrow_x;
            const arrowXCenter = ((_middlewareData_arrow_x = (_middlewareData_arrow1 = middlewareData.arrow) === null || _middlewareData_arrow1 === void 0 ? void 0 : _middlewareData_arrow1.x) !== null && _middlewareData_arrow_x !== void 0 ? _middlewareData_arrow_x : 0) + arrowWidth / 2;
            var _middlewareData_arrow_y;
            const arrowYCenter = ((_middlewareData_arrow_y = (_middlewareData_arrow2 = middlewareData.arrow) === null || _middlewareData_arrow2 === void 0 ? void 0 : _middlewareData_arrow2.y) !== null && _middlewareData_arrow_y !== void 0 ? _middlewareData_arrow_y : 0) + arrowHeight / 2;
            let x = "";
            let y = "";
            if (placedSide === "bottom") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === "top") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === "right") {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === "left") {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    });
function $7952cd297982b588$var$getSideAndAlignFromPlacement(placement) {
    const [side, align = "center"] = placement.split("-");
    return [
        side,
        align
    ];
}
var $7952cd297982b588$export$be92b6f5f03c0fe9 = $7952cd297982b588$export$badac9ada3a0bdf9;
var $7952cd297982b588$export$b688253958b8dfe7 = $7952cd297982b588$export$ecd4e1ccab6ed6d;
var $7952cd297982b588$export$7c6e2c02157bb7d2 = $7952cd297982b588$export$bc4ae5855d3c4fc;
var $7952cd297982b588$export$21b07c8f274aebd5 = $7952cd297982b588$export$79d62cd4e10a3fd0;









"use client";
var [$ec185ecb78ca2c5c$var$createTooltipContext, $ec185ecb78ca2c5c$export$1c540a2224f0d865] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)("Tooltip", [
    (0, $7952cd297982b588$export$722aac194ae923)
]);
var $ec185ecb78ca2c5c$var$usePopperScope = (0, $7952cd297982b588$export$722aac194ae923)();
var $ec185ecb78ca2c5c$var$PROVIDER_NAME = "TooltipProvider";
var $ec185ecb78ca2c5c$var$DEFAULT_DELAY_DURATION = 700;
var $ec185ecb78ca2c5c$var$TOOLTIP_OPEN = "tooltip.open";
var [$ec185ecb78ca2c5c$var$TooltipProviderContextProvider, $ec185ecb78ca2c5c$var$useTooltipProviderContext] = $ec185ecb78ca2c5c$var$createTooltipContext($ec185ecb78ca2c5c$var$PROVIDER_NAME);
var $ec185ecb78ca2c5c$export$f78649fb9ca566b8 = (props)=>{
    const { __scopeTooltip: __scopeTooltip, delayDuration: delayDuration = $ec185ecb78ca2c5c$var$DEFAULT_DELAY_DURATION, skipDelayDuration: skipDelayDuration = 300, disableHoverableContent: disableHoverableContent = false, children: children } = props;
    const [isOpenDelayed, setIsOpenDelayed] = $7fPBF.useState(true);
    const isPointerInTransitRef = $7fPBF.useRef(false);
    const skipDelayTimerRef = $7fPBF.useRef(0);
    $7fPBF.useEffect(()=>{
        const skipDelayTimer = skipDelayTimerRef.current;
        return ()=>window.clearTimeout(skipDelayTimer);
    }, []);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($ec185ecb78ca2c5c$var$TooltipProviderContextProvider, {
        scope: __scopeTooltip,
        isOpenDelayed: isOpenDelayed,
        delayDuration: delayDuration,
        onOpen: $7fPBF.useCallback(()=>{
            window.clearTimeout(skipDelayTimerRef.current);
            setIsOpenDelayed(false);
        }, []),
        onClose: $7fPBF.useCallback(()=>{
            window.clearTimeout(skipDelayTimerRef.current);
            skipDelayTimerRef.current = window.setTimeout(()=>setIsOpenDelayed(true), skipDelayDuration);
        }, [
            skipDelayDuration
        ]),
        isPointerInTransitRef: isPointerInTransitRef,
        onPointerInTransitChange: $7fPBF.useCallback((inTransit)=>{
            isPointerInTransitRef.current = inTransit;
        }, []),
        disableHoverableContent: disableHoverableContent,
        children: children
    });
};
$ec185ecb78ca2c5c$export$f78649fb9ca566b8.displayName = $ec185ecb78ca2c5c$var$PROVIDER_NAME;
var $ec185ecb78ca2c5c$var$TOOLTIP_NAME = "Tooltip";
var [$ec185ecb78ca2c5c$var$TooltipContextProvider, $ec185ecb78ca2c5c$var$useTooltipContext] = $ec185ecb78ca2c5c$var$createTooltipContext($ec185ecb78ca2c5c$var$TOOLTIP_NAME);
var $ec185ecb78ca2c5c$export$28c660c63b792dea = (props)=>{
    const { __scopeTooltip: __scopeTooltip, children: children, open: openProp, defaultOpen: defaultOpen = false, onOpenChange: onOpenChange, disableHoverableContent: disableHoverableContentProp, delayDuration: delayDurationProp } = props;
    const providerContext = $ec185ecb78ca2c5c$var$useTooltipProviderContext($ec185ecb78ca2c5c$var$TOOLTIP_NAME, props.__scopeTooltip);
    const popperScope = $ec185ecb78ca2c5c$var$usePopperScope(__scopeTooltip);
    const [trigger, setTrigger] = $7fPBF.useState(null);
    const contentId = (0, $8a8e9b94c33ba6d6$export$f680877a34711e37)();
    const openTimerRef = $7fPBF.useRef(0);
    const disableHoverableContent = disableHoverableContentProp !== null && disableHoverableContentProp !== void 0 ? disableHoverableContentProp : providerContext.disableHoverableContent;
    const delayDuration = delayDurationProp !== null && delayDurationProp !== void 0 ? delayDurationProp : providerContext.delayDuration;
    const wasOpenDelayedRef = $7fPBF.useRef(false);
    const [open = false, setOpen] = (0, $915387e6ab4d88b1$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: (open2)=>{
            if (open2) {
                providerContext.onOpen();
                document.dispatchEvent(new CustomEvent($ec185ecb78ca2c5c$var$TOOLTIP_OPEN));
            } else providerContext.onClose();
            onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(open2);
        }
    });
    const stateAttribute = $7fPBF.useMemo(()=>{
        return open ? wasOpenDelayedRef.current ? "delayed-open" : "instant-open" : "closed";
    }, [
        open
    ]);
    const handleOpen = $7fPBF.useCallback(()=>{
        window.clearTimeout(openTimerRef.current);
        wasOpenDelayedRef.current = false;
        setOpen(true);
    }, [
        setOpen
    ]);
    const handleClose = $7fPBF.useCallback(()=>{
        window.clearTimeout(openTimerRef.current);
        setOpen(false);
    }, [
        setOpen
    ]);
    const handleDelayedOpen = $7fPBF.useCallback(()=>{
        window.clearTimeout(openTimerRef.current);
        openTimerRef.current = window.setTimeout(()=>{
            wasOpenDelayedRef.current = true;
            setOpen(true);
        }, delayDuration);
    }, [
        delayDuration,
        setOpen
    ]);
    $7fPBF.useEffect(()=>{
        return ()=>window.clearTimeout(openTimerRef.current);
    }, []);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$export$be92b6f5f03c0fe9, {
        ...popperScope,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($ec185ecb78ca2c5c$var$TooltipContextProvider, {
            scope: __scopeTooltip,
            contentId: contentId,
            open: open,
            stateAttribute: stateAttribute,
            trigger: trigger,
            onTriggerChange: setTrigger,
            onTriggerEnter: $7fPBF.useCallback(()=>{
                if (providerContext.isOpenDelayed) handleDelayedOpen();
                else handleOpen();
            }, [
                providerContext.isOpenDelayed,
                handleDelayedOpen,
                handleOpen
            ]),
            onTriggerLeave: $7fPBF.useCallback(()=>{
                if (disableHoverableContent) handleClose();
                else window.clearTimeout(openTimerRef.current);
            }, [
                handleClose,
                disableHoverableContent
            ]),
            onOpen: handleOpen,
            onClose: handleClose,
            disableHoverableContent: disableHoverableContent,
            children: children
        })
    });
};
$ec185ecb78ca2c5c$export$28c660c63b792dea.displayName = $ec185ecb78ca2c5c$var$TOOLTIP_NAME;
var $ec185ecb78ca2c5c$var$TRIGGER_NAME = "TooltipTrigger";
var $ec185ecb78ca2c5c$export$8c610744efcf8a1d = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip, ...triggerProps } = props;
    const context = $ec185ecb78ca2c5c$var$useTooltipContext($ec185ecb78ca2c5c$var$TRIGGER_NAME, __scopeTooltip);
    const providerContext = $ec185ecb78ca2c5c$var$useTooltipProviderContext($ec185ecb78ca2c5c$var$TRIGGER_NAME, __scopeTooltip);
    const popperScope = $ec185ecb78ca2c5c$var$usePopperScope(__scopeTooltip);
    const ref = $7fPBF.useRef(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, ref, context.onTriggerChange);
    const isPointerDownRef = $7fPBF.useRef(false);
    const hasPointerMoveOpenedRef = $7fPBF.useRef(false);
    const handlePointerUp = $7fPBF.useCallback(()=>isPointerDownRef.current = false, []);
    $7fPBF.useEffect(()=>{
        return ()=>document.removeEventListener("pointerup", handlePointerUp);
    }, [
        handlePointerUp
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$export$b688253958b8dfe7, {
        asChild: true,
        ...popperScope,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).button, {
            "aria-describedby": context.open ? context.contentId : void 0,
            "data-state": context.stateAttribute,
            ...triggerProps,
            ref: composedRefs,
            onPointerMove: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerMove, (event)=>{
                if (event.pointerType === "touch") return;
                if (!hasPointerMoveOpenedRef.current && !providerContext.isPointerInTransitRef.current) {
                    context.onTriggerEnter();
                    hasPointerMoveOpenedRef.current = true;
                }
            }),
            onPointerLeave: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerLeave, ()=>{
                context.onTriggerLeave();
                hasPointerMoveOpenedRef.current = false;
            }),
            onPointerDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerDown, ()=>{
                isPointerDownRef.current = true;
                document.addEventListener("pointerup", handlePointerUp, {
                    once: true
                });
            }),
            onFocus: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onFocus, ()=>{
                if (!isPointerDownRef.current) context.onOpen();
            }),
            onBlur: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onBlur, context.onClose),
            onClick: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onClick, context.onClose)
        })
    });
});
$ec185ecb78ca2c5c$export$8c610744efcf8a1d.displayName = $ec185ecb78ca2c5c$var$TRIGGER_NAME;
var $ec185ecb78ca2c5c$var$PORTAL_NAME = "TooltipPortal";
var [$ec185ecb78ca2c5c$var$PortalProvider, $ec185ecb78ca2c5c$var$usePortalContext] = $ec185ecb78ca2c5c$var$createTooltipContext($ec185ecb78ca2c5c$var$PORTAL_NAME, {
    forceMount: void 0
});
var $ec185ecb78ca2c5c$export$7b36b8f925ab7497 = (props)=>{
    const { __scopeTooltip: __scopeTooltip, forceMount: forceMount, children: children, container: container } = props;
    const context = $ec185ecb78ca2c5c$var$useTooltipContext($ec185ecb78ca2c5c$var$PORTAL_NAME, __scopeTooltip);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($ec185ecb78ca2c5c$var$PortalProvider, {
        scope: __scopeTooltip,
        forceMount: forceMount,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $e9ce08b8e6e14786$export$99c2b779aa4e8b8b), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $57c7abe8fecdeb41$export$602eac185826482c), {
                asChild: true,
                container: container,
                children: children
            })
        })
    });
};
$ec185ecb78ca2c5c$export$7b36b8f925ab7497.displayName = $ec185ecb78ca2c5c$var$PORTAL_NAME;
var $ec185ecb78ca2c5c$var$CONTENT_NAME = "TooltipContent";
var $ec185ecb78ca2c5c$export$e9003e2be37ec060 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const portalContext = $ec185ecb78ca2c5c$var$usePortalContext($ec185ecb78ca2c5c$var$CONTENT_NAME, props.__scopeTooltip);
    const { forceMount: forceMount = portalContext.forceMount, side: side = "top", ...contentProps } = props;
    const context = $ec185ecb78ca2c5c$var$useTooltipContext($ec185ecb78ca2c5c$var$CONTENT_NAME, props.__scopeTooltip);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $e9ce08b8e6e14786$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: context.disableHoverableContent ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($ec185ecb78ca2c5c$var$TooltipContentImpl, {
            side: side,
            ...contentProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($ec185ecb78ca2c5c$var$TooltipContentHoverable, {
            side: side,
            ...contentProps,
            ref: forwardedRef
        })
    });
});
var $ec185ecb78ca2c5c$var$TooltipContentHoverable = $7fPBF.forwardRef((props, forwardedRef)=>{
    const context = $ec185ecb78ca2c5c$var$useTooltipContext($ec185ecb78ca2c5c$var$CONTENT_NAME, props.__scopeTooltip);
    const providerContext = $ec185ecb78ca2c5c$var$useTooltipProviderContext($ec185ecb78ca2c5c$var$CONTENT_NAME, props.__scopeTooltip);
    const ref = $7fPBF.useRef(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const [pointerGraceArea, setPointerGraceArea] = $7fPBF.useState(null);
    const { trigger: trigger, onClose: onClose } = context;
    const content = ref.current;
    const { onPointerInTransitChange: onPointerInTransitChange } = providerContext;
    const handleRemoveGraceArea = $7fPBF.useCallback(()=>{
        setPointerGraceArea(null);
        onPointerInTransitChange(false);
    }, [
        onPointerInTransitChange
    ]);
    const handleCreateGraceArea = $7fPBF.useCallback((event, hoverTarget)=>{
        const currentTarget = event.currentTarget;
        const exitPoint = {
            x: event.clientX,
            y: event.clientY
        };
        const exitSide = $ec185ecb78ca2c5c$var$getExitSideFromRect(exitPoint, currentTarget.getBoundingClientRect());
        const paddedExitPoints = $ec185ecb78ca2c5c$var$getPaddedExitPoints(exitPoint, exitSide);
        const hoverTargetPoints = $ec185ecb78ca2c5c$var$getPointsFromRect(hoverTarget.getBoundingClientRect());
        const graceArea = $ec185ecb78ca2c5c$var$getHull([
            ...paddedExitPoints,
            ...hoverTargetPoints
        ]);
        setPointerGraceArea(graceArea);
        onPointerInTransitChange(true);
    }, [
        onPointerInTransitChange
    ]);
    $7fPBF.useEffect(()=>{
        return ()=>handleRemoveGraceArea();
    }, [
        handleRemoveGraceArea
    ]);
    $7fPBF.useEffect(()=>{
        if (trigger && content) {
            const handleTriggerLeave = (event)=>handleCreateGraceArea(event, content);
            const handleContentLeave = (event)=>handleCreateGraceArea(event, trigger);
            trigger.addEventListener("pointerleave", handleTriggerLeave);
            content.addEventListener("pointerleave", handleContentLeave);
            return ()=>{
                trigger.removeEventListener("pointerleave", handleTriggerLeave);
                content.removeEventListener("pointerleave", handleContentLeave);
            };
        }
    }, [
        trigger,
        content,
        handleCreateGraceArea,
        handleRemoveGraceArea
    ]);
    $7fPBF.useEffect(()=>{
        if (pointerGraceArea) {
            const handleTrackPointerGrace = (event)=>{
                const target = event.target;
                const pointerPosition = {
                    x: event.clientX,
                    y: event.clientY
                };
                const hasEnteredTarget = (trigger === null || trigger === void 0 ? void 0 : trigger.contains(target)) || (content === null || content === void 0 ? void 0 : content.contains(target));
                const isPointerOutsideGraceArea = !$ec185ecb78ca2c5c$var$isPointInPolygon(pointerPosition, pointerGraceArea);
                if (hasEnteredTarget) handleRemoveGraceArea();
                else if (isPointerOutsideGraceArea) {
                    handleRemoveGraceArea();
                    onClose();
                }
            };
            document.addEventListener("pointermove", handleTrackPointerGrace);
            return ()=>document.removeEventListener("pointermove", handleTrackPointerGrace);
        }
    }, [
        trigger,
        content,
        pointerGraceArea,
        onClose,
        handleRemoveGraceArea
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($ec185ecb78ca2c5c$var$TooltipContentImpl, {
        ...props,
        ref: composedRefs
    });
});
var [$ec185ecb78ca2c5c$var$VisuallyHiddenContentContextProvider, $ec185ecb78ca2c5c$var$useVisuallyHiddenContentContext] = $ec185ecb78ca2c5c$var$createTooltipContext($ec185ecb78ca2c5c$var$TOOLTIP_NAME, {
    isInside: false
});
var $ec185ecb78ca2c5c$var$TooltipContentImpl = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip, children: children, "aria-label": ariaLabel, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, ...contentProps } = props;
    const context = $ec185ecb78ca2c5c$var$useTooltipContext($ec185ecb78ca2c5c$var$CONTENT_NAME, __scopeTooltip);
    const popperScope = $ec185ecb78ca2c5c$var$usePopperScope(__scopeTooltip);
    const { onClose: onClose } = context;
    $7fPBF.useEffect(()=>{
        document.addEventListener($ec185ecb78ca2c5c$var$TOOLTIP_OPEN, onClose);
        return ()=>document.removeEventListener($ec185ecb78ca2c5c$var$TOOLTIP_OPEN, onClose);
    }, [
        onClose
    ]);
    $7fPBF.useEffect(()=>{
        if (context.trigger) {
            const handleScroll = (event)=>{
                const target = event.target;
                if (target === null || target === void 0 ? void 0 : target.contains(context.trigger)) onClose();
            };
            window.addEventListener("scroll", handleScroll, {
                capture: true
            });
            return ()=>window.removeEventListener("scroll", handleScroll, {
                    capture: true
                });
        }
    }, [
        context.trigger,
        onClose
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $251340165f4765e5$export$177fb62ff3ec1f22), {
        asChild: true,
        disableOutsidePointerEvents: false,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onFocusOutside: (event)=>event.preventDefault(),
        onDismiss: onClose,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)($7952cd297982b588$export$7c6e2c02157bb7d2, {
            "data-state": context.stateAttribute,
            ...popperScope,
            ...contentProps,
            ref: forwardedRef,
            style: {
                ...contentProps.style,
                "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
                "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
                "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
                "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
                "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
                /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $089057084dfb92a4$export$d9f1ccf0bdb05d45), {
                    children: children
                }),
                /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($ec185ecb78ca2c5c$var$VisuallyHiddenContentContextProvider, {
                    scope: __scopeTooltip,
                    isInside: true,
                    children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($28c8fa82e4cfdc1a$export$be92b6f5f03c0fe9, {
                        id: context.contentId,
                        role: "tooltip",
                        children: ariaLabel || children
                    })
                })
            ]
        })
    });
});
$ec185ecb78ca2c5c$export$e9003e2be37ec060.displayName = $ec185ecb78ca2c5c$var$CONTENT_NAME;
var $ec185ecb78ca2c5c$var$ARROW_NAME = "TooltipArrow";
var $ec185ecb78ca2c5c$export$c27ee0ad710f7559 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeTooltip: __scopeTooltip, ...arrowProps } = props;
    const popperScope = $ec185ecb78ca2c5c$var$usePopperScope(__scopeTooltip);
    const visuallyHiddenContentContext = $ec185ecb78ca2c5c$var$useVisuallyHiddenContentContext($ec185ecb78ca2c5c$var$ARROW_NAME, __scopeTooltip);
    return visuallyHiddenContentContext.isInside ? null : /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$export$21b07c8f274aebd5, {
        ...popperScope,
        ...arrowProps,
        ref: forwardedRef
    });
});
$ec185ecb78ca2c5c$export$c27ee0ad710f7559.displayName = $ec185ecb78ca2c5c$var$ARROW_NAME;
function $ec185ecb78ca2c5c$var$getExitSideFromRect(point, rect) {
    const top = Math.abs(rect.top - point.y);
    const bottom = Math.abs(rect.bottom - point.y);
    const right = Math.abs(rect.right - point.x);
    const left = Math.abs(rect.left - point.x);
    switch(Math.min(top, bottom, right, left)){
        case left:
            return "left";
        case right:
            return "right";
        case top:
            return "top";
        case bottom:
            return "bottom";
        default:
            throw new Error("unreachable");
    }
}
function $ec185ecb78ca2c5c$var$getPaddedExitPoints(exitPoint, exitSide, padding = 5) {
    const paddedExitPoints = [];
    switch(exitSide){
        case "top":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y + padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y + padding
            });
            break;
        case "bottom":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y - padding
            });
            break;
        case "left":
            paddedExitPoints.push({
                x: exitPoint.x + padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y + padding
            });
            break;
        case "right":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x - padding,
                y: exitPoint.y + padding
            });
            break;
    }
    return paddedExitPoints;
}
function $ec185ecb78ca2c5c$var$getPointsFromRect(rect) {
    const { top: top, right: right, bottom: bottom, left: left } = rect;
    return [
        {
            x: left,
            y: top
        },
        {
            x: right,
            y: top
        },
        {
            x: right,
            y: bottom
        },
        {
            x: left,
            y: bottom
        }
    ];
}
function $ec185ecb78ca2c5c$var$isPointInPolygon(point, polygon) {
    const { x: x, y: y } = point;
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const xi = polygon[i].x;
        const yi = polygon[i].y;
        const xj = polygon[j].x;
        const yj = polygon[j].y;
        const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
}
function $ec185ecb78ca2c5c$var$getHull(points) {
    const newPoints = points.slice();
    newPoints.sort((a, b)=>{
        if (a.x < b.x) return -1;
        else if (a.x > b.x) return 1;
        else if (a.y < b.y) return -1;
        else if (a.y > b.y) return 1;
        else return 0;
    });
    return $ec185ecb78ca2c5c$var$getHullPresorted(newPoints);
}
function $ec185ecb78ca2c5c$var$getHullPresorted(points) {
    if (points.length <= 1) return points.slice();
    const upperHull = [];
    for(let i = 0; i < points.length; i++){
        const p = points[i];
        while(upperHull.length >= 2){
            const q = upperHull[upperHull.length - 1];
            const r = upperHull[upperHull.length - 2];
            if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x)) upperHull.pop();
            else break;
        }
        upperHull.push(p);
    }
    upperHull.pop();
    const lowerHull = [];
    for(let i = points.length - 1; i >= 0; i--){
        const p = points[i];
        while(lowerHull.length >= 2){
            const q = lowerHull[lowerHull.length - 1];
            const r = lowerHull[lowerHull.length - 2];
            if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x)) lowerHull.pop();
            else break;
        }
        lowerHull.push(p);
    }
    lowerHull.pop();
    if (upperHull.length === 1 && lowerHull.length === 1 && upperHull[0].x === lowerHull[0].x && upperHull[0].y === lowerHull[0].y) return upperHull;
    else return upperHull.concat(lowerHull);
}
var $ec185ecb78ca2c5c$export$2881499e37b75b9a = $ec185ecb78ca2c5c$export$f78649fb9ca566b8;
var $ec185ecb78ca2c5c$export$be92b6f5f03c0fe9 = $ec185ecb78ca2c5c$export$28c660c63b792dea;
var $ec185ecb78ca2c5c$export$41fb9f06171c75f4 = $ec185ecb78ca2c5c$export$8c610744efcf8a1d;
var $ec185ecb78ca2c5c$export$602eac185826482c = $ec185ecb78ca2c5c$export$7b36b8f925ab7497;
var $ec185ecb78ca2c5c$export$7c6e2c02157bb7d2 = $ec185ecb78ca2c5c$export$e9003e2be37ec060;
var $ec185ecb78ca2c5c$export$21b07c8f274aebd5 = $ec185ecb78ca2c5c$export$c27ee0ad710f7559;


// packages/react/direction/src/Direction.tsx

var $7fPBF = parcelRequire("7fPBF");

var $3342477e04611d10$var$DirectionContext = $7fPBF.createContext(void 0);
var $3342477e04611d10$export$c760c09fdd558351 = (props)=>{
    const { dir: dir, children: children } = props;
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($3342477e04611d10$var$DirectionContext.Provider, {
        value: dir,
        children: children
    });
};
function $3342477e04611d10$export$b39126d51d94e6f3(localDir) {
    const globalDir = $7fPBF.useContext($3342477e04611d10$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
var $3342477e04611d10$export$2881499e37b75b9a = $3342477e04611d10$export$c760c09fdd558351;



function $35c1c1e30f45838f$export$74e595af20fc4c22(e) {
    switch(e){
        case "tomato":
        case "red":
        case "ruby":
        case "crimson":
        case "pink":
        case "plum":
        case "purple":
        case "violet":
            return "mauve";
        case "iris":
        case "indigo":
        case "blue":
        case "sky":
        case "cyan":
            return "slate";
        case "teal":
        case "jade":
        case "mint":
        case "green":
            return "sage";
        case "grass":
        case "lime":
            return "olive";
        case "yellow":
        case "amber":
        case "orange":
        case "brown":
        case "gold":
        case "bronze":
            return "sand";
        case "gray":
            return "gray";
    }
}




const $3d20a83f81464c0a$export$18f838d5aba6962a = [
    "none",
    "small",
    "medium",
    "large",
    "full"
], $3d20a83f81464c0a$export$c467f6769b59b70c = {
    radius: {
        type: "enum",
        values: $3d20a83f81464c0a$export$18f838d5aba6962a,
        default: void 0
    }
};


const $56174f3812602a5f$var$p = [
    "inherit",
    "light",
    "dark"
], $56174f3812602a5f$var$t = [
    "solid",
    "translucent"
], $56174f3812602a5f$var$n = [
    "90%",
    "95%",
    "100%",
    "105%",
    "110%"
], $56174f3812602a5f$export$59a6a824235dee85 = {
    ...(0, $b302dbddfdac9d75$export$1e7c0b54c65e0280),
    hasBackground: {
        type: "boolean",
        default: !0
    },
    appearance: {
        type: "enum",
        values: $56174f3812602a5f$var$p,
        default: "inherit"
    },
    accentColor: {
        type: "enum",
        values: (0, $e914ebf2ce406d8c$export$8d1fb2aae3e7d457),
        default: "indigo"
    },
    grayColor: {
        type: "enum",
        values: (0, $e914ebf2ce406d8c$export$10473e9ffc331ca1),
        default: "auto"
    },
    panelBackground: {
        type: "enum",
        values: $56174f3812602a5f$var$t,
        default: "translucent"
    },
    radius: {
        type: "enum",
        values: (0, $3d20a83f81464c0a$export$18f838d5aba6962a),
        default: "medium"
    },
    scaling: {
        type: "enum",
        values: $56174f3812602a5f$var$n,
        default: "100%"
    }
};


"use client";
const $fe07e27ecf0fa1d7$var$d = ()=>{}, $fe07e27ecf0fa1d7$var$b = $7fPBF.createContext(void 0);
function $fe07e27ecf0fa1d7$export$c4281ec44b929e6() {
    const a = $7fPBF.useContext($fe07e27ecf0fa1d7$var$b);
    if (a === void 0) throw new Error("`useThemeContext` must be used within a `Theme`");
    return a;
}
const $fe07e27ecf0fa1d7$export$14faa19a0f3bbeb2 = $7fPBF.forwardRef((a, s)=>$7fPBF.useContext($fe07e27ecf0fa1d7$var$b) === void 0 ? $7fPBF.createElement($ec185ecb78ca2c5c$export$2881499e37b75b9a, {
        delayDuration: 200
    }, $7fPBF.createElement((0, $3342477e04611d10$export$c760c09fdd558351), {
        dir: "ltr"
    }, $7fPBF.createElement($fe07e27ecf0fa1d7$var$R, {
        ...a,
        ref: s
    }))) : $7fPBF.createElement($fe07e27ecf0fa1d7$var$A, {
        ...a,
        ref: s
    }));
$fe07e27ecf0fa1d7$export$14faa19a0f3bbeb2.displayName = "Theme";
const $fe07e27ecf0fa1d7$var$R = $7fPBF.forwardRef((a, s)=>{
    const { appearance: r = (0, $56174f3812602a5f$export$59a6a824235dee85).appearance.default, accentColor: c = (0, $56174f3812602a5f$export$59a6a824235dee85).accentColor.default, grayColor: l = (0, $56174f3812602a5f$export$59a6a824235dee85).grayColor.default, panelBackground: p = (0, $56174f3812602a5f$export$59a6a824235dee85).panelBackground.default, radius: n = (0, $56174f3812602a5f$export$59a6a824235dee85).radius.default, scaling: t = (0, $56174f3812602a5f$export$59a6a824235dee85).scaling.default, hasBackground: m = (0, $56174f3812602a5f$export$59a6a824235dee85).hasBackground.default, ...u } = a, [h, i] = $7fPBF.useState(r);
    $7fPBF.useEffect(()=>i(r), [
        r
    ]);
    const [T, g] = $7fPBF.useState(c);
    $7fPBF.useEffect(()=>g(c), [
        c
    ]);
    const [y, C] = $7fPBF.useState(l);
    $7fPBF.useEffect(()=>C(l), [
        l
    ]);
    const [v, f] = $7fPBF.useState(p);
    $7fPBF.useEffect(()=>f(p), [
        p
    ]);
    const [k, B] = $7fPBF.useState(n);
    $7fPBF.useEffect(()=>B(n), [
        n
    ]);
    const [P, x] = $7fPBF.useState(t);
    return $7fPBF.useEffect(()=>x(t), [
        t
    ]), $7fPBF.createElement($fe07e27ecf0fa1d7$var$A, {
        ...u,
        ref: s,
        isRoot: !0,
        hasBackground: m,
        appearance: h,
        accentColor: T,
        grayColor: y,
        panelBackground: v,
        radius: k,
        scaling: P,
        onAppearanceChange: i,
        onAccentColorChange: g,
        onGrayColorChange: C,
        onPanelBackgroundChange: f,
        onRadiusChange: B,
        onScalingChange: x
    });
});
$fe07e27ecf0fa1d7$var$R.displayName = "ThemeRoot";
const $fe07e27ecf0fa1d7$var$A = $7fPBF.forwardRef((a, s)=>{
    var _r_appearance, _r_accentColor, _r_resolvedGrayColor, _r_panelBackground, _r_radius, _r_scaling;
    const r = $7fPBF.useContext($fe07e27ecf0fa1d7$var$b), { asChild: c, isRoot: l, hasBackground: p, appearance: n = (_r_appearance = r === null || r === void 0 ? void 0 : r.appearance) !== null && _r_appearance !== void 0 ? _r_appearance : (0, $56174f3812602a5f$export$59a6a824235dee85).appearance.default, accentColor: t = (_r_accentColor = r === null || r === void 0 ? void 0 : r.accentColor) !== null && _r_accentColor !== void 0 ? _r_accentColor : (0, $56174f3812602a5f$export$59a6a824235dee85).accentColor.default, grayColor: m = (_r_resolvedGrayColor = r === null || r === void 0 ? void 0 : r.resolvedGrayColor) !== null && _r_resolvedGrayColor !== void 0 ? _r_resolvedGrayColor : (0, $56174f3812602a5f$export$59a6a824235dee85).grayColor.default, panelBackground: u = (_r_panelBackground = r === null || r === void 0 ? void 0 : r.panelBackground) !== null && _r_panelBackground !== void 0 ? _r_panelBackground : (0, $56174f3812602a5f$export$59a6a824235dee85).panelBackground.default, radius: h = (_r_radius = r === null || r === void 0 ? void 0 : r.radius) !== null && _r_radius !== void 0 ? _r_radius : (0, $56174f3812602a5f$export$59a6a824235dee85).radius.default, scaling: i = (_r_scaling = r === null || r === void 0 ? void 0 : r.scaling) !== null && _r_scaling !== void 0 ? _r_scaling : (0, $56174f3812602a5f$export$59a6a824235dee85).scaling.default, onAppearanceChange: T = $fe07e27ecf0fa1d7$var$d, onAccentColorChange: g = $fe07e27ecf0fa1d7$var$d, onGrayColorChange: y = $fe07e27ecf0fa1d7$var$d, onPanelBackgroundChange: C = $fe07e27ecf0fa1d7$var$d, onRadiusChange: v = $fe07e27ecf0fa1d7$var$d, onScalingChange: f = $fe07e27ecf0fa1d7$var$d, ...k } = a, B = c ? (0, $089057084dfb92a4$export$8c6ed5c666ac1360) : "div", P = m === "auto" ? (0, $35c1c1e30f45838f$export$74e595af20fc4c22)(t) : m, x = a.appearance === "light" || a.appearance === "dark", S = p === void 0 ? l || x : p;
    return $7fPBF.createElement($fe07e27ecf0fa1d7$var$b.Provider, {
        value: $7fPBF.useMemo(()=>({
                appearance: n,
                accentColor: t,
                grayColor: m,
                resolvedGrayColor: P,
                panelBackground: u,
                radius: h,
                scaling: i,
                onAppearanceChange: T,
                onAccentColorChange: g,
                onGrayColorChange: y,
                onPanelBackgroundChange: C,
                onRadiusChange: v,
                onScalingChange: f
            }), [
            n,
            t,
            m,
            P,
            u,
            h,
            i,
            T,
            g,
            y,
            C,
            v,
            f
        ])
    }, $7fPBF.createElement(B, {
        "data-is-root-theme": l ? "true" : "false",
        "data-accent-color": t,
        "data-gray-color": P,
        "data-has-background": S ? "true" : "false",
        "data-panel-background": u,
        "data-radius": h,
        "data-scaling": i,
        ref: s,
        ...k,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("radix-themes", {
            light: n === "light",
            dark: n === "dark"
        }, k.className)
    }));
});
$fe07e27ecf0fa1d7$var$A.displayName = "ThemeImpl";




var $7fPBF = parcelRequire("7fPBF");
const $d51eb3faadbea344$export$fb35347076fc30e = (t)=>{
    if (!$7fPBF.isValidElement(t)) throw Error(`Expected a single React Element child, but got: ${$7fPBF.Children.toArray(t).map((e)=>typeof e == "object" && "type" in e && typeof e.type == "string" ? e.type : typeof e).join(", ")}`);
    return t;
};


const $99c5b0300cb21d88$export$be92b6f5f03c0fe9 = (t)=>$7fPBF.createElement($3ca1ba55f468f447$export$be92b6f5f03c0fe9, {
        ...t
    });
$99c5b0300cb21d88$export$be92b6f5f03c0fe9.displayName = "AlertDialog.Root";
const $99c5b0300cb21d88$export$41fb9f06171c75f4 = $7fPBF.forwardRef(({ children: t, ...o }, i)=>$7fPBF.createElement($3ca1ba55f468f447$export$41fb9f06171c75f4, {
        ...o,
        ref: i,
        asChild: !0
    }, (0, $d51eb3faadbea344$export$fb35347076fc30e)(t)));
$99c5b0300cb21d88$export$41fb9f06171c75f4.displayName = "AlertDialog.Trigger";
const $99c5b0300cb21d88$export$7c6e2c02157bb7d2 = $7fPBF.forwardRef(({ align: t, ...o }, i)=>{
    const { align: P, ...c } = (0, $2f4552c9a33a7df5$export$cde45305589709cc), { className: f } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)({
        align: t
    }, {
        align: P
    }), { className: C, forceMount: d, container: y, ...v } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(o, c);
    return $7fPBF.createElement($3ca1ba55f468f447$export$602eac185826482c, {
        container: y,
        forceMount: d
    }, $7fPBF.createElement((0, $fe07e27ecf0fa1d7$export$14faa19a0f3bbeb2), {
        asChild: !0
    }, $7fPBF.createElement($3ca1ba55f468f447$export$c6fdb837b070b4ff, {
        className: "rt-BaseDialogOverlay rt-AlertDialogOverlay"
    }, $7fPBF.createElement("div", {
        className: "rt-BaseDialogScroll rt-AlertDialogScroll"
    }, $7fPBF.createElement("div", {
        className: `rt-BaseDialogScrollPadding rt-AlertDialogScrollPadding ${f}`
    }, $7fPBF.createElement($3ca1ba55f468f447$export$7c6e2c02157bb7d2, {
        ...v,
        ref: i,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-BaseDialogContent", "rt-AlertDialogContent", C)
    }))))));
});
$99c5b0300cb21d88$export$7c6e2c02157bb7d2.displayName = "AlertDialog.Content";
const $99c5b0300cb21d88$export$f99233281efd08a0 = $7fPBF.forwardRef((t, o)=>$7fPBF.createElement($3ca1ba55f468f447$export$f99233281efd08a0, {
        asChild: !0
    }, $7fPBF.createElement((0, $a81a142737c4a792$export$a8a3e93435678ff9), {
        size: "5",
        mb: "3",
        trim: "start",
        ...t,
        asChild: !1,
        ref: o
    })));
$99c5b0300cb21d88$export$f99233281efd08a0.displayName = "AlertDialog.Title";
const $99c5b0300cb21d88$export$393edc798c47379d = $7fPBF.forwardRef((t, o)=>$7fPBF.createElement($3ca1ba55f468f447$export$393edc798c47379d, {
        asChild: !0
    }, $7fPBF.createElement((0, $83db9e82a643d7a4$export$5f1af8db9871e1d6), {
        as: "p",
        size: "3",
        ...t,
        asChild: !1,
        ref: o
    })));
$99c5b0300cb21d88$export$393edc798c47379d.displayName = "AlertDialog.Description";
const $99c5b0300cb21d88$export$e19cd5f9376f8cee = $7fPBF.forwardRef(({ children: t, ...o }, i)=>$7fPBF.createElement($3ca1ba55f468f447$export$e19cd5f9376f8cee, {
        ...o,
        ref: i,
        asChild: !0
    }, (0, $d51eb3faadbea344$export$fb35347076fc30e)(t)));
$99c5b0300cb21d88$export$e19cd5f9376f8cee.displayName = "AlertDialog.Action";
const $99c5b0300cb21d88$export$848c9b7ead0df967 = $7fPBF.forwardRef(({ children: t, ...o }, i)=>$7fPBF.createElement($3ca1ba55f468f447$export$848c9b7ead0df967, {
        ...o,
        ref: i,
        asChild: !0
    }, (0, $d51eb3faadbea344$export$fb35347076fc30e)(t)));
$99c5b0300cb21d88$export$848c9b7ead0df967.displayName = "AlertDialog.Cancel";






var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");





"use client";
var $4b9b6dd2c76ac01f$var$AVATAR_NAME = "Avatar";
var [$4b9b6dd2c76ac01f$var$createAvatarContext, $4b9b6dd2c76ac01f$export$90370d16b488820f] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)($4b9b6dd2c76ac01f$var$AVATAR_NAME);
var [$4b9b6dd2c76ac01f$var$AvatarProvider, $4b9b6dd2c76ac01f$var$useAvatarContext] = $4b9b6dd2c76ac01f$var$createAvatarContext($4b9b6dd2c76ac01f$var$AVATAR_NAME);
var $4b9b6dd2c76ac01f$export$e2255cf6045e8d47 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeAvatar: __scopeAvatar, ...avatarProps } = props;
    const [imageLoadingStatus, setImageLoadingStatus] = $7fPBF.useState("idle");
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($4b9b6dd2c76ac01f$var$AvatarProvider, {
        scope: __scopeAvatar,
        imageLoadingStatus: imageLoadingStatus,
        onImageLoadingStatusChange: setImageLoadingStatus,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).span, {
            ...avatarProps,
            ref: forwardedRef
        })
    });
});
$4b9b6dd2c76ac01f$export$e2255cf6045e8d47.displayName = $4b9b6dd2c76ac01f$var$AVATAR_NAME;
var $4b9b6dd2c76ac01f$var$IMAGE_NAME = "AvatarImage";
var $4b9b6dd2c76ac01f$export$2cd8ae1985206fe8 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeAvatar: __scopeAvatar, src: src, onLoadingStatusChange: onLoadingStatusChange = ()=>{}, ...imageProps } = props;
    const context = $4b9b6dd2c76ac01f$var$useAvatarContext($4b9b6dd2c76ac01f$var$IMAGE_NAME, __scopeAvatar);
    const imageLoadingStatus = $4b9b6dd2c76ac01f$var$useImageLoadingStatus(src);
    const handleLoadingStatusChange = (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)((status)=>{
        onLoadingStatusChange(status);
        context.onImageLoadingStatusChange(status);
    });
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        if (imageLoadingStatus !== "idle") handleLoadingStatusChange(imageLoadingStatus);
    }, [
        imageLoadingStatus,
        handleLoadingStatusChange
    ]);
    return imageLoadingStatus === "loaded" ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).img, {
        ...imageProps,
        ref: forwardedRef,
        src: src
    }) : null;
});
$4b9b6dd2c76ac01f$export$2cd8ae1985206fe8.displayName = $4b9b6dd2c76ac01f$var$IMAGE_NAME;
var $4b9b6dd2c76ac01f$var$FALLBACK_NAME = "AvatarFallback";
var $4b9b6dd2c76ac01f$export$69fffb6a9571fbfe = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeAvatar: __scopeAvatar, delayMs: delayMs, ...fallbackProps } = props;
    const context = $4b9b6dd2c76ac01f$var$useAvatarContext($4b9b6dd2c76ac01f$var$FALLBACK_NAME, __scopeAvatar);
    const [canRender, setCanRender] = $7fPBF.useState(delayMs === void 0);
    $7fPBF.useEffect(()=>{
        if (delayMs !== void 0) {
            const timerId = window.setTimeout(()=>setCanRender(true), delayMs);
            return ()=>window.clearTimeout(timerId);
        }
    }, [
        delayMs
    ]);
    return canRender && context.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).span, {
        ...fallbackProps,
        ref: forwardedRef
    }) : null;
});
$4b9b6dd2c76ac01f$export$69fffb6a9571fbfe.displayName = $4b9b6dd2c76ac01f$var$FALLBACK_NAME;
function $4b9b6dd2c76ac01f$var$useImageLoadingStatus(src) {
    const [loadingStatus, setLoadingStatus] = $7fPBF.useState("idle");
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        if (!src) {
            setLoadingStatus("error");
            return;
        }
        let isMounted = true;
        const image = new window.Image();
        const updateStatus = (status)=>()=>{
                if (!isMounted) return;
                setLoadingStatus(status);
            };
        setLoadingStatus("loading");
        image.onload = updateStatus("loaded");
        image.onerror = updateStatus("error");
        image.src = src;
        return ()=>{
            isMounted = false;
        };
    }, [
        src
    ]);
    return loadingStatus;
}
var $4b9b6dd2c76ac01f$export$be92b6f5f03c0fe9 = $4b9b6dd2c76ac01f$export$e2255cf6045e8d47;
var $4b9b6dd2c76ac01f$export$3e431a229df88919 = $4b9b6dd2c76ac01f$export$2cd8ae1985206fe8;
var $4b9b6dd2c76ac01f$export$fb8d7f40caaeea67 = $4b9b6dd2c76ac01f$export$69fffb6a9571fbfe;






const $3d3e676e80939815$var$s = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9"
], $3d3e676e80939815$var$a = [
    "solid",
    "soft"
], $3d3e676e80939815$export$bdfce572a7c4d923 = {
    ...(0, $b302dbddfdac9d75$export$1e7c0b54c65e0280),
    size: {
        type: "enum",
        className: "rt-r-size",
        values: $3d3e676e80939815$var$s,
        default: "3",
        responsive: !0
    },
    variant: {
        type: "enum",
        className: "rt-variant",
        values: $3d3e676e80939815$var$a,
        default: "soft"
    },
    ...(0, $e914ebf2ce406d8c$export$d0261b42be231f92),
    ...(0, $f41c61290c2a7125$export$2f84412d299def33),
    ...(0, $3d20a83f81464c0a$export$c467f6769b59b70c),
    fallback: {
        type: "ReactNode",
        required: !0
    }
};




var $7fPBF = parcelRequire("7fPBF");
function $3de7503944cba122$export$9e8b964465d7899e(i, e) {
    const { asChild: r, children: c } = i;
    if (!r) return typeof e == "function" ? e(c) : e;
    const t = $7fPBF.Children.only(c);
    return $7fPBF.cloneElement(t, {
        children: typeof e == "function" ? e(t.props.children) : e
    });
}



"use client";
const $a93feb7e07610316$export$e2255cf6045e8d47 = $7fPBF.forwardRef((t, e)=>{
    const { asChild: o, children: a, className: s, style: p, color: v, radius: f, ...d } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(t, (0, $3d3e676e80939815$export$bdfce572a7c4d923), (0, $df06be8448ff4f3c$export$83503616c7a463e3));
    return $7fPBF.createElement($4b9b6dd2c76ac01f$export$be92b6f5f03c0fe9, {
        "data-accent-color": v,
        "data-radius": f,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-reset", "rt-AvatarRoot", s),
        style: p,
        asChild: o
    }, (0, $3de7503944cba122$export$9e8b964465d7899e)({
        asChild: o,
        children: a
    }, $7fPBF.createElement($a93feb7e07610316$var$n, {
        ref: e,
        ...d
    })));
});
$a93feb7e07610316$export$e2255cf6045e8d47.displayName = "Avatar";
const $a93feb7e07610316$var$n = $7fPBF.forwardRef(({ fallback: t, ...e }, o)=>{
    const [a, s] = $7fPBF.useState("idle");
    return $7fPBF.createElement($7fPBF.Fragment, null, a === "idle" || a === "loading" ? $7fPBF.createElement("span", {
        className: "rt-AvatarFallback"
    }) : null, a === "error" ? $7fPBF.createElement($4b9b6dd2c76ac01f$export$fb8d7f40caaeea67, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-AvatarFallback", {
            "rt-one-letter": typeof t == "string" && t.length === 1,
            "rt-two-letters": typeof t == "string" && t.length === 2
        }),
        delayMs: 0
    }, t) : null, $7fPBF.createElement($4b9b6dd2c76ac01f$export$3e431a229df88919, {
        ref: o,
        className: "rt-AvatarImage",
        ...e,
        onLoadingStatusChange: (p)=>{
            var _e_onLoadingStatusChange;
            (_e_onLoadingStatusChange = e.onLoadingStatusChange) === null || _e_onLoadingStatusChange === void 0 ? void 0 : _e_onLoadingStatusChange.call(e, p), s(p);
        }
    }));
});
$a93feb7e07610316$var$n.displayName = "AvatarImpl";



var $7fPBF = parcelRequire("7fPBF");






const $57e897ffc9a41115$var$t = [
    "1",
    "2",
    "3"
], $57e897ffc9a41115$var$a = [
    "solid",
    "soft",
    "surface",
    "outline"
], $57e897ffc9a41115$export$41ad9fee7a8fe9f1 = {
    ...(0, $b302dbddfdac9d75$export$1e7c0b54c65e0280),
    size: {
        type: "enum",
        className: "rt-r-size",
        values: $57e897ffc9a41115$var$t,
        default: "1",
        responsive: !0
    },
    variant: {
        type: "enum",
        className: "rt-variant",
        values: $57e897ffc9a41115$var$a,
        default: "soft"
    },
    ...(0, $e914ebf2ce406d8c$export$d0261b42be231f92),
    ...(0, $f41c61290c2a7125$export$2f84412d299def33),
    ...(0, $3d20a83f81464c0a$export$c467f6769b59b70c)
};




const $fb1373b494fa36be$export$37acb3580601e69a = $7fPBF.forwardRef((r, p)=>{
    const { asChild: s, className: t, color: a, radius: m, ...n } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(r, (0, $57e897ffc9a41115$export$41ad9fee7a8fe9f1), (0, $df06be8448ff4f3c$export$83503616c7a463e3));
    return $7fPBF.createElement(s ? (0, $089057084dfb92a4$export$8c6ed5c666ac1360) : "span", {
        "data-accent-color": a,
        "data-radius": m,
        ...n,
        ref: p,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-reset", "rt-Badge", t)
    });
});
$fb1373b494fa36be$export$37acb3580601e69a.displayName = "Badge";



var $7fPBF = parcelRequire("7fPBF");









const $6ea0ba02c5b000bc$var$f = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9"
], $6ea0ba02c5b000bc$export$303a4da38fad6e35 = {
    ...(0, $b302dbddfdac9d75$export$1e7c0b54c65e0280),
    size: {
        type: "enum",
        className: "rt-r-size",
        values: $6ea0ba02c5b000bc$var$f,
        responsive: !0
    },
    ...(0, $ec44dfa8e04fe2ae$export$959a85f577d21089),
    ...(0, $e914ebf2ce406d8c$export$8255b018f448be13),
    ...(0, $f41c61290c2a7125$export$2f84412d299def33),
    ...(0, $2c64e4634b053e6a$export$b51caa9f475eecbe),
    ...(0, $738dfabf5e38f576$export$d1dbebac82aee34d)
};


const $10e62b451f73e39d$export$29a7a275fe11687 = $7fPBF.forwardRef((t, p)=>{
    const { asChild: r, children: s, className: m, ...l } = t, c = r ? (0, $089057084dfb92a4$export$8c6ed5c666ac1360) : "blockquote";
    return $7fPBF.createElement((0, $83db9e82a643d7a4$export$5f1af8db9871e1d6), {
        asChild: !0,
        ...l,
        ref: p,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-Blockquote", m)
    }, $7fPBF.createElement(c, null, s));
});
$10e62b451f73e39d$export$29a7a275fe11687.displayName = "Blockquote";



var $7fPBF = parcelRequire("7fPBF");





const $0c5c7d485f2d9927$var$s = [
    "div",
    "span"
], $0c5c7d485f2d9927$var$p = [
    "none",
    "inline",
    "inline-block",
    "block"
], $0c5c7d485f2d9927$export$94779dc4910eab00 = {
    as: {
        type: "enum",
        values: $0c5c7d485f2d9927$var$s,
        default: "div"
    },
    ...(0, $b302dbddfdac9d75$export$1e7c0b54c65e0280),
    display: {
        type: "enum",
        className: "rt-r-display",
        values: $0c5c7d485f2d9927$var$p,
        responsive: !0
    }
};



const $48ad56c8dba75b58$var$e = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9"
], $48ad56c8dba75b58$export$2076c0543e271ca1 = {
    p: {
        type: "enum | string",
        className: "rt-r-p",
        customProperties: [
            "--p"
        ],
        values: $48ad56c8dba75b58$var$e,
        responsive: !0
    },
    px: {
        type: "enum | string",
        className: "rt-r-px",
        customProperties: [
            "--pl",
            "--pr"
        ],
        values: $48ad56c8dba75b58$var$e,
        responsive: !0
    },
    py: {
        type: "enum | string",
        className: "rt-r-py",
        customProperties: [
            "--pt",
            "--pb"
        ],
        values: $48ad56c8dba75b58$var$e,
        responsive: !0
    },
    pt: {
        type: "enum | string",
        className: "rt-r-pt",
        customProperties: [
            "--pt"
        ],
        values: $48ad56c8dba75b58$var$e,
        responsive: !0
    },
    pr: {
        type: "enum | string",
        className: "rt-r-pr",
        customProperties: [
            "--pr"
        ],
        values: $48ad56c8dba75b58$var$e,
        responsive: !0
    },
    pb: {
        type: "enum | string",
        className: "rt-r-pb",
        customProperties: [
            "--pb"
        ],
        values: $48ad56c8dba75b58$var$e,
        responsive: !0
    },
    pl: {
        type: "enum | string",
        className: "rt-r-pl",
        customProperties: [
            "--pl"
        ],
        values: $48ad56c8dba75b58$var$e,
        responsive: !0
    }
};




const $b1d6d16f69302f9e$var$r = [
    "visible",
    "hidden",
    "clip",
    "scroll",
    "auto"
], $b1d6d16f69302f9e$var$i = [
    "static",
    "relative",
    "absolute",
    "fixed",
    "sticky"
], $b1d6d16f69302f9e$var$e = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "-1",
    "-2",
    "-3",
    "-4",
    "-5",
    "-6",
    "-7",
    "-8",
    "-9"
], $b1d6d16f69302f9e$var$p = [
    "0",
    "1"
], $b1d6d16f69302f9e$var$n = [
    "0",
    "1"
], $b1d6d16f69302f9e$export$e71e58537b2e6660 = {
    ...(0, $48ad56c8dba75b58$export$2076c0543e271ca1),
    ...(0, $b6a742bf1f02ee7d$export$18e5dbe2c243731),
    ...(0, $a66fc9f2b041fa5d$export$e039c83f102b25e2),
    position: {
        type: "enum",
        className: "rt-r-position",
        values: $b1d6d16f69302f9e$var$i,
        responsive: !0
    },
    inset: {
        type: "enum | string",
        className: "rt-r-inset",
        customProperties: [
            "--inset"
        ],
        values: $b1d6d16f69302f9e$var$e,
        responsive: !0
    },
    top: {
        type: "enum | string",
        className: "rt-r-top",
        customProperties: [
            "--top"
        ],
        values: $b1d6d16f69302f9e$var$e,
        responsive: !0
    },
    right: {
        type: "enum | string",
        className: "rt-r-right",
        customProperties: [
            "--right"
        ],
        values: $b1d6d16f69302f9e$var$e,
        responsive: !0
    },
    bottom: {
        type: "enum | string",
        className: "rt-r-bottom",
        customProperties: [
            "--bottom"
        ],
        values: $b1d6d16f69302f9e$var$e,
        responsive: !0
    },
    left: {
        type: "enum | string",
        className: "rt-r-left",
        customProperties: [
            "--left"
        ],
        values: $b1d6d16f69302f9e$var$e,
        responsive: !0
    },
    overflow: {
        type: "enum",
        className: "rt-r-overflow",
        values: $b1d6d16f69302f9e$var$r,
        responsive: !0
    },
    overflowX: {
        type: "enum",
        className: "rt-r-ox",
        values: $b1d6d16f69302f9e$var$r,
        responsive: !0
    },
    overflowY: {
        type: "enum",
        className: "rt-r-oy",
        values: $b1d6d16f69302f9e$var$r,
        responsive: !0
    },
    flexBasis: {
        type: "string",
        className: "rt-r-fb",
        customProperties: [
            "--flex-basis"
        ],
        responsive: !0
    },
    flexShrink: {
        type: "enum | string",
        className: "rt-r-fs",
        customProperties: [
            "--flex-shrink"
        ],
        values: $b1d6d16f69302f9e$var$p,
        responsive: !0
    },
    flexGrow: {
        type: "enum | string",
        className: "rt-r-fg",
        customProperties: [
            "--flex-grow"
        ],
        values: $b1d6d16f69302f9e$var$n,
        responsive: !0
    },
    gridArea: {
        type: "string",
        className: "rt-r-ga",
        customProperties: [
            "--grid-area"
        ],
        responsive: !0
    },
    gridColumn: {
        type: "string",
        className: "rt-r-gc",
        customProperties: [
            "--grid-column"
        ],
        responsive: !0
    },
    gridColumnStart: {
        type: "string",
        className: "rt-r-gcs",
        customProperties: [
            "--grid-column-start"
        ],
        responsive: !0
    },
    gridColumnEnd: {
        type: "string",
        className: "rt-r-gce",
        customProperties: [
            "--grid-column-end"
        ],
        responsive: !0
    },
    gridRow: {
        type: "string",
        className: "rt-r-gr",
        customProperties: [
            "--grid-row"
        ],
        responsive: !0
    },
    gridRowStart: {
        type: "string",
        className: "rt-r-grs",
        customProperties: [
            "--grid-row-start"
        ],
        responsive: !0
    },
    gridRowEnd: {
        type: "string",
        className: "rt-r-gre",
        customProperties: [
            "--grid-row-end"
        ],
        responsive: !0
    }
};



const $70d14e4633845b98$export$e71c4d32a2263218 = $7fPBF.forwardRef((r, s)=>{
    const { className: t, asChild: e, as: m = "div", ...a } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(r, (0, $0c5c7d485f2d9927$export$94779dc4910eab00), (0, $b1d6d16f69302f9e$export$e71e58537b2e6660), (0, $df06be8448ff4f3c$export$83503616c7a463e3));
    return $7fPBF.createElement(e ? (0, $089057084dfb92a4$export$8c6ed5c666ac1360) : m, {
        ...a,
        ref: s,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-Box", t)
    });
});
$70d14e4633845b98$export$e71c4d32a2263218.displayName = "Box";



var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");






const $2f23395b076ad3bd$var$t = [
    "1",
    "2",
    "3",
    "4"
], $2f23395b076ad3bd$var$a = [
    "classic",
    "solid",
    "soft",
    "surface",
    "outline",
    "ghost"
], $2f23395b076ad3bd$export$cd7555e680e5ab9b = {
    ...(0, $b302dbddfdac9d75$export$1e7c0b54c65e0280),
    size: {
        type: "enum",
        className: "rt-r-size",
        values: $2f23395b076ad3bd$var$t,
        default: "2",
        responsive: !0
    },
    variant: {
        type: "enum",
        className: "rt-variant",
        values: $2f23395b076ad3bd$var$a,
        default: "solid"
    },
    ...(0, $e914ebf2ce406d8c$export$d0261b42be231f92),
    ...(0, $f41c61290c2a7125$export$2f84412d299def33),
    ...(0, $3d20a83f81464c0a$export$c467f6769b59b70c),
    loading: {
        type: "boolean",
        className: "rt-loading",
        default: !1
    }
};



var $7fPBF = parcelRequire("7fPBF");






const $c41c3de109a79969$var$e = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9"
], $c41c3de109a79969$export$9422eeaa89c788b = {
    gap: {
        type: "enum | string",
        className: "rt-r-gap",
        customProperties: [
            "--gap"
        ],
        values: $c41c3de109a79969$var$e,
        responsive: !0
    },
    gapX: {
        type: "enum | string",
        className: "rt-r-cg",
        customProperties: [
            "--column-gap"
        ],
        values: $c41c3de109a79969$var$e,
        responsive: !0
    },
    gapY: {
        type: "enum | string",
        className: "rt-r-rg",
        customProperties: [
            "--row-gap"
        ],
        values: $c41c3de109a79969$var$e,
        responsive: !0
    }
};


const $c1eba8fbe9fc8173$var$t = [
    "div",
    "span"
], $c1eba8fbe9fc8173$var$p = [
    "none",
    "inline-flex",
    "flex"
], $c1eba8fbe9fc8173$var$a = [
    "row",
    "column",
    "row-reverse",
    "column-reverse"
], $c1eba8fbe9fc8173$var$o = [
    "start",
    "center",
    "end",
    "baseline",
    "stretch"
], $c1eba8fbe9fc8173$var$n = [
    "start",
    "center",
    "end",
    "between"
], $c1eba8fbe9fc8173$var$l = [
    "nowrap",
    "wrap",
    "wrap-reverse"
], $c1eba8fbe9fc8173$export$472ad07285607ea8 = {
    as: {
        type: "enum",
        values: $c1eba8fbe9fc8173$var$t,
        default: "div"
    },
    ...(0, $b302dbddfdac9d75$export$1e7c0b54c65e0280),
    display: {
        type: "enum",
        className: "rt-r-display",
        values: $c1eba8fbe9fc8173$var$p,
        responsive: !0
    },
    direction: {
        type: "enum",
        className: "rt-r-fd",
        values: $c1eba8fbe9fc8173$var$a,
        responsive: !0
    },
    align: {
        type: "enum",
        className: "rt-r-ai",
        values: $c1eba8fbe9fc8173$var$o,
        responsive: !0
    },
    justify: {
        type: "enum",
        className: "rt-r-jc",
        values: $c1eba8fbe9fc8173$var$n,
        parseValue: $c1eba8fbe9fc8173$var$f,
        responsive: !0
    },
    wrap: {
        type: "enum",
        className: "rt-r-fw",
        values: $c1eba8fbe9fc8173$var$l,
        responsive: !0
    },
    ...(0, $c41c3de109a79969$export$9422eeaa89c788b)
};
function $c1eba8fbe9fc8173$var$f(e) {
    return e === "between" ? "space-between" : e;
}


const $95341668bcbb7769$export$f51f4c4ede09e011 = $7fPBF.forwardRef((r, e)=>{
    const { className: s, asChild: t, as: m = "div", ...l } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(r, (0, $c1eba8fbe9fc8173$export$472ad07285607ea8), (0, $b1d6d16f69302f9e$export$e71e58537b2e6660), (0, $df06be8448ff4f3c$export$83503616c7a463e3));
    return $7fPBF.createElement(t ? (0, $089057084dfb92a4$export$8c6ed5c666ac1360) : m, {
        ...l,
        ref: e,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-Flex", s)
    });
});
$95341668bcbb7769$export$f51f4c4ede09e011.displayName = "Flex";



var $7fPBF = parcelRequire("7fPBF");


const $59b94feaf66a795e$var$e = [
    "1",
    "2",
    "3"
], $59b94feaf66a795e$export$3d23f5a65266d073 = {
    size: {
        type: "enum",
        className: "rt-r-size",
        values: $59b94feaf66a795e$var$e,
        default: "2",
        responsive: !0
    },
    loading: {
        type: "boolean",
        default: !0
    }
};



var $7fPBF = parcelRequire("7fPBF");
const $18c8d007fcd48c4d$export$2780f85aa8ed0db8 = parseFloat($7fPBF.version) >= 19 || "";




const $62ca5e79378cd184$export$7f7cbe89f1eacd2 = $7fPBF.forwardRef((i, o)=>{
    const { className: a, children: e, loading: t, ...m } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(i, (0, $59b94feaf66a795e$export$3d23f5a65266d073), (0, $df06be8448ff4f3c$export$83503616c7a463e3));
    if (!t) return e;
    const r = $7fPBF.createElement("span", {
        ...m,
        ref: o,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-Spinner", a)
    }, $7fPBF.createElement("span", {
        className: "rt-SpinnerLeaf"
    }), $7fPBF.createElement("span", {
        className: "rt-SpinnerLeaf"
    }), $7fPBF.createElement("span", {
        className: "rt-SpinnerLeaf"
    }), $7fPBF.createElement("span", {
        className: "rt-SpinnerLeaf"
    }), $7fPBF.createElement("span", {
        className: "rt-SpinnerLeaf"
    }), $7fPBF.createElement("span", {
        className: "rt-SpinnerLeaf"
    }), $7fPBF.createElement("span", {
        className: "rt-SpinnerLeaf"
    }), $7fPBF.createElement("span", {
        className: "rt-SpinnerLeaf"
    }));
    return e === void 0 ? r : $7fPBF.createElement((0, $95341668bcbb7769$export$f51f4c4ede09e011), {
        asChild: !0,
        position: "relative",
        align: "center",
        justify: "center"
    }, $7fPBF.createElement("span", null, $7fPBF.createElement("span", {
        "aria-hidden": !0,
        style: {
            display: "contents",
            visibility: "hidden"
        },
        inert: void 0
    }, e), $7fPBF.createElement((0, $95341668bcbb7769$export$f51f4c4ede09e011), {
        asChild: !0,
        align: "center",
        justify: "center",
        position: "absolute",
        inset: "0"
    }, $7fPBF.createElement("span", null, r))));
});
$62ca5e79378cd184$export$7f7cbe89f1eacd2.displayName = "Spinner";










const $d865a7859985655f$var$t = [
    "1",
    "2",
    "3"
], $d865a7859985655f$var$r = [
    "soft",
    "surface",
    "outline"
], $d865a7859985655f$export$753b26683bfdc1bf = {
    ...(0, $b302dbddfdac9d75$export$1e7c0b54c65e0280),
    size: {
        type: "enum",
        className: "rt-r-size",
        values: $d865a7859985655f$var$t,
        default: "2",
        responsive: !0
    },
    variant: {
        type: "enum",
        className: "rt-variant",
        values: $d865a7859985655f$var$r,
        default: "soft"
    },
    ...(0, $e914ebf2ce406d8c$export$d0261b42be231f92),
    ...(0, $f41c61290c2a7125$export$2f84412d299def33)
};




function $355b46622a2c20aa$export$47ddd1fd55f68a50(e, t) {
    if (e !== void 0) return typeof e == "string" ? t(e) : Object.fromEntries(Object.entries(e).map(([n, r])=>[
            n,
            t(r)
        ]));
}
function $355b46622a2c20aa$export$188d5db9225086ca(e) {
    return e === "3" ? "3" : "2";
}
function $355b46622a2c20aa$export$1bf96581e53c8050(e) {
    switch(e){
        case "1":
            return "1";
        case "2":
        case "3":
            return "2";
        case "4":
            return "3";
    }
}



const $c2c644e421d61486$export$e30f1d91ae9a4bf9 = $7fPBF.forwardRef((t, p)=>{
    const { size: i = (0, $2f23395b076ad3bd$export$cd7555e680e5ab9b).size.default } = t, { className: a, children: e, asChild: m, color: d, radius: l, disabled: s = t.loading, ...u } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(t, (0, $2f23395b076ad3bd$export$cd7555e680e5ab9b), (0, $df06be8448ff4f3c$export$83503616c7a463e3));
    return $7fPBF.createElement(m ? (0, $089057084dfb92a4$export$8c6ed5c666ac1360) : "button", {
        "data-disabled": s || void 0,
        "data-accent-color": d,
        "data-radius": l,
        ...u,
        ref: p,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-reset", "rt-BaseButton", a),
        disabled: s
    }, t.loading ? $7fPBF.createElement($7fPBF.Fragment, null, $7fPBF.createElement("span", {
        style: {
            display: "contents",
            visibility: "hidden"
        },
        "aria-hidden": !0
    }, e), $7fPBF.createElement((0, $28c8fa82e4cfdc1a$export$439d29a4e110a164), null, e), $7fPBF.createElement((0, $95341668bcbb7769$export$f51f4c4ede09e011), {
        asChild: !0,
        align: "center",
        justify: "center",
        position: "absolute",
        inset: "0"
    }, $7fPBF.createElement("span", null, $7fPBF.createElement((0, $62ca5e79378cd184$export$7f7cbe89f1eacd2), {
        size: (0, $355b46622a2c20aa$export$47ddd1fd55f68a50)(i, (0, $355b46622a2c20aa$export$1bf96581e53c8050))
    })))) : e);
});
$c2c644e421d61486$export$e30f1d91ae9a4bf9.displayName = "BaseButton";


const $d934301c5a05c9c5$export$353f5b6fc5456de1 = $7fPBF.forwardRef(({ className: e, ...n }, r)=>$7fPBF.createElement((0, $c2c644e421d61486$export$e30f1d91ae9a4bf9), {
        ...n,
        ref: r,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-Button", e)
    }));
$d934301c5a05c9c5$export$353f5b6fc5456de1.displayName = "Button";



var $7fPBF = parcelRequire("7fPBF");







"use client";
const $c1bc73d23bbf663a$var$a = $7fPBF.createContext({}), $c1bc73d23bbf663a$export$be92b6f5f03c0fe9 = $7fPBF.forwardRef((t, l)=>{
    const { size: e = (0, $d865a7859985655f$export$753b26683bfdc1bf).size.default } = t, { asChild: r, children: u, className: i, color: c, ...f } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(t, (0, $d865a7859985655f$export$753b26683bfdc1bf), (0, $df06be8448ff4f3c$export$83503616c7a463e3));
    return $7fPBF.createElement(r ? (0, $089057084dfb92a4$export$8c6ed5c666ac1360) : "div", {
        "data-accent-color": c,
        ...f,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-CalloutRoot", i),
        ref: l
    }, $7fPBF.createElement($c1bc73d23bbf663a$var$a.Provider, {
        value: $7fPBF.useMemo(()=>({
                size: e
            }), [
            e
        ])
    }, u));
});
$c1bc73d23bbf663a$export$be92b6f5f03c0fe9.displayName = "Callout.Root";
const $c1bc73d23bbf663a$export$f04a61298a47a40f = $7fPBF.forwardRef(({ className: t, ...l }, e)=>$7fPBF.createElement("div", {
        ...l,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-CalloutIcon", t),
        ref: e
    }));
$c1bc73d23bbf663a$export$f04a61298a47a40f.displayName = "Callout.Icon";
const $c1bc73d23bbf663a$export$5f1af8db9871e1d6 = $7fPBF.forwardRef(({ className: t, ...l }, e)=>{
    const { size: r } = $7fPBF.useContext($c1bc73d23bbf663a$var$a);
    return $7fPBF.createElement((0, $83db9e82a643d7a4$export$5f1af8db9871e1d6), {
        as: "p",
        size: (0, $355b46622a2c20aa$export$47ddd1fd55f68a50)(r, (0, $355b46622a2c20aa$export$188d5db9225086ca)),
        ...l,
        asChild: !1,
        ref: e,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-CalloutText", t)
    });
});
$c1bc73d23bbf663a$export$5f1af8db9871e1d6.displayName = "Callout.Text";



var $7fPBF = parcelRequire("7fPBF");



const $011cc5699245fa3a$var$e = [
    "1",
    "2",
    "3",
    "4",
    "5"
], $011cc5699245fa3a$var$r = [
    "surface",
    "classic",
    "ghost"
], $011cc5699245fa3a$export$f9c0de09109cd53 = {
    ...(0, $b302dbddfdac9d75$export$1e7c0b54c65e0280),
    size: {
        type: "enum",
        className: "rt-r-size",
        values: $011cc5699245fa3a$var$e,
        default: "1",
        responsive: !0
    },
    variant: {
        type: "enum",
        className: "rt-variant",
        values: $011cc5699245fa3a$var$r,
        default: "surface"
    }
};




const $bee696b036d759c9$export$60332b2344f7fe41 = $7fPBF.forwardRef((p, e)=>{
    const { asChild: t, className: s, ...m } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(p, (0, $011cc5699245fa3a$export$f9c0de09109cd53), (0, $df06be8448ff4f3c$export$83503616c7a463e3));
    return $7fPBF.createElement(t ? (0, $089057084dfb92a4$export$8c6ed5c666ac1360) : "div", {
        ref: e,
        ...m,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-reset", "rt-BaseCard", "rt-Card", s)
    });
});
$bee696b036d759c9$export$60332b2344f7fe41.displayName = "Card";



var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");




// packages/react/use-previous/src/usePrevious.tsx

var $7fPBF = parcelRequire("7fPBF");
function $62f6e650b37fb598$export$5cae361ad82dce8b(value) {
    const ref = $7fPBF.useRef({
        value: value,
        previous: value
    });
    return $7fPBF.useMemo(()=>{
        if (ref.current.value !== value) {
            ref.current.previous = ref.current.value;
            ref.current.value = value;
        }
        return ref.current.previous;
    }, [
        value
    ]);
}






"use client";
var $02d43fb88a8d607d$var$CHECKBOX_NAME = "Checkbox";
var [$02d43fb88a8d607d$var$createCheckboxContext, $02d43fb88a8d607d$export$b566c4ff5488ea01] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)($02d43fb88a8d607d$var$CHECKBOX_NAME);
var [$02d43fb88a8d607d$var$CheckboxProvider, $02d43fb88a8d607d$var$useCheckboxContext] = $02d43fb88a8d607d$var$createCheckboxContext($02d43fb88a8d607d$var$CHECKBOX_NAME);
var $02d43fb88a8d607d$export$48513f6b9f8ce62d = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeCheckbox: __scopeCheckbox, name: name, checked: checkedProp, defaultChecked: defaultChecked, required: required, disabled: disabled, value: value = "on", onCheckedChange: onCheckedChange, ...checkboxProps } = props;
    const [button, setButton] = $7fPBF.useState(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setButton(node));
    const hasConsumerStoppedPropagationRef = $7fPBF.useRef(false);
    const isFormControl = button ? Boolean(button.closest("form")) : true;
    const [checked = false, setChecked] = (0, $915387e6ab4d88b1$export$6f32135080cb4c3)({
        prop: checkedProp,
        defaultProp: defaultChecked,
        onChange: onCheckedChange
    });
    const initialCheckedStateRef = $7fPBF.useRef(checked);
    $7fPBF.useEffect(()=>{
        const form = button === null || button === void 0 ? void 0 : button.form;
        if (form) {
            const reset = ()=>setChecked(initialCheckedStateRef.current);
            form.addEventListener("reset", reset);
            return ()=>form.removeEventListener("reset", reset);
        }
    }, [
        button,
        setChecked
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)($02d43fb88a8d607d$var$CheckboxProvider, {
        scope: __scopeCheckbox,
        state: checked,
        disabled: disabled,
        children: [
            /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).button, {
                type: "button",
                role: "checkbox",
                "aria-checked": $02d43fb88a8d607d$var$isIndeterminate(checked) ? "mixed" : checked,
                "aria-required": required,
                "data-state": $02d43fb88a8d607d$var$getState(checked),
                "data-disabled": disabled ? "" : void 0,
                disabled: disabled,
                value: value,
                ...checkboxProps,
                ref: composedRefs,
                onKeyDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                    if (event.key === "Enter") event.preventDefault();
                }),
                onClick: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onClick, (event)=>{
                    setChecked((prevChecked)=>$02d43fb88a8d607d$var$isIndeterminate(prevChecked) ? true : !prevChecked);
                    if (isFormControl) {
                        hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
                        if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
                    }
                })
            }),
            isFormControl && /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($02d43fb88a8d607d$var$BubbleInput, {
                control: button,
                bubbles: !hasConsumerStoppedPropagationRef.current,
                name: name,
                value: value,
                checked: checked,
                required: required,
                disabled: disabled,
                style: {
                    transform: "translateX(-100%)"
                }
            })
        ]
    });
});
$02d43fb88a8d607d$export$48513f6b9f8ce62d.displayName = $02d43fb88a8d607d$var$CHECKBOX_NAME;
var $02d43fb88a8d607d$var$INDICATOR_NAME = "CheckboxIndicator";
var $02d43fb88a8d607d$export$59aad738f51d1c05 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeCheckbox: __scopeCheckbox, forceMount: forceMount, ...indicatorProps } = props;
    const context = $02d43fb88a8d607d$var$useCheckboxContext($02d43fb88a8d607d$var$INDICATOR_NAME, __scopeCheckbox);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $e9ce08b8e6e14786$export$99c2b779aa4e8b8b), {
        present: forceMount || $02d43fb88a8d607d$var$isIndeterminate(context.state) || context.state === true,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).span, {
            "data-state": $02d43fb88a8d607d$var$getState(context.state),
            "data-disabled": context.disabled ? "" : void 0,
            ...indicatorProps,
            ref: forwardedRef,
            style: {
                pointerEvents: "none",
                ...props.style
            }
        })
    });
});
$02d43fb88a8d607d$export$59aad738f51d1c05.displayName = $02d43fb88a8d607d$var$INDICATOR_NAME;
var $02d43fb88a8d607d$var$BubbleInput = (props)=>{
    const { control: control, checked: checked, bubbles: bubbles = true, ...inputProps } = props;
    const ref = $7fPBF.useRef(null);
    const prevChecked = (0, $62f6e650b37fb598$export$5cae361ad82dce8b)(checked);
    const controlSize = (0, $0560b0618278acc0$export$1ab7ae714698c4b8)(control);
    $7fPBF.useEffect(()=>{
        const input = ref.current;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
        const setChecked = descriptor.set;
        if (prevChecked !== checked && setChecked) {
            const event = new Event("click", {
                bubbles: bubbles
            });
            input.indeterminate = $02d43fb88a8d607d$var$isIndeterminate(checked);
            setChecked.call(input, $02d43fb88a8d607d$var$isIndeterminate(checked) ? false : checked);
            input.dispatchEvent(event);
        }
    }, [
        prevChecked,
        checked,
        bubbles
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("input", {
        type: "checkbox",
        "aria-hidden": true,
        defaultChecked: $02d43fb88a8d607d$var$isIndeterminate(checked) ? false : checked,
        ...inputProps,
        tabIndex: -1,
        ref: ref,
        style: {
            ...props.style,
            ...controlSize,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0
        }
    });
};
function $02d43fb88a8d607d$var$isIndeterminate(checked) {
    return checked === "indeterminate";
}
function $02d43fb88a8d607d$var$getState(checked) {
    return $02d43fb88a8d607d$var$isIndeterminate(checked) ? "indeterminate" : checked ? "checked" : "unchecked";
}
var $02d43fb88a8d607d$export$be92b6f5f03c0fe9 = $02d43fb88a8d607d$export$48513f6b9f8ce62d;
var $02d43fb88a8d607d$export$adb584737d712b70 = $02d43fb88a8d607d$export$59aad738f51d1c05;






var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");




"use client";
function $08a94ba50b5cc249$export$c74125a8e3af6bb2(name) {
    const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: /* @__PURE__ */ new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope, children: children } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(null);
        const itemMap = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(/* @__PURE__ */ new Map()).current;
        return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref,
            children: children
        });
    };
    CollectionProvider.displayName = PROVIDER_NAME;
    const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlot = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $089057084dfb92a4$export$8c6ed5c666ac1360), {
            ref: composedRefs,
            children: children
        });
    });
    CollectionSlot.displayName = COLLECTION_SLOT_NAME;
    const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlot = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(null);
        const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $089057084dfb92a4$export$8c6ed5c666ac1360), {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs,
            children: children
        });
    });
    CollectionItemSlot.displayName = ITEM_SLOT_NAME;
    function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}










"use client";
var $8183e11ba1e9b7dc$var$ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
var $8183e11ba1e9b7dc$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $8183e11ba1e9b7dc$var$GROUP_NAME = "RovingFocusGroup";
var [$8183e11ba1e9b7dc$var$Collection, $8183e11ba1e9b7dc$var$useCollection, $8183e11ba1e9b7dc$var$createCollectionScope] = (0, $08a94ba50b5cc249$export$c74125a8e3af6bb2)($8183e11ba1e9b7dc$var$GROUP_NAME);
var [$8183e11ba1e9b7dc$var$createRovingFocusGroupContext, $8183e11ba1e9b7dc$export$c7109489551a4f4] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)($8183e11ba1e9b7dc$var$GROUP_NAME, [
    $8183e11ba1e9b7dc$var$createCollectionScope
]);
var [$8183e11ba1e9b7dc$var$RovingFocusProvider, $8183e11ba1e9b7dc$var$useRovingFocusContext] = $8183e11ba1e9b7dc$var$createRovingFocusGroupContext($8183e11ba1e9b7dc$var$GROUP_NAME);
var $8183e11ba1e9b7dc$export$8699f7c8af148338 = $7fPBF.forwardRef((props, forwardedRef)=>{
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($8183e11ba1e9b7dc$var$Collection.Provider, {
        scope: props.__scopeRovingFocusGroup,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($8183e11ba1e9b7dc$var$Collection.Slot, {
            scope: props.__scopeRovingFocusGroup,
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($8183e11ba1e9b7dc$var$RovingFocusGroupImpl, {
                ...props,
                ref: forwardedRef
            })
        })
    });
});
$8183e11ba1e9b7dc$export$8699f7c8af148338.displayName = $8183e11ba1e9b7dc$var$GROUP_NAME;
var $8183e11ba1e9b7dc$var$RovingFocusGroupImpl = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, orientation: orientation, loop: loop = false, dir: dir, currentTabStopId: currentTabStopIdProp, defaultCurrentTabStopId: defaultCurrentTabStopId, onCurrentTabStopIdChange: onCurrentTabStopIdChange, onEntryFocus: onEntryFocus, preventScrollOnEntryFocus: preventScrollOnEntryFocus = false, ...groupProps } = props;
    const ref = $7fPBF.useRef(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const direction = (0, $3342477e04611d10$export$b39126d51d94e6f3)(dir);
    const [currentTabStopId = null, setCurrentTabStopId] = (0, $915387e6ab4d88b1$export$6f32135080cb4c3)({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId,
        onChange: onCurrentTabStopIdChange
    });
    const [isTabbingBackOut, setIsTabbingBackOut] = $7fPBF.useState(false);
    const handleEntryFocus = (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(onEntryFocus);
    const getItems = $8183e11ba1e9b7dc$var$useCollection(__scopeRovingFocusGroup);
    const isClickFocusRef = $7fPBF.useRef(false);
    const [focusableItemsCount, setFocusableItemsCount] = $7fPBF.useState(0);
    $7fPBF.useEffect(()=>{
        const node = ref.current;
        if (node) {
            node.addEventListener($8183e11ba1e9b7dc$var$ENTRY_FOCUS, handleEntryFocus);
            return ()=>node.removeEventListener($8183e11ba1e9b7dc$var$ENTRY_FOCUS, handleEntryFocus);
        }
    }, [
        handleEntryFocus
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($8183e11ba1e9b7dc$var$RovingFocusProvider, {
        scope: __scopeRovingFocusGroup,
        orientation: orientation,
        dir: direction,
        loop: loop,
        currentTabStopId: currentTabStopId,
        onItemFocus: $7fPBF.useCallback((tabStopId)=>setCurrentTabStopId(tabStopId), [
            setCurrentTabStopId
        ]),
        onItemShiftTab: $7fPBF.useCallback(()=>setIsTabbingBackOut(true), []),
        onFocusableItemAdd: $7fPBF.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount + 1), []),
        onFocusableItemRemove: $7fPBF.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount - 1), []),
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
            tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
            "data-orientation": orientation,
            ...groupProps,
            ref: composedRefs,
            style: {
                outline: "none",
                ...props.style
            },
            onMouseDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onMouseDown, ()=>{
                isClickFocusRef.current = true;
            }),
            onFocus: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onFocus, (event)=>{
                const isKeyboardFocus = !isClickFocusRef.current;
                if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                    const entryFocusEvent = new CustomEvent($8183e11ba1e9b7dc$var$ENTRY_FOCUS, $8183e11ba1e9b7dc$var$EVENT_OPTIONS);
                    event.currentTarget.dispatchEvent(entryFocusEvent);
                    if (!entryFocusEvent.defaultPrevented) {
                        const items = getItems().filter((item)=>item.focusable);
                        const activeItem = items.find((item)=>item.active);
                        const currentItem = items.find((item)=>item.id === currentTabStopId);
                        const candidateItems = [
                            activeItem,
                            currentItem,
                            ...items
                        ].filter(Boolean);
                        const candidateNodes = candidateItems.map((item)=>item.ref.current);
                        $8183e11ba1e9b7dc$var$focusFirst(candidateNodes, preventScrollOnEntryFocus);
                    }
                }
                isClickFocusRef.current = false;
            }),
            onBlur: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onBlur, ()=>setIsTabbingBackOut(false))
        })
    });
});
var $8183e11ba1e9b7dc$var$ITEM_NAME = "RovingFocusGroupItem";
var $8183e11ba1e9b7dc$export$ab9df7c53fe8454 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, focusable: focusable = true, active: active = false, tabStopId: tabStopId, ...itemProps } = props;
    const autoId = (0, $8a8e9b94c33ba6d6$export$f680877a34711e37)();
    const id = tabStopId || autoId;
    const context = $8183e11ba1e9b7dc$var$useRovingFocusContext($8183e11ba1e9b7dc$var$ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = $8183e11ba1e9b7dc$var$useCollection(__scopeRovingFocusGroup);
    const { onFocusableItemAdd: onFocusableItemAdd, onFocusableItemRemove: onFocusableItemRemove } = context;
    $7fPBF.useEffect(()=>{
        if (focusable) {
            onFocusableItemAdd();
            return ()=>onFocusableItemRemove();
        }
    }, [
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($8183e11ba1e9b7dc$var$Collection.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id: id,
        focusable: focusable,
        active: active,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).span, {
            tabIndex: isCurrentTabStop ? 0 : -1,
            "data-orientation": context.orientation,
            ...itemProps,
            ref: forwardedRef,
            onMouseDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onMouseDown, (event)=>{
                if (!focusable) event.preventDefault();
                else context.onItemFocus(id);
            }),
            onFocus: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onFocus, ()=>context.onItemFocus(id)),
            onKeyDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                if (event.key === "Tab" && event.shiftKey) {
                    context.onItemShiftTab();
                    return;
                }
                if (event.target !== event.currentTarget) return;
                const focusIntent = $8183e11ba1e9b7dc$var$getFocusIntent(event, context.orientation, context.dir);
                if (focusIntent !== void 0) {
                    if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
                    event.preventDefault();
                    const items = getItems().filter((item)=>item.focusable);
                    let candidateNodes = items.map((item)=>item.ref.current);
                    if (focusIntent === "last") candidateNodes.reverse();
                    else if (focusIntent === "prev" || focusIntent === "next") {
                        if (focusIntent === "prev") candidateNodes.reverse();
                        const currentIndex = candidateNodes.indexOf(event.currentTarget);
                        candidateNodes = context.loop ? $8183e11ba1e9b7dc$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                    }
                    setTimeout(()=>$8183e11ba1e9b7dc$var$focusFirst(candidateNodes));
                }
            })
        })
    });
});
$8183e11ba1e9b7dc$export$ab9df7c53fe8454.displayName = $8183e11ba1e9b7dc$var$ITEM_NAME;
var $8183e11ba1e9b7dc$var$MAP_KEY_TO_FOCUS_INTENT = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
};
function $8183e11ba1e9b7dc$var$getDirectionAwareKey(key, dir) {
    if (dir !== "rtl") return key;
    return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
function $8183e11ba1e9b7dc$var$getFocusIntent(event, orientation, dir) {
    const key = $8183e11ba1e9b7dc$var$getDirectionAwareKey(event.key, dir);
    if (orientation === "vertical" && [
        "ArrowLeft",
        "ArrowRight"
    ].includes(key)) return void 0;
    if (orientation === "horizontal" && [
        "ArrowUp",
        "ArrowDown"
    ].includes(key)) return void 0;
    return $8183e11ba1e9b7dc$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
function $8183e11ba1e9b7dc$var$focusFirst(candidates, preventScroll = false) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus({
            preventScroll: preventScroll
        });
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
function $8183e11ba1e9b7dc$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
var $8183e11ba1e9b7dc$export$be92b6f5f03c0fe9 = $8183e11ba1e9b7dc$export$8699f7c8af148338;
var $8183e11ba1e9b7dc$export$6d08773d2e66f8f2 = $8183e11ba1e9b7dc$export$ab9df7c53fe8454;




"use client";
const $a562f34061d8ab10$var$k = "CheckboxGroup", [$a562f34061d8ab10$var$O, $a562f34061d8ab10$export$19e38fc04063f12] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)($a562f34061d8ab10$var$k, [
    (0, $8183e11ba1e9b7dc$export$c7109489551a4f4),
    (0, $02d43fb88a8d607d$export$b566c4ff5488ea01)
]), $a562f34061d8ab10$var$y = (0, $8183e11ba1e9b7dc$export$c7109489551a4f4)(), $a562f34061d8ab10$var$S = (0, $02d43fb88a8d607d$export$b566c4ff5488ea01)(), [$a562f34061d8ab10$var$T, $a562f34061d8ab10$var$B] = $a562f34061d8ab10$var$O($a562f34061d8ab10$var$k), $a562f34061d8ab10$export$4aa08d5625cb8ead = $7fPBF.forwardRef((r, i)=>{
    const { __scopeCheckboxGroup: e, name: p, defaultValue: c, value: t, required: n = !1, disabled: s = !1, orientation: d, dir: m, loop: C = !0, onValueChange: u, ...h } = r, F = $a562f34061d8ab10$var$y(e), v = (0, $3342477e04611d10$export$b39126d51d94e6f3)(m), [_ = [], a] = (0, $915387e6ab4d88b1$export$6f32135080cb4c3)({
        prop: t,
        defaultProp: c,
        onChange: u
    }), V = $7fPBF.useCallback((l)=>a((b = [])=>[
                ...b,
                l
            ]), [
        a
    ]), q = $7fPBF.useCallback((l)=>a((b = [])=>b.filter((N)=>N !== l)), [
        a
    ]);
    return $7fPBF.createElement($a562f34061d8ab10$var$T, {
        scope: e,
        name: p,
        required: n,
        disabled: s,
        value: _,
        onItemCheck: V,
        onItemUncheck: q
    }, $7fPBF.createElement($8183e11ba1e9b7dc$export$be92b6f5f03c0fe9, {
        asChild: !0,
        ...F,
        orientation: d,
        dir: v,
        loop: C
    }, $7fPBF.createElement((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
        role: "group",
        "data-disabled": s ? "" : void 0,
        dir: v,
        ...h,
        ref: i
    })));
});
$a562f34061d8ab10$export$4aa08d5625cb8ead.displayName = $a562f34061d8ab10$var$k;
const $a562f34061d8ab10$var$E = "CheckboxGroupItem", $a562f34061d8ab10$export$2d7cbf022af9788a = $7fPBF.forwardRef((r, i)=>{
    var _t_value;
    const { __scopeCheckboxGroup: e, disabled: p, ...c } = r, t = $a562f34061d8ab10$var$B($a562f34061d8ab10$var$E, e), n = t.disabled || p, s = $a562f34061d8ab10$var$y(e), d = $a562f34061d8ab10$var$S(e), m = $7fPBF.useRef(null), C = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(i, m), u = (_t_value = t.value) === null || _t_value === void 0 ? void 0 : _t_value.includes(c.value);
    return $7fPBF.createElement($8183e11ba1e9b7dc$export$6d08773d2e66f8f2, {
        asChild: !0,
        ...s,
        focusable: !n,
        active: u
    }, $7fPBF.createElement($02d43fb88a8d607d$export$be92b6f5f03c0fe9, {
        name: t.name,
        disabled: n,
        required: t.required,
        checked: u,
        ...d,
        ...c,
        ref: C,
        onCheckedChange: (h)=>{
            h ? t.onItemCheck(r.value) : t.onItemUncheck(r.value);
        }
    }));
});
$a562f34061d8ab10$export$2d7cbf022af9788a.displayName = $a562f34061d8ab10$var$E;
const $a562f34061d8ab10$var$H = "CheckboxGroupIndicator", $a562f34061d8ab10$export$6dafd3912320edec = $7fPBF.forwardRef((r, i)=>{
    const { __scopeCheckboxGroup: e, ...p } = r, c = $a562f34061d8ab10$var$S(e);
    return $7fPBF.createElement($02d43fb88a8d607d$export$adb584737d712b70, {
        ...c,
        ...p,
        ref: i
    });
});
$a562f34061d8ab10$export$6dafd3912320edec.displayName = $a562f34061d8ab10$var$H;
const $a562f34061d8ab10$export$be92b6f5f03c0fe9 = $a562f34061d8ab10$export$4aa08d5625cb8ead, $a562f34061d8ab10$export$6d08773d2e66f8f2 = $a562f34061d8ab10$export$2d7cbf022af9788a, $a562f34061d8ab10$export$adb584737d712b70 = $a562f34061d8ab10$export$6dafd3912320edec;







const $9b4d70d1960910a3$var$a = [
    "div",
    "span"
], $9b4d70d1960910a3$var$n = [
    "none",
    "inline-grid",
    "grid"
], $9b4d70d1960910a3$var$p = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9"
], $9b4d70d1960910a3$var$u = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9"
], $9b4d70d1960910a3$var$i = [
    "row",
    "column",
    "dense",
    "row-dense",
    "column-dense"
], $9b4d70d1960910a3$var$l = [
    "start",
    "center",
    "end",
    "baseline",
    "stretch"
], $9b4d70d1960910a3$var$f = [
    "start",
    "center",
    "end",
    "between"
], $9b4d70d1960910a3$export$b3262d61b3123b38 = {
    as: {
        type: "enum",
        values: $9b4d70d1960910a3$var$a,
        default: "div"
    },
    ...(0, $b302dbddfdac9d75$export$1e7c0b54c65e0280),
    display: {
        type: "enum",
        className: "rt-r-display",
        values: $9b4d70d1960910a3$var$n,
        responsive: !0
    },
    areas: {
        type: "string",
        className: "rt-r-gta",
        customProperties: [
            "--grid-template-areas"
        ],
        responsive: !0
    },
    columns: {
        type: "enum | string",
        className: "rt-r-gtc",
        customProperties: [
            "--grid-template-columns"
        ],
        values: $9b4d70d1960910a3$var$p,
        parseValue: $9b4d70d1960910a3$var$r,
        responsive: !0
    },
    rows: {
        type: "enum | string",
        className: "rt-r-gtr",
        customProperties: [
            "--grid-template-rows"
        ],
        values: $9b4d70d1960910a3$var$u,
        parseValue: $9b4d70d1960910a3$var$r,
        responsive: !0
    },
    flow: {
        type: "enum",
        className: "rt-r-gaf",
        values: $9b4d70d1960910a3$var$i,
        responsive: !0
    },
    align: {
        type: "enum",
        className: "rt-r-ai",
        values: $9b4d70d1960910a3$var$l,
        responsive: !0
    },
    justify: {
        type: "enum",
        className: "rt-r-jc",
        values: $9b4d70d1960910a3$var$f,
        parseValue: $9b4d70d1960910a3$var$m,
        responsive: !0
    },
    ...(0, $c41c3de109a79969$export$9422eeaa89c788b)
};
function $9b4d70d1960910a3$var$r(e) {
    return $9b4d70d1960910a3$export$b3262d61b3123b38.columns.values.includes(e) ? e : (e === null || e === void 0 ? void 0 : e.match(/^\d+$/)) ? `repeat(${e}, minmax(0, 1fr))` : e;
}
function $9b4d70d1960910a3$var$m(e) {
    return e === "between" ? "space-between" : e;
}


const $fe9514ee2d5263f2$var$a = [
    "1",
    "2",
    "3"
], $fe9514ee2d5263f2$var$t = [
    "surface",
    "classic"
], $fe9514ee2d5263f2$export$328214b63232fea9 = {
    ...(0, $b302dbddfdac9d75$export$1e7c0b54c65e0280),
    size: {
        type: "enum",
        className: "rt-r-size",
        values: $fe9514ee2d5263f2$var$a,
        default: "2",
        responsive: !0
    },
    variant: {
        type: "enum",
        className: "rt-variant",
        values: $fe9514ee2d5263f2$var$t,
        default: "surface"
    },
    ...(0, $e914ebf2ce406d8c$export$8255b018f448be13),
    ...(0, $f41c61290c2a7125$export$2f84412d299def33),
    columns: {
        ...(0, $9b4d70d1960910a3$export$b3262d61b3123b38).columns,
        default: "repeat(auto-fit, minmax(200px, 1fr))"
    },
    gap: {
        ...(0, $9b4d70d1960910a3$export$b3262d61b3123b38).gap,
        default: "4"
    }
};




const $63f7884c474c8198$var$r = [
    "1",
    "2",
    "3"
], $63f7884c474c8198$var$o = [
    "classic",
    "surface",
    "soft"
], $63f7884c474c8198$export$dfc7ebaec798447d = {
    size: {
        type: "enum",
        className: "rt-r-size",
        values: $63f7884c474c8198$var$r,
        default: "2",
        responsive: !0
    },
    variant: {
        type: "enum",
        className: "rt-variant",
        values: $63f7884c474c8198$var$o,
        default: "surface"
    },
    ...(0, $e914ebf2ce406d8c$export$8255b018f448be13),
    ...(0, $f41c61290c2a7125$export$2f84412d299def33)
};



var $7fPBF = parcelRequire("7fPBF");






const $1186128e999eac49$export$ef2184bd89960b14 = $7fPBF.forwardRef((p, s)=>{
    const { className: t, asChild: e, as: i = "div", ...m } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(p, (0, $9b4d70d1960910a3$export$b3262d61b3123b38), (0, $b1d6d16f69302f9e$export$e71e58537b2e6660), (0, $df06be8448ff4f3c$export$83503616c7a463e3));
    return $7fPBF.createElement(e ? (0, $089057084dfb92a4$export$8c6ed5c666ac1360) : i, {
        ...m,
        ref: s,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-Grid", t)
    });
});
$1186128e999eac49$export$ef2184bd89960b14.displayName = "Grid";



var $7fPBF = parcelRequire("7fPBF");
const $a0cf194253713caf$export$e9ff24309c5d362a = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef((e, n)=>(0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "9",
        height: "9",
        viewBox: "0 0 9 9",
        fill: "currentcolor",
        xmlns: "http://www.w3.org/2000/svg",
        ...e,
        ref: n
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.75 4.5C0.75 4.08579 1.08579 3.75 1.5 3.75H7.5C7.91421 3.75 8.25 4.08579 8.25 4.5C8.25 4.91421 7.91421 5.25 7.5 5.25H1.5C1.08579 5.25 0.75 4.91421 0.75 4.5Z"
    })));
$a0cf194253713caf$export$e9ff24309c5d362a.displayName = "ThickDividerHorizontalIcon";
const $a0cf194253713caf$export$e8a6d0edce052b3e = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef((e, n)=>(0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "9",
        height: "9",
        viewBox: "0 0 9 9",
        fill: "currentcolor",
        xmlns: "http://www.w3.org/2000/svg",
        ...e,
        ref: n
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.53547 0.62293C8.88226 0.849446 8.97976 1.3142 8.75325 1.66099L4.5083 8.1599C4.38833 8.34356 4.19397 8.4655 3.9764 8.49358C3.75883 8.52167 3.53987 8.45309 3.3772 8.30591L0.616113 5.80777C0.308959 5.52987 0.285246 5.05559 0.563148 4.74844C0.84105 4.44128 1.31533 4.41757 1.62249 4.69547L3.73256 6.60459L7.49741 0.840706C7.72393 0.493916 8.18868 0.396414 8.53547 0.62293Z"
    })));
$a0cf194253713caf$export$e8a6d0edce052b3e.displayName = "ThickCheckIcon";
const $a0cf194253713caf$export$4857d3f3f5f8319b = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef((e, n)=>(0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "9",
        height: "9",
        viewBox: "0 0 9 9",
        fill: "currentcolor",
        xmlns: "http://www.w3.org/2000/svg",
        ...e,
        ref: n
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M0.135232 3.15803C0.324102 2.95657 0.640521 2.94637 0.841971 3.13523L4.5 6.56464L8.158 3.13523C8.3595 2.94637 8.6759 2.95657 8.8648 3.15803C9.0536 3.35949 9.0434 3.67591 8.842 3.86477L4.84197 7.6148C4.64964 7.7951 4.35036 7.7951 4.15803 7.6148L0.158031 3.86477C-0.0434285 3.67591 -0.0536285 3.35949 0.135232 3.15803Z"
    })));
$a0cf194253713caf$export$4857d3f3f5f8319b.displayName = "ChevronDownIcon";
const $a0cf194253713caf$export$e27db7fd6f9e0eab = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef((e, n)=>(0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "9",
        height: "9",
        viewBox: "0 0 9 9",
        fill: "currentcolor",
        xmlns: "http://www.w3.org/2000/svg",
        ...e,
        ref: n
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.23826 0.201711C3.54108 -0.0809141 4.01567 -0.0645489 4.29829 0.238264L7.79829 3.98826C8.06724 4.27642 8.06724 4.72359 7.79829 5.01174L4.29829 8.76174C4.01567 9.06455 3.54108 9.08092 3.23826 8.79829C2.93545 8.51567 2.91909 8.04108 3.20171 7.73826L6.22409 4.5L3.20171 1.26174C2.91909 0.958928 2.93545 0.484337 3.23826 0.201711Z"
    })));
$a0cf194253713caf$export$e27db7fd6f9e0eab.displayName = "ThickChevronRightIcon";




"use client";
const $023de1cc27f3aeec$var$x = "CheckboxCards", [$023de1cc27f3aeec$var$G] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)($023de1cc27f3aeec$var$x, [
    (0, $a562f34061d8ab10$export$19e38fc04063f12)
]), $023de1cc27f3aeec$var$d = (0, $a562f34061d8ab10$export$19e38fc04063f12)(), [$023de1cc27f3aeec$var$v, $023de1cc27f3aeec$var$N] = $023de1cc27f3aeec$var$G($023de1cc27f3aeec$var$x), $023de1cc27f3aeec$export$be92b6f5f03c0fe9 = $7fPBF.forwardRef((e, s)=>{
    const { __scopeCheckboxCards: r, className: c, color: p, ...a } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(e, (0, $fe9514ee2d5263f2$export$328214b63232fea9), (0, $df06be8448ff4f3c$export$83503616c7a463e3)), t = $023de1cc27f3aeec$var$d(r);
    return $7fPBF.createElement($023de1cc27f3aeec$var$v, {
        scope: r,
        size: e.size,
        highContrast: e.highContrast
    }, $7fPBF.createElement((0, $1186128e999eac49$export$ef2184bd89960b14), {
        asChild: !0
    }, $7fPBF.createElement($a562f34061d8ab10$export$be92b6f5f03c0fe9, {
        ...t,
        "data-accent-color": p,
        ...a,
        ref: s,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-CheckboxCardsRoot", c)
    })));
});
$023de1cc27f3aeec$export$be92b6f5f03c0fe9.displayName = "CheckboxCards.Root";
const $023de1cc27f3aeec$export$6d08773d2e66f8f2 = $7fPBF.forwardRef(({ __scopeCheckboxCards: e, children: s, className: r, style: c, ...p }, a)=>{
    const t = $023de1cc27f3aeec$var$N("CheckboxCardsItem", e), i = $023de1cc27f3aeec$var$d(e), { className: P } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)({
        size: t === null || t === void 0 ? void 0 : t.size,
        variant: "surface",
        highContrast: t === null || t === void 0 ? void 0 : t.highContrast
    }, (0, $63f7884c474c8198$export$dfc7ebaec798447d));
    return $7fPBF.createElement("label", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-BaseCard", "rt-CheckboxCardsItem", r),
        style: c
    }, s, $7fPBF.createElement($a562f34061d8ab10$export$6d08773d2e66f8f2, {
        ...i,
        ...p,
        ref: a,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-reset", "rt-BaseCheckboxRoot", "rt-CheckboxCardCheckbox", P)
    }, $7fPBF.createElement($a562f34061d8ab10$export$adb584737d712b70, {
        ...i,
        asChild: !0,
        className: "rt-BaseCheckboxIndicator"
    }, $7fPBF.createElement((0, $a0cf194253713caf$export$e8a6d0edce052b3e), null))));
});
$023de1cc27f3aeec$export$6d08773d2e66f8f2.displayName = "CheckboxCards.Item";



var $7fPBF = parcelRequire("7fPBF");





const $beb4c71d7ea297af$export$76098a789a4303b5 = {
    ...(0, $b302dbddfdac9d75$export$1e7c0b54c65e0280),
    ...(0, $63f7884c474c8198$export$dfc7ebaec798447d)
};






"use client";
const $73fa8b8533ae425e$var$b = "CheckboxGroup", [$73fa8b8533ae425e$var$N] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)($73fa8b8533ae425e$var$b, [
    (0, $a562f34061d8ab10$export$19e38fc04063f12)
]), $73fa8b8533ae425e$var$G = (0, $a562f34061d8ab10$export$19e38fc04063f12)(), [$73fa8b8533ae425e$var$E, $73fa8b8533ae425e$var$P] = $73fa8b8533ae425e$var$N($73fa8b8533ae425e$var$b), $73fa8b8533ae425e$export$be92b6f5f03c0fe9 = $7fPBF.forwardRef(({ color: s = (0, $beb4c71d7ea297af$export$76098a789a4303b5).color.default, highContrast: e = (0, $beb4c71d7ea297af$export$76098a789a4303b5).highContrast.default, size: r = (0, $beb4c71d7ea297af$export$76098a789a4303b5).size.default, variant: t = (0, $beb4c71d7ea297af$export$76098a789a4303b5).variant.default, ...p }, m)=>{
    const { __scopeCheckboxGroup: c, className: h, ...I } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(p, (0, $df06be8448ff4f3c$export$83503616c7a463e3)), d = $73fa8b8533ae425e$var$G(c);
    return $7fPBF.createElement($73fa8b8533ae425e$var$E, {
        scope: c,
        color: s,
        size: r,
        highContrast: e,
        variant: t
    }, $7fPBF.createElement($a562f34061d8ab10$export$be92b6f5f03c0fe9, {
        ...d,
        ...I,
        ref: m,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-CheckboxGroupRoot", h)
    }));
});
$73fa8b8533ae425e$export$be92b6f5f03c0fe9.displayName = "CheckboxGroup.Root";
const $73fa8b8533ae425e$export$6d08773d2e66f8f2 = $7fPBF.forwardRef((s, e)=>{
    const { __scopeCheckboxGroup: r, children: t, className: p, style: m, ...c } = s, { size: h } = $73fa8b8533ae425e$var$P("CheckboxGroupItem", r);
    return t ? $7fPBF.createElement((0, $83db9e82a643d7a4$export$5f1af8db9871e1d6), {
        as: "label",
        size: h,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-CheckboxGroupItem", p),
        style: m
    }, $7fPBF.createElement($73fa8b8533ae425e$var$u, {
        __scopeCheckboxGroup: r,
        ...c,
        ref: e
    }), t && $7fPBF.createElement("span", {
        className: "rt-CheckboxGroupItemInner"
    }, t)) : $7fPBF.createElement($73fa8b8533ae425e$var$u, {
        __scopeCheckboxGroup: r,
        ...c,
        ref: e,
        className: p,
        style: m
    });
});
$73fa8b8533ae425e$export$6d08773d2e66f8f2.displayName = "CheckboxGroup.Item";
const $73fa8b8533ae425e$var$u = $7fPBF.forwardRef(({ __scopeCheckboxGroup: s, ...e }, r)=>{
    const t = $73fa8b8533ae425e$var$P("CheckboxGroupItemCheckbox", s), p = $73fa8b8533ae425e$var$G(s), { color: m, className: c } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)({
        ...e,
        ...t
    }, (0, $beb4c71d7ea297af$export$76098a789a4303b5), (0, $df06be8448ff4f3c$export$83503616c7a463e3));
    return $7fPBF.createElement($a562f34061d8ab10$export$6d08773d2e66f8f2, {
        ...p,
        "data-accent-color": m,
        ...e,
        ref: r,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-reset", "rt-BaseCheckboxRoot", "rt-CheckboxGroupItemCheckbox", c)
    }, $7fPBF.createElement($a562f34061d8ab10$export$adb584737d712b70, {
        ...p,
        asChild: !0,
        className: "rt-BaseCheckboxIndicator"
    }, $7fPBF.createElement((0, $a0cf194253713caf$export$e8a6d0edce052b3e), null)));
});
$73fa8b8533ae425e$var$u.displayName = "CheckboxGroup.ItemCheckbox";



var $7fPBF = parcelRequire("7fPBF");









"use client";
const $cfba43b0436ea168$export$48513f6b9f8ce62d = $7fPBF.forwardRef((p, i)=>{
    const { className: s, color: h, checked: a, defaultChecked: o, onCheckedChange: m, ...n } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(p, (0, $63f7884c474c8198$export$dfc7ebaec798447d), (0, $df06be8448ff4f3c$export$83503616c7a463e3)), [r, k] = (0, $915387e6ab4d88b1$export$6f32135080cb4c3)({
        prop: a,
        defaultProp: o,
        onChange: m
    });
    return $7fPBF.createElement($02d43fb88a8d607d$export$be92b6f5f03c0fe9, {
        "data-accent-color": h,
        ...n,
        defaultChecked: o,
        checked: r,
        onCheckedChange: k,
        asChild: !1,
        ref: i,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-reset", "rt-BaseCheckboxRoot", "rt-CheckboxRoot", s)
    }, $7fPBF.createElement($02d43fb88a8d607d$export$adb584737d712b70, {
        asChild: !0,
        className: "rt-BaseCheckboxIndicator rt-CheckboxIndicator"
    }, $7fPBF.createElement(r === "indeterminate" ? (0, $a0cf194253713caf$export$e9ff24309c5d362a) : (0, $a0cf194253713caf$export$e8a6d0edce052b3e), null)));
});
$cfba43b0436ea168$export$48513f6b9f8ce62d.displayName = "Checkbox";



var $7fPBF = parcelRequire("7fPBF");








const $5d0ced7f3b46317d$var$a = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9"
], $5d0ced7f3b46317d$var$i = [
    "solid",
    "soft",
    "outline",
    "ghost"
], $5d0ced7f3b46317d$export$7e94fdaa074c44db = {
    ...(0, $b302dbddfdac9d75$export$1e7c0b54c65e0280),
    size: {
        type: "enum",
        className: "rt-r-size",
        values: $5d0ced7f3b46317d$var$a,
        responsive: !0
    },
    variant: {
        type: "enum",
        className: "rt-variant",
        values: $5d0ced7f3b46317d$var$i,
        default: "soft"
    },
    ...(0, $ec44dfa8e04fe2ae$export$959a85f577d21089),
    ...(0, $e914ebf2ce406d8c$export$d0261b42be231f92),
    ...(0, $f41c61290c2a7125$export$2f84412d299def33),
    ...(0, $2c64e4634b053e6a$export$b51caa9f475eecbe),
    ...(0, $738dfabf5e38f576$export$d1dbebac82aee34d)
};




const $06ee742a99440616$export$52f0f02147b12c03 = $7fPBF.forwardRef((o, t)=>{
    const { asChild: s, className: m, color: e, ...d } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(o, (0, $5d0ced7f3b46317d$export$7e94fdaa074c44db), (0, $df06be8448ff4f3c$export$83503616c7a463e3)), n = o.variant === "ghost" ? e || void 0 : e;
    return $7fPBF.createElement(s ? (0, $089057084dfb92a4$export$8c6ed5c666ac1360) : "code", {
        "data-accent-color": n,
        ...d,
        ref: t,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-reset", "rt-Code", m)
    });
});
$06ee742a99440616$export$52f0f02147b12c03.displayName = "Code";



var $7fPBF = parcelRequire("7fPBF");



const $9539e65f4fb55094$var$r = [
    "1",
    "2",
    "3",
    "4"
], $9539e65f4fb55094$var$t = [
    "none",
    "initial"
], $9539e65f4fb55094$var$p = [
    "left",
    "center",
    "right"
], $9539e65f4fb55094$export$92fba2069eb598d8 = {
    ...(0, $b302dbddfdac9d75$export$1e7c0b54c65e0280),
    size: {
        type: "enum",
        className: "rt-r-size",
        values: $9539e65f4fb55094$var$r,
        default: "4",
        responsive: !0
    },
    display: {
        type: "enum",
        className: "rt-r-display",
        values: $9539e65f4fb55094$var$t,
        parseValue: $9539e65f4fb55094$var$a,
        responsive: !0
    },
    align: {
        type: "enum",
        className: "rt-r-ai",
        values: $9539e65f4fb55094$var$p,
        parseValue: $9539e65f4fb55094$var$i,
        responsive: !0
    }
};
function $9539e65f4fb55094$var$a(e) {
    return e === "initial" ? "flex" : e;
}
function $9539e65f4fb55094$var$i(e) {
    return e === "left" ? "start" : e === "right" ? "end" : e;
}








const $bb4521bcecb1cd38$export$42a852a2b6b56249 = $7fPBF.forwardRef(({ width: n, minWidth: s, maxWidth: m, height: i, minHeight: a, maxHeight: f, ...P }, l)=>{
    const { asChild: r, children: C, className: c, ...y } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(P, (0, $9539e65f4fb55094$export$92fba2069eb598d8), (0, $b1d6d16f69302f9e$export$e71e58537b2e6660), (0, $df06be8448ff4f3c$export$83503616c7a463e3)), { className: d, style: h } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)({
        width: n,
        minWidth: s,
        maxWidth: m,
        height: i,
        minHeight: a,
        maxHeight: f
    }, (0, $b6a742bf1f02ee7d$export$18e5dbe2c243731), (0, $a66fc9f2b041fa5d$export$e039c83f102b25e2));
    return $7fPBF.createElement(r ? (0, $089057084dfb92a4$export$8c6ed5c666ac1360) : "div", {
        ...y,
        ref: l,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-Container", c)
    }, (0, $3de7503944cba122$export$9e8b964465d7899e)({
        asChild: r,
        children: C
    }, (u)=>$7fPBF.createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-ContainerInner", d),
            style: h
        }, u)));
});
$bb4521bcecb1cd38$export$42a852a2b6b56249.displayName = "Container";



var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");



















"use client";
var $860e6fb93642be7e$var$SELECTION_KEYS = [
    "Enter",
    " "
];
var $860e6fb93642be7e$var$FIRST_KEYS = [
    "ArrowDown",
    "PageUp",
    "Home"
];
var $860e6fb93642be7e$var$LAST_KEYS = [
    "ArrowUp",
    "PageDown",
    "End"
];
var $860e6fb93642be7e$var$FIRST_LAST_KEYS = [
    ...$860e6fb93642be7e$var$FIRST_KEYS,
    ...$860e6fb93642be7e$var$LAST_KEYS
];
var $860e6fb93642be7e$var$SUB_OPEN_KEYS = {
    ltr: [
        ...$860e6fb93642be7e$var$SELECTION_KEYS,
        "ArrowRight"
    ],
    rtl: [
        ...$860e6fb93642be7e$var$SELECTION_KEYS,
        "ArrowLeft"
    ]
};
var $860e6fb93642be7e$var$SUB_CLOSE_KEYS = {
    ltr: [
        "ArrowLeft"
    ],
    rtl: [
        "ArrowRight"
    ]
};
var $860e6fb93642be7e$var$MENU_NAME = "Menu";
var [$860e6fb93642be7e$var$Collection, $860e6fb93642be7e$var$useCollection, $860e6fb93642be7e$var$createCollectionScope] = (0, $08a94ba50b5cc249$export$c74125a8e3af6bb2)($860e6fb93642be7e$var$MENU_NAME);
var [$860e6fb93642be7e$var$createMenuContext, $860e6fb93642be7e$export$4027731b685e72eb] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)($860e6fb93642be7e$var$MENU_NAME, [
    $860e6fb93642be7e$var$createCollectionScope,
    (0, $7952cd297982b588$export$722aac194ae923),
    (0, $8183e11ba1e9b7dc$export$c7109489551a4f4)
]);
var $860e6fb93642be7e$var$usePopperScope = (0, $7952cd297982b588$export$722aac194ae923)();
var $860e6fb93642be7e$var$useRovingFocusGroupScope = (0, $8183e11ba1e9b7dc$export$c7109489551a4f4)();
var [$860e6fb93642be7e$var$MenuProvider, $860e6fb93642be7e$var$useMenuContext] = $860e6fb93642be7e$var$createMenuContext($860e6fb93642be7e$var$MENU_NAME);
var [$860e6fb93642be7e$var$MenuRootProvider, $860e6fb93642be7e$var$useMenuRootContext] = $860e6fb93642be7e$var$createMenuContext($860e6fb93642be7e$var$MENU_NAME);
var $860e6fb93642be7e$export$d9b273488cd8ce6f = (props)=>{
    const { __scopeMenu: __scopeMenu, open: open = false, children: children, dir: dir, onOpenChange: onOpenChange, modal: modal = true } = props;
    const popperScope = $860e6fb93642be7e$var$usePopperScope(__scopeMenu);
    const [content, setContent] = $7fPBF.useState(null);
    const isUsingKeyboardRef = $7fPBF.useRef(false);
    const handleOpenChange = (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(onOpenChange);
    const direction = (0, $3342477e04611d10$export$b39126d51d94e6f3)(dir);
    $7fPBF.useEffect(()=>{
        const handleKeyDown = ()=>{
            isUsingKeyboardRef.current = true;
            document.addEventListener("pointerdown", handlePointer, {
                capture: true,
                once: true
            });
            document.addEventListener("pointermove", handlePointer, {
                capture: true,
                once: true
            });
        };
        const handlePointer = ()=>isUsingKeyboardRef.current = false;
        document.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
            document.removeEventListener("pointerdown", handlePointer, {
                capture: true
            });
            document.removeEventListener("pointermove", handlePointer, {
                capture: true
            });
        };
    }, []);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$export$be92b6f5f03c0fe9, {
        ...popperScope,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$var$MenuProvider, {
            scope: __scopeMenu,
            open: open,
            onOpenChange: handleOpenChange,
            content: content,
            onContentChange: setContent,
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$var$MenuRootProvider, {
                scope: __scopeMenu,
                onClose: $7fPBF.useCallback(()=>handleOpenChange(false), [
                    handleOpenChange
                ]),
                isUsingKeyboardRef: isUsingKeyboardRef,
                dir: direction,
                modal: modal,
                children: children
            })
        })
    });
};
$860e6fb93642be7e$export$d9b273488cd8ce6f.displayName = $860e6fb93642be7e$var$MENU_NAME;
var $860e6fb93642be7e$var$ANCHOR_NAME = "MenuAnchor";
var $860e6fb93642be7e$export$9fa5ebd18bee4d43 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...anchorProps } = props;
    const popperScope = $860e6fb93642be7e$var$usePopperScope(__scopeMenu);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$export$b688253958b8dfe7, {
        ...popperScope,
        ...anchorProps,
        ref: forwardedRef
    });
});
$860e6fb93642be7e$export$9fa5ebd18bee4d43.displayName = $860e6fb93642be7e$var$ANCHOR_NAME;
var $860e6fb93642be7e$var$PORTAL_NAME = "MenuPortal";
var [$860e6fb93642be7e$var$PortalProvider, $860e6fb93642be7e$var$usePortalContext] = $860e6fb93642be7e$var$createMenuContext($860e6fb93642be7e$var$PORTAL_NAME, {
    forceMount: void 0
});
var $860e6fb93642be7e$export$793392f970497feb = (props)=>{
    const { __scopeMenu: __scopeMenu, forceMount: forceMount, children: children, container: container } = props;
    const context = $860e6fb93642be7e$var$useMenuContext($860e6fb93642be7e$var$PORTAL_NAME, __scopeMenu);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$var$PortalProvider, {
        scope: __scopeMenu,
        forceMount: forceMount,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $e9ce08b8e6e14786$export$99c2b779aa4e8b8b), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $57c7abe8fecdeb41$export$602eac185826482c), {
                asChild: true,
                container: container,
                children: children
            })
        })
    });
};
$860e6fb93642be7e$export$793392f970497feb.displayName = $860e6fb93642be7e$var$PORTAL_NAME;
var $860e6fb93642be7e$var$CONTENT_NAME = "MenuContent";
var [$860e6fb93642be7e$var$MenuContentProvider, $860e6fb93642be7e$var$useMenuContentContext] = $860e6fb93642be7e$var$createMenuContext($860e6fb93642be7e$var$CONTENT_NAME);
var $860e6fb93642be7e$export$479f0f2f71193efe = $7fPBF.forwardRef((props, forwardedRef)=>{
    const portalContext = $860e6fb93642be7e$var$usePortalContext($860e6fb93642be7e$var$CONTENT_NAME, props.__scopeMenu);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $860e6fb93642be7e$var$useMenuContext($860e6fb93642be7e$var$CONTENT_NAME, props.__scopeMenu);
    const rootContext = $860e6fb93642be7e$var$useMenuRootContext($860e6fb93642be7e$var$CONTENT_NAME, props.__scopeMenu);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$var$Collection.Provider, {
        scope: props.__scopeMenu,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $e9ce08b8e6e14786$export$99c2b779aa4e8b8b), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$var$Collection.Slot, {
                scope: props.__scopeMenu,
                children: rootContext.modal ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$var$MenuRootContentModal, {
                    ...contentProps,
                    ref: forwardedRef
                }) : /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$var$MenuRootContentNonModal, {
                    ...contentProps,
                    ref: forwardedRef
                })
            })
        })
    });
});
var $860e6fb93642be7e$var$MenuRootContentModal = $7fPBF.forwardRef((props, forwardedRef)=>{
    const context = $860e6fb93642be7e$var$useMenuContext($860e6fb93642be7e$var$CONTENT_NAME, props.__scopeMenu);
    const ref = $7fPBF.useRef(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $7fPBF.useEffect(()=>{
        const content = ref.current;
        if (content) return (0, $2950574f4b60c018$export$6e33d16126ed003c)(content);
    }, []);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$var$MenuContentImpl, {
        ...props,
        ref: composedRefs,
        trapFocus: context.open,
        disableOutsidePointerEvents: context.open,
        disableOutsideScroll: true,
        onFocusOutside: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault(), {
            checkForDefaultPrevented: false
        }),
        onDismiss: ()=>context.onOpenChange(false)
    });
});
var $860e6fb93642be7e$var$MenuRootContentNonModal = $7fPBF.forwardRef((props, forwardedRef)=>{
    const context = $860e6fb93642be7e$var$useMenuContext($860e6fb93642be7e$var$CONTENT_NAME, props.__scopeMenu);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$var$MenuContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        disableOutsideScroll: false,
        onDismiss: ()=>context.onOpenChange(false)
    });
});
var $860e6fb93642be7e$var$MenuContentImpl = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, loop: loop = false, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, disableOutsidePointerEvents: disableOutsidePointerEvents, onEntryFocus: onEntryFocus, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, disableOutsideScroll: disableOutsideScroll, ...contentProps } = props;
    const context = $860e6fb93642be7e$var$useMenuContext($860e6fb93642be7e$var$CONTENT_NAME, __scopeMenu);
    const rootContext = $860e6fb93642be7e$var$useMenuRootContext($860e6fb93642be7e$var$CONTENT_NAME, __scopeMenu);
    const popperScope = $860e6fb93642be7e$var$usePopperScope(__scopeMenu);
    const rovingFocusGroupScope = $860e6fb93642be7e$var$useRovingFocusGroupScope(__scopeMenu);
    const getItems = $860e6fb93642be7e$var$useCollection(__scopeMenu);
    const [currentItemId, setCurrentItemId] = $7fPBF.useState(null);
    const contentRef = $7fPBF.useRef(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, contentRef, context.onContentChange);
    const timerRef = $7fPBF.useRef(0);
    const searchRef = $7fPBF.useRef("");
    const pointerGraceTimerRef = $7fPBF.useRef(0);
    const pointerGraceIntentRef = $7fPBF.useRef(null);
    const pointerDirRef = $7fPBF.useRef("right");
    const lastPointerXRef = $7fPBF.useRef(0);
    const ScrollLockWrapper = disableOutsideScroll ? (0, $ef57a4b421076988$export$2e2bcd8739ae039) : $7fPBF.Fragment;
    const scrollLockWrapperProps = disableOutsideScroll ? {
        as: (0, $089057084dfb92a4$export$8c6ed5c666ac1360),
        allowPinchZoom: true
    } : void 0;
    const handleTypeaheadSearch = (key)=>{
        var _items_find, _items_find1;
        const search = searchRef.current + key;
        const items = getItems().filter((item)=>!item.disabled);
        const currentItem = document.activeElement;
        const currentMatch = (_items_find = items.find((item)=>item.ref.current === currentItem)) === null || _items_find === void 0 ? void 0 : _items_find.textValue;
        const values = items.map((item)=>item.textValue);
        const nextMatch = $860e6fb93642be7e$var$getNextMatch(values, search, currentMatch);
        const newItem = (_items_find1 = items.find((item)=>item.textValue === nextMatch)) === null || _items_find1 === void 0 ? void 0 : _items_find1.ref.current;
        (function updateSearch(value) {
            searchRef.current = value;
            window.clearTimeout(timerRef.current);
            if (value !== "") timerRef.current = window.setTimeout(()=>updateSearch(""), 1e3);
        })(search);
        if (newItem) setTimeout(()=>newItem.focus());
    };
    $7fPBF.useEffect(()=>{
        return ()=>window.clearTimeout(timerRef.current);
    }, []);
    (0, $38bbe2f1de23f200$export$b7ece24a22aeda8c)();
    const isPointerMovingToSubmenu = $7fPBF.useCallback((event)=>{
        var _pointerGraceIntentRef_current, _pointerGraceIntentRef_current1;
        const isMovingTowards = pointerDirRef.current === ((_pointerGraceIntentRef_current = pointerGraceIntentRef.current) === null || _pointerGraceIntentRef_current === void 0 ? void 0 : _pointerGraceIntentRef_current.side);
        return isMovingTowards && $860e6fb93642be7e$var$isPointerInGraceArea(event, (_pointerGraceIntentRef_current1 = pointerGraceIntentRef.current) === null || _pointerGraceIntentRef_current1 === void 0 ? void 0 : _pointerGraceIntentRef_current1.area);
    }, []);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$var$MenuContentProvider, {
        scope: __scopeMenu,
        searchRef: searchRef,
        onItemEnter: $7fPBF.useCallback((event)=>{
            if (isPointerMovingToSubmenu(event)) event.preventDefault();
        }, [
            isPointerMovingToSubmenu
        ]),
        onItemLeave: $7fPBF.useCallback((event)=>{
            var _contentRef_current;
            if (isPointerMovingToSubmenu(event)) return;
            (_contentRef_current = contentRef.current) === null || _contentRef_current === void 0 ? void 0 : _contentRef_current.focus();
            setCurrentItemId(null);
        }, [
            isPointerMovingToSubmenu
        ]),
        onTriggerLeave: $7fPBF.useCallback((event)=>{
            if (isPointerMovingToSubmenu(event)) event.preventDefault();
        }, [
            isPointerMovingToSubmenu
        ]),
        pointerGraceTimerRef: pointerGraceTimerRef,
        onPointerGraceIntentChange: $7fPBF.useCallback((intent)=>{
            pointerGraceIntentRef.current = intent;
        }, []),
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(ScrollLockWrapper, {
            ...scrollLockWrapperProps,
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $0d555b2b0a3ffff1$export$20e40289641fbbb6), {
                asChild: true,
                trapped: trapFocus,
                onMountAutoFocus: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(onOpenAutoFocus, (event)=>{
                    var _contentRef_current;
                    event.preventDefault();
                    (_contentRef_current = contentRef.current) === null || _contentRef_current === void 0 ? void 0 : _contentRef_current.focus({
                        preventScroll: true
                    });
                }),
                onUnmountAutoFocus: onCloseAutoFocus,
                children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $251340165f4765e5$export$177fb62ff3ec1f22), {
                    asChild: true,
                    disableOutsidePointerEvents: disableOutsidePointerEvents,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onPointerDownOutside: onPointerDownOutside,
                    onFocusOutside: onFocusOutside,
                    onInteractOutside: onInteractOutside,
                    onDismiss: onDismiss,
                    children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($8183e11ba1e9b7dc$export$be92b6f5f03c0fe9, {
                        asChild: true,
                        ...rovingFocusGroupScope,
                        dir: rootContext.dir,
                        orientation: "vertical",
                        loop: loop,
                        currentTabStopId: currentItemId,
                        onCurrentTabStopIdChange: setCurrentItemId,
                        onEntryFocus: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(onEntryFocus, (event)=>{
                            if (!rootContext.isUsingKeyboardRef.current) event.preventDefault();
                        }),
                        preventScrollOnEntryFocus: true,
                        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$export$7c6e2c02157bb7d2, {
                            role: "menu",
                            "aria-orientation": "vertical",
                            "data-state": $860e6fb93642be7e$var$getOpenState(context.open),
                            "data-radix-menu-content": "",
                            dir: rootContext.dir,
                            ...popperScope,
                            ...contentProps,
                            ref: composedRefs,
                            style: {
                                outline: "none",
                                ...contentProps.style
                            },
                            onKeyDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(contentProps.onKeyDown, (event)=>{
                                const target = event.target;
                                const isKeyDownInside = target.closest("[data-radix-menu-content]") === event.currentTarget;
                                const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
                                const isCharacterKey = event.key.length === 1;
                                if (isKeyDownInside) {
                                    if (event.key === "Tab") event.preventDefault();
                                    if (!isModifierKey && isCharacterKey) handleTypeaheadSearch(event.key);
                                }
                                const content = contentRef.current;
                                if (event.target !== content) return;
                                if (!$860e6fb93642be7e$var$FIRST_LAST_KEYS.includes(event.key)) return;
                                event.preventDefault();
                                const items = getItems().filter((item)=>!item.disabled);
                                const candidateNodes = items.map((item)=>item.ref.current);
                                if ($860e6fb93642be7e$var$LAST_KEYS.includes(event.key)) candidateNodes.reverse();
                                $860e6fb93642be7e$var$focusFirst(candidateNodes);
                            }),
                            onBlur: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onBlur, (event)=>{
                                if (!event.currentTarget.contains(event.target)) {
                                    window.clearTimeout(timerRef.current);
                                    searchRef.current = "";
                                }
                            }),
                            onPointerMove: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerMove, $860e6fb93642be7e$var$whenMouse((event)=>{
                                const target = event.target;
                                const pointerXHasChanged = lastPointerXRef.current !== event.clientX;
                                if (event.currentTarget.contains(target) && pointerXHasChanged) {
                                    const newDir = event.clientX > lastPointerXRef.current ? "right" : "left";
                                    pointerDirRef.current = newDir;
                                    lastPointerXRef.current = event.clientX;
                                }
                            }))
                        })
                    })
                })
            })
        })
    });
});
$860e6fb93642be7e$export$479f0f2f71193efe.displayName = $860e6fb93642be7e$var$CONTENT_NAME;
var $860e6fb93642be7e$var$GROUP_NAME = "MenuGroup";
var $860e6fb93642be7e$export$22a631d1f72787bb = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...groupProps } = props;
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
        role: "group",
        ...groupProps,
        ref: forwardedRef
    });
});
$860e6fb93642be7e$export$22a631d1f72787bb.displayName = $860e6fb93642be7e$var$GROUP_NAME;
var $860e6fb93642be7e$var$LABEL_NAME = "MenuLabel";
var $860e6fb93642be7e$export$dd37bec0e8a99143 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...labelProps } = props;
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
        ...labelProps,
        ref: forwardedRef
    });
});
$860e6fb93642be7e$export$dd37bec0e8a99143.displayName = $860e6fb93642be7e$var$LABEL_NAME;
var $860e6fb93642be7e$var$ITEM_NAME = "MenuItem";
var $860e6fb93642be7e$var$ITEM_SELECT = "menu.itemSelect";
var $860e6fb93642be7e$export$2ce376c2cc3355c8 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { disabled: disabled = false, onSelect: onSelect, ...itemProps } = props;
    const ref = $7fPBF.useRef(null);
    const rootContext = $860e6fb93642be7e$var$useMenuRootContext($860e6fb93642be7e$var$ITEM_NAME, props.__scopeMenu);
    const contentContext = $860e6fb93642be7e$var$useMenuContentContext($860e6fb93642be7e$var$ITEM_NAME, props.__scopeMenu);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const isPointerDownRef = $7fPBF.useRef(false);
    const handleSelect = ()=>{
        const menuItem = ref.current;
        if (!disabled && menuItem) {
            const itemSelectEvent = new CustomEvent($860e6fb93642be7e$var$ITEM_SELECT, {
                bubbles: true,
                cancelable: true
            });
            menuItem.addEventListener($860e6fb93642be7e$var$ITEM_SELECT, (event)=>onSelect === null || onSelect === void 0 ? void 0 : onSelect(event), {
                once: true
            });
            (0, $4b1a25a893812cc7$export$6d1a0317bde7de7f)(menuItem, itemSelectEvent);
            if (itemSelectEvent.defaultPrevented) isPointerDownRef.current = false;
            else rootContext.onClose();
        }
    };
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$var$MenuItemImpl, {
        ...itemProps,
        ref: composedRefs,
        disabled: disabled,
        onClick: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onClick, handleSelect),
        onPointerDown: (event)=>{
            var _props_onPointerDown;
            (_props_onPointerDown = props.onPointerDown) === null || _props_onPointerDown === void 0 ? void 0 : _props_onPointerDown.call(props, event);
            isPointerDownRef.current = true;
        },
        onPointerUp: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerUp, (event)=>{
            var _event_currentTarget;
            if (!isPointerDownRef.current) (_event_currentTarget = event.currentTarget) === null || _event_currentTarget === void 0 ? void 0 : _event_currentTarget.click();
        }),
        onKeyDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            const isTypingAhead = contentContext.searchRef.current !== "";
            if (disabled || isTypingAhead && event.key === " ") return;
            if ($860e6fb93642be7e$var$SELECTION_KEYS.includes(event.key)) {
                event.currentTarget.click();
                event.preventDefault();
            }
        })
    });
});
$860e6fb93642be7e$export$2ce376c2cc3355c8.displayName = $860e6fb93642be7e$var$ITEM_NAME;
var $860e6fb93642be7e$var$MenuItemImpl = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, disabled: disabled = false, textValue: textValue, ...itemProps } = props;
    const contentContext = $860e6fb93642be7e$var$useMenuContentContext($860e6fb93642be7e$var$ITEM_NAME, __scopeMenu);
    const rovingFocusGroupScope = $860e6fb93642be7e$var$useRovingFocusGroupScope(__scopeMenu);
    const ref = $7fPBF.useRef(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const [isFocused, setIsFocused] = $7fPBF.useState(false);
    const [textContent, setTextContent] = $7fPBF.useState("");
    $7fPBF.useEffect(()=>{
        const menuItem = ref.current;
        var _menuItem_textContent;
        if (menuItem) setTextContent(((_menuItem_textContent = menuItem.textContent) !== null && _menuItem_textContent !== void 0 ? _menuItem_textContent : "").trim());
    }, [
        itemProps.children
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$var$Collection.ItemSlot, {
        scope: __scopeMenu,
        disabled: disabled,
        textValue: textValue !== null && textValue !== void 0 ? textValue : textContent,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($8183e11ba1e9b7dc$export$6d08773d2e66f8f2, {
            asChild: true,
            ...rovingFocusGroupScope,
            focusable: !disabled,
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
                role: "menuitem",
                "data-highlighted": isFocused ? "" : void 0,
                "aria-disabled": disabled || void 0,
                "data-disabled": disabled ? "" : void 0,
                ...itemProps,
                ref: composedRefs,
                onPointerMove: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerMove, $860e6fb93642be7e$var$whenMouse((event)=>{
                    if (disabled) contentContext.onItemLeave(event);
                    else {
                        contentContext.onItemEnter(event);
                        if (!event.defaultPrevented) {
                            const item = event.currentTarget;
                            item.focus({
                                preventScroll: true
                            });
                        }
                    }
                })),
                onPointerLeave: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerLeave, $860e6fb93642be7e$var$whenMouse((event)=>contentContext.onItemLeave(event))),
                onFocus: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onFocus, ()=>setIsFocused(true)),
                onBlur: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onBlur, ()=>setIsFocused(false))
            })
        })
    });
});
var $860e6fb93642be7e$var$CHECKBOX_ITEM_NAME = "MenuCheckboxItem";
var $860e6fb93642be7e$export$f6f243521332502d = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { checked: checked = false, onCheckedChange: onCheckedChange, ...checkboxItemProps } = props;
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$var$ItemIndicatorProvider, {
        scope: props.__scopeMenu,
        checked: checked,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$2ce376c2cc3355c8, {
            role: "menuitemcheckbox",
            "aria-checked": $860e6fb93642be7e$var$isIndeterminate(checked) ? "mixed" : checked,
            ...checkboxItemProps,
            ref: forwardedRef,
            "data-state": $860e6fb93642be7e$var$getCheckedState(checked),
            onSelect: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(checkboxItemProps.onSelect, ()=>onCheckedChange === null || onCheckedChange === void 0 ? void 0 : onCheckedChange($860e6fb93642be7e$var$isIndeterminate(checked) ? true : !checked), {
                checkForDefaultPrevented: false
            })
        })
    });
});
$860e6fb93642be7e$export$f6f243521332502d.displayName = $860e6fb93642be7e$var$CHECKBOX_ITEM_NAME;
var $860e6fb93642be7e$var$RADIO_GROUP_NAME = "MenuRadioGroup";
var [$860e6fb93642be7e$var$RadioGroupProvider, $860e6fb93642be7e$var$useRadioGroupContext] = $860e6fb93642be7e$var$createMenuContext($860e6fb93642be7e$var$RADIO_GROUP_NAME, {
    value: void 0,
    onValueChange: ()=>{}
});
var $860e6fb93642be7e$export$ea2200c9eee416b3 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { value: value, onValueChange: onValueChange, ...groupProps } = props;
    const handleValueChange = (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(onValueChange);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$var$RadioGroupProvider, {
        scope: props.__scopeMenu,
        value: value,
        onValueChange: handleValueChange,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$22a631d1f72787bb, {
            ...groupProps,
            ref: forwardedRef
        })
    });
});
$860e6fb93642be7e$export$ea2200c9eee416b3.displayName = $860e6fb93642be7e$var$RADIO_GROUP_NAME;
var $860e6fb93642be7e$var$RADIO_ITEM_NAME = "MenuRadioItem";
var $860e6fb93642be7e$export$69bd225e9817f6d0 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { value: value, ...radioItemProps } = props;
    const context = $860e6fb93642be7e$var$useRadioGroupContext($860e6fb93642be7e$var$RADIO_ITEM_NAME, props.__scopeMenu);
    const checked = value === context.value;
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$var$ItemIndicatorProvider, {
        scope: props.__scopeMenu,
        checked: checked,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$2ce376c2cc3355c8, {
            role: "menuitemradio",
            "aria-checked": checked,
            ...radioItemProps,
            ref: forwardedRef,
            "data-state": $860e6fb93642be7e$var$getCheckedState(checked),
            onSelect: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(radioItemProps.onSelect, ()=>{
                var _context_onValueChange;
                return (_context_onValueChange = context.onValueChange) === null || _context_onValueChange === void 0 ? void 0 : _context_onValueChange.call(context, value);
            }, {
                checkForDefaultPrevented: false
            })
        })
    });
});
$860e6fb93642be7e$export$69bd225e9817f6d0.displayName = $860e6fb93642be7e$var$RADIO_ITEM_NAME;
var $860e6fb93642be7e$var$ITEM_INDICATOR_NAME = "MenuItemIndicator";
var [$860e6fb93642be7e$var$ItemIndicatorProvider, $860e6fb93642be7e$var$useItemIndicatorContext] = $860e6fb93642be7e$var$createMenuContext($860e6fb93642be7e$var$ITEM_INDICATOR_NAME, {
    checked: false
});
var $860e6fb93642be7e$export$a2593e23056970a3 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, forceMount: forceMount, ...itemIndicatorProps } = props;
    const indicatorContext = $860e6fb93642be7e$var$useItemIndicatorContext($860e6fb93642be7e$var$ITEM_INDICATOR_NAME, __scopeMenu);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $e9ce08b8e6e14786$export$99c2b779aa4e8b8b), {
        present: forceMount || $860e6fb93642be7e$var$isIndeterminate(indicatorContext.checked) || indicatorContext.checked === true,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).span, {
            ...itemIndicatorProps,
            ref: forwardedRef,
            "data-state": $860e6fb93642be7e$var$getCheckedState(indicatorContext.checked)
        })
    });
});
$860e6fb93642be7e$export$a2593e23056970a3.displayName = $860e6fb93642be7e$var$ITEM_INDICATOR_NAME;
var $860e6fb93642be7e$var$SEPARATOR_NAME = "MenuSeparator";
var $860e6fb93642be7e$export$1cec7dcdd713e220 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...separatorProps } = props;
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
        role: "separator",
        "aria-orientation": "horizontal",
        ...separatorProps,
        ref: forwardedRef
    });
});
$860e6fb93642be7e$export$1cec7dcdd713e220.displayName = $860e6fb93642be7e$var$SEPARATOR_NAME;
var $860e6fb93642be7e$var$ARROW_NAME = "MenuArrow";
var $860e6fb93642be7e$export$bcdda4773debf5fa = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeMenu: __scopeMenu, ...arrowProps } = props;
    const popperScope = $860e6fb93642be7e$var$usePopperScope(__scopeMenu);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$export$21b07c8f274aebd5, {
        ...popperScope,
        ...arrowProps,
        ref: forwardedRef
    });
});
$860e6fb93642be7e$export$bcdda4773debf5fa.displayName = $860e6fb93642be7e$var$ARROW_NAME;
var $860e6fb93642be7e$var$SUB_NAME = "MenuSub";
var [$860e6fb93642be7e$var$MenuSubProvider, $860e6fb93642be7e$var$useMenuSubContext] = $860e6fb93642be7e$var$createMenuContext($860e6fb93642be7e$var$SUB_NAME);
var $860e6fb93642be7e$export$71bdb9d1e2909932 = (props)=>{
    const { __scopeMenu: __scopeMenu, children: children, open: open = false, onOpenChange: onOpenChange } = props;
    const parentMenuContext = $860e6fb93642be7e$var$useMenuContext($860e6fb93642be7e$var$SUB_NAME, __scopeMenu);
    const popperScope = $860e6fb93642be7e$var$usePopperScope(__scopeMenu);
    const [trigger, setTrigger] = $7fPBF.useState(null);
    const [content, setContent] = $7fPBF.useState(null);
    const handleOpenChange = (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(onOpenChange);
    $7fPBF.useEffect(()=>{
        if (parentMenuContext.open === false) handleOpenChange(false);
        return ()=>handleOpenChange(false);
    }, [
        parentMenuContext.open,
        handleOpenChange
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$export$be92b6f5f03c0fe9, {
        ...popperScope,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$var$MenuProvider, {
            scope: __scopeMenu,
            open: open,
            onOpenChange: handleOpenChange,
            content: content,
            onContentChange: setContent,
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$var$MenuSubProvider, {
                scope: __scopeMenu,
                contentId: (0, $8a8e9b94c33ba6d6$export$f680877a34711e37)(),
                triggerId: (0, $8a8e9b94c33ba6d6$export$f680877a34711e37)(),
                trigger: trigger,
                onTriggerChange: setTrigger,
                children: children
            })
        })
    });
};
$860e6fb93642be7e$export$71bdb9d1e2909932.displayName = $860e6fb93642be7e$var$SUB_NAME;
var $860e6fb93642be7e$var$SUB_TRIGGER_NAME = "MenuSubTrigger";
var $860e6fb93642be7e$export$5fbbb3ba7297405f = $7fPBF.forwardRef((props, forwardedRef)=>{
    const context = $860e6fb93642be7e$var$useMenuContext($860e6fb93642be7e$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const rootContext = $860e6fb93642be7e$var$useMenuRootContext($860e6fb93642be7e$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const subContext = $860e6fb93642be7e$var$useMenuSubContext($860e6fb93642be7e$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const contentContext = $860e6fb93642be7e$var$useMenuContentContext($860e6fb93642be7e$var$SUB_TRIGGER_NAME, props.__scopeMenu);
    const openTimerRef = $7fPBF.useRef(null);
    const { pointerGraceTimerRef: pointerGraceTimerRef, onPointerGraceIntentChange: onPointerGraceIntentChange } = contentContext;
    const scope = {
        __scopeMenu: props.__scopeMenu
    };
    const clearOpenTimer = $7fPBF.useCallback(()=>{
        if (openTimerRef.current) window.clearTimeout(openTimerRef.current);
        openTimerRef.current = null;
    }, []);
    $7fPBF.useEffect(()=>clearOpenTimer, [
        clearOpenTimer
    ]);
    $7fPBF.useEffect(()=>{
        const pointerGraceTimer = pointerGraceTimerRef.current;
        return ()=>{
            window.clearTimeout(pointerGraceTimer);
            onPointerGraceIntentChange(null);
        };
    }, [
        pointerGraceTimerRef,
        onPointerGraceIntentChange
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$9fa5ebd18bee4d43, {
        asChild: true,
        ...scope,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$var$MenuItemImpl, {
            id: subContext.triggerId,
            "aria-haspopup": "menu",
            "aria-expanded": context.open,
            "aria-controls": subContext.contentId,
            "data-state": $860e6fb93642be7e$var$getOpenState(context.open),
            ...props,
            ref: (0, $2d44b7cb84ff0f1c$export$43e446d32b3d21af)(forwardedRef, subContext.onTriggerChange),
            onClick: (event)=>{
                var _props_onClick;
                (_props_onClick = props.onClick) === null || _props_onClick === void 0 ? void 0 : _props_onClick.call(props, event);
                if (props.disabled || event.defaultPrevented) return;
                event.currentTarget.focus();
                if (!context.open) context.onOpenChange(true);
            },
            onPointerMove: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerMove, $860e6fb93642be7e$var$whenMouse((event)=>{
                contentContext.onItemEnter(event);
                if (event.defaultPrevented) return;
                if (!props.disabled && !context.open && !openTimerRef.current) {
                    contentContext.onPointerGraceIntentChange(null);
                    openTimerRef.current = window.setTimeout(()=>{
                        context.onOpenChange(true);
                        clearOpenTimer();
                    }, 100);
                }
            })),
            onPointerLeave: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerLeave, $860e6fb93642be7e$var$whenMouse((event)=>{
                var _context_content;
                clearOpenTimer();
                const contentRect = (_context_content = context.content) === null || _context_content === void 0 ? void 0 : _context_content.getBoundingClientRect();
                if (contentRect) {
                    var _context_content1;
                    const side = (_context_content1 = context.content) === null || _context_content1 === void 0 ? void 0 : _context_content1.dataset.side;
                    const rightSide = side === "right";
                    const bleed = rightSide ? -5 : 5;
                    const contentNearEdge = contentRect[rightSide ? "left" : "right"];
                    const contentFarEdge = contentRect[rightSide ? "right" : "left"];
                    contentContext.onPointerGraceIntentChange({
                        area: [
                            // Apply a bleed on clientX to ensure that our exit point is
                            // consistently within polygon bounds
                            {
                                x: event.clientX + bleed,
                                y: event.clientY
                            },
                            {
                                x: contentNearEdge,
                                y: contentRect.top
                            },
                            {
                                x: contentFarEdge,
                                y: contentRect.top
                            },
                            {
                                x: contentFarEdge,
                                y: contentRect.bottom
                            },
                            {
                                x: contentNearEdge,
                                y: contentRect.bottom
                            }
                        ],
                        side: side
                    });
                    window.clearTimeout(pointerGraceTimerRef.current);
                    pointerGraceTimerRef.current = window.setTimeout(()=>contentContext.onPointerGraceIntentChange(null), 300);
                } else {
                    contentContext.onTriggerLeave(event);
                    if (event.defaultPrevented) return;
                    contentContext.onPointerGraceIntentChange(null);
                }
            })),
            onKeyDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                const isTypingAhead = contentContext.searchRef.current !== "";
                if (props.disabled || isTypingAhead && event.key === " ") return;
                if ($860e6fb93642be7e$var$SUB_OPEN_KEYS[rootContext.dir].includes(event.key)) {
                    var _context_content;
                    context.onOpenChange(true);
                    (_context_content = context.content) === null || _context_content === void 0 ? void 0 : _context_content.focus();
                    event.preventDefault();
                }
            })
        })
    });
});
$860e6fb93642be7e$export$5fbbb3ba7297405f.displayName = $860e6fb93642be7e$var$SUB_TRIGGER_NAME;
var $860e6fb93642be7e$var$SUB_CONTENT_NAME = "MenuSubContent";
var $860e6fb93642be7e$export$e7142ab31822bde6 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const portalContext = $860e6fb93642be7e$var$usePortalContext($860e6fb93642be7e$var$CONTENT_NAME, props.__scopeMenu);
    const { forceMount: forceMount = portalContext.forceMount, ...subContentProps } = props;
    const context = $860e6fb93642be7e$var$useMenuContext($860e6fb93642be7e$var$CONTENT_NAME, props.__scopeMenu);
    const rootContext = $860e6fb93642be7e$var$useMenuRootContext($860e6fb93642be7e$var$CONTENT_NAME, props.__scopeMenu);
    const subContext = $860e6fb93642be7e$var$useMenuSubContext($860e6fb93642be7e$var$SUB_CONTENT_NAME, props.__scopeMenu);
    const ref = $7fPBF.useRef(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$var$Collection.Provider, {
        scope: props.__scopeMenu,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $e9ce08b8e6e14786$export$99c2b779aa4e8b8b), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$var$Collection.Slot, {
                scope: props.__scopeMenu,
                children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$var$MenuContentImpl, {
                    id: subContext.contentId,
                    "aria-labelledby": subContext.triggerId,
                    ...subContentProps,
                    ref: composedRefs,
                    align: "start",
                    side: rootContext.dir === "rtl" ? "left" : "right",
                    disableOutsidePointerEvents: false,
                    disableOutsideScroll: false,
                    trapFocus: false,
                    onOpenAutoFocus: (event)=>{
                        var _ref_current;
                        if (rootContext.isUsingKeyboardRef.current) (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.focus();
                        event.preventDefault();
                    },
                    onCloseAutoFocus: (event)=>event.preventDefault(),
                    onFocusOutside: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>{
                        if (event.target !== subContext.trigger) context.onOpenChange(false);
                    }),
                    onEscapeKeyDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onEscapeKeyDown, (event)=>{
                        rootContext.onClose();
                        event.preventDefault();
                    }),
                    onKeyDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                        const isKeyDownInside = event.currentTarget.contains(event.target);
                        const isCloseKey = $860e6fb93642be7e$var$SUB_CLOSE_KEYS[rootContext.dir].includes(event.key);
                        if (isKeyDownInside && isCloseKey) {
                            var _subContext_trigger;
                            context.onOpenChange(false);
                            (_subContext_trigger = subContext.trigger) === null || _subContext_trigger === void 0 ? void 0 : _subContext_trigger.focus();
                            event.preventDefault();
                        }
                    })
                })
            })
        })
    });
});
$860e6fb93642be7e$export$e7142ab31822bde6.displayName = $860e6fb93642be7e$var$SUB_CONTENT_NAME;
function $860e6fb93642be7e$var$getOpenState(open) {
    return open ? "open" : "closed";
}
function $860e6fb93642be7e$var$isIndeterminate(checked) {
    return checked === "indeterminate";
}
function $860e6fb93642be7e$var$getCheckedState(checked) {
    return $860e6fb93642be7e$var$isIndeterminate(checked) ? "indeterminate" : checked ? "checked" : "unchecked";
}
function $860e6fb93642be7e$var$focusFirst(candidates) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus();
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
function $860e6fb93642be7e$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
function $860e6fb93642be7e$var$getNextMatch(values, search, currentMatch) {
    const isRepeated = search.length > 1 && Array.from(search).every((char)=>char === search[0]);
    const normalizedSearch = isRepeated ? search[0] : search;
    const currentMatchIndex = currentMatch ? values.indexOf(currentMatch) : -1;
    let wrappedValues = $860e6fb93642be7e$var$wrapArray(values, Math.max(currentMatchIndex, 0));
    const excludeCurrentMatch = normalizedSearch.length === 1;
    if (excludeCurrentMatch) wrappedValues = wrappedValues.filter((v)=>v !== currentMatch);
    const nextMatch = wrappedValues.find((value)=>value.toLowerCase().startsWith(normalizedSearch.toLowerCase()));
    return nextMatch !== currentMatch ? nextMatch : void 0;
}
function $860e6fb93642be7e$var$isPointInPolygon(point, polygon) {
    const { x: x, y: y } = point;
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const xi = polygon[i].x;
        const yi = polygon[i].y;
        const xj = polygon[j].x;
        const yj = polygon[j].y;
        const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
}
function $860e6fb93642be7e$var$isPointerInGraceArea(event, area) {
    if (!area) return false;
    const cursorPos = {
        x: event.clientX,
        y: event.clientY
    };
    return $860e6fb93642be7e$var$isPointInPolygon(cursorPos, area);
}
function $860e6fb93642be7e$var$whenMouse(handler) {
    return (event)=>event.pointerType === "mouse" ? handler(event) : void 0;
}
var $860e6fb93642be7e$export$be92b6f5f03c0fe9 = $860e6fb93642be7e$export$d9b273488cd8ce6f;
var $860e6fb93642be7e$export$b688253958b8dfe7 = $860e6fb93642be7e$export$9fa5ebd18bee4d43;
var $860e6fb93642be7e$export$602eac185826482c = $860e6fb93642be7e$export$793392f970497feb;
var $860e6fb93642be7e$export$7c6e2c02157bb7d2 = $860e6fb93642be7e$export$479f0f2f71193efe;
var $860e6fb93642be7e$export$eb2fcfdbd7ba97d4 = $860e6fb93642be7e$export$22a631d1f72787bb;
var $860e6fb93642be7e$export$b04be29aa201d4f5 = $860e6fb93642be7e$export$dd37bec0e8a99143;
var $860e6fb93642be7e$export$6d08773d2e66f8f2 = $860e6fb93642be7e$export$2ce376c2cc3355c8;
var $860e6fb93642be7e$export$16ce288f89fa631c = $860e6fb93642be7e$export$f6f243521332502d;
var $860e6fb93642be7e$export$a98f0dcb43a68a25 = $860e6fb93642be7e$export$ea2200c9eee416b3;
var $860e6fb93642be7e$export$371ab307eab489c0 = $860e6fb93642be7e$export$69bd225e9817f6d0;
var $860e6fb93642be7e$export$c3468e2714d175fa = $860e6fb93642be7e$export$a2593e23056970a3;
var $860e6fb93642be7e$export$1ff3c3f08ae963c0 = $860e6fb93642be7e$export$1cec7dcdd713e220;
var $860e6fb93642be7e$export$21b07c8f274aebd5 = $860e6fb93642be7e$export$bcdda4773debf5fa;
var $860e6fb93642be7e$export$d7a01e11500dfb6f = $860e6fb93642be7e$export$71bdb9d1e2909932;
var $860e6fb93642be7e$export$2ea8a7a591ac5eac = $860e6fb93642be7e$export$5fbbb3ba7297405f;
var $860e6fb93642be7e$export$6d4de93b380beddf = $860e6fb93642be7e$export$e7142ab31822bde6;





"use client";
var $ace24827494fe46d$var$CONTEXT_MENU_NAME = "ContextMenu";
var [$ace24827494fe46d$var$createContextMenuContext, $ace24827494fe46d$export$1059331f43ddcc82] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)($ace24827494fe46d$var$CONTEXT_MENU_NAME, [
    (0, $860e6fb93642be7e$export$4027731b685e72eb)
]);
var $ace24827494fe46d$var$useMenuScope = (0, $860e6fb93642be7e$export$4027731b685e72eb)();
var [$ace24827494fe46d$var$ContextMenuProvider, $ace24827494fe46d$var$useContextMenuContext] = $ace24827494fe46d$var$createContextMenuContext($ace24827494fe46d$var$CONTEXT_MENU_NAME);
var $ace24827494fe46d$export$8dc6765e8be191c7 = (props)=>{
    const { __scopeContextMenu: __scopeContextMenu, children: children, onOpenChange: onOpenChange, dir: dir, modal: modal = true } = props;
    const [open, setOpen] = $7fPBF.useState(false);
    const menuScope = $ace24827494fe46d$var$useMenuScope(__scopeContextMenu);
    const handleOpenChangeProp = (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(onOpenChange);
    const handleOpenChange = $7fPBF.useCallback((open2)=>{
        setOpen(open2);
        handleOpenChangeProp(open2);
    }, [
        handleOpenChangeProp
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($ace24827494fe46d$var$ContextMenuProvider, {
        scope: __scopeContextMenu,
        open: open,
        onOpenChange: handleOpenChange,
        modal: modal,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$be92b6f5f03c0fe9, {
            ...menuScope,
            dir: dir,
            open: open,
            onOpenChange: handleOpenChange,
            modal: modal,
            children: children
        })
    });
};
$ace24827494fe46d$export$8dc6765e8be191c7.displayName = $ace24827494fe46d$var$CONTEXT_MENU_NAME;
var $ace24827494fe46d$var$TRIGGER_NAME = "ContextMenuTrigger";
var $ace24827494fe46d$export$be6fc7b1d5b0beb9 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeContextMenu: __scopeContextMenu, disabled: disabled = false, ...triggerProps } = props;
    const context = $ace24827494fe46d$var$useContextMenuContext($ace24827494fe46d$var$TRIGGER_NAME, __scopeContextMenu);
    const menuScope = $ace24827494fe46d$var$useMenuScope(__scopeContextMenu);
    const pointRef = $7fPBF.useRef({
        x: 0,
        y: 0
    });
    const virtualRef = $7fPBF.useRef({
        getBoundingClientRect: ()=>DOMRect.fromRect({
                width: 0,
                height: 0,
                ...pointRef.current
            })
    });
    const longPressTimerRef = $7fPBF.useRef(0);
    const clearLongPress = $7fPBF.useCallback(()=>window.clearTimeout(longPressTimerRef.current), []);
    const handleOpen = (event)=>{
        pointRef.current = {
            x: event.clientX,
            y: event.clientY
        };
        context.onOpenChange(true);
    };
    $7fPBF.useEffect(()=>clearLongPress, [
        clearLongPress
    ]);
    $7fPBF.useEffect(()=>void (disabled && clearLongPress()), [
        disabled,
        clearLongPress
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$b688253958b8dfe7, {
                ...menuScope,
                virtualRef: virtualRef
            }),
            /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).span, {
                "data-state": context.open ? "open" : "closed",
                "data-disabled": disabled ? "" : void 0,
                ...triggerProps,
                ref: forwardedRef,
                style: {
                    WebkitTouchCallout: "none",
                    ...props.style
                },
                onContextMenu: disabled ? props.onContextMenu : (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onContextMenu, (event)=>{
                    clearLongPress();
                    handleOpen(event);
                    event.preventDefault();
                }),
                onPointerDown: disabled ? props.onPointerDown : (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerDown, $ace24827494fe46d$var$whenTouchOrPen((event)=>{
                    clearLongPress();
                    longPressTimerRef.current = window.setTimeout(()=>handleOpen(event), 700);
                })),
                onPointerMove: disabled ? props.onPointerMove : (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerMove, $ace24827494fe46d$var$whenTouchOrPen(clearLongPress)),
                onPointerCancel: disabled ? props.onPointerCancel : (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerCancel, $ace24827494fe46d$var$whenTouchOrPen(clearLongPress)),
                onPointerUp: disabled ? props.onPointerUp : (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerUp, $ace24827494fe46d$var$whenTouchOrPen(clearLongPress))
            })
        ]
    });
});
$ace24827494fe46d$export$be6fc7b1d5b0beb9.displayName = $ace24827494fe46d$var$TRIGGER_NAME;
var $ace24827494fe46d$var$PORTAL_NAME = "ContextMenuPortal";
var $ace24827494fe46d$export$14afd0be83e45060 = (props)=>{
    const { __scopeContextMenu: __scopeContextMenu, ...portalProps } = props;
    const menuScope = $ace24827494fe46d$var$useMenuScope(__scopeContextMenu);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$602eac185826482c, {
        ...menuScope,
        ...portalProps
    });
};
$ace24827494fe46d$export$14afd0be83e45060.displayName = $ace24827494fe46d$var$PORTAL_NAME;
var $ace24827494fe46d$var$CONTENT_NAME = "ContextMenuContent";
var $ace24827494fe46d$export$572205900c9369e = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeContextMenu: __scopeContextMenu, ...contentProps } = props;
    const context = $ace24827494fe46d$var$useContextMenuContext($ace24827494fe46d$var$CONTENT_NAME, __scopeContextMenu);
    const menuScope = $ace24827494fe46d$var$useMenuScope(__scopeContextMenu);
    const hasInteractedOutsideRef = $7fPBF.useRef(false);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$7c6e2c02157bb7d2, {
        ...menuScope,
        ...contentProps,
        ref: forwardedRef,
        side: "right",
        sideOffset: 2,
        align: "start",
        onCloseAutoFocus: (event)=>{
            var _props_onCloseAutoFocus;
            (_props_onCloseAutoFocus = props.onCloseAutoFocus) === null || _props_onCloseAutoFocus === void 0 ? void 0 : _props_onCloseAutoFocus.call(props, event);
            if (!event.defaultPrevented && hasInteractedOutsideRef.current) event.preventDefault();
            hasInteractedOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            var _props_onInteractOutside;
            (_props_onInteractOutside = props.onInteractOutside) === null || _props_onInteractOutside === void 0 ? void 0 : _props_onInteractOutside.call(props, event);
            if (!event.defaultPrevented && !context.modal) hasInteractedOutsideRef.current = true;
        },
        style: {
            ...props.style,
            "--radix-context-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-context-menu-content-available-width": "var(--radix-popper-available-width)",
            "--radix-context-menu-content-available-height": "var(--radix-popper-available-height)",
            "--radix-context-menu-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-context-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
    });
});
$ace24827494fe46d$export$572205900c9369e.displayName = $ace24827494fe46d$var$CONTENT_NAME;
var $ace24827494fe46d$var$GROUP_NAME = "ContextMenuGroup";
var $ace24827494fe46d$export$9860523b0fcdd664 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeContextMenu: __scopeContextMenu, ...groupProps } = props;
    const menuScope = $ace24827494fe46d$var$useMenuScope(__scopeContextMenu);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$eb2fcfdbd7ba97d4, {
        ...menuScope,
        ...groupProps,
        ref: forwardedRef
    });
});
$ace24827494fe46d$export$9860523b0fcdd664.displayName = $ace24827494fe46d$var$GROUP_NAME;
var $ace24827494fe46d$var$LABEL_NAME = "ContextMenuLabel";
var $ace24827494fe46d$export$d4b9d3b609a10742 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeContextMenu: __scopeContextMenu, ...labelProps } = props;
    const menuScope = $ace24827494fe46d$var$useMenuScope(__scopeContextMenu);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$b04be29aa201d4f5, {
        ...menuScope,
        ...labelProps,
        ref: forwardedRef
    });
});
$ace24827494fe46d$export$d4b9d3b609a10742.displayName = $ace24827494fe46d$var$LABEL_NAME;
var $ace24827494fe46d$var$ITEM_NAME = "ContextMenuItem";
var $ace24827494fe46d$export$16a26dc176a49100 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeContextMenu: __scopeContextMenu, ...itemProps } = props;
    const menuScope = $ace24827494fe46d$var$useMenuScope(__scopeContextMenu);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$6d08773d2e66f8f2, {
        ...menuScope,
        ...itemProps,
        ref: forwardedRef
    });
});
$ace24827494fe46d$export$16a26dc176a49100.displayName = $ace24827494fe46d$var$ITEM_NAME;
var $ace24827494fe46d$var$CHECKBOX_ITEM_NAME = "ContextMenuCheckboxItem";
var $ace24827494fe46d$export$b6adbe51d5d8b7ec = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeContextMenu: __scopeContextMenu, ...checkboxItemProps } = props;
    const menuScope = $ace24827494fe46d$var$useMenuScope(__scopeContextMenu);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$16ce288f89fa631c, {
        ...menuScope,
        ...checkboxItemProps,
        ref: forwardedRef
    });
});
$ace24827494fe46d$export$b6adbe51d5d8b7ec.displayName = $ace24827494fe46d$var$CHECKBOX_ITEM_NAME;
var $ace24827494fe46d$var$RADIO_GROUP_NAME = "ContextMenuRadioGroup";
var $ace24827494fe46d$export$db5c89af5ed9aa07 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeContextMenu: __scopeContextMenu, ...radioGroupProps } = props;
    const menuScope = $ace24827494fe46d$var$useMenuScope(__scopeContextMenu);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$a98f0dcb43a68a25, {
        ...menuScope,
        ...radioGroupProps,
        ref: forwardedRef
    });
});
$ace24827494fe46d$export$db5c89af5ed9aa07.displayName = $ace24827494fe46d$var$RADIO_GROUP_NAME;
var $ace24827494fe46d$var$RADIO_ITEM_NAME = "ContextMenuRadioItem";
var $ace24827494fe46d$export$8a727d09a7d9bfc2 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeContextMenu: __scopeContextMenu, ...radioItemProps } = props;
    const menuScope = $ace24827494fe46d$var$useMenuScope(__scopeContextMenu);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$371ab307eab489c0, {
        ...menuScope,
        ...radioItemProps,
        ref: forwardedRef
    });
});
$ace24827494fe46d$export$8a727d09a7d9bfc2.displayName = $ace24827494fe46d$var$RADIO_ITEM_NAME;
var $ace24827494fe46d$var$INDICATOR_NAME = "ContextMenuItemIndicator";
var $ace24827494fe46d$export$9ed8194dee42d94b = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeContextMenu: __scopeContextMenu, ...itemIndicatorProps } = props;
    const menuScope = $ace24827494fe46d$var$useMenuScope(__scopeContextMenu);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$c3468e2714d175fa, {
        ...menuScope,
        ...itemIndicatorProps,
        ref: forwardedRef
    });
});
$ace24827494fe46d$export$9ed8194dee42d94b.displayName = $ace24827494fe46d$var$INDICATOR_NAME;
var $ace24827494fe46d$var$SEPARATOR_NAME = "ContextMenuSeparator";
var $ace24827494fe46d$export$8d6b009fadfe1207 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeContextMenu: __scopeContextMenu, ...separatorProps } = props;
    const menuScope = $ace24827494fe46d$var$useMenuScope(__scopeContextMenu);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$1ff3c3f08ae963c0, {
        ...menuScope,
        ...separatorProps,
        ref: forwardedRef
    });
});
$ace24827494fe46d$export$8d6b009fadfe1207.displayName = $ace24827494fe46d$var$SEPARATOR_NAME;
var $ace24827494fe46d$var$ARROW_NAME = "ContextMenuArrow";
var $ace24827494fe46d$export$f47d0a58228a61e2 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeContextMenu: __scopeContextMenu, ...arrowProps } = props;
    const menuScope = $ace24827494fe46d$var$useMenuScope(__scopeContextMenu);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$21b07c8f274aebd5, {
        ...menuScope,
        ...arrowProps,
        ref: forwardedRef
    });
});
$ace24827494fe46d$export$f47d0a58228a61e2.displayName = $ace24827494fe46d$var$ARROW_NAME;
var $ace24827494fe46d$var$SUB_NAME = "ContextMenuSub";
var $ace24827494fe46d$export$5bc21d1c00c4b201 = (props)=>{
    const { __scopeContextMenu: __scopeContextMenu, children: children, onOpenChange: onOpenChange, open: openProp, defaultOpen: defaultOpen } = props;
    const menuScope = $ace24827494fe46d$var$useMenuScope(__scopeContextMenu);
    const [open, setOpen] = (0, $915387e6ab4d88b1$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$d7a01e11500dfb6f, {
        ...menuScope,
        open: open,
        onOpenChange: setOpen,
        children: children
    });
};
$ace24827494fe46d$export$5bc21d1c00c4b201.displayName = $ace24827494fe46d$var$SUB_NAME;
var $ace24827494fe46d$var$SUB_TRIGGER_NAME = "ContextMenuSubTrigger";
var $ace24827494fe46d$export$30b2b5c64556d316 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeContextMenu: __scopeContextMenu, ...triggerItemProps } = props;
    const menuScope = $ace24827494fe46d$var$useMenuScope(__scopeContextMenu);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$2ea8a7a591ac5eac, {
        ...menuScope,
        ...triggerItemProps,
        ref: forwardedRef
    });
});
$ace24827494fe46d$export$30b2b5c64556d316.displayName = $ace24827494fe46d$var$SUB_TRIGGER_NAME;
var $ace24827494fe46d$var$SUB_CONTENT_NAME = "ContextMenuSubContent";
var $ace24827494fe46d$export$2c967063bd2dc512 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeContextMenu: __scopeContextMenu, ...subContentProps } = props;
    const menuScope = $ace24827494fe46d$var$useMenuScope(__scopeContextMenu);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$6d4de93b380beddf, {
        ...menuScope,
        ...subContentProps,
        ref: forwardedRef,
        style: {
            ...props.style,
            "--radix-context-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-context-menu-content-available-width": "var(--radix-popper-available-width)",
            "--radix-context-menu-content-available-height": "var(--radix-popper-available-height)",
            "--radix-context-menu-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-context-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
    });
});
$ace24827494fe46d$export$2c967063bd2dc512.displayName = $ace24827494fe46d$var$SUB_CONTENT_NAME;
function $ace24827494fe46d$var$whenTouchOrPen(handler) {
    return (event)=>event.pointerType !== "mouse" ? handler(event) : void 0;
}
var $ace24827494fe46d$export$be92b6f5f03c0fe9 = $ace24827494fe46d$export$8dc6765e8be191c7;
var $ace24827494fe46d$export$41fb9f06171c75f4 = $ace24827494fe46d$export$be6fc7b1d5b0beb9;
var $ace24827494fe46d$export$602eac185826482c = $ace24827494fe46d$export$14afd0be83e45060;
var $ace24827494fe46d$export$7c6e2c02157bb7d2 = $ace24827494fe46d$export$572205900c9369e;
var $ace24827494fe46d$export$eb2fcfdbd7ba97d4 = $ace24827494fe46d$export$9860523b0fcdd664;
var $ace24827494fe46d$export$b04be29aa201d4f5 = $ace24827494fe46d$export$d4b9d3b609a10742;
var $ace24827494fe46d$export$6d08773d2e66f8f2 = $ace24827494fe46d$export$16a26dc176a49100;
var $ace24827494fe46d$export$16ce288f89fa631c = $ace24827494fe46d$export$b6adbe51d5d8b7ec;
var $ace24827494fe46d$export$a98f0dcb43a68a25 = $ace24827494fe46d$export$db5c89af5ed9aa07;
var $ace24827494fe46d$export$371ab307eab489c0 = $ace24827494fe46d$export$8a727d09a7d9bfc2;
var $ace24827494fe46d$export$c3468e2714d175fa = $ace24827494fe46d$export$9ed8194dee42d94b;
var $ace24827494fe46d$export$1ff3c3f08ae963c0 = $ace24827494fe46d$export$8d6b009fadfe1207;
var $ace24827494fe46d$export$21b07c8f274aebd5 = $ace24827494fe46d$export$f47d0a58228a61e2;
var $ace24827494fe46d$export$d7a01e11500dfb6f = $ace24827494fe46d$export$5bc21d1c00c4b201;
var $ace24827494fe46d$export$2ea8a7a591ac5eac = $ace24827494fe46d$export$30b2b5c64556d316;
var $ace24827494fe46d$export$6d4de93b380beddf = $ace24827494fe46d$export$2c967063bd2dc512;




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");







// packages/core/number/src/number.ts
function $6d53081595419ec4$export$7d15b64cf5a3a4c4(value, [min, max]) {
    return Math.min(max, Math.max(min, value));
}




"use client";
function $25e27e390e2ae51e$var$useStateMachine(initialState, machine) {
    return $7fPBF.useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}
var $25e27e390e2ae51e$var$SCROLL_AREA_NAME = "ScrollArea";
var [$25e27e390e2ae51e$var$createScrollAreaContext, $25e27e390e2ae51e$export$488468afe3a6f2b1] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)($25e27e390e2ae51e$var$SCROLL_AREA_NAME);
var [$25e27e390e2ae51e$var$ScrollAreaProvider, $25e27e390e2ae51e$var$useScrollAreaContext] = $25e27e390e2ae51e$var$createScrollAreaContext($25e27e390e2ae51e$var$SCROLL_AREA_NAME);
var $25e27e390e2ae51e$export$ccf8d8d7bbf3c2cc = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeScrollArea: __scopeScrollArea, type: type = "hover", dir: dir, scrollHideDelay: scrollHideDelay = 600, ...scrollAreaProps } = props;
    const [scrollArea, setScrollArea] = $7fPBF.useState(null);
    const [viewport, setViewport] = $7fPBF.useState(null);
    const [content, setContent] = $7fPBF.useState(null);
    const [scrollbarX, setScrollbarX] = $7fPBF.useState(null);
    const [scrollbarY, setScrollbarY] = $7fPBF.useState(null);
    const [cornerWidth, setCornerWidth] = $7fPBF.useState(0);
    const [cornerHeight, setCornerHeight] = $7fPBF.useState(0);
    const [scrollbarXEnabled, setScrollbarXEnabled] = $7fPBF.useState(false);
    const [scrollbarYEnabled, setScrollbarYEnabled] = $7fPBF.useState(false);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setScrollArea(node));
    const direction = (0, $3342477e04611d10$export$b39126d51d94e6f3)(dir);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($25e27e390e2ae51e$var$ScrollAreaProvider, {
        scope: __scopeScrollArea,
        type: type,
        dir: direction,
        scrollHideDelay: scrollHideDelay,
        scrollArea: scrollArea,
        viewport: viewport,
        onViewportChange: setViewport,
        content: content,
        onContentChange: setContent,
        scrollbarX: scrollbarX,
        onScrollbarXChange: setScrollbarX,
        scrollbarXEnabled: scrollbarXEnabled,
        onScrollbarXEnabledChange: setScrollbarXEnabled,
        scrollbarY: scrollbarY,
        onScrollbarYChange: setScrollbarY,
        scrollbarYEnabled: scrollbarYEnabled,
        onScrollbarYEnabledChange: setScrollbarYEnabled,
        onCornerWidthChange: setCornerWidth,
        onCornerHeightChange: setCornerHeight,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
            dir: direction,
            ...scrollAreaProps,
            ref: composedRefs,
            style: {
                position: "relative",
                // Pass corner sizes as CSS vars to reduce re-renders of context consumers
                ["--radix-scroll-area-corner-width"]: cornerWidth + "px",
                ["--radix-scroll-area-corner-height"]: cornerHeight + "px",
                ...props.style
            }
        })
    });
});
$25e27e390e2ae51e$export$ccf8d8d7bbf3c2cc.displayName = $25e27e390e2ae51e$var$SCROLL_AREA_NAME;
var $25e27e390e2ae51e$var$VIEWPORT_NAME = "ScrollAreaViewport";
var $25e27e390e2ae51e$export$a21cbf9f11fca853 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeScrollArea: __scopeScrollArea, children: children, nonce: nonce, ...viewportProps } = props;
    const context = $25e27e390e2ae51e$var$useScrollAreaContext($25e27e390e2ae51e$var$VIEWPORT_NAME, __scopeScrollArea);
    const ref = $7fPBF.useRef(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, ref, context.onViewportChange);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("style", {
                dangerouslySetInnerHTML: {
                    __html: `[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}`
                },
                nonce: nonce
            }),
            /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
                "data-radix-scroll-area-viewport": "",
                ...viewportProps,
                ref: composedRefs,
                style: {
                    /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflowed#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */ overflowX: context.scrollbarXEnabled ? "scroll" : "hidden",
                    overflowY: context.scrollbarYEnabled ? "scroll" : "hidden",
                    ...props.style
                },
                children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("div", {
                    ref: context.onContentChange,
                    style: {
                        minWidth: "100%",
                        display: "table"
                    },
                    children: children
                })
            })
        ]
    });
});
$25e27e390e2ae51e$export$a21cbf9f11fca853.displayName = $25e27e390e2ae51e$var$VIEWPORT_NAME;
var $25e27e390e2ae51e$var$SCROLLBAR_NAME = "ScrollAreaScrollbar";
var $25e27e390e2ae51e$export$2fabd85d0eba3c57 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { forceMount: forceMount, ...scrollbarProps } = props;
    const context = $25e27e390e2ae51e$var$useScrollAreaContext($25e27e390e2ae51e$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const { onScrollbarXEnabledChange: onScrollbarXEnabledChange, onScrollbarYEnabledChange: onScrollbarYEnabledChange } = context;
    const isHorizontal = props.orientation === "horizontal";
    $7fPBF.useEffect(()=>{
        isHorizontal ? onScrollbarXEnabledChange(true) : onScrollbarYEnabledChange(true);
        return ()=>{
            isHorizontal ? onScrollbarXEnabledChange(false) : onScrollbarYEnabledChange(false);
        };
    }, [
        isHorizontal,
        onScrollbarXEnabledChange,
        onScrollbarYEnabledChange
    ]);
    return context.type === "hover" ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($25e27e390e2ae51e$var$ScrollAreaScrollbarHover, {
        ...scrollbarProps,
        ref: forwardedRef,
        forceMount: forceMount
    }) : context.type === "scroll" ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($25e27e390e2ae51e$var$ScrollAreaScrollbarScroll, {
        ...scrollbarProps,
        ref: forwardedRef,
        forceMount: forceMount
    }) : context.type === "auto" ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($25e27e390e2ae51e$var$ScrollAreaScrollbarAuto, {
        ...scrollbarProps,
        ref: forwardedRef,
        forceMount: forceMount
    }) : context.type === "always" ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($25e27e390e2ae51e$var$ScrollAreaScrollbarVisible, {
        ...scrollbarProps,
        ref: forwardedRef
    }) : null;
});
$25e27e390e2ae51e$export$2fabd85d0eba3c57.displayName = $25e27e390e2ae51e$var$SCROLLBAR_NAME;
var $25e27e390e2ae51e$var$ScrollAreaScrollbarHover = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { forceMount: forceMount, ...scrollbarProps } = props;
    const context = $25e27e390e2ae51e$var$useScrollAreaContext($25e27e390e2ae51e$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const [visible, setVisible] = $7fPBF.useState(false);
    $7fPBF.useEffect(()=>{
        const scrollArea = context.scrollArea;
        let hideTimer = 0;
        if (scrollArea) {
            const handlePointerEnter = ()=>{
                window.clearTimeout(hideTimer);
                setVisible(true);
            };
            const handlePointerLeave = ()=>{
                hideTimer = window.setTimeout(()=>setVisible(false), context.scrollHideDelay);
            };
            scrollArea.addEventListener("pointerenter", handlePointerEnter);
            scrollArea.addEventListener("pointerleave", handlePointerLeave);
            return ()=>{
                window.clearTimeout(hideTimer);
                scrollArea.removeEventListener("pointerenter", handlePointerEnter);
                scrollArea.removeEventListener("pointerleave", handlePointerLeave);
            };
        }
    }, [
        context.scrollArea,
        context.scrollHideDelay
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $e9ce08b8e6e14786$export$99c2b779aa4e8b8b), {
        present: forceMount || visible,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($25e27e390e2ae51e$var$ScrollAreaScrollbarAuto, {
            "data-state": visible ? "visible" : "hidden",
            ...scrollbarProps,
            ref: forwardedRef
        })
    });
});
var $25e27e390e2ae51e$var$ScrollAreaScrollbarScroll = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { forceMount: forceMount, ...scrollbarProps } = props;
    const context = $25e27e390e2ae51e$var$useScrollAreaContext($25e27e390e2ae51e$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const isHorizontal = props.orientation === "horizontal";
    const debounceScrollEnd = $25e27e390e2ae51e$var$useDebounceCallback(()=>send("SCROLL_END"), 100);
    const [state, send] = $25e27e390e2ae51e$var$useStateMachine("hidden", {
        hidden: {
            SCROLL: "scrolling"
        },
        scrolling: {
            SCROLL_END: "idle",
            POINTER_ENTER: "interacting"
        },
        interacting: {
            SCROLL: "interacting",
            POINTER_LEAVE: "idle"
        },
        idle: {
            HIDE: "hidden",
            SCROLL: "scrolling",
            POINTER_ENTER: "interacting"
        }
    });
    $7fPBF.useEffect(()=>{
        if (state === "idle") {
            const hideTimer = window.setTimeout(()=>send("HIDE"), context.scrollHideDelay);
            return ()=>window.clearTimeout(hideTimer);
        }
    }, [
        state,
        context.scrollHideDelay,
        send
    ]);
    $7fPBF.useEffect(()=>{
        const viewport = context.viewport;
        const scrollDirection = isHorizontal ? "scrollLeft" : "scrollTop";
        if (viewport) {
            let prevScrollPos = viewport[scrollDirection];
            const handleScroll = ()=>{
                const scrollPos = viewport[scrollDirection];
                const hasScrollInDirectionChanged = prevScrollPos !== scrollPos;
                if (hasScrollInDirectionChanged) {
                    send("SCROLL");
                    debounceScrollEnd();
                }
                prevScrollPos = scrollPos;
            };
            viewport.addEventListener("scroll", handleScroll);
            return ()=>viewport.removeEventListener("scroll", handleScroll);
        }
    }, [
        context.viewport,
        isHorizontal,
        send,
        debounceScrollEnd
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $e9ce08b8e6e14786$export$99c2b779aa4e8b8b), {
        present: forceMount || state !== "hidden",
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($25e27e390e2ae51e$var$ScrollAreaScrollbarVisible, {
            "data-state": state === "hidden" ? "hidden" : "visible",
            ...scrollbarProps,
            ref: forwardedRef,
            onPointerEnter: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerEnter, ()=>send("POINTER_ENTER")),
            onPointerLeave: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerLeave, ()=>send("POINTER_LEAVE"))
        })
    });
});
var $25e27e390e2ae51e$var$ScrollAreaScrollbarAuto = $7fPBF.forwardRef((props, forwardedRef)=>{
    const context = $25e27e390e2ae51e$var$useScrollAreaContext($25e27e390e2ae51e$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const { forceMount: forceMount, ...scrollbarProps } = props;
    const [visible, setVisible] = $7fPBF.useState(false);
    const isHorizontal = props.orientation === "horizontal";
    const handleResize = $25e27e390e2ae51e$var$useDebounceCallback(()=>{
        if (context.viewport) {
            const isOverflowX = context.viewport.offsetWidth < context.viewport.scrollWidth;
            const isOverflowY = context.viewport.offsetHeight < context.viewport.scrollHeight;
            setVisible(isHorizontal ? isOverflowX : isOverflowY);
        }
    }, 10);
    $25e27e390e2ae51e$var$useResizeObserver(context.viewport, handleResize);
    $25e27e390e2ae51e$var$useResizeObserver(context.content, handleResize);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $e9ce08b8e6e14786$export$99c2b779aa4e8b8b), {
        present: forceMount || visible,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($25e27e390e2ae51e$var$ScrollAreaScrollbarVisible, {
            "data-state": visible ? "visible" : "hidden",
            ...scrollbarProps,
            ref: forwardedRef
        })
    });
});
var $25e27e390e2ae51e$var$ScrollAreaScrollbarVisible = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { orientation: orientation = "vertical", ...scrollbarProps } = props;
    const context = $25e27e390e2ae51e$var$useScrollAreaContext($25e27e390e2ae51e$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const thumbRef = $7fPBF.useRef(null);
    const pointerOffsetRef = $7fPBF.useRef(0);
    const [sizes, setSizes] = $7fPBF.useState({
        content: 0,
        viewport: 0,
        scrollbar: {
            size: 0,
            paddingStart: 0,
            paddingEnd: 0
        }
    });
    const thumbRatio = $25e27e390e2ae51e$var$getThumbRatio(sizes.viewport, sizes.content);
    const commonProps = {
        ...scrollbarProps,
        sizes: sizes,
        onSizesChange: setSizes,
        hasThumb: Boolean(thumbRatio > 0 && thumbRatio < 1),
        onThumbChange: (thumb)=>thumbRef.current = thumb,
        onThumbPointerUp: ()=>pointerOffsetRef.current = 0,
        onThumbPointerDown: (pointerPos)=>pointerOffsetRef.current = pointerPos
    };
    function getScrollPosition(pointerPos, dir) {
        return $25e27e390e2ae51e$var$getScrollPositionFromPointer(pointerPos, pointerOffsetRef.current, sizes, dir);
    }
    if (orientation === "horizontal") return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($25e27e390e2ae51e$var$ScrollAreaScrollbarX, {
        ...commonProps,
        ref: forwardedRef,
        onThumbPositionChange: ()=>{
            if (context.viewport && thumbRef.current) {
                const scrollPos = context.viewport.scrollLeft;
                const offset = $25e27e390e2ae51e$var$getThumbOffsetFromScroll(scrollPos, sizes, context.dir);
                thumbRef.current.style.transform = `translate3d(${offset}px, 0, 0)`;
            }
        },
        onWheelScroll: (scrollPos)=>{
            if (context.viewport) context.viewport.scrollLeft = scrollPos;
        },
        onDragScroll: (pointerPos)=>{
            if (context.viewport) context.viewport.scrollLeft = getScrollPosition(pointerPos, context.dir);
        }
    });
    if (orientation === "vertical") return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($25e27e390e2ae51e$var$ScrollAreaScrollbarY, {
        ...commonProps,
        ref: forwardedRef,
        onThumbPositionChange: ()=>{
            if (context.viewport && thumbRef.current) {
                const scrollPos = context.viewport.scrollTop;
                const offset = $25e27e390e2ae51e$var$getThumbOffsetFromScroll(scrollPos, sizes);
                thumbRef.current.style.transform = `translate3d(0, ${offset}px, 0)`;
            }
        },
        onWheelScroll: (scrollPos)=>{
            if (context.viewport) context.viewport.scrollTop = scrollPos;
        },
        onDragScroll: (pointerPos)=>{
            if (context.viewport) context.viewport.scrollTop = getScrollPosition(pointerPos);
        }
    });
    return null;
});
var $25e27e390e2ae51e$var$ScrollAreaScrollbarX = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { sizes: sizes, onSizesChange: onSizesChange, ...scrollbarProps } = props;
    const context = $25e27e390e2ae51e$var$useScrollAreaContext($25e27e390e2ae51e$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const [computedStyle, setComputedStyle] = $7fPBF.useState();
    const ref = $7fPBF.useRef(null);
    const composeRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, ref, context.onScrollbarXChange);
    $7fPBF.useEffect(()=>{
        if (ref.current) setComputedStyle(getComputedStyle(ref.current));
    }, [
        ref
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($25e27e390e2ae51e$var$ScrollAreaScrollbarImpl, {
        "data-orientation": "horizontal",
        ...scrollbarProps,
        ref: composeRefs,
        sizes: sizes,
        style: {
            bottom: 0,
            left: context.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
            right: context.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
            ["--radix-scroll-area-thumb-width"]: $25e27e390e2ae51e$var$getThumbSize(sizes) + "px",
            ...props.style
        },
        onThumbPointerDown: (pointerPos)=>props.onThumbPointerDown(pointerPos.x),
        onDragScroll: (pointerPos)=>props.onDragScroll(pointerPos.x),
        onWheelScroll: (event, maxScrollPos)=>{
            if (context.viewport) {
                const scrollPos = context.viewport.scrollLeft + event.deltaX;
                props.onWheelScroll(scrollPos);
                if ($25e27e390e2ae51e$var$isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos)) event.preventDefault();
            }
        },
        onResize: ()=>{
            if (ref.current && context.viewport && computedStyle) onSizesChange({
                content: context.viewport.scrollWidth,
                viewport: context.viewport.offsetWidth,
                scrollbar: {
                    size: ref.current.clientWidth,
                    paddingStart: $25e27e390e2ae51e$var$toInt(computedStyle.paddingLeft),
                    paddingEnd: $25e27e390e2ae51e$var$toInt(computedStyle.paddingRight)
                }
            });
        }
    });
});
var $25e27e390e2ae51e$var$ScrollAreaScrollbarY = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { sizes: sizes, onSizesChange: onSizesChange, ...scrollbarProps } = props;
    const context = $25e27e390e2ae51e$var$useScrollAreaContext($25e27e390e2ae51e$var$SCROLLBAR_NAME, props.__scopeScrollArea);
    const [computedStyle, setComputedStyle] = $7fPBF.useState();
    const ref = $7fPBF.useRef(null);
    const composeRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, ref, context.onScrollbarYChange);
    $7fPBF.useEffect(()=>{
        if (ref.current) setComputedStyle(getComputedStyle(ref.current));
    }, [
        ref
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($25e27e390e2ae51e$var$ScrollAreaScrollbarImpl, {
        "data-orientation": "vertical",
        ...scrollbarProps,
        ref: composeRefs,
        sizes: sizes,
        style: {
            top: 0,
            right: context.dir === "ltr" ? 0 : void 0,
            left: context.dir === "rtl" ? 0 : void 0,
            bottom: "var(--radix-scroll-area-corner-height)",
            ["--radix-scroll-area-thumb-height"]: $25e27e390e2ae51e$var$getThumbSize(sizes) + "px",
            ...props.style
        },
        onThumbPointerDown: (pointerPos)=>props.onThumbPointerDown(pointerPos.y),
        onDragScroll: (pointerPos)=>props.onDragScroll(pointerPos.y),
        onWheelScroll: (event, maxScrollPos)=>{
            if (context.viewport) {
                const scrollPos = context.viewport.scrollTop + event.deltaY;
                props.onWheelScroll(scrollPos);
                if ($25e27e390e2ae51e$var$isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos)) event.preventDefault();
            }
        },
        onResize: ()=>{
            if (ref.current && context.viewport && computedStyle) onSizesChange({
                content: context.viewport.scrollHeight,
                viewport: context.viewport.offsetHeight,
                scrollbar: {
                    size: ref.current.clientHeight,
                    paddingStart: $25e27e390e2ae51e$var$toInt(computedStyle.paddingTop),
                    paddingEnd: $25e27e390e2ae51e$var$toInt(computedStyle.paddingBottom)
                }
            });
        }
    });
});
var [$25e27e390e2ae51e$var$ScrollbarProvider, $25e27e390e2ae51e$var$useScrollbarContext] = $25e27e390e2ae51e$var$createScrollAreaContext($25e27e390e2ae51e$var$SCROLLBAR_NAME);
var $25e27e390e2ae51e$var$ScrollAreaScrollbarImpl = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeScrollArea: __scopeScrollArea, sizes: sizes, hasThumb: hasThumb, onThumbChange: onThumbChange, onThumbPointerUp: onThumbPointerUp, onThumbPointerDown: onThumbPointerDown, onThumbPositionChange: onThumbPositionChange, onDragScroll: onDragScroll, onWheelScroll: onWheelScroll, onResize: onResize, ...scrollbarProps } = props;
    const context = $25e27e390e2ae51e$var$useScrollAreaContext($25e27e390e2ae51e$var$SCROLLBAR_NAME, __scopeScrollArea);
    const [scrollbar, setScrollbar] = $7fPBF.useState(null);
    const composeRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setScrollbar(node));
    const rectRef = $7fPBF.useRef(null);
    const prevWebkitUserSelectRef = $7fPBF.useRef("");
    const viewport = context.viewport;
    const maxScrollPos = sizes.content - sizes.viewport;
    const handleWheelScroll = (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(onWheelScroll);
    const handleThumbPositionChange = (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(onThumbPositionChange);
    const handleResize = $25e27e390e2ae51e$var$useDebounceCallback(onResize, 10);
    function handleDragScroll(event) {
        if (rectRef.current) {
            const x = event.clientX - rectRef.current.left;
            const y = event.clientY - rectRef.current.top;
            onDragScroll({
                x: x,
                y: y
            });
        }
    }
    $7fPBF.useEffect(()=>{
        const handleWheel = (event)=>{
            const element = event.target;
            const isScrollbarWheel = scrollbar === null || scrollbar === void 0 ? void 0 : scrollbar.contains(element);
            if (isScrollbarWheel) handleWheelScroll(event, maxScrollPos);
        };
        document.addEventListener("wheel", handleWheel, {
            passive: false
        });
        return ()=>document.removeEventListener("wheel", handleWheel, {
                passive: false
            });
    }, [
        viewport,
        scrollbar,
        maxScrollPos,
        handleWheelScroll
    ]);
    $7fPBF.useEffect(handleThumbPositionChange, [
        sizes,
        handleThumbPositionChange
    ]);
    $25e27e390e2ae51e$var$useResizeObserver(scrollbar, handleResize);
    $25e27e390e2ae51e$var$useResizeObserver(context.content, handleResize);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($25e27e390e2ae51e$var$ScrollbarProvider, {
        scope: __scopeScrollArea,
        scrollbar: scrollbar,
        hasThumb: hasThumb,
        onThumbChange: (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(onThumbChange),
        onThumbPointerUp: (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(onThumbPointerUp),
        onThumbPositionChange: handleThumbPositionChange,
        onThumbPointerDown: (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(onThumbPointerDown),
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
            ...scrollbarProps,
            ref: composeRefs,
            style: {
                position: "absolute",
                ...scrollbarProps.style
            },
            onPointerDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerDown, (event)=>{
                const mainPointer = 0;
                if (event.button === mainPointer) {
                    const element = event.target;
                    element.setPointerCapture(event.pointerId);
                    rectRef.current = scrollbar.getBoundingClientRect();
                    prevWebkitUserSelectRef.current = document.body.style.webkitUserSelect;
                    document.body.style.webkitUserSelect = "none";
                    if (context.viewport) context.viewport.style.scrollBehavior = "auto";
                    handleDragScroll(event);
                }
            }),
            onPointerMove: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerMove, handleDragScroll),
            onPointerUp: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerUp, (event)=>{
                const element = event.target;
                if (element.hasPointerCapture(event.pointerId)) element.releasePointerCapture(event.pointerId);
                document.body.style.webkitUserSelect = prevWebkitUserSelectRef.current;
                if (context.viewport) context.viewport.style.scrollBehavior = "";
                rectRef.current = null;
            })
        })
    });
});
var $25e27e390e2ae51e$var$THUMB_NAME = "ScrollAreaThumb";
var $25e27e390e2ae51e$export$9fba1154677d7cd2 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { forceMount: forceMount, ...thumbProps } = props;
    const scrollbarContext = $25e27e390e2ae51e$var$useScrollbarContext($25e27e390e2ae51e$var$THUMB_NAME, props.__scopeScrollArea);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $e9ce08b8e6e14786$export$99c2b779aa4e8b8b), {
        present: forceMount || scrollbarContext.hasThumb,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($25e27e390e2ae51e$var$ScrollAreaThumbImpl, {
            ref: forwardedRef,
            ...thumbProps
        })
    });
});
var $25e27e390e2ae51e$var$ScrollAreaThumbImpl = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeScrollArea: __scopeScrollArea, style: style, ...thumbProps } = props;
    const scrollAreaContext = $25e27e390e2ae51e$var$useScrollAreaContext($25e27e390e2ae51e$var$THUMB_NAME, __scopeScrollArea);
    const scrollbarContext = $25e27e390e2ae51e$var$useScrollbarContext($25e27e390e2ae51e$var$THUMB_NAME, __scopeScrollArea);
    const { onThumbPositionChange: onThumbPositionChange } = scrollbarContext;
    const composedRef = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>scrollbarContext.onThumbChange(node));
    const removeUnlinkedScrollListenerRef = $7fPBF.useRef();
    const debounceScrollEnd = $25e27e390e2ae51e$var$useDebounceCallback(()=>{
        if (removeUnlinkedScrollListenerRef.current) {
            removeUnlinkedScrollListenerRef.current();
            removeUnlinkedScrollListenerRef.current = void 0;
        }
    }, 100);
    $7fPBF.useEffect(()=>{
        const viewport = scrollAreaContext.viewport;
        if (viewport) {
            const handleScroll = ()=>{
                debounceScrollEnd();
                if (!removeUnlinkedScrollListenerRef.current) {
                    const listener = $25e27e390e2ae51e$var$addUnlinkedScrollListener(viewport, onThumbPositionChange);
                    removeUnlinkedScrollListenerRef.current = listener;
                    onThumbPositionChange();
                }
            };
            onThumbPositionChange();
            viewport.addEventListener("scroll", handleScroll);
            return ()=>viewport.removeEventListener("scroll", handleScroll);
        }
    }, [
        scrollAreaContext.viewport,
        debounceScrollEnd,
        onThumbPositionChange
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
        "data-state": scrollbarContext.hasThumb ? "visible" : "hidden",
        ...thumbProps,
        ref: composedRef,
        style: {
            width: "var(--radix-scroll-area-thumb-width)",
            height: "var(--radix-scroll-area-thumb-height)",
            ...style
        },
        onPointerDownCapture: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerDownCapture, (event)=>{
            const thumb = event.target;
            const thumbRect = thumb.getBoundingClientRect();
            const x = event.clientX - thumbRect.left;
            const y = event.clientY - thumbRect.top;
            scrollbarContext.onThumbPointerDown({
                x: x,
                y: y
            });
        }),
        onPointerUp: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerUp, scrollbarContext.onThumbPointerUp)
    });
});
$25e27e390e2ae51e$export$9fba1154677d7cd2.displayName = $25e27e390e2ae51e$var$THUMB_NAME;
var $25e27e390e2ae51e$var$CORNER_NAME = "ScrollAreaCorner";
var $25e27e390e2ae51e$export$56969d565df7cc4b = $7fPBF.forwardRef((props, forwardedRef)=>{
    const context = $25e27e390e2ae51e$var$useScrollAreaContext($25e27e390e2ae51e$var$CORNER_NAME, props.__scopeScrollArea);
    const hasBothScrollbarsVisible = Boolean(context.scrollbarX && context.scrollbarY);
    const hasCorner = context.type !== "scroll" && hasBothScrollbarsVisible;
    return hasCorner ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($25e27e390e2ae51e$var$ScrollAreaCornerImpl, {
        ...props,
        ref: forwardedRef
    }) : null;
});
$25e27e390e2ae51e$export$56969d565df7cc4b.displayName = $25e27e390e2ae51e$var$CORNER_NAME;
var $25e27e390e2ae51e$var$ScrollAreaCornerImpl = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeScrollArea: __scopeScrollArea, ...cornerProps } = props;
    const context = $25e27e390e2ae51e$var$useScrollAreaContext($25e27e390e2ae51e$var$CORNER_NAME, __scopeScrollArea);
    const [width, setWidth] = $7fPBF.useState(0);
    const [height, setHeight] = $7fPBF.useState(0);
    const hasSize = Boolean(width && height);
    $25e27e390e2ae51e$var$useResizeObserver(context.scrollbarX, ()=>{
        var _context_scrollbarX;
        const height2 = ((_context_scrollbarX = context.scrollbarX) === null || _context_scrollbarX === void 0 ? void 0 : _context_scrollbarX.offsetHeight) || 0;
        context.onCornerHeightChange(height2);
        setHeight(height2);
    });
    $25e27e390e2ae51e$var$useResizeObserver(context.scrollbarY, ()=>{
        var _context_scrollbarY;
        const width2 = ((_context_scrollbarY = context.scrollbarY) === null || _context_scrollbarY === void 0 ? void 0 : _context_scrollbarY.offsetWidth) || 0;
        context.onCornerWidthChange(width2);
        setWidth(width2);
    });
    return hasSize ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
        ...cornerProps,
        ref: forwardedRef,
        style: {
            width: width,
            height: height,
            position: "absolute",
            right: context.dir === "ltr" ? 0 : void 0,
            left: context.dir === "rtl" ? 0 : void 0,
            bottom: 0,
            ...props.style
        }
    }) : null;
});
function $25e27e390e2ae51e$var$toInt(value) {
    return value ? parseInt(value, 10) : 0;
}
function $25e27e390e2ae51e$var$getThumbRatio(viewportSize, contentSize) {
    const ratio = viewportSize / contentSize;
    return isNaN(ratio) ? 0 : ratio;
}
function $25e27e390e2ae51e$var$getThumbSize(sizes) {
    const ratio = $25e27e390e2ae51e$var$getThumbRatio(sizes.viewport, sizes.content);
    const scrollbarPadding = sizes.scrollbar.paddingStart + sizes.scrollbar.paddingEnd;
    const thumbSize = (sizes.scrollbar.size - scrollbarPadding) * ratio;
    return Math.max(thumbSize, 18);
}
function $25e27e390e2ae51e$var$getScrollPositionFromPointer(pointerPos, pointerOffset, sizes, dir = "ltr") {
    const thumbSizePx = $25e27e390e2ae51e$var$getThumbSize(sizes);
    const thumbCenter = thumbSizePx / 2;
    const offset = pointerOffset || thumbCenter;
    const thumbOffsetFromEnd = thumbSizePx - offset;
    const minPointerPos = sizes.scrollbar.paddingStart + offset;
    const maxPointerPos = sizes.scrollbar.size - sizes.scrollbar.paddingEnd - thumbOffsetFromEnd;
    const maxScrollPos = sizes.content - sizes.viewport;
    const scrollRange = dir === "ltr" ? [
        0,
        maxScrollPos
    ] : [
        maxScrollPos * -1,
        0
    ];
    const interpolate = $25e27e390e2ae51e$var$linearScale([
        minPointerPos,
        maxPointerPos
    ], scrollRange);
    return interpolate(pointerPos);
}
function $25e27e390e2ae51e$var$getThumbOffsetFromScroll(scrollPos, sizes, dir = "ltr") {
    const thumbSizePx = $25e27e390e2ae51e$var$getThumbSize(sizes);
    const scrollbarPadding = sizes.scrollbar.paddingStart + sizes.scrollbar.paddingEnd;
    const scrollbar = sizes.scrollbar.size - scrollbarPadding;
    const maxScrollPos = sizes.content - sizes.viewport;
    const maxThumbPos = scrollbar - thumbSizePx;
    const scrollClampRange = dir === "ltr" ? [
        0,
        maxScrollPos
    ] : [
        maxScrollPos * -1,
        0
    ];
    const scrollWithoutMomentum = (0, $6d53081595419ec4$export$7d15b64cf5a3a4c4)(scrollPos, scrollClampRange);
    const interpolate = $25e27e390e2ae51e$var$linearScale([
        0,
        maxScrollPos
    ], [
        0,
        maxThumbPos
    ]);
    return interpolate(scrollWithoutMomentum);
}
function $25e27e390e2ae51e$var$linearScale(input, output) {
    return (value)=>{
        if (input[0] === input[1] || output[0] === output[1]) return output[0];
        const ratio = (output[1] - output[0]) / (input[1] - input[0]);
        return output[0] + ratio * (value - input[0]);
    };
}
function $25e27e390e2ae51e$var$isScrollingWithinScrollbarBounds(scrollPos, maxScrollPos) {
    return scrollPos > 0 && scrollPos < maxScrollPos;
}
var $25e27e390e2ae51e$var$addUnlinkedScrollListener = (node, handler = ()=>{})=>{
    let prevPosition = {
        left: node.scrollLeft,
        top: node.scrollTop
    };
    let rAF = 0;
    (function loop() {
        const position = {
            left: node.scrollLeft,
            top: node.scrollTop
        };
        const isHorizontalScroll = prevPosition.left !== position.left;
        const isVerticalScroll = prevPosition.top !== position.top;
        if (isHorizontalScroll || isVerticalScroll) handler();
        prevPosition = position;
        rAF = window.requestAnimationFrame(loop);
    })();
    return ()=>window.cancelAnimationFrame(rAF);
};
function $25e27e390e2ae51e$var$useDebounceCallback(callback, delay) {
    const handleCallback = (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(callback);
    const debounceTimerRef = $7fPBF.useRef(0);
    $7fPBF.useEffect(()=>()=>window.clearTimeout(debounceTimerRef.current), []);
    return $7fPBF.useCallback(()=>{
        window.clearTimeout(debounceTimerRef.current);
        debounceTimerRef.current = window.setTimeout(handleCallback, delay);
    }, [
        handleCallback,
        delay
    ]);
}
function $25e27e390e2ae51e$var$useResizeObserver(element, onResize) {
    const handleResize = (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(onResize);
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        let rAF = 0;
        if (element) {
            const resizeObserver = new ResizeObserver(()=>{
                cancelAnimationFrame(rAF);
                rAF = window.requestAnimationFrame(handleResize);
            });
            resizeObserver.observe(element);
            return ()=>{
                window.cancelAnimationFrame(rAF);
                resizeObserver.unobserve(element);
            };
        }
    }, [
        element,
        handleResize
    ]);
}
var $25e27e390e2ae51e$export$be92b6f5f03c0fe9 = $25e27e390e2ae51e$export$ccf8d8d7bbf3c2cc;
var $25e27e390e2ae51e$export$d5c6c08dc2d3ca7 = $25e27e390e2ae51e$export$a21cbf9f11fca853;
var $25e27e390e2ae51e$export$9a4e88b92edfce6b = $25e27e390e2ae51e$export$2fabd85d0eba3c57;
var $25e27e390e2ae51e$export$6521433ed15a34db = $25e27e390e2ae51e$export$9fba1154677d7cd2;
var $25e27e390e2ae51e$export$ac61190d9fc311a9 = $25e27e390e2ae51e$export$56969d565df7cc4b;




const $0de2ab9eaa595812$var$r = [
    "1",
    "2",
    "3"
], $0de2ab9eaa595812$var$o = [
    "vertical",
    "horizontal",
    "both"
], $0de2ab9eaa595812$export$c470a0fe1928a781 = {
    ...(0, $b302dbddfdac9d75$export$1e7c0b54c65e0280),
    size: {
        type: "enum",
        className: "rt-r-size",
        values: $0de2ab9eaa595812$var$r,
        default: "1",
        responsive: !0
    },
    ...(0, $3d20a83f81464c0a$export$c467f6769b59b70c),
    scrollbars: {
        type: "enum",
        values: $0de2ab9eaa595812$var$o,
        default: "both"
    }
};


function $969e5ff9b8743171$export$59b6393f3e8acf0f(r) {
    const { m: t, mx: m, my: o, mt: p, mr: n, mb: s, ml: e, ...i } = r;
    return {
        m: t,
        mx: m,
        my: o,
        mt: p,
        mr: n,
        mb: s,
        ml: e,
        rest: i
    };
}






const $d867552581e3a30c$var$r = (0, $df06be8448ff4f3c$export$83503616c7a463e3).m.values;
function $d867552581e3a30c$export$2b2a55ba40b1211c(s) {
    const [e, t] = (0, $6e74cfda01acbc32$export$10dac92f1edafe3b)({
        className: "rt-r-m",
        customProperties: [
            "--margin"
        ],
        propValues: $d867552581e3a30c$var$r,
        value: s.m
    }), [a, o] = (0, $6e74cfda01acbc32$export$10dac92f1edafe3b)({
        className: "rt-r-mx",
        customProperties: [
            "--margin-left",
            "--margin-right"
        ],
        propValues: $d867552581e3a30c$var$r,
        value: s.mx
    }), [l, i] = (0, $6e74cfda01acbc32$export$10dac92f1edafe3b)({
        className: "rt-r-my",
        customProperties: [
            "--margin-top",
            "--margin-bottom"
        ],
        propValues: $d867552581e3a30c$var$r,
        value: s.my
    }), [p, u] = (0, $6e74cfda01acbc32$export$10dac92f1edafe3b)({
        className: "rt-r-mt",
        customProperties: [
            "--margin-top"
        ],
        propValues: $d867552581e3a30c$var$r,
        value: s.mt
    }), [n, c] = (0, $6e74cfda01acbc32$export$10dac92f1edafe3b)({
        className: "rt-r-mr",
        customProperties: [
            "--margin-right"
        ],
        propValues: $d867552581e3a30c$var$r,
        value: s.mr
    }), [g, P] = (0, $6e74cfda01acbc32$export$10dac92f1edafe3b)({
        className: "rt-r-mb",
        customProperties: [
            "--margin-bottom"
        ],
        propValues: $d867552581e3a30c$var$r,
        value: s.mb
    }), [N, C] = (0, $6e74cfda01acbc32$export$10dac92f1edafe3b)({
        className: "rt-r-ml",
        customProperties: [
            "--margin-left"
        ],
        propValues: $d867552581e3a30c$var$r,
        value: s.ml
    });
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))(e, a, l, p, n, g, N),
        (0, $f71bfc9c84797302$export$e618dc39ac9ad607)(t, o, i, u, c, P, C)
    ];
}





const $649b23d2e2cfc248$export$ccf8d8d7bbf3c2cc = $7fPBF.forwardRef((n, S)=>{
    const { rest: f, ...P } = (0, $969e5ff9b8743171$export$59b6393f3e8acf0f)(n), [u, A] = (0, $d867552581e3a30c$export$2b2a55ba40b1211c)(P), { asChild: a, children: d, className: y, style: v, type: t, scrollHideDelay: N = t !== "scroll" ? 0 : void 0, dir: V, size: i = (0, $0de2ab9eaa595812$export$c470a0fe1928a781).size.default, radius: p = (0, $0de2ab9eaa595812$export$c470a0fe1928a781).radius.default, scrollbars: l = (0, $0de2ab9eaa595812$export$c470a0fe1928a781).scrollbars.default, ...b } = f;
    return $7fPBF.createElement($25e27e390e2ae51e$export$be92b6f5f03c0fe9, {
        type: t,
        scrollHideDelay: N,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-ScrollAreaRoot", u, y),
        style: (0, $f71bfc9c84797302$export$e618dc39ac9ad607)(A, v),
        asChild: a
    }, (0, $3de7503944cba122$export$9e8b964465d7899e)({
        asChild: a,
        children: d
    }, (g)=>$7fPBF.createElement($7fPBF.Fragment, null, $7fPBF.createElement($25e27e390e2ae51e$export$d5c6c08dc2d3ca7, {
            ...b,
            ref: S,
            className: "rt-ScrollAreaViewport"
        }, g), $7fPBF.createElement("div", {
            className: "rt-ScrollAreaViewportFocusRing"
        }), l !== "vertical" ? $7fPBF.createElement($25e27e390e2ae51e$export$9a4e88b92edfce6b, {
            "data-radius": p,
            orientation: "horizontal",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-ScrollAreaScrollbar", (0, $6e74cfda01acbc32$export$d03033efad57dbbf)({
                className: "rt-r-size",
                value: i,
                propValues: (0, $0de2ab9eaa595812$export$c470a0fe1928a781).size.values
            }))
        }, $7fPBF.createElement($25e27e390e2ae51e$export$6521433ed15a34db, {
            className: "rt-ScrollAreaThumb"
        })) : null, l !== "horizontal" ? $7fPBF.createElement($25e27e390e2ae51e$export$9a4e88b92edfce6b, {
            "data-radius": p,
            orientation: "vertical",
            className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-ScrollAreaScrollbar", (0, $6e74cfda01acbc32$export$d03033efad57dbbf)({
                className: "rt-r-size",
                value: i,
                propValues: (0, $0de2ab9eaa595812$export$c470a0fe1928a781).size.values
            }))
        }, $7fPBF.createElement($25e27e390e2ae51e$export$6521433ed15a34db, {
            className: "rt-ScrollAreaThumb"
        })) : null, l === "both" ? $7fPBF.createElement($25e27e390e2ae51e$export$ac61190d9fc311a9, {
            className: "rt-ScrollAreaCorner"
        }) : null)));
});
$649b23d2e2cfc248$export$ccf8d8d7bbf3c2cc.displayName = "ScrollArea";





const $bb16039287dfead6$var$o = [
    "1",
    "2"
], $bb16039287dfead6$var$r = [
    "solid",
    "soft"
], $bb16039287dfead6$export$4ee1af1a98da3b88 = {
    size: {
        type: "enum",
        className: "rt-r-size",
        values: $bb16039287dfead6$var$o,
        default: "2",
        responsive: !0
    },
    variant: {
        type: "enum",
        className: "rt-variant",
        values: $bb16039287dfead6$var$r,
        default: "solid"
    },
    ...(0, $e914ebf2ce406d8c$export$8255b018f448be13),
    ...(0, $f41c61290c2a7125$export$2f84412d299def33)
}, $bb16039287dfead6$export$5a2fcca75b2e1ae6 = {
    ...(0, $b302dbddfdac9d75$export$1e7c0b54c65e0280),
    ...(0, $e914ebf2ce406d8c$export$8255b018f448be13),
    shortcut: {
        type: "string"
    }
}, $bb16039287dfead6$export$4b863c7c9f8e5d87 = {
    ...(0, $e914ebf2ce406d8c$export$8255b018f448be13),
    shortcut: {
        type: "string"
    }
}, $bb16039287dfead6$export$157ca09440ca2711 = {
    ...(0, $e914ebf2ce406d8c$export$8255b018f448be13)
};








"use client";
const $c01b26e1c527f461$export$be92b6f5f03c0fe9 = (t)=>$7fPBF.createElement($ace24827494fe46d$export$be92b6f5f03c0fe9, {
        ...t
    });
$c01b26e1c527f461$export$be92b6f5f03c0fe9.displayName = "ContextMenu.Root";
const $c01b26e1c527f461$export$41fb9f06171c75f4 = $7fPBF.forwardRef(({ children: t, ...n }, o)=>$7fPBF.createElement($ace24827494fe46d$export$41fb9f06171c75f4, {
        ...n,
        ref: o,
        asChild: !0
    }, (0, $d51eb3faadbea344$export$fb35347076fc30e)(t)));
$c01b26e1c527f461$export$41fb9f06171c75f4.displayName = "ContextMenu.Trigger";
const $c01b26e1c527f461$var$v = $7fPBF.createContext({}), $c01b26e1c527f461$export$7c6e2c02157bb7d2 = $7fPBF.forwardRef((t, n)=>{
    const o = (0, $fe07e27ecf0fa1d7$export$c4281ec44b929e6)(), { size: s = (0, $bb16039287dfead6$export$4ee1af1a98da3b88).size.default, variant: u = (0, $bb16039287dfead6$export$4ee1af1a98da3b88).variant.default, highContrast: i = (0, $bb16039287dfead6$export$4ee1af1a98da3b88).highContrast.default } = t, { className: C, children: m, color: x, container: M, forceMount: l, ...L } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(t, (0, $bb16039287dfead6$export$4ee1af1a98da3b88)), c = x || o.accentColor;
    return $7fPBF.createElement($ace24827494fe46d$export$602eac185826482c, {
        container: M,
        forceMount: l
    }, $7fPBF.createElement((0, $fe07e27ecf0fa1d7$export$14faa19a0f3bbeb2), {
        asChild: !0
    }, $7fPBF.createElement($ace24827494fe46d$export$7c6e2c02157bb7d2, {
        "data-accent-color": c,
        alignOffset: -Number(s) * 4,
        collisionPadding: 10,
        ...L,
        asChild: !1,
        ref: n,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-PopperContent", "rt-BaseMenuContent", "rt-ContextMenuContent", C)
    }, $7fPBF.createElement((0, $649b23d2e2cfc248$export$ccf8d8d7bbf3c2cc), {
        type: "auto"
    }, $7fPBF.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-BaseMenuViewport", "rt-ContextMenuViewport")
    }, $7fPBF.createElement($c01b26e1c527f461$var$v.Provider, {
        value: $7fPBF.useMemo(()=>({
                size: s,
                variant: u,
                color: c,
                highContrast: i
            }), [
            s,
            u,
            c,
            i
        ])
    }, m))))));
});
$c01b26e1c527f461$export$7c6e2c02157bb7d2.displayName = "ContextMenu.Content";
const $c01b26e1c527f461$export$b04be29aa201d4f5 = $7fPBF.forwardRef(({ className: t, ...n }, o)=>$7fPBF.createElement($ace24827494fe46d$export$b04be29aa201d4f5, {
        ...n,
        asChild: !1,
        ref: o,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-BaseMenuLabel", "rt-ContextMenuLabel", t)
    }));
$c01b26e1c527f461$export$b04be29aa201d4f5.displayName = "ContextMenu.Label";
const $c01b26e1c527f461$export$6d08773d2e66f8f2 = $7fPBF.forwardRef((t, n)=>{
    const { className: o, children: s, color: u = (0, $bb16039287dfead6$export$5a2fcca75b2e1ae6).color.default, shortcut: i, ...C } = t;
    return $7fPBF.createElement($ace24827494fe46d$export$6d08773d2e66f8f2, {
        "data-accent-color": u,
        ...C,
        ref: n,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-reset", "rt-BaseMenuItem", "rt-ContextMenuItem", o)
    }, $7fPBF.createElement((0, $089057084dfb92a4$export$d9f1ccf0bdb05d45), null, s), i && $7fPBF.createElement("div", {
        className: "rt-BaseMenuShortcut rt-ContextMenuShortcut"
    }, i));
});
$c01b26e1c527f461$export$6d08773d2e66f8f2.displayName = "ContextMenu.Item";
const $c01b26e1c527f461$export$eb2fcfdbd7ba97d4 = $7fPBF.forwardRef(({ className: t, ...n }, o)=>$7fPBF.createElement($ace24827494fe46d$export$eb2fcfdbd7ba97d4, {
        ...n,
        asChild: !1,
        ref: o,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-BaseMenuGroup", "rt-ContextMenuGroup", t)
    }));
$c01b26e1c527f461$export$eb2fcfdbd7ba97d4.displayName = "ContextMenu.Group";
const $c01b26e1c527f461$export$a98f0dcb43a68a25 = $7fPBF.forwardRef(({ className: t, ...n }, o)=>$7fPBF.createElement($ace24827494fe46d$export$a98f0dcb43a68a25, {
        ...n,
        asChild: !1,
        ref: o,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-BaseMenuRadioGroup", "rt-ContextMenuRadioGroup", t)
    }));
$c01b26e1c527f461$export$a98f0dcb43a68a25.displayName = "ContextMenu.RadioGroup";
const $c01b26e1c527f461$export$371ab307eab489c0 = $7fPBF.forwardRef((t, n)=>{
    const { children: o, className: s, color: u = (0, $bb16039287dfead6$export$157ca09440ca2711).color.default, ...i } = t;
    return $7fPBF.createElement($ace24827494fe46d$export$371ab307eab489c0, {
        ...i,
        asChild: !1,
        ref: n,
        "data-accent-color": u,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-BaseMenuItem", "rt-BaseMenuRadioItem", "rt-ContextMenuItem", "rt-ContextMenuRadioItem", s)
    }, $7fPBF.createElement((0, $089057084dfb92a4$export$d9f1ccf0bdb05d45), null, o), $7fPBF.createElement($ace24827494fe46d$export$c3468e2714d175fa, {
        className: "rt-BaseMenuItemIndicator rt-ContextMenuItemIndicator"
    }, $7fPBF.createElement((0, $a0cf194253713caf$export$e8a6d0edce052b3e), {
        className: "rt-BaseMenuItemIndicatorIcon rt-ContextMenuItemIndicatorIcon"
    })));
});
$c01b26e1c527f461$export$371ab307eab489c0.displayName = "ContextMenu.RadioItem";
const $c01b26e1c527f461$export$16ce288f89fa631c = $7fPBF.forwardRef((t, n)=>{
    const { children: o, className: s, shortcut: u, color: i = (0, $bb16039287dfead6$export$4b863c7c9f8e5d87).color.default, ...C } = t;
    return $7fPBF.createElement($ace24827494fe46d$export$16ce288f89fa631c, {
        ...C,
        asChild: !1,
        ref: n,
        "data-accent-color": i,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-BaseMenuItem", "rt-BaseMenuCheckboxItem", "rt-ContextMenuItem", "rt-ContextMenuCheckboxItem", s)
    }, $7fPBF.createElement((0, $089057084dfb92a4$export$d9f1ccf0bdb05d45), null, o), $7fPBF.createElement($ace24827494fe46d$export$c3468e2714d175fa, {
        className: "rt-BaseMenuItemIndicator rt-ContextMenuItemIndicator"
    }, $7fPBF.createElement((0, $a0cf194253713caf$export$e8a6d0edce052b3e), {
        className: "rt-BaseMenuItemIndicatorIcon rt-ContextMenuItemIndicatorIcon"
    })), u && $7fPBF.createElement("div", {
        className: "rt-BaseMenuShortcut rt-ContextMenuShortcut"
    }, u));
});
$c01b26e1c527f461$export$16ce288f89fa631c.displayName = "ContextMenu.CheckboxItem";
const $c01b26e1c527f461$export$d7a01e11500dfb6f = (t)=>$7fPBF.createElement($ace24827494fe46d$export$d7a01e11500dfb6f, {
        ...t
    });
$c01b26e1c527f461$export$d7a01e11500dfb6f.displayName = "ContextMenu.Sub";
const $c01b26e1c527f461$export$2ea8a7a591ac5eac = $7fPBF.forwardRef((t, n)=>{
    const { className: o, children: s, ...u } = t;
    return $7fPBF.createElement($ace24827494fe46d$export$2ea8a7a591ac5eac, {
        ...u,
        asChild: !1,
        ref: n,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-BaseMenuItem", "rt-BaseMenuSubTrigger", "rt-ContextMenuItem", "rt-ContextMenuSubTrigger", o)
    }, s, $7fPBF.createElement("div", {
        className: "rt-BaseMenuShortcut rt-ContextMenuShortcut"
    }, $7fPBF.createElement((0, $a0cf194253713caf$export$e27db7fd6f9e0eab), {
        className: "rt-BaseMenuSubTriggerIcon rt-ContextMenuSubTriggerIcon"
    })));
});
$c01b26e1c527f461$export$2ea8a7a591ac5eac.displayName = "ContextMenu.SubTrigger";
const $c01b26e1c527f461$export$6d4de93b380beddf = $7fPBF.forwardRef((t, n)=>{
    const { size: o, variant: s, color: u, highContrast: i } = $7fPBF.useContext($c01b26e1c527f461$var$v), { className: C, children: m, container: x, forceMount: M, ...l } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)({
        size: o,
        variant: s,
        color: u,
        highContrast: i,
        ...t
    }, (0, $bb16039287dfead6$export$4ee1af1a98da3b88));
    return $7fPBF.createElement($ace24827494fe46d$export$602eac185826482c, {
        container: x,
        forceMount: M
    }, $7fPBF.createElement((0, $fe07e27ecf0fa1d7$export$14faa19a0f3bbeb2), {
        asChild: !0
    }, $7fPBF.createElement($ace24827494fe46d$export$6d4de93b380beddf, {
        "data-accent-color": u,
        alignOffset: -Number(o) * 4,
        sideOffset: 1,
        collisionPadding: 10,
        ...l,
        asChild: !1,
        ref: n,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-PopperContent", "rt-BaseMenuContent", "rt-BaseMenuSubContent", "rt-ContextMenuContent", "rt-ContextMenuSubContent", C)
    }, $7fPBF.createElement((0, $649b23d2e2cfc248$export$ccf8d8d7bbf3c2cc), {
        type: "auto"
    }, $7fPBF.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-BaseMenuViewport", "rt-ContextMenuViewport")
    }, m)))));
});
$c01b26e1c527f461$export$6d4de93b380beddf.displayName = "ContextMenu.SubContent";
const $c01b26e1c527f461$export$1ff3c3f08ae963c0 = $7fPBF.forwardRef(({ className: t, ...n }, o)=>$7fPBF.createElement($ace24827494fe46d$export$1ff3c3f08ae963c0, {
        ...n,
        asChild: !1,
        ref: o,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-BaseMenuSeparator", "rt-ContextMenuSeparator", t)
    }));
$c01b26e1c527f461$export$1ff3c3f08ae963c0.displayName = "ContextMenu.Separator";




var $7fPBF = parcelRequire("7fPBF");





const $a02c7fd115b4851c$var$s = [
    "start",
    "center",
    "end",
    "baseline",
    "stretch"
], $a02c7fd115b4851c$var$i = [
    "horizontal",
    "vertical"
], $a02c7fd115b4851c$var$a = [
    "1",
    "2",
    "3"
], $a02c7fd115b4851c$export$3056055984c6febe = {
    orientation: {
        type: "enum",
        className: "rt-r-orientation",
        values: $a02c7fd115b4851c$var$i,
        default: "horizontal",
        responsive: !0
    },
    size: {
        type: "enum",
        className: "rt-r-size",
        values: $a02c7fd115b4851c$var$a,
        default: "2",
        responsive: !0
    },
    trim: {
        ...(0, $748529190ac30cea$export$9fbb19586d60aa6c).trim,
        className: "rt-r-trim"
    }
}, $a02c7fd115b4851c$export$e7368116db7fa725 = {
    align: {
        type: "enum",
        className: "rt-r-ai",
        values: $a02c7fd115b4851c$var$s,
        responsive: !0
    }
}, $a02c7fd115b4851c$export$654a91d42d6f6c30 = {
    ...(0, $b6a742bf1f02ee7d$export$18e5dbe2c243731),
    ...(0, $e914ebf2ce406d8c$export$8255b018f448be13),
    ...(0, $f41c61290c2a7125$export$2f84412d299def33)
};




const $8eaf7faaa7560688$export$be92b6f5f03c0fe9 = $7fPBF.forwardRef((a, e)=>{
    const { className: s, ...o } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(a, (0, $a02c7fd115b4851c$export$3056055984c6febe), (0, $df06be8448ff4f3c$export$83503616c7a463e3));
    return $7fPBF.createElement((0, $83db9e82a643d7a4$export$5f1af8db9871e1d6), {
        asChild: !0
    }, $7fPBF.createElement("dl", {
        ...o,
        ref: e,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-DataListRoot", s)
    }));
});
$8eaf7faaa7560688$export$be92b6f5f03c0fe9.displayName = "DataList.Root";
const $8eaf7faaa7560688$export$6d08773d2e66f8f2 = $7fPBF.forwardRef((a, e)=>{
    const { className: s, ...o } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(a, (0, $a02c7fd115b4851c$export$e7368116db7fa725));
    return $7fPBF.createElement("div", {
        ...o,
        ref: e,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-DataListItem", s)
    });
});
$8eaf7faaa7560688$export$6d08773d2e66f8f2.displayName = "DataList.Item";
const $8eaf7faaa7560688$export$b04be29aa201d4f5 = $7fPBF.forwardRef((a, e)=>{
    const { className: s, color: o, ...n } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(a, (0, $a02c7fd115b4851c$export$654a91d42d6f6c30));
    return $7fPBF.createElement("dt", {
        ...n,
        "data-accent-color": o,
        ref: e,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-DataListLabel", s)
    });
});
$8eaf7faaa7560688$export$b04be29aa201d4f5.displayName = "DataList.Label";
const $8eaf7faaa7560688$export$4c8d1a57a761ef94 = $7fPBF.forwardRef(({ children: a, className: e, ...s }, o)=>$7fPBF.createElement("dd", {
        ...s,
        ref: o,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))(e, "rt-DataListValue")
    }, a));
$8eaf7faaa7560688$export$4c8d1a57a761ef94.displayName = "DataList.Value";



var $7fPBF = parcelRequire("7fPBF");








const $860663d5dd59cd3a$export$be92b6f5f03c0fe9 = (e)=>$7fPBF.createElement($eff5647826d6bc5d$export$be92b6f5f03c0fe9, {
        ...e,
        modal: !0
    });
$860663d5dd59cd3a$export$be92b6f5f03c0fe9.displayName = "Dialog.Root";
const $860663d5dd59cd3a$export$41fb9f06171c75f4 = $7fPBF.forwardRef(({ children: e, ...i }, r)=>$7fPBF.createElement($eff5647826d6bc5d$export$41fb9f06171c75f4, {
        ...i,
        ref: r,
        asChild: !0
    }, (0, $d51eb3faadbea344$export$fb35347076fc30e)(e)));
$860663d5dd59cd3a$export$41fb9f06171c75f4.displayName = "Dialog.Trigger";
const $860663d5dd59cd3a$export$7c6e2c02157bb7d2 = $7fPBF.forwardRef(({ align: e, ...i }, r)=>{
    const { align: P, ...f } = (0, $2f4552c9a33a7df5$export$cde45305589709cc), { className: C } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)({
        align: e
    }, {
        align: P
    }), { className: d, forceMount: c, container: y, ...T } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(i, f);
    return $7fPBF.createElement($eff5647826d6bc5d$export$602eac185826482c, {
        container: y,
        forceMount: c
    }, $7fPBF.createElement((0, $fe07e27ecf0fa1d7$export$14faa19a0f3bbeb2), {
        asChild: !0
    }, $7fPBF.createElement($eff5647826d6bc5d$export$c6fdb837b070b4ff, {
        className: "rt-BaseDialogOverlay rt-DialogOverlay"
    }, $7fPBF.createElement("div", {
        className: "rt-BaseDialogScroll rt-DialogScroll"
    }, $7fPBF.createElement("div", {
        className: `rt-BaseDialogScrollPadding rt-DialogScrollPadding ${C}`
    }, $7fPBF.createElement($eff5647826d6bc5d$export$7c6e2c02157bb7d2, {
        ...T,
        ref: r,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-BaseDialogContent", "rt-DialogContent", d)
    }))))));
});
$860663d5dd59cd3a$export$7c6e2c02157bb7d2.displayName = "Dialog.Content";
const $860663d5dd59cd3a$export$f99233281efd08a0 = $7fPBF.forwardRef((e, i)=>$7fPBF.createElement($eff5647826d6bc5d$export$f99233281efd08a0, {
        asChild: !0
    }, $7fPBF.createElement((0, $a81a142737c4a792$export$a8a3e93435678ff9), {
        size: "5",
        mb: "3",
        trim: "start",
        ...e,
        asChild: !1,
        ref: i
    })));
$860663d5dd59cd3a$export$f99233281efd08a0.displayName = "Dialog.Title";
const $860663d5dd59cd3a$export$393edc798c47379d = $7fPBF.forwardRef((e, i)=>$7fPBF.createElement($eff5647826d6bc5d$export$393edc798c47379d, {
        asChild: !0
    }, $7fPBF.createElement((0, $83db9e82a643d7a4$export$5f1af8db9871e1d6), {
        as: "p",
        size: "3",
        ...e,
        asChild: !1,
        ref: i
    })));
$860663d5dd59cd3a$export$393edc798c47379d.displayName = "Dialog.Description";
const $860663d5dd59cd3a$export$f39c2d165cd861fe = $7fPBF.forwardRef(({ children: e, ...i }, r)=>$7fPBF.createElement($eff5647826d6bc5d$export$f39c2d165cd861fe, {
        ...i,
        ref: r,
        asChild: !0
    }, (0, $d51eb3faadbea344$export$fb35347076fc30e)(e)));
$860663d5dd59cd3a$export$f39c2d165cd861fe.displayName = "Dialog.Close";



var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");








"use client";
var $d727ebae1b6a7799$var$DROPDOWN_MENU_NAME = "DropdownMenu";
var [$d727ebae1b6a7799$var$createDropdownMenuContext, $d727ebae1b6a7799$export$c0623cd925aeb687] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)($d727ebae1b6a7799$var$DROPDOWN_MENU_NAME, [
    (0, $860e6fb93642be7e$export$4027731b685e72eb)
]);
var $d727ebae1b6a7799$var$useMenuScope = (0, $860e6fb93642be7e$export$4027731b685e72eb)();
var [$d727ebae1b6a7799$var$DropdownMenuProvider, $d727ebae1b6a7799$var$useDropdownMenuContext] = $d727ebae1b6a7799$var$createDropdownMenuContext($d727ebae1b6a7799$var$DROPDOWN_MENU_NAME);
var $d727ebae1b6a7799$export$e44a253a59704894 = (props)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, children: children, dir: dir, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = true } = props;
    const menuScope = $d727ebae1b6a7799$var$useMenuScope(__scopeDropdownMenu);
    const triggerRef = $7fPBF.useRef(null);
    const [open = false, setOpen] = (0, $915387e6ab4d88b1$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($d727ebae1b6a7799$var$DropdownMenuProvider, {
        scope: __scopeDropdownMenu,
        triggerId: (0, $8a8e9b94c33ba6d6$export$f680877a34711e37)(),
        triggerRef: triggerRef,
        contentId: (0, $8a8e9b94c33ba6d6$export$f680877a34711e37)(),
        open: open,
        onOpenChange: setOpen,
        onOpenToggle: $7fPBF.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
            setOpen
        ]),
        modal: modal,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$be92b6f5f03c0fe9, {
            ...menuScope,
            open: open,
            onOpenChange: setOpen,
            dir: dir,
            modal: modal,
            children: children
        })
    });
};
$d727ebae1b6a7799$export$e44a253a59704894.displayName = $d727ebae1b6a7799$var$DROPDOWN_MENU_NAME;
var $d727ebae1b6a7799$var$TRIGGER_NAME = "DropdownMenuTrigger";
var $d727ebae1b6a7799$export$d2469213b3befba9 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, disabled: disabled = false, ...triggerProps } = props;
    const context = $d727ebae1b6a7799$var$useDropdownMenuContext($d727ebae1b6a7799$var$TRIGGER_NAME, __scopeDropdownMenu);
    const menuScope = $d727ebae1b6a7799$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$b688253958b8dfe7, {
        asChild: true,
        ...menuScope,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).button, {
            type: "button",
            id: context.triggerId,
            "aria-haspopup": "menu",
            "aria-expanded": context.open,
            "aria-controls": context.open ? context.contentId : void 0,
            "data-state": context.open ? "open" : "closed",
            "data-disabled": disabled ? "" : void 0,
            disabled: disabled,
            ...triggerProps,
            ref: (0, $2d44b7cb84ff0f1c$export$43e446d32b3d21af)(forwardedRef, context.triggerRef),
            onPointerDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerDown, (event)=>{
                if (!disabled && event.button === 0 && event.ctrlKey === false) {
                    context.onOpenToggle();
                    if (!context.open) event.preventDefault();
                }
            }),
            onKeyDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                if (disabled) return;
                if ([
                    "Enter",
                    " "
                ].includes(event.key)) context.onOpenToggle();
                if (event.key === "ArrowDown") context.onOpenChange(true);
                if ([
                    "Enter",
                    " ",
                    "ArrowDown"
                ].includes(event.key)) event.preventDefault();
            })
        })
    });
});
$d727ebae1b6a7799$export$d2469213b3befba9.displayName = $d727ebae1b6a7799$var$TRIGGER_NAME;
var $d727ebae1b6a7799$var$PORTAL_NAME = "DropdownMenuPortal";
var $d727ebae1b6a7799$export$cd369b4d4d54efc9 = (props)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...portalProps } = props;
    const menuScope = $d727ebae1b6a7799$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$602eac185826482c, {
        ...menuScope,
        ...portalProps
    });
};
$d727ebae1b6a7799$export$cd369b4d4d54efc9.displayName = $d727ebae1b6a7799$var$PORTAL_NAME;
var $d727ebae1b6a7799$var$CONTENT_NAME = "DropdownMenuContent";
var $d727ebae1b6a7799$export$6e76d93a37c01248 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...contentProps } = props;
    const context = $d727ebae1b6a7799$var$useDropdownMenuContext($d727ebae1b6a7799$var$CONTENT_NAME, __scopeDropdownMenu);
    const menuScope = $d727ebae1b6a7799$var$useMenuScope(__scopeDropdownMenu);
    const hasInteractedOutsideRef = $7fPBF.useRef(false);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$7c6e2c02157bb7d2, {
        id: context.contentId,
        "aria-labelledby": context.triggerId,
        ...menuScope,
        ...contentProps,
        ref: forwardedRef,
        onCloseAutoFocus: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
            var _context_triggerRef_current;
            if (!hasInteractedOutsideRef.current) (_context_triggerRef_current = context.triggerRef.current) === null || _context_triggerRef_current === void 0 ? void 0 : _context_triggerRef_current.focus();
            hasInteractedOutsideRef.current = false;
            event.preventDefault();
        }),
        onInteractOutside: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onInteractOutside, (event)=>{
            const originalEvent = event.detail.originalEvent;
            const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
            const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
            if (!context.modal || isRightClick) hasInteractedOutsideRef.current = true;
        }),
        style: {
            ...props.style,
            "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
            "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
            "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
    });
});
$d727ebae1b6a7799$export$6e76d93a37c01248.displayName = $d727ebae1b6a7799$var$CONTENT_NAME;
var $d727ebae1b6a7799$var$GROUP_NAME = "DropdownMenuGroup";
var $d727ebae1b6a7799$export$246bebaba3a2f70e = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...groupProps } = props;
    const menuScope = $d727ebae1b6a7799$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$eb2fcfdbd7ba97d4, {
        ...menuScope,
        ...groupProps,
        ref: forwardedRef
    });
});
$d727ebae1b6a7799$export$246bebaba3a2f70e.displayName = $d727ebae1b6a7799$var$GROUP_NAME;
var $d727ebae1b6a7799$var$LABEL_NAME = "DropdownMenuLabel";
var $d727ebae1b6a7799$export$76e48c5b57f24495 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...labelProps } = props;
    const menuScope = $d727ebae1b6a7799$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$b04be29aa201d4f5, {
        ...menuScope,
        ...labelProps,
        ref: forwardedRef
    });
});
$d727ebae1b6a7799$export$76e48c5b57f24495.displayName = $d727ebae1b6a7799$var$LABEL_NAME;
var $d727ebae1b6a7799$var$ITEM_NAME = "DropdownMenuItem";
var $d727ebae1b6a7799$export$ed97964d1871885d = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...itemProps } = props;
    const menuScope = $d727ebae1b6a7799$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$6d08773d2e66f8f2, {
        ...menuScope,
        ...itemProps,
        ref: forwardedRef
    });
});
$d727ebae1b6a7799$export$ed97964d1871885d.displayName = $d727ebae1b6a7799$var$ITEM_NAME;
var $d727ebae1b6a7799$var$CHECKBOX_ITEM_NAME = "DropdownMenuCheckboxItem";
var $d727ebae1b6a7799$export$53a69729da201fa9 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...checkboxItemProps } = props;
    const menuScope = $d727ebae1b6a7799$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$16ce288f89fa631c, {
        ...menuScope,
        ...checkboxItemProps,
        ref: forwardedRef
    });
});
$d727ebae1b6a7799$export$53a69729da201fa9.displayName = $d727ebae1b6a7799$var$CHECKBOX_ITEM_NAME;
var $d727ebae1b6a7799$var$RADIO_GROUP_NAME = "DropdownMenuRadioGroup";
var $d727ebae1b6a7799$export$3323ad73d55f587e = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...radioGroupProps } = props;
    const menuScope = $d727ebae1b6a7799$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$a98f0dcb43a68a25, {
        ...menuScope,
        ...radioGroupProps,
        ref: forwardedRef
    });
});
$d727ebae1b6a7799$export$3323ad73d55f587e.displayName = $d727ebae1b6a7799$var$RADIO_GROUP_NAME;
var $d727ebae1b6a7799$var$RADIO_ITEM_NAME = "DropdownMenuRadioItem";
var $d727ebae1b6a7799$export$e4f69b41b1637536 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...radioItemProps } = props;
    const menuScope = $d727ebae1b6a7799$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$371ab307eab489c0, {
        ...menuScope,
        ...radioItemProps,
        ref: forwardedRef
    });
});
$d727ebae1b6a7799$export$e4f69b41b1637536.displayName = $d727ebae1b6a7799$var$RADIO_ITEM_NAME;
var $d727ebae1b6a7799$var$INDICATOR_NAME = "DropdownMenuItemIndicator";
var $d727ebae1b6a7799$export$42355ae145153fb6 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...itemIndicatorProps } = props;
    const menuScope = $d727ebae1b6a7799$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$c3468e2714d175fa, {
        ...menuScope,
        ...itemIndicatorProps,
        ref: forwardedRef
    });
});
$d727ebae1b6a7799$export$42355ae145153fb6.displayName = $d727ebae1b6a7799$var$INDICATOR_NAME;
var $d727ebae1b6a7799$var$SEPARATOR_NAME = "DropdownMenuSeparator";
var $d727ebae1b6a7799$export$da160178fd3bc7e9 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...separatorProps } = props;
    const menuScope = $d727ebae1b6a7799$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$1ff3c3f08ae963c0, {
        ...menuScope,
        ...separatorProps,
        ref: forwardedRef
    });
});
$d727ebae1b6a7799$export$da160178fd3bc7e9.displayName = $d727ebae1b6a7799$var$SEPARATOR_NAME;
var $d727ebae1b6a7799$var$ARROW_NAME = "DropdownMenuArrow";
var $d727ebae1b6a7799$export$34b8980744021ec5 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...arrowProps } = props;
    const menuScope = $d727ebae1b6a7799$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$21b07c8f274aebd5, {
        ...menuScope,
        ...arrowProps,
        ref: forwardedRef
    });
});
$d727ebae1b6a7799$export$34b8980744021ec5.displayName = $d727ebae1b6a7799$var$ARROW_NAME;
var $d727ebae1b6a7799$export$2f307d81a64f5442 = (props)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, children: children, open: openProp, onOpenChange: onOpenChange, defaultOpen: defaultOpen } = props;
    const menuScope = $d727ebae1b6a7799$var$useMenuScope(__scopeDropdownMenu);
    const [open = false, setOpen] = (0, $915387e6ab4d88b1$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$d7a01e11500dfb6f, {
        ...menuScope,
        open: open,
        onOpenChange: setOpen,
        children: children
    });
};
var $d727ebae1b6a7799$var$SUB_TRIGGER_NAME = "DropdownMenuSubTrigger";
var $d727ebae1b6a7799$export$21dcb7ec56f874cf = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...subTriggerProps } = props;
    const menuScope = $d727ebae1b6a7799$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$2ea8a7a591ac5eac, {
        ...menuScope,
        ...subTriggerProps,
        ref: forwardedRef
    });
});
$d727ebae1b6a7799$export$21dcb7ec56f874cf.displayName = $d727ebae1b6a7799$var$SUB_TRIGGER_NAME;
var $d727ebae1b6a7799$var$SUB_CONTENT_NAME = "DropdownMenuSubContent";
var $d727ebae1b6a7799$export$f34ec8bc2482cc5f = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeDropdownMenu: __scopeDropdownMenu, ...subContentProps } = props;
    const menuScope = $d727ebae1b6a7799$var$useMenuScope(__scopeDropdownMenu);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($860e6fb93642be7e$export$6d4de93b380beddf, {
        ...menuScope,
        ...subContentProps,
        ref: forwardedRef,
        style: {
            ...props.style,
            "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
            "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
            "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
    });
});
$d727ebae1b6a7799$export$f34ec8bc2482cc5f.displayName = $d727ebae1b6a7799$var$SUB_CONTENT_NAME;
var $d727ebae1b6a7799$export$be92b6f5f03c0fe9 = $d727ebae1b6a7799$export$e44a253a59704894;
var $d727ebae1b6a7799$export$41fb9f06171c75f4 = $d727ebae1b6a7799$export$d2469213b3befba9;
var $d727ebae1b6a7799$export$602eac185826482c = $d727ebae1b6a7799$export$cd369b4d4d54efc9;
var $d727ebae1b6a7799$export$7c6e2c02157bb7d2 = $d727ebae1b6a7799$export$6e76d93a37c01248;
var $d727ebae1b6a7799$export$eb2fcfdbd7ba97d4 = $d727ebae1b6a7799$export$246bebaba3a2f70e;
var $d727ebae1b6a7799$export$b04be29aa201d4f5 = $d727ebae1b6a7799$export$76e48c5b57f24495;
var $d727ebae1b6a7799$export$6d08773d2e66f8f2 = $d727ebae1b6a7799$export$ed97964d1871885d;
var $d727ebae1b6a7799$export$16ce288f89fa631c = $d727ebae1b6a7799$export$53a69729da201fa9;
var $d727ebae1b6a7799$export$a98f0dcb43a68a25 = $d727ebae1b6a7799$export$3323ad73d55f587e;
var $d727ebae1b6a7799$export$371ab307eab489c0 = $d727ebae1b6a7799$export$e4f69b41b1637536;
var $d727ebae1b6a7799$export$c3468e2714d175fa = $d727ebae1b6a7799$export$42355ae145153fb6;
var $d727ebae1b6a7799$export$1ff3c3f08ae963c0 = $d727ebae1b6a7799$export$da160178fd3bc7e9;
var $d727ebae1b6a7799$export$21b07c8f274aebd5 = $d727ebae1b6a7799$export$34b8980744021ec5;
var $d727ebae1b6a7799$export$d7a01e11500dfb6f = $d727ebae1b6a7799$export$2f307d81a64f5442;
var $d727ebae1b6a7799$export$2ea8a7a591ac5eac = $d727ebae1b6a7799$export$21dcb7ec56f874cf;
var $d727ebae1b6a7799$export$6d4de93b380beddf = $d727ebae1b6a7799$export$f34ec8bc2482cc5f;











"use client";
const $37866b0508619fa8$export$be92b6f5f03c0fe9 = (e)=>$7fPBF.createElement($d727ebae1b6a7799$export$be92b6f5f03c0fe9, {
        ...e
    });
$37866b0508619fa8$export$be92b6f5f03c0fe9.displayName = "DropdownMenu.Root";
const $37866b0508619fa8$export$41fb9f06171c75f4 = $7fPBF.forwardRef(({ children: e, ...n }, r)=>$7fPBF.createElement($d727ebae1b6a7799$export$41fb9f06171c75f4, {
        ...n,
        ref: r,
        asChild: !0
    }, (0, $d51eb3faadbea344$export$fb35347076fc30e)(e)));
$37866b0508619fa8$export$41fb9f06171c75f4.displayName = "DropdownMenu.Trigger";
const $37866b0508619fa8$var$b = $7fPBF.createContext({}), $37866b0508619fa8$export$7c6e2c02157bb7d2 = $7fPBF.forwardRef((e, n)=>{
    const r = (0, $fe07e27ecf0fa1d7$export$c4281ec44b929e6)(), { size: s = (0, $bb16039287dfead6$export$4ee1af1a98da3b88).size.default, variant: p = (0, $bb16039287dfead6$export$4ee1af1a98da3b88).variant.default, highContrast: a = (0, $bb16039287dfead6$export$4ee1af1a98da3b88).highContrast.default } = e, { className: i, children: m, color: M, container: w, forceMount: D, ...k } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(e, (0, $bb16039287dfead6$export$4ee1af1a98da3b88)), l = M || r.accentColor;
    return $7fPBF.createElement($d727ebae1b6a7799$export$602eac185826482c, {
        container: w,
        forceMount: D
    }, $7fPBF.createElement((0, $fe07e27ecf0fa1d7$export$14faa19a0f3bbeb2), {
        asChild: !0
    }, $7fPBF.createElement($d727ebae1b6a7799$export$7c6e2c02157bb7d2, {
        "data-accent-color": l,
        align: "start",
        sideOffset: 4,
        collisionPadding: 10,
        ...k,
        asChild: !1,
        ref: n,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-PopperContent", "rt-BaseMenuContent", "rt-DropdownMenuContent", i)
    }, $7fPBF.createElement((0, $649b23d2e2cfc248$export$ccf8d8d7bbf3c2cc), {
        type: "auto"
    }, $7fPBF.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-BaseMenuViewport", "rt-DropdownMenuViewport")
    }, $7fPBF.createElement($37866b0508619fa8$var$b.Provider, {
        value: $7fPBF.useMemo(()=>({
                size: s,
                variant: p,
                color: l,
                highContrast: a
            }), [
            s,
            p,
            l,
            a
        ])
    }, m))))));
});
$37866b0508619fa8$export$7c6e2c02157bb7d2.displayName = "DropdownMenu.Content";
const $37866b0508619fa8$export$b04be29aa201d4f5 = $7fPBF.forwardRef(({ className: e, ...n }, r)=>$7fPBF.createElement($d727ebae1b6a7799$export$b04be29aa201d4f5, {
        ...n,
        asChild: !1,
        ref: r,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-BaseMenuLabel", "rt-DropdownMenuLabel", e)
    }));
$37866b0508619fa8$export$b04be29aa201d4f5.displayName = "DropdownMenu.Label";
const $37866b0508619fa8$export$6d08773d2e66f8f2 = $7fPBF.forwardRef((e, n)=>{
    const { className: r, children: s, color: p = (0, $bb16039287dfead6$export$5a2fcca75b2e1ae6).color.default, shortcut: a, ...i } = e;
    return $7fPBF.createElement($d727ebae1b6a7799$export$6d08773d2e66f8f2, {
        "data-accent-color": p,
        ...i,
        ref: n,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-reset", "rt-BaseMenuItem", "rt-DropdownMenuItem", r)
    }, $7fPBF.createElement((0, $089057084dfb92a4$export$d9f1ccf0bdb05d45), null, s), a && $7fPBF.createElement("div", {
        className: "rt-BaseMenuShortcut rt-DropdownMenuShortcut"
    }, a));
});
$37866b0508619fa8$export$6d08773d2e66f8f2.displayName = "DropdownMenu.Item";
const $37866b0508619fa8$export$eb2fcfdbd7ba97d4 = $7fPBF.forwardRef(({ className: e, ...n }, r)=>$7fPBF.createElement($d727ebae1b6a7799$export$eb2fcfdbd7ba97d4, {
        ...n,
        asChild: !1,
        ref: r,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-BaseMenuGroup", "rt-DropdownMenuGroup", e)
    }));
$37866b0508619fa8$export$eb2fcfdbd7ba97d4.displayName = "DropdownMenu.Group";
const $37866b0508619fa8$export$a98f0dcb43a68a25 = $7fPBF.forwardRef(({ className: e, ...n }, r)=>$7fPBF.createElement($d727ebae1b6a7799$export$a98f0dcb43a68a25, {
        ...n,
        asChild: !1,
        ref: r,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-BaseMenuRadioGroup", "rt-DropdownMenuRadioGroup", e)
    }));
$37866b0508619fa8$export$a98f0dcb43a68a25.displayName = "DropdownMenu.RadioGroup";
const $37866b0508619fa8$export$371ab307eab489c0 = $7fPBF.forwardRef((e, n)=>{
    const { children: r, className: s, color: p = (0, $bb16039287dfead6$export$157ca09440ca2711).color.default, ...a } = e;
    return $7fPBF.createElement($d727ebae1b6a7799$export$371ab307eab489c0, {
        ...a,
        asChild: !1,
        ref: n,
        "data-accent-color": p,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-BaseMenuItem", "rt-BaseMenuRadioItem", "rt-DropdownMenuItem", "rt-DropdownMenuRadioItem", s)
    }, r, $7fPBF.createElement($d727ebae1b6a7799$export$c3468e2714d175fa, {
        className: "rt-BaseMenuItemIndicator rt-DropdownMenuItemIndicator"
    }, $7fPBF.createElement((0, $a0cf194253713caf$export$e8a6d0edce052b3e), {
        className: "rt-BaseMenuItemIndicatorIcon rt-DropdownMenuItemIndicatorIcon"
    })));
});
$37866b0508619fa8$export$371ab307eab489c0.displayName = "DropdownMenu.RadioItem";
const $37866b0508619fa8$export$16ce288f89fa631c = $7fPBF.forwardRef((e, n)=>{
    const { children: r, className: s, shortcut: p, color: a = (0, $bb16039287dfead6$export$4b863c7c9f8e5d87).color.default, ...i } = e;
    return $7fPBF.createElement($d727ebae1b6a7799$export$16ce288f89fa631c, {
        ...i,
        asChild: !1,
        ref: n,
        "data-accent-color": a,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-BaseMenuItem", "rt-BaseMenuCheckboxItem", "rt-DropdownMenuItem", "rt-DropdownMenuCheckboxItem", s)
    }, r, $7fPBF.createElement($d727ebae1b6a7799$export$c3468e2714d175fa, {
        className: "rt-BaseMenuItemIndicator rt-DropdownMenuItemIndicator"
    }, $7fPBF.createElement((0, $a0cf194253713caf$export$e8a6d0edce052b3e), {
        className: "rt-BaseMenuItemIndicatorIcon rt-ContextMenuItemIndicatorIcon"
    })), p && $7fPBF.createElement("div", {
        className: "rt-BaseMenuShortcut rt-DropdownMenuShortcut"
    }, p));
});
$37866b0508619fa8$export$16ce288f89fa631c.displayName = "DropdownMenu.CheckboxItem";
const $37866b0508619fa8$export$d7a01e11500dfb6f = (e)=>$7fPBF.createElement($d727ebae1b6a7799$export$d7a01e11500dfb6f, {
        ...e
    });
$37866b0508619fa8$export$d7a01e11500dfb6f.displayName = "DropdownMenu.Sub";
const $37866b0508619fa8$export$2ea8a7a591ac5eac = $7fPBF.forwardRef((e, n)=>{
    const { className: r, children: s, ...p } = e;
    return $7fPBF.createElement($d727ebae1b6a7799$export$2ea8a7a591ac5eac, {
        ...p,
        asChild: !1,
        ref: n,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-BaseMenuItem", "rt-BaseMenuSubTrigger", "rt-DropdownMenuItem", "rt-DropdownMenuSubTrigger", r)
    }, s, $7fPBF.createElement("div", {
        className: "rt-BaseMenuShortcut rt-DropdownMenuShortcut"
    }, $7fPBF.createElement((0, $a0cf194253713caf$export$e27db7fd6f9e0eab), {
        className: "rt-BaseMenuSubTriggerIcon rt-DropdownMenuSubtriggerIcon"
    })));
});
$37866b0508619fa8$export$2ea8a7a591ac5eac.displayName = "DropdownMenu.SubTrigger";
const $37866b0508619fa8$export$6d4de93b380beddf = $7fPBF.forwardRef((e, n)=>{
    const { size: r, variant: s, color: p, highContrast: a } = $7fPBF.useContext($37866b0508619fa8$var$b), { className: i, children: m, container: M, forceMount: w, ...D } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)({
        size: r,
        variant: s,
        color: p,
        highContrast: a,
        ...e
    }, (0, $bb16039287dfead6$export$4ee1af1a98da3b88));
    return $7fPBF.createElement($d727ebae1b6a7799$export$602eac185826482c, {
        container: M,
        forceMount: w
    }, $7fPBF.createElement((0, $fe07e27ecf0fa1d7$export$14faa19a0f3bbeb2), {
        asChild: !0
    }, $7fPBF.createElement($d727ebae1b6a7799$export$6d4de93b380beddf, {
        "data-accent-color": p,
        alignOffset: -Number(r) * 4,
        sideOffset: 1,
        collisionPadding: 10,
        ...D,
        asChild: !1,
        ref: n,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-PopperContent", "rt-BaseMenuContent", "rt-BaseMenuSubContent", "rt-DropdownMenuContent", "rt-DropdownMenuSubContent", i)
    }, $7fPBF.createElement((0, $649b23d2e2cfc248$export$ccf8d8d7bbf3c2cc), {
        type: "auto"
    }, $7fPBF.createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-BaseMenuViewport", "rt-DropdownMenuViewport")
    }, m)))));
});
$37866b0508619fa8$export$6d4de93b380beddf.displayName = "DropdownMenu.SubContent";
const $37866b0508619fa8$export$1ff3c3f08ae963c0 = $7fPBF.forwardRef(({ className: e, ...n }, r)=>$7fPBF.createElement($d727ebae1b6a7799$export$1ff3c3f08ae963c0, {
        ...n,
        asChild: !1,
        ref: r,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-BaseMenuSeparator", "rt-DropdownMenuSeparator", e)
    }));
$37866b0508619fa8$export$1ff3c3f08ae963c0.displayName = "DropdownMenu.Separator";



var $7fPBF = parcelRequire("7fPBF");





const $6b041706bd29b0a0$export$30d0f7f5de27d862 = {
    ...(0, $b302dbddfdac9d75$export$1e7c0b54c65e0280),
    ...(0, $2c64e4634b053e6a$export$b51caa9f475eecbe),
    ...(0, $738dfabf5e38f576$export$d1dbebac82aee34d)
};



const $af50ae08936e85bf$export$e7bdca014c19fc5c = $7fPBF.forwardRef((p, m)=>{
    const { asChild: r, className: t, ...s } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(p, (0, $6b041706bd29b0a0$export$30d0f7f5de27d862));
    return $7fPBF.createElement(r ? (0, $089057084dfb92a4$export$8c6ed5c666ac1360) : "em", {
        ...s,
        ref: m,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-Em", t)
    });
});
$af50ae08936e85bf$export$e7bdca014c19fc5c.displayName = "Em";






var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");










"use client";
var $1d0670a810892a30$var$originalBodyUserSelect;
var $1d0670a810892a30$var$HOVERCARD_NAME = "HoverCard";
var [$1d0670a810892a30$var$createHoverCardContext, $1d0670a810892a30$export$47b6998a836b7260] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)($1d0670a810892a30$var$HOVERCARD_NAME, [
    (0, $7952cd297982b588$export$722aac194ae923)
]);
var $1d0670a810892a30$var$usePopperScope = (0, $7952cd297982b588$export$722aac194ae923)();
var [$1d0670a810892a30$var$HoverCardProvider, $1d0670a810892a30$var$useHoverCardContext] = $1d0670a810892a30$var$createHoverCardContext($1d0670a810892a30$var$HOVERCARD_NAME);
var $1d0670a810892a30$export$57a077cc9fbe653e = (props)=>{
    const { __scopeHoverCard: __scopeHoverCard, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, openDelay: openDelay = 700, closeDelay: closeDelay = 300 } = props;
    const popperScope = $1d0670a810892a30$var$usePopperScope(__scopeHoverCard);
    const openTimerRef = $7fPBF.useRef(0);
    const closeTimerRef = $7fPBF.useRef(0);
    const hasSelectionRef = $7fPBF.useRef(false);
    const isPointerDownOnContentRef = $7fPBF.useRef(false);
    const [open = false, setOpen] = (0, $915387e6ab4d88b1$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    const handleOpen = $7fPBF.useCallback(()=>{
        clearTimeout(closeTimerRef.current);
        openTimerRef.current = window.setTimeout(()=>setOpen(true), openDelay);
    }, [
        openDelay,
        setOpen
    ]);
    const handleClose = $7fPBF.useCallback(()=>{
        clearTimeout(openTimerRef.current);
        if (!hasSelectionRef.current && !isPointerDownOnContentRef.current) closeTimerRef.current = window.setTimeout(()=>setOpen(false), closeDelay);
    }, [
        closeDelay,
        setOpen
    ]);
    const handleDismiss = $7fPBF.useCallback(()=>setOpen(false), [
        setOpen
    ]);
    $7fPBF.useEffect(()=>{
        return ()=>{
            clearTimeout(openTimerRef.current);
            clearTimeout(closeTimerRef.current);
        };
    }, []);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($1d0670a810892a30$var$HoverCardProvider, {
        scope: __scopeHoverCard,
        open: open,
        onOpenChange: setOpen,
        onOpen: handleOpen,
        onClose: handleClose,
        onDismiss: handleDismiss,
        hasSelectionRef: hasSelectionRef,
        isPointerDownOnContentRef: isPointerDownOnContentRef,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$export$be92b6f5f03c0fe9, {
            ...popperScope,
            children: children
        })
    });
};
$1d0670a810892a30$export$57a077cc9fbe653e.displayName = $1d0670a810892a30$var$HOVERCARD_NAME;
var $1d0670a810892a30$var$TRIGGER_NAME = "HoverCardTrigger";
var $1d0670a810892a30$export$ef9f7fd8e4ba882f = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeHoverCard: __scopeHoverCard, ...triggerProps } = props;
    const context = $1d0670a810892a30$var$useHoverCardContext($1d0670a810892a30$var$TRIGGER_NAME, __scopeHoverCard);
    const popperScope = $1d0670a810892a30$var$usePopperScope(__scopeHoverCard);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$export$b688253958b8dfe7, {
        asChild: true,
        ...popperScope,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).a, {
            "data-state": context.open ? "open" : "closed",
            ...triggerProps,
            ref: forwardedRef,
            onPointerEnter: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerEnter, $1d0670a810892a30$var$excludeTouch(context.onOpen)),
            onPointerLeave: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerLeave, $1d0670a810892a30$var$excludeTouch(context.onClose)),
            onFocus: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onFocus, context.onOpen),
            onBlur: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onBlur, context.onClose),
            onTouchStart: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onTouchStart, (event)=>event.preventDefault())
        })
    });
});
$1d0670a810892a30$export$ef9f7fd8e4ba882f.displayName = $1d0670a810892a30$var$TRIGGER_NAME;
var $1d0670a810892a30$var$PORTAL_NAME = "HoverCardPortal";
var [$1d0670a810892a30$var$PortalProvider, $1d0670a810892a30$var$usePortalContext] = $1d0670a810892a30$var$createHoverCardContext($1d0670a810892a30$var$PORTAL_NAME, {
    forceMount: void 0
});
var $1d0670a810892a30$export$b384c6e0a789f88b = (props)=>{
    const { __scopeHoverCard: __scopeHoverCard, forceMount: forceMount, children: children, container: container } = props;
    const context = $1d0670a810892a30$var$useHoverCardContext($1d0670a810892a30$var$PORTAL_NAME, __scopeHoverCard);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($1d0670a810892a30$var$PortalProvider, {
        scope: __scopeHoverCard,
        forceMount: forceMount,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $e9ce08b8e6e14786$export$99c2b779aa4e8b8b), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $57c7abe8fecdeb41$export$602eac185826482c), {
                asChild: true,
                container: container,
                children: children
            })
        })
    });
};
$1d0670a810892a30$export$b384c6e0a789f88b.displayName = $1d0670a810892a30$var$PORTAL_NAME;
var $1d0670a810892a30$var$CONTENT_NAME = "HoverCardContent";
var $1d0670a810892a30$export$aa4724a5938c586 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const portalContext = $1d0670a810892a30$var$usePortalContext($1d0670a810892a30$var$CONTENT_NAME, props.__scopeHoverCard);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $1d0670a810892a30$var$useHoverCardContext($1d0670a810892a30$var$CONTENT_NAME, props.__scopeHoverCard);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $e9ce08b8e6e14786$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($1d0670a810892a30$var$HoverCardContentImpl, {
            "data-state": context.open ? "open" : "closed",
            ...contentProps,
            onPointerEnter: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerEnter, $1d0670a810892a30$var$excludeTouch(context.onOpen)),
            onPointerLeave: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerLeave, $1d0670a810892a30$var$excludeTouch(context.onClose)),
            ref: forwardedRef
        })
    });
});
$1d0670a810892a30$export$aa4724a5938c586.displayName = $1d0670a810892a30$var$CONTENT_NAME;
var $1d0670a810892a30$var$HoverCardContentImpl = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeHoverCard: __scopeHoverCard, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, ...contentProps } = props;
    const context = $1d0670a810892a30$var$useHoverCardContext($1d0670a810892a30$var$CONTENT_NAME, __scopeHoverCard);
    const popperScope = $1d0670a810892a30$var$usePopperScope(__scopeHoverCard);
    const ref = $7fPBF.useRef(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const [containSelection, setContainSelection] = $7fPBF.useState(false);
    $7fPBF.useEffect(()=>{
        if (containSelection) {
            const body = document.body;
            $1d0670a810892a30$var$originalBodyUserSelect = body.style.userSelect || body.style.webkitUserSelect;
            body.style.userSelect = "none";
            body.style.webkitUserSelect = "none";
            return ()=>{
                body.style.userSelect = $1d0670a810892a30$var$originalBodyUserSelect;
                body.style.webkitUserSelect = $1d0670a810892a30$var$originalBodyUserSelect;
            };
        }
    }, [
        containSelection
    ]);
    $7fPBF.useEffect(()=>{
        if (ref.current) {
            const handlePointerUp = ()=>{
                setContainSelection(false);
                context.isPointerDownOnContentRef.current = false;
                setTimeout(()=>{
                    var _document_getSelection;
                    const hasSelection = ((_document_getSelection = document.getSelection()) === null || _document_getSelection === void 0 ? void 0 : _document_getSelection.toString()) !== "";
                    if (hasSelection) context.hasSelectionRef.current = true;
                });
            };
            document.addEventListener("pointerup", handlePointerUp);
            return ()=>{
                document.removeEventListener("pointerup", handlePointerUp);
                context.hasSelectionRef.current = false;
                context.isPointerDownOnContentRef.current = false;
            };
        }
    }, [
        context.isPointerDownOnContentRef,
        context.hasSelectionRef
    ]);
    $7fPBF.useEffect(()=>{
        if (ref.current) {
            const tabbables = $1d0670a810892a30$var$getTabbableNodes(ref.current);
            tabbables.forEach((tabbable)=>tabbable.setAttribute("tabindex", "-1"));
        }
    });
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $251340165f4765e5$export$177fb62ff3ec1f22), {
        asChild: true,
        disableOutsidePointerEvents: false,
        onInteractOutside: onInteractOutside,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onFocusOutside: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(onFocusOutside, (event)=>{
            event.preventDefault();
        }),
        onDismiss: context.onDismiss,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$export$7c6e2c02157bb7d2, {
            ...popperScope,
            ...contentProps,
            onPointerDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(contentProps.onPointerDown, (event)=>{
                if (event.currentTarget.contains(event.target)) setContainSelection(true);
                context.hasSelectionRef.current = false;
                context.isPointerDownOnContentRef.current = true;
            }),
            ref: composedRefs,
            style: {
                ...contentProps.style,
                userSelect: containSelection ? "text" : void 0,
                // Safari requires prefix
                WebkitUserSelect: containSelection ? "text" : void 0,
                "--radix-hover-card-content-transform-origin": "var(--radix-popper-transform-origin)",
                "--radix-hover-card-content-available-width": "var(--radix-popper-available-width)",
                "--radix-hover-card-content-available-height": "var(--radix-popper-available-height)",
                "--radix-hover-card-trigger-width": "var(--radix-popper-anchor-width)",
                "--radix-hover-card-trigger-height": "var(--radix-popper-anchor-height)"
            }
        })
    });
});
var $1d0670a810892a30$var$ARROW_NAME = "HoverCardArrow";
var $1d0670a810892a30$export$b9744d3e7456d806 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeHoverCard: __scopeHoverCard, ...arrowProps } = props;
    const popperScope = $1d0670a810892a30$var$usePopperScope(__scopeHoverCard);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$export$21b07c8f274aebd5, {
        ...popperScope,
        ...arrowProps,
        ref: forwardedRef
    });
});
$1d0670a810892a30$export$b9744d3e7456d806.displayName = $1d0670a810892a30$var$ARROW_NAME;
function $1d0670a810892a30$var$excludeTouch(eventHandler) {
    return (event)=>event.pointerType === "touch" ? void 0 : eventHandler();
}
function $1d0670a810892a30$var$getTabbableNodes(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode);
    return nodes;
}
var $1d0670a810892a30$export$be92b6f5f03c0fe9 = $1d0670a810892a30$export$57a077cc9fbe653e;
var $1d0670a810892a30$export$41fb9f06171c75f4 = $1d0670a810892a30$export$ef9f7fd8e4ba882f;
var $1d0670a810892a30$export$602eac185826482c = $1d0670a810892a30$export$b384c6e0a789f88b;
var $1d0670a810892a30$export$7c6e2c02157bb7d2 = $1d0670a810892a30$export$aa4724a5938c586;
var $1d0670a810892a30$export$21b07c8f274aebd5 = $1d0670a810892a30$export$b9744d3e7456d806;





const $6e46f7197e72bb47$var$r = [
    "1",
    "2",
    "3"
], $6e46f7197e72bb47$export$4a5b5f0b27c7f985 = {
    ...(0, $b302dbddfdac9d75$export$1e7c0b54c65e0280),
    size: {
        type: "enum",
        className: "rt-r-size",
        values: $6e46f7197e72bb47$var$r,
        default: "2",
        responsive: !0
    },
    width: (0, $b6a742bf1f02ee7d$export$18e5dbe2c243731).width,
    minWidth: (0, $b6a742bf1f02ee7d$export$18e5dbe2c243731).minWidth,
    maxWidth: {
        ...(0, $b6a742bf1f02ee7d$export$18e5dbe2c243731).maxWidth,
        default: "480px"
    },
    ...(0, $a66fc9f2b041fa5d$export$e039c83f102b25e2)
};





const $f1315b00eb5bf4b6$export$be92b6f5f03c0fe9 = (e)=>$7fPBF.createElement($1d0670a810892a30$export$be92b6f5f03c0fe9, {
        closeDelay: 150,
        openDelay: 200,
        ...e
    });
$f1315b00eb5bf4b6$export$be92b6f5f03c0fe9.displayName = "HoverCard.Root";
const $f1315b00eb5bf4b6$export$41fb9f06171c75f4 = $7fPBF.forwardRef(({ children: e, className: t, ...n }, a)=>$7fPBF.createElement($1d0670a810892a30$export$41fb9f06171c75f4, {
        ref: a,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-HoverCardTrigger", t),
        ...n,
        asChild: !0
    }, (0, $d51eb3faadbea344$export$fb35347076fc30e)(e)));
$f1315b00eb5bf4b6$export$41fb9f06171c75f4.displayName = "HoverCard.Trigger";
const $f1315b00eb5bf4b6$export$7c6e2c02157bb7d2 = $7fPBF.forwardRef((e, t)=>{
    const { className: n, forceMount: a, container: m, ...d } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(e, (0, $6e46f7197e72bb47$export$4a5b5f0b27c7f985));
    return $7fPBF.createElement($1d0670a810892a30$export$602eac185826482c, {
        container: m,
        forceMount: a
    }, $7fPBF.createElement((0, $fe07e27ecf0fa1d7$export$14faa19a0f3bbeb2), {
        asChild: !0
    }, $7fPBF.createElement($1d0670a810892a30$export$7c6e2c02157bb7d2, {
        align: "start",
        sideOffset: 8,
        collisionPadding: 10,
        ...d,
        ref: t,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-PopperContent", "rt-HoverCardContent", n)
    })));
});
$f1315b00eb5bf4b6$export$7c6e2c02157bb7d2.displayName = "HoverCard.Content";



var $7fPBF = parcelRequire("7fPBF");


const $a9ab71d5f2dd22da$export$c25acd513dcc8062 = $7fPBF.forwardRef(({ className: e, ...n }, r)=>$7fPBF.createElement((0, $c2c644e421d61486$export$e30f1d91ae9a4bf9), {
        ...n,
        ref: r,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-IconButton", e)
    }));
$a9ab71d5f2dd22da$export$c25acd513dcc8062.displayName = "IconButton";




var $7fPBF = parcelRequire("7fPBF");



const $7b80e402860d0db6$var$a = [
    "all",
    "x",
    "y",
    "top",
    "bottom",
    "left",
    "right"
], $7b80e402860d0db6$var$t = [
    "border-box",
    "padding-box"
], $7b80e402860d0db6$var$e = [
    "current",
    "0"
], $7b80e402860d0db6$export$ced5b5f267007f59 = {
    ...(0, $b302dbddfdac9d75$export$1e7c0b54c65e0280),
    side: {
        type: "enum",
        className: "rt-r-side",
        values: $7b80e402860d0db6$var$a,
        default: "all",
        responsive: !0
    },
    clip: {
        type: "enum",
        className: "rt-r-clip",
        values: $7b80e402860d0db6$var$t,
        default: "border-box",
        responsive: !0
    },
    p: {
        type: "enum",
        className: "rt-r-p",
        values: $7b80e402860d0db6$var$e,
        parseValue: $7b80e402860d0db6$var$p,
        responsive: !0
    },
    px: {
        type: "enum",
        className: "rt-r-px",
        values: $7b80e402860d0db6$var$e,
        parseValue: $7b80e402860d0db6$var$p,
        responsive: !0
    },
    py: {
        type: "enum",
        className: "rt-r-py",
        values: $7b80e402860d0db6$var$e,
        parseValue: $7b80e402860d0db6$var$p,
        responsive: !0
    },
    pt: {
        type: "enum",
        className: "rt-r-pt",
        values: $7b80e402860d0db6$var$e,
        parseValue: $7b80e402860d0db6$var$p,
        responsive: !0
    },
    pr: {
        type: "enum",
        className: "rt-r-pr",
        values: $7b80e402860d0db6$var$e,
        parseValue: $7b80e402860d0db6$var$p,
        responsive: !0
    },
    pb: {
        type: "enum",
        className: "rt-r-pb",
        values: $7b80e402860d0db6$var$e,
        parseValue: $7b80e402860d0db6$var$p,
        responsive: !0
    },
    pl: {
        type: "enum",
        className: "rt-r-pl",
        values: $7b80e402860d0db6$var$e,
        parseValue: $7b80e402860d0db6$var$p,
        responsive: !0
    }
};
function $7b80e402860d0db6$var$p(s) {
    return s === "current" ? "inset" : s;
}




const $838adec7d930b2c0$export$45e6362c68fff4f8 = $7fPBF.forwardRef((r, p)=>{
    const { asChild: t, className: s, ...m } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(r, (0, $7b80e402860d0db6$export$ced5b5f267007f59), (0, $df06be8448ff4f3c$export$83503616c7a463e3));
    return $7fPBF.createElement(t ? (0, $089057084dfb92a4$export$8c6ed5c666ac1360) : "div", {
        ...m,
        ref: p,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-Inset", s)
    });
});
$838adec7d930b2c0$export$45e6362c68fff4f8.displayName = "Inset";



var $7fPBF = parcelRequire("7fPBF");



const $e37e2a7c15281fb1$var$e = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9"
], $e37e2a7c15281fb1$export$1ad1d5a833ace4d5 = {
    ...(0, $b302dbddfdac9d75$export$1e7c0b54c65e0280),
    size: {
        type: "enum",
        className: "rt-r-size",
        values: $e37e2a7c15281fb1$var$e,
        responsive: !0
    }
};




const $e34f6ad538a6cb7d$export$5e66ad77b1eb2956 = $7fPBF.forwardRef((p, e)=>{
    const { asChild: t, className: s, ...m } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(p, (0, $e37e2a7c15281fb1$export$1ad1d5a833ace4d5), (0, $df06be8448ff4f3c$export$83503616c7a463e3));
    return $7fPBF.createElement(t ? (0, $089057084dfb92a4$export$8c6ed5c666ac1360) : "kbd", {
        ...m,
        ref: e,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-reset", "rt-Kbd", s)
    });
});
$e34f6ad538a6cb7d$export$5e66ad77b1eb2956.displayName = "Kbd";



var $7fPBF = parcelRequire("7fPBF");










const $227438da311d7d8a$var$n = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9"
], $227438da311d7d8a$var$f = [
    "auto",
    "always",
    "hover",
    "none"
], $227438da311d7d8a$export$3264cbbb98f52462 = {
    ...(0, $b302dbddfdac9d75$export$1e7c0b54c65e0280),
    size: {
        type: "enum",
        className: "rt-r-size",
        values: $227438da311d7d8a$var$n,
        responsive: !0
    },
    ...(0, $ec44dfa8e04fe2ae$export$959a85f577d21089),
    ...(0, $748529190ac30cea$export$9fbb19586d60aa6c),
    ...(0, $2c64e4634b053e6a$export$b51caa9f475eecbe),
    ...(0, $738dfabf5e38f576$export$d1dbebac82aee34d),
    underline: {
        type: "enum",
        className: "rt-underline",
        values: $227438da311d7d8a$var$f,
        default: "auto"
    },
    ...(0, $e914ebf2ce406d8c$export$d0261b42be231f92),
    ...(0, $f41c61290c2a7125$export$2f84412d299def33)
};


const $c3e3b5f85797bbb1$export$a6c7ac8248d6e38a = $7fPBF.forwardRef((p, t)=>{
    const { children: r, className: s, color: n, asChild: i, ...m } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(p, (0, $227438da311d7d8a$export$3264cbbb98f52462));
    return $7fPBF.createElement((0, $83db9e82a643d7a4$export$5f1af8db9871e1d6), {
        ...m,
        "data-accent-color": n,
        ref: t,
        asChild: !0,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-reset", "rt-Link", s)
    }, i ? r : $7fPBF.createElement("a", null, r));
});
$c3e3b5f85797bbb1$export$a6c7ac8248d6e38a.displayName = "Link";


var $1876ebeddbd368a2$exports = {};

$parcel$export($1876ebeddbd368a2$exports, "Root", function () { return $1876ebeddbd368a2$export$be92b6f5f03c0fe9; });
$parcel$export($1876ebeddbd368a2$exports, "Trigger", function () { return $1876ebeddbd368a2$export$41fb9f06171c75f4; });
$parcel$export($1876ebeddbd368a2$exports, "Content", function () { return $1876ebeddbd368a2$export$7c6e2c02157bb7d2; });
$parcel$export($1876ebeddbd368a2$exports, "Close", function () { return $1876ebeddbd368a2$export$f39c2d165cd861fe; });

var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
















"use client";
var $4fba2669e33915a2$var$POPOVER_NAME = "Popover";
var [$4fba2669e33915a2$var$createPopoverContext, $4fba2669e33915a2$export$c8393c9e73286932] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)($4fba2669e33915a2$var$POPOVER_NAME, [
    (0, $7952cd297982b588$export$722aac194ae923)
]);
var $4fba2669e33915a2$var$usePopperScope = (0, $7952cd297982b588$export$722aac194ae923)();
var [$4fba2669e33915a2$var$PopoverProvider, $4fba2669e33915a2$var$usePopoverContext] = $4fba2669e33915a2$var$createPopoverContext($4fba2669e33915a2$var$POPOVER_NAME);
var $4fba2669e33915a2$export$5b6b19405a83ff9d = (props)=>{
    const { __scopePopover: __scopePopover, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = false } = props;
    const popperScope = $4fba2669e33915a2$var$usePopperScope(__scopePopover);
    const triggerRef = $7fPBF.useRef(null);
    const [hasCustomAnchor, setHasCustomAnchor] = $7fPBF.useState(false);
    const [open = false, setOpen] = (0, $915387e6ab4d88b1$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$export$be92b6f5f03c0fe9, {
        ...popperScope,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($4fba2669e33915a2$var$PopoverProvider, {
            scope: __scopePopover,
            contentId: (0, $8a8e9b94c33ba6d6$export$f680877a34711e37)(),
            triggerRef: triggerRef,
            open: open,
            onOpenChange: setOpen,
            onOpenToggle: $7fPBF.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
                setOpen
            ]),
            hasCustomAnchor: hasCustomAnchor,
            onCustomAnchorAdd: $7fPBF.useCallback(()=>setHasCustomAnchor(true), []),
            onCustomAnchorRemove: $7fPBF.useCallback(()=>setHasCustomAnchor(false), []),
            modal: modal,
            children: children
        })
    });
};
$4fba2669e33915a2$export$5b6b19405a83ff9d.displayName = $4fba2669e33915a2$var$POPOVER_NAME;
var $4fba2669e33915a2$var$ANCHOR_NAME = "PopoverAnchor";
var $4fba2669e33915a2$export$96e5381f42521a79 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...anchorProps } = props;
    const context = $4fba2669e33915a2$var$usePopoverContext($4fba2669e33915a2$var$ANCHOR_NAME, __scopePopover);
    const popperScope = $4fba2669e33915a2$var$usePopperScope(__scopePopover);
    const { onCustomAnchorAdd: onCustomAnchorAdd, onCustomAnchorRemove: onCustomAnchorRemove } = context;
    $7fPBF.useEffect(()=>{
        onCustomAnchorAdd();
        return ()=>onCustomAnchorRemove();
    }, [
        onCustomAnchorAdd,
        onCustomAnchorRemove
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$export$b688253958b8dfe7, {
        ...popperScope,
        ...anchorProps,
        ref: forwardedRef
    });
});
$4fba2669e33915a2$export$96e5381f42521a79.displayName = $4fba2669e33915a2$var$ANCHOR_NAME;
var $4fba2669e33915a2$var$TRIGGER_NAME = "PopoverTrigger";
var $4fba2669e33915a2$export$7dacb05d26466c3 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...triggerProps } = props;
    const context = $4fba2669e33915a2$var$usePopoverContext($4fba2669e33915a2$var$TRIGGER_NAME, __scopePopover);
    const popperScope = $4fba2669e33915a2$var$usePopperScope(__scopePopover);
    const composedTriggerRef = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    const trigger = /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).button, {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.contentId,
        "data-state": $4fba2669e33915a2$var$getState(context.open),
        ...triggerProps,
        ref: composedTriggerRef,
        onClick: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    });
    return context.hasCustomAnchor ? trigger : /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$export$b688253958b8dfe7, {
        asChild: true,
        ...popperScope,
        children: trigger
    });
});
$4fba2669e33915a2$export$7dacb05d26466c3.displayName = $4fba2669e33915a2$var$TRIGGER_NAME;
var $4fba2669e33915a2$var$PORTAL_NAME = "PopoverPortal";
var [$4fba2669e33915a2$var$PortalProvider, $4fba2669e33915a2$var$usePortalContext] = $4fba2669e33915a2$var$createPopoverContext($4fba2669e33915a2$var$PORTAL_NAME, {
    forceMount: void 0
});
var $4fba2669e33915a2$export$dd679ffb4362d2d4 = (props)=>{
    const { __scopePopover: __scopePopover, forceMount: forceMount, children: children, container: container } = props;
    const context = $4fba2669e33915a2$var$usePopoverContext($4fba2669e33915a2$var$PORTAL_NAME, __scopePopover);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($4fba2669e33915a2$var$PortalProvider, {
        scope: __scopePopover,
        forceMount: forceMount,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $e9ce08b8e6e14786$export$99c2b779aa4e8b8b), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $57c7abe8fecdeb41$export$602eac185826482c), {
                asChild: true,
                container: container,
                children: children
            })
        })
    });
};
$4fba2669e33915a2$export$dd679ffb4362d2d4.displayName = $4fba2669e33915a2$var$PORTAL_NAME;
var $4fba2669e33915a2$var$CONTENT_NAME = "PopoverContent";
var $4fba2669e33915a2$export$d7e1f420b25549ff = $7fPBF.forwardRef((props, forwardedRef)=>{
    const portalContext = $4fba2669e33915a2$var$usePortalContext($4fba2669e33915a2$var$CONTENT_NAME, props.__scopePopover);
    const { forceMount: forceMount = portalContext.forceMount, ...contentProps } = props;
    const context = $4fba2669e33915a2$var$usePopoverContext($4fba2669e33915a2$var$CONTENT_NAME, props.__scopePopover);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $e9ce08b8e6e14786$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: context.modal ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($4fba2669e33915a2$var$PopoverContentModal, {
            ...contentProps,
            ref: forwardedRef
        }) : /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($4fba2669e33915a2$var$PopoverContentNonModal, {
            ...contentProps,
            ref: forwardedRef
        })
    });
});
$4fba2669e33915a2$export$d7e1f420b25549ff.displayName = $4fba2669e33915a2$var$CONTENT_NAME;
var $4fba2669e33915a2$var$PopoverContentModal = $7fPBF.forwardRef((props, forwardedRef)=>{
    const context = $4fba2669e33915a2$var$usePopoverContext($4fba2669e33915a2$var$CONTENT_NAME, props.__scopePopover);
    const contentRef = $7fPBF.useRef(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, contentRef);
    const isRightClickOutsideRef = $7fPBF.useRef(false);
    $7fPBF.useEffect(()=>{
        const content = contentRef.current;
        if (content) return (0, $2950574f4b60c018$export$6e33d16126ed003c)(content);
    }, []);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $ef57a4b421076988$export$2e2bcd8739ae039), {
        as: (0, $089057084dfb92a4$export$8c6ed5c666ac1360),
        allowPinchZoom: true,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($4fba2669e33915a2$var$PopoverContentImpl, {
            ...props,
            ref: composedRefs,
            trapFocus: context.open,
            disableOutsidePointerEvents: true,
            onCloseAutoFocus: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
                var _context_triggerRef_current;
                event.preventDefault();
                if (!isRightClickOutsideRef.current) (_context_triggerRef_current = context.triggerRef.current) === null || _context_triggerRef_current === void 0 ? void 0 : _context_triggerRef_current.focus();
            }),
            onPointerDownOutside: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
                const originalEvent = event.detail.originalEvent;
                const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
                const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
                isRightClickOutsideRef.current = isRightClick;
            }, {
                checkForDefaultPrevented: false
            }),
            onFocusOutside: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault(), {
                checkForDefaultPrevented: false
            })
        })
    });
});
var $4fba2669e33915a2$var$PopoverContentNonModal = $7fPBF.forwardRef((props, forwardedRef)=>{
    const context = $4fba2669e33915a2$var$usePopoverContext($4fba2669e33915a2$var$CONTENT_NAME, props.__scopePopover);
    const hasInteractedOutsideRef = $7fPBF.useRef(false);
    const hasPointerDownOutsideRef = $7fPBF.useRef(false);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($4fba2669e33915a2$var$PopoverContentImpl, {
        ...props,
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            var _props_onCloseAutoFocus;
            (_props_onCloseAutoFocus = props.onCloseAutoFocus) === null || _props_onCloseAutoFocus === void 0 ? void 0 : _props_onCloseAutoFocus.call(props, event);
            if (!event.defaultPrevented) {
                var _context_triggerRef_current;
                if (!hasInteractedOutsideRef.current) (_context_triggerRef_current = context.triggerRef.current) === null || _context_triggerRef_current === void 0 ? void 0 : _context_triggerRef_current.focus();
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            var _props_onInteractOutside, _context_triggerRef_current;
            (_props_onInteractOutside = props.onInteractOutside) === null || _props_onInteractOutside === void 0 ? void 0 : _props_onInteractOutside.call(props, event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            }
            const target = event.target;
            const targetIsTrigger = (_context_triggerRef_current = context.triggerRef.current) === null || _context_triggerRef_current === void 0 ? void 0 : _context_triggerRef_current.contains(target);
            if (targetIsTrigger) event.preventDefault();
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    });
});
var $4fba2669e33915a2$var$PopoverContentImpl = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, disableOutsidePointerEvents: disableOutsidePointerEvents, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, ...contentProps } = props;
    const context = $4fba2669e33915a2$var$usePopoverContext($4fba2669e33915a2$var$CONTENT_NAME, __scopePopover);
    const popperScope = $4fba2669e33915a2$var$usePopperScope(__scopePopover);
    (0, $38bbe2f1de23f200$export$b7ece24a22aeda8c)();
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $0d555b2b0a3ffff1$export$20e40289641fbbb6), {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $251340165f4765e5$export$177fb62ff3ec1f22), {
            asChild: true,
            disableOutsidePointerEvents: disableOutsidePointerEvents,
            onInteractOutside: onInteractOutside,
            onEscapeKeyDown: onEscapeKeyDown,
            onPointerDownOutside: onPointerDownOutside,
            onFocusOutside: onFocusOutside,
            onDismiss: ()=>context.onOpenChange(false),
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$export$7c6e2c02157bb7d2, {
                "data-state": $4fba2669e33915a2$var$getState(context.open),
                role: "dialog",
                id: context.contentId,
                ...popperScope,
                ...contentProps,
                ref: forwardedRef,
                style: {
                    ...contentProps.style,
                    "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                    "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                    "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                    "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                    "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
            })
        })
    });
});
var $4fba2669e33915a2$var$CLOSE_NAME = "PopoverClose";
var $4fba2669e33915a2$export$d6ac43ebaa40d53e = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...closeProps } = props;
    const context = $4fba2669e33915a2$var$usePopoverContext($4fba2669e33915a2$var$CLOSE_NAME, __scopePopover);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).button, {
        type: "button",
        ...closeProps,
        ref: forwardedRef,
        onClick: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    });
});
$4fba2669e33915a2$export$d6ac43ebaa40d53e.displayName = $4fba2669e33915a2$var$CLOSE_NAME;
var $4fba2669e33915a2$var$ARROW_NAME = "PopoverArrow";
var $4fba2669e33915a2$export$3152841115e061b2 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopePopover: __scopePopover, ...arrowProps } = props;
    const popperScope = $4fba2669e33915a2$var$usePopperScope(__scopePopover);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$export$21b07c8f274aebd5, {
        ...popperScope,
        ...arrowProps,
        ref: forwardedRef
    });
});
$4fba2669e33915a2$export$3152841115e061b2.displayName = $4fba2669e33915a2$var$ARROW_NAME;
function $4fba2669e33915a2$var$getState(open) {
    return open ? "open" : "closed";
}
var $4fba2669e33915a2$export$be92b6f5f03c0fe9 = $4fba2669e33915a2$export$5b6b19405a83ff9d;
var $4fba2669e33915a2$export$b688253958b8dfe7 = $4fba2669e33915a2$export$96e5381f42521a79;
var $4fba2669e33915a2$export$41fb9f06171c75f4 = $4fba2669e33915a2$export$7dacb05d26466c3;
var $4fba2669e33915a2$export$602eac185826482c = $4fba2669e33915a2$export$dd679ffb4362d2d4;
var $4fba2669e33915a2$export$7c6e2c02157bb7d2 = $4fba2669e33915a2$export$d7e1f420b25549ff;
var $4fba2669e33915a2$export$f39c2d165cd861fe = $4fba2669e33915a2$export$d6ac43ebaa40d53e;
var $4fba2669e33915a2$export$21b07c8f274aebd5 = $4fba2669e33915a2$export$3152841115e061b2;







const $39cc5ba69db27796$var$p = [
    "1",
    "2",
    "3",
    "4"
], $39cc5ba69db27796$export$dae284412ba58db7 = {
    ...(0, $b302dbddfdac9d75$export$1e7c0b54c65e0280),
    size: {
        type: "enum",
        className: "rt-r-size",
        values: $39cc5ba69db27796$var$p,
        default: "2",
        responsive: !0
    },
    width: (0, $b6a742bf1f02ee7d$export$18e5dbe2c243731).width,
    minWidth: (0, $b6a742bf1f02ee7d$export$18e5dbe2c243731).minWidth,
    maxWidth: {
        ...(0, $b6a742bf1f02ee7d$export$18e5dbe2c243731).maxWidth,
        default: "480px"
    },
    ...(0, $a66fc9f2b041fa5d$export$e039c83f102b25e2)
};



const $1876ebeddbd368a2$export$be92b6f5f03c0fe9 = (e)=>$7fPBF.createElement($4fba2669e33915a2$export$be92b6f5f03c0fe9, {
        ...e
    });
$1876ebeddbd368a2$export$be92b6f5f03c0fe9.displayName = "Popover.Root";
const $1876ebeddbd368a2$export$41fb9f06171c75f4 = $7fPBF.forwardRef(({ children: e, ...r }, t)=>$7fPBF.createElement($4fba2669e33915a2$export$41fb9f06171c75f4, {
        ...r,
        ref: t,
        asChild: !0
    }, (0, $d51eb3faadbea344$export$fb35347076fc30e)(e)));
$1876ebeddbd368a2$export$41fb9f06171c75f4.displayName = "Popover.Trigger";
const $1876ebeddbd368a2$export$7c6e2c02157bb7d2 = $7fPBF.forwardRef((e, r)=>{
    const { className: t, forceMount: v, container: a, ...f } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(e, (0, $39cc5ba69db27796$export$dae284412ba58db7));
    return $7fPBF.createElement($4fba2669e33915a2$export$602eac185826482c, {
        container: a,
        forceMount: v
    }, $7fPBF.createElement((0, $fe07e27ecf0fa1d7$export$14faa19a0f3bbeb2), {
        asChild: !0
    }, $7fPBF.createElement($4fba2669e33915a2$export$7c6e2c02157bb7d2, {
        align: "start",
        sideOffset: 8,
        collisionPadding: 10,
        ...f,
        ref: r,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-PopperContent", "rt-PopoverContent", t)
    })));
});
$1876ebeddbd368a2$export$7c6e2c02157bb7d2.displayName = "Popover.Content";
const $1876ebeddbd368a2$export$f39c2d165cd861fe = $7fPBF.forwardRef(({ children: e, ...r }, t)=>$7fPBF.createElement($4fba2669e33915a2$export$f39c2d165cd861fe, {
        ...r,
        ref: t,
        asChild: !0
    }, (0, $d51eb3faadbea344$export$fb35347076fc30e)(e)));
$1876ebeddbd368a2$export$f39c2d165cd861fe.displayName = "Popover.Close";






var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");



"use client";
var $d6f63fb7ff0439db$var$PROGRESS_NAME = "Progress";
var $d6f63fb7ff0439db$var$DEFAULT_MAX = 100;
var [$d6f63fb7ff0439db$var$createProgressContext, $d6f63fb7ff0439db$export$388eb2d8f6d3261f] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)($d6f63fb7ff0439db$var$PROGRESS_NAME);
var [$d6f63fb7ff0439db$var$ProgressProvider, $d6f63fb7ff0439db$var$useProgressContext] = $d6f63fb7ff0439db$var$createProgressContext($d6f63fb7ff0439db$var$PROGRESS_NAME);
var $d6f63fb7ff0439db$export$b25a304ec7d746bb = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeProgress: __scopeProgress, value: valueProp = null, max: maxProp, getValueLabel: getValueLabel = $d6f63fb7ff0439db$var$defaultGetValueLabel, ...progressProps } = props;
    if ((maxProp || maxProp === 0) && !$d6f63fb7ff0439db$var$isValidMaxNumber(maxProp)) console.error($d6f63fb7ff0439db$var$getInvalidMaxError(`${maxProp}`, "Progress"));
    const max = $d6f63fb7ff0439db$var$isValidMaxNumber(maxProp) ? maxProp : $d6f63fb7ff0439db$var$DEFAULT_MAX;
    if (valueProp !== null && !$d6f63fb7ff0439db$var$isValidValueNumber(valueProp, max)) console.error($d6f63fb7ff0439db$var$getInvalidValueError(`${valueProp}`, "Progress"));
    const value = $d6f63fb7ff0439db$var$isValidValueNumber(valueProp, max) ? valueProp : null;
    const valueLabel = $d6f63fb7ff0439db$var$isNumber(value) ? getValueLabel(value, max) : void 0;
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($d6f63fb7ff0439db$var$ProgressProvider, {
        scope: __scopeProgress,
        value: value,
        max: max,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
            "aria-valuemax": max,
            "aria-valuemin": 0,
            "aria-valuenow": $d6f63fb7ff0439db$var$isNumber(value) ? value : void 0,
            "aria-valuetext": valueLabel,
            role: "progressbar",
            "data-state": $d6f63fb7ff0439db$var$getProgressState(value, max),
            "data-value": value !== null && value !== void 0 ? value : void 0,
            "data-max": max,
            ...progressProps,
            ref: forwardedRef
        })
    });
});
$d6f63fb7ff0439db$export$b25a304ec7d746bb.displayName = $d6f63fb7ff0439db$var$PROGRESS_NAME;
var $d6f63fb7ff0439db$var$INDICATOR_NAME = "ProgressIndicator";
var $d6f63fb7ff0439db$export$2b776f7e7ee60dbd = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeProgress: __scopeProgress, ...indicatorProps } = props;
    const context = $d6f63fb7ff0439db$var$useProgressContext($d6f63fb7ff0439db$var$INDICATOR_NAME, __scopeProgress);
    var _context_value;
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
        "data-state": $d6f63fb7ff0439db$var$getProgressState(context.value, context.max),
        "data-value": (_context_value = context.value) !== null && _context_value !== void 0 ? _context_value : void 0,
        "data-max": context.max,
        ...indicatorProps,
        ref: forwardedRef
    });
});
$d6f63fb7ff0439db$export$2b776f7e7ee60dbd.displayName = $d6f63fb7ff0439db$var$INDICATOR_NAME;
function $d6f63fb7ff0439db$var$defaultGetValueLabel(value, max) {
    return `${Math.round(value / max * 100)}%`;
}
function $d6f63fb7ff0439db$var$getProgressState(value, maxValue) {
    return value == null ? "indeterminate" : value === maxValue ? "complete" : "loading";
}
function $d6f63fb7ff0439db$var$isNumber(value) {
    return typeof value === "number";
}
function $d6f63fb7ff0439db$var$isValidMaxNumber(max) {
    return $d6f63fb7ff0439db$var$isNumber(max) && !isNaN(max) && max > 0;
}
function $d6f63fb7ff0439db$var$isValidValueNumber(value, max) {
    return $d6f63fb7ff0439db$var$isNumber(value) && !isNaN(value) && value <= max && value >= 0;
}
function $d6f63fb7ff0439db$var$getInvalidMaxError(propValue, componentName) {
    return `Invalid prop \`max\` of value \`${propValue}\` supplied to \`${componentName}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${$d6f63fb7ff0439db$var$DEFAULT_MAX}\`.`;
}
function $d6f63fb7ff0439db$var$getInvalidValueError(propValue, componentName) {
    return `Invalid prop \`value\` of value \`${propValue}\` supplied to \`${componentName}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${$d6f63fb7ff0439db$var$DEFAULT_MAX} if no \`max\` prop is set)
  - \`null\` or \`undefined\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
var $d6f63fb7ff0439db$export$be92b6f5f03c0fe9 = $d6f63fb7ff0439db$export$b25a304ec7d746bb;
var $d6f63fb7ff0439db$export$adb584737d712b70 = $d6f63fb7ff0439db$export$2b776f7e7ee60dbd;





const $b9c878bef60b58fd$var$o = [
    "1",
    "2",
    "3"
], $b9c878bef60b58fd$var$t = [
    "classic",
    "surface",
    "soft"
], $b9c878bef60b58fd$export$373d690c590c11f6 = {
    size: {
        type: "enum",
        className: "rt-r-size",
        values: $b9c878bef60b58fd$var$o,
        default: "2",
        responsive: !0
    },
    variant: {
        type: "enum",
        className: "rt-variant",
        values: $b9c878bef60b58fd$var$t,
        default: "surface"
    },
    ...(0, $e914ebf2ce406d8c$export$8255b018f448be13),
    ...(0, $f41c61290c2a7125$export$2f84412d299def33),
    ...(0, $3d20a83f81464c0a$export$c467f6769b59b70c),
    duration: {
        type: "string"
    }
};





const $d0465bc755514d39$export$b25a304ec7d746bb = $7fPBF.forwardRef((p, t)=>{
    const { className: m, style: i, color: a, radius: n, duration: P, ...r } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(p, (0, $b9c878bef60b58fd$export$373d690c590c11f6), (0, $df06be8448ff4f3c$export$83503616c7a463e3));
    return $7fPBF.createElement($d6f63fb7ff0439db$export$be92b6f5f03c0fe9, {
        "data-accent-color": a,
        "data-radius": n,
        ref: t,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-ProgressRoot", m),
        style: (0, $f71bfc9c84797302$export$e618dc39ac9ad607)({
            "--progress-duration": "value" in r ? void 0 : P,
            "--progress-value": "value" in r ? r.value : void 0,
            "--progress-max": "max" in r ? r.max : void 0
        }, i),
        ...r,
        asChild: !1
    }, $7fPBF.createElement($d6f63fb7ff0439db$export$adb584737d712b70, {
        className: "rt-ProgressIndicator"
    }));
});
$d0465bc755514d39$export$b25a304ec7d746bb.displayName = "Progress";



var $7fPBF = parcelRequire("7fPBF");





const $c7c4b10358d968e2$export$ec5b28dc52657bbf = {
    ...(0, $b302dbddfdac9d75$export$1e7c0b54c65e0280),
    ...(0, $2c64e4634b053e6a$export$b51caa9f475eecbe),
    ...(0, $738dfabf5e38f576$export$d1dbebac82aee34d)
};



const $c002b24eb8e1074b$export$82b8d343c504672 = $7fPBF.forwardRef((t, p)=>{
    const { asChild: r, className: s, ...m } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(t, (0, $c7c4b10358d968e2$export$ec5b28dc52657bbf));
    return $7fPBF.createElement(r ? (0, $089057084dfb92a4$export$8c6ed5c666ac1360) : "q", {
        ...m,
        ref: p,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-Quote", s)
    });
});
$c002b24eb8e1074b$export$82b8d343c504672.displayName = "Quote";



var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");











"use client";
var $40fc6af44b1cb291$var$RADIO_NAME = "Radio";
var [$40fc6af44b1cb291$var$createRadioContext, $40fc6af44b1cb291$var$createRadioScope] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)($40fc6af44b1cb291$var$RADIO_NAME);
var [$40fc6af44b1cb291$var$RadioProvider, $40fc6af44b1cb291$var$useRadioContext] = $40fc6af44b1cb291$var$createRadioContext($40fc6af44b1cb291$var$RADIO_NAME);
var $40fc6af44b1cb291$var$Radio = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeRadio: __scopeRadio, name: name, checked: checked = false, required: required, disabled: disabled, value: value = "on", onCheck: onCheck, ...radioProps } = props;
    const [button, setButton] = $7fPBF.useState(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setButton(node));
    const hasConsumerStoppedPropagationRef = $7fPBF.useRef(false);
    const isFormControl = button ? Boolean(button.closest("form")) : true;
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)($40fc6af44b1cb291$var$RadioProvider, {
        scope: __scopeRadio,
        checked: checked,
        disabled: disabled,
        children: [
            /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).button, {
                type: "button",
                role: "radio",
                "aria-checked": checked,
                "data-state": $40fc6af44b1cb291$var$getState(checked),
                "data-disabled": disabled ? "" : void 0,
                disabled: disabled,
                value: value,
                ...radioProps,
                ref: composedRefs,
                onClick: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onClick, (event)=>{
                    if (!checked) onCheck === null || onCheck === void 0 ? void 0 : onCheck();
                    if (isFormControl) {
                        hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
                        if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
                    }
                })
            }),
            isFormControl && /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($40fc6af44b1cb291$var$BubbleInput, {
                control: button,
                bubbles: !hasConsumerStoppedPropagationRef.current,
                name: name,
                value: value,
                checked: checked,
                required: required,
                disabled: disabled,
                style: {
                    transform: "translateX(-100%)"
                }
            })
        ]
    });
});
$40fc6af44b1cb291$var$Radio.displayName = $40fc6af44b1cb291$var$RADIO_NAME;
var $40fc6af44b1cb291$var$INDICATOR_NAME = "RadioIndicator";
var $40fc6af44b1cb291$var$RadioIndicator = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeRadio: __scopeRadio, forceMount: forceMount, ...indicatorProps } = props;
    const context = $40fc6af44b1cb291$var$useRadioContext($40fc6af44b1cb291$var$INDICATOR_NAME, __scopeRadio);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $e9ce08b8e6e14786$export$99c2b779aa4e8b8b), {
        present: forceMount || context.checked,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).span, {
            "data-state": $40fc6af44b1cb291$var$getState(context.checked),
            "data-disabled": context.disabled ? "" : void 0,
            ...indicatorProps,
            ref: forwardedRef
        })
    });
});
$40fc6af44b1cb291$var$RadioIndicator.displayName = $40fc6af44b1cb291$var$INDICATOR_NAME;
var $40fc6af44b1cb291$var$BubbleInput = (props)=>{
    const { control: control, checked: checked, bubbles: bubbles = true, ...inputProps } = props;
    const ref = $7fPBF.useRef(null);
    const prevChecked = (0, $62f6e650b37fb598$export$5cae361ad82dce8b)(checked);
    const controlSize = (0, $0560b0618278acc0$export$1ab7ae714698c4b8)(control);
    $7fPBF.useEffect(()=>{
        const input = ref.current;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
        const setChecked = descriptor.set;
        if (prevChecked !== checked && setChecked) {
            const event = new Event("click", {
                bubbles: bubbles
            });
            setChecked.call(input, checked);
            input.dispatchEvent(event);
        }
    }, [
        prevChecked,
        checked,
        bubbles
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("input", {
        type: "radio",
        "aria-hidden": true,
        defaultChecked: checked,
        ...inputProps,
        tabIndex: -1,
        ref: ref,
        style: {
            ...props.style,
            ...controlSize,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0
        }
    });
};
function $40fc6af44b1cb291$var$getState(checked) {
    return checked ? "checked" : "unchecked";
}
var $40fc6af44b1cb291$var$ARROW_KEYS = [
    "ArrowUp",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight"
];
var $40fc6af44b1cb291$var$RADIO_GROUP_NAME = "RadioGroup";
var [$40fc6af44b1cb291$var$createRadioGroupContext, $40fc6af44b1cb291$export$c547093f11b76da2] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)($40fc6af44b1cb291$var$RADIO_GROUP_NAME, [
    (0, $8183e11ba1e9b7dc$export$c7109489551a4f4),
    $40fc6af44b1cb291$var$createRadioScope
]);
var $40fc6af44b1cb291$var$useRovingFocusGroupScope = (0, $8183e11ba1e9b7dc$export$c7109489551a4f4)();
var $40fc6af44b1cb291$var$useRadioScope = $40fc6af44b1cb291$var$createRadioScope();
var [$40fc6af44b1cb291$var$RadioGroupProvider, $40fc6af44b1cb291$var$useRadioGroupContext] = $40fc6af44b1cb291$var$createRadioGroupContext($40fc6af44b1cb291$var$RADIO_GROUP_NAME);
var $40fc6af44b1cb291$export$a98f0dcb43a68a25 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeRadioGroup: __scopeRadioGroup, name: name, defaultValue: defaultValue, value: valueProp, required: required = false, disabled: disabled = false, orientation: orientation, dir: dir, loop: loop = true, onValueChange: onValueChange, ...groupProps } = props;
    const rovingFocusGroupScope = $40fc6af44b1cb291$var$useRovingFocusGroupScope(__scopeRadioGroup);
    const direction = (0, $3342477e04611d10$export$b39126d51d94e6f3)(dir);
    const [value, setValue] = (0, $915387e6ab4d88b1$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange
    });
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($40fc6af44b1cb291$var$RadioGroupProvider, {
        scope: __scopeRadioGroup,
        name: name,
        required: required,
        disabled: disabled,
        value: value,
        onValueChange: setValue,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($8183e11ba1e9b7dc$export$be92b6f5f03c0fe9, {
            asChild: true,
            ...rovingFocusGroupScope,
            orientation: orientation,
            dir: direction,
            loop: loop,
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
                role: "radiogroup",
                "aria-required": required,
                "aria-orientation": orientation,
                "data-disabled": disabled ? "" : void 0,
                dir: direction,
                ...groupProps,
                ref: forwardedRef
            })
        })
    });
});
$40fc6af44b1cb291$export$a98f0dcb43a68a25.displayName = $40fc6af44b1cb291$var$RADIO_GROUP_NAME;
var $40fc6af44b1cb291$var$ITEM_NAME = "RadioGroupItem";
var $40fc6af44b1cb291$export$9f866c100ef519e4 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeRadioGroup: __scopeRadioGroup, disabled: disabled, ...itemProps } = props;
    const context = $40fc6af44b1cb291$var$useRadioGroupContext($40fc6af44b1cb291$var$ITEM_NAME, __scopeRadioGroup);
    const isDisabled = context.disabled || disabled;
    const rovingFocusGroupScope = $40fc6af44b1cb291$var$useRovingFocusGroupScope(__scopeRadioGroup);
    const radioScope = $40fc6af44b1cb291$var$useRadioScope(__scopeRadioGroup);
    const ref = $7fPBF.useRef(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const checked = context.value === itemProps.value;
    const isArrowKeyPressedRef = $7fPBF.useRef(false);
    $7fPBF.useEffect(()=>{
        const handleKeyDown = (event)=>{
            if ($40fc6af44b1cb291$var$ARROW_KEYS.includes(event.key)) isArrowKeyPressedRef.current = true;
        };
        const handleKeyUp = ()=>isArrowKeyPressedRef.current = false;
        document.addEventListener("keydown", handleKeyDown);
        document.addEventListener("keyup", handleKeyUp);
        return ()=>{
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("keyup", handleKeyUp);
        };
    }, []);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($8183e11ba1e9b7dc$export$6d08773d2e66f8f2, {
        asChild: true,
        ...rovingFocusGroupScope,
        focusable: !isDisabled,
        active: checked,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($40fc6af44b1cb291$var$Radio, {
            disabled: isDisabled,
            required: context.required,
            checked: checked,
            ...radioScope,
            ...itemProps,
            name: context.name,
            ref: composedRefs,
            onCheck: ()=>context.onValueChange(itemProps.value),
            onKeyDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)((event)=>{
                if (event.key === "Enter") event.preventDefault();
            }),
            onFocus: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(itemProps.onFocus, ()=>{
                var _ref_current;
                if (isArrowKeyPressedRef.current) (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.click();
            })
        })
    });
});
$40fc6af44b1cb291$export$9f866c100ef519e4.displayName = $40fc6af44b1cb291$var$ITEM_NAME;
var $40fc6af44b1cb291$var$INDICATOR_NAME2 = "RadioGroupIndicator";
var $40fc6af44b1cb291$export$5fb54c671a65c88 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeRadioGroup: __scopeRadioGroup, ...indicatorProps } = props;
    const radioScope = $40fc6af44b1cb291$var$useRadioScope(__scopeRadioGroup);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($40fc6af44b1cb291$var$RadioIndicator, {
        ...radioScope,
        ...indicatorProps,
        ref: forwardedRef
    });
});
$40fc6af44b1cb291$export$5fb54c671a65c88.displayName = $40fc6af44b1cb291$var$INDICATOR_NAME2;
var $40fc6af44b1cb291$export$be92b6f5f03c0fe9 = $40fc6af44b1cb291$export$a98f0dcb43a68a25;
var $40fc6af44b1cb291$export$6d08773d2e66f8f2 = $40fc6af44b1cb291$export$9f866c100ef519e4;
var $40fc6af44b1cb291$export$adb584737d712b70 = $40fc6af44b1cb291$export$5fb54c671a65c88;






const $9ac86668d50cd85d$var$a = [
    "1",
    "2",
    "3"
], $9ac86668d50cd85d$var$t = [
    "surface",
    "classic"
], $9ac86668d50cd85d$export$46452353e8a3c678 = {
    ...(0, $b302dbddfdac9d75$export$1e7c0b54c65e0280),
    size: {
        type: "enum",
        className: "rt-r-size",
        values: $9ac86668d50cd85d$var$a,
        default: "2",
        responsive: !0
    },
    variant: {
        type: "enum",
        className: "rt-variant",
        values: $9ac86668d50cd85d$var$t,
        default: "surface"
    },
    ...(0, $e914ebf2ce406d8c$export$8255b018f448be13),
    ...(0, $f41c61290c2a7125$export$2f84412d299def33),
    columns: {
        ...(0, $9b4d70d1960910a3$export$b3262d61b3123b38).columns,
        default: "repeat(auto-fit, minmax(160px, 1fr))"
    },
    gap: {
        ...(0, $9b4d70d1960910a3$export$b3262d61b3123b38).gap,
        default: "4"
    }
};





const $a64c604549c7250e$export$be92b6f5f03c0fe9 = $7fPBF.forwardRef((r, t)=>{
    const { className: e, color: d, ...m } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(r, (0, $9ac86668d50cd85d$export$46452353e8a3c678), (0, $df06be8448ff4f3c$export$83503616c7a463e3));
    return $7fPBF.createElement((0, $1186128e999eac49$export$ef2184bd89960b14), {
        asChild: !0
    }, $7fPBF.createElement($40fc6af44b1cb291$export$be92b6f5f03c0fe9, {
        "data-accent-color": d,
        ...m,
        ref: t,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-RadioCardsRoot", e)
    }));
});
$a64c604549c7250e$export$be92b6f5f03c0fe9.displayName = "RadioCards.Root";
const $a64c604549c7250e$export$6d08773d2e66f8f2 = $7fPBF.forwardRef(({ className: r, ...t }, e)=>$7fPBF.createElement($40fc6af44b1cb291$export$6d08773d2e66f8f2, {
        ...t,
        asChild: !1,
        ref: e,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-reset", "rt-BaseCard", "rt-RadioCardsItem", r)
    }));
$a64c604549c7250e$export$6d08773d2e66f8f2.displayName = "RadioCards.Item";



var $7fPBF = parcelRequire("7fPBF");






const $941c27d361a3b819$var$o = [
    "1",
    "2",
    "3"
], $941c27d361a3b819$var$t = [
    "classic",
    "surface",
    "soft"
], $941c27d361a3b819$export$ddc224a851ab43da = {
    ...(0, $b302dbddfdac9d75$export$1e7c0b54c65e0280),
    size: {
        type: "enum",
        className: "rt-r-size",
        values: $941c27d361a3b819$var$o,
        default: "2",
        responsive: !0
    },
    variant: {
        type: "enum",
        className: "rt-variant",
        values: $941c27d361a3b819$var$t,
        default: "surface"
    },
    ...(0, $e914ebf2ce406d8c$export$8255b018f448be13),
    ...(0, $f41c61290c2a7125$export$2f84412d299def33)
};





"use client";
const $bba87979b9fa9e19$var$P = "RadioGroup", [$bba87979b9fa9e19$var$S] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)($bba87979b9fa9e19$var$P, [
    (0, $40fc6af44b1cb291$export$c547093f11b76da2)
]), $bba87979b9fa9e19$var$l = (0, $40fc6af44b1cb291$export$c547093f11b76da2)(), [$bba87979b9fa9e19$var$E, $bba87979b9fa9e19$var$I] = $bba87979b9fa9e19$var$S($bba87979b9fa9e19$var$P), $bba87979b9fa9e19$export$be92b6f5f03c0fe9 = $7fPBF.forwardRef(({ color: a = (0, $941c27d361a3b819$export$ddc224a851ab43da).color.default, highContrast: e = (0, $941c27d361a3b819$export$ddc224a851ab43da).highContrast.default, size: r = (0, $941c27d361a3b819$export$ddc224a851ab43da).size.default, variant: t = (0, $941c27d361a3b819$export$ddc224a851ab43da).variant.default, ...i }, s)=>{
    const { __scopeRadioGroup: p, className: R, ...C } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(i, (0, $df06be8448ff4f3c$export$83503616c7a463e3)), h = $bba87979b9fa9e19$var$l(p);
    return $7fPBF.createElement($bba87979b9fa9e19$var$E, {
        scope: p,
        color: a,
        highContrast: e,
        size: r,
        variant: t
    }, $7fPBF.createElement($40fc6af44b1cb291$export$be92b6f5f03c0fe9, {
        ...h,
        ...C,
        ref: s,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-RadioGroupRoot", R)
    }));
});
$bba87979b9fa9e19$export$be92b6f5f03c0fe9.displayName = "RadioGroup.Root";
const $bba87979b9fa9e19$export$6d08773d2e66f8f2 = $7fPBF.forwardRef((a, e)=>{
    const { __scopeRadioGroup: r, children: t, className: i, style: s, ...p } = a, { size: R } = $bba87979b9fa9e19$var$I("RadioGroupItem", r);
    return t ? $7fPBF.createElement((0, $83db9e82a643d7a4$export$5f1af8db9871e1d6), {
        as: "label",
        size: R,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-RadioGroupItem", i),
        style: s
    }, $7fPBF.createElement($bba87979b9fa9e19$var$u, {
        __scopeRadioGroup: r,
        ...p,
        ref: e
    }), t && $7fPBF.createElement("span", {
        className: "rt-RadioGroupItemInner"
    }, t)) : $7fPBF.createElement($bba87979b9fa9e19$var$u, {
        __scopeRadioGroup: r,
        ...p,
        ref: e,
        className: i,
        style: s
    });
});
$bba87979b9fa9e19$export$6d08773d2e66f8f2.displayName = "RadioGroup.Item";
const $bba87979b9fa9e19$var$u = $7fPBF.forwardRef(({ __scopeRadioGroup: a, ...e }, r)=>{
    const t = $bba87979b9fa9e19$var$I("RadioGroupItemRadio", a), i = $bba87979b9fa9e19$var$l(a), { color: s, className: p } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)({
        ...e,
        ...t
    }, (0, $941c27d361a3b819$export$ddc224a851ab43da), (0, $df06be8448ff4f3c$export$83503616c7a463e3));
    return $7fPBF.createElement($40fc6af44b1cb291$export$6d08773d2e66f8f2, {
        ...i,
        "data-accent-color": s,
        ...e,
        asChild: !1,
        ref: r,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-reset", "rt-BaseRadioRoot", p)
    });
});
$bba87979b9fa9e19$var$u.displayName = "RadioGroup.ItemRadio";



var $7fPBF = parcelRequire("7fPBF");





const $1727333085d54fb7$var$r = [
    "1",
    "2",
    "3"
], $1727333085d54fb7$var$o = [
    "classic",
    "surface",
    "soft"
], $1727333085d54fb7$export$798fe80a86a772af = {
    size: {
        type: "enum",
        className: "rt-r-size",
        values: $1727333085d54fb7$var$r,
        default: "2",
        responsive: !0
    },
    variant: {
        type: "enum",
        className: "rt-variant",
        values: $1727333085d54fb7$var$o,
        default: "surface"
    },
    ...(0, $e914ebf2ce406d8c$export$8255b018f448be13),
    ...(0, $f41c61290c2a7125$export$2f84412d299def33)
};






"use client";
const $789edc428a1bc702$export$d7b12c4107be0d61 = $7fPBF.forwardRef((r, t)=>{
    const p = $7fPBF.useRef(null), { className: a, color: s, onChange: i, onValueChange: n, ...m } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(r, (0, $1727333085d54fb7$export$798fe80a86a772af), (0, $df06be8448ff4f3c$export$83503616c7a463e3));
    return $7fPBF.createElement("input", {
        type: "radio",
        "data-accent-color": s,
        ...m,
        onChange: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(i, (d)=>n === null || n === void 0 ? void 0 : n(d.currentTarget.value)),
        ref: (0, $2d44b7cb84ff0f1c$export$43e446d32b3d21af)(p, t),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-reset", "rt-BaseRadioRoot", "rt-RadioRoot", a)
    });
});
$789edc428a1bc702$export$d7b12c4107be0d61.displayName = "Radio";



var $7fPBF = parcelRequire("7fPBF");



const $f8f609a11220c633$export$fcc683c36751f67a = $7fPBF.forwardRef(({ className: t, children: r, ...s }, p)=>$7fPBF.createElement((0, $089057084dfb92a4$export$8c6ed5c666ac1360), {
        ...s,
        ref: p,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-reset", t)
    }, (0, $d51eb3faadbea344$export$fb35347076fc30e)(r)));
$f8f609a11220c633$export$fcc683c36751f67a.displayName = "Reset";




var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");




"use client";
var $190783a67cfa1dc0$var$NAME = "Toggle";
var $190783a67cfa1dc0$export$bea8ebba691c5813 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { pressed: pressedProp, defaultPressed: defaultPressed = false, onPressedChange: onPressedChange, ...buttonProps } = props;
    const [pressed = false, setPressed] = (0, $915387e6ab4d88b1$export$6f32135080cb4c3)({
        prop: pressedProp,
        onChange: onPressedChange,
        defaultProp: defaultPressed
    });
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).button, {
        type: "button",
        "aria-pressed": pressed,
        "data-state": pressed ? "on" : "off",
        "data-disabled": props.disabled ? "" : void 0,
        ...buttonProps,
        ref: forwardedRef,
        onClick: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onClick, ()=>{
            if (!props.disabled) setPressed(!pressed);
        })
    });
});
$190783a67cfa1dc0$export$bea8ebba691c5813.displayName = $190783a67cfa1dc0$var$NAME;
var $190783a67cfa1dc0$export$be92b6f5f03c0fe9 = $190783a67cfa1dc0$export$bea8ebba691c5813;





"use client";
var $45e01d9175aeb53c$var$TOGGLE_GROUP_NAME = "ToggleGroup";
var [$45e01d9175aeb53c$var$createToggleGroupContext, $45e01d9175aeb53c$export$d1c7c4bcd9f26dd4] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)($45e01d9175aeb53c$var$TOGGLE_GROUP_NAME, [
    (0, $8183e11ba1e9b7dc$export$c7109489551a4f4)
]);
var $45e01d9175aeb53c$var$useRovingFocusGroupScope = (0, $8183e11ba1e9b7dc$export$c7109489551a4f4)();
var $45e01d9175aeb53c$export$af3ec21f6cfb5e30 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef((props, forwardedRef)=>{
    const { type: type, ...toggleGroupProps } = props;
    if (type === "single") {
        const singleProps = toggleGroupProps;
        return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($45e01d9175aeb53c$var$ToggleGroupImplSingle, {
            ...singleProps,
            ref: forwardedRef
        });
    }
    if (type === "multiple") {
        const multipleProps = toggleGroupProps;
        return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($45e01d9175aeb53c$var$ToggleGroupImplMultiple, {
            ...multipleProps,
            ref: forwardedRef
        });
    }
    throw new Error(`Missing prop \`type\` expected on \`${$45e01d9175aeb53c$var$TOGGLE_GROUP_NAME}\``);
});
$45e01d9175aeb53c$export$af3ec21f6cfb5e30.displayName = $45e01d9175aeb53c$var$TOGGLE_GROUP_NAME;
var [$45e01d9175aeb53c$var$ToggleGroupValueProvider, $45e01d9175aeb53c$var$useToggleGroupValueContext] = $45e01d9175aeb53c$var$createToggleGroupContext($45e01d9175aeb53c$var$TOGGLE_GROUP_NAME);
var $45e01d9175aeb53c$var$ToggleGroupImplSingle = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef((props, forwardedRef)=>{
    const { value: valueProp, defaultValue: defaultValue, onValueChange: onValueChange = ()=>{}, ...toggleGroupSingleProps } = props;
    const [value, setValue] = (0, $915387e6ab4d88b1$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange
    });
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($45e01d9175aeb53c$var$ToggleGroupValueProvider, {
        scope: props.__scopeToggleGroup,
        type: "single",
        value: value ? [
            value
        ] : [],
        onItemActivate: setValue,
        onItemDeactivate: (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(()=>setValue(""), [
            setValue
        ]),
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($45e01d9175aeb53c$var$ToggleGroupImpl, {
            ...toggleGroupSingleProps,
            ref: forwardedRef
        })
    });
});
var $45e01d9175aeb53c$var$ToggleGroupImplMultiple = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef((props, forwardedRef)=>{
    const { value: valueProp, defaultValue: defaultValue, onValueChange: onValueChange = ()=>{}, ...toggleGroupMultipleProps } = props;
    const [value = [], setValue] = (0, $915387e6ab4d88b1$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange
    });
    const handleButtonActivate = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((itemValue)=>setValue((prevValue = [])=>[
                ...prevValue,
                itemValue
            ]), [
        setValue
    ]);
    const handleButtonDeactivate = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((itemValue)=>setValue((prevValue = [])=>prevValue.filter((value2)=>value2 !== itemValue)), [
        setValue
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($45e01d9175aeb53c$var$ToggleGroupValueProvider, {
        scope: props.__scopeToggleGroup,
        type: "multiple",
        value: value,
        onItemActivate: handleButtonActivate,
        onItemDeactivate: handleButtonDeactivate,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($45e01d9175aeb53c$var$ToggleGroupImpl, {
            ...toggleGroupMultipleProps,
            ref: forwardedRef
        })
    });
});
$45e01d9175aeb53c$export$af3ec21f6cfb5e30.displayName = $45e01d9175aeb53c$var$TOGGLE_GROUP_NAME;
var [$45e01d9175aeb53c$var$ToggleGroupContext, $45e01d9175aeb53c$var$useToggleGroupContext] = $45e01d9175aeb53c$var$createToggleGroupContext($45e01d9175aeb53c$var$TOGGLE_GROUP_NAME);
var $45e01d9175aeb53c$var$ToggleGroupImpl = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef((props, forwardedRef)=>{
    const { __scopeToggleGroup: __scopeToggleGroup, disabled: disabled = false, rovingFocus: rovingFocus = true, orientation: orientation, dir: dir, loop: loop = true, ...toggleGroupProps } = props;
    const rovingFocusGroupScope = $45e01d9175aeb53c$var$useRovingFocusGroupScope(__scopeToggleGroup);
    const direction = (0, $3342477e04611d10$export$b39126d51d94e6f3)(dir);
    const commonProps = {
        role: "group",
        dir: direction,
        ...toggleGroupProps
    };
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($45e01d9175aeb53c$var$ToggleGroupContext, {
        scope: __scopeToggleGroup,
        rovingFocus: rovingFocus,
        disabled: disabled,
        children: rovingFocus ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($8183e11ba1e9b7dc$export$be92b6f5f03c0fe9, {
            asChild: true,
            ...rovingFocusGroupScope,
            orientation: orientation,
            dir: direction,
            loop: loop,
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
                ...commonProps,
                ref: forwardedRef
            })
        }) : /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
            ...commonProps,
            ref: forwardedRef
        })
    });
});
var $45e01d9175aeb53c$var$ITEM_NAME = "ToggleGroupItem";
var $45e01d9175aeb53c$export$b453109e13abe10b = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef((props, forwardedRef)=>{
    const valueContext = $45e01d9175aeb53c$var$useToggleGroupValueContext($45e01d9175aeb53c$var$ITEM_NAME, props.__scopeToggleGroup);
    const context = $45e01d9175aeb53c$var$useToggleGroupContext($45e01d9175aeb53c$var$ITEM_NAME, props.__scopeToggleGroup);
    const rovingFocusGroupScope = $45e01d9175aeb53c$var$useRovingFocusGroupScope(props.__scopeToggleGroup);
    const pressed = valueContext.value.includes(props.value);
    const disabled = context.disabled || props.disabled;
    const commonProps = {
        ...props,
        pressed: pressed,
        disabled: disabled
    };
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(null);
    return context.rovingFocus ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($8183e11ba1e9b7dc$export$6d08773d2e66f8f2, {
        asChild: true,
        ...rovingFocusGroupScope,
        focusable: !disabled,
        active: pressed,
        ref: ref,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($45e01d9175aeb53c$var$ToggleGroupItemImpl, {
            ...commonProps,
            ref: forwardedRef
        })
    }) : /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($45e01d9175aeb53c$var$ToggleGroupItemImpl, {
        ...commonProps,
        ref: forwardedRef
    });
});
$45e01d9175aeb53c$export$b453109e13abe10b.displayName = $45e01d9175aeb53c$var$ITEM_NAME;
var $45e01d9175aeb53c$var$ToggleGroupItemImpl = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef((props, forwardedRef)=>{
    const { __scopeToggleGroup: __scopeToggleGroup, value: value, ...itemProps } = props;
    const valueContext = $45e01d9175aeb53c$var$useToggleGroupValueContext($45e01d9175aeb53c$var$ITEM_NAME, __scopeToggleGroup);
    const singleProps = {
        role: "radio",
        "aria-checked": props.pressed,
        "aria-pressed": void 0
    };
    const typeProps = valueContext.type === "single" ? singleProps : void 0;
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $190783a67cfa1dc0$export$bea8ebba691c5813), {
        ...typeProps,
        ...itemProps,
        ref: forwardedRef,
        onPressedChange: (pressed)=>{
            if (pressed) valueContext.onItemActivate(value);
            else valueContext.onItemDeactivate(value);
        }
    });
});
var $45e01d9175aeb53c$export$be92b6f5f03c0fe9 = $45e01d9175aeb53c$export$af3ec21f6cfb5e30;
var $45e01d9175aeb53c$export$6d08773d2e66f8f2 = $45e01d9175aeb53c$export$b453109e13abe10b;




const $28bc0f48eb6304af$var$s = [
    "1",
    "2",
    "3"
], $28bc0f48eb6304af$var$r = [
    "surface",
    "classic"
], $28bc0f48eb6304af$export$cbaecdbc44a6ebd8 = {
    size: {
        type: "enum",
        className: "rt-r-size",
        values: $28bc0f48eb6304af$var$s,
        default: "2",
        responsive: !0
    },
    variant: {
        type: "enum",
        className: "rt-variant",
        values: $28bc0f48eb6304af$var$r,
        default: "surface"
    },
    ...(0, $3d20a83f81464c0a$export$c467f6769b59b70c)
};




"use client";
const $9d4a973d0fab3419$export$be92b6f5f03c0fe9 = $7fPBF.forwardRef((o, t)=>{
    const { className: r, children: n, radius: i, value: d, defaultValue: g, onValueChange: f, ...P } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(o, (0, $28bc0f48eb6304af$export$cbaecdbc44a6ebd8), (0, $df06be8448ff4f3c$export$83503616c7a463e3)), [C, u] = (0, $915387e6ab4d88b1$export$6f32135080cb4c3)({
        prop: d,
        onChange: f,
        defaultProp: g
    });
    return $7fPBF.createElement($45e01d9175aeb53c$export$be92b6f5f03c0fe9, {
        "data-radius": i,
        ref: t,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-SegmentedControlRoot", r),
        onValueChange: (s)=>{
            s && u(s);
        },
        ...P,
        type: "single",
        value: C,
        asChild: !1,
        disabled: !1
    }, n, $7fPBF.createElement("div", {
        className: "rt-SegmentedControlIndicator"
    }));
});
$9d4a973d0fab3419$export$be92b6f5f03c0fe9.displayName = "SegmentedControl.Root";
const $9d4a973d0fab3419$export$6d08773d2e66f8f2 = $7fPBF.forwardRef(({ children: o, className: t, ...r }, n)=>$7fPBF.createElement($45e01d9175aeb53c$export$6d08773d2e66f8f2, {
        ref: n,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-reset", "rt-SegmentedControlItem", t),
        ...r,
        disabled: !1,
        asChild: !1
    }, $7fPBF.createElement("span", {
        className: "rt-SegmentedControlItemSeparator"
    }), $7fPBF.createElement("span", {
        className: "rt-SegmentedControlItemLabel"
    }, $7fPBF.createElement("span", {
        className: "rt-SegmentedControlItemLabelActive"
    }, o), $7fPBF.createElement("span", {
        className: "rt-SegmentedControlItemLabelInactive"
    }, o))));
$9d4a973d0fab3419$export$6d08773d2e66f8f2.displayName = "SegmentedControl.Item";



var $7fPBF = parcelRequire("7fPBF");



const $139f6d5183d4b7e9$var$p = [
    "1",
    "2",
    "3",
    "4"
], $139f6d5183d4b7e9$var$o = [
    "none",
    "initial"
], $139f6d5183d4b7e9$export$fcc2f15b78879f49 = {
    ...(0, $b302dbddfdac9d75$export$1e7c0b54c65e0280),
    size: {
        type: "enum",
        className: "rt-r-size",
        values: $139f6d5183d4b7e9$var$p,
        default: "3",
        responsive: !0
    },
    display: {
        type: "enum",
        className: "rt-r-display",
        values: $139f6d5183d4b7e9$var$o,
        parseValue: $139f6d5183d4b7e9$var$r,
        responsive: !0
    }
};
function $139f6d5183d4b7e9$var$r(e) {
    return e === "initial" ? "block" : e;
}





const $39efd20724bedfa4$export$6e2c8f0811a474ce = $7fPBF.forwardRef((t, p)=>{
    const { asChild: e, className: s, ...m } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(t, (0, $139f6d5183d4b7e9$export$fcc2f15b78879f49), (0, $b1d6d16f69302f9e$export$e71e58537b2e6660), (0, $df06be8448ff4f3c$export$83503616c7a463e3));
    return $7fPBF.createElement(e ? (0, $089057084dfb92a4$export$8c6ed5c666ac1360) : "section", {
        ...m,
        ref: p,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-Section", s)
    });
});
$39efd20724bedfa4$export$6e2c8f0811a474ce.displayName = "Section";


var $608da1f87bc1fe5b$exports = {};

$parcel$export($608da1f87bc1fe5b$exports, "Root", function () { return $608da1f87bc1fe5b$export$be92b6f5f03c0fe9; });
$parcel$export($608da1f87bc1fe5b$exports, "Trigger", function () { return $608da1f87bc1fe5b$export$41fb9f06171c75f4; });
$parcel$export($608da1f87bc1fe5b$exports, "Content", function () { return $608da1f87bc1fe5b$export$7c6e2c02157bb7d2; });
$parcel$export($608da1f87bc1fe5b$exports, "Item", function () { return $608da1f87bc1fe5b$export$6d08773d2e66f8f2; });
$parcel$export($608da1f87bc1fe5b$exports, "Group", function () { return $608da1f87bc1fe5b$export$eb2fcfdbd7ba97d4; });
$parcel$export($608da1f87bc1fe5b$exports, "Label", function () { return $608da1f87bc1fe5b$export$b04be29aa201d4f5; });
$parcel$export($608da1f87bc1fe5b$exports, "Separator", function () { return $608da1f87bc1fe5b$export$1ff3c3f08ae963c0; });

var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");























"use client";
var $7cacca21c6f84773$var$OPEN_KEYS = [
    " ",
    "Enter",
    "ArrowUp",
    "ArrowDown"
];
var $7cacca21c6f84773$var$SELECTION_KEYS = [
    " ",
    "Enter"
];
var $7cacca21c6f84773$var$SELECT_NAME = "Select";
var [$7cacca21c6f84773$var$Collection, $7cacca21c6f84773$var$useCollection, $7cacca21c6f84773$var$createCollectionScope] = (0, $08a94ba50b5cc249$export$c74125a8e3af6bb2)($7cacca21c6f84773$var$SELECT_NAME);
var [$7cacca21c6f84773$var$createSelectContext, $7cacca21c6f84773$export$286727a75dc039bd] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)($7cacca21c6f84773$var$SELECT_NAME, [
    $7cacca21c6f84773$var$createCollectionScope,
    (0, $7952cd297982b588$export$722aac194ae923)
]);
var $7cacca21c6f84773$var$usePopperScope = (0, $7952cd297982b588$export$722aac194ae923)();
var [$7cacca21c6f84773$var$SelectProvider, $7cacca21c6f84773$var$useSelectContext] = $7cacca21c6f84773$var$createSelectContext($7cacca21c6f84773$var$SELECT_NAME);
var [$7cacca21c6f84773$var$SelectNativeOptionsProvider, $7cacca21c6f84773$var$useSelectNativeOptionsContext] = $7cacca21c6f84773$var$createSelectContext($7cacca21c6f84773$var$SELECT_NAME);
var $7cacca21c6f84773$export$ef9b1a59e592288f = (props)=>{
    const { __scopeSelect: __scopeSelect, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, value: valueProp, defaultValue: defaultValue, onValueChange: onValueChange, dir: dir, name: name, autoComplete: autoComplete, disabled: disabled, required: required } = props;
    const popperScope = $7cacca21c6f84773$var$usePopperScope(__scopeSelect);
    const [trigger, setTrigger] = $7fPBF.useState(null);
    const [valueNode, setValueNode] = $7fPBF.useState(null);
    const [valueNodeHasChildren, setValueNodeHasChildren] = $7fPBF.useState(false);
    const direction = (0, $3342477e04611d10$export$b39126d51d94e6f3)(dir);
    const [open = false, setOpen] = (0, $915387e6ab4d88b1$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    const [value, setValue] = (0, $915387e6ab4d88b1$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange
    });
    const triggerPointerDownPosRef = $7fPBF.useRef(null);
    const isFormControl = trigger ? Boolean(trigger.closest("form")) : true;
    const [nativeOptionsSet, setNativeOptionsSet] = $7fPBF.useState(/* @__PURE__ */ new Set());
    const nativeSelectKey = Array.from(nativeOptionsSet).map((option)=>option.props.value).join(";");
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$export$be92b6f5f03c0fe9, {
        ...popperScope,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)($7cacca21c6f84773$var$SelectProvider, {
            required: required,
            scope: __scopeSelect,
            trigger: trigger,
            onTriggerChange: setTrigger,
            valueNode: valueNode,
            onValueNodeChange: setValueNode,
            valueNodeHasChildren: valueNodeHasChildren,
            onValueNodeHasChildrenChange: setValueNodeHasChildren,
            contentId: (0, $8a8e9b94c33ba6d6$export$f680877a34711e37)(),
            value: value,
            onValueChange: setValue,
            open: open,
            onOpenChange: setOpen,
            dir: direction,
            triggerPointerDownPosRef: triggerPointerDownPosRef,
            disabled: disabled,
            children: [
                /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7cacca21c6f84773$var$Collection.Provider, {
                    scope: __scopeSelect,
                    children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7cacca21c6f84773$var$SelectNativeOptionsProvider, {
                        scope: props.__scopeSelect,
                        onNativeOptionAdd: $7fPBF.useCallback((option)=>{
                            setNativeOptionsSet((prev)=>new Set(prev).add(option));
                        }, []),
                        onNativeOptionRemove: $7fPBF.useCallback((option)=>{
                            setNativeOptionsSet((prev)=>{
                                const optionsSet = new Set(prev);
                                optionsSet.delete(option);
                                return optionsSet;
                            });
                        }, []),
                        children: children
                    })
                }),
                isFormControl ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)($7cacca21c6f84773$var$BubbleSelect, {
                    "aria-hidden": true,
                    required: required,
                    tabIndex: -1,
                    name: name,
                    autoComplete: autoComplete,
                    value: value,
                    onChange: (event)=>setValue(event.target.value),
                    disabled: disabled,
                    children: [
                        value === void 0 ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("option", {
                            value: ""
                        }) : null,
                        Array.from(nativeOptionsSet)
                    ]
                }, nativeSelectKey) : null
            ]
        })
    });
};
$7cacca21c6f84773$export$ef9b1a59e592288f.displayName = $7cacca21c6f84773$var$SELECT_NAME;
var $7cacca21c6f84773$var$TRIGGER_NAME = "SelectTrigger";
var $7cacca21c6f84773$export$3ac1e88a1c0b9f1 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, disabled: disabled = false, ...triggerProps } = props;
    const popperScope = $7cacca21c6f84773$var$usePopperScope(__scopeSelect);
    const context = $7cacca21c6f84773$var$useSelectContext($7cacca21c6f84773$var$TRIGGER_NAME, __scopeSelect);
    const isDisabled = context.disabled || disabled;
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, context.onTriggerChange);
    const getItems = $7cacca21c6f84773$var$useCollection(__scopeSelect);
    const [searchRef, handleTypeaheadSearch, resetTypeahead] = $7cacca21c6f84773$var$useTypeaheadSearch((search)=>{
        const enabledItems = getItems().filter((item)=>!item.disabled);
        const currentItem = enabledItems.find((item)=>item.value === context.value);
        const nextItem = $7cacca21c6f84773$var$findNextItem(enabledItems, search, currentItem);
        if (nextItem !== void 0) context.onValueChange(nextItem.value);
    });
    const handleOpen = ()=>{
        if (!isDisabled) {
            context.onOpenChange(true);
            resetTypeahead();
        }
    };
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$export$b688253958b8dfe7, {
        asChild: true,
        ...popperScope,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).button, {
            type: "button",
            role: "combobox",
            "aria-controls": context.contentId,
            "aria-expanded": context.open,
            "aria-required": context.required,
            "aria-autocomplete": "none",
            dir: context.dir,
            "data-state": context.open ? "open" : "closed",
            disabled: isDisabled,
            "data-disabled": isDisabled ? "" : void 0,
            "data-placeholder": $7cacca21c6f84773$var$shouldShowPlaceholder(context.value) ? "" : void 0,
            ...triggerProps,
            ref: composedRefs,
            onClick: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(triggerProps.onClick, (event)=>{
                event.currentTarget.focus();
            }),
            onPointerDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(triggerProps.onPointerDown, (event)=>{
                const target = event.target;
                if (target.hasPointerCapture(event.pointerId)) target.releasePointerCapture(event.pointerId);
                if (event.button === 0 && event.ctrlKey === false) {
                    handleOpen();
                    context.triggerPointerDownPosRef.current = {
                        x: Math.round(event.pageX),
                        y: Math.round(event.pageY)
                    };
                    event.preventDefault();
                }
            }),
            onKeyDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(triggerProps.onKeyDown, (event)=>{
                const isTypingAhead = searchRef.current !== "";
                const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
                if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
                if (isTypingAhead && event.key === " ") return;
                if ($7cacca21c6f84773$var$OPEN_KEYS.includes(event.key)) {
                    handleOpen();
                    event.preventDefault();
                }
            })
        })
    });
});
$7cacca21c6f84773$export$3ac1e88a1c0b9f1.displayName = $7cacca21c6f84773$var$TRIGGER_NAME;
var $7cacca21c6f84773$var$VALUE_NAME = "SelectValue";
var $7cacca21c6f84773$export$e288731fd71264f0 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, className: className, style: style, children: children, placeholder: placeholder = "", ...valueProps } = props;
    const context = $7cacca21c6f84773$var$useSelectContext($7cacca21c6f84773$var$VALUE_NAME, __scopeSelect);
    const { onValueNodeHasChildrenChange: onValueNodeHasChildrenChange } = context;
    const hasChildren = children !== void 0;
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, context.onValueNodeChange);
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        onValueNodeHasChildrenChange(hasChildren);
    }, [
        onValueNodeHasChildrenChange,
        hasChildren
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).span, {
        ...valueProps,
        ref: composedRefs,
        style: {
            pointerEvents: "none"
        },
        children: $7cacca21c6f84773$var$shouldShowPlaceholder(context.value) ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
            children: placeholder
        }) : children
    });
});
$7cacca21c6f84773$export$e288731fd71264f0.displayName = $7cacca21c6f84773$var$VALUE_NAME;
var $7cacca21c6f84773$var$ICON_NAME = "SelectIcon";
var $7cacca21c6f84773$export$99b400cabb58c515 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, children: children, ...iconProps } = props;
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).span, {
        "aria-hidden": true,
        ...iconProps,
        ref: forwardedRef,
        children: children || "\u25BC"
    });
});
$7cacca21c6f84773$export$99b400cabb58c515.displayName = $7cacca21c6f84773$var$ICON_NAME;
var $7cacca21c6f84773$var$PORTAL_NAME = "SelectPortal";
var $7cacca21c6f84773$export$b2af6c9944296213 = (props)=>{
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $57c7abe8fecdeb41$export$602eac185826482c), {
        asChild: true,
        ...props
    });
};
$7cacca21c6f84773$export$b2af6c9944296213.displayName = $7cacca21c6f84773$var$PORTAL_NAME;
var $7cacca21c6f84773$var$CONTENT_NAME = "SelectContent";
var $7cacca21c6f84773$export$c973a4b3cb86a03d = $7fPBF.forwardRef((props, forwardedRef)=>{
    const context = $7cacca21c6f84773$var$useSelectContext($7cacca21c6f84773$var$CONTENT_NAME, props.__scopeSelect);
    const [fragment, setFragment] = $7fPBF.useState();
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        setFragment(new DocumentFragment());
    }, []);
    if (!context.open) {
        const frag = fragment;
        return frag ? $b4ba1c853f6e1116$exports.createPortal(/* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7cacca21c6f84773$var$SelectContentProvider, {
            scope: props.__scopeSelect,
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7cacca21c6f84773$var$Collection.Slot, {
                scope: props.__scopeSelect,
                children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("div", {
                    children: props.children
                })
            })
        }), frag) : null;
    }
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7cacca21c6f84773$var$SelectContentImpl, {
        ...props,
        ref: forwardedRef
    });
});
$7cacca21c6f84773$export$c973a4b3cb86a03d.displayName = $7cacca21c6f84773$var$CONTENT_NAME;
var $7cacca21c6f84773$var$CONTENT_MARGIN = 10;
var [$7cacca21c6f84773$var$SelectContentProvider, $7cacca21c6f84773$var$useSelectContentContext] = $7cacca21c6f84773$var$createSelectContext($7cacca21c6f84773$var$CONTENT_NAME);
var $7cacca21c6f84773$var$CONTENT_IMPL_NAME = "SelectContentImpl";
var $7cacca21c6f84773$var$SelectContentImpl = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, position: position = "item-aligned", onCloseAutoFocus: onCloseAutoFocus, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, side: //
    // PopperContent props
    side, sideOffset: sideOffset, align: align, alignOffset: alignOffset, arrowPadding: arrowPadding, collisionBoundary: collisionBoundary, collisionPadding: collisionPadding, sticky: sticky, hideWhenDetached: hideWhenDetached, avoidCollisions: avoidCollisions, //
    ...contentProps } = props;
    const context = $7cacca21c6f84773$var$useSelectContext($7cacca21c6f84773$var$CONTENT_NAME, __scopeSelect);
    const [content, setContent] = $7fPBF.useState(null);
    const [viewport, setViewport] = $7fPBF.useState(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const [selectedItem, setSelectedItem] = $7fPBF.useState(null);
    const [selectedItemText, setSelectedItemText] = $7fPBF.useState(null);
    const getItems = $7cacca21c6f84773$var$useCollection(__scopeSelect);
    const [isPositioned, setIsPositioned] = $7fPBF.useState(false);
    const firstValidItemFoundRef = $7fPBF.useRef(false);
    $7fPBF.useEffect(()=>{
        if (content) return (0, $2950574f4b60c018$export$6e33d16126ed003c)(content);
    }, [
        content
    ]);
    (0, $38bbe2f1de23f200$export$b7ece24a22aeda8c)();
    const focusFirst = $7fPBF.useCallback((candidates)=>{
        const [firstItem, ...restItems] = getItems().map((item)=>item.ref.current);
        const [lastItem] = restItems.slice(-1);
        const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
        for (const candidate of candidates){
            if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
            candidate === null || candidate === void 0 ? void 0 : candidate.scrollIntoView({
                block: "nearest"
            });
            if (candidate === firstItem && viewport) viewport.scrollTop = 0;
            if (candidate === lastItem && viewport) viewport.scrollTop = viewport.scrollHeight;
            candidate === null || candidate === void 0 ? void 0 : candidate.focus();
            if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
        }
    }, [
        getItems,
        viewport
    ]);
    const focusSelectedItem = $7fPBF.useCallback(()=>focusFirst([
            selectedItem,
            content
        ]), [
        focusFirst,
        selectedItem,
        content
    ]);
    $7fPBF.useEffect(()=>{
        if (isPositioned) focusSelectedItem();
    }, [
        isPositioned,
        focusSelectedItem
    ]);
    const { onOpenChange: onOpenChange, triggerPointerDownPosRef: triggerPointerDownPosRef } = context;
    $7fPBF.useEffect(()=>{
        if (content) {
            let pointerMoveDelta = {
                x: 0,
                y: 0
            };
            const handlePointerMove = (event)=>{
                var _triggerPointerDownPosRef_current, _triggerPointerDownPosRef_current1;
                var _triggerPointerDownPosRef_current_x, _triggerPointerDownPosRef_current_y;
                pointerMoveDelta = {
                    x: Math.abs(Math.round(event.pageX) - ((_triggerPointerDownPosRef_current_x = (_triggerPointerDownPosRef_current = triggerPointerDownPosRef.current) === null || _triggerPointerDownPosRef_current === void 0 ? void 0 : _triggerPointerDownPosRef_current.x) !== null && _triggerPointerDownPosRef_current_x !== void 0 ? _triggerPointerDownPosRef_current_x : 0)),
                    y: Math.abs(Math.round(event.pageY) - ((_triggerPointerDownPosRef_current_y = (_triggerPointerDownPosRef_current1 = triggerPointerDownPosRef.current) === null || _triggerPointerDownPosRef_current1 === void 0 ? void 0 : _triggerPointerDownPosRef_current1.y) !== null && _triggerPointerDownPosRef_current_y !== void 0 ? _triggerPointerDownPosRef_current_y : 0))
                };
            };
            const handlePointerUp = (event)=>{
                if (pointerMoveDelta.x <= 10 && pointerMoveDelta.y <= 10) event.preventDefault();
                else if (!content.contains(event.target)) onOpenChange(false);
                document.removeEventListener("pointermove", handlePointerMove);
                triggerPointerDownPosRef.current = null;
            };
            if (triggerPointerDownPosRef.current !== null) {
                document.addEventListener("pointermove", handlePointerMove);
                document.addEventListener("pointerup", handlePointerUp, {
                    capture: true,
                    once: true
                });
            }
            return ()=>{
                document.removeEventListener("pointermove", handlePointerMove);
                document.removeEventListener("pointerup", handlePointerUp, {
                    capture: true
                });
            };
        }
    }, [
        content,
        onOpenChange,
        triggerPointerDownPosRef
    ]);
    $7fPBF.useEffect(()=>{
        const close = ()=>onOpenChange(false);
        window.addEventListener("blur", close);
        window.addEventListener("resize", close);
        return ()=>{
            window.removeEventListener("blur", close);
            window.removeEventListener("resize", close);
        };
    }, [
        onOpenChange
    ]);
    const [searchRef, handleTypeaheadSearch] = $7cacca21c6f84773$var$useTypeaheadSearch((search)=>{
        const enabledItems = getItems().filter((item)=>!item.disabled);
        const currentItem = enabledItems.find((item)=>item.ref.current === document.activeElement);
        const nextItem = $7cacca21c6f84773$var$findNextItem(enabledItems, search, currentItem);
        if (nextItem) setTimeout(()=>nextItem.ref.current.focus());
    });
    const itemRefCallback = $7fPBF.useCallback((node, value, disabled)=>{
        const isFirstValidItem = !firstValidItemFoundRef.current && !disabled;
        const isSelectedItem = context.value !== void 0 && context.value === value;
        if (isSelectedItem || isFirstValidItem) {
            setSelectedItem(node);
            if (isFirstValidItem) firstValidItemFoundRef.current = true;
        }
    }, [
        context.value
    ]);
    const handleItemLeave = $7fPBF.useCallback(()=>content === null || content === void 0 ? void 0 : content.focus(), [
        content
    ]);
    const itemTextRefCallback = $7fPBF.useCallback((node, value, disabled)=>{
        const isFirstValidItem = !firstValidItemFoundRef.current && !disabled;
        const isSelectedItem = context.value !== void 0 && context.value === value;
        if (isSelectedItem || isFirstValidItem) setSelectedItemText(node);
    }, [
        context.value
    ]);
    const SelectPosition = position === "popper" ? $7cacca21c6f84773$var$SelectPopperPosition : $7cacca21c6f84773$var$SelectItemAlignedPosition;
    const popperContentProps = SelectPosition === $7cacca21c6f84773$var$SelectPopperPosition ? {
        side: side,
        sideOffset: sideOffset,
        align: align,
        alignOffset: alignOffset,
        arrowPadding: arrowPadding,
        collisionBoundary: collisionBoundary,
        collisionPadding: collisionPadding,
        sticky: sticky,
        hideWhenDetached: hideWhenDetached,
        avoidCollisions: avoidCollisions
    } : {};
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7cacca21c6f84773$var$SelectContentProvider, {
        scope: __scopeSelect,
        content: content,
        viewport: viewport,
        onViewportChange: setViewport,
        itemRefCallback: itemRefCallback,
        selectedItem: selectedItem,
        onItemLeave: handleItemLeave,
        itemTextRefCallback: itemTextRefCallback,
        focusSelectedItem: focusSelectedItem,
        selectedItemText: selectedItemText,
        position: position,
        isPositioned: isPositioned,
        searchRef: searchRef,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $ef57a4b421076988$export$2e2bcd8739ae039), {
            as: (0, $089057084dfb92a4$export$8c6ed5c666ac1360),
            allowPinchZoom: true,
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $0d555b2b0a3ffff1$export$20e40289641fbbb6), {
                asChild: true,
                trapped: context.open,
                onMountAutoFocus: (event)=>{
                    event.preventDefault();
                },
                onUnmountAutoFocus: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(onCloseAutoFocus, (event)=>{
                    var _context_trigger;
                    (_context_trigger = context.trigger) === null || _context_trigger === void 0 ? void 0 : _context_trigger.focus({
                        preventScroll: true
                    });
                    event.preventDefault();
                }),
                children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $251340165f4765e5$export$177fb62ff3ec1f22), {
                    asChild: true,
                    disableOutsidePointerEvents: true,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onPointerDownOutside: onPointerDownOutside,
                    onFocusOutside: (event)=>event.preventDefault(),
                    onDismiss: ()=>context.onOpenChange(false),
                    children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(SelectPosition, {
                        role: "listbox",
                        id: context.contentId,
                        "data-state": context.open ? "open" : "closed",
                        dir: context.dir,
                        onContextMenu: (event)=>event.preventDefault(),
                        ...contentProps,
                        ...popperContentProps,
                        onPlaced: ()=>setIsPositioned(true),
                        ref: composedRefs,
                        style: {
                            // flex layout so we can place the scroll buttons properly
                            display: "flex",
                            flexDirection: "column",
                            // reset the outline by default as the content MAY get focused
                            outline: "none",
                            ...contentProps.style
                        },
                        onKeyDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(contentProps.onKeyDown, (event)=>{
                            const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
                            if (event.key === "Tab") event.preventDefault();
                            if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
                            if ([
                                "ArrowUp",
                                "ArrowDown",
                                "Home",
                                "End"
                            ].includes(event.key)) {
                                const items = getItems().filter((item)=>!item.disabled);
                                let candidateNodes = items.map((item)=>item.ref.current);
                                if ([
                                    "ArrowUp",
                                    "End"
                                ].includes(event.key)) candidateNodes = candidateNodes.slice().reverse();
                                if ([
                                    "ArrowUp",
                                    "ArrowDown"
                                ].includes(event.key)) {
                                    const currentElement = event.target;
                                    const currentIndex = candidateNodes.indexOf(currentElement);
                                    candidateNodes = candidateNodes.slice(currentIndex + 1);
                                }
                                setTimeout(()=>focusFirst(candidateNodes));
                                event.preventDefault();
                            }
                        })
                    })
                })
            })
        })
    });
});
$7cacca21c6f84773$var$SelectContentImpl.displayName = $7cacca21c6f84773$var$CONTENT_IMPL_NAME;
var $7cacca21c6f84773$var$ITEM_ALIGNED_POSITION_NAME = "SelectItemAlignedPosition";
var $7cacca21c6f84773$var$SelectItemAlignedPosition = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, onPlaced: onPlaced, ...popperProps } = props;
    const context = $7cacca21c6f84773$var$useSelectContext($7cacca21c6f84773$var$CONTENT_NAME, __scopeSelect);
    const contentContext = $7cacca21c6f84773$var$useSelectContentContext($7cacca21c6f84773$var$CONTENT_NAME, __scopeSelect);
    const [contentWrapper, setContentWrapper] = $7fPBF.useState(null);
    const [content, setContent] = $7fPBF.useState(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setContent(node));
    const getItems = $7cacca21c6f84773$var$useCollection(__scopeSelect);
    const shouldExpandOnScrollRef = $7fPBF.useRef(false);
    const shouldRepositionRef = $7fPBF.useRef(true);
    const { viewport: viewport, selectedItem: selectedItem, selectedItemText: selectedItemText, focusSelectedItem: focusSelectedItem } = contentContext;
    const position = $7fPBF.useCallback(()=>{
        if (context.trigger && context.valueNode && contentWrapper && content && viewport && selectedItem && selectedItemText) {
            const triggerRect = context.trigger.getBoundingClientRect();
            const contentRect = content.getBoundingClientRect();
            const valueNodeRect = context.valueNode.getBoundingClientRect();
            const itemTextRect = selectedItemText.getBoundingClientRect();
            if (context.dir !== "rtl") {
                const itemTextOffset = itemTextRect.left - contentRect.left;
                const left = valueNodeRect.left - itemTextOffset;
                const leftDelta = triggerRect.left - left;
                const minContentWidth = triggerRect.width + leftDelta;
                const contentWidth = Math.max(minContentWidth, contentRect.width);
                const rightEdge = window.innerWidth - $7cacca21c6f84773$var$CONTENT_MARGIN;
                const clampedLeft = (0, $6d53081595419ec4$export$7d15b64cf5a3a4c4)(left, [
                    $7cacca21c6f84773$var$CONTENT_MARGIN,
                    rightEdge - contentWidth
                ]);
                contentWrapper.style.minWidth = minContentWidth + "px";
                contentWrapper.style.left = clampedLeft + "px";
            } else {
                const itemTextOffset = contentRect.right - itemTextRect.right;
                const right = window.innerWidth - valueNodeRect.right - itemTextOffset;
                const rightDelta = window.innerWidth - triggerRect.right - right;
                const minContentWidth = triggerRect.width + rightDelta;
                const contentWidth = Math.max(minContentWidth, contentRect.width);
                const leftEdge = window.innerWidth - $7cacca21c6f84773$var$CONTENT_MARGIN;
                const clampedRight = (0, $6d53081595419ec4$export$7d15b64cf5a3a4c4)(right, [
                    $7cacca21c6f84773$var$CONTENT_MARGIN,
                    leftEdge - contentWidth
                ]);
                contentWrapper.style.minWidth = minContentWidth + "px";
                contentWrapper.style.right = clampedRight + "px";
            }
            const items = getItems();
            const availableHeight = window.innerHeight - $7cacca21c6f84773$var$CONTENT_MARGIN * 2;
            const itemsHeight = viewport.scrollHeight;
            const contentStyles = window.getComputedStyle(content);
            const contentBorderTopWidth = parseInt(contentStyles.borderTopWidth, 10);
            const contentPaddingTop = parseInt(contentStyles.paddingTop, 10);
            const contentBorderBottomWidth = parseInt(contentStyles.borderBottomWidth, 10);
            const contentPaddingBottom = parseInt(contentStyles.paddingBottom, 10);
            const fullContentHeight = contentBorderTopWidth + contentPaddingTop + itemsHeight + contentPaddingBottom + contentBorderBottomWidth;
            const minContentHeight = Math.min(selectedItem.offsetHeight * 5, fullContentHeight);
            const viewportStyles = window.getComputedStyle(viewport);
            const viewportPaddingTop = parseInt(viewportStyles.paddingTop, 10);
            const viewportPaddingBottom = parseInt(viewportStyles.paddingBottom, 10);
            const topEdgeToTriggerMiddle = triggerRect.top + triggerRect.height / 2 - $7cacca21c6f84773$var$CONTENT_MARGIN;
            const triggerMiddleToBottomEdge = availableHeight - topEdgeToTriggerMiddle;
            const selectedItemHalfHeight = selectedItem.offsetHeight / 2;
            const itemOffsetMiddle = selectedItem.offsetTop + selectedItemHalfHeight;
            const contentTopToItemMiddle = contentBorderTopWidth + contentPaddingTop + itemOffsetMiddle;
            const itemMiddleToContentBottom = fullContentHeight - contentTopToItemMiddle;
            const willAlignWithoutTopOverflow = contentTopToItemMiddle <= topEdgeToTriggerMiddle;
            if (willAlignWithoutTopOverflow) {
                const isLastItem = selectedItem === items[items.length - 1].ref.current;
                contentWrapper.style.bottom = "0px";
                const viewportOffsetBottom = content.clientHeight - viewport.offsetTop - viewport.offsetHeight;
                const clampedTriggerMiddleToBottomEdge = Math.max(triggerMiddleToBottomEdge, selectedItemHalfHeight + // viewport might have padding bottom, include it to avoid a scrollable viewport
                (isLastItem ? viewportPaddingBottom : 0) + viewportOffsetBottom + contentBorderBottomWidth);
                const height = contentTopToItemMiddle + clampedTriggerMiddleToBottomEdge;
                contentWrapper.style.height = height + "px";
            } else {
                const isFirstItem = selectedItem === items[0].ref.current;
                contentWrapper.style.top = "0px";
                const clampedTopEdgeToTriggerMiddle = Math.max(topEdgeToTriggerMiddle, contentBorderTopWidth + viewport.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
                (isFirstItem ? viewportPaddingTop : 0) + selectedItemHalfHeight);
                const height = clampedTopEdgeToTriggerMiddle + itemMiddleToContentBottom;
                contentWrapper.style.height = height + "px";
                viewport.scrollTop = contentTopToItemMiddle - topEdgeToTriggerMiddle + viewport.offsetTop;
            }
            contentWrapper.style.margin = `${$7cacca21c6f84773$var$CONTENT_MARGIN}px 0`;
            contentWrapper.style.minHeight = minContentHeight + "px";
            contentWrapper.style.maxHeight = availableHeight + "px";
            onPlaced === null || onPlaced === void 0 ? void 0 : onPlaced();
            requestAnimationFrame(()=>shouldExpandOnScrollRef.current = true);
        }
    }, [
        getItems,
        context.trigger,
        context.valueNode,
        contentWrapper,
        content,
        viewport,
        selectedItem,
        selectedItemText,
        context.dir,
        onPlaced
    ]);
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>position(), [
        position
    ]);
    const [contentZIndex, setContentZIndex] = $7fPBF.useState();
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    const handleScrollButtonChange = $7fPBF.useCallback((node)=>{
        if (node && shouldRepositionRef.current === true) {
            position();
            focusSelectedItem === null || focusSelectedItem === void 0 ? void 0 : focusSelectedItem();
            shouldRepositionRef.current = false;
        }
    }, [
        position,
        focusSelectedItem
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7cacca21c6f84773$var$SelectViewportProvider, {
        scope: __scopeSelect,
        contentWrapper: contentWrapper,
        shouldExpandOnScrollRef: shouldExpandOnScrollRef,
        onScrollButtonChange: handleScrollButtonChange,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("div", {
            ref: setContentWrapper,
            style: {
                display: "flex",
                flexDirection: "column",
                position: "fixed",
                zIndex: contentZIndex
            },
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
                ...popperProps,
                ref: composedRefs,
                style: {
                    // When we get the height of the content, it includes borders. If we were to set
                    // the height without having `boxSizing: 'border-box'` it would be too big.
                    boxSizing: "border-box",
                    // We need to ensure the content doesn't get taller than the wrapper
                    maxHeight: "100%",
                    ...popperProps.style
                }
            })
        })
    });
});
$7cacca21c6f84773$var$SelectItemAlignedPosition.displayName = $7cacca21c6f84773$var$ITEM_ALIGNED_POSITION_NAME;
var $7cacca21c6f84773$var$POPPER_POSITION_NAME = "SelectPopperPosition";
var $7cacca21c6f84773$var$SelectPopperPosition = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, align: align = "start", collisionPadding: collisionPadding = $7cacca21c6f84773$var$CONTENT_MARGIN, ...popperProps } = props;
    const popperScope = $7cacca21c6f84773$var$usePopperScope(__scopeSelect);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$export$7c6e2c02157bb7d2, {
        ...popperScope,
        ...popperProps,
        ref: forwardedRef,
        align: align,
        collisionPadding: collisionPadding,
        style: {
            // Ensure border-box for floating-ui calculations
            boxSizing: "border-box",
            ...popperProps.style,
            "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-select-content-available-width": "var(--radix-popper-available-width)",
            "--radix-select-content-available-height": "var(--radix-popper-available-height)",
            "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
        }
    });
});
$7cacca21c6f84773$var$SelectPopperPosition.displayName = $7cacca21c6f84773$var$POPPER_POSITION_NAME;
var [$7cacca21c6f84773$var$SelectViewportProvider, $7cacca21c6f84773$var$useSelectViewportContext] = $7cacca21c6f84773$var$createSelectContext($7cacca21c6f84773$var$CONTENT_NAME, {});
var $7cacca21c6f84773$var$VIEWPORT_NAME = "SelectViewport";
var $7cacca21c6f84773$export$9ed6e7b40248d36d = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, nonce: nonce, ...viewportProps } = props;
    const contentContext = $7cacca21c6f84773$var$useSelectContentContext($7cacca21c6f84773$var$VIEWPORT_NAME, __scopeSelect);
    const viewportContext = $7cacca21c6f84773$var$useSelectViewportContext($7cacca21c6f84773$var$VIEWPORT_NAME, __scopeSelect);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, contentContext.onViewportChange);
    const prevScrollTopRef = $7fPBF.useRef(0);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("style", {
                dangerouslySetInnerHTML: {
                    __html: `[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}`
                },
                nonce: nonce
            }),
            /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7cacca21c6f84773$var$Collection.Slot, {
                scope: __scopeSelect,
                children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
                    "data-radix-select-viewport": "",
                    role: "presentation",
                    ...viewportProps,
                    ref: composedRefs,
                    style: {
                        // we use position: 'relative' here on the `viewport` so that when we call
                        // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
                        // (independent of the scrollUpButton).
                        position: "relative",
                        flex: 1,
                        overflow: "auto",
                        ...viewportProps.style
                    },
                    onScroll: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(viewportProps.onScroll, (event)=>{
                        const viewport = event.currentTarget;
                        const { contentWrapper: contentWrapper, shouldExpandOnScrollRef: shouldExpandOnScrollRef } = viewportContext;
                        if ((shouldExpandOnScrollRef === null || shouldExpandOnScrollRef === void 0 ? void 0 : shouldExpandOnScrollRef.current) && contentWrapper) {
                            const scrolledBy = Math.abs(prevScrollTopRef.current - viewport.scrollTop);
                            if (scrolledBy > 0) {
                                const availableHeight = window.innerHeight - $7cacca21c6f84773$var$CONTENT_MARGIN * 2;
                                const cssMinHeight = parseFloat(contentWrapper.style.minHeight);
                                const cssHeight = parseFloat(contentWrapper.style.height);
                                const prevHeight = Math.max(cssMinHeight, cssHeight);
                                if (prevHeight < availableHeight) {
                                    const nextHeight = prevHeight + scrolledBy;
                                    const clampedNextHeight = Math.min(availableHeight, nextHeight);
                                    const heightDiff = nextHeight - clampedNextHeight;
                                    contentWrapper.style.height = clampedNextHeight + "px";
                                    if (contentWrapper.style.bottom === "0px") {
                                        viewport.scrollTop = heightDiff > 0 ? heightDiff : 0;
                                        contentWrapper.style.justifyContent = "flex-end";
                                    }
                                }
                            }
                        }
                        prevScrollTopRef.current = viewport.scrollTop;
                    })
                })
            })
        ]
    });
});
$7cacca21c6f84773$export$9ed6e7b40248d36d.displayName = $7cacca21c6f84773$var$VIEWPORT_NAME;
var $7cacca21c6f84773$var$GROUP_NAME = "SelectGroup";
var [$7cacca21c6f84773$var$SelectGroupContextProvider, $7cacca21c6f84773$var$useSelectGroupContext] = $7cacca21c6f84773$var$createSelectContext($7cacca21c6f84773$var$GROUP_NAME);
var $7cacca21c6f84773$export$ee25a334c55de1f4 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...groupProps } = props;
    const groupId = (0, $8a8e9b94c33ba6d6$export$f680877a34711e37)();
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7cacca21c6f84773$var$SelectGroupContextProvider, {
        scope: __scopeSelect,
        id: groupId,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
            role: "group",
            "aria-labelledby": groupId,
            ...groupProps,
            ref: forwardedRef
        })
    });
});
$7cacca21c6f84773$export$ee25a334c55de1f4.displayName = $7cacca21c6f84773$var$GROUP_NAME;
var $7cacca21c6f84773$var$LABEL_NAME = "SelectLabel";
var $7cacca21c6f84773$export$f67338d29bd972f8 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...labelProps } = props;
    const groupContext = $7cacca21c6f84773$var$useSelectGroupContext($7cacca21c6f84773$var$LABEL_NAME, __scopeSelect);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
        id: groupContext.id,
        ...labelProps,
        ref: forwardedRef
    });
});
$7cacca21c6f84773$export$f67338d29bd972f8.displayName = $7cacca21c6f84773$var$LABEL_NAME;
var $7cacca21c6f84773$var$ITEM_NAME = "SelectItem";
var [$7cacca21c6f84773$var$SelectItemContextProvider, $7cacca21c6f84773$var$useSelectItemContext] = $7cacca21c6f84773$var$createSelectContext($7cacca21c6f84773$var$ITEM_NAME);
var $7cacca21c6f84773$export$13ef48a934230896 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, value: value, disabled: disabled = false, textValue: textValueProp, ...itemProps } = props;
    const context = $7cacca21c6f84773$var$useSelectContext($7cacca21c6f84773$var$ITEM_NAME, __scopeSelect);
    const contentContext = $7cacca21c6f84773$var$useSelectContentContext($7cacca21c6f84773$var$ITEM_NAME, __scopeSelect);
    const isSelected = context.value === value;
    const [textValue, setTextValue] = $7fPBF.useState(textValueProp !== null && textValueProp !== void 0 ? textValueProp : "");
    const [isFocused, setIsFocused] = $7fPBF.useState(false);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>{
        var _contentContext_itemRefCallback;
        return (_contentContext_itemRefCallback = contentContext.itemRefCallback) === null || _contentContext_itemRefCallback === void 0 ? void 0 : _contentContext_itemRefCallback.call(contentContext, node, value, disabled);
    });
    const textId = (0, $8a8e9b94c33ba6d6$export$f680877a34711e37)();
    const handleSelect = ()=>{
        if (!disabled) {
            context.onValueChange(value);
            context.onOpenChange(false);
        }
    };
    if (value === "") throw new Error("A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder.");
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7cacca21c6f84773$var$SelectItemContextProvider, {
        scope: __scopeSelect,
        value: value,
        disabled: disabled,
        textId: textId,
        isSelected: isSelected,
        onItemTextChange: $7fPBF.useCallback((node)=>{
            setTextValue((prevTextValue)=>{
                var _node_textContent;
                return prevTextValue || ((_node_textContent = node === null || node === void 0 ? void 0 : node.textContent) !== null && _node_textContent !== void 0 ? _node_textContent : "").trim();
            });
        }, []),
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7cacca21c6f84773$var$Collection.ItemSlot, {
            scope: __scopeSelect,
            value: value,
            disabled: disabled,
            textValue: textValue,
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
                role: "option",
                "aria-labelledby": textId,
                "data-highlighted": isFocused ? "" : void 0,
                "aria-selected": isSelected && isFocused,
                "data-state": isSelected ? "checked" : "unchecked",
                "aria-disabled": disabled || void 0,
                "data-disabled": disabled ? "" : void 0,
                tabIndex: disabled ? void 0 : -1,
                ...itemProps,
                ref: composedRefs,
                onFocus: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(itemProps.onFocus, ()=>setIsFocused(true)),
                onBlur: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(itemProps.onBlur, ()=>setIsFocused(false)),
                onPointerUp: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(itemProps.onPointerUp, handleSelect),
                onPointerMove: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(itemProps.onPointerMove, (event)=>{
                    var _contentContext_onItemLeave;
                    if (disabled) (_contentContext_onItemLeave = contentContext.onItemLeave) === null || _contentContext_onItemLeave === void 0 ? void 0 : _contentContext_onItemLeave.call(contentContext);
                    else event.currentTarget.focus({
                        preventScroll: true
                    });
                }),
                onPointerLeave: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(itemProps.onPointerLeave, (event)=>{
                    var _contentContext_onItemLeave;
                    if (event.currentTarget === document.activeElement) (_contentContext_onItemLeave = contentContext.onItemLeave) === null || _contentContext_onItemLeave === void 0 ? void 0 : _contentContext_onItemLeave.call(contentContext);
                }),
                onKeyDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(itemProps.onKeyDown, (event)=>{
                    var _contentContext_searchRef;
                    const isTypingAhead = ((_contentContext_searchRef = contentContext.searchRef) === null || _contentContext_searchRef === void 0 ? void 0 : _contentContext_searchRef.current) !== "";
                    if (isTypingAhead && event.key === " ") return;
                    if ($7cacca21c6f84773$var$SELECTION_KEYS.includes(event.key)) handleSelect();
                    if (event.key === " ") event.preventDefault();
                })
            })
        })
    });
});
$7cacca21c6f84773$export$13ef48a934230896.displayName = $7cacca21c6f84773$var$ITEM_NAME;
var $7cacca21c6f84773$var$ITEM_TEXT_NAME = "SelectItemText";
var $7cacca21c6f84773$export$3572fb0fb821ff49 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, className: className, style: style, ...itemTextProps } = props;
    const context = $7cacca21c6f84773$var$useSelectContext($7cacca21c6f84773$var$ITEM_TEXT_NAME, __scopeSelect);
    const contentContext = $7cacca21c6f84773$var$useSelectContentContext($7cacca21c6f84773$var$ITEM_TEXT_NAME, __scopeSelect);
    const itemContext = $7cacca21c6f84773$var$useSelectItemContext($7cacca21c6f84773$var$ITEM_TEXT_NAME, __scopeSelect);
    const nativeOptionsContext = $7cacca21c6f84773$var$useSelectNativeOptionsContext($7cacca21c6f84773$var$ITEM_TEXT_NAME, __scopeSelect);
    const [itemTextNode, setItemTextNode] = $7fPBF.useState(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setItemTextNode(node), itemContext.onItemTextChange, (node)=>{
        var _contentContext_itemTextRefCallback;
        return (_contentContext_itemTextRefCallback = contentContext.itemTextRefCallback) === null || _contentContext_itemTextRefCallback === void 0 ? void 0 : _contentContext_itemTextRefCallback.call(contentContext, node, itemContext.value, itemContext.disabled);
    });
    const textContent = itemTextNode === null || itemTextNode === void 0 ? void 0 : itemTextNode.textContent;
    const nativeOption = $7fPBF.useMemo(()=>/* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("option", {
            value: itemContext.value,
            disabled: itemContext.disabled,
            children: textContent
        }, itemContext.value), [
        itemContext.disabled,
        itemContext.value,
        textContent
    ]);
    const { onNativeOptionAdd: onNativeOptionAdd, onNativeOptionRemove: onNativeOptionRemove } = nativeOptionsContext;
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        onNativeOptionAdd(nativeOption);
        return ()=>onNativeOptionRemove(nativeOption);
    }, [
        onNativeOptionAdd,
        onNativeOptionRemove,
        nativeOption
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).span, {
                id: itemContext.textId,
                ...itemTextProps,
                ref: composedRefs
            }),
            itemContext.isSelected && context.valueNode && !context.valueNodeHasChildren ? $b4ba1c853f6e1116$exports.createPortal(itemTextProps.children, context.valueNode) : null
        ]
    });
});
$7cacca21c6f84773$export$3572fb0fb821ff49.displayName = $7cacca21c6f84773$var$ITEM_TEXT_NAME;
var $7cacca21c6f84773$var$ITEM_INDICATOR_NAME = "SelectItemIndicator";
var $7cacca21c6f84773$export$6b9198de19accfe6 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...itemIndicatorProps } = props;
    const itemContext = $7cacca21c6f84773$var$useSelectItemContext($7cacca21c6f84773$var$ITEM_INDICATOR_NAME, __scopeSelect);
    return itemContext.isSelected ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).span, {
        "aria-hidden": true,
        ...itemIndicatorProps,
        ref: forwardedRef
    }) : null;
});
$7cacca21c6f84773$export$6b9198de19accfe6.displayName = $7cacca21c6f84773$var$ITEM_INDICATOR_NAME;
var $7cacca21c6f84773$var$SCROLL_UP_BUTTON_NAME = "SelectScrollUpButton";
var $7cacca21c6f84773$export$d8117927658af6d7 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const contentContext = $7cacca21c6f84773$var$useSelectContentContext($7cacca21c6f84773$var$SCROLL_UP_BUTTON_NAME, props.__scopeSelect);
    const viewportContext = $7cacca21c6f84773$var$useSelectViewportContext($7cacca21c6f84773$var$SCROLL_UP_BUTTON_NAME, props.__scopeSelect);
    const [canScrollUp, setCanScrollUp] = $7fPBF.useState(false);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, viewportContext.onScrollButtonChange);
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        if (contentContext.viewport && contentContext.isPositioned) {
            let handleScroll2 = function() {
                const canScrollUp2 = viewport.scrollTop > 0;
                setCanScrollUp(canScrollUp2);
            };
            var handleScroll = handleScroll2;
            const viewport = contentContext.viewport;
            handleScroll2();
            viewport.addEventListener("scroll", handleScroll2);
            return ()=>viewport.removeEventListener("scroll", handleScroll2);
        }
    }, [
        contentContext.viewport,
        contentContext.isPositioned
    ]);
    return canScrollUp ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7cacca21c6f84773$var$SelectScrollButtonImpl, {
        ...props,
        ref: composedRefs,
        onAutoScroll: ()=>{
            const { viewport: viewport, selectedItem: selectedItem } = contentContext;
            if (viewport && selectedItem) viewport.scrollTop = viewport.scrollTop - selectedItem.offsetHeight;
        }
    }) : null;
});
$7cacca21c6f84773$export$d8117927658af6d7.displayName = $7cacca21c6f84773$var$SCROLL_UP_BUTTON_NAME;
var $7cacca21c6f84773$var$SCROLL_DOWN_BUTTON_NAME = "SelectScrollDownButton";
var $7cacca21c6f84773$export$ff951e476c12189 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const contentContext = $7cacca21c6f84773$var$useSelectContentContext($7cacca21c6f84773$var$SCROLL_DOWN_BUTTON_NAME, props.__scopeSelect);
    const viewportContext = $7cacca21c6f84773$var$useSelectViewportContext($7cacca21c6f84773$var$SCROLL_DOWN_BUTTON_NAME, props.__scopeSelect);
    const [canScrollDown, setCanScrollDown] = $7fPBF.useState(false);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, viewportContext.onScrollButtonChange);
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        if (contentContext.viewport && contentContext.isPositioned) {
            let handleScroll2 = function() {
                const maxScroll = viewport.scrollHeight - viewport.clientHeight;
                const canScrollDown2 = Math.ceil(viewport.scrollTop) < maxScroll;
                setCanScrollDown(canScrollDown2);
            };
            var handleScroll = handleScroll2;
            const viewport = contentContext.viewport;
            handleScroll2();
            viewport.addEventListener("scroll", handleScroll2);
            return ()=>viewport.removeEventListener("scroll", handleScroll2);
        }
    }, [
        contentContext.viewport,
        contentContext.isPositioned
    ]);
    return canScrollDown ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7cacca21c6f84773$var$SelectScrollButtonImpl, {
        ...props,
        ref: composedRefs,
        onAutoScroll: ()=>{
            const { viewport: viewport, selectedItem: selectedItem } = contentContext;
            if (viewport && selectedItem) viewport.scrollTop = viewport.scrollTop + selectedItem.offsetHeight;
        }
    }) : null;
});
$7cacca21c6f84773$export$ff951e476c12189.displayName = $7cacca21c6f84773$var$SCROLL_DOWN_BUTTON_NAME;
var $7cacca21c6f84773$var$SelectScrollButtonImpl = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, onAutoScroll: onAutoScroll, ...scrollIndicatorProps } = props;
    const contentContext = $7cacca21c6f84773$var$useSelectContentContext("SelectScrollButton", __scopeSelect);
    const autoScrollTimerRef = $7fPBF.useRef(null);
    const getItems = $7cacca21c6f84773$var$useCollection(__scopeSelect);
    const clearAutoScrollTimer = $7fPBF.useCallback(()=>{
        if (autoScrollTimerRef.current !== null) {
            window.clearInterval(autoScrollTimerRef.current);
            autoScrollTimerRef.current = null;
        }
    }, []);
    $7fPBF.useEffect(()=>{
        return ()=>clearAutoScrollTimer();
    }, [
        clearAutoScrollTimer
    ]);
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        var _activeItem_ref_current;
        const activeItem = getItems().find((item)=>item.ref.current === document.activeElement);
        activeItem === null || activeItem === void 0 ? void 0 : (_activeItem_ref_current = activeItem.ref.current) === null || _activeItem_ref_current === void 0 ? void 0 : _activeItem_ref_current.scrollIntoView({
            block: "nearest"
        });
    }, [
        getItems
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
        "aria-hidden": true,
        ...scrollIndicatorProps,
        ref: forwardedRef,
        style: {
            flexShrink: 0,
            ...scrollIndicatorProps.style
        },
        onPointerDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(scrollIndicatorProps.onPointerDown, ()=>{
            if (autoScrollTimerRef.current === null) autoScrollTimerRef.current = window.setInterval(onAutoScroll, 50);
        }),
        onPointerMove: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(scrollIndicatorProps.onPointerMove, ()=>{
            var _contentContext_onItemLeave;
            (_contentContext_onItemLeave = contentContext.onItemLeave) === null || _contentContext_onItemLeave === void 0 ? void 0 : _contentContext_onItemLeave.call(contentContext);
            if (autoScrollTimerRef.current === null) autoScrollTimerRef.current = window.setInterval(onAutoScroll, 50);
        }),
        onPointerLeave: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(scrollIndicatorProps.onPointerLeave, ()=>{
            clearAutoScrollTimer();
        })
    });
});
var $7cacca21c6f84773$var$SEPARATOR_NAME = "SelectSeparator";
var $7cacca21c6f84773$export$eba4b1df07cb1d3 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...separatorProps } = props;
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
        "aria-hidden": true,
        ...separatorProps,
        ref: forwardedRef
    });
});
$7cacca21c6f84773$export$eba4b1df07cb1d3.displayName = $7cacca21c6f84773$var$SEPARATOR_NAME;
var $7cacca21c6f84773$var$ARROW_NAME = "SelectArrow";
var $7cacca21c6f84773$export$314f4cb8f8099628 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeSelect: __scopeSelect, ...arrowProps } = props;
    const popperScope = $7cacca21c6f84773$var$usePopperScope(__scopeSelect);
    const context = $7cacca21c6f84773$var$useSelectContext($7cacca21c6f84773$var$ARROW_NAME, __scopeSelect);
    const contentContext = $7cacca21c6f84773$var$useSelectContentContext($7cacca21c6f84773$var$ARROW_NAME, __scopeSelect);
    return context.open && contentContext.position === "popper" ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$export$21b07c8f274aebd5, {
        ...popperScope,
        ...arrowProps,
        ref: forwardedRef
    }) : null;
});
$7cacca21c6f84773$export$314f4cb8f8099628.displayName = $7cacca21c6f84773$var$ARROW_NAME;
function $7cacca21c6f84773$var$shouldShowPlaceholder(value) {
    return value === "" || value === void 0;
}
var $7cacca21c6f84773$var$BubbleSelect = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { value: value, ...selectProps } = props;
    const ref = $7fPBF.useRef(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const prevValue = (0, $62f6e650b37fb598$export$5cae361ad82dce8b)(value);
    $7fPBF.useEffect(()=>{
        const select = ref.current;
        const selectProto = window.HTMLSelectElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(selectProto, "value");
        const setValue = descriptor.set;
        if (prevValue !== value && setValue) {
            const event = new Event("change", {
                bubbles: true
            });
            setValue.call(select, value);
            select.dispatchEvent(event);
        }
    }, [
        prevValue,
        value
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $28c8fa82e4cfdc1a$export$439d29a4e110a164), {
        asChild: true,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("select", {
            ...selectProps,
            ref: composedRefs,
            defaultValue: value
        })
    });
});
$7cacca21c6f84773$var$BubbleSelect.displayName = "BubbleSelect";
function $7cacca21c6f84773$var$useTypeaheadSearch(onSearchChange) {
    const handleSearchChange = (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(onSearchChange);
    const searchRef = $7fPBF.useRef("");
    const timerRef = $7fPBF.useRef(0);
    const handleTypeaheadSearch = $7fPBF.useCallback((key)=>{
        const search = searchRef.current + key;
        handleSearchChange(search);
        (function updateSearch(value) {
            searchRef.current = value;
            window.clearTimeout(timerRef.current);
            if (value !== "") timerRef.current = window.setTimeout(()=>updateSearch(""), 1e3);
        })(search);
    }, [
        handleSearchChange
    ]);
    const resetTypeahead = $7fPBF.useCallback(()=>{
        searchRef.current = "";
        window.clearTimeout(timerRef.current);
    }, []);
    $7fPBF.useEffect(()=>{
        return ()=>window.clearTimeout(timerRef.current);
    }, []);
    return [
        searchRef,
        handleTypeaheadSearch,
        resetTypeahead
    ];
}
function $7cacca21c6f84773$var$findNextItem(items, search, currentItem) {
    const isRepeated = search.length > 1 && Array.from(search).every((char)=>char === search[0]);
    const normalizedSearch = isRepeated ? search[0] : search;
    const currentItemIndex = currentItem ? items.indexOf(currentItem) : -1;
    let wrappedItems = $7cacca21c6f84773$var$wrapArray(items, Math.max(currentItemIndex, 0));
    const excludeCurrentItem = normalizedSearch.length === 1;
    if (excludeCurrentItem) wrappedItems = wrappedItems.filter((v)=>v !== currentItem);
    const nextItem = wrappedItems.find((item)=>item.textValue.toLowerCase().startsWith(normalizedSearch.toLowerCase()));
    return nextItem !== currentItem ? nextItem : void 0;
}
function $7cacca21c6f84773$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
var $7cacca21c6f84773$export$be92b6f5f03c0fe9 = $7cacca21c6f84773$export$ef9b1a59e592288f;
var $7cacca21c6f84773$export$41fb9f06171c75f4 = $7cacca21c6f84773$export$3ac1e88a1c0b9f1;
var $7cacca21c6f84773$export$4c8d1a57a761ef94 = $7cacca21c6f84773$export$e288731fd71264f0;
var $7cacca21c6f84773$export$f04a61298a47a40f = $7cacca21c6f84773$export$99b400cabb58c515;
var $7cacca21c6f84773$export$602eac185826482c = $7cacca21c6f84773$export$b2af6c9944296213;
var $7cacca21c6f84773$export$7c6e2c02157bb7d2 = $7cacca21c6f84773$export$c973a4b3cb86a03d;
var $7cacca21c6f84773$export$d5c6c08dc2d3ca7 = $7cacca21c6f84773$export$9ed6e7b40248d36d;
var $7cacca21c6f84773$export$eb2fcfdbd7ba97d4 = $7cacca21c6f84773$export$ee25a334c55de1f4;
var $7cacca21c6f84773$export$b04be29aa201d4f5 = $7cacca21c6f84773$export$f67338d29bd972f8;
var $7cacca21c6f84773$export$6d08773d2e66f8f2 = $7cacca21c6f84773$export$13ef48a934230896;
var $7cacca21c6f84773$export$d6e5bf9c43ea9319 = $7cacca21c6f84773$export$3572fb0fb821ff49;
var $7cacca21c6f84773$export$c3468e2714d175fa = $7cacca21c6f84773$export$6b9198de19accfe6;
var $7cacca21c6f84773$export$2f60d3ec9ad468f2 = $7cacca21c6f84773$export$d8117927658af6d7;
var $7cacca21c6f84773$export$bf1aedc3039c8d63 = $7cacca21c6f84773$export$ff951e476c12189;
var $7cacca21c6f84773$export$1ff3c3f08ae963c0 = $7cacca21c6f84773$export$eba4b1df07cb1d3;
var $7cacca21c6f84773$export$21b07c8f274aebd5 = $7cacca21c6f84773$export$314f4cb8f8099628;









const $8aacb632f7d805c5$var$r = [
    "1",
    "2",
    "3"
], $8aacb632f7d805c5$export$58dfb7f97f8eec9b = {
    size: {
        type: "enum",
        className: "rt-r-size",
        values: $8aacb632f7d805c5$var$r,
        default: "2",
        responsive: !0
    }
}, $8aacb632f7d805c5$var$a = [
    "classic",
    "surface",
    "soft",
    "ghost"
], $8aacb632f7d805c5$export$bcc05edae978d73e = {
    variant: {
        type: "enum",
        className: "rt-variant",
        values: $8aacb632f7d805c5$var$a,
        default: "surface"
    },
    ...(0, $e914ebf2ce406d8c$export$8255b018f448be13),
    ...(0, $3d20a83f81464c0a$export$c467f6769b59b70c),
    placeholder: {
        type: "string"
    }
}, $8aacb632f7d805c5$var$n = [
    "solid",
    "soft"
], $8aacb632f7d805c5$export$375dc816459789a3 = {
    variant: {
        type: "enum",
        className: "rt-variant",
        values: $8aacb632f7d805c5$var$n,
        default: "solid"
    },
    ...(0, $e914ebf2ce406d8c$export$8255b018f448be13),
    ...(0, $f41c61290c2a7125$export$2f84412d299def33)
};



"use client";
const $608da1f87bc1fe5b$var$f = $7fPBF.createContext({}), $608da1f87bc1fe5b$export$be92b6f5f03c0fe9 = (o)=>{
    const { children: r, size: t = (0, $8aacb632f7d805c5$export$58dfb7f97f8eec9b).size.default, ...s } = o;
    return $7fPBF.createElement($7cacca21c6f84773$export$be92b6f5f03c0fe9, {
        ...s
    }, $7fPBF.createElement($608da1f87bc1fe5b$var$f.Provider, {
        value: $7fPBF.useMemo(()=>({
                size: t
            }), [
            t
        ])
    }, r));
};
$608da1f87bc1fe5b$export$be92b6f5f03c0fe9.displayName = "Select.Root";
const $608da1f87bc1fe5b$export$41fb9f06171c75f4 = $7fPBF.forwardRef((o, r)=>{
    const t = $7fPBF.useContext($608da1f87bc1fe5b$var$f), { children: s, className: p, color: n, radius: m, placeholder: c, ...S } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)({
        size: t === null || t === void 0 ? void 0 : t.size,
        ...o
    }, {
        size: (0, $8aacb632f7d805c5$export$58dfb7f97f8eec9b).size
    }, (0, $8aacb632f7d805c5$export$bcc05edae978d73e), (0, $df06be8448ff4f3c$export$83503616c7a463e3));
    return $7fPBF.createElement($7cacca21c6f84773$export$41fb9f06171c75f4, {
        asChild: !0
    }, $7fPBF.createElement("button", {
        "data-accent-color": n,
        "data-radius": m,
        ...S,
        ref: r,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-reset", "rt-SelectTrigger", p)
    }, $7fPBF.createElement("span", {
        className: "rt-SelectTriggerInner"
    }, $7fPBF.createElement($7cacca21c6f84773$export$4c8d1a57a761ef94, {
        placeholder: c
    }, s)), $7fPBF.createElement($7cacca21c6f84773$export$f04a61298a47a40f, {
        asChild: !0
    }, $7fPBF.createElement((0, $a0cf194253713caf$export$4857d3f3f5f8319b), {
        className: "rt-SelectIcon"
    }))));
});
$608da1f87bc1fe5b$export$41fb9f06171c75f4.displayName = "Select.Trigger";
const $608da1f87bc1fe5b$export$7c6e2c02157bb7d2 = $7fPBF.forwardRef((o, r)=>{
    const t = $7fPBF.useContext($608da1f87bc1fe5b$var$f), { className: s, children: p, color: n, container: m, ...c } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)({
        size: t === null || t === void 0 ? void 0 : t.size,
        ...o
    }, {
        size: (0, $8aacb632f7d805c5$export$58dfb7f97f8eec9b).size
    }, (0, $8aacb632f7d805c5$export$375dc816459789a3)), S = (0, $fe07e27ecf0fa1d7$export$c4281ec44b929e6)(), T = n || S.accentColor;
    return $7fPBF.createElement($7cacca21c6f84773$export$602eac185826482c, {
        container: m
    }, $7fPBF.createElement((0, $fe07e27ecf0fa1d7$export$14faa19a0f3bbeb2), {
        asChild: !0
    }, $7fPBF.createElement($7cacca21c6f84773$export$7c6e2c02157bb7d2, {
        "data-accent-color": T,
        sideOffset: 4,
        ...c,
        asChild: !1,
        ref: r,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))({
            "rt-PopperContent": c.position === "popper"
        }, "rt-SelectContent", s)
    }, $7fPBF.createElement($25e27e390e2ae51e$export$be92b6f5f03c0fe9, {
        type: "auto",
        className: "rt-ScrollAreaRoot"
    }, $7fPBF.createElement($7cacca21c6f84773$export$d5c6c08dc2d3ca7, {
        asChild: !0,
        className: "rt-SelectViewport"
    }, $7fPBF.createElement($25e27e390e2ae51e$export$d5c6c08dc2d3ca7, {
        className: "rt-ScrollAreaViewport",
        style: {
            overflowY: void 0
        }
    }, p)), $7fPBF.createElement($25e27e390e2ae51e$export$9a4e88b92edfce6b, {
        className: "rt-ScrollAreaScrollbar rt-r-size-1",
        orientation: "vertical"
    }, $7fPBF.createElement($25e27e390e2ae51e$export$6521433ed15a34db, {
        className: "rt-ScrollAreaThumb"
    }))))));
});
$608da1f87bc1fe5b$export$7c6e2c02157bb7d2.displayName = "Select.Content";
const $608da1f87bc1fe5b$export$6d08773d2e66f8f2 = $7fPBF.forwardRef((o, r)=>{
    const { className: t, children: s, ...p } = o;
    return $7fPBF.createElement($7cacca21c6f84773$export$6d08773d2e66f8f2, {
        ...p,
        asChild: !1,
        ref: r,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-SelectItem", t)
    }, $7fPBF.createElement($7cacca21c6f84773$export$c3468e2714d175fa, {
        className: "rt-SelectItemIndicator"
    }, $7fPBF.createElement((0, $a0cf194253713caf$export$e8a6d0edce052b3e), {
        className: "rt-SelectItemIndicatorIcon"
    })), $7fPBF.createElement($7cacca21c6f84773$export$d6e5bf9c43ea9319, null, s));
});
$608da1f87bc1fe5b$export$6d08773d2e66f8f2.displayName = "Select.Item";
const $608da1f87bc1fe5b$export$eb2fcfdbd7ba97d4 = $7fPBF.forwardRef(({ className: o, ...r }, t)=>$7fPBF.createElement($7cacca21c6f84773$export$eb2fcfdbd7ba97d4, {
        ...r,
        asChild: !1,
        ref: t,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-SelectGroup", o)
    }));
$608da1f87bc1fe5b$export$eb2fcfdbd7ba97d4.displayName = "Select.Group";
const $608da1f87bc1fe5b$export$b04be29aa201d4f5 = $7fPBF.forwardRef(({ className: o, ...r }, t)=>$7fPBF.createElement($7cacca21c6f84773$export$b04be29aa201d4f5, {
        ...r,
        asChild: !1,
        ref: t,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-SelectLabel", o)
    }));
$608da1f87bc1fe5b$export$b04be29aa201d4f5.displayName = "Select.Label";
const $608da1f87bc1fe5b$export$1ff3c3f08ae963c0 = $7fPBF.forwardRef(({ className: o, ...r }, t)=>$7fPBF.createElement($7cacca21c6f84773$export$1ff3c3f08ae963c0, {
        ...r,
        asChild: !1,
        ref: t,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-SelectSeparator", o)
    }));
$608da1f87bc1fe5b$export$1ff3c3f08ae963c0.displayName = "Select.Separator";



var $7fPBF = parcelRequire("7fPBF");


const $f5761cdec1053935$var$e = [
    "horizontal",
    "vertical"
], $f5761cdec1053935$var$r = [
    "1",
    "2",
    "3",
    "4"
], $f5761cdec1053935$export$731bad63e72c8763 = {
    orientation: {
        type: "enum",
        className: "rt-r-orientation",
        values: $f5761cdec1053935$var$e,
        default: "horizontal",
        responsive: !0
    },
    size: {
        type: "enum",
        className: "rt-r-size",
        values: $f5761cdec1053935$var$r,
        default: "1",
        responsive: !0
    },
    color: {
        ...(0, $e914ebf2ce406d8c$export$8255b018f448be13).color,
        default: "gray"
    },
    decorative: {
        type: "boolean",
        default: !0
    }
};




const $589b7039d69bab54$export$1ff3c3f08ae963c0 = $7fPBF.forwardRef((p, e)=>{
    const { className: t, color: a, decorative: s, ...m } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(p, (0, $f5761cdec1053935$export$731bad63e72c8763), (0, $df06be8448ff4f3c$export$83503616c7a463e3));
    return $7fPBF.createElement("span", {
        "data-accent-color": a,
        role: s ? void 0 : "separator",
        ...m,
        ref: e,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-Separator", t)
    });
});
$589b7039d69bab54$export$1ff3c3f08ae963c0.displayName = "Separator";



var $7fPBF = parcelRequire("7fPBF");







const $3902685dd994178b$export$259e1d18ad76daa8 = {
    loading: {
        type: "boolean",
        default: !0
    },
    ...(0, $b6a742bf1f02ee7d$export$18e5dbe2c243731),
    ...(0, $a66fc9f2b041fa5d$export$e039c83f102b25e2)
};


const $f39b79cd48223c33$export$8f31e4c4a37b8e9c = $7fPBF.forwardRef((t, p)=>{
    const { children: e, className: n, loading: s, ...m } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(t, (0, $3902685dd994178b$export$259e1d18ad76daa8), (0, $df06be8448ff4f3c$export$83503616c7a463e3));
    if (!s) return e;
    const i = $7fPBF.isValidElement(e) ? (0, $089057084dfb92a4$export$8c6ed5c666ac1360) : "span";
    return $7fPBF.createElement(i, {
        ref: p,
        "aria-hidden": !0,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-Skeleton", n),
        "data-inline-skeleton": $7fPBF.isValidElement(e) ? void 0 : !0,
        tabIndex: -1,
        inert: (0, $18c8d007fcd48c4d$export$2780f85aa8ed0db8),
        ...m
    }, e);
});
$f39b79cd48223c33$export$8f31e4c4a37b8e9c.displayName = "Skeleton";



var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");











"use client";
var $2f6802a36674df6b$var$PAGE_KEYS = [
    "PageUp",
    "PageDown"
];
var $2f6802a36674df6b$var$ARROW_KEYS = [
    "ArrowUp",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight"
];
var $2f6802a36674df6b$var$BACK_KEYS = {
    "from-left": [
        "Home",
        "PageDown",
        "ArrowDown",
        "ArrowLeft"
    ],
    "from-right": [
        "Home",
        "PageDown",
        "ArrowDown",
        "ArrowRight"
    ],
    "from-bottom": [
        "Home",
        "PageDown",
        "ArrowDown",
        "ArrowLeft"
    ],
    "from-top": [
        "Home",
        "PageDown",
        "ArrowUp",
        "ArrowLeft"
    ]
};
var $2f6802a36674df6b$var$SLIDER_NAME = "Slider";
var [$2f6802a36674df6b$var$Collection, $2f6802a36674df6b$var$useCollection, $2f6802a36674df6b$var$createCollectionScope] = (0, $08a94ba50b5cc249$export$c74125a8e3af6bb2)($2f6802a36674df6b$var$SLIDER_NAME);
var [$2f6802a36674df6b$var$createSliderContext, $2f6802a36674df6b$export$ef72632d7b901f97] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)($2f6802a36674df6b$var$SLIDER_NAME, [
    $2f6802a36674df6b$var$createCollectionScope
]);
var [$2f6802a36674df6b$var$SliderProvider, $2f6802a36674df6b$var$useSliderContext] = $2f6802a36674df6b$var$createSliderContext($2f6802a36674df6b$var$SLIDER_NAME);
var $2f6802a36674df6b$export$472062a354075cee = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { name: name, min: min = 0, max: max = 100, step: step = 1, orientation: orientation = "horizontal", disabled: disabled = false, minStepsBetweenThumbs: minStepsBetweenThumbs = 0, defaultValue: defaultValue = [
        min
    ], value: value, onValueChange: onValueChange = ()=>{}, onValueCommit: onValueCommit = ()=>{}, inverted: inverted = false, ...sliderProps } = props;
    const thumbRefs = $7fPBF.useRef(/* @__PURE__ */ new Set());
    const valueIndexToChangeRef = $7fPBF.useRef(0);
    const isHorizontal = orientation === "horizontal";
    const SliderOrientation = isHorizontal ? $2f6802a36674df6b$var$SliderHorizontal : $2f6802a36674df6b$var$SliderVertical;
    const [values = [], setValues] = (0, $915387e6ab4d88b1$export$6f32135080cb4c3)({
        prop: value,
        defaultProp: defaultValue,
        onChange: (value2)=>{
            var _thumbs_valueIndexToChangeRef_current;
            const thumbs = [
                ...thumbRefs.current
            ];
            (_thumbs_valueIndexToChangeRef_current = thumbs[valueIndexToChangeRef.current]) === null || _thumbs_valueIndexToChangeRef_current === void 0 ? void 0 : _thumbs_valueIndexToChangeRef_current.focus();
            onValueChange(value2);
        }
    });
    const valuesBeforeSlideStartRef = $7fPBF.useRef(values);
    function handleSlideStart(value2) {
        const closestIndex = $2f6802a36674df6b$var$getClosestValueIndex(values, value2);
        updateValues(value2, closestIndex);
    }
    function handleSlideMove(value2) {
        updateValues(value2, valueIndexToChangeRef.current);
    }
    function handleSlideEnd() {
        const prevValue = valuesBeforeSlideStartRef.current[valueIndexToChangeRef.current];
        const nextValue = values[valueIndexToChangeRef.current];
        const hasChanged = nextValue !== prevValue;
        if (hasChanged) onValueCommit(values);
    }
    function updateValues(value2, atIndex, { commit: commit } = {
        commit: false
    }) {
        const decimalCount = $2f6802a36674df6b$var$getDecimalCount(step);
        const snapToStep = $2f6802a36674df6b$var$roundValue(Math.round((value2 - min) / step) * step + min, decimalCount);
        const nextValue = (0, $6d53081595419ec4$export$7d15b64cf5a3a4c4)(snapToStep, [
            min,
            max
        ]);
        setValues((prevValues = [])=>{
            const nextValues = $2f6802a36674df6b$var$getNextSortedValues(prevValues, nextValue, atIndex);
            if ($2f6802a36674df6b$var$hasMinStepsBetweenValues(nextValues, minStepsBetweenThumbs * step)) {
                valueIndexToChangeRef.current = nextValues.indexOf(nextValue);
                const hasChanged = String(nextValues) !== String(prevValues);
                if (hasChanged && commit) onValueCommit(nextValues);
                return hasChanged ? nextValues : prevValues;
            } else return prevValues;
        });
    }
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($2f6802a36674df6b$var$SliderProvider, {
        scope: props.__scopeSlider,
        name: name,
        disabled: disabled,
        min: min,
        max: max,
        valueIndexToChangeRef: valueIndexToChangeRef,
        thumbs: thumbRefs.current,
        values: values,
        orientation: orientation,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($2f6802a36674df6b$var$Collection.Provider, {
            scope: props.__scopeSlider,
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($2f6802a36674df6b$var$Collection.Slot, {
                scope: props.__scopeSlider,
                children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(SliderOrientation, {
                    "aria-disabled": disabled,
                    "data-disabled": disabled ? "" : void 0,
                    ...sliderProps,
                    ref: forwardedRef,
                    onPointerDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(sliderProps.onPointerDown, ()=>{
                        if (!disabled) valuesBeforeSlideStartRef.current = values;
                    }),
                    min: min,
                    max: max,
                    inverted: inverted,
                    onSlideStart: disabled ? void 0 : handleSlideStart,
                    onSlideMove: disabled ? void 0 : handleSlideMove,
                    onSlideEnd: disabled ? void 0 : handleSlideEnd,
                    onHomeKeyDown: ()=>!disabled && updateValues(min, 0, {
                            commit: true
                        }),
                    onEndKeyDown: ()=>!disabled && updateValues(max, values.length - 1, {
                            commit: true
                        }),
                    onStepKeyDown: ({ event: event, direction: stepDirection })=>{
                        if (!disabled) {
                            const isPageKey = $2f6802a36674df6b$var$PAGE_KEYS.includes(event.key);
                            const isSkipKey = isPageKey || event.shiftKey && $2f6802a36674df6b$var$ARROW_KEYS.includes(event.key);
                            const multiplier = isSkipKey ? 10 : 1;
                            const atIndex = valueIndexToChangeRef.current;
                            const value2 = values[atIndex];
                            const stepInDirection = step * multiplier * stepDirection;
                            updateValues(value2 + stepInDirection, atIndex, {
                                commit: true
                            });
                        }
                    }
                })
            })
        })
    });
});
$2f6802a36674df6b$export$472062a354075cee.displayName = $2f6802a36674df6b$var$SLIDER_NAME;
var [$2f6802a36674df6b$var$SliderOrientationProvider, $2f6802a36674df6b$var$useSliderOrientationContext] = $2f6802a36674df6b$var$createSliderContext($2f6802a36674df6b$var$SLIDER_NAME, {
    startEdge: "left",
    endEdge: "right",
    size: "width",
    direction: 1
});
var $2f6802a36674df6b$var$SliderHorizontal = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { min: min, max: max, dir: dir, inverted: inverted, onSlideStart: onSlideStart, onSlideMove: onSlideMove, onSlideEnd: onSlideEnd, onStepKeyDown: onStepKeyDown, ...sliderProps } = props;
    const [slider, setSlider] = $7fPBF.useState(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setSlider(node));
    const rectRef = $7fPBF.useRef();
    const direction = (0, $3342477e04611d10$export$b39126d51d94e6f3)(dir);
    const isDirectionLTR = direction === "ltr";
    const isSlidingFromLeft = isDirectionLTR && !inverted || !isDirectionLTR && inverted;
    function getValueFromPointer(pointerPosition) {
        const rect = rectRef.current || slider.getBoundingClientRect();
        const input = [
            0,
            rect.width
        ];
        const output = isSlidingFromLeft ? [
            min,
            max
        ] : [
            max,
            min
        ];
        const value = $2f6802a36674df6b$var$linearScale(input, output);
        rectRef.current = rect;
        return value(pointerPosition - rect.left);
    }
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($2f6802a36674df6b$var$SliderOrientationProvider, {
        scope: props.__scopeSlider,
        startEdge: isSlidingFromLeft ? "left" : "right",
        endEdge: isSlidingFromLeft ? "right" : "left",
        direction: isSlidingFromLeft ? 1 : -1,
        size: "width",
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($2f6802a36674df6b$var$SliderImpl, {
            dir: direction,
            "data-orientation": "horizontal",
            ...sliderProps,
            ref: composedRefs,
            style: {
                ...sliderProps.style,
                ["--radix-slider-thumb-transform"]: "translateX(-50%)"
            },
            onSlideStart: (event)=>{
                const value = getValueFromPointer(event.clientX);
                onSlideStart === null || onSlideStart === void 0 ? void 0 : onSlideStart(value);
            },
            onSlideMove: (event)=>{
                const value = getValueFromPointer(event.clientX);
                onSlideMove === null || onSlideMove === void 0 ? void 0 : onSlideMove(value);
            },
            onSlideEnd: ()=>{
                rectRef.current = void 0;
                onSlideEnd === null || onSlideEnd === void 0 ? void 0 : onSlideEnd();
            },
            onStepKeyDown: (event)=>{
                const slideDirection = isSlidingFromLeft ? "from-left" : "from-right";
                const isBackKey = $2f6802a36674df6b$var$BACK_KEYS[slideDirection].includes(event.key);
                onStepKeyDown === null || onStepKeyDown === void 0 ? void 0 : onStepKeyDown({
                    event: event,
                    direction: isBackKey ? -1 : 1
                });
            }
        })
    });
});
var $2f6802a36674df6b$var$SliderVertical = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { min: min, max: max, inverted: inverted, onSlideStart: onSlideStart, onSlideMove: onSlideMove, onSlideEnd: onSlideEnd, onStepKeyDown: onStepKeyDown, ...sliderProps } = props;
    const sliderRef = $7fPBF.useRef(null);
    const ref = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, sliderRef);
    const rectRef = $7fPBF.useRef();
    const isSlidingFromBottom = !inverted;
    function getValueFromPointer(pointerPosition) {
        const rect = rectRef.current || sliderRef.current.getBoundingClientRect();
        const input = [
            0,
            rect.height
        ];
        const output = isSlidingFromBottom ? [
            max,
            min
        ] : [
            min,
            max
        ];
        const value = $2f6802a36674df6b$var$linearScale(input, output);
        rectRef.current = rect;
        return value(pointerPosition - rect.top);
    }
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($2f6802a36674df6b$var$SliderOrientationProvider, {
        scope: props.__scopeSlider,
        startEdge: isSlidingFromBottom ? "bottom" : "top",
        endEdge: isSlidingFromBottom ? "top" : "bottom",
        size: "height",
        direction: isSlidingFromBottom ? 1 : -1,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($2f6802a36674df6b$var$SliderImpl, {
            "data-orientation": "vertical",
            ...sliderProps,
            ref: ref,
            style: {
                ...sliderProps.style,
                ["--radix-slider-thumb-transform"]: "translateY(50%)"
            },
            onSlideStart: (event)=>{
                const value = getValueFromPointer(event.clientY);
                onSlideStart === null || onSlideStart === void 0 ? void 0 : onSlideStart(value);
            },
            onSlideMove: (event)=>{
                const value = getValueFromPointer(event.clientY);
                onSlideMove === null || onSlideMove === void 0 ? void 0 : onSlideMove(value);
            },
            onSlideEnd: ()=>{
                rectRef.current = void 0;
                onSlideEnd === null || onSlideEnd === void 0 ? void 0 : onSlideEnd();
            },
            onStepKeyDown: (event)=>{
                const slideDirection = isSlidingFromBottom ? "from-bottom" : "from-top";
                const isBackKey = $2f6802a36674df6b$var$BACK_KEYS[slideDirection].includes(event.key);
                onStepKeyDown === null || onStepKeyDown === void 0 ? void 0 : onStepKeyDown({
                    event: event,
                    direction: isBackKey ? -1 : 1
                });
            }
        })
    });
});
var $2f6802a36674df6b$var$SliderImpl = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeSlider: __scopeSlider, onSlideStart: onSlideStart, onSlideMove: onSlideMove, onSlideEnd: onSlideEnd, onHomeKeyDown: onHomeKeyDown, onEndKeyDown: onEndKeyDown, onStepKeyDown: onStepKeyDown, ...sliderProps } = props;
    const context = $2f6802a36674df6b$var$useSliderContext($2f6802a36674df6b$var$SLIDER_NAME, __scopeSlider);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).span, {
        ...sliderProps,
        ref: forwardedRef,
        onKeyDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            if (event.key === "Home") {
                onHomeKeyDown(event);
                event.preventDefault();
            } else if (event.key === "End") {
                onEndKeyDown(event);
                event.preventDefault();
            } else if ($2f6802a36674df6b$var$PAGE_KEYS.concat($2f6802a36674df6b$var$ARROW_KEYS).includes(event.key)) {
                onStepKeyDown(event);
                event.preventDefault();
            }
        }),
        onPointerDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerDown, (event)=>{
            const target = event.target;
            target.setPointerCapture(event.pointerId);
            event.preventDefault();
            if (context.thumbs.has(target)) target.focus();
            else onSlideStart(event);
        }),
        onPointerMove: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerMove, (event)=>{
            const target = event.target;
            if (target.hasPointerCapture(event.pointerId)) onSlideMove(event);
        }),
        onPointerUp: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerUp, (event)=>{
            const target = event.target;
            if (target.hasPointerCapture(event.pointerId)) {
                target.releasePointerCapture(event.pointerId);
                onSlideEnd(event);
            }
        })
    });
});
var $2f6802a36674df6b$var$TRACK_NAME = "SliderTrack";
var $2f6802a36674df6b$export$105594979f116971 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeSlider: __scopeSlider, ...trackProps } = props;
    const context = $2f6802a36674df6b$var$useSliderContext($2f6802a36674df6b$var$TRACK_NAME, __scopeSlider);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).span, {
        "data-disabled": context.disabled ? "" : void 0,
        "data-orientation": context.orientation,
        ...trackProps,
        ref: forwardedRef
    });
});
$2f6802a36674df6b$export$105594979f116971.displayName = $2f6802a36674df6b$var$TRACK_NAME;
var $2f6802a36674df6b$var$RANGE_NAME = "SliderRange";
var $2f6802a36674df6b$export$a5cf38a7a000fe77 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeSlider: __scopeSlider, ...rangeProps } = props;
    const context = $2f6802a36674df6b$var$useSliderContext($2f6802a36674df6b$var$RANGE_NAME, __scopeSlider);
    const orientation = $2f6802a36674df6b$var$useSliderOrientationContext($2f6802a36674df6b$var$RANGE_NAME, __scopeSlider);
    const ref = $7fPBF.useRef(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const valuesCount = context.values.length;
    const percentages = context.values.map((value)=>$2f6802a36674df6b$var$convertValueToPercentage(value, context.min, context.max));
    const offsetStart = valuesCount > 1 ? Math.min(...percentages) : 0;
    const offsetEnd = 100 - Math.max(...percentages);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).span, {
        "data-orientation": context.orientation,
        "data-disabled": context.disabled ? "" : void 0,
        ...rangeProps,
        ref: composedRefs,
        style: {
            ...props.style,
            [orientation.startEdge]: offsetStart + "%",
            [orientation.endEdge]: offsetEnd + "%"
        }
    });
});
$2f6802a36674df6b$export$a5cf38a7a000fe77.displayName = $2f6802a36674df6b$var$RANGE_NAME;
var $2f6802a36674df6b$var$THUMB_NAME = "SliderThumb";
var $2f6802a36674df6b$export$2c1b491743890dec = $7fPBF.forwardRef((props, forwardedRef)=>{
    const getItems = $2f6802a36674df6b$var$useCollection(props.__scopeSlider);
    const [thumb, setThumb] = $7fPBF.useState(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setThumb(node));
    const index = $7fPBF.useMemo(()=>thumb ? getItems().findIndex((item)=>item.ref.current === thumb) : -1, [
        getItems,
        thumb
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($2f6802a36674df6b$var$SliderThumbImpl, {
        ...props,
        ref: composedRefs,
        index: index
    });
});
var $2f6802a36674df6b$var$SliderThumbImpl = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeSlider: __scopeSlider, index: index, name: name, ...thumbProps } = props;
    const context = $2f6802a36674df6b$var$useSliderContext($2f6802a36674df6b$var$THUMB_NAME, __scopeSlider);
    const orientation = $2f6802a36674df6b$var$useSliderOrientationContext($2f6802a36674df6b$var$THUMB_NAME, __scopeSlider);
    const [thumb, setThumb] = $7fPBF.useState(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setThumb(node));
    const isFormControl = thumb ? Boolean(thumb.closest("form")) : true;
    const size = (0, $0560b0618278acc0$export$1ab7ae714698c4b8)(thumb);
    const value = context.values[index];
    const percent = value === void 0 ? 0 : $2f6802a36674df6b$var$convertValueToPercentage(value, context.min, context.max);
    const label = $2f6802a36674df6b$var$getLabel(index, context.values.length);
    const orientationSize = size === null || size === void 0 ? void 0 : size[orientation.size];
    const thumbInBoundsOffset = orientationSize ? $2f6802a36674df6b$var$getThumbInBoundsOffset(orientationSize, percent, orientation.direction) : 0;
    $7fPBF.useEffect(()=>{
        if (thumb) {
            context.thumbs.add(thumb);
            return ()=>{
                context.thumbs.delete(thumb);
            };
        }
    }, [
        thumb,
        context.thumbs
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)("span", {
        style: {
            transform: "var(--radix-slider-thumb-transform)",
            position: "absolute",
            [orientation.startEdge]: `calc(${percent}% + ${thumbInBoundsOffset}px)`
        },
        children: [
            /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($2f6802a36674df6b$var$Collection.ItemSlot, {
                scope: props.__scopeSlider,
                children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).span, {
                    role: "slider",
                    "aria-label": props["aria-label"] || label,
                    "aria-valuemin": context.min,
                    "aria-valuenow": value,
                    "aria-valuemax": context.max,
                    "aria-orientation": context.orientation,
                    "data-orientation": context.orientation,
                    "data-disabled": context.disabled ? "" : void 0,
                    tabIndex: context.disabled ? void 0 : 0,
                    ...thumbProps,
                    ref: composedRefs,
                    style: value === void 0 ? {
                        display: "none"
                    } : props.style,
                    onFocus: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onFocus, ()=>{
                        context.valueIndexToChangeRef.current = index;
                    })
                })
            }),
            isFormControl && /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($2f6802a36674df6b$var$BubbleInput, {
                name: name !== null && name !== void 0 ? name : context.name ? context.name + (context.values.length > 1 ? "[]" : "") : void 0,
                value: value
            }, index)
        ]
    });
});
$2f6802a36674df6b$export$2c1b491743890dec.displayName = $2f6802a36674df6b$var$THUMB_NAME;
var $2f6802a36674df6b$var$BubbleInput = (props)=>{
    const { value: value, ...inputProps } = props;
    const ref = $7fPBF.useRef(null);
    const prevValue = (0, $62f6e650b37fb598$export$5cae361ad82dce8b)(value);
    $7fPBF.useEffect(()=>{
        const input = ref.current;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "value");
        const setValue = descriptor.set;
        if (prevValue !== value && setValue) {
            const event = new Event("input", {
                bubbles: true
            });
            setValue.call(input, value);
            input.dispatchEvent(event);
        }
    }, [
        prevValue,
        value
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("input", {
        style: {
            display: "none"
        },
        ...inputProps,
        ref: ref,
        defaultValue: value
    });
};
function $2f6802a36674df6b$var$getNextSortedValues(prevValues = [], nextValue, atIndex) {
    const nextValues = [
        ...prevValues
    ];
    nextValues[atIndex] = nextValue;
    return nextValues.sort((a, b)=>a - b);
}
function $2f6802a36674df6b$var$convertValueToPercentage(value, min, max) {
    const maxSteps = max - min;
    const percentPerStep = 100 / maxSteps;
    const percentage = percentPerStep * (value - min);
    return (0, $6d53081595419ec4$export$7d15b64cf5a3a4c4)(percentage, [
        0,
        100
    ]);
}
function $2f6802a36674df6b$var$getLabel(index, totalValues) {
    if (totalValues > 2) return `Value ${index + 1} of ${totalValues}`;
    else if (totalValues === 2) return [
        "Minimum",
        "Maximum"
    ][index];
    else return void 0;
}
function $2f6802a36674df6b$var$getClosestValueIndex(values, nextValue) {
    if (values.length === 1) return 0;
    const distances = values.map((value)=>Math.abs(value - nextValue));
    const closestDistance = Math.min(...distances);
    return distances.indexOf(closestDistance);
}
function $2f6802a36674df6b$var$getThumbInBoundsOffset(width, left, direction) {
    const halfWidth = width / 2;
    const halfPercent = 50;
    const offset = $2f6802a36674df6b$var$linearScale([
        0,
        halfPercent
    ], [
        0,
        halfWidth
    ]);
    return (halfWidth - offset(left) * direction) * direction;
}
function $2f6802a36674df6b$var$getStepsBetweenValues(values) {
    return values.slice(0, -1).map((value, index)=>values[index + 1] - value);
}
function $2f6802a36674df6b$var$hasMinStepsBetweenValues(values, minStepsBetweenValues) {
    if (minStepsBetweenValues > 0) {
        const stepsBetweenValues = $2f6802a36674df6b$var$getStepsBetweenValues(values);
        const actualMinStepsBetweenValues = Math.min(...stepsBetweenValues);
        return actualMinStepsBetweenValues >= minStepsBetweenValues;
    }
    return true;
}
function $2f6802a36674df6b$var$linearScale(input, output) {
    return (value)=>{
        if (input[0] === input[1] || output[0] === output[1]) return output[0];
        const ratio = (output[1] - output[0]) / (input[1] - input[0]);
        return output[0] + ratio * (value - input[0]);
    };
}
function $2f6802a36674df6b$var$getDecimalCount(value) {
    return (String(value).split(".")[1] || "").length;
}
function $2f6802a36674df6b$var$roundValue(value, decimalCount) {
    const rounder = Math.pow(10, decimalCount);
    return Math.round(value * rounder) / rounder;
}
var $2f6802a36674df6b$export$be92b6f5f03c0fe9 = $2f6802a36674df6b$export$472062a354075cee;
var $2f6802a36674df6b$export$13921ac0cc260818 = $2f6802a36674df6b$export$105594979f116971;
var $2f6802a36674df6b$export$9a58ef0d7ad3278c = $2f6802a36674df6b$export$a5cf38a7a000fe77;
var $2f6802a36674df6b$export$6521433ed15a34db = $2f6802a36674df6b$export$2c1b491743890dec;





const $baae7cc38c72e2f2$var$o = [
    "1",
    "2",
    "3"
], $baae7cc38c72e2f2$var$t = [
    "classic",
    "surface",
    "soft"
], $baae7cc38c72e2f2$export$38aed91363d8d0ba = {
    size: {
        type: "enum",
        className: "rt-r-size",
        values: $baae7cc38c72e2f2$var$o,
        default: "2",
        responsive: !0
    },
    variant: {
        type: "enum",
        className: "rt-variant",
        values: $baae7cc38c72e2f2$var$t,
        default: "surface"
    },
    ...(0, $e914ebf2ce406d8c$export$8255b018f448be13),
    ...(0, $f41c61290c2a7125$export$2f84412d299def33),
    ...(0, $3d20a83f81464c0a$export$c467f6769b59b70c)
};




const $3f72ca6b570d3f0a$export$472062a354075cee = $7fPBF.forwardRef((i, a)=>{
    const { className: d, color: l, radius: m, tabIndex: t, ...r } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(i, (0, $baae7cc38c72e2f2$export$38aed91363d8d0ba), (0, $df06be8448ff4f3c$export$83503616c7a463e3));
    var _r_value, _ref;
    return $7fPBF.createElement($2f6802a36674df6b$export$be92b6f5f03c0fe9, {
        "data-accent-color": l,
        "data-radius": m,
        ref: a,
        ...r,
        asChild: !1,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-SliderRoot", d)
    }, $7fPBF.createElement($2f6802a36674df6b$export$13921ac0cc260818, {
        className: "rt-SliderTrack"
    }, $7fPBF.createElement($2f6802a36674df6b$export$9a58ef0d7ad3278c, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-SliderRange", {
            "rt-high-contrast": i.highContrast
        }),
        "data-inverted": r.inverted ? "" : void 0
    })), ((_ref = (_r_value = r.value) !== null && _r_value !== void 0 ? _r_value : r.defaultValue) !== null && _ref !== void 0 ? _ref : []).map((S, n)=>$7fPBF.createElement($2f6802a36674df6b$export$6521433ed15a34db, {
            key: n,
            className: "rt-SliderThumb",
            ...t !== void 0 ? {
                tabIndex: t
            } : void 0
        })));
});
$3f72ca6b570d3f0a$export$472062a354075cee.displayName = "Slider";





var $7fPBF = parcelRequire("7fPBF");






const $cc625667a735b9d6$export$ab71030b3cc9d78e = {
    ...(0, $b302dbddfdac9d75$export$1e7c0b54c65e0280),
    ...(0, $2c64e4634b053e6a$export$b51caa9f475eecbe),
    ...(0, $738dfabf5e38f576$export$d1dbebac82aee34d)
};


const $842de530bb5b7a94$export$f301627d437cff88 = $7fPBF.forwardRef((t, e)=>{
    const { asChild: p, className: s, ...n } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(t, (0, $cc625667a735b9d6$export$ab71030b3cc9d78e));
    return $7fPBF.createElement(p ? (0, $089057084dfb92a4$export$8c6ed5c666ac1360) : "strong", {
        ...n,
        ref: e,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-Strong", s)
    });
});
$842de530bb5b7a94$export$f301627d437cff88.displayName = "Strong";



var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");








"use client";
var $6b25d42c112352bd$var$SWITCH_NAME = "Switch";
var [$6b25d42c112352bd$var$createSwitchContext, $6b25d42c112352bd$export$cf7f5f17f69cbd43] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)($6b25d42c112352bd$var$SWITCH_NAME);
var [$6b25d42c112352bd$var$SwitchProvider, $6b25d42c112352bd$var$useSwitchContext] = $6b25d42c112352bd$var$createSwitchContext($6b25d42c112352bd$var$SWITCH_NAME);
var $6b25d42c112352bd$export$b5d5cf8927ab7262 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeSwitch: __scopeSwitch, name: name, checked: checkedProp, defaultChecked: defaultChecked, required: required, disabled: disabled, value: value = "on", onCheckedChange: onCheckedChange, ...switchProps } = props;
    const [button, setButton] = $7fPBF.useState(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setButton(node));
    const hasConsumerStoppedPropagationRef = $7fPBF.useRef(false);
    const isFormControl = button ? Boolean(button.closest("form")) : true;
    const [checked = false, setChecked] = (0, $915387e6ab4d88b1$export$6f32135080cb4c3)({
        prop: checkedProp,
        defaultProp: defaultChecked,
        onChange: onCheckedChange
    });
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)($6b25d42c112352bd$var$SwitchProvider, {
        scope: __scopeSwitch,
        checked: checked,
        disabled: disabled,
        children: [
            /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).button, {
                type: "button",
                role: "switch",
                "aria-checked": checked,
                "aria-required": required,
                "data-state": $6b25d42c112352bd$var$getState(checked),
                "data-disabled": disabled ? "" : void 0,
                disabled: disabled,
                value: value,
                ...switchProps,
                ref: composedRefs,
                onClick: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onClick, (event)=>{
                    setChecked((prevChecked)=>!prevChecked);
                    if (isFormControl) {
                        hasConsumerStoppedPropagationRef.current = event.isPropagationStopped();
                        if (!hasConsumerStoppedPropagationRef.current) event.stopPropagation();
                    }
                })
            }),
            isFormControl && /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($6b25d42c112352bd$var$BubbleInput, {
                control: button,
                bubbles: !hasConsumerStoppedPropagationRef.current,
                name: name,
                value: value,
                checked: checked,
                required: required,
                disabled: disabled,
                style: {
                    transform: "translateX(-100%)"
                }
            })
        ]
    });
});
$6b25d42c112352bd$export$b5d5cf8927ab7262.displayName = $6b25d42c112352bd$var$SWITCH_NAME;
var $6b25d42c112352bd$var$THUMB_NAME = "SwitchThumb";
var $6b25d42c112352bd$export$4d07bf653ea69106 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeSwitch: __scopeSwitch, ...thumbProps } = props;
    const context = $6b25d42c112352bd$var$useSwitchContext($6b25d42c112352bd$var$THUMB_NAME, __scopeSwitch);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).span, {
        "data-state": $6b25d42c112352bd$var$getState(context.checked),
        "data-disabled": context.disabled ? "" : void 0,
        ...thumbProps,
        ref: forwardedRef
    });
});
$6b25d42c112352bd$export$4d07bf653ea69106.displayName = $6b25d42c112352bd$var$THUMB_NAME;
var $6b25d42c112352bd$var$BubbleInput = (props)=>{
    const { control: control, checked: checked, bubbles: bubbles = true, ...inputProps } = props;
    const ref = $7fPBF.useRef(null);
    const prevChecked = (0, $62f6e650b37fb598$export$5cae361ad82dce8b)(checked);
    const controlSize = (0, $0560b0618278acc0$export$1ab7ae714698c4b8)(control);
    $7fPBF.useEffect(()=>{
        const input = ref.current;
        const inputProto = window.HTMLInputElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(inputProto, "checked");
        const setChecked = descriptor.set;
        if (prevChecked !== checked && setChecked) {
            const event = new Event("click", {
                bubbles: bubbles
            });
            setChecked.call(input, checked);
            input.dispatchEvent(event);
        }
    }, [
        prevChecked,
        checked,
        bubbles
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("input", {
        type: "checkbox",
        "aria-hidden": true,
        defaultChecked: checked,
        ...inputProps,
        tabIndex: -1,
        ref: ref,
        style: {
            ...props.style,
            ...controlSize,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0
        }
    });
};
function $6b25d42c112352bd$var$getState(checked) {
    return checked ? "checked" : "unchecked";
}
var $6b25d42c112352bd$export$be92b6f5f03c0fe9 = $6b25d42c112352bd$export$b5d5cf8927ab7262;
var $6b25d42c112352bd$export$6521433ed15a34db = $6b25d42c112352bd$export$4d07bf653ea69106;







const $5eb3eda75a4fba36$var$o = [
    "1",
    "2",
    "3"
], $5eb3eda75a4fba36$var$t = [
    "classic",
    "surface",
    "soft"
], $5eb3eda75a4fba36$export$4979e84a09636a44 = {
    size: {
        type: "enum",
        className: "rt-r-size",
        values: $5eb3eda75a4fba36$var$o,
        default: "2",
        responsive: !0
    },
    variant: {
        type: "enum",
        className: "rt-variant",
        values: $5eb3eda75a4fba36$var$t,
        default: "surface"
    },
    ...(0, $e914ebf2ce406d8c$export$8255b018f448be13),
    ...(0, $f41c61290c2a7125$export$2f84412d299def33),
    ...(0, $3d20a83f81464c0a$export$c467f6769b59b70c)
};


const $901c8ad894d4a6c1$export$b5d5cf8927ab7262 = $7fPBF.forwardRef((o, p)=>{
    const { className: s, color: m, radius: c, ...a } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(o, (0, $5eb3eda75a4fba36$export$4979e84a09636a44), (0, $df06be8448ff4f3c$export$83503616c7a463e3));
    return $7fPBF.createElement($6b25d42c112352bd$export$be92b6f5f03c0fe9, {
        "data-accent-color": m,
        "data-radius": c,
        ...a,
        asChild: !1,
        ref: p,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-reset", "rt-SwitchRoot", s)
    }, $7fPBF.createElement($6b25d42c112352bd$export$6521433ed15a34db, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-SwitchThumb", {
            "rt-high-contrast": o.highContrast
        })
    }));
});
$901c8ad894d4a6c1$export$b5d5cf8927ab7262.displayName = "Switch";



var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
















"use client";
var $851416859f33009f$var$NAVIGATION_MENU_NAME = "NavigationMenu";
var [$851416859f33009f$var$Collection, $851416859f33009f$var$useCollection, $851416859f33009f$var$createCollectionScope] = (0, $08a94ba50b5cc249$export$c74125a8e3af6bb2)($851416859f33009f$var$NAVIGATION_MENU_NAME);
var [$851416859f33009f$var$FocusGroupCollection, $851416859f33009f$var$useFocusGroupCollection, $851416859f33009f$var$createFocusGroupCollectionScope] = (0, $08a94ba50b5cc249$export$c74125a8e3af6bb2)($851416859f33009f$var$NAVIGATION_MENU_NAME);
var [$851416859f33009f$var$createNavigationMenuContext, $851416859f33009f$export$fb8ea5af8c9fcdf0] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)($851416859f33009f$var$NAVIGATION_MENU_NAME, [
    $851416859f33009f$var$createCollectionScope,
    $851416859f33009f$var$createFocusGroupCollectionScope
]);
var [$851416859f33009f$var$NavigationMenuProviderImpl, $851416859f33009f$var$useNavigationMenuContext] = $851416859f33009f$var$createNavigationMenuContext($851416859f33009f$var$NAVIGATION_MENU_NAME);
var [$851416859f33009f$var$ViewportContentProvider, $851416859f33009f$var$useViewportContentContext] = $851416859f33009f$var$createNavigationMenuContext($851416859f33009f$var$NAVIGATION_MENU_NAME);
var $851416859f33009f$export$5b2278cf1e8bcae2 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeNavigationMenu: __scopeNavigationMenu, value: valueProp, onValueChange: onValueChange, defaultValue: defaultValue, delayDuration: delayDuration = 200, skipDelayDuration: skipDelayDuration = 300, orientation: orientation = "horizontal", dir: dir, ...NavigationMenuProps } = props;
    const [navigationMenu, setNavigationMenu] = $7fPBF.useState(null);
    const composedRef = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setNavigationMenu(node));
    const direction = (0, $3342477e04611d10$export$b39126d51d94e6f3)(dir);
    const openTimerRef = $7fPBF.useRef(0);
    const closeTimerRef = $7fPBF.useRef(0);
    const skipDelayTimerRef = $7fPBF.useRef(0);
    const [isOpenDelayed, setIsOpenDelayed] = $7fPBF.useState(true);
    const [value = "", setValue] = (0, $915387e6ab4d88b1$export$6f32135080cb4c3)({
        prop: valueProp,
        onChange: (value2)=>{
            const isOpen = value2 !== "";
            const hasSkipDelayDuration = skipDelayDuration > 0;
            if (isOpen) {
                window.clearTimeout(skipDelayTimerRef.current);
                if (hasSkipDelayDuration) setIsOpenDelayed(false);
            } else {
                window.clearTimeout(skipDelayTimerRef.current);
                skipDelayTimerRef.current = window.setTimeout(()=>setIsOpenDelayed(true), skipDelayDuration);
            }
            onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(value2);
        },
        defaultProp: defaultValue
    });
    const startCloseTimer = $7fPBF.useCallback(()=>{
        window.clearTimeout(closeTimerRef.current);
        closeTimerRef.current = window.setTimeout(()=>setValue(""), 150);
    }, [
        setValue
    ]);
    const handleOpen = $7fPBF.useCallback((itemValue)=>{
        window.clearTimeout(closeTimerRef.current);
        setValue(itemValue);
    }, [
        setValue
    ]);
    const handleDelayedOpen = $7fPBF.useCallback((itemValue)=>{
        const isOpenItem = value === itemValue;
        if (isOpenItem) window.clearTimeout(closeTimerRef.current);
        else openTimerRef.current = window.setTimeout(()=>{
            window.clearTimeout(closeTimerRef.current);
            setValue(itemValue);
        }, delayDuration);
    }, [
        value,
        setValue,
        delayDuration
    ]);
    $7fPBF.useEffect(()=>{
        return ()=>{
            window.clearTimeout(openTimerRef.current);
            window.clearTimeout(closeTimerRef.current);
            window.clearTimeout(skipDelayTimerRef.current);
        };
    }, []);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($851416859f33009f$var$NavigationMenuProvider, {
        scope: __scopeNavigationMenu,
        isRootMenu: true,
        value: value,
        dir: direction,
        orientation: orientation,
        rootNavigationMenu: navigationMenu,
        onTriggerEnter: (itemValue)=>{
            window.clearTimeout(openTimerRef.current);
            if (isOpenDelayed) handleDelayedOpen(itemValue);
            else handleOpen(itemValue);
        },
        onTriggerLeave: ()=>{
            window.clearTimeout(openTimerRef.current);
            startCloseTimer();
        },
        onContentEnter: ()=>window.clearTimeout(closeTimerRef.current),
        onContentLeave: startCloseTimer,
        onItemSelect: (itemValue)=>{
            setValue((prevValue)=>prevValue === itemValue ? "" : itemValue);
        },
        onItemDismiss: ()=>setValue(""),
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).nav, {
            "aria-label": "Main",
            "data-orientation": orientation,
            dir: direction,
            ...NavigationMenuProps,
            ref: composedRef
        })
    });
});
$851416859f33009f$export$5b2278cf1e8bcae2.displayName = $851416859f33009f$var$NAVIGATION_MENU_NAME;
var $851416859f33009f$var$SUB_NAME = "NavigationMenuSub";
var $851416859f33009f$export$5958edd6c4ee7c79 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeNavigationMenu: __scopeNavigationMenu, value: valueProp, onValueChange: onValueChange, defaultValue: defaultValue, orientation: orientation = "horizontal", ...subProps } = props;
    const context = $851416859f33009f$var$useNavigationMenuContext($851416859f33009f$var$SUB_NAME, __scopeNavigationMenu);
    const [value = "", setValue] = (0, $915387e6ab4d88b1$export$6f32135080cb4c3)({
        prop: valueProp,
        onChange: onValueChange,
        defaultProp: defaultValue
    });
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($851416859f33009f$var$NavigationMenuProvider, {
        scope: __scopeNavigationMenu,
        isRootMenu: false,
        value: value,
        dir: context.dir,
        orientation: orientation,
        rootNavigationMenu: context.rootNavigationMenu,
        onTriggerEnter: (itemValue)=>setValue(itemValue),
        onItemSelect: (itemValue)=>setValue(itemValue),
        onItemDismiss: ()=>setValue(""),
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
            "data-orientation": orientation,
            ...subProps,
            ref: forwardedRef
        })
    });
});
$851416859f33009f$export$5958edd6c4ee7c79.displayName = $851416859f33009f$var$SUB_NAME;
var $851416859f33009f$var$NavigationMenuProvider = (props)=>{
    const { scope: scope, isRootMenu: isRootMenu, rootNavigationMenu: rootNavigationMenu, dir: dir, orientation: orientation, children: children, value: value, onItemSelect: onItemSelect, onItemDismiss: onItemDismiss, onTriggerEnter: onTriggerEnter, onTriggerLeave: onTriggerLeave, onContentEnter: onContentEnter, onContentLeave: onContentLeave } = props;
    const [viewport, setViewport] = $7fPBF.useState(null);
    const [viewportContent, setViewportContent] = $7fPBF.useState(/* @__PURE__ */ new Map());
    const [indicatorTrack, setIndicatorTrack] = $7fPBF.useState(null);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($851416859f33009f$var$NavigationMenuProviderImpl, {
        scope: scope,
        isRootMenu: isRootMenu,
        rootNavigationMenu: rootNavigationMenu,
        value: value,
        previousValue: (0, $62f6e650b37fb598$export$5cae361ad82dce8b)(value),
        baseId: (0, $8a8e9b94c33ba6d6$export$f680877a34711e37)(),
        dir: dir,
        orientation: orientation,
        viewport: viewport,
        onViewportChange: setViewport,
        indicatorTrack: indicatorTrack,
        onIndicatorTrackChange: setIndicatorTrack,
        onTriggerEnter: (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(onTriggerEnter),
        onTriggerLeave: (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(onTriggerLeave),
        onContentEnter: (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(onContentEnter),
        onContentLeave: (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(onContentLeave),
        onItemSelect: (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(onItemSelect),
        onItemDismiss: (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(onItemDismiss),
        onViewportContentChange: $7fPBF.useCallback((contentValue, contentData)=>{
            setViewportContent((prevContent)=>{
                prevContent.set(contentValue, contentData);
                return new Map(prevContent);
            });
        }, []),
        onViewportContentRemove: $7fPBF.useCallback((contentValue)=>{
            setViewportContent((prevContent)=>{
                if (!prevContent.has(contentValue)) return prevContent;
                prevContent.delete(contentValue);
                return new Map(prevContent);
            });
        }, []),
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($851416859f33009f$var$Collection.Provider, {
            scope: scope,
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($851416859f33009f$var$ViewportContentProvider, {
                scope: scope,
                items: viewportContent,
                children: children
            })
        })
    });
};
var $851416859f33009f$var$LIST_NAME = "NavigationMenuList";
var $851416859f33009f$export$c361068a95fd2286 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeNavigationMenu: __scopeNavigationMenu, ...listProps } = props;
    const context = $851416859f33009f$var$useNavigationMenuContext($851416859f33009f$var$LIST_NAME, __scopeNavigationMenu);
    const list = /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).ul, {
        "data-orientation": context.orientation,
        ...listProps,
        ref: forwardedRef
    });
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
        style: {
            position: "relative"
        },
        ref: context.onIndicatorTrackChange,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($851416859f33009f$var$Collection.Slot, {
            scope: __scopeNavigationMenu,
            children: context.isRootMenu ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($851416859f33009f$var$FocusGroup, {
                asChild: true,
                children: list
            }) : list
        })
    });
});
$851416859f33009f$export$c361068a95fd2286.displayName = $851416859f33009f$var$LIST_NAME;
var $851416859f33009f$var$ITEM_NAME = "NavigationMenuItem";
var [$851416859f33009f$var$NavigationMenuItemContextProvider, $851416859f33009f$var$useNavigationMenuItemContext] = $851416859f33009f$var$createNavigationMenuContext($851416859f33009f$var$ITEM_NAME);
var $851416859f33009f$export$ffdbb83a2de845c2 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeNavigationMenu: __scopeNavigationMenu, value: valueProp, ...itemProps } = props;
    const autoValue = (0, $8a8e9b94c33ba6d6$export$f680877a34711e37)();
    const value = valueProp || autoValue || "LEGACY_REACT_AUTO_VALUE";
    const contentRef = $7fPBF.useRef(null);
    const triggerRef = $7fPBF.useRef(null);
    const focusProxyRef = $7fPBF.useRef(null);
    const restoreContentTabOrderRef = $7fPBF.useRef(()=>{});
    const wasEscapeCloseRef = $7fPBF.useRef(false);
    const handleContentEntry = $7fPBF.useCallback((side = "start")=>{
        if (contentRef.current) {
            restoreContentTabOrderRef.current();
            const candidates = $851416859f33009f$var$getTabbableCandidates(contentRef.current);
            if (candidates.length) $851416859f33009f$var$focusFirst(side === "start" ? candidates : candidates.reverse());
        }
    }, []);
    const handleContentExit = $7fPBF.useCallback(()=>{
        if (contentRef.current) {
            const candidates = $851416859f33009f$var$getTabbableCandidates(contentRef.current);
            if (candidates.length) restoreContentTabOrderRef.current = $851416859f33009f$var$removeFromTabOrder(candidates);
        }
    }, []);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($851416859f33009f$var$NavigationMenuItemContextProvider, {
        scope: __scopeNavigationMenu,
        value: value,
        triggerRef: triggerRef,
        contentRef: contentRef,
        focusProxyRef: focusProxyRef,
        wasEscapeCloseRef: wasEscapeCloseRef,
        onEntryKeyDown: handleContentEntry,
        onFocusProxyEnter: handleContentEntry,
        onRootContentClose: handleContentExit,
        onContentFocusOutside: handleContentExit,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).li, {
            ...itemProps,
            ref: forwardedRef
        })
    });
});
$851416859f33009f$export$ffdbb83a2de845c2.displayName = $851416859f33009f$var$ITEM_NAME;
var $851416859f33009f$var$TRIGGER_NAME = "NavigationMenuTrigger";
var $851416859f33009f$export$37fe8002734d8f2 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeNavigationMenu: __scopeNavigationMenu, disabled: disabled, ...triggerProps } = props;
    const context = $851416859f33009f$var$useNavigationMenuContext($851416859f33009f$var$TRIGGER_NAME, props.__scopeNavigationMenu);
    const itemContext = $851416859f33009f$var$useNavigationMenuItemContext($851416859f33009f$var$TRIGGER_NAME, props.__scopeNavigationMenu);
    const ref = $7fPBF.useRef(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(ref, itemContext.triggerRef, forwardedRef);
    const triggerId = $851416859f33009f$var$makeTriggerId(context.baseId, itemContext.value);
    const contentId = $851416859f33009f$var$makeContentId(context.baseId, itemContext.value);
    const hasPointerMoveOpenedRef = $7fPBF.useRef(false);
    const wasClickCloseRef = $7fPBF.useRef(false);
    const open = itemContext.value === context.value;
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($851416859f33009f$var$Collection.ItemSlot, {
                scope: __scopeNavigationMenu,
                value: itemContext.value,
                children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($851416859f33009f$var$FocusGroupItem, {
                    asChild: true,
                    children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).button, {
                        id: triggerId,
                        disabled: disabled,
                        "data-disabled": disabled ? "" : void 0,
                        "data-state": $851416859f33009f$var$getOpenState(open),
                        "aria-expanded": open,
                        "aria-controls": contentId,
                        ...triggerProps,
                        ref: composedRefs,
                        onPointerEnter: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerEnter, ()=>{
                            wasClickCloseRef.current = false;
                            itemContext.wasEscapeCloseRef.current = false;
                        }),
                        onPointerMove: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerMove, $851416859f33009f$var$whenMouse(()=>{
                            if (disabled || wasClickCloseRef.current || itemContext.wasEscapeCloseRef.current || hasPointerMoveOpenedRef.current) return;
                            context.onTriggerEnter(itemContext.value);
                            hasPointerMoveOpenedRef.current = true;
                        })),
                        onPointerLeave: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerLeave, $851416859f33009f$var$whenMouse(()=>{
                            if (disabled) return;
                            context.onTriggerLeave();
                            hasPointerMoveOpenedRef.current = false;
                        })),
                        onClick: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onClick, ()=>{
                            context.onItemSelect(itemContext.value);
                            wasClickCloseRef.current = open;
                        }),
                        onKeyDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                            const verticalEntryKey = context.dir === "rtl" ? "ArrowLeft" : "ArrowRight";
                            const entryKey = {
                                horizontal: "ArrowDown",
                                vertical: verticalEntryKey
                            }[context.orientation];
                            if (open && event.key === entryKey) {
                                itemContext.onEntryKeyDown();
                                event.preventDefault();
                            }
                        })
                    })
                })
            }),
            open && /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($28c8fa82e4cfdc1a$export$be92b6f5f03c0fe9, {
                        "aria-hidden": true,
                        tabIndex: 0,
                        ref: itemContext.focusProxyRef,
                        onFocus: (event)=>{
                            const content = itemContext.contentRef.current;
                            const prevFocusedElement = event.relatedTarget;
                            const wasTriggerFocused = prevFocusedElement === ref.current;
                            const wasFocusFromContent = content === null || content === void 0 ? void 0 : content.contains(prevFocusedElement);
                            if (wasTriggerFocused || !wasFocusFromContent) itemContext.onFocusProxyEnter(wasTriggerFocused ? "start" : "end");
                        }
                    }),
                    context.viewport && /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("span", {
                        "aria-owns": contentId
                    })
                ]
            })
        ]
    });
});
$851416859f33009f$export$37fe8002734d8f2.displayName = $851416859f33009f$var$TRIGGER_NAME;
var $851416859f33009f$var$LINK_NAME = "NavigationMenuLink";
var $851416859f33009f$var$LINK_SELECT = "navigationMenu.linkSelect";
var $851416859f33009f$export$6893bf21536567da = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeNavigationMenu: __scopeNavigationMenu, active: active, onSelect: onSelect, ...linkProps } = props;
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($851416859f33009f$var$FocusGroupItem, {
        asChild: true,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).a, {
            "data-active": active ? "" : void 0,
            "aria-current": active ? "page" : void 0,
            ...linkProps,
            ref: forwardedRef,
            onClick: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onClick, (event)=>{
                const target = event.target;
                const linkSelectEvent = new CustomEvent($851416859f33009f$var$LINK_SELECT, {
                    bubbles: true,
                    cancelable: true
                });
                target.addEventListener($851416859f33009f$var$LINK_SELECT, (event2)=>onSelect === null || onSelect === void 0 ? void 0 : onSelect(event2), {
                    once: true
                });
                (0, $4b1a25a893812cc7$export$6d1a0317bde7de7f)(target, linkSelectEvent);
                if (!linkSelectEvent.defaultPrevented && !event.metaKey) {
                    const rootContentDismissEvent = new CustomEvent($851416859f33009f$var$ROOT_CONTENT_DISMISS, {
                        bubbles: true,
                        cancelable: true
                    });
                    (0, $4b1a25a893812cc7$export$6d1a0317bde7de7f)(target, rootContentDismissEvent);
                }
            }, {
                checkForDefaultPrevented: false
            })
        })
    });
});
$851416859f33009f$export$6893bf21536567da.displayName = $851416859f33009f$var$LINK_NAME;
var $851416859f33009f$var$INDICATOR_NAME = "NavigationMenuIndicator";
var $851416859f33009f$export$8ddb526647c0d8fb = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { forceMount: forceMount, ...indicatorProps } = props;
    const context = $851416859f33009f$var$useNavigationMenuContext($851416859f33009f$var$INDICATOR_NAME, props.__scopeNavigationMenu);
    const isVisible = Boolean(context.value);
    return context.indicatorTrack ? (0, (/*@__PURE__*/$parcel$interopDefault($b4ba1c853f6e1116$exports))).createPortal(/* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $e9ce08b8e6e14786$export$99c2b779aa4e8b8b), {
        present: forceMount || isVisible,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($851416859f33009f$var$NavigationMenuIndicatorImpl, {
            ...indicatorProps,
            ref: forwardedRef
        })
    }), context.indicatorTrack) : null;
});
$851416859f33009f$export$8ddb526647c0d8fb.displayName = $851416859f33009f$var$INDICATOR_NAME;
var $851416859f33009f$var$NavigationMenuIndicatorImpl = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeNavigationMenu: __scopeNavigationMenu, ...indicatorProps } = props;
    const context = $851416859f33009f$var$useNavigationMenuContext($851416859f33009f$var$INDICATOR_NAME, __scopeNavigationMenu);
    const getItems = $851416859f33009f$var$useCollection(__scopeNavigationMenu);
    const [activeTrigger, setActiveTrigger] = $7fPBF.useState(null);
    const [position, setPosition] = $7fPBF.useState(null);
    const isHorizontal = context.orientation === "horizontal";
    const isVisible = Boolean(context.value);
    $7fPBF.useEffect(()=>{
        var _items_find;
        const items = getItems();
        const triggerNode = (_items_find = items.find((item)=>item.value === context.value)) === null || _items_find === void 0 ? void 0 : _items_find.ref.current;
        if (triggerNode) setActiveTrigger(triggerNode);
    }, [
        getItems,
        context.value
    ]);
    const handlePositionChange = ()=>{
        if (activeTrigger) setPosition({
            size: isHorizontal ? activeTrigger.offsetWidth : activeTrigger.offsetHeight,
            offset: isHorizontal ? activeTrigger.offsetLeft : activeTrigger.offsetTop
        });
    };
    $851416859f33009f$var$useResizeObserver(activeTrigger, handlePositionChange);
    $851416859f33009f$var$useResizeObserver(context.indicatorTrack, handlePositionChange);
    return position ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
        "aria-hidden": true,
        "data-state": isVisible ? "visible" : "hidden",
        "data-orientation": context.orientation,
        ...indicatorProps,
        ref: forwardedRef,
        style: {
            position: "absolute",
            ...isHorizontal ? {
                left: 0,
                width: position.size + "px",
                transform: `translateX(${position.offset}px)`
            } : {
                top: 0,
                height: position.size + "px",
                transform: `translateY(${position.offset}px)`
            },
            ...indicatorProps.style
        }
    }) : null;
});
var $851416859f33009f$var$CONTENT_NAME = "NavigationMenuContent";
var $851416859f33009f$export$38e00e996c2f93f7 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { forceMount: forceMount, ...contentProps } = props;
    const context = $851416859f33009f$var$useNavigationMenuContext($851416859f33009f$var$CONTENT_NAME, props.__scopeNavigationMenu);
    const itemContext = $851416859f33009f$var$useNavigationMenuItemContext($851416859f33009f$var$CONTENT_NAME, props.__scopeNavigationMenu);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(itemContext.contentRef, forwardedRef);
    const open = itemContext.value === context.value;
    const commonProps = {
        value: itemContext.value,
        triggerRef: itemContext.triggerRef,
        focusProxyRef: itemContext.focusProxyRef,
        wasEscapeCloseRef: itemContext.wasEscapeCloseRef,
        onContentFocusOutside: itemContext.onContentFocusOutside,
        onRootContentClose: itemContext.onRootContentClose,
        ...contentProps
    };
    return !context.viewport ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $e9ce08b8e6e14786$export$99c2b779aa4e8b8b), {
        present: forceMount || open,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($851416859f33009f$var$NavigationMenuContentImpl, {
            "data-state": $851416859f33009f$var$getOpenState(open),
            ...commonProps,
            ref: composedRefs,
            onPointerEnter: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerEnter, context.onContentEnter),
            onPointerLeave: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerLeave, $851416859f33009f$var$whenMouse(context.onContentLeave)),
            style: {
                // Prevent interaction when animating out
                pointerEvents: !open && context.isRootMenu ? "none" : void 0,
                ...commonProps.style
            }
        })
    }) : /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($851416859f33009f$var$ViewportContentMounter, {
        forceMount: forceMount,
        ...commonProps,
        ref: composedRefs
    });
});
$851416859f33009f$export$38e00e996c2f93f7.displayName = $851416859f33009f$var$CONTENT_NAME;
var $851416859f33009f$var$ViewportContentMounter = $7fPBF.forwardRef((props, forwardedRef)=>{
    const context = $851416859f33009f$var$useNavigationMenuContext($851416859f33009f$var$CONTENT_NAME, props.__scopeNavigationMenu);
    const { onViewportContentChange: onViewportContentChange, onViewportContentRemove: onViewportContentRemove } = context;
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        onViewportContentChange(props.value, {
            ref: forwardedRef,
            ...props
        });
    }, [
        props,
        forwardedRef,
        onViewportContentChange
    ]);
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        return ()=>onViewportContentRemove(props.value);
    }, [
        props.value,
        onViewportContentRemove
    ]);
    return null;
});
var $851416859f33009f$var$ROOT_CONTENT_DISMISS = "navigationMenu.rootContentDismiss";
var $851416859f33009f$var$NavigationMenuContentImpl = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeNavigationMenu: __scopeNavigationMenu, value: value, triggerRef: triggerRef, focusProxyRef: focusProxyRef, wasEscapeCloseRef: wasEscapeCloseRef, onRootContentClose: onRootContentClose, onContentFocusOutside: onContentFocusOutside, ...contentProps } = props;
    const context = $851416859f33009f$var$useNavigationMenuContext($851416859f33009f$var$CONTENT_NAME, __scopeNavigationMenu);
    const ref = $7fPBF.useRef(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(ref, forwardedRef);
    const triggerId = $851416859f33009f$var$makeTriggerId(context.baseId, value);
    const contentId = $851416859f33009f$var$makeContentId(context.baseId, value);
    const getItems = $851416859f33009f$var$useCollection(__scopeNavigationMenu);
    const prevMotionAttributeRef = $7fPBF.useRef(null);
    const { onItemDismiss: onItemDismiss } = context;
    $7fPBF.useEffect(()=>{
        const content = ref.current;
        if (context.isRootMenu && content) {
            const handleClose = ()=>{
                var _triggerRef_current;
                onItemDismiss();
                onRootContentClose();
                if (content.contains(document.activeElement)) (_triggerRef_current = triggerRef.current) === null || _triggerRef_current === void 0 ? void 0 : _triggerRef_current.focus();
            };
            content.addEventListener($851416859f33009f$var$ROOT_CONTENT_DISMISS, handleClose);
            return ()=>content.removeEventListener($851416859f33009f$var$ROOT_CONTENT_DISMISS, handleClose);
        }
    }, [
        context.isRootMenu,
        props.value,
        triggerRef,
        onItemDismiss,
        onRootContentClose
    ]);
    const motionAttribute = $7fPBF.useMemo(()=>{
        const items = getItems();
        const values = items.map((item)=>item.value);
        if (context.dir === "rtl") values.reverse();
        const index = values.indexOf(context.value);
        const prevIndex = values.indexOf(context.previousValue);
        const isSelected = value === context.value;
        const wasSelected = prevIndex === values.indexOf(value);
        if (!isSelected && !wasSelected) return prevMotionAttributeRef.current;
        const attribute = (()=>{
            if (index !== prevIndex) {
                if (isSelected && prevIndex !== -1) return index > prevIndex ? "from-end" : "from-start";
                if (wasSelected && index !== -1) return index > prevIndex ? "to-start" : "to-end";
            }
            return null;
        })();
        prevMotionAttributeRef.current = attribute;
        return attribute;
    }, [
        context.previousValue,
        context.value,
        context.dir,
        getItems,
        value
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($851416859f33009f$var$FocusGroup, {
        asChild: true,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $251340165f4765e5$export$177fb62ff3ec1f22), {
            id: contentId,
            "aria-labelledby": triggerId,
            "data-motion": motionAttribute,
            "data-orientation": context.orientation,
            ...contentProps,
            ref: composedRefs,
            disableOutsidePointerEvents: false,
            onDismiss: ()=>{
                var _ref_current;
                const rootContentDismissEvent = new Event($851416859f33009f$var$ROOT_CONTENT_DISMISS, {
                    bubbles: true,
                    cancelable: true
                });
                (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.dispatchEvent(rootContentDismissEvent);
            },
            onFocusOutside: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>{
                var _context_rootNavigationMenu;
                onContentFocusOutside();
                const target = event.target;
                if ((_context_rootNavigationMenu = context.rootNavigationMenu) === null || _context_rootNavigationMenu === void 0 ? void 0 : _context_rootNavigationMenu.contains(target)) event.preventDefault();
            }),
            onPointerDownOutside: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
                var _context_viewport;
                const target = event.target;
                const isTrigger = getItems().some((item)=>{
                    var _item_ref_current;
                    return (_item_ref_current = item.ref.current) === null || _item_ref_current === void 0 ? void 0 : _item_ref_current.contains(target);
                });
                const isRootViewport = context.isRootMenu && ((_context_viewport = context.viewport) === null || _context_viewport === void 0 ? void 0 : _context_viewport.contains(target));
                if (isTrigger || isRootViewport || !context.isRootMenu) event.preventDefault();
            }),
            onKeyDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                const isMetaKey = event.altKey || event.ctrlKey || event.metaKey;
                const isTabKey = event.key === "Tab" && !isMetaKey;
                if (isTabKey) {
                    var _focusProxyRef_current;
                    const candidates = $851416859f33009f$var$getTabbableCandidates(event.currentTarget);
                    const focusedElement = document.activeElement;
                    const index = candidates.findIndex((candidate)=>candidate === focusedElement);
                    const isMovingBackwards = event.shiftKey;
                    const nextCandidates = isMovingBackwards ? candidates.slice(0, index).reverse() : candidates.slice(index + 1, candidates.length);
                    if ($851416859f33009f$var$focusFirst(nextCandidates)) event.preventDefault();
                    else (_focusProxyRef_current = focusProxyRef.current) === null || _focusProxyRef_current === void 0 ? void 0 : _focusProxyRef_current.focus();
                }
            }),
            onEscapeKeyDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onEscapeKeyDown, (event)=>{
                wasEscapeCloseRef.current = true;
            })
        })
    });
});
var $851416859f33009f$var$VIEWPORT_NAME = "NavigationMenuViewport";
var $851416859f33009f$export$ee880b97cc6d44a5 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { forceMount: forceMount, ...viewportProps } = props;
    const context = $851416859f33009f$var$useNavigationMenuContext($851416859f33009f$var$VIEWPORT_NAME, props.__scopeNavigationMenu);
    const open = Boolean(context.value);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $e9ce08b8e6e14786$export$99c2b779aa4e8b8b), {
        present: forceMount || open,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($851416859f33009f$var$NavigationMenuViewportImpl, {
            ...viewportProps,
            ref: forwardedRef
        })
    });
});
$851416859f33009f$export$ee880b97cc6d44a5.displayName = $851416859f33009f$var$VIEWPORT_NAME;
var $851416859f33009f$var$NavigationMenuViewportImpl = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeNavigationMenu: __scopeNavigationMenu, children: children, ...viewportImplProps } = props;
    const context = $851416859f33009f$var$useNavigationMenuContext($851416859f33009f$var$VIEWPORT_NAME, __scopeNavigationMenu);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, context.onViewportChange);
    const viewportContentContext = $851416859f33009f$var$useViewportContentContext($851416859f33009f$var$CONTENT_NAME, props.__scopeNavigationMenu);
    const [size, setSize] = $7fPBF.useState(null);
    const [content, setContent] = $7fPBF.useState(null);
    const viewportWidth = size ? (size === null || size === void 0 ? void 0 : size.width) + "px" : void 0;
    const viewportHeight = size ? (size === null || size === void 0 ? void 0 : size.height) + "px" : void 0;
    const open = Boolean(context.value);
    const activeContentValue = open ? context.value : context.previousValue;
    const handleSizeChange = ()=>{
        if (content) setSize({
            width: content.offsetWidth,
            height: content.offsetHeight
        });
    };
    $851416859f33009f$var$useResizeObserver(content, handleSizeChange);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
        "data-state": $851416859f33009f$var$getOpenState(open),
        "data-orientation": context.orientation,
        ...viewportImplProps,
        ref: composedRefs,
        style: {
            // Prevent interaction when animating out
            pointerEvents: !open && context.isRootMenu ? "none" : void 0,
            ["--radix-navigation-menu-viewport-width"]: viewportWidth,
            ["--radix-navigation-menu-viewport-height"]: viewportHeight,
            ...viewportImplProps.style
        },
        onPointerEnter: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerEnter, context.onContentEnter),
        onPointerLeave: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerLeave, $851416859f33009f$var$whenMouse(context.onContentLeave)),
        children: Array.from(viewportContentContext.items).map(([value, { ref: ref, forceMount: forceMount, ...props2 }])=>{
            const isActive = activeContentValue === value;
            return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $e9ce08b8e6e14786$export$99c2b779aa4e8b8b), {
                present: forceMount || isActive,
                children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($851416859f33009f$var$NavigationMenuContentImpl, {
                    ...props2,
                    ref: (0, $2d44b7cb84ff0f1c$export$43e446d32b3d21af)(ref, (node)=>{
                        if (isActive && node) setContent(node);
                    })
                })
            }, value);
        })
    });
});
var $851416859f33009f$var$FOCUS_GROUP_NAME = "FocusGroup";
var $851416859f33009f$var$FocusGroup = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeNavigationMenu: __scopeNavigationMenu, ...groupProps } = props;
    const context = $851416859f33009f$var$useNavigationMenuContext($851416859f33009f$var$FOCUS_GROUP_NAME, __scopeNavigationMenu);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($851416859f33009f$var$FocusGroupCollection.Provider, {
        scope: __scopeNavigationMenu,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($851416859f33009f$var$FocusGroupCollection.Slot, {
            scope: __scopeNavigationMenu,
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
                dir: context.dir,
                ...groupProps,
                ref: forwardedRef
            })
        })
    });
});
var $851416859f33009f$var$ARROW_KEYS = [
    "ArrowRight",
    "ArrowLeft",
    "ArrowUp",
    "ArrowDown"
];
var $851416859f33009f$var$FOCUS_GROUP_ITEM_NAME = "FocusGroupItem";
var $851416859f33009f$var$FocusGroupItem = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeNavigationMenu: __scopeNavigationMenu, ...groupProps } = props;
    const getItems = $851416859f33009f$var$useFocusGroupCollection(__scopeNavigationMenu);
    const context = $851416859f33009f$var$useNavigationMenuContext($851416859f33009f$var$FOCUS_GROUP_ITEM_NAME, __scopeNavigationMenu);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($851416859f33009f$var$FocusGroupCollection.ItemSlot, {
        scope: __scopeNavigationMenu,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).button, {
            ...groupProps,
            ref: forwardedRef,
            onKeyDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                const isFocusNavigationKey = [
                    "Home",
                    "End",
                    ...$851416859f33009f$var$ARROW_KEYS
                ].includes(event.key);
                if (isFocusNavigationKey) {
                    let candidateNodes = getItems().map((item)=>item.ref.current);
                    const prevItemKey = context.dir === "rtl" ? "ArrowRight" : "ArrowLeft";
                    const prevKeys = [
                        prevItemKey,
                        "ArrowUp",
                        "End"
                    ];
                    if (prevKeys.includes(event.key)) candidateNodes.reverse();
                    if ($851416859f33009f$var$ARROW_KEYS.includes(event.key)) {
                        const currentIndex = candidateNodes.indexOf(event.currentTarget);
                        candidateNodes = candidateNodes.slice(currentIndex + 1);
                    }
                    setTimeout(()=>$851416859f33009f$var$focusFirst(candidateNodes));
                    event.preventDefault();
                }
            })
        })
    });
});
function $851416859f33009f$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode);
    return nodes;
}
function $851416859f33009f$var$focusFirst(candidates) {
    const previouslyFocusedElement = document.activeElement;
    return candidates.some((candidate)=>{
        if (candidate === previouslyFocusedElement) return true;
        candidate.focus();
        return document.activeElement !== previouslyFocusedElement;
    });
}
function $851416859f33009f$var$removeFromTabOrder(candidates) {
    candidates.forEach((candidate)=>{
        candidate.dataset.tabindex = candidate.getAttribute("tabindex") || "";
        candidate.setAttribute("tabindex", "-1");
    });
    return ()=>{
        candidates.forEach((candidate)=>{
            const prevTabIndex = candidate.dataset.tabindex;
            candidate.setAttribute("tabindex", prevTabIndex);
        });
    };
}
function $851416859f33009f$var$useResizeObserver(element, onResize) {
    const handleResize = (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(onResize);
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        let rAF = 0;
        if (element) {
            const resizeObserver = new ResizeObserver(()=>{
                cancelAnimationFrame(rAF);
                rAF = window.requestAnimationFrame(handleResize);
            });
            resizeObserver.observe(element);
            return ()=>{
                window.cancelAnimationFrame(rAF);
                resizeObserver.unobserve(element);
            };
        }
    }, [
        element,
        handleResize
    ]);
}
function $851416859f33009f$var$getOpenState(open) {
    return open ? "open" : "closed";
}
function $851416859f33009f$var$makeTriggerId(baseId, value) {
    return `${baseId}-trigger-${value}`;
}
function $851416859f33009f$var$makeContentId(baseId, value) {
    return `${baseId}-content-${value}`;
}
function $851416859f33009f$var$whenMouse(handler) {
    return (event)=>event.pointerType === "mouse" ? handler(event) : void 0;
}
var $851416859f33009f$export$be92b6f5f03c0fe9 = $851416859f33009f$export$5b2278cf1e8bcae2;
var $851416859f33009f$export$d7a01e11500dfb6f = $851416859f33009f$export$5958edd6c4ee7c79;
var $851416859f33009f$export$54c2e3dc7acea9f5 = $851416859f33009f$export$c361068a95fd2286;
var $851416859f33009f$export$6d08773d2e66f8f2 = $851416859f33009f$export$ffdbb83a2de845c2;
var $851416859f33009f$export$41fb9f06171c75f4 = $851416859f33009f$export$37fe8002734d8f2;
var $851416859f33009f$export$a6c7ac8248d6e38a = $851416859f33009f$export$6893bf21536567da;
var $851416859f33009f$export$adb584737d712b70 = $851416859f33009f$export$8ddb526647c0d8fb;
var $851416859f33009f$export$7c6e2c02157bb7d2 = $851416859f33009f$export$38e00e996c2f93f7;
var $851416859f33009f$export$d5c6c08dc2d3ca7 = $851416859f33009f$export$ee880b97cc6d44a5;





const $f4d2894713d23b28$var$r = [
    "1",
    "2"
], $f4d2894713d23b28$var$t = [
    "nowrap",
    "wrap",
    "wrap-reverse"
], $f4d2894713d23b28$var$o = [
    "start",
    "center",
    "end"
], $f4d2894713d23b28$export$bf3e34726f4451cf = {
    size: {
        type: "enum",
        className: "rt-r-size",
        values: $f4d2894713d23b28$var$r,
        default: "2",
        responsive: !0
    },
    wrap: {
        type: "enum",
        className: "rt-r-fw",
        values: $f4d2894713d23b28$var$t,
        responsive: !0
    },
    justify: {
        type: "enum",
        className: "rt-r-jc",
        values: $f4d2894713d23b28$var$o,
        responsive: !0
    },
    ...(0, $e914ebf2ce406d8c$export$8255b018f448be13),
    ...(0, $f41c61290c2a7125$export$2f84412d299def33)
};


const $c6a05559c391209a$export$7acbbb824e87e447 = {
    ...(0, $b302dbddfdac9d75$export$1e7c0b54c65e0280),
    active: {
        type: "boolean",
        default: !1
    }
};





const $95cda4101006eb9c$export$be92b6f5f03c0fe9 = $7fPBF.forwardRef((t, r)=>{
    const { children: a, className: s, color: n, ...p } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(t, (0, $f4d2894713d23b28$export$bf3e34726f4451cf), (0, $df06be8448ff4f3c$export$83503616c7a463e3));
    return $7fPBF.createElement($851416859f33009f$export$be92b6f5f03c0fe9, {
        className: "rt-TabNavRoot",
        "data-accent-color": n,
        ...p,
        asChild: !1,
        ref: r
    }, $7fPBF.createElement($851416859f33009f$export$54c2e3dc7acea9f5, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-reset", "rt-BaseTabList", "rt-TabNavList", s)
    }, a));
});
$95cda4101006eb9c$export$be92b6f5f03c0fe9.displayName = "TabNav.Root";
const $95cda4101006eb9c$export$a6c7ac8248d6e38a = $7fPBF.forwardRef((t, r)=>{
    const { asChild: a, children: s, className: n, ...p } = t;
    return $7fPBF.createElement($851416859f33009f$export$6d08773d2e66f8f2, {
        className: "rt-TabNavItem"
    }, $7fPBF.createElement($851416859f33009f$export$a6c7ac8248d6e38a, {
        ...p,
        ref: r,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-reset", "rt-BaseTabListTrigger", "rt-TabNavLink", n),
        onSelect: void 0,
        asChild: a
    }, (0, $3de7503944cba122$export$9e8b964465d7899e)({
        asChild: a,
        children: s
    }, (i)=>$7fPBF.createElement($7fPBF.Fragment, null, $7fPBF.createElement("span", {
            className: "rt-BaseTabListTriggerInner rt-TabNavLinkInner"
        }, i), $7fPBF.createElement("span", {
            className: "rt-BaseTabListTriggerInnerHidden rt-TabNavLinkInnerHidden"
        }, i)))));
});
$95cda4101006eb9c$export$a6c7ac8248d6e38a.displayName = "TabNav.Link";



var $7fPBF = parcelRequire("7fPBF");



const $91b35b361439082d$var$r = [
    "1",
    "2",
    "3"
], $91b35b361439082d$var$a = [
    "surface",
    "ghost"
], $91b35b361439082d$var$o = [
    "auto",
    "fixed"
], $91b35b361439082d$export$d58150cb0a4f2438 = {
    size: {
        type: "enum",
        className: "rt-r-size",
        values: $91b35b361439082d$var$r,
        default: "2",
        responsive: !0
    },
    variant: {
        type: "enum",
        className: "rt-variant",
        values: $91b35b361439082d$var$a,
        default: "ghost"
    },
    layout: {
        type: "enum",
        className: "rt-r-tl",
        values: $91b35b361439082d$var$o,
        responsive: !0
    }
}, $91b35b361439082d$var$i = [
    "start",
    "center",
    "end",
    "baseline"
], $91b35b361439082d$export$adf668be1c8c343 = {
    align: {
        type: "enum",
        className: "rt-r-va",
        values: $91b35b361439082d$var$i,
        parseValue: $91b35b361439082d$var$l,
        responsive: !0
    }
};
function $91b35b361439082d$var$l(e) {
    return ({
        baseline: "baseline",
        start: "top",
        center: "middle",
        end: "bottom"
    })[e];
}
const $91b35b361439082d$var$p = [
    "start",
    "center",
    "end"
], $91b35b361439082d$export$32704d7609f850a5 = {
    justify: {
        type: "enum",
        className: "rt-r-ta",
        values: $91b35b361439082d$var$p,
        parseValue: $91b35b361439082d$var$c,
        responsive: !0
    },
    ...(0, $b6a742bf1f02ee7d$export$18e5dbe2c243731),
    ...(0, $48ad56c8dba75b58$export$2076c0543e271ca1)
};
function $91b35b361439082d$var$c(e) {
    return ({
        start: "left",
        center: "center",
        end: "right"
    })[e];
}






const $6824654050574b5e$export$be92b6f5f03c0fe9 = $7fPBF.forwardRef((o, l)=>{
    const { layout: a, ...r } = (0, $91b35b361439082d$export$d58150cb0a4f2438), { className: C, children: c, layout: y, ...i } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(o, r, (0, $df06be8448ff4f3c$export$83503616c7a463e3)), w = (0, $6e74cfda01acbc32$export$d03033efad57dbbf)({
        value: y,
        className: (0, $91b35b361439082d$export$d58150cb0a4f2438).layout.className,
        propValues: (0, $91b35b361439082d$export$d58150cb0a4f2438).layout.values
    });
    return $7fPBF.createElement("div", {
        ref: l,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-TableRoot", C),
        ...i
    }, $7fPBF.createElement((0, $649b23d2e2cfc248$export$ccf8d8d7bbf3c2cc), null, $7fPBF.createElement("table", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-TableRootTable", w)
    }, c)));
});
$6824654050574b5e$export$be92b6f5f03c0fe9.displayName = "Table.Root";
const $6824654050574b5e$export$8b251419efc915eb = $7fPBF.forwardRef(({ className: o, ...l }, a)=>$7fPBF.createElement("thead", {
        ...l,
        ref: a,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-TableHeader", o)
    }));
$6824654050574b5e$export$8b251419efc915eb.displayName = "Table.Header";
const $6824654050574b5e$export$4b2c32e08f77ff18 = $7fPBF.forwardRef(({ className: o, ...l }, a)=>$7fPBF.createElement("tbody", {
        ...l,
        ref: a,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-TableBody", o)
    }));
$6824654050574b5e$export$4b2c32e08f77ff18.displayName = "Table.Body";
const $6824654050574b5e$export$b59bdbef9ce70de2 = $7fPBF.forwardRef((o, l)=>{
    const { className: a, ...r } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(o, (0, $91b35b361439082d$export$adf668be1c8c343));
    return $7fPBF.createElement("tr", {
        ...r,
        ref: l,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-TableRow", a)
    });
});
$6824654050574b5e$export$b59bdbef9ce70de2.displayName = "Table.Row";
const $6824654050574b5e$export$f6f0c3fe4ec306ea = $7fPBF.forwardRef((o, l)=>{
    const { className: a, ...r } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(o, (0, $91b35b361439082d$export$32704d7609f850a5));
    return $7fPBF.createElement("td", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-TableCell", a),
        ref: l,
        ...r
    });
});
$6824654050574b5e$export$f6f0c3fe4ec306ea.displayName = "Table.Cell";
const $6824654050574b5e$export$9766c08b419bb79 = $7fPBF.forwardRef((o, l)=>{
    const { className: a, ...r } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(o, (0, $91b35b361439082d$export$32704d7609f850a5));
    return $7fPBF.createElement("th", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-TableCell", "rt-TableColumnHeaderCell", a),
        scope: "col",
        ref: l,
        ...r
    });
});
$6824654050574b5e$export$9766c08b419bb79.displayName = "Table.ColumnHeaderCell";
const $6824654050574b5e$export$90b286dd97c43ca1 = $7fPBF.forwardRef((o, l)=>{
    const { className: a, ...r } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(o, (0, $91b35b361439082d$export$32704d7609f850a5));
    return $7fPBF.createElement("th", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-TableCell", "rt-TableRowHeaderCell", a),
        scope: "row",
        ref: l,
        ...r
    });
});
$6824654050574b5e$export$90b286dd97c43ca1.displayName = "Table.RowHeaderCell";



var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");









"use client";
var $8e0e96bb8b7270da$var$TABS_NAME = "Tabs";
var [$8e0e96bb8b7270da$var$createTabsContext, $8e0e96bb8b7270da$export$355f5bd209d7b13a] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)($8e0e96bb8b7270da$var$TABS_NAME, [
    (0, $8183e11ba1e9b7dc$export$c7109489551a4f4)
]);
var $8e0e96bb8b7270da$var$useRovingFocusGroupScope = (0, $8183e11ba1e9b7dc$export$c7109489551a4f4)();
var [$8e0e96bb8b7270da$var$TabsProvider, $8e0e96bb8b7270da$var$useTabsContext] = $8e0e96bb8b7270da$var$createTabsContext($8e0e96bb8b7270da$var$TABS_NAME);
var $8e0e96bb8b7270da$export$b2539bed5023c21c = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs, value: valueProp, onValueChange: onValueChange, defaultValue: defaultValue, orientation: orientation = "horizontal", dir: dir, activationMode: activationMode = "automatic", ...tabsProps } = props;
    const direction = (0, $3342477e04611d10$export$b39126d51d94e6f3)(dir);
    const [value, setValue] = (0, $915387e6ab4d88b1$export$6f32135080cb4c3)({
        prop: valueProp,
        onChange: onValueChange,
        defaultProp: defaultValue
    });
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($8e0e96bb8b7270da$var$TabsProvider, {
        scope: __scopeTabs,
        baseId: (0, $8a8e9b94c33ba6d6$export$f680877a34711e37)(),
        value: value,
        onValueChange: setValue,
        orientation: orientation,
        dir: direction,
        activationMode: activationMode,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
            dir: direction,
            "data-orientation": orientation,
            ...tabsProps,
            ref: forwardedRef
        })
    });
});
$8e0e96bb8b7270da$export$b2539bed5023c21c.displayName = $8e0e96bb8b7270da$var$TABS_NAME;
var $8e0e96bb8b7270da$var$TAB_LIST_NAME = "TabsList";
var $8e0e96bb8b7270da$export$9712d22edc0d78c1 = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs, loop: loop = true, ...listProps } = props;
    const context = $8e0e96bb8b7270da$var$useTabsContext($8e0e96bb8b7270da$var$TAB_LIST_NAME, __scopeTabs);
    const rovingFocusGroupScope = $8e0e96bb8b7270da$var$useRovingFocusGroupScope(__scopeTabs);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($8183e11ba1e9b7dc$export$be92b6f5f03c0fe9, {
        asChild: true,
        ...rovingFocusGroupScope,
        orientation: context.orientation,
        dir: context.dir,
        loop: loop,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
            role: "tablist",
            "aria-orientation": context.orientation,
            ...listProps,
            ref: forwardedRef
        })
    });
});
$8e0e96bb8b7270da$export$9712d22edc0d78c1.displayName = $8e0e96bb8b7270da$var$TAB_LIST_NAME;
var $8e0e96bb8b7270da$var$TRIGGER_NAME = "TabsTrigger";
var $8e0e96bb8b7270da$export$8114b9fdfdf9f3ba = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs, value: value, disabled: disabled = false, ...triggerProps } = props;
    const context = $8e0e96bb8b7270da$var$useTabsContext($8e0e96bb8b7270da$var$TRIGGER_NAME, __scopeTabs);
    const rovingFocusGroupScope = $8e0e96bb8b7270da$var$useRovingFocusGroupScope(__scopeTabs);
    const triggerId = $8e0e96bb8b7270da$var$makeTriggerId(context.baseId, value);
    const contentId = $8e0e96bb8b7270da$var$makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($8183e11ba1e9b7dc$export$6d08773d2e66f8f2, {
        asChild: true,
        ...rovingFocusGroupScope,
        focusable: !disabled,
        active: isSelected,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).button, {
            type: "button",
            role: "tab",
            "aria-selected": isSelected,
            "aria-controls": contentId,
            "data-state": isSelected ? "active" : "inactive",
            "data-disabled": disabled ? "" : void 0,
            disabled: disabled,
            id: triggerId,
            ...triggerProps,
            ref: forwardedRef,
            onMouseDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onMouseDown, (event)=>{
                if (!disabled && event.button === 0 && event.ctrlKey === false) context.onValueChange(value);
                else event.preventDefault();
            }),
            onKeyDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                if ([
                    " ",
                    "Enter"
                ].includes(event.key)) context.onValueChange(value);
            }),
            onFocus: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onFocus, ()=>{
                const isAutomaticActivation = context.activationMode !== "manual";
                if (!isSelected && !disabled && isAutomaticActivation) context.onValueChange(value);
            })
        })
    });
});
$8e0e96bb8b7270da$export$8114b9fdfdf9f3ba.displayName = $8e0e96bb8b7270da$var$TRIGGER_NAME;
var $8e0e96bb8b7270da$var$CONTENT_NAME = "TabsContent";
var $8e0e96bb8b7270da$export$bd905d70e8fd2ebb = $7fPBF.forwardRef((props, forwardedRef)=>{
    const { __scopeTabs: __scopeTabs, value: value, forceMount: forceMount, children: children, ...contentProps } = props;
    const context = $8e0e96bb8b7270da$var$useTabsContext($8e0e96bb8b7270da$var$CONTENT_NAME, __scopeTabs);
    const triggerId = $8e0e96bb8b7270da$var$makeTriggerId(context.baseId, value);
    const contentId = $8e0e96bb8b7270da$var$makeContentId(context.baseId, value);
    const isSelected = value === context.value;
    const isMountAnimationPreventedRef = $7fPBF.useRef(isSelected);
    $7fPBF.useEffect(()=>{
        const rAF = requestAnimationFrame(()=>isMountAnimationPreventedRef.current = false);
        return ()=>cancelAnimationFrame(rAF);
    }, []);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $e9ce08b8e6e14786$export$99c2b779aa4e8b8b), {
        present: forceMount || isSelected,
        children: ({ present: present })=>/* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, {
                "data-state": isSelected ? "active" : "inactive",
                "data-orientation": context.orientation,
                role: "tabpanel",
                "aria-labelledby": triggerId,
                hidden: !present,
                id: contentId,
                tabIndex: 0,
                ...contentProps,
                ref: forwardedRef,
                style: {
                    ...props.style,
                    animationDuration: isMountAnimationPreventedRef.current ? "0s" : void 0
                },
                children: present && children
            })
    });
});
$8e0e96bb8b7270da$export$bd905d70e8fd2ebb.displayName = $8e0e96bb8b7270da$var$CONTENT_NAME;
function $8e0e96bb8b7270da$var$makeTriggerId(baseId, value) {
    return `${baseId}-trigger-${value}`;
}
function $8e0e96bb8b7270da$var$makeContentId(baseId, value) {
    return `${baseId}-content-${value}`;
}
var $8e0e96bb8b7270da$export$be92b6f5f03c0fe9 = $8e0e96bb8b7270da$export$b2539bed5023c21c;
var $8e0e96bb8b7270da$export$54c2e3dc7acea9f5 = $8e0e96bb8b7270da$export$9712d22edc0d78c1;
var $8e0e96bb8b7270da$export$41fb9f06171c75f4 = $8e0e96bb8b7270da$export$8114b9fdfdf9f3ba;
var $8e0e96bb8b7270da$export$7c6e2c02157bb7d2 = $8e0e96bb8b7270da$export$bd905d70e8fd2ebb;




const $5fe9a87e9c67033d$export$2402b8f894c7f9d7 = {
    ...(0, $b302dbddfdac9d75$export$1e7c0b54c65e0280)
}, $5fe9a87e9c67033d$export$f9c97f2c55b16927 = {
    ...(0, $b302dbddfdac9d75$export$1e7c0b54c65e0280)
};




const $48fc66ada58b00f8$export$be92b6f5f03c0fe9 = $7fPBF.forwardRef((t, o)=>{
    const { className: r, ...e } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(t, (0, $df06be8448ff4f3c$export$83503616c7a463e3));
    return $7fPBF.createElement($8e0e96bb8b7270da$export$be92b6f5f03c0fe9, {
        ...e,
        ref: o,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-TabsRoot", r)
    });
});
$48fc66ada58b00f8$export$be92b6f5f03c0fe9.displayName = "Tabs.Root";
const $48fc66ada58b00f8$export$54c2e3dc7acea9f5 = $7fPBF.forwardRef((t, o)=>{
    const { className: r, color: e, ...n } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(t, (0, $f4d2894713d23b28$export$bf3e34726f4451cf), (0, $df06be8448ff4f3c$export$83503616c7a463e3));
    return $7fPBF.createElement($8e0e96bb8b7270da$export$54c2e3dc7acea9f5, {
        "data-accent-color": e,
        ...n,
        asChild: !1,
        ref: o,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-BaseTabList", "rt-TabsList", r)
    });
});
$48fc66ada58b00f8$export$54c2e3dc7acea9f5.displayName = "Tabs.List";
const $48fc66ada58b00f8$export$41fb9f06171c75f4 = $7fPBF.forwardRef((t, o)=>{
    const { className: r, children: e, ...n } = t;
    return $7fPBF.createElement($8e0e96bb8b7270da$export$41fb9f06171c75f4, {
        ...n,
        asChild: !1,
        ref: o,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-reset", "rt-BaseTabListTrigger", "rt-TabsTrigger", r)
    }, $7fPBF.createElement("span", {
        className: "rt-BaseTabListTriggerInner rt-TabsTriggerInner"
    }, e), $7fPBF.createElement("span", {
        className: "rt-BaseTabListTriggerInnerHidden rt-TabsTriggerInnerHidden"
    }, e));
});
$48fc66ada58b00f8$export$41fb9f06171c75f4.displayName = "Tabs.Trigger";
const $48fc66ada58b00f8$export$7c6e2c02157bb7d2 = $7fPBF.forwardRef((t, o)=>{
    const { className: r, ...e } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(t, (0, $df06be8448ff4f3c$export$83503616c7a463e3));
    return $7fPBF.createElement($8e0e96bb8b7270da$export$7c6e2c02157bb7d2, {
        ...e,
        ref: o,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-TabsContent", r)
    });
});
$48fc66ada58b00f8$export$7c6e2c02157bb7d2.displayName = "Tabs.Content";



var $7fPBF = parcelRequire("7fPBF");



const $55373679f6468204$var$r = [
    "1",
    "2",
    "3"
], $55373679f6468204$var$t = [
    "classic",
    "surface",
    "soft"
], $55373679f6468204$var$o = [
    "none",
    "vertical",
    "horizontal",
    "both"
], $55373679f6468204$export$59471c6b05e40e6a = {
    size: {
        type: "enum",
        className: "rt-r-size",
        values: $55373679f6468204$var$r,
        default: "2",
        responsive: !0
    },
    variant: {
        type: "enum",
        className: "rt-variant",
        values: $55373679f6468204$var$t,
        default: "surface"
    },
    resize: {
        type: "enum",
        className: "rt-r-resize",
        values: $55373679f6468204$var$o,
        responsive: !0
    },
    ...(0, $e914ebf2ce406d8c$export$8255b018f448be13),
    ...(0, $3d20a83f81464c0a$export$c467f6769b59b70c)
};




const $c303baca598cd11c$export$f5c9f3c2c4054eec = $7fPBF.forwardRef((t, o)=>{
    const { className: p, color: a, radius: s, style: m, ...n } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(t, (0, $55373679f6468204$export$59471c6b05e40e6a), (0, $df06be8448ff4f3c$export$83503616c7a463e3));
    return $7fPBF.createElement("div", {
        "data-accent-color": a,
        "data-radius": s,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-TextAreaRoot", p),
        style: m
    }, $7fPBF.createElement("textarea", {
        className: "rt-reset rt-TextAreaInput",
        ref: o,
        ...n
    }));
});
$c303baca598cd11c$export$f5c9f3c2c4054eec.displayName = "TextArea";



var $7fPBF = parcelRequire("7fPBF");






const $a0a08d483d4b4abf$var$r = [
    "1",
    "2",
    "3"
], $a0a08d483d4b4abf$var$t = [
    "classic",
    "surface",
    "soft"
], $a0a08d483d4b4abf$export$35eed719b2e901b4 = {
    size: {
        type: "enum",
        className: "rt-r-size",
        values: $a0a08d483d4b4abf$var$r,
        default: "2",
        responsive: !0
    },
    variant: {
        type: "enum",
        className: "rt-variant",
        values: $a0a08d483d4b4abf$var$t,
        default: "surface"
    },
    ...(0, $e914ebf2ce406d8c$export$8255b018f448be13),
    ...(0, $3d20a83f81464c0a$export$c467f6769b59b70c)
}, $a0a08d483d4b4abf$var$a = [
    "left",
    "right"
], $a0a08d483d4b4abf$export$c2c5347ccd3692ef = {
    side: {
        type: "enum",
        values: $a0a08d483d4b4abf$var$a
    },
    ...(0, $e914ebf2ce406d8c$export$8255b018f448be13),
    gap: (0, $c1eba8fbe9fc8173$export$472ad07285607ea8).gap,
    px: (0, $48ad56c8dba75b58$export$2076c0543e271ca1).px,
    pl: (0, $48ad56c8dba75b58$export$2076c0543e271ca1).pl,
    pr: (0, $48ad56c8dba75b58$export$2076c0543e271ca1).pr
};




"use client";
const $a3d64abea89bc20d$export$be92b6f5f03c0fe9 = $7fPBF.forwardRef((r, s)=>{
    const e = $7fPBF.useRef(null), { children: l, className: i, color: p, radius: f, style: x, ...P } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(r, (0, $a0a08d483d4b4abf$export$35eed719b2e901b4), (0, $df06be8448ff4f3c$export$83503616c7a463e3));
    return $7fPBF.createElement("div", {
        "data-accent-color": p,
        "data-radius": f,
        style: x,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-TextFieldRoot", i),
        onPointerDown: (T)=>{
            const n = T.target;
            if (n.closest("input, button, a")) return;
            const o = e.current;
            if (!o) return;
            const a = n.closest(`
            .rt-TextFieldSlot[data-side='right'],
            .rt-TextFieldSlot:not([data-side='right']) ~ .rt-TextFieldSlot:not([data-side='left'])
          `) ? o.value.length : 0;
            requestAnimationFrame(()=>{
                try {
                    o.setSelectionRange(a, a);
                } catch  {}
                o.focus();
            });
        }
    }, $7fPBF.createElement("input", {
        spellCheck: "false",
        ...P,
        ref: (0, $2d44b7cb84ff0f1c$export$43e446d32b3d21af)(e, s),
        className: "rt-reset rt-TextFieldInput"
    }), l);
});
$a3d64abea89bc20d$export$be92b6f5f03c0fe9.displayName = "TextField.Root";
const $a3d64abea89bc20d$export$8c6ed5c666ac1360 = $7fPBF.forwardRef((r, s)=>{
    const { className: e, color: l, side: i, ...p } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(r, (0, $a0a08d483d4b4abf$export$c2c5347ccd3692ef));
    return $7fPBF.createElement("div", {
        "data-accent-color": l,
        "data-side": i,
        ...p,
        ref: s,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-TextFieldSlot", e)
    });
});
$a3d64abea89bc20d$export$8c6ed5c666ac1360.displayName = "TextField.Slot";




var $7fPBF = parcelRequire("7fPBF");






"use client";
const $bb5dfa462014b74b$export$b0a39009850adc92 = $7fPBF.forwardRef(({ defaultOpen: n = !0, ...a }, l)=>{
    const [c, h] = $7fPBF.useState(n);
    return $7fPBF.createElement($bb5dfa462014b74b$var$z, {
        ...a,
        ref: l,
        open: c,
        onOpenChange: h
    });
});
$bb5dfa462014b74b$export$b0a39009850adc92.displayName = "ThemePanel";
const $bb5dfa462014b74b$var$z = $7fPBF.forwardRef((n, a)=>{
    const { open: l, onOpenChange: c, onAppearanceChange: h, ...v } = n, G = (0, $fe07e27ecf0fa1d7$export$c4281ec44b929e6)(), { appearance: d, onAppearanceChange: B, accentColor: g, onAccentColorChange: $, grayColor: f, onGrayColorChange: F, panelBackground: T, onPanelBackgroundChange: O, radius: w, onRadiusChange: D, scaling: x, onScalingChange: j } = G, E = h !== void 0, K = (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(h), k = $7fPBF.useCallback((t)=>{
        const o = $bb5dfa462014b74b$var$a9();
        if (d !== "inherit") {
            B(t);
            return;
        }
        E ? K(t) : (H(t), $bb5dfa462014b74b$var$l9(t)), o();
    }, [
        d,
        B,
        E,
        K
    ]), P = (0, $35c1c1e30f45838f$export$74e595af20fc4c22)(g), S = f === "auto" ? P : f, [W, M] = $7fPBF.useState("idle");
    async function U() {
        const t = {
            appearance: d === (0, $56174f3812602a5f$export$59a6a824235dee85).appearance.default ? void 0 : d,
            accentColor: g === (0, $56174f3812602a5f$export$59a6a824235dee85).accentColor.default ? void 0 : g,
            grayColor: f === (0, $56174f3812602a5f$export$59a6a824235dee85).grayColor.default ? void 0 : f,
            panelBackground: T === (0, $56174f3812602a5f$export$59a6a824235dee85).panelBackground.default ? void 0 : T,
            radius: w === (0, $56174f3812602a5f$export$59a6a824235dee85).radius.default ? void 0 : w,
            scaling: x === (0, $56174f3812602a5f$export$59a6a824235dee85).scaling.default ? void 0 : x
        }, o = Object.keys(t).filter((i)=>t[i] !== void 0).map((i)=>`${i}="${t[i]}"`).join(" "), m = o ? `<Theme ${o}>` : "<Theme>";
        M("copying"), await navigator.clipboard.writeText(m), M("copied"), setTimeout(()=>M("idle"), 2e3);
    }
    const [Z, H] = $7fPBF.useState(d === "inherit" ? null : d), b = `
      [contenteditable],
      [role="combobox"],
      [role="listbox"],
      [role="menu"],
      input:not([type="radio"], [type="checkbox"]),
      select,
      textarea
    `;
    return $7fPBF.useEffect(()=>{
        function t(o) {
            var _document_activeElement, _o_key;
            const m = o.altKey || o.ctrlKey || o.shiftKey || o.metaKey, i = (_document_activeElement = document.activeElement) === null || _document_activeElement === void 0 ? void 0 : _document_activeElement.closest(b);
            ((_o_key = o.key) === null || _o_key === void 0 ? void 0 : _o_key.toUpperCase()) === "T" && !m && !i && c(!l);
        }
        return document.addEventListener("keydown", t), ()=>document.removeEventListener("keydown", t);
    }, [
        c,
        l,
        b
    ]), $7fPBF.useEffect(()=>{
        function t(o) {
            var _document_activeElement, _o_key;
            const m = o.altKey || o.ctrlKey || o.shiftKey || o.metaKey, i = (_document_activeElement = document.activeElement) === null || _document_activeElement === void 0 ? void 0 : _document_activeElement.closest(b);
            ((_o_key = o.key) === null || _o_key === void 0 ? void 0 : _o_key.toUpperCase()) === "D" && !m && !i && k(Z === "light" ? "dark" : "light");
        }
        return document.addEventListener("keydown", t), ()=>document.removeEventListener("keydown", t);
    }, [
        k,
        Z,
        b
    ]), $7fPBF.useEffect(()=>{
        const t = document.documentElement, o = document.body;
        function m() {
            const y = t.classList.contains("dark") || t.classList.contains("dark-theme") || o.classList.contains("dark") || o.classList.contains("dark-theme");
            H(d === "inherit" ? y ? "dark" : "light" : d);
        }
        const i = new MutationObserver(function(y) {
            y.forEach(function(X) {
                X.attributeName === "class" && m();
            });
        });
        return m(), d === "inherit" && (i.observe(t, {
            attributes: !0
        }), i.observe(o, {
            attributes: !0
        })), ()=>i.disconnect();
    }, [
        d
    ]), $7fPBF.createElement((0, $fe07e27ecf0fa1d7$export$14faa19a0f3bbeb2), {
        asChild: !0,
        radius: "medium",
        scaling: "100%"
    }, $7fPBF.createElement((0, $95341668bcbb7769$export$f51f4c4ede09e011), {
        direction: "column",
        position: "fixed",
        top: "0",
        right: "0",
        mr: "4",
        mt: "4",
        inert: l ? void 0 : (0, $18c8d007fcd48c4d$export$2780f85aa8ed0db8),
        ...v,
        ref: a,
        style: {
            zIndex: 9999,
            overflow: "hidden",
            maxHeight: "calc(100vh - var(--space-4) - var(--space-4))",
            borderRadius: "var(--radius-4)",
            backgroundColor: "var(--color-panel-solid)",
            transformOrigin: "top center",
            transitionProperty: "transform, box-shadow",
            transitionDuration: "200ms",
            transitionTimingFunction: l ? "ease-out" : "ease-in",
            transform: l ? "none" : "translateX(105%)",
            boxShadow: l ? "var(--shadow-5)" : "var(--shadow-2)",
            ...n.style
        }
    }, $7fPBF.createElement((0, $649b23d2e2cfc248$export$ccf8d8d7bbf3c2cc), null, $7fPBF.createElement((0, $70d14e4633845b98$export$e71c4d32a2263218), {
        flexGrow: "1",
        p: "5",
        position: "relative"
    }, $7fPBF.createElement((0, $70d14e4633845b98$export$e71c4d32a2263218), {
        position: "absolute",
        top: "0",
        right: "0",
        m: "2"
    }, $7fPBF.createElement((0, $78c951eb7a4c3f69$export$28c660c63b792dea), {
        content: "Press T to show/hide the Theme Panel",
        side: "bottom",
        sideOffset: 6
    }, $7fPBF.createElement((0, $e34f6ad538a6cb7d$export$5e66ad77b1eb2956), {
        asChild: !0,
        size: "3",
        tabIndex: 0,
        className: "rt-ThemePanelShortcut"
    }, $7fPBF.createElement("button", {
        onClick: ()=>c(!l)
    }, "T")))), $7fPBF.createElement((0, $a81a142737c4a792$export$a8a3e93435678ff9), {
        size: "5",
        trim: "both",
        as: "h3",
        mb: "5"
    }, "Theme"), $7fPBF.createElement((0, $83db9e82a643d7a4$export$5f1af8db9871e1d6), {
        id: "accent-color-title",
        as: "p",
        size: "2",
        weight: "medium",
        mt: "5"
    }, "Accent color"), $7fPBF.createElement((0, $1186128e999eac49$export$ef2184bd89960b14), {
        columns: "10",
        gap: "2",
        mt: "3",
        role: "group",
        "aria-labelledby": "accent-color-title"
    }, (0, $56174f3812602a5f$export$59a6a824235dee85).accentColor.values.map((t)=>$7fPBF.createElement("label", {
            key: t,
            className: "rt-ThemePanelSwatch",
            style: {
                backgroundColor: `var(--${t}-9)`
            }
        }, $7fPBF.createElement((0, $78c951eb7a4c3f69$export$28c660c63b792dea), {
            content: `${$bb5dfa462014b74b$var$C(t)}${g === "gray" && S !== "gray" ? ` (${$bb5dfa462014b74b$var$C(S)})` : ""}`
        }, $7fPBF.createElement("input", {
            className: "rt-ThemePanelSwatchInput",
            type: "radio",
            name: "accentColor",
            value: t,
            checked: g === t,
            onChange: (o)=>$(o.target.value)
        }))))), $7fPBF.createElement((0, $95341668bcbb7769$export$f51f4c4ede09e011), {
        asChild: !0,
        align: "center",
        justify: "between"
    }, $7fPBF.createElement((0, $83db9e82a643d7a4$export$5f1af8db9871e1d6), {
        as: "p",
        id: "gray-color-title",
        size: "2",
        weight: "medium",
        mt: "5"
    }, "Gray color")), $7fPBF.createElement((0, $1186128e999eac49$export$ef2184bd89960b14), {
        columns: "10",
        gap: "2",
        mt: "3",
        role: "group",
        "aria-labelledby": "gray-color-title"
    }, (0, $56174f3812602a5f$export$59a6a824235dee85).grayColor.values.map((t)=>$7fPBF.createElement((0, $95341668bcbb7769$export$f51f4c4ede09e011), {
            key: t,
            asChild: !0,
            align: "center",
            justify: "center"
        }, $7fPBF.createElement("label", {
            className: "rt-ThemePanelSwatch",
            style: {
                backgroundColor: t === "auto" ? `var(--${P}-9)` : t === "gray" ? "var(--gray-9)" : `var(--${t}-9)`,
                filter: t === "gray" ? "saturate(0)" : void 0
            }
        }, $7fPBF.createElement((0, $78c951eb7a4c3f69$export$28c660c63b792dea), {
            content: `${$bb5dfa462014b74b$var$C(t)}${t === "auto" ? ` (${$bb5dfa462014b74b$var$C(P)})` : ""}`
        }, $7fPBF.createElement("input", {
            className: "rt-ThemePanelSwatchInput",
            type: "radio",
            name: "grayColor",
            value: t,
            checked: f === t,
            onChange: (o)=>F(o.target.value)
        })))))), $7fPBF.createElement((0, $83db9e82a643d7a4$export$5f1af8db9871e1d6), {
        id: "appearance-title",
        as: "p",
        size: "2",
        weight: "medium",
        mt: "5"
    }, "Appearance"), $7fPBF.createElement((0, $1186128e999eac49$export$ef2184bd89960b14), {
        columns: "2",
        gap: "2",
        mt: "3",
        role: "group",
        "aria-labelledby": "appearance-title"
    }, [
        "light",
        "dark"
    ].map((t)=>$7fPBF.createElement("label", {
            key: t,
            className: "rt-ThemePanelRadioCard"
        }, $7fPBF.createElement("input", {
            className: "rt-ThemePanelRadioCardInput",
            type: "radio",
            name: "appearance",
            value: t,
            checked: Z === t,
            onChange: (o)=>k(o.target.value)
        }), $7fPBF.createElement((0, $95341668bcbb7769$export$f51f4c4ede09e011), {
            align: "center",
            justify: "center",
            height: "32px",
            gap: "2"
        }, t === "light" ? $7fPBF.createElement("svg", {
            width: "15",
            height: "15",
            viewBox: "0 0 15 15",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            style: {
                margin: "0 -1px"
            }
        }, $7fPBF.createElement("path", {
            d: "M7.5 0C7.77614 0 8 0.223858 8 0.5V2.5C8 2.77614 7.77614 3 7.5 3C7.22386 3 7 2.77614 7 2.5V0.5C7 0.223858 7.22386 0 7.5 0ZM2.1967 2.1967C2.39196 2.00144 2.70854 2.00144 2.90381 2.1967L4.31802 3.61091C4.51328 3.80617 4.51328 4.12276 4.31802 4.31802C4.12276 4.51328 3.80617 4.51328 3.61091 4.31802L2.1967 2.90381C2.00144 2.70854 2.00144 2.39196 2.1967 2.1967ZM0.5 7C0.223858 7 0 7.22386 0 7.5C0 7.77614 0.223858 8 0.5 8H2.5C2.77614 8 3 7.77614 3 7.5C3 7.22386 2.77614 7 2.5 7H0.5ZM2.1967 12.8033C2.00144 12.608 2.00144 12.2915 2.1967 12.0962L3.61091 10.682C3.80617 10.4867 4.12276 10.4867 4.31802 10.682C4.51328 10.8772 4.51328 11.1938 4.31802 11.3891L2.90381 12.8033C2.70854 12.9986 2.39196 12.9986 2.1967 12.8033ZM12.5 7C12.2239 7 12 7.22386 12 7.5C12 7.77614 12.2239 8 12.5 8H14.5C14.7761 8 15 7.77614 15 7.5C15 7.22386 14.7761 7 14.5 7H12.5ZM10.682 4.31802C10.4867 4.12276 10.4867 3.80617 10.682 3.61091L12.0962 2.1967C12.2915 2.00144 12.608 2.00144 12.8033 2.1967C12.9986 2.39196 12.9986 2.70854 12.8033 2.90381L11.3891 4.31802C11.1938 4.51328 10.8772 4.51328 10.682 4.31802ZM8 12.5C8 12.2239 7.77614 12 7.5 12C7.22386 12 7 12.2239 7 12.5V14.5C7 14.7761 7.22386 15 7.5 15C7.77614 15 8 14.7761 8 14.5V12.5ZM10.682 10.682C10.8772 10.4867 11.1938 10.4867 11.3891 10.682L12.8033 12.0962C12.9986 12.2915 12.9986 12.608 12.8033 12.8033C12.608 12.9986 12.2915 12.9986 12.0962 12.8033L10.682 11.3891C10.4867 11.1938 10.4867 10.8772 10.682 10.682ZM5.5 7.5C5.5 6.39543 6.39543 5.5 7.5 5.5C8.60457 5.5 9.5 6.39543 9.5 7.5C9.5 8.60457 8.60457 9.5 7.5 9.5C6.39543 9.5 5.5 8.60457 5.5 7.5ZM7.5 4.5C5.84315 4.5 4.5 5.84315 4.5 7.5C4.5 9.15685 5.84315 10.5 7.5 10.5C9.15685 10.5 10.5 9.15685 10.5 7.5C10.5 5.84315 9.15685 4.5 7.5 4.5Z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
        })) : $7fPBF.createElement("svg", {
            width: "15",
            height: "15",
            viewBox: "0 0 15 15",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            style: {
                margin: "0 -1px"
            }
        }, $7fPBF.createElement("path", {
            d: "M2.89998 0.499976C2.89998 0.279062 2.72089 0.0999756 2.49998 0.0999756C2.27906 0.0999756 2.09998 0.279062 2.09998 0.499976V1.09998H1.49998C1.27906 1.09998 1.09998 1.27906 1.09998 1.49998C1.09998 1.72089 1.27906 1.89998 1.49998 1.89998H2.09998V2.49998C2.09998 2.72089 2.27906 2.89998 2.49998 2.89998C2.72089 2.89998 2.89998 2.72089 2.89998 2.49998V1.89998H3.49998C3.72089 1.89998 3.89998 1.72089 3.89998 1.49998C3.89998 1.27906 3.72089 1.09998 3.49998 1.09998H2.89998V0.499976ZM5.89998 3.49998C5.89998 3.27906 5.72089 3.09998 5.49998 3.09998C5.27906 3.09998 5.09998 3.27906 5.09998 3.49998V4.09998H4.49998C4.27906 4.09998 4.09998 4.27906 4.09998 4.49998C4.09998 4.72089 4.27906 4.89998 4.49998 4.89998H5.09998V5.49998C5.09998 5.72089 5.27906 5.89998 5.49998 5.89998C5.72089 5.89998 5.89998 5.72089 5.89998 5.49998V4.89998H6.49998C6.72089 4.89998 6.89998 4.72089 6.89998 4.49998C6.89998 4.27906 6.72089 4.09998 6.49998 4.09998H5.89998V3.49998ZM1.89998 6.49998C1.89998 6.27906 1.72089 6.09998 1.49998 6.09998C1.27906 6.09998 1.09998 6.27906 1.09998 6.49998V7.09998H0.499976C0.279062 7.09998 0.0999756 7.27906 0.0999756 7.49998C0.0999756 7.72089 0.279062 7.89998 0.499976 7.89998H1.09998V8.49998C1.09998 8.72089 1.27906 8.89997 1.49998 8.89997C1.72089 8.89997 1.89998 8.72089 1.89998 8.49998V7.89998H2.49998C2.72089 7.89998 2.89998 7.72089 2.89998 7.49998C2.89998 7.27906 2.72089 7.09998 2.49998 7.09998H1.89998V6.49998ZM8.54406 0.98184L8.24618 0.941586C8.03275 0.917676 7.90692 1.1655 8.02936 1.34194C8.17013 1.54479 8.29981 1.75592 8.41754 1.97445C8.91878 2.90485 9.20322 3.96932 9.20322 5.10022C9.20322 8.37201 6.82247 11.0878 3.69887 11.6097C3.45736 11.65 3.20988 11.6772 2.96008 11.6906C2.74563 11.702 2.62729 11.9535 2.77721 12.1072C2.84551 12.1773 2.91535 12.2458 2.98667 12.3128L3.05883 12.3795L3.31883 12.6045L3.50684 12.7532L3.62796 12.8433L3.81491 12.9742L3.99079 13.089C4.11175 13.1651 4.23536 13.2375 4.36157 13.3059L4.62496 13.4412L4.88553 13.5607L5.18837 13.6828L5.43169 13.7686C5.56564 13.8128 5.70149 13.8529 5.83857 13.8885C5.94262 13.9155 6.04767 13.9401 6.15405 13.9622C6.27993 13.9883 6.40713 14.0109 6.53544 14.0298L6.85241 14.0685L7.11934 14.0892C7.24637 14.0965 7.37436 14.1002 7.50322 14.1002C11.1483 14.1002 14.1032 11.1453 14.1032 7.50023C14.1032 7.25044 14.0893 7.00389 14.0623 6.76131L14.0255 6.48407C13.991 6.26083 13.9453 6.04129 13.8891 5.82642C13.8213 5.56709 13.7382 5.31398 13.6409 5.06881L13.5279 4.80132L13.4507 4.63542L13.3766 4.48666C13.2178 4.17773 13.0353 3.88295 12.8312 3.60423L12.6782 3.40352L12.4793 3.16432L12.3157 2.98361L12.1961 2.85951L12.0355 2.70246L11.8134 2.50184L11.4925 2.24191L11.2483 2.06498L10.9562 1.87446L10.6346 1.68894L10.3073 1.52378L10.1938 1.47176L9.95488 1.3706L9.67791 1.2669L9.42566 1.1846L9.10075 1.09489L8.83599 1.03486L8.54406 0.98184ZM10.4032 5.30023C10.4032 4.27588 10.2002 3.29829 9.83244 2.40604C11.7623 3.28995 13.1032 5.23862 13.1032 7.50023C13.1032 10.593 10.596 13.1002 7.50322 13.1002C6.63646 13.1002 5.81597 12.9036 5.08355 12.5522C6.5419 12.0941 7.81081 11.2082 8.74322 10.0416C8.87963 10.2284 9.10028 10.3497 9.34928 10.3497C9.76349 10.3497 10.0993 10.0139 10.0993 9.59971C10.0993 9.24256 9.84965 8.94373 9.51535 8.86816C9.57741 8.75165 9.63653 8.63334 9.6926 8.51332C9.88358 8.63163 10.1088 8.69993 10.35 8.69993C11.0403 8.69993 11.6 8.14028 11.6 7.44993C11.6 6.75976 11.0406 6.20024 10.3505 6.19993C10.3853 5.90487 10.4032 5.60464 10.4032 5.30023Z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
        })), $7fPBF.createElement((0, $83db9e82a643d7a4$export$5f1af8db9871e1d6), {
            size: "1",
            weight: "medium"
        }, $bb5dfa462014b74b$var$C(t)))))), $7fPBF.createElement((0, $83db9e82a643d7a4$export$5f1af8db9871e1d6), {
        id: "radius-title",
        as: "p",
        size: "2",
        weight: "medium",
        mt: "5"
    }, "Radius"), $7fPBF.createElement((0, $1186128e999eac49$export$ef2184bd89960b14), {
        columns: "5",
        gap: "2",
        mt: "3",
        role: "group",
        "aria-labelledby": "radius-title"
    }, (0, $56174f3812602a5f$export$59a6a824235dee85).radius.values.map((t)=>$7fPBF.createElement((0, $95341668bcbb7769$export$f51f4c4ede09e011), {
            key: t,
            direction: "column",
            align: "center"
        }, $7fPBF.createElement("label", {
            className: "rt-ThemePanelRadioCard"
        }, $7fPBF.createElement("input", {
            className: "rt-ThemePanelRadioCardInput",
            type: "radio",
            name: "radius",
            id: `theme-panel-radius-${t}`,
            value: t,
            checked: w === t,
            onChange: (o)=>D(o.target.value)
        }), $7fPBF.createElement((0, $fe07e27ecf0fa1d7$export$14faa19a0f3bbeb2), {
            asChild: !0,
            radius: t
        }, $7fPBF.createElement((0, $70d14e4633845b98$export$e71c4d32a2263218), {
            m: "3",
            width: "32px",
            height: "32px",
            style: {
                borderTopLeftRadius: t === "full" ? "80%" : "var(--radius-5)",
                backgroundImage: "linear-gradient(to bottom right, var(--accent-3), var(--accent-4))",
                borderTop: "2px solid var(--accent-a8)",
                borderLeft: "2px solid var(--accent-a8)"
            }
        }))), $7fPBF.createElement((0, $70d14e4633845b98$export$e71c4d32a2263218), {
            asChild: !0,
            pt: "2"
        }, $7fPBF.createElement((0, $83db9e82a643d7a4$export$5f1af8db9871e1d6), {
            asChild: !0,
            size: "1",
            color: "gray"
        }, $7fPBF.createElement("label", {
            htmlFor: `theme-panel-radius-${t}`
        }, $bb5dfa462014b74b$var$C(t))))))), $7fPBF.createElement((0, $83db9e82a643d7a4$export$5f1af8db9871e1d6), {
        id: "scaling-title",
        as: "p",
        size: "2",
        weight: "medium",
        mt: "5"
    }, "Scaling"), $7fPBF.createElement((0, $1186128e999eac49$export$ef2184bd89960b14), {
        columns: "5",
        gap: "2",
        mt: "3",
        role: "group",
        "aria-labelledby": "scaling-title"
    }, (0, $56174f3812602a5f$export$59a6a824235dee85).scaling.values.map((t)=>$7fPBF.createElement("label", {
            key: t,
            className: "rt-ThemePanelRadioCard"
        }, $7fPBF.createElement("input", {
            className: "rt-ThemePanelRadioCardInput",
            type: "radio",
            name: "scaling",
            value: t,
            checked: x === t,
            onChange: (o)=>j(o.target.value)
        }), $7fPBF.createElement((0, $95341668bcbb7769$export$f51f4c4ede09e011), {
            align: "center",
            justify: "center",
            height: "32px"
        }, $7fPBF.createElement((0, $fe07e27ecf0fa1d7$export$14faa19a0f3bbeb2), {
            asChild: !0,
            scaling: t
        }, $7fPBF.createElement((0, $95341668bcbb7769$export$f51f4c4ede09e011), {
            align: "center",
            justify: "center"
        }, $7fPBF.createElement((0, $83db9e82a643d7a4$export$5f1af8db9871e1d6), {
            size: "1",
            weight: "medium"
        }, $bb5dfa462014b74b$var$C(t)))))))), $7fPBF.createElement((0, $95341668bcbb7769$export$f51f4c4ede09e011), {
        mt: "5",
        align: "center",
        gap: "2"
    }, $7fPBF.createElement((0, $83db9e82a643d7a4$export$5f1af8db9871e1d6), {
        id: "panel-background-title",
        as: "p",
        size: "2",
        weight: "medium"
    }, "Panel background"), $7fPBF.createElement((0, $1876ebeddbd368a2$exports).Root, null, $7fPBF.createElement((0, $1876ebeddbd368a2$exports).Trigger, null, $7fPBF.createElement((0, $a9ab71d5f2dd22da$export$c25acd513dcc8062), {
        size: "1",
        variant: "ghost",
        color: "gray"
    }, $7fPBF.createElement((0, $72d653f67b66328c$export$5aec92af04ace2d2), {
        label: "Learn more about panel background options"
    }, $7fPBF.createElement("svg", {
        width: "15",
        height: "15",
        viewBox: "0 0 15 15",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg"
    }, $7fPBF.createElement("path", {
        d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM8.24992 4.49999C8.24992 4.9142 7.91413 5.24999 7.49992 5.24999C7.08571 5.24999 6.74992 4.9142 6.74992 4.49999C6.74992 4.08577 7.08571 3.74999 7.49992 3.74999C7.91413 3.74999 8.24992 4.08577 8.24992 4.49999ZM6.00003 5.99999H6.50003H7.50003C7.77618 5.99999 8.00003 6.22384 8.00003 6.49999V9.99999H8.50003H9.00003V11H8.50003H7.50003H6.50003H6.00003V9.99999H6.50003H7.00003V6.99999H6.50003H6.00003V5.99999Z",
        fillRule: "evenodd",
        clipRule: "evenodd"
    }))))), $7fPBF.createElement((0, $1876ebeddbd368a2$exports).Content, {
        size: "1",
        style: {
            maxWidth: 220
        },
        side: "top",
        align: "center"
    }, $7fPBF.createElement((0, $83db9e82a643d7a4$export$5f1af8db9871e1d6), {
        as: "p",
        size: "2"
    }, "Whether Card and Table panels are translucent, showing some of\xa0the background behind them.")))), $7fPBF.createElement((0, $1186128e999eac49$export$ef2184bd89960b14), {
        columns: "2",
        gap: "2",
        mt: "3",
        role: "group",
        "aria-labelledby": "panel-background-title"
    }, (0, $56174f3812602a5f$export$59a6a824235dee85).panelBackground.values.map((t)=>$7fPBF.createElement("label", {
            key: t,
            className: "rt-ThemePanelRadioCard"
        }, $7fPBF.createElement("input", {
            className: "rt-ThemePanelRadioCardInput",
            type: "radio",
            name: "panelBackground",
            value: t,
            checked: T === t,
            onChange: (o)=>O(o.target.value)
        }), $7fPBF.createElement((0, $95341668bcbb7769$export$f51f4c4ede09e011), {
            align: "center",
            justify: "center",
            height: "32px",
            gap: "2"
        }, t === "solid" ? $7fPBF.createElement("svg", {
            width: "15",
            height: "15",
            viewBox: "0 0 15 15",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            style: {
                margin: "0 -2px"
            }
        }, $7fPBF.createElement("path", {
            d: "M0.877075 7.49988C0.877075 3.84219 3.84222 0.877045 7.49991 0.877045C11.1576 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49988ZM7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 4.36686 10.6329 1.82704 7.49991 1.82704Z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
        })) : $7fPBF.createElement("svg", {
            width: "15",
            height: "15",
            viewBox: "0 0 15 15",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            style: {
                margin: "0 -2px"
            }
        }, $7fPBF.createElement("path", {
            opacity: ".05",
            d: "M6.78296 13.376C8.73904 9.95284 8.73904 5.04719 6.78296 1.62405L7.21708 1.37598C9.261 4.95283 9.261 10.0472 7.21708 13.624L6.78296 13.376Z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
        }), $7fPBF.createElement("path", {
            opacity: ".1",
            d: "M7.28204 13.4775C9.23929 9.99523 9.23929 5.00475 7.28204 1.52248L7.71791 1.2775C9.76067 4.9119 9.76067 10.0881 7.71791 13.7225L7.28204 13.4775Z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
        }), $7fPBF.createElement("path", {
            opacity: ".15",
            d: "M7.82098 13.5064C9.72502 9.99523 9.72636 5.01411 7.82492 1.50084L8.26465 1.26285C10.2465 4.92466 10.2451 10.085 8.26052 13.7448L7.82098 13.5064Z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
        }), $7fPBF.createElement("path", {
            opacity: ".2",
            d: "M8.41284 13.429C10.1952 9.92842 10.1957 5.07537 8.41435 1.57402L8.85999 1.34729C10.7139 4.99113 10.7133 10.0128 8.85841 13.6559L8.41284 13.429Z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
        }), $7fPBF.createElement("path", {
            opacity: ".25",
            d: "M9.02441 13.2956C10.6567 9.8379 10.6586 5.17715 9.03005 1.71656L9.48245 1.50366C11.1745 5.09919 11.1726 9.91629 9.47657 13.5091L9.02441 13.2956Z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
        }), $7fPBF.createElement("path", {
            opacity: ".3",
            d: "M9.66809 13.0655C11.1097 9.69572 11.1107 5.3121 9.67088 1.94095L10.1307 1.74457C11.6241 5.24121 11.6231 9.76683 10.1278 13.2622L9.66809 13.0655Z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
        }), $7fPBF.createElement("path", {
            opacity: ".35",
            d: "M10.331 12.7456C11.5551 9.52073 11.5564 5.49103 10.3347 2.26444L10.8024 2.0874C12.0672 5.42815 12.0659 9.58394 10.7985 12.9231L10.331 12.7456Z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
        }), $7fPBF.createElement("path", {
            opacity: ".4",
            d: "M11.0155 12.2986C11.9938 9.29744 11.9948 5.71296 11.0184 2.71067L11.4939 2.55603C12.503 5.6589 12.502 9.35178 11.4909 12.4535L11.0155 12.2986Z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
        }), $7fPBF.createElement("path", {
            opacity: ".45",
            d: "M11.7214 11.668C12.4254 9.01303 12.4262 5.99691 11.7237 3.34116L12.2071 3.21329C12.9318 5.95292 12.931 9.05728 12.2047 11.7961L11.7214 11.668Z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
        }), $7fPBF.createElement("path", {
            opacity: ".5",
            d: "M12.4432 10.752C12.8524 8.63762 12.8523 6.36089 12.4429 4.2466L12.9338 4.15155C13.3553 6.32861 13.3554 8.66985 12.9341 10.847L12.4432 10.752Z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
        }), $7fPBF.createElement("path", {
            d: "M0.877075 7.49988C0.877075 3.84219 3.84222 0.877045 7.49991 0.877045C11.1576 0.877045 14.1227 3.84219 14.1227 7.49988C14.1227 11.1575 11.1576 14.1227 7.49991 14.1227C3.84222 14.1227 0.877075 11.1575 0.877075 7.49988ZM7.49991 1.82704C4.36689 1.82704 1.82708 4.36686 1.82708 7.49988C1.82708 10.6329 4.36689 13.1727 7.49991 13.1727C10.6329 13.1727 13.1727 10.6329 13.1727 7.49988C13.1727 4.36686 10.6329 1.82704 7.49991 1.82704Z",
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd"
        })), $7fPBF.createElement((0, $83db9e82a643d7a4$export$5f1af8db9871e1d6), {
            size: "1",
            weight: "medium"
        }, $bb5dfa462014b74b$var$C(t)))))), $7fPBF.createElement((0, $d934301c5a05c9c5$export$353f5b6fc5456de1), {
        mt: "5",
        style: {
            width: "100%"
        },
        onClick: U
    }, W === "copied" ? "Copied" : "Copy Theme")))));
});
$bb5dfa462014b74b$var$z.displayName = "ThemePanelImpl";
function $bb5dfa462014b74b$var$a9() {
    const n = document.createElement("style");
    return n.appendChild(document.createTextNode("*,*::before,*::after{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}")), document.head.appendChild(n), ()=>{
        window.getComputedStyle(document.body), setTimeout(()=>{
            document.head.removeChild(n);
        }, 1);
    };
}
function $bb5dfa462014b74b$var$C(n) {
    return n.charAt(0).toUpperCase() + n.slice(1);
}
function $bb5dfa462014b74b$var$l9(n) {
    const a = document.documentElement, l = a.classList.contains("light-theme"), c = a.classList.contains("dark-theme"), h = a.classList.contains("light"), v = a.classList.contains("dark");
    (l || c) && (a.classList.remove("light-theme", "dark-theme"), a.style.colorScheme = n, a.classList.add(`${n}-theme`)), (h || v) && (a.classList.remove("light", "dark"), a.style.colorScheme = n, a.classList.add(n)), !l && !c && !h && !v && (a.style.colorScheme = n, a.classList.add(n));
}




var $7fPBF = parcelRequire("7fPBF");






const $bb214ee7928e4b67$export$e72475bbea542107 = {
    content: {
        type: "ReactNode",
        required: !0
    },
    width: (0, $b6a742bf1f02ee7d$export$18e5dbe2c243731).width,
    minWidth: (0, $b6a742bf1f02ee7d$export$18e5dbe2c243731).minWidth,
    maxWidth: {
        ...(0, $b6a742bf1f02ee7d$export$18e5dbe2c243731).maxWidth,
        default: "360px"
    }
};


const $78c951eb7a4c3f69$export$28c660c63b792dea = $7fPBF.forwardRef((i, p)=>{
    const { children: r, className: n, open: s, defaultOpen: l, onOpenChange: m, delayDuration: a, disableHoverableContent: f, content: P, container: T, forceMount: c, ...d } = (0, $ef0737d72702ceb3$export$7782f98975e2d28f)(i, (0, $bb214ee7928e4b67$export$e72475bbea542107)), C = {
        open: s,
        defaultOpen: l,
        onOpenChange: m,
        delayDuration: a,
        disableHoverableContent: f
    };
    return $7fPBF.createElement($ec185ecb78ca2c5c$export$be92b6f5f03c0fe9, {
        ...C
    }, $7fPBF.createElement($ec185ecb78ca2c5c$export$41fb9f06171c75f4, {
        asChild: !0
    }, r), $7fPBF.createElement($ec185ecb78ca2c5c$export$602eac185826482c, {
        container: T,
        forceMount: c
    }, $7fPBF.createElement((0, $fe07e27ecf0fa1d7$export$14faa19a0f3bbeb2), {
        asChild: !0
    }, $7fPBF.createElement($ec185ecb78ca2c5c$export$7c6e2c02157bb7d2, {
        sideOffset: 4,
        collisionPadding: 10,
        ...d,
        asChild: !1,
        ref: p,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("rt-TooltipContent", n)
    }, $7fPBF.createElement((0, $83db9e82a643d7a4$export$5f1af8db9871e1d6), {
        as: "p",
        className: "rt-TooltipText",
        size: "1"
    }, P), $7fPBF.createElement($ec185ecb78ca2c5c$export$21b07c8f274aebd5, {
        className: "rt-TooltipArrow"
    })))));
});
$78c951eb7a4c3f69$export$28c660c63b792dea.displayName = "Tooltip";









var $aba35fd891fdedeb$exports = {};
$aba35fd891fdedeb$exports = new URL("logo.41ae7c84.png", import.meta.url).toString();


var $6cab325760b0af7c$exports = {};
$6cab325760b0af7c$exports = new URL("library_hero.152204f6.png", import.meta.url).toString();



/**
 * React Router DOM v6.2.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7fPBF = parcelRequire("7fPBF");
function $628bb797dd3c4d2c$export$2e2bcd8739ae039() {
    $628bb797dd3c4d2c$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $628bb797dd3c4d2c$export$2e2bcd8739ae039.apply(this, arguments);
}


/**
 * Actions represent the type of change to a location value.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#action
 */ var $91da240b76094466$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($91da240b76094466$export$e19cd5f9376f8cee || ($91da240b76094466$export$e19cd5f9376f8cee = {}));
var $91da240b76094466$var$readOnly = function(obj) {
    return obj;
};
function $91da240b76094466$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
var $91da240b76094466$var$BeforeUnloadEventType = "beforeunload";
var $91da240b76094466$var$HashChangeEventType = "hashchange";
var $91da240b76094466$var$PopStateEventType = "popstate";
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $91da240b76094466$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    var _options = options, _options$window = _options.window, window = _options$window === void 0 ? document.defaultView : _options$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $91da240b76094466$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || "default"
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $91da240b76094466$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation = getIndexAndLocation(), nextIndex = _getIndexAndLocation[0], nextLocation = _getIndexAndLocation[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($91da240b76094466$var$PopStateEventType, handlePop);
    var action = $91da240b76094466$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation2 = getIndexAndLocation(), index = _getIndexAndLocation2[0], location = _getIndexAndLocation2[1];
    var listeners = $91da240b76094466$var$createEvents();
    var blockers = $91da240b76094466$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $628bb797dd3c4d2c$export$2e2bcd8739ae039)({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function createHref(to) {
        return typeof to === "string" ? to : $91da240b76094466$export$fe53371bee54353d(to);
    } // state defaults to `null` because `window.history.state` does
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $91da240b76094466$var$readOnly((0, $628bb797dd3c4d2c$export$2e2bcd8739ae039)({
            pathname: location.pathname,
            hash: "",
            search: ""
        }, typeof to === "string" ? $91da240b76094466$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $91da240b76094466$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation3 = getIndexAndLocation();
        index = _getIndexAndLocation3[0];
        location = _getIndexAndLocation3[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $91da240b76094466$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr[0], url = _getHistoryStateAndUr[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, "", url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $91da240b76094466$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr2 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr2[0], url = _getHistoryStateAndUr2[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, "", url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($91da240b76094466$var$BeforeUnloadEventType, $91da240b76094466$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($91da240b76094466$var$BeforeUnloadEventType, $91da240b76094466$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $91da240b76094466$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    var _options2 = options, _options2$window = _options2.window, window = _options2$window === void 0 ? document.defaultView : _options2$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _parsePath = $91da240b76094466$export$8ccf933b0513f8d0(window.location.hash.substr(1)), _parsePath$pathname = _parsePath.pathname, pathname = _parsePath$pathname === void 0 ? "/" : _parsePath$pathname, _parsePath$search = _parsePath.search, search = _parsePath$search === void 0 ? "" : _parsePath$search, _parsePath$hash = _parsePath.hash, hash = _parsePath$hash === void 0 ? "" : _parsePath$hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $91da240b76094466$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || "default"
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $91da240b76094466$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation4 = getIndexAndLocation(), nextIndex = _getIndexAndLocation4[0], nextLocation = _getIndexAndLocation4[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($91da240b76094466$var$PopStateEventType, handlePop); // popstate does not fire on hashchange in IE 11 and old (trident) Edge
    // https://developer.mozilla.org/de/docs/Web/API/Window/popstate_event
    window.addEventListener($91da240b76094466$var$HashChangeEventType, function() {
        var _getIndexAndLocation5 = getIndexAndLocation(), nextLocation = _getIndexAndLocation5[1]; // Ignore extraneous hashchange events.
        if ($91da240b76094466$export$fe53371bee54353d(nextLocation) !== $91da240b76094466$export$fe53371bee54353d(location)) handlePop();
    });
    var action = $91da240b76094466$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation6 = getIndexAndLocation(), index = _getIndexAndLocation6[0], location = _getIndexAndLocation6[1];
    var listeners = $91da240b76094466$var$createEvents();
    var blockers = $91da240b76094466$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $628bb797dd3c4d2c$export$2e2bcd8739ae039)({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getBaseHref() {
        var base = document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href;
    }
    function createHref(to) {
        return getBaseHref() + "#" + (typeof to === "string" ? to : $91da240b76094466$export$fe53371bee54353d(to));
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $91da240b76094466$var$readOnly((0, $628bb797dd3c4d2c$export$2e2bcd8739ae039)({
            pathname: location.pathname,
            hash: "",
            search: ""
        }, typeof to === "string" ? $91da240b76094466$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $91da240b76094466$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation7 = getIndexAndLocation();
        index = _getIndexAndLocation7[0];
        location = _getIndexAndLocation7[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $91da240b76094466$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr3 = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr3[0], url = _getHistoryStateAndUr3[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, "", url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $91da240b76094466$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr4 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr4[0], url = _getHistoryStateAndUr4[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, "", url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($91da240b76094466$var$BeforeUnloadEventType, $91da240b76094466$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($91da240b76094466$var$BeforeUnloadEventType, $91da240b76094466$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#creatememoryhistory
 */ function $91da240b76094466$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    var _options3 = options, _options3$initialEntr = _options3.initialEntries, initialEntries = _options3$initialEntr === void 0 ? [
        "/"
    ] : _options3$initialEntr, initialIndex = _options3.initialIndex;
    var entries = initialEntries.map(function(entry) {
        var location = $91da240b76094466$var$readOnly((0, $628bb797dd3c4d2c$export$2e2bcd8739ae039)({
            pathname: "/",
            search: "",
            hash: "",
            state: null,
            key: $91da240b76094466$var$createKey()
        }, typeof entry === "string" ? $91da240b76094466$export$8ccf933b0513f8d0(entry) : entry));
        return location;
    });
    var index = $91da240b76094466$var$clamp(initialIndex == null ? entries.length - 1 : initialIndex, 0, entries.length - 1);
    var action = $91da240b76094466$export$e19cd5f9376f8cee.Pop;
    var location = entries[index];
    var listeners = $91da240b76094466$var$createEvents();
    var blockers = $91da240b76094466$var$createEvents();
    function createHref(to) {
        return typeof to === "string" ? to : $91da240b76094466$export$fe53371bee54353d(to);
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $91da240b76094466$var$readOnly((0, $628bb797dd3c4d2c$export$2e2bcd8739ae039)({
            pathname: location.pathname,
            search: "",
            hash: ""
        }, typeof to === "string" ? $91da240b76094466$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $91da240b76094466$var$createKey()
        }));
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction, nextLocation) {
        action = nextAction;
        location = nextLocation;
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $91da240b76094466$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            applyTx(nextAction, nextLocation);
        }
    }
    function replace(to, state) {
        var nextAction = $91da240b76094466$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            entries[index] = nextLocation;
            applyTx(nextAction, nextLocation);
        }
    }
    function go(delta) {
        var nextIndex = $91da240b76094466$var$clamp(index + delta, 0, entries.length - 1);
        var nextAction = $91da240b76094466$export$e19cd5f9376f8cee.Pop;
        var nextLocation = entries[nextIndex];
        function retry() {
            go(delta);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index = nextIndex;
            applyTx(nextAction, nextLocation);
        }
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            return blockers.push(blocker);
        }
    };
    return history;
} ////////////////////////////////////////////////////////////////////////////////
// UTILS
////////////////////////////////////////////////////////////////////////////////
function $91da240b76094466$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
function $91da240b76094466$var$promptBeforeUnload(event) {
    // Cancel the event.
    event.preventDefault(); // Chrome (and legacy IE) requires returnValue to be set.
    event.returnValue = "";
}
function $91da240b76094466$var$createEvents() {
    var handlers = [];
    return {
        get length () {
            return handlers.length;
        },
        push: function push(fn) {
            handlers.push(fn);
            return function() {
                handlers = handlers.filter(function(handler) {
                    return handler !== fn;
                });
            };
        },
        call: function call(arg) {
            handlers.forEach(function(fn) {
                return fn && fn(arg);
            });
        }
    };
}
function $91da240b76094466$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createpath
 */ function $91da240b76094466$export$fe53371bee54353d(_ref) {
    var _ref$pathname = _ref.pathname, pathname = _ref$pathname === void 0 ? "/" : _ref$pathname, _ref$search = _ref.search, search = _ref$search === void 0 ? "" : _ref$search, _ref$hash = _ref.hash, hash = _ref$hash === void 0 ? "" : _ref$hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#parsepath
 */ function $91da240b76094466$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}


/**
 * React Router v6.2.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7fPBF = parcelRequire("7fPBF");

function $6de75bb8982f6eaa$var$invariant(cond, message) {
    if (!cond) throw new Error(message);
}
function $6de75bb8982f6eaa$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging React Router!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
const $6de75bb8982f6eaa$var$alreadyWarned = {};
function $6de75bb8982f6eaa$var$warningOnce(key, cond, message) {
    if (!cond && !$6de75bb8982f6eaa$var$alreadyWarned[key]) $6de75bb8982f6eaa$var$alreadyWarned[key] = true;
} ///////////////////////////////////////////////////////////////////////////////
// CONTEXT
///////////////////////////////////////////////////////////////////////////////
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level <Router> API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $6de75bb8982f6eaa$export$26749e8557646306 = /*#__PURE__*/ (0, $7fPBF.createContext)(null);
const $6de75bb8982f6eaa$export$c7914228fb69b0f5 = /*#__PURE__*/ (0, $7fPBF.createContext)(null);
const $6de75bb8982f6eaa$export$9072aa6dd1f93057 = /*#__PURE__*/ (0, $7fPBF.createContext)({
    outlet: null,
    matches: []
});
// COMPONENTS
///////////////////////////////////////////////////////////////////////////////
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/docs/en/v6/api#memoryrouter
 */ function $6de75bb8982f6eaa$export$ae46f04cfaffe093(_ref) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex } = _ref;
    let historyRef = (0, $7fPBF.useRef)();
    if (historyRef.current == null) historyRef.current = (0, $91da240b76094466$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex
    });
    let history = historyRef.current;
    let [state, setState] = (0, $7fPBF.useState)({
        action: history.action,
        location: history.location
    });
    (0, $7fPBF.useLayoutEffect)(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ (0, $7fPBF.createElement)($6de75bb8982f6eaa$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/docs/en/v6/api#navigate
 */ function $6de75bb8982f6eaa$export$444b3ab0cb9aec40(_ref2) {
    let { to: to, replace: replace, state: state } = _ref2;
    !$6de75bb8982f6eaa$export$9c954a9d03d32f4a() && $6de75bb8982f6eaa$var$invariant(false);
    let navigate = $6de75bb8982f6eaa$export$9770f232ac06a008();
    (0, $7fPBF.useEffect)(()=>{
        navigate(to, {
            replace: replace,
            state: state
        });
    });
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/docs/en/v6/api#outlet
 */ function $6de75bb8982f6eaa$export$910ae8079b2c2852(props) {
    return $6de75bb8982f6eaa$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/docs/en/v6/api#route
 */ function $6de75bb8982f6eaa$export$e7b0ac011bb776c6(_props) {
    $6de75bb8982f6eaa$var$invariant(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/docs/en/v6/api#router
 */ function $6de75bb8982f6eaa$export$55185c17a0fcbe46(_ref3) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $91da240b76094466$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref3;
    !!$6de75bb8982f6eaa$export$9c954a9d03d32f4a() && $6de75bb8982f6eaa$var$invariant(false);
    let basename = $6de75bb8982f6eaa$var$normalizePathname(basenameProp);
    let navigationContext = (0, $7fPBF.useMemo)(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $91da240b76094466$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let location = (0, $7fPBF.useMemo)(()=>{
        let trailingPathname = $6de75bb8982f6eaa$var$stripBasename(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            pathname: trailingPathname,
            search: search,
            hash: hash,
            state: state,
            key: key
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key
    ]);
    if (location == null) return null;
    return /*#__PURE__*/ (0, $7fPBF.createElement)($6de75bb8982f6eaa$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ (0, $7fPBF.createElement)($6de75bb8982f6eaa$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: {
            location: location,
            navigationType: navigationType
        }
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/docs/en/v6/api#routes
 */ function $6de75bb8982f6eaa$export$3565eb3d00ca5a74(_ref4) {
    let { children: children, location: location } = _ref4;
    return $6de75bb8982f6eaa$export$5d3fca4a98652595($6de75bb8982f6eaa$export$16da398f5434bdec(children), location);
} ///////////////////////////////////////////////////////////////////////////////
// HOOKS
///////////////////////////////////////////////////////////////////////////////
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/docs/en/v6/api#usehref
 */ function $6de75bb8982f6eaa$export$b66bb29c5006f12f(to) {
    !$6de75bb8982f6eaa$export$9c954a9d03d32f4a() && $6de75bb8982f6eaa$var$invariant(false);
    let { basename: basename, navigator: navigator } = (0, $7fPBF.useContext)($6de75bb8982f6eaa$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $6de75bb8982f6eaa$export$e75d2a2d1b3c245b(to);
    let joinedPathname = pathname;
    if (basename !== "/") {
        let toPathname = $6de75bb8982f6eaa$var$getToPathname(to);
        let endsWithSlash = toPathname != null && toPathname.endsWith("/");
        joinedPathname = pathname === "/" ? basename + (endsWithSlash ? "/" : "") : $6de75bb8982f6eaa$var$joinPaths([
            basename,
            pathname
        ]);
    }
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useinroutercontext
 */ function $6de75bb8982f6eaa$export$9c954a9d03d32f4a() {
    return (0, $7fPBF.useContext)($6de75bb8982f6eaa$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/docs/en/v6/api#uselocation
 */ function $6de75bb8982f6eaa$export$45d76561a5302f2b() {
    !$6de75bb8982f6eaa$export$9c954a9d03d32f4a() && $6de75bb8982f6eaa$var$invariant(false);
    return (0, $7fPBF.useContext)($6de75bb8982f6eaa$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/docs/en/v6/api#usenavigationtype
 */ function $6de75bb8982f6eaa$export$1b3f31771c5d07c() {
    return (0, $7fPBF.useContext)($6de75bb8982f6eaa$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns true if the URL for the given "to" value matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/docs/en/v6/api#usematch
 */ function $6de75bb8982f6eaa$export$6c330e8992e8a295(pattern) {
    !$6de75bb8982f6eaa$export$9c954a9d03d32f4a() && $6de75bb8982f6eaa$var$invariant(false);
    let { pathname: pathname } = $6de75bb8982f6eaa$export$45d76561a5302f2b();
    return (0, $7fPBF.useMemo)(()=>$6de75bb8982f6eaa$export$81336c211d5ff295(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ /**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/docs/en/v6/api#usenavigate
 */ function $6de75bb8982f6eaa$export$9770f232ac06a008() {
    !$6de75bb8982f6eaa$export$9c954a9d03d32f4a() && $6de75bb8982f6eaa$var$invariant(false);
    let { basename: basename, navigator: navigator } = (0, $7fPBF.useContext)($6de75bb8982f6eaa$export$26749e8557646306);
    let { matches: matches } = (0, $7fPBF.useContext)($6de75bb8982f6eaa$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6de75bb8982f6eaa$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify(matches.map((match)=>match.pathnameBase));
    let activeRef = (0, $7fPBF.useRef)(false);
    (0, $7fPBF.useEffect)(()=>{
        activeRef.current = true;
    });
    let navigate = (0, $7fPBF.useCallback)(function(to, options) {
        if (options === void 0) options = {};
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $6de75bb8982f6eaa$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname);
        if (basename !== "/") path.pathname = $6de75bb8982f6eaa$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname
    ]);
    return navigate;
}
const $6de75bb8982f6eaa$var$OutletContext = /*#__PURE__*/ (0, $7fPBF.createContext)(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/docs/en/v6/api#useoutletcontext
 */ function $6de75bb8982f6eaa$export$4138103a3ae699cc() {
    return (0, $7fPBF.useContext)($6de75bb8982f6eaa$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useoutlet
 */ function $6de75bb8982f6eaa$export$a3be3530d8e40d0b(context) {
    let outlet = (0, $7fPBF.useContext)($6de75bb8982f6eaa$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ (0, $7fPBF.createElement)($6de75bb8982f6eaa$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useparams
 */ function $6de75bb8982f6eaa$export$99eaa27ddbbb95ef() {
    let { matches: matches } = (0, $7fPBF.useContext)($6de75bb8982f6eaa$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useresolvedpath
 */ function $6de75bb8982f6eaa$export$e75d2a2d1b3c245b(to) {
    let { matches: matches } = (0, $7fPBF.useContext)($6de75bb8982f6eaa$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6de75bb8982f6eaa$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify(matches.map((match)=>match.pathnameBase));
    return (0, $7fPBF.useMemo)(()=>$6de75bb8982f6eaa$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname), [
        to,
        routePathnamesJson,
        locationPathname
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/docs/en/v6/api#useroutes
 */ function $6de75bb8982f6eaa$export$5d3fca4a98652595(routes, locationArg) {
    !$6de75bb8982f6eaa$export$9c954a9d03d32f4a() && $6de75bb8982f6eaa$var$invariant(false);
    let { matches: parentMatches } = (0, $7fPBF.useContext)($6de75bb8982f6eaa$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $6de75bb8982f6eaa$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $91da240b76094466$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && $6de75bb8982f6eaa$var$invariant(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = $6de75bb8982f6eaa$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    return $6de75bb8982f6eaa$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $6de75bb8982f6eaa$var$joinPaths([
                parentPathnameBase,
                match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $6de75bb8982f6eaa$var$joinPaths([
                parentPathnameBase,
                match.pathnameBase
            ])
        })), parentMatches);
} ///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/docs/en/v6/api#createroutesfromchildren
 */ function $6de75bb8982f6eaa$export$16da398f5434bdec(children) {
    let routes = [];
    (0, $7fPBF.Children).forEach(children, (element)=>{
        if (!/*#__PURE__*/ (0, $7fPBF.isValidElement)(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        if (element.type === (0, $7fPBF.Fragment)) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $6de75bb8982f6eaa$export$16da398f5434bdec(element.props.children));
            return;
        }
        !(element.type === $6de75bb8982f6eaa$export$e7b0ac011bb776c6) && $6de75bb8982f6eaa$var$invariant(false);
        let route = {
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            index: element.props.index,
            path: element.props.path
        };
        if (element.props.children) route.children = $6de75bb8982f6eaa$export$16da398f5434bdec(element.props.children);
        routes.push(route);
    });
    return routes;
}
/**
 * The parameters that were parsed from the URL path.
 */ /**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/docs/en/v6/api#generatepath
 */ function $6de75bb8982f6eaa$export$82476f982757e71e(path, params) {
    if (params === void 0) params = {};
    return path.replace(/:(\w+)/g, (_, key)=>{
        !(params[key] != null) && $6de75bb8982f6eaa$var$invariant(false);
        return params[key];
    }).replace(/\/*\*$/, (_)=>params["*"] == null ? "" : params["*"].replace(/^\/*/, "/"));
}
/**
 * A RouteMatch contains info about how a route matched a URL.
 */ /**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/docs/en/v6/api#matchroutes
 */ function $6de75bb8982f6eaa$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? (0, $91da240b76094466$export$8ccf933b0513f8d0)(locationArg) : locationArg;
    let pathname = $6de75bb8982f6eaa$var$stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $6de75bb8982f6eaa$var$flattenRoutes(routes);
    $6de75bb8982f6eaa$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $6de75bb8982f6eaa$var$matchRouteBranch(branches[i], pathname);
    return matches;
}
function $6de75bb8982f6eaa$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    routes.forEach((route, index)=>{
        let meta = {
            relativePath: route.path || "",
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            !meta.relativePath.startsWith(parentPath) && $6de75bb8982f6eaa$var$invariant(false);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $6de75bb8982f6eaa$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta); // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            !(route.index !== true) && $6de75bb8982f6eaa$var$invariant(false);
            $6de75bb8982f6eaa$var$flattenRoutes(route.children, branches, routesMeta, path);
        } // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $6de75bb8982f6eaa$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    });
    return branches;
}
function $6de75bb8982f6eaa$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $6de75bb8982f6eaa$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $6de75bb8982f6eaa$var$paramRe = /^:\w+$/;
const $6de75bb8982f6eaa$var$dynamicSegmentValue = 3;
const $6de75bb8982f6eaa$var$indexRouteValue = 2;
const $6de75bb8982f6eaa$var$emptySegmentValue = 1;
const $6de75bb8982f6eaa$var$staticSegmentValue = 10;
const $6de75bb8982f6eaa$var$splatPenalty = -2;
const $6de75bb8982f6eaa$var$isSplat = (s)=>s === "*";
function $6de75bb8982f6eaa$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($6de75bb8982f6eaa$var$isSplat)) initialScore += $6de75bb8982f6eaa$var$splatPenalty;
    if (index) initialScore += $6de75bb8982f6eaa$var$indexRouteValue;
    return segments.filter((s)=>!$6de75bb8982f6eaa$var$isSplat(s)).reduce((score, segment)=>score + ($6de75bb8982f6eaa$var$paramRe.test(segment) ? $6de75bb8982f6eaa$var$dynamicSegmentValue : segment === "" ? $6de75bb8982f6eaa$var$emptySegmentValue : $6de75bb8982f6eaa$var$staticSegmentValue), initialScore);
}
function $6de75bb8982f6eaa$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // so they sort equally.
    0;
}
function $6de75bb8982f6eaa$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $6de75bb8982f6eaa$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            params: matchedParams,
            pathname: $6de75bb8982f6eaa$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $6de75bb8982f6eaa$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ]),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $6de75bb8982f6eaa$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $6de75bb8982f6eaa$export$daf73786167a7f72(matches) {
    return $6de75bb8982f6eaa$var$_renderMatches(matches);
}
function $6de75bb8982f6eaa$var$_renderMatches(matches, parentMatches) {
    if (parentMatches === void 0) parentMatches = [];
    if (matches == null) return null;
    return matches.reduceRight((outlet, match, index)=>{
        return /*#__PURE__*/ (0, $7fPBF.createElement)($6de75bb8982f6eaa$export$9072aa6dd1f93057.Provider, {
            children: match.route.element !== undefined ? match.route.element : /*#__PURE__*/ (0, $7fPBF.createElement)($6de75bb8982f6eaa$export$910ae8079b2c2852, null),
            value: {
                outlet: outlet,
                matches: parentMatches.concat(matches.slice(0, index + 1))
            }
        });
    }, null);
}
/**
 * A PathPattern is used to match on some portion of a URL pathname.
 */ /**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/docs/en/v6/api#matchpath
 */ function $6de75bb8982f6eaa$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $6de75bb8982f6eaa$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $6de75bb8982f6eaa$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $6de75bb8982f6eaa$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else regexpSource += end ? "\\/*$" // When matching to the end, ignore trailing slashes
     : // parent routes to matching only their own words and nothing more, e.g. parent
    // route "/home" should not match "/home2".
    "(?:\\b|\\/|$)";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $6de75bb8982f6eaa$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/docs/en/v6/api#resolvepath
 */ function $6de75bb8982f6eaa$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? (0, $91da240b76094466$export$8ccf933b0513f8d0)(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $6de75bb8982f6eaa$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $6de75bb8982f6eaa$var$normalizeSearch(search),
        hash: $6de75bb8982f6eaa$var$normalizeHash(hash)
    };
}
function $6de75bb8982f6eaa$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $6de75bb8982f6eaa$var$resolveTo(toArg, routePathnames, locationPathname) {
    let to = typeof toArg === "string" ? (0, $91da240b76094466$export$8ccf933b0513f8d0)(toArg) : toArg;
    let toPathname = toArg === "" || to.pathname === "" ? "/" : to.pathname; // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/"); // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        } // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $6de75bb8982f6eaa$export$b09f2ff0bbcb43c7(to, from); // Ensure the pathname has a trailing slash if the original to value had one.
    if (toPathname && toPathname !== "/" && toPathname.endsWith("/") && !path.pathname.endsWith("/")) path.pathname += "/";
    return path;
}
function $6de75bb8982f6eaa$var$getToPathname(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? (0, $91da240b76094466$export$8ccf933b0513f8d0)(to).pathname : to.pathname;
}
function $6de75bb8982f6eaa$var$stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let nextChar = pathname.charAt(basename.length);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(basename.length) || "/";
}
const $6de75bb8982f6eaa$var$joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
const $6de75bb8982f6eaa$var$normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
const $6de75bb8982f6eaa$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
const $6de75bb8982f6eaa$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash; ///////////////////////////////////////////////////////////////////////////////


function $1a29469ea96a6022$var$_extends() {
    $1a29469ea96a6022$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1a29469ea96a6022$var$_extends.apply(this, arguments);
}
function $1a29469ea96a6022$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $1a29469ea96a6022$var$_excluded = [
    "onClick",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to"
], $1a29469ea96a6022$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
];
function $1a29469ea96a6022$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging React Router!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
} ////////////////////////////////////////////////////////////////////////////////
// COMPONENTS
////////////////////////////////////////////////////////////////////////////////
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $1a29469ea96a6022$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, window: window } = _ref;
    let historyRef = (0, $7fPBF.useRef)();
    if (historyRef.current == null) historyRef.current = (0, $91da240b76094466$export$719fc203c4e16dee)({
        window: window
    });
    let history = historyRef.current;
    let [state, setState] = (0, $7fPBF.useState)({
        action: history.action,
        location: history.location
    });
    (0, $7fPBF.useLayoutEffect)(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ (0, $7fPBF.createElement)((0, $6de75bb8982f6eaa$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $1a29469ea96a6022$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, window: window } = _ref2;
    let historyRef = (0, $7fPBF.useRef)();
    if (historyRef.current == null) historyRef.current = (0, $91da240b76094466$export$b71fdd3798280242)({
        window: window
    });
    let history = historyRef.current;
    let [state, setState] = (0, $7fPBF.useState)({
        action: history.action,
        location: history.location
    });
    (0, $7fPBF.useLayoutEffect)(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ (0, $7fPBF.createElement)((0, $6de75bb8982f6eaa$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $1a29469ea96a6022$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, history: history } = _ref3;
    const [state, setState] = (0, $7fPBF.useState)({
        action: history.action,
        location: history.location
    });
    (0, $7fPBF.useLayoutEffect)(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ (0, $7fPBF.createElement)((0, $6de75bb8982f6eaa$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
function $1a29469ea96a6022$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
/**
 * The public API for rendering a history-aware <a>.
 */ const $1a29469ea96a6022$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, reloadDocument: reloadDocument, replace: replace = false, state: state, target: target, to: to } = _ref4, rest = $1a29469ea96a6022$var$_objectWithoutPropertiesLoose(_ref4, $1a29469ea96a6022$var$_excluded);
    let href = (0, $6de75bb8982f6eaa$export$b66bb29c5006f12f)(to);
    let internalOnClick = $1a29469ea96a6022$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented && !reloadDocument) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    (0, $7fPBF.createElement)("a", $1a29469ea96a6022$var$_extends({}, rest, {
        href: href,
        onClick: handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $1a29469ea96a6022$export$b0d92dbee9b5b60d = /*#__PURE__*/ (0, $7fPBF.forwardRef)(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $1a29469ea96a6022$var$_objectWithoutPropertiesLoose(_ref5, $1a29469ea96a6022$var$_excluded2);
    let location = (0, $6de75bb8982f6eaa$export$45d76561a5302f2b)();
    let path = (0, $6de75bb8982f6eaa$export$e75d2a2d1b3c245b)(to);
    let locationPathname = location.pathname;
    let toPathname = path.pathname;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive
    }) : styleProp;
    return /*#__PURE__*/ (0, $7fPBF.createElement)($1a29469ea96a6022$export$a6c7ac8248d6e38a, $1a29469ea96a6022$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive
    }) : children);
});
// HOOKS
////////////////////////////////////////////////////////////////////////////////
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $1a29469ea96a6022$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $6de75bb8982f6eaa$export$9770f232ac06a008)();
    let location = (0, $6de75bb8982f6eaa$export$45d76561a5302f2b)();
    let path = (0, $6de75bb8982f6eaa$export$e75d2a2d1b3c245b)(to);
    return (0, $7fPBF.useCallback)((event)=>{
        if (event.button === 0 && (!target || target === "_self") && // Let browser handle "target=_blank" etc.
        !$1a29469ea96a6022$var$isModifiedEvent(event) // Ignore clicks with modifier keys
        ) {
            event.preventDefault(); // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here.
            let replace = !!replaceProp || (0, $91da240b76094466$export$fe53371bee54353d)(location) === (0, $91da240b76094466$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $1a29469ea96a6022$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = (0, $7fPBF.useRef)($1a29469ea96a6022$export$a2e4e2dcc7b1f22f(defaultInit));
    let location = (0, $6de75bb8982f6eaa$export$45d76561a5302f2b)();
    let searchParams = (0, $7fPBF.useMemo)(()=>{
        let searchParams = $1a29469ea96a6022$export$a2e4e2dcc7b1f22f(location.search);
        for (let key of defaultSearchParamsRef.current.keys())if (!searchParams.has(key)) defaultSearchParamsRef.current.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
        return searchParams;
    }, [
        location.search
    ]);
    let navigate = (0, $6de75bb8982f6eaa$export$9770f232ac06a008)();
    let setSearchParams = (0, $7fPBF.useCallback)((nextInit, navigateOptions)=>{
        navigate("?" + $1a29469ea96a6022$export$a2e4e2dcc7b1f22f(nextInit), navigateOptions);
    }, [
        navigate
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $1a29469ea96a6022$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}


function $6fd93f5a7f6231fc$export$8b251419efc915eb(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        style: {
            width: "100%",
            padding: 20,
            backgroundImage: "url(" + (0, (/*@__PURE__*/$parcel$interopDefault($6cab325760b0af7c$exports))) + ")",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "50%",
            borderRadius: 16,
            position: "relative",
            zIndex: 1,
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                style: {
                    background: "linear-gradient(0deg, rgba(0,0,0,0.6) 0%, rgba(238,246,252,0) 30%)",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    zIndex: -1
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    flexWrap: "wrap"
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1a29469ea96a6022$export$a6c7ac8248d6e38a), {
                        to: "/",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            style: {
                                width: 300,
                                height: 140,
                                overflow: "hidden"
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                style: {
                                    width: "100%",
                                    height: "100%",
                                    backgroundImage: "url(" + (0, (/*@__PURE__*/$parcel$interopDefault($aba35fd891fdedeb$exports))) + ")",
                                    backgroundSize: "120%",
                                    backgroundRepeat: "no-repeat",
                                    backgroundPosition: "50%"
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                        style: {
                            textTransform: "uppercase",
                            textShadow: "0 0 10px #444",
                            margin: 0,
                            color: "white"
                        },
                        children: props.label
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($6fd93f5a7f6231fc$var$Nav, {})
        ]
    });
}
function $6fd93f5a7f6231fc$var$Nav() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        style: {
            width: "100%",
            display: "flex",
            justifyContent: "center",
            marginTop: 20
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            style: {
                display: "flex",
                flexWrap: "wrap"
            },
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $593b59ea7ea0c236$export$353f5b6fc5456de1), {
                    link: "https://ring-of-titans.fandom.com",
                    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("i", {
                        className: "fas fa-book"
                    }),
                    style: {
                        borderTopLeftRadius: 12,
                        borderBottomLeftRadius: 12
                    },
                    children: "WIKI"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1a29469ea96a6022$export$a6c7ac8248d6e38a), {
                    to: "/titans",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $593b59ea7ea0c236$export$353f5b6fc5456de1), {
                        icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("i", {
                            className: "fas fa-bars"
                        }),
                        style: {},
                        children: "TITANS"
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1a29469ea96a6022$export$a6c7ac8248d6e38a), {
                    to: "/leaderboards",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $593b59ea7ea0c236$export$353f5b6fc5456de1), {
                        icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("i", {
                            className: "fas fa-crown"
                        }),
                        style: {},
                        children: "LEADERBOARDS"
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1a29469ea96a6022$export$a6c7ac8248d6e38a), {
                    to: "/patchnotes",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $593b59ea7ea0c236$export$353f5b6fc5456de1), {
                        icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("i", {
                            className: "fas fa-book"
                        }),
                        style: {},
                        children: "PATCH NOTES"
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $593b59ea7ea0c236$export$353f5b6fc5456de1), {
                    link: "https://store.steampowered.com/app/1460550/Ring_of_Titans/",
                    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("i", {
                        className: "fab fa-steam"
                    }),
                    target: "_blank",
                    style: {
                        borderBottomRightRadius: 12,
                        borderTopRightRadius: 12
                    },
                    children: "PLAY FREE"
                })
            ]
        })
    });
}





function $27761470cadbd47e$export$a06f1c675e846f6f(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        style: {
            position: "relative",
            zIndex: 1,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 8,
            width: "100%",
            padding: 20
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                style: {
                    width: "100%",
                    display: "flex",
                    justifyContent: "center"
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        gap: 8
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $593b59ea7ea0c236$export$353f5b6fc5456de1), {
                            link: "https://discord.gg/Rgy9wVQcqK",
                            icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("i", {
                                className: "fab fa-discord"
                            }),
                            target: "_blank",
                            style: {
                                borderRadius: 16,
                                paddingTop: 8,
                                paddingBottom: 8
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $593b59ea7ea0c236$export$353f5b6fc5456de1), {
                            link: "https://twitter.com/ringoftitansgg",
                            icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("i", {
                                className: "fab fa-twitter"
                            }),
                            target: "_blank",
                            style: {
                                borderRadius: 16,
                                paddingTop: 8,
                                paddingBottom: 8
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $593b59ea7ea0c236$export$353f5b6fc5456de1), {
                            link: "https://reddit.com/r/ringoftitans",
                            icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("i", {
                                className: "fab fa-reddit"
                            }),
                            target: "_blank",
                            style: {
                                borderRadius: 16,
                                paddingTop: 8,
                                paddingBottom: 8
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $593b59ea7ea0c236$export$353f5b6fc5456de1), {
                            link: "https://www.facebook.com/ringoftitans/",
                            icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("i", {
                                className: "fab fa-facebook"
                            }),
                            target: "_blank",
                            style: {
                                borderRadius: 16,
                                paddingTop: 8,
                                paddingBottom: 8
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $593b59ea7ea0c236$export$353f5b6fc5456de1), {
                            link: "https://www.youtube.com/@ringoftitans",
                            icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("i", {
                                className: "fab fa-youtube"
                            }),
                            target: "_blank",
                            style: {
                                borderRadius: 16,
                                paddingTop: 8,
                                paddingBottom: 8
                            }
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $593b59ea7ea0c236$export$353f5b6fc5456de1), {
                            link: "https://store.steampowered.com/app/1460550/Ring_of_Titans/",
                            icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("i", {
                                className: "fab fa-steam"
                            }),
                            target: "_blank",
                            style: {
                                borderRadius: 16,
                                paddingTop: 8,
                                paddingBottom: 8
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    gap: 8,
                    flexWrap: "wrap",
                    justifyContent: "center"
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1a29469ea96a6022$export$a6c7ac8248d6e38a), {
                        to: "/link/discord",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $593b59ea7ea0c236$export$353f5b6fc5456de1), {
                            icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("i", {
                                className: "fab fa-discord"
                            }),
                            style: {
                                borderRadius: 12,
                                padding: "8px 12px"
                            },
                            children: "LINK YOUR DISCORD"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $593b59ea7ea0c236$export$353f5b6fc5456de1), {
                        icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("i", {
                            className: "fas fa-newspaper"
                        }),
                        style: {
                            borderRadius: 12,
                            padding: "8px 12px"
                        },
                        link: "https://impress.games/press-kit/mash/ring-of-titans",
                        children: "PRESSKIT"
                    })
                ]
            })
        ]
    });
}


function $032aab6647148487$export$6d1402fb58384e4f(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                style: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 20,
                    background: "#040404"
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        width: props.width ? props.width : 960,
                        maxWidth: "100%",
                        margin: "20px auto",
                        gap: 20
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            style: {
                                width: 960,
                                maxWidth: "100%"
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6fd93f5a7f6231fc$export$8b251419efc915eb), {
                                label: props.label
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            style: {
                                padding: 20,
                                background: "rgba(0, 0, 0, 0.5)",
                                borderRadius: 16,
                                width: "100%",
                                zIndex: 0,
                                ...props.style
                            },
                            children: props.children
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $27761470cadbd47e$export$a06f1c675e846f6f), {})
        ]
    });
}



var $lTQU8 = parcelRequire("lTQU8");

var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $5605a1df2b1e9ff0$export$8793edee2d425525 = function() {};
function $5605a1df2b1e9ff0$export$af631764ddc44097(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.addEventListener) obj.addEventListener.apply(obj, args);
}
function $5605a1df2b1e9ff0$export$8c8705df4a2dcec9(obj) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (obj && obj.removeEventListener) obj.removeEventListener.apply(obj, args);
}
var $5605a1df2b1e9ff0$export$4e09c449d6c407f7 = typeof window !== "undefined";
var $5605a1df2b1e9ff0$export$42e7ac6120dd324e = typeof navigator !== "undefined";


var $a779c50d8cc42ab2$var$useIsomorphicLayoutEffect = (0, $5605a1df2b1e9ff0$export$4e09c449d6c407f7) ? (0, $7fPBF.useLayoutEffect) : (0, $7fPBF.useEffect);
var $a779c50d8cc42ab2$export$2e2bcd8739ae039 = $a779c50d8cc42ab2$var$useIsomorphicLayoutEffect;



var $a866348bf32b3b60$var$defaultState = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
};
function $a866348bf32b3b60$var$useMeasure() {
    var _a = (0, $7fPBF.useState)(null), element = _a[0], ref = _a[1];
    var _b = (0, $7fPBF.useState)($a866348bf32b3b60$var$defaultState), rect = _b[0], setRect = _b[1];
    var observer = (0, $7fPBF.useMemo)(function() {
        return new window.ResizeObserver(function(entries) {
            if (entries[0]) {
                var _a = entries[0].contentRect, x = _a.x, y = _a.y, width = _a.width, height = _a.height, top_1 = _a.top, left = _a.left, bottom = _a.bottom, right = _a.right;
                setRect({
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    top: top_1,
                    left: left,
                    bottom: bottom,
                    right: right
                });
            }
        });
    }, []);
    (0, $a779c50d8cc42ab2$export$2e2bcd8739ae039)(function() {
        if (!element) return;
        observer.observe(element);
        return function() {
            observer.disconnect();
        };
    }, [
        element
    ]);
    return [
        ref,
        rect
    ];
}
var $a866348bf32b3b60$export$2e2bcd8739ae039 = (0, $5605a1df2b1e9ff0$export$4e09c449d6c407f7) && typeof window.ResizeObserver !== "undefined" ? $a866348bf32b3b60$var$useMeasure : function() {
    return [
        (0, $5605a1df2b1e9ff0$export$8793edee2d425525),
        $a866348bf32b3b60$var$defaultState
    ];
};


const $593b59ea7ea0c236$export$353f5b6fc5456de1 = ({ icon: icon, afterIcon: afterIcon, spinIcon: spinIcon, children: children, link: link, onClick: onClick, target: target, style: style })=>{
    const targetOpt = {};
    if (target) targetOpt.target = target;
    const extraIconStyles = spinIcon ? {
        animation: "spin 800ms linear infinite"
    } : {};
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
        href: link,
        onClick: onClick,
        ...targetOpt,
        style: {
            textDecoration: "none"
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "btn",
            style: {
                display: "flex",
                gap: 8,
                padding: 16,
                cursor: "pointer",
                textShadow: "0 0 5px black",
                color: "white",
                lineHeight: 1,
                ...style
            },
            children: [
                icon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    style: {
                        display: "inline-block",
                        ...extraIconStyles
                    },
                    children: icon
                }),
                children,
                afterIcon && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    style: {
                        display: "inline-block",
                        ...extraIconStyles
                    },
                    children: afterIcon
                })
            ]
        })
    });
};
const $593b59ea7ea0c236$var$NumField = ({ amt: amt, label: label })=>{
    if (amt < 10) amt = "0" + amt;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "column"
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: amt
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                style: {
                    fontSize: 24,
                    fontWeight: 100
                },
                children: label
            })
        ]
    });
};
const $593b59ea7ea0c236$var$countdownRenderer = ({ days: days, hours: hours, minutes: minutes, seconds: seconds, completed: completed, props: props })=>{
    if (completed) return props.children;
    else return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        style: {
            textAlign: "center",
            display: "flex",
            gap: 40,
            flexWrap: "wrap",
            justifyContent: "center"
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($593b59ea7ea0c236$var$NumField, {
                label: "DAYS",
                amt: days
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($593b59ea7ea0c236$var$NumField, {
                label: "HOURS",
                amt: hours
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($593b59ea7ea0c236$var$NumField, {
                label: "MINUTES",
                amt: minutes
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($593b59ea7ea0c236$var$NumField, {
                label: "SECONDS",
                amt: seconds
            })
        ]
    });
};
function $593b59ea7ea0c236$var$LandingPage() {
    const [ref, { x: x, y: y, width: width, height: height, top: top, right: right, bottom: bottom, left: left }] = (0, $a866348bf32b3b60$export$2e2bcd8739ae039)();
    const trailerWidth = width;
    const trailerHeight = trailerWidth / (16 / 9);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $032aab6647148487$export$6d1402fb58384e4f), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            ref: ref,
            style: {
                display: "flex",
                flexDirection: "column",
                alignItems: "stretch",
                gap: 20,
                width: "100%"
            },
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bee696b036d759c9$export$60332b2344f7fe41), {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        style: {
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: 20
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                style: {
                                    fontSize: 40,
                                    lineHeight: 1
                                },
                                children: "SEASON 2 RELEASES IN"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                style: {
                                    fontSize: 66,
                                    lineHeight: 1,
                                    fontWeight: 800,
                                    fontFamily: '"Roboto Mono", monospace'
                                },
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $lTQU8.default), {
                                    date: 1746291600000,
                                    renderer: $593b59ea7ea0c236$var$countdownRenderer,
                                    children: "SEASON 2 IS LIVE NOW"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $95341668bcbb7769$export$f51f4c4ede09e011), {
                    gap: "2",
                    align: "start",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bee696b036d759c9$export$60332b2344f7fe41), {
                        style: {
                            width: "100%",
                            flexShrink: 0,
                            maxWidth: trailerWidth
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $838adec7d930b2c0$export$45e6362c68fff4f8), {
                                clip: "padding-box",
                                side: "top",
                                pb: "current",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("iframe", {
                                    style: {
                                        width: "100%",
                                        height: trailerHeight
                                    },
                                    src: "https://www.youtube.com/embed/cs_Osz5ph4E?autoplay=1&loop=1&modestbranding=1&mute=1",
                                    title: "YouTube video player",
                                    frameBorder: "0",
                                    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                                    allowFullScreen: true
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $83db9e82a643d7a4$export$5f1af8db9871e1d6), {
                                as: "p",
                                size: "3",
                                style: {
                                    fontFamily: '"Montserrat", sans-serif'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                        children: "Ring of Titans"
                                    }),
                                    " is a modern take on the small-scale fast-paced arena genre. Pick a Titan and queue up to play 1v1, 2v2, or 3v3, the first team to eliminate everyone from the other team wins. No grinding, no pay to win, no RNG. Just queue and play."
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}
var $593b59ea7ea0c236$export$2e2bcd8739ae039 = $593b59ea7ea0c236$var$LandingPage;




var $7fPBF = parcelRequire("7fPBF");
var $ced2bca4b04dc0d9$exports = {};
$ced2bca4b04dc0d9$exports = new URL("mage.16133bbc.png", import.meta.url).toString();


var $91214974a4505acb$exports = {};
$91214974a4505acb$exports = new URL("rogue.415138ed.png", import.meta.url).toString();


var $8f58763fc858f573$exports = {};
$8f58763fc858f573$exports = new URL("priest.44bc4143.png", import.meta.url).toString();


var $d662445dc22e608e$exports = {};
$d662445dc22e608e$exports = new URL("warlock.01f44c8e.png", import.meta.url).toString();


var $04e7740abd1b7773$exports = {};
$04e7740abd1b7773$exports = new URL("warrior.c1fa2d46.png", import.meta.url).toString();


var $d64390d43a823463$exports = {};
$d64390d43a823463$exports = new URL("druid.a6091e44.png", import.meta.url).toString();


var $9e13773973309a8e$exports = {};
$9e13773973309a8e$exports = new URL("hunter.2db1e2af.png", import.meta.url).toString();


var $01f87719a9a60f47$exports = {};
$01f87719a9a60f47$exports = new URL("paladin.45269b78.png", import.meta.url).toString();


var $942f72df8870c063$exports = {};
$942f72df8870c063$exports = new URL("soulstealer.6885a998.png", import.meta.url).toString();


var $1ad995008f55d4b9$exports = {};
$1ad995008f55d4b9$exports = new URL("crystalmage.5fbf4fb7.png", import.meta.url).toString();


var $37fa17704c2c463c$exports = {};
$37fa17704c2c463c$exports = new URL("bruiser.7d408668.png", import.meta.url).toString();


var $2eca6277e971ca99$exports = {};
$2eca6277e971ca99$exports = new URL("blademaster.22c09ca4.png", import.meta.url).toString();


var $c284eba5c33e2fd5$exports = {};
$c284eba5c33e2fd5$exports = new URL("eradicator.e111fb3f.png", import.meta.url).toString();


var $554b5f7607202234$exports = {};
$554b5f7607202234$exports = new URL("smiter.f05b7a65.png", import.meta.url).toString();


var $5234bb79c235e4dc$exports = {};
$5234bb79c235e4dc$exports = new URL("stormcaller.6256ea09.png", import.meta.url).toString();


var $d8004ab6de1569d7$exports = {};
$d8004ab6de1569d7$exports = new URL("marksman.73cc29a3.png", import.meta.url).toString();


var $2fb13c1bc62427bf$exports = {};
$2fb13c1bc62427bf$exports = new URL("unranked.c642ff10.png", import.meta.url).toString();


var $43a92d3d36619867$exports = {};
$43a92d3d36619867$exports = new URL("Bronze1.873cd9b3.png", import.meta.url).toString();


var $b84c1348a88bd27c$exports = {};
$b84c1348a88bd27c$exports = new URL("Bronze2.75352fd0.png", import.meta.url).toString();


var $a73a186b2585051d$exports = {};
$a73a186b2585051d$exports = new URL("Bronze3.8af22458.png", import.meta.url).toString();


var $bebfd4a6184143fe$exports = {};
$bebfd4a6184143fe$exports = new URL("silver1.51ca2532.png", import.meta.url).toString();


var $3e7904860ca9656d$exports = {};
$3e7904860ca9656d$exports = new URL("silver2.bd792a2d.png", import.meta.url).toString();


var $efe897d6529bda5c$exports = {};
$efe897d6529bda5c$exports = new URL("silver3.a0440a87.png", import.meta.url).toString();


var $a296b61bac502e0a$exports = {};
$a296b61bac502e0a$exports = new URL("gold1.66595575.png", import.meta.url).toString();


var $1cc8b0aaa1acdbf7$exports = {};
$1cc8b0aaa1acdbf7$exports = new URL("gold2.f2722292.png", import.meta.url).toString();


var $1d6c7b0e3248c862$exports = {};
$1d6c7b0e3248c862$exports = new URL("gold3.565cd697.png", import.meta.url).toString();


var $311dd5c675fee100$exports = {};
$311dd5c675fee100$exports = new URL("platinum1.f23806cf.png", import.meta.url).toString();


var $f24172bb4d6362c4$exports = {};
$f24172bb4d6362c4$exports = new URL("platinum2.23d2ea8c.png", import.meta.url).toString();


var $afa6ad9a48137ecd$exports = {};
$afa6ad9a48137ecd$exports = new URL("platinum3.5d7e469a.png", import.meta.url).toString();


var $bdf50a473bd9e243$exports = {};
$bdf50a473bd9e243$exports = new URL("diamond1.200d0382.png", import.meta.url).toString();


var $d68b88ac38af1719$exports = {};
$d68b88ac38af1719$exports = new URL("diamond2.85a5fecb.png", import.meta.url).toString();


var $b711b8daee063f82$exports = {};
$b711b8daee063f82$exports = new URL("diamond3.a5b37d54.png", import.meta.url).toString();


var $8241c056730ed656$exports = {};
$8241c056730ed656$exports = new URL("titan1.0ecf1a25.png", import.meta.url).toString();


var $c7f9ce3e6e552370$exports = {};
$c7f9ce3e6e552370$exports = new URL("titan2.4b42c336.png", import.meta.url).toString();


var $0ac5f841e7056e7c$exports = {};
$0ac5f841e7056e7c$exports = new URL("titan3.605740d6.png", import.meta.url).toString();


var $8db3137b4aba0951$exports = {};
$8db3137b4aba0951$exports = new URL("grandtitan.e72d042b.png", import.meta.url).toString();




/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ var $3a3153321729209f$exports = {};
// shim for using process in browser
var $3a3153321729209f$var$process = $3a3153321729209f$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $3a3153321729209f$var$cachedSetTimeout;
var $3a3153321729209f$var$cachedClearTimeout;
function $3a3153321729209f$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $3a3153321729209f$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $3a3153321729209f$var$cachedSetTimeout = setTimeout;
        else $3a3153321729209f$var$cachedSetTimeout = $3a3153321729209f$var$defaultSetTimout;
    } catch (e) {
        $3a3153321729209f$var$cachedSetTimeout = $3a3153321729209f$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $3a3153321729209f$var$cachedClearTimeout = clearTimeout;
        else $3a3153321729209f$var$cachedClearTimeout = $3a3153321729209f$var$defaultClearTimeout;
    } catch (e) {
        $3a3153321729209f$var$cachedClearTimeout = $3a3153321729209f$var$defaultClearTimeout;
    }
})();
function $3a3153321729209f$var$runTimeout(fun) {
    if ($3a3153321729209f$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($3a3153321729209f$var$cachedSetTimeout === $3a3153321729209f$var$defaultSetTimout || !$3a3153321729209f$var$cachedSetTimeout) && setTimeout) {
        $3a3153321729209f$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3a3153321729209f$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $3a3153321729209f$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $3a3153321729209f$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $3a3153321729209f$var$runClearTimeout(marker) {
    if ($3a3153321729209f$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($3a3153321729209f$var$cachedClearTimeout === $3a3153321729209f$var$defaultClearTimeout || !$3a3153321729209f$var$cachedClearTimeout) && clearTimeout) {
        $3a3153321729209f$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3a3153321729209f$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $3a3153321729209f$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $3a3153321729209f$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $3a3153321729209f$var$queue = [];
var $3a3153321729209f$var$draining = false;
var $3a3153321729209f$var$currentQueue;
var $3a3153321729209f$var$queueIndex = -1;
function $3a3153321729209f$var$cleanUpNextTick() {
    if (!$3a3153321729209f$var$draining || !$3a3153321729209f$var$currentQueue) return;
    $3a3153321729209f$var$draining = false;
    if ($3a3153321729209f$var$currentQueue.length) $3a3153321729209f$var$queue = $3a3153321729209f$var$currentQueue.concat($3a3153321729209f$var$queue);
    else $3a3153321729209f$var$queueIndex = -1;
    if ($3a3153321729209f$var$queue.length) $3a3153321729209f$var$drainQueue();
}
function $3a3153321729209f$var$drainQueue() {
    if ($3a3153321729209f$var$draining) return;
    var timeout = $3a3153321729209f$var$runTimeout($3a3153321729209f$var$cleanUpNextTick);
    $3a3153321729209f$var$draining = true;
    var len = $3a3153321729209f$var$queue.length;
    while(len){
        $3a3153321729209f$var$currentQueue = $3a3153321729209f$var$queue;
        $3a3153321729209f$var$queue = [];
        while(++$3a3153321729209f$var$queueIndex < len)if ($3a3153321729209f$var$currentQueue) $3a3153321729209f$var$currentQueue[$3a3153321729209f$var$queueIndex].run();
        $3a3153321729209f$var$queueIndex = -1;
        len = $3a3153321729209f$var$queue.length;
    }
    $3a3153321729209f$var$currentQueue = null;
    $3a3153321729209f$var$draining = false;
    $3a3153321729209f$var$runClearTimeout(timeout);
}
$3a3153321729209f$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $3a3153321729209f$var$queue.push(new $3a3153321729209f$var$Item(fun, args));
    if ($3a3153321729209f$var$queue.length === 1 && !$3a3153321729209f$var$draining) $3a3153321729209f$var$runTimeout($3a3153321729209f$var$drainQueue);
};
// v8 likes predictible objects
function $3a3153321729209f$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$3a3153321729209f$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$3a3153321729209f$var$process.title = "browser";
$3a3153321729209f$var$process.browser = true;
$3a3153321729209f$var$process.env = {};
$3a3153321729209f$var$process.argv = [];
$3a3153321729209f$var$process.version = ""; // empty string to avoid regexp issues
$3a3153321729209f$var$process.versions = {};
function $3a3153321729209f$var$noop() {}
$3a3153321729209f$var$process.on = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.addListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.once = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.off = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.removeListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.removeAllListeners = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.emit = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.prependListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.prependOnceListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.listeners = function(name) {
    return [];
};
$3a3153321729209f$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$3a3153321729209f$var$process.cwd = function() {
    return "/";
};
$3a3153321729209f$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$3a3153321729209f$var$process.umask = function() {
    return 0;
};


const $706eb2584c77c6e1$export$588c7fdda06fbb0a = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: "${JSCORE_VERSION}"
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const $706eb2584c77c6e1$export$a7a9523472993e97 = function(assertion, message) {
    if (!assertion) throw $706eb2584c77c6e1$export$a39cad550e7ab28a(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const $706eb2584c77c6e1$export$a39cad550e7ab28a = function(message) {
    return new Error("Firebase Database (" + $706eb2584c77c6e1$export$588c7fdda06fbb0a.SDK_VERSION + ") INTERNAL ASSERT FAILED: " + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $706eb2584c77c6e1$var$stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const $706eb2584c77c6e1$var$byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join("");
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
const $706eb2584c77c6e1$export$b3b2de96497acc47 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + "+/=";
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + "-_.";
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === "function",
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error("encodeByteArray takes an array as a parameter");
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join("");
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray($706eb2584c77c6e1$var$stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return $706eb2584c77c6e1$var$byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new $706eb2584c77c6e1$export$55ca9d4bee46aeb3();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class $706eb2584c77c6e1$export$55ca9d4bee46aeb3 extends Error {
    constructor(){
        super(...arguments);
        this.name = "DecodeBase64StringError";
    }
}
/**
 * URL-safe base64 encoding
 */ const $706eb2584c77c6e1$export$e510a73ee562749 = function(str) {
    const utf8Bytes = $706eb2584c77c6e1$var$stringToByteArray$1(str);
    return $706eb2584c77c6e1$export$b3b2de96497acc47.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const $706eb2584c77c6e1$export$4b5284a3025a455 = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return $706eb2584c77c6e1$export$e510a73ee562749(str).replace(/\./g, "");
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const $706eb2584c77c6e1$export$c62426fdd000a97e = function(str) {
    try {
        return $706eb2584c77c6e1$export$b3b2de96497acc47.decodeString(str, true);
    } catch (e) {
        console.error("base64Decode failed: ", e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function $706eb2584c77c6e1$export$6c40052bed430212(value) {
    return $706eb2584c77c6e1$export$54e9fb29908872fa(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function $706eb2584c77c6e1$export$54e9fb29908872fa(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !$706eb2584c77c6e1$var$isValidKey(prop)) continue;
        target[prop] = $706eb2584c77c6e1$export$54e9fb29908872fa(target[prop], source[prop]);
    }
    return target;
}
function $706eb2584c77c6e1$var$isValidKey(key) {
    return key !== "__proto__";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function $706eb2584c77c6e1$export$a4e55266d2135a7f() {
    if (typeof self !== "undefined") return self;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $706eb2584c77c6e1$var$getDefaultsFromGlobal = ()=>$706eb2584c77c6e1$export$a4e55266d2135a7f().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const $706eb2584c77c6e1$var$getDefaultsFromEnvVariable = ()=>{
    if (typeof $3a3153321729209f$exports === "undefined" || typeof $3a3153321729209f$exports.env === "undefined") return;
    const defaultsJsonString = undefined;
    if (defaultsJsonString) return JSON.parse(defaultsJsonString);
};
const $706eb2584c77c6e1$var$getDefaultsFromCookie = ()=>{
    if (typeof document === "undefined") return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && $706eb2584c77c6e1$export$c62426fdd000a97e(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const $706eb2584c77c6e1$export$212bb2fc580a90a8 = ()=>{
    try {
        return $706eb2584c77c6e1$var$getDefaultsFromGlobal() || $706eb2584c77c6e1$var$getDefaultsFromEnvVariable() || $706eb2584c77c6e1$var$getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const $706eb2584c77c6e1$export$9c11895284c8adad = (productName)=>{
    var _a, _b;
    return (_b = (_a = $706eb2584c77c6e1$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.emulatorHosts) === null || _b === void 0 ? void 0 : _b[productName];
};
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const $706eb2584c77c6e1$export$a3febcf1f14a3a0c = (productName)=>{
    const host = $706eb2584c77c6e1$export$9c11895284c8adad(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(":"); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === "[") // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const $706eb2584c77c6e1$export$3dfb6827a9f89756 = ()=>{
    var _a;
    return (_a = $706eb2584c77c6e1$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.config;
};
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const $706eb2584c77c6e1$export$5539a1a3afe87d6 = (name)=>{
    var _a;
    return (_a = $706eb2584c77c6e1$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a[`_${name}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $706eb2584c77c6e1$export$85f6557964517f1a {
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === "function") {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $706eb2584c77c6e1$export$367bf224123348f1(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: "none",
        type: "JWT"
    };
    const project = projectId || "demo-project";
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = Object.assign({
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat: iat,
        exp: iat + 3600,
        auth_time: iat,
        sub: sub,
        user_id: sub,
        firebase: {
            sign_in_provider: "custom",
            identities: {}
        }
    }, token);
    // Unsecured JWTs use the empty string as a signature.
    const signature = "";
    return [
        $706eb2584c77c6e1$export$4b5284a3025a455(JSON.stringify(header)),
        $706eb2584c77c6e1$export$4b5284a3025a455(JSON.stringify(payload)),
        signature
    ].join(".");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function $706eb2584c77c6e1$export$c36915b22ce77c19() {
    if (typeof navigator !== "undefined" && typeof navigator["userAgent"] === "string") return navigator["userAgent"];
    else return "";
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function $706eb2584c77c6e1$export$872f8323f01d7ae0() {
    return typeof window !== "undefined" && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window["cordova"] || window["phonegap"] || window["PhoneGap"]) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test($706eb2584c77c6e1$export$c36915b22ce77c19());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function $706eb2584c77c6e1$export$8ee0fc9ee280b4ee() {
    var _a;
    const forceEnvironment = (_a = $706eb2584c77c6e1$export$212bb2fc580a90a8()) === null || _a === void 0 ? void 0 : _a.forceEnvironment;
    if (forceEnvironment === "node") return true;
    else if (forceEnvironment === "browser") return false;
    try {
        return Object.prototype.toString.call($parcel$global.process) === "[object process]";
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment
 */ function $706eb2584c77c6e1$export$4e09c449d6c407f7() {
    return typeof window !== "undefined" || $706eb2584c77c6e1$export$97b87b8868ff7a3c();
}
/**
 * Detect Web Worker context
 */ function $706eb2584c77c6e1$export$97b87b8868ff7a3c() {
    return typeof WorkerGlobalScope !== "undefined" && typeof self !== "undefined" && self instanceof WorkerGlobalScope;
}
function $706eb2584c77c6e1$export$caa8774a9107a58e() {
    const runtime = typeof chrome === "object" ? chrome.runtime : typeof browser === "object" ? browser.runtime : undefined;
    return typeof runtime === "object" && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function $706eb2584c77c6e1$export$f7a1e23e542d38e3() {
    return typeof navigator === "object" && navigator["product"] === "ReactNative";
}
/** Detects Electron apps. */ function $706eb2584c77c6e1$export$f2f6a8999f8ebd30() {
    return $706eb2584c77c6e1$export$c36915b22ce77c19().indexOf("Electron/") >= 0;
}
/** Detects Internet Explorer. */ function $706eb2584c77c6e1$export$7e7b1a9668aaed8() {
    const ua = $706eb2584c77c6e1$export$c36915b22ce77c19();
    return ua.indexOf("MSIE ") >= 0 || ua.indexOf("Trident/") >= 0;
}
/** Detects Universal Windows Platform apps. */ function $706eb2584c77c6e1$export$202944b2d2824246() {
    return $706eb2584c77c6e1$export$c36915b22ce77c19().indexOf("MSAppHost/") >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function $706eb2584c77c6e1$export$5d1d834fbbf8bab7() {
    return $706eb2584c77c6e1$export$588c7fdda06fbb0a.NODE_CLIENT === true || $706eb2584c77c6e1$export$588c7fdda06fbb0a.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function $706eb2584c77c6e1$export$95df08bae54cb4df() {
    return !$706eb2584c77c6e1$export$8ee0fc9ee280b4ee() && !!navigator.userAgent && navigator.userAgent.includes("Safari") && !navigator.userAgent.includes("Chrome");
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function $706eb2584c77c6e1$export$3865db50535c2055() {
    try {
        return typeof indexedDB === "object";
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function $706eb2584c77c6e1$export$a8a3018f3d187a4d() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = "validate-browser-context-for-indexeddb-analytics-module";
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                var _a;
                reject(((_a = request.error) === null || _a === void 0 ? void 0 : _a.message) || "");
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function $706eb2584c77c6e1$export$f172b7eb6cf60599() {
    if (typeof navigator === "undefined" || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // Typescript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const $706eb2584c77c6e1$var$ERROR_NAME = "FirebaseError";
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class $706eb2584c77c6e1$export$dd24e9cd51226c56 extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = $706eb2584c77c6e1$var$ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $706eb2584c77c6e1$export$dd24e9cd51226c56.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, $706eb2584c77c6e1$export$3fa6e1b18a3b2d40.prototype.create);
    }
}
class $706eb2584c77c6e1$export$3fa6e1b18a3b2d40 {
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? $706eb2584c77c6e1$var$replaceTemplate(template, customData) : "Error";
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new $706eb2584c77c6e1$export$dd24e9cd51226c56(fullCode, fullMessage, customData);
        return error;
    }
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
}
function $706eb2584c77c6e1$var$replaceTemplate(template, data) {
    return template.replace($706eb2584c77c6e1$var$PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const $706eb2584c77c6e1$var$PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function $706eb2584c77c6e1$export$c5a53ce6a17cf18d(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function $706eb2584c77c6e1$export$fac44ee5b035f737(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $706eb2584c77c6e1$export$2f872c0f2117be69 = function(token) {
    let header = {}, claims = {}, data = {}, signature = "";
    try {
        const parts = token.split(".");
        header = $706eb2584c77c6e1$export$c5a53ce6a17cf18d($706eb2584c77c6e1$export$c62426fdd000a97e(parts[0]) || "");
        claims = $706eb2584c77c6e1$export$c5a53ce6a17cf18d($706eb2584c77c6e1$export$c62426fdd000a97e(parts[1]) || "");
        signature = parts[2];
        data = claims["d"] || {};
        delete claims["d"];
    } catch (e) {}
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $706eb2584c77c6e1$export$5f870fcca7ae6a88 = function(token) {
    const claims = $706eb2584c77c6e1$export$2f872c0f2117be69(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === "object") {
        if (claims.hasOwnProperty("nbf")) validSince = claims["nbf"];
        else if (claims.hasOwnProperty("iat")) validSince = claims["iat"];
        if (claims.hasOwnProperty("exp")) validUntil = claims["exp"];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $706eb2584c77c6e1$export$701c661ec91095f2 = function(token) {
    const claims = $706eb2584c77c6e1$export$2f872c0f2117be69(token).claims;
    if (typeof claims === "object" && claims.hasOwnProperty("iat")) return claims["iat"];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $706eb2584c77c6e1$export$9565ca3d387f8aa0 = function(token) {
    const decoded = $706eb2584c77c6e1$export$2f872c0f2117be69(token), claims = decoded.claims;
    return !!claims && typeof claims === "object" && claims.hasOwnProperty("iat");
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const $706eb2584c77c6e1$export$fc970ed23da99565 = function(token) {
    const claims = $706eb2584c77c6e1$export$2f872c0f2117be69(token).claims;
    return typeof claims === "object" && claims["admin"] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $706eb2584c77c6e1$export$2344b14b097df817(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function $706eb2584c77c6e1$export$e51ae4db7b428f67(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function $706eb2584c77c6e1$export$dd1bc94b04021eeb(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function $706eb2584c77c6e1$export$871de8747c9eaa88(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function $706eb2584c77c6e1$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if ($706eb2584c77c6e1$var$isObject(aProp) && $706eb2584c77c6e1$var$isObject(bProp)) {
            if (!$706eb2584c77c6e1$export$9cb4719e2e525b7a(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function $706eb2584c77c6e1$var$isObject(thing) {
    return thing !== null && typeof thing === "object";
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function $706eb2584c77c6e1$export$a9cd205a244d9f54(promise, timeInMS = 2000) {
    const deferredPromise = new $706eb2584c77c6e1$export$85f6557964517f1a();
    setTimeout(()=>deferredPromise.reject("timeout!"), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function $706eb2584c77c6e1$export$ac4103b836844853(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + "=" + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
    return params.length ? "&" + params.join("&") : "";
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function $706eb2584c77c6e1$export$c1271ca4c8a70741(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, "").split("&");
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split("=");
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function $706eb2584c77c6e1$export$1a8408415472d8ed(url) {
    const queryStart = url.indexOf("?");
    if (!queryStart) return "";
    const fragmentStart = url.indexOf("#", queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class $706eb2584c77c6e1$export$c85d589bf4e25fef {
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === "string") for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === "string") while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function $706eb2584c77c6e1$export$364097d812234b3f(executor, onNoObservers) {
    const proxy = new $706eb2584c77c6e1$var$ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class $706eb2584c77c6e1$var$ObserverProxy {
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error("Missing Observer.");
        // Assemble an Observer object when passed as callback functions.
        if ($706eb2584c77c6e1$var$implementsAnyMethods(nextOrObserver, [
            "next",
            "error",
            "complete"
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error: error,
            complete: complete
        };
        if (observer.next === undefined) observer.next = $706eb2584c77c6e1$var$noop;
        if (observer.error === undefined) observer.error = $706eb2584c77c6e1$var$noop;
        if (observer.complete === undefined) observer.complete = $706eb2584c77c6e1$var$noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== "undefined" && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function $706eb2584c77c6e1$export$12af436354f1a4f7(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function $706eb2584c77c6e1$var$implementsAnyMethods(obj, methods) {
    if (typeof obj !== "object" || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === "function") return true;
    }
    return false;
}
function $706eb2584c77c6e1$var$noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const $706eb2584c77c6e1$export$20164226a0ed35c3 = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = "at least " + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? "none" : "no more than " + maxCount;
    if (argError) {
        const error = fnName + " failed: Was called with " + argCount + (argCount === 1 ? " argument." : " arguments.") + " Expects " + argError + ".";
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function $706eb2584c77c6e1$export$adea4917e02d93dc(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function $706eb2584c77c6e1$export$8eef22622e725943(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== "string") //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error($706eb2584c77c6e1$export$adea4917e02d93dc(fnName, "namespace") + "must be a valid firebase namespace.");
}
function $706eb2584c77c6e1$export$5bcd2a2eb6640dfa(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== "function") throw new Error($706eb2584c77c6e1$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid function.");
}
function $706eb2584c77c6e1$export$df77539402cfb523(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== "object" || context === null) throw new Error($706eb2584c77c6e1$export$adea4917e02d93dc(fnName, argumentName) + "must be a valid context object.");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const $706eb2584c77c6e1$export$655666783217a925 = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            $706eb2584c77c6e1$export$a7a9523472993e97(i < str.length, "Surrogate pair missing trail surrogate.");
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const $706eb2584c77c6e1$export$9536dc0a75b20bf9 = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Copied from https://stackoverflow.com/a/2117523
 * Generates a new uuid.
 * @public
 */ const $706eb2584c77c6e1$export$abe4376e1bf796d6 = function() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0, v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const $706eb2584c77c6e1$var$DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const $706eb2584c77c6e1$var$DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const $706eb2584c77c6e1$export$bdf1213ffbdb096e = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const $706eb2584c77c6e1$export$3518ed2cfe61fa30 = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function $706eb2584c77c6e1$export$4d810c0ca64ed8e9(backoffCount, intervalMillis = $706eb2584c77c6e1$var$DEFAULT_INTERVAL_MILLIS, backoffFactor = $706eb2584c77c6e1$var$DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    $706eb2584c77c6e1$export$3518ed2cfe61fa30 * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min($706eb2584c77c6e1$export$bdf1213ffbdb096e, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function $706eb2584c77c6e1$export$7bb39f879164e4ac(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + $706eb2584c77c6e1$var$indicator(i);
}
function $706eb2584c77c6e1$var$indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return "th";
    const dec = i % 10;
    if (dec === 1) return "st";
    if (dec === 2) return "nd";
    if (dec === 3) return "rd";
    return "th";
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $706eb2584c77c6e1$export$4befe9b5fa509a1b(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}


/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class $83e41358bca2e3f4$export$16fa2f45be04daa8 {
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $83e41358bca2e3f4$var$DEFAULT_ENTRY_NAME = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class $83e41358bca2e3f4$export$2881499e37b75b9a {
    /**
     * @param identifier A provider can provide mulitple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, $706eb2584c77c6e1$export$85f6557964517f1a)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        var _a;
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options === null || options === void 0 ? void 0 : options.identifier);
        const optional = (_a = options === null || options === void 0 ? void 0 : options.optional) !== null && _a !== void 0 ? _a : false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/can not be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if ($83e41358bca2e3f4$var$isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: $83e41358bca2e3f4$var$DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = $83e41358bca2e3f4$var$DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>"INTERNAL" in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>"_delete" in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = $83e41358bca2e3f4$var$DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = $83e41358bca2e3f4$var$DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options: options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options: options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        var _a;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = (_a = this.onInitCallbacks.get(normalizedIdentifier)) !== null && _a !== void 0 ? _a : new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch (_a) {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier: instanceIdentifier, options: options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: $83e41358bca2e3f4$var$normalizeIdentifierForFactory(instanceIdentifier),
                options: options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch (_a) {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = $83e41358bca2e3f4$var$DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : $83e41358bca2e3f4$var$DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
}
// undefined should be passed to the service factory for the default instance
function $83e41358bca2e3f4$var$normalizeIdentifierForFactory(identifier) {
    return identifier === $83e41358bca2e3f4$var$DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function $83e41358bca2e3f4$var$isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class $83e41358bca2e3f4$export$436a80eea5d5c0c5 {
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new $83e41358bca2e3f4$export$2881499e37b75b9a(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
}


/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ const $72e7953bca38524c$var$instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var $72e7953bca38524c$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})($72e7953bca38524c$export$243e62d78d3b544d || ($72e7953bca38524c$export$243e62d78d3b544d = {}));
const $72e7953bca38524c$var$levelStringToEnum = {
    "debug": $72e7953bca38524c$export$243e62d78d3b544d.DEBUG,
    "verbose": $72e7953bca38524c$export$243e62d78d3b544d.VERBOSE,
    "info": $72e7953bca38524c$export$243e62d78d3b544d.INFO,
    "warn": $72e7953bca38524c$export$243e62d78d3b544d.WARN,
    "error": $72e7953bca38524c$export$243e62d78d3b544d.ERROR,
    "silent": $72e7953bca38524c$export$243e62d78d3b544d.SILENT
};
/**
 * The default log level
 */ const $72e7953bca38524c$var$defaultLogLevel = $72e7953bca38524c$export$243e62d78d3b544d.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const $72e7953bca38524c$var$ConsoleMethod = {
    [$72e7953bca38524c$export$243e62d78d3b544d.DEBUG]: "log",
    [$72e7953bca38524c$export$243e62d78d3b544d.VERBOSE]: "log",
    [$72e7953bca38524c$export$243e62d78d3b544d.INFO]: "info",
    [$72e7953bca38524c$export$243e62d78d3b544d.WARN]: "warn",
    [$72e7953bca38524c$export$243e62d78d3b544d.ERROR]: "error"
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const $72e7953bca38524c$var$defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = $72e7953bca38524c$var$ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class $72e7953bca38524c$export$efa9a398d6368992 {
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in $72e7953bca38524c$export$243e62d78d3b544d)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === "string" ? $72e7953bca38524c$var$levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== "function") throw new TypeError("Value assigned to `logHandler` must be a function");
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, $72e7953bca38524c$export$243e62d78d3b544d.DEBUG, ...args);
        this._logHandler(this, $72e7953bca38524c$export$243e62d78d3b544d.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, $72e7953bca38524c$export$243e62d78d3b544d.VERBOSE, ...args);
        this._logHandler(this, $72e7953bca38524c$export$243e62d78d3b544d.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, $72e7953bca38524c$export$243e62d78d3b544d.INFO, ...args);
        this._logHandler(this, $72e7953bca38524c$export$243e62d78d3b544d.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, $72e7953bca38524c$export$243e62d78d3b544d.WARN, ...args);
        this._logHandler(this, $72e7953bca38524c$export$243e62d78d3b544d.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, $72e7953bca38524c$export$243e62d78d3b544d.ERROR, ...args);
        this._logHandler(this, $72e7953bca38524c$export$243e62d78d3b544d.ERROR, ...args);
    }
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = $72e7953bca38524c$var$defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = $72e7953bca38524c$var$defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ $72e7953bca38524c$var$instances.push(this);
    }
}
function $72e7953bca38524c$export$c622e99c0ce7b1c9(level) {
    $72e7953bca38524c$var$instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function $72e7953bca38524c$export$29577d29c84db5f6(logCallback, options) {
    for (const instance of $72e7953bca38524c$var$instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = $72e7953bca38524c$var$levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === "string") return arg;
                else if (typeof arg === "number" || typeof arg === "boolean") return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(" ");
            if (level >= (customLogLevel !== null && customLogLevel !== void 0 ? customLogLevel : instance.logLevel)) logCallback({
                level: $72e7953bca38524c$export$243e62d78d3b544d[level].toLowerCase(),
                message: message,
                args: args,
                type: instance.name
            });
        };
    }
}



const $5f31840df4fad724$export$23f2a1d2818174ef = (object, constructors)=>constructors.some((c)=>object instanceof c);
let $5f31840df4fad724$var$idbProxyableTypes;
let $5f31840df4fad724$var$cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function $5f31840df4fad724$var$getIdbProxyableTypes() {
    return $5f31840df4fad724$var$idbProxyableTypes || ($5f31840df4fad724$var$idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function $5f31840df4fad724$var$getCursorAdvanceMethods() {
    return $5f31840df4fad724$var$cursorAdvanceMethods || ($5f31840df4fad724$var$cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const $5f31840df4fad724$var$cursorRequestMap = new WeakMap();
const $5f31840df4fad724$var$transactionDoneMap = new WeakMap();
const $5f31840df4fad724$var$transactionStoreNamesMap = new WeakMap();
const $5f31840df4fad724$var$transformCache = new WeakMap();
const $5f31840df4fad724$export$407448d2b89b1813 = new WeakMap();
function $5f31840df4fad724$var$promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener("success", success);
            request.removeEventListener("error", error);
        };
        const success = ()=>{
            resolve($5f31840df4fad724$export$efccba1c4a2ef57b(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener("success", success);
        request.addEventListener("error", error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) $5f31840df4fad724$var$cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    $5f31840df4fad724$export$407448d2b89b1813.set(promise, request);
    return promise;
}
function $5f31840df4fad724$var$cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if ($5f31840df4fad724$var$transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener("complete", complete);
            tx.removeEventListener("error", error);
            tx.removeEventListener("abort", error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException("AbortError", "AbortError"));
            unlisten();
        };
        tx.addEventListener("complete", complete);
        tx.addEventListener("error", error);
        tx.addEventListener("abort", error);
    });
    // Cache it for later retrieval.
    $5f31840df4fad724$var$transactionDoneMap.set(tx, done);
}
let $5f31840df4fad724$var$idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === "done") return $5f31840df4fad724$var$transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === "objectStoreNames") return target.objectStoreNames || $5f31840df4fad724$var$transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === "store") return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return $5f31840df4fad724$export$efccba1c4a2ef57b(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === "done" || prop === "store")) return true;
        return prop in target;
    }
};
function $5f31840df4fad724$export$43caf9889c228507(callback) {
    $5f31840df4fad724$var$idbProxyTraps = callback($5f31840df4fad724$var$idbProxyTraps);
}
function $5f31840df4fad724$var$wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call($5f31840df4fad724$export$3b14a55fb2447963(this), storeNames, ...args);
        $5f31840df4fad724$var$transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return $5f31840df4fad724$export$efccba1c4a2ef57b(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if ($5f31840df4fad724$var$getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply($5f31840df4fad724$export$3b14a55fb2447963(this), args);
        return $5f31840df4fad724$export$efccba1c4a2ef57b($5f31840df4fad724$var$cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return $5f31840df4fad724$export$efccba1c4a2ef57b(func.apply($5f31840df4fad724$export$3b14a55fb2447963(this), args));
    };
}
function $5f31840df4fad724$var$transformCachableValue(value) {
    if (typeof value === "function") return $5f31840df4fad724$var$wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) $5f31840df4fad724$var$cacheDonePromiseForTransaction(value);
    if ($5f31840df4fad724$export$23f2a1d2818174ef(value, $5f31840df4fad724$var$getIdbProxyableTypes())) return new Proxy(value, $5f31840df4fad724$var$idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function $5f31840df4fad724$export$efccba1c4a2ef57b(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return $5f31840df4fad724$var$promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if ($5f31840df4fad724$var$transformCache.has(value)) return $5f31840df4fad724$var$transformCache.get(value);
    const newValue = $5f31840df4fad724$var$transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        $5f31840df4fad724$var$transformCache.set(value, newValue);
        $5f31840df4fad724$export$407448d2b89b1813.set(newValue, value);
    }
    return newValue;
}
const $5f31840df4fad724$export$3b14a55fb2447963 = (value)=>$5f31840df4fad724$export$407448d2b89b1813.get(value);


/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function $2178381af1cf984e$export$ca0ed41b1a2af7e(name, version, { blocked: blocked, upgrade: upgrade, blocking: blocking, terminated: terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, $5f31840df4fad724$export$efccba1c4a2ef57b)(request);
    if (upgrade) request.addEventListener("upgradeneeded", (event)=>{
        upgrade((0, $5f31840df4fad724$export$efccba1c4a2ef57b)(request.result), event.oldVersion, event.newVersion, (0, $5f31840df4fad724$export$efccba1c4a2ef57b)(request.transaction), event);
    });
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener("close", ()=>terminated());
        if (blocking) db.addEventListener("versionchange", (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function $2178381af1cf984e$export$9d6df0ac66a98bb2(name, { blocked: blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener("blocked", (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, $5f31840df4fad724$export$efccba1c4a2ef57b)(request).then(()=>undefined);
}
const $2178381af1cf984e$var$readMethods = [
    "get",
    "getKey",
    "getAll",
    "getAllKeys",
    "count"
];
const $2178381af1cf984e$var$writeMethods = [
    "put",
    "add",
    "delete",
    "clear"
];
const $2178381af1cf984e$var$cachedMethods = new Map();
function $2178381af1cf984e$var$getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === "string")) return;
    if ($2178381af1cf984e$var$cachedMethods.get(prop)) return $2178381af1cf984e$var$cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, "");
    const useIndex = prop !== targetFuncName;
    const isWrite = $2178381af1cf984e$var$writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || $2178381af1cf984e$var$readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? "readwrite" : "readonly");
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    $2178381af1cf984e$var$cachedMethods.set(prop, method);
    return method;
}
(0, $5f31840df4fad724$export$43caf9889c228507)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>$2178381af1cf984e$var$getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!$2178381af1cf984e$var$getMethod(target, prop) || oldTraps.has(target, prop)
    }));


/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c682bcd2a19f8af3$var$PlatformLoggerServiceImpl {
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if ($c682bcd2a19f8af3$var$isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(" ");
    }
    constructor(container){
        this.container = container;
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function $c682bcd2a19f8af3$var$isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return (component === null || component === void 0 ? void 0 : component.type) === "VERSION" /* ComponentType.VERSION */ ;
}
const $c682bcd2a19f8af3$var$name$p = "@firebase/app";
const $c682bcd2a19f8af3$var$version$1 = "0.10.9";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c682bcd2a19f8af3$var$logger = new (0, $72e7953bca38524c$export$efa9a398d6368992)("@firebase/app");
const $c682bcd2a19f8af3$var$name$o = "@firebase/app-compat";
const $c682bcd2a19f8af3$var$name$n = "@firebase/analytics-compat";
const $c682bcd2a19f8af3$var$name$m = "@firebase/analytics";
const $c682bcd2a19f8af3$var$name$l = "@firebase/app-check-compat";
const $c682bcd2a19f8af3$var$name$k = "@firebase/app-check";
const $c682bcd2a19f8af3$var$name$j = "@firebase/auth";
const $c682bcd2a19f8af3$var$name$i = "@firebase/auth-compat";
const $c682bcd2a19f8af3$var$name$h = "@firebase/database";
const $c682bcd2a19f8af3$var$name$g = "@firebase/database-compat";
const $c682bcd2a19f8af3$var$name$f = "@firebase/functions";
const $c682bcd2a19f8af3$var$name$e = "@firebase/functions-compat";
const $c682bcd2a19f8af3$var$name$d = "@firebase/installations";
const $c682bcd2a19f8af3$var$name$c = "@firebase/installations-compat";
const $c682bcd2a19f8af3$var$name$b = "@firebase/messaging";
const $c682bcd2a19f8af3$var$name$a = "@firebase/messaging-compat";
const $c682bcd2a19f8af3$var$name$9 = "@firebase/performance";
const $c682bcd2a19f8af3$var$name$8 = "@firebase/performance-compat";
const $c682bcd2a19f8af3$var$name$7 = "@firebase/remote-config";
const $c682bcd2a19f8af3$var$name$6 = "@firebase/remote-config-compat";
const $c682bcd2a19f8af3$var$name$5 = "@firebase/storage";
const $c682bcd2a19f8af3$var$name$4 = "@firebase/storage-compat";
const $c682bcd2a19f8af3$var$name$3 = "@firebase/firestore";
const $c682bcd2a19f8af3$var$name$2 = "@firebase/vertexai-preview";
const $c682bcd2a19f8af3$var$name$1 = "@firebase/firestore-compat";
const $c682bcd2a19f8af3$var$name = "firebase";
const $c682bcd2a19f8af3$var$version = "10.13.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const $c682bcd2a19f8af3$export$9f30fa0c10967f7f = "[DEFAULT]";
const $c682bcd2a19f8af3$var$PLATFORM_LOG_STRING = {
    [$c682bcd2a19f8af3$var$name$p]: "fire-core",
    [$c682bcd2a19f8af3$var$name$o]: "fire-core-compat",
    [$c682bcd2a19f8af3$var$name$m]: "fire-analytics",
    [$c682bcd2a19f8af3$var$name$n]: "fire-analytics-compat",
    [$c682bcd2a19f8af3$var$name$k]: "fire-app-check",
    [$c682bcd2a19f8af3$var$name$l]: "fire-app-check-compat",
    [$c682bcd2a19f8af3$var$name$j]: "fire-auth",
    [$c682bcd2a19f8af3$var$name$i]: "fire-auth-compat",
    [$c682bcd2a19f8af3$var$name$h]: "fire-rtdb",
    [$c682bcd2a19f8af3$var$name$g]: "fire-rtdb-compat",
    [$c682bcd2a19f8af3$var$name$f]: "fire-fn",
    [$c682bcd2a19f8af3$var$name$e]: "fire-fn-compat",
    [$c682bcd2a19f8af3$var$name$d]: "fire-iid",
    [$c682bcd2a19f8af3$var$name$c]: "fire-iid-compat",
    [$c682bcd2a19f8af3$var$name$b]: "fire-fcm",
    [$c682bcd2a19f8af3$var$name$a]: "fire-fcm-compat",
    [$c682bcd2a19f8af3$var$name$9]: "fire-perf",
    [$c682bcd2a19f8af3$var$name$8]: "fire-perf-compat",
    [$c682bcd2a19f8af3$var$name$7]: "fire-rc",
    [$c682bcd2a19f8af3$var$name$6]: "fire-rc-compat",
    [$c682bcd2a19f8af3$var$name$5]: "fire-gcs",
    [$c682bcd2a19f8af3$var$name$4]: "fire-gcs-compat",
    [$c682bcd2a19f8af3$var$name$3]: "fire-fst",
    [$c682bcd2a19f8af3$var$name$1]: "fire-fst-compat",
    [$c682bcd2a19f8af3$var$name$2]: "fire-vertex",
    "fire-js": "fire-js",
    [$c682bcd2a19f8af3$var$name]: "fire-js-all"
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const $c682bcd2a19f8af3$export$b4e3c36c855b14b5 = new Map();
/**
 * @internal
 */ const $c682bcd2a19f8af3$export$fb03ad8d3d5c5f76 = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c682bcd2a19f8af3$export$9566bce3835c0f28 = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function $c682bcd2a19f8af3$export$fa5244b94c62d36a(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        $c682bcd2a19f8af3$var$logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function $c682bcd2a19f8af3$export$4393112b42e2b41d(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function $c682bcd2a19f8af3$export$c930050e7bb63965(component) {
    const componentName = component.name;
    if ($c682bcd2a19f8af3$export$9566bce3835c0f28.has(componentName)) {
        $c682bcd2a19f8af3$var$logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    $c682bcd2a19f8af3$export$9566bce3835c0f28.set(componentName, component);
    // add the component to existing app instances
    for (const app of $c682bcd2a19f8af3$export$b4e3c36c855b14b5.values())$c682bcd2a19f8af3$export$fa5244b94c62d36a(app, component);
    for (const serverApp of $c682bcd2a19f8af3$export$fb03ad8d3d5c5f76.values())$c682bcd2a19f8af3$export$fa5244b94c62d36a(serverApp, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function $c682bcd2a19f8af3$export$fa0d6da0f5838f50(app, name) {
    const heartbeatController = app.container.getProvider("heartbeat").getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function $c682bcd2a19f8af3$export$48d18de2ff1c45a5(app, name, instanceIdentifier = $c682bcd2a19f8af3$export$9f30fa0c10967f7f) {
    $c682bcd2a19f8af3$export$fa0d6da0f5838f50(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp or FirebaseOptions.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */ function $c682bcd2a19f8af3$export$110778f8e98b8257(obj) {
    return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function $c682bcd2a19f8af3$export$643c8bc6c389f34e(obj) {
    return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */ function $c682bcd2a19f8af3$export$3685d89b9c3cdfaf() {
    $c682bcd2a19f8af3$export$9566bce3835c0f28.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c682bcd2a19f8af3$var$ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}'",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["server-app-deleted" /* AppError.SERVER_APP_DELETED */ ]: "Firebase Server App has been deleted",
    ["no-options" /* AppError.NO_OPTIONS */ ]: "Need to provide options, when not being deployed to hosting via source.",
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: "First argument to `onLog` must be null or a function.",
    ["idb-open" /* AppError.IDB_OPEN */ ]: "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-get" /* AppError.IDB_GET */ ]: "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-set" /* AppError.IDB_WRITE */ ]: "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.",
    ["idb-delete" /* AppError.IDB_DELETE */ ]: "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.",
    ["finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ ]: "FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.",
    ["invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ ]: "FirebaseServerApp is not for use in browser environments."
};
const $c682bcd2a19f8af3$var$ERROR_FACTORY = new (0, $706eb2584c77c6e1$export$3fa6e1b18a3b2d40)("app", "Firebase", $c682bcd2a19f8af3$var$ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c682bcd2a19f8af3$var$FirebaseAppImpl {
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $c682bcd2a19f8af3$var$ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = Object.assign({}, options);
        this._config = Object.assign({}, config);
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, $83e41358bca2e3f4$export$16fa2f45be04daa8)("app", ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class $c682bcd2a19f8af3$var$FirebaseServerAppImpl extends $c682bcd2a19f8af3$var$FirebaseAppImpl {
    toJSON() {
        return undefined;
    }
    get refCount() {
        return this._refCount;
    }
    // Increment the reference count of this server app. If an object is provided, register it
    // with the finalization registry.
    incRefCount(obj) {
        if (this.isDeleted) return;
        this._refCount++;
        if (obj !== undefined && this._finalizationRegistry !== null) this._finalizationRegistry.register(obj, this);
    }
    // Decrement the reference count.
    decRefCount() {
        if (this.isDeleted) return 0;
        return --this._refCount;
    }
    // Invoked by the FinalizationRegistry callback to note that this app should go through its
    // reference counts and delete itself if no reference count remain. The coordinating logic that
    // handles this is in deleteApp(...).
    automaticCleanup() {
        $c682bcd2a19f8af3$export$6eec44aa53d5ea34(this);
    }
    get settings() {
        this.checkDestroyed();
        return this._serverConfig;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw $c682bcd2a19f8af3$var$ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */ );
    }
    constructor(options, serverConfig, name, container){
        // Build configuration parameters for the FirebaseAppImpl base class.
        const automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined ? serverConfig.automaticDataCollectionEnabled : false;
        // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
        const config = {
            name: name,
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        };
        if (options.apiKey !== undefined) // Construct the parent FirebaseAppImp object.
        super(options, config, container);
        else {
            const appImpl = options;
            super(appImpl.options, config, container);
        }
        // Now construct the data for the FirebaseServerAppImpl.
        this._serverConfig = Object.assign({
            automaticDataCollectionEnabled: automaticDataCollectionEnabled
        }, serverConfig);
        this._finalizationRegistry = null;
        if (typeof FinalizationRegistry !== "undefined") this._finalizationRegistry = new FinalizationRegistry(()=>{
            this.automaticCleanup();
        });
        this._refCount = 0;
        this.incRefCount(this._serverConfig.releaseOnDeref);
        // Do not retain a hard reference to the dref object, otherwise the FinalizationRegistry
        // will never trigger.
        this._serverConfig.releaseOnDeref = undefined;
        serverConfig.releaseOnDeref = undefined;
        $c682bcd2a19f8af3$export$d29d5299a7137abc($c682bcd2a19f8af3$var$name$p, $c682bcd2a19f8af3$var$version$1, "serverapp");
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const $c682bcd2a19f8af3$export$31499a9cd224b78c = $c682bcd2a19f8af3$var$version;
function $c682bcd2a19f8af3$export$c55cfd413944906d(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== "object") {
        const name = rawConfig;
        rawConfig = {
            name: name
        };
    }
    const config = Object.assign({
        name: $c682bcd2a19f8af3$export$9f30fa0c10967f7f,
        automaticDataCollectionEnabled: false
    }, rawConfig);
    const name = config.name;
    if (typeof name !== "string" || !name) throw $c682bcd2a19f8af3$var$ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, $706eb2584c77c6e1$export$3dfb6827a9f89756)());
    if (!options) throw $c682bcd2a19f8af3$var$ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = $c682bcd2a19f8af3$export$b4e3c36c855b14b5.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, $706eb2584c77c6e1$export$9cb4719e2e525b7a)(options, existingApp.options) && (0, $706eb2584c77c6e1$export$9cb4719e2e525b7a)(config, existingApp.config)) return existingApp;
        else throw $c682bcd2a19f8af3$var$ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, $83e41358bca2e3f4$export$436a80eea5d5c0c5)(name);
    for (const component of $c682bcd2a19f8af3$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $c682bcd2a19f8af3$var$FirebaseAppImpl(options, config, container);
    $c682bcd2a19f8af3$export$b4e3c36c855b14b5.set(name, newApp);
    return newApp;
}
function $c682bcd2a19f8af3$export$45a407ab953b136b(_options, _serverAppConfig) {
    if ((0, $706eb2584c77c6e1$export$4e09c449d6c407f7)() && !(0, $706eb2584c77c6e1$export$97b87b8868ff7a3c)()) // FirebaseServerApp isn't designed to be run in browsers.
    throw $c682bcd2a19f8af3$var$ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ );
    if (_serverAppConfig.automaticDataCollectionEnabled === undefined) _serverAppConfig.automaticDataCollectionEnabled = false;
    let appOptions;
    if ($c682bcd2a19f8af3$export$110778f8e98b8257(_options)) appOptions = _options.options;
    else appOptions = _options;
    // Build an app name based on a hash of the configuration options.
    const nameObj = Object.assign(Object.assign({}, _serverAppConfig), appOptions);
    // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
    // construction of FirebaseServerApp instances. For example, if the object is the request headers.
    if (nameObj.releaseOnDeref !== undefined) delete nameObj.releaseOnDeref;
    const hashCode = (s)=>{
        return [
            ...s
        ].reduce((hash, c)=>Math.imul(31, hash) + c.charCodeAt(0) | 0, 0);
    };
    if (_serverAppConfig.releaseOnDeref !== undefined) {
        if (typeof FinalizationRegistry === "undefined") throw $c682bcd2a19f8af3$var$ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ , {});
    }
    const nameString = "" + hashCode(JSON.stringify(nameObj));
    const existingApp = $c682bcd2a19f8af3$export$fb03ad8d3d5c5f76.get(nameString);
    if (existingApp) {
        existingApp.incRefCount(_serverAppConfig.releaseOnDeref);
        return existingApp;
    }
    const container = new (0, $83e41358bca2e3f4$export$436a80eea5d5c0c5)(nameString);
    for (const component of $c682bcd2a19f8af3$export$9566bce3835c0f28.values())container.addComponent(component);
    const newApp = new $c682bcd2a19f8af3$var$FirebaseServerAppImpl(appOptions, _serverAppConfig, nameString, container);
    $c682bcd2a19f8af3$export$fb03ad8d3d5c5f76.set(nameString, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function $c682bcd2a19f8af3$export$f9962582c9e66d99(name = $c682bcd2a19f8af3$export$9f30fa0c10967f7f) {
    const app = $c682bcd2a19f8af3$export$b4e3c36c855b14b5.get(name);
    if (!app && name === $c682bcd2a19f8af3$export$9f30fa0c10967f7f && (0, $706eb2584c77c6e1$export$3dfb6827a9f89756)()) return $c682bcd2a19f8af3$export$c55cfd413944906d();
    if (!app) throw $c682bcd2a19f8af3$var$ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function $c682bcd2a19f8af3$export$68ddedf7d44b3bdf() {
    return Array.from($c682bcd2a19f8af3$export$b4e3c36c855b14b5.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function $c682bcd2a19f8af3$export$6eec44aa53d5ea34(app) {
    let cleanupProviders = false;
    const name = app.name;
    if ($c682bcd2a19f8af3$export$b4e3c36c855b14b5.has(name)) {
        cleanupProviders = true;
        $c682bcd2a19f8af3$export$b4e3c36c855b14b5.delete(name);
    } else if ($c682bcd2a19f8af3$export$fb03ad8d3d5c5f76.has(name)) {
        const firebaseServerApp = app;
        if (firebaseServerApp.decRefCount() <= 0) {
            $c682bcd2a19f8af3$export$fb03ad8d3d5c5f76.delete(name);
            cleanupProviders = true;
        }
    }
    if (cleanupProviders) {
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function $c682bcd2a19f8af3$export$d29d5299a7137abc(libraryKeyOrName, version, variant) {
    var _a;
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = (_a = $c682bcd2a19f8af3$var$PLATFORM_LOG_STRING[libraryKeyOrName]) !== null && _a !== void 0 ? _a : libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push("and");
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        $c682bcd2a19f8af3$var$logger.warn(warning.join(" "));
        return;
    }
    $c682bcd2a19f8af3$export$c930050e7bb63965(new (0, $83e41358bca2e3f4$export$16fa2f45be04daa8)(`${library}-version`, ()=>({
            library: library,
            version: version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function $c682bcd2a19f8af3$export$a82ad227dc8163dc(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== "function") throw $c682bcd2a19f8af3$var$ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, $72e7953bca38524c$export$29577d29c84db5f6)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function $c682bcd2a19f8af3$export$c622e99c0ce7b1c9(logLevel) {
    (0, $72e7953bca38524c$export$c622e99c0ce7b1c9)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c682bcd2a19f8af3$var$DB_NAME = "firebase-heartbeat-database";
const $c682bcd2a19f8af3$var$DB_VERSION = 1;
const $c682bcd2a19f8af3$var$STORE_NAME = "firebase-heartbeat-store";
let $c682bcd2a19f8af3$var$dbPromise = null;
function $c682bcd2a19f8af3$var$getDbPromise() {
    if (!$c682bcd2a19f8af3$var$dbPromise) $c682bcd2a19f8af3$var$dbPromise = (0, $2178381af1cf984e$export$ca0ed41b1a2af7e)($c682bcd2a19f8af3$var$DB_NAME, $c682bcd2a19f8af3$var$DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    try {
                        db.createObjectStore($c682bcd2a19f8af3$var$STORE_NAME);
                    } catch (e) {
                        // Safari/iOS browsers throw occasional exceptions on
                        // db.createObjectStore() that may be a bug. Avoid blocking
                        // the rest of the app functionality.
                        console.warn(e);
                    }
            }
        }
    }).catch((e)=>{
        throw $c682bcd2a19f8af3$var$ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return $c682bcd2a19f8af3$var$dbPromise;
}
async function $c682bcd2a19f8af3$var$readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await $c682bcd2a19f8af3$var$getDbPromise();
        const tx = db.transaction($c682bcd2a19f8af3$var$STORE_NAME);
        const result = await tx.objectStore($c682bcd2a19f8af3$var$STORE_NAME).get($c682bcd2a19f8af3$var$computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    } catch (e) {
        if (e instanceof (0, $706eb2584c77c6e1$export$dd24e9cd51226c56)) $c682bcd2a19f8af3$var$logger.warn(e.message);
        else {
            const idbGetError = $c682bcd2a19f8af3$var$ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $c682bcd2a19f8af3$var$logger.warn(idbGetError.message);
        }
    }
}
async function $c682bcd2a19f8af3$var$writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await $c682bcd2a19f8af3$var$getDbPromise();
        const tx = db.transaction($c682bcd2a19f8af3$var$STORE_NAME, "readwrite");
        const objectStore = tx.objectStore($c682bcd2a19f8af3$var$STORE_NAME);
        await objectStore.put(heartbeatObject, $c682bcd2a19f8af3$var$computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, $706eb2584c77c6e1$export$dd24e9cd51226c56)) $c682bcd2a19f8af3$var$logger.warn(e.message);
        else {
            const idbGetError = $c682bcd2a19f8af3$var$ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e === null || e === void 0 ? void 0 : e.message
            });
            $c682bcd2a19f8af3$var$logger.warn(idbGetError.message);
        }
    }
}
function $c682bcd2a19f8af3$var$computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $c682bcd2a19f8af3$var$MAX_HEADER_BYTES = 1024;
// 30 days
const $c682bcd2a19f8af3$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS = 2592000000;
class $c682bcd2a19f8af3$var$HeartbeatServiceImpl {
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        var _a, _b, _c;
        try {
            const platformLogger = this.container.getProvider("platform-logger").getImmediate();
            // This is the "Firebase user agent" string from the platform logger
            // service, not the browser user agent.
            const agent = platformLogger.getPlatformInfoString();
            const date = $c682bcd2a19f8af3$var$getUTCDateString();
            console.log("heartbeats", (_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats);
            if (((_b = this._heartbeatsCache) === null || _b === void 0 ? void 0 : _b.heartbeats) == null) {
                this._heartbeatsCache = await this._heartbeatsCachePromise;
                // If we failed to construct a heartbeats cache, then return immediately.
                if (((_c = this._heartbeatsCache) === null || _c === void 0 ? void 0 : _c.heartbeats) == null) return;
            }
            // Do not store a heartbeat if one is already stored for this day
            // or if a header has already been sent today.
            if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
            else // There is no entry for this date. Create one.
            this._heartbeatsCache.heartbeats.push({
                date: date,
                agent: agent
            });
            // Remove entries older than 30 days.
            this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((singleDateHeartbeat)=>{
                const hbTimestamp = new Date(singleDateHeartbeat.date).valueOf();
                const now = Date.now();
                return now - hbTimestamp <= $c682bcd2a19f8af3$var$STORED_HEARTBEAT_RETENTION_MAX_MILLIS;
            });
            return this._storage.overwrite(this._heartbeatsCache);
        } catch (e) {
            $c682bcd2a19f8af3$var$logger.warn(e);
        }
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        var _a;
        try {
            if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
            // If it's still null or the array is empty, there is no data to send.
            if (((_a = this._heartbeatsCache) === null || _a === void 0 ? void 0 : _a.heartbeats) == null || this._heartbeatsCache.heartbeats.length === 0) return "";
            const date = $c682bcd2a19f8af3$var$getUTCDateString();
            // Extract as many heartbeats from the cache as will fit under the size limit.
            const { heartbeatsToSend: heartbeatsToSend, unsentEntries: unsentEntries } = $c682bcd2a19f8af3$var$extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
            const headerString = (0, $706eb2584c77c6e1$export$4b5284a3025a455)(JSON.stringify({
                version: 2,
                heartbeats: heartbeatsToSend
            }));
            // Store last sent date to prevent another being logged/sent for the same day.
            this._heartbeatsCache.lastSentHeartbeatDate = date;
            if (unsentEntries.length > 0) {
                // Store any unsent entries if they exist.
                this._heartbeatsCache.heartbeats = unsentEntries;
                // This seems more likely than emptying the array (below) to lead to some odd state
                // since the cache isn't empty and this will be called again on the next request,
                // and is probably safest if we await it.
                await this._storage.overwrite(this._heartbeatsCache);
            } else {
                this._heartbeatsCache.heartbeats = [];
                // Do not wait for this, to reduce latency.
                this._storage.overwrite(this._heartbeatsCache);
            }
            return headerString;
        } catch (e) {
            $c682bcd2a19f8af3$var$logger.warn(e);
            return "";
        }
    }
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider("app").getImmediate();
        this._storage = new $c682bcd2a19f8af3$var$HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
}
function $c682bcd2a19f8af3$var$getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function $c682bcd2a19f8af3$var$extractHeartbeatsForHeader(heartbeatsCache, maxSize = $c682bcd2a19f8af3$var$MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if ($c682bcd2a19f8af3$var$countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if ($c682bcd2a19f8af3$var$countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend: heartbeatsToSend,
        unsentEntries: unsentEntries
    };
}
class $c682bcd2a19f8af3$var$HeartbeatStorageImpl {
    async runIndexedDBEnvironmentCheck() {
        if (!(0, $706eb2584c77c6e1$export$3865db50535c2055)()) return false;
        else return (0, $706eb2584c77c6e1$export$a8a3018f3d187a4d)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await $c682bcd2a19f8af3$var$readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject === null || idbHeartbeatObject === void 0 ? void 0 : idbHeartbeatObject.heartbeats) return idbHeartbeatObject;
            else return {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $c682bcd2a19f8af3$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        var _a;
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return $c682bcd2a19f8af3$var$writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: (_a = heartbeatsObject.lastSentHeartbeatDate) !== null && _a !== void 0 ? _a : existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function $c682bcd2a19f8af3$var$countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, $706eb2584c77c6e1$export$4b5284a3025a455)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $c682bcd2a19f8af3$var$registerCoreComponents(variant) {
    $c682bcd2a19f8af3$export$c930050e7bb63965(new (0, $83e41358bca2e3f4$export$16fa2f45be04daa8)("platform-logger", (container)=>new $c682bcd2a19f8af3$var$PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    $c682bcd2a19f8af3$export$c930050e7bb63965(new (0, $83e41358bca2e3f4$export$16fa2f45be04daa8)("heartbeat", (container)=>new $c682bcd2a19f8af3$var$HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    $c682bcd2a19f8af3$export$d29d5299a7137abc($c682bcd2a19f8af3$var$name$p, $c682bcd2a19f8af3$var$version$1, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    $c682bcd2a19f8af3$export$d29d5299a7137abc($c682bcd2a19f8af3$var$name$p, $c682bcd2a19f8af3$var$version$1, "esm2017");
    // Register platform SDK identifier (no version).
    $c682bcd2a19f8af3$export$d29d5299a7137abc("fire-js", "");
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ $c682bcd2a19f8af3$var$registerCoreComponents("");




/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e5aa85852f7f6779$var$LONG_TYPE = "type.googleapis.com/google.protobuf.Int64Value";
const $e5aa85852f7f6779$var$UNSIGNED_LONG_TYPE = "type.googleapis.com/google.protobuf.UInt64Value";
function $e5aa85852f7f6779$var$mapValues(// { [k: string]: unknown } is no longer a wildcard assignment target after typescript 3.5
// eslint-disable-next-line @typescript-eslint/no-explicit-any
o, f) {
    const result = {};
    for(const key in o)if (o.hasOwnProperty(key)) result[key] = f(o[key]);
    return result;
}
/**
 * Takes data and encodes it in a JSON-friendly way, such that types such as
 * Date are preserved.
 * @internal
 * @param data - Data to encode.
 */ function $e5aa85852f7f6779$var$encode(data) {
    if (data == null) return null;
    if (data instanceof Number) data = data.valueOf();
    if (typeof data === "number" && isFinite(data)) // Any number in JS is safe to put directly in JSON and parse as a double
    // without any loss of precision.
    return data;
    if (data === true || data === false) return data;
    if (Object.prototype.toString.call(data) === "[object String]") return data;
    if (data instanceof Date) return data.toISOString();
    if (Array.isArray(data)) return data.map((x)=>$e5aa85852f7f6779$var$encode(x));
    if (typeof data === "function" || typeof data === "object") return $e5aa85852f7f6779$var$mapValues(data, (x)=>$e5aa85852f7f6779$var$encode(x));
    // If we got this far, the data is not encodable.
    throw new Error("Data cannot be encoded in JSON: " + data);
}
/**
 * Takes data that's been encoded in a JSON-friendly form and returns a form
 * with richer datatypes, such as Dates, etc.
 * @internal
 * @param json - JSON to convert.
 */ function $e5aa85852f7f6779$var$decode(json) {
    if (json == null) return json;
    if (json["@type"]) switch(json["@type"]){
        case $e5aa85852f7f6779$var$LONG_TYPE:
        // Fall through and handle this the same as unsigned.
        case $e5aa85852f7f6779$var$UNSIGNED_LONG_TYPE:
            {
                // Technically, this could work return a valid number for malformed
                // data if there was a number followed by garbage. But it's just not
                // worth all the extra code to detect that case.
                const value = Number(json["value"]);
                if (isNaN(value)) throw new Error("Data cannot be decoded from JSON: " + json);
                return value;
            }
        default:
            throw new Error("Data cannot be decoded from JSON: " + json);
    }
    if (Array.isArray(json)) return json.map((x)=>$e5aa85852f7f6779$var$decode(x));
    if (typeof json === "function" || typeof json === "object") return $e5aa85852f7f6779$var$mapValues(json, (x)=>$e5aa85852f7f6779$var$decode(x));
    // Anything else is safe to return.
    return json;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Functions.
 */ const $e5aa85852f7f6779$var$FUNCTIONS_TYPE = "functions";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Standard error codes for different ways a request can fail, as defined by:
 * https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
 *
 * This map is used primarily to convert from a backend error code string to
 * a client SDK error code string, and make sure it's in the supported set.
 */ const $e5aa85852f7f6779$var$errorCodeMap = {
    OK: "ok",
    CANCELLED: "cancelled",
    UNKNOWN: "unknown",
    INVALID_ARGUMENT: "invalid-argument",
    DEADLINE_EXCEEDED: "deadline-exceeded",
    NOT_FOUND: "not-found",
    ALREADY_EXISTS: "already-exists",
    PERMISSION_DENIED: "permission-denied",
    UNAUTHENTICATED: "unauthenticated",
    RESOURCE_EXHAUSTED: "resource-exhausted",
    FAILED_PRECONDITION: "failed-precondition",
    ABORTED: "aborted",
    OUT_OF_RANGE: "out-of-range",
    UNIMPLEMENTED: "unimplemented",
    INTERNAL: "internal",
    UNAVAILABLE: "unavailable",
    DATA_LOSS: "data-loss"
};
/**
 * An explicit error that can be thrown from a handler to send an error to the
 * client that called the function.
 */ class $e5aa85852f7f6779$var$FunctionsError extends (0, $706eb2584c77c6e1$export$dd24e9cd51226c56) {
    constructor(/**
     * A standard error code that will be returned to the client. This also
     * determines the HTTP status code of the response, as defined in code.proto.
     */ code, message, /**
     * Extra data to be converted to JSON and included in the error response.
     */ details){
        super(`${$e5aa85852f7f6779$var$FUNCTIONS_TYPE}/${code}`, message || "");
        this.details = details;
    }
}
/**
 * Takes an HTTP status code and returns the corresponding ErrorCode.
 * This is the standard HTTP status code -> error mapping defined in:
 * https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
 *
 * @param status An HTTP status code.
 * @return The corresponding ErrorCode, or ErrorCode.UNKNOWN if none.
 */ function $e5aa85852f7f6779$var$codeForHTTPStatus(status) {
    // Make sure any successful status is OK.
    if (status >= 200 && status < 300) return "ok";
    switch(status){
        case 0:
            // This can happen if the server returns 500.
            return "internal";
        case 400:
            return "invalid-argument";
        case 401:
            return "unauthenticated";
        case 403:
            return "permission-denied";
        case 404:
            return "not-found";
        case 409:
            return "aborted";
        case 429:
            return "resource-exhausted";
        case 499:
            return "cancelled";
        case 500:
            return "internal";
        case 501:
            return "unimplemented";
        case 503:
            return "unavailable";
        case 504:
            return "deadline-exceeded";
    }
    return "unknown";
}
/**
 * Takes an HTTP response and returns the corresponding Error, if any.
 */ function $e5aa85852f7f6779$var$_errorForResponse(status, bodyJSON) {
    let code = $e5aa85852f7f6779$var$codeForHTTPStatus(status);
    // Start with reasonable defaults from the status code.
    let description = code;
    let details = undefined;
    // Then look through the body for explicit details.
    try {
        const errorJSON = bodyJSON && bodyJSON.error;
        if (errorJSON) {
            const status = errorJSON.status;
            if (typeof status === "string") {
                if (!$e5aa85852f7f6779$var$errorCodeMap[status]) // They must've included an unknown error code in the body.
                return new $e5aa85852f7f6779$var$FunctionsError("internal", "internal");
                code = $e5aa85852f7f6779$var$errorCodeMap[status];
                // TODO(klimt): Add better default descriptions for error enums.
                // The default description needs to be updated for the new code.
                description = status;
            }
            const message = errorJSON.message;
            if (typeof message === "string") description = message;
            details = errorJSON.details;
            if (details !== undefined) details = $e5aa85852f7f6779$var$decode(details);
        }
    } catch (e) {
    // If we couldn't parse explicit error data, that's fine.
    }
    if (code === "ok") // Technically, there's an edge case where a developer could explicitly
    // return an error code of OK, and we will treat it as success, but that
    // seems reasonable.
    return null;
    return new $e5aa85852f7f6779$var$FunctionsError(code, description, details);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper class to get metadata that should be included with a function call.
 * @internal
 */ class $e5aa85852f7f6779$var$ContextProvider {
    async getAuthToken() {
        if (!this.auth) return undefined;
        try {
            const token = await this.auth.getToken();
            return token === null || token === void 0 ? void 0 : token.accessToken;
        } catch (e) {
            // If there's any error when trying to get the auth token, leave it off.
            return undefined;
        }
    }
    async getMessagingToken() {
        if (!this.messaging || !("Notification" in self) || Notification.permission !== "granted") return undefined;
        try {
            return await this.messaging.getToken();
        } catch (e) {
            // We don't warn on this, because it usually means messaging isn't set up.
            // console.warn('Failed to retrieve instance id token.', e);
            // If there's any error when trying to get the token, leave it off.
            return undefined;
        }
    }
    async getAppCheckToken(limitedUseAppCheckTokens) {
        if (this.appCheck) {
            const result = limitedUseAppCheckTokens ? await this.appCheck.getLimitedUseToken() : await this.appCheck.getToken();
            if (result.error) // Do not send the App Check header to the functions endpoint if
            // there was an error from the App Check exchange endpoint. The App
            // Check SDK will already have logged the error to console.
            return null;
            return result.token;
        }
        return null;
    }
    async getContext(limitedUseAppCheckTokens) {
        const authToken = await this.getAuthToken();
        const messagingToken = await this.getMessagingToken();
        const appCheckToken = await this.getAppCheckToken(limitedUseAppCheckTokens);
        return {
            authToken: authToken,
            messagingToken: messagingToken,
            appCheckToken: appCheckToken
        };
    }
    constructor(authProvider, messagingProvider, appCheckProvider){
        this.auth = null;
        this.messaging = null;
        this.appCheck = null;
        this.auth = authProvider.getImmediate({
            optional: true
        });
        this.messaging = messagingProvider.getImmediate({
            optional: true
        });
        if (!this.auth) authProvider.get().then((auth)=>this.auth = auth, ()=>{
        /* get() never rejects */ });
        if (!this.messaging) messagingProvider.get().then((messaging)=>this.messaging = messaging, ()=>{
        /* get() never rejects */ });
        if (!this.appCheck) appCheckProvider.get().then((appCheck)=>this.appCheck = appCheck, ()=>{
        /* get() never rejects */ });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e5aa85852f7f6779$var$DEFAULT_REGION = "us-central1";
/**
 * Returns a Promise that will be rejected after the given duration.
 * The error will be of type FunctionsError.
 *
 * @param millis Number of milliseconds to wait before rejecting.
 */ function $e5aa85852f7f6779$var$failAfter(millis) {
    // Node timers and browser timers are fundamentally incompatible, but we
    // don't care about the value here
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let timer = null;
    return {
        promise: new Promise((_, reject)=>{
            timer = setTimeout(()=>{
                reject(new $e5aa85852f7f6779$var$FunctionsError("deadline-exceeded", "deadline-exceeded"));
            }, millis);
        }),
        cancel: ()=>{
            if (timer) clearTimeout(timer);
        }
    };
}
/**
 * The main class for the Firebase Functions SDK.
 * @internal
 */ class $e5aa85852f7f6779$var$FunctionsService {
    _delete() {
        return this.deleteService();
    }
    /**
     * Returns the URL for a callable with the given name.
     * @param name - The name of the callable.
     * @internal
     */ _url(name) {
        const projectId = this.app.options.projectId;
        if (this.emulatorOrigin !== null) {
            const origin = this.emulatorOrigin;
            return `${origin}/${projectId}/${this.region}/${name}`;
        }
        if (this.customDomain !== null) return `${this.customDomain}/${name}`;
        return `https://${this.region}-${projectId}.cloudfunctions.net/${name}`;
    }
    /**
     * Creates a new Functions service for the given app.
     * @param app - The FirebaseApp to use.
     */ constructor(app, authProvider, messagingProvider, appCheckProvider, regionOrCustomDomain = $e5aa85852f7f6779$var$DEFAULT_REGION, fetchImpl){
        this.app = app;
        this.fetchImpl = fetchImpl;
        this.emulatorOrigin = null;
        this.contextProvider = new $e5aa85852f7f6779$var$ContextProvider(authProvider, messagingProvider, appCheckProvider);
        // Cancels all ongoing requests when resolved.
        this.cancelAllRequests = new Promise((resolve)=>{
            this.deleteService = ()=>{
                return Promise.resolve(resolve());
            };
        });
        // Resolve the region or custom domain overload by attempting to parse it.
        try {
            const url = new URL(regionOrCustomDomain);
            this.customDomain = url.origin;
            this.region = $e5aa85852f7f6779$var$DEFAULT_REGION;
        } catch (e) {
            this.customDomain = null;
            this.region = regionOrCustomDomain;
        }
    }
}
/**
 * Modify this instance to communicate with the Cloud Functions emulator.
 *
 * Note: this must be called before this instance has been used to do any operations.
 *
 * @param host The emulator host (ex: localhost)
 * @param port The emulator port (ex: 5001)
 * @public
 */ function $e5aa85852f7f6779$var$connectFunctionsEmulator$1(functionsInstance, host, port) {
    functionsInstance.emulatorOrigin = `http://${host}:${port}`;
}
/**
 * Returns a reference to the callable https trigger with the given name.
 * @param name - The name of the trigger.
 * @public
 */ function $e5aa85852f7f6779$var$httpsCallable$1(functionsInstance, name, options) {
    return (data)=>{
        return $e5aa85852f7f6779$var$call(functionsInstance, name, data, options || {});
    };
}
/**
 * Returns a reference to the callable https trigger with the given url.
 * @param url - The url of the trigger.
 * @public
 */ function $e5aa85852f7f6779$var$httpsCallableFromURL$1(functionsInstance, url, options) {
    return (data)=>{
        return $e5aa85852f7f6779$var$callAtURL(functionsInstance, url, data, options || {});
    };
}
/**
 * Does an HTTP POST and returns the completed response.
 * @param url The url to post to.
 * @param body The JSON body of the post.
 * @param headers The HTTP headers to include in the request.
 * @return A Promise that will succeed when the request finishes.
 */ async function $e5aa85852f7f6779$var$postJSON(url, body, headers, fetchImpl) {
    headers["Content-Type"] = "application/json";
    let response;
    try {
        response = await fetchImpl(url, {
            method: "POST",
            body: JSON.stringify(body),
            headers: headers
        });
    } catch (e) {
        // This could be an unhandled error on the backend, or it could be a
        // network error. There's no way to know, since an unhandled error on the
        // backend will fail to set the proper CORS header, and thus will be
        // treated as a network error by fetch.
        return {
            status: 0,
            json: null
        };
    }
    let json = null;
    try {
        json = await response.json();
    } catch (e) {
    // If we fail to parse JSON, it will fail the same as an empty body.
    }
    return {
        status: response.status,
        json: json
    };
}
/**
 * Calls a callable function asynchronously and returns the result.
 * @param name The name of the callable trigger.
 * @param data The data to pass as params to the function.s
 */ function $e5aa85852f7f6779$var$call(functionsInstance, name, data, options) {
    const url = functionsInstance._url(name);
    return $e5aa85852f7f6779$var$callAtURL(functionsInstance, url, data, options);
}
/**
 * Calls a callable function asynchronously and returns the result.
 * @param url The url of the callable trigger.
 * @param data The data to pass as params to the function.s
 */ async function $e5aa85852f7f6779$var$callAtURL(functionsInstance, url, data, options) {
    // Encode any special types, such as dates, in the input data.
    data = $e5aa85852f7f6779$var$encode(data);
    const body = {
        data: data
    };
    // Add a header for the authToken.
    const headers = {};
    const context = await functionsInstance.contextProvider.getContext(options.limitedUseAppCheckTokens);
    if (context.authToken) headers["Authorization"] = "Bearer " + context.authToken;
    if (context.messagingToken) headers["Firebase-Instance-ID-Token"] = context.messagingToken;
    if (context.appCheckToken !== null) headers["X-Firebase-AppCheck"] = context.appCheckToken;
    // Default timeout to 70s, but let the options override it.
    const timeout = options.timeout || 70000;
    const failAfterHandle = $e5aa85852f7f6779$var$failAfter(timeout);
    const response = await Promise.race([
        $e5aa85852f7f6779$var$postJSON(url, body, headers, functionsInstance.fetchImpl),
        failAfterHandle.promise,
        functionsInstance.cancelAllRequests
    ]);
    // Always clear the failAfter timeout
    failAfterHandle.cancel();
    // If service was deleted, interrupted response throws an error.
    if (!response) throw new $e5aa85852f7f6779$var$FunctionsError("cancelled", "Firebase Functions instance was deleted.");
    // Check for an error status, regardless of http status.
    const error = $e5aa85852f7f6779$var$_errorForResponse(response.status, response.json);
    if (error) throw error;
    if (!response.json) throw new $e5aa85852f7f6779$var$FunctionsError("internal", "Response is not valid JSON object.");
    let responseData = response.json.data;
    // TODO(klimt): For right now, allow "result" instead of "data", for
    // backwards compatibility.
    if (typeof responseData === "undefined") responseData = response.json.result;
    if (typeof responseData === "undefined") // Consider the response malformed.
    throw new $e5aa85852f7f6779$var$FunctionsError("internal", "Response is missing data field.");
    // Decode any special types, such as dates, in the returned data.
    const decodedData = $e5aa85852f7f6779$var$decode(responseData);
    return {
        data: decodedData
    };
}
const $e5aa85852f7f6779$var$name = "@firebase/functions";
const $e5aa85852f7f6779$var$version = "0.11.6";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e5aa85852f7f6779$var$AUTH_INTERNAL_NAME = "auth-internal";
const $e5aa85852f7f6779$var$APP_CHECK_INTERNAL_NAME = "app-check-internal";
const $e5aa85852f7f6779$var$MESSAGING_INTERNAL_NAME = "messaging-internal";
function $e5aa85852f7f6779$var$registerFunctions(fetchImpl, variant) {
    const factory = (container, { instanceIdentifier: regionOrCustomDomain })=>{
        // Dependencies
        const app = container.getProvider("app").getImmediate();
        const authProvider = container.getProvider($e5aa85852f7f6779$var$AUTH_INTERNAL_NAME);
        const messagingProvider = container.getProvider($e5aa85852f7f6779$var$MESSAGING_INTERNAL_NAME);
        const appCheckProvider = container.getProvider($e5aa85852f7f6779$var$APP_CHECK_INTERNAL_NAME);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new $e5aa85852f7f6779$var$FunctionsService(app, authProvider, messagingProvider, appCheckProvider, regionOrCustomDomain, fetchImpl);
    };
    (0, $c682bcd2a19f8af3$export$c930050e7bb63965)(new (0, $83e41358bca2e3f4$export$16fa2f45be04daa8)($e5aa85852f7f6779$var$FUNCTIONS_TYPE, factory, "PUBLIC" /* ComponentType.PUBLIC */ ).setMultipleInstances(true));
    (0, $c682bcd2a19f8af3$export$d29d5299a7137abc)($e5aa85852f7f6779$var$name, $e5aa85852f7f6779$var$version, variant);
    // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation
    (0, $c682bcd2a19f8af3$export$d29d5299a7137abc)($e5aa85852f7f6779$var$name, $e5aa85852f7f6779$var$version, "esm2017");
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a {@link Functions} instance for the given app.
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 * @param regionOrCustomDomain - one of:
 *   a) The region the callable functions are located in (ex: us-central1)
 *   b) A custom domain hosting the callable functions (ex: https://mydomain.com)
 * @public
 */ function $e5aa85852f7f6779$export$7d4c14593b8a2193(app = (0, $c682bcd2a19f8af3$export$f9962582c9e66d99)(), regionOrCustomDomain = $e5aa85852f7f6779$var$DEFAULT_REGION) {
    // Dependencies
    const functionsProvider = (0, $c682bcd2a19f8af3$export$fa0d6da0f5838f50)((0, $706eb2584c77c6e1$export$4befe9b5fa509a1b)(app), $e5aa85852f7f6779$var$FUNCTIONS_TYPE);
    const functionsInstance = functionsProvider.getImmediate({
        identifier: regionOrCustomDomain
    });
    const emulator = (0, $706eb2584c77c6e1$export$a3febcf1f14a3a0c)("functions");
    if (emulator) $e5aa85852f7f6779$export$472343ee9d485d97(functionsInstance, ...emulator);
    return functionsInstance;
}
/**
 * Modify this instance to communicate with the Cloud Functions emulator.
 *
 * Note: this must be called before this instance has been used to do any operations.
 *
 * @param host - The emulator host (ex: localhost)
 * @param port - The emulator port (ex: 5001)
 * @public
 */ function $e5aa85852f7f6779$export$472343ee9d485d97(functionsInstance, host, port) {
    $e5aa85852f7f6779$var$connectFunctionsEmulator$1((0, $706eb2584c77c6e1$export$4befe9b5fa509a1b)(functionsInstance), host, port);
}
/**
 * Returns a reference to the callable HTTPS trigger with the given name.
 * @param name - The name of the trigger.
 * @public
 */ function $e5aa85852f7f6779$export$438b58c7f2c6bf5e(functionsInstance, name, options) {
    return $e5aa85852f7f6779$var$httpsCallable$1((0, $706eb2584c77c6e1$export$4befe9b5fa509a1b)(functionsInstance), name, options);
}
/**
 * Returns a reference to the callable HTTPS trigger with the specified url.
 * @param url - The url of the trigger.
 * @public
 */ function $e5aa85852f7f6779$export$486b60b301a0b194(functionsInstance, url, options) {
    return $e5aa85852f7f6779$var$httpsCallableFromURL$1((0, $706eb2584c77c6e1$export$4befe9b5fa509a1b)(functionsInstance), url, options);
}
/**
 * Cloud Functions for Firebase
 *
 * @packageDocumentation
 */ $e5aa85852f7f6779$var$registerFunctions(fetch.bind(self));






var $d41cf46441fcb495$var$name = "firebase";
var $d41cf46441fcb495$var$version = "10.13.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, $c682bcd2a19f8af3$export$d29d5299a7137abc)($d41cf46441fcb495$var$name, $d41cf46441fcb495$var$version, "app");


const $f28c8197d3b2b122$var$firebaseConfig = {
    apiKey: "AIzaSyAWy_AdDDm7ueDHLuvzwG3YQL2Asfh9R4w",
    authDomain: "unity-d90a5.firebaseapp.com",
    databaseURL: "https://unity-d90a5.firebaseio.com",
    projectId: "unity-d90a5",
    storageBucket: "unity-d90a5.appspot.com",
    messagingSenderId: "465051373740",
    appId: "1:465051373740:web:9809c8f19431c76e918f09"
};
const $f28c8197d3b2b122$export$729c8b7179294ba = (0, $c682bcd2a19f8af3$export$c55cfd413944906d)($f28c8197d3b2b122$var$firebaseConfig);


const $6e4321e933c8cf65$var$functions = (0, $e5aa85852f7f6779$export$7d4c14593b8a2193)((0, $f28c8197d3b2b122$export$729c8b7179294ba));
async function $6e4321e933c8cf65$export$2e2bcd8739ae039(endpoint, params) {
    const resp = await (0, $e5aa85852f7f6779$export$438b58c7f2c6bf5e)($6e4321e933c8cf65$var$functions, endpoint)(params);
    return resp.data;
}



const $af2a9b1bf6586921$var$CLASSES = [
    "mage",
    "rogue",
    "priest",
    "warlock",
    "warrior",
    "druid",
    "hunter",
    "paladin",
    "dark_priest",
    "crystal_mage",
    "bruiser_rogue",
    "blademaster_warrior",
    "eradicator_warlock",
    "smiter_paladin",
    "corruption_airion",
    "marksman_orin"
];
const $af2a9b1bf6586921$export$13dc4137905925d1 = {
    rogue: (/*@__PURE__*/$parcel$interopDefault($91214974a4505acb$exports)),
    mage: (/*@__PURE__*/$parcel$interopDefault($ced2bca4b04dc0d9$exports)),
    druid: (/*@__PURE__*/$parcel$interopDefault($d64390d43a823463$exports)),
    priest: (/*@__PURE__*/$parcel$interopDefault($8f58763fc858f573$exports)),
    warrior: (/*@__PURE__*/$parcel$interopDefault($04e7740abd1b7773$exports)),
    warlock: (/*@__PURE__*/$parcel$interopDefault($d662445dc22e608e$exports)),
    hunter: (/*@__PURE__*/$parcel$interopDefault($9e13773973309a8e$exports)),
    paladin: (/*@__PURE__*/$parcel$interopDefault($01f87719a9a60f47$exports)),
    dark_priest: (/*@__PURE__*/$parcel$interopDefault($942f72df8870c063$exports)),
    crystal_mage: (/*@__PURE__*/$parcel$interopDefault($1ad995008f55d4b9$exports)),
    bruiser_rogue: (/*@__PURE__*/$parcel$interopDefault($37fa17704c2c463c$exports)),
    blademaster_warrior: (/*@__PURE__*/$parcel$interopDefault($2eca6277e971ca99$exports)),
    eradicator_warlock: (/*@__PURE__*/$parcel$interopDefault($c284eba5c33e2fd5$exports)),
    smiter_paladin: (/*@__PURE__*/$parcel$interopDefault($554b5f7607202234$exports)),
    corruption_airion: (/*@__PURE__*/$parcel$interopDefault($5234bb79c235e4dc$exports)),
    marksman_orin: (/*@__PURE__*/$parcel$interopDefault($d8004ab6de1569d7$exports))
};
const $af2a9b1bf6586921$export$426db7a6155b7a80 = {
    boss: "SOULBOUND BOSS FIGHTS",
    ones: "DUEL",
    twos: "2v2",
    threes: "3v3",
    ctf: "CTF",
    ones_bot: "DUEL vs BOT",
    twos_bot: "2v2 vs BOTS",
    threes_bot: "3v3 vs BOTS",
    ctf_bot: "CTF vs BOTS"
};
const $af2a9b1bf6586921$export$dea41471f21a81e5 = {
    alpha: "ALPHA",
    s1: "EARLY ACCESS SEASON 1",
    s2: "EARLY ACCESS SEASON 2",
    full_s1: "SEASON 1",
    full_s2: "SEASON 2"
};
// public enum ArenaRank {
//   UNRANKED = 0,
//   BRONZE_I,
//   BRONZE_II,
//   BRONZE_III,
//   SILVER_I,
//   SILVER_II,
//   SILVER_III,
//   GOLD_I,
//   GOLD_II,
//   GOLD_III,
//   PLATINUM_I,
//   PLATINUM_II,
//   PLATINUM_III,
//   DIAMOND_I,
//   DIAMOND_II,
//   DIAMOND_III,
//   TITAN_I,
//   TITAN_II,
//   TITAN_III,
//   GRAND_TITAN,
// }
const $af2a9b1bf6586921$var$RANKS = {
    0: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2fb13c1bc62427bf$exports))),
        name: "UNRANKED",
        color: "#756158"
    },
    1: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($43a92d3d36619867$exports))),
        name: "BRONZE I",
        color: "#BA6E31"
    },
    2: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($b84c1348a88bd27c$exports))),
        name: "BRONZE II",
        color: "#BA6E31"
    },
    3: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($a73a186b2585051d$exports))),
        name: "BRONZE III",
        color: "#BA6E31"
    },
    4: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bebfd4a6184143fe$exports))),
        name: "SILVER I",
        color: "#D9D7D1"
    },
    5: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3e7904860ca9656d$exports))),
        name: "SILVER II",
        color: "#D9D7D1"
    },
    6: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($efe897d6529bda5c$exports))),
        name: "SILVER III",
        color: "#D9D7D1"
    },
    7: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($a296b61bac502e0a$exports))),
        name: "GOLD I",
        color: "#FFCA40"
    },
    8: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1cc8b0aaa1acdbf7$exports))),
        name: "GOLD II",
        color: "#FFCA40"
    },
    9: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1d6c7b0e3248c862$exports))),
        name: "GOLD III",
        color: "#FFCA40"
    },
    10: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($311dd5c675fee100$exports))),
        name: "PLATINUM I",
        color: "#3FFFC6"
    },
    11: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f24172bb4d6362c4$exports))),
        name: "PLATINUM II",
        color: "#3FFFC6"
    },
    12: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($afa6ad9a48137ecd$exports))),
        name: "PLATINUM III",
        color: "#3FFFC6"
    },
    13: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bdf50a473bd9e243$exports))),
        name: "DIAMOND I",
        color: "#3FC1FF"
    },
    14: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($d68b88ac38af1719$exports))),
        name: "DIAMOND II",
        color: "#3FC1FF"
    },
    15: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($b711b8daee063f82$exports))),
        name: "DIAMOND III",
        color: "#3FC1FF"
    },
    16: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8241c056730ed656$exports))),
        name: "TITAN I",
        color: "#3FFF52"
    },
    17: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c7f9ce3e6e552370$exports))),
        name: "TITAN II",
        color: "#3FFF52"
    },
    18: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($0ac5f841e7056e7c$exports))),
        name: "TITAN III",
        color: "#3FFF52"
    },
    19: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8db3137b4aba0951$exports))),
        name: "GRAND TITAN",
        color: "#FF252B"
    }
};
const $af2a9b1bf6586921$var$getIconForClass = (cls)=>{
    return $af2a9b1bf6586921$export$13dc4137905925d1[cls];
};
const $af2a9b1bf6586921$var$Row = ({ number: number, icon: icon, name: name, classIcon: classIcon, rank: rank, highlight: highlight })=>{
    const highlightStyle = highlight ? {
        background: "rgba(255, 255, 255, 0.05)",
        borderRadius: 8
    } : {};
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        style: {
            textTransform: "uppercase",
            display: "flex",
            alignItems: "center",
            padding: 8,
            ...highlightStyle
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                style: {
                    display: "inline-block",
                    width: 40,
                    textAlign: "right",
                    marginRight: 16
                },
                children: number
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                style: {
                    display: "inline-block",
                    marginRight: 8
                },
                children: icon
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                style: {
                    display: "inline-block",
                    marginRight: 8,
                    width: 340,
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis"
                },
                children: name
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                style: {
                    display: "inline-block",
                    marginRight: 8,
                    textAlign: "center"
                },
                children: classIcon
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                style: {
                    display: "inline-block",
                    flex: 1,
                    textAlign: "right",
                    fontSize: 22
                },
                children: rank
            })
        ]
    });
};
const $af2a9b1bf6586921$var$useData = (season, type)=>{
    const [data, setData] = (0, $7fPBF.useState)(null);
    (0, $7fPBF.useEffect)(()=>{
        setData(null);
        const controller = new AbortController();
        (0, $6e4321e933c8cf65$export$2e2bcd8739ae039)("getLeaderboards3", {
            season: season,
            type: type
        }).then((response)=>{
            console.log(response);
            if (!controller.signal.aborted) setData(response);
        });
        return ()=>controller.abort();
    }, [
        season,
        type
    ]);
    return data;
};
const $af2a9b1bf6586921$var$LeaderboardWrapper = ({ children: children, type: type, season: season, onTypeChanged: onTypeChanged, onSeasonChanged: onSeasonChanged })=>{
    const typeOptions = Object.keys($af2a9b1bf6586921$export$426db7a6155b7a80).map((key)=>{
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $608da1f87bc1fe5b$exports).Item, {
            value: key,
            children: $af2a9b1bf6586921$export$426db7a6155b7a80[key]
        }, key);
    });
    const seasonOptions = Object.keys($af2a9b1bf6586921$export$dea41471f21a81e5).map((key)=>{
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $608da1f87bc1fe5b$exports).Item, {
            value: key,
            children: $af2a9b1bf6586921$export$dea41471f21a81e5[key]
        }, key);
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $032aab6647148487$export$6d1402fb58384e4f), {
        label: "Leaderboards",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            style: {
                width: "100%"
            },
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        gap: 8
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $608da1f87bc1fe5b$exports).Root, {
                            value: season,
                            onValueChange: (e)=>onSeasonChanged(e),
                            style: {
                                marginRight: 8
                            },
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $608da1f87bc1fe5b$exports).Trigger, {
                                    variant: "soft",
                                    color: "green"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $608da1f87bc1fe5b$exports).Content, {
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $608da1f87bc1fe5b$exports).Group, {
                                        children: seasonOptions
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $608da1f87bc1fe5b$exports).Root, {
                            value: type,
                            onValueChange: (e)=>onTypeChanged(e),
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $608da1f87bc1fe5b$exports).Trigger, {
                                    variant: "soft",
                                    color: "green"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $608da1f87bc1fe5b$exports).Content, {
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $608da1f87bc1fe5b$exports).Group, {
                                        children: typeOptions
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    children: children
                })
            ]
        })
    });
};
function $af2a9b1bf6586921$var$darkenHexColor(hexColor, percent) {
    // Ensure the hex color starts with a #
    if (hexColor.startsWith("#")) hexColor = hexColor.slice(1);
    // Convert the hex color to RGB
    const r = parseInt(hexColor.substring(0, 2), 16);
    const g = parseInt(hexColor.substring(2, 4), 16);
    const b = parseInt(hexColor.substring(4, 6), 16);
    // Calculate the new RGB values by reducing brightness
    const darken = (color, percent)=>Math.max(0, Math.min(255, Math.floor(color * (1 - percent / 100))));
    const newR = darken(r, percent);
    const newG = darken(g, percent);
    const newB = darken(b, percent);
    // Convert the new RGB values back to hex and return the result
    const toHex = (value)=>value.toString(16).padStart(2, "0");
    return `#${toHex(newR)}${toHex(newG)}${toHex(newB)}`;
}
function $af2a9b1bf6586921$export$f829dc875a4981a2({ rank: rank }) {
    return $af2a9b1bf6586921$var$RANKS[rank] != null && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        style: {
            display: "flex",
            gap: 8,
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                style: {
                    fontSize: 14,
                    fontWeight: "bold",
                    color: $af2a9b1bf6586921$var$RANKS[rank].color,
                    textShadow: "0 0 5px " + $af2a9b1bf6586921$var$darkenHexColor($af2a9b1bf6586921$var$RANKS[rank].color, 40)
                },
                children: $af2a9b1bf6586921$var$RANKS[rank] ? $af2a9b1bf6586921$var$RANKS[rank].name : null
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                style: {
                    width: 32,
                    height: 32,
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        style: {
                            width: 1,
                            height: 1,
                            position: "absolute",
                            top: 16,
                            left: 16,
                            boxShadow: "0 0 7px 7px " + $af2a9b1bf6586921$var$RANKS[rank].color + "44"
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                        src: $af2a9b1bf6586921$var$RANKS[rank].icon
                    })
                ]
            })
        ]
    });
}
function $af2a9b1bf6586921$var$Leaderboards() {
    const params = (0, $6de75bb8982f6eaa$export$99eaa27ddbbb95ef)();
    const navigate = (0, $6de75bb8982f6eaa$export$9770f232ac06a008)();
    var _params_type;
    const type = (_params_type = params.type) !== null && _params_type !== void 0 ? _params_type : "ones";
    var _params_season;
    const season = (_params_season = params.season) !== null && _params_season !== void 0 ? _params_season : "full_s1";
    const data = $af2a9b1bf6586921$var$useData(season, type);
    const onTypeChanged = (0, $7fPBF.useCallback)((newType)=>{
        navigate(`/leaderboards/${season}/${newType}`);
    });
    const onSeasonChanged = (0, $7fPBF.useCallback)((newSeason)=>{
        navigate(`/leaderboards/${newSeason}/${type}`);
    });
    if (data == null) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($af2a9b1bf6586921$var$LeaderboardWrapper, {
        type: type,
        season: season,
        onTypeChanged: onTypeChanged,
        onSeasonChanged: onSeasonChanged,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            style: {
                textAlign: "center",
                padding: 20
            },
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62ca5e79378cd184$export$7f7cbe89f1eacd2), {})
        })
    });
    const rows = data.slice(0, 50).map((row, idx)=>{
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($af2a9b1bf6586921$var$Row, {
            number: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    idx + 1,
                    "."
                ]
            }),
            icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                style: {
                    borderRadius: 8
                },
                src: row.avatar,
                width: "32",
                height: "32"
            }),
            highlight: idx % 2 === 1,
            name: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1a29469ea96a6022$export$a6c7ac8248d6e38a), {
                to: "/player/" + row.id,
                children: idx == 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        row.name,
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("i", {
                            className: "fas fa-crown",
                            style: {
                                marginLeft: 4
                            }
                        })
                    ]
                }) : row.name
            }),
            classIcon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                style: {
                    borderRadius: 8
                },
                src: $af2a9b1bf6586921$var$getIconForClass(row.class),
                width: "32",
                height: "32"
            }),
            rank: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "end",
                    gap: 8
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($af2a9b1bf6586921$export$f829dc875a4981a2, {
                        rank: row.rank
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        style: {
                            width: 80
                        },
                        children: [
                            "(",
                            row.mmr,
                            ")"
                        ]
                    })
                ]
            })
        }, row.id + row.class);
    });
    const content = rows.length > 0 ? rows : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        children: "NO ENTRIES."
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($af2a9b1bf6586921$var$LeaderboardWrapper, {
        type: type,
        season: season,
        onTypeChanged: onTypeChanged,
        onSeasonChanged: onSeasonChanged,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($af2a9b1bf6586921$var$Row, {
                    number: "#",
                    icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        style: {
                            display: "inline-block",
                            width: 32
                        }
                    }),
                    name: "NAME",
                    classIcon: "TITAN",
                    rank: "RANK / MMR"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    style: {
                        height: 1,
                        background: "white",
                        margin: 8
                    }
                }),
                content
            ]
        })
    });
}
var $af2a9b1bf6586921$export$2e2bcd8739ae039 = $af2a9b1bf6586921$var$Leaderboards;





function $097a36482b746d2a$export$2e2bcd8739ae039(version, date, input) {
    const result = $097a36482b746d2a$var$parseMarkdownList(input);
    result.label = version + " PATCH NOTES";
    result.date = date;
    return result;
}
function $097a36482b746d2a$var$parseMarkdownList(markdown) {
    const lines = markdown.split("\n").filter((line)=>line.trim());
    function parseLines(lines, level = 0) {
        const items = [];
        while(lines.length){
            const line = lines[0];
            const currentIndent = line.search(/\S|$/); // Count leading spaces
            const isListItem = /^(\s*)[-*+]\s|^\s*\d+\.\s/.test(line); // Detect list items
            if (currentIndent < level) break; // End of current level
            if (isListItem && currentIndent === level) {
                lines.shift(); // Remove current line
                const label = line.trim().replace(/^[-*+]\s|^\d+\.\s/, ""); // Remove list marker
                const item = {
                    label: label,
                    children: []
                };
                // Parse children if they exist
                const children = parseLines(lines, level + 2); // Increase level by 2 spaces for indentation
                if (children.length) item.children = children;
                items.push(item);
            } else break;
        }
        return items;
    }
    return {
        label: "root",
        children: parseLines(lines)
    };
}


const $840435af9e77c74e$var$Notes = (0, $097a36482b746d2a$export$2e2bcd8739ae039)("1.0.0rc7", "Oct 23, 2024", `
- General
  - Improvements
    - Improved queue manager performance
    - Fixed an issue causing players to occasionally get put into a match after already being put into one.
    - Fixed an issue causing clicks to be eaten by floating combat text
    - Improved performance of authentication
    - Allowed for teams of 2 or 3 to queue for 3v3 (you can still solo queue too)
    - Made some adjustments to the MMR/rank system
    - The server now attempts to fix quest status if it gets out of sync on the client.
    - Made self titan frames show by default
    - Made combo point UI larger on nameplates
- Balance
  - Stormcaller
    - Lightning Storm now lasts 8 seconds (down from 10).
`);
var $840435af9e77c74e$export$2e2bcd8739ae039 = $840435af9e77c74e$var$Notes;



const $236d46d1878de3f7$var$Notes = (0, $097a36482b746d2a$export$2e2bcd8739ae039)("1.0.0rc8", "Oct 26, 2024", `
- General
  - Improvements
    - Fixed many potential Authentication errors
    - Further performance improvements to the Authentication flow
    - Fixed a couple of tooltip typos/correctness issues
    - Fixed an issue where going to the main menu while on the end game screen caused all of the UI to disappear
    - Fixed a rare edge case where you'd still get pulled out of a match to go into another one
    - Spells set to mouseover no longer default to cast on yourself if there is no target under the mouse
- Balance
  - General
    - Health pools have been increased by ~10%
    - 50% healing reduction in duels vs players
`);
var $236d46d1878de3f7$export$2e2bcd8739ae039 = $236d46d1878de3f7$var$Notes;



const $3b51bf76c4e654d4$var$Notes = (0, $097a36482b746d2a$export$2e2bcd8739ae039)("1.0.0rc9", "Oct 27, 2024", `
- General
  - Improvements
    - The matchmaking system now tries for a bit longer to find better matches, and will try to avoid placing solo queue players with teammates with far away ratings.
    - Damage dealt to yourself or teammates no longer counts on the end game screen.
    - Fixed the 3v3 tooltip claiming that it only allows solo queues.
    - Fixed a couple of tooltip typos.
    - Added a few new cosmetics to the shop pool.
- Balance
  - General
    - Lightning Storm reduced to 19 damage (down from 21) per tick.
    - Thorns now lasts 8 seconds (down from 10).
    - Thorns now ticks 3 times per second (down from 4 times per second).
    - Enhanced Power reduced to 15% (down from 20%) bonus damage.
    - Bandage now heals 20 per tick (up from 10).
    - Enhanced Resilience now reduces damage taken by 30% (up from 20%)
    - Toughness now reduces the duration of stuns by 25% (up from 20%).
    - Resolve now reduces the duration of Incapacitates by 25% (up from 20%).
    - Warmth now reduces the duration of slows and snares by 50% (up from 20%).
    - The "Explosive" talent now reduces the damage dealt by each explosion by 7% (up from 5%).
    - Bruiser talent "Resourceful" now always gives 1 combo points, without the bonus point when using 5cp.
    - Bruiser talent "Deep Wounds" now causes a 100% damage bleed from Shadow Blow (down from 150%).
    - Dark suppression now has a 45 sec cd (up from 40).
    - Naturalist Airion now automatically gets Nature Mode when loading into a match.
    - Stormcaller Airion now automatically gets Lightning Mode when loading into a match.
`);
var $3b51bf76c4e654d4$export$2e2bcd8739ae039 = $3b51bf76c4e654d4$var$Notes;



const $7ed097507043a648$var$Notes = (0, $097a36482b746d2a$export$2e2bcd8739ae039)("1.0.0rc10", "Oct 29, 2024", `
- General
  - Improvements
    - Attempted to improve Swift Justice and Sweeping Revenge land logic to avoid being so far away upon landing
    - Fixed a race condition when entering lobby at the same time as a match found caused your character to appear in the lobby and the match at the same time.
    - Fixed an issue with hats on the Airion model
    - Powerup orbs spawn every 60 seconds now (up from 45) after their initial spawn (which is 2mins)
    - The matchmaking system now tries much harder to ensure solo queue teammates are closer in rank
    - The matchmaking system now attempts to avoid repeat matchups for a small period of time
    - Added a new Halloween theme item which will be in tomorrows shop
- Balance
  - General
    - Righteous Defense now makes the target honored for 90 seconds (up from 70 seconds)
    - Glacial Encapsulation now has a 90 second cooldown (up from 60 seconds)
    - Dark Suppression now has a 60 second cooldown (up from 45 seconds)
    - Soul Recovery now has a 40 second cooldown (up from 35 seconds)
    - Chain Breaker now has an 80 second cooldown (up from 70 seconds)
    - Enhanced Power now has a 45 second cooldown (down from 60 seconds)
    - Holy Fortitude now has a 90 second cooldown (up from 60 seconds)
    - Earth Shield now has a 90 second cooldown (up from 60 seconds)
    - Empowered Shields now has a 90 second cooldown (up from 60 seconds)
`);
var $7ed097507043a648$export$2e2bcd8739ae039 = $7ed097507043a648$var$Notes;



const $e538aa4e3bbd3d32$var$Notes = (0, $097a36482b746d2a$export$2e2bcd8739ae039)("1.0.0rc11", "Nov 1, 2024", `
- General
  - Improvements
    - During the intro/outro cinematics you'll now play one of your equipped emotes if you have one
  - Fixes
    - Fixed an issue preventing customizations from showing on the end game cinematic
    - Fixed an issue with the flare tooltip
    - Fixed an issue where you could cast spells on dead targets
    - Fixed an issue causing the global cooldown tracker settings not to work properly
- Balance
  - General
    - Powerup Orbs now must be killed before the powerup is received and have 75 health.
    - Interdimensional Portals no longer increases movement speed.
    - Increased the cast time of the 4th Frost Crystal cast to 1.8 sec (up from 1 sec)
    - Increased the cast time of the 4th Fire Crystl cast to 1.8 sec (up from 1.5 sec)
    - Reduced the duration of crystals to 8 seconds (down from 16 seconds)
    - "Improved Righteous Shield" now only increases the targets movement speed by 25% (down from 50%)
    - "Soothing Souls" now restores 75% of the health taken from teammates after 4 seconds (changed from 100% after 6 seconds)
    - Requisite Confession now has a 35 second CD (down from 60 sec)
    - Righteous Hindrance now slows the target by 15% and has a 15 yard range (changed from no slow and 10 yard range)
    - Fixed an issue causing Righteous Hindrance not granding a stack of Divine Empowerment
    - Mystical Brilliance now heals for 12 on Smiter (up from 8)
    - Fixed an issue causing Sedative Shot to sometimes fully interrupt targets for 6 seconds (w/ the talent) who weren't actually casting
    - Rupture base damage changed to 1/2/4/6/11 (from 1/2/4/7/13)
    - The Ruptured Organ talent now also increases the damage dealt by Rupture by 10% (changed from previously lowering the damage per tick)
    - Reduced the Bruiser passive momentum from jumping from 14 to 12
    - Reduced the Warmth general talent from 50% reduction in Slows and Snares to 30%
`);
var $e538aa4e3bbd3d32$export$2e2bcd8739ae039 = $e538aa4e3bbd3d32$var$Notes;



const $e2036aea0a5c990a$var$Notes = (0, $097a36482b746d2a$export$2e2bcd8739ae039)("1.0.0rc12", "Nov 3, 2024", `
- General
  - Improvements
    - Fixed an issue causing the Soul Leak talent to crash the game when it bounced damage into another shield with Soul Leak
    - Kill Shot now glows when it is active (target below 20% HP)
    - Added the stun duration to the tooltip of Crystal Blast
    - Fixed an issue where your whole game would break if you got a match while previewing a shop item
    - Fixed a couple of bugs with the chat system
- Balance
  - General
    - The powerup orbs have been removed and replaced with a general dampening system. After 2 minutes of game time, a 1% multiplicative healing/shielding reduction will apply every 6 seconds to everyone in the match.
      - The powerup orbs remain in CTF.
  - Crystalmancer
    - Crystalmancer's "Crystal Blast" is now instant cast (was: 1 second cast).
`);
var $e2036aea0a5c990a$export$2e2bcd8739ae039 = $e2036aea0a5c990a$var$Notes;



const $6f3fe2121e3199ff$var$Notes = (0, $097a36482b746d2a$export$2e2bcd8739ae039)("1.0.0rc13", "Nov 4, 2024", `
- General
  - Improvements
    - The CC overlay always picks the longest CC to show now.
    - When Titan frame icons are replaced with important buffs, CC now has priority over other effects.
    - The mature language filter now works on player names in addition to chat messages.
    - Updated the action bar context menu (for selecting target, focus, etc) to be dark to be easier to see.
    - The action bar context menu now closes when you go to the main menu if you don't close it yourself.
    - Buff tooltips now show whether that buff can be removed by Sacred Cleansing.
    - Added a few new cosmetics to the pool.
    - You can now purchase Obol vouchers  in the misc section of the shop. This will give you a one-time code to redeem that amount of Obols which you can share with friends, do giveaways, run tournaments, or whatever you'd like.
    - The Diminishing Return (DR) count now shows on the DR tracker icons.
    - The spectator camera can now zoom out further while locked on a player.
  - Fixes
    - Improved collision issues causing players to fall out of bounds of arena occasionally.
    - Fixed a bug causing the Sharp Ice projectiles to be permanently floating sometimes.
    - Fixed a few tooltip typos and incorrect information.
    - The self Titan frame can now be properly aligned with the target/focus frame. You will have to adjust your UI layout if you've moved it.
- Balance
  - General
    - A new stack of dampening is now added once every 3 seconds (down from 6 seconds) after starting.
    - Fixed a bug with Bandage causing multiple heals on the first tick sometimes.
    - Increased animation speeds for several key spells (Inner Rage, Shadow Blink, Frost Portal, Shadow Demons).
  - Soulstealer
    - Essence Burst is now a 1.5 second cast (up from 1.3 seconds)
    - The Soothing Souls talent now only restores 50% of health taken (down from 75%).
    - Ethereal Binding now lasts 7 seconds (down from 9).
    - Fixed a bug causing the Soul Capture talent to unintentionally reduce the cooldown of Soul Recovery by 18 seconds instead of 8.
  - Crystalmancer
    - Added a range to Crystal Blast (40 yards) and a LoS check.
  - Blademaster
    - Inner Rage is no longer on GCD, and now increases all physical damage dealt by 50% for 4 seconds.
  - Assassin
    - Fixed an issue with Smoke Screen allowing enemy teammates to heal into it.
  - Naturalist
    - Slam no longer requires Lightning Form to cast.
`);
var $6f3fe2121e3199ff$export$2e2bcd8739ae039 = $6f3fe2121e3199ff$var$Notes;



const $09610735bb769f94$var$Notes = (0, $097a36482b746d2a$export$2e2bcd8739ae039)("1.0.0rc14", "Nov 8, 2024", `
- General
  - Improvements
    - Added new Skin cosmetics - 2 appear in the shop each day
    - Added 3x exp for 3v3s
    - Made the tier 2 bow cosmetics larger
    - Tons of server hotfixes and performance improvements (mostly already hotfixed on 1.0.0rc13)
    - Some more tooltip fixes/improvements
    - Added support for translations for spells, talents, and buffs
      - Currently only Chinese Traditional & Simplified is supported, thanks to \u{65E5}\u{66AE} who translated them
      - It's using your system language to pick the language at the moment
      - If you're interested in helping to translating to a language you know, please DM me on Discord
    - Fixed an issue where the mature language filter wouldn't apply to player names in chat messages
    - Sped up animation times ~2x for Smoke Bomb (Assassin) and Soul Recovery (Soulstealer)
  - Bug fixes
    - Fixed an issue where Multishot (Marksman) could target invisible units
    - Fixed an issue with the target/focus mouseover keybinds when hovering over UI elements
`);
var $09610735bb769f94$export$2e2bcd8739ae039 = $09610735bb769f94$var$Notes;



const $aab0fbc91d2d0f8b$var$Notes = (0, $097a36482b746d2a$export$2e2bcd8739ae039)("1.0.0rc15", "Nov 9, 2024", `
- General
  - Improvements
    - Added new settings for nameplate overall scale and nameplate buff scale.
    - Added a 500 obol voucher to the shop.
  - Bug fixes
    - Fixed some issues with formatting in the translations.
    - Fixed an issue causing the mouseover hit box to be larger than intended for buffs.
    - Fixed some issues with the new skins.
    - Possibly fixed the T-Pose & nameplate bug that occurs very rarely.
    - Reduced the likelyhood of the issue where your client breaks after waiting for authentication for a while.
    - Fixed a bug where auto run would not correctly cancel in-progress casts/channels.
    - Fixed an issue where Sacred Cleansing a target in combat would not put the caster in combat.
- Balance
  - Soulstealer
    - Spirit Sector is now an instant cast spell (was: 1 sec cast).
  - Blademaster
    - The talent "Overpowered" now also increases the cooldown of Power Strike by 5 seconds.
    - "Inner Rage" now increases physical damage dealt by 35% for 5 seconds (changed from 50% for 4 seconds).
  - Naturalist & Stormcaller
    - Cultivation now stacks to 3 (up from 2).
  - Cleric
    - Added a new baseline spell called "Power Burn", which reads:
      - Deal 2 damage to the target and reduce the amount of outgoing healing & shielding they do by 2% per stack for 30 seconds. Stacks up to 30 times.
  - Assassin
    - Replaced the talent "Ambush" with a new talent called "Cheap Tactics" which reads:
      - Blow from the Shadows and Poison Blade increase all damage taken by the target by 20%.
  - Eradicator
    - Dark Portal is now baseline available for Eradicator.
    - The portal talent has been replaced with "Death Wish" (from Plaguebringer), which reads:
      - When Demon Skull hits a target, heal for 50 health.
  - Plaguebringer
    - The passive "Soul Essence" now stacks to 5, and provides 2% physical damage reduction per stack (changed from 1% stacking to 10).
    - The talent "Empowered Soul Essence" has been changed and now reads:
      - Consume all stacks of Soul Essence to reduce all physical damage taken by 6% per stack for 12 seconds.
      - The cooldown has also changed from 30 seconds to 45 seconds.
  - Crystalmancer
    - Crystals now last 10 seconds (up from 8 seconds).
    - The cast time of the 4th frost crystal is now 1.5 sec (down from 1.8 sec).
  - Lightbringer
    - Righteous Flash now has a 6 second cooldown (up from 5 seconds).
    - Mystical Brilliance now deals 9 damage when cast on an enemy target (down from 12).
  - Lightbringer & Smiter
    - Righteous Defense lasts 8 seconds now on allies (down from 10 sec).
      - It still lasts 10 seconds when cast on yourself.
`);
var $aab0fbc91d2d0f8b$export$2e2bcd8739ae039 = $aab0fbc91d2d0f8b$var$Notes;



const $13b43309586d560c$var$Notes = (0, $097a36482b746d2a$export$2e2bcd8739ae039)("1.0.0rc16", "Nov 13, 2024", `
- General
  - General
    - You're no longer allowed to queue for any bracket with multiple of the same Titan (e.g. double Assassin).
  - Bug fixes
    - Fixed an issue where units would occasionally be invisible (already hotfixed).
- Balance
  - General
    - Dev Note: The intention of the balance changes in 1.0.0rc16 is to:
      - Attempt to close out games quicker without having to go deep into dampening.
      - Give double DPS compositions a better chance in 2v2.
      - Rewarding smart & strategic cooldown trades rather than encouraging just pressing defensives whenever they are available.
    - Master of Battle can no longer be used while Stunned, Silenced or Incapacitated.
    - Enhanced Resilience now lasts 8 seconds (down from 10 seconds).
    - The cooldown of Enhanced Resilience has been increased to 80 seconds (up from 60 seconds).
    - Toughness and Resolve (Stun/Incap reduction talents) have had their effects reduced to 20% (down from 25%).
  - Cleric
    - Blessed Light healing has been increased by 33%.
    - The Power Burn debuff now lasts 45 seconds and reduces healing/shielding by 2.5% per stack (up from 30 sec, 2% per stack).
  - Lightbringer
    - Righteous Defense can no longer be cast on friendly targets other than the caster while Stunned, Silenced, or Incapacitated.
  - Plaguebringer
    - Curses now correctly apply the passive "Soul Essence".
`);
var $13b43309586d560c$export$2e2bcd8739ae039 = $13b43309586d560c$var$Notes;



const $3c5eca3b738805b1$var$Notes = (0, $097a36482b746d2a$export$2e2bcd8739ae039)("1.0.0rc17", "Nov 18, 2024", `
- General
  - Improvements
    - Instant cast spells with animation times now show a cast bar (with a different, yellow color).
      - This is something I want to try - it adds a lot of clarity to the game and I think it fixes the feeling of "unresponsiveness" as you can see a clear indicator of what's going on.
      - Will create a thread on this to gather feedback and adjust as necessary.
    - You can now drag your mouse over top of Titan Frames and Nameplates to drag the camera without it blocking the drag.
    - Added a setting to prevent the chat window from fading out.
    - Made some slight adjustments to the matchmaking algorithm.
      - Including some artificial inflation. This will replace top50 decay for now, and we'll see how it is working.
    - Airion now gets their main form back after respawning in CTF.
    - Fixed some more tooltip incorrectness issues on various spells.
- Balance
  - General
    - Absorption now absorbs 40 damage (down from 50).
  - Naturalist
    - Cultivation now heals 8 per stack on expiration (down from 9 per stack).
  - Assassin / Bruiser
    - Shadow Strike base damage has been increased to 4 / 10 alternating (up from 3 / 9).
  - Soulstealer
    - Essence Burst has been reduced to a 1.4 second cast (down from 1.5 sec).
    - Fixed some issues with Soul Swap - it should now function as expected.
  - Fighter
    - The passive "Shattered Armor" now increases the physical damage taken by the target by 0.4% per stack and stacks to 10 (changed from 1% per stack stacking to 5).
    - Swift Justice now triggers the cooldown when used on friendly targets.
  - Blademaster
    - The "Overpowered" talent has been changed to increase the cooldown of Devastating Strike by 1 sec (changed from increasing the CD of Power Strike by 5 sec).
`);
var $3c5eca3b738805b1$export$2e2bcd8739ae039 = $3c5eca3b738805b1$var$Notes;



const $c25e12ff1d53e4a6$var$Notes = (0, $097a36482b746d2a$export$2e2bcd8739ae039)("1.0.0rc17a", "Dec 1, 2024", `
- General
  - Improvements / Fixes
    - Added settings to disable showing cast bars for animation times (called uninterruptible spells).
      - This can be toggled for each nameplate/titan frame individually.
    - Minor tooltip fixes.
    - Fixed some rare errors.
`);
var $c25e12ff1d53e4a6$export$2e2bcd8739ae039 = $c25e12ff1d53e4a6$var$Notes;



var $081758a6359f9a3c$exports = {};
$081758a6359f9a3c$exports = new URL("gif1.3f047513.webm", import.meta.url).toString();


var $c2ad65b061033bbc$exports = {};
$c2ad65b061033bbc$exports = new URL("gif2.7729b7fa.webm", import.meta.url).toString();


var $c05d06f852041174$exports = {};
$c05d06f852041174$exports = new URL("gif5.d935d903.webm", import.meta.url).toString();


var $1126e6e04bdbfbc4$exports = {};
$1126e6e04bdbfbc4$exports = new URL("gif3.d22634dd.webm", import.meta.url).toString();


var $688a7387d200161c$exports = {};
$688a7387d200161c$exports = new URL("runes.49e40666.jpeg", import.meta.url).toString();


var $5a6956292b55d120$exports = {};
$5a6956292b55d120$exports = new URL("friends.9562da31.jpeg", import.meta.url).toString();


var $327da6560f2f8783$exports = {};
$327da6560f2f8783$exports = new URL("chat.45bda19b.jpeg", import.meta.url).toString();


var $aa55a78d2bda3451$exports = {};
$aa55a78d2bda3451$exports = new URL("settings.92ba71a7.jpeg", import.meta.url).toString();


var $f12c3253b58948ea$exports = {};
$f12c3253b58948ea$exports = new URL("shop.c1b59597.jpeg", import.meta.url).toString();




function $b0bc79b9cf9652e7$export$96d9fc423ab60b4d({ children: children }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $bee696b036d759c9$export$60332b2344f7fe41), {
        style: {
            fontFamily: '"Montserrat", sans-serif'
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("b", {
                style: {
                    fontSize: 18
                },
                children: "Developer Note"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("i", {
                    children: children
                })
            })
        ]
    });
}




var $7fPBF = parcelRequire("7fPBF");
function $d547e444859ed572$export$6663d34114c75100({ media: media, subtitle: subtitle }) {
    const [expanded, setExpanded] = (0, $7fPBF.useState)(false);
    const mediaEle = media.includes("webm") ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("video", {
        style: {
            width: "100%",
            borderRadius: 8,
            margin: "8px 0",
            cursor: "pointer"
        },
        onClick: ()=>setExpanded((old)=>!old),
        loop: true,
        autoPlay: true,
        muted: true,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("source", {
            src: media,
            type: "video/webm"
        })
    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
        src: media,
        style: {
            width: "100%",
            borderRadius: 8,
            margin: "8px 0",
            cursor: "pointer"
        },
        onClick: ()=>setExpanded((old)=>!old)
    });
    const expandedEle = expanded ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        style: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            background: "rgba(0, 0, 0, 0.95)"
        },
        onClick: ()=>setExpanded(false),
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                style: {
                    width: "80%"
                },
                children: mediaEle
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                style: {
                    fontSize: 14,
                    fontStyle: "italic"
                },
                children: subtitle
            })
        ]
    }) : null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                style: {
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column"
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        style: {
                            width: "100%",
                            maxWidth: 616
                        },
                        children: mediaEle
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        style: {
                            fontSize: 14,
                            fontStyle: "italic"
                        },
                        children: subtitle
                    })
                ]
            }),
            expandedEle
        ]
    });
}


const $51bfda0fc616004a$var$Notes = {
    label: "1.0 PATCH NOTES",
    date: "Oct 21, 2024",
    subtitle: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                children: [
                    "1.0 will release on ",
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                        children: "Oct 21, 2024"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $b0bc79b9cf9652e7$export$96d9fc423ab60b4d), {
                children: [
                    "It's been over ",
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                        children: "2 years"
                    }),
                    " since the last update. Thank you all for the support and for sticking around while waiting for an update, I hope this absolutely massive ",
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                        children: "1.0 update"
                    }),
                    " will bring a new wave of enjoyment to Ring of Titans."
                ]
            })
        ]
    }),
    children: [
        {
            label: "NEW FEATURES & UPDATES",
            children: [
                {
                    label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                        children: "New Titans"
                    }),
                    children: [
                        {
                            label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                    href: "/titan/soulstealer",
                                    children: "Soulstealer Kanna"
                                })
                            }),
                            children: [
                                "An offensive, vulnerable healer that transfers health between herself and her teammates."
                            ]
                        },
                        {
                            label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                    href: "/titan/crystalmancer",
                                    children: "Crystalmancer Azora"
                                })
                            }),
                            children: [
                                "A hybrid melee / caster that utilizes all elements to deal massive amounts of burst."
                            ]
                        },
                        {
                            label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                    href: "/titan/bruiser",
                                    children: "Bruiser Volen"
                                })
                            }),
                            children: [
                                "A versatile and mobile melee damage dealer that can focus on bleeds, burst, or sustain depending on build choices."
                            ]
                        },
                        {
                            label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                    href: "/titan/blademaster",
                                    children: "Blademaster Tarcza"
                                })
                            }),
                            children: [
                                "A two-handed sword wielding melee damage dealer with high mobility and sustain, but not many defensive options."
                            ]
                        },
                        {
                            label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                    href: "/titan/smiter",
                                    children: "Smiter Anthriel"
                                })
                            }),
                            children: [
                                "A two-handed hammer wielding melee damage dealer with great support and high burst damage but few mobility tools."
                            ]
                        },
                        {
                            label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                    href: "/titan/eradicator",
                                    children: "Eradicator Malrah"
                                })
                            }),
                            children: [
                                "A caster with consistent high burst damage and high control that casts a lot with not many defensive options."
                            ]
                        },
                        {
                            label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                    href: "/titan/stormcaller",
                                    children: "Stormcaller Airion"
                                })
                            }),
                            children: [
                                "A hybrid caster & healer with huge burst potential which can be difficult to set up."
                            ]
                        },
                        {
                            label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                    href: "/titan/marksman",
                                    children: "Marksman Orin"
                                })
                            }),
                            children: [
                                "A ranged physical damage dealer which is less mobile than Hunter Orin, but has higher damage with the tradeoff of having to stand still to cast more."
                            ]
                        }
                    ],
                    after: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d547e444859ed572$export$6663d34114c75100), {
                        media: (0, (/*@__PURE__*/$parcel$interopDefault($c05d06f852041174$exports))),
                        subtitle: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                "The new ",
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                    children: "Smiter Anthriel"
                                }),
                                " Titan winning a duel against ",
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                    children: "Stormcaller Airion"
                                }),
                                "."
                            ]
                        })
                    })
                },
                {
                    label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                        children: "Balance Pass"
                    }),
                    children: [
                        "All existing Titans have had a balance pass, adjusting damage numbers, spell availability, and Talents.",
                        {
                            label: "All Titans now have a thematic passive intended to increase skill cap without increasing the barrier to entry.",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                    children: [
                                        "You can learn more about each Titan's passive ability",
                                        " ",
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                            href: "/titans",
                                            children: "here"
                                        }),
                                        "."
                                    ]
                                })
                            ]
                        },
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                "All Titans now have ",
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                    children: "Chain Breaker"
                                }),
                                " out of the box, which is no longer a general Talent."
                            ]
                        }),
                        {
                            label: "4 new General Talents have been introduced:",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                            children: "Toughness"
                                        }),
                                        ": Passive 20% reduction in Stun duration."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                            children: "Resolve"
                                        }),
                                        ": Passive 20% reduction in Incapacitate duration."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                            children: "Warmth"
                                        }),
                                        ": Passive 20% reduction in Snare and Slow duration."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                            children: "Enhanced Resilience:"
                                        }),
                                        " A new spell which grants 20% damage reduction for 10 seconds."
                                    ]
                                })
                            ]
                        },
                        "You'll now choose 3 out of the 9 available general Talents (instead of 2 out of 6).",
                        "The diminishing returns timer to reset crowd control durations has been increased to 22 seconds (up from 18 seconds).",
                        "The combat timer has been increased to 6 seconds (up from 5 seconds).",
                        "There are too many Titan balance changes to list each one out here, so you'll have to explore in game to learn of all of the changes."
                    ],
                    after: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b0bc79b9cf9652e7$export$96d9fc423ab60b4d), {
                                children: "Overall, the goal for 1.0 is to make the game faster paced, as well as improving some poorly designed Talents. Damage and healing is higher, health pools are lower. The new Talents to reduce crowd control durations and a longer DR timer make it so you spend less time in crowd control and more time playing."
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d547e444859ed572$export$6663d34114c75100), {
                                media: (0, (/*@__PURE__*/$parcel$interopDefault($081758a6359f9a3c$exports))),
                                subtitle: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                                    children: "Existing Titans fighting with higher damage."
                                })
                            })
                        ]
                    })
                },
                {
                    label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                        children: "Capture the Flag"
                    }),
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                            children: "A new 5v5 Capture the Flag (CTF) mode has been introduced, alongside a brand new map for it."
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                            children: "In this mode, there are two teams of 5 players attempting to capture the flag from the other team's dock."
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                            children: "There's a map UI built just for this mode where you can see the locations of other players and the flags."
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                            children: "If you die, you'll respawn after 20 seconds."
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                            children: "To capture the enemy team's flag, you need to bring it from the enemy team's dock to your own dock while the enemy team does not hold your flag."
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                            children: "To return your flag back to your base after it has been captured, you simply kill the Titan who captured the flag."
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                            children: "The first team to capture 3 flags wins. If no team has captured 3 flags by 15 minutes, the team with more captures will win. If both teams have an equal number of captures at 15 minutes, it will be a draw."
                        })
                    ],
                    after: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d547e444859ed572$export$6663d34114c75100), {
                        media: (0, (/*@__PURE__*/$parcel$interopDefault($c2ad65b061033bbc$exports))),
                        subtitle: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                            children: "Gameplay on the new CTF mode."
                        })
                    })
                },
                {
                    label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                        children: "Powerups"
                    }),
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                    children: "Powerups"
                                }),
                                " have been introduced, which are orbs that provide bonuses to the team who picks them up."
                            ]
                        }),
                        {
                            label: "All Powerups:",
                            children: [
                                "Look like a glowing orb.",
                                "Can be picked up by walking near them.",
                                "Spawn on top of small raised platforms on each map.",
                                "Apply to your entire team (or the enemy team) when picked up.",
                                "Begin spawning after 2 minutes of play time (not counting prep time).",
                                "Spawn every 45 seconds after the first spawn.",
                                "Last for the remainder of the match after being picked up.",
                                "Stack infinitely."
                            ]
                        },
                        {
                            label: "There are currently 3 Powerups:",
                            children: [
                                "10% Damage Bonus (purple, always spawns in the center).",
                                "10% Damage Reduction Bonus (green, spawns in a corner).",
                                "10% Healing Reduction Debuff (applies to the opposite team) (yellow, spawns in a corner)."
                            ]
                        },
                        "There is also new UI that you can use to track the Powerup timers and pickups by each team.",
                        , 
                    ],
                    after: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b0bc79b9cf9652e7$export$96d9fc423ab60b4d), {
                        children: 'The intent here is to add a more strategic element to the game in addition to the micro gameplay skill already involved. The new powerups also replace the old "Dampening" effect that would automatically apply throughout the match to ensure matches eventually end.'
                    })
                },
                {
                    label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                        children: "Runes & Titan Points"
                    }),
                    children: [
                        {
                            label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                children: [
                                    "There's now a new currency called ",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("b", {
                                        children: "Titan Points"
                                    }),
                                    ", which you can use to buy ",
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("b", {
                                        children: "Runes"
                                    }),
                                    "."
                                ]
                            })
                        },
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("b", {
                                    children: "Runes"
                                }),
                                " provide small stat bonuses (such as dealing 1-3% more physical damage), and you can use up to 3 Runes at once."
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                "Each ",
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("b", {
                                    children: "Rune"
                                }),
                                " has 3 tiers, where you must buy the previous tier before unlocking the next. You are able to stack multiple Runes of the same type of different tiers."
                            ]
                        }),
                        {
                            label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                                children: "You'll earn Titan Points by playing arenas or the new CTF mode against players. You'll be able to earn up to 7000 Titan Points each week."
                            })
                        },
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                            children: "After you've purchased all of the Runes you wish to acquire each Season, you can exchange Titan Points for Obols in the Shop. Titan Points will reset each Season, but Obols will not."
                        })
                    ],
                    after: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b0bc79b9cf9652e7$export$96d9fc423ab60b4d), {
                                children: "One of the original goals of Ring of Titans was to ensure there was no grind required to play. However, it's always nice to have something to work towards to get a sense of progression as you play. So the goal here is to find a good balance between giving a sense of progression while still ensuring the advantage is not too high. In addition, having Runes adds a theorycrafting metagame around which Runes to buy first and determining which are best for which Titans in in which scenarios and matchups, which can be fun for players into that part of the game."
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d547e444859ed572$export$6663d34114c75100), {
                                media: (0, (/*@__PURE__*/$parcel$interopDefault($688a7387d200161c$exports))),
                                subtitle: "The new Rune selection UI"
                            })
                        ]
                    })
                },
                {
                    label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                        children: "Social Features"
                    }),
                    children: [
                        "You can now add friends directly in game. Just right-click on any Titan frame or chat message to add a friend.",
                        "The Steam-based party system has been replaced entirely with an in-game system. This makes it easy to find teammates to play with in game.",
                        "You can now send whispers in the game directly to other players.",
                        "You can now challenge players, add friends, or invite to party by right-clicking chat messages (in addition to Titan frames).",
                        "Inappropriate chat messages can now be reported directly in game by right-clicking the message.",
                        'As also noted below in "Chat Improvements", there are now chat channels that can be organized into tabs, such as global chat, LFG, team, party, etc.'
                    ],
                    after: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d547e444859ed572$export$6663d34114c75100), {
                        media: (0, (/*@__PURE__*/$parcel$interopDefault($5a6956292b55d120$exports))),
                        subtitle: "UI to add a new friend or share your friend ID."
                    })
                },
                {
                    label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                        children: "Chat Improvements"
                    }),
                    children: [
                        "Introduced chat channels to keep chat organized and allow chatting within a zone, team, party, etc.",
                        {
                            label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                                children: "In addition, you can now create up to 8 chat tabs with custom names and choose which channels display in each tab."
                            })
                        },
                        {
                            label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                                children: "There's additionally a new chat channel for the combat log, showing all damage dealt and the source. This also shows the raw amount, such as `12.4` which was previously inaccessible."
                            })
                        },
                        {
                            label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                                children: "Changed the Chat UI to use a font that is easier to read, and increased the font size."
                            })
                        },
                        {
                            label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                                children: "All chat messages now contain a timestamp of when it was sent."
                            })
                        },
                        {
                            label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                                children: "Chat no longer scrolls to the bottom if you're not already scrolled to the bottom, allowing you to read messages in the middle without constantly being scrolled back down."
                            })
                        },
                        {
                            label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                                children: "Chat performance has been improved significantly. The max number of messages shown has been increased to 1000."
                            })
                        }
                    ],
                    after: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d547e444859ed572$export$6663d34114c75100), {
                        media: (0, (/*@__PURE__*/$parcel$interopDefault($327da6560f2f8783$exports))),
                        subtitle: "New chat UI including chat tabs and a combat log channel."
                    })
                },
                {
                    label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                        children: "Settings Improvements"
                    }),
                    children: [
                        {
                            label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                                children: "A ton of new settings have been introduced, including:"
                            }),
                            children: [
                                "A setting to choose which cooldowns are tracked on the global enemy cooldown tracker UI.",
                                "Settings to choose which cooldowns are tracked for each individual cooldown tracker on Titan Frames.",
                                "Settings to choose which buffs show on each Titan Frame/Nameplate.",
                                "Settings to enable/disable UI tinting when Titans are out of a chosen range (e.g. fade out when over 40 yards away).",
                                "A hold-to-cast setting which allows you to hold a key down to continually cast it instead of having to spam a keybind over and over.",
                                "A setting to disable auto spell swapping, which allows you to separately keybind buff cancel spells (e.g. Cancel Glacial Encapsulation).",
                                "A setting to fade out your own nameplate while you have a target.",
                                "Settings to hide player names, and disable chat bubbles (useful for streamers / content creators).",
                                "And more..."
                            ]
                        },
                        {
                            label: "UI Edit Mode",
                            children: [
                                {
                                    label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                                        children: "There's a new setting to enable moving and resizing frames, which pops up a UI allowing you to move and resize all frames at once. This will make it much easier to set up your UI without having to jump into bot games to get all of the frames to show up."
                                    })
                                },
                                {
                                    label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                                        children: "In addition, UI frames that were previously not movable can now be moved and resized, such as the self cast bar, and the crowd control overlay."
                                    })
                                },
                                {
                                    label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                                        children: "The new edit mode also snaps frames to a grid, as you move them allowing the creation of clean UIs."
                                    })
                                }
                            ]
                        },
                        "You can now import & export UIs, so it's easy to share your UI layout with your friends.",
                        "In addition, the UI & keybinding settings sections have been reorganized to be much easier to use."
                    ],
                    after: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d547e444859ed572$export$6663d34114c75100), {
                        media: (0, (/*@__PURE__*/$parcel$interopDefault($aa55a78d2bda3451$exports))),
                        subtitle: "Explore a plethora of well organized settings in the updated settings UI."
                    })
                },
                {
                    label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                        children: "Visual Improvements"
                    }),
                    children: [
                        "All Titan models have been updated with brand new high quality 3D models.",
                        "The spell VFX for every single existing spell and all animations have been redone to be far more polished and satisfying.",
                        "Shading, fog, and overall graphical cohesion have all been vastly improved.",
                        "Every map, including the lobby and each arena has been improved visually.",
                        "The UI now has satisfying animations and sound effects.",
                        {
                            label: "Loads of additional visual improvements:",
                            children: [
                                "Added a sun, which rotates, gets bigger near the horizon and is synced with the other players in the lobby.",
                                "Grass now emits shadows and has improved shading.",
                                "Lighting has been improved in every map.",
                                "The feet of Titan models now matches the ground (i.e. it won't clip through the ground).",
                                "Titan models now rotate to match the terrain while moving.",
                                "God ray VFX has been added.",
                                "Fixed several visual issues and bugs with animation transitions.",
                                "Titan models now properly close their hands around their weapons.",
                                "Your Titan's head now turns to face the same direction that the camera is facing.",
                                "Added a flash visual effect when taking damage or being healed.",
                                "Transitions between running, sprinting, and walking are now done smoothly.",
                                "Improved floating combat text animation and visual artifacts (such as showing too far away, in the wrong location, and off-screen).",
                                "Visual effects no longer instantly disappear, they have clean fade out animations.",
                                "Visual effects attached to Titans now properly align while mounted.",
                                "The mount is now centered while mounted instead of being offset.",
                                "Turning animations have been significantly tweaked.",
                                "Added dirt particles wherever a footstep occurs.",
                                "Updated the cursor image, which is also dynamic (such as changing to a sword while hovering over an enemy Titan)."
                            ]
                        }
                    ]
                },
                {
                    label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                        children: "Lobby Activities"
                    }),
                    children: [
                        "You can now duel other Titans right in the lobby.",
                        "There's a new jump quest which is far more challenging.",
                        "There's a daily Prize Wheel you can spin to win Obols.",
                        "The Town in the lobby has been completed, with houses that can be entered and explored.",
                        "You can now sit on the chairs in the lobby and hang out with your friends.",
                        "Local chat (another new feature) shows speech bubbles above your head.",
                        "There are now signposts in the lobby to help navigate to various locations/activities."
                    ]
                },
                {
                    label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                        children: "Shop Updates"
                    }),
                    children: [
                        "Added a Daily Shop section, which rotates daily with new items available.",
                        "The set of items in the Daily Shop is random and is generated each day.",
                        {
                            label: "There are two new types of cosmetics: Weapons & Emotes",
                            children: [
                                "Multiple weapons can be equipped at a time (e.g. a one-hander and a shield).",
                                "Up to 8 emotes can be equipped at once.",
                                "There's a new emote action (default keybind: H) which opens an emote wheel UI, allowing you to choose one of your equipped emotes to use."
                            ]
                        },
                        "You can now preview items from the shop before purchasing them.",
                        "The shop now shows items that you already own, greyed out with a tag.",
                        {
                            label: "You can now purchase additional Obols in game, which also helps support the game's future development.",
                            children: [
                                "Optionally, enter your favorite creator's Creator Code to help support them too and receive 5% more Obols per purchase."
                            ]
                        }
                    ],
                    after: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d547e444859ed572$export$6663d34114c75100), {
                        media: (0, (/*@__PURE__*/$parcel$interopDefault($f12c3253b58948ea$exports))),
                        subtitle: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                "The new rotating ",
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                    children: "Daily Shop"
                                }),
                                " tab."
                            ]
                        })
                    })
                },
                {
                    label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                        children: "New Rank System"
                    }),
                    children: [
                        "The MMR-based rating system has been replaced with a Rank system.",
                        "You need to play 6 placement matches before you get a rank.",
                        "Your rank is still separate for each bracket (e.g. 2v2, 3v3) and Titan.",
                        "There are 7 ranks: Bronze, Silver, Gold, Platinum, Diamond, Titan, and Grand Titan.",
                        "Within each rank (except Grand Titan), there are 3 tiers (e.g. Bronze I, Bronze II, Bronze III), where III is the highest.",
                        "Within each rank and tier, there are 3 divisions (e.g. Bronze I Div I), where Division III is the highest."
                    ],
                    after: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b0bc79b9cf9652e7$export$96d9fc423ab60b4d), {
                                children: "While it varies slightly depending on your rank and your opponent, the aim is for 2-3 wins in a row to get you up to the next division."
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d547e444859ed572$export$6663d34114c75100), {
                                media: (0, (/*@__PURE__*/$parcel$interopDefault($1126e6e04bdbfbc4$exports))),
                                subtitle: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                    children: [
                                        "Showcasing the ",
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                            children: "Rank Up"
                                        }),
                                        " animation after reaching ",
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                            children: "Grand Titan"
                                        }),
                                        "."
                                    ]
                                })
                            })
                        ]
                    })
                },
                {
                    label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                        children: "New Onboarding / Tutorial"
                    }),
                    children: [
                        "The new tutorial has 3 options: beginner, intermediate, or skip. The tutorial now provides rewards as you progress through it, including Obols and Account XP.",
                        "If you choose to skip the tutorial, you can still start it later via the settings menu. However, if you start in intermediate mode, you won't be able to go back to beginner mode later and will lose out on the extra rewards.",
                        {
                            label: "The bot experience has also been improved for new players:",
                            children: [
                                "Lower ranked bots now use most spells other than crowd control and major defensive spells.",
                                "You always start at Bronze I vs bots, and gain roughly one division each win.",
                                "Bots now get a debuff at lower ranks that reduces their damage/healing output and increases the amount of damage they take.",
                                "At higher ranks, bots get a buff that increases their damage/healing and reduces the amount of damage they take.",
                                "The higher the rank, the stronger they will get, with no limit.",
                                "This allows you to use bots as a great way to practice no matter your skill level, as you'll eventually reach a point where they become challenging.",
                                "There's also a quest chain giving rewards for winning against bots all the way up to Grand Titan rank.",
                                "In addition, the bot logic has been improved, and more bots have been implemented to add more variety to matches."
                            ]
                        },
                        "All tooltips have had their readability and English improved including better spacing and bolding key words to be easier to understand.",
                        "The camera is now always behind your Titan by default (can be disabled in settings). This makes it easier for new players to track where they are facing",
                        "You can now turn your Titan via keybind actions (default A and D), which may be more intuitive for new players compared to right click dragging to adjust your facing direction."
                    ]
                },
                {
                    label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                        children: "Quests & Daily Quests"
                    }),
                    children: [
                        "Added a new quest system, used for both the tutorial and daily quests.",
                        "You get one daily quest every day, and can hold a maximum of 3.",
                        "For example, if you complete all of your daily quests and log in a week later, you'll have 3 more to do.",
                        "If you complete only one daily quest and log in the next day, a new one will take its place.",
                        "Every daily quest rewards 25 Obols and 2000 Account XP.",
                        "You can also reroll a daily quest once per day if you get one you don't like.",
                        "In addition, you'll get a quest every time your daily wheel spin is available, to remind you and give a small additional reward."
                    ]
                },
                {
                    label: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                        children: "Matchmaking Heuristics"
                    }),
                    children: [
                        'Previously, matchmaking would always try to find the "best" matches every 10 seconds',
                        {
                            label: "Now we use a heuristic to determine if a matchup is acceptable, taking into account factors such as:",
                            children: [
                                "Time waiting in queue",
                                "MMR difference between teams",
                                "Number of players online / in queue"
                            ]
                        },
                        "It's still expected to find matches quickly (<30 sec), especially when fewer players are online.",
                        , 
                    ],
                    after: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b0bc79b9cf9652e7$export$96d9fc423ab60b4d), {
                        children: "The overall goal here is to ensure higher quality matchups, but a tradeoff is made to ensure matches occur quickly when less players are available."
                    })
                }
            ]
        },
        {
            label: "FIXES & IMPROVEMENTS",
            children: [
                {
                    label: "Bug Fixes",
                    children: [
                        "Fixed an issue where you could not hit the bots in the lobby with area of effect spells.",
                        "Fixed an issue causing player names to overflow to multiple lines on nameplates.",
                        "Fixed an issue causing HP text to overflow to multiple lines on nameplates.",
                        "Fixed an issue where VFX spawned in would appear for one frame at 0,0,0 before moving to the correct location.",
                        "Fixed an issue preventing persistent VFX spawned from spells (such as dark portal) not being destroyed when leaving matches or zones.",
                        "Fixed an issue where the cast bar UI would block the mouse.",
                        "Fixed an issue allowing you to chain certain active spells (like Empowered Shields) when recasting it near the end of the duration.",
                        "Fixed an issue causing you to lose your Combo Points when using a spell that the server rejected.",
                        "Fixed an issue causing Titans to sometimes slightly be mispositioned immediately after using a movement effect like Swift Justice.",
                        "Fixed an issue causing tooltips to sometimes appear offscreen. They now attempt to position themselves to an area that will be on screen.",
                        "Fixed an issue preventing casting spells on other players in the lobby.",
                        "Fixed an issue preventing buff VFX (e.g. shield VFX) from showing on existing Titans when entering a new zone.",
                        "Fixed a visual issue where the queue status indicator would sometimes show the wrong brackets as being queued for.",
                        "Fixed an issue where tooltips could be stuck being visible permanently when changing zones.",
                        "Fixed an issue where going to the main menu while spectating a match using freecam caused the camera to break permenantly.",
                        "Fixed an issue where your Obol count shown on the main menu wouldn't update immediately after each match.",
                        "Fixed an issue where your Obol amount shown on the main menu wouldn't update after making a purchase in the shop.",
                        "Fixed an issue where dragging an icon off an action bar slot and then back onto it broke the cooldown spinner and other tint indicators.",
                        "Fixed an issue where the Free Fly camera in spectate or replay mode would not reset properly.",
                        "Fixed an issue which would occasionally cause chat messages to be cut off.",
                        "Fixed an issue where the experience bar on the main menu would sometimes not update after a match completed.",
                        "Fixed an issue preventing players in a party from queuing for 3v3 vs bots.",
                        'Fixed several issues causing players to get stuck on "Authenticating" or "Waiting for all players".',
                        "Fixed an issue where you could get stuck in queue and be unable to leave it.",
                        "Fixed a bug causing teams to leave queue unexpectedly, and cause their queue status to be out of sync.",
                        "Fixed an issue where you could open the spellbook on the main menu.",
                        "Fixed an issue where if you found a match to join right as you entered the lobby, you wouldn't be able to join the match."
                    ]
                },
                {
                    label: "Improvements",
                    children: [
                        "The client now connects to up to two servers: a master server and a world server. The master server handles things like the queue and chat, and the world server handles the rest.",
                        "The client can reconnect to a server if it gets unexpectedly disconnected, including the ability to rejoin an in-progress match.",
                        "The client can now cancel a connection attempt if it is taking too long to connect to a server or too long to start a match.",
                        'The "selection circle" that shows below Titans that are targeted or focused now always follows the ground.',
                        "Adjusted the ordering of UI elements to make more sense, such as putting nameplates below UI windows.",
                        "Updated the spell book UI to be organized into sections and include the passive for each Titan.",
                        "The default zoom value has been decreased so your camera is closer to your Titan.",
                        "The max zoom value has been decreased so you can't zoom out quite as far.",
                        "Improved netcode implementation, including better client-side prediction, rollback and latency handling.",
                        "Improved the method used to create rounded corners on the UI to be higher quality.",
                        "Added dust, wind and other various particle effects around the camera/Titan.",
                        "The primary cursor is now hidden when in AoE cursor mode (when choosing where to cast a spell).",
                        "All spells for a Titan are now shown on the Titan Confirmation screen when changing Titans (used to be a max of 12 spells shown).",
                        'Cast bars now say "Success" or "Interrupted" when a cast completes, so it is clear what the result of the cast was.',
                        "Your camera and Titan now face reasonable directions whenever entering a new zone (lobby, arena, etc).",
                        "The Titan nameplate UI height is now dynamic depending on the height of the Titan model.",
                        "You now have separate spells to cancel active buffs (for example, Glacial Encapsulation and Cancel Glacial Encapsulation).",
                        "In settings, you can choose to disable auto swapping spells, so that pressing the same button won't cancel the effect and you can set a separate button to cancel.",
                        "Titan Nameplate draw distance is now much larger while in a match, and smaller in the lobby.",
                        "Added a ton of system messages to confirm when actions have been taken (e.g. requesting custom games, inviting to party, etc) or errors occur.",
                        "The UI for nameplates and Titan frames has been redone to be more consistent, better aligned and more compact.",
                        "Healers can no longer queue for duels and bot duels will never place you against a healer Titan. However, healers can still challenge players to custom match 1v1s, or duel in the lobby.",
                        "The game version now shows on the main menu.",
                        "Titan Frames and Nameplates now change their icon for major positive cooldowns, such as defensives like Empowered Shields.",
                        "Titan Frames and Nameplates now show text (e.g. 5.4) to indicate the remaining duration of major effects (such as crowd control or defensive CDs) when active.",
                        "There's now more shuffling variance in matchmaking, helping to prevent continually getting the same matchups over and over.",
                        'Added new "cinematics" when entering and concluding a match, showcasing the players involved.',
                        "There's now a confirm dialog that shows up when you attempt to go to the main menu while in a match.",
                        "Added a button to copy keybindings from another Titan (in keybinding settings at the top).",
                        "All keybindings are now separate for each Titan. Previously only the action slot keybindings were separate, but now you can also separate out other keybinds like targeting ones.",
                        "Channeled spells now start at 100% and count down to 0% on the cast bar (previously it went from 0% -> 100% like regular casts).",
                        "The mature language filter has been improved.",
                        "Increased the font size on tooltips.",
                        "Absorption and shielding provided now counts as healing on the end of match screen.",
                        {
                            label: "All UI locations where text is shown to indicate a countdown is now shared.",
                            children: [
                                "This means that all cooldown/duration text has decimals when less than 10 seconds remain.",
                                "In addition, all cooldown/duration text updates the color as it gets closer to zero."
                            ]
                        },
                        "Added a new animation that plays when you suddenly stop moving.",
                        "Some spells now snapshot facing direction at the end of the animation, and some at the beginning (e.g. Icy Shards snapshots at the start, and Dash at the end).",
                        "The amount of movement made by the cloth physics on cloaks has been reduced to prevent cloaks from clipping through Titan models as much as it did.",
                        "Made it so that you should be able to successfully auth even if Steam goes down while playing. No more getting locked out during Tuesday Steam maintenance.",
                        "Added the option to view Combo Points for enemy Titans, making it easy to track if desired.",
                        "You can now set up to 2 keybinds per action and action slot.",
                        {
                            label: "Added more bot implementations:",
                            children: [
                                "Lightbringer Anthriel",
                                "Hunter Orin",
                                "Eradicator Malrah",
                                "Soulstealer Kanna",
                                "Smiter Anthriel"
                            ]
                        },
                        'Updated replays, spectate list, and current status on Steam include the Titan "Spec" (e.g. Eradicator) in addition to their name.',
                        "Made it so that hide UI cannot hide the escape menu and the settings page, so that if you accidentally bind left mouse to hide UI, you can still fix it.",
                        "Equipped Titles are now bolded instead of being a different color, making it easier to see them on certain nameplates.",
                        "Changing your selected customization (e.g. hat, cloak) now happens much faster.",
                        "Removed the self-cast and focus-cast modifiers. These were confusing and not implemented well - the workaround is to keybind your focus and self casts separately.",
                        "Added a keybind to target the first enemy. This differs from the existing keybind to target next enemy because it does not cycle through the list.",
                        "Improved the logic for targeting the first/nearest enemy.",
                        "Renamed arena1/2/3 to enemy1/2/3 and party1/2/3 to team1/2/3 as it is easier to understand, and not everything is an arena anymore since we have CTF now.",
                        'Added a "highlight" effect on action slots where the spell has a special condition met, such as Power Strike dealing more damage after Devastating Strike has been cast. This can be disabled in General Settings.',
                        "Added a setting to fade out your own nameplate when you have a target, making it easier to see your target's nameplate.",
                        "Spells you don't currently have (like spells from Talents, if you haven't selected that talent) are now grayed out.",
                        "Cooldowns above 60 seconds now correctly show on the cooldown tracker UI.",
                        "Added a total online player count in the top right of the UI.",
                        "Floating damage and healing text now no longer shows up if you are too far from it.",
                        "Minor reorganization of the main menu UI, putting the chat in the bottom right by default.",
                        "Cosmetic choices (hats, cloaks, etc) now sync with your party on the main menu when you change them.",
                        "Titles are now shown on the main menu.",
                        "Cosmetic choices are now saved per-Titan, so you can now, for example, choose a different hat for every Titan.",
                        "Several directional spells now aim towards your Titan's movement direction, so if you hold down a movement key midair it will adjust the direction of the spell.",
                        "You can now left-click (in addition to right-clicking) on a talent you already have to unlearn it.",
                        "Added some tooltips on the main menu nav items and queue menu items.",
                        'Added a setting for "Hold to Cast", which allows you to hold a keybind to continuously cast that skill whenever it can be cast.',
                        "All matches now give 30 seconds for preparation (up from 20), including the intro cinematic.",
                        'When you damage targets that are immune to damage or buffs, it now says "IMMUNE" instead of there being no floating text at all.',
                        "You can now sit in most of the chairs/benches/stools/etc in the Lobby.",
                        "Bots now switch target if their current target becomes immune.",
                        "Renamed M0 -> M1, M1 -> M2, etc. Left click should be M1 now, instead of M0.",
                        'Added "Tips" that are sent in chat every 2 minutes, helping to explain some concepts. If you have ideas for new tips, please let me know!',
                        "Added a credits tab in settings.",
                        "Removed a bunch of UI scale/position settings since the fullscreen UI edit mode replaces those options.",
                        "Added a convenient button after a match ends to immediately requeue for the same modes you had previously selected.",
                        "Removed the setting to toggle cooldowns on Nameplates, which did nothing anyway since Nameplates cannot show cooldowns.",
                        "Added several windows to the list of windows that automatically close when you press escape.",
                        'Graphics settings has been simplified to just "low", "medium" and "high" options.',
                        "Obol, Titan Point, and EXP UI has been improved to take up less space and be easier to read.",
                        "New spells received (e.g. during the Tutorial, or when learning new Talents) are automatically placed on the action bars now.",
                        "Diminishing Return Timers and the Cooldown Tracker on Titan Frames are now disabled by default.",
                        "Added quick access buttons (buttons at the top of the screen) for the escape menu and settings.",
                        "The max amount of Obols you can get for playing matches each day has been updated to 25 (you can get another 25 from a daily quest, plus up to 500 more from the daily wheel spin).",
                        'The "Interrupt Bar" UI has been renamed to "Enemy CD Tracker", as you can now choose which enemy cooldowns to track in UI Settings.',
                        "Titan Frames for far away Titans are now tinted darker. You can choose how far away to tint (or disable it) in UI Settings.",
                        "Two of the same buff can now apply to a single Titan, if the source was from different Titans. For example, Titan A and Titan B can both cast Cultivate on Titan C."
                    ]
                }
            ]
        }
    ]
};
var $51bfda0fc616004a$export$2e2bcd8739ae039 = $51bfda0fc616004a$var$Notes;



const $a5a6ede7c654530c$var$Notes = (0, $097a36482b746d2a$export$2e2bcd8739ae039)("Season 2: Soulbound Patch Notes", "Releases on May 3rd, 2025", `
- General
  - Soulbound Boss Fights
    - Soulbound Boss Fights have been introduced into the game, offering a cooperative way to play.
    - In Soulbound Boss Fights, you'll face a random boss as a team of 3 players and be given 3 attempts and 15 minutes to defeat the boss.
    - If you succeed, you'll be rewarded with some equippable items that make you stronger, and if you continue to succeed you'll rank up.
    - Losing has no penalty unless you're in Grand Titan, where boss difficulty grows indefinitely with your internal rating.
    - The higher your rank, the harder the bosses will be, and the better the rewards will be.
    - At silver and above, bosses will also receive additional powerup buffs adding more mechanics to deal with during the fights.
    - You can choose to filter which rank you'd like to face when you queue to enter a boss fight.
    - You can sell unwanted equipment for Titan Points and purchase better gear from the Shop.
    - The shop will have random equipment available that you can purchase with Titan Points.
      - The Equipment Shop resets every 3 hours, and is different for each player + Titan.
    - Equipment and boss fight rank is unique for each Titan you play.
    - You can trade equipment and Titan Points with other players in game for a small fee in Titan Points.
    - You're now able to inspect players in the world to see what equipment they have.
    - Chain Breaker cannot be used during Soulbound Boss Fights.
  - Season 2
    - In Season 2, all Runes will be unlocked for everyone by default.
    - All Titan Points will be wiped - if you have extra unused Titan Points, please convert them to Obols before the season starts. You can do so in the Shop in the Misc tab.
      - Titan Points will now be used as the item currency for Soulbound Boss Fights.
    - Items equipped from Soulbound Boss Fights will have no impact in PvP arena matches.
    - The new Season 2 titles are now available in the shop and can be acquired when you hit the required rank for each title.
    - All healing done in duels is now reduced by 75% (was: 50%).
    - There are 3 new general talents
      - Cower: Reduce your threat by 30%.
      - Menace: Increase your threat by 30%.
      - Solace: Increase all outgoing healing by 5%.
    - There are new cosmetics in the shop, including:
      - A Dragon Mount based on one of the Soulbound Bosses (Smolderak).
      - Classic Skins for each Titan (the same models from the early access version).
      - New epic weapons.
  - Improvements
    - Improved the main menu UI with easier navigation.
      - Other various UI improvements as well such as darker backgrounds to make things easier to read.
      - UI tabs are now highlighted when active.
      - Opening large windows now automatically closes other large windows that were open to prevent UI clutter.
      - Removed some unnecessary UI animations when certain UI elements appeared on screen.
    - Updated the lobby layout.
      - Players now spawn directly in the town.
      - The training area has been moved to just outside the town border.
      - Practice targets now have their own unique models instead of reusing Titan models.
      - Fixed some floating models/flowers and removed some invisible colliders.
    - Reduced the fog and saturation to increase visual clarity.
    - Added colored outlines around Titan models to make it easier to see your target, focus and mouseover.
    - Added colored outlines around the Titan Frame and Titan Nameplate of your target and focus.
    - The circles underneath your self, focus, and mouseover now match the highlight colors, and there is also now a circle for your mouseover target.
    - Added new DPS, Healing, and Threat meter UIs to help theorycraft and compare with other players.
    - When entering a lobby in a party, you'll now always enter the same lobby as your party members if multiple lobbies exist.
    - Overhealing no longer counts as healing done.
    - The Combat Log now shows when buffs are added and removed.
    - When typing /dance into chat, you'll get an explaination of how to emote.
    - When typing /m or /macro into chat, you'll get an explanation how to set spells to cast on specific targets.
    - If at Grand Titan, you'll now see your current MMR on the queue screen.
  - Fixes
    - Fixed an issue which would rarely cause buffs/debuffs to sometimes last longer than intended.
    - Fixed overflowing health numbers on Titan Frames and Titan Nameplates in certain cases.
    - DR timers and floating text is now synced on the server instead of being client side predicted.
      - This fixes the issue where your client thought you landed a spell but the server didn't, causing incorrect DR timers to show up and incorrect floating text.
    - Improved latency and reliability of server DB writes.
    - Fixed an issue where successful casts would sometimes appear incomplete on the UI for a small period of time.
    - Fixed an issue causing mount walk/run animations to last longer than they should after stopping moving.
    - Sound effects are now muted during intro cinematics.
    - Fixed the look direction of your character's head being slightly too high while mounted.
    - Fixed an issue where you could accept two outstanding party invites at once.
    - Prevented any invites from showing while you are in a match (such as party or trade invites).
    - Fixed an issue causing error logs to spam when using multiple actions on a single keybind.
    - Fixed an issue causing Titan Models to flicker on the main menu while entering a new world server.
    - Fixed an issue preventing chatting during replays or while spectating.
    - Fixed a minor one-frame UI flicker on Titan Nameplates when new Titans appear in the world.
    - Fixed an issue causing permanent auth failures during the Tuesday Steam maintenance window even after the maintenance ended.
    - Fixed an issue causing internal Titan classes to show on the copy keybinds dropdown.
    - Fixed an issue preventing seeking from working correctly in Replays.
    - Fixed an issue preventing clients from being unable to reconnect to an active match.
  - Balance
    - Hunter Orin
      - The Hunter Orin passive has been changed to "Every time you take physical damage, reduce the cooldown on Dissociative Force by 5% of the remaining duration.".
`);
var $a5a6ede7c654530c$export$2e2bcd8739ae039 = $a5a6ede7c654530c$var$Notes;



const $82bfa5d3a2ad1c2a$export$959d3245e7b2b502 = [
    {
        key: "1.1",
        val: (0, $a5a6ede7c654530c$export$2e2bcd8739ae039)
    },
    {
        key: "100rc17a",
        val: (0, $c25e12ff1d53e4a6$export$2e2bcd8739ae039)
    },
    {
        key: "100rc17",
        val: (0, $3c5eca3b738805b1$export$2e2bcd8739ae039)
    },
    {
        key: "100rc16",
        val: (0, $13b43309586d560c$export$2e2bcd8739ae039)
    },
    {
        key: "100rc15",
        val: (0, $aab0fbc91d2d0f8b$export$2e2bcd8739ae039)
    },
    {
        key: "100rc14",
        val: (0, $09610735bb769f94$export$2e2bcd8739ae039)
    },
    {
        key: "100rc13",
        val: (0, $6f3fe2121e3199ff$export$2e2bcd8739ae039)
    },
    {
        key: "100rc12",
        val: (0, $e2036aea0a5c990a$export$2e2bcd8739ae039)
    },
    {
        key: "100rc11",
        val: (0, $e538aa4e3bbd3d32$export$2e2bcd8739ae039)
    },
    {
        key: "100rc10",
        val: (0, $7ed097507043a648$export$2e2bcd8739ae039)
    },
    {
        key: "100rc9",
        val: (0, $3b51bf76c4e654d4$export$2e2bcd8739ae039)
    },
    {
        key: "100rc8",
        val: (0, $236d46d1878de3f7$export$2e2bcd8739ae039)
    },
    {
        key: "100rc7",
        val: (0, $840435af9e77c74e$export$2e2bcd8739ae039)
    },
    {
        key: 1,
        val: (0, $51bfda0fc616004a$export$2e2bcd8739ae039)
    }
];
function $82bfa5d3a2ad1c2a$var$PatchNotesSection({ notes: notes, depth: depth }) {
    var _notes_children, _notes_children1, _notes_children2, _notes_children3;
    depth = depth !== null && depth !== void 0 ? depth : 0;
    var _notes_label;
    const content = (_notes_label = notes.label) !== null && _notes_label !== void 0 ? _notes_label : notes;
    if (depth === 0) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                style: {
                    fontSize: 34,
                    textTransform: "uppercase",
                    margin: 0
                },
                children: content
            }),
            notes.date,
            notes.subtitle,
            (_notes_children = notes.children) === null || _notes_children === void 0 ? void 0 : _notes_children.map((child)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($82bfa5d3a2ad1c2a$var$PatchNotesSection, {
                    notes: child,
                    depth: depth + 1
                })),
            notes.after
        ]
    });
    if (depth === 1) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                style: {
                    fontSize: 24,
                    textTransform: "uppercase"
                },
                children: content
            }),
            notes.subtitle,
            (_notes_children1 = notes.children) === null || _notes_children1 === void 0 ? void 0 : _notes_children1.map((child)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($82bfa5d3a2ad1c2a$var$PatchNotesSection, {
                    notes: child,
                    depth: depth + 1
                })),
            notes.after
        ]
    });
    if (depth === 2) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h4", {
                style: {
                    textTransform: "uppercase"
                },
                children: content
            }),
            notes.subtitle,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
                children: (_notes_children2 = notes.children) === null || _notes_children2 === void 0 ? void 0 : _notes_children2.map((child)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($82bfa5d3a2ad1c2a$var$PatchNotesSection, {
                        notes: child,
                        depth: depth + 1
                    }))
            }),
            notes.after
        ]
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                children: content
            }),
            notes.subtitle,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
                children: (_notes_children3 = notes.children) === null || _notes_children3 === void 0 ? void 0 : _notes_children3.map((child)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($82bfa5d3a2ad1c2a$var$PatchNotesSection, {
                        notes: child,
                        depth: depth + 1
                    }))
            }),
            notes.after
        ]
    });
}
function $82bfa5d3a2ad1c2a$export$2e2bcd8739ae039(props) {
    console.log(props);
    if (props.notes) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $032aab6647148487$export$6d1402fb58384e4f), {
        label: "Patch Notes",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            style: {
                fontFamily: '"Montserrat", sans-serif'
            },
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($82bfa5d3a2ad1c2a$var$PatchNotesSection, {
                notes: props.notes
            })
        })
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $032aab6647148487$export$6d1402fb58384e4f), {
        label: "Patch Notes",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: "PATCH NOTES"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                style: {
                    fontFamily: '"Montserrat", sans-serif'
                },
                children: "Here you can find all of the recent patch notes for Ring of Titans."
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                style: {
                    display: "flex",
                    flexDirection: "column",
                    gap: 20
                },
                children: $82bfa5d3a2ad1c2a$export$959d3245e7b2b502.map((x)=>{
                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        style: {
                            textTransform: "uppercase",
                            fontSize: 24
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1a29469ea96a6022$export$a6c7ac8248d6e38a), {
                                to: "/patchnotes/" + x.key,
                                children: x.val.label
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                style: {
                                    fontSize: 14
                                },
                                children: x.val.date
                            })
                        ]
                    });
                })
            })
        ]
    });
}




var $08e390bc033a1b28$exports = {};
var $6b660904ff72bc40$exports = {};
var $8e0beec087703ed0$exports = {};
$8e0beec087703ed0$exports = new URL("Mageskill_48.775ab908.png", import.meta.url).toString();


$6b660904ff72bc40$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "17c14f584f7d29740952e55a51d6a1fe",
            "type": 3
        },
        "m_Name": "AddDragonBossFireOrb",
        "m_EditorClassIdentifier": null,
        "unitModel": {
            "fileID": 1737313431337791700,
            "guid": "523a1bb40963957419f0bf724105e1cd",
            "type": 3
        },
        "heroClass": 29,
        "isHealer": 0,
        "isInternal": 1,
        "isBoss": 0,
        "level": 0,
        "attackSpeed": 1,
        "baseHP": 320,
        "baseGCDMultiplier": 0,
        "unitName": "Fire Orb",
        "unitSpec": null,
        "icon": "a23e082d7a100634383ef0082e371229",
        "backgroundColor": {
            "r": 0.8588235,
            "g": 0.8588235,
            "b": 0.854902,
            "a": 1
        },
        "textColor": {
            "r": 0.4,
            "g": 0.4,
            "b": 0.4,
            "a": 1
        },
        "typeIcon": {
            "fileID": 21300000,
            "guid": "423717ccb76a74e489e5d288c5af5780",
            "type": 3
        },
        "type": "HEALER",
        "description": null,
        "hitboxScale": {
            "x": 1,
            "true": 1,
            "z": 1
        },
        "selectionCircleScale": {
            "x": 2,
            "true": 2,
            "z": 2
        },
        "mouseHitboxScale": {
            "x": 3,
            "true": 1,
            "z": 3
        },
        "hitAnimationType": 17,
        "dieAnimationType": 18,
        "animationSpeedMultiplier": 1,
        "supportsStopWalkAnimation": 0,
        "isLeftHandClosed": 0,
        "isRightHandClosed": 0,
        "dualWields": 0,
        "runAnimation": {
            "fileID": 0
        },
        "sprintAnimation": {
            "fileID": 0
        },
        "idleAnimation": {
            "fileID": 0
        },
        "stopWalkAnimation": {
            "fileID": 0
        },
        "footstepSounds": [
            {
                "fileID": 8300000,
                "guid": "f6a0604181d205c48a1487b0a420b0e0",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "129dbdeb1611723489ad2445e4d62806",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "761b3b0bb7a210f45ab22851c8823fd5",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0207beb000d2a984aba8d8c18033978d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3331792b169924448bd774007767d02b",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a01ca2c05517c2440923677ccbcf13c4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a1932d9612ddc6c4b89c2f012dd59eb2",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "e307c1e688ce6fa4090baf3702ff14e3",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0b508f958dc2fc14dae01bc74f6c3896",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c75f01921060aea468faa65f382dfdf4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c7dfd018c818f2e479b45a715e1a2a6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "330aba8c48b34b64baa9d90ca470ea6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c891b25e37059b44eb224f93803a764a",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "f438ee57a0c246b41ba90434f9e37112",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3a735f9d10cd39f4292bec35fb227445",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "232d552e7c3364c41afe7c570ce7b088",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "586061caa5f6f294886fc39578ccd458",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "ed9abe2423737ba42940d0efff5508c9",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0107856a8ad9a31498651137a892e49d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "5ec4507ee2b342e48a3de0355249e568",
                "type": 3
            }
        ],
        "passiveIcon": {
            "fileID": 21300000,
            "guid": "d3857588363cc674ea1157723c39247f",
            "type": 3
        },
        "passiveName": null,
        "passiveDescription": null
    }
};
$6b660904ff72bc40$exports.getImport = (guid)=>{
    switch(guid){
        case "a23e082d7a100634383ef0082e371229":
            return 0, (/*@__PURE__*/$parcel$interopDefault($8e0beec087703ed0$exports));
    }
};


var $08b23a00df2e1a52$exports = {};
var $0557eb189010fd0a$exports = {};
$0557eb189010fd0a$exports = new URL("bear_paw.bdc61759.png", import.meta.url).toString();


$08b23a00df2e1a52$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "17c14f584f7d29740952e55a51d6a1fe",
            "type": 3
        },
        "m_Name": "BossBear",
        "m_EditorClassIdentifier": null,
        "unitModel": {
            "fileID": 3241138547371686400,
            "guid": "cced8a6bc51f31f43bca07dfe748e4e7",
            "type": 3
        },
        "heroClass": 24,
        "isHealer": 0,
        "isInternal": 1,
        "isBoss": 1,
        "level": 0,
        "attackSpeed": 1,
        "baseHP": 6000,
        "baseGCDMultiplier": 100,
        "unitName": "Yorgun the Frostforged",
        "unitSpec": "Polar",
        "icon": "20bebf031d70e6e4eaa69513f49b7bf3",
        "backgroundColor": {
            "r": 0.8588235,
            "g": 0.8588235,
            "b": 0.854902,
            "a": 1
        },
        "textColor": {
            "r": 0.4,
            "g": 0.4,
            "b": 0.4,
            "a": 1
        },
        "typeIcon": {
            "fileID": 21300000,
            "guid": "423717ccb76a74e489e5d288c5af5780",
            "type": 3
        },
        "type": "HEALER",
        "description": null,
        "hitboxScale": {
            "x": 4,
            "true": 4,
            "z": 4
        },
        "selectionCircleScale": {
            "x": 6,
            "true": 2,
            "z": 6
        },
        "mouseHitboxScale": {
            "x": 4,
            "true": 3,
            "z": 4
        },
        "hitAnimationType": 3,
        "dieAnimationType": 1,
        "animationSpeedMultiplier": 0.7,
        "supportsStopWalkAnimation": 1,
        "isLeftHandClosed": 0,
        "isRightHandClosed": 1,
        "dualWields": 0,
        "runAnimation": {
            "fileID": 7400000,
            "guid": "5e04ec40bbc3ac84796a85672bfea74b",
            "type": 3
        },
        "sprintAnimation": {
            "fileID": 7400000,
            "guid": "5e04ec40bbc3ac84796a85672bfea74b",
            "type": 3
        },
        "idleAnimation": {
            "fileID": 7400000,
            "guid": "738b43c856812d44485cce817b79ea06",
            "type": 3
        },
        "stopWalkAnimation": {
            "fileID": 0
        },
        "footstepSounds": [
            {
                "fileID": 8300000,
                "guid": "f6a0604181d205c48a1487b0a420b0e0",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "129dbdeb1611723489ad2445e4d62806",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "761b3b0bb7a210f45ab22851c8823fd5",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0207beb000d2a984aba8d8c18033978d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3331792b169924448bd774007767d02b",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a01ca2c05517c2440923677ccbcf13c4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a1932d9612ddc6c4b89c2f012dd59eb2",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "e307c1e688ce6fa4090baf3702ff14e3",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0b508f958dc2fc14dae01bc74f6c3896",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c75f01921060aea468faa65f382dfdf4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c7dfd018c818f2e479b45a715e1a2a6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "330aba8c48b34b64baa9d90ca470ea6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c891b25e37059b44eb224f93803a764a",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "f438ee57a0c246b41ba90434f9e37112",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3a735f9d10cd39f4292bec35fb227445",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "232d552e7c3364c41afe7c570ce7b088",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "586061caa5f6f294886fc39578ccd458",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "ed9abe2423737ba42940d0efff5508c9",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0107856a8ad9a31498651137a892e49d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "5ec4507ee2b342e48a3de0355249e568",
                "type": 3
            }
        ],
        "passiveIcon": {
            "fileID": 21300000,
            "guid": "d3857588363cc674ea1157723c39247f",
            "type": 3
        },
        "passiveName": null,
        "passiveDescription": null
    }
};
$08b23a00df2e1a52$exports.getImport = (guid)=>{
    switch(guid){
        case "20bebf031d70e6e4eaa69513f49b7bf3":
            return 0, (/*@__PURE__*/$parcel$interopDefault($0557eb189010fd0a$exports));
    }
};


var $25a6e9d2d7fe177c$exports = {};
var $6cb05a2dc02fef32$exports = {};
$6cb05a2dc02fef32$exports = new URL("Warriorskill_13.a4e52990.png", import.meta.url).toString();


$25a6e9d2d7fe177c$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "17c14f584f7d29740952e55a51d6a1fe",
            "type": 3
        },
        "m_Name": "BossDeathKnight",
        "m_EditorClassIdentifier": null,
        "unitModel": {
            "fileID": 3241138547371686400,
            "guid": "a7fd11468df75dd488ea98c19f486e7d",
            "type": 3
        },
        "heroClass": 25,
        "isHealer": 0,
        "isInternal": 1,
        "isBoss": 1,
        "level": 0,
        "attackSpeed": 1,
        "baseHP": 6250,
        "baseGCDMultiplier": 100,
        "unitName": "Malrik the Dreadborne",
        "unitSpec": "Fire",
        "icon": "8e0bc87a0991fb646ad0f0834130139d",
        "backgroundColor": {
            "r": 0.8588235,
            "g": 0.8588235,
            "b": 0.854902,
            "a": 1
        },
        "textColor": {
            "r": 0.4,
            "g": 0.4,
            "b": 0.4,
            "a": 1
        },
        "typeIcon": {
            "fileID": 21300000,
            "guid": "423717ccb76a74e489e5d288c5af5780",
            "type": 3
        },
        "type": "HEALER",
        "description": null,
        "hitboxScale": {
            "x": 4,
            "true": 4,
            "z": 4
        },
        "selectionCircleScale": {
            "x": 6,
            "true": 2,
            "z": 6
        },
        "mouseHitboxScale": {
            "x": 4,
            "true": 3,
            "z": 4
        },
        "hitAnimationType": 3,
        "dieAnimationType": 1,
        "animationSpeedMultiplier": 1,
        "supportsStopWalkAnimation": 1,
        "isLeftHandClosed": 0,
        "isRightHandClosed": 1,
        "dualWields": 0,
        "runAnimation": {
            "fileID": 7400000,
            "guid": "79c9141b1a4f23044a6800bb9812a8ce",
            "type": 3
        },
        "sprintAnimation": {
            "fileID": 7400000,
            "guid": "79c9141b1a4f23044a6800bb9812a8ce",
            "type": 3
        },
        "idleAnimation": {
            "fileID": 7400000,
            "guid": "45eefc6046bf9b843ad2ab23fd7adbb6",
            "type": 3
        },
        "stopWalkAnimation": {
            "fileID": 0
        },
        "footstepSounds": [
            {
                "fileID": 8300000,
                "guid": "f6a0604181d205c48a1487b0a420b0e0",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "129dbdeb1611723489ad2445e4d62806",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "761b3b0bb7a210f45ab22851c8823fd5",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0207beb000d2a984aba8d8c18033978d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3331792b169924448bd774007767d02b",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a01ca2c05517c2440923677ccbcf13c4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a1932d9612ddc6c4b89c2f012dd59eb2",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "e307c1e688ce6fa4090baf3702ff14e3",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0b508f958dc2fc14dae01bc74f6c3896",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c75f01921060aea468faa65f382dfdf4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c7dfd018c818f2e479b45a715e1a2a6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "330aba8c48b34b64baa9d90ca470ea6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c891b25e37059b44eb224f93803a764a",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "f438ee57a0c246b41ba90434f9e37112",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3a735f9d10cd39f4292bec35fb227445",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "232d552e7c3364c41afe7c570ce7b088",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "586061caa5f6f294886fc39578ccd458",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "ed9abe2423737ba42940d0efff5508c9",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0107856a8ad9a31498651137a892e49d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "5ec4507ee2b342e48a3de0355249e568",
                "type": 3
            }
        ],
        "passiveIcon": {
            "fileID": 21300000,
            "guid": "d3857588363cc674ea1157723c39247f",
            "type": 3
        },
        "passiveName": null,
        "passiveDescription": null
    }
};
$25a6e9d2d7fe177c$exports.getImport = (guid)=>{
    switch(guid){
        case "8e0bc87a0991fb646ad0f0834130139d":
            return 0, (/*@__PURE__*/$parcel$interopDefault($6cb05a2dc02fef32$exports));
    }
};


var $508a5f1810527103$exports = {};

$508a5f1810527103$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "17c14f584f7d29740952e55a51d6a1fe",
            "type": 3
        },
        "m_Name": "BossDragon",
        "m_EditorClassIdentifier": null,
        "unitModel": {
            "fileID": 3241138547371686400,
            "guid": "18bd2c6cbea9e624a8241325c3007f92",
            "type": 3
        },
        "heroClass": 28,
        "isHealer": 0,
        "isInternal": 1,
        "isBoss": 1,
        "level": 0,
        "attackSpeed": 1,
        "baseHP": 3500,
        "baseGCDMultiplier": 100,
        "unitName": "Smolderak",
        "unitSpec": null,
        "icon": "a23e082d7a100634383ef0082e371229",
        "backgroundColor": {
            "r": 0.8588235,
            "g": 0.8588235,
            "b": 0.854902,
            "a": 1
        },
        "textColor": {
            "r": 0.4,
            "g": 0.4,
            "b": 0.4,
            "a": 1
        },
        "typeIcon": {
            "fileID": 21300000,
            "guid": "423717ccb76a74e489e5d288c5af5780",
            "type": 3
        },
        "type": "HEALER",
        "description": null,
        "hitboxScale": {
            "x": 15,
            "true": 4,
            "z": 15
        },
        "selectionCircleScale": {
            "x": 15,
            "true": 3.1,
            "z": 15
        },
        "mouseHitboxScale": {
            "x": 15,
            "true": 4,
            "z": 15
        },
        "hitAnimationType": 17,
        "dieAnimationType": 18,
        "animationSpeedMultiplier": 1,
        "supportsStopWalkAnimation": 0,
        "isLeftHandClosed": 0,
        "isRightHandClosed": 0,
        "dualWields": 0,
        "runAnimation": {
            "fileID": 7400018,
            "guid": "5c1a7f08c15994365a2d0b0afba374a3",
            "type": 3
        },
        "sprintAnimation": {
            "fileID": 7400018,
            "guid": "5c1a7f08c15994365a2d0b0afba374a3",
            "type": 3
        },
        "idleAnimation": {
            "fileID": 7400004,
            "guid": "5c1a7f08c15994365a2d0b0afba374a3",
            "type": 3
        },
        "stopWalkAnimation": {
            "fileID": 0
        },
        "footstepSounds": [
            {
                "fileID": 8300000,
                "guid": "c75d853d28819419f888ae428e053845",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "73b33344897394a55963181ab6b5d6fb",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "2b7ee34fc58104412b93347642ad061f",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "55e0a2cf5ae054f4cb8bb3235320e636",
                "type": 3
            }
        ],
        "passiveIcon": {
            "fileID": 21300000,
            "guid": "d3857588363cc674ea1157723c39247f",
            "type": 3
        },
        "passiveName": null,
        "passiveDescription": null
    }
};
$508a5f1810527103$exports.getImport = (guid)=>{
    switch(guid){
        case "a23e082d7a100634383ef0082e371229":
            return 0, (/*@__PURE__*/$parcel$interopDefault($8e0beec087703ed0$exports));
    }
};


var $38381072d6f777e4$exports = {};
var $936dcd69c7f33d06$exports = {};
$936dcd69c7f33d06$exports = new URL("Mageskill_34.44210f4a.png", import.meta.url).toString();


$38381072d6f777e4$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "17c14f584f7d29740952e55a51d6a1fe",
            "type": 3
        },
        "m_Name": "BossGolem",
        "m_EditorClassIdentifier": null,
        "unitModel": {
            "fileID": 3241138547371686400,
            "guid": "4026d9046df077946a339599f89d13a7",
            "type": 3
        },
        "heroClass": 21,
        "isHealer": 0,
        "isInternal": 1,
        "isBoss": 1,
        "level": 0,
        "attackSpeed": 1,
        "baseHP": 6500,
        "baseGCDMultiplier": 100,
        "unitName": "Cryonox",
        "unitSpec": "Ice",
        "icon": "51ab4dd7eb43254459606fb4c68bdd46",
        "backgroundColor": {
            "r": 0.8588235,
            "g": 0.8588235,
            "b": 0.854902,
            "a": 1
        },
        "textColor": {
            "r": 0.4,
            "g": 0.4,
            "b": 0.4,
            "a": 1
        },
        "typeIcon": {
            "fileID": 21300000,
            "guid": "423717ccb76a74e489e5d288c5af5780",
            "type": 3
        },
        "type": "HEALER",
        "description": null,
        "hitboxScale": {
            "x": 4,
            "true": 4,
            "z": 4
        },
        "selectionCircleScale": {
            "x": 6,
            "true": 2,
            "z": 6
        },
        "mouseHitboxScale": {
            "x": 14,
            "true": 3,
            "z": 14
        },
        "hitAnimationType": 11,
        "dieAnimationType": 10,
        "animationSpeedMultiplier": 1,
        "supportsStopWalkAnimation": 0,
        "isLeftHandClosed": 0,
        "isRightHandClosed": 0,
        "dualWields": 0,
        "runAnimation": {
            "fileID": 1827226128182048800,
            "guid": "2fb51310bb5d9174c80ddab0062351f2",
            "type": 3
        },
        "sprintAnimation": {
            "fileID": 1827226128182048800,
            "guid": "2fb51310bb5d9174c80ddab0062351f2",
            "type": 3
        },
        "idleAnimation": {
            "fileID": 1125262853868821400,
            "guid": "fc1dd3c29d42f9340964b0ec777af477",
            "type": 3
        },
        "stopWalkAnimation": {
            "fileID": 0
        },
        "footstepSounds": [
            {
                "fileID": 8300000,
                "guid": "f190e98ea68485c46a8b523530bfbe1a",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "edc457158e6277e4492955283a098fe3",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "54ff19bbbf6d1c94b9b8c02e457dca49",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3066b90b87bfdf14597f3cde5adfe2e0",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c9b361aab0858a7469beda7ddf39810d",
                "type": 3
            }
        ],
        "passiveIcon": {
            "fileID": 21300000,
            "guid": "d3857588363cc674ea1157723c39247f",
            "type": 3
        },
        "passiveName": null,
        "passiveDescription": null
    }
};
$38381072d6f777e4$exports.getImport = (guid)=>{
    switch(guid){
        case "51ab4dd7eb43254459606fb4c68bdd46":
            return 0, (/*@__PURE__*/$parcel$interopDefault($936dcd69c7f33d06$exports));
    }
};


var $9e7396c0a9a49e68$exports = {};

$9e7396c0a9a49e68$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "17c14f584f7d29740952e55a51d6a1fe",
            "type": 3
        },
        "m_Name": "BossPoisonInsect",
        "m_EditorClassIdentifier": null,
        "unitModel": {
            "fileID": 3241138547371686400,
            "guid": "819b7ff216c2c1d49a32f39e68d959f7",
            "type": 3
        },
        "heroClass": 26,
        "isHealer": 0,
        "isInternal": 1,
        "isBoss": 1,
        "level": 0,
        "attackSpeed": 1,
        "baseHP": 6125,
        "baseGCDMultiplier": 0,
        "unitName": "Virelok",
        "unitSpec": null,
        "icon": "20bebf031d70e6e4eaa69513f49b7bf3",
        "backgroundColor": {
            "r": 0.8588235,
            "g": 0.8588235,
            "b": 0.854902,
            "a": 1
        },
        "textColor": {
            "r": 0.4,
            "g": 0.4,
            "b": 0.4,
            "a": 1
        },
        "typeIcon": {
            "fileID": 21300000,
            "guid": "423717ccb76a74e489e5d288c5af5780",
            "type": 3
        },
        "type": "HEALER",
        "description": null,
        "hitboxScale": {
            "x": 3.5,
            "true": 2,
            "z": 3.5
        },
        "selectionCircleScale": {
            "x": 6,
            "true": 2,
            "z": 6
        },
        "mouseHitboxScale": {
            "x": 12,
            "true": 2,
            "z": 12
        },
        "hitAnimationType": 14,
        "dieAnimationType": 15,
        "animationSpeedMultiplier": 0.7,
        "supportsStopWalkAnimation": 0,
        "isLeftHandClosed": 0,
        "isRightHandClosed": 0,
        "dualWields": 0,
        "runAnimation": {
            "fileID": 7400000,
            "guid": "32c546551504acb43a4eaea218782597",
            "type": 3
        },
        "sprintAnimation": {
            "fileID": 7400000,
            "guid": "32c546551504acb43a4eaea218782597",
            "type": 3
        },
        "idleAnimation": {
            "fileID": 7400000,
            "guid": "21e9e1d7cf338d64cadea56af92821c2",
            "type": 3
        },
        "stopWalkAnimation": {
            "fileID": 0
        },
        "footstepSounds": [
            {
                "fileID": 8300000,
                "guid": "f6a0604181d205c48a1487b0a420b0e0",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "129dbdeb1611723489ad2445e4d62806",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "761b3b0bb7a210f45ab22851c8823fd5",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0207beb000d2a984aba8d8c18033978d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3331792b169924448bd774007767d02b",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a01ca2c05517c2440923677ccbcf13c4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a1932d9612ddc6c4b89c2f012dd59eb2",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "e307c1e688ce6fa4090baf3702ff14e3",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0b508f958dc2fc14dae01bc74f6c3896",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c75f01921060aea468faa65f382dfdf4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c7dfd018c818f2e479b45a715e1a2a6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "330aba8c48b34b64baa9d90ca470ea6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c891b25e37059b44eb224f93803a764a",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "f438ee57a0c246b41ba90434f9e37112",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3a735f9d10cd39f4292bec35fb227445",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "232d552e7c3364c41afe7c570ce7b088",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "586061caa5f6f294886fc39578ccd458",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "ed9abe2423737ba42940d0efff5508c9",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0107856a8ad9a31498651137a892e49d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "5ec4507ee2b342e48a3de0355249e568",
                "type": 3
            }
        ],
        "passiveIcon": {
            "fileID": 21300000,
            "guid": "d3857588363cc674ea1157723c39247f",
            "type": 3
        },
        "passiveName": null,
        "passiveDescription": null
    }
};
$9e7396c0a9a49e68$exports.getImport = (guid)=>{
    switch(guid){
        case "20bebf031d70e6e4eaa69513f49b7bf3":
            return 0, (/*@__PURE__*/$parcel$interopDefault($0557eb189010fd0a$exports));
    }
};


var $9508b818235e28a5$exports = {};
var $08ce6b81b6c0a7e8$exports = {};
$08ce6b81b6c0a7e8$exports = new URL("Paladinskill_46.dcf0ef4b.png", import.meta.url).toString();


$9508b818235e28a5$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "17c14f584f7d29740952e55a51d6a1fe",
            "type": 3
        },
        "m_Name": "BossTroll",
        "m_EditorClassIdentifier": null,
        "unitModel": {
            "fileID": 3241138547371686400,
            "guid": "b81eb0f159ecd01438bc750a87ebdbe3",
            "type": 3
        },
        "heroClass": 27,
        "isHealer": 0,
        "isInternal": 1,
        "isBoss": 1,
        "level": 0,
        "attackSpeed": 1,
        "baseHP": 6350,
        "baseGCDMultiplier": 100,
        "unitName": "Gralnok Stonefang",
        "unitSpec": null,
        "icon": "f2511cc91ca2a95439b9056ba31b9802",
        "backgroundColor": {
            "r": 0.8588235,
            "g": 0.8588235,
            "b": 0.854902,
            "a": 1
        },
        "textColor": {
            "r": 0.4,
            "g": 0.4,
            "b": 0.4,
            "a": 1
        },
        "typeIcon": {
            "fileID": 21300000,
            "guid": "423717ccb76a74e489e5d288c5af5780",
            "type": 3
        },
        "type": "HEALER",
        "description": null,
        "hitboxScale": {
            "x": 6,
            "true": 3,
            "z": 6
        },
        "selectionCircleScale": {
            "x": 8,
            "true": 2,
            "z": 8
        },
        "mouseHitboxScale": {
            "x": 9,
            "true": 3.5,
            "z": 9
        },
        "hitAnimationType": 20,
        "dieAnimationType": 21,
        "animationSpeedMultiplier": 1,
        "supportsStopWalkAnimation": 0,
        "isLeftHandClosed": 0,
        "isRightHandClosed": 1,
        "dualWields": 0,
        "runAnimation": {
            "fileID": 1827226128182048800,
            "guid": "7b7cc865466160745b7ee114ef76aa07",
            "type": 3
        },
        "sprintAnimation": {
            "fileID": 1827226128182048800,
            "guid": "79208bd5d1341364b80b6579be249b2a",
            "type": 3
        },
        "idleAnimation": {
            "fileID": 1827226128182048800,
            "guid": "b968b489bd584ad4f9f557a15d4a1897",
            "type": 3
        },
        "stopWalkAnimation": {
            "fileID": 0
        },
        "footstepSounds": [
            {
                "fileID": 8300000,
                "guid": "f6a0604181d205c48a1487b0a420b0e0",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "129dbdeb1611723489ad2445e4d62806",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "761b3b0bb7a210f45ab22851c8823fd5",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0207beb000d2a984aba8d8c18033978d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3331792b169924448bd774007767d02b",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a01ca2c05517c2440923677ccbcf13c4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a1932d9612ddc6c4b89c2f012dd59eb2",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "e307c1e688ce6fa4090baf3702ff14e3",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0b508f958dc2fc14dae01bc74f6c3896",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c75f01921060aea468faa65f382dfdf4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c7dfd018c818f2e479b45a715e1a2a6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "330aba8c48b34b64baa9d90ca470ea6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c891b25e37059b44eb224f93803a764a",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "f438ee57a0c246b41ba90434f9e37112",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3a735f9d10cd39f4292bec35fb227445",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "232d552e7c3364c41afe7c570ce7b088",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "586061caa5f6f294886fc39578ccd458",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "ed9abe2423737ba42940d0efff5508c9",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0107856a8ad9a31498651137a892e49d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "5ec4507ee2b342e48a3de0355249e568",
                "type": 3
            }
        ],
        "passiveIcon": {
            "fileID": 21300000,
            "guid": "d3857588363cc674ea1157723c39247f",
            "type": 3
        },
        "passiveName": null,
        "passiveDescription": null
    }
};
$9508b818235e28a5$exports.getImport = (guid)=>{
    switch(guid){
        case "f2511cc91ca2a95439b9056ba31b9802":
            return 0, (/*@__PURE__*/$parcel$interopDefault($08ce6b81b6c0a7e8$exports));
    }
};


var $f4d4979756ee69af$exports = {};
var $58f8c4a9dfdcf67c$exports = {};
$58f8c4a9dfdcf67c$exports = new URL("Warriorskill_34.9539066a.png", import.meta.url).toString();


var $bebbfec07073abc4$exports = {};
$bebbfec07073abc4$exports = new URL("quickrecovery.964f2075.png", import.meta.url).toString();


$f4d4979756ee69af$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "17c14f584f7d29740952e55a51d6a1fe",
            "type": 3
        },
        "m_Name": "PlayerBlademasterWarrior",
        "m_EditorClassIdentifier": null,
        "unitModel": {
            "fileID": 2853453332119588000,
            "guid": "be1c54b2a09b3de46b747815e0b297bc",
            "type": 3
        },
        "heroClass": 11,
        "isHealer": 0,
        "isInternal": 0,
        "isBoss": 0,
        "level": 0,
        "attackSpeed": 1,
        "baseHP": 220,
        "baseGCDMultiplier": 0,
        "unitName": "Tarcza",
        "unitSpec": "Blademaster",
        "icon": "6ca95c685a14328478a71db739ec37f5",
        "backgroundColor": {
            "r": 0.24313724,
            "g": 0.26777333,
            "b": 0.65882355,
            "a": 1
        },
        "textColor": {
            "r": 1,
            "g": 1,
            "b": 1,
            "a": 1
        },
        "typeIcon": {
            "fileID": 21300000,
            "guid": "5480d4e62790e9049be1a6360fd9a498",
            "type": 3
        },
        "type": "DPS",
        "description": "Tarcza is a formidable Blademaster whose ferocity is matched only by his unyielding determination. Known for his aggressive tactics and unwavering courage, Tarcza is a warrior who never retreats from a challenge. With each swing of his mighty blade, he embodies the relentless spirit of battle, driving forward with unbridled intensity. His opponents tremble at the sight of him, for they know that once Tarcza has set his sights on victory, nothing can stand in his way. In the arena of combat, Tarcza is a force to be reckoned with, a living testament to the undying resolve of a true warrior.",
        "hitboxScale": {
            "x": 1,
            "true": 1,
            "z": 1
        },
        "selectionCircleScale": {
            "x": 2,
            "true": 2,
            "z": 2
        },
        "mouseHitboxScale": {
            "x": 3,
            "true": 1,
            "z": 3
        },
        "hitAnimationType": 3,
        "dieAnimationType": 1,
        "animationSpeedMultiplier": 1,
        "supportsStopWalkAnimation": 1,
        "isLeftHandClosed": 0,
        "isRightHandClosed": 1,
        "dualWields": 0,
        "runAnimation": {
            "fileID": 7400000,
            "guid": "f57f5f52133617945ba2882277d12087",
            "type": 3
        },
        "sprintAnimation": {
            "fileID": 0
        },
        "idleAnimation": {
            "fileID": 0
        },
        "stopWalkAnimation": {
            "fileID": 0
        },
        "footstepSounds": [
            {
                "fileID": 8300000,
                "guid": "f6a0604181d205c48a1487b0a420b0e0",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "129dbdeb1611723489ad2445e4d62806",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "761b3b0bb7a210f45ab22851c8823fd5",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0207beb000d2a984aba8d8c18033978d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3331792b169924448bd774007767d02b",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a01ca2c05517c2440923677ccbcf13c4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a1932d9612ddc6c4b89c2f012dd59eb2",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "e307c1e688ce6fa4090baf3702ff14e3",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0b508f958dc2fc14dae01bc74f6c3896",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c75f01921060aea468faa65f382dfdf4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c7dfd018c818f2e479b45a715e1a2a6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "330aba8c48b34b64baa9d90ca470ea6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c891b25e37059b44eb224f93803a764a",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "f438ee57a0c246b41ba90434f9e37112",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3a735f9d10cd39f4292bec35fb227445",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "232d552e7c3364c41afe7c570ce7b088",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "586061caa5f6f294886fc39578ccd458",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "ed9abe2423737ba42940d0efff5508c9",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0107856a8ad9a31498651137a892e49d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "5ec4507ee2b342e48a3de0355249e568",
                "type": 3
            }
        ],
        "passiveIcon": "d9c9a9083861bff4b97e856e530f7d53",
        "passiveName": "Quick Recovery",
        "passiveDescription": "Whenever you are <b>Stunned</b>, heal for <b>6</b> health every <b>2</b> seconds for <b>6</b> seconds. The effect does not stack."
    }
};
$f4d4979756ee69af$exports.getImport = (guid)=>{
    switch(guid){
        case "6ca95c685a14328478a71db739ec37f5":
            return 0, (/*@__PURE__*/$parcel$interopDefault($58f8c4a9dfdcf67c$exports));
        case "d9c9a9083861bff4b97e856e530f7d53":
            return 0, (/*@__PURE__*/$parcel$interopDefault($bebbfec07073abc4$exports));
    }
};


var $369b50bb787c477f$exports = {};
var $2b41a148e0f95ddc$exports = {};
$2b41a148e0f95ddc$exports = new URL("Assassinskill_05.74120464.png", import.meta.url).toString();


var $8fd5e9a79a673a25$exports = {};
$8fd5e9a79a673a25$exports = new URL("Mageskill_47.2cce9ac8.png", import.meta.url).toString();


$369b50bb787c477f$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "17c14f584f7d29740952e55a51d6a1fe",
            "type": 3
        },
        "m_Name": "PlayerBruiserRogue",
        "m_EditorClassIdentifier": null,
        "unitModel": {
            "fileID": 1737313431337791700,
            "guid": "503aab51049ed98479cdd715045cb3ba",
            "type": 3
        },
        "heroClass": 10,
        "isHealer": 0,
        "isInternal": 0,
        "isBoss": 0,
        "level": 0,
        "attackSpeed": 1,
        "baseHP": 194,
        "baseGCDMultiplier": 0,
        "unitName": "Volen",
        "unitSpec": "Bruiser",
        "icon": "2978e214a62beee449d7882b1a12a347",
        "backgroundColor": {
            "r": 0.8773585,
            "g": 0.24334282,
            "b": 0.24967617,
            "a": 1
        },
        "textColor": {
            "r": 1,
            "g": 1,
            "b": 1,
            "a": 1
        },
        "typeIcon": {
            "fileID": 21300000,
            "guid": "5480d4e62790e9049be1a6360fd9a498",
            "type": 3
        },
        "type": "DPS",
        "description": "Volen is a Bruiser who commands respect within the Ring of Titans. His combat style is defined by relentless aggression and unyielding resolve, dealing consistent damage to his opponents without showing any sign of backing down. What sets him apart is his remarkable ability to stun and control adversaries with precision, slowly wearing his opponents down with his determination. With his imposing presence and mastery over controlling the flow of combat, Volen stands as a force to be reckoned with in the arena, leaving a trail of defeated foes in his wake.",
        "hitboxScale": {
            "x": 1,
            "true": 1,
            "z": 1
        },
        "selectionCircleScale": {
            "x": 2,
            "true": 2,
            "z": 2
        },
        "mouseHitboxScale": {
            "x": 3,
            "true": 1,
            "z": 3
        },
        "hitAnimationType": 3,
        "dieAnimationType": 1,
        "animationSpeedMultiplier": 1,
        "supportsStopWalkAnimation": 1,
        "isLeftHandClosed": 1,
        "isRightHandClosed": 1,
        "dualWields": 1,
        "runAnimation": {
            "fileID": 0
        },
        "sprintAnimation": {
            "fileID": 0
        },
        "idleAnimation": {
            "fileID": 0
        },
        "stopWalkAnimation": {
            "fileID": 0
        },
        "footstepSounds": [
            {
                "fileID": 8300000,
                "guid": "f6a0604181d205c48a1487b0a420b0e0",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "129dbdeb1611723489ad2445e4d62806",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "761b3b0bb7a210f45ab22851c8823fd5",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0207beb000d2a984aba8d8c18033978d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3331792b169924448bd774007767d02b",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a01ca2c05517c2440923677ccbcf13c4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a1932d9612ddc6c4b89c2f012dd59eb2",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "e307c1e688ce6fa4090baf3702ff14e3",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0b508f958dc2fc14dae01bc74f6c3896",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c75f01921060aea468faa65f382dfdf4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c7dfd018c818f2e479b45a715e1a2a6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "330aba8c48b34b64baa9d90ca470ea6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c891b25e37059b44eb224f93803a764a",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "f438ee57a0c246b41ba90434f9e37112",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3a735f9d10cd39f4292bec35fb227445",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "232d552e7c3364c41afe7c570ce7b088",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "586061caa5f6f294886fc39578ccd458",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "ed9abe2423737ba42940d0efff5508c9",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0107856a8ad9a31498651137a892e49d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "5ec4507ee2b342e48a3de0355249e568",
                "type": 3
            }
        ],
        "passiveIcon": "c95e43e176074c548b752c46fa9b9b25",
        "passiveName": "Double Jump",
        "passiveDescription": "You can jump again while in the air after jumping from the ground. Your second jump also gives a burst of momentum in your facing direction."
    }
};
$369b50bb787c477f$exports.getImport = (guid)=>{
    switch(guid){
        case "2978e214a62beee449d7882b1a12a347":
            return 0, (/*@__PURE__*/$parcel$interopDefault($2b41a148e0f95ddc$exports));
        case "c95e43e176074c548b752c46fa9b9b25":
            return 0, (/*@__PURE__*/$parcel$interopDefault($8fd5e9a79a673a25$exports));
    }
};


var $2c8d73f08547bb4d$exports = {};
var $95a0f4cbc8babfe9$exports = {};
$95a0f4cbc8babfe9$exports = new URL("Mageskill_41.9eb129e4.png", import.meta.url).toString();


var $7a2ca75d4fd23463$exports = {};
$7a2ca75d4fd23463$exports = new URL("Mageskill_42.4595e76b.png", import.meta.url).toString();


$2c8d73f08547bb4d$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "17c14f584f7d29740952e55a51d6a1fe",
            "type": 3
        },
        "m_Name": "PlayerCorruptorDruid",
        "m_EditorClassIdentifier": null,
        "unitModel": {
            "fileID": 3241138547371686400,
            "guid": "d7a299f5825fe1c4482c6261124bb072",
            "type": 3
        },
        "heroClass": 14,
        "isHealer": 0,
        "isInternal": 0,
        "isBoss": 0,
        "level": 0,
        "attackSpeed": 1,
        "baseHP": 174,
        "baseGCDMultiplier": 0,
        "unitName": "Airion",
        "unitSpec": "Stormcaller",
        "icon": "18901b897df0f664dbdc34927f5c0228",
        "backgroundColor": {
            "r": 0.90588236,
            "g": 0.4630687,
            "b": 0.121568635,
            "a": 1
        },
        "textColor": {
            "r": 0.4,
            "g": 0.4,
            "b": 0.4,
            "a": 1
        },
        "typeIcon": {
            "fileID": 21300000,
            "guid": "5480d4e62790e9049be1a6360fd9a498",
            "type": 3
        },
        "type": "DPS",
        "description": "In the Ring of Titans, Airion is a formidable Stormcaller. With crackling lightning at his command, Airion unleashes devastating storms upon adversaries, striking fear into the hearts of challengers. However, beyond his mastery of tempestuous forces, Airion possesses another gift \u2013 the ability to harness the powers of nature for healing and support. With a deft touch, he can mend wounds and bolster allies, balancing the ferocity of the storm with the tranquility of the natural world. As a versatile combatant, Airion stands as both a fearsome opponent and a steadfast ally, his prowess echoing like thunder across the battlefield.",
        "hitboxScale": {
            "x": 1,
            "true": 1,
            "z": 1
        },
        "selectionCircleScale": {
            "x": 2,
            "true": 2,
            "z": 2
        },
        "mouseHitboxScale": {
            "x": 3,
            "true": 1,
            "z": 3
        },
        "hitAnimationType": 3,
        "dieAnimationType": 1,
        "animationSpeedMultiplier": 1,
        "supportsStopWalkAnimation": 1,
        "isLeftHandClosed": 0,
        "isRightHandClosed": 1,
        "dualWields": 0,
        "runAnimation": {
            "fileID": 0
        },
        "sprintAnimation": {
            "fileID": 0
        },
        "idleAnimation": {
            "fileID": 0
        },
        "stopWalkAnimation": {
            "fileID": 0
        },
        "footstepSounds": [
            {
                "fileID": 8300000,
                "guid": "f6a0604181d205c48a1487b0a420b0e0",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "129dbdeb1611723489ad2445e4d62806",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "761b3b0bb7a210f45ab22851c8823fd5",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0207beb000d2a984aba8d8c18033978d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3331792b169924448bd774007767d02b",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a01ca2c05517c2440923677ccbcf13c4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a1932d9612ddc6c4b89c2f012dd59eb2",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "e307c1e688ce6fa4090baf3702ff14e3",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0b508f958dc2fc14dae01bc74f6c3896",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c75f01921060aea468faa65f382dfdf4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c7dfd018c818f2e479b45a715e1a2a6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "330aba8c48b34b64baa9d90ca470ea6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c891b25e37059b44eb224f93803a764a",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "f438ee57a0c246b41ba90434f9e37112",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3a735f9d10cd39f4292bec35fb227445",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "232d552e7c3364c41afe7c570ce7b088",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "586061caa5f6f294886fc39578ccd458",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "ed9abe2423737ba42940d0efff5508c9",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0107856a8ad9a31498651137a892e49d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "5ec4507ee2b342e48a3de0355249e568",
                "type": 3
            }
        ],
        "passiveIcon": "e7dae896993f7c144bdd4b51b3fddf24",
        "passiveName": "Lightning Mastery",
        "passiveDescription": "Deal an additional 15% magic damage while in <b>Lightning Mode</b>."
    }
};
$2c8d73f08547bb4d$exports.getImport = (guid)=>{
    switch(guid){
        case "18901b897df0f664dbdc34927f5c0228":
            return 0, (/*@__PURE__*/$parcel$interopDefault($95a0f4cbc8babfe9$exports));
        case "e7dae896993f7c144bdd4b51b3fddf24":
            return 0, (/*@__PURE__*/$parcel$interopDefault($7a2ca75d4fd23463$exports));
    }
};


var $5fb4c63ab8907e0b$exports = {};
var $08e7e2039e38e50f$exports = {};
$08e7e2039e38e50f$exports = new URL("crystalmage.1d4d3e31.png", import.meta.url).toString();


var $a798ed4f2ffa720f$exports = {};
$a798ed4f2ffa720f$exports = new URL("shatteredcrystals.667df8b3.png", import.meta.url).toString();


$5fb4c63ab8907e0b$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "17c14f584f7d29740952e55a51d6a1fe",
            "type": 3
        },
        "m_Name": "PlayerCrystalMage",
        "m_EditorClassIdentifier": null,
        "unitModel": {
            "fileID": 5226127952259784000,
            "guid": "33a1d022504f42a449331a8e55e4cbbf",
            "type": 3
        },
        "heroClass": 9,
        "isHealer": 0,
        "isInternal": 0,
        "isBoss": 0,
        "level": 0,
        "attackSpeed": 1,
        "baseHP": 132,
        "baseGCDMultiplier": 0,
        "unitName": "Azora",
        "unitSpec": "Crystalmancer",
        "icon": "c6499b21fa0f0c84186119a11f06d9e0",
        "backgroundColor": {
            "r": 0.2170167,
            "g": 0.9056604,
            "b": 0.5898942,
            "a": 1
        },
        "textColor": {
            "r": 0.4,
            "g": 0.4,
            "b": 0.4,
            "a": 1
        },
        "typeIcon": {
            "fileID": 21300000,
            "guid": "5480d4e62790e9049be1a6360fd9a498",
            "type": 3
        },
        "type": "DPS",
        "description": "Azora is a daunting force, wielding the ethereal powers of crystal magic. Known as a Crystalmancer, she dazzles spectators with her mastery over all of the elements, crafting devastating spells that unleash torrents of destruction upon her opponents. Azora's prowess is unmatched; her ability to deal immense damage strikes fear into the hearts of her adversaries. However, her power comes with a perilous vulnerability, as she stands on the razor's edge of survival, susceptible to even the slightest misstep. In the arena, Azora dances with danger, harnessing the brilliance of her magic while teetering on the brink of demise. Her every move is a delicate balance between annihilation and victory, captivating audiences with the spectacle of her dazzling, yet precarious, performance.",
        "hitboxScale": {
            "x": 1,
            "true": 1,
            "z": 1
        },
        "selectionCircleScale": {
            "x": 2,
            "true": 2,
            "z": 2
        },
        "mouseHitboxScale": {
            "x": 3,
            "true": 1,
            "z": 3
        },
        "hitAnimationType": 3,
        "dieAnimationType": 1,
        "animationSpeedMultiplier": 1,
        "supportsStopWalkAnimation": 1,
        "isLeftHandClosed": 0,
        "isRightHandClosed": 1,
        "dualWields": 0,
        "runAnimation": {
            "fileID": 8430362803238232000,
            "guid": "5aff1555fb420e048b4e05ffebab65fe",
            "type": 3
        },
        "sprintAnimation": {
            "fileID": 2019560895462781200,
            "guid": "584dcc3ec614bc34da99f5a3bb6d15fc",
            "type": 3
        },
        "idleAnimation": {
            "fileID": -5416651000045457000,
            "guid": "bce44f2ab64e1c847b2ade1020ec6a3b",
            "type": 3
        },
        "stopWalkAnimation": {
            "fileID": 1874791023308148200,
            "guid": "7daf9a049f61cc147b1a611182e8c924",
            "type": 3
        },
        "footstepSounds": [
            {
                "fileID": 8300000,
                "guid": "f6a0604181d205c48a1487b0a420b0e0",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "129dbdeb1611723489ad2445e4d62806",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "761b3b0bb7a210f45ab22851c8823fd5",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0207beb000d2a984aba8d8c18033978d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3331792b169924448bd774007767d02b",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a01ca2c05517c2440923677ccbcf13c4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a1932d9612ddc6c4b89c2f012dd59eb2",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "e307c1e688ce6fa4090baf3702ff14e3",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0b508f958dc2fc14dae01bc74f6c3896",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c75f01921060aea468faa65f382dfdf4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c7dfd018c818f2e479b45a715e1a2a6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "330aba8c48b34b64baa9d90ca470ea6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c891b25e37059b44eb224f93803a764a",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "f438ee57a0c246b41ba90434f9e37112",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3a735f9d10cd39f4292bec35fb227445",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "232d552e7c3364c41afe7c570ce7b088",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "586061caa5f6f294886fc39578ccd458",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "ed9abe2423737ba42940d0efff5508c9",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0107856a8ad9a31498651137a892e49d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "5ec4507ee2b342e48a3de0355249e568",
                "type": 3
            }
        ],
        "passiveIcon": "34e5b75006acb3a4eaeece2479656353",
        "passiveName": "Shattered Crystals",
        "passiveDescription": "While below <b>30%</b> health, deal <b>30%</b> more magic damage."
    }
};
$5fb4c63ab8907e0b$exports.getImport = (guid)=>{
    switch(guid){
        case "c6499b21fa0f0c84186119a11f06d9e0":
            return 0, (/*@__PURE__*/$parcel$interopDefault($08e7e2039e38e50f$exports));
        case "34e5b75006acb3a4eaeece2479656353":
            return 0, (/*@__PURE__*/$parcel$interopDefault($a798ed4f2ffa720f$exports));
    }
};


var $8bb3362da6ea79e1$exports = {};
var $d819d719cd1ca495$exports = {};
$d819d719cd1ca495$exports = new URL("Priestskill_10.8303df6d.png", import.meta.url).toString();


var $7278215c072ef058$exports = {};
$7278215c072ef058$exports = new URL("Priestskill_13.c7f15e2a.png", import.meta.url).toString();


$8bb3362da6ea79e1$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "17c14f584f7d29740952e55a51d6a1fe",
            "type": 3
        },
        "m_Name": "PlayerDarkPriest",
        "m_EditorClassIdentifier": null,
        "unitModel": {
            "fileID": 2777422822122511000,
            "guid": "4e97436c6d3330246a037b6dc6dba6c7",
            "type": 3
        },
        "heroClass": 8,
        "isHealer": 1,
        "isInternal": 0,
        "isBoss": 0,
        "level": 0,
        "attackSpeed": 1,
        "baseHP": 150,
        "baseGCDMultiplier": 0,
        "unitName": "Kanna",
        "unitSpec": "Soulstealer",
        "icon": "3d37dcc66de5bc148b9e40e6300cfa88",
        "backgroundColor": {
            "r": 0.5283019,
            "g": 0.28608045,
            "b": 0.50953025,
            "a": 1
        },
        "textColor": {
            "r": 1,
            "g": 1,
            "b": 1,
            "a": 1
        },
        "typeIcon": {
            "fileID": 21300000,
            "guid": "9df8e2d193abdec44b5895cb67921ac0",
            "type": 3
        },
        "type": "HEALER",
        "description": "Kanna, the enigmatic Soulstealer of the Ring of Titans, maneuvers the battlefield with a delicate balance of sacrifice and salvation. Renowned for her unparalleled support, she deftly manipulates the essence of souls, weaving a web of interconnected life force among her allies. In the throes of combat, Kanna selflessly redistributes vitality, drawing from her own spirit and those of her companions to sustain the team's resilience. With each exchange, she orchestrates a symphony of healing, ensuring her comrades endure the trials of the arena with unwavering fortitude.",
        "hitboxScale": {
            "x": 1,
            "true": 1,
            "z": 1
        },
        "selectionCircleScale": {
            "x": 2,
            "true": 2,
            "z": 2
        },
        "mouseHitboxScale": {
            "x": 3,
            "true": 1,
            "z": 3
        },
        "hitAnimationType": 3,
        "dieAnimationType": 1,
        "animationSpeedMultiplier": 1,
        "supportsStopWalkAnimation": 1,
        "isLeftHandClosed": 0,
        "isRightHandClosed": 1,
        "dualWields": 0,
        "runAnimation": {
            "fileID": 8430362803238232000,
            "guid": "5aff1555fb420e048b4e05ffebab65fe",
            "type": 3
        },
        "sprintAnimation": {
            "fileID": 2019560895462781200,
            "guid": "584dcc3ec614bc34da99f5a3bb6d15fc",
            "type": 3
        },
        "idleAnimation": {
            "fileID": -5416651000045457000,
            "guid": "bce44f2ab64e1c847b2ade1020ec6a3b",
            "type": 3
        },
        "stopWalkAnimation": {
            "fileID": 1874791023308148200,
            "guid": "7daf9a049f61cc147b1a611182e8c924",
            "type": 3
        },
        "footstepSounds": [
            {
                "fileID": 8300000,
                "guid": "f6a0604181d205c48a1487b0a420b0e0",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "129dbdeb1611723489ad2445e4d62806",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "761b3b0bb7a210f45ab22851c8823fd5",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0207beb000d2a984aba8d8c18033978d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3331792b169924448bd774007767d02b",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a01ca2c05517c2440923677ccbcf13c4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a1932d9612ddc6c4b89c2f012dd59eb2",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "e307c1e688ce6fa4090baf3702ff14e3",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0b508f958dc2fc14dae01bc74f6c3896",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c75f01921060aea468faa65f382dfdf4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c7dfd018c818f2e479b45a715e1a2a6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "330aba8c48b34b64baa9d90ca470ea6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c891b25e37059b44eb224f93803a764a",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "f438ee57a0c246b41ba90434f9e37112",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3a735f9d10cd39f4292bec35fb227445",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "232d552e7c3364c41afe7c570ce7b088",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "586061caa5f6f294886fc39578ccd458",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "ed9abe2423737ba42940d0efff5508c9",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0107856a8ad9a31498651137a892e49d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "5ec4507ee2b342e48a3de0355249e568",
                "type": 3
            }
        ],
        "passiveIcon": "952aff501826fd84594c9b2b2e334e1b",
        "passiveName": "Tough Soul",
        "passiveDescription": "Take up to <b>20%</b> reduced damage as your current health decreases."
    }
};
$8bb3362da6ea79e1$exports.getImport = (guid)=>{
    switch(guid){
        case "3d37dcc66de5bc148b9e40e6300cfa88":
            return 0, (/*@__PURE__*/$parcel$interopDefault($d819d719cd1ca495$exports));
        case "952aff501826fd84594c9b2b2e334e1b":
            return 0, (/*@__PURE__*/$parcel$interopDefault($7278215c072ef058$exports));
    }
};


var $8776c17491df8072$exports = {};
var $32722f13267baf3c$exports = {};
$32722f13267baf3c$exports = new URL("Druideskill_07.d63ed4e9.png", import.meta.url).toString();


var $75e9c60c80bd70e6$exports = {};
$75e9c60c80bd70e6$exports = new URL("Druideskill_36.26c4803d.png", import.meta.url).toString();


$8776c17491df8072$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "17c14f584f7d29740952e55a51d6a1fe",
            "type": 3
        },
        "m_Name": "PlayerDruid",
        "m_EditorClassIdentifier": null,
        "unitModel": {
            "fileID": 3241138547371686400,
            "guid": "2190831e07812fc469425810ebd0e015",
            "type": 3
        },
        "heroClass": 5,
        "isHealer": 1,
        "isInternal": 0,
        "isBoss": 0,
        "level": 0,
        "attackSpeed": 1,
        "baseHP": 192,
        "baseGCDMultiplier": 0,
        "unitName": "Airion",
        "unitSpec": "Naturalist",
        "icon": "4260c5888aba0a742ae51670f774d53d",
        "backgroundColor": {
            "r": 0.6886792,
            "g": 0.30881846,
            "b": 0.10720008,
            "a": 1
        },
        "textColor": {
            "r": 1,
            "g": 1,
            "b": 1,
            "a": 1
        },
        "typeIcon": {
            "fileID": 21300000,
            "guid": "9df8e2d193abdec44b5895cb67921ac0",
            "type": 3
        },
        "type": "HEALER",
        "description": "With a profound connection to the elements, Airion embodies the harmony between nature's nurturing embrace and the electrifying power of the storm. In combat, he orchestrates a delicate symphony, seamlessly blending his ability to harness the healing properties of the earth with the crackling fury of lightning. While his adversaries feel the sting of his electric assaults, Airion's team finds solace in his consistent support, as he ensures their resilience with the gentle caress of nature's mending touch. A true master of balance, Airion stands as a testament to the formidable union of nature's grace and tempestuous might within the arena's unforgiving confines.",
        "hitboxScale": {
            "x": 1,
            "true": 1,
            "z": 1
        },
        "selectionCircleScale": {
            "x": 2,
            "true": 2,
            "z": 2
        },
        "mouseHitboxScale": {
            "x": 3,
            "true": 1,
            "z": 3
        },
        "hitAnimationType": 3,
        "dieAnimationType": 1,
        "animationSpeedMultiplier": 1,
        "supportsStopWalkAnimation": 1,
        "isLeftHandClosed": 0,
        "isRightHandClosed": 1,
        "dualWields": 0,
        "runAnimation": {
            "fileID": 0
        },
        "sprintAnimation": {
            "fileID": 0
        },
        "idleAnimation": {
            "fileID": 0
        },
        "stopWalkAnimation": {
            "fileID": 0
        },
        "footstepSounds": [
            {
                "fileID": 8300000,
                "guid": "f6a0604181d205c48a1487b0a420b0e0",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "129dbdeb1611723489ad2445e4d62806",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "761b3b0bb7a210f45ab22851c8823fd5",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0207beb000d2a984aba8d8c18033978d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3331792b169924448bd774007767d02b",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a01ca2c05517c2440923677ccbcf13c4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a1932d9612ddc6c4b89c2f012dd59eb2",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "e307c1e688ce6fa4090baf3702ff14e3",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0b508f958dc2fc14dae01bc74f6c3896",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c75f01921060aea468faa65f382dfdf4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c7dfd018c818f2e479b45a715e1a2a6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "330aba8c48b34b64baa9d90ca470ea6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c891b25e37059b44eb224f93803a764a",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "f438ee57a0c246b41ba90434f9e37112",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3a735f9d10cd39f4292bec35fb227445",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "232d552e7c3364c41afe7c570ce7b088",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "586061caa5f6f294886fc39578ccd458",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "ed9abe2423737ba42940d0efff5508c9",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0107856a8ad9a31498651137a892e49d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "5ec4507ee2b342e48a3de0355249e568",
                "type": 3
            }
        ],
        "passiveIcon": "a0e16df8054af214b98b6aba1c12cbd7",
        "passiveName": "Nature Mastery",
        "passiveDescription": "Gain an additional 85% healing while in <b>Nature Mode</b>."
    }
};
$8776c17491df8072$exports.getImport = (guid)=>{
    switch(guid){
        case "4260c5888aba0a742ae51670f774d53d":
            return 0, (/*@__PURE__*/$parcel$interopDefault($32722f13267baf3c$exports));
        case "a0e16df8054af214b98b6aba1c12cbd7":
            return 0, (/*@__PURE__*/$parcel$interopDefault($75e9c60c80bd70e6$exports));
    }
};


var $806ab136a3cf8e1f$exports = {};
var $5bc82aefc1cc5942$exports = {};
$5bc82aefc1cc5942$exports = new URL("Warlock_50.a638d31b.png", import.meta.url).toString();


var $2b07be47fd148a97$exports = {};
$2b07be47fd148a97$exports = new URL("shadowresistance.393d8f02.png", import.meta.url).toString();


$806ab136a3cf8e1f$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "17c14f584f7d29740952e55a51d6a1fe",
            "type": 3
        },
        "m_Name": "PlayerEradicatorWarlock",
        "m_EditorClassIdentifier": null,
        "unitModel": {
            "fileID": 5925594905447184000,
            "guid": "1d2827baba4a3ca4190c404cfb6a598a",
            "type": 3
        },
        "heroClass": 12,
        "isHealer": 0,
        "isInternal": 0,
        "isBoss": 0,
        "level": 0,
        "attackSpeed": 1,
        "baseHP": 160,
        "baseGCDMultiplier": 0,
        "unitName": "Malrah",
        "unitSpec": "Eradicator",
        "icon": "6a1e0d2d7dc596e40beeb25d5d5d18ee",
        "backgroundColor": {
            "r": 0.4716981,
            "g": 0.113029525,
            "b": 0.2992613,
            "a": 1
        },
        "textColor": {
            "r": 1,
            "g": 1,
            "b": 1,
            "a": 1
        },
        "typeIcon": {
            "fileID": 21300000,
            "guid": "5480d4e62790e9049be1a6360fd9a498",
            "type": 3
        },
        "type": "DPS",
        "description": "Malrah, known as the Eradicator, commands terrifying dark powers within the Ring of Titans, unleashing devastating damage upon her adversaries with ruthless efficiency. However, her strength comes with a cost, as she requires periods of downtime to replenish her energies. Despite her formidable prowess, Malrah is vulnerable to interruptions while casting spells, and her lack of mobility leaves her exposed to swift opponents. In the arena, her strategy revolves around swift strikes and calculated bursts of power, making her a force to be reckoned with for those who dare to challenge her domain.",
        "hitboxScale": {
            "x": 1,
            "true": 1,
            "z": 1
        },
        "selectionCircleScale": {
            "x": 2,
            "true": 2,
            "z": 2
        },
        "mouseHitboxScale": {
            "x": 3,
            "true": 1,
            "z": 3
        },
        "hitAnimationType": 3,
        "dieAnimationType": 1,
        "animationSpeedMultiplier": 1,
        "supportsStopWalkAnimation": 1,
        "isLeftHandClosed": 0,
        "isRightHandClosed": 1,
        "dualWields": 0,
        "runAnimation": {
            "fileID": 8430362803238232000,
            "guid": "5aff1555fb420e048b4e05ffebab65fe",
            "type": 3
        },
        "sprintAnimation": {
            "fileID": 2019560895462781200,
            "guid": "584dcc3ec614bc34da99f5a3bb6d15fc",
            "type": 3
        },
        "idleAnimation": {
            "fileID": -5416651000045457000,
            "guid": "bce44f2ab64e1c847b2ade1020ec6a3b",
            "type": 3
        },
        "stopWalkAnimation": {
            "fileID": 1874791023308148200,
            "guid": "7daf9a049f61cc147b1a611182e8c924",
            "type": 3
        },
        "footstepSounds": [
            {
                "fileID": 8300000,
                "guid": "f6a0604181d205c48a1487b0a420b0e0",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "129dbdeb1611723489ad2445e4d62806",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "761b3b0bb7a210f45ab22851c8823fd5",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0207beb000d2a984aba8d8c18033978d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3331792b169924448bd774007767d02b",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a01ca2c05517c2440923677ccbcf13c4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a1932d9612ddc6c4b89c2f012dd59eb2",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "e307c1e688ce6fa4090baf3702ff14e3",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0b508f958dc2fc14dae01bc74f6c3896",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c75f01921060aea468faa65f382dfdf4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c7dfd018c818f2e479b45a715e1a2a6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "330aba8c48b34b64baa9d90ca470ea6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c891b25e37059b44eb224f93803a764a",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "f438ee57a0c246b41ba90434f9e37112",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3a735f9d10cd39f4292bec35fb227445",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "232d552e7c3364c41afe7c570ce7b088",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "586061caa5f6f294886fc39578ccd458",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "ed9abe2423737ba42940d0efff5508c9",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0107856a8ad9a31498651137a892e49d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "5ec4507ee2b342e48a3de0355249e568",
                "type": 3
            }
        ],
        "passiveIcon": "f0b5a859b7b719944901cbed811dcfe3",
        "passiveName": "Shadow Resistance",
        "passiveDescription": "Every time you successfully cast a spell, gain a buff that reduces the magic damage you take by <b>2%</b>. Stacks up to <b>5</b> times."
    }
};
$806ab136a3cf8e1f$exports.getImport = (guid)=>{
    switch(guid){
        case "6a1e0d2d7dc596e40beeb25d5d5d18ee":
            return 0, (/*@__PURE__*/$parcel$interopDefault($5bc82aefc1cc5942$exports));
        case "f0b5a859b7b719944901cbed811dcfe3":
            return 0, (/*@__PURE__*/$parcel$interopDefault($2b07be47fd148a97$exports));
    }
};


var $42ecc19aca70d114$exports = {};
var $d3908074401469de$exports = {};
$d3908074401469de$exports = new URL("Archerskill_44.d0820720.png", import.meta.url).toString();


var $68feaae8666d2857$exports = {};
$68feaae8666d2857$exports = new URL("disengaged.db48327e.png", import.meta.url).toString();


$42ecc19aca70d114$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "17c14f584f7d29740952e55a51d6a1fe",
            "type": 3
        },
        "m_Name": "PlayerHunter",
        "m_EditorClassIdentifier": null,
        "unitModel": {
            "fileID": 2910940308793556500,
            "guid": "d2c76fa636f5cb84dbaa1aceb77c021b",
            "type": 3
        },
        "heroClass": 6,
        "isHealer": 0,
        "isInternal": 0,
        "isBoss": 0,
        "level": 0,
        "attackSpeed": 1,
        "baseHP": 200,
        "baseGCDMultiplier": 0,
        "unitName": "Orin",
        "unitSpec": "Hunter",
        "icon": "eb8ceac05c3baf242a6b90310f4abd40",
        "backgroundColor": {
            "r": 0.6666667,
            "g": 0.827451,
            "b": 0.44705883,
            "a": 1
        },
        "textColor": {
            "r": 0.4,
            "g": 0.4,
            "b": 0.4,
            "a": 1
        },
        "typeIcon": {
            "fileID": 21300000,
            "guid": "5480d4e62790e9049be1a6360fd9a498",
            "type": 3
        },
        "type": "DPS",
        "description": "Orin, a seasoned Hunter in the renowned Ring of Titans, wields his trusty bow with unparalleled skill and finesse. Swift and nimble, he dances across the arena with remarkable agility, always maintaining distance from his foes. His precision and accuracy with the bow are legendary, consistently delivering devastating blows that leave his opponents reeling. However, despite his prowess from afar, Orin is notably vulnerable when adversaries close in on him, lacking the brute strength or close-quarters combat expertise of his counterparts. Nonetheless, his mastery of ranged combat ensures that he remains a formidable force to be reckoned with in the arena, his arrows striking true and his determination unyielding.",
        "hitboxScale": {
            "x": 1,
            "true": 1,
            "z": 1
        },
        "selectionCircleScale": {
            "x": 2,
            "true": 2,
            "z": 2
        },
        "mouseHitboxScale": {
            "x": 3,
            "true": 1,
            "z": 3
        },
        "hitAnimationType": 3,
        "dieAnimationType": 1,
        "animationSpeedMultiplier": 1,
        "supportsStopWalkAnimation": 1,
        "isLeftHandClosed": 1,
        "isRightHandClosed": 0,
        "dualWields": 0,
        "runAnimation": {
            "fileID": 0
        },
        "sprintAnimation": {
            "fileID": 0
        },
        "idleAnimation": {
            "fileID": 0
        },
        "stopWalkAnimation": {
            "fileID": 0
        },
        "footstepSounds": [
            {
                "fileID": 8300000,
                "guid": "f6a0604181d205c48a1487b0a420b0e0",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "129dbdeb1611723489ad2445e4d62806",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "761b3b0bb7a210f45ab22851c8823fd5",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0207beb000d2a984aba8d8c18033978d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3331792b169924448bd774007767d02b",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a01ca2c05517c2440923677ccbcf13c4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a1932d9612ddc6c4b89c2f012dd59eb2",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "e307c1e688ce6fa4090baf3702ff14e3",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0b508f958dc2fc14dae01bc74f6c3896",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c75f01921060aea468faa65f382dfdf4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c7dfd018c818f2e479b45a715e1a2a6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "330aba8c48b34b64baa9d90ca470ea6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c891b25e37059b44eb224f93803a764a",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "f438ee57a0c246b41ba90434f9e37112",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3a735f9d10cd39f4292bec35fb227445",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "232d552e7c3364c41afe7c570ce7b088",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "586061caa5f6f294886fc39578ccd458",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "ed9abe2423737ba42940d0efff5508c9",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0107856a8ad9a31498651137a892e49d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "5ec4507ee2b342e48a3de0355249e568",
                "type": 3
            }
        ],
        "passiveIcon": "0663a9fb22239e24ba94016599adc2e3",
        "passiveName": "Disengaged",
        "passiveDescription": "Every time you take physical damage, reduce the cooldown on Dissociative Force by 5% of the remaining duration."
    }
};
$42ecc19aca70d114$exports.getImport = (guid)=>{
    switch(guid){
        case "eb8ceac05c3baf242a6b90310f4abd40":
            return 0, (/*@__PURE__*/$parcel$interopDefault($d3908074401469de$exports));
        case "0663a9fb22239e24ba94016599adc2e3":
            return 0, (/*@__PURE__*/$parcel$interopDefault($68feaae8666d2857$exports));
    }
};


var $c5e2b7ba9c9bc857$exports = {};
var $21dbfcde0651b3bf$exports = {};
$21dbfcde0651b3bf$exports = new URL("Mageskill_01.fae8ee40.png", import.meta.url).toString();


var $a2f654a2e330cd5a$exports = {};
$a2f654a2e330cd5a$exports = new URL("Mageskill_36.7f397fb8.png", import.meta.url).toString();


$c5e2b7ba9c9bc857$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "17c14f584f7d29740952e55a51d6a1fe",
            "type": 3
        },
        "m_Name": "PlayerMage",
        "m_EditorClassIdentifier": null,
        "unitModel": {
            "fileID": 5226127952259784000,
            "guid": "365d9e4be31e2ed4c851d634392055f8",
            "type": 3
        },
        "heroClass": 0,
        "isHealer": 0,
        "isInternal": 0,
        "isBoss": 0,
        "level": 0,
        "attackSpeed": 1,
        "baseHP": 146,
        "baseGCDMultiplier": 0,
        "unitName": "Azora",
        "unitSpec": "Cryomancer",
        "icon": "8c7a31f97aa2ba54084540434eba412b",
        "backgroundColor": {
            "r": 0.2392157,
            "g": 0.4745098,
            "b": 0.654902,
            "a": 1
        },
        "textColor": {
            "r": 1,
            "g": 1,
            "b": 1,
            "a": 1
        },
        "typeIcon": {
            "fileID": 21300000,
            "guid": "5480d4e62790e9049be1a6360fd9a498",
            "type": 3
        },
        "type": "DPS",
        "description": "Azora is a Cryomancer who wields frost magic with unparalleled finesse. With a swift flick of her hand, she can ensnare her adversaries near and far, freezing their movements. Despite her fragile constitution, Azora's mastery over her craft grants her longevity in battles, as she maneuvers effortlessly amidst the chaos, her frost spells dictate the flow of combat. Her foes find themselves trapped in a chilling dance of survival, where every step could lead to their icy demise at the hands of this cunning spellcaster.",
        "hitboxScale": {
            "x": 1,
            "true": 1,
            "z": 1
        },
        "selectionCircleScale": {
            "x": 2,
            "true": 2,
            "z": 2
        },
        "mouseHitboxScale": {
            "x": 3,
            "true": 1,
            "z": 3
        },
        "hitAnimationType": 3,
        "dieAnimationType": 1,
        "animationSpeedMultiplier": 1,
        "supportsStopWalkAnimation": 1,
        "isLeftHandClosed": 0,
        "isRightHandClosed": 1,
        "dualWields": 0,
        "runAnimation": {
            "fileID": 8430362803238232000,
            "guid": "5aff1555fb420e048b4e05ffebab65fe",
            "type": 3
        },
        "sprintAnimation": {
            "fileID": 2019560895462781200,
            "guid": "584dcc3ec614bc34da99f5a3bb6d15fc",
            "type": 3
        },
        "idleAnimation": {
            "fileID": -5416651000045457000,
            "guid": "bce44f2ab64e1c847b2ade1020ec6a3b",
            "type": 3
        },
        "stopWalkAnimation": {
            "fileID": 1874791023308148200,
            "guid": "7daf9a049f61cc147b1a611182e8c924",
            "type": 3
        },
        "footstepSounds": [
            {
                "fileID": 8300000,
                "guid": "f6a0604181d205c48a1487b0a420b0e0",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "129dbdeb1611723489ad2445e4d62806",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "761b3b0bb7a210f45ab22851c8823fd5",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0207beb000d2a984aba8d8c18033978d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3331792b169924448bd774007767d02b",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a01ca2c05517c2440923677ccbcf13c4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a1932d9612ddc6c4b89c2f012dd59eb2",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "e307c1e688ce6fa4090baf3702ff14e3",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0b508f958dc2fc14dae01bc74f6c3896",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c75f01921060aea468faa65f382dfdf4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c7dfd018c818f2e479b45a715e1a2a6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "330aba8c48b34b64baa9d90ca470ea6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c891b25e37059b44eb224f93803a764a",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "f438ee57a0c246b41ba90434f9e37112",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3a735f9d10cd39f4292bec35fb227445",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "232d552e7c3364c41afe7c570ce7b088",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "586061caa5f6f294886fc39578ccd458",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "ed9abe2423737ba42940d0efff5508c9",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0107856a8ad9a31498651137a892e49d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "5ec4507ee2b342e48a3de0355249e568",
                "type": 3
            }
        ],
        "passiveIcon": "50eee26b30095d449a0391e278394e5a",
        "passiveName": "Icy Chill",
        "passiveDescription": "Whenever you take physical damage, slow the attacker's movement speed by <b>50%</b> for <b>5</b> seconds."
    }
};
$c5e2b7ba9c9bc857$exports.getImport = (guid)=>{
    switch(guid){
        case "8c7a31f97aa2ba54084540434eba412b":
            return 0, (/*@__PURE__*/$parcel$interopDefault($21dbfcde0651b3bf$exports));
        case "50eee26b30095d449a0391e278394e5a":
            return 0, (/*@__PURE__*/$parcel$interopDefault($a2f654a2e330cd5a$exports));
    }
};


var $836d00f1820221ad$exports = {};
var $d6cdd308983f2259$exports = {};
$d6cdd308983f2259$exports = new URL("Archerskill_07.914a5480.png", import.meta.url).toString();


var $0493bc48520867c3$exports = {};
$0493bc48520867c3$exports = new URL("Archerskill_03.c2a9681c.png", import.meta.url).toString();


$836d00f1820221ad$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "17c14f584f7d29740952e55a51d6a1fe",
            "type": 3
        },
        "m_Name": "PlayerMarksmanHunter",
        "m_EditorClassIdentifier": null,
        "unitModel": {
            "fileID": 2910940308793556500,
            "guid": "685ccb12f928e04408126300cdbb68df",
            "type": 3
        },
        "heroClass": 15,
        "isHealer": 0,
        "isInternal": 0,
        "isBoss": 0,
        "level": 0,
        "attackSpeed": 1,
        "baseHP": 190,
        "baseGCDMultiplier": 0,
        "unitName": "Orin",
        "unitSpec": "Marksman",
        "icon": "110e14c2d23805f4cbee7472b57b7cf4",
        "backgroundColor": {
            "r": 0.18490559,
            "g": 0.18490559,
            "b": 0.18490559,
            "a": 1
        },
        "textColor": {
            "r": 1,
            "g": 1,
            "b": 1,
            "a": 1
        },
        "typeIcon": {
            "fileID": 21300000,
            "guid": "5480d4e62790e9049be1a6360fd9a498",
            "type": 3
        },
        "type": "DPS",
        "description": "Orin is a Marksman who epitomizes precision and devastation on the battlefield. A master of dealing immense damage from a distance, Orin's prowess is unmatched when allowed to stand undisturbed, his aim unwavering and lethal. Yet, for all his offensive might, Orin is vulnerable when the spotlight turns his way, lacking the resilience to withstand direct assault. Thus, in the dance of combat, Orin must balance his unmatched offensive capabilities with strategic positioning and swift evasiveness to survive and reign supreme in the arena.",
        "hitboxScale": {
            "x": 1,
            "true": 1,
            "z": 1
        },
        "selectionCircleScale": {
            "x": 2,
            "true": 2,
            "z": 2
        },
        "mouseHitboxScale": {
            "x": 3,
            "true": 1,
            "z": 3
        },
        "hitAnimationType": 3,
        "dieAnimationType": 1,
        "animationSpeedMultiplier": 1,
        "supportsStopWalkAnimation": 1,
        "isLeftHandClosed": 1,
        "isRightHandClosed": 0,
        "dualWields": 0,
        "runAnimation": {
            "fileID": 0
        },
        "sprintAnimation": {
            "fileID": 0
        },
        "idleAnimation": {
            "fileID": 0
        },
        "stopWalkAnimation": {
            "fileID": 0
        },
        "footstepSounds": [
            {
                "fileID": 8300000,
                "guid": "f6a0604181d205c48a1487b0a420b0e0",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "129dbdeb1611723489ad2445e4d62806",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "761b3b0bb7a210f45ab22851c8823fd5",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0207beb000d2a984aba8d8c18033978d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3331792b169924448bd774007767d02b",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a01ca2c05517c2440923677ccbcf13c4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a1932d9612ddc6c4b89c2f012dd59eb2",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "e307c1e688ce6fa4090baf3702ff14e3",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0b508f958dc2fc14dae01bc74f6c3896",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c75f01921060aea468faa65f382dfdf4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c7dfd018c818f2e479b45a715e1a2a6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "330aba8c48b34b64baa9d90ca470ea6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c891b25e37059b44eb224f93803a764a",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "f438ee57a0c246b41ba90434f9e37112",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3a735f9d10cd39f4292bec35fb227445",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "232d552e7c3364c41afe7c570ce7b088",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "586061caa5f6f294886fc39578ccd458",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "ed9abe2423737ba42940d0efff5508c9",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0107856a8ad9a31498651137a892e49d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "5ec4507ee2b342e48a3de0355249e568",
                "type": 3
            }
        ],
        "passiveIcon": "c0da235e560fec9448a025b35e9e80bf",
        "passiveName": "Headshot",
        "passiveDescription": "Every <b>5th</b> arrow shot deals <b>10%</b> additional damage."
    }
};
$836d00f1820221ad$exports.getImport = (guid)=>{
    switch(guid){
        case "110e14c2d23805f4cbee7472b57b7cf4":
            return 0, (/*@__PURE__*/$parcel$interopDefault($d6cdd308983f2259$exports));
        case "c0da235e560fec9448a025b35e9e80bf":
            return 0, (/*@__PURE__*/$parcel$interopDefault($0493bc48520867c3$exports));
    }
};


var $e521d67bef8c1a45$exports = {};
var $16c5dbd9163143a1$exports = {};
$16c5dbd9163143a1$exports = new URL("paladin.f1958368.png", import.meta.url).toString();


var $bf521cab79734a79$exports = {};
$bf521cab79734a79$exports = new URL("Paladinskill_34.7feff019.png", import.meta.url).toString();


$e521d67bef8c1a45$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "17c14f584f7d29740952e55a51d6a1fe",
            "type": 3
        },
        "m_Name": "PlayerPaladin",
        "m_EditorClassIdentifier": null,
        "unitModel": {
            "fileID": 1343574854534011600,
            "guid": "f06c9874bdb4a2645988576db6dd4dd2",
            "type": 3
        },
        "heroClass": 7,
        "isHealer": 1,
        "isInternal": 0,
        "isBoss": 0,
        "level": 0,
        "attackSpeed": 1,
        "baseHP": 198,
        "baseGCDMultiplier": 0,
        "unitName": "Anthriel",
        "unitSpec": "Lightbringer",
        "icon": "e20bf3af84b72884a800b72e7c259fdd",
        "backgroundColor": {
            "r": 0.8962264,
            "g": 0.45149517,
            "b": 0.8414983,
            "a": 1
        },
        "textColor": {
            "r": 1,
            "g": 1,
            "b": 1,
            "a": 1
        },
        "typeIcon": {
            "fileID": 21300000,
            "guid": "9df8e2d193abdec44b5895cb67921ac0",
            "type": 3
        },
        "type": "HEALER",
        "description": "Anthriel, a revered Lightbringer in the Ring of Titans, epitomizes the embodiment of divine healing and support. With her mastery over Holy magic, she stands as a beacon of hope amidst the chaos of battle. While her prowess lies in delivering massive healing and bolstering her comrades, she lacks the means to inflict significant damage upon her adversaries. Yet, her unwavering dedication to her allies and her unparalleled ability to restore vitality ensure that her team remains resilient in the face of adversity. In the arena, Anthriel's presence is not just a force for survival but a testament to the power of compassion and divine intervention.",
        "hitboxScale": {
            "x": 1,
            "true": 1,
            "z": 1
        },
        "selectionCircleScale": {
            "x": 2,
            "true": 2,
            "z": 2
        },
        "mouseHitboxScale": {
            "x": 3,
            "true": 1,
            "z": 3
        },
        "hitAnimationType": 3,
        "dieAnimationType": 1,
        "animationSpeedMultiplier": 1,
        "supportsStopWalkAnimation": 1,
        "isLeftHandClosed": 1,
        "isRightHandClosed": 1,
        "dualWields": 0,
        "runAnimation": {
            "fileID": 8430362803238232000,
            "guid": "5aff1555fb420e048b4e05ffebab65fe",
            "type": 3
        },
        "sprintAnimation": {
            "fileID": 2019560895462781200,
            "guid": "584dcc3ec614bc34da99f5a3bb6d15fc",
            "type": 3
        },
        "idleAnimation": {
            "fileID": -5416651000045457000,
            "guid": "bce44f2ab64e1c847b2ade1020ec6a3b",
            "type": 3
        },
        "stopWalkAnimation": {
            "fileID": 1874791023308148200,
            "guid": "7daf9a049f61cc147b1a611182e8c924",
            "type": 3
        },
        "footstepSounds": [
            {
                "fileID": 8300000,
                "guid": "f6a0604181d205c48a1487b0a420b0e0",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "129dbdeb1611723489ad2445e4d62806",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "761b3b0bb7a210f45ab22851c8823fd5",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0207beb000d2a984aba8d8c18033978d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3331792b169924448bd774007767d02b",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a01ca2c05517c2440923677ccbcf13c4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a1932d9612ddc6c4b89c2f012dd59eb2",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "e307c1e688ce6fa4090baf3702ff14e3",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0b508f958dc2fc14dae01bc74f6c3896",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c75f01921060aea468faa65f382dfdf4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c7dfd018c818f2e479b45a715e1a2a6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "330aba8c48b34b64baa9d90ca470ea6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c891b25e37059b44eb224f93803a764a",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "f438ee57a0c246b41ba90434f9e37112",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3a735f9d10cd39f4292bec35fb227445",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "232d552e7c3364c41afe7c570ce7b088",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "586061caa5f6f294886fc39578ccd458",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "ed9abe2423737ba42940d0efff5508c9",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0107856a8ad9a31498651137a892e49d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "5ec4507ee2b342e48a3de0355249e568",
                "type": 3
            }
        ],
        "passiveIcon": "7b54730f0ef7d7c43aafbf4313f936cc",
        "passiveName": "Divine Perserverance",
        "passiveDescription": "Reduces the duration of <b>Incapacitates</b> on you by <b>12%</b>."
    }
};
$e521d67bef8c1a45$exports.getImport = (guid)=>{
    switch(guid){
        case "e20bf3af84b72884a800b72e7c259fdd":
            return 0, (/*@__PURE__*/$parcel$interopDefault($16c5dbd9163143a1$exports));
        case "7b54730f0ef7d7c43aafbf4313f936cc":
            return 0, (/*@__PURE__*/$parcel$interopDefault($bf521cab79734a79$exports));
    }
};


var $47503e4141f88be7$exports = {};
var $9e96db7afdfbaa7a$exports = {};
$9e96db7afdfbaa7a$exports = new URL("Priestskill_47.a8aeb0b7.png", import.meta.url).toString();


var $15fe584689ef248d$exports = {};
$15fe584689ef248d$exports = new URL("Priestskill_50.ae20b08b.png", import.meta.url).toString();


$47503e4141f88be7$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "17c14f584f7d29740952e55a51d6a1fe",
            "type": 3
        },
        "m_Name": "PlayerPriest",
        "m_EditorClassIdentifier": null,
        "unitModel": {
            "fileID": 2777422822122511000,
            "guid": "892a4c77ee3e92c4496f6884a387772d",
            "type": 3
        },
        "heroClass": 2,
        "isHealer": 1,
        "isInternal": 0,
        "isBoss": 0,
        "level": 0,
        "attackSpeed": 1,
        "baseHP": 164,
        "baseGCDMultiplier": 0,
        "unitName": "Kanna",
        "unitSpec": "Cleric",
        "icon": "e49abf2bcfe0d1a4381b6d5319affcf4",
        "backgroundColor": {
            "r": 0.8588235,
            "g": 0.8588235,
            "b": 0.854902,
            "a": 1
        },
        "textColor": {
            "r": 0.4,
            "g": 0.4,
            "b": 0.4,
            "a": 1
        },
        "typeIcon": {
            "fileID": 21300000,
            "guid": "9df8e2d193abdec44b5895cb67921ac0",
            "type": 3
        },
        "type": "HEALER",
        "description": "Kanna, a renowned Cleric in the Ring of Titans, commands the power of Holy magic to excel in combat. Specializing in absorption, she conjures impenetrable shields that deflect enemy attacks while bolstering her own strength. In the arena, Kanna is a beacon of balance, seamlessly transitioning between dealing damage to adversaries and providing vital support and healing to her allies. With her unwavering dedication and mastery of Holy magic, Kanna emerges as a formidable force, revered for her prowess and feared by her foes.",
        "hitboxScale": {
            "x": 1,
            "true": 1,
            "z": 1
        },
        "selectionCircleScale": {
            "x": 2,
            "true": 2,
            "z": 2
        },
        "mouseHitboxScale": {
            "x": 3,
            "true": 1,
            "z": 3
        },
        "hitAnimationType": 3,
        "dieAnimationType": 1,
        "animationSpeedMultiplier": 1,
        "supportsStopWalkAnimation": 1,
        "isLeftHandClosed": 0,
        "isRightHandClosed": 1,
        "dualWields": 0,
        "runAnimation": {
            "fileID": 8430362803238232000,
            "guid": "5aff1555fb420e048b4e05ffebab65fe",
            "type": 3
        },
        "sprintAnimation": {
            "fileID": 2019560895462781200,
            "guid": "584dcc3ec614bc34da99f5a3bb6d15fc",
            "type": 3
        },
        "idleAnimation": {
            "fileID": -5416651000045457000,
            "guid": "bce44f2ab64e1c847b2ade1020ec6a3b",
            "type": 3
        },
        "stopWalkAnimation": {
            "fileID": 1874791023308148200,
            "guid": "7daf9a049f61cc147b1a611182e8c924",
            "type": 3
        },
        "footstepSounds": [
            {
                "fileID": 8300000,
                "guid": "f6a0604181d205c48a1487b0a420b0e0",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "129dbdeb1611723489ad2445e4d62806",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "761b3b0bb7a210f45ab22851c8823fd5",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0207beb000d2a984aba8d8c18033978d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3331792b169924448bd774007767d02b",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a01ca2c05517c2440923677ccbcf13c4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a1932d9612ddc6c4b89c2f012dd59eb2",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "e307c1e688ce6fa4090baf3702ff14e3",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0b508f958dc2fc14dae01bc74f6c3896",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c75f01921060aea468faa65f382dfdf4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c7dfd018c818f2e479b45a715e1a2a6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "330aba8c48b34b64baa9d90ca470ea6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c891b25e37059b44eb224f93803a764a",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "f438ee57a0c246b41ba90434f9e37112",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3a735f9d10cd39f4292bec35fb227445",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "232d552e7c3364c41afe7c570ce7b088",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "586061caa5f6f294886fc39578ccd458",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "ed9abe2423737ba42940d0efff5508c9",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0107856a8ad9a31498651137a892e49d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "5ec4507ee2b342e48a3de0355249e568",
                "type": 3
            }
        ],
        "passiveIcon": "79acd8a805130f140b713a6f3e32257c",
        "passiveName": "Prayer of Faith",
        "passiveDescription": "Shield your target for <b>5%</b> of all healing you do. Does not stack with itself."
    }
};
$47503e4141f88be7$exports.getImport = (guid)=>{
    switch(guid){
        case "e49abf2bcfe0d1a4381b6d5319affcf4":
            return 0, (/*@__PURE__*/$parcel$interopDefault($9e96db7afdfbaa7a$exports));
        case "79acd8a805130f140b713a6f3e32257c":
            return 0, (/*@__PURE__*/$parcel$interopDefault($15fe584689ef248d$exports));
    }
};


var $f6876016ff799de6$exports = {};
var $bcfe3032ccfca944$exports = {};
$bcfe3032ccfca944$exports = new URL("rogue.28e06f56.png", import.meta.url).toString();


var $10c730a975b3a467$exports = {};
$10c730a975b3a467$exports = new URL("gcdreduce.e003012d.png", import.meta.url).toString();


$f6876016ff799de6$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "17c14f584f7d29740952e55a51d6a1fe",
            "type": 3
        },
        "m_Name": "PlayerRogue",
        "m_EditorClassIdentifier": null,
        "unitModel": {
            "fileID": 1737313431337791700,
            "guid": "523a1bb40963957419f0bf724105e1cd",
            "type": 3
        },
        "heroClass": 1,
        "isHealer": 0,
        "isInternal": 0,
        "isBoss": 0,
        "level": 0,
        "attackSpeed": 1,
        "baseHP": 184,
        "baseGCDMultiplier": -10,
        "unitName": "Volen",
        "unitSpec": "Assassin",
        "icon": "2bac70bcc3eeba8468ef80431e0bd35a",
        "backgroundColor": {
            "r": 0.9921569,
            "g": 0.7727113,
            "b": 0.1411765,
            "a": 1
        },
        "textColor": {
            "r": 0.4,
            "g": 0.4,
            "b": 0.4,
            "a": 1
        },
        "typeIcon": {
            "fileID": 21300000,
            "guid": "5480d4e62790e9049be1a6360fd9a498",
            "type": 3
        },
        "type": "DPS",
        "description": "Volen, a feared assassin renowned within the Ring of Titans, wields two deadly daggers with unparalleled finesse. His mastery extends beyond mere physical prowess; he exists in the space between reality and the shadow realm, granting him the ability to seamlessly traverse between the two realms. This unique talent enables him to stalk his prey with precision, biding his time until the opportune moment to strike arises. Employing a combination of swift strikes and shadowy maneuvers, Volen can control the battlefield, slowing his adversaries, stunning them with his swift agility, and ultimately incapacitating them with lethal precision. In the arena, he is a silent but deadly force to be reckoned with, his presence alone striking fear into the hearts of his foes.",
        "hitboxScale": {
            "x": 1,
            "true": 1,
            "z": 1
        },
        "selectionCircleScale": {
            "x": 2,
            "true": 2,
            "z": 2
        },
        "mouseHitboxScale": {
            "x": 3,
            "true": 1,
            "z": 3
        },
        "hitAnimationType": 3,
        "dieAnimationType": 1,
        "animationSpeedMultiplier": 1,
        "supportsStopWalkAnimation": 1,
        "isLeftHandClosed": 1,
        "isRightHandClosed": 1,
        "dualWields": 1,
        "runAnimation": {
            "fileID": 0
        },
        "sprintAnimation": {
            "fileID": 0
        },
        "idleAnimation": {
            "fileID": 0
        },
        "stopWalkAnimation": {
            "fileID": 0
        },
        "footstepSounds": [
            {
                "fileID": 8300000,
                "guid": "f6a0604181d205c48a1487b0a420b0e0",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "129dbdeb1611723489ad2445e4d62806",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "761b3b0bb7a210f45ab22851c8823fd5",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0207beb000d2a984aba8d8c18033978d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3331792b169924448bd774007767d02b",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a01ca2c05517c2440923677ccbcf13c4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a1932d9612ddc6c4b89c2f012dd59eb2",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "e307c1e688ce6fa4090baf3702ff14e3",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0b508f958dc2fc14dae01bc74f6c3896",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c75f01921060aea468faa65f382dfdf4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c7dfd018c818f2e479b45a715e1a2a6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "330aba8c48b34b64baa9d90ca470ea6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c891b25e37059b44eb224f93803a764a",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "f438ee57a0c246b41ba90434f9e37112",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3a735f9d10cd39f4292bec35fb227445",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "232d552e7c3364c41afe7c570ce7b088",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "586061caa5f6f294886fc39578ccd458",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "ed9abe2423737ba42940d0efff5508c9",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0107856a8ad9a31498651137a892e49d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "5ec4507ee2b342e48a3de0355249e568",
                "type": 3
            }
        ],
        "passiveIcon": "3dd0bfdaf4779d540a2a58efead63e14",
        "passiveName": "Gotta Go Fast",
        "passiveDescription": "The global cooldown is reduced by <b>10%</b>."
    }
};
$f6876016ff799de6$exports.getImport = (guid)=>{
    switch(guid){
        case "2bac70bcc3eeba8468ef80431e0bd35a":
            return 0, (/*@__PURE__*/$parcel$interopDefault($bcfe3032ccfca944$exports));
        case "3dd0bfdaf4779d540a2a58efead63e14":
            return 0, (/*@__PURE__*/$parcel$interopDefault($10c730a975b3a467$exports));
    }
};


var $5dc33d233767d87d$exports = {};
var $5274f50d3925e523$exports = {};
$5274f50d3925e523$exports = new URL("Paladinskill_02.d8cae53c.png", import.meta.url).toString();


var $676caa11503d43c3$exports = {};
$676caa11503d43c3$exports = new URL("divineempowerment.a2a14275.png", import.meta.url).toString();


$5dc33d233767d87d$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "17c14f584f7d29740952e55a51d6a1fe",
            "type": 3
        },
        "m_Name": "PlayerSmiterPaladin",
        "m_EditorClassIdentifier": null,
        "unitModel": {
            "fileID": 2181780924318426400,
            "guid": "60874159367d7634699066f188942bb7",
            "type": 3
        },
        "heroClass": 13,
        "isHealer": 0,
        "isInternal": 0,
        "isBoss": 0,
        "level": 0,
        "attackSpeed": 1,
        "baseHP": 214,
        "baseGCDMultiplier": 0,
        "unitName": "Anthriel",
        "unitSpec": "Smiter",
        "icon": "2af88f958103e1c4bbedf6f01bf60ee3",
        "backgroundColor": {
            "r": 0.18926665,
            "g": 0.46226418,
            "b": 0.22623509,
            "a": 1
        },
        "textColor": {
            "r": 1,
            "g": 1,
            "b": 1,
            "a": 1
        },
        "typeIcon": {
            "fileID": 21300000,
            "guid": "5480d4e62790e9049be1a6360fd9a498",
            "type": 3
        },
        "type": "DPS",
        "description": "Anthriel is a Smiter who wields a colossal hammer and holy magic to dominate her adversaries. Her combat prowess is unmatched, delivering devastating blows with swift precision. Not only can she deal tremendous damage swiftly, but she also serves as a beacon of hope for her allies, adeptly wielding her holy magic to heal wounds and provide support when needed. With her unwavering resolve and versatile abilities, Anthriel stands as a stalwart defender of justice in the arena, ready to vanquish any foe that dares to challenge her.",
        "hitboxScale": {
            "x": 1,
            "true": 1,
            "z": 1
        },
        "selectionCircleScale": {
            "x": 2,
            "true": 2,
            "z": 2
        },
        "mouseHitboxScale": {
            "x": 3,
            "true": 1,
            "z": 3
        },
        "hitAnimationType": 3,
        "dieAnimationType": 1,
        "animationSpeedMultiplier": 1,
        "supportsStopWalkAnimation": 1,
        "isLeftHandClosed": 0,
        "isRightHandClosed": 1,
        "dualWields": 0,
        "runAnimation": {
            "fileID": 7400000,
            "guid": "f561c8c659cf37149891228483ea1eb3",
            "type": 3
        },
        "sprintAnimation": {
            "fileID": 2019560895462781200,
            "guid": "584dcc3ec614bc34da99f5a3bb6d15fc",
            "type": 3
        },
        "idleAnimation": {
            "fileID": -5416651000045457000,
            "guid": "bce44f2ab64e1c847b2ade1020ec6a3b",
            "type": 3
        },
        "stopWalkAnimation": {
            "fileID": 0
        },
        "footstepSounds": [
            {
                "fileID": 8300000,
                "guid": "f6a0604181d205c48a1487b0a420b0e0",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "129dbdeb1611723489ad2445e4d62806",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "761b3b0bb7a210f45ab22851c8823fd5",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0207beb000d2a984aba8d8c18033978d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3331792b169924448bd774007767d02b",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a01ca2c05517c2440923677ccbcf13c4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a1932d9612ddc6c4b89c2f012dd59eb2",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "e307c1e688ce6fa4090baf3702ff14e3",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0b508f958dc2fc14dae01bc74f6c3896",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c75f01921060aea468faa65f382dfdf4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c7dfd018c818f2e479b45a715e1a2a6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "330aba8c48b34b64baa9d90ca470ea6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c891b25e37059b44eb224f93803a764a",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "f438ee57a0c246b41ba90434f9e37112",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3a735f9d10cd39f4292bec35fb227445",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "232d552e7c3364c41afe7c570ce7b088",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "586061caa5f6f294886fc39578ccd458",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "ed9abe2423737ba42940d0efff5508c9",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0107856a8ad9a31498651137a892e49d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "5ec4507ee2b342e48a3de0355249e568",
                "type": 3
            }
        ],
        "passiveIcon": "24fe1e4458bec764193ad1e355df4991",
        "passiveName": "Divine Empowerment",
        "passiveDescription": "Upon dealing damage, gain a stack of <b>Divine Empowerment</b>. Consume it to heal <b>2</b> extra per stack, or gain <b>6%</b> movespeed per stack when casting <b>Righteous Privelege</b> on yourself."
    }
};
$5dc33d233767d87d$exports.getImport = (guid)=>{
    switch(guid){
        case "2af88f958103e1c4bbedf6f01bf60ee3":
            return 0, (/*@__PURE__*/$parcel$interopDefault($5274f50d3925e523$exports));
        case "24fe1e4458bec764193ad1e355df4991":
            return 0, (/*@__PURE__*/$parcel$interopDefault($676caa11503d43c3$exports));
    }
};


var $fec124af39a31446$exports = {};


$fec124af39a31446$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "17c14f584f7d29740952e55a51d6a1fe",
            "type": 3
        },
        "m_Name": "PlayerTutorialPriest",
        "m_EditorClassIdentifier": null,
        "unitModel": {
            "fileID": 2777422822122511000,
            "guid": "892a4c77ee3e92c4496f6884a387772d",
            "type": 3
        },
        "heroClass": 17,
        "isHealer": 1,
        "isInternal": 1,
        "isBoss": 0,
        "level": 0,
        "attackSpeed": 1,
        "baseHP": 75,
        "baseGCDMultiplier": 0,
        "unitName": "Kanna",
        "unitSpec": "Cleric",
        "icon": "e49abf2bcfe0d1a4381b6d5319affcf4",
        "backgroundColor": {
            "r": 0.8588235,
            "g": 0.8588235,
            "b": 0.854902,
            "a": 1
        },
        "textColor": {
            "r": 0.4,
            "g": 0.4,
            "b": 0.4,
            "a": 1
        },
        "typeIcon": {
            "fileID": 21300000,
            "guid": "423717ccb76a74e489e5d288c5af5780",
            "type": 3
        },
        "type": "HEALER",
        "description": "Kanna, a renowned Cleric in the Ring of Titans, commands the power of Holy magic to excel in combat. Specializing in absorption, she conjures impenetrable shields that deflect enemy attacks while bolstering her own strength. In the arena, Kanna is a beacon of balance, seamlessly transitioning between dealing damage to adversaries and providing vital support and healing to her allies. With her unwavering dedication and mastery of Holy magic, Kanna emerges as a formidable force, revered for her prowess and feared by her foes.",
        "hitboxScale": {
            "x": 1,
            "true": 1,
            "z": 1
        },
        "selectionCircleScale": {
            "x": 2,
            "true": 2,
            "z": 2
        },
        "mouseHitboxScale": {
            "x": 3,
            "true": 1,
            "z": 3
        },
        "hitAnimationType": 3,
        "dieAnimationType": 1,
        "animationSpeedMultiplier": 1,
        "supportsStopWalkAnimation": 1,
        "isLeftHandClosed": 0,
        "isRightHandClosed": 1,
        "dualWields": 0,
        "runAnimation": {
            "fileID": 8430362803238232000,
            "guid": "5aff1555fb420e048b4e05ffebab65fe",
            "type": 3
        },
        "sprintAnimation": {
            "fileID": 2019560895462781200,
            "guid": "584dcc3ec614bc34da99f5a3bb6d15fc",
            "type": 3
        },
        "idleAnimation": {
            "fileID": -5416651000045457000,
            "guid": "bce44f2ab64e1c847b2ade1020ec6a3b",
            "type": 3
        },
        "stopWalkAnimation": {
            "fileID": 1874791023308148200,
            "guid": "7daf9a049f61cc147b1a611182e8c924",
            "type": 3
        },
        "footstepSounds": [
            {
                "fileID": 8300000,
                "guid": "f6a0604181d205c48a1487b0a420b0e0",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "129dbdeb1611723489ad2445e4d62806",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "761b3b0bb7a210f45ab22851c8823fd5",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0207beb000d2a984aba8d8c18033978d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3331792b169924448bd774007767d02b",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a01ca2c05517c2440923677ccbcf13c4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a1932d9612ddc6c4b89c2f012dd59eb2",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "e307c1e688ce6fa4090baf3702ff14e3",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0b508f958dc2fc14dae01bc74f6c3896",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c75f01921060aea468faa65f382dfdf4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c7dfd018c818f2e479b45a715e1a2a6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "330aba8c48b34b64baa9d90ca470ea6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c891b25e37059b44eb224f93803a764a",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "f438ee57a0c246b41ba90434f9e37112",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3a735f9d10cd39f4292bec35fb227445",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "232d552e7c3364c41afe7c570ce7b088",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "586061caa5f6f294886fc39578ccd458",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "ed9abe2423737ba42940d0efff5508c9",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0107856a8ad9a31498651137a892e49d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "5ec4507ee2b342e48a3de0355249e568",
                "type": 3
            }
        ],
        "passiveIcon": "79acd8a805130f140b713a6f3e32257c",
        "passiveName": "Prayer of Faith",
        "passiveDescription": "Shield your target for <b>5%</b> of all healing you do. Does not stack with itself."
    }
};
$fec124af39a31446$exports.getImport = (guid)=>{
    switch(guid){
        case "e49abf2bcfe0d1a4381b6d5319affcf4":
            return 0, (/*@__PURE__*/$parcel$interopDefault($9e96db7afdfbaa7a$exports));
        case "79acd8a805130f140b713a6f3e32257c":
            return 0, (/*@__PURE__*/$parcel$interopDefault($15fe584689ef248d$exports));
    }
};


var $7eacad6c68c1cb0d$exports = {};
var $ad7ad24329f5af0d$exports = {};
$ad7ad24329f5af0d$exports = new URL("warrior.07dfac48.png", import.meta.url).toString();


var $410430edea9bda1f$exports = {};
$410430edea9bda1f$exports = new URL("shatteredarmor.6aaf0da9.png", import.meta.url).toString();


$7eacad6c68c1cb0d$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "17c14f584f7d29740952e55a51d6a1fe",
            "type": 3
        },
        "m_Name": "PlayerTutorialWarrior",
        "m_EditorClassIdentifier": null,
        "unitModel": {
            "fileID": 2853453332119588000,
            "guid": "f552254a024425747a17e5058dce1260",
            "type": 3
        },
        "heroClass": 16,
        "isHealer": 0,
        "isInternal": 1,
        "isBoss": 0,
        "level": 0,
        "attackSpeed": 1,
        "baseHP": 208,
        "baseGCDMultiplier": 0,
        "unitName": "Tarcza",
        "unitSpec": "Fighter",
        "icon": "020cc09f56b4c9341b4f380652c83f4b",
        "backgroundColor": {
            "r": 0.6588235,
            "g": 0.4705882,
            "b": 0.2431373,
            "a": 1
        },
        "textColor": {
            "r": 1,
            "g": 1,
            "b": 1,
            "a": 1
        },
        "typeIcon": {
            "fileID": 21300000,
            "guid": "95cbed828bf835049b3345c4a977845e",
            "type": 3
        },
        "type": "BRUISER",
        "description": "Tarcza, is a seasoned Fighter renowned for his mastery with both sword and shield. His combat style is characterized by relentless offense combined with strategic defense. Specializing in inflicting consistent, high damage to adversaries, Tarcza excels at nullifying his opponents' abilities to cast spells or maneuver effectively. However, his own weakness lies in susceptibility to control tactics employed by his foes. Despite this vulnerability, Tarcza's unwavering determination and precise combat techniques make him a force to be reckoned with in the arena, where he dominates with his offensive and tactical prowess.",
        "hitboxScale": {
            "x": 1,
            "true": 1,
            "z": 1
        },
        "selectionCircleScale": {
            "x": 2,
            "true": 2,
            "z": 2
        },
        "mouseHitboxScale": {
            "x": 3,
            "true": 1,
            "z": 3
        },
        "hitAnimationType": 3,
        "dieAnimationType": 1,
        "animationSpeedMultiplier": 1,
        "supportsStopWalkAnimation": 1,
        "isLeftHandClosed": 1,
        "isRightHandClosed": 1,
        "dualWields": 0,
        "runAnimation": {
            "fileID": 0
        },
        "sprintAnimation": {
            "fileID": 0
        },
        "idleAnimation": {
            "fileID": 0
        },
        "stopWalkAnimation": {
            "fileID": 0
        },
        "footstepSounds": [
            {
                "fileID": 8300000,
                "guid": "f6a0604181d205c48a1487b0a420b0e0",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "129dbdeb1611723489ad2445e4d62806",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "761b3b0bb7a210f45ab22851c8823fd5",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0207beb000d2a984aba8d8c18033978d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3331792b169924448bd774007767d02b",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a01ca2c05517c2440923677ccbcf13c4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a1932d9612ddc6c4b89c2f012dd59eb2",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "e307c1e688ce6fa4090baf3702ff14e3",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0b508f958dc2fc14dae01bc74f6c3896",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c75f01921060aea468faa65f382dfdf4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c7dfd018c818f2e479b45a715e1a2a6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "330aba8c48b34b64baa9d90ca470ea6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c891b25e37059b44eb224f93803a764a",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "f438ee57a0c246b41ba90434f9e37112",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3a735f9d10cd39f4292bec35fb227445",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "232d552e7c3364c41afe7c570ce7b088",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "586061caa5f6f294886fc39578ccd458",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "ed9abe2423737ba42940d0efff5508c9",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0107856a8ad9a31498651137a892e49d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "5ec4507ee2b342e48a3de0355249e568",
                "type": 3
            }
        ],
        "passiveIcon": "cbe9b237356d9e848800b25063f1c444",
        "passiveName": "Shattered Armor",
        "passiveDescription": "Every time you cast a damaging spell on your opponent, add a stack of <b>Shattered Armor</b>, increasing the physical damage they take by <b>1%</b> per stack. Stacks up to <b>5</b> times."
    }
};
$7eacad6c68c1cb0d$exports.getImport = (guid)=>{
    switch(guid){
        case "020cc09f56b4c9341b4f380652c83f4b":
            return 0, (/*@__PURE__*/$parcel$interopDefault($ad7ad24329f5af0d$exports));
        case "cbe9b237356d9e848800b25063f1c444":
            return 0, (/*@__PURE__*/$parcel$interopDefault($410430edea9bda1f$exports));
    }
};


var $d642e3e90398477c$exports = {};
var $075818b7101c3db8$exports = {};
$075818b7101c3db8$exports = new URL("Warlock_07.dbd20466.png", import.meta.url).toString();


var $46be0bbf84b98063$exports = {};
$46be0bbf84b98063$exports = new URL("Warlock_49.cc32748c.png", import.meta.url).toString();


$d642e3e90398477c$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "17c14f584f7d29740952e55a51d6a1fe",
            "type": 3
        },
        "m_Name": "PlayerWarlock",
        "m_EditorClassIdentifier": null,
        "unitModel": {
            "fileID": 5925594905447184000,
            "guid": "a195385654101404d995fcab48ff43e4",
            "type": 3
        },
        "heroClass": 4,
        "isHealer": 0,
        "isInternal": 0,
        "isBoss": 0,
        "level": 0,
        "attackSpeed": 1,
        "baseHP": 172,
        "baseGCDMultiplier": 0,
        "unitName": "Malrah",
        "unitSpec": "Plaguebringer",
        "icon": "2f5f12c1e28063045b07f1b6a009ec08",
        "backgroundColor": {
            "r": 0.4606976,
            "g": 0.1965112,
            "b": 0.6037736,
            "a": 1
        },
        "textColor": {
            "r": 1,
            "g": 1,
            "b": 1,
            "a": 1
        },
        "typeIcon": {
            "fileID": 21300000,
            "guid": "5480d4e62790e9049be1a6360fd9a498",
            "type": 3
        },
        "type": "DPS",
        "description": "Malrah, the enigmatic Plaguebringer, casts her shadowy presence across the Ring of Titans, wielding dark magic with deadly precision. Specializing in mass devastation, she unleashes torrents of shadow energy to inflict damage upon multiple adversaries simultaneously, leaving chaos in her wake. Her mastery over the arcane arts extends to the macabre ability to siphon the life force from her foes, granting her vitality as she drains theirs. With each eerie whisper and flicker of her cloak, Malrah commands fear and respect, a formidable force in the arena of combat.",
        "hitboxScale": {
            "x": 1,
            "true": 1,
            "z": 1
        },
        "selectionCircleScale": {
            "x": 2,
            "true": 2,
            "z": 2
        },
        "mouseHitboxScale": {
            "x": 3,
            "true": 1,
            "z": 3
        },
        "hitAnimationType": 3,
        "dieAnimationType": 1,
        "animationSpeedMultiplier": 1,
        "supportsStopWalkAnimation": 1,
        "isLeftHandClosed": 0,
        "isRightHandClosed": 1,
        "dualWields": 0,
        "runAnimation": {
            "fileID": 8430362803238232000,
            "guid": "5aff1555fb420e048b4e05ffebab65fe",
            "type": 3
        },
        "sprintAnimation": {
            "fileID": 2019560895462781200,
            "guid": "584dcc3ec614bc34da99f5a3bb6d15fc",
            "type": 3
        },
        "idleAnimation": {
            "fileID": -5416651000045457000,
            "guid": "bce44f2ab64e1c847b2ade1020ec6a3b",
            "type": 3
        },
        "stopWalkAnimation": {
            "fileID": 1874791023308148200,
            "guid": "7daf9a049f61cc147b1a611182e8c924",
            "type": 3
        },
        "footstepSounds": [
            {
                "fileID": 8300000,
                "guid": "f6a0604181d205c48a1487b0a420b0e0",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "129dbdeb1611723489ad2445e4d62806",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "761b3b0bb7a210f45ab22851c8823fd5",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0207beb000d2a984aba8d8c18033978d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3331792b169924448bd774007767d02b",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a01ca2c05517c2440923677ccbcf13c4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a1932d9612ddc6c4b89c2f012dd59eb2",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "e307c1e688ce6fa4090baf3702ff14e3",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0b508f958dc2fc14dae01bc74f6c3896",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c75f01921060aea468faa65f382dfdf4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c7dfd018c818f2e479b45a715e1a2a6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "330aba8c48b34b64baa9d90ca470ea6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c891b25e37059b44eb224f93803a764a",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "f438ee57a0c246b41ba90434f9e37112",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3a735f9d10cd39f4292bec35fb227445",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "232d552e7c3364c41afe7c570ce7b088",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "586061caa5f6f294886fc39578ccd458",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "ed9abe2423737ba42940d0efff5508c9",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0107856a8ad9a31498651137a892e49d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "5ec4507ee2b342e48a3de0355249e568",
                "type": 3
            }
        ],
        "passiveIcon": "dce10b7b34f9f514288288c28ca7ee3a",
        "passiveName": "Soul Essence",
        "passiveDescription": "Every time you use a targeted damaging ability, collect a <b>Soul Essence</b>, reducing the physical damage you take by <b>2%</b>. Stacks up to <b>5</b> times."
    }
};
$d642e3e90398477c$exports.getImport = (guid)=>{
    switch(guid){
        case "2f5f12c1e28063045b07f1b6a009ec08":
            return 0, (/*@__PURE__*/$parcel$interopDefault($075818b7101c3db8$exports));
        case "dce10b7b34f9f514288288c28ca7ee3a":
            return 0, (/*@__PURE__*/$parcel$interopDefault($46be0bbf84b98063$exports));
    }
};


var $28cfd132ba043728$exports = {};


$28cfd132ba043728$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "17c14f584f7d29740952e55a51d6a1fe",
            "type": 3
        },
        "m_Name": "PlayerWarrior",
        "m_EditorClassIdentifier": null,
        "unitModel": {
            "fileID": 2853453332119588000,
            "guid": "f552254a024425747a17e5058dce1260",
            "type": 3
        },
        "heroClass": 3,
        "isHealer": 0,
        "isInternal": 0,
        "isBoss": 0,
        "level": 0,
        "attackSpeed": 1,
        "baseHP": 224,
        "baseGCDMultiplier": 0,
        "unitName": "Tarcza",
        "unitSpec": "Fighter",
        "icon": "020cc09f56b4c9341b4f380652c83f4b",
        "backgroundColor": {
            "r": 0.6588235,
            "g": 0.4705882,
            "b": 0.2431373,
            "a": 1
        },
        "textColor": {
            "r": 1,
            "g": 1,
            "b": 1,
            "a": 1
        },
        "typeIcon": {
            "fileID": 21300000,
            "guid": "5480d4e62790e9049be1a6360fd9a498",
            "type": 3
        },
        "type": "DPS",
        "description": "Tarcza, is a seasoned Fighter renowned for his mastery with both sword and shield. His combat style is characterized by relentless offense combined with strategic defense. Specializing in inflicting consistent, high damage to adversaries, Tarcza excels at nullifying his opponents' abilities to cast spells or maneuver effectively. However, his own weakness lies in susceptibility to control tactics employed by his foes. Despite this vulnerability, Tarcza's unwavering determination and precise combat techniques make him a force to be reckoned with in the arena, where he dominates with his offensive and tactical prowess.",
        "hitboxScale": {
            "x": 1,
            "true": 1,
            "z": 1
        },
        "selectionCircleScale": {
            "x": 2,
            "true": 2,
            "z": 2
        },
        "mouseHitboxScale": {
            "x": 3,
            "true": 1,
            "z": 3
        },
        "hitAnimationType": 3,
        "dieAnimationType": 1,
        "animationSpeedMultiplier": 1,
        "supportsStopWalkAnimation": 1,
        "isLeftHandClosed": 1,
        "isRightHandClosed": 1,
        "dualWields": 0,
        "runAnimation": {
            "fileID": 0
        },
        "sprintAnimation": {
            "fileID": 0
        },
        "idleAnimation": {
            "fileID": 0
        },
        "stopWalkAnimation": {
            "fileID": 0
        },
        "footstepSounds": [
            {
                "fileID": 8300000,
                "guid": "f6a0604181d205c48a1487b0a420b0e0",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "129dbdeb1611723489ad2445e4d62806",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "761b3b0bb7a210f45ab22851c8823fd5",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0207beb000d2a984aba8d8c18033978d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3331792b169924448bd774007767d02b",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a01ca2c05517c2440923677ccbcf13c4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a1932d9612ddc6c4b89c2f012dd59eb2",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "e307c1e688ce6fa4090baf3702ff14e3",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0b508f958dc2fc14dae01bc74f6c3896",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c75f01921060aea468faa65f382dfdf4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c7dfd018c818f2e479b45a715e1a2a6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "330aba8c48b34b64baa9d90ca470ea6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c891b25e37059b44eb224f93803a764a",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "f438ee57a0c246b41ba90434f9e37112",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3a735f9d10cd39f4292bec35fb227445",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "232d552e7c3364c41afe7c570ce7b088",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "586061caa5f6f294886fc39578ccd458",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "ed9abe2423737ba42940d0efff5508c9",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0107856a8ad9a31498651137a892e49d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "5ec4507ee2b342e48a3de0355249e568",
                "type": 3
            }
        ],
        "passiveIcon": "cbe9b237356d9e848800b25063f1c444",
        "passiveName": "Shattered Armor",
        "passiveDescription": "Every time you cast a damaging spell on your opponent, add a stack of <b>Shattered Armor</b>, increasing the physical damage they take by <b>0.4%</b> per stack. Stacks up to <b>10</b> times."
    }
};
$28cfd132ba043728$exports.getImport = (guid)=>{
    switch(guid){
        case "020cc09f56b4c9341b4f380652c83f4b":
            return 0, (/*@__PURE__*/$parcel$interopDefault($ad7ad24329f5af0d$exports));
        case "cbe9b237356d9e848800b25063f1c444":
            return 0, (/*@__PURE__*/$parcel$interopDefault($410430edea9bda1f$exports));
    }
};


var $68dd5c6abcfc4238$exports = {};
$68dd5c6abcfc4238$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "17c14f584f7d29740952e55a51d6a1fe",
            "type": 3
        },
        "m_Name": "PracticeDummy",
        "m_EditorClassIdentifier": null,
        "unitModel": {
            "fileID": 3241138547371686400,
            "guid": "66f695610850be44c807d6bc9a95c019",
            "type": 3
        },
        "heroClass": 23,
        "isHealer": 0,
        "isInternal": 1,
        "isBoss": 0,
        "level": 0,
        "attackSpeed": 1,
        "baseHP": 2000,
        "baseGCDMultiplier": 0,
        "unitName": "Target Practice",
        "unitSpec": null,
        "icon": {
            "fileID": 2800000,
            "guid": "1820afab5df9a4549a9f9f97d0b4f28c",
            "type": 3
        },
        "backgroundColor": {
            "r": 0.8588235,
            "g": 0.8588235,
            "b": 0.854902,
            "a": 1
        },
        "textColor": {
            "r": 0.4,
            "g": 0.4,
            "b": 0.4,
            "a": 1
        },
        "typeIcon": {
            "fileID": 21300000,
            "guid": "423717ccb76a74e489e5d288c5af5780",
            "type": 3
        },
        "type": "HEALER",
        "description": null,
        "hitboxScale": {
            "x": 1,
            "true": 1,
            "z": 1
        },
        "selectionCircleScale": {
            "x": 2,
            "true": 2,
            "z": 2
        },
        "mouseHitboxScale": {
            "x": 3,
            "true": 1,
            "z": 3
        },
        "hitAnimationType": 13,
        "dieAnimationType": 1,
        "animationSpeedMultiplier": 1,
        "supportsStopWalkAnimation": 0,
        "isLeftHandClosed": 0,
        "isRightHandClosed": 0,
        "dualWields": 0,
        "runAnimation": {
            "fileID": 7400000,
            "guid": "c9ed3c390c9e59a4fb671074d5a7b713",
            "type": 3
        },
        "sprintAnimation": {
            "fileID": 7400000,
            "guid": "c9ed3c390c9e59a4fb671074d5a7b713",
            "type": 3
        },
        "idleAnimation": {
            "fileID": 7400000,
            "guid": "8ac07673d14b4cf48997a4d9e236c55a",
            "type": 3
        },
        "stopWalkAnimation": {
            "fileID": 0
        },
        "footstepSounds": [],
        "passiveIcon": {
            "fileID": 21300000,
            "guid": "d3857588363cc674ea1157723c39247f",
            "type": 3
        },
        "passiveName": null,
        "passiveDescription": null
    }
};
$68dd5c6abcfc4238$exports.getImport = (guid)=>{
    guid;
};


var $f995ed836be5b5b5$exports = {};
var $747bf2895fc79134$exports = {};
$747bf2895fc79134$exports = new URL("damagebuff.0d0c9c55.png", import.meta.url).toString();


$f995ed836be5b5b5$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "17c14f584f7d29740952e55a51d6a1fe",
            "type": 3
        },
        "m_Name": "SpecialPowerupOrbDamage",
        "m_EditorClassIdentifier": null,
        "unitModel": {
            "fileID": 9171098766967479000,
            "guid": "750d3a611ebef8b4e8e930c9cb49b047",
            "type": 3
        },
        "heroClass": 18,
        "isHealer": 0,
        "isInternal": 1,
        "isBoss": 0,
        "level": 0,
        "attackSpeed": 1,
        "baseHP": 75,
        "baseGCDMultiplier": 0,
        "unitName": "Powerup Orb",
        "unitSpec": "Damage Bonus",
        "icon": "63ea9479831daaa439dbf33eb6ba4933",
        "backgroundColor": {
            "r": 0.8588235,
            "g": 0.8588235,
            "b": 0.854902,
            "a": 1
        },
        "textColor": {
            "r": 0.4,
            "g": 0.4,
            "b": 0.4,
            "a": 1
        },
        "typeIcon": {
            "fileID": 21300000,
            "guid": "423717ccb76a74e489e5d288c5af5780",
            "type": 3
        },
        "type": "HEALER",
        "description": null,
        "hitboxScale": {
            "x": 1,
            "true": 1,
            "z": 1
        },
        "selectionCircleScale": {
            "x": 2,
            "true": 2,
            "z": 2
        },
        "mouseHitboxScale": {
            "x": 3,
            "true": 1,
            "z": 3
        },
        "hitAnimationType": 3,
        "dieAnimationType": 1,
        "animationSpeedMultiplier": 1,
        "supportsStopWalkAnimation": 1,
        "isLeftHandClosed": 0,
        "isRightHandClosed": 0,
        "dualWields": 0,
        "runAnimation": {
            "fileID": 0
        },
        "sprintAnimation": {
            "fileID": 0
        },
        "idleAnimation": {
            "fileID": 0
        },
        "stopWalkAnimation": {
            "fileID": 0
        },
        "footstepSounds": [
            {
                "fileID": 8300000,
                "guid": "f6a0604181d205c48a1487b0a420b0e0",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "129dbdeb1611723489ad2445e4d62806",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "761b3b0bb7a210f45ab22851c8823fd5",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0207beb000d2a984aba8d8c18033978d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3331792b169924448bd774007767d02b",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a01ca2c05517c2440923677ccbcf13c4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a1932d9612ddc6c4b89c2f012dd59eb2",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "e307c1e688ce6fa4090baf3702ff14e3",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0b508f958dc2fc14dae01bc74f6c3896",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c75f01921060aea468faa65f382dfdf4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c7dfd018c818f2e479b45a715e1a2a6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "330aba8c48b34b64baa9d90ca470ea6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c891b25e37059b44eb224f93803a764a",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "f438ee57a0c246b41ba90434f9e37112",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3a735f9d10cd39f4292bec35fb227445",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "232d552e7c3364c41afe7c570ce7b088",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "586061caa5f6f294886fc39578ccd458",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "ed9abe2423737ba42940d0efff5508c9",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0107856a8ad9a31498651137a892e49d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "5ec4507ee2b342e48a3de0355249e568",
                "type": 3
            }
        ],
        "passiveIcon": {
            "fileID": 21300000,
            "guid": "d3857588363cc674ea1157723c39247f",
            "type": 3
        },
        "passiveName": null,
        "passiveDescription": null
    }
};
$f995ed836be5b5b5$exports.getImport = (guid)=>{
    switch(guid){
        case "63ea9479831daaa439dbf33eb6ba4933":
            return 0, (/*@__PURE__*/$parcel$interopDefault($747bf2895fc79134$exports));
    }
};


var $a8898f289410122c$exports = {};
var $3f2d16b39730f949$exports = {};
$3f2d16b39730f949$exports = new URL("damagereductionbuff.d46757d8.png", import.meta.url).toString();


$a8898f289410122c$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "17c14f584f7d29740952e55a51d6a1fe",
            "type": 3
        },
        "m_Name": "SpecialPowerupOrbDamageReduction",
        "m_EditorClassIdentifier": null,
        "unitModel": {
            "fileID": 7249044206385413000,
            "guid": "5226393926f731248872efd798814e9b",
            "type": 3
        },
        "heroClass": 19,
        "isHealer": 0,
        "isInternal": 1,
        "isBoss": 0,
        "level": 0,
        "attackSpeed": 1,
        "baseHP": 75,
        "baseGCDMultiplier": 0,
        "unitName": "Powerup Orb",
        "unitSpec": "Damage Reduction",
        "icon": "c115ac83a594b5840b95721326ebf5aa",
        "backgroundColor": {
            "r": 0.8588235,
            "g": 0.8588235,
            "b": 0.854902,
            "a": 1
        },
        "textColor": {
            "r": 0.4,
            "g": 0.4,
            "b": 0.4,
            "a": 1
        },
        "typeIcon": {
            "fileID": 21300000,
            "guid": "423717ccb76a74e489e5d288c5af5780",
            "type": 3
        },
        "type": "HEALER",
        "description": null,
        "hitboxScale": {
            "x": 1,
            "true": 1,
            "z": 1
        },
        "selectionCircleScale": {
            "x": 2,
            "true": 2,
            "z": 2
        },
        "mouseHitboxScale": {
            "x": 3,
            "true": 1,
            "z": 3
        },
        "hitAnimationType": 3,
        "dieAnimationType": 1,
        "animationSpeedMultiplier": 1,
        "supportsStopWalkAnimation": 1,
        "isLeftHandClosed": 0,
        "isRightHandClosed": 0,
        "dualWields": 0,
        "runAnimation": {
            "fileID": 0
        },
        "sprintAnimation": {
            "fileID": 0
        },
        "idleAnimation": {
            "fileID": 0
        },
        "stopWalkAnimation": {
            "fileID": 0
        },
        "footstepSounds": [
            {
                "fileID": 8300000,
                "guid": "f6a0604181d205c48a1487b0a420b0e0",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "129dbdeb1611723489ad2445e4d62806",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "761b3b0bb7a210f45ab22851c8823fd5",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0207beb000d2a984aba8d8c18033978d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3331792b169924448bd774007767d02b",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a01ca2c05517c2440923677ccbcf13c4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a1932d9612ddc6c4b89c2f012dd59eb2",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "e307c1e688ce6fa4090baf3702ff14e3",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0b508f958dc2fc14dae01bc74f6c3896",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c75f01921060aea468faa65f382dfdf4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c7dfd018c818f2e479b45a715e1a2a6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "330aba8c48b34b64baa9d90ca470ea6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c891b25e37059b44eb224f93803a764a",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "f438ee57a0c246b41ba90434f9e37112",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3a735f9d10cd39f4292bec35fb227445",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "232d552e7c3364c41afe7c570ce7b088",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "586061caa5f6f294886fc39578ccd458",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "ed9abe2423737ba42940d0efff5508c9",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0107856a8ad9a31498651137a892e49d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "5ec4507ee2b342e48a3de0355249e568",
                "type": 3
            }
        ],
        "passiveIcon": {
            "fileID": 21300000,
            "guid": "d3857588363cc674ea1157723c39247f",
            "type": 3
        },
        "passiveName": null,
        "passiveDescription": null
    }
};
$a8898f289410122c$exports.getImport = (guid)=>{
    switch(guid){
        case "c115ac83a594b5840b95721326ebf5aa":
            return 0, (/*@__PURE__*/$parcel$interopDefault($3f2d16b39730f949$exports));
    }
};


var $9ad764c1b3adcd43$exports = {};
var $7373aba449c2091e$exports = {};
$7373aba449c2091e$exports = new URL("healingreductionbuff.6932728d.png", import.meta.url).toString();


$9ad764c1b3adcd43$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "17c14f584f7d29740952e55a51d6a1fe",
            "type": 3
        },
        "m_Name": "SpecialPowerupOrbHealingReduction",
        "m_EditorClassIdentifier": null,
        "unitModel": {
            "fileID": 3737948953826524700,
            "guid": "615a8e7b4d8d0894289a2cac9f9e4460",
            "type": 3
        },
        "heroClass": 20,
        "isHealer": 0,
        "isInternal": 1,
        "isBoss": 0,
        "level": 0,
        "attackSpeed": 1,
        "baseHP": 75,
        "baseGCDMultiplier": 0,
        "unitName": "Powerup Orb",
        "unitSpec": "Healing Reduction",
        "icon": "a955b06f5a0d13c48a78d6531eded5ac",
        "backgroundColor": {
            "r": 0.8588235,
            "g": 0.8588235,
            "b": 0.854902,
            "a": 1
        },
        "textColor": {
            "r": 0.4,
            "g": 0.4,
            "b": 0.4,
            "a": 1
        },
        "typeIcon": {
            "fileID": 21300000,
            "guid": "423717ccb76a74e489e5d288c5af5780",
            "type": 3
        },
        "type": "HEALER",
        "description": null,
        "hitboxScale": {
            "x": 1,
            "true": 1,
            "z": 1
        },
        "selectionCircleScale": {
            "x": 2,
            "true": 2,
            "z": 2
        },
        "mouseHitboxScale": {
            "x": 3,
            "true": 1,
            "z": 3
        },
        "hitAnimationType": 3,
        "dieAnimationType": 1,
        "animationSpeedMultiplier": 1,
        "supportsStopWalkAnimation": 1,
        "isLeftHandClosed": 0,
        "isRightHandClosed": 0,
        "dualWields": 0,
        "runAnimation": {
            "fileID": 0
        },
        "sprintAnimation": {
            "fileID": 0
        },
        "idleAnimation": {
            "fileID": 0
        },
        "stopWalkAnimation": {
            "fileID": 0
        },
        "footstepSounds": [
            {
                "fileID": 8300000,
                "guid": "f6a0604181d205c48a1487b0a420b0e0",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "129dbdeb1611723489ad2445e4d62806",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "761b3b0bb7a210f45ab22851c8823fd5",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0207beb000d2a984aba8d8c18033978d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3331792b169924448bd774007767d02b",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a01ca2c05517c2440923677ccbcf13c4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "a1932d9612ddc6c4b89c2f012dd59eb2",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "e307c1e688ce6fa4090baf3702ff14e3",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0b508f958dc2fc14dae01bc74f6c3896",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c75f01921060aea468faa65f382dfdf4",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c7dfd018c818f2e479b45a715e1a2a6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "330aba8c48b34b64baa9d90ca470ea6c",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "c891b25e37059b44eb224f93803a764a",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "f438ee57a0c246b41ba90434f9e37112",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "3a735f9d10cd39f4292bec35fb227445",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "232d552e7c3364c41afe7c570ce7b088",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "586061caa5f6f294886fc39578ccd458",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "ed9abe2423737ba42940d0efff5508c9",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "0107856a8ad9a31498651137a892e49d",
                "type": 3
            },
            {
                "fileID": 8300000,
                "guid": "5ec4507ee2b342e48a3de0355249e568",
                "type": 3
            }
        ],
        "passiveIcon": {
            "fileID": 21300000,
            "guid": "d3857588363cc674ea1157723c39247f",
            "type": 3
        },
        "passiveName": null,
        "passiveDescription": null
    }
};
$9ad764c1b3adcd43$exports.getImport = (guid)=>{
    switch(guid){
        case "a955b06f5a0d13c48a78d6531eded5ac":
            return 0, (/*@__PURE__*/$parcel$interopDefault($7373aba449c2091e$exports));
    }
};


var $e65e2c565ec0bff2$exports = {};
$e65e2c565ec0bff2$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "17c14f584f7d29740952e55a51d6a1fe",
            "type": 3
        },
        "m_Name": "TargetDummy",
        "m_EditorClassIdentifier": null,
        "unitModel": {
            "fileID": 3241138547371686400,
            "guid": "bd8b68430dbebba4eab6e9a152f7ee74",
            "type": 3
        },
        "heroClass": 22,
        "isHealer": 0,
        "isInternal": 1,
        "isBoss": 0,
        "level": 0,
        "attackSpeed": 1,
        "baseHP": 2000,
        "baseGCDMultiplier": 0,
        "unitName": "Target Practice",
        "unitSpec": null,
        "icon": {
            "fileID": 2800000,
            "guid": "1820afab5df9a4549a9f9f97d0b4f28c",
            "type": 3
        },
        "backgroundColor": {
            "r": 0.8588235,
            "g": 0.8588235,
            "b": 0.854902,
            "a": 1
        },
        "textColor": {
            "r": 0.4,
            "g": 0.4,
            "b": 0.4,
            "a": 1
        },
        "typeIcon": {
            "fileID": 21300000,
            "guid": "423717ccb76a74e489e5d288c5af5780",
            "type": 3
        },
        "type": "HEALER",
        "description": null,
        "hitboxScale": {
            "x": 1,
            "true": 1,
            "z": 1
        },
        "selectionCircleScale": {
            "x": 2,
            "true": 2,
            "z": 2
        },
        "mouseHitboxScale": {
            "x": 3,
            "true": 1,
            "z": 3
        },
        "hitAnimationType": 12,
        "dieAnimationType": 1,
        "animationSpeedMultiplier": 1,
        "supportsStopWalkAnimation": 0,
        "isLeftHandClosed": 0,
        "isRightHandClosed": 0,
        "dualWields": 0,
        "runAnimation": {
            "fileID": 7400000,
            "guid": "442b8f9fa7ae4c346a99bcea84fa834a",
            "type": 3
        },
        "sprintAnimation": {
            "fileID": 7400000,
            "guid": "442b8f9fa7ae4c346a99bcea84fa834a",
            "type": 3
        },
        "idleAnimation": {
            "fileID": 7400000,
            "guid": "61b16a550c901094096d212a14017d54",
            "type": 3
        },
        "stopWalkAnimation": {
            "fileID": 0
        },
        "footstepSounds": [],
        "passiveIcon": {
            "fileID": 21300000,
            "guid": "d3857588363cc674ea1157723c39247f",
            "type": 3
        },
        "passiveName": null,
        "passiveDescription": null
    }
};
$e65e2c565ec0bff2$exports.getImport = (guid)=>{
    guid;
};


$08e390bc033a1b28$exports = {
    "AddDragonBossFireOrb": $6b660904ff72bc40$exports,
    "BossBear": $08b23a00df2e1a52$exports,
    "BossDeathKnight": $25a6e9d2d7fe177c$exports,
    "BossDragon": $508a5f1810527103$exports,
    "BossGolem": $38381072d6f777e4$exports,
    "BossPoisonInsect": $9e7396c0a9a49e68$exports,
    "BossTroll": $9508b818235e28a5$exports,
    "PlayerBlademasterWarrior": $f4d4979756ee69af$exports,
    "PlayerBruiserRogue": $369b50bb787c477f$exports,
    "PlayerCorruptorDruid": $2c8d73f08547bb4d$exports,
    "PlayerCrystalMage": $5fb4c63ab8907e0b$exports,
    "PlayerDarkPriest": $8bb3362da6ea79e1$exports,
    "PlayerDruid": $8776c17491df8072$exports,
    "PlayerEradicatorWarlock": $806ab136a3cf8e1f$exports,
    "PlayerHunter": $42ecc19aca70d114$exports,
    "PlayerMage": $c5e2b7ba9c9bc857$exports,
    "PlayerMarksmanHunter": $836d00f1820221ad$exports,
    "PlayerPaladin": $e521d67bef8c1a45$exports,
    "PlayerPriest": $47503e4141f88be7$exports,
    "PlayerRogue": $f6876016ff799de6$exports,
    "PlayerSmiterPaladin": $5dc33d233767d87d$exports,
    "PlayerTutorialPriest": $fec124af39a31446$exports,
    "PlayerTutorialWarrior": $7eacad6c68c1cb0d$exports,
    "PlayerWarlock": $d642e3e90398477c$exports,
    "PlayerWarrior": $28cfd132ba043728$exports,
    "PracticeDummy": $68dd5c6abcfc4238$exports,
    "SpecialPowerupOrbDamage": $f995ed836be5b5b5$exports,
    "SpecialPowerupOrbDamageReduction": $a8898f289410122c$exports,
    "SpecialPowerupOrbHealingReduction": $9ad764c1b3adcd43$exports,
    "TargetDummy": $e65e2c565ec0bff2$exports
};


var $9e6fa7d34afa6e59$exports = {};
var $968082b0f8413fa8$exports = {};
$968082b0f8413fa8$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "TemplateSpellData",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "castAuraPrefab": {
            "fileID": 0
        },
        "castSound": {
            "fileID": 0
        },
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "castDelay": 0,
        "animationSpeed": 1,
        "animationDuration": 1,
        "enableWeaponGlow": 0,
        "skipCooldownOnChannel": 0
    }
};
$968082b0f8413fa8$exports.getImport = (guid)=>{
    guid;
};


var $d5e5e083b329ca66$exports = {};
var $e684b8e7760beba8$exports = {};
$e684b8e7760beba8$exports = new URL("blindinglight.3d35e55a.png", import.meta.url).toString();


$d5e5e083b329ca66$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "BlindingLight",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "73c526bbb006fde49a6978e33b9c6786",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 42,
        "castDelay": 350,
        "animationSpeed": 2,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Blinding Light",
        "description": "<b>Stun</b> the target for <b>5</b> seconds.",
        "icon": "52fc3138cb30a83499e0c8f30f14ebf1",
        "usableBy": "070000000d000000",
        "cooldown": 30,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$d5e5e083b329ca66$exports.getImport = (guid)=>{
    switch(guid){
        case "52fc3138cb30a83499e0c8f30f14ebf1":
            return 0, (/*@__PURE__*/$parcel$interopDefault($e684b8e7760beba8$exports));
    }
};


var $65946b28f8902388$exports = {};
var $262124302d798a02$exports = {};
$262124302d798a02$exports = new URL("corporealprotection.3c4481cb.png", import.meta.url).toString();


$65946b28f8902388$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "CorporealProtection",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 110620,
            "guid": "dd18fef4bb6bc05418e566f124f04d44",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 27,
        "castDelay": 180,
        "animationSpeed": 1.8,
        "animationDuration": 0.8,
        "skipCooldownOnChannel": 0,
        "spellName": "Corporeal Protection",
        "description": "Remove all <b>Stuns</b> and <b>Incapacitates</b> from the target. In addition, the target cannot be stunned and takes 100% reduced physical damage, but deals 100% reduced physical damage and 65% reduced magic damage for 8 seconds. The target is considered Honored for 28 seconds after use. Cannot be used while the target is Honored.",
        "icon": "4d41bfb472e7f834e9c5517cf9ac0f22",
        "usableBy": null,
        "cooldown": 60,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "027489edcf0967b4c9cd9e38e44be6cf",
            "type": 2
        }
    }
};
$65946b28f8902388$exports.getImport = (guid)=>{
    switch(guid){
        case "4d41bfb472e7f834e9c5517cf9ac0f22":
            return 0, (/*@__PURE__*/$parcel$interopDefault($262124302d798a02$exports));
    }
};


var $ad1ca1849c79e9f1$exports = {};
var $ad01da37dbf4b5e1$exports = {};
$ad01da37dbf4b5e1$exports = new URL("divinecalling.a4664fe2.png", import.meta.url).toString();


$ad1ca1849c79e9f1$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "DivineCalling",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "73c526bbb006fde49a6978e33b9c6786",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 0,
        "castDelay": 180,
        "animationSpeed": 1.5,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Divine Calling",
        "description": "Increase all damage and healing done by <b>20%</b> for <b>18</b> seconds. You are considered <b>Honored</b> for an additional <b>24</b> seconds.",
        "icon": "d84e75cd4db4d154b86ff0c7e479b47a",
        "usableBy": null,
        "cooldown": 60,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$ad1ca1849c79e9f1$exports.getImport = (guid)=>{
    switch(guid){
        case "d84e75cd4db4d154b86ff0c7e479b47a":
            return 0, (/*@__PURE__*/$parcel$interopDefault($ad01da37dbf4b5e1$exports));
    }
};


var $3dad9eb583b9bd17$exports = {};
var $9e46c780ab6b55bf$exports = {};
$9e46c780ab6b55bf$exports = new URL("holydeflection.afc766db.png", import.meta.url).toString();


$3dad9eb583b9bd17$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "HolyDeflection",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "73c526bbb006fde49a6978e33b9c6786",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 14,
        "castDelay": 180,
        "animationSpeed": 2,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Holy Deflection",
        "description": "Every time the target takes over <b>10</b> damage, they will receive a shield that absorbs <b>16</b> damage and lasts <b>4</b> seconds. The shield effect can only occur once every <b>4</b> seconds. The buff lasts <b>20</b> seconds and can only be active on one target at a time.",
        "icon": "96e5489270ded0445856efc88bfb868a",
        "usableBy": "070000000d000000",
        "cooldown": 10,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "027489edcf0967b4c9cd9e38e44be6cf",
            "type": 2
        }
    }
};
$3dad9eb583b9bd17$exports.getImport = (guid)=>{
    switch(guid){
        case "96e5489270ded0445856efc88bfb868a":
            return 0, (/*@__PURE__*/$parcel$interopDefault($9e46c780ab6b55bf$exports));
    }
};


var $2f663bb137d1b8cb$exports = {};

$2f663bb137d1b8cb$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "HolyDeflectionShortCD",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "73c526bbb006fde49a6978e33b9c6786",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 14,
        "castDelay": 180,
        "animationSpeed": 2,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Holy Deflection",
        "description": "Every time the target takes over <b>10</b> damage, they will receive a shield that absorbs <b>16</b> damage and lasts <b>4</b> seconds. The shield effect can only occur once every <b>4</b> seconds. The buff lasts <b>20</b> seconds and can only be active on one target at a time.",
        "icon": "96e5489270ded0445856efc88bfb868a",
        "usableBy": null,
        "cooldown": 5,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "027489edcf0967b4c9cd9e38e44be6cf",
            "type": 2
        }
    }
};
$2f663bb137d1b8cb$exports.getImport = (guid)=>{
    switch(guid){
        case "96e5489270ded0445856efc88bfb868a":
            return 0, (/*@__PURE__*/$parcel$interopDefault($9e46c780ab6b55bf$exports));
    }
};


var $46852bbe4a60b821$exports = {};
var $d932c79033c037ca$exports = {};
$d932c79033c037ca$exports = new URL("holystrike.218ed7b5.png", import.meta.url).toString();


$46852bbe4a60b821$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "HolyStrike",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 110620,
            "guid": "dd18fef4bb6bc05418e566f124f04d44",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 3,
        "castDelay": 180,
        "animationSpeed": 1.6,
        "animationDuration": 0.8,
        "skipCooldownOnChannel": 0,
        "spellName": "Holy Strike",
        "description": "Deal <b>8</b> damage to the target.",
        "icon": "3b5a111b903c16a48856b33c8b6f2aef",
        "usableBy": null,
        "cooldown": 7,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$46852bbe4a60b821$exports.getImport = (guid)=>{
    switch(guid){
        case "3b5a111b903c16a48856b33c8b6f2aef":
            return 0, (/*@__PURE__*/$parcel$interopDefault($d932c79033c037ca$exports));
    }
};


var $b16e2bc5085e5ed8$exports = {};
var $e2a1ac7f79f914a1$exports = {};
$e2a1ac7f79f914a1$exports = new URL("hope.b28c9560.png", import.meta.url).toString();


$b16e2bc5085e5ed8$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "Hope",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "73c526bbb006fde49a6978e33b9c6786",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 0,
        "castDelay": 400,
        "animationSpeed": 1.5,
        "animationDuration": 1,
        "skipCooldownOnChannel": 1,
        "spellName": "Hope",
        "description": "Your next heal will heal for <b>100%</b> more.",
        "icon": "601889a369ccc264484667d3365d37e1",
        "usableBy": null,
        "cooldown": 24,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$b16e2bc5085e5ed8$exports.getImport = (guid)=>{
    switch(guid){
        case "601889a369ccc264484667d3365d37e1":
            return 0, (/*@__PURE__*/$parcel$interopDefault($e2a1ac7f79f914a1$exports));
    }
};


var $edb0d3362b5bc78d$exports = {};
var $439da93261e882bc$exports = {};
$439da93261e882bc$exports = new URL("mysticalbrilliance.5243a4fa.png", import.meta.url).toString();


$edb0d3362b5bc78d$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "InstantMysticalBrilliance",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "73c526bbb006fde49a6978e33b9c6786",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 8300000,
            "guid": "115326b0a1d301d408b2a59db74f0093",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 14,
        "castDelay": 200,
        "animationSpeed": 2,
        "animationDuration": 0.6,
        "skipCooldownOnChannel": 0,
        "spellName": "Mystical Brilliance",
        "description": "Heal the target for <b>28</b> health.",
        "icon": "c330824bb70e2c643a0339a300e8a697",
        "usableBy": null,
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "03c30f735d409064ea31b6b51d03dd6f",
            "type": 2
        }
    }
};
$edb0d3362b5bc78d$exports.getImport = (guid)=>{
    switch(guid){
        case "c330824bb70e2c643a0339a300e8a697":
            return 0, (/*@__PURE__*/$parcel$interopDefault($439da93261e882bc$exports));
    }
};


var $cfaf6d2087e96d5a$exports = {};
var $073a356f01e93242$exports = {};
$073a356f01e93242$exports = new URL("righteouscleansing.4d096e4d.png", import.meta.url).toString();


$cfaf6d2087e96d5a$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "InstantRighteousCleansing",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 110620,
            "guid": "dd18fef4bb6bc05418e566f124f04d44",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 8300000,
            "guid": "115326b0a1d301d408b2a59db74f0093",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 14,
        "castDelay": 200,
        "animationSpeed": 2,
        "animationDuration": 0.6,
        "skipCooldownOnChannel": 0,
        "spellName": "Righteous Cleansing",
        "description": "Deal <b>25</b> damage to the target.",
        "icon": "74f315ee59694ab4298039308e466e72",
        "usableBy": null,
        "cooldown": 22,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$cfaf6d2087e96d5a$exports.getImport = (guid)=>{
    switch(guid){
        case "74f315ee59694ab4298039308e466e72":
            return 0, (/*@__PURE__*/$parcel$interopDefault($073a356f01e93242$exports));
    }
};


var $9e876e3b93dde5a5$exports = {};
var $eef4a5e934c993b7$exports = {};
$eef4a5e934c993b7$exports = new URL("maceswing.f1958368.png", import.meta.url).toString();


$9e876e3b93dde5a5$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "MaceSwing",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 8300000,
            "guid": "004255efa44392a4ab6ff82bc342a7ef",
            "type": 3
        },
        "afterChannelSoundDelay": 215,
        "animation": 0,
        "animationVariation": 4,
        "castDelay": 350,
        "animationSpeed": 1,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Mace Swing",
        "description": "Deal <b>5</b> damage to the target.",
        "icon": "60cfd603bb0c29c44bd0c258fcddaa23",
        "usableBy": "07000000",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "12d2ef2f459217549b413b4b15bf4b0e",
            "type": 2
        }
    }
};
$9e876e3b93dde5a5$exports.getImport = (guid)=>{
    switch(guid){
        case "60cfd603bb0c29c44bd0c258fcddaa23":
            return 0, (/*@__PURE__*/$parcel$interopDefault($eef4a5e934c993b7$exports));
    }
};


var $d8d411acfff00cb6$exports = {};

$d8d411acfff00cb6$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "MysticalBrilliance",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "ca4ffbb7fd64e3440b066bb5cbee0962",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 8300000,
            "guid": "115326b0a1d301d408b2a59db74f0093",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 22,
        "castDelay": 0,
        "animationSpeed": 0.8,
        "animationDuration": 1.6,
        "skipCooldownOnChannel": 0,
        "spellName": "Mystical Brilliance",
        "description": "<b>Friendly Target:</b> heal the target for <b>24</b> health. \n\n<b>Enemy Target:</b> deal <b>9</b> damage to the target.",
        "icon": "c330824bb70e2c643a0339a300e8a697",
        "usableBy": "070000000d000000",
        "cooldown": 0,
        "castTime": 1.6,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "03c30f735d409064ea31b6b51d03dd6f",
            "type": 2
        }
    }
};
$d8d411acfff00cb6$exports.getImport = (guid)=>{
    switch(guid){
        case "c330824bb70e2c643a0339a300e8a697":
            return 0, (/*@__PURE__*/$parcel$interopDefault($439da93261e882bc$exports));
    }
};


var $6dae8d6ae04ae612$exports = {};

$6dae8d6ae04ae612$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "RighteousCleansing",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 110620,
            "guid": "dd18fef4bb6bc05418e566f124f04d44",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 8300000,
            "guid": "115326b0a1d301d408b2a59db74f0093",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 0,
        "castDelay": 0,
        "animationSpeed": 0.5,
        "animationDuration": 1.4,
        "skipCooldownOnChannel": 0,
        "spellName": "Righteous Cleansing",
        "description": "Deal <b>25</b> damage to the target.",
        "icon": "74f315ee59694ab4298039308e466e72",
        "usableBy": null,
        "cooldown": 22,
        "castTime": 1.4,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$6dae8d6ae04ae612$exports.getImport = (guid)=>{
    switch(guid){
        case "74f315ee59694ab4298039308e466e72":
            return 0, (/*@__PURE__*/$parcel$interopDefault($073a356f01e93242$exports));
    }
};


var $6a14bf21b42a40b3$exports = {};
var $8fe91f41bb785101$exports = {};
$8fe91f41bb785101$exports = new URL("righteousdefense.05fcfce7.png", import.meta.url).toString();


$6a14bf21b42a40b3$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "RighteousDefense",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "73c526bbb006fde49a6978e33b9c6786",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 87,
        "castDelay": 450,
        "animationSpeed": 1.2,
        "animationDuration": 0.6,
        "skipCooldownOnChannel": 1,
        "spellName": "Righteous Defense",
        "description": "Remove all <b>Stuns</b>, <b>Slows</b>, and <b>Incapacitates</b> from the target and make them <b>Immune</b> to <b>Stuns</b> and physical damage for <b>8</b> seconds. The target will also deal <b>100%</b> reduced physical damage and <b>65%</b> reduced magic damage. Cannot be cast on <b>Honored</b> targets. The target will be <b>Honored</b> for 90 seconds. \n\nIf cast on yourself, it lasts <b>2</b> seconds longer and you also become <b>Immune</b> to magic damage and become <b>Uninterruptable</b>. \n\nThis can be cast while <b>Silenced</b>, <b>Stunned</b> or <b>Incapacitated</b> if cast on yourself.",
        "icon": "6d110e1853f8ed04f86ef9ec33e758a5",
        "usableBy": "070000000d000000",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "027489edcf0967b4c9cd9e38e44be6cf",
            "type": 2
        }
    }
};
$6a14bf21b42a40b3$exports.getImport = (guid)=>{
    switch(guid){
        case "6d110e1853f8ed04f86ef9ec33e758a5":
            return 0, (/*@__PURE__*/$parcel$interopDefault($8fe91f41bb785101$exports));
    }
};


var $4a54951fd244d178$exports = {};
var $1ef1c2b41caa24a7$exports = {};
$1ef1c2b41caa24a7$exports = new URL("righteousdefensecancel.a07411e8.png", import.meta.url).toString();


$4a54951fd244d178$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "RighteousDefenseCancel",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 14,
        "castDelay": 0,
        "animationSpeed": 3,
        "animationDuration": 0,
        "skipCooldownOnChannel": 0,
        "spellName": "Cancel Righteous Defense",
        "description": "Remove <b>Righteous Defense</b> from yourself.",
        "icon": "94dd8715df5de1d4884dc8a001e5c39a",
        "usableBy": "000000000100000002000000030000000400000005000000060000000700000008000000090000000a0000000b0000000c0000000d0000000e0000000f000000",
        "cooldown": 1,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "a8cd7cc6f0212db4a8228be1ba9145b6",
            "type": 2
        }
    }
};
$4a54951fd244d178$exports.getImport = (guid)=>{
    switch(guid){
        case "94dd8715df5de1d4884dc8a001e5c39a":
            return 0, (/*@__PURE__*/$parcel$interopDefault($1ef1c2b41caa24a7$exports));
    }
};


var $714becaf0d0a03f6$exports = {};
var $7f40191d7fa6d843$exports = {};
$7f40191d7fa6d843$exports = new URL("righteousflash.eeb816eb.png", import.meta.url).toString();


$714becaf0d0a03f6$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "RighteousFlash",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "73c526bbb006fde49a6978e33b9c6786",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 8300000,
            "guid": "115326b0a1d301d408b2a59db74f0093",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 14,
        "castDelay": 150,
        "animationSpeed": 2.5,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Righteous Flash",
        "description": "<b>Friendly Target:</b> heal the target for <b>44</b> health. \n\n<b>Enemy Target:</b> deal <b>14</b> damage to the target.",
        "icon": "935e51a83e3b9d04f906fc1b0c7fd844",
        "usableBy": "07000000",
        "cooldown": 6,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "03c30f735d409064ea31b6b51d03dd6f",
            "type": 2
        }
    }
};
$714becaf0d0a03f6$exports.getImport = (guid)=>{
    switch(guid){
        case "935e51a83e3b9d04f906fc1b0c7fd844":
            return 0, (/*@__PURE__*/$parcel$interopDefault($7f40191d7fa6d843$exports));
    }
};


var $d646858ce09b0fec$exports = {};
var $39b1d80db3e23eac$exports = {};
$39b1d80db3e23eac$exports = new URL("righteousprivilege.01d6ed9f.png", import.meta.url).toString();


$d646858ce09b0fec$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "RighteousPrivilege",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "73c526bbb006fde49a6978e33b9c6786",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 20,
        "castDelay": 420,
        "animationSpeed": 2,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Righteous Privilege",
        "description": "Instantly remove all <b>Slows</b> from the target. In addition, the target cannot be <b>Slowed</b> for <b>10</b> seconds.",
        "icon": "cb0069029c9a66849bd251f1456ed963",
        "usableBy": "070000000d000000",
        "cooldown": 30,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "027489edcf0967b4c9cd9e38e44be6cf",
            "type": 2
        }
    }
};
$d646858ce09b0fec$exports.getImport = (guid)=>{
    switch(guid){
        case "cb0069029c9a66849bd251f1456ed963":
            return 0, (/*@__PURE__*/$parcel$interopDefault($39b1d80db3e23eac$exports));
    }
};


var $cd24b8de6ab0d19f$exports = {};
var $66767a64a3156887$exports = {};
$66767a64a3156887$exports = new URL("spiritualbrilliance.0b03f204.png", import.meta.url).toString();


$cd24b8de6ab0d19f$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "SpiritualBrilliance",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "ca4ffbb7fd64e3440b066bb5cbee0962",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 8300000,
            "guid": "115326b0a1d301d408b2a59db74f0093",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 22,
        "castDelay": 0,
        "animationSpeed": 0.5,
        "animationDuration": 3.2,
        "skipCooldownOnChannel": 0,
        "spellName": "Spiritual Brilliance",
        "description": "Heal the target for <b>64</b> health.",
        "icon": "529e328741ee8824fa6847612c3b4cec",
        "usableBy": "070000000d000000",
        "cooldown": 0,
        "castTime": 3.2,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "027489edcf0967b4c9cd9e38e44be6cf",
            "type": 2
        }
    }
};
$cd24b8de6ab0d19f$exports.getImport = (guid)=>{
    switch(guid){
        case "529e328741ee8824fa6847612c3b4cec":
            return 0, (/*@__PURE__*/$parcel$interopDefault($66767a64a3156887$exports));
    }
};


var $e159f5f9dac0e6e6$exports = {};
var $6fec09437f975a85$exports = {};
$6fec09437f975a85$exports = new URL("virtuousbonding.c3f8c8c6.png", import.meta.url).toString();


$e159f5f9dac0e6e6$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "VirtuousBonding",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "73c526bbb006fde49a6978e33b9c6786",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 14,
        "castDelay": 380,
        "animationSpeed": 1.3,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Virtuous Bonding",
        "description": "The target will take <b>30%</b> less damage for <b>8</b> seconds. However, every time the target takes damage, you take <b>2</b> damage.",
        "icon": "a6efcb0f660af8245a7c20213c7e11da",
        "usableBy": "07000000",
        "cooldown": 42,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "dc869fafcb67be64f9817b3529f844ae",
            "type": 2
        }
    }
};
$e159f5f9dac0e6e6$exports.getImport = (guid)=>{
    switch(guid){
        case "a6efcb0f660af8245a7c20213c7e11da":
            return 0, (/*@__PURE__*/$parcel$interopDefault($6fec09437f975a85$exports));
    }
};


var $2c21c7f4b9304e07$exports = {};
var $9e967cbeb0248a92$exports = {};
$9e967cbeb0248a92$exports = new URL("chainsofice.3e6c97ad.png", import.meta.url).toString();


$2c21c7f4b9304e07$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "ChainsOfIce",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "31f0c923b7b660e47938376fb189e949",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 21,
        "castDelay": 380,
        "animationSpeed": 2.8,
        "animationDuration": 0.7,
        "skipCooldownOnChannel": 0,
        "spellName": "Chains of Ice",
        "description": "Deal <b>1</b> damage and prevent all targets in a <b>10</b> yard radius at the mouse position from moving for <b>8</b> seconds. Targets are considered <b>Frozen</b> for this duration. Can be cast while <b>Stunned</b> or <b>Incapacitated</b>.",
        "icon": "a4e342ff663a43545bbb98d416cafc0a",
        "usableBy": "00000000",
        "cooldown": 20,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 10,
        "isHidden": 0,
        "isInternal": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "49714b7747fcdd245a2a48451ad05657",
            "type": 2
        }
    }
};
$2c21c7f4b9304e07$exports.getImport = (guid)=>{
    switch(guid){
        case "a4e342ff663a43545bbb98d416cafc0a":
            return 0, (/*@__PURE__*/$parcel$interopDefault($9e967cbeb0248a92$exports));
    }
};


var $8c01216a6d966819$exports = {};
var $f944039797fbf4ef$exports = {};
$f944039797fbf4ef$exports = new URL("crystaldetonation.2ca191c4.png", import.meta.url).toString();


$8c01216a6d966819$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "CrystalDetonation",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 199898,
            "guid": "7bbe36e923d120540a9d42d5002a84f5",
            "type": 3
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "2a0cebb6dfd66ca428f8e23c279102a8",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 58,
        "castDelay": 300,
        "animationSpeed": 1.8,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Crystal Detonation",
        "description": "Deal <b>8</b> damage to all units within <b>10</b> yards.",
        "icon": "1e4465075e487624fa48ad68393aa440",
        "usableBy": "00000000",
        "cooldown": 3,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$8c01216a6d966819$exports.getImport = (guid)=>{
    switch(guid){
        case "1e4465075e487624fa48ad68393aa440":
            return 0, (/*@__PURE__*/$parcel$interopDefault($f944039797fbf4ef$exports));
    }
};


var $055dce97637f34e1$exports = {};
var $a2250f1cffd3df82$exports = {};
$a2250f1cffd3df82$exports = new URL("fieryinfliction.a866edf5.png", import.meta.url).toString();


$055dce97637f34e1$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "FieryInfliction",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "c6cb37df2c0db6e47b38d20f306e416a",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 13,
        "castDelay": 180,
        "animationSpeed": 1.8,
        "animationDuration": 0.4,
        "skipCooldownOnChannel": 0,
        "spellName": "Fiery Infliction",
        "description": "Deal <b>10</b> damage to your target.",
        "icon": "ec41bd890283be448b413dc7f583f2ad",
        "usableBy": "00000000",
        "cooldown": 8,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$055dce97637f34e1$exports.getImport = (guid)=>{
    switch(guid){
        case "ec41bd890283be448b413dc7f583f2ad":
            return 0, (/*@__PURE__*/$parcel$interopDefault($a2250f1cffd3df82$exports));
    }
};


var $73d322d019512bd7$exports = {};
var $e867e3c6fa53e18f$exports = {};
$e867e3c6fa53e18f$exports = new URL("frostlance.dbd343ae.png", import.meta.url).toString();


$73d322d019512bd7$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "Frostlance",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.05,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "627bba32f0250004d89cec8e6388f690",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 1,
        "castSound": {
            "fileID": 8300000,
            "guid": "e2ba9e05eab44f348b73e583715738ec",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 0,
        "castDelay": 0,
        "animationSpeed": 0.395,
        "animationDuration": 1.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Frostlance",
        "description": "Deal <b>22</b> damage and slow the target by <b>50%</b> for <b>8</b> seconds. If the target is <b>Frozen</b>, this deals <b>36</b> damage.",
        "icon": "0ebfd878c357aae43bb57205f3154664",
        "usableBy": "00000000",
        "cooldown": 0,
        "castTime": 1.5,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$73d322d019512bd7$exports.getImport = (guid)=>{
    switch(guid){
        case "0ebfd878c357aae43bb57205f3154664":
            return 0, (/*@__PURE__*/$parcel$interopDefault($e867e3c6fa53e18f$exports));
    }
};


var $e76f28235acfb710$exports = {};
var $2262e81e2b5a9f84$exports = {};
$2262e81e2b5a9f84$exports = new URL("frostportal.aed2f56f.png", import.meta.url).toString();


$e76f28235acfb710$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "FrostPortal",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "31f0c923b7b660e47938376fb189e949",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 49,
        "castDelay": 200,
        "animationSpeed": 3,
        "animationDuration": 0.6,
        "skipCooldownOnChannel": 0,
        "spellName": "Frost Portal",
        "description": "Teleport forward <b>20</b> yards and remove all <b>stuns</b> from yourself. Can be used while <b>stunned</b>.",
        "icon": "e0f3c7b5e50de5b438b3af2172869432",
        "usableBy": "00000000",
        "cooldown": 15,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$e76f28235acfb710$exports.getImport = (guid)=>{
    switch(guid){
        case "e0f3c7b5e50de5b438b3af2172869432":
            return 0, (/*@__PURE__*/$parcel$interopDefault($2262e81e2b5a9f84$exports));
    }
};


var $149166563a8ddb92$exports = {};
var $a6ecec85fd9e6ceb$exports = {};
$a6ecec85fd9e6ceb$exports = new URL("frostshield.d5242eb9.png", import.meta.url).toString();


$149166563a8ddb92$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "FrostShield",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "31f0c923b7b660e47938376fb189e949",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 55,
        "castDelay": 440,
        "animationSpeed": 1.8,
        "animationDuration": 0.8,
        "skipCooldownOnChannel": 0,
        "spellName": "Frost Shield",
        "description": "Apply a shield to yourself which absorbs up to <b>38</b> damage and lasts <b>30</b> seconds.",
        "icon": "3a948149664916e47bab40ade6fd7664",
        "usableBy": "00000000",
        "cooldown": 20,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$149166563a8ddb92$exports.getImport = (guid)=>{
    switch(guid){
        case "3a948149664916e47bab40ade6fd7664":
            return 0, (/*@__PURE__*/$parcel$interopDefault($a6ecec85fd9e6ceb$exports));
    }
};


var $9551da6e3b644401$exports = {};
var $de0b03921019ee0d$exports = {};
$de0b03921019ee0d$exports = new URL("frozenreversal.8820037f.png", import.meta.url).toString();


$9551da6e3b644401$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "FrozenReversal",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "31f0c923b7b660e47938376fb189e949",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 9,
        "castDelay": 0,
        "animationSpeed": 1,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Frozen Reversal",
        "description": "Reset the cooldown of <b>Icy Explosion</b>, <b>Icy Shards</b> and <b>Frost Shield</b>.",
        "icon": "e7c623928f7073f46a1fcea7759cf257",
        "usableBy": "00000000",
        "cooldown": 90,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$9551da6e3b644401$exports.getImport = (guid)=>{
    switch(guid){
        case "e7c623928f7073f46a1fcea7759cf257":
            return 0, (/*@__PURE__*/$parcel$interopDefault($de0b03921019ee0d$exports));
    }
};


var $67905ea30482f60f$exports = {};
var $1f44ced5197c0c49$exports = {};
$1f44ced5197c0c49$exports = new URL("glacialencapsulation.579120fa.png", import.meta.url).toString();


$67905ea30482f60f$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "GlacialEncapsulation",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "31f0c923b7b660e47938376fb189e949",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 3,
        "castDelay": 0,
        "animationSpeed": 2,
        "animationDuration": 10,
        "skipCooldownOnChannel": 0,
        "spellName": "Glacial Encapsulation",
        "description": "Become <b>Immune</b> to damage and incoming negative effects for <b>10</b> seconds. You cannot move or cast spells while the effect is active.",
        "icon": "2f23c410d89a52e4e9217b8cbdb630fa",
        "usableBy": "0000000009000000",
        "cooldown": 90,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$67905ea30482f60f$exports.getImport = (guid)=>{
    switch(guid){
        case "2f23c410d89a52e4e9217b8cbdb630fa":
            return 0, (/*@__PURE__*/$parcel$interopDefault($1f44ced5197c0c49$exports));
    }
};


var $5ef550c0c4d85055$exports = {};
var $77e60f81952ba866$exports = {};
$77e60f81952ba866$exports = new URL("glacialencapsulationcancel.c20e467e.png", import.meta.url).toString();


$5ef550c0c4d85055$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "GlacialEncapsulationCancel",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "31f0c923b7b660e47938376fb189e949",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 3,
        "castDelay": 0,
        "animationSpeed": 2,
        "animationDuration": 0,
        "skipCooldownOnChannel": 0,
        "spellName": "Cancel Glacial Encapsulation",
        "description": "Cancel <b>Glacial Encapsulation</b>.",
        "icon": "8f17dbe684c39274c879bee10ef0ea62",
        "usableBy": "0000000009000000",
        "cooldown": 1,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$5ef550c0c4d85055$exports.getImport = (guid)=>{
    switch(guid){
        case "8f17dbe684c39274c879bee10ef0ea62":
            return 0, (/*@__PURE__*/$parcel$interopDefault($77e60f81952ba866$exports));
    }
};


var $1fc21a146b281d8a$exports = {};
var $2d0df1093c4d634f$exports = {};
$2d0df1093c4d634f$exports = new URL("icybindings.a5e7e536.png", import.meta.url).toString();


$1fc21a146b281d8a$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "IcyBindings",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "31f0c923b7b660e47938376fb189e949",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 14,
        "castDelay": 180,
        "animationSpeed": 2.5,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Icy Bindings",
        "description": "<b>Stun</b> the target for <b>4</b> seconds. Can only be used if the target is <b>Frozen</b>. The target is considered <b>Frozen</b> for the duration.",
        "icon": "1e9d019548a706641b83a44d53cf5392",
        "usableBy": "00000000",
        "cooldown": 25,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$1fc21a146b281d8a$exports.getImport = (guid)=>{
    switch(guid){
        case "1e9d019548a706641b83a44d53cf5392":
            return 0, (/*@__PURE__*/$parcel$interopDefault($2d0df1093c4d634f$exports));
    }
};


var $0b8690f5c14a8965$exports = {};
var $96ba447699abd04e$exports = {};
$96ba447699abd04e$exports = new URL("icyexplosion.902ca34b.png", import.meta.url).toString();


$0b8690f5c14a8965$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "IcyExplosion",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "31f0c923b7b660e47938376fb189e949",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 14,
        "castDelay": 180,
        "animationSpeed": 2.5,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Icy Explosion",
        "description": "Deal <b>3</b> damage to all targets in an <b>10</b> yard radius from the caster and prevent them from moving for <b>8</b> seconds. Targets are considered <b>Frozen</b> for this duration.",
        "icon": "f12f21bd276edf24eaa127697c232784",
        "usableBy": "00000000",
        "cooldown": 18,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$0b8690f5c14a8965$exports.getImport = (guid)=>{
    switch(guid){
        case "f12f21bd276edf24eaa127697c232784":
            return 0, (/*@__PURE__*/$parcel$interopDefault($96ba447699abd04e$exports));
    }
};


var $47a9856441a20453$exports = {};
var $011983df8e060085$exports = {};
$011983df8e060085$exports = new URL("icyshards.7f617c75.png", import.meta.url).toString();


$47a9856441a20453$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "IcyShards",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "31f0c923b7b660e47938376fb189e949",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 15,
        "castDelay": 200,
        "animationSpeed": 2.5,
        "animationDuration": 0.6,
        "skipCooldownOnChannel": 0,
        "spellName": "Icy Shards",
        "description": "Deal <b>10</b> damage and apply a <b>60%</b> slow for <b>7</b> seconds to all targets in a cone in front of the caster.",
        "icon": "1d51f3572d15132408e2167383259f72",
        "usableBy": "00000000",
        "cooldown": 10,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$47a9856441a20453$exports.getImport = (guid)=>{
    switch(guid){
        case "1d51f3572d15132408e2167383259f72":
            return 0, (/*@__PURE__*/$parcel$interopDefault($011983df8e060085$exports));
    }
};


var $4558158000be7ce5$exports = {};
var $993468cf4e9defd2$exports = {};
$993468cf4e9defd2$exports = new URL("innerfrost.473041e9.png", import.meta.url).toString();


$4558158000be7ce5$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "InnerFrost",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "31f0c923b7b660e47938376fb189e949",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 18,
        "castDelay": 300,
        "animationSpeed": 3,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Inner Frost",
        "description": "Increase your cast speed by <b>20%</b> for <b>15</b> seconds.",
        "icon": "804040b3ceef70a4c929026b763e8387",
        "usableBy": "00000000",
        "cooldown": 60,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$4558158000be7ce5$exports.getImport = (guid)=>{
    switch(guid){
        case "804040b3ceef70a4c929026b763e8387":
            return 0, (/*@__PURE__*/$parcel$interopDefault($993468cf4e9defd2$exports));
    }
};


var $97afd38131482bb3$exports = {};

$97afd38131482bb3$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "InstantFrostlance",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "31f0c923b7b660e47938376fb189e949",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 8300000,
            "guid": "e2ba9e05eab44f348b73e583715738ec",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 13,
        "castDelay": 180,
        "animationSpeed": 1.8,
        "animationDuration": 0.4,
        "skipCooldownOnChannel": 0,
        "spellName": "Frostlance",
        "description": "Deal <b>22</b> damage and slow the target by <b>50%</b> for <b>8</b> seconds. If the target is <b>Frozen</b>, this deals <b>36</b> damage.",
        "icon": "0ebfd878c357aae43bb57205f3154664",
        "usableBy": null,
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$97afd38131482bb3$exports.getImport = (guid)=>{
    switch(guid){
        case "0ebfd878c357aae43bb57205f3154664":
            return 0, (/*@__PURE__*/$parcel$interopDefault($e867e3c6fa53e18f$exports));
    }
};


var $1e54d220b410847e$exports = {};
var $16d9213e2fa37cf8$exports = {};
$16d9213e2fa37cf8$exports = new URL("invisibility.8d18cbb6.png", import.meta.url).toString();


$1e54d220b410847e$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "Invisibility",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "2a0cebb6dfd66ca428f8e23c279102a8",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 22,
        "castDelay": 0,
        "animationSpeed": 0.6,
        "animationDuration": 3,
        "skipCooldownOnChannel": 0,
        "spellName": "Invisibility",
        "description": "After <b>3</b> seconds, become invisible to enemy players. The effect lasts <b>15</b> seconds or until any spell completes channeling.",
        "icon": "0dca87acec2ac9f4da8b604cc493ad59",
        "usableBy": null,
        "cooldown": 80,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$1e54d220b410847e$exports.getImport = (guid)=>{
    switch(guid){
        case "0dca87acec2ac9f4da8b604cc493ad59":
            return 0, (/*@__PURE__*/$parcel$interopDefault($16d9213e2fa37cf8$exports));
    }
};


var $5cf053083a5c6400$exports = {};
var $91869d151fcd1b12$exports = {};
$91869d151fcd1b12$exports = new URL("penguinify.c11c242e.png", import.meta.url).toString();


$5cf053083a5c6400$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "Penguinify",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 199898,
            "guid": "7bbe36e923d120540a9d42d5002a84f5",
            "type": 3
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "7f1c197a232a3d345aaa061a8840dedd",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 8300000,
            "guid": "c345102d431271742ac08c44960b0cd6",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 0,
        "castDelay": 0,
        "animationSpeed": 0.395,
        "animationDuration": 1.7,
        "skipCooldownOnChannel": 0,
        "spellName": "Penguinify",
        "description": "Turn the target into a penguin, <b>Incapacitating</b> them for <b>10</b> seconds. Any damage dealt to the target will break this effect.",
        "icon": "39033e69610f5294c853d3f02164fa45",
        "usableBy": "00000000",
        "cooldown": 0,
        "castTime": 1.5,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$5cf053083a5c6400$exports.getImport = (guid)=>{
    switch(guid){
        case "39033e69610f5294c853d3f02164fa45":
            return 0, (/*@__PURE__*/$parcel$interopDefault($91869d151fcd1b12$exports));
    }
};


var $0b7de7a838cb7e75$exports = {};

$0b7de7a838cb7e75$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "PenguinifyShort",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 199898,
            "guid": "7bbe36e923d120540a9d42d5002a84f5",
            "type": 3
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "7f1c197a232a3d345aaa061a8840dedd",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 8300000,
            "guid": "c345102d431271742ac08c44960b0cd6",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 0,
        "castDelay": 0,
        "animationSpeed": 0.52,
        "animationDuration": 1.4,
        "skipCooldownOnChannel": 0,
        "spellName": "Penguinify",
        "description": "Turn the target into a penguin, <b>Incapacitating</b> them for <b>10</b> seconds. Any damage dealt to the target will break this effect.",
        "icon": "39033e69610f5294c853d3f02164fa45",
        "usableBy": null,
        "cooldown": 0,
        "castTime": 1.2,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$0b7de7a838cb7e75$exports.getImport = (guid)=>{
    switch(guid){
        case "39033e69610f5294c853d3f02164fa45":
            return 0, (/*@__PURE__*/$parcel$interopDefault($91869d151fcd1b12$exports));
    }
};


var $155e97159da39107$exports = {};
var $b08d6c5ea3221911$exports = {};
$b08d6c5ea3221911$exports = new URL("pyrolance.3a356156.png", import.meta.url).toString();


$155e97159da39107$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "Pyrolance",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "188ccd91914323f48a7ff9686cb3242a",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 1,
        "playOnCast": [
            {
                "fileID": 193574,
                "guid": "549a96f1185245e438a33ecbf99a97d5",
                "type": 3
            }
        ],
        "castSound": {
            "fileID": 8300000,
            "guid": "3f776ba755ba71341bb3f527c8369c60",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 0,
        "castDelay": 0,
        "animationSpeed": 0.395,
        "animationDuration": 1.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Pyrolance",
        "description": "Deal <b>28</b> damage to the target.",
        "icon": "c1d6653c52b46d840ae56e6b7842fbc6",
        "usableBy": "00000000",
        "cooldown": 0,
        "castTime": 1.5,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$155e97159da39107$exports.getImport = (guid)=>{
    switch(guid){
        case "c1d6653c52b46d840ae56e6b7842fbc6":
            return 0, (/*@__PURE__*/$parcel$interopDefault($b08d6c5ea3221911$exports));
    }
};


var $470b9c689e00988b$exports = {};

$470b9c689e00988b$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "PyrolanceInstant",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "c6cb37df2c0db6e47b38d20f306e416a",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 8300000,
            "guid": "3f776ba755ba71341bb3f527c8369c60",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 13,
        "castDelay": 180,
        "animationSpeed": 1.8,
        "animationDuration": 0.4,
        "skipCooldownOnChannel": 0,
        "spellName": "Frostlance",
        "description": "Deal <b>28</b> damage to the target.",
        "icon": "c1d6653c52b46d840ae56e6b7842fbc6",
        "usableBy": null,
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$470b9c689e00988b$exports.getImport = (guid)=>{
    switch(guid){
        case "c1d6653c52b46d840ae56e6b7842fbc6":
            return 0, (/*@__PURE__*/$parcel$interopDefault($b08d6c5ea3221911$exports));
    }
};


var $a5d9babf514c646e$exports = {};
var $e0bafa6a360e488b$exports = {};
$e0bafa6a360e488b$exports = new URL("sharpice.904efdbe.png", import.meta.url).toString();


$a5d9babf514c646e$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "SharpIce",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "31f0c923b7b660e47938376fb189e949",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 23,
        "castDelay": 0,
        "animationSpeed": 1.6,
        "animationDuration": 1.2,
        "skipCooldownOnChannel": 0,
        "spellName": "Sharp Ice",
        "description": "Deal <b>3</b> damage to the target. Deals <b>18</b> damage if the target is frozen.",
        "icon": "c4744887f189dd3479aae88073b55fdd",
        "usableBy": "00000000",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$a5d9babf514c646e$exports.getImport = (guid)=>{
    switch(guid){
        case "c4744887f189dd3479aae88073b55fdd":
            return 0, (/*@__PURE__*/$parcel$interopDefault($e0bafa6a360e488b$exports));
    }
};


var $435503d289ad9853$exports = {};

$435503d289ad9853$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "SlowFrostlance",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "627bba32f0250004d89cec8e6388f690",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 1,
        "castSound": {
            "fileID": 8300000,
            "guid": "e2ba9e05eab44f348b73e583715738ec",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 0,
        "castDelay": 0,
        "animationSpeed": 0.23,
        "animationDuration": 2.8,
        "skipCooldownOnChannel": 0,
        "spellName": "Frostlance",
        "description": "Deal <b>22</b> damage and slow the target by <b>50%</b> for <b>8</b> seconds. If the target is <b>Frozen</b>, this deals <b>36</b> damage.",
        "icon": "0ebfd878c357aae43bb57205f3154664",
        "usableBy": null,
        "cooldown": 0,
        "castTime": 2.5,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$435503d289ad9853$exports.getImport = (guid)=>{
    switch(guid){
        case "0ebfd878c357aae43bb57205f3154664":
            return 0, (/*@__PURE__*/$parcel$interopDefault($e867e3c6fa53e18f$exports));
    }
};


var $5cc7b39ea0d41cff$exports = {};
var $9c8d8031a2489315$exports = {};
$9c8d8031a2489315$exports = new URL("spellscatter.a1ec5dde.png", import.meta.url).toString();


$5cc7b39ea0d41cff$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "Spellscatter",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 199898,
            "guid": "7bbe36e923d120540a9d42d5002a84f5",
            "type": 3
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "2a0cebb6dfd66ca428f8e23c279102a8",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 10,
        "castDelay": 0,
        "animationSpeed": 2,
        "animationDuration": 0.4,
        "skipCooldownOnChannel": 0,
        "spellName": "Spellscatter",
        "description": "If the target is casting, <b>Interrupt</b> them and prevent them from casting the same spell for <b>8</b> seconds and any other spell for <b>4</b> seconds. \n\nIf the target is not casting, prevent them from casting any spell for <b>2</b> seconds.",
        "icon": "98e62f857d70c3843b19466f48c4ee54",
        "usableBy": "000000000400000009000000",
        "cooldown": 25,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$5cc7b39ea0d41cff$exports.getImport = (guid)=>{
    switch(guid){
        case "98e62f857d70c3843b19466f48c4ee54":
            return 0, (/*@__PURE__*/$parcel$interopDefault($9c8d8031a2489315$exports));
    }
};


var $a5a6f70c21bbde41$exports = {};
var $699ff1745c9a16dc$exports = {};
$699ff1745c9a16dc$exports = new URL("bash.ae2d82f4.png", import.meta.url).toString();


$a5a6f70c21bbde41$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "Bash",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "038adfb581b6c7e46885cbe249190c23",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 8,
        "castDelay": 220,
        "animationSpeed": 1,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Slam",
        "description": "Stun the target for <b>4</b> seconds.",
        "icon": "edebd213b3c4c944aa118ed9f3b6379b",
        "usableBy": "05000000",
        "cooldown": 25,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$a5a6f70c21bbde41$exports.getImport = (guid)=>{
    switch(guid){
        case "edebd213b3c4c944aa118ed9f3b6379b":
            return 0, (/*@__PURE__*/$parcel$interopDefault($699ff1745c9a16dc$exports));
    }
};


var $759c4fd59d782c92$exports = {};
var $fdfb64e0d8c932b9$exports = {};
$fdfb64e0d8c932b9$exports = new URL("cloudform.f6fe495f.png", import.meta.url).toString();


$759c4fd59d782c92$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "CloudForm",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "038adfb581b6c7e46885cbe249190c23",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 217,
        "castDelay": 500,
        "animationSpeed": 2,
        "animationDuration": 0.6,
        "skipCooldownOnChannel": 1,
        "spellName": "Cloud Form",
        "description": "Turn into a ball of wind, increasing move speed by <b>40%</b> and increasing damage taken by <b>10%</b>. If any spells are cast the effect will break.",
        "icon": "504fcd7cd3c53d9408cfb61db172c3e8",
        "usableBy": "050000000e000000",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$759c4fd59d782c92$exports.getImport = (guid)=>{
    switch(guid){
        case "504fcd7cd3c53d9408cfb61db172c3e8":
            return 0, (/*@__PURE__*/$parcel$interopDefault($fdfb64e0d8c932b9$exports));
    }
};


var $df099f1ef08d632f$exports = {};
var $c07ca06509638d13$exports = {};
$c07ca06509638d13$exports = new URL("cloudformcancel.e5e0a4b3.png", import.meta.url).toString();


$df099f1ef08d632f$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "CloudFormCancel",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "038adfb581b6c7e46885cbe249190c23",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 217,
        "castDelay": 0,
        "animationSpeed": 2,
        "animationDuration": 0,
        "skipCooldownOnChannel": 0,
        "spellName": "Cancel Cloud Form",
        "description": "Exit <b>Cloud Form</b>.",
        "icon": "712e09466ed9b6a45803bf6a20fe005e",
        "usableBy": "050000000e000000",
        "cooldown": 1,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$df099f1ef08d632f$exports.getImport = (guid)=>{
    switch(guid){
        case "712e09466ed9b6a45803bf6a20fe005e":
            return 0, (/*@__PURE__*/$parcel$interopDefault($c07ca06509638d13$exports));
    }
};


var $d623f8c1feb50695$exports = {};
var $17bbd5ceb18f2434$exports = {};
$17bbd5ceb18f2434$exports = new URL("cultivation.a3d0762b.png", import.meta.url).toString();


$d623f8c1feb50695$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "Cultivation",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "038adfb581b6c7e46885cbe249190c23",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 14,
        "castDelay": 100,
        "animationSpeed": 2.5,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Cultivation",
        "description": "Heal the target for <b>2</b> health per stack every <b>2</b> seconds for <b>10</b> seconds. Heal for an additional <b>8</b> health per stack when the effect ends. This can be stacked up to <b>3</b> times on one target.",
        "icon": "bdaa1efd9b48d4341a971dc8d4d64485",
        "usableBy": "050000000e000000",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "027489edcf0967b4c9cd9e38e44be6cf",
            "type": 2
        }
    }
};
$d623f8c1feb50695$exports.getImport = (guid)=>{
    switch(guid){
        case "bdaa1efd9b48d4341a971dc8d4d64485":
            return 0, (/*@__PURE__*/$parcel$interopDefault($17bbd5ceb18f2434$exports));
    }
};


var $7b829d777b14d308$exports = {};
var $0f8e15e9fa094680$exports = {};
$0f8e15e9fa094680$exports = new URL("duststorm.9734ab49.png", import.meta.url).toString();


$7b829d777b14d308$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "DustStorm",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "038adfb581b6c7e46885cbe249190c23",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 8300000,
            "guid": "46f394b80779f0040a4c88bce842f006",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 0,
        "castDelay": 0,
        "animationSpeed": 0.47,
        "animationDuration": 1.3,
        "skipCooldownOnChannel": 0,
        "spellName": "Dust Storm",
        "description": "<b>Incapacitate</b> the target for 6 seconds. The target cannot be damaged or healed for the duration.",
        "icon": "3762cdaa74d0c1646accd36bfef91896",
        "usableBy": "050000000e000000",
        "cooldown": 0,
        "castTime": 1.3,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$7b829d777b14d308$exports.getImport = (guid)=>{
    switch(guid){
        case "3762cdaa74d0c1646accd36bfef91896":
            return 0, (/*@__PURE__*/$parcel$interopDefault($0f8e15e9fa094680$exports));
    }
};


var $3909d26e09c7720b$exports = {};
var $9c6fdb52456a2ebf$exports = {};
$9c6fdb52456a2ebf$exports = new URL("lightningbolt.c64a1583.png", import.meta.url).toString();


$3909d26e09c7720b$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "LightningBolt",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 727422648304881800,
            "guid": "a9f11eefd58c0244ba94098589ebf7db",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 8300000,
            "guid": "46f394b80779f0040a4c88bce842f006",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 0,
        "castDelay": 0,
        "animationSpeed": 0.45,
        "animationDuration": 1.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Lightning Bolt",
        "description": "Deal <b>12</b> damage to the target.",
        "icon": "0197aa44be1dc8c48a0c9eaf33592913",
        "usableBy": "050000000e000000",
        "cooldown": 0,
        "castTime": 1.5,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$3909d26e09c7720b$exports.getImport = (guid)=>{
    switch(guid){
        case "0197aa44be1dc8c48a0c9eaf33592913":
            return 0, (/*@__PURE__*/$parcel$interopDefault($9c6fdb52456a2ebf$exports));
    }
};


var $95fa74e4bb3a6710$exports = {};
var $ce45f3a5a336ac99$exports = {};
$ce45f3a5a336ac99$exports = new URL("lightningfire.469d20f6.png", import.meta.url).toString();


$95fa74e4bb3a6710$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "LightningFire",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 727422648304881800,
            "guid": "a9f11eefd58c0244ba94098589ebf7db",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 85,
        "castDelay": 350,
        "animationSpeed": 1.5,
        "animationDuration": 0.8,
        "skipCooldownOnChannel": 0,
        "spellName": "Lightning Fire",
        "description": "Deal <b>6</b> damage to the target and also deal <b>6</b> damage every <b>3</b> seconds for <b>9</b> seconds.",
        "icon": "8f49956c5d3784141a5902cc45a42460",
        "usableBy": "050000000e000000",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$95fa74e4bb3a6710$exports.getImport = (guid)=>{
    switch(guid){
        case "8f49956c5d3784141a5902cc45a42460":
            return 0, (/*@__PURE__*/$parcel$interopDefault($ce45f3a5a336ac99$exports));
    }
};


var $a77f2efe71fd5ccf$exports = {};
var $274bcd3e72c5416b$exports = {};
$274bcd3e72c5416b$exports = new URL("lightningform.66fcac40.png", import.meta.url).toString();


$a77f2efe71fd5ccf$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "LightningForm",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 727422648304881800,
            "guid": "a9f11eefd58c0244ba94098589ebf7db",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 14,
        "castDelay": 100,
        "animationSpeed": 2.5,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Lightning Mode",
        "description": "Switch to <b>Lightning Mode</b>.",
        "icon": "691184fd28bb344479810923399d5c2d",
        "usableBy": "050000000e000000",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100035,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "1631e66a35497e44fb7cd9422d512865",
            "type": 3
        }
    }
};
$a77f2efe71fd5ccf$exports.getImport = (guid)=>{
    switch(guid){
        case "691184fd28bb344479810923399d5c2d":
            return 0, (/*@__PURE__*/$parcel$interopDefault($274bcd3e72c5416b$exports));
    }
};


var $b68d7f60a8b13828$exports = {};
var $1ab3b2415f028b4f$exports = {};
$1ab3b2415f028b4f$exports = new URL("massrevitalization.eb2b849a.png", import.meta.url).toString();


$b68d7f60a8b13828$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "MassRevitalization",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "038adfb581b6c7e46885cbe249190c23",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 14,
        "castDelay": 100,
        "animationSpeed": 2,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Mass Revitalization",
        "description": "Heal the target and all friendly targets within <b>8</b> yards for <b>5</b> health. In addition, heal the target and all friendly targets within <b>8</b> yards of them for <b>2</b> health every <b>2</b> seconds for <b>8</b> seconds.",
        "icon": "72debf396e3642c46922b1cbebe2c798",
        "usableBy": null,
        "cooldown": 6,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "027489edcf0967b4c9cd9e38e44be6cf",
            "type": 2
        }
    }
};
$b68d7f60a8b13828$exports.getImport = (guid)=>{
    switch(guid){
        case "72debf396e3642c46922b1cbebe2c798":
            return 0, (/*@__PURE__*/$parcel$interopDefault($1ab3b2415f028b4f$exports));
    }
};


var $5de5b323e5bc2b08$exports = {};
var $27234af6fa5b87e7$exports = {};
$27234af6fa5b87e7$exports = new URL("natureform.02732a98.png", import.meta.url).toString();


$5de5b323e5bc2b08$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "NatureForm",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "038adfb581b6c7e46885cbe249190c23",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 14,
        "castDelay": 100,
        "animationSpeed": 2.5,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Nature Mode",
        "description": "Switch to <b>Nature Mode</b>.",
        "icon": "9d943d556a25846459414f9e881d81b4",
        "usableBy": "050000000e000000",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100008,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "708ade88d002dcc489e77c76c7930079",
            "type": 3
        }
    }
};
$5de5b323e5bc2b08$exports.getImport = (guid)=>{
    switch(guid){
        case "9d943d556a25846459414f9e881d81b4":
            return 0, (/*@__PURE__*/$parcel$interopDefault($27234af6fa5b87e7$exports));
    }
};


var $06557b42fea2b3a2$exports = {};
var $c224bf1617eb49fa$exports = {};
$c224bf1617eb49fa$exports = new URL("refreshingleaves.78506314.png", import.meta.url).toString();


$06557b42fea2b3a2$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "RefreshingLeaves",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "038adfb581b6c7e46885cbe249190c23",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 8300000,
            "guid": "115326b0a1d301d408b2a59db74f0093",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 20,
        "castDelay": 0,
        "animationSpeed": 1,
        "animationDuration": 1.45,
        "skipCooldownOnChannel": 0,
        "spellName": "Refreshing Leaves",
        "description": "Heal the target for <b>5</b> health.",
        "icon": "38f6abbc1f31b5c47ad63ddc443fb793",
        "usableBy": "050000000e000000",
        "cooldown": 0,
        "castTime": 1.3,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "027489edcf0967b4c9cd9e38e44be6cf",
            "type": 2
        }
    }
};
$06557b42fea2b3a2$exports.getImport = (guid)=>{
    switch(guid){
        case "38f6abbc1f31b5c47ad63ddc443fb793":
            return 0, (/*@__PURE__*/$parcel$interopDefault($c224bf1617eb49fa$exports));
    }
};


var $b94fa88bf2498baf$exports = {};
var $afa61428d13ae3e4$exports = {};
$afa61428d13ae3e4$exports = new URL("regeneration.c5d4c2bb.png", import.meta.url).toString();


$b94fa88bf2498baf$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "Regeneration",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "038adfb581b6c7e46885cbe249190c23",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 14,
        "castDelay": 100,
        "animationSpeed": 2.5,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Regeneration",
        "description": "Heal the target for <b>6</b> health every <b>3</b> seconds for <b>15</b> seconds.",
        "icon": "35e45ebff5d504f4dadbb763ee86509a",
        "usableBy": "050000000e000000",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "027489edcf0967b4c9cd9e38e44be6cf",
            "type": 2
        }
    }
};
$b94fa88bf2498baf$exports.getImport = (guid)=>{
    switch(guid){
        case "35e45ebff5d504f4dadbb763ee86509a":
            return 0, (/*@__PURE__*/$parcel$interopDefault($afa61428d13ae3e4$exports));
    }
};


var $669e76e8ee6de68a$exports = {};
var $147cb5d10ee04061$exports = {};
$147cb5d10ee04061$exports = new URL("revitalize.c02316c2.png", import.meta.url).toString();


$669e76e8ee6de68a$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "Revitalize",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "038adfb581b6c7e46885cbe249190c23",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 8300000,
            "guid": "115326b0a1d301d408b2a59db74f0093",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 20,
        "castDelay": 0,
        "animationSpeed": 0.9,
        "animationDuration": 1.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Revitalize",
        "description": "Heal the target for <b>5</b> health. Additionally, heal the target for <b>3</b> health every <b>4</b> seconds for <b>16</b> seconds.",
        "icon": "9dd102533952fff409deba3aa8b99840",
        "usableBy": "05000000",
        "cooldown": 0,
        "castTime": 1.5,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "027489edcf0967b4c9cd9e38e44be6cf",
            "type": 2
        }
    }
};
$669e76e8ee6de68a$exports.getImport = (guid)=>{
    switch(guid){
        case "9dd102533952fff409deba3aa8b99840":
            return 0, (/*@__PURE__*/$parcel$interopDefault($147cb5d10ee04061$exports));
    }
};


var $76d305e3d33214a3$exports = {};
var $c6cd283e0af22a65$exports = {};
$c6cd283e0af22a65$exports = new URL("root.4c03bc9f.png", import.meta.url).toString();


$76d305e3d33214a3$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "Root",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "038adfb581b6c7e46885cbe249190c23",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 8300000,
            "guid": "46f394b80779f0040a4c88bce842f006",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 0,
        "castDelay": 0,
        "animationSpeed": 0.395,
        "animationDuration": 1.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Root",
        "description": "<b>Snare</b> the target in place for <b>10</b> seconds. The effect will break if over <b>20</b> damage is dealt to the target.",
        "icon": "575859cdc3f08734796c86629fa25819",
        "usableBy": "05000000",
        "cooldown": 2,
        "castTime": 1.5,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$76d305e3d33214a3$exports.getImport = (guid)=>{
    switch(guid){
        case "575859cdc3f08734796c86629fa25819":
            return 0, (/*@__PURE__*/$parcel$interopDefault($c6cd283e0af22a65$exports));
    }
};


var $b989222274112227$exports = {};
var $789ab15a96799f11$exports = {};
$789ab15a96799f11$exports = new URL("swiftnourishment.0d5188a2.png", import.meta.url).toString();


$b989222274112227$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "SwiftNourishment",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "038adfb581b6c7e46885cbe249190c23",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 14,
        "castDelay": 100,
        "animationSpeed": 2.5,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Swift Nourishment",
        "description": "Heal the target for <b>32</b> health.",
        "icon": "e83b4e1886823cf4d96edec47cfa12c2",
        "usableBy": null,
        "cooldown": 28,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "027489edcf0967b4c9cd9e38e44be6cf",
            "type": 2
        }
    }
};
$b989222274112227$exports.getImport = (guid)=>{
    switch(guid){
        case "e83b4e1886823cf4d96edec47cfa12c2":
            return 0, (/*@__PURE__*/$parcel$interopDefault($789ab15a96799f11$exports));
    }
};


var $b9e26d8376fb634b$exports = {};
var $eb5f61edd63c7f3a$exports = {};
$eb5f61edd63c7f3a$exports = new URL("swiftrenewal.2eddbd0d.png", import.meta.url).toString();


$b9e26d8376fb634b$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "SwiftRenewal",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "038adfb581b6c7e46885cbe249190c23",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 14,
        "castDelay": 100,
        "animationSpeed": 2.5,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Swift Renewal",
        "description": "Heal the target for <b>18</b> health. The target must have <b>Regeneration</b> applied first.",
        "icon": "e7eac03f6ee848448b2d6b3d8808bccd",
        "usableBy": "05000000",
        "cooldown": 13,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "027489edcf0967b4c9cd9e38e44be6cf",
            "type": 2
        }
    }
};
$b9e26d8376fb634b$exports.getImport = (guid)=>{
    switch(guid){
        case "e7eac03f6ee848448b2d6b3d8808bccd":
            return 0, (/*@__PURE__*/$parcel$interopDefault($eb5f61edd63c7f3a$exports));
    }
};


var $0ff1529b2855bf51$exports = {};
var $29bcf441dd1600ca$exports = {};
$29bcf441dd1600ca$exports = new URL("thickskin.4eb9f76c.png", import.meta.url).toString();


$0ff1529b2855bf51$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "ThickSkin",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "038adfb581b6c7e46885cbe249190c23",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 14,
        "castDelay": 100,
        "animationSpeed": 2.5,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Thick Skin",
        "description": "Reduce all incoming damage by <b>40%</b> for <b>6</b> seconds. Can be cast while <b>Stunned</b> or <b>Incapacitated</b>.",
        "icon": "74d2cb3126fd9ad41b95bcbfc11e5f7f",
        "usableBy": "050000000e000000",
        "cooldown": 35,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "9799ddaee87d0194fb063b42fe7ef8d2",
            "type": 2
        }
    }
};
$0ff1529b2855bf51$exports.getImport = (guid)=>{
    switch(guid){
        case "74d2cb3126fd9ad41b95bcbfc11e5f7f":
            return 0, (/*@__PURE__*/$parcel$interopDefault($29bcf441dd1600ca$exports));
    }
};


var $fcacf25694a49461$exports = {};
var $b924195dd4e48633$exports = {};
$b924195dd4e48633$exports = new URL("thunderfire.ea49eab9.png", import.meta.url).toString();


$fcacf25694a49461$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "ThunderFire",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 727422648304881800,
            "guid": "a9f11eefd58c0244ba94098589ebf7db",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 8300000,
            "guid": "46f394b80779f0040a4c88bce842f006",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 21,
        "castDelay": 0,
        "animationSpeed": 0.52,
        "animationDuration": 2.7,
        "skipCooldownOnChannel": 0,
        "spellName": "Thunder Fire",
        "description": "Deal <b>30</b> damage to the target.",
        "icon": "055b45ae4c103324a9e9f59c2ecc1950",
        "usableBy": "0e000000",
        "cooldown": 0,
        "castTime": 2.5,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$fcacf25694a49461$exports.getImport = (guid)=>{
    switch(guid){
        case "055b45ae4c103324a9e9f59c2ecc1950":
            return 0, (/*@__PURE__*/$parcel$interopDefault($b924195dd4e48633$exports));
    }
};


var $f93ed4e53370a22a$exports = {};
var $84e58221825787cc$exports = {};
$84e58221825787cc$exports = new URL("dash.ebcd855c.png", import.meta.url).toString();


$f93ed4e53370a22a$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "Dash",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 88,
        "castDelay": 0,
        "animationSpeed": 1,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Dash",
        "description": "Dash forward <b>20</b> yards. Any targets in your path take <b>10</b> damage and bleed for <b>5</b> damage a second for <b>9</b> seconds. Gain <b>1</b> combo point for each target hit.",
        "icon": "98ac4f5f246f2a242a1944b8332fac48",
        "usableBy": "0a000000",
        "cooldown": 25,
        "castTime": 0.25,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100017,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "e8baebc57f5f1034ea06ad779c0e5f31",
            "type": 3
        }
    }
};
$f93ed4e53370a22a$exports.getImport = (guid)=>{
    switch(guid){
        case "98ac4f5f246f2a242a1944b8332fac48":
            return 0, (/*@__PURE__*/$parcel$interopDefault($84e58221825787cc$exports));
    }
};


var $5db44d82ef201cc2$exports = {};
var $2e5a58b7c8825f0c$exports = {};
$2e5a58b7c8825f0c$exports = new URL("scatteredattacks.52e0e460.png", import.meta.url).toString();


$5db44d82ef201cc2$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "ScatteredAttacks",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 9,
        "castDelay": 330,
        "animationSpeed": 1,
        "animationDuration": 0.8,
        "skipCooldownOnChannel": 0,
        "spellName": "Scattered Attacks",
        "description": "All direct damage you deal for <b>10</b> seconds will also hit up to one nearby target.",
        "icon": "faeb347b8fe7aca4582ba3b5fb2e8e4d",
        "usableBy": null,
        "cooldown": 30,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100052,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "3789f0c844c33144a8965a48a0565c7d",
            "type": 3
        }
    }
};
$5db44d82ef201cc2$exports.getImport = (guid)=>{
    switch(guid){
        case "faeb347b8fe7aca4582ba3b5fb2e8e4d":
            return 0, (/*@__PURE__*/$parcel$interopDefault($2e5a58b7c8825f0c$exports));
    }
};


var $1333675f9043cb8c$exports = {};
var $e4ccd63b017345dd$exports = {};
$e4ccd63b017345dd$exports = new URL("bruiserrogue.e9eeb464.png", import.meta.url).toString();


$1333675f9043cb8c$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "Slam",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 113,
        "castDelay": 50,
        "animationSpeed": 1,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Slam",
        "description": "Slam down on your target, dealing <b>25</b> damage and stunning them for <b>4</b> seconds. Must be cast after double jumping. Awards <b>1</b> combo point.",
        "icon": "852a8a2a1bdbf0a42a6827a6227021a6",
        "cooldown": 25,
        "castTime": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100016,
        "usableBy": "0a000000",
        "luaScript": {
            "fileID": 4900000,
            "guid": "67220f1141174204487eb86fbc257b18",
            "type": 3
        }
    }
};
$1333675f9043cb8c$exports.getImport = (guid)=>{
    switch(guid){
        case "852a8a2a1bdbf0a42a6827a6227021a6":
            return 0, (/*@__PURE__*/$parcel$interopDefault($e4ccd63b017345dd$exports));
    }
};


var $097079c0d4cecb3a$exports = {};
var $6466bbb40a6c1d6b$exports = {};
$6466bbb40a6c1d6b$exports = new URL("darkdamage.313bd36a.png", import.meta.url).toString();


$097079c0d4cecb3a$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "DarkDamage",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "7f1c197a232a3d345aaa061a8840dedd",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 8300000,
            "guid": "2c783095a3b2c8a4fa8cae902699c577",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 262,
        "castDelay": 0,
        "animationSpeed": 0.64,
        "animationDuration": 1.8,
        "skipCooldownOnChannel": 0,
        "spellName": "Essence Burst",
        "description": "Deal <b>15</b> damage to the target. Your first cast every <b>15</b> seconds will also <b>Stun</b> the target for <b>3</b> seconds.",
        "icon": "1fdd2763b0fc2f449b24cae23b04b7a0",
        "usableBy": "08000000",
        "cooldown": 0,
        "castTime": 1.4,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100006,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "a8650d35974c05c4dba85a436775c2cf",
            "type": 3
        }
    }
};
$097079c0d4cecb3a$exports.getImport = (guid)=>{
    switch(guid){
        case "1fdd2763b0fc2f449b24cae23b04b7a0":
            return 0, (/*@__PURE__*/$parcel$interopDefault($6466bbb40a6c1d6b$exports));
    }
};


var $6370869c5eb53097$exports = {};
var $d92473a3b7869481$exports = {};
$d92473a3b7869481$exports = new URL("darkdot.b9c5683a.png", import.meta.url).toString();


$6370869c5eb53097$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "DarkDot",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "7f1c197a232a3d345aaa061a8840dedd",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "2836c0e6012a3e94e90f1174c296b6fc",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 26,
        "castDelay": 450,
        "animationSpeed": 3.5,
        "animationDuration": 0.7,
        "skipCooldownOnChannel": 0,
        "spellName": "Ethereal Binding",
        "description": "Bind yourself with a target, taking <b>1</b> health from yourself to heal the target for <b>4</b> every <b>0.25</b> seconds for <b>7</b> seconds.",
        "icon": "14a2185b5873b0f4d9f532a9be06ccb5",
        "usableBy": "08000000",
        "cooldown": 34,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "027489edcf0967b4c9cd9e38e44be6cf",
            "type": 2
        },
        "spellKey": 100004,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "8fb9e87f397dabb4d833b8de1148b943",
            "type": 3
        }
    }
};
$6370869c5eb53097$exports.getImport = (guid)=>{
    switch(guid){
        case "14a2185b5873b0f4d9f532a9be06ccb5":
            return 0, (/*@__PURE__*/$parcel$interopDefault($d92473a3b7869481$exports));
    }
};


var $e1d9e04940ea5898$exports = {};
var $b88bdb025397943e$exports = {};
$b88bdb025397943e$exports = new URL("darkheal.469c6cc8.png", import.meta.url).toString();


$e1d9e04940ea5898$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "DarkHeal",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "7f1c197a232a3d345aaa061a8840dedd",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 8300000,
            "guid": "2c783095a3b2c8a4fa8cae902699c577",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 12,
        "castDelay": 0,
        "animationSpeed": 0.65,
        "animationDuration": 1.2,
        "skipCooldownOnChannel": 0,
        "spellName": "Soul Sacrifice",
        "description": "Consume <b>10%</b> of your current health to heal your target for <b>35</b>.",
        "icon": "1a308b929a29e904ab24e52ceff3fff5",
        "usableBy": "08000000",
        "cooldown": 0,
        "castTime": 1,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "dc869fafcb67be64f9817b3529f844ae",
            "type": 2
        },
        "spellKey": 100001,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "9139b5b0f081364488cabf1d034242a1",
            "type": 3
        }
    }
};
$e1d9e04940ea5898$exports.getImport = (guid)=>{
    switch(guid){
        case "1a308b929a29e904ab24e52ceff3fff5":
            return 0, (/*@__PURE__*/$parcel$interopDefault($b88bdb025397943e$exports));
    }
};


var $84fc648daf3129c9$exports = {};
var $7457e9da96675bb4$exports = {};
$7457e9da96675bb4$exports = new URL("darkmending.10b81ff8.png", import.meta.url).toString();


$84fc648daf3129c9$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "DarkMending",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "7f1c197a232a3d345aaa061a8840dedd",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 8300000,
            "guid": "2c783095a3b2c8a4fa8cae902699c577",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 44,
        "castDelay": 0,
        "animationSpeed": 0.6,
        "animationDuration": 1.2,
        "skipCooldownOnChannel": 0,
        "spellName": "Soul Steal",
        "description": "Consume <b>10%</b> of your target's health to heal yourself for <b>35</b>.",
        "icon": "88141249bef60e34abe2f814c5ab1cd6",
        "usableBy": "08000000",
        "cooldown": 0,
        "castTime": 1,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "dc869fafcb67be64f9817b3529f844ae",
            "type": 2
        },
        "spellKey": 100003,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "193436816404c3b4489f81d13679889c",
            "type": 3
        }
    }
};
$84fc648daf3129c9$exports.getImport = (guid)=>{
    switch(guid){
        case "88141249bef60e34abe2f814c5ab1cd6":
            return 0, (/*@__PURE__*/$parcel$interopDefault($7457e9da96675bb4$exports));
    }
};


var $47e31dae65e3b133$exports = {};
var $6fc1aaeeb57632eb$exports = {};
$6fc1aaeeb57632eb$exports = new URL("darkshield.74a5271c.png", import.meta.url).toString();


$47e31dae65e3b133$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "DarkShield",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "7f1c197a232a3d345aaa061a8840dedd",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "2836c0e6012a3e94e90f1174c296b6fc",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 22,
        "castDelay": 450,
        "animationSpeed": 3,
        "animationDuration": 0.55,
        "skipCooldownOnChannel": 0,
        "spellName": "Soul Shield",
        "description": "Consume <b>5%</b> of your current health to shield your target for <b>50</b>.",
        "icon": "0e9d99d7aa1cc1642a2fc5e61fd2f06d",
        "usableBy": "08000000",
        "cooldown": 13,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "027489edcf0967b4c9cd9e38e44be6cf",
            "type": 2
        },
        "spellKey": 100002,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "926a2342ab4d1b74cb2c8dfc8fe8a33a",
            "type": 3
        }
    }
};
$47e31dae65e3b133$exports.getImport = (guid)=>{
    switch(guid){
        case "0e9d99d7aa1cc1642a2fc5e61fd2f06d":
            return 0, (/*@__PURE__*/$parcel$interopDefault($6fc1aaeeb57632eb$exports));
    }
};


var $363f84e8f7ae61a1$exports = {};
var $dacb70d82f47f189$exports = {};
$dacb70d82f47f189$exports = new URL("darksuppression.34ff0728.png", import.meta.url).toString();


$363f84e8f7ae61a1$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "DarkSuppression",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "7f1c197a232a3d345aaa061a8840dedd",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "2836c0e6012a3e94e90f1174c296b6fc",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 22,
        "castDelay": 450,
        "animationSpeed": 3,
        "animationDuration": 0.55,
        "skipCooldownOnChannel": 0,
        "spellName": "Dark Suppression",
        "description": "IInstantly remove all <b>Slows</b> and reduce all damage taken by <b>90%</b>. The effect lasts <b>5</b> seconds or until any other spell is cast. Can be cast while <b>Stunned</b>, <b>Incapacitated</b>, or <b>Silenced</b>.",
        "icon": "dfa8586691105d846b2d434d94b692e5",
        "usableBy": "08000000",
        "cooldown": 60,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100007,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "4f2c56c1997de8d4da4dd1258bb7138a",
            "type": 3
        }
    }
};
$363f84e8f7ae61a1$exports.getImport = (guid)=>{
    switch(guid){
        case "dfa8586691105d846b2d434d94b692e5":
            return 0, (/*@__PURE__*/$parcel$interopDefault($dacb70d82f47f189$exports));
    }
};


var $673773ee6160675b$exports = {};
var $2f365f4bc3acaa2e$exports = {};
$2f365f4bc3acaa2e$exports = new URL("instantheal.bd4d9f5e.png", import.meta.url).toString();


$673773ee6160675b$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "InstantHeal",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "7f1c197a232a3d345aaa061a8840dedd",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "2836c0e6012a3e94e90f1174c296b6fc",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 37,
        "castDelay": 225,
        "animationSpeed": 3.2,
        "animationDuration": 0.4,
        "skipCooldownOnChannel": 0,
        "spellName": "Soul Recovery",
        "description": "Instantly heal <b>50%</b> of the target's missing health.",
        "icon": "6dd37b0599960ba4a854b4cfca495918",
        "usableBy": "08000000",
        "cooldown": 45,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "027489edcf0967b4c9cd9e38e44be6cf",
            "type": 2
        },
        "spellKey": 100005,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "4f5c5500255fe274bbee3da6d59f0679",
            "type": 3
        }
    }
};
$673773ee6160675b$exports.getImport = (guid)=>{
    switch(guid){
        case "6dd37b0599960ba4a854b4cfca495918":
            return 0, (/*@__PURE__*/$parcel$interopDefault($2f365f4bc3acaa2e$exports));
    }
};


var $f19a4ac4723ae7fc$exports = {};

$f19a4ac4723ae7fc$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "InstantHealImproved",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "7f1c197a232a3d345aaa061a8840dedd",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "2836c0e6012a3e94e90f1174c296b6fc",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 37,
        "castDelay": 450,
        "animationSpeed": 1.6,
        "animationDuration": 0.8,
        "skipCooldownOnChannel": 0,
        "spellName": "Soul Recovery",
        "description": "Instantly heal <b>75%</b> of the target's missing health.",
        "icon": "6dd37b0599960ba4a854b4cfca495918",
        "usableBy": null,
        "cooldown": 37,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "027489edcf0967b4c9cd9e38e44be6cf",
            "type": 2
        }
    }
};
$f19a4ac4723ae7fc$exports.getImport = (guid)=>{
    switch(guid){
        case "6dd37b0599960ba4a854b4cfca495918":
            return 0, (/*@__PURE__*/$parcel$interopDefault($2f365f4bc3acaa2e$exports));
    }
};


var $67391804ad26c91b$exports = {};
var $3c9ec4c6a4aa622d$exports = {};
$3c9ec4c6a4aa622d$exports = new URL("soulsiphon.cb6c3c81.png", import.meta.url).toString();


$67391804ad26c91b$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "SoulSiphon",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "7f1c197a232a3d345aaa061a8840dedd",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "2836c0e6012a3e94e90f1174c296b6fc",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 432,
        "castDelay": 400,
        "animationSpeed": 1.1,
        "animationDuration": 1.2,
        "skipCooldownOnChannel": 0,
        "spellName": "Soul Siphon",
        "description": "Deal <b>6</b> damage to your target every <b>3</b> seconds for <b>18</b> seconds.",
        "icon": "21ced9b8d65d7fb42ab0a74cabd34d1c",
        "usableBy": "08000000",
        "cooldown": 18,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100049,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "82f91f3da9c5c994d9eb7fca1f107d89",
            "type": 3
        }
    }
};
$67391804ad26c91b$exports.getImport = (guid)=>{
    switch(guid){
        case "21ced9b8d65d7fb42ab0a74cabd34d1c":
            return 0, (/*@__PURE__*/$parcel$interopDefault($3c9ec4c6a4aa622d$exports));
    }
};


var $accacbd677c8e407$exports = {};
var $b68064e0770be003$exports = {};
$b68064e0770be003$exports = new URL("soulswap.3ba8c0e7.png", import.meta.url).toString();


$accacbd677c8e407$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "SoulSwap",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "7f1c197a232a3d345aaa061a8840dedd",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "2836c0e6012a3e94e90f1174c296b6fc",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 35,
        "castDelay": 550,
        "animationSpeed": 1.2,
        "animationDuration": 0.8,
        "skipCooldownOnChannel": 0,
        "spellName": "Soul Swap",
        "description": "Swap health percentages with a friendly target",
        "icon": "d9971ea9d4051b948aa3f0d8f8ae70e0",
        "usableBy": null,
        "cooldown": 24,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "dc869fafcb67be64f9817b3529f844ae",
            "type": 2
        },
        "spellKey": 100047,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "15996b561880f7e489ea64a0b8fdf676",
            "type": 3
        }
    }
};
$accacbd677c8e407$exports.getImport = (guid)=>{
    switch(guid){
        case "d9971ea9d4051b948aa3f0d8f8ae70e0":
            return 0, (/*@__PURE__*/$parcel$interopDefault($b68064e0770be003$exports));
    }
};


var $180c6d69ce51f3f9$exports = {};
var $e8f5811fd6e7e008$exports = {};
$e8f5811fd6e7e008$exports = new URL("spiritsector.b9939322.png", import.meta.url).toString();


$180c6d69ce51f3f9$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "SpiritSector",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "7f1c197a232a3d345aaa061a8840dedd",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 8300000,
            "guid": "2c783095a3b2c8a4fa8cae902699c577",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 323,
        "castDelay": 150,
        "animationSpeed": 2,
        "animationDuration": 0.4,
        "skipCooldownOnChannel": 0,
        "spellName": "Spirit Sector",
        "description": "Create a <b>Spirit Sector</b>. Any teammates in the <b>Spirit Sector</b> will take <b>20%</b> less damage. Lasts <b>10</b> seconds.",
        "icon": "4c194d689d04caf4993e635d42b3be3f",
        "usableBy": "08000000",
        "cooldown": 24,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 8,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "49714b7747fcdd245a2a48451ad05657",
            "type": 2
        },
        "spellKey": 100048,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "f760ce282a4fedc4283efc7330de2b44",
            "type": 3
        }
    }
};
$180c6d69ce51f3f9$exports.getImport = (guid)=>{
    switch(guid){
        case "4c194d689d04caf4993e635d42b3be3f":
            return 0, (/*@__PURE__*/$parcel$interopDefault($e8f5811fd6e7e008$exports));
    }
};


var $90d65f5328942161$exports = {};
var $39444bdf1c7c0537$exports = {};
$39444bdf1c7c0537$exports = new URL("crystalblast.1199c4c5.png", import.meta.url).toString();


$90d65f5328942161$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "CrystalBlast",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "b1e3c0f02d3d52e4282044628720bede",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 8300000,
            "guid": "c6a46772a396efa4c95545ff89c47323",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 22,
        "castDelay": 350,
        "animationSpeed": 4,
        "animationDuration": 0.7,
        "skipCooldownOnChannel": 0,
        "spellName": "Crystal Blast",
        "description": "Deal <b>10</b> damage and <b>Stun</b> all enemies within <b>6</b> yards of the targeted area for <b>3</b> seconds.",
        "icon": "d7c2298a565d7cc41b2a8fe0ffb0d680",
        "usableBy": "09000000",
        "cooldown": 30,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 6,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "49714b7747fcdd245a2a48451ad05657",
            "type": 2
        },
        "spellKey": 100014,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "057dde6365dd2204c9d246081cc615c3",
            "type": 3
        }
    }
};
$90d65f5328942161$exports.getImport = (guid)=>{
    switch(guid){
        case "d7c2298a565d7cc41b2a8fe0ffb0d680":
            return 0, (/*@__PURE__*/$parcel$interopDefault($39444bdf1c7c0537$exports));
    }
};


var $e27f3b157274a035$exports = {};
var $203a73d670a70c4c$exports = {};
$203a73d670a70c4c$exports = new URL("crystalbreath.2eb02852.png", import.meta.url).toString();


$e27f3b157274a035$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "CrystalBreath",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "b1e3c0f02d3d52e4282044628720bede",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "c6a46772a396efa4c95545ff89c47323",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 15,
        "castDelay": 240,
        "animationSpeed": 2.7,
        "animationDuration": 0.7,
        "skipCooldownOnChannel": 0,
        "spellName": "Crystal Breath",
        "description": "Deal <b>18</b> damage and <b>Incapacitate</b> all targets in a cone in front of you for <b>5</b> seconds. Any damage dealt will break the effect.",
        "icon": "45d1cea6dc009cf40893a6b593303eba",
        "usableBy": null,
        "cooldown": 28,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100051,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "2ccb1f54149fb664e821eb6693fc67e2",
            "type": 3
        }
    }
};
$e27f3b157274a035$exports.getImport = (guid)=>{
    switch(guid){
        case "45d1cea6dc009cf40893a6b593303eba":
            return 0, (/*@__PURE__*/$parcel$interopDefault($203a73d670a70c4c$exports));
    }
};


var $149818ad8be12625$exports = {};
var $e87f443b00091ea5$exports = {};
$e87f443b00091ea5$exports = new URL("crystalhaste.0bc2bb3c.png", import.meta.url).toString();


$149818ad8be12625$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "CrystalHaste",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "b1e3c0f02d3d52e4282044628720bede",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "c6a46772a396efa4c95545ff89c47323",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 22,
        "castDelay": 450,
        "animationSpeed": 3,
        "animationDuration": 0.55,
        "skipCooldownOnChannel": 0,
        "spellName": "Crystal Haste",
        "description": "Reduce the global cooldown by <b>35%</b> for <b>10</b> seconds.",
        "icon": "1941c5e37e4b6244a8db2b32b03115d3",
        "usableBy": "09000000",
        "cooldown": 60,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100015,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "5fb933e1831182c4388c3bca5a6da5de",
            "type": 3
        }
    }
};
$149818ad8be12625$exports.getImport = (guid)=>{
    switch(guid){
        case "1941c5e37e4b6244a8db2b32b03115d3":
            return 0, (/*@__PURE__*/$parcel$interopDefault($e87f443b00091ea5$exports));
    }
};


var $a9db216868dc75e4$exports = {};
var $8271675f988303ca$exports = {};
$8271675f988303ca$exports = new URL("crystalshield.b5476743.png", import.meta.url).toString();


$a9db216868dc75e4$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "CrystalShield",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "b1e3c0f02d3d52e4282044628720bede",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "c6a46772a396efa4c95545ff89c47323",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 22,
        "castDelay": 550,
        "animationSpeed": 2.6,
        "animationDuration": 0.8,
        "skipCooldownOnChannel": 0,
        "spellName": "Crystal Shield",
        "description": "Shield yourself for <b>30</b> damage. Requires at least one <b>Pure Crystal</b> charge, but it is not consumed.",
        "icon": "8ce153400b1f76740a9ba581aa5a5956",
        "usableBy": "09000000",
        "cooldown": 30,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100012,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "1ebbdfc30ec9f684c8d443ddbb4f9cd4",
            "type": 3
        }
    }
};
$a9db216868dc75e4$exports.getImport = (guid)=>{
    switch(guid){
        case "8ce153400b1f76740a9ba581aa5a5956":
            return 0, (/*@__PURE__*/$parcel$interopDefault($8271675f988303ca$exports));
    }
};


var $0f36a10cda6d22f4$exports = {};
var $5d4aaa5b7e107040$exports = {};
$5d4aaa5b7e107040$exports = new URL("firecrystal.6d2fabef.png", import.meta.url).toString();


$0f36a10cda6d22f4$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "FireCrystal1",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "c6cb37df2c0db6e47b38d20f306e416a",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 13,
        "castDelay": 180,
        "animationSpeed": 1.8,
        "animationDuration": 0.4,
        "skipCooldownOnChannel": 0,
        "spellName": "Fire Crystal",
        "description": "<b>First Cast</b>: Deal <b>15</b> magic damage. Must be in melee range. Gain one <b>Fire Crystal</b>.\n\n<b>Second cast</b>: Deal <b>31</b> magic damage. Gain one <b>Fire Crystal</b>.\n\n<b>Third cast</b>: Deal <b>16</b> magic damage to all enemies within <b>8</b> yards of the target. Gain one <b>Fire Crystal</b>.\n\n<b>Fourth cast</b>: Unleash all <b>Fire Crystals</b> at 75% effectiveness with a <b>1.5</b> second cast time.",
        "icon": "ff6e288a238c87c49870f9735a1f78f9",
        "usableBy": "09000000",
        "cooldown": 3,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100009,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "14b2e0fb4cddc4040868da0317b6b6e1",
            "type": 3
        }
    }
};
$0f36a10cda6d22f4$exports.getImport = (guid)=>{
    switch(guid){
        case "ff6e288a238c87c49870f9735a1f78f9":
            return 0, (/*@__PURE__*/$parcel$interopDefault($5d4aaa5b7e107040$exports));
    }
};


var $a21269dd9a102054$exports = {};

$a21269dd9a102054$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "FireCrystal2",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "c6cb37df2c0db6e47b38d20f306e416a",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 13,
        "castDelay": 180,
        "animationSpeed": 1.8,
        "animationDuration": 0.4,
        "skipCooldownOnChannel": 0,
        "spellName": "Fire Crystal",
        "description": "<b>First Cast</b>: Deal <b>15</b> magic damage. Must be in melee range. Gain one <b>Fire Crystal</b>.\n\n<b>Second cast</b>: Deal <b>31</b> magic damage. Gain one <b>Fire Crystal</b>.\n\n<b>Third cast</b>: Deal <b>16</b> magic damage to all enemies within <b>8</b> yards of the target. Gain one <b>Fire Crystal</b>.\n\n<b>Fourth cast</b>: Unleash all <b>Fire Crystals</b> at 75% effectiveness with a <b>1.5</b> second cast time.",
        "icon": "ff6e288a238c87c49870f9735a1f78f9",
        "usableBy": "09000000",
        "cooldown": 3,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100036,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "c0772eeeb586b314886927d820e84b1d",
            "type": 3
        }
    }
};
$a21269dd9a102054$exports.getImport = (guid)=>{
    switch(guid){
        case "ff6e288a238c87c49870f9735a1f78f9":
            return 0, (/*@__PURE__*/$parcel$interopDefault($5d4aaa5b7e107040$exports));
    }
};


var $a98c811cbaf2b1ab$exports = {};

$a98c811cbaf2b1ab$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "FireCrystal3",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "c6cb37df2c0db6e47b38d20f306e416a",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 13,
        "castDelay": 180,
        "animationSpeed": 1.8,
        "animationDuration": 0.4,
        "skipCooldownOnChannel": 0,
        "spellName": "Fire Crystal",
        "description": "<b>First Cast</b>: Deal <b>15</b> magic damage. Must be in melee range. Gain one <b>Fire Crystal</b>.\n\n<b>Second cast</b>: Deal <b>31</b> magic damage. Gain one <b>Fire Crystal</b>.\n\n<b>Third cast</b>: Deal <b>16</b> magic damage to all enemies within <b>8</b> yards of the target. Gain one <b>Fire Crystal</b>.\n\n<b>Fourth cast</b>: Unleash all <b>Fire Crystals</b> at 75% effectiveness with a <b>1.5</b> second cast time.",
        "icon": "ff6e288a238c87c49870f9735a1f78f9",
        "usableBy": "09000000",
        "cooldown": 3,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100037,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "f6bbd414396fe544fbda0a6dbf73814d",
            "type": 3
        }
    }
};
$a98c811cbaf2b1ab$exports.getImport = (guid)=>{
    switch(guid){
        case "ff6e288a238c87c49870f9735a1f78f9":
            return 0, (/*@__PURE__*/$parcel$interopDefault($5d4aaa5b7e107040$exports));
    }
};


var $e0aa940cc0e30e79$exports = {};

$e0aa940cc0e30e79$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "FireCrystal4",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.05,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "188ccd91914323f48a7ff9686cb3242a",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 8300000,
            "guid": "3f776ba755ba71341bb3f527c8369c60",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 0,
        "castDelay": 0,
        "animationSpeed": 0.32,
        "animationDuration": 2,
        "skipCooldownOnChannel": 0,
        "spellName": "Fire Crystal",
        "description": "<b>First Cast</b>: Deal <b>15</b> magic damage. Must be in melee range. Gain one <b>Fire Crystal</b>.\n\n<b>Second cast</b>: Deal <b>31</b> magic damage. Gain one <b>Fire Crystal</b>.\n\n<b>Third cast</b>: Deal <b>16</b> magic damage to all enemies within <b>8</b> yards of the target. Gain one <b>Fire Crystal</b>.\n\n<b>Fourth cast</b>: Unleash all <b>Fire Crystals</b> at 75% effectiveness with a <b>1.5</b> second cast time.",
        "icon": "ff6e288a238c87c49870f9735a1f78f9",
        "usableBy": "09000000",
        "cooldown": 0,
        "castTime": 1.8,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100038,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "f4cf22be6fcd0ef4bbe058c8fc6c0704",
            "type": 3
        }
    }
};
$e0aa940cc0e30e79$exports.getImport = (guid)=>{
    switch(guid){
        case "ff6e288a238c87c49870f9735a1f78f9":
            return 0, (/*@__PURE__*/$parcel$interopDefault($5d4aaa5b7e107040$exports));
    }
};


var $60f31c73bcd7e230$exports = {};
var $3fc8155443f6fc2f$exports = {};
$3fc8155443f6fc2f$exports = new URL("frostcrystal.aefa94d7.png", import.meta.url).toString();


$60f31c73bcd7e230$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "FrostCrystal1",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "31f0c923b7b660e47938376fb189e949",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 13,
        "castDelay": 180,
        "animationSpeed": 1.8,
        "animationDuration": 0.4,
        "skipCooldownOnChannel": 0,
        "spellName": "Frost Crystal",
        "description": "<b>First Cast</b>: Deal <b>10</b> magic damage and slow the target by <b>50%</b> for <b>8</b> seconds. Must be in melee range. Gain one <b>Frost Crystal</b>.\n\n<b>Second cast</b>: Deal <b>22</b> magic damage and slow the target by <b>50%</b> for <b>8</b> seconds. Snares the target in place for <b>8</b> seconds upon impact. Gain one <b>Frost Crystal</b>.\n\n<b>Third cast</b>: Project a Frost Orb which moves slowly towards your target and damages and slows all targets in its radius. Gain one <b>Frost Crystal</b>.\n\n<b>Fourth cast</b>: Unleash all <b>Frost Crystals</b> at <b>75%</b> effectiveness with a <b>1</b> second cast time.",
        "icon": "11f18a9c024828a4f8771bddef8a06b6",
        "usableBy": "09000000",
        "cooldown": 3,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100010,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "44784d5f3ef83794eb2be950438b7243",
            "type": 3
        }
    }
};
$60f31c73bcd7e230$exports.getImport = (guid)=>{
    switch(guid){
        case "11f18a9c024828a4f8771bddef8a06b6":
            return 0, (/*@__PURE__*/$parcel$interopDefault($3fc8155443f6fc2f$exports));
    }
};


var $c998ddcfb70175cd$exports = {};

$c998ddcfb70175cd$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "FrostCrystal2",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "31f0c923b7b660e47938376fb189e949",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 13,
        "castDelay": 180,
        "animationSpeed": 1.8,
        "animationDuration": 0.4,
        "skipCooldownOnChannel": 0,
        "spellName": "Frost Crystal",
        "description": "<b>First Cast</b>: Deal <b>10</b> magic damage and slow the target by <b>50%</b> for <b>8</b> seconds. Must be in melee range. Gain one <b>Frost Crystal</b>.\n\n<b>Second cast</b>: Deal <b>22</b> magic damage and slow the target by <b>50%</b> for <b>8</b> seconds. Snares the target in place for <b>8</b> seconds upon impact. Gain one <b>Frost Crystal</b>.\n\n<b>Third cast</b>: Project a Frost Orb which moves slowly towards your target and damages and slows all targets in its radius. Gain one <b>Frost Crystal</b>.\n\n<b>Fourth cast</b>: Unleash all <b>Frost Crystals</b> at <b>75%</b> effectiveness with a <b>1</b> second cast time.",
        "icon": "11f18a9c024828a4f8771bddef8a06b6",
        "usableBy": "09000000",
        "cooldown": 3,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100042,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "8fe0b6d9ced302a4ca10b86e6d10c45e",
            "type": 3
        }
    }
};
$c998ddcfb70175cd$exports.getImport = (guid)=>{
    switch(guid){
        case "11f18a9c024828a4f8771bddef8a06b6":
            return 0, (/*@__PURE__*/$parcel$interopDefault($3fc8155443f6fc2f$exports));
    }
};


var $1af4f064ca5789fd$exports = {};

$1af4f064ca5789fd$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "FrostCrystal3",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "31f0c923b7b660e47938376fb189e949",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 13,
        "castDelay": 180,
        "animationSpeed": 1.8,
        "animationDuration": 0.4,
        "skipCooldownOnChannel": 0,
        "spellName": "Frost Crystal",
        "description": "<b>First Cast</b>: Deal <b>10</b> magic damage and slow the target by <b>50%</b> for <b>8</b> seconds. Must be in melee range. Gain one <b>Frost Crystal</b>.\n\n<b>Second cast</b>: Deal <b>22</b> magic damage and slow the target by <b>50%</b> for <b>8</b> seconds. Snares the target in place for <b>8</b> seconds upon impact. Gain one <b>Frost Crystal</b>.\n\n<b>Third cast</b>: Project a Frost Orb which moves slowly towards your target and damages and slows all targets in its radius. Gain one <b>Frost Crystal</b>.\n\n<b>Fourth cast</b>: Unleash all <b>Frost Crystals</b> at <b>75%</b> effectiveness with a <b>1</b> second cast time.",
        "icon": "11f18a9c024828a4f8771bddef8a06b6",
        "usableBy": "09000000",
        "cooldown": 3,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100043,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "469d5499017831445aff9ef9eaba238a",
            "type": 3
        }
    }
};
$1af4f064ca5789fd$exports.getImport = (guid)=>{
    switch(guid){
        case "11f18a9c024828a4f8771bddef8a06b6":
            return 0, (/*@__PURE__*/$parcel$interopDefault($3fc8155443f6fc2f$exports));
    }
};


var $2f0d40801f094b88$exports = {};

$2f0d40801f094b88$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "FrostCrystal4",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.05,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "627bba32f0250004d89cec8e6388f690",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 8300000,
            "guid": "e2ba9e05eab44f348b73e583715738ec",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 0,
        "castDelay": 0,
        "animationSpeed": 0.38,
        "animationDuration": 1.75,
        "skipCooldownOnChannel": 0,
        "spellName": "Frost Crystal",
        "description": "<b>First Cast</b>: Deal <b>10</b> magic damage and slow the target by <b>50%</b> for <b>8</b> seconds. Must be in melee range. Gain one <b>Frost Crystal</b>.\n\n<b>Second cast</b>: Deal <b>22</b> magic damage and slow the target by <b>50%</b> for <b>8</b> seconds. Snares the target in place for <b>8</b> seconds upon impact. Gain one <b>Frost Crystal</b>.\n\n<b>Third cast</b>: Project a Frost Orb which moves slowly towards your target and damages and slows all targets in its radius. Gain one <b>Frost Crystal</b>.\n\n<b>Fourth cast</b>: Unleash all <b>Frost Crystals</b> at <b>75%</b> effectiveness with a <b>1</b> second cast time.",
        "icon": "11f18a9c024828a4f8771bddef8a06b6",
        "usableBy": "09000000",
        "cooldown": 0,
        "castTime": 1.5,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100044,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "34114106b7bf4244b8eb2804e5cfb40a",
            "type": 3
        }
    }
};
$2f0d40801f094b88$exports.getImport = (guid)=>{
    switch(guid){
        case "11f18a9c024828a4f8771bddef8a06b6":
            return 0, (/*@__PURE__*/$parcel$interopDefault($3fc8155443f6fc2f$exports));
    }
};


var $3691082ae11ca3ae$exports = {};

$3691082ae11ca3ae$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "InstantPenguinify",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "b1e3c0f02d3d52e4282044628720bede",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "c6a46772a396efa4c95545ff89c47323",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 13,
        "castDelay": 180,
        "animationSpeed": 1.8,
        "animationDuration": 0.4,
        "skipCooldownOnChannel": 0,
        "spellName": "Penguinify",
        "description": "<b>Incapacitate</b> the target for <b>10</b> seconds. Any damage dealt will break the effect. Consumes <b>2 Pure Crystals</b> upon cast.",
        "icon": "39033e69610f5294c853d3f02164fa45",
        "usableBy": "09000000",
        "cooldown": 38,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100013,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "2eb4312a86d19574a9004d770148085b",
            "type": 3
        }
    }
};
$3691082ae11ca3ae$exports.getImport = (guid)=>{
    switch(guid){
        case "39033e69610f5294c853d3f02164fa45":
            return 0, (/*@__PURE__*/$parcel$interopDefault($91869d151fcd1b12$exports));
    }
};


var $cf635747ff5cf3ee$exports = {};
var $8fe238c8989cce4d$exports = {};
$8fe238c8989cce4d$exports = new URL("mendingcrystals.6fd1c15e.png", import.meta.url).toString();


$cf635747ff5cf3ee$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "MendingCrystals",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "b1e3c0f02d3d52e4282044628720bede",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "c6a46772a396efa4c95545ff89c47323",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 22,
        "castDelay": 450,
        "animationSpeed": 2.88,
        "animationDuration": 0.55,
        "skipCooldownOnChannel": 0,
        "spellName": "Mending Crystals",
        "description": "Consume all of your crystals. Heal for <b>10</b> health per crystal consumed.",
        "icon": "b7342470691e5144e9f86ef67a8e76c6",
        "usableBy": null,
        "cooldown": 9,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100050,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "6795c6493326f3249be1a58c3f9090ec",
            "type": 3
        }
    }
};
$cf635747ff5cf3ee$exports.getImport = (guid)=>{
    switch(guid){
        case "b7342470691e5144e9f86ef67a8e76c6":
            return 0, (/*@__PURE__*/$parcel$interopDefault($8fe238c8989cce4d$exports));
    }
};


var $ef46766426ef1980$exports = {};
var $e74e2607a5198edc$exports = {};
$e74e2607a5198edc$exports = new URL("purecrystal.44fbdb7b.png", import.meta.url).toString();


$ef46766426ef1980$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "PureCrystal1",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "b1e3c0f02d3d52e4282044628720bede",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "c6a46772a396efa4c95545ff89c47323",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 301,
        "castDelay": 200,
        "animationSpeed": 1.5,
        "animationDuration": 0.4,
        "skipCooldownOnChannel": 0,
        "spellName": "Pure Crystal",
        "description": "<b>First Cast</b>: Throw a pure crystal at the target, dealing <b>8</b> damage and teleporting you to it on impact. Gain one <b>Pure Crystal</b>.\n\n<b>Second Cast</b>: Deal <b>15</b> damage to all enemies in a 10 yard radius. Gain one <b>Pure Crystal</b>.\n\n<b>Third Cast</b>: Deal <b>18</b> damage and throw a crystal 40 yards through the target, teleporting to it upon impact. Gain one <b>Pure Crystal</b>.\n\n<b>Fourth Cast</b>: Instantly unleash all <b>Pure Crystals</b> at <b>75%</b> effectiveness.",
        "icon": "4122ebf4377dff94aa873fccd45d739f",
        "usableBy": "09000000",
        "cooldown": 3,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100011,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "eb302eae4b189eb48a4d3739db70b166",
            "type": 3
        }
    }
};
$ef46766426ef1980$exports.getImport = (guid)=>{
    switch(guid){
        case "4122ebf4377dff94aa873fccd45d739f":
            return 0, (/*@__PURE__*/$parcel$interopDefault($e74e2607a5198edc$exports));
    }
};


var $8ac959bda4df36bf$exports = {};

$8ac959bda4df36bf$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "PureCrystal2",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "b1e3c0f02d3d52e4282044628720bede",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "c6a46772a396efa4c95545ff89c47323",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 301,
        "castDelay": 200,
        "animationSpeed": 1.5,
        "animationDuration": 0.4,
        "skipCooldownOnChannel": 0,
        "spellName": "Pure Crystal",
        "description": "<b>First Cast</b>: Throw a pure crystal at the target, dealing <b>8</b> damage and teleporting you to it on impact. Gain one <b>Pure Crystal</b>.\n\n<b>Second Cast</b>: Deal <b>15</b> damage to all enemies in a 10 yard radius. Gain one <b>Pure Crystal</b>.\n\n<b>Third Cast</b>: Deal <b>18</b> damage and throw a crystal 40 yards through the target, teleporting to it upon impact. Gain one <b>Pure Crystal</b>.\n\n<b>Fourth Cast</b>: Instantly unleash all <b>Pure Crystals</b> at <b>75%</b> effectiveness.",
        "icon": "4122ebf4377dff94aa873fccd45d739f",
        "usableBy": "09000000",
        "cooldown": 3,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100039,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "ff135f9886b90e24dae1c27c6e901449",
            "type": 3
        }
    }
};
$8ac959bda4df36bf$exports.getImport = (guid)=>{
    switch(guid){
        case "4122ebf4377dff94aa873fccd45d739f":
            return 0, (/*@__PURE__*/$parcel$interopDefault($e74e2607a5198edc$exports));
    }
};


var $d33fb2c233bdf6dc$exports = {};

$d33fb2c233bdf6dc$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "PureCrystal3",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "b1e3c0f02d3d52e4282044628720bede",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "c6a46772a396efa4c95545ff89c47323",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 301,
        "castDelay": 200,
        "animationSpeed": 1.5,
        "animationDuration": 0.4,
        "skipCooldownOnChannel": 0,
        "spellName": "Pure Crystal",
        "description": "<b>First Cast</b>: Throw a pure crystal at the target, dealing <b>8</b> damage and teleporting you to it on impact. Gain one <b>Pure Crystal</b>.\n\n<b>Second Cast</b>: Deal <b>15</b> damage to all enemies in a 10 yard radius. Gain one <b>Pure Crystal</b>.\n\n<b>Third Cast</b>: Deal <b>18</b> damage and throw a crystal 40 yards through the target, teleporting to it upon impact. Gain one <b>Pure Crystal</b>.\n\n<b>Fourth Cast</b>: Instantly unleash all <b>Pure Crystals</b> at <b>75%</b> effectiveness.",
        "icon": "4122ebf4377dff94aa873fccd45d739f",
        "usableBy": "09000000",
        "cooldown": 3,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100040,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "111f3d1715d2abf49aadd221d33d8695",
            "type": 3
        }
    }
};
$d33fb2c233bdf6dc$exports.getImport = (guid)=>{
    switch(guid){
        case "4122ebf4377dff94aa873fccd45d739f":
            return 0, (/*@__PURE__*/$parcel$interopDefault($e74e2607a5198edc$exports));
    }
};


var $7d49187d9bfd42ac$exports = {};

$7d49187d9bfd42ac$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "PureCrystal4",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "b1e3c0f02d3d52e4282044628720bede",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "c6a46772a396efa4c95545ff89c47323",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 301,
        "castDelay": 200,
        "animationSpeed": 1.5,
        "animationDuration": 0.4,
        "skipCooldownOnChannel": 0,
        "spellName": "Pure Crystal",
        "description": "<b>First Cast</b>: Throw a pure crystal at the target, dealing <b>8</b> damage and teleporting you to it on impact. Gain one <b>Pure Crystal</b>.\n\n<b>Second Cast</b>: Deal <b>15</b> damage to all enemies in a 10 yard radius. Gain one <b>Pure Crystal</b>.\n\n<b>Third Cast</b>: Deal <b>18</b> damage and throw a crystal 40 yards through the target, teleporting to it upon impact. Gain one <b>Pure Crystal</b>.\n\n<b>Fourth Cast</b>: Instantly unleash all <b>Pure Crystals</b> at <b>75%</b> effectiveness.",
        "icon": "4122ebf4377dff94aa873fccd45d739f",
        "usableBy": "09000000",
        "cooldown": 3,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100041,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "ac44b3b333d57144589f6ea7791abe26",
            "type": 3
        }
    }
};
$7d49187d9bfd42ac$exports.getImport = (guid)=>{
    switch(guid){
        case "4122ebf4377dff94aa873fccd45d739f":
            return 0, (/*@__PURE__*/$parcel$interopDefault($e74e2607a5198edc$exports));
    }
};


var $c352e69ecf062f4f$exports = {};
var $a3c9c3af934bf630$exports = {};
$a3c9c3af934bf630$exports = new URL("absorption.43660af9.png", import.meta.url).toString();


$c352e69ecf062f4f$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "Absorption",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 14,
        "castDelay": 280,
        "animationSpeed": 2,
        "animationDuration": 0.6,
        "skipCooldownOnChannel": 0,
        "spellName": "Absorption",
        "description": "Shield yourself for <b>40</b> damage. The effect lasts <b>3</b> seconds. Can be cast while <b>Stunned</b>, <b>Incapacitated</b> or <b>Silenced</b>.",
        "icon": "4d0db9b4483a3964598aec629e0bc5cc",
        "usableBy": null,
        "cooldown": 60,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "a8cd7cc6f0212db4a8228be1ba9145b6",
            "type": 2
        }
    }
};
$c352e69ecf062f4f$exports.getImport = (guid)=>{
    switch(guid){
        case "4d0db9b4483a3964598aec629e0bc5cc":
            return 0, (/*@__PURE__*/$parcel$interopDefault($a3c9c3af934bf630$exports));
    }
};


var $d8975e56c68b67a9$exports = {};
var $231e7148fef07f6a$exports = {};
$231e7148fef07f6a$exports = new URL("bandage.9781b769.png", import.meta.url).toString();


$d8975e56c68b67a9$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "Bandage",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 4,
        "animationVariation": 0,
        "castDelay": 0,
        "animationSpeed": 1,
        "animationDuration": 10,
        "skipCooldownOnChannel": 0,
        "spellName": "Bandage",
        "description": "Heal yourself for <b>20</b> health immediately, and <b>20</b> health every second for <b>10</b> seconds. Any action taken or damage taken will stop the effect.",
        "icon": "4a07413e37c2a914a8ec79111132b41a",
        "usableBy": null,
        "cooldown": 60,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$d8975e56c68b67a9$exports.getImport = (guid)=>{
    switch(guid){
        case "4a07413e37c2a914a8ec79111132b41a":
            return 0, (/*@__PURE__*/$parcel$interopDefault($231e7148fef07f6a$exports));
    }
};


var $86d561435e131e2d$exports = {};
var $70b937c96eb48fcd$exports = {};
$70b937c96eb48fcd$exports = new URL("chainbreaker.8abed712.png", import.meta.url).toString();


$86d561435e131e2d$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "ChainBreaker",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 323,
        "castDelay": 120,
        "animationSpeed": 2,
        "animationDuration": 0.6,
        "skipCooldownOnChannel": 0,
        "spellName": "Chain Breaker",
        "description": "Instantly remove all <b>Incapactitates</b>, <b>Stuns</b>, <b>Slows</b> and <b>Snares</b> from your Titan. \n\nCannot be used during <b>Boss Fights</b>.",
        "icon": "d84d0caef9bf6d743976e7918dac0a33",
        "usableBy": "000000000100000002000000030000000400000005000000060000000700000008000000090000000a0000000b0000000c0000000d0000000e0000000f00000011000000",
        "cooldown": 80,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$86d561435e131e2d$exports.getImport = (guid)=>{
    switch(guid){
        case "d84d0caef9bf6d743976e7918dac0a33":
            return 0, (/*@__PURE__*/$parcel$interopDefault($70b937c96eb48fcd$exports));
    }
};


var $14378970f0cf8a03$exports = {};
var $d1c441d41babcb6c$exports = {};
$d1c441d41babcb6c$exports = new URL("mountcancel.5b3e4ac1.png", import.meta.url).toString();


$14378970f0cf8a03$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "Dismount",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 5,
        "animationVariation": 0,
        "castDelay": 0,
        "animationSpeed": 1,
        "animationDuration": 0,
        "skipCooldownOnChannel": 0,
        "spellName": "Dismount",
        "description": "Dismount",
        "icon": "93256ea590f5e3740a414b96b01a3b0b",
        "usableBy": "000000000100000002000000030000000400000005000000060000000700000008000000090000000a0000000b0000000c0000000d0000000e0000000f000000",
        "cooldown": 1,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$14378970f0cf8a03$exports.getImport = (guid)=>{
    switch(guid){
        case "93256ea590f5e3740a414b96b01a3b0b":
            return 0, (/*@__PURE__*/$parcel$interopDefault($d1c441d41babcb6c$exports));
    }
};


var $562abdeaec5e0b5a$exports = {};
$562abdeaec5e0b5a$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "EmoteDance",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 6,
        "animationVariation": 1,
        "castDelay": 100,
        "animationSpeed": 0.8,
        "animationDuration": 0,
        "skipCooldownOnChannel": 0,
        "spellName": "Dance",
        "description": "Dance",
        "icon": {
            "fileID": 2800000,
            "guid": "a013a40035f9af24eaca850616908423",
            "type": 3
        },
        "usableBy": "000000000100000002000000030000000400000005000000060000000700000008000000090000000a0000000b0000000c0000000d0000000e0000000f000000",
        "cooldown": 1,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "a8cd7cc6f0212db4a8228be1ba9145b6",
            "type": 2
        },
        "spellKey": 100025,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "60307befb2328374aa47e14efb554d7f",
            "type": 3
        }
    }
};
$562abdeaec5e0b5a$exports.getImport = (guid)=>{
    guid;
};


var $ef0f7859e3ca383b$exports = {};
var $5f7aa0778a36ef5c$exports = {};
$5f7aa0778a36ef5c$exports = new URL("enhancedpower.ab4ffa3e.png", import.meta.url).toString();


$ef0f7859e3ca383b$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "EnhancedPower",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 9,
        "castDelay": 150,
        "animationSpeed": 1.3,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Enhanced Power",
        "description": "Increase all damage you deal by <b>15%</b> for <b>10</b> seconds.",
        "icon": "f08703c0e0b5e85428c8acb805f46cdb",
        "usableBy": null,
        "cooldown": 45,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "a8cd7cc6f0212db4a8228be1ba9145b6",
            "type": 2
        }
    }
};
$ef0f7859e3ca383b$exports.getImport = (guid)=>{
    switch(guid){
        case "f08703c0e0b5e85428c8acb805f46cdb":
            return 0, (/*@__PURE__*/$parcel$interopDefault($5f7aa0778a36ef5c$exports));
    }
};


var $052ebbe76fecac9f$exports = {};
var $606bf04962894e57$exports = {};
$606bf04962894e57$exports = new URL("enhancedresilience.3ef06ce4.png", import.meta.url).toString();


$052ebbe76fecac9f$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "EnhancedResilience",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 9,
        "castDelay": 150,
        "animationSpeed": 1.3,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Enhanced Resilience",
        "description": "Reduce all damage taken by <b>30%</b> for <b>8</b> seconds. Can be cast while <b>Stunned</b>, <b>Incapacitated</b> or <b>Silenced</b>.",
        "icon": "be563552db2414f4dabb5815ce6437e8",
        "usableBy": null,
        "cooldown": 80,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "a8cd7cc6f0212db4a8228be1ba9145b6",
            "type": 2
        }
    }
};
$052ebbe76fecac9f$exports.getImport = (guid)=>{
    switch(guid){
        case "be563552db2414f4dabb5815ce6437e8":
            return 0, (/*@__PURE__*/$parcel$interopDefault($606bf04962894e57$exports));
    }
};


var $a02107f45b7b1684$exports = {};
$a02107f45b7b1684$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "Jump",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 2,
        "animationVariation": 2,
        "castDelay": 100,
        "animationSpeed": 0.8,
        "animationDuration": 0.2,
        "skipCooldownOnChannel": 0,
        "spellName": "Jump",
        "description": "Jump.",
        "icon": {
            "fileID": 0
        },
        "usableBy": "000000000100000002000000030000000400000005000000060000000700000008000000090000000a0000000b0000000c0000000d0000000e0000000f000000",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 1,
        "spellType": {
            "fileID": 11400000,
            "guid": "91266f2c466c90d4fb0037a50ff4f7d6",
            "type": 2
        }
    }
};
$a02107f45b7b1684$exports.getImport = (guid)=>{
    guid;
};


var $ae258f0dd8271f79$exports = {};
var $cd2509d4eb768a36$exports = {};
$cd2509d4eb768a36$exports = new URL("masterofbattle.66a48892.png", import.meta.url).toString();


$ae258f0dd8271f79$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "MasterofBattle",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 20,
        "castDelay": 380,
        "animationSpeed": 3,
        "animationDuration": 0.7,
        "skipCooldownOnChannel": 0,
        "spellName": "Master of Battle",
        "description": "Instantly heal for <b>40</b> health.",
        "icon": "c84298cd4493ff542bd947f816a88b50",
        "usableBy": null,
        "cooldown": 60,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "a8cd7cc6f0212db4a8228be1ba9145b6",
            "type": 2
        }
    }
};
$ae258f0dd8271f79$exports.getImport = (guid)=>{
    switch(guid){
        case "c84298cd4493ff542bd947f816a88b50":
            return 0, (/*@__PURE__*/$parcel$interopDefault($cd2509d4eb768a36$exports));
    }
};


var $bfa8619f75fb8d5e$exports = {};
var $fd2892ade9f29bbb$exports = {};
$fd2892ade9f29bbb$exports = new URL("meditation.fafafa26.png", import.meta.url).toString();


$bfa8619f75fb8d5e$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "Meditation",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 5,
        "animationVariation": 0,
        "castDelay": 0,
        "animationSpeed": 1,
        "animationDuration": 30,
        "skipCooldownOnChannel": 0,
        "spellName": "Meditation",
        "description": "When used, sit down and heal <b>30</b> health every <b>3</b> seconds. Must not be in <b>Combat</b> to use. Any action taken or damage taken will stop the effect.",
        "icon": "24aaba64d039e7347b4c082e1231efc5",
        "usableBy": null,
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "a8cd7cc6f0212db4a8228be1ba9145b6",
            "type": 2
        }
    }
};
$bfa8619f75fb8d5e$exports.getImport = (guid)=>{
    switch(guid){
        case "24aaba64d039e7347b4c082e1231efc5":
            return 0, (/*@__PURE__*/$parcel$interopDefault($fd2892ade9f29bbb$exports));
    }
};


var $edafe1e66951570d$exports = {};
var $509ee571fdf0fb1b$exports = {};
$509ee571fdf0fb1b$exports = new URL("mount.04e47eca.png", import.meta.url).toString();


$edafe1e66951570d$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "Mount",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 8300000,
            "guid": "61932a98031a8014685b4598a7858066",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 4,
        "animationVariation": 0,
        "castDelay": 0,
        "animationSpeed": 0.5,
        "animationDuration": 1.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Mount",
        "description": "Mount up, increasing movement speed by 100%. Any spell cast will dismount you.",
        "icon": "10574bc17976a0e4fb39ef3f781232da",
        "usableBy": "000000000100000002000000030000000400000005000000060000000700000008000000090000000a0000000b0000000c0000000d0000000e0000000f00000011000000",
        "cooldown": 0,
        "castTime": 1.5,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$edafe1e66951570d$exports.getImport = (guid)=>{
    switch(guid){
        case "10574bc17976a0e4fb39ef3f781232da":
            return 0, (/*@__PURE__*/$parcel$interopDefault($509ee571fdf0fb1b$exports));
    }
};


var $a2ec348dd9ad3b03$exports = {};
var $1e2e4be6edc6cd31$exports = {};
$1e2e4be6edc6cd31$exports = new URL("longincap.9e7d1e38.png", import.meta.url).toString();


$a2ec348dd9ad3b03$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "LongIncap",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "c6cb37df2c0db6e47b38d20f306e416a",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 8300000,
            "guid": "2c783095a3b2c8a4fa8cae902699c577",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 356,
        "castDelay": 0,
        "animationSpeed": 1.5,
        "animationDuration": 0.8,
        "skipCooldownOnChannel": 0,
        "spellName": "Soul Tether",
        "description": "Place an orb at the targeted location that binds with your target, <b>Incapacitating</b> them for <b>10</b> seconds. If anyone steps on the orb, it will break the effect. If any damage is dealt to the target, it will break the effect.",
        "icon": "cf94875e2d335e945be76e5cf0370372",
        "usableBy": "0c000000",
        "cooldown": 20,
        "castTime": 0.5,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 1,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "4463a0bf39618d546a32d217dd4e2516",
            "type": 2
        },
        "spellKey": 100031,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "f0323aafe07f0844f957ded7ac5d3634",
            "type": 3
        }
    }
};
$a2ec348dd9ad3b03$exports.getImport = (guid)=>{
    switch(guid){
        case "cf94875e2d335e945be76e5cf0370372":
            return 0, (/*@__PURE__*/$parcel$interopDefault($1e2e4be6edc6cd31$exports));
    }
};


var $05646709fc3aa670$exports = {};
var $963592b88b0c9028$exports = {};
$963592b88b0c9028$exports = new URL("pestulantdevastation.1cdee15b.png", import.meta.url).toString();


$05646709fc3aa670$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "PestulantDevastation",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "e140a1d299338b14a8f4463a4862358b",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 8300000,
            "guid": "2c783095a3b2c8a4fa8cae902699c577",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 135,
        "castDelay": 0,
        "animationSpeed": 0.32,
        "animationDuration": 1.7,
        "skipCooldownOnChannel": 0,
        "spellName": "Pestilent Devastation",
        "description": "Deal <b>10</b> damage instantly, then <b>8</b> damage every <b>2</b> seconds for <b>12</b> seconds.",
        "icon": "4b302a6cbb6957440a3198eb588fbeca",
        "usableBy": "0c000000",
        "cooldown": 0,
        "castTime": 1.2,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100027,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "fcae517920c4d794ebcc50d02717e4b6",
            "type": 3
        }
    }
};
$05646709fc3aa670$exports.getImport = (guid)=>{
    switch(guid){
        case "4b302a6cbb6957440a3198eb588fbeca":
            return 0, (/*@__PURE__*/$parcel$interopDefault($963592b88b0c9028$exports));
    }
};


var $04a7b2195674a2ad$exports = {};

$04a7b2195674a2ad$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "PestulantDevastationImproved",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "e140a1d299338b14a8f4463a4862358b",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 8300000,
            "guid": "2c783095a3b2c8a4fa8cae902699c577",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 135,
        "castDelay": 0,
        "animationSpeed": 0.384,
        "animationDuration": 1.4,
        "skipCooldownOnChannel": 0,
        "spellName": "Pestilent Devastation",
        "description": "Deal <b>10</b> damage instantly, then <b>8</b> damage every <b>2</b> seconds for <b>18</b> seconds.",
        "icon": "4b302a6cbb6957440a3198eb588fbeca",
        "usableBy": null,
        "cooldown": 0,
        "castTime": 1,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$04a7b2195674a2ad$exports.getImport = (guid)=>{
    switch(guid){
        case "4b302a6cbb6957440a3198eb588fbeca":
            return 0, (/*@__PURE__*/$parcel$interopDefault($963592b88b0c9028$exports));
    }
};


var $118d4be54cea0a1b$exports = {};
var $08110898f60f6651$exports = {};
$08110898f60f6651$exports = new URL("residualimplosion.3f45593d.png", import.meta.url).toString();


$118d4be54cea0a1b$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "ResidualImplosion",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "c6cb37df2c0db6e47b38d20f306e416a",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "c6a46772a396efa4c95545ff89c47323",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 356,
        "castDelay": 450,
        "animationSpeed": 1.5,
        "animationDuration": 0.8,
        "skipCooldownOnChannel": 0,
        "spellName": "Residual Implosion",
        "description": "Deal <b>24</b> damage to the target and slow them by <b>50%</b> for <b>8</b> seconds. The target must have <b>Pestilent Devastation</b> applied.",
        "icon": "65b585752fad6ff46849bb3991aaa32f",
        "usableBy": "0c000000",
        "cooldown": 10,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100028,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "a65387cf0412c91488a2958fd2de08e0",
            "type": 3
        }
    }
};
$118d4be54cea0a1b$exports.getImport = (guid)=>{
    switch(guid){
        case "65b585752fad6ff46849bb3991aaa32f":
            return 0, (/*@__PURE__*/$parcel$interopDefault($08110898f60f6651$exports));
    }
};


var $fa11fc2a7725786f$exports = {};
var $1589a414dd70673f$exports = {};
$1589a414dd70673f$exports = new URL("shadowspike.b57e4804.png", import.meta.url).toString();


$fa11fc2a7725786f$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "Shadowspike",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "c6cb37df2c0db6e47b38d20f306e416a",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "c6a46772a396efa4c95545ff89c47323",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 356,
        "castDelay": 450,
        "animationSpeed": 1.5,
        "animationDuration": 0.8,
        "skipCooldownOnChannel": 0,
        "spellName": "Shadowspike",
        "description": "Deal <b>10</b> damage to the target. Deal an additional <b>15</b> damage if the target is below <b>30%</b> health.",
        "icon": "adead562ad85909448e0aacac4f5366a",
        "usableBy": null,
        "cooldown": 22,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100055,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "77526d94b64723942adf43fbc070d10a",
            "type": 3
        }
    }
};
$fa11fc2a7725786f$exports.getImport = (guid)=>{
    switch(guid){
        case "adead562ad85909448e0aacac4f5366a":
            return 0, (/*@__PURE__*/$parcel$interopDefault($1589a414dd70673f$exports));
    }
};


var $c55ced727d240320$exports = {};
var $b59103e693d71735$exports = {};
$b59103e693d71735$exports = new URL("verdantpyre.b9d4969a.png", import.meta.url).toString();


$c55ced727d240320$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "VerdantPyre",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "47c3a89d05c5e5548a6e1b93393aad7f",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 1,
        "castSound": {
            "fileID": 8300000,
            "guid": "2c783095a3b2c8a4fa8cae902699c577",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 309,
        "castDelay": 0,
        "animationSpeed": 0.4,
        "animationDuration": 1.7,
        "skipCooldownOnChannel": 0,
        "spellName": "Verdant Pyre",
        "description": "Deal <b>12</b> damage to the target.",
        "icon": "c8a600ddf59452e45852d85e432dc158",
        "usableBy": "0c000000",
        "cooldown": 0,
        "castTime": 1.5,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100029,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "7585e4302f5122d478f857139ff4e460",
            "type": 3
        }
    }
};
$c55ced727d240320$exports.getImport = (guid)=>{
    switch(guid){
        case "c8a600ddf59452e45852d85e432dc158":
            return 0, (/*@__PURE__*/$parcel$interopDefault($b59103e693d71735$exports));
    }
};


var $e6ca5a91ae6d7003$exports = {};

$e6ca5a91ae6d7003$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "VerdantPyreInstant",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "e140a1d299338b14a8f4463a4862358b",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "c6a46772a396efa4c95545ff89c47323",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 309,
        "castDelay": 350,
        "animationSpeed": 1.2,
        "animationDuration": 0.6,
        "skipCooldownOnChannel": 0,
        "spellName": "Verdant Pyre",
        "description": "Deal <b>12</b> damage to the target.",
        "icon": "c8a600ddf59452e45852d85e432dc158",
        "usableBy": "0c000000",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100054,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "2d46676a9fe4f3340947786a72a4cf62",
            "type": 3
        }
    }
};
$e6ca5a91ae6d7003$exports.getImport = (guid)=>{
    switch(guid){
        case "c8a600ddf59452e45852d85e432dc158":
            return 0, (/*@__PURE__*/$parcel$interopDefault($b59103e693d71735$exports));
    }
};


var $c765e1c3a4a3a68c$exports = {};
var $8943a0213be610c1$exports = {};
$8943a0213be610c1$exports = new URL("virulenteruption.4bfb3b9f.png", import.meta.url).toString();


$c765e1c3a4a3a68c$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "VirulentEruption",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "b1e3c0f02d3d52e4282044628720bede",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "c6a46772a396efa4c95545ff89c47323",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 21,
        "castDelay": 450,
        "animationSpeed": 2.2,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Virulent Eruption",
        "description": "Deal <b>13</b> damage and <b>Stun</b> all enemies in a <b>8</b> yard radius at the targeted location for <b>3</b> seconds.",
        "icon": "242d2ed074ec33543b021df1127530eb",
        "usableBy": "0c000000",
        "cooldown": 26,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 8,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "49714b7747fcdd245a2a48451ad05657",
            "type": 2
        },
        "spellKey": 100030,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "8219d4e10ac3eed43a6c787af851f961",
            "type": 3
        }
    }
};
$c765e1c3a4a3a68c$exports.getImport = (guid)=>{
    switch(guid){
        case "242d2ed074ec33543b021df1127530eb":
            return 0, (/*@__PURE__*/$parcel$interopDefault($8943a0213be610c1$exports));
    }
};


var $1a3795c116a960b3$exports = {};
var $a30d9a7f1a8769f3$exports = {};
$a30d9a7f1a8769f3$exports = new URL("eradicatorwarlock.a8d70769.png", import.meta.url).toString();


$1a3795c116a960b3$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "VirulentOrb",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "47c3a89d05c5e5548a6e1b93393aad7f",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 1,
        "castSound": {
            "fileID": 8300000,
            "guid": "2c783095a3b2c8a4fa8cae902699c577",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 24,
        "castDelay": 0,
        "animationSpeed": 0.9,
        "animationDuration": 1.7,
        "skipCooldownOnChannel": 0,
        "spellName": "Virulent Orb",
        "description": "Deal <b>33</b> damage to the target. This will deal <b>42</b> damage if <b>Pestulant Devastation</b> is active on the target.",
        "icon": "2afc2cef1f7eba649b9367de7507b854",
        "usableBy": "0c000000",
        "cooldown": 8,
        "castTime": 1.5,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100026,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "9af3316181deac94e8b5850a64087361",
            "type": 3
        }
    }
};
$1a3795c116a960b3$exports.getImport = (guid)=>{
    switch(guid){
        case "2afc2cef1f7eba649b9367de7507b854":
            return 0, (/*@__PURE__*/$parcel$interopDefault($a30d9a7f1a8769f3$exports));
    }
};


var $5c7ee4e377f9db4f$exports = {};
var $94d7465c5663bf7a$exports = {};
$94d7465c5663bf7a$exports = new URL("innerrage.1a2726c5.png", import.meta.url).toString();


$5c7ee4e377f9db4f$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "InnerRage",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 22,
        "castDelay": 400,
        "animationSpeed": 4,
        "animationDuration": 0.6,
        "skipCooldownOnChannel": 0,
        "spellName": "Inner Rage",
        "description": "Deal <b>35%</b> more physical damage for the next <b>5</b> seconds.",
        "icon": "1048ef2b4c1d07042b95619c25149c99",
        "usableBy": "0b000000",
        "cooldown": 75,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100020,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "e9d642d4a9d525a4ca9d254d67d71296",
            "type": 3
        }
    }
};
$5c7ee4e377f9db4f$exports.getImport = (guid)=>{
    switch(guid){
        case "1048ef2b4c1d07042b95619c25149c99":
            return 0, (/*@__PURE__*/$parcel$interopDefault($94d7465c5663bf7a$exports));
    }
};


var $0f25348cac52bfc1$exports = {};
var $47ef7507f17606f3$exports = {};
$47ef7507f17606f3$exports = new URL("leap.2c3efd8b.png", import.meta.url).toString();


$0f25348cac52bfc1$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "Leap",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "38939067706f25947b6a252ffec7753a",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 36,
        "castDelay": 0,
        "animationSpeed": 1.1,
        "animationDuration": 2.2,
        "skipCooldownOnChannel": 0,
        "spellName": "Leap",
        "description": "Leap to the targeted location, dealing <b>12</b> damage and slowing all enemies within <b>6</b> yards by <b>30%</b> for <b>8</b> seconds upon impact.",
        "icon": "73946e785106e4d429070471d7a5e4bb",
        "usableBy": "0b000000",
        "cooldown": 25,
        "castTime": 0.75,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 6,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "49714b7747fcdd245a2a48451ad05657",
            "type": 2
        },
        "spellKey": 100053,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "0248dd734f21dc543b47e75809a0f41d",
            "type": 3
        }
    }
};
$0f25348cac52bfc1$exports.getImport = (guid)=>{
    switch(guid){
        case "73946e785106e4d429070471d7a5e4bb":
            return 0, (/*@__PURE__*/$parcel$interopDefault($47ef7507f17606f3$exports));
    }
};


var $a9d3dd44cc5ad7ef$exports = {};
var $303a65f37cc30169$exports = {};
$303a65f37cc30169$exports = new URL("shockwave.2ac120ef.png", import.meta.url).toString();


$a9d3dd44cc5ad7ef$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "Shockwave",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 323,
        "castDelay": 300,
        "animationSpeed": 1.5,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Shockwave",
        "description": "Deal <b>18</b> damage and <b>Stun</b> all enemies within <b>6</b> yards for <b>3</b> seconds.",
        "icon": "fb89c9a5bbd394744bba26125cdcd4dd",
        "usableBy": "0b000000",
        "cooldown": 28,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100019,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "9f47a42fdf423bd47b150a8f0d3f4ed3",
            "type": 3
        }
    }
};
$a9d3dd44cc5ad7ef$exports.getImport = (guid)=>{
    switch(guid){
        case "fb89c9a5bbd394744bba26125cdcd4dd":
            return 0, (/*@__PURE__*/$parcel$interopDefault($303a65f37cc30169$exports));
    }
};


var $26063c2ba0aa7c80$exports = {};

$26063c2ba0aa7c80$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "ShockwaveShortCD",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 323,
        "castDelay": 300,
        "animationSpeed": 1.5,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Shockwave",
        "description": "Deal <b>18</b> damage and <b>Stun</b> all enemies within <b>6</b> yards for <b>4.5</b> seconds. <b>Stun</b> yourself for <b>1</b> second.",
        "icon": "fb89c9a5bbd394744bba26125cdcd4dd",
        "usableBy": "03000000",
        "cooldown": 24,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$26063c2ba0aa7c80$exports.getImport = (guid)=>{
    switch(guid){
        case "fb89c9a5bbd394744bba26125cdcd4dd":
            return 0, (/*@__PURE__*/$parcel$interopDefault($303a65f37cc30169$exports));
    }
};


var $2d316ed1499ea9cd$exports = {};
var $ee81878d5b625fe2$exports = {};
$ee81878d5b625fe2$exports = new URL("slash.03091c24.png", import.meta.url).toString();


$2d316ed1499ea9cd$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "Slash1",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "d456f70dbff661749a87d1f3288a9d8d",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 40,
        "castDelay": 0,
        "animationSpeed": 1.5,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Slash",
        "description": "<b>First Cast</b>: Slash forward, dealing 8 damage to the first target hit.\n\n<b>Second Cast</b>: Slash forward, dealing 12 damage to the first target hit.\n\n<b>Third Cast</b>: Leap forward, dealing 26 damage and stunning the first target hit for 3 seconds.",
        "icon": "4a614e9a23441a544a07a7b011cbc913",
        "usableBy": "0b000000",
        "cooldown": 1,
        "castTime": 0.25,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 1,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100018,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "3ce96710edc88d247aac7cbe32a47aeb",
            "type": 3
        }
    }
};
$2d316ed1499ea9cd$exports.getImport = (guid)=>{
    switch(guid){
        case "4a614e9a23441a544a07a7b011cbc913":
            return 0, (/*@__PURE__*/$parcel$interopDefault($ee81878d5b625fe2$exports));
    }
};


var $0c2ac4f82994301f$exports = {};

$0c2ac4f82994301f$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "Slash2",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.05,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "d44b46a27bd0a8f4e83641e36dffdc4b",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 41,
        "castDelay": 0,
        "animationSpeed": 1.5,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Slash",
        "description": "<b>First Cast</b>: Slash forward, dealing 8 damage to the first target hit.\n\n<b>Second Cast</b>: Slash forward, dealing 12 damage to the first target hit.\n\n<b>Third Cast</b>: Leap forward, dealing 26 damage and stunning the first target hit for 3 seconds.",
        "icon": "4a614e9a23441a544a07a7b011cbc913",
        "usableBy": "0b000000",
        "cooldown": 1,
        "castTime": 0.25,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 1,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100045,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "830b5171d02217b4eba097c7733f4251",
            "type": 3
        }
    }
};
$0c2ac4f82994301f$exports.getImport = (guid)=>{
    switch(guid){
        case "4a614e9a23441a544a07a7b011cbc913":
            return 0, (/*@__PURE__*/$parcel$interopDefault($ee81878d5b625fe2$exports));
    }
};


var $0c94ace0bcaf6b07$exports = {};

$0c94ace0bcaf6b07$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "Slash3",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.05,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "964fdba38affb6b458daf089802e5431",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 8300000,
            "guid": "f8ec7fedf0c58e64480639fc2c72608a",
            "type": 3
        },
        "afterChannelSoundDelay": 400,
        "animation": 0,
        "animationVariation": 32,
        "castDelay": 0,
        "animationSpeed": 1.5,
        "animationDuration": 1.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Slash",
        "description": "<b>First Cast</b>: Slash forward, dealing 8 damage to the first target hit.\n\n<b>Second Cast</b>: Slash forward, dealing 12 damage to the first target hit.\n\n<b>Third Cast</b>: Leap forward, dealing 26 damage and stunning the first target hit for 3 seconds.",
        "icon": "4a614e9a23441a544a07a7b011cbc913",
        "usableBy": "0b000000",
        "cooldown": 16,
        "castTime": 0.25,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 1,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100046,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "9d74c8d9aecd6a44aa529004bec2aa64",
            "type": 3
        }
    }
};
$0c94ace0bcaf6b07$exports.getImport = (guid)=>{
    switch(guid){
        case "4a614e9a23441a544a07a7b011cbc913":
            return 0, (/*@__PURE__*/$parcel$interopDefault($ee81878d5b625fe2$exports));
    }
};


var $40f2d315cc48b2a0$exports = {};
var $df05b75f2dd54dbd$exports = {};
$df05b75f2dd54dbd$exports = new URL("slice.e1cbbec6.png", import.meta.url).toString();


$40f2d315cc48b2a0$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "Slice",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 8300000,
            "guid": "ee793a397c7c8b841a9cc6a74d9cff7c",
            "type": 3
        },
        "castSoundVolume": 0.4,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 8300000,
            "guid": "ee793a397c7c8b841a9cc6a74d9cff7c",
            "type": 3
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 33,
        "castDelay": 0,
        "animationSpeed": 1.5,
        "animationDuration": 1.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Slice",
        "description": "Slice forward <b>20</b> yards. Any targets in your path take <b>10</b> damage and bleed for <b>4</b> damage every <b>2</b> seconds for <b>20</b> seconds.",
        "icon": "4844f73b629221244a95cef134b0be89",
        "usableBy": "0b000000",
        "cooldown": 20,
        "castTime": 0.8,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100021,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "b9ad019ab621fd2479604084efc3117d",
            "type": 3
        }
    }
};
$40f2d315cc48b2a0$exports.getImport = (guid)=>{
    switch(guid){
        case "4844f73b629221244a95cef134b0be89":
            return 0, (/*@__PURE__*/$parcel$interopDefault($df05b75f2dd54dbd$exports));
    }
};


var $e276e7e38dedf944$exports = {};
var $42690ba132f48523$exports = {};
$42690ba132f48523$exports = new URL("bigholysmite.587aac80.png", import.meta.url).toString();


$e276e7e38dedf944$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "BigHolySmite",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "ca4ffbb7fd64e3440b066bb5cbee0962",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 8300000,
            "guid": "115326b0a1d301d408b2a59db74f0093",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 21,
        "castDelay": 0,
        "animationSpeed": 1.3,
        "animationDuration": 1.2,
        "skipCooldownOnChannel": 0,
        "spellName": "Holy Smite",
        "description": "Deal <b>12</b> damage to the target. Once every <b>10</b> seconds, the cast time will be reduced by <b>0.5</b> seconds and it will deal <b>8</b> additional damage.",
        "icon": "8ade1d5b61f162349942266569680bf6",
        "usableBy": "02000000",
        "cooldown": 0,
        "castTime": 1,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$e276e7e38dedf944$exports.getImport = (guid)=>{
    switch(guid){
        case "8ade1d5b61f162349942266569680bf6":
            return 0, (/*@__PURE__*/$parcel$interopDefault($42690ba132f48523$exports));
    }
};


var $55146dd127878c0e$exports = {};
var $45dd914987f0213d$exports = {};
$45dd914987f0213d$exports = new URL("blessedlight.9a453ed9.png", import.meta.url).toString();


$55146dd127878c0e$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "BlessedLight",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "ca4ffbb7fd64e3440b066bb5cbee0962",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 25,
        "castDelay": 500,
        "animationSpeed": 1.8,
        "animationDuration": 1.6,
        "skipCooldownOnChannel": 0,
        "spellName": "Blessed Light",
        "description": "Channel <b>3</b> heals to the target over <b>1</b> second, each healing for <b>24</b>.",
        "icon": "3e70bf0113e400b4c95bb998d245badc",
        "usableBy": "02000000",
        "cooldown": 10,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 1,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "027489edcf0967b4c9cd9e38e44be6cf",
            "type": 2
        }
    }
};
$55146dd127878c0e$exports.getImport = (guid)=>{
    switch(guid){
        case "3e70bf0113e400b4c95bb998d245badc":
            return 0, (/*@__PURE__*/$parcel$interopDefault($45dd914987f0213d$exports));
    }
};


var $48c66bc1c6684f7a$exports = {};

$48c66bc1c6684f7a$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "BlessedLightImp",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "ca4ffbb7fd64e3440b066bb5cbee0962",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 25,
        "castDelay": 500,
        "animationSpeed": 1.8,
        "animationDuration": 1.6,
        "skipCooldownOnChannel": 0,
        "spellName": "Blessed Light",
        "description": "Channel <b>3</b> heals to the target over <b>1</b> second, each healing for <b>18</b>.",
        "icon": "3e70bf0113e400b4c95bb998d245badc",
        "usableBy": null,
        "cooldown": 8,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 1,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "027489edcf0967b4c9cd9e38e44be6cf",
            "type": 2
        }
    }
};
$48c66bc1c6684f7a$exports.getImport = (guid)=>{
    switch(guid){
        case "3e70bf0113e400b4c95bb998d245badc":
            return 0, (/*@__PURE__*/$parcel$interopDefault($45dd914987f0213d$exports));
    }
};


var $3c94e2ee0630f034$exports = {};
var $eab2126c9982734a$exports = {};
$eab2126c9982734a$exports = new URL("dispel.7571e580.png", import.meta.url).toString();


$3c94e2ee0630f034$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "Dispel",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "73c526bbb006fde49a6978e33b9c6786",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 14,
        "castDelay": 100,
        "animationSpeed": 2.5,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Sacred Cleansing",
        "description": "<b>Remove</b> an unfriendly buff from a friendly target.",
        "icon": "d2191d87fa1f1ad4e9d959085ac4ff23",
        "usableBy": "02000000070000000d000000",
        "cooldown": 2,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "027489edcf0967b4c9cd9e38e44be6cf",
            "type": 2
        }
    }
};
$3c94e2ee0630f034$exports.getImport = (guid)=>{
    switch(guid){
        case "d2191d87fa1f1ad4e9d959085ac4ff23":
            return 0, (/*@__PURE__*/$parcel$interopDefault($eab2126c9982734a$exports));
    }
};


var $e0e196d984c9b094$exports = {};
var $c4a3e82a21c54c82$exports = {};
$c4a3e82a21c54c82$exports = new URL("divineintervention.a3170b60.png", import.meta.url).toString();


$e0e196d984c9b094$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "DivineIntervention",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "73c526bbb006fde49a6978e33b9c6786",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 15,
        "castDelay": 150,
        "animationSpeed": 2.5,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Divine Intervention",
        "description": "Pull the friendly target towards you.",
        "icon": "7e1c24088b88378418a1139ae3ae2d85",
        "usableBy": null,
        "cooldown": 24,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "dc869fafcb67be64f9817b3529f844ae",
            "type": 2
        }
    }
};
$e0e196d984c9b094$exports.getImport = (guid)=>{
    switch(guid){
        case "7e1c24088b88378418a1139ae3ae2d85":
            return 0, (/*@__PURE__*/$parcel$interopDefault($c4a3e82a21c54c82$exports));
    }
};


var $a91164ab145bd66d$exports = {};
var $c5843df6e2648d6a$exports = {};
$c5843df6e2648d6a$exports = new URL("divinelight.2f2c1b1f.png", import.meta.url).toString();


$a91164ab145bd66d$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "DivineLight",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "ca4ffbb7fd64e3440b066bb5cbee0962",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 8300000,
            "guid": "115326b0a1d301d408b2a59db74f0093",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 27,
        "castDelay": 0,
        "animationSpeed": 0.72,
        "animationDuration": 3.3,
        "skipCooldownOnChannel": 0,
        "spellName": "Divine Light",
        "description": "Heal the target for <b>70</b> health.",
        "icon": "983fc0cd437e15746a00c8869c4d45cb",
        "usableBy": "02000000",
        "cooldown": 0,
        "castTime": 3,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "027489edcf0967b4c9cd9e38e44be6cf",
            "type": 2
        }
    }
};
$a91164ab145bd66d$exports.getImport = (guid)=>{
    switch(guid){
        case "983fc0cd437e15746a00c8869c4d45cb":
            return 0, (/*@__PURE__*/$parcel$interopDefault($c5843df6e2648d6a$exports));
    }
};


var $fe0c1e04a2db75f0$exports = {};
var $b8262990c60e003c$exports = {};
$b8262990c60e003c$exports = new URL("explosionoflight.7e8d4552.png", import.meta.url).toString();


$fe0c1e04a2db75f0$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "ExplosionOfLight",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "73c526bbb006fde49a6978e33b9c6786",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 22,
        "castDelay": 450,
        "animationSpeed": 3.3,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Explosion of Light",
        "description": "Deal <b>6</b> damage to all enemies within <b>8</b> yards. Additionally, heal all allies within <b>8</b> yards for <b>8</b> health.",
        "icon": "79eec3dcb8f30e44cad3ad6d193af0c9",
        "usableBy": "02000000",
        "cooldown": 3,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$fe0c1e04a2db75f0$exports.getImport = (guid)=>{
    switch(guid){
        case "79eec3dcb8f30e44cad3ad6d193af0c9":
            return 0, (/*@__PURE__*/$parcel$interopDefault($b8262990c60e003c$exports));
    }
};


var $5f51cc609123b866$exports = {};
var $7693133e87c52e69$exports = {};
$7693133e87c52e69$exports = new URL("fear.bbb2fe30.png", import.meta.url).toString();


$5f51cc609123b866$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "Fear",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "7f1c197a232a3d345aaa061a8840dedd",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 86,
        "castDelay": 175,
        "animationSpeed": 3,
        "animationDuration": 0.4,
        "skipCooldownOnChannel": 0,
        "spellName": "Shadow Demons",
        "description": "<b>Incapacitate</b> all units within <b>8</b> yards for <b>8</b> seconds. The effect will break if over <b>15</b> damage is dealt.",
        "icon": "21aadc19e57cd4241be083489b7ceecc",
        "usableBy": "0200000008000000",
        "cooldown": 30,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$5f51cc609123b866$exports.getImport = (guid)=>{
    switch(guid){
        case "21aadc19e57cd4241be083489b7ceecc":
            return 0, (/*@__PURE__*/$parcel$interopDefault($7693133e87c52e69$exports));
    }
};


var $9efa4f30bf8c0d24$exports = {};
var $d7e39cc025d3ef41$exports = {};
$d7e39cc025d3ef41$exports = new URL("holyflash.eccbe40a.png", import.meta.url).toString();


$9efa4f30bf8c0d24$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "HolyFlash",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "ca4ffbb7fd64e3440b066bb5cbee0962",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 8300000,
            "guid": "115326b0a1d301d408b2a59db74f0093",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 20,
        "castDelay": 0,
        "animationSpeed": 0.9,
        "animationDuration": 1.8,
        "skipCooldownOnChannel": 0,
        "spellName": "Holy Flash",
        "description": "Heal the target for <b>25</b> health.",
        "icon": "d8a75ce3e266d8b419459a15e101d4fe",
        "usableBy": "0200000011000000",
        "cooldown": 0,
        "castTime": 1.5,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "027489edcf0967b4c9cd9e38e44be6cf",
            "type": 2
        }
    }
};
$9efa4f30bf8c0d24$exports.getImport = (guid)=>{
    switch(guid){
        case "d8a75ce3e266d8b419459a15e101d4fe":
            return 0, (/*@__PURE__*/$parcel$interopDefault($d7e39cc025d3ef41$exports));
    }
};


var $6624ac00122a5d7a$exports = {};
var $628558bb6861e06b$exports = {};
$628558bb6861e06b$exports = new URL("holyfortitude.650d21ab.png", import.meta.url).toString();


$6624ac00122a5d7a$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "HolyFortitude",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "73c526bbb006fde49a6978e33b9c6786",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 14,
        "castDelay": 0,
        "animationSpeed": 2.5,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Holy Fortitude",
        "description": "Reduce all incoming damage on the target by <b>60%</b>. In addition, increase all incoming healing to the target by <b>20%</b>. Can be cast while <b>Stunned</b> or <b>Incapacitated</b>. Lasts <b>10</b> seconds.",
        "icon": "d8eaed9766a06554b97cf29203f38c1f",
        "usableBy": "02000000",
        "cooldown": 90,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "027489edcf0967b4c9cd9e38e44be6cf",
            "type": 2
        }
    }
};
$6624ac00122a5d7a$exports.getImport = (guid)=>{
    switch(guid){
        case "d8eaed9766a06554b97cf29203f38c1f":
            return 0, (/*@__PURE__*/$parcel$interopDefault($628558bb6861e06b$exports));
    }
};


var $991d42558a6a6de3$exports = {};
var $821994a46e697258$exports = {};
$821994a46e697258$exports = new URL("powerburn.cd77507b.png", import.meta.url).toString();


$991d42558a6a6de3$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "PowerBurn",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "7f1c197a232a3d345aaa061a8840dedd",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 8300000,
            "guid": "2c783095a3b2c8a4fa8cae902699c577",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 309,
        "castDelay": 0,
        "animationSpeed": 0.33,
        "animationDuration": 2,
        "skipCooldownOnChannel": 0,
        "spellName": "Power Burn",
        "description": "Deal <b>2</b> damage to the target and reduce the amount of outgoing healing & shielding they do by <b>2.5%</b> per stack for <b>30</b> seconds. Stacks up to <b>30</b> times.",
        "icon": "725e09d20b39ab947a7ab585d759d817",
        "usableBy": "02000000",
        "cooldown": 0,
        "castTime": 1.8,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$991d42558a6a6de3$exports.getImport = (guid)=>{
    switch(guid){
        case "725e09d20b39ab947a7ab585d759d817":
            return 0, (/*@__PURE__*/$parcel$interopDefault($821994a46e697258$exports));
    }
};


var $d941d0c617e6d1ba$exports = {};
var $7162b1baddd6baeb$exports = {};
$7162b1baddd6baeb$exports = new URL("righteousprayer.0564ee71.png", import.meta.url).toString();


$d941d0c617e6d1ba$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "RighteousPrayer",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "73c526bbb006fde49a6978e33b9c6786",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 25,
        "castDelay": 500,
        "animationSpeed": 2.5,
        "animationDuration": 0.8,
        "skipCooldownOnChannel": 0,
        "spellName": "Righteous Prayer",
        "description": "Heal the target for <b>15</b> health.",
        "icon": "ce9b5feec305abf49bafb76852ee438b",
        "usableBy": null,
        "cooldown": 6,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "027489edcf0967b4c9cd9e38e44be6cf",
            "type": 2
        }
    }
};
$d941d0c617e6d1ba$exports.getImport = (guid)=>{
    switch(guid){
        case "ce9b5feec305abf49bafb76852ee438b":
            return 0, (/*@__PURE__*/$parcel$interopDefault($7162b1baddd6baeb$exports));
    }
};


var $fa9d21992eda5ea7$exports = {};
var $ee72274429293117$exports = {};
$ee72274429293117$exports = new URL("righteousshield.6c67e5db.png", import.meta.url).toString();


$fa9d21992eda5ea7$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "RighteousShield",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "73c526bbb006fde49a6978e33b9c6786",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 14,
        "castDelay": 150,
        "animationSpeed": 2.5,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Righteous Shield",
        "description": "Provide a shield to the target absorbing up to <b>40</b> damage. Can only be cast on each target once every <b>15</b> seconds.",
        "icon": "9eef69afc5bea6e43873d8c99a046758",
        "usableBy": "02000000",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "027489edcf0967b4c9cd9e38e44be6cf",
            "type": 2
        }
    }
};
$fa9d21992eda5ea7$exports.getImport = (guid)=>{
    switch(guid){
        case "9eef69afc5bea6e43873d8c99a046758":
            return 0, (/*@__PURE__*/$parcel$interopDefault($ee72274429293117$exports));
    }
};


var $39c924d522cd20df$exports = {};
var $51d8655af7d84af0$exports = {};
$51d8655af7d84af0$exports = new URL("sacredselection.6bba31b5.png", import.meta.url).toString();


$39c924d522cd20df$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "SacredSelection",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "73c526bbb006fde49a6978e33b9c6786",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 14,
        "castDelay": 180,
        "animationSpeed": 2.5,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Sacred Selection",
        "description": "Increase your <b>Cast Speed</b> by <b>25%</b> for <b>15</b> seconds.",
        "icon": "37b29a97fce506e44a0222e70abb9aa9",
        "usableBy": "02000000",
        "cooldown": 60,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$39c924d522cd20df$exports.getImport = (guid)=>{
    switch(guid){
        case "37b29a97fce506e44a0222e70abb9aa9":
            return 0, (/*@__PURE__*/$parcel$interopDefault($51d8655af7d84af0$exports));
    }
};


var $c17c327def3d93d3$exports = {};
var $7745e776a44d0869$exports = {};
$7745e776a44d0869$exports = new URL("shackleoflight.0dd43e93.png", import.meta.url).toString();


$c17c327def3d93d3$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "ShackleOfLight",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "ca4ffbb7fd64e3440b066bb5cbee0962",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 8300000,
            "guid": "115326b0a1d301d408b2a59db74f0093",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 24,
        "castDelay": 0,
        "animationSpeed": 0.95,
        "animationDuration": 1.8,
        "skipCooldownOnChannel": 0,
        "spellName": "Shackle of Light",
        "description": "Heal yourself and your target for <b>15</b> health each.",
        "icon": "1457702380cb7e94e81bed99ff764719",
        "usableBy": "02000000",
        "cooldown": 0,
        "castTime": 1.5,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "dc869fafcb67be64f9817b3529f844ae",
            "type": 2
        }
    }
};
$c17c327def3d93d3$exports.getImport = (guid)=>{
    switch(guid){
        case "1457702380cb7e94e81bed99ff764719":
            return 0, (/*@__PURE__*/$parcel$interopDefault($7745e776a44d0869$exports));
    }
};


var $a237d60e4deed913$exports = {};
var $5a4dcfae165cc99a$exports = {};
$5a4dcfae165cc99a$exports = new URL("shadowbomb.267a767b.png", import.meta.url).toString();


$a237d60e4deed913$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "ShadowBomb",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "7f1c197a232a3d345aaa061a8840dedd",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 3,
        "castDelay": 180,
        "animationSpeed": 2,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Shadow Bomb",
        "description": "Deal <b>8</b> damage to the target. If the target is still alive after <b>0.5</b> seconds, deal <b>5</b> damage to yourself.",
        "icon": "ec90c747b516de042952eef01ee5e849",
        "usableBy": "0200000008000000",
        "cooldown": 12,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "12d2ef2f459217549b413b4b15bf4b0e",
            "type": 2
        }
    }
};
$a237d60e4deed913$exports.getImport = (guid)=>{
    switch(guid){
        case "ec90c747b516de042952eef01ee5e849":
            return 0, (/*@__PURE__*/$parcel$interopDefault($5a4dcfae165cc99a$exports));
    }
};


var $1773f833471aceab$exports = {};
var $3172c0c6a841bc14$exports = {};
$3172c0c6a841bc14$exports = new URL("smite.8ad89b18.png", import.meta.url).toString();


$1773f833471aceab$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "Smite",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "ca4ffbb7fd64e3440b066bb5cbee0962",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 8300000,
            "guid": "115326b0a1d301d408b2a59db74f0093",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 0,
        "castDelay": 0,
        "animationSpeed": 0.395,
        "animationDuration": 1.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Holy Smite",
        "description": "Deal <b>12</b> damage to the target. Once every <b>10</b> seconds, the cast time will be reduced by <b>0.5</b> seconds and it will deal <b>8</b> additional damage.",
        "icon": "8ceeb355f0f5a29469640ba0397b545a",
        "usableBy": "02000000",
        "cooldown": 0,
        "castTime": 1.5,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$1773f833471aceab$exports.getImport = (guid)=>{
    switch(guid){
        case "8ceeb355f0f5a29469640ba0397b545a":
            return 0, (/*@__PURE__*/$parcel$interopDefault($3172c0c6a841bc14$exports));
    }
};


var $0341fbd9fca8c6da$exports = {};
var $1dafb3938d0d47c1$exports = {};
$1dafb3938d0d47c1$exports = new URL("activateportal.e5fd3d55.png", import.meta.url).toString();


$0341fbd9fca8c6da$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "ActivatePortal",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "7f1c197a232a3d345aaa061a8840dedd",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 13,
        "castDelay": 250,
        "animationSpeed": 2,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Dark Portal: Teleport",
        "description": "<b>Teleport</b> to your previously opened <b>Dark Portal</b>.",
        "icon": "af6a0e7cc90cc8548a51f5cffe7c8293",
        "usableBy": "040000000c000000",
        "cooldown": 18,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$0341fbd9fca8c6da$exports.getImport = (guid)=>{
    switch(guid){
        case "af6a0e7cc90cc8548a51f5cffe7c8293":
            return 0, (/*@__PURE__*/$parcel$interopDefault($1dafb3938d0d47c1$exports));
    }
};


var $ade60e5a46c9727f$exports = {};
var $dca4eb440d71f2d1$exports = {};
$dca4eb440d71f2d1$exports = new URL("bloodcurse.8c27b561.png", import.meta.url).toString();


$ade60e5a46c9727f$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "BloodCurse",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "7f1c197a232a3d345aaa061a8840dedd",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 3,
        "castDelay": 180,
        "animationSpeed": 2.5,
        "animationDuration": 0.4,
        "skipCooldownOnChannel": 0,
        "spellName": "Blood Curse",
        "description": "Deal <b>4</b> damage every <b>3</b> seconds to the target for <b>18</b> seconds. Only one <b>Curse</b> can be active at a time on each target.",
        "icon": "1e33267a4abab384a8d70bdbbe89a240",
        "usableBy": "040000000c000000",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$ade60e5a46c9727f$exports.getImport = (guid)=>{
    switch(guid){
        case "1e33267a4abab384a8d70bdbbe89a240":
            return 0, (/*@__PURE__*/$parcel$interopDefault($dca4eb440d71f2d1$exports));
    }
};


var $2a3b6e62bc273cc3$exports = {};
var $50642fa2d3090c68$exports = {};
$50642fa2d3090c68$exports = new URL("castedfear.8e2d5f6c.png", import.meta.url).toString();


$2a3b6e62bc273cc3$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "CastedFear",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "7f1c197a232a3d345aaa061a8840dedd",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 8300000,
            "guid": "2c783095a3b2c8a4fa8cae902699c577",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 0,
        "castDelay": 0,
        "animationSpeed": 0.395,
        "animationDuration": 1.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Fear",
        "description": "<b>Incapacitate</b> the target for <b>10</b> seconds. The effect will break if over <b>17</b> damage is dealt.",
        "icon": "7b955b9bb7f95a346bff976f8f815e2e",
        "usableBy": "040000000c000000",
        "cooldown": 0,
        "castTime": 1.5,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$2a3b6e62bc273cc3$exports.getImport = (guid)=>{
    switch(guid){
        case "7b955b9bb7f95a346bff976f8f815e2e":
            return 0, (/*@__PURE__*/$parcel$interopDefault($50642fa2d3090c68$exports));
    }
};


var $f13191c75d9d59ce$exports = {};
var $38134e06604bbde7$exports = {};
$38134e06604bbde7$exports = new URL("corrosivedecay.0ff4626b.png", import.meta.url).toString();


$f13191c75d9d59ce$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "CorrosiveDecay",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "7f1c197a232a3d345aaa061a8840dedd",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 3,
        "castDelay": 180,
        "animationSpeed": 2.5,
        "animationDuration": 0.4,
        "skipCooldownOnChannel": 0,
        "spellName": "Corrosive Decay",
        "description": "Deal <b>12</b> damage to the target every <b>3</b> seconds for <b>15</b> seconds.",
        "icon": "a45332d8d237975468aca07ac0bffe51",
        "usableBy": "04000000",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$f13191c75d9d59ce$exports.getImport = (guid)=>{
    switch(guid){
        case "a45332d8d237975468aca07ac0bffe51":
            return 0, (/*@__PURE__*/$parcel$interopDefault($38134e06604bbde7$exports));
    }
};


var $ddea01ddf5886594$exports = {};
var $03ef3ad618ec71e4$exports = {};
$03ef3ad618ec71e4$exports = new URL("corruptedsoul.60f16456.png", import.meta.url).toString();


$ddea01ddf5886594$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "CorruptedSoul",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "7e2f695a25f727b45949d193cd7620ca",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 1,
        "playOnCast": [],
        "castSound": {
            "fileID": 8300000,
            "guid": "2c783095a3b2c8a4fa8cae902699c577",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 0,
        "castDelay": 0,
        "animationSpeed": 0.395,
        "animationDuration": 1.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Corrupted Soul",
        "description": "Deal <b>14</b> damage to the target every <b>3</b> seconds for <b>12</b> seconds. If <b>Removed</b>, the remover will take <b>50</b> damage and be unable to cast any spells for <b>3</b> seconds.",
        "icon": "3ddc5bc385072714dad48488b849c5b6",
        "usableBy": "04000000",
        "cooldown": 0,
        "castTime": 1.5,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$ddea01ddf5886594$exports.getImport = (guid)=>{
    switch(guid){
        case "3ddc5bc385072714dad48488b849c5b6":
            return 0, (/*@__PURE__*/$parcel$interopDefault($03ef3ad618ec71e4$exports));
    }
};


var $27a86e71d66b3067$exports = {};
var $40a66ec48d9411ef$exports = {};
$40a66ec48d9411ef$exports = new URL("demongrasp.9ce61dd8.png", import.meta.url).toString();


$27a86e71d66b3067$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "DemonGrasp",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "7e2f695a25f727b45949d193cd7620ca",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 1,
        "playOnCast": [],
        "castSound": {
            "fileID": 8300000,
            "guid": "2c783095a3b2c8a4fa8cae902699c577",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 0,
        "castDelay": 0,
        "animationSpeed": 0.395,
        "animationDuration": 1.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Demon Grasp",
        "description": "Deal <b>15</b> damage and increase all magic damage taken by the target by <b>30%</b> for <b>6</b> seconds.",
        "icon": "76158c29c5709d043b460ad593f506e4",
        "usableBy": "04000000",
        "cooldown": 12,
        "castTime": 1.5,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$27a86e71d66b3067$exports.getImport = (guid)=>{
    switch(guid){
        case "76158c29c5709d043b460ad593f506e4":
            return 0, (/*@__PURE__*/$parcel$interopDefault($40a66ec48d9411ef$exports));
    }
};


var $ca90821326a670ce$exports = {};
var $f610e55aaba3d002$exports = {};
$f610e55aaba3d002$exports = new URL("demonskull.abce51c0.png", import.meta.url).toString();


$ca90821326a670ce$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "DemonSkull",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "7f1c197a232a3d345aaa061a8840dedd",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 15,
        "castDelay": 180,
        "animationSpeed": 3,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Demon Skull",
        "description": "<b>Incapacitate</b> the target for <b>3</b> seconds. The effect will not break on any amount of damage.",
        "icon": "3dd5534ed15cb31419dd9c9136ce2cad",
        "usableBy": "040000000c000000",
        "cooldown": 60,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$ca90821326a670ce$exports.getImport = (guid)=>{
    switch(guid){
        case "3dd5534ed15cb31419dd9c9136ce2cad":
            return 0, (/*@__PURE__*/$parcel$interopDefault($f610e55aaba3d002$exports));
    }
};


var $86f09a88bd3e11cc$exports = {};
var $f7082be87427a563$exports = {};
$f7082be87427a563$exports = new URL("drainlife.b828bca7.png", import.meta.url).toString();


$86f09a88bd3e11cc$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "DrainLife",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "47c3a89d05c5e5548a6e1b93393aad7f",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 1,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 26,
        "castDelay": 0,
        "animationSpeed": 1.6,
        "animationDuration": 2,
        "skipCooldownOnChannel": 0,
        "spellName": "Drain Life",
        "description": "Deal <b>5</b> damage to the target and heal yourself for <b>1</b> health <b>4</b> times over <b>2</b> seconds.",
        "icon": "d8238ba7efd8b6e488dc9a5c2a387218",
        "usableBy": "04000000",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 2,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$86f09a88bd3e11cc$exports.getImport = (guid)=>{
    switch(guid){
        case "d8238ba7efd8b6e488dc9a5c2a387218":
            return 0, (/*@__PURE__*/$parcel$interopDefault($f7082be87427a563$exports));
    }
};


var $774884f0d0507bc4$exports = {};
var $84351f22081b5456$exports = {};
$84351f22081b5456$exports = new URL("empoweredsoulessence.8bcc4151.png", import.meta.url).toString();


$774884f0d0507bc4$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "EmpoweredSoulEssence",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "7f1c197a232a3d345aaa061a8840dedd",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 20,
        "castDelay": 440,
        "animationSpeed": 2.5,
        "animationDuration": 0.7,
        "skipCooldownOnChannel": 0,
        "spellName": "Empowered Soul Essence",
        "description": "Consume all stacks of <b>Soul Essence</b> to reduce all physical damage taken by <b>6%</b> per stack for <b>12</b> seconds.",
        "icon": "375c0a9969e082b4abca6d3823bbebd5",
        "usableBy": null,
        "cooldown": 45,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$774884f0d0507bc4$exports.getImport = (guid)=>{
    switch(guid){
        case "375c0a9969e082b4abca6d3823bbebd5":
            return 0, (/*@__PURE__*/$parcel$interopDefault($84351f22081b5456$exports));
    }
};


var $e8f1d11188067e35$exports = {};
var $c23ec22572e9c566$exports = {};
$c23ec22572e9c566$exports = new URL("fireexplosion.3a356156.png", import.meta.url).toString();


$e8f1d11188067e35$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "FireExplosion",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "c6cb37df2c0db6e47b38d20f306e416a",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 22,
        "castDelay": 450,
        "animationSpeed": 3.3,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Fire Explosion",
        "description": "Deal <b>12</b> damage to enemies within <b>7</b> yards. Take <b>2</b> damage.",
        "icon": "7108de3a0a61ee143ae1e064aaedd28b",
        "usableBy": "040000000c000000",
        "cooldown": 3,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$e8f1d11188067e35$exports.getImport = (guid)=>{
    switch(guid){
        case "7108de3a0a61ee143ae1e064aaedd28b":
            return 0, (/*@__PURE__*/$parcel$interopDefault($c23ec22572e9c566$exports));
    }
};


var $618fa0a40af65782$exports = {};
var $908dbea61a85e8ed$exports = {};
$908dbea61a85e8ed$exports = new URL("shadowlance.dbea2af4.png", import.meta.url).toString();


$618fa0a40af65782$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "InstantShadowlance",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "7f1c197a232a3d345aaa061a8840dedd",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 8300000,
            "guid": "2c783095a3b2c8a4fa8cae902699c577",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 13,
        "castDelay": 180,
        "animationSpeed": 1.8,
        "animationDuration": 0.4,
        "skipCooldownOnChannel": 0,
        "spellName": "Shadowlance",
        "description": "Deal <b>18</b> damage to the target.",
        "icon": "485155af540d7c94ab2f3f6b424ca557",
        "usableBy": "04000000",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$618fa0a40af65782$exports.getImport = (guid)=>{
    switch(guid){
        case "485155af540d7c94ab2f3f6b424ca557":
            return 0, (/*@__PURE__*/$parcel$interopDefault($908dbea61a85e8ed$exports));
    }
};


var $fd6ed1c97ffadb33$exports = {};
var $fbef02f8e5f5ad58$exports = {};
$fbef02f8e5f5ad58$exports = new URL("limbnumbingcurse.ba97b00b.png", import.meta.url).toString();


$fd6ed1c97ffadb33$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "LimbnumbingCurse",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "7f1c197a232a3d345aaa061a8840dedd",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 3,
        "castDelay": 180,
        "animationSpeed": 2.5,
        "animationDuration": 0.4,
        "skipCooldownOnChannel": 0,
        "spellName": "Limb-numbing Curse",
        "description": "Slow the target by <b>45%</b> for <b>18</b> seconds. Only one <b>Curse</b> can be active at a time on each target.",
        "icon": "e90366f29b1cc0e41a672de5d3b25907",
        "usableBy": "040000000c000000",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$fd6ed1c97ffadb33$exports.getImport = (guid)=>{
    switch(guid){
        case "e90366f29b1cc0e41a672de5d3b25907":
            return 0, (/*@__PURE__*/$parcel$interopDefault($fbef02f8e5f5ad58$exports));
    }
};


var $5619e2c2ff7e6dfb$exports = {};
var $a665543c6e7f9995$exports = {};
$a665543c6e7f9995$exports = new URL("openportal.3d0f6dbf.png", import.meta.url).toString();


$5619e2c2ff7e6dfb$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "OpenPortal",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "7f1c197a232a3d345aaa061a8840dedd",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 8300000,
            "guid": "2c783095a3b2c8a4fa8cae902699c577",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 14,
        "castDelay": 0,
        "animationSpeed": 2.7,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Dark Portal: Open",
        "description": "Open a <b>Dark Portal</b> at your current location that lasts for <b>2</b> minutes. Cast again to <b>Teleport</b> to it.",
        "icon": "c450f5325a70b4c47b7d361e3d5e30eb",
        "usableBy": "040000000c000000",
        "cooldown": 0,
        "castTime": 0.3,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$5619e2c2ff7e6dfb$exports.getImport = (guid)=>{
    switch(guid){
        case "c450f5325a70b4c47b7d361e3d5e30eb":
            return 0, (/*@__PURE__*/$parcel$interopDefault($a665543c6e7f9995$exports));
    }
};


var $b05495aa41b80f5f$exports = {};
var $d41ba17e6a18cb32$exports = {};
$d41ba17e6a18cb32$exports = new URL("shadowflame.a66a771c.png", import.meta.url).toString();


$b05495aa41b80f5f$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "Shadowflame",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "7f1c197a232a3d345aaa061a8840dedd",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 15,
        "castDelay": 240,
        "animationSpeed": 2.5,
        "animationDuration": 0.7,
        "skipCooldownOnChannel": 0,
        "spellName": "Shadowflame",
        "description": "Deal <b>12</b> damage, apply a <b>60%</b> slow and deal <b>2</b> damage every <b>2</b> seconds for <b>8</b> seconds to all targets in a cone in front of the caster.",
        "icon": "f058eb6b5d89dc84fb1dd43b2c5c2c6d",
        "usableBy": null,
        "cooldown": 10,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$b05495aa41b80f5f$exports.getImport = (guid)=>{
    switch(guid){
        case "f058eb6b5d89dc84fb1dd43b2c5c2c6d":
            return 0, (/*@__PURE__*/$parcel$interopDefault($d41ba17e6a18cb32$exports));
    }
};


var $7008dce24899ddf8$exports = {};

$7008dce24899ddf8$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "Shadowlance",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "7e2f695a25f727b45949d193cd7620ca",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 1,
        "playOnCast": [],
        "castSound": {
            "fileID": 8300000,
            "guid": "2c783095a3b2c8a4fa8cae902699c577",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 0,
        "castDelay": 0,
        "animationSpeed": 0.35,
        "animationDuration": 1.8,
        "skipCooldownOnChannel": 0,
        "spellName": "Shadowlance",
        "description": "Deal <b>21</b> damage to the target.",
        "icon": "485155af540d7c94ab2f3f6b424ca557",
        "usableBy": "04000000",
        "cooldown": 0,
        "castTime": 1.8,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$7008dce24899ddf8$exports.getImport = (guid)=>{
    switch(guid){
        case "485155af540d7c94ab2f3f6b424ca557":
            return 0, (/*@__PURE__*/$parcel$interopDefault($908dbea61a85e8ed$exports));
    }
};


var $9fa53495d8af4180$exports = {};
var $55f8ef590b1af318$exports = {};
$55f8ef590b1af318$exports = new URL("weakenedsoulcurse.50128e5e.png", import.meta.url).toString();


$9fa53495d8af4180$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "WeakenedSoulCurse",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "7f1c197a232a3d345aaa061a8840dedd",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 3,
        "castDelay": 180,
        "animationSpeed": 2.5,
        "animationDuration": 0.4,
        "skipCooldownOnChannel": 0,
        "spellName": "Weakened Soul Curse",
        "description": "The target will take <b>6%</b> more magic damage for <b>30</b> seconds. Only one <b>Curse</b> can be active at a time on each target.",
        "icon": "320e32d6055842145ab48ebb56adf86a",
        "usableBy": "040000000c000000",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100062,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "d9d6900d2f55b944fbbc3a7dea40d8e8",
            "type": 3
        }
    }
};
$9fa53495d8af4180$exports.getImport = (guid)=>{
    switch(guid){
        case "320e32d6055842145ab48ebb56adf86a":
            return 0, (/*@__PURE__*/$parcel$interopDefault($55f8ef590b1af318$exports));
    }
};


var $1c34f1522c1b65c2$exports = {};
var $bcce86c345e49cdd$exports = {};
$bcce86c345e49cdd$exports = new URL("Archerskill_20.ec5a8aa4.png", import.meta.url).toString();


$1c34f1522c1b65c2$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "BigJump",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 2,
        "animationVariation": 3,
        "castDelay": 0,
        "animationSpeed": 0.032,
        "animationDuration": 3,
        "skipCooldownOnChannel": 0,
        "spellName": "Jump!",
        "description": "Channel a huge jump forward. Cancelling the channel will jump with less force.",
        "icon": "32fd9b70f9f60bb4ca6029fa64f89dc5",
        "usableBy": "000000000100000002000000030000000400000005000000060000000700000008000000090000000a0000000b0000000c0000000d0000000e0000000f000000",
        "cooldown": 3,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 1,
        "isRegional": 1,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100061,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "0b2e323273f37994aa1351e1ba85047a",
            "type": 3
        }
    }
};
$1c34f1522c1b65c2$exports.getImport = (guid)=>{
    switch(guid){
        case "32fd9b70f9f60bb4ca6029fa64f89dc5":
            return 0, (/*@__PURE__*/$parcel$interopDefault($bcce86c345e49cdd$exports));
    }
};


var $e890ebda5549b716$exports = {};
var $ed6dd1f16c496c50$exports = {};
$ed6dd1f16c496c50$exports = new URL("sit.649e685d.png", import.meta.url).toString();


$e890ebda5549b716$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "Sit",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 3,
        "castDelay": 0,
        "animationSpeed": 0.032,
        "animationDuration": 0,
        "skipCooldownOnChannel": 0,
        "spellName": "Sit",
        "description": "Sit in the chair.",
        "icon": "843c618aacdb9334a9ded6a2b388fadf",
        "usableBy": "000000000100000002000000030000000400000005000000060000000700000008000000090000000a0000000b0000000c0000000d0000000e0000000f000000",
        "cooldown": 3,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 1,
        "isRegional": 1,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100075,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "cc89706438333b8498fe5ba3927e968f",
            "type": 3
        }
    }
};
$e890ebda5549b716$exports.getImport = (guid)=>{
    switch(guid){
        case "843c618aacdb9334a9ded6a2b388fadf":
            return 0, (/*@__PURE__*/$parcel$interopDefault($ed6dd1f16c496c50$exports));
    }
};


var $a0f3052520d7fa45$exports = {};
var $5453999170785a40$exports = {};
$5453999170785a40$exports = new URL("spin.154f05cf.png", import.meta.url).toString();


$a0f3052520d7fa45$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "SpinWheel",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 2,
        "animationVariation": 3,
        "castDelay": 0,
        "animationSpeed": 0.032,
        "animationDuration": 0,
        "skipCooldownOnChannel": 0,
        "spellName": "Spin the Wheel!",
        "description": "Spin the wheel to win a prize! Can only be used once per day.",
        "icon": "4bdad90befe5a57418a617a3d7e6d12d",
        "usableBy": "000000000100000002000000030000000400000005000000060000000700000008000000090000000a0000000b0000000c0000000d0000000e0000000f000000",
        "cooldown": 3,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 1,
        "isRegional": 1,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$a0f3052520d7fa45$exports.getImport = (guid)=>{
    switch(guid){
        case "4bdad90befe5a57418a617a3d7e6d12d":
            return 0, (/*@__PURE__*/$parcel$interopDefault($5453999170785a40$exports));
    }
};


var $91251d928b94f86c$exports = {};

$91251d928b94f86c$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "SpinWheelSpecialSpell",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 2,
        "animationVariation": 3,
        "castDelay": 0,
        "animationSpeed": 0.032,
        "animationDuration": 0,
        "skipCooldownOnChannel": 0,
        "spellName": "Spin the Wheel!",
        "description": "Spin the wheel to win a prize! Can only be used once per day.",
        "icon": "4bdad90befe5a57418a617a3d7e6d12d",
        "usableBy": "000000000100000002000000030000000400000005000000060000000700000008000000090000000a0000000b0000000c0000000d0000000e0000000f000000",
        "cooldown": 3,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$91251d928b94f86c$exports.getImport = (guid)=>{
    switch(guid){
        case "4bdad90befe5a57418a617a3d7e6d12d":
            return 0, (/*@__PURE__*/$parcel$interopDefault($5453999170785a40$exports));
    }
};


var $6b8558768eb882b9$exports = {};
var $c3b4aa0698d9e4be$exports = {};
$c3b4aa0698d9e4be$exports = new URL("cycloneshot.7cf71a54.png", import.meta.url).toString();


$6b8558768eb882b9$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "CycloneShot",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "e1469613e3c96a34a99dc366ba596c51",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "964fdba38affb6b458daf089802e5431",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 411,
        "castDelay": 0,
        "animationSpeed": 0.5,
        "animationDuration": 4.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Cyclone Shot",
        "description": "Shoot arrows in a circle for <b>4</b> seconds, dealing <b>10</b> damage every <b>0.5</b> seconds to all enemy Titans within <b>10</b> yards. \n\nYou move <b>30%</b> slower for the duration, and cannot cast any other spells.",
        "icon": "08c066d7588cf9941b8a91b2262dc1c2",
        "usableBy": "0f000000",
        "cooldown": 42,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100074,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "596770eaea22461489398a7e1bf98283",
            "type": 3
        }
    }
};
$6b8558768eb882b9$exports.getImport = (guid)=>{
    switch(guid){
        case "08c066d7588cf9941b8a91b2262dc1c2":
            return 0, (/*@__PURE__*/$parcel$interopDefault($c3b4aa0698d9e4be$exports));
    }
};


var $f0cb8d4f38bce557$exports = {};
var $d063837262d04b61$exports = {};
$d063837262d04b61$exports = new URL("explosiveshot.d0cda28b.png", import.meta.url).toString();


$f0cb8d4f38bce557$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "ExplosiveShot",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "e1469613e3c96a34a99dc366ba596c51",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 8300000,
            "guid": "b49169f973e2c674caf89289d6b096a1",
            "type": 3
        },
        "castSoundVolume": 1,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 29,
        "castDelay": 0,
        "animationSpeed": 0.3,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Eruptive Shot",
        "description": "Trigger <b>10</b> explosions over <b>1</b> second, each dealing <b>4</b> damage to the target and nearby enemies.",
        "icon": "b020668696625f94c92d93184e340789",
        "usableBy": "0f000000",
        "cooldown": 16,
        "castTime": 0.65,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100068,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "d55c7b7f16eb3d349bd1afeee3c08d37",
            "type": 3
        }
    }
};
$f0cb8d4f38bce557$exports.getImport = (guid)=>{
    switch(guid){
        case "b020668696625f94c92d93184e340789":
            return 0, (/*@__PURE__*/$parcel$interopDefault($d063837262d04b61$exports));
    }
};


var $a6af6ef562ea09d3$exports = {};
var $d36b096611916fbc$exports = {};
$d36b096611916fbc$exports = new URL("hookshot.02f89eb0.png", import.meta.url).toString();


$a6af6ef562ea09d3$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "HookShot",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "e1469613e3c96a34a99dc366ba596c51",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 8300000,
            "guid": "b49169f973e2c674caf89289d6b096a1",
            "type": 3
        },
        "castSoundVolume": 1,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 29,
        "castDelay": 0,
        "animationSpeed": 1,
        "animationDuration": 0.4,
        "skipCooldownOnChannel": 0,
        "spellName": "Hookshot",
        "description": "Shoot a hook towards your cursor.\n\nIf the hook collides with anything, you will pull yourself to it.\n\nIf the hook collides with an enemy Titan, the enemy will be slowed by <b>50%</b> for <b>5</b> seconds.",
        "icon": "3e6e70441cdd1134eaa240028a1e3a0c",
        "usableBy": "0f000000",
        "cooldown": 12,
        "castTime": 0.2,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 2,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "49714b7747fcdd245a2a48451ad05657",
            "type": 2
        },
        "spellKey": 100073,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "dcf6b0fca1590774f81dc1348161a684",
            "type": 3
        }
    }
};
$a6af6ef562ea09d3$exports.getImport = (guid)=>{
    switch(guid){
        case "3e6e70441cdd1134eaa240028a1e3a0c":
            return 0, (/*@__PURE__*/$parcel$interopDefault($d36b096611916fbc$exports));
    }
};


var $029778e498e6e66c$exports = {};
var $2b887dc9d66b54fc$exports = {};
$2b887dc9d66b54fc$exports = new URL("markedfordeath.914a5480.png", import.meta.url).toString();


$029778e498e6e66c$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "MarkedForDeath",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "e1469613e3c96a34a99dc366ba596c51",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 14,
        "castDelay": 180,
        "animationSpeed": 2.5,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Marked for Death",
        "description": "Mark the target for death, increasing all damage they take by <b>15%</b> for <b>8</b> seconds. \n\nIn addition, you will always be able to see the target for the duration.",
        "icon": "ffa4ec90915a9a144a539d88135dca4a",
        "usableBy": null,
        "cooldown": 45,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100072,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "80add44ec1997934383b1fd1de4ee119",
            "type": 3
        }
    }
};
$029778e498e6e66c$exports.getImport = (guid)=>{
    switch(guid){
        case "ffa4ec90915a9a144a539d88135dca4a":
            return 0, (/*@__PURE__*/$parcel$interopDefault($2b887dc9d66b54fc$exports));
    }
};


var $22c23b2cae36f699$exports = {};
var $4285171a65fe6a5c$exports = {};
$4285171a65fe6a5c$exports = new URL("multishot.9219ed09.png", import.meta.url).toString();


$22c23b2cae36f699$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "Multishot",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "e1469613e3c96a34a99dc366ba596c51",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 8300000,
            "guid": "b49169f973e2c674caf89289d6b096a1",
            "type": 3
        },
        "castSoundVolume": 1,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 29,
        "castDelay": 0,
        "animationSpeed": 0.3,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Multishot",
        "description": "Deal <b>20</b> damage to the target and up to <b>2</b> nearby targets in front of you.",
        "icon": "1d8c1a0335fd3e74ca886c0b2c14615c",
        "usableBy": "0f000000",
        "cooldown": 8,
        "castTime": 0.65,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100069,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "360e0f6fcc65c684c8d0f7c483f1b62e",
            "type": 3
        }
    }
};
$22c23b2cae36f699$exports.getImport = (guid)=>{
    switch(guid){
        case "1d8c1a0335fd3e74ca886c0b2c14615c":
            return 0, (/*@__PURE__*/$parcel$interopDefault($4285171a65fe6a5c$exports));
    }
};


var $ec060ae19def3df7$exports = {};
var $f69de4da02efcc46$exports = {};
$f69de4da02efcc46$exports = new URL("net.b723cb4a.png", import.meta.url).toString();


$ec060ae19def3df7$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "Net",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "e1469613e3c96a34a99dc366ba596c51",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "964fdba38affb6b458daf089802e5431",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 14,
        "castDelay": 180,
        "animationSpeed": 2.5,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Electric Fence",
        "description": "<b>Snare</b> the target in place for <b>4</b> seconds. \n\nThe effect does not break on damage.",
        "icon": "7032e5449a56f0c41b7035bd89c059f5",
        "usableBy": "0f000000",
        "cooldown": 30,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100071,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "bd12b3e71b30b8a42bd2dfd59deece93",
            "type": 3
        }
    }
};
$ec060ae19def3df7$exports.getImport = (guid)=>{
    switch(guid){
        case "7032e5449a56f0c41b7035bd89c059f5":
            return 0, (/*@__PURE__*/$parcel$interopDefault($f69de4da02efcc46$exports));
    }
};


var $287e39de9385da33$exports = {};
var $6db30fb6abb3bdfa$exports = {};
$6db30fb6abb3bdfa$exports = new URL("Archerskill_47.4b85b449.png", import.meta.url).toString();


$287e39de9385da33$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "ShortDraw",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "e1469613e3c96a34a99dc366ba596c51",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 8300000,
            "guid": "b49169f973e2c674caf89289d6b096a1",
            "type": 3
        },
        "castSoundVolume": 1,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 29,
        "castDelay": 0,
        "animationSpeed": 0.21,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Short Draw",
        "description": "Deal <b>14</b> damage to the target.",
        "icon": "183d4ae782a28e14ab580b67ad3c9db8",
        "usableBy": "0f000000",
        "cooldown": 0,
        "castTime": 0.9,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100070,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "15fd5623231743b4cb74624c2ea57ed2",
            "type": 3
        }
    }
};
$287e39de9385da33$exports.getImport = (guid)=>{
    switch(guid){
        case "183d4ae782a28e14ab580b67ad3c9db8":
            return 0, (/*@__PURE__*/$parcel$interopDefault($6db30fb6abb3bdfa$exports));
    }
};


var $2bdb0031d12cced9$exports = {};
var $7aa530c3af84aa42$exports = {};
$7aa530c3af84aa42$exports = new URL("hammerstorm.47d53067.png", import.meta.url).toString();


$2bdb0031d12cced9$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "HammerStorm",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "73c526bbb006fde49a6978e33b9c6786",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 8300000,
            "guid": "964fdba38affb6b458daf089802e5431",
            "type": 3
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 42,
        "castDelay": 520,
        "animationSpeed": 1.6,
        "animationDuration": 1.2,
        "skipCooldownOnChannel": 0,
        "spellName": "Hammer Storm",
        "description": "Deal <b>43</b> damage to all enemy targets within <b>5</b> yards. \n\nIf this deals damage, your next <B>Mystical Brilliance</b> within <b>6</b> seconds will be an instant cast.",
        "icon": "3a49796b3a7ff7242925ec54ec929135",
        "usableBy": "0d000000",
        "cooldown": 6,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100033,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "325d4cf26adb6964f815bb94c86c9b1b",
            "type": 3
        }
    }
};
$2bdb0031d12cced9$exports.getImport = (guid)=>{
    switch(guid){
        case "3a49796b3a7ff7242925ec54ec929135":
            return 0, (/*@__PURE__*/$parcel$interopDefault($7aa530c3af84aa42$exports));
    }
};


var $2eb181dab58917ce$exports = {};
var $9bdc4cdb14ca3a05$exports = {};
$9bdc4cdb14ca3a05$exports = new URL("righteoushammer.f88a55ec.png", import.meta.url).toString();


$2eb181dab58917ce$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "HammerSwing",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 407,
        "castDelay": 650,
        "animationSpeed": 0.9,
        "animationDuration": 0.9,
        "skipCooldownOnChannel": 0,
        "spellName": "Hammer Swing",
        "description": "Swing your hammer, dealing 10 physical damage.",
        "icon": "3bfcddde9508ae34d90af7caea7ec88e",
        "usableBy": null,
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100034,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "1970b4ff367a6d7489c43fde09631c7b",
            "type": 3
        }
    }
};
$2eb181dab58917ce$exports.getImport = (guid)=>{
    switch(guid){
        case "3bfcddde9508ae34d90af7caea7ec88e":
            return 0, (/*@__PURE__*/$parcel$interopDefault($9bdc4cdb14ca3a05$exports));
    }
};


var $f61453f9c98ea1ab$exports = {};
var $1866b2408941f4b8$exports = {};
$1866b2408941f4b8$exports = new URL("requisiteconfession.939de409.png", import.meta.url).toString();


$f61453f9c98ea1ab$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "RequisiteConfession",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "73c526bbb006fde49a6978e33b9c6786",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 279,
        "castDelay": 350,
        "animationSpeed": 2,
        "animationDuration": 0.75,
        "skipCooldownOnChannel": 0,
        "spellName": "Requisite Confession",
        "description": "<b>Incapacitate</b> the target for <b>5</b> seconds. Any damage dealt will break the effect.",
        "icon": "b1659c4ca6f53aa40b313fd1613756b1",
        "usableBy": "0d000000",
        "cooldown": 35,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100063,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "134f2de59f0e4a443a12d41ed31fa6ca",
            "type": 3
        }
    }
};
$f61453f9c98ea1ab$exports.getImport = (guid)=>{
    switch(guid){
        case "b1659c4ca6f53aa40b313fd1613756b1":
            return 0, (/*@__PURE__*/$parcel$interopDefault($1866b2408941f4b8$exports));
    }
};


var $a7c376e2b7ab9ff8$exports = {};

$a7c376e2b7ab9ff8$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "RighteousHammer",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "73c526bbb006fde49a6978e33b9c6786",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 39,
        "castDelay": 400,
        "animationSpeed": 1.5,
        "animationDuration": 1.2,
        "skipCooldownOnChannel": 0,
        "spellName": "Righteous Hammer",
        "description": "Deal <b>8</b> physical damage shortly followed by <b>8</b> magical damage to the target. \n\nIf this deals damage, your next <B>Mystical Brilliance</b> within <b>6</b> seconds will be an instant cast.",
        "icon": "3bfcddde9508ae34d90af7caea7ec88e",
        "usableBy": "0d000000",
        "cooldown": 2,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100032,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "3f56b5f4d38c27347bde75788b333519",
            "type": 3
        }
    }
};
$a7c376e2b7ab9ff8$exports.getImport = (guid)=>{
    switch(guid){
        case "3bfcddde9508ae34d90af7caea7ec88e":
            return 0, (/*@__PURE__*/$parcel$interopDefault($9bdc4cdb14ca3a05$exports));
    }
};


var $123e78c4304b7ac7$exports = {};
var $c2399ee6bc553618$exports = {};
$c2399ee6bc553618$exports = new URL("righteoushindrance.c0703628.png", import.meta.url).toString();


$123e78c4304b7ac7$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "RighteousHindrance",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "73c526bbb006fde49a6978e33b9c6786",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 128,
        "castDelay": 750,
        "animationSpeed": 1,
        "animationDuration": 1.4,
        "skipCooldownOnChannel": 0,
        "spellName": "Righteous Hindrance",
        "description": "Deal <b>12</b> damage to the target, slow them by 15% and prevent them from moving faster than their base movement speed for <b>10</b> seconds.",
        "icon": "6b113059e73fc494eaaa0727e6b5ea9d",
        "usableBy": "0d000000",
        "cooldown": 10,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100060,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "53f5e78702578ec4cbd1f711584a2364",
            "type": 3
        }
    }
};
$123e78c4304b7ac7$exports.getImport = (guid)=>{
    switch(guid){
        case "6b113059e73fc494eaaa0727e6b5ea9d":
            return 0, (/*@__PURE__*/$parcel$interopDefault($c2399ee6bc553618$exports));
    }
};


var $aa884c3f740b8a29$exports = {};
var $a83ef64084af778d$exports = {};
$a83ef64084af778d$exports = new URL("righteousshock.218ed7b5.png", import.meta.url).toString();


$aa884c3f740b8a29$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "SpikeWave",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "73c526bbb006fde49a6978e33b9c6786",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 90,
        "castDelay": 750,
        "animationSpeed": 1.2,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Righteous Shock",
        "description": "Deal <b>12</b> damage to all enemies within <b>7</b> yards. In addition, deal <b>6</b> damage every <b>3</b> seconds to anyone who remains in the effect, which lasts <b>9</b> seconds.",
        "icon": "881514c4d98e2e34186a2454bee68f48",
        "usableBy": null,
        "cooldown": 12,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100056,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "135b61980c304d543981b0d3245307ab",
            "type": 3
        }
    }
};
$aa884c3f740b8a29$exports.getImport = (guid)=>{
    switch(guid){
        case "881514c4d98e2e34186a2454bee68f48":
            return 0, (/*@__PURE__*/$parcel$interopDefault($a83ef64084af778d$exports));
    }
};


var $9327a9d30ac11948$exports = {};

$9327a9d30ac11948$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "SpecialBuffDamageReduceSpell",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 20,
        "castDelay": 250,
        "animationSpeed": 4,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Damage Reduce",
        "description": "Damage Reduce",
        "icon": "d84d0caef9bf6d743976e7918dac0a33",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "preventManualCasts": 1,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100023,
        "alwaysCastableSpell": 1,
        "usableBy": null,
        "luaScript": {
            "fileID": 4900000,
            "guid": "bd3736f642574c440bdc541438684d91",
            "type": 3
        }
    }
};
$9327a9d30ac11948$exports.getImport = (guid)=>{
    switch(guid){
        case "d84d0caef9bf6d743976e7918dac0a33":
            return 0, (/*@__PURE__*/$parcel$interopDefault($70b937c96eb48fcd$exports));
    }
};


var $01f5aa025077497e$exports = {};

$01f5aa025077497e$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "SpecialBuffDamageSpell",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 20,
        "castDelay": 250,
        "animationSpeed": 4,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Damage Buff",
        "description": "Damage Buff",
        "icon": "d84d0caef9bf6d743976e7918dac0a33",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "preventManualCasts": 1,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100022,
        "alwaysCastableSpell": 1,
        "usableBy": null,
        "luaScript": {
            "fileID": 4900000,
            "guid": "563bfa98f3cdf294da0e029c3412dc08",
            "type": 3
        }
    }
};
$01f5aa025077497e$exports.getImport = (guid)=>{
    switch(guid){
        case "d84d0caef9bf6d743976e7918dac0a33":
            return 0, (/*@__PURE__*/$parcel$interopDefault($70b937c96eb48fcd$exports));
    }
};


var $c624fdd9fb25382e$exports = {};

$c624fdd9fb25382e$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "SpecialBuffHealingReduceSpell",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 20,
        "castDelay": 250,
        "animationSpeed": 4,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Healing Reduce",
        "description": "Healing Reduce",
        "icon": "d84d0caef9bf6d743976e7918dac0a33",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "preventManualCasts": 1,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100024,
        "alwaysCastableSpell": 1,
        "usableBy": null,
        "luaScript": {
            "fileID": 4900000,
            "guid": "37b45dff048cc9e4d896311309b3d8e3",
            "type": 3
        }
    }
};
$c624fdd9fb25382e$exports.getImport = (guid)=>{
    switch(guid){
        case "d84d0caef9bf6d743976e7918dac0a33":
            return 0, (/*@__PURE__*/$parcel$interopDefault($70b937c96eb48fcd$exports));
    }
};


var $5e43b1abad24fb63$exports = {};

$5e43b1abad24fb63$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "SpecialEyeSpell",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 20,
        "castDelay": 250,
        "animationSpeed": 4,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Eye",
        "description": "Eye",
        "icon": "d84d0caef9bf6d743976e7918dac0a33",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "preventManualCasts": 1,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$5e43b1abad24fb63$exports.getImport = (guid)=>{
    switch(guid){
        case "d84d0caef9bf6d743976e7918dac0a33":
            return 0, (/*@__PURE__*/$parcel$interopDefault($70b937c96eb48fcd$exports));
    }
};


var $061db0ca4500820c$exports = {};

$061db0ca4500820c$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "SpecialFlagSpell",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 20,
        "castDelay": 250,
        "animationSpeed": 4,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Flag Manager",
        "description": "Flag Manager",
        "icon": "d84d0caef9bf6d743976e7918dac0a33",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "preventManualCasts": 1,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100058,
        "alwaysCastableSpell": 1,
        "usableBy": null,
        "luaScript": {
            "fileID": 4900000,
            "guid": "fcbfb4e16dff3424d83eba5002c697ad",
            "type": 3
        }
    }
};
$061db0ca4500820c$exports.getImport = (guid)=>{
    switch(guid){
        case "d84d0caef9bf6d743976e7918dac0a33":
            return 0, (/*@__PURE__*/$parcel$interopDefault($70b937c96eb48fcd$exports));
    }
};


var $b462fdd036bfc86d$exports = {};

$b462fdd036bfc86d$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "SpecialResetAllCDsSpell",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 20,
        "castDelay": 250,
        "animationSpeed": 4,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Teleport",
        "description": "Teleport",
        "icon": "d84d0caef9bf6d743976e7918dac0a33",
        "usableBy": null,
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100081,
        "alwaysCastableSpell": 1,
        "luaScript": {
            "fileID": 4900000,
            "guid": "112b8e12a7327684c805fbd08dd1bb47",
            "type": 3
        }
    }
};
$b462fdd036bfc86d$exports.getImport = (guid)=>{
    switch(guid){
        case "d84d0caef9bf6d743976e7918dac0a33":
            return 0, (/*@__PURE__*/$parcel$interopDefault($70b937c96eb48fcd$exports));
    }
};


var $86b16717080306ad$exports = {};

$86b16717080306ad$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "SpecialTeleportSpell",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 20,
        "castDelay": 250,
        "animationSpeed": 4,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Teleport",
        "description": "Teleport",
        "icon": "d84d0caef9bf6d743976e7918dac0a33",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "preventManualCasts": 1,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100059,
        "alwaysCastableSpell": 1,
        "usableBy": null,
        "luaScript": {
            "fileID": 4900000,
            "guid": "0c78b7b1fb261bc4d9a5c80c15a67051",
            "type": 3
        }
    }
};
$86b16717080306ad$exports.getImport = (guid)=>{
    switch(guid){
        case "d84d0caef9bf6d743976e7918dac0a33":
            return 0, (/*@__PURE__*/$parcel$interopDefault($70b937c96eb48fcd$exports));
    }
};


var $0176937bdfcdd9f8$exports = {};
var $d413d574764915c4$exports = {};
$d413d574764915c4$exports = new URL("lightningstorm.b1a113ee.png", import.meta.url).toString();


$0176937bdfcdd9f8$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "LightningStorm",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 727422648304881800,
            "guid": "a9f11eefd58c0244ba94098589ebf7db",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "044eae113b60d7e46b52f96eb863fa08",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 22,
        "castDelay": 850,
        "animationSpeed": 2,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Lightning Storm",
        "description": "Deal <b>19</b> damage instantly and every <b>1.5</b> seconds to all enemies within <b>12</b> yards of yourself for <b>8</b> seconds. The storm becomes dormant if you are <b>Stunned</b>, <b>Silenced</b>, or <b>Incapacitated</b>.",
        "icon": "7f26fddce2a24b04aafe84682aabe7d5",
        "usableBy": "0e000000",
        "cooldown": 85,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100065,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "cc5b8c8e0220046459fe82b4e33b751e",
            "type": 3
        }
    }
};
$0176937bdfcdd9f8$exports.getImport = (guid)=>{
    switch(guid){
        case "7f26fddce2a24b04aafe84682aabe7d5":
            return 0, (/*@__PURE__*/$parcel$interopDefault($d413d574764915c4$exports));
    }
};


var $30be86d45ba22669$exports = {};
var $10baff03856807e8$exports = {};
$10baff03856807e8$exports = new URL("stormcloud.0dab84a7.png", import.meta.url).toString();


$30be86d45ba22669$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "StormCloud",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 727422648304881800,
            "guid": "a9f11eefd58c0244ba94098589ebf7db",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "964fdba38affb6b458daf089802e5431",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 26,
        "castDelay": 450,
        "animationSpeed": 3.5,
        "animationDuration": 0.7,
        "skipCooldownOnChannel": 0,
        "spellName": "Storm Cloud",
        "description": "Deal <b>8</b> damage to the target every <b>3</b> seconds for <b>12</b> seconds.",
        "icon": "1203233fdb1e1e349a386b900102ba04",
        "usableBy": "0e000000",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100064,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "c9d0d5c2607e74144821cc0c165fc605",
            "type": 3
        }
    }
};
$30be86d45ba22669$exports.getImport = (guid)=>{
    switch(guid){
        case "1203233fdb1e1e349a386b900102ba04":
            return 0, (/*@__PURE__*/$parcel$interopDefault($10baff03856807e8$exports));
    }
};


var $7c416959ea474b85$exports = {};
var $b37194b960498e64$exports = {};
$b37194b960498e64$exports = new URL("stormwave.add597ff.png", import.meta.url).toString();


$7c416959ea474b85$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "StormWave",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 727422648304881800,
            "guid": "a9f11eefd58c0244ba94098589ebf7db",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "964fdba38affb6b458daf089802e5431",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 15,
        "castDelay": 240,
        "animationSpeed": 2.7,
        "animationDuration": 0.7,
        "skipCooldownOnChannel": 0,
        "spellName": "Storm Wave",
        "description": "Deal <b>18</b> damage and <b>Stun</b> all targets in a cone in front of you for <b>1</b> second.",
        "icon": "d1abaf84d4ead1248be0fcd999e80266",
        "usableBy": null,
        "cooldown": 28,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100067,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "ee0aad09b9b99114a9ce357811a9802a",
            "type": 3
        }
    }
};
$7c416959ea474b85$exports.getImport = (guid)=>{
    switch(guid){
        case "d1abaf84d4ead1248be0fcd999e80266":
            return 0, (/*@__PURE__*/$parcel$interopDefault($b37194b960498e64$exports));
    }
};


var $192389adfa53bc85$exports = {};
var $96c08f69d7be3312$exports = {};
$96c08f69d7be3312$exports = new URL("thorns.09c31415.png", import.meta.url).toString();


$192389adfa53bc85$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "Thorns",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 727422648304881800,
            "guid": "a9f11eefd58c0244ba94098589ebf7db",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "044eae113b60d7e46b52f96eb863fa08",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 26,
        "castDelay": 450,
        "animationSpeed": 3.5,
        "animationDuration": 0.7,
        "skipCooldownOnChannel": 0,
        "spellName": "Thorns",
        "description": "Thorns erupt from the ground, following the target for <b>8</b> seconds, dealing <b>3</b> damage all enemies who are hit by them <b>3</b> times per second.",
        "icon": "3b7be4ee8548c6b418338d414b669e4e",
        "usableBy": "0e000000",
        "cooldown": 45,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100066,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "c8b6945e4d88383428d935c19a177057",
            "type": 3
        }
    }
};
$192389adfa53bc85$exports.getImport = (guid)=>{
    switch(guid){
        case "3b7be4ee8548c6b418338d414b669e4e":
            return 0, (/*@__PURE__*/$parcel$interopDefault($96c08f69d7be3312$exports));
    }
};


var $7e98047965022489$exports = {};
var $b62e0347bf04d7c5$exports = {};
$b62e0347bf04d7c5$exports = new URL("ankleslice.1ae45896.png", import.meta.url).toString();


$7e98047965022489$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "AnkleSlice",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 37,
        "castDelay": 380,
        "animationSpeed": 1.4,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Ankle Slice",
        "description": "Deal <b>1</b> damage and slow the target by <b>60%</b> for <b>8</b> seconds.",
        "icon": "4d88cbdd322ba5e4993acf84e1c675da",
        "usableBy": "030000000b000000",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "12d2ef2f459217549b413b4b15bf4b0e",
            "type": 2
        }
    }
};
$7e98047965022489$exports.getImport = (guid)=>{
    switch(guid){
        case "4d88cbdd322ba5e4993acf84e1c675da":
            return 0, (/*@__PURE__*/$parcel$interopDefault($b62e0347bf04d7c5$exports));
    }
};


var $c6fe6bc9d73a4555$exports = {};
var $183e639aac5e3f33$exports = {};
$183e639aac5e3f33$exports = new URL("bladevortex.676185c8.png", import.meta.url).toString();


$c6fe6bc9d73a4555$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "BladeVortex",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 411,
        "castDelay": 350,
        "animationSpeed": 0.5,
        "animationDuration": 5.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Blade Vortex",
        "description": "Become <b>Unstoppable</b> and deal <b>20</b> damage to all nearby enemies every second for <b>8</b> seconds. You can't cast any other spells while the effect is active. Damage taken is increased by <b>10%</b> while the effect is active.",
        "icon": "00e001d820b531143882280fb06886a9",
        "usableBy": "030000000b000000",
        "cooldown": 90,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$c6fe6bc9d73a4555$exports.getImport = (guid)=>{
    switch(guid){
        case "00e001d820b531143882280fb06886a9":
            return 0, (/*@__PURE__*/$parcel$interopDefault($183e639aac5e3f33$exports));
    }
};


var $d80978e45f7d7978$exports = {};
var $b245d963f1f5d5e9$exports = {};
$b245d963f1f5d5e9$exports = new URL("bladevortexcancel.bdddafbb.png", import.meta.url).toString();


$d80978e45f7d7978$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "BladeVortexCancel",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 6,
        "castDelay": 0,
        "animationSpeed": 1,
        "animationDuration": 0,
        "skipCooldownOnChannel": 0,
        "spellName": "Cancel Blade Vortex",
        "description": "Cancel <b>Blade Vortex</b>.",
        "icon": "05c6dc45f29ede2458cb64447493d391",
        "usableBy": "030000000b000000",
        "cooldown": 1,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$d80978e45f7d7978$exports.getImport = (guid)=>{
    switch(guid){
        case "05c6dc45f29ede2458cb64447493d391":
            return 0, (/*@__PURE__*/$parcel$interopDefault($b245d963f1f5d5e9$exports));
    }
};


var $2c390dc37bff363d$exports = {};

$2c390dc37bff363d$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "BladeVortexShortCD",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 411,
        "castDelay": 350,
        "animationSpeed": 0.5,
        "animationDuration": 5.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Blade Vortex",
        "description": "Become <b>Unstoppable</b> and deal <b>12</b> damage to all nearby enemies every second for <b>8</b> seconds. You can't cast any other spells while the effect is active. Damage taken is increased by <b>10%</b> while the effect is active.",
        "icon": "00e001d820b531143882280fb06886a9",
        "usableBy": null,
        "cooldown": 45,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$2c390dc37bff363d$exports.getImport = (guid)=>{
    switch(guid){
        case "00e001d820b531143882280fb06886a9":
            return 0, (/*@__PURE__*/$parcel$interopDefault($183e639aac5e3f33$exports));
    }
};


var $8c7ce643d624ce9c$exports = {};
var $4c900f368333b08b$exports = {};
$4c900f368333b08b$exports = new URL("rend.0ff0d5d1.png", import.meta.url).toString();


$8c7ce643d624ce9c$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "Bleed",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "9e56d9f0b64fd444888ce572ea1cb882",
            "type": 3
        },
        "beforeChannelSoundDelay": 250,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 30,
        "castDelay": 420,
        "animationSpeed": 1.6,
        "animationDuration": 0.6,
        "skipCooldownOnChannel": 0,
        "spellName": "Bleed",
        "description": "Cause the target to bleed for <b>4</b> damage every <b>3</b> seconds for <b>12</b> seconds.",
        "icon": "e8175970d2f112e4e888c404e92ecd6c",
        "usableBy": "030000000b000000",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "12d2ef2f459217549b413b4b15bf4b0e",
            "type": 2
        }
    }
};
$8c7ce643d624ce9c$exports.getImport = (guid)=>{
    switch(guid){
        case "e8175970d2f112e4e888c404e92ecd6c":
            return 0, (/*@__PURE__*/$parcel$interopDefault($4c900f368333b08b$exports));
    }
};


var $041f8080e654d1e1$exports = {};
var $976a8366a3f10f6a$exports = {};
$976a8366a3f10f6a$exports = new URL("devastatingstrike.a43a02c3.png", import.meta.url).toString();


$041f8080e654d1e1$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "DevastatingStrike",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "d44b46a27bd0a8f4e83641e36dffdc4b",
            "type": 3
        },
        "beforeChannelSoundDelay": 100,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 38,
        "castDelay": 500,
        "animationSpeed": 1.5,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Devastating Strike",
        "description": "Deal <b>32</b> damage to the target. Apply <b>Devastating Strike</b> to the opponent for <b>2</b> seconds. Reduce all healing received by the target by <b>25%</b> for <b>6</b> seconds.",
        "icon": "6f7f9289900650948bef4415d8d91de9",
        "usableBy": "030000000b000000",
        "cooldown": 7,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "12d2ef2f459217549b413b4b15bf4b0e",
            "type": 2
        }
    }
};
$041f8080e654d1e1$exports.getImport = (guid)=>{
    switch(guid){
        case "6f7f9289900650948bef4415d8d91de9":
            return 0, (/*@__PURE__*/$parcel$interopDefault($976a8366a3f10f6a$exports));
    }
};


var $313a89ad1241431b$exports = {};

$313a89ad1241431b$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "DevastatingStrikeLongCD",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "d44b46a27bd0a8f4e83641e36dffdc4b",
            "type": 3
        },
        "beforeChannelSoundDelay": 100,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 38,
        "castDelay": 500,
        "animationSpeed": 1.5,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Devastating Strike",
        "description": "Deal <b>32</b> damage to the target. Apply <b>Devastating Strike</b> to the opponent for <b>2</b> seconds. Reduce all healing received by the target by <b>25%</b> for <b>6</b> seconds.",
        "icon": "6f7f9289900650948bef4415d8d91de9",
        "usableBy": "030000000b000000",
        "cooldown": 8,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "12d2ef2f459217549b413b4b15bf4b0e",
            "type": 2
        }
    }
};
$313a89ad1241431b$exports.getImport = (guid)=>{
    switch(guid){
        case "6f7f9289900650948bef4415d8d91de9":
            return 0, (/*@__PURE__*/$parcel$interopDefault($976a8366a3f10f6a$exports));
    }
};


var $583deb707643d56d$exports = {};
var $b925d197bdc6de72$exports = {};
$b925d197bdc6de72$exports = new URL("execute.d90a7dfa.png", import.meta.url).toString();


$583deb707643d56d$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "Execute",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 46,
        "castDelay": 625,
        "animationSpeed": 1.5,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Decapitate",
        "description": "Deal <b>40</b> damage to the target. This can only be used if the target is below <b>20%</b> health.",
        "icon": "cd8441257777e6b4694869fef7d72a7f",
        "usableBy": "030000000b000000",
        "cooldown": 15,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "12d2ef2f459217549b413b4b15bf4b0e",
            "type": 2
        }
    }
};
$583deb707643d56d$exports.getImport = (guid)=>{
    switch(guid){
        case "cd8441257777e6b4694869fef7d72a7f":
            return 0, (/*@__PURE__*/$parcel$interopDefault($b925d197bdc6de72$exports));
    }
};


var $8a6f50c107f17c4d$exports = {};
var $13d9d27c8df89d7c$exports = {};
$13d9d27c8df89d7c$exports = new URL("focusedregeneration.9e699438.png", import.meta.url).toString();


$8a6f50c107f17c4d$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "FocusedRegeneration",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 87,
        "castDelay": 500,
        "animationSpeed": 1,
        "animationDuration": 0.8,
        "skipCooldownOnChannel": 0,
        "spellName": "Focused Regeneration",
        "description": "Heal yourself for <b>5</b> health every second for <b>12</b> seconds.",
        "icon": "0ab5d0c171bd30c4bbf4863231809538",
        "usableBy": null,
        "cooldown": 60,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$8a6f50c107f17c4d$exports.getImport = (guid)=>{
    switch(guid){
        case "0ab5d0c171bd30c4bbf4863231809538":
            return 0, (/*@__PURE__*/$parcel$interopDefault($13d9d27c8df89d7c$exports));
    }
};


var $e1aa9c73044a7b64$exports = {};
var $b40ffa94834fa556$exports = {};
$b40ffa94834fa556$exports = new URL("intimidatingshout.8b0e2a15.png", import.meta.url).toString();


$e1aa9c73044a7b64$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "IntimidatingShout",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 18,
        "castDelay": 200,
        "animationSpeed": 2,
        "animationDuration": 0.6,
        "skipCooldownOnChannel": 0,
        "spellName": "Intimidating Shout",
        "description": "Slow all targets within <b>8</b> yards by <b>50%</b>.",
        "icon": "580edcb553337f5499359458eeb2d417",
        "usableBy": null,
        "cooldown": 3,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$e1aa9c73044a7b64$exports.getImport = (guid)=>{
    switch(guid){
        case "580edcb553337f5499359458eeb2d417":
            return 0, (/*@__PURE__*/$parcel$interopDefault($b40ffa94834fa556$exports));
    }
};


var $ad3d12d16a1d70de$exports = {};
var $fc6165290da5d85b$exports = {};
$fc6165290da5d85b$exports = new URL("menacingblow.faa64946.png", import.meta.url).toString();


$ad3d12d16a1d70de$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "MenacingBlow",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "d456f70dbff661749a87d1f3288a9d8d",
            "type": 3
        },
        "beforeChannelSoundDelay": 100,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 8,
        "castDelay": 300,
        "animationSpeed": 1,
        "animationDuration": 0.7,
        "skipCooldownOnChannel": 0,
        "spellName": "Menacing Blow",
        "description": "Deal <b>9</b> damage to the target.",
        "icon": "5ea5a4165a1029d498282b07a7aea7e8",
        "usableBy": "030000000b000000",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "12d2ef2f459217549b413b4b15bf4b0e",
            "type": 2
        }
    }
};
$ad3d12d16a1d70de$exports.getImport = (guid)=>{
    switch(guid){
        case "5ea5a4165a1029d498282b07a7aea7e8":
            return 0, (/*@__PURE__*/$parcel$interopDefault($fc6165290da5d85b$exports));
    }
};


var $8f014eba7f0d1e93$exports = {};
var $1ff0cb040edc5731$exports = {};
$1ff0cb040edc5731$exports = new URL("overwhelmingpower.f70f2b4b.png", import.meta.url).toString();


$8f014eba7f0d1e93$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "OverwhelmingPower",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 20,
        "castDelay": 240,
        "animationSpeed": 3,
        "animationDuration": 0.8,
        "skipCooldownOnChannel": 0,
        "spellName": "Overwhelming Power",
        "description": "Remove all <b>Slow</b> and <b>Snare</b> effects from yourself.",
        "icon": "c052fb89cad18364ab91fd897fc11a41",
        "usableBy": "0b000000",
        "cooldown": 30,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$8f014eba7f0d1e93$exports.getImport = (guid)=>{
    switch(guid){
        case "c052fb89cad18364ab91fd897fc11a41":
            return 0, (/*@__PURE__*/$parcel$interopDefault($1ff0cb040edc5731$exports));
    }
};


var $9b34fb66ac06ab4e$exports = {};
var $efcfe03905e2ae46$exports = {};
$efcfe03905e2ae46$exports = new URL("powerstrike.932dd4fd.png", import.meta.url).toString();


$9b34fb66ac06ab4e$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "PowerStrike",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "f8ec7fedf0c58e64480639fc2c72608a",
            "type": 3
        },
        "beforeChannelSoundDelay": 100,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 31,
        "castDelay": 450,
        "animationSpeed": 2,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Power Strike",
        "description": "Deal <b>16</b> damage to the target. Deal an additional <b>10</b> damage if <b>Devastating Strike</b> is on the target.",
        "icon": "78b03e780c95cba46a497c873eab18ba",
        "usableBy": "030000000b000000",
        "cooldown": 3,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "12d2ef2f459217549b413b4b15bf4b0e",
            "type": 2
        }
    }
};
$9b34fb66ac06ab4e$exports.getImport = (guid)=>{
    switch(guid){
        case "78b03e780c95cba46a497c873eab18ba":
            return 0, (/*@__PURE__*/$parcel$interopDefault($efcfe03905e2ae46$exports));
    }
};


var $8fea66adb4dd7c60$exports = {};

$8fea66adb4dd7c60$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "PowerStrikeLongCD",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "f8ec7fedf0c58e64480639fc2c72608a",
            "type": 3
        },
        "beforeChannelSoundDelay": 100,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 31,
        "castDelay": 450,
        "animationSpeed": 2,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Power Strike",
        "description": "Deal <b>16</b> damage to the target. Deal an additional <b>10</b> damage if <b>Devastating Strike</b> is on the target.",
        "icon": "78b03e780c95cba46a497c873eab18ba",
        "usableBy": "030000000b000000",
        "cooldown": 8,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "12d2ef2f459217549b413b4b15bf4b0e",
            "type": 2
        }
    }
};
$8fea66adb4dd7c60$exports.getImport = (guid)=>{
    switch(guid){
        case "78b03e780c95cba46a497c873eab18ba":
            return 0, (/*@__PURE__*/$parcel$interopDefault($efcfe03905e2ae46$exports));
    }
};


var $b4b4e6f14e2a5105$exports = {};
var $144c9535a3f4f0c2$exports = {};
$144c9535a3f4f0c2$exports = new URL("reflect.c0b511a0.png", import.meta.url).toString();


$b4b4e6f14e2a5105$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "Reflect",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 150,
        "castDelay": 150,
        "animationSpeed": 1,
        "animationDuration": 0.8,
        "skipCooldownOnChannel": 0,
        "spellName": "Reflect",
        "description": "<b>Reflect</b> the next incoming projectile back to its source.",
        "icon": "c8ba110259020cd46916463a7095e59d",
        "usableBy": "03000000",
        "cooldown": 15,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$b4b4e6f14e2a5105$exports.getImport = (guid)=>{
    switch(guid){
        case "c8ba110259020cd46916463a7095e59d":
            return 0, (/*@__PURE__*/$parcel$interopDefault($144c9535a3f4f0c2$exports));
    }
};


var $2069717b3662ac92$exports = {};
var $187f7445dfb02fd1$exports = {};
$187f7445dfb02fd1$exports = new URL("shieldwall.42e62331.png", import.meta.url).toString();


$2069717b3662ac92$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "ShieldWall",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7649805383090480000,
            "guid": "f35254fae1fea054bb028dad35611c32",
            "type": 3
        },
        "castAuraScale": 1,
        "castAuraYOffset": 0.18,
        "attachCastAuraToCaster": 1,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 20,
        "castDelay": 400,
        "animationSpeed": 2,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Empowered Shields",
        "description": "Reduce all incoming damage by <b>90%</b> and reduce your damage done by <b>60%</b>. Lasts <b>10</b> seconds.",
        "icon": "ee221876e7c50f6449caf488c4dedb5c",
        "usableBy": "03000000",
        "cooldown": 90,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$2069717b3662ac92$exports.getImport = (guid)=>{
    switch(guid){
        case "ee221876e7c50f6449caf488c4dedb5c":
            return 0, (/*@__PURE__*/$parcel$interopDefault($187f7445dfb02fd1$exports));
    }
};


var $5f0c0ecad9cae7be$exports = {};
var $d9a16532105148a2$exports = {};
$d9a16532105148a2$exports = new URL("shieldwallcancel.e7a031c8.png", import.meta.url).toString();


$5f0c0ecad9cae7be$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "ShieldWallCancel",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 20,
        "castDelay": 0,
        "animationSpeed": 2,
        "animationDuration": 0,
        "skipCooldownOnChannel": 0,
        "spellName": "Cancel Empowered Shields",
        "description": "Cancel <b>Empowered Shields</b>.",
        "icon": "79ea3624985851d4197603ee2580baf5",
        "usableBy": "03000000",
        "cooldown": 1,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$5f0c0ecad9cae7be$exports.getImport = (guid)=>{
    switch(guid){
        case "79ea3624985851d4197603ee2580baf5":
            return 0, (/*@__PURE__*/$parcel$interopDefault($d9a16532105148a2$exports));
    }
};


var $9b90798b734765e7$exports = {};
var $2479d9ac49c6b12e$exports = {};
$2479d9ac49c6b12e$exports = new URL("sweepingrevenge.1d707150.png", import.meta.url).toString();


$9b90798b734765e7$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "SweepingRevenge",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 2,
        "castDelay": 250,
        "animationSpeed": 1.3,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Sweeping Revenge",
        "description": "Charge rapidly at the target, deal <b>12</b> damage and <b>Stun</b> them for <b>3</b> seconds, and <b>Dismount</b> them.",
        "icon": "e9ae962ebadecbb4b862758a718e02f9",
        "usableBy": "03000000",
        "cooldown": 30,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$9b90798b734765e7$exports.getImport = (guid)=>{
    switch(guid){
        case "e9ae962ebadecbb4b862758a718e02f9":
            return 0, (/*@__PURE__*/$parcel$interopDefault($2479d9ac49c6b12e$exports));
    }
};


var $753ffed3d21c3b85$exports = {};
var $15622bbeb3319a2a$exports = {};
$15622bbeb3319a2a$exports = new URL("swiftjustice.fd81a73b.png", import.meta.url).toString();


$753ffed3d21c3b85$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "SwiftJustice",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 2,
        "castDelay": 180,
        "animationSpeed": 1.7,
        "animationDuration": 0.7,
        "skipCooldownOnChannel": 0,
        "spellName": "Swift Justice",
        "description": "Charge rapidly at the target. \n\n<b>Enemy Target:</b> deal <b>12</b> damage and <b>Stun</b> them for <b>1.5</b> seconds, and <b>Dismount</b> them.\n\n<b>Friendly Target:</b> reduce all physical damage they take by <b>20%</b> for 4 seconds.",
        "icon": "171ada2280fc2a04fbdb7d89a5ac6e30",
        "usableBy": "03000000",
        "cooldown": 18,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$753ffed3d21c3b85$exports.getImport = (guid)=>{
    switch(guid){
        case "171ada2280fc2a04fbdb7d89a5ac6e30":
            return 0, (/*@__PURE__*/$parcel$interopDefault($15622bbeb3319a2a$exports));
    }
};


var $dfd4f37387971019$exports = {};

$dfd4f37387971019$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "SwiftJusticeNoCD",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 2,
        "castDelay": 180,
        "animationSpeed": 1,
        "animationDuration": 1,
        "skipCooldownOnChannel": 1,
        "spellName": "Swift Justice",
        "description": "Charge rapidly at the target. \n\n<b>Enemy Target:</b> deal <b>12</b> damage and <b>Stun</b> them for <b>1.5</b> seconds, and <b>Dismount</b> them.\n\n<b>Friendly Target:</b> reduce all physical damage they take by <b>20%</b> for 4 seconds.",
        "icon": "171ada2280fc2a04fbdb7d89a5ac6e30",
        "usableBy": null,
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$dfd4f37387971019$exports.getImport = (guid)=>{
    switch(guid){
        case "171ada2280fc2a04fbdb7d89a5ac6e30":
            return 0, (/*@__PURE__*/$parcel$interopDefault($15622bbeb3319a2a$exports));
    }
};


var $7c5e8fc46ca19de3$exports = {};
var $da33fda954c5bcd0$exports = {};
$da33fda954c5bcd0$exports = new URL("terrifyingshout.ea7f08bf.png", import.meta.url).toString();


$7c5e8fc46ca19de3$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "TerrifyingShout",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 22,
        "castDelay": 600,
        "animationSpeed": 3,
        "animationDuration": 0.7,
        "skipCooldownOnChannel": 0,
        "spellName": "Terrifying Shout",
        "description": "<b>Incapacitate</b> all units within <b>8</b> yards. The effect will break if over <b>30</b> damage is dealt.",
        "icon": "5f52b93379fe5ce47aa3402bf4d976fd",
        "usableBy": "03000000",
        "cooldown": 80,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$7c5e8fc46ca19de3$exports.getImport = (guid)=>{
    switch(guid){
        case "5f52b93379fe5ce47aa3402bf4d976fd":
            return 0, (/*@__PURE__*/$parcel$interopDefault($da33fda954c5bcd0$exports));
    }
};


var $f95bb1ae2396815f$exports = {};
var $fdb6cd2f0e7c3cda$exports = {};
$fdb6cd2f0e7c3cda$exports = new URL("throatkick.a242f634.png", import.meta.url).toString();


$f95bb1ae2396815f$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "ThroatKick",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 16,
        "castDelay": 0,
        "animationSpeed": 1.2,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Throat Kick",
        "description": "If the target is casting, <b>Interrupt</b> them and prevent them from casting that spell for <b>5</b> seconds and any other spell for <b>3</b> seconds.",
        "icon": "e88820560787cf24b84b3a768989ca63",
        "usableBy": "03000000",
        "cooldown": 12,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "12d2ef2f459217549b413b4b15bf4b0e",
            "type": 2
        }
    }
};
$f95bb1ae2396815f$exports.getImport = (guid)=>{
    switch(guid){
        case "e88820560787cf24b84b3a768989ca63":
            return 0, (/*@__PURE__*/$parcel$interopDefault($fdb6cd2f0e7c3cda$exports));
    }
};


var $35c86f177c3f28a6$exports = {};
var $4a8e88f8c11bde91$exports = {};
$4a8e88f8c11bde91$exports = new URL("basicshot.4b85b449.png", import.meta.url).toString();


$35c86f177c3f28a6$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "BasicShot",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "e1469613e3c96a34a99dc366ba596c51",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 29,
        "castDelay": 280,
        "animationSpeed": 1,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Basic Shot",
        "description": "Deal <b>10</b> damage to the target. \n\nIf the target is within <b>10</b> yards, this will deal <b>50%</b> less damage.",
        "icon": "0ea63dd95ddc9ea40af807bb843ba582",
        "usableBy": "06000000",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$35c86f177c3f28a6$exports.getImport = (guid)=>{
    switch(guid){
        case "0ea63dd95ddc9ea40af807bb843ba582":
            return 0, (/*@__PURE__*/$parcel$interopDefault($4a8e88f8c11bde91$exports));
    }
};


var $cd321be7f8d12674$exports = {};
var $d409ea197d9d8485$exports = {};
$d409ea197d9d8485$exports = new URL("dissociativeforce.ec5a8aa4.png", import.meta.url).toString();


$cd321be7f8d12674$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "DissociativeForce",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "e1469613e3c96a34a99dc366ba596c51",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 177,
        "castDelay": 0,
        "animationSpeed": 1,
        "animationDuration": 0.52,
        "skipCooldownOnChannel": 0,
        "spellName": "Dissociative Force",
        "description": "Jump backwards with significant force.",
        "icon": "95f0b3f2b094f584aadf779bc0f8b409",
        "usableBy": "06000000",
        "cooldown": 15,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$cd321be7f8d12674$exports.getImport = (guid)=>{
    switch(guid){
        case "95f0b3f2b094f584aadf779bc0f8b409":
            return 0, (/*@__PURE__*/$parcel$interopDefault($d409ea197d9d8485$exports));
    }
};


var $657241a0c8825944$exports = {};
var $e9e3e8321fdc934d$exports = {};
$e9e3e8321fdc934d$exports = new URL("earthshield.bf8e71ad.png", import.meta.url).toString();


$657241a0c8825944$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "EarthShield",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "e1469613e3c96a34a99dc366ba596c51",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 312,
        "castDelay": 400,
        "animationSpeed": 1.5,
        "animationDuration": 0.8,
        "skipCooldownOnChannel": 0,
        "spellName": "Earth Shield",
        "description": "Become <b>Immune</b> to all incoming damage and negative effects for <b>6</b> seconds. You can move while the effect is active, but you cannot use any skills.",
        "icon": "fded7bcb5e6bf2f4a8b893610aff577b",
        "usableBy": "060000000f000000",
        "cooldown": 90,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$657241a0c8825944$exports.getImport = (guid)=>{
    switch(guid){
        case "fded7bcb5e6bf2f4a8b893610aff577b":
            return 0, (/*@__PURE__*/$parcel$interopDefault($e9e3e8321fdc934d$exports));
    }
};


var $85734d2c823989de$exports = {};
var $a60ace941eeefece$exports = {};
$a60ace941eeefece$exports = new URL("earthshieldcancel.08d2dc74.png", import.meta.url).toString();


$85734d2c823989de$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "EarthShieldCancel",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "e1469613e3c96a34a99dc366ba596c51",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 312,
        "castDelay": 0,
        "animationSpeed": 1.5,
        "animationDuration": 0,
        "skipCooldownOnChannel": 0,
        "spellName": "Cancel Earth Shield",
        "description": "Cancel <b>Earth Shield</b>.",
        "icon": "de4c74eddbade024b8892f0b5d59ae3f",
        "usableBy": "060000000f000000",
        "cooldown": 1,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$85734d2c823989de$exports.getImport = (guid)=>{
    switch(guid){
        case "de4c74eddbade024b8892f0b5d59ae3f":
            return 0, (/*@__PURE__*/$parcel$interopDefault($a60ace941eeefece$exports));
    }
};


var $8dd8d40680c80bcb$exports = {};
var $8cf4e1e483b9d126$exports = {};
$8cf4e1e483b9d126$exports = new URL("flare.937e38fe.png", import.meta.url).toString();


$8dd8d40680c80bcb$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "Flare",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "e1469613e3c96a34a99dc366ba596c51",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 0,
        "castDelay": 250,
        "animationSpeed": 1.5,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Flare Shot",
        "description": "Reveal all <b>Invisible</b> targets within <b>8</b> yards of the targeted location for <b>15</b> seconds.",
        "icon": "df5a24fba1b4a274a9b8bbe383ba7c79",
        "usableBy": "060000000f000000",
        "cooldown": 20,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 8,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "49714b7747fcdd245a2a48451ad05657",
            "type": 2
        }
    }
};
$8dd8d40680c80bcb$exports.getImport = (guid)=>{
    switch(guid){
        case "df5a24fba1b4a274a9b8bbe383ba7c79":
            return 0, (/*@__PURE__*/$parcel$interopDefault($8cf4e1e483b9d126$exports));
    }
};


var $31ca1b498026887a$exports = {};
var $edd8eb1821a0c436$exports = {};
$edd8eb1821a0c436$exports = new URL("freezingtrap.8d5b900f.png", import.meta.url).toString();


$31ca1b498026887a$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "FreezingTrap",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "e1469613e3c96a34a99dc366ba596c51",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 18,
        "castDelay": 275,
        "animationSpeed": 2,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Freezing Trap",
        "description": "Shoot a freezing trap at the targeted area, <b>Incapacitating</b> the closest target for <b>10</b> seconds. Any damage dealt to the target will break the effect.",
        "icon": "e3c08afc92535b2449c4d61c202511c7",
        "usableBy": "06000000",
        "cooldown": 34,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 1.5,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "49714b7747fcdd245a2a48451ad05657",
            "type": 2
        }
    }
};
$31ca1b498026887a$exports.getImport = (guid)=>{
    switch(guid){
        case "e3c08afc92535b2449c4d61c202511c7":
            return 0, (/*@__PURE__*/$parcel$interopDefault($edd8eb1821a0c436$exports));
    }
};


var $38957bd8c3668d39$exports = {};
var $9d8671c268c577b6$exports = {};
$9d8671c268c577b6$exports = new URL("longdraw.2afc543b.png", import.meta.url).toString();


$38957bd8c3668d39$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "InstantLongDraw",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "e1469613e3c96a34a99dc366ba596c51",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 259,
        "castDelay": 750,
        "animationSpeed": 1.5,
        "animationDuration": 0.8,
        "skipCooldownOnChannel": 0,
        "spellName": "Long Draw",
        "description": "Deal <b>29</b> damage to the target. Reduce the healing received by the target by <b>25%</b> for <b>6</b> seconds. \n\nIf the target is poisoned, this will deal <b>38</b> damage instead. \n\nIf the target is within <b>10</b> yards, this will deal <b>50%</b> less damage.",
        "icon": "78d18975f4524354199d2100476e9758",
        "usableBy": null,
        "cooldown": 6,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$38957bd8c3668d39$exports.getImport = (guid)=>{
    switch(guid){
        case "78d18975f4524354199d2100476e9758":
            return 0, (/*@__PURE__*/$parcel$interopDefault($9d8671c268c577b6$exports));
    }
};


var $cbcbfdd15d960420$exports = {};
var $70cb1e543041e881$exports = {};
$70cb1e543041e881$exports = new URL("killshot.37187ef2.png", import.meta.url).toString();


$cbcbfdd15d960420$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "KillShot",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "e1469613e3c96a34a99dc366ba596c51",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 29,
        "castDelay": 140,
        "animationSpeed": 2,
        "animationDuration": 0.25,
        "skipCooldownOnChannel": 0,
        "spellName": "Kill Shot",
        "description": "Deal <b>32</b> damage to the target. This can only be used if the target is below <b>20%</b> health. \n\nIf the target is within <b>10</b> yards, this will deal <b>50%</b> less damage",
        "icon": "a9672c0760f252f468f04517630b39e6",
        "usableBy": "060000000f000000",
        "cooldown": 15,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$cbcbfdd15d960420$exports.getImport = (guid)=>{
    switch(guid){
        case "a9672c0760f252f468f04517630b39e6":
            return 0, (/*@__PURE__*/$parcel$interopDefault($70cb1e543041e881$exports));
    }
};


var $b8264b3f10a81286$exports = {};

$b8264b3f10a81286$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "LongDraw",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "b537e8a82d547164c80ff39158b0c623",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 8300000,
            "guid": "b49169f973e2c674caf89289d6b096a1",
            "type": 3
        },
        "castSoundVolume": 1,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 259,
        "castDelay": 0,
        "animationSpeed": 1,
        "animationDuration": 1.1,
        "skipCooldownOnChannel": 0,
        "spellName": "Long Draw",
        "description": "Deal <b>29</b> damage to the target. Reduce the healing received by the target by <b>25%</b> for <b>6</b> seconds. \n\nIf the target is poisoned, this will deal <b>38</b> damage instead. \n\nIf the target is within <b>10</b> yards, this will deal <b>50%</b> less damage.",
        "icon": "78d18975f4524354199d2100476e9758",
        "usableBy": "060000000f000000",
        "cooldown": 6,
        "castTime": 1,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$b8264b3f10a81286$exports.getImport = (guid)=>{
    switch(guid){
        case "78d18975f4524354199d2100476e9758":
            return 0, (/*@__PURE__*/$parcel$interopDefault($9d8671c268c577b6$exports));
    }
};


var $f08efac4a0914da3$exports = {};
var $acb25574e9f79e8e$exports = {};
$acb25574e9f79e8e$exports = new URL("magicarrow.e00e013d.png", import.meta.url).toString();


$f08efac4a0914da3$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "MagicArrow",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "e1469613e3c96a34a99dc366ba596c51",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 29,
        "castDelay": 375,
        "animationSpeed": 0.65,
        "animationDuration": 0.8,
        "skipCooldownOnChannel": 0,
        "spellName": "Magic Arrow",
        "description": "Deal <b>12</b> damage to the target. Slow the target by <b>35%</b> for <b>5</b> seconds. \n\nIf the target is within <b>10</b> yards, this will deal <b>50%</b> less damage",
        "icon": "cce22c74c16aaa44090b8a38937e9b6d",
        "usableBy": "060000000f000000",
        "cooldown": 8,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$f08efac4a0914da3$exports.getImport = (guid)=>{
    switch(guid){
        case "cce22c74c16aaa44090b8a38937e9b6d":
            return 0, (/*@__PURE__*/$parcel$interopDefault($acb25574e9f79e8e$exports));
    }
};


var $b51132ddc9b2cecc$exports = {};
var $751f622784a4b7a0$exports = {};
$751f622784a4b7a0$exports = new URL("paralyticarrow.9dc04320.png", import.meta.url).toString();


$b51132ddc9b2cecc$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "ParalyticArrow",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "e1469613e3c96a34a99dc366ba596c51",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 29,
        "castDelay": 180,
        "animationSpeed": 1.75,
        "animationDuration": 0.3,
        "skipCooldownOnChannel": 0,
        "spellName": "Paralytic Arrow",
        "description": "<b>Incapacitate</b> the target for <b>3</b> seconds. Any damage dealt to the target will break the effect.",
        "icon": "1dbf4dc58552f87459de56d99ee1dc16",
        "usableBy": "06000000",
        "cooldown": 25,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$b51132ddc9b2cecc$exports.getImport = (guid)=>{
    switch(guid){
        case "1dbf4dc58552f87459de56d99ee1dc16":
            return 0, (/*@__PURE__*/$parcel$interopDefault($751f622784a4b7a0$exports));
    }
};


var $e5b1ca906b021de4$exports = {};
var $d2a5150af1601384$exports = {};
$d2a5150af1601384$exports = new URL("poisontippedarrow.2c49b373.png", import.meta.url).toString();


$e5b1ca906b021de4$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "PoisonTippedArrow",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "e1469613e3c96a34a99dc366ba596c51",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 29,
        "castDelay": 280,
        "animationSpeed": 1,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Poison Tipped Arrow",
        "description": "Deal <b>7</b> damage every <b>3</b> seconds to the target for <b>9</b> seconds.",
        "icon": "3d94f5ed814ff3e4d828ac7b730cfd43",
        "usableBy": "060000000f000000",
        "cooldown": 12,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$e5b1ca906b021de4$exports.getImport = (guid)=>{
    switch(guid){
        case "3d94f5ed814ff3e4d828ac7b730cfd43":
            return 0, (/*@__PURE__*/$parcel$interopDefault($d2a5150af1601384$exports));
    }
};


var $880de85bef55cae1$exports = {};
var $85b01a459719871c$exports = {};
$85b01a459719871c$exports = new URL("rapidfire.639db96c.png", import.meta.url).toString();


$880de85bef55cae1$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "RapidFire",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "e1469613e3c96a34a99dc366ba596c51",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 14,
        "castDelay": 250,
        "animationSpeed": 2,
        "animationDuration": 0.6,
        "skipCooldownOnChannel": 0,
        "spellName": "Rapid Fire",
        "description": "Reduce your global cooldown by <b>35%</b> and increase your cast speed by <b>35%</b> for <b>8</b> seconds.",
        "icon": "121f1815ccc8024499ef1312ac624479",
        "usableBy": null,
        "cooldown": 60,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$880de85bef55cae1$exports.getImport = (guid)=>{
    switch(guid){
        case "121f1815ccc8024499ef1312ac624479":
            return 0, (/*@__PURE__*/$parcel$interopDefault($85b01a459719871c$exports));
    }
};


var $ef874693bb3df6ff$exports = {};
var $9b7186ce219b2084$exports = {};
$9b7186ce219b2084$exports = new URL("sedativeshot.cf8ed2d0.png", import.meta.url).toString();


$ef874693bb3df6ff$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "SedativeShot",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "e1469613e3c96a34a99dc366ba596c51",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 29,
        "castDelay": 320,
        "animationSpeed": 0.8,
        "animationDuration": 0.65,
        "skipCooldownOnChannel": 0,
        "spellName": "Sedative Shot",
        "description": "Deal <b>2</b> damage and prevent the target from casting spells for <b>3</b> seconds.",
        "icon": "05d1c779bd585304fa0902366307dc27",
        "usableBy": "060000000f000000",
        "cooldown": 15,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$ef874693bb3df6ff$exports.getImport = (guid)=>{
    switch(guid){
        case "05d1c779bd585304fa0902366307dc27":
            return 0, (/*@__PURE__*/$parcel$interopDefault($9b7186ce219b2084$exports));
    }
};


var $3aa96ccb04a46ad9$exports = {};
var $0d1656142bcdd735$exports = {};
$0d1656142bcdd735$exports = new URL("volley.9b4cfb33.png", import.meta.url).toString();


$3aa96ccb04a46ad9$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "Volley",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "b537e8a82d547164c80ff39158b0c623",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 22,
        "castDelay": 0,
        "animationSpeed": 2,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Volley",
        "description": "For <b>8</b> seconds, all enemies within <b>8</b> yards of the targeted area will be slowed by <b>65%</b>. \n\nIn addition, every <b>2</b> seconds they will take <b>2</b> damage.",
        "icon": "9488e74b1d93ce04ead2df6c377fd8c9",
        "usableBy": "060000000f000000",
        "cooldown": 25,
        "castTime": 0.75,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 8,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "f421617b0a9e30f489dcb239dba0bd90",
            "type": 2
        }
    }
};
$3aa96ccb04a46ad9$exports.getImport = (guid)=>{
    switch(guid){
        case "9488e74b1d93ce04ead2df6c377fd8c9":
            return 0, (/*@__PURE__*/$parcel$interopDefault($0d1656142bcdd735$exports));
    }
};


var $978e97668ee148a3$exports = {};

$978e97668ee148a3$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "TestLuaSpell",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 0,
        "castDelay": 350,
        "animationSpeed": 1.5,
        "animationDuration": 0.65,
        "skipCooldownOnChannel": 0,
        "spellName": "Test Lua Spell",
        "description": "My Description",
        "icon": "c1d6653c52b46d840ae56e6b7842fbc6",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100000,
        "alwaysCastableSpell": 0,
        "usableBy": null,
        "luaScript": {
            "fileID": 4900000,
            "guid": "6b1055f9daf179a4ca3b3efbd96d5438",
            "type": 3
        }
    }
};
$978e97668ee148a3$exports.getImport = (guid)=>{
    switch(guid){
        case "c1d6653c52b46d840ae56e6b7842fbc6":
            return 0, (/*@__PURE__*/$parcel$interopDefault($b08d6c5ea3221911$exports));
    }
};


var $54b537a3b7f34316$exports = {};
var $82e2b9a1fa037463$exports = {};
$82e2b9a1fa037463$exports = new URL("bloodshackles.115c2d7f.png", import.meta.url).toString();


$54b537a3b7f34316$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "BloodShackles",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 146,
        "castDelay": 140,
        "animationSpeed": 1,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Blood Shackles",
        "description": "<b>Incapacitate</b> your target for <b>10</b> seconds. Must be in <b>Shadow Crawl</b> to use. Target must not be in <b>Combat</b>. Does not break <b>Shadow Crawl</b> when used.",
        "icon": "47c9b84aaab2d6e46a0bcbc570f494ea",
        "usableBy": "01000000",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "3d5ec28ee1f473644bac30cba533f2b6",
            "type": 2
        }
    }
};
$54b537a3b7f34316$exports.getImport = (guid)=>{
    switch(guid){
        case "47c9b84aaab2d6e46a0bcbc570f494ea":
            return 0, (/*@__PURE__*/$parcel$interopDefault($82e2b9a1fa037463$exports));
    }
};


var $79e22fd9457be8f3$exports = {};
var $0dde379a356e17b2$exports = {};
$0dde379a356e17b2$exports = new URL("blowfromtheshadows.285c5f25.png", import.meta.url).toString();


$79e22fd9457be8f3$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "BlowFromTheShadows",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 135,
        "castDelay": 320,
        "animationSpeed": 1,
        "animationDuration": 0.7,
        "skipCooldownOnChannel": 0,
        "spellName": "Blow From the Shadows",
        "description": "<b>Stun</b> the target for <b>4</b> seconds and gain <b>2</b> combo points. Must be in <b>Shadow Crawl</b> to use.",
        "icon": "da3b3a9056de3364a80baaf1c138a0bb",
        "usableBy": "01000000",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "12d2ef2f459217549b413b4b15bf4b0e",
            "type": 2
        }
    }
};
$79e22fd9457be8f3$exports.getImport = (guid)=>{
    switch(guid){
        case "da3b3a9056de3364a80baaf1c138a0bb":
            return 0, (/*@__PURE__*/$parcel$interopDefault($0dde379a356e17b2$exports));
    }
};


var $32c8d772dfaa1caf$exports = {};
var $458c8393947b944b$exports = {};
$458c8393947b944b$exports = new URL("dirtytricks.6caa629f.png", import.meta.url).toString();


$32c8d772dfaa1caf$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "DirtyTricks",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 9,
        "castDelay": 0,
        "animationSpeed": 1,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Dirty Tricks",
        "description": "Increase the damage dealt by your next damage dealing ability by <b>35%</b>. Does not break <b>Shadow Crawl</b>.",
        "icon": "3ef2e204a9c40ab45935c80c67c26dd4",
        "usableBy": null,
        "cooldown": 60,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "a8cd7cc6f0212db4a8228be1ba9145b6",
            "type": 2
        }
    }
};
$32c8d772dfaa1caf$exports.getImport = (guid)=>{
    switch(guid){
        case "3ef2e204a9c40ab45935c80c67c26dd4":
            return 0, (/*@__PURE__*/$parcel$interopDefault($458c8393947b944b$exports));
    }
};


var $79541344c7fe0711$exports = {};
var $86fe524a9c85cdcf$exports = {};
$86fe524a9c85cdcf$exports = new URL("focus.d37eda71.png", import.meta.url).toString();


$79541344c7fe0711$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "Focus",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 8,
        "castDelay": 0,
        "animationSpeed": 1,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Focus",
        "description": "Reset the cooldown of <b>Smoke Bomb</b>, <b>Invigorate</b>, and <b>Shadow Blink</b>. Can be cast while <b>Stunned</b> or <b>Incapacitated</b>. Does not break <b>Shadow Crawl</b>.",
        "icon": "553542b94b9c3fe46bae97534122c6b6",
        "usableBy": "01000000",
        "cooldown": 120,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "a8cd7cc6f0212db4a8228be1ba9145b6",
            "type": 2
        }
    }
};
$79541344c7fe0711$exports.getImport = (guid)=>{
    switch(guid){
        case "553542b94b9c3fe46bae97534122c6b6":
            return 0, (/*@__PURE__*/$parcel$interopDefault($86fe524a9c85cdcf$exports));
    }
};


var $2e0dfe3c5031fb09$exports = {};
var $9ac58729d1bebfd5$exports = {};
$9ac58729d1bebfd5$exports = new URL("incapacitate.420d5ca6.png", import.meta.url).toString();


$2e0dfe3c5031fb09$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "Incapacitate",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 0,
        "castDelay": 180,
        "animationSpeed": 2,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Incapacitate",
        "description": "Deal <b>2</b> damage, <b>Incapacitate</b> the target for <b>2</b> seconds and gain <b>1</b> combo point. Any damage dealt will break the effect.",
        "icon": "b5b3f89cc61b53e4e992179ccb46b542",
        "usableBy": "010000000a000000",
        "cooldown": 10,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$2e0dfe3c5031fb09$exports.getImport = (guid)=>{
    switch(guid){
        case "b5b3f89cc61b53e4e992179ccb46b542":
            return 0, (/*@__PURE__*/$parcel$interopDefault($9ac58729d1bebfd5$exports));
    }
};


var $d483f3ace4ec045e$exports = {};
var $a32f8d41c7f9e367$exports = {};
$a32f8d41c7f9e367$exports = new URL("invigorate.cf9a3fb2.png", import.meta.url).toString();


$d483f3ace4ec045e$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "Invigorate",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 15,
        "castDelay": 0,
        "animationSpeed": 2,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Invigorate",
        "description": "Increase your movement speed by <b>80%</b> for <b>10</b> seconds.",
        "icon": "1e93a01a34ac35847b9fe93c8aca18f8",
        "usableBy": "01000000",
        "cooldown": 60,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "a8cd7cc6f0212db4a8228be1ba9145b6",
            "type": 2
        }
    }
};
$d483f3ace4ec045e$exports.getImport = (guid)=>{
    switch(guid){
        case "1e93a01a34ac35847b9fe93c8aca18f8":
            return 0, (/*@__PURE__*/$parcel$interopDefault($a32f8d41c7f9e367$exports));
    }
};


var $19e536cb6c5b5dda$exports = {};
var $058623973010f076$exports = {};
$058623973010f076$exports = new URL("kick.d3f59eaa.png", import.meta.url).toString();


$19e536cb6c5b5dda$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "Kick",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 11,
        "castDelay": 0,
        "animationSpeed": 1.5,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Kick",
        "description": "If the target is casting, <b>Interrupt</b> them and prevent them from casting that spell for <b>4</b> seconds and any other spell for <b>2</b> seconds.",
        "icon": "4bac57cf058bba546ab93e97c1ada84f",
        "usableBy": "010000000a000000",
        "cooldown": 10,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "12d2ef2f459217549b413b4b15bf4b0e",
            "type": 2
        }
    }
};
$19e536cb6c5b5dda$exports.getImport = (guid)=>{
    switch(guid){
        case "4bac57cf058bba546ab93e97c1ada84f":
            return 0, (/*@__PURE__*/$parcel$interopDefault($058623973010f076$exports));
    }
};


var $737c478fc3a36bda$exports = {};
var $3b4dd03ca6ae689a$exports = {};
$3b4dd03ca6ae689a$exports = new URL("knifestorm.ed4621d0.png", import.meta.url).toString();


$737c478fc3a36bda$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "KnifeStorm",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 22,
        "castDelay": 550,
        "animationSpeed": 3.2,
        "animationDuration": 0.7,
        "skipCooldownOnChannel": 0,
        "spellName": "Knife Storm",
        "description": "Deal <b>6</b> damage to all enemy Titans within <b>8</b> yards of yourself. In addition, <b>Slow</b> them by <b>50%</b> for <b>7</b> seconds.",
        "icon": "9b47afa0c666d44418476bf524b99796",
        "usableBy": "010000000a000000",
        "cooldown": 2,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$737c478fc3a36bda$exports.getImport = (guid)=>{
    switch(guid){
        case "9b47afa0c666d44418476bf524b99796":
            return 0, (/*@__PURE__*/$parcel$interopDefault($3b4dd03ca6ae689a$exports));
    }
};


var $5cdfcd4c21d96cb8$exports = {};
var $a6d88839025cd87a$exports = {};
$a6d88839025cd87a$exports = new URL("poisonblade.eb2878a4.png", import.meta.url).toString();


$5cdfcd4c21d96cb8$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "PoisonBlade",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 135,
        "castDelay": 320,
        "animationSpeed": 1,
        "animationDuration": 0.7,
        "skipCooldownOnChannel": 0,
        "spellName": "Poison Blade",
        "description": "<b>Stun</b> the target for a duration based on the number of combo points you have.\n\n<b>1 Combo Point</b>: 0 seconds\n<b>2 Combo Points</b>: 1 second\n<b>3 Combo Points</b>: 2 seconds\n<b>4 Combo Points</b>: 3 seconds\n<b>5 Combo Points</b>: 4 seconds",
        "icon": "6e2799ea8f38db3479293189cbfbf2d9",
        "usableBy": "01000000",
        "cooldown": 20,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "12d2ef2f459217549b413b4b15bf4b0e",
            "type": 2
        }
    }
};
$5cdfcd4c21d96cb8$exports.getImport = (guid)=>{
    switch(guid){
        case "6e2799ea8f38db3479293189cbfbf2d9":
            return 0, (/*@__PURE__*/$parcel$interopDefault($a6d88839025cd87a$exports));
    }
};


var $c01f367a0411e047$exports = {};
var $409823f1ace9a460$exports = {};
$409823f1ace9a460$exports = new URL("poisoninabottle.bdfdd34b.png", import.meta.url).toString();


$c01f367a0411e047$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "PoisonInABottle",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 23,
        "castDelay": 220,
        "animationSpeed": 3,
        "animationDuration": 0.8,
        "skipCooldownOnChannel": 0,
        "spellName": "Poison in a Bottle",
        "description": "<b>Incapacitate</b> your target for <b>10</b> seconds. Any damage dealt to the target will break the effect.",
        "icon": "e00e6fd325557f84aab65e995127b6b4",
        "usableBy": "010000000a000000",
        "cooldown": 120,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        }
    }
};
$c01f367a0411e047$exports.getImport = (guid)=>{
    switch(guid){
        case "e00e6fd325557f84aab65e995127b6b4":
            return 0, (/*@__PURE__*/$parcel$interopDefault($409823f1ace9a460$exports));
    }
};


var $3979c6ef0cbb751a$exports = {};

$3979c6ef0cbb751a$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "PoisonStrike",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 135,
        "castDelay": 320,
        "animationSpeed": 1,
        "animationDuration": 0.7,
        "skipCooldownOnChannel": 0,
        "spellName": "Poison Strike",
        "description": "<b>Stun</b> the target for a duration based on the number of combo points you have.\n\n<b>1 Combo Point</b>: 0 seconds\n<b>2 Combo Points</b>: 1 second\n<b>3 Combo Points</b>: 2 seconds\n<b>4 Combo Points</b>: 3 seconds\n<b>5 Combo Points</b>: 4 seconds",
        "icon": "6e2799ea8f38db3479293189cbfbf2d9",
        "usableBy": "0a000000",
        "cooldown": 20,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "12d2ef2f459217549b413b4b15bf4b0e",
            "type": 2
        }
    }
};
$3979c6ef0cbb751a$exports.getImport = (guid)=>{
    switch(guid){
        case "6e2799ea8f38db3479293189cbfbf2d9":
            return 0, (/*@__PURE__*/$parcel$interopDefault($a6d88839025cd87a$exports));
    }
};


var $fb081b677e06bd45$exports = {};
var $0a122ab5833f5a8e$exports = {};
$0a122ab5833f5a8e$exports = new URL("rupture.dce0cff1.png", import.meta.url).toString();


$fb081b677e06bd45$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "Rupture",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "d44b46a27bd0a8f4e83641e36dffdc4b",
            "type": 3
        },
        "beforeChannelSoundDelay": 150,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 45,
        "castDelay": 650,
        "animationSpeed": 1.5,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Rupture",
        "description": "Deal <b>1</b> damage and make the target bleed every <b>3</b> seconds for <b>18</b> seconds, dealing damage based on the amount of combo points used.\n\n<b>1 Combo Point</b>: 1 damage per hit\n<b>2 Combo Points</b>: 2 damage per hit\n<b>3 Combo Points</b>: 4 damage per hit\n<b>4 Combo Points</b>: 6 damage per hit\n<b>5 Combo Points</b>: 11 damage per hit",
        "icon": "852174498f621804d9d515044b686998",
        "usableBy": "0a000000",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "12d2ef2f459217549b413b4b15bf4b0e",
            "type": 2
        }
    }
};
$fb081b677e06bd45$exports.getImport = (guid)=>{
    switch(guid){
        case "852174498f621804d9d515044b686998":
            return 0, (/*@__PURE__*/$parcel$interopDefault($0a122ab5833f5a8e$exports));
    }
};


var $be57dcb08f9ca0b0$exports = {};
var $bacd43a98fda1d04$exports = {};
$bacd43a98fda1d04$exports = new URL("shadowblink.c540f736.png", import.meta.url).toString();


$be57dcb08f9ca0b0$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "ShadowBlink",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 341,
        "castDelay": 150,
        "animationSpeed": 1.5,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Shadow Blink",
        "description": "Instantly teleport behind the target. In addition, increase your move speed by <b>70%</b> for <b>3</b> seconds.",
        "icon": "bb4cba7abcbd5b44fbb34c1c394305c1",
        "usableBy": "01000000",
        "cooldown": 12,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "b303c186cbd822f4dbe036e16255d8fc",
            "type": 2
        }
    }
};
$be57dcb08f9ca0b0$exports.getImport = (guid)=>{
    switch(guid){
        case "bb4cba7abcbd5b44fbb34c1c394305c1":
            return 0, (/*@__PURE__*/$parcel$interopDefault($bacd43a98fda1d04$exports));
    }
};


var $ae930b367d282e07$exports = {};

$ae930b367d282e07$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "ShadowBlinkNoCD",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 341,
        "castDelay": 400,
        "animationSpeed": 1.25,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 1,
        "spellName": "Shadow Blink",
        "description": "Instantly teleport behind the target. In addition, increase your move speed by <b>70%</b> for <b>3</b> seconds.",
        "icon": "bb4cba7abcbd5b44fbb34c1c394305c1",
        "usableBy": null,
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "b303c186cbd822f4dbe036e16255d8fc",
            "type": 2
        }
    }
};
$ae930b367d282e07$exports.getImport = (guid)=>{
    switch(guid){
        case "bb4cba7abcbd5b44fbb34c1c394305c1":
            return 0, (/*@__PURE__*/$parcel$interopDefault($bacd43a98fda1d04$exports));
    }
};


var $21b566a4a4c60551$exports = {};
var $86413e7a1103d68f$exports = {};
$86413e7a1103d68f$exports = new URL("shadowblow.59a6683a.png", import.meta.url).toString();


$21b566a4a4c60551$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "ShadowBlow",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "d44b46a27bd0a8f4e83641e36dffdc4b",
            "type": 3
        },
        "beforeChannelSoundDelay": 200,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 2,
        "castDelay": 420,
        "animationSpeed": 1,
        "animationDuration": 0.8,
        "skipCooldownOnChannel": 0,
        "spellName": "Shadow Blow",
        "description": "Deal damage to the target based on the number of combo points you have.\n\n<b>1 Combo Point</b>: 8 damage\n<b>2 Combo Points</b>: 12 damage\n<b>3 Combo Points</b>: 18 damage\n<b>4 Combo Points</b>: 27 damage\n<b>5 Combo Points</b>: 40 damage",
        "icon": "b08893aeec1f1cb42b234604696ddf0f",
        "usableBy": "010000000a000000",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "12d2ef2f459217549b413b4b15bf4b0e",
            "type": 2
        }
    }
};
$21b566a4a4c60551$exports.getImport = (guid)=>{
    switch(guid){
        case "b08893aeec1f1cb42b234604696ddf0f":
            return 0, (/*@__PURE__*/$parcel$interopDefault($86413e7a1103d68f$exports));
    }
};


var $ac6d8e07ce86055d$exports = {};
var $f842e9261e95226b$exports = {};
$f842e9261e95226b$exports = new URL("shadowelusion.21ca45dc.png", import.meta.url).toString();


$ac6d8e07ce86055d$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "ShadowElusion",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 21,
        "castDelay": 350,
        "animationSpeed": 3.5,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Shadow Elusion",
        "description": "Instantly leave <b>Combat</b>. Instantly remove all damage over time effects and all dispellable effects from yourself. Reduce all magical damage taken by <b>100%</b> for <b>3</b> seconds. Reduce all physical damage taken by <b>35%</b> for <b>8</b> seconds.",
        "icon": "d0074ec7bfe57e240b3f88b65a15bcc3",
        "usableBy": "010000000a000000",
        "cooldown": 55,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        }
    }
};
$ac6d8e07ce86055d$exports.getImport = (guid)=>{
    switch(guid){
        case "d0074ec7bfe57e240b3f88b65a15bcc3":
            return 0, (/*@__PURE__*/$parcel$interopDefault($f842e9261e95226b$exports));
    }
};


var $31dba1c024951dfa$exports = {};
var $31202f056d123fab$exports = {};
$31202f056d123fab$exports = new URL("shadowstrike.3653c9bc.png", import.meta.url).toString();


$31dba1c024951dfa$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "ShadowStrike",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "e846e2e0f891e534191da75cd0487529",
            "type": 3
        },
        "beforeChannelSoundDelay": 100,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 432,
        "castDelay": 380,
        "animationSpeed": 1.5,
        "animationDuration": 0.75,
        "skipCooldownOnChannel": 0,
        "spellName": "Shadow Strike",
        "description": "Deal <b>4</b> damage to the target, gain one combo point. \n<b>If cast again within 3 seconds</b> of the first cast, deal <b>10</b> damage and gain <b>2</b> combo points. \n<b>If cast in Shadow Crawl</b>, teleport behind your target and deal <b>28</b> damage.\n\nIn addition, slows the target by <b>60%</b> for <b>4</b> seconds and reduces the healing taken by the target by <b>25%</b> for <b>4</b> seconds.",
        "icon": "b82ed707bccd0614098ad4bb330394c7",
        "usableBy": "010000000a000000",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "12d2ef2f459217549b413b4b15bf4b0e",
            "type": 2
        }
    }
};
$31dba1c024951dfa$exports.getImport = (guid)=>{
    switch(guid){
        case "b82ed707bccd0614098ad4bb330394c7":
            return 0, (/*@__PURE__*/$parcel$interopDefault($31202f056d123fab$exports));
    }
};


var $817ef7a387589b00$exports = {};

$817ef7a387589b00$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "ShadowStrikeSecondHit",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "e846e2e0f891e534191da75cd0487529",
            "type": 3
        },
        "beforeChannelSoundDelay": 100,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 433,
        "castDelay": 380,
        "animationSpeed": 1.5,
        "animationDuration": 0.75,
        "skipCooldownOnChannel": 0,
        "spellName": "Shadow Strike",
        "description": "Deal <b>4</b> damage to the target, gain one combo point. \n<b>If cast again within 3 seconds</b> of the first cast, deal <b>10</b> damage and gain <b>2</b> combo points. \n<b>If cast in Shadow Crawl</b>, teleport behind your target and deal <b>28</b> damage.\n\nIn addition, slows the target by <b>60%</b> for <b>4</b> seconds and reduces the healing taken by the target by <b>25%</b> for <b>4</b> seconds.",
        "icon": "b82ed707bccd0614098ad4bb330394c7",
        "usableBy": "010000000a000000",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "12d2ef2f459217549b413b4b15bf4b0e",
            "type": 2
        }
    }
};
$817ef7a387589b00$exports.getImport = (guid)=>{
    switch(guid){
        case "b82ed707bccd0614098ad4bb330394c7":
            return 0, (/*@__PURE__*/$parcel$interopDefault($31202f056d123fab$exports));
    }
};


var $1399740022af9db5$exports = {};

$1399740022af9db5$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "ShadowStrikeStealth",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "e846e2e0f891e534191da75cd0487529",
            "type": 3
        },
        "beforeChannelSoundDelay": 100,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 301,
        "castDelay": 200,
        "animationSpeed": 1.5,
        "animationDuration": 0.4,
        "skipCooldownOnChannel": 0,
        "spellName": "Shadow Strike",
        "description": "Deal <b>4</b> damage to the target, gain one combo point. \n<b>If cast again within 3 seconds</b> of the first cast, deal <b>10</b> damage and gain <b>2</b> combo points. \n<b>If cast in Shadow Crawl</b>, teleport behind your target and deal <b>28</b> damage.\n\nIn addition, slows the target by <b>60%</b> for <b>4</b> seconds and reduces the healing taken by the target by <b>25%</b> for <b>4</b> seconds.",
        "icon": "b82ed707bccd0614098ad4bb330394c7",
        "usableBy": "01000000",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "12d2ef2f459217549b413b4b15bf4b0e",
            "type": 2
        }
    }
};
$1399740022af9db5$exports.getImport = (guid)=>{
    switch(guid){
        case "b82ed707bccd0614098ad4bb330394c7":
            return 0, (/*@__PURE__*/$parcel$interopDefault($31202f056d123fab$exports));
    }
};


var $69dd7ab9fd952889$exports = {};
var $3cead11313e49f2b$exports = {};
$3cead11313e49f2b$exports = new URL("shank.12c57ce0.png", import.meta.url).toString();


$69dd7ab9fd952889$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "Shank",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 8300000,
            "guid": "6143c30f5c883d347a69de4519c4fbba",
            "type": 3
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 9,
        "castDelay": 180,
        "animationSpeed": 1.3,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Shank",
        "description": "Adds 1 combo point, deals 1 damage to the target and slows them by 65% for 5 seconds. In addition, reduces the healing taken by the target by 25% for 6 seconds.",
        "icon": "4721b5eaceae21f45b14dc7a518882ee",
        "usableBy": null,
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "preventManualCasts": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "12d2ef2f459217549b413b4b15bf4b0e",
            "type": 2
        }
    }
};
$69dd7ab9fd952889$exports.getImport = (guid)=>{
    switch(guid){
        case "4721b5eaceae21f45b14dc7a518882ee":
            return 0, (/*@__PURE__*/$parcel$interopDefault($3cead11313e49f2b$exports));
    }
};


var $b0c947657b50b056$exports = {};
var $72ba177207ae2274$exports = {};
$72ba177207ae2274$exports = new URL("smokebomb.2c63537e.png", import.meta.url).toString();


$b0c947657b50b056$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "SmokeBomb",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 21,
        "castDelay": 200,
        "animationSpeed": 4,
        "animationDuration": 0.35,
        "skipCooldownOnChannel": 0,
        "spellName": "Smoke Bomb",
        "description": "Instantly enter <b>Shadow Crawl</b> and remove all movement impairing effects, becoming invisible to enemies for <b>40</b> seconds. You cannot be seen at all by enemy players, regardless of distance for <b>10</b> seconds. Can be used while in <b>Combat</b>.",
        "icon": "ec22e424a8ad9204397951e993d5771d",
        "usableBy": "01000000",
        "cooldown": 60,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "a8cd7cc6f0212db4a8228be1ba9145b6",
            "type": 2
        }
    }
};
$b0c947657b50b056$exports.getImport = (guid)=>{
    switch(guid){
        case "ec22e424a8ad9204397951e993d5771d":
            return 0, (/*@__PURE__*/$parcel$interopDefault($72ba177207ae2274$exports));
    }
};


var $2dc8fe6f7ef9fd60$exports = {};
var $068fe07c47a5c3c6$exports = {};
$068fe07c47a5c3c6$exports = new URL("smokescreen.424742cd.png", import.meta.url).toString();


$2dc8fe6f7ef9fd60$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "SmokeScreen",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 21,
        "castDelay": 350,
        "animationSpeed": 2.6,
        "animationDuration": 0.6,
        "skipCooldownOnChannel": 0,
        "spellName": "Smoke Screen",
        "description": "Create a <b>10</b> yard <b>Smoke Screen</b>. Enemy Titans inside cannot interact with Titans outside of the fog and vice versa.",
        "icon": "e1de123d7a09e3248b3f88afe1c7afde",
        "usableBy": null,
        "cooldown": 60,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100057,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "03c0486c74a640d488b418e4e31e599e",
            "type": 3
        }
    }
};
$2dc8fe6f7ef9fd60$exports.getImport = (guid)=>{
    switch(guid){
        case "e1de123d7a09e3248b3f88afe1c7afde":
            return 0, (/*@__PURE__*/$parcel$interopDefault($068fe07c47a5c3c6$exports));
    }
};


var $e7c2e3cd0d274b9f$exports = {};
var $d713228a9358ed5e$exports = {};
$d713228a9358ed5e$exports = new URL("stealth.b04bdad4.png", import.meta.url).toString();


$e7c2e3cd0d274b9f$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "Stealth",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 14,
        "castDelay": 150,
        "animationSpeed": 3,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Shadow Crawl",
        "description": "Enter <b>Shadow Crawl</b>, making you invisible to far away enemies for <b>40</b> seconds. Enemies within <b>4</b> yards will be able to see you. Must not be in <b>Combat</b> to cast.",
        "icon": "3c111c333cc00914daaeadedcac02828",
        "usableBy": "010000000e000000",
        "cooldown": 5,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "a8cd7cc6f0212db4a8228be1ba9145b6",
            "type": 2
        }
    }
};
$e7c2e3cd0d274b9f$exports.getImport = (guid)=>{
    switch(guid){
        case "3c111c333cc00914daaeadedcac02828":
            return 0, (/*@__PURE__*/$parcel$interopDefault($d713228a9358ed5e$exports));
    }
};


var $4d5ada5d75ba7ec4$exports = {};
var $3c78d45a4d45b1bd$exports = {};
$3c78d45a4d45b1bd$exports = new URL("stealthcancel.42022f52.png", import.meta.url).toString();


$4d5ada5d75ba7ec4$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "f1565e2ac6d6cbe4bb0b302c1b554d10",
            "type": 3
        },
        "m_Name": "StealthCancel",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.15,
        "castAuraYOffset": 0.3,
        "attachCastAuraToCaster": 0,
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 14,
        "castDelay": 0,
        "animationSpeed": 3,
        "animationDuration": 0,
        "skipCooldownOnChannel": 0,
        "spellName": "Cancel Shadow Crawl",
        "description": "Cancel <b>Shadow Crawl</b>.",
        "icon": "253943bd50821c74bb84f1d39e0f9a25",
        "usableBy": "010000000e000000",
        "cooldown": 1,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 0,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "a8cd7cc6f0212db4a8228be1ba9145b6",
            "type": 2
        }
    }
};
$4d5ada5d75ba7ec4$exports.getImport = (guid)=>{
    switch(guid){
        case "253943bd50821c74bb84f1d39e0f9a25":
            return 0, (/*@__PURE__*/$parcel$interopDefault($3c78d45a4d45b1bd$exports));
    }
};


var $dee1184e04d07166$exports = {};
var $617e57dd50e7b54b$exports = {};
$617e57dd50e7b54b$exports = new URL("Druideskill_22.c87a8919.png", import.meta.url).toString();


$dee1184e04d07166$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "BearCharge",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 265,
        "castDelay": 0,
        "animationSpeed": 0.75,
        "animationDuration": 2.2,
        "skipCooldownOnChannel": 0,
        "spellName": "Charge",
        "description": "Charge forward.",
        "icon": "28cb68587c575d14c9ad5ec7e334f9ca",
        "usableBy": "18000000",
        "cooldown": 20,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100084,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "73eae3197d80b694aaf28b29acdb00c1",
            "type": 3
        }
    }
};
$dee1184e04d07166$exports.getImport = (guid)=>{
    switch(guid){
        case "28cb68587c575d14c9ad5ec7e334f9ca":
            return 0, (/*@__PURE__*/$parcel$interopDefault($617e57dd50e7b54b$exports));
    }
};


var $b4b0263dacf291cf$exports = {};
var $16140a4eb4a60e9c$exports = {};
$16140a4eb4a60e9c$exports = new URL("Mageskill_38.7f617c75.png", import.meta.url).toString();


$b4b0263dacf291cf$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "BearConalAttack",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "beforeChannelSoundVolume": 1,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "afterChannelSoundVolume": 1,
        "animation": 0,
        "animationVariation": 268,
        "castDelay": 0,
        "animationSpeed": 1,
        "animationDuration": 2,
        "skipCooldownOnChannel": 0,
        "spellName": "Ice Spikes",
        "description": "Turn around and freeze all targets in a conal area.",
        "icon": "fc1aee381f9731149b1a0d9d6210573d",
        "usableBy": "18000000",
        "cooldown": 30,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100086,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "3527be1a53f1b19448351be63dce4b2b",
            "type": 3
        }
    }
};
$b4b0263dacf291cf$exports.getImport = (guid)=>{
    switch(guid){
        case "fc1aee381f9731149b1a0d9d6210573d":
            return 0, (/*@__PURE__*/$parcel$interopDefault($16140a4eb4a60e9c$exports));
    }
};


var $ddd6d90302e80d5e$exports = {};
var $1225831e23570092$exports = {};
$1225831e23570092$exports = new URL("Druideskill_32.02a5e866.png", import.meta.url).toString();


$ddd6d90302e80d5e$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "BearIcePillars",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 333,
        "castDelay": 600,
        "animationSpeed": 0.7,
        "animationDuration": 1.7,
        "skipCooldownOnChannel": 0,
        "spellName": "Ice Pillars",
        "description": "Shoot ice pillars forward.",
        "icon": "0d6aa2ef93ac3c94d9d53a1a098769f5",
        "usableBy": "18000000",
        "cooldown": 35,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100085,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "023ed5b0374cd1049aec178df4ab211b",
            "type": 3
        }
    }
};
$ddd6d90302e80d5e$exports.getImport = (guid)=>{
    switch(guid){
        case "0d6aa2ef93ac3c94d9d53a1a098769f5":
            return 0, (/*@__PURE__*/$parcel$interopDefault($1225831e23570092$exports));
    }
};


var $6e6c85d50de74255$exports = {};
var $f16ac3bb0819529e$exports = {};
$f16ac3bb0819529e$exports = new URL("Druideskill_21.666035bc.png", import.meta.url).toString();


$6e6c85d50de74255$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "BearSwing1",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 430,
        "castDelay": 800,
        "animationSpeed": 1,
        "animationDuration": 2.3,
        "skipCooldownOnChannel": 0,
        "spellName": "Swing",
        "description": "Deal damage to the main target.",
        "icon": "5aa1e732358c3cd4383847fc2fa05028",
        "usableBy": "18000000",
        "cooldown": 4,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100082,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "6b9bfe6daf969b049b06959b2e399f7e",
            "type": 3
        }
    }
};
$6e6c85d50de74255$exports.getImport = (guid)=>{
    switch(guid){
        case "5aa1e732358c3cd4383847fc2fa05028":
            return 0, (/*@__PURE__*/$parcel$interopDefault($f16ac3bb0819529e$exports));
    }
};


var $7b51d6cc2eabf8b6$exports = {};

$7b51d6cc2eabf8b6$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "BearSwing2",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 432,
        "castDelay": 600,
        "animationSpeed": 1,
        "animationDuration": 1.2,
        "skipCooldownOnChannel": 0,
        "spellName": "Swing",
        "description": "Deal damage to the main target.",
        "icon": "5aa1e732358c3cd4383847fc2fa05028",
        "usableBy": "18000000",
        "cooldown": 4,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100083,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "4fa67b5135d769a44967e4c0381f2cc9",
            "type": 3
        }
    }
};
$7b51d6cc2eabf8b6$exports.getImport = (guid)=>{
    switch(guid){
        case "5aa1e732358c3cd4383847fc2fa05028":
            return 0, (/*@__PURE__*/$parcel$interopDefault($f16ac3bb0819529e$exports));
    }
};


var $aa3a939766f9244a$exports = {};
var $cc1780d8f3a1d794$exports = {};
$cc1780d8f3a1d794$exports = new URL("Mageskill_09.a357473f.png", import.meta.url).toString();


$aa3a939766f9244a$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "DKFirestorm",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "188ccd91914323f48a7ff9686cb3242a",
            "type": 3
        },
        "castAuraScale": 1.2,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 0
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 440,
        "castDelay": 0,
        "animationSpeed": 1,
        "animationDuration": 10,
        "skipCooldownOnChannel": 0,
        "spellName": "Firestorm",
        "description": "Rain fire on nearby targets for 10 seconds.",
        "icon": "cc661a521afcfca41b5091f5c31f8dc8",
        "usableBy": "19000000",
        "cooldown": 42,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100093,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "412f0ec108eb643439119e687b35fed2",
            "type": 3
        }
    }
};
$aa3a939766f9244a$exports.getImport = (guid)=>{
    switch(guid){
        case "cc661a521afcfca41b5091f5c31f8dc8":
            return 0, (/*@__PURE__*/$parcel$interopDefault($cc1780d8f3a1d794$exports));
    }
};


var $4176d3ed77d4853d$exports = {};
var $bcecfd593485bf9f$exports = {};
$bcecfd593485bf9f$exports = new URL("Assassinskill_28.b1678470.png", import.meta.url).toString();


$4176d3ed77d4853d$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "DKGrip",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 179,
        "castDelay": 0,
        "animationSpeed": 0.5,
        "animationDuration": 1.8,
        "skipCooldownOnChannel": 0,
        "spellName": "Soul Grip",
        "description": "Pull in the target, slow them and deal damage to them.",
        "icon": "3aa40204028b3014aae02c3e6e9c553e",
        "usableBy": "19000000",
        "cooldown": 25,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100092,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "88e6398ed77ba1448bf97b770068ad2b",
            "type": 3
        }
    }
};
$4176d3ed77d4853d$exports.getImport = (guid)=>{
    switch(guid){
        case "3aa40204028b3014aae02c3e6e9c553e":
            return 0, (/*@__PURE__*/$parcel$interopDefault($bcecfd593485bf9f$exports));
    }
};


var $fd014afba88cd25e$exports = {};

$fd014afba88cd25e$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "DKLongIncap",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 7489370104637421000,
            "guid": "c6cb37df2c0db6e47b38d20f306e416a",
            "type": 3
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 8300000,
            "guid": "2c783095a3b2c8a4fa8cae902699c577",
            "type": 3
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 318,
        "castDelay": 750,
        "animationSpeed": 0.6,
        "animationDuration": 1.2,
        "skipCooldownOnChannel": 0,
        "spellName": "Soul Tether",
        "description": "Place an orb behind the target, <b>Incapacitating</b> them for <b>15</b> seconds. If anyone steps on the orb, it will break the effect. If any damage is dealt to the target, it will break the effect.",
        "icon": "cf94875e2d335e945be76e5cf0370372",
        "usableBy": "19000000",
        "cooldown": 35,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 1,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "4463a0bf39618d546a32d217dd4e2516",
            "type": 2
        },
        "spellKey": 100090,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "5037156effe65c84189c1c76508dce50",
            "type": 3
        }
    }
};
$fd014afba88cd25e$exports.getImport = (guid)=>{
    switch(guid){
        case "cf94875e2d335e945be76e5cf0370372":
            return 0, (/*@__PURE__*/$parcel$interopDefault($1e2e4be6edc6cd31$exports));
    }
};


var $3f3dd1d40c5de366$exports = {};
var $14c02f1dbdec1d7b$exports = {};
$14c02f1dbdec1d7b$exports = new URL("Mageskill_40.f5f56b8e.png", import.meta.url).toString();


$3f3dd1d40c5de366$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "DKSuck",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 124,
        "castDelay": 0,
        "animationSpeed": 0.7,
        "animationDuration": 1.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Soul Explosion",
        "description": "Pull all nearby targets towards the caster, slowing them for 8 seconds and causing an explosion after a short time.",
        "icon": "987a8ec9bf27ffa4cb7d80cc55b1edc0",
        "usableBy": "19000000",
        "cooldown": 50,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100091,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "ff1120f22f85a4d41859ef33c47e4680",
            "type": 3
        }
    }
};
$3f3dd1d40c5de366$exports.getImport = (guid)=>{
    switch(guid){
        case "987a8ec9bf27ffa4cb7d80cc55b1edc0":
            return 0, (/*@__PURE__*/$parcel$interopDefault($14c02f1dbdec1d7b$exports));
    }
};


var $08d74d320238286f$exports = {};
var $f9825f2875981eee$exports = {};
$f9825f2875981eee$exports = new URL("Assassinskill_45.ab4bfe8a.png", import.meta.url).toString();


$08d74d320238286f$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "DKSwing1",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "d44b46a27bd0a8f4e83641e36dffdc4b",
            "type": 3
        },
        "beforeChannelSoundDelay": 225,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 107,
        "castDelay": 650,
        "animationSpeed": 0.8,
        "animationDuration": 1.4,
        "skipCooldownOnChannel": 0,
        "spellName": "Swing",
        "description": "Deal damage to the main target.",
        "icon": "abd0b44fc0e203d439ab1ae8491d7c64",
        "usableBy": "19000000",
        "cooldown": 6,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100088,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "074825d86116a4748ac1655eb4a573c4",
            "type": 3
        }
    }
};
$08d74d320238286f$exports.getImport = (guid)=>{
    switch(guid){
        case "abd0b44fc0e203d439ab1ae8491d7c64":
            return 0, (/*@__PURE__*/$parcel$interopDefault($f9825f2875981eee$exports));
    }
};


var $974167eba22b29d2$exports = {};

$974167eba22b29d2$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "DKSwing2",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "f8ec7fedf0c58e64480639fc2c72608a",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 109,
        "castDelay": 330,
        "animationSpeed": 0.8,
        "animationDuration": 1.2,
        "skipCooldownOnChannel": 0,
        "spellName": "Swing",
        "description": "Deal damage to the main target.",
        "icon": "abd0b44fc0e203d439ab1ae8491d7c64",
        "usableBy": "19000000",
        "cooldown": 6,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100087,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "10623ea9db03a90458e7e005ac4c0242",
            "type": 3
        }
    }
};
$974167eba22b29d2$exports.getImport = (guid)=>{
    switch(guid){
        case "abd0b44fc0e203d439ab1ae8491d7c64":
            return 0, (/*@__PURE__*/$parcel$interopDefault($f9825f2875981eee$exports));
    }
};


var $06547ebcecde823a$exports = {};

$06547ebcecde823a$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "DKSwing3",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 113,
        "castDelay": 400,
        "animationSpeed": 0.8,
        "animationDuration": 0.9,
        "skipCooldownOnChannel": 0,
        "spellName": "Swing",
        "description": "Deal damage to the main target.",
        "icon": "abd0b44fc0e203d439ab1ae8491d7c64",
        "usableBy": "19000000",
        "cooldown": 6,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100089,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "5758b690452b16b4e9dca124dfa13f1b",
            "type": 3
        }
    }
};
$06547ebcecde823a$exports.getImport = (guid)=>{
    switch(guid){
        case "abd0b44fc0e203d439ab1ae8491d7c64":
            return 0, (/*@__PURE__*/$parcel$interopDefault($f9825f2875981eee$exports));
    }
};


var $f6e59fa0e2555b13$exports = {};
var $700fa45b0b8a7dc1$exports = {};
$700fa45b0b8a7dc1$exports = new URL("Druideskill_26.660935e2.png", import.meta.url).toString();


$f6e59fa0e2555b13$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "DragonAttack1",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "cd4c0ddd3361a984e904884770e3faf1",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 19,
        "animationVariation": 0,
        "castDelay": 550,
        "animationSpeed": 1,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Bite",
        "description": "Deal damage to the main target.",
        "icon": "7f9d1d6b6beebd04fbffacfac87c7931",
        "usableBy": "1c000000",
        "cooldown": 2,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100100,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "96cd016db142f0b4eb1de3d9dc365ba0",
            "type": 3
        }
    }
};
$f6e59fa0e2555b13$exports.getImport = (guid)=>{
    switch(guid){
        case "7f9d1d6b6beebd04fbffacfac87c7931":
            return 0, (/*@__PURE__*/$parcel$interopDefault($700fa45b0b8a7dc1$exports));
    }
};


var $f46cf4cb26cf7bd1$exports = {};
var $78cc6289616aaaa1$exports = {};
$78cc6289616aaaa1$exports = new URL("tail_strike.edff5ac5.png", import.meta.url).toString();


$f46cf4cb26cf7bd1$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "DragonAttack2",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7eecff82092cb4b3a9bca0daf1f9f480",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 8300000,
            "guid": "e051d1f79ef314bcb8d44c40a761bf22",
            "type": 3
        },
        "afterChannelSoundDelay": 500,
        "animation": 19,
        "animationVariation": 3,
        "castDelay": 0,
        "animationSpeed": 1,
        "animationDuration": 2,
        "skipCooldownOnChannel": 0,
        "spellName": "Tail Swing",
        "description": "Deal damage to anyone behind the dragon.",
        "icon": "8f2b7cddd344aab4ebce90b33d02ce42",
        "usableBy": "1c000000",
        "cooldown": 6,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100101,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "5b4dddf07c41e6a4f99cc739ebce0f62",
            "type": 3
        }
    }
};
$f46cf4cb26cf7bd1$exports.getImport = (guid)=>{
    switch(guid){
        case "8f2b7cddd344aab4ebce90b33d02ce42":
            return 0, (/*@__PURE__*/$parcel$interopDefault($78cc6289616aaaa1$exports));
    }
};


var $704c30adec95292c$exports = {};
var $b72c5773dc7301ed$exports = {};
$b72c5773dc7301ed$exports = new URL("Mageskill_18.7b724f63.png", import.meta.url).toString();


$704c30adec95292c$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "DragonBossFly1",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 19,
        "animationVariation": 7,
        "castDelay": 0,
        "animationSpeed": 1,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Sunfall",
        "description": "Fly up and rain down a fire missile.",
        "icon": "48025fd840e59ee4db8afc712eda600e",
        "usableBy": "1c000000",
        "cooldown": 80,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100105,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "e11d22b1e53d4f7488f22f205e0aa964",
            "type": 3
        }
    }
};
$704c30adec95292c$exports.getImport = (guid)=>{
    switch(guid){
        case "48025fd840e59ee4db8afc712eda600e":
            return 0, (/*@__PURE__*/$parcel$interopDefault($b72c5773dc7301ed$exports));
    }
};


var $25b4d22193cf5c5d$exports = {};
var $f016f94aa808f59a$exports = {};
$f016f94aa808f59a$exports = new URL("Mageskill_12.87135fd3.png", import.meta.url).toString();


$25b4d22193cf5c5d$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "DragonFireBreath",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 8300000,
            "guid": "de004a7bae707c448878ca3b60ecc912",
            "type": 3
        },
        "afterChannelSoundDelay": 600,
        "animation": 19,
        "animationVariation": 2,
        "castDelay": 0,
        "animationSpeed": 1,
        "animationDuration": 2,
        "skipCooldownOnChannel": 0,
        "spellName": "Emberstrike",
        "description": "Breathe fire in front of you, permanently damaging the surface and damaging anyone who stands there.",
        "icon": "eaf4a0329e2305b4083c854a5db6e42d",
        "usableBy": "1c000000",
        "cooldown": 20,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100102,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "d94c1ffe53785a440a7fe74cf732440a",
            "type": 3
        }
    }
};
$25b4d22193cf5c5d$exports.getImport = (guid)=>{
    switch(guid){
        case "eaf4a0329e2305b4083c854a5db6e42d":
            return 0, (/*@__PURE__*/$parcel$interopDefault($f016f94aa808f59a$exports));
    }
};


var $2e9738d5a7942548$exports = {};
var $6b426ad738929ef5$exports = {};
$6b426ad738929ef5$exports = new URL("Druideskill_24.ae2d82f4.png", import.meta.url).toString();


$2e9738d5a7942548$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "DragonRespawnSpecialSkillApplyBuff",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 19,
        "animationVariation": 0,
        "castDelay": 0,
        "animationSpeed": 1,
        "animationDuration": 0,
        "skipCooldownOnChannel": 0,
        "spellName": "Respawn",
        "description": "Respawn on death",
        "icon": "a63737f85f848d74e91a2c437c7c5089",
        "usableBy": "1c000000",
        "cooldown": 9999,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100103,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "249d441f8dd968c418d67fba5961a0ee",
            "type": 3
        }
    }
};
$2e9738d5a7942548$exports.getImport = (guid)=>{
    switch(guid){
        case "a63737f85f848d74e91a2c437c7c5089":
            return 0, (/*@__PURE__*/$parcel$interopDefault($6b426ad738929ef5$exports));
    }
};


var $4862d6068a21524a$exports = {};

$4862d6068a21524a$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "DragonRespawnSpecialSkillDoRespawn",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 19,
        "animationVariation": 0,
        "castDelay": 0,
        "animationSpeed": 1,
        "animationDuration": 0,
        "skipCooldownOnChannel": 0,
        "spellName": "Respawn",
        "description": "Respawn on death",
        "icon": "a63737f85f848d74e91a2c437c7c5089",
        "usableBy": "1c000000",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 1,
        "isInternal": 1,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100104,
        "alwaysCastableSpell": 1,
        "luaScript": {
            "fileID": 4900000,
            "guid": "a8b67f6ab55fce44798ce8b5e9e62a23",
            "type": 3
        }
    }
};
$4862d6068a21524a$exports.getImport = (guid)=>{
    switch(guid){
        case "a63737f85f848d74e91a2c437c7c5089":
            return 0, (/*@__PURE__*/$parcel$interopDefault($6b426ad738929ef5$exports));
    }
};


var $5b1a3c10f73279fc$exports = {};
var $20b0de4f4d4e8134$exports = {};
$20b0de4f4d4e8134$exports = new URL("Shamanskill_06.91e48a46.png", import.meta.url).toString();


$5b1a3c10f73279fc$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "DragonSpawnAdds",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "e05366ece04f65f4cb2578a6b04d2ad9",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 19,
        "animationVariation": 1,
        "castDelay": 1500,
        "animationSpeed": 1,
        "animationDuration": 2,
        "skipCooldownOnChannel": 0,
        "spellName": "Hellfire Wisps",
        "description": "Spawn fiery orbs that damage nearby enemies.",
        "icon": "472de894e31aadf48a85e231eb4a9986",
        "usableBy": "1c000000",
        "cooldown": 60,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100106,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "d724e20e66c2744458b2c3cdd9dad006",
            "type": 3
        }
    }
};
$5b1a3c10f73279fc$exports.getImport = (guid)=>{
    switch(guid){
        case "472de894e31aadf48a85e231eb4a9986":
            return 0, (/*@__PURE__*/$parcel$interopDefault($20b0de4f4d4e8134$exports));
    }
};


var $c0ec5c21d93c4352$exports = {};
var $2cbc3c5a3244b760$exports = {};
$2cbc3c5a3244b760$exports = new URL("golemhuddle.7f397fb8.png", import.meta.url).toString();


$c0ec5c21d93c4352$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "GolemHuddle",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "24e9caa2bd7c3294cbfc8b7517f0627b",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 439,
        "castDelay": 0,
        "animationSpeed": 1,
        "animationDuration": 20,
        "skipCooldownOnChannel": 0,
        "spellName": "Huddle",
        "description": "Huddle down. Spawn ice orbs around the room.",
        "icon": "6c1544aa9d7d1104e9ce1d474b131ef7",
        "usableBy": "15000000",
        "cooldown": 55,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 20,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100079,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "e09a21d2e9553c2458020bc29f7845db",
            "type": 3
        }
    }
};
$c0ec5c21d93c4352$exports.getImport = (guid)=>{
    switch(guid){
        case "6c1544aa9d7d1104e9ce1d474b131ef7":
            return 0, (/*@__PURE__*/$parcel$interopDefault($2cbc3c5a3244b760$exports));
    }
};


var $44dc33be3f554f5a$exports = {};

$44dc33be3f554f5a$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "GolemRockThrow",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 437,
        "castDelay": 600,
        "animationSpeed": 1.5,
        "animationDuration": 1.2,
        "skipCooldownOnChannel": 0,
        "spellName": "Hurl Ice Stone",
        "description": "Throw a stone of ice at a random enemy.",
        "icon": "51ab4dd7eb43254459606fb4c68bdd46",
        "usableBy": "15000000",
        "cooldown": 9,
        "castTime": 0,
        "isCastInterruptible": 1,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100080,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "9502c7e56f7737e4aaae94d3995e8f38",
            "type": 3
        }
    }
};
$44dc33be3f554f5a$exports.getImport = (guid)=>{
    switch(guid){
        case "51ab4dd7eb43254459606fb4c68bdd46":
            return 0, (/*@__PURE__*/$parcel$interopDefault($936dcd69c7f33d06$exports));
    }
};


var $7d1938b780242c6b$exports = {};
var $8838475516433054$exports = {};
$8838475516433054$exports = new URL("Shamanskill_22.f62f2a2f.png", import.meta.url).toString();


$7d1938b780242c6b$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "GolemSmash",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 438,
        "castDelay": 0,
        "animationSpeed": 0.6,
        "animationDuration": 1.8,
        "skipCooldownOnChannel": 0,
        "spellName": "Smash",
        "description": "Smash the target, damaging all nearby units.",
        "icon": "9eb6045416b0cd143ab25d3067cfebc2",
        "usableBy": "15000000",
        "cooldown": 10,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100078,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "8ae4caf47c0117c4aa7eeedda33d0622",
            "type": 3
        }
    }
};
$7d1938b780242c6b$exports.getImport = (guid)=>{
    switch(guid){
        case "9eb6045416b0cd143ab25d3067cfebc2":
            return 0, (/*@__PURE__*/$parcel$interopDefault($8838475516433054$exports));
    }
};


var $8da32ba5c408aec6$exports = {};
var $9f284b50fcb7afc4$exports = {};
$9f284b50fcb7afc4$exports = new URL("Mageskill_31.c689b5f7.png", import.meta.url).toString();


$8da32ba5c408aec6$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "GolemSwing1",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 436,
        "castDelay": 900,
        "animationSpeed": 1,
        "animationDuration": 1.8,
        "skipCooldownOnChannel": 0,
        "spellName": "Swing",
        "description": "Deal damage to the main target.",
        "icon": "2663966faa5210646b09c3cf37c31dac",
        "usableBy": "15000000",
        "cooldown": 3,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100076,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "4f59a08fa1028614896314b249529e69",
            "type": 3
        }
    }
};
$8da32ba5c408aec6$exports.getImport = (guid)=>{
    switch(guid){
        case "2663966faa5210646b09c3cf37c31dac":
            return 0, (/*@__PURE__*/$parcel$interopDefault($9f284b50fcb7afc4$exports));
    }
};


var $754515a1a1f418ae$exports = {};

$754515a1a1f418ae$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "GolemSwing2",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 0,
        "animationVariation": 437,
        "castDelay": 900,
        "animationSpeed": 1,
        "animationDuration": 1.8,
        "skipCooldownOnChannel": 0,
        "spellName": "Swing",
        "description": "Deal damage to the main target.",
        "icon": "2663966faa5210646b09c3cf37c31dac",
        "usableBy": "15000000",
        "cooldown": 3,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100077,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "c205fce7055252a49ae5ff743ffc7aa0",
            "type": 3
        }
    }
};
$754515a1a1f418ae$exports.getImport = (guid)=>{
    switch(guid){
        case "2663966faa5210646b09c3cf37c31dac":
            return 0, (/*@__PURE__*/$parcel$interopDefault($9f284b50fcb7afc4$exports));
    }
};


var $2efe5ec32b70791f$exports = {};
var $956a381ad46d00f7$exports = {};
$956a381ad46d00f7$exports = new URL("Warlock_38.8a73180e.png", import.meta.url).toString();


$2efe5ec32b70791f$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "PoisonBossFly",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "beforeChannelSoundVolume": 1,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "afterChannelSoundVolume": 1,
        "animation": 16,
        "animationVariation": 7,
        "castDelay": 0,
        "animationSpeed": 1,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Toxic Rainfall",
        "description": "Fly up and rain down toxic missiles.",
        "icon": "fab145eb7120b764e9a9e629c4f93e5b",
        "usableBy": "1a000000",
        "cooldown": 60,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100099,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "59602f092113ef54eac40ff68add77d2",
            "type": 3
        }
    }
};
$2efe5ec32b70791f$exports.getImport = (guid)=>{
    switch(guid){
        case "fab145eb7120b764e9a9e629c4f93e5b":
            return 0, (/*@__PURE__*/$parcel$interopDefault($956a381ad46d00f7$exports));
    }
};


var $1ba824cd50e5dacb$exports = {};
var $5732a8b5eac91699$exports = {};
$5732a8b5eac91699$exports = new URL("36_Critical_strike4.e8aad1bd.png", import.meta.url).toString();


$1ba824cd50e5dacb$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "PoisonInsectBite1",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 16,
        "animationVariation": 2,
        "castDelay": 650,
        "animationSpeed": 0.5,
        "animationDuration": 1,
        "skipCooldownOnChannel": 0,
        "spellName": "Sting",
        "description": "Deal damage to the main target.",
        "icon": "6daf385ceb64cf643b52e7f4115766ed",
        "usableBy": "1a000000",
        "cooldown": 2,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100094,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "6073c1f2845b47b47bc4be046041c2f7",
            "type": 3
        }
    }
};
$1ba824cd50e5dacb$exports.getImport = (guid)=>{
    switch(guid){
        case "6daf385ceb64cf643b52e7f4115766ed":
            return 0, (/*@__PURE__*/$parcel$interopDefault($5732a8b5eac91699$exports));
    }
};


var $e4fb271653c7e458$exports = {};
var $795b59552ee04afa$exports = {};
$795b59552ee04afa$exports = new URL("fishbite.f148b74e.png", import.meta.url).toString();


$e4fb271653c7e458$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "PoisonInsectBite2",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "96c549165c725b94f9b5fa3eeb7d2537",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "beforeChannelSoundVolume": 0.4,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "afterChannelSoundVolume": 1,
        "animation": 16,
        "animationVariation": 3,
        "castDelay": 300,
        "animationSpeed": 1,
        "animationDuration": 0.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Bite",
        "description": "Deal damage to the main target.",
        "icon": "1ab28e3e1154af9479c46dd1d30ce10e",
        "usableBy": "1a000000",
        "cooldown": 8,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100095,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "718823ad25bba394ba78f3ae5f6f29b8",
            "type": 3
        }
    }
};
$e4fb271653c7e458$exports.getImport = (guid)=>{
    switch(guid){
        case "1ab28e3e1154af9479c46dd1d30ce10e":
            return 0, (/*@__PURE__*/$parcel$interopDefault($795b59552ee04afa$exports));
    }
};


var $5992626457cfb6c6$exports = {};
var $974c984e1952ef44$exports = {};
$974c984e1952ef44$exports = new URL("poison_claw.01842c64.png", import.meta.url).toString();


$5992626457cfb6c6$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "PoisonMissile",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 16,
        "animationVariation": 0,
        "castDelay": 400,
        "animationSpeed": 1,
        "animationDuration": 0.7,
        "skipCooldownOnChannel": 0,
        "spellName": "Spit",
        "description": "Spit poison at a target, dealing damage and applying a stacking damage over time effect on them.",
        "icon": "96868e2190e6eeb45a34c7805f76247d",
        "usableBy": "1a000000",
        "cooldown": 12,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100096,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "332b352453c37534f9b90ed47dfaf9b8",
            "type": 3
        }
    }
};
$5992626457cfb6c6$exports.getImport = (guid)=>{
    switch(guid){
        case "96868e2190e6eeb45a34c7805f76247d":
            return 0, (/*@__PURE__*/$parcel$interopDefault($974c984e1952ef44$exports));
    }
};


var $98a286dbbb0b5bdb$exports = {};
var $53f947a31196ba7e$exports = {};
$53f947a31196ba7e$exports = new URL("Shamanskill_34.5e496bb5.png", import.meta.url).toString();


$98a286dbbb0b5bdb$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "PoisonNova",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 16,
        "animationVariation": 0,
        "castDelay": 0,
        "animationSpeed": 0.3,
        "animationDuration": 3.3,
        "skipCooldownOnChannel": 0,
        "spellName": "Toxic Vortex",
        "description": "Shoot poison missiles outwards.",
        "icon": "9bf9be34eac06a146aee83bec4040ce3",
        "usableBy": "1a000000",
        "cooldown": 43,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100097,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "b61da461dcf3ca34c96ddfc98d9dea75",
            "type": 3
        }
    }
};
$98a286dbbb0b5bdb$exports.getImport = (guid)=>{
    switch(guid){
        case "9bf9be34eac06a146aee83bec4040ce3":
            return 0, (/*@__PURE__*/$parcel$interopDefault($53f947a31196ba7e$exports));
    }
};


var $43bdea7354e21ae6$exports = {};
var $537823d32c2aa34a$exports = {};
$537823d32c2aa34a$exports = new URL("Warriorskill_38.240c4dc3.png", import.meta.url).toString();


$43bdea7354e21ae6$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "PoisonPool",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 16,
        "animationVariation": 0,
        "castDelay": 400,
        "animationSpeed": 1,
        "animationDuration": 0.7,
        "skipCooldownOnChannel": 0,
        "spellName": "Acid Barrage",
        "description": "Shoot poison missiles at the target, dealing damage and poisoning the target. After the effect ends, a pool of acid will spawn below the target, dealing damage to any targets standing in it.",
        "icon": "538b175a7d185264a984f1d848bb00af",
        "usableBy": "1a000000",
        "cooldown": 38,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100098,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "319bcca6cd176934e975fc59f65a8318",
            "type": 3
        }
    }
};
$43bdea7354e21ae6$exports.getImport = (guid)=>{
    switch(guid){
        case "538b175a7d185264a984f1d848bb00af":
            return 0, (/*@__PURE__*/$parcel$interopDefault($537823d32c2aa34a$exports));
    }
};


var $4d5ec665db68b052$exports = {};

$4d5ec665db68b052$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "PoisonPoolSpecialSpell",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 16,
        "animationVariation": 0,
        "castDelay": 0,
        "animationSpeed": 1,
        "animationDuration": 0,
        "skipCooldownOnChannel": 0,
        "spellName": "Acid Barrage",
        "description": "Shoot poison missiles at the target, dealing damage and poisoning the target. After the effect ends, a pool of acid will spawn below the target, dealing damage to any targets standing in it.",
        "icon": "538b175a7d185264a984f1d848bb00af",
        "usableBy": "1a000000",
        "cooldown": 0,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 1,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100107,
        "alwaysCastableSpell": 1,
        "luaScript": {
            "fileID": 4900000,
            "guid": "eae0c6b8b0e35ec40bca3ce2bca9a15d",
            "type": 3
        }
    }
};
$4d5ec665db68b052$exports.getImport = (guid)=>{
    switch(guid){
        case "538b175a7d185264a984f1d848bb00af":
            return 0, (/*@__PURE__*/$parcel$interopDefault($537823d32c2aa34a$exports));
    }
};


var $ea0e193e9e53df76$exports = {};
var $758756c4e25761a3$exports = {};
$758756c4e25761a3$exports = new URL("Mageskill_50.31ea2932.png", import.meta.url).toString();


$ea0e193e9e53df76$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "BossPowerupAoeDamage",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 19,
        "animationVariation": 0,
        "castDelay": 0,
        "animationSpeed": 1,
        "animationDuration": 0,
        "skipCooldownOnChannel": 0,
        "spellName": "Pyromaniac",
        "description": "Deals 12 damage to all enemies every 2 seconds.",
        "icon": "7a79a4bd2ee01c046b144b1a4fe83d10",
        "usableBy": null,
        "cooldown": 2,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100108,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "2871283b5245bfd47bcb22bc7d0c6c28",
            "type": 3
        }
    }
};
$ea0e193e9e53df76$exports.getImport = (guid)=>{
    switch(guid){
        case "7a79a4bd2ee01c046b144b1a4fe83d10":
            return 0, (/*@__PURE__*/$parcel$interopDefault($758756c4e25761a3$exports));
    }
};


var $0b56ed83cb262be7$exports = {};
var $64baa0814ec1e3ee$exports = {};
$64baa0814ec1e3ee$exports = new URL("Mageskill_33.768c213a.png", import.meta.url).toString();


$0b56ed83cb262be7$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "BossPowerupFrostOrbs",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 19,
        "animationVariation": 0,
        "castDelay": 0,
        "animationSpeed": 1,
        "animationDuration": 0,
        "skipCooldownOnChannel": 0,
        "spellName": "Cryomaniac",
        "description": "Every 8 seconds, spawn a frost orb near a random target which will slowly follow them for 8 seconds.",
        "icon": "5a332bd33b937d949b1184f3175cb2e5",
        "usableBy": null,
        "cooldown": 8,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100109,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "884f6e6f1659a1b44ad3f8bbf454e139",
            "type": 3
        }
    }
};
$0b56ed83cb262be7$exports.getImport = (guid)=>{
    switch(guid){
        case "5a332bd33b937d949b1184f3175cb2e5":
            return 0, (/*@__PURE__*/$parcel$interopDefault($64baa0814ec1e3ee$exports));
    }
};


var $c5493fa6ba97f331$exports = {};
var $a2d774f140f03b4a$exports = {};
$a2d774f140f03b4a$exports = new URL("Shamanskill_40.0d6584e1.png", import.meta.url).toString();


$c5493fa6ba97f331$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "BossPowerupGrid",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 19,
        "animationVariation": 0,
        "castDelay": 0,
        "animationSpeed": 1,
        "animationDuration": 0,
        "skipCooldownOnChannel": 0,
        "spellName": "Terramaniac",
        "description": "Every 10 seconds, parts of the ground will shatter under your feet, dealing significant damage to anyone standing on it.",
        "icon": "fbe5c21983df7f24a8c9a75eb76dba21",
        "usableBy": null,
        "cooldown": 10,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100117,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "6ea2c12917bc9b2478d4bc752921be1d",
            "type": 3
        }
    }
};
$c5493fa6ba97f331$exports.getImport = (guid)=>{
    switch(guid){
        case "fbe5c21983df7f24a8c9a75eb76dba21":
            return 0, (/*@__PURE__*/$parcel$interopDefault($a2d774f140f03b4a$exports));
    }
};


var $b9e6a37dbd3d6905$exports = {};
var $910a8b3e9b88ddf3$exports = {};
$910a8b3e9b88ddf3$exports = new URL("Mageskill_02.9dcf3fbf.png", import.meta.url).toString();


$b9e6a37dbd3d6905$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "BossPowerupMeteors",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 19,
        "animationVariation": 0,
        "castDelay": 0,
        "animationSpeed": 1,
        "animationDuration": 0,
        "skipCooldownOnChannel": 0,
        "spellName": "Pyrefall",
        "description": "Every 6 seconds, a flaming meteor will fall on a random target.",
        "icon": "aa2b1dbc81fe5264889f03900102792e",
        "usableBy": null,
        "cooldown": 6,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100110,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "c086c20ba7057a9489d3a9325e5b2fae",
            "type": 3
        }
    }
};
$b9e6a37dbd3d6905$exports.getImport = (guid)=>{
    switch(guid){
        case "aa2b1dbc81fe5264889f03900102792e":
            return 0, (/*@__PURE__*/$parcel$interopDefault($910a8b3e9b88ddf3$exports));
    }
};


var $50d8b2294e572b27$exports = {};
var $e170523dddf7e44e$exports = {};
$e170523dddf7e44e$exports = new URL("Mageskill_27.8d18cbb6.png", import.meta.url).toString();


$50d8b2294e572b27$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "BossPowerupMiniMe",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "beforeChannelSoundVolume": 1,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "afterChannelSoundVolume": 1,
        "animation": 19,
        "animationVariation": 0,
        "castDelay": 0,
        "animationSpeed": 1,
        "animationDuration": 0,
        "skipCooldownOnChannel": 0,
        "spellName": "Mini Me",
        "description": "Every 30 seconds, summon a clone of yourself that deals reduced damage and has reduced health.",
        "icon": "74e58aba47e666e46994c2700d7a8e29",
        "usableBy": null,
        "cooldown": 30,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100118,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "ac556daff38a62e4aa55752881d8a3ca",
            "type": 3
        }
    }
};
$50d8b2294e572b27$exports.getImport = (guid)=>{
    switch(guid){
        case "74e58aba47e666e46994c2700d7a8e29":
            return 0, (/*@__PURE__*/$parcel$interopDefault($e170523dddf7e44e$exports));
    }
};


var $beebe3194ac69581$exports = {};

$beebe3194ac69581$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "BossPowerupPoisonLine",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 19,
        "animationVariation": 0,
        "castDelay": 0,
        "animationSpeed": 1,
        "animationDuration": 0,
        "skipCooldownOnChannel": 0,
        "spellName": "Toxicomaniac",
        "description": "Every 7 seconds, a poison missile will fly at a random target, if it lands it will deal damage and apply a stacking damage over time effect to them.",
        "icon": "9bf9be34eac06a146aee83bec4040ce3",
        "usableBy": null,
        "cooldown": 7,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 0,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100111,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "d495db5f750f72a4eb4b0ddba2b12a7f",
            "type": 3
        }
    }
};
$beebe3194ac69581$exports.getImport = (guid)=>{
    switch(guid){
        case "9bf9be34eac06a146aee83bec4040ce3":
            return 0, (/*@__PURE__*/$parcel$interopDefault($53f947a31196ba7e$exports));
    }
};


var $6ba2ed2d92a49389$exports = {};
var $bb8b8e4fae75e542$exports = {};
$bb8b8e4fae75e542$exports = new URL("Engineerskill_07.40ee855e.png", import.meta.url).toString();


$6ba2ed2d92a49389$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "TrollBleed",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 22,
        "animationVariation": 2,
        "castDelay": 800,
        "animationSpeed": 1,
        "animationDuration": 2.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Heavy Rock Throw",
        "description": "Throw a rock at the target, causing them to bleed, dealing increasing damage over time. The target must heal the wound or bleed out.",
        "icon": "23fe79b023535a446865f5e7214a69b9",
        "usableBy": "1b000000",
        "cooldown": 28,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100115,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "c5a01d2889cc7cb498b10b5bd059a960",
            "type": 3
        }
    }
};
$6ba2ed2d92a49389$exports.getImport = (guid)=>{
    switch(guid){
        case "23fe79b023535a446865f5e7214a69b9":
            return 0, (/*@__PURE__*/$parcel$interopDefault($bb8b8e4fae75e542$exports));
    }
};


var $8816b843e5b5c91e$exports = {};
var $97bcb1816cc73904$exports = {};
$97bcb1816cc73904$exports = new URL("Archerskill_26.f12ea740.png", import.meta.url).toString();


$8816b843e5b5c91e$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "TrollJump",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 22,
        "animationVariation": 3,
        "castDelay": 1900,
        "animationSpeed": 0.6,
        "animationDuration": 3.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Stomp",
        "description": "Jump up and down, creating tremors which cause rocks to fall from the ceiling, damaging any targets hit by them.",
        "icon": "87b278d022d9f694795fb5ee8dc350b3",
        "usableBy": "1b000000",
        "cooldown": 36,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100114,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "e8bd63862dacbaf45b8baa3e76aa3c04",
            "type": 3
        }
    }
};
$8816b843e5b5c91e$exports.getImport = (guid)=>{
    switch(guid){
        case "87b278d022d9f694795fb5ee8dc350b3":
            return 0, (/*@__PURE__*/$parcel$interopDefault($97bcb1816cc73904$exports));
    }
};


var $54a9164e7c524aee$exports = {};
var $d286f199af6cc9fb$exports = {};
$d286f199af6cc9fb$exports = new URL("Archerskill_33.156a66a2.png", import.meta.url).toString();


$54a9164e7c524aee$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "TrollSwing1",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 22,
        "animationVariation": 0,
        "castDelay": 750,
        "animationSpeed": 1,
        "animationDuration": 2.6,
        "skipCooldownOnChannel": 0,
        "spellName": "Swing",
        "description": "Deal damage to the main target.",
        "icon": "d0b94be29d874ae4191866d2e90effbd",
        "usableBy": "1b000000",
        "cooldown": 4,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100112,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "2a61928ee0d68c24399986cd272c66e9",
            "type": 3
        }
    }
};
$54a9164e7c524aee$exports.getImport = (guid)=>{
    switch(guid){
        case "d0b94be29d874ae4191866d2e90effbd":
            return 0, (/*@__PURE__*/$parcel$interopDefault($d286f199af6cc9fb$exports));
    }
};


var $57545fe86949c3fb$exports = {};

$57545fe86949c3fb$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "TrollSwing2",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 22,
        "animationVariation": 1,
        "castDelay": 650,
        "animationSpeed": 1,
        "animationDuration": 2.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Swing",
        "description": "Deal damage to the main target.",
        "icon": "d0b94be29d874ae4191866d2e90effbd",
        "usableBy": "1b000000",
        "cooldown": 4,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "cac5c20beb8c65d47b88d3b03bc2946d",
            "type": 2
        },
        "spellKey": 100113,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "5e6a9ca699664d2489a2f64205f6682e",
            "type": 3
        }
    }
};
$57545fe86949c3fb$exports.getImport = (guid)=>{
    switch(guid){
        case "d0b94be29d874ae4191866d2e90effbd":
            return 0, (/*@__PURE__*/$parcel$interopDefault($d286f199af6cc9fb$exports));
    }
};


var $87494d38c3b25baf$exports = {};
var $8c6351409db13e8c$exports = {};
$8c6351409db13e8c$exports = new URL("Priestskill_02.1307dcb2.png", import.meta.url).toString();


$87494d38c3b25baf$exports = {
    "MonoBehaviour": {
        "m_ObjectHideFlags": 0,
        "m_CorrespondingSourceObject": {
            "fileID": 0
        },
        "m_PrefabInstance": {
            "fileID": 0
        },
        "m_PrefabAsset": {
            "fileID": 0
        },
        "m_GameObject": {
            "fileID": 0
        },
        "m_Enabled": 1,
        "m_EditorHideFlags": 0,
        "m_Script": {
            "fileID": 11500000,
            "guid": "85449c2ea301fc54091646f096d9e4dc",
            "type": 3
        },
        "m_Name": "TrollTether",
        "m_EditorClassIdentifier": null,
        "impactPrefab": {
            "fileID": 0
        },
        "handGlowPrefab": {
            "fileID": 0
        },
        "handGlowScale": 0.2,
        "castAuraPrefab": {
            "fileID": 0
        },
        "castAuraScale": 0.4,
        "castAuraYOffset": 0.5,
        "attachCastAuraToCaster": 0,
        "playOnCast": [],
        "castSound": {
            "fileID": 0
        },
        "castSoundVolume": 0.2,
        "soundBeforeChannel": {
            "fileID": 8300000,
            "guid": "7994f284bb25ca64fa21bb890b0e5e98",
            "type": 3
        },
        "beforeChannelSoundDelay": 0,
        "soundAfterChannel": {
            "fileID": 0
        },
        "afterChannelSoundDelay": 0,
        "animation": 22,
        "animationVariation": 4,
        "castDelay": 800,
        "animationSpeed": 1,
        "animationDuration": 2.5,
        "skipCooldownOnChannel": 0,
        "spellName": "Binding Screech",
        "description": "Tether your enemies together, causing them to constantly damage each other. Perhaps there is some way they can remove the tether.",
        "icon": "a85a61a419e2cea4abb75c8c6bdf447c",
        "usableBy": "1b000000",
        "cooldown": 60,
        "castTime": 0,
        "isCastInterruptible": 0,
        "channelTime": 0,
        "isOnGlobalCooldown": 1,
        "aoeRadius": 0,
        "isHidden": 0,
        "isInternal": 0,
        "isRegional": 0,
        "preventManualCasts": 1,
        "useKeyboardForFacing": 0,
        "spellType": {
            "fileID": 11400000,
            "guid": "80cddad32b4f07e4bbf640afdccb32f4",
            "type": 2
        },
        "spellKey": 100116,
        "alwaysCastableSpell": 0,
        "luaScript": {
            "fileID": 4900000,
            "guid": "5293f38008200ae428f61ab58310f3b5",
            "type": 3
        }
    }
};
$87494d38c3b25baf$exports.getImport = (guid)=>{
    switch(guid){
        case "a85a61a419e2cea4abb75c8c6bdf447c":
            return 0, (/*@__PURE__*/$parcel$interopDefault($8c6351409db13e8c$exports));
    }
};


$9e6fa7d34afa6e59$exports = {
    "TemplateSpellData": $968082b0f8413fa8$exports,
    "Anthriel": {
        "BlindingLight": $d5e5e083b329ca66$exports,
        "CorporealProtection": $65946b28f8902388$exports,
        "DivineCalling": $ad1ca1849c79e9f1$exports,
        "HolyDeflection": $3dad9eb583b9bd17$exports,
        "HolyDeflectionShortCD": $2f663bb137d1b8cb$exports,
        "HolyStrike": $46852bbe4a60b821$exports,
        "Hope": $b16e2bc5085e5ed8$exports,
        "InstantMysticalBrilliance": $edb0d3362b5bc78d$exports,
        "InstantRighteousCleansing": $cfaf6d2087e96d5a$exports,
        "MaceSwing": $9e876e3b93dde5a5$exports,
        "MysticalBrilliance": $d8d411acfff00cb6$exports,
        "RighteousCleansing": $6dae8d6ae04ae612$exports,
        "RighteousDefense": $6a14bf21b42a40b3$exports,
        "RighteousDefenseCancel": $4a54951fd244d178$exports,
        "RighteousFlash": $714becaf0d0a03f6$exports,
        "RighteousPrivilege": $d646858ce09b0fec$exports,
        "SpiritualBrilliance": $cd24b8de6ab0d19f$exports,
        "VirtuousBonding": $e159f5f9dac0e6e6$exports
    },
    "Azora": {
        "ChainsOfIce": $2c21c7f4b9304e07$exports,
        "CrystalDetonation": $8c01216a6d966819$exports,
        "FieryInfliction": $055dce97637f34e1$exports,
        "Frostlance": $73d322d019512bd7$exports,
        "FrostPortal": $e76f28235acfb710$exports,
        "FrostShield": $149166563a8ddb92$exports,
        "FrozenReversal": $9551da6e3b644401$exports,
        "GlacialEncapsulation": $67905ea30482f60f$exports,
        "GlacialEncapsulationCancel": $5ef550c0c4d85055$exports,
        "IcyBindings": $1fc21a146b281d8a$exports,
        "IcyExplosion": $0b8690f5c14a8965$exports,
        "IcyShards": $47a9856441a20453$exports,
        "InnerFrost": $4558158000be7ce5$exports,
        "InstantFrostlance": $97afd38131482bb3$exports,
        "Invisibility": $1e54d220b410847e$exports,
        "Penguinify": $5cf053083a5c6400$exports,
        "PenguinifyShort": $0b7de7a838cb7e75$exports,
        "Pyrolance": $155e97159da39107$exports,
        "PyrolanceInstant": $470b9c689e00988b$exports,
        "SharpIce": $a5d9babf514c646e$exports,
        "SlowFrostlance": $435503d289ad9853$exports,
        "Spellscatter": $5cc7b39ea0d41cff$exports
    },
    "Airion": {
        "Bash": $a5a6f70c21bbde41$exports,
        "CloudForm": $759c4fd59d782c92$exports,
        "CloudFormCancel": $df099f1ef08d632f$exports,
        "Cultivation": $d623f8c1feb50695$exports,
        "DustStorm": $7b829d777b14d308$exports,
        "LightningBolt": $3909d26e09c7720b$exports,
        "LightningFire": $95fa74e4bb3a6710$exports,
        "LightningForm": $a77f2efe71fd5ccf$exports,
        "MassRevitalization": $b68d7f60a8b13828$exports,
        "NatureForm": $5de5b323e5bc2b08$exports,
        "RefreshingLeaves": $06557b42fea2b3a2$exports,
        "Regeneration": $b94fa88bf2498baf$exports,
        "Revitalize": $669e76e8ee6de68a$exports,
        "Root": $76d305e3d33214a3$exports,
        "SwiftNourishment": $b989222274112227$exports,
        "SwiftRenewal": $b9e26d8376fb634b$exports,
        "ThickSkin": $0ff1529b2855bf51$exports,
        "ThunderFire": $fcacf25694a49461$exports
    },
    "BruiserVolen": {
        "Dash": $f93ed4e53370a22a$exports,
        "ScatteredAttacks": $5db44d82ef201cc2$exports,
        "Slam": $1333675f9043cb8c$exports
    },
    "DarkKanna": {
        "DarkDamage": $097079c0d4cecb3a$exports,
        "DarkDot": $6370869c5eb53097$exports,
        "DarkHeal": $e1d9e04940ea5898$exports,
        "DarkMending": $84fc648daf3129c9$exports,
        "DarkShield": $47e31dae65e3b133$exports,
        "DarkSuppression": $363f84e8f7ae61a1$exports,
        "InstantHeal": $673773ee6160675b$exports,
        "InstantHealImproved": $f19a4ac4723ae7fc$exports,
        "SoulSiphon": $67391804ad26c91b$exports,
        "SoulSwap": $accacbd677c8e407$exports,
        "SpiritSector": $180c6d69ce51f3f9$exports
    },
    "CrystalAzora": {
        "CrystalBlast": $90d65f5328942161$exports,
        "CrystalBreath": $e27f3b157274a035$exports,
        "CrystalHaste": $149818ad8be12625$exports,
        "CrystalShield": $a9db216868dc75e4$exports,
        "FireCrystal1": $0f36a10cda6d22f4$exports,
        "FireCrystal2": $a21269dd9a102054$exports,
        "FireCrystal3": $a98c811cbaf2b1ab$exports,
        "FireCrystal4": $e0aa940cc0e30e79$exports,
        "FrostCrystal1": $60f31c73bcd7e230$exports,
        "FrostCrystal2": $c998ddcfb70175cd$exports,
        "FrostCrystal3": $1af4f064ca5789fd$exports,
        "FrostCrystal4": $2f0d40801f094b88$exports,
        "InstantPenguinify": $3691082ae11ca3ae$exports,
        "MendingCrystals": $cf635747ff5cf3ee$exports,
        "PureCrystal1": $ef46766426ef1980$exports,
        "PureCrystal2": $8ac959bda4df36bf$exports,
        "PureCrystal3": $d33fb2c233bdf6dc$exports,
        "PureCrystal4": $7d49187d9bfd42ac$exports
    },
    "General": {
        "Absorption": $c352e69ecf062f4f$exports,
        "Bandage": $d8975e56c68b67a9$exports,
        "ChainBreaker": $86d561435e131e2d$exports,
        "Dismount": $14378970f0cf8a03$exports,
        "EmoteDance": $562abdeaec5e0b5a$exports,
        "EnhancedPower": $ef0f7859e3ca383b$exports,
        "EnhancedResilience": $052ebbe76fecac9f$exports,
        "Jump": $a02107f45b7b1684$exports,
        "MasterofBattle": $ae258f0dd8271f79$exports,
        "Meditation": $bfa8619f75fb8d5e$exports,
        "Mount": $edafe1e66951570d$exports
    },
    "EradicatorMalrah": {
        "LongIncap": $a2ec348dd9ad3b03$exports,
        "PestulantDevastation": $05646709fc3aa670$exports,
        "PestulantDevastationImproved": $04a7b2195674a2ad$exports,
        "ResidualImplosion": $118d4be54cea0a1b$exports,
        "Shadowspike": $fa11fc2a7725786f$exports,
        "VerdantPyre": $c55ced727d240320$exports,
        "VerdantPyreInstant": $e6ca5a91ae6d7003$exports,
        "VirulentEruption": $c765e1c3a4a3a68c$exports,
        "VirulentOrb": $1a3795c116a960b3$exports
    },
    "BlademasterTarcza": {
        "InnerRage": $5c7ee4e377f9db4f$exports,
        "Leap": $0f25348cac52bfc1$exports,
        "Shockwave": $a9d3dd44cc5ad7ef$exports,
        "ShockwaveShortCD": $26063c2ba0aa7c80$exports,
        "Slash1": $2d316ed1499ea9cd$exports,
        "Slash2": $0c2ac4f82994301f$exports,
        "Slash3": $0c94ace0bcaf6b07$exports,
        "Slice": $40f2d315cc48b2a0$exports
    },
    "Kanna": {
        "BigHolySmite": $e276e7e38dedf944$exports,
        "BlessedLight": $55146dd127878c0e$exports,
        "BlessedLightImp": $48c66bc1c6684f7a$exports,
        "Dispel": $3c94e2ee0630f034$exports,
        "DivineIntervention": $e0e196d984c9b094$exports,
        "DivineLight": $a91164ab145bd66d$exports,
        "ExplosionOfLight": $fe0c1e04a2db75f0$exports,
        "Fear": $5f51cc609123b866$exports,
        "HolyFlash": $9efa4f30bf8c0d24$exports,
        "HolyFortitude": $6624ac00122a5d7a$exports,
        "PowerBurn": $991d42558a6a6de3$exports,
        "RighteousPrayer": $d941d0c617e6d1ba$exports,
        "RighteousShield": $fa9d21992eda5ea7$exports,
        "SacredSelection": $39c924d522cd20df$exports,
        "ShackleOfLight": $c17c327def3d93d3$exports,
        "ShadowBomb": $a237d60e4deed913$exports,
        "Smite": $1773f833471aceab$exports
    },
    "Malrah": {
        "ActivatePortal": $0341fbd9fca8c6da$exports,
        "BloodCurse": $ade60e5a46c9727f$exports,
        "CastedFear": $2a3b6e62bc273cc3$exports,
        "CorrosiveDecay": $f13191c75d9d59ce$exports,
        "CorruptedSoul": $ddea01ddf5886594$exports,
        "DemonGrasp": $27a86e71d66b3067$exports,
        "DemonSkull": $ca90821326a670ce$exports,
        "DrainLife": $86f09a88bd3e11cc$exports,
        "EmpoweredSoulEssence": $774884f0d0507bc4$exports,
        "FireExplosion": $e8f1d11188067e35$exports,
        "InstantShadowlance": $618fa0a40af65782$exports,
        "LimbnumbingCurse": $fd6ed1c97ffadb33$exports,
        "OpenPortal": $5619e2c2ff7e6dfb$exports,
        "Shadowflame": $b05495aa41b80f5f$exports,
        "Shadowlance": $7008dce24899ddf8$exports,
        "WeakenedSoulCurse": $9fa53495d8af4180$exports
    },
    "Regional": {
        "BigJump": $1c34f1522c1b65c2$exports,
        "Sit": $e890ebda5549b716$exports,
        "SpinWheel": $a0f3052520d7fa45$exports,
        "SpinWheelSpecialSpell": $91251d928b94f86c$exports
    },
    "MarksmanOrin": {
        "CycloneShot": $6b8558768eb882b9$exports,
        "ExplosiveShot": $f0cb8d4f38bce557$exports,
        "HookShot": $a6af6ef562ea09d3$exports,
        "MarkedForDeath": $029778e498e6e66c$exports,
        "Multishot": $22c23b2cae36f699$exports,
        "Net": $ec060ae19def3df7$exports,
        "ShortDraw": $287e39de9385da33$exports
    },
    "SmiterAnthriel": {
        "HammerStorm": $2bdb0031d12cced9$exports,
        "HammerSwing": $2eb181dab58917ce$exports,
        "RequisiteConfession": $f61453f9c98ea1ab$exports,
        "RighteousHammer": $a7c376e2b7ab9ff8$exports,
        "RighteousHindrance": $123e78c4304b7ac7$exports,
        "SpikeWave": $aa884c3f740b8a29$exports
    },
    "Special": {
        "SpecialBuffDamageReduceSpell": $9327a9d30ac11948$exports,
        "SpecialBuffDamageSpell": $01f5aa025077497e$exports,
        "SpecialBuffHealingReduceSpell": $c624fdd9fb25382e$exports,
        "SpecialEyeSpell": $5e43b1abad24fb63$exports,
        "SpecialFlagSpell": $061db0ca4500820c$exports,
        "SpecialResetAllCDsSpell": $b462fdd036bfc86d$exports,
        "SpecialTeleportSpell": $86b16717080306ad$exports
    },
    "StormcallerAirion": {
        "LightningStorm": $0176937bdfcdd9f8$exports,
        "StormCloud": $30be86d45ba22669$exports,
        "StormWave": $7c416959ea474b85$exports,
        "Thorns": $192389adfa53bc85$exports
    },
    "Tarcza": {
        "AnkleSlice": $7e98047965022489$exports,
        "BladeVortex": $c6fe6bc9d73a4555$exports,
        "BladeVortexCancel": $d80978e45f7d7978$exports,
        "BladeVortexShortCD": $2c390dc37bff363d$exports,
        "Bleed": $8c7ce643d624ce9c$exports,
        "DevastatingStrike": $041f8080e654d1e1$exports,
        "DevastatingStrikeLongCD": $313a89ad1241431b$exports,
        "Execute": $583deb707643d56d$exports,
        "FocusedRegeneration": $8a6f50c107f17c4d$exports,
        "IntimidatingShout": $e1aa9c73044a7b64$exports,
        "MenacingBlow": $ad3d12d16a1d70de$exports,
        "OverwhelmingPower": $8f014eba7f0d1e93$exports,
        "PowerStrike": $9b34fb66ac06ab4e$exports,
        "PowerStrikeLongCD": $8fea66adb4dd7c60$exports,
        "Reflect": $b4b4e6f14e2a5105$exports,
        "ShieldWall": $2069717b3662ac92$exports,
        "ShieldWallCancel": $5f0c0ecad9cae7be$exports,
        "SweepingRevenge": $9b90798b734765e7$exports,
        "SwiftJustice": $753ffed3d21c3b85$exports,
        "SwiftJusticeNoCD": $dfd4f37387971019$exports,
        "TerrifyingShout": $7c5e8fc46ca19de3$exports,
        "ThroatKick": $f95bb1ae2396815f$exports
    },
    "Orin": {
        "BasicShot": $35c86f177c3f28a6$exports,
        "DissociativeForce": $cd321be7f8d12674$exports,
        "EarthShield": $657241a0c8825944$exports,
        "EarthShieldCancel": $85734d2c823989de$exports,
        "Flare": $8dd8d40680c80bcb$exports,
        "FreezingTrap": $31ca1b498026887a$exports,
        "InstantLongDraw": $38957bd8c3668d39$exports,
        "KillShot": $cbcbfdd15d960420$exports,
        "LongDraw": $b8264b3f10a81286$exports,
        "MagicArrow": $f08efac4a0914da3$exports,
        "ParalyticArrow": $b51132ddc9b2cecc$exports,
        "PoisonTippedArrow": $e5b1ca906b021de4$exports,
        "RapidFire": $880de85bef55cae1$exports,
        "SedativeShot": $ef874693bb3df6ff$exports,
        "Volley": $3aa96ccb04a46ad9$exports
    },
    "Test": {
        "TestLuaSpell": $978e97668ee148a3$exports
    },
    "Volen": {
        "BloodShackles": $54b537a3b7f34316$exports,
        "BlowFromTheShadows": $79e22fd9457be8f3$exports,
        "DirtyTricks": $32c8d772dfaa1caf$exports,
        "Focus": $79541344c7fe0711$exports,
        "Incapacitate": $2e0dfe3c5031fb09$exports,
        "Invigorate": $d483f3ace4ec045e$exports,
        "Kick": $19e536cb6c5b5dda$exports,
        "KnifeStorm": $737c478fc3a36bda$exports,
        "PoisonBlade": $5cdfcd4c21d96cb8$exports,
        "PoisonInABottle": $c01f367a0411e047$exports,
        "PoisonStrike": $3979c6ef0cbb751a$exports,
        "Rupture": $fb081b677e06bd45$exports,
        "ShadowBlink": $be57dcb08f9ca0b0$exports,
        "ShadowBlinkNoCD": $ae930b367d282e07$exports,
        "ShadowBlow": $21b566a4a4c60551$exports,
        "ShadowElusion": $ac6d8e07ce86055d$exports,
        "ShadowStrike": $31dba1c024951dfa$exports,
        "ShadowStrikeSecondHit": $817ef7a387589b00$exports,
        "ShadowStrikeStealth": $1399740022af9db5$exports,
        "Shank": $69dd7ab9fd952889$exports,
        "SmokeBomb": $b0c947657b50b056$exports,
        "SmokeScreen": $2dc8fe6f7ef9fd60$exports,
        "Stealth": $e7c2e3cd0d274b9f$exports,
        "StealthCancel": $4d5ada5d75ba7ec4$exports
    },
    "Bosses": {
        "Bear Boss": {
            "BearCharge": $dee1184e04d07166$exports,
            "BearConalAttack": $b4b0263dacf291cf$exports,
            "BearIcePillars": $ddd6d90302e80d5e$exports,
            "BearSwing1": $6e6c85d50de74255$exports,
            "BearSwing2": $7b51d6cc2eabf8b6$exports
        },
        "DK Boss": {
            "DKFirestorm": $aa3a939766f9244a$exports,
            "DKGrip": $4176d3ed77d4853d$exports,
            "DKLongIncap": $fd014afba88cd25e$exports,
            "DKSuck": $3f3dd1d40c5de366$exports,
            "DKSwing1": $08d74d320238286f$exports,
            "DKSwing2": $974167eba22b29d2$exports,
            "DKSwing3": $06547ebcecde823a$exports
        },
        "Dragon Boss": {
            "DragonAttack1": $f6e59fa0e2555b13$exports,
            "DragonAttack2": $f46cf4cb26cf7bd1$exports,
            "DragonBossFly1": $704c30adec95292c$exports,
            "DragonFireBreath": $25b4d22193cf5c5d$exports,
            "DragonRespawnSpecialSkillApplyBuff": $2e9738d5a7942548$exports,
            "DragonRespawnSpecialSkillDoRespawn": $4862d6068a21524a$exports,
            "DragonSpawnAdds": $5b1a3c10f73279fc$exports
        },
        "Golem Boss": {
            "GolemHuddle": $c0ec5c21d93c4352$exports,
            "GolemRockThrow": $44dc33be3f554f5a$exports,
            "GolemSmash": $7d1938b780242c6b$exports,
            "GolemSwing1": $8da32ba5c408aec6$exports,
            "GolemSwing2": $754515a1a1f418ae$exports
        },
        "Poison Insect Boss": {
            "PoisonBossFly": $2efe5ec32b70791f$exports,
            "PoisonInsectBite1": $1ba824cd50e5dacb$exports,
            "PoisonInsectBite2": $e4fb271653c7e458$exports,
            "PoisonMissile": $5992626457cfb6c6$exports,
            "PoisonNova": $98a286dbbb0b5bdb$exports,
            "PoisonPool": $43bdea7354e21ae6$exports,
            "PoisonPoolSpecialSpell": $4d5ec665db68b052$exports
        },
        "Powerups": {
            "BossPowerupAoeDamage": $ea0e193e9e53df76$exports,
            "BossPowerupFrostOrbs": $0b56ed83cb262be7$exports,
            "BossPowerupGrid": $c5493fa6ba97f331$exports,
            "BossPowerupMeteors": $b9e6a37dbd3d6905$exports,
            "BossPowerupMiniMe": $50d8b2294e572b27$exports,
            "BossPowerupPoisonLine": $beebe3194ac69581$exports
        },
        "Troll Boss": {
            "TrollBleed": $6ba2ed2d92a49389$exports,
            "TrollJump": $8816b843e5b5c91e$exports,
            "TrollSwing1": $54a9164e7c524aee$exports,
            "TrollSwing2": $57545fe86949c3fb$exports,
            "TrollTether": $87494d38c3b25baf$exports
        }
    }
};





console.log((0, (/*@__PURE__*/$parcel$interopDefault($9e6fa7d34afa6e59$exports))));
function $0c82a97cdf031e93$var$flattenRecursive(data) {
    console.log(data);
    if (data.MonoBehaviour) return data;
    return Object.keys(data).flatMap((x)=>$0c82a97cdf031e93$var$flattenRecursive(data[x]));
}
const $0c82a97cdf031e93$var$flattenedSpellList = $0c82a97cdf031e93$var$flattenRecursive((0, (/*@__PURE__*/$parcel$interopDefault($9e6fa7d34afa6e59$exports)))).map((x)=>({
        ...x.MonoBehaviour,
        usableBy: $0c82a97cdf031e93$var$parseUsableByList(x.MonoBehaviour.usableBy),
        getImport: x.getImport
    }));
function $0c82a97cdf031e93$var$parseUsableByList(unityHexListString) {
    if (unityHexListString == null) return [];
    return unityHexListString.match(/.{1,8}/g).map((x)=>parseInt(x.substring(1).split("").reverse().join(""), 16));
}
const $0c82a97cdf031e93$var$titanInfoLookup = {};
Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($08e390bc033a1b28$exports)))).forEach((key)=>{
    const titanInfo = (0, (/*@__PURE__*/$parcel$interopDefault($08e390bc033a1b28$exports)))[key];
    const classId = titanInfo.MonoBehaviour.heroClass;
    $0c82a97cdf031e93$var$titanInfoLookup[classId] = titanInfo;
});
function $0c82a97cdf031e93$var$Spell({ icon: icon, name: name, castTime: castTime, cooldown: cooldown, description: description }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bee696b036d759c9$export$60332b2344f7fe41), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $95341668bcbb7769$export$f51f4c4ede09e011), {
            gap: "2",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    style: {
                        width: 80,
                        height: 80,
                        flexShrink: 0,
                        borderRadius: 8,
                        backgroundImage: "url(" + icon + ")",
                        backgroundSize: "100%"
                    }
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            style: {
                                textTransform: "uppercase",
                                fontSize: 22
                            },
                            children: name
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            style: {
                                fontFamily: '"Montserrat", sans-serif',
                                fontSize: 14,
                                fontWeight: "bold",
                                marginBottom: 8
                            },
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    children: castTime == null ? null : castTime === 0 ? "Instant cast" : castTime + "s cast"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    children: cooldown != null && cooldown > 0 ? cooldown + "sec cooldown" : null
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("pre", {
                            style: {
                                margin: 0,
                                whiteSpace: "pre-wrap",
                                fontFamily: '"Montserrat", sans-serif'
                            },
                            dangerouslySetInnerHTML: {
                                __html: description
                            }
                        })
                    ]
                })
            ]
        })
    });
}
function $0c82a97cdf031e93$var$SpellList(props) {
    const titanSpells = $0c82a97cdf031e93$var$flattenedSpellList.filter((x)=>x.usableBy.indexOf(props.classId) !== -1).filter((x)=>x.getImport(x.icon)).filter((x)=>!x.isHidden && !x.isInternal && x.spellName.toLowerCase() !== "mount");
    const spells = titanSpells.map((x)=>{
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($0c82a97cdf031e93$var$Spell, {
            icon: x.getImport(x.icon),
            name: x.spellName,
            castTime: x.castTime,
            cooldown: x.cooldown,
            description: x.description
        });
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1186128e999eac49$export$ef2184bd89960b14), {
        columns: "2",
        gap: "3",
        width: "auto",
        children: spells
    });
}
function $0c82a97cdf031e93$var$TitanInfo(props) {
    const titanInfo = $0c82a97cdf031e93$var$titanInfoLookup[props.classId];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            gap: 20
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $95341668bcbb7769$export$f51f4c4ede09e011), {
                align: "center",
                gap: "2",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1a29469ea96a6022$export$a6c7ac8248d6e38a), {
                        to: "/titans",
                        style: {
                            color: "#e9f1e9",
                            marginRight: 8,
                            fontSize: 24
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("i", {
                            className: "fas fa-arrow-left"
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a93feb7e07610316$export$e2255cf6045e8d47), {
                        src: titanInfo.getImport(titanInfo.MonoBehaviour.icon),
                        size: "6"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $95341668bcbb7769$export$f51f4c4ede09e011), {
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                style: {
                                    margin: 0,
                                    textTransform: "uppercase"
                                },
                                children: titanInfo.MonoBehaviour.unitSpec
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                                style: {
                                    margin: 0,
                                    textTransform: "uppercase"
                                },
                                children: titanInfo.MonoBehaviour.unitName
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $bee696b036d759c9$export$60332b2344f7fe41), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    style: {
                        fontFamily: '"Montserrat", sans-serif'
                    },
                    children: titanInfo.MonoBehaviour.description
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($0c82a97cdf031e93$var$Spell, {
                icon: titanInfo.getImport(titanInfo.MonoBehaviour.passiveIcon),
                name: "Passive: " + titanInfo.MonoBehaviour.passiveName,
                description: titanInfo.MonoBehaviour.passiveDescription
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($0c82a97cdf031e93$var$SpellList, {
                ...props
            })
        ]
    });
}
function $0c82a97cdf031e93$var$TitanButton(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $593b59ea7ea0c236$export$353f5b6fc5456de1), {
        style: {
            padding: 0,
            borderRadius: 8
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            style: {
                width: 172,
                height: 172,
                position: "relative",
                borderRadius: 8,
                overflow: "hidden",
                cursor: "pointer"
            },
            onClick: props.onClick,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    style: {
                        position: "absolute",
                        top: 0,
                        left: 0,
                        bottom: 0,
                        right: 0,
                        backgroundImage: "url(" + props.titan.getImport(props.titan.MonoBehaviour.icon) + ")",
                        backgroundSize: "100%",
                        zIndex: -1
                    }
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    style: {
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        right: 0,
                        color: "white",
                        textAlign: "center",
                        textTransform: "uppercase",
                        fontSize: 24,
                        textShadow: "0 0 5px #444"
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            style: {
                                fontSize: 18
                            },
                            children: props.titan.MonoBehaviour.unitSpec
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            children: props.titan.MonoBehaviour.unitName
                        })
                    ]
                })
            ]
        })
    });
}
function $0c82a97cdf031e93$export$2e2bcd8739ae039() {
    const params = (0, $6de75bb8982f6eaa$export$99eaa27ddbbb95ef)();
    const navigate = (0, $6de75bb8982f6eaa$export$9770f232ac06a008)();
    if (params.titan != null) {
        const selectedTitanKey = Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($08e390bc033a1b28$exports)))).find((key)=>{
            const data = (0, (/*@__PURE__*/$parcel$interopDefault($08e390bc033a1b28$exports)))[key];
            return data.MonoBehaviour.unitSpec.toLowerCase() == params.titan.toLowerCase() && !key.toLowerCase().includes("tutorial");
        });
        const selectedTitanId = (0, (/*@__PURE__*/$parcel$interopDefault($08e390bc033a1b28$exports)))[selectedTitanKey].MonoBehaviour.heroClass;
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $032aab6647148487$export$6d1402fb58384e4f), {
            label: params.titan,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($0c82a97cdf031e93$var$TitanInfo, {
                classId: selectedTitanId
            })
        });
    }
    const sortedTitanData = Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($08e390bc033a1b28$exports)))).filter((x)=>!(0, (/*@__PURE__*/$parcel$interopDefault($08e390bc033a1b28$exports)))[x].MonoBehaviour.isInternal);
    sortedTitanData.sort((a, b)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($08e390bc033a1b28$exports)))[a].MonoBehaviour.heroClass - (0, (/*@__PURE__*/$parcel$interopDefault($08e390bc033a1b28$exports)))[b].MonoBehaviour.heroClass;
    });
    const buttons = sortedTitanData.filter((key)=>{
        const data = (0, (/*@__PURE__*/$parcel$interopDefault($08e390bc033a1b28$exports)))[key];
        return !key.toLowerCase().includes("tutorial");
    }).map((key)=>{
        const data = (0, (/*@__PURE__*/$parcel$interopDefault($08e390bc033a1b28$exports)))[key];
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($0c82a97cdf031e93$var$TitanButton, {
            titan: data,
            onClick: ()=>navigate("/titan/" + data.MonoBehaviour.unitSpec.toLowerCase())
        });
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $032aab6647148487$export$6d1402fb58384e4f), {
        label: "Titans",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            style: {
                display: "flex",
                gap: 20,
                flexWrap: "wrap",
                justifyContent: "center"
            },
            children: buttons
        })
    });
}






var $7fPBF = parcelRequire("7fPBF");




const $a904a3a08cd39599$export$48af0a42e6aa05c1 = 10;
const $a904a3a08cd39599$export$f3759eddb222dd7 = $a904a3a08cd39599$export$48af0a42e6aa05c1 * 86400000;
const $a904a3a08cd39599$export$2bea95b25498691e = 20;


const $616bb1ffe380c55d$export$533edcdef9a0af13 = {
    outline: "none",
    border: "none",
    borderRadius: 8,
    background: "rgba(255, 255, 255, 0.05)",
    color: "white",
    padding: "8px 12px"
};
function $616bb1ffe380c55d$var$formatTime(seconds) {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    let timeString = "";
    if (minutes > 0) timeString += `${minutes} min`;
    if (remainingSeconds > 0) {
        if (minutes > 0) timeString += ", ";
        timeString += `${remainingSeconds} sec`;
    }
    return timeString || "0 sec"; // handle case where seconds = 0
}
function $616bb1ffe380c55d$var$PlayerBox({ playerInfo: playerInfo, won: won }) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1a29469ea96a6022$export$a6c7ac8248d6e38a), {
        to: "/player/" + playerInfo.steamId,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $fb1373b494fa36be$export$37acb3580601e69a), {
            color: won ? "green" : "red",
            size: "3",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                    src: (0, $af2a9b1bf6586921$export$13dc4137905925d1)[playerInfo.titan.toLowerCase()],
                    style: {
                        borderRadius: 4
                    }
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                    src: playerInfo.icon,
                    style: {
                        borderRadius: 8
                    }
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    children: [
                        playerInfo.name,
                        " (",
                        playerInfo.mmr,
                        ")"
                    ]
                })
            ]
        })
    });
}
function $616bb1ffe380c55d$var$MatchRow({ steamId: steamId, matchInfo: matchInfo, highlight: highlight }) {
    let team1 = matchInfo.team1;
    let team2 = matchInfo.team2;
    let winner = matchInfo.winner;
    if (team1.findIndex((x)=>x.steamId === steamId) === -1) {
        [team1, team2] = [
            team2,
            team1
        ];
        winner = matchInfo.winner === 1 ? 2 : 1;
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                style: {
                    display: "flex",
                    alignItems: "start",
                    background: highlight ? "rgba(255, 255, 255, 0.05)" : "none",
                    padding: 8,
                    borderTopLeftRadius: 12,
                    borderBottomLeftRadius: 12
                },
                children: new Date(matchInfo.startTime * 1000).toLocaleString()
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                style: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "start",
                    gap: 4,
                    background: highlight ? "rgba(255, 255, 255, 0.05)" : "none",
                    padding: 8
                },
                children: team1.map((x, idx)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($616bb1ffe380c55d$var$PlayerBox, {
                        playerInfo: x,
                        won: winner === 1
                    }, idx))
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                style: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "start",
                    gap: 4,
                    background: highlight ? "rgba(255, 255, 255, 0.05)" : "none",
                    padding: 8
                },
                children: team2.map((x, idx)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($616bb1ffe380c55d$var$PlayerBox, {
                        playerInfo: x,
                        won: winner === 2
                    }, idx))
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                style: {
                    display: "flex",
                    alignItems: "start",
                    justifyContent: "end",
                    background: highlight ? "rgba(255, 255, 255, 0.05)" : "none",
                    padding: 8,
                    borderTopRightRadius: 12,
                    borderBottomRightRadius: 12
                },
                children: $616bb1ffe380c55d$var$formatTime(matchInfo.endTime - matchInfo.startTime)
            })
        ]
    });
}
function $616bb1ffe380c55d$var$MatchHistoryTable({ steamId: steamId, data: data }) {
    if (data == null) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62ca5e79378cd184$export$7f7cbe89f1eacd2), {});
    if (data.length === 0) return "No match history available.";
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        style: {
            display: "grid",
            gridTemplateColumns: "200px 1fr 1fr 130px",
            fontFamily: '"Montserrat", sans-serif'
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                style: {
                    fontSize: 20,
                    fontWeight: "bold",
                    padding: 4
                },
                children: "DATE"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                style: {
                    fontSize: 20,
                    fontWeight: "bold",
                    padding: 4
                },
                children: "TEAM 1"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                style: {
                    fontSize: 20,
                    fontWeight: "bold",
                    padding: 4
                },
                children: "TEAM 2"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                style: {
                    fontSize: 20,
                    fontWeight: "bold",
                    padding: 4,
                    textAlign: "right"
                },
                children: "DURATION"
            }),
            data.map((matchInfo, idx)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($616bb1ffe380c55d$var$MatchRow, {
                    steamId: steamId,
                    matchInfo: matchInfo,
                    highlight: idx % 2 === 0
                }, idx))
        ]
    });
}
function $616bb1ffe380c55d$var$MatchHistory({ steamId: steamId }) {
    const [data, setData] = (0, $7fPBF.useState)(null);
    const [afterIds, setAfterIds] = (0, $7fPBF.useState)([]);
    (0, $7fPBF.useEffect)(async ()=>{
        setData(null);
        const history = await (0, $6e4321e933c8cf65$export$2e2bcd8739ae039)("getMatchHistory", {
            steamId: steamId,
            after: afterIds.length > 0 ? afterIds[afterIds.length - 1] : null
        });
        setData(history);
    }, [
        steamId,
        afterIds
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($616bb1ffe380c55d$var$MatchHistoryTable, {
                steamId: steamId,
                data: data
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    width: "100%",
                    justifyContent: "space-between"
                },
                children: [
                    data != null && afterIds.length > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $593b59ea7ea0c236$export$353f5b6fc5456de1), {
                        style: {
                            borderRadius: 12
                        },
                        icon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("i", {
                            className: "fas fa-chevron-left"
                        }),
                        onClick: ()=>{
                            setAfterIds((old)=>old.slice(0, old.length - 1));
                        },
                        children: "PREVIOUS PAGE"
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {}),
                    data != null && data.length >= 50 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $593b59ea7ea0c236$export$353f5b6fc5456de1), {
                        style: {
                            borderRadius: 12
                        },
                        afterIcon: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("i", {
                            className: "fas fa-chevron-right"
                        }),
                        onClick: ()=>{
                            setAfterIds((old)=>[
                                    ...old,
                                    data[data.length - 1].id
                                ]);
                        },
                        children: "NEXT PAGE"
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {})
                ]
            })
        ]
    });
}
function $616bb1ffe380c55d$var$SearchBox() {
    const navigate = (0, $6de75bb8982f6eaa$export$9770f232ac06a008)();
    const [searchSteamId, setSearchSteamId] = (0, $7fPBF.useState)("");
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("form", {
        onSubmit: (e)=>{
            e.stopPropagation();
            e.preventDefault();
            navigate("/player/" + searchSteamId);
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            style: {
                ...$616bb1ffe380c55d$export$533edcdef9a0af13,
                display: "flex",
                gap: 8,
                alignItems: "center"
            },
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("i", {
                    className: "fas fa-search"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                    type: "search",
                    style: {
                        background: "none",
                        border: "none",
                        outline: "none",
                        color: "white"
                    },
                    placeholder: "Enter a steam ID...",
                    value: searchSteamId,
                    onChange: (e)=>setSearchSteamId(e.target.value)
                })
            ]
        })
    });
}
function $616bb1ffe380c55d$var$PlayerInfo({ steamId: steamId }) {
    const [data, setData] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(async ()=>{
        setData(null);
        const result = await (0, $6e4321e933c8cf65$export$2e2bcd8739ae039)("getPlayerInfo", {
            steamId: steamId
        });
        setData(result);
    }, [
        steamId
    ]);
    if (data == null) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62ca5e79378cd184$export$7f7cbe89f1eacd2), {});
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        style: {
            display: "flex",
            gap: 8,
            alignItems: "center",
            fontSize: 22
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                style: {
                    width: 32,
                    height: 32,
                    borderRadius: 16
                },
                src: data.icon
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: data.name
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: "\u2022"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                style: {
                    fontSize: 14
                },
                children: steamId
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                children: "\u2022"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                style: {
                    fontSize: 14
                },
                children: [
                    "PLAYED ",
                    data.numMatchesPlayed,
                    " MATCHES"
                ]
            })
        ]
    });
}
const $616bb1ffe380c55d$var$CLASSES = {
    mage: "Cryomancer Azora",
    rogue: "Assassin Volen",
    priest: "Cleric Kanna",
    warlock: "Plaguebringer Malrah",
    warrior: "Fighter Tarcza",
    druid: "Naturalist Airion",
    hunter: "Hunter Orin",
    paladin: "Lightbringer Anthriel",
    dark_priest: "Soulstealer Kanna",
    crystal_mage: "Crystalmancer Azora",
    bruiser_rogue: "Bruiser Volen",
    blademaster_warrior: "Blademaster Tarcza",
    eradicator_warlock: "Eradicator Malrah",
    smiter_paladin: "Smiter Anthriel",
    corruption_airion: "Stormcaller Airion",
    marksman_orin: "Marksman Orin"
};
function $616bb1ffe380c55d$var$TitanInfo({ steamId: steamId }) {
    const [data, setData] = (0, $7fPBF.useState)(false);
    const [type, setType] = (0, $7fPBF.useState)("ones");
    const [season, setSeason] = (0, $7fPBF.useState)("full_s1");
    const [titan, setTitan] = (0, $7fPBF.useState)("mage");
    (0, $7fPBF.useEffect)(async ()=>{
        setData(null);
        const result = await (0, $6e4321e933c8cf65$export$2e2bcd8739ae039)("getPlayerTitanRankInfo", {
            steamId: steamId,
            type: type,
            season: season,
            titan: titan
        });
        setData(result);
    }, [
        steamId,
        type,
        season,
        titan
    ]);
    if (data == null) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $62ca5e79378cd184$export$7f7cbe89f1eacd2), {});
    const seasonOptions = Object.keys((0, $af2a9b1bf6586921$export$dea41471f21a81e5)).map((key)=>{
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $608da1f87bc1fe5b$exports).Item, {
            value: key,
            children: (0, $af2a9b1bf6586921$export$dea41471f21a81e5)[key].toUpperCase()
        }, key);
    });
    const titanOptions = Object.keys($616bb1ffe380c55d$var$CLASSES).map((key)=>{
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $608da1f87bc1fe5b$exports).Item, {
            value: key,
            children: $616bb1ffe380c55d$var$CLASSES[key].toUpperCase()
        }, key);
    });
    const typeOptions = Object.keys((0, $af2a9b1bf6586921$export$426db7a6155b7a80)).map((key)=>{
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $608da1f87bc1fe5b$exports).Item, {
            value: key,
            children: (0, $af2a9b1bf6586921$export$426db7a6155b7a80)[key].toUpperCase()
        }, key);
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        style: {
            display: "flex",
            flexDirection: "column",
            gap: 12
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    gap: 8
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $608da1f87bc1fe5b$exports).Root, {
                        value: season,
                        onValueChange: (e)=>setSeason(e),
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $608da1f87bc1fe5b$exports).Trigger, {
                                variant: "soft",
                                color: "green"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $608da1f87bc1fe5b$exports).Content, {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $608da1f87bc1fe5b$exports).Group, {
                                    children: seasonOptions
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $608da1f87bc1fe5b$exports).Root, {
                        value: titan,
                        onValueChange: (e)=>setTitan(e),
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $608da1f87bc1fe5b$exports).Trigger, {
                                variant: "soft",
                                color: "green"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $608da1f87bc1fe5b$exports).Content, {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $608da1f87bc1fe5b$exports).Group, {
                                    children: titanOptions
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $608da1f87bc1fe5b$exports).Root, {
                        value: type,
                        onValueChange: (e)=>setType(e),
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $608da1f87bc1fe5b$exports).Trigger, {
                                variant: "soft",
                                color: "green"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $608da1f87bc1fe5b$exports).Content, {
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $608da1f87bc1fe5b$exports).Group, {
                                    children: typeOptions
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                style: {
                    display: "flex",
                    flexDirection: "column",
                    gap: 8
                },
                children: [
                    data.mmr != null && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "MMR:"
                            }),
                            " ",
                            data.mmr
                        ]
                    }),
                    data.rank != null && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "RANK:"
                            }),
                            " ",
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                style: {
                                    display: "inline-block"
                                },
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af2a9b1bf6586921$export$f829dc875a4981a2), {
                                    rank: data.rank
                                })
                            })
                        ]
                    }),
                    data.ranking != null && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "RANKING:"
                            }),
                            " #",
                            data.ranking,
                            " ON LEADERBOARDS"
                        ]
                    }),
                    data.numMatchesPlayed != null && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("strong", {
                                children: [
                                    "MATCHES PLAYED IN LAST ",
                                    (0, $a904a3a08cd39599$export$48af0a42e6aa05c1),
                                    " DAYS:"
                                ]
                            }),
                            " ",
                            data.numMatchesPlayed,
                            " / ",
                            (0, $a904a3a08cd39599$export$2bea95b25498691e),
                            " (",
                            data.numMatchesPlayed >= (0, $a904a3a08cd39599$export$2bea95b25498691e) ? "SAFE" : "WILL DECAY",
                            ")"
                        ]
                    })
                ]
            })
        ]
    });
}
function $616bb1ffe380c55d$export$2e2bcd8739ae039() {
    const params = (0, $6de75bb8982f6eaa$export$99eaa27ddbbb95ef)();
    const steamId = params.steamId;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $032aab6647148487$export$6d1402fb58384e4f), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            style: {
                display: "flex",
                flexDirection: "column",
                gap: 20
            },
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    style: {
                        display: "flex",
                        justifyContent: "space-between"
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($616bb1ffe380c55d$var$PlayerInfo, {
                            steamId: steamId
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($616bb1ffe380c55d$var$SearchBox, {})
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    style: {
                        padding: 20,
                        background: "rgba(255, 255, 255, 0.05)",
                        borderRadius: 16,
                        display: "flex",
                        flexDirection: "column",
                        gap: 20
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                            style: {
                                margin: 0
                            },
                            children: "TITAN INFO"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($616bb1ffe380c55d$var$TitanInfo, {
                            steamId: steamId
                        }, steamId)
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    style: {
                        padding: 20,
                        background: "rgba(255, 255, 255, 0.05)",
                        borderRadius: 16,
                        display: "flex",
                        flexDirection: "column",
                        gap: 20
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                    style: {
                                        margin: 0
                                    },
                                    children: "MATCH HISTORY"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    style: {
                                        margin: 0,
                                        marginTop: 4,
                                        fontFamily: '"Montserrat", sans-serif',
                                        fontSize: 14,
                                        color: "#ddd"
                                    },
                                    children: "Match history is delayed by 3 hours to prevent sniping/dodging/etc."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($616bb1ffe380c55d$var$MatchHistory, {
                            steamId: steamId
                        }, steamId)
                    ]
                })
            ]
        })
    });
}




function $dd60961f6c49e3c0$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $032aab6647148487$export$6d1402fb58384e4f), {
        label: "LINK DISCORD",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            style: {
                display: "flex",
                flexDirection: "column",
                gap: 8,
                textAlign: "center",
                fontFamily: '"Montserrat", sans-serif'
            },
            children: "Your Discord has been successfully linked! It may take some time to sync your roles on Discord."
        })
    });
}




function $ddd84badcbaf1320$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $032aab6647148487$export$6d1402fb58384e4f), {
        label: "LINK DISCORD",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            style: {
                display: "flex",
                flexDirection: "column",
                gap: 8,
                textAlign: "center",
                fontFamily: '"Montserrat", sans-serif'
            },
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    children: [
                        "You can Link your Discord account if you'd like to get special Roles granted on the official",
                        " ",
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                            href: "https://discord.gg/8xRbPjgg7p",
                            children: "Ring of Titans Discord"
                        }),
                        " ",
                        "based on your in-game accomplishments. Note that you must have your Steam linked and verified on Discord. You may need to unlink and re-link your Steam to Discord in order to ensure it has been verified."
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    children: "Also note that this is a one-time sync, so if you have new accomplishments in game, you'll have to come back and re-link to get those to update on Discord."
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                            href: "https://discord.com/oauth2/authorize?client_id=939722825005170730&response_type=code&redirect_uri=https%3A%2F%2Flinkdiscord-vg6rnx7kwa-uc.a.run.app%2F&scope=connections+identify",
                            children: "Click here"
                        }),
                        " ",
                        "to link your account."
                    ]
                })
            ]
        })
    });
}




function $d8c91452cd284d9f$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $032aab6647148487$export$6d1402fb58384e4f), {
        label: "LINK DISCORD",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            style: {
                display: "flex",
                flexDirection: "column",
                gap: 8,
                textAlign: "center",
                fontFamily: '"Montserrat", sans-serif'
            },
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    children: "There has been an error linking your Discord. Note that you must have your Steam account linked and verified on Discord. You may need to unlink and re-link your Steam to Discord in order to ensure it has been verified."
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                            href: "https://discord.com/oauth2/authorize?client_id=939722825005170730&response_type=code&redirect_uri=https%3A%2F%2Flinkdiscord-vg6rnx7kwa-uc.a.run.app%2F&scope=connections+identify",
                            children: "Click here"
                        }),
                        " ",
                        "to try again."
                    ]
                })
            ]
        })
    });
}


function $6aaba76260e26777$var$App() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1a29469ea96a6022$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $6de75bb8982f6eaa$export$3565eb3d00ca5a74), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de75bb8982f6eaa$export$e7b0ac011bb776c6), {
                    path: "/",
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $593b59ea7ea0c236$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de75bb8982f6eaa$export$e7b0ac011bb776c6), {
                    path: "/leaderboards/:season/:type",
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af2a9b1bf6586921$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de75bb8982f6eaa$export$e7b0ac011bb776c6), {
                    path: "/leaderboards",
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $af2a9b1bf6586921$export$2e2bcd8739ae039), {})
                }),
                (0, $82bfa5d3a2ad1c2a$export$959d3245e7b2b502).map((x)=>{
                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de75bb8982f6eaa$export$e7b0ac011bb776c6), {
                        path: "/patchnotes/" + x.key,
                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $82bfa5d3a2ad1c2a$export$2e2bcd8739ae039), {
                            notes: x.val
                        })
                    });
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de75bb8982f6eaa$export$e7b0ac011bb776c6), {
                    path: "/patchnotes",
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $82bfa5d3a2ad1c2a$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de75bb8982f6eaa$export$e7b0ac011bb776c6), {
                    path: "/titans",
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0c82a97cdf031e93$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de75bb8982f6eaa$export$e7b0ac011bb776c6), {
                    path: "/titan/:titan",
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0c82a97cdf031e93$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de75bb8982f6eaa$export$e7b0ac011bb776c6), {
                    path: "/player/:steamId",
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $616bb1ffe380c55d$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de75bb8982f6eaa$export$e7b0ac011bb776c6), {
                    path: "/link/discord/",
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ddd84badcbaf1320$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de75bb8982f6eaa$export$e7b0ac011bb776c6), {
                    path: "/link/discord/success",
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dd60961f6c49e3c0$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6de75bb8982f6eaa$export$e7b0ac011bb776c6), {
                    path: "/link/discord/error",
                    element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d8c91452cd284d9f$export$2e2bcd8739ae039), {})
                })
            ]
        })
    });
}
var $6aaba76260e26777$export$2e2bcd8739ae039 = $6aaba76260e26777$var$App;



/*!
 * Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */ (function() {
    "use strict";
    function _typeof(obj) {
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function(obj) {
            return typeof obj;
        };
        else _typeof = function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _objectSpread(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            var ownKeys = Object.keys(source);
            if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
            ownKeys.forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
        }
        return target;
    }
    function _slicedToArray(arr, i) {
        return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) {
            for(var i = 0, arr2 = new Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
            return arr2;
        }
    }
    function _arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function _iterableToArray(iter) {
        if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
    }
    function _iterableToArrayLimit(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"] != null) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance");
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
    var noop = function noop() {};
    var _WINDOW = {};
    var _DOCUMENT = {};
    var _MUTATION_OBSERVER = null;
    var _PERFORMANCE = {
        mark: noop,
        measure: noop
    };
    try {
        if (typeof window !== "undefined") _WINDOW = window;
        if (typeof document !== "undefined") _DOCUMENT = document;
        if (typeof MutationObserver !== "undefined") _MUTATION_OBSERVER = MutationObserver;
        if (typeof performance !== "undefined") _PERFORMANCE = performance;
    } catch (e) {}
    var _ref = _WINDOW.navigator || {}, _ref$userAgent = _ref.userAgent, userAgent = _ref$userAgent === void 0 ? "" : _ref$userAgent;
    var WINDOW = _WINDOW;
    var DOCUMENT = _DOCUMENT;
    var MUTATION_OBSERVER = _MUTATION_OBSERVER;
    var PERFORMANCE = _PERFORMANCE;
    var IS_BROWSER = !!WINDOW.document;
    var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === "function" && typeof DOCUMENT.createElement === "function";
    var IS_IE = ~userAgent.indexOf("MSIE") || ~userAgent.indexOf("Trident/");
    var NAMESPACE_IDENTIFIER = "___FONT_AWESOME___";
    var UNITS_IN_GRID = 16;
    var DEFAULT_FAMILY_PREFIX = "fa";
    var DEFAULT_REPLACEMENT_CLASS = "svg-inline--fa";
    var DATA_FA_I2SVG = "data-fa-i2svg";
    var DATA_FA_PSEUDO_ELEMENT = "data-fa-pseudo-element";
    var DATA_FA_PSEUDO_ELEMENT_PENDING = "data-fa-pseudo-element-pending";
    var DATA_PREFIX = "data-prefix";
    var DATA_ICON = "data-icon";
    var HTML_CLASS_I2SVG_BASE_CLASS = "fontawesome-i2svg";
    var MUTATION_APPROACH_ASYNC = "async";
    var TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = [
        "HTML",
        "HEAD",
        "STYLE",
        "SCRIPT"
    ];
    var PRODUCTION = function() {
        try {
            return true;
        } catch (e) {
            return false;
        }
    }();
    var PREFIX_TO_STYLE = {
        "fas": "solid",
        "far": "regular",
        "fal": "light",
        "fad": "duotone",
        "fab": "brands",
        "fak": "kit",
        "fa": "solid"
    };
    var STYLE_TO_PREFIX = {
        "solid": "fas",
        "regular": "far",
        "light": "fal",
        "duotone": "fad",
        "brands": "fab",
        "kit": "fak"
    };
    var LAYERS_TEXT_CLASSNAME = "fa-layers-text";
    var FONT_FAMILY_PATTERN = /Font Awesome ([5 ]*)(Solid|Regular|Light|Duotone|Brands|Free|Pro|Kit).*/i; // TODO: do we need to handle font-weight for kit SVG pseudo-elements?
    var FONT_WEIGHT_TO_PREFIX = {
        "900": "fas",
        "400": "far",
        "normal": "far",
        "300": "fal"
    };
    var oneToTen = [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10
    ];
    var oneToTwenty = oneToTen.concat([
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20
    ]);
    var ATTRIBUTES_WATCHED_FOR_MUTATION = [
        "class",
        "data-prefix",
        "data-icon",
        "data-fa-transform",
        "data-fa-mask"
    ];
    var DUOTONE_CLASSES = {
        GROUP: "group",
        SWAP_OPACITY: "swap-opacity",
        PRIMARY: "primary",
        SECONDARY: "secondary"
    };
    var RESERVED_CLASSES = [
        "xs",
        "sm",
        "lg",
        "fw",
        "ul",
        "li",
        "border",
        "pull-left",
        "pull-right",
        "spin",
        "pulse",
        "rotate-90",
        "rotate-180",
        "rotate-270",
        "flip-horizontal",
        "flip-vertical",
        "flip-both",
        "stack",
        "stack-1x",
        "stack-2x",
        "inverse",
        "layers",
        "layers-text",
        "layers-counter",
        DUOTONE_CLASSES.GROUP,
        DUOTONE_CLASSES.SWAP_OPACITY,
        DUOTONE_CLASSES.PRIMARY,
        DUOTONE_CLASSES.SECONDARY
    ].concat(oneToTen.map(function(n) {
        return "".concat(n, "x");
    })).concat(oneToTwenty.map(function(n) {
        return "w-".concat(n);
    }));
    var initial = WINDOW.FontAwesomeConfig || {};
    function getAttrConfig(attr) {
        var element = DOCUMENT.querySelector("script[" + attr + "]");
        if (element) return element.getAttribute(attr);
    }
    function coerce(val) {
        // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
        // We'll assume that this is an indication that it should be toggled to true
        // For example <script data-search-pseudo-elements src="..."></script>
        if (val === "") return true;
        if (val === "false") return false;
        if (val === "true") return true;
        return val;
    }
    if (DOCUMENT && typeof DOCUMENT.querySelector === "function") {
        var attrs = [
            [
                "data-family-prefix",
                "familyPrefix"
            ],
            [
                "data-replacement-class",
                "replacementClass"
            ],
            [
                "data-auto-replace-svg",
                "autoReplaceSvg"
            ],
            [
                "data-auto-add-css",
                "autoAddCss"
            ],
            [
                "data-auto-a11y",
                "autoA11y"
            ],
            [
                "data-search-pseudo-elements",
                "searchPseudoElements"
            ],
            [
                "data-observe-mutations",
                "observeMutations"
            ],
            [
                "data-mutate-approach",
                "mutateApproach"
            ],
            [
                "data-keep-original-source",
                "keepOriginalSource"
            ],
            [
                "data-measure-performance",
                "measurePerformance"
            ],
            [
                "data-show-missing-icons",
                "showMissingIcons"
            ]
        ];
        attrs.forEach(function(_ref) {
            var _ref2 = _slicedToArray(_ref, 2), attr = _ref2[0], key = _ref2[1];
            var val = coerce(getAttrConfig(attr));
            if (val !== undefined && val !== null) initial[key] = val;
        });
    }
    var _default = {
        familyPrefix: DEFAULT_FAMILY_PREFIX,
        replacementClass: DEFAULT_REPLACEMENT_CLASS,
        autoReplaceSvg: true,
        autoAddCss: true,
        autoA11y: true,
        searchPseudoElements: false,
        observeMutations: true,
        mutateApproach: "async",
        keepOriginalSource: true,
        measurePerformance: false,
        showMissingIcons: true
    };
    var _config = _objectSpread({}, _default, initial);
    if (!_config.autoReplaceSvg) _config.observeMutations = false;
    var config = _objectSpread({}, _config);
    WINDOW.FontAwesomeConfig = config;
    var w = WINDOW || {};
    if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
    if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
    if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
    if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
    var namespace = w[NAMESPACE_IDENTIFIER];
    var functions = [];
    var listener = function listener() {
        DOCUMENT.removeEventListener("DOMContentLoaded", listener);
        loaded = 1;
        functions.map(function(fn) {
            return fn();
        });
    };
    var loaded = false;
    if (IS_DOM) {
        loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
        if (!loaded) DOCUMENT.addEventListener("DOMContentLoaded", listener);
    }
    function domready(fn) {
        if (!IS_DOM) return;
        loaded ? setTimeout(fn, 0) : functions.push(fn);
    }
    var PENDING = "pending";
    var SETTLED = "settled";
    var FULFILLED = "fulfilled";
    var REJECTED = "rejected";
    var NOOP = function NOOP() {};
    var isNode = typeof $parcel$global !== "undefined" && typeof $parcel$global.process !== "undefined" && typeof $parcel$global.process.emit === "function";
    var asyncSetTimer = typeof setImmediate === "undefined" ? setTimeout : setImmediate;
    var asyncQueue = [];
    var asyncTimer;
    function asyncFlush() {
        // run promise callbacks
        for(var i = 0; i < asyncQueue.length; i++)asyncQueue[i][0](asyncQueue[i][1]);
         // reset async asyncQueue
        asyncQueue = [];
        asyncTimer = false;
    }
    function asyncCall(callback, arg) {
        asyncQueue.push([
            callback,
            arg
        ]);
        if (!asyncTimer) {
            asyncTimer = true;
            asyncSetTimer(asyncFlush, 0);
        }
    }
    function invokeResolver(resolver, promise) {
        function resolvePromise(value) {
            resolve(promise, value);
        }
        function rejectPromise(reason) {
            reject(promise, reason);
        }
        try {
            resolver(resolvePromise, rejectPromise);
        } catch (e) {
            rejectPromise(e);
        }
    }
    function invokeCallback(subscriber) {
        var owner = subscriber.owner;
        var settled = owner._state;
        var value = owner._data;
        var callback = subscriber[settled];
        var promise = subscriber.then;
        if (typeof callback === "function") {
            settled = FULFILLED;
            try {
                value = callback(value);
            } catch (e) {
                reject(promise, e);
            }
        }
        if (!handleThenable(promise, value)) {
            if (settled === FULFILLED) resolve(promise, value);
            if (settled === REJECTED) reject(promise, value);
        }
    }
    function handleThenable(promise, value) {
        var resolved;
        try {
            if (promise === value) throw new TypeError("A promises callback cannot return that same promise.");
            if (value && (typeof value === "function" || _typeof(value) === "object")) {
                // then should be retrieved only once
                var then = value.then;
                if (typeof then === "function") {
                    then.call(value, function(val) {
                        if (!resolved) {
                            resolved = true;
                            if (value === val) fulfill(promise, val);
                            else resolve(promise, val);
                        }
                    }, function(reason) {
                        if (!resolved) {
                            resolved = true;
                            reject(promise, reason);
                        }
                    });
                    return true;
                }
            }
        } catch (e) {
            if (!resolved) reject(promise, e);
            return true;
        }
        return false;
    }
    function resolve(promise, value) {
        if (promise === value || !handleThenable(promise, value)) fulfill(promise, value);
    }
    function fulfill(promise, value) {
        if (promise._state === PENDING) {
            promise._state = SETTLED;
            promise._data = value;
            asyncCall(publishFulfillment, promise);
        }
    }
    function reject(promise, reason) {
        if (promise._state === PENDING) {
            promise._state = SETTLED;
            promise._data = reason;
            asyncCall(publishRejection, promise);
        }
    }
    function publish(promise) {
        promise._then = promise._then.forEach(invokeCallback);
    }
    function publishFulfillment(promise) {
        promise._state = FULFILLED;
        publish(promise);
    }
    function publishRejection(promise) {
        promise._state = REJECTED;
        publish(promise);
        if (!promise._handled && isNode) $parcel$global.process.emit("unhandledRejection", promise._data, promise);
    }
    function notifyRejectionHandled(promise) {
        $parcel$global.process.emit("rejectionHandled", promise);
    }
    /**
   * @class
   */ function P(resolver) {
        if (typeof resolver !== "function") throw new TypeError("Promise resolver " + resolver + " is not a function");
        if (this instanceof P === false) throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
        this._then = [];
        invokeResolver(resolver, this);
    }
    P.prototype = {
        constructor: P,
        _state: PENDING,
        _then: null,
        _data: undefined,
        _handled: false,
        then: function then(onFulfillment, onRejection) {
            var subscriber = {
                owner: this,
                then: new this.constructor(NOOP),
                fulfilled: onFulfillment,
                rejected: onRejection
            };
            if ((onRejection || onFulfillment) && !this._handled) {
                this._handled = true;
                if (this._state === REJECTED && isNode) asyncCall(notifyRejectionHandled, this);
            }
            if (this._state === FULFILLED || this._state === REJECTED) // already resolved, call callback async
            asyncCall(invokeCallback, subscriber);
            else // subscribe
            this._then.push(subscriber);
            return subscriber.then;
        },
        catch: function _catch(onRejection) {
            return this.then(null, onRejection);
        }
    };
    P.all = function(promises) {
        if (!Array.isArray(promises)) throw new TypeError("You must pass an array to Promise.all().");
        return new P(function(resolve, reject) {
            var results = [];
            var remaining = 0;
            function resolver(index) {
                remaining++;
                return function(value) {
                    results[index] = value;
                    if (!--remaining) resolve(results);
                };
            }
            for(var i = 0, promise; i < promises.length; i++){
                promise = promises[i];
                if (promise && typeof promise.then === "function") promise.then(resolver(i), reject);
                else results[i] = promise;
            }
            if (!remaining) resolve(results);
        });
    };
    P.race = function(promises) {
        if (!Array.isArray(promises)) throw new TypeError("You must pass an array to Promise.race().");
        return new P(function(resolve, reject) {
            for(var i = 0, promise; i < promises.length; i++){
                promise = promises[i];
                if (promise && typeof promise.then === "function") promise.then(resolve, reject);
                else resolve(promise);
            }
        });
    };
    P.resolve = function(value) {
        if (value && _typeof(value) === "object" && value.constructor === P) return value;
        return new P(function(resolve) {
            resolve(value);
        });
    };
    P.reject = function(reason) {
        return new P(function(resolve, reject) {
            reject(reason);
        });
    };
    var picked = typeof Promise === "function" ? Promise : P;
    var d = UNITS_IN_GRID;
    var meaninglessTransform = {
        size: 16,
        x: 0,
        y: 0,
        rotate: 0,
        flipX: false,
        flipY: false
    };
    function isReserved(name) {
        return ~RESERVED_CLASSES.indexOf(name);
    }
    function bunker(fn) {
        try {
            fn();
        } catch (e) {
            if (!PRODUCTION) throw e;
        }
    }
    function insertCss(css) {
        if (!css || !IS_DOM) return;
        var style = DOCUMENT.createElement("style");
        style.setAttribute("type", "text/css");
        style.innerHTML = css;
        var headChildren = DOCUMENT.head.childNodes;
        var beforeChild = null;
        for(var i = headChildren.length - 1; i > -1; i--){
            var child = headChildren[i];
            var tagName = (child.tagName || "").toUpperCase();
            if ([
                "STYLE",
                "LINK"
            ].indexOf(tagName) > -1) beforeChild = child;
        }
        DOCUMENT.head.insertBefore(style, beforeChild);
        return css;
    }
    var idPool = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    function nextUniqueId() {
        var size = 12;
        var id = "";
        while(size-- > 0)id += idPool[Math.random() * 62 | 0];
        return id;
    }
    function toArray(obj) {
        var array = [];
        for(var i = (obj || []).length >>> 0; i--;)array[i] = obj[i];
        return array;
    }
    function classArray(node) {
        if (node.classList) return toArray(node.classList);
        else return (node.getAttribute("class") || "").split(" ").filter(function(i) {
            return i;
        });
    }
    function getIconName(familyPrefix, cls) {
        var parts = cls.split("-");
        var prefix = parts[0];
        var iconName = parts.slice(1).join("-");
        if (prefix === familyPrefix && iconName !== "" && !isReserved(iconName)) return iconName;
        else return null;
    }
    function htmlEscape(str) {
        return "".concat(str).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    }
    function joinAttributes(attributes) {
        return Object.keys(attributes || {}).reduce(function(acc, attributeName) {
            return acc + "".concat(attributeName, '="').concat(htmlEscape(attributes[attributeName]), '" ');
        }, "").trim();
    }
    function joinStyles(styles) {
        return Object.keys(styles || {}).reduce(function(acc, styleName) {
            return acc + "".concat(styleName, ": ").concat(styles[styleName], ";");
        }, "");
    }
    function transformIsMeaningful(transform) {
        return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
    }
    function transformForSvg(_ref) {
        var transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
        var outer = {
            transform: "translate(".concat(containerWidth / 2, " 256)")
        };
        var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
        var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
        var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
        var inner = {
            transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
        };
        var path = {
            transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
        };
        return {
            outer: outer,
            inner: inner,
            path: path
        };
    }
    function transformForCss(_ref2) {
        var transform = _ref2.transform, _ref2$width = _ref2.width, width = _ref2$width === void 0 ? UNITS_IN_GRID : _ref2$width, _ref2$height = _ref2.height, height = _ref2$height === void 0 ? UNITS_IN_GRID : _ref2$height, _ref2$startCentered = _ref2.startCentered, startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
        var val = "";
        if (startCentered && IS_IE) val += "translate(".concat(transform.x / d - width / 2, "em, ").concat(transform.y / d - height / 2, "em) ");
        else if (startCentered) val += "translate(calc(-50% + ".concat(transform.x / d, "em), calc(-50% + ").concat(transform.y / d, "em)) ");
        else val += "translate(".concat(transform.x / d, "em, ").concat(transform.y / d, "em) ");
        val += "scale(".concat(transform.size / d * (transform.flipX ? -1 : 1), ", ").concat(transform.size / d * (transform.flipY ? -1 : 1), ") ");
        val += "rotate(".concat(transform.rotate, "deg) ");
        return val;
    }
    var ALL_SPACE = {
        x: 0,
        y: 0,
        width: "100%",
        height: "100%"
    };
    function fillBlack(abstract) {
        var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        if (abstract.attributes && (abstract.attributes.fill || force)) abstract.attributes.fill = "black";
        return abstract;
    }
    function deGroup(abstract) {
        if (abstract.tag === "g") return abstract.children;
        else return [
            abstract
        ];
    }
    function makeIconMasking(_ref) {
        var children = _ref.children, attributes = _ref.attributes, main = _ref.main, mask = _ref.mask, explicitMaskId = _ref.maskId, transform = _ref.transform;
        var mainWidth = main.width, mainPath = main.icon;
        var maskWidth = mask.width, maskPath = mask.icon;
        var trans = transformForSvg({
            transform: transform,
            containerWidth: maskWidth,
            iconWidth: mainWidth
        });
        var maskRect = {
            tag: "rect",
            attributes: _objectSpread({}, ALL_SPACE, {
                fill: "white"
            })
        };
        var maskInnerGroupChildrenMixin = mainPath.children ? {
            children: mainPath.children.map(fillBlack)
        } : {};
        var maskInnerGroup = {
            tag: "g",
            attributes: _objectSpread({}, trans.inner),
            children: [
                fillBlack(_objectSpread({
                    tag: mainPath.tag,
                    attributes: _objectSpread({}, mainPath.attributes, trans.path)
                }, maskInnerGroupChildrenMixin))
            ]
        };
        var maskOuterGroup = {
            tag: "g",
            attributes: _objectSpread({}, trans.outer),
            children: [
                maskInnerGroup
            ]
        };
        var maskId = "mask-".concat(explicitMaskId || nextUniqueId());
        var clipId = "clip-".concat(explicitMaskId || nextUniqueId());
        var maskTag = {
            tag: "mask",
            attributes: _objectSpread({}, ALL_SPACE, {
                id: maskId,
                maskUnits: "userSpaceOnUse",
                maskContentUnits: "userSpaceOnUse"
            }),
            children: [
                maskRect,
                maskOuterGroup
            ]
        };
        var defs = {
            tag: "defs",
            children: [
                {
                    tag: "clipPath",
                    attributes: {
                        id: clipId
                    },
                    children: deGroup(maskPath)
                },
                maskTag
            ]
        };
        children.push(defs, {
            tag: "rect",
            attributes: _objectSpread({
                fill: "currentColor",
                "clip-path": "url(#".concat(clipId, ")"),
                mask: "url(#".concat(maskId, ")")
            }, ALL_SPACE)
        });
        return {
            children: children,
            attributes: attributes
        };
    }
    function makeIconStandard(_ref) {
        var children = _ref.children, attributes = _ref.attributes, main = _ref.main, transform = _ref.transform, styles = _ref.styles;
        var styleString = joinStyles(styles);
        if (styleString.length > 0) attributes["style"] = styleString;
        if (transformIsMeaningful(transform)) {
            var trans = transformForSvg({
                transform: transform,
                containerWidth: main.width,
                iconWidth: main.width
            });
            children.push({
                tag: "g",
                attributes: _objectSpread({}, trans.outer),
                children: [
                    {
                        tag: "g",
                        attributes: _objectSpread({}, trans.inner),
                        children: [
                            {
                                tag: main.icon.tag,
                                children: main.icon.children,
                                attributes: _objectSpread({}, main.icon.attributes, trans.path)
                            }
                        ]
                    }
                ]
            });
        } else children.push(main.icon);
        return {
            children: children,
            attributes: attributes
        };
    }
    function asIcon(_ref) {
        var children = _ref.children, main = _ref.main, mask = _ref.mask, attributes = _ref.attributes, styles = _ref.styles, transform = _ref.transform;
        if (transformIsMeaningful(transform) && main.found && !mask.found) {
            var width = main.width, height = main.height;
            var offset = {
                x: width / height / 2,
                y: 0.5
            };
            attributes["style"] = joinStyles(_objectSpread({}, styles, {
                "transform-origin": "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
            }));
        }
        return [
            {
                tag: "svg",
                attributes: attributes,
                children: children
            }
        ];
    }
    function asSymbol(_ref) {
        var prefix = _ref.prefix, iconName = _ref.iconName, children = _ref.children, attributes = _ref.attributes, symbol = _ref.symbol;
        var id = symbol === true ? "".concat(prefix, "-").concat(config.familyPrefix, "-").concat(iconName) : symbol;
        return [
            {
                tag: "svg",
                attributes: {
                    style: "display: none;"
                },
                children: [
                    {
                        tag: "symbol",
                        attributes: _objectSpread({}, attributes, {
                            id: id
                        }),
                        children: children
                    }
                ]
            }
        ];
    }
    function makeInlineSvgAbstract(params) {
        var _params$icons = params.icons, main = _params$icons.main, mask = _params$icons.mask, prefix = params.prefix, iconName = params.iconName, transform = params.transform, symbol = params.symbol, title = params.title, maskId = params.maskId, titleId = params.titleId, extra = params.extra, _params$watchable = params.watchable, watchable = _params$watchable === void 0 ? false : _params$watchable;
        var _ref = mask.found ? mask : main, width = _ref.width, height = _ref.height;
        var isUploadedIcon = prefix === "fak";
        var widthClass = isUploadedIcon ? "" : "fa-w-".concat(Math.ceil(width / height * 16));
        var attrClass = [
            config.replacementClass,
            iconName ? "".concat(config.familyPrefix, "-").concat(iconName) : "",
            widthClass
        ].filter(function(c) {
            return extra.classes.indexOf(c) === -1;
        }).filter(function(c) {
            return c !== "" || !!c;
        }).concat(extra.classes).join(" ");
        var content = {
            children: [],
            attributes: _objectSpread({}, extra.attributes, {
                "data-prefix": prefix,
                "data-icon": iconName,
                "class": attrClass,
                "role": extra.attributes.role || "img",
                "xmlns": "http://www.w3.org/2000/svg",
                "viewBox": "0 0 ".concat(width, " ").concat(height)
            })
        };
        var uploadedIconWidthStyle = isUploadedIcon && !~extra.classes.indexOf("fa-fw") ? {
            width: "".concat(width / height * 1, "em")
        } : {};
        if (watchable) content.attributes[DATA_FA_I2SVG] = "";
        if (title) content.children.push({
            tag: "title",
            attributes: {
                id: content.attributes["aria-labelledby"] || "title-".concat(titleId || nextUniqueId())
            },
            children: [
                title
            ]
        });
        var args = _objectSpread({}, content, {
            prefix: prefix,
            iconName: iconName,
            main: main,
            mask: mask,
            maskId: maskId,
            transform: transform,
            symbol: symbol,
            styles: _objectSpread({}, uploadedIconWidthStyle, extra.styles)
        });
        var _ref2 = mask.found && main.found ? makeIconMasking(args) : makeIconStandard(args), children = _ref2.children, attributes = _ref2.attributes;
        args.children = children;
        args.attributes = attributes;
        if (symbol) return asSymbol(args);
        else return asIcon(args);
    }
    function makeLayersTextAbstract(params) {
        var content = params.content, width = params.width, height = params.height, transform = params.transform, title = params.title, extra = params.extra, _params$watchable2 = params.watchable, watchable = _params$watchable2 === void 0 ? false : _params$watchable2;
        var attributes = _objectSpread({}, extra.attributes, title ? {
            "title": title
        } : {}, {
            "class": extra.classes.join(" ")
        });
        if (watchable) attributes[DATA_FA_I2SVG] = "";
        var styles = _objectSpread({}, extra.styles);
        if (transformIsMeaningful(transform)) {
            styles["transform"] = transformForCss({
                transform: transform,
                startCentered: true,
                width: width,
                height: height
            });
            styles["-webkit-transform"] = styles["transform"];
        }
        var styleString = joinStyles(styles);
        if (styleString.length > 0) attributes["style"] = styleString;
        var val = [];
        val.push({
            tag: "span",
            attributes: attributes,
            children: [
                content
            ]
        });
        if (title) val.push({
            tag: "span",
            attributes: {
                class: "sr-only"
            },
            children: [
                title
            ]
        });
        return val;
    }
    function makeLayersCounterAbstract(params) {
        var content = params.content, title = params.title, extra = params.extra;
        var attributes = _objectSpread({}, extra.attributes, title ? {
            "title": title
        } : {}, {
            "class": extra.classes.join(" ")
        });
        var styleString = joinStyles(extra.styles);
        if (styleString.length > 0) attributes["style"] = styleString;
        var val = [];
        val.push({
            tag: "span",
            attributes: attributes,
            children: [
                content
            ]
        });
        if (title) val.push({
            tag: "span",
            attributes: {
                class: "sr-only"
            },
            children: [
                title
            ]
        });
        return val;
    }
    var noop$1 = function noop() {};
    var p = config.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : {
        mark: noop$1,
        measure: noop$1
    };
    var preamble = 'FA "5.15.4"';
    var begin = function begin(name) {
        p.mark("".concat(preamble, " ").concat(name, " begins"));
        return function() {
            return end(name);
        };
    };
    var end = function end(name) {
        p.mark("".concat(preamble, " ").concat(name, " ends"));
        p.measure("".concat(preamble, " ").concat(name), "".concat(preamble, " ").concat(name, " begins"), "".concat(preamble, " ").concat(name, " ends"));
    };
    var perf = {
        begin: begin,
        end: end
    };
    /**
   * Internal helper to bind a function known to have 4 arguments
   * to a given context.
   */ var bindInternal4 = function bindInternal4(func, thisContext) {
        return function(a, b, c, d) {
            return func.call(thisContext, a, b, c, d);
        };
    };
    /**
   * # Reduce
   *
   * A fast object `.reduce()` implementation.
   *
   * @param  {Object}   subject      The object to reduce over.
   * @param  {Function} fn           The reducer function.
   * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
   * @param  {Object}   thisContext  The context for the reducer.
   * @return {mixed}                 The final result.
   */ var reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
        var keys = Object.keys(subject), length = keys.length, iterator = thisContext !== undefined ? bindInternal4(fn, thisContext) : fn, i, key, result;
        if (initialValue === undefined) {
            i = 1;
            result = subject[keys[0]];
        } else {
            i = 0;
            result = initialValue;
        }
        for(; i < length; i++){
            key = keys[i];
            result = iterator(result, subject[key], key, subject);
        }
        return result;
    };
    function toHex(unicode) {
        var result = "";
        for(var i = 0; i < unicode.length; i++){
            var hex = unicode.charCodeAt(i).toString(16);
            result += ("000" + hex).slice(-4);
        }
        return result;
    }
    function defineIcons(prefix, icons) {
        var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var _params$skipHooks = params.skipHooks, skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
        var normalized = Object.keys(icons).reduce(function(acc, iconName) {
            var icon = icons[iconName];
            var expanded = !!icon.icon;
            if (expanded) acc[icon.iconName] = icon.icon;
            else acc[iconName] = icon;
            return acc;
        }, {});
        if (typeof namespace.hooks.addPack === "function" && !skipHooks) namespace.hooks.addPack(prefix, normalized);
        else namespace.styles[prefix] = _objectSpread({}, namespace.styles[prefix] || {}, normalized);
        /**
     * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
     * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
     * for `fas` so we'll easy the upgrade process for our users by automatically defining
     * this as well.
     */ if (prefix === "fas") defineIcons("fa", icons);
    }
    var styles = namespace.styles, shims = namespace.shims;
    var _byUnicode = {};
    var _byLigature = {};
    var _byOldName = {};
    var build = function build() {
        var lookup = function lookup(reducer) {
            return reduce(styles, function(o, style, prefix) {
                o[prefix] = reduce(style, reducer, {});
                return o;
            }, {});
        };
        _byUnicode = lookup(function(acc, icon, iconName) {
            if (icon[3]) acc[icon[3]] = iconName;
            return acc;
        });
        _byLigature = lookup(function(acc, icon, iconName) {
            var ligatures = icon[2];
            acc[iconName] = iconName;
            ligatures.forEach(function(ligature) {
                acc[ligature] = iconName;
            });
            return acc;
        });
        var hasRegular = "far" in styles;
        _byOldName = reduce(shims, function(acc, shim) {
            var oldName = shim[0];
            var prefix = shim[1];
            var iconName = shim[2];
            if (prefix === "far" && !hasRegular) prefix = "fas";
            acc[oldName] = {
                prefix: prefix,
                iconName: iconName
            };
            return acc;
        }, {});
    };
    build();
    function byUnicode(prefix, unicode) {
        return (_byUnicode[prefix] || {})[unicode];
    }
    function byLigature(prefix, ligature) {
        return (_byLigature[prefix] || {})[ligature];
    }
    function byOldName(name) {
        return _byOldName[name] || {
            prefix: null,
            iconName: null
        };
    }
    var styles$1 = namespace.styles;
    var emptyCanonicalIcon = function emptyCanonicalIcon() {
        return {
            prefix: null,
            iconName: null,
            rest: []
        };
    };
    function getCanonicalIcon(values) {
        return values.reduce(function(acc, cls) {
            var iconName = getIconName(config.familyPrefix, cls);
            if (styles$1[cls]) acc.prefix = cls;
            else if (config.autoFetchSvg && Object.keys(PREFIX_TO_STYLE).indexOf(cls) > -1) acc.prefix = cls;
            else if (iconName) {
                var shim = acc.prefix === "fa" ? byOldName(iconName) : {};
                acc.iconName = shim.iconName || iconName;
                acc.prefix = shim.prefix || acc.prefix;
            } else if (cls !== config.replacementClass && cls.indexOf("fa-w-") !== 0) acc.rest.push(cls);
            return acc;
        }, emptyCanonicalIcon());
    }
    function iconFromMapping(mapping, prefix, iconName) {
        if (mapping && mapping[prefix] && mapping[prefix][iconName]) return {
            prefix: prefix,
            iconName: iconName,
            icon: mapping[prefix][iconName]
        };
    }
    function toHtml(abstractNodes) {
        var tag = abstractNodes.tag, _abstractNodes$attrib = abstractNodes.attributes, attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib, _abstractNodes$childr = abstractNodes.children, children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;
        if (typeof abstractNodes === "string") return htmlEscape(abstractNodes);
        else return "<".concat(tag, " ").concat(joinAttributes(attributes), ">").concat(children.map(toHtml).join(""), "</").concat(tag, ">");
    }
    var noop$2 = function noop() {};
    function isWatched(node) {
        var i2svg = node.getAttribute ? node.getAttribute(DATA_FA_I2SVG) : null;
        return typeof i2svg === "string";
    }
    function getMutator() {
        if (config.autoReplaceSvg === true) return mutators.replace;
        var mutator = mutators[config.autoReplaceSvg];
        return mutator || mutators.replace;
    }
    var mutators = {
        replace: function replace(mutation) {
            var node = mutation[0];
            var abstract = mutation[1];
            var newOuterHTML = abstract.map(function(a) {
                return toHtml(a);
            }).join("\n");
            if (node.parentNode && node.outerHTML) node.outerHTML = newOuterHTML + (config.keepOriginalSource && node.tagName.toLowerCase() !== "svg" ? "<!-- ".concat(node.outerHTML, " Font Awesome fontawesome.com -->") : "");
            else if (node.parentNode) {
                var newNode = document.createElement("span");
                node.parentNode.replaceChild(newNode, node);
                newNode.outerHTML = newOuterHTML;
            }
        },
        nest: function nest(mutation) {
            var node = mutation[0];
            var abstract = mutation[1]; // If we already have a replaced node we do not want to continue nesting within it.
            // Short-circuit to the standard replacement
            if (~classArray(node).indexOf(config.replacementClass)) return mutators.replace(mutation);
            var forSvg = new RegExp("".concat(config.familyPrefix, "-.*"));
            delete abstract[0].attributes.style;
            delete abstract[0].attributes.id;
            var splitClasses = abstract[0].attributes.class.split(" ").reduce(function(acc, cls) {
                if (cls === config.replacementClass || cls.match(forSvg)) acc.toSvg.push(cls);
                else acc.toNode.push(cls);
                return acc;
            }, {
                toNode: [],
                toSvg: []
            });
            abstract[0].attributes.class = splitClasses.toSvg.join(" ");
            var newInnerHTML = abstract.map(function(a) {
                return toHtml(a);
            }).join("\n");
            node.setAttribute("class", splitClasses.toNode.join(" "));
            node.setAttribute(DATA_FA_I2SVG, "");
            node.innerHTML = newInnerHTML;
        }
    };
    function performOperationSync(op) {
        op();
    }
    function perform(mutations, callback) {
        var callbackFunction = typeof callback === "function" ? callback : noop$2;
        if (mutations.length === 0) callbackFunction();
        else {
            var frame = performOperationSync;
            if (config.mutateApproach === MUTATION_APPROACH_ASYNC) frame = WINDOW.requestAnimationFrame || performOperationSync;
            frame(function() {
                var mutator = getMutator();
                var mark = perf.begin("mutate");
                mutations.map(mutator);
                mark();
                callbackFunction();
            });
        }
    }
    var disabled = false;
    function disableObservation() {
        disabled = true;
    }
    function enableObservation() {
        disabled = false;
    }
    var mo = null;
    function observe(options) {
        if (!MUTATION_OBSERVER) return;
        if (!config.observeMutations) return;
        var treeCallback = options.treeCallback, nodeCallback = options.nodeCallback, pseudoElementsCallback = options.pseudoElementsCallback, _options$observeMutat = options.observeMutationsRoot, observeMutationsRoot = _options$observeMutat === void 0 ? DOCUMENT : _options$observeMutat;
        mo = new MUTATION_OBSERVER(function(objects) {
            if (disabled) return;
            toArray(objects).forEach(function(mutationRecord) {
                if (mutationRecord.type === "childList" && mutationRecord.addedNodes.length > 0 && !isWatched(mutationRecord.addedNodes[0])) {
                    if (config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target);
                    treeCallback(mutationRecord.target);
                }
                if (mutationRecord.type === "attributes" && mutationRecord.target.parentNode && config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target.parentNode);
                if (mutationRecord.type === "attributes" && isWatched(mutationRecord.target) && ~ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
                    if (mutationRecord.attributeName === "class") {
                        var _getCanonicalIcon = getCanonicalIcon(classArray(mutationRecord.target)), prefix = _getCanonicalIcon.prefix, iconName = _getCanonicalIcon.iconName;
                        if (prefix) mutationRecord.target.setAttribute("data-prefix", prefix);
                        if (iconName) mutationRecord.target.setAttribute("data-icon", iconName);
                    } else nodeCallback(mutationRecord.target);
                }
            });
        });
        if (!IS_DOM) return;
        mo.observe(observeMutationsRoot, {
            childList: true,
            attributes: true,
            characterData: true,
            subtree: true
        });
    }
    function disconnect() {
        if (!mo) return;
        mo.disconnect();
    }
    function styleParser(node) {
        var style = node.getAttribute("style");
        var val = [];
        if (style) val = style.split(";").reduce(function(acc, style) {
            var styles = style.split(":");
            var prop = styles[0];
            var value = styles.slice(1);
            if (prop && value.length > 0) acc[prop] = value.join(":").trim();
            return acc;
        }, {});
        return val;
    }
    function classParser(node) {
        var existingPrefix = node.getAttribute("data-prefix");
        var existingIconName = node.getAttribute("data-icon");
        var innerText = node.innerText !== undefined ? node.innerText.trim() : "";
        var val = getCanonicalIcon(classArray(node));
        if (existingPrefix && existingIconName) {
            val.prefix = existingPrefix;
            val.iconName = existingIconName;
        }
        if (val.prefix && innerText.length > 1) val.iconName = byLigature(val.prefix, node.innerText);
        else if (val.prefix && innerText.length === 1) val.iconName = byUnicode(val.prefix, toHex(node.innerText));
        return val;
    }
    var parseTransformString = function parseTransformString(transformString) {
        var transform = {
            size: 16,
            x: 0,
            y: 0,
            flipX: false,
            flipY: false,
            rotate: 0
        };
        if (!transformString) return transform;
        else return transformString.toLowerCase().split(" ").reduce(function(acc, n) {
            var parts = n.toLowerCase().split("-");
            var first = parts[0];
            var rest = parts.slice(1).join("-");
            if (first && rest === "h") {
                acc.flipX = true;
                return acc;
            }
            if (first && rest === "v") {
                acc.flipY = true;
                return acc;
            }
            rest = parseFloat(rest);
            if (isNaN(rest)) return acc;
            switch(first){
                case "grow":
                    acc.size = acc.size + rest;
                    break;
                case "shrink":
                    acc.size = acc.size - rest;
                    break;
                case "left":
                    acc.x = acc.x - rest;
                    break;
                case "right":
                    acc.x = acc.x + rest;
                    break;
                case "up":
                    acc.y = acc.y - rest;
                    break;
                case "down":
                    acc.y = acc.y + rest;
                    break;
                case "rotate":
                    acc.rotate = acc.rotate + rest;
                    break;
            }
            return acc;
        }, transform);
    };
    function transformParser(node) {
        return parseTransformString(node.getAttribute("data-fa-transform"));
    }
    function symbolParser(node) {
        var symbol = node.getAttribute("data-fa-symbol");
        return symbol === null ? false : symbol === "" ? true : symbol;
    }
    function attributesParser(node) {
        var extraAttributes = toArray(node.attributes).reduce(function(acc, attr) {
            if (acc.name !== "class" && acc.name !== "style") acc[attr.name] = attr.value;
            return acc;
        }, {});
        var title = node.getAttribute("title");
        var titleId = node.getAttribute("data-fa-title-id");
        if (config.autoA11y) {
            if (title) extraAttributes["aria-labelledby"] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
            else {
                extraAttributes["aria-hidden"] = "true";
                extraAttributes["focusable"] = "false";
            }
        }
        return extraAttributes;
    }
    function maskParser(node) {
        var mask = node.getAttribute("data-fa-mask");
        if (!mask) return emptyCanonicalIcon();
        else return getCanonicalIcon(mask.split(" ").map(function(i) {
            return i.trim();
        }));
    }
    function blankMeta() {
        return {
            iconName: null,
            title: null,
            titleId: null,
            prefix: null,
            transform: meaninglessTransform,
            symbol: false,
            mask: null,
            maskId: null,
            extra: {
                classes: [],
                styles: {},
                attributes: {}
            }
        };
    }
    function parseMeta(node) {
        var _classParser = classParser(node), iconName = _classParser.iconName, prefix = _classParser.prefix, extraClasses = _classParser.rest;
        var extraStyles = styleParser(node);
        var transform = transformParser(node);
        var symbol = symbolParser(node);
        var extraAttributes = attributesParser(node);
        var mask = maskParser(node);
        return {
            iconName: iconName,
            title: node.getAttribute("title"),
            titleId: node.getAttribute("data-fa-title-id"),
            prefix: prefix,
            transform: transform,
            symbol: symbol,
            mask: mask,
            maskId: node.getAttribute("data-fa-mask-id"),
            extra: {
                classes: extraClasses,
                styles: extraStyles,
                attributes: extraAttributes
            }
        };
    }
    function MissingIcon(error) {
        this.name = "MissingIcon";
        this.message = error || "Icon unavailable";
        this.stack = new Error().stack;
    }
    MissingIcon.prototype = Object.create(Error.prototype);
    MissingIcon.prototype.constructor = MissingIcon;
    var FILL = {
        fill: "currentColor"
    };
    var ANIMATION_BASE = {
        attributeType: "XML",
        repeatCount: "indefinite",
        dur: "2s"
    };
    var RING = {
        tag: "path",
        attributes: _objectSpread({}, FILL, {
            d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
        })
    };
    var OPACITY_ANIMATE = _objectSpread({}, ANIMATION_BASE, {
        attributeName: "opacity"
    });
    var DOT = {
        tag: "circle",
        attributes: _objectSpread({}, FILL, {
            cx: "256",
            cy: "364",
            r: "28"
        }),
        children: [
            {
                tag: "animate",
                attributes: _objectSpread({}, ANIMATION_BASE, {
                    attributeName: "r",
                    values: "28;14;28;28;14;28;"
                })
            },
            {
                tag: "animate",
                attributes: _objectSpread({}, OPACITY_ANIMATE, {
                    values: "1;0;1;1;0;1;"
                })
            }
        ]
    };
    var QUESTION = {
        tag: "path",
        attributes: _objectSpread({}, FILL, {
            opacity: "1",
            d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
        }),
        children: [
            {
                tag: "animate",
                attributes: _objectSpread({}, OPACITY_ANIMATE, {
                    values: "1;0;0;0;0;1;"
                })
            }
        ]
    };
    var EXCLAMATION = {
        tag: "path",
        attributes: _objectSpread({}, FILL, {
            opacity: "0",
            d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
        }),
        children: [
            {
                tag: "animate",
                attributes: _objectSpread({}, OPACITY_ANIMATE, {
                    values: "0;0;1;1;0;0;"
                })
            }
        ]
    };
    var missing = {
        tag: "g",
        children: [
            RING,
            DOT,
            QUESTION,
            EXCLAMATION
        ]
    };
    var styles$2 = namespace.styles;
    function asFoundIcon(icon) {
        var width = icon[0];
        var height = icon[1];
        var _icon$slice = icon.slice(4), _icon$slice2 = _slicedToArray(_icon$slice, 1), vectorData = _icon$slice2[0];
        var element = null;
        if (Array.isArray(vectorData)) element = {
            tag: "g",
            attributes: {
                class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.GROUP)
            },
            children: [
                {
                    tag: "path",
                    attributes: {
                        class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.SECONDARY),
                        fill: "currentColor",
                        d: vectorData[0]
                    }
                },
                {
                    tag: "path",
                    attributes: {
                        class: "".concat(config.familyPrefix, "-").concat(DUOTONE_CLASSES.PRIMARY),
                        fill: "currentColor",
                        d: vectorData[1]
                    }
                }
            ]
        };
        else element = {
            tag: "path",
            attributes: {
                fill: "currentColor",
                d: vectorData
            }
        };
        return {
            found: true,
            width: width,
            height: height,
            icon: element
        };
    }
    function findIcon(iconName, prefix) {
        return new picked(function(resolve, reject) {
            var val = {
                found: false,
                width: 512,
                height: 512,
                icon: missing
            };
            if (iconName && prefix && styles$2[prefix] && styles$2[prefix][iconName]) {
                var icon = styles$2[prefix][iconName];
                return resolve(asFoundIcon(icon));
            }
            if (iconName && prefix && !config.showMissingIcons) reject(new MissingIcon("Icon is missing for prefix ".concat(prefix, " with icon name ").concat(iconName)));
            else resolve(val);
        });
    }
    var styles$3 = namespace.styles;
    function generateSvgReplacementMutation(node, nodeMeta) {
        var iconName = nodeMeta.iconName, title = nodeMeta.title, titleId = nodeMeta.titleId, prefix = nodeMeta.prefix, transform = nodeMeta.transform, symbol = nodeMeta.symbol, mask = nodeMeta.mask, maskId = nodeMeta.maskId, extra = nodeMeta.extra;
        return new picked(function(resolve, reject) {
            picked.all([
                findIcon(iconName, prefix),
                findIcon(mask.iconName, mask.prefix)
            ]).then(function(_ref) {
                var _ref2 = _slicedToArray(_ref, 2), main = _ref2[0], mask = _ref2[1];
                resolve([
                    node,
                    makeInlineSvgAbstract({
                        icons: {
                            main: main,
                            mask: mask
                        },
                        prefix: prefix,
                        iconName: iconName,
                        transform: transform,
                        symbol: symbol,
                        mask: mask,
                        maskId: maskId,
                        title: title,
                        titleId: titleId,
                        extra: extra,
                        watchable: true
                    })
                ]);
            });
        });
    }
    function generateLayersText(node, nodeMeta) {
        var title = nodeMeta.title, transform = nodeMeta.transform, extra = nodeMeta.extra;
        var width = null;
        var height = null;
        if (IS_IE) {
            var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
            var boundingClientRect = node.getBoundingClientRect();
            width = boundingClientRect.width / computedFontSize;
            height = boundingClientRect.height / computedFontSize;
        }
        if (config.autoA11y && !title) extra.attributes["aria-hidden"] = "true";
        return picked.resolve([
            node,
            makeLayersTextAbstract({
                content: node.innerHTML,
                width: width,
                height: height,
                transform: transform,
                title: title,
                extra: extra,
                watchable: true
            })
        ]);
    }
    function generateMutation(node) {
        var nodeMeta = parseMeta(node);
        if (~nodeMeta.extra.classes.indexOf(LAYERS_TEXT_CLASSNAME)) return generateLayersText(node, nodeMeta);
        else return generateSvgReplacementMutation(node, nodeMeta);
    }
    function onTree(root) {
        var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        if (!IS_DOM) return;
        var htmlClassList = DOCUMENT.documentElement.classList;
        var hclAdd = function hclAdd(suffix) {
            return htmlClassList.add("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
        };
        var hclRemove = function hclRemove(suffix) {
            return htmlClassList.remove("".concat(HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
        };
        var prefixes = config.autoFetchSvg ? Object.keys(PREFIX_TO_STYLE) : Object.keys(styles$3);
        var prefixesDomQuery = [
            ".".concat(LAYERS_TEXT_CLASSNAME, ":not([").concat(DATA_FA_I2SVG, "])")
        ].concat(prefixes.map(function(p) {
            return ".".concat(p, ":not([").concat(DATA_FA_I2SVG, "])");
        })).join(", ");
        if (prefixesDomQuery.length === 0) return;
        var candidates = [];
        try {
            candidates = toArray(root.querySelectorAll(prefixesDomQuery));
        } catch (e) {}
        if (candidates.length > 0) {
            hclAdd("pending");
            hclRemove("complete");
        } else return;
        var mark = perf.begin("onTree");
        var mutations = candidates.reduce(function(acc, node) {
            try {
                var mutation = generateMutation(node);
                if (mutation) acc.push(mutation);
            } catch (e) {
                if (!PRODUCTION) {
                    if (e instanceof MissingIcon) console.error(e);
                }
            }
            return acc;
        }, []);
        return new picked(function(resolve, reject) {
            picked.all(mutations).then(function(resolvedMutations) {
                perform(resolvedMutations, function() {
                    hclAdd("active");
                    hclAdd("complete");
                    hclRemove("pending");
                    if (typeof callback === "function") callback();
                    mark();
                    resolve();
                });
            }).catch(function() {
                mark();
                reject();
            });
        });
    }
    function onNode(node) {
        var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        generateMutation(node).then(function(mutation) {
            if (mutation) perform([
                mutation
            ], callback);
        });
    }
    function replaceForPosition(node, position) {
        var pendingAttribute = "".concat(DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(":", "-"));
        return new picked(function(resolve, reject) {
            if (node.getAttribute(pendingAttribute) !== null) // This node is already being processed
            return resolve();
            var children = toArray(node.children);
            var alreadyProcessedPseudoElement = children.filter(function(c) {
                return c.getAttribute(DATA_FA_PSEUDO_ELEMENT) === position;
            })[0];
            var styles = WINDOW.getComputedStyle(node, position);
            var fontFamily = styles.getPropertyValue("font-family").match(FONT_FAMILY_PATTERN);
            var fontWeight = styles.getPropertyValue("font-weight");
            var content = styles.getPropertyValue("content");
            if (alreadyProcessedPseudoElement && !fontFamily) {
                // If we've already processed it but the current computed style does not result in a font-family,
                // that probably means that a class name that was previously present to make the icon has been
                // removed. So we now should delete the icon.
                node.removeChild(alreadyProcessedPseudoElement);
                return resolve();
            } else if (fontFamily && content !== "none" && content !== "") {
                var _content = styles.getPropertyValue("content");
                var prefix = ~[
                    "Solid",
                    "Regular",
                    "Light",
                    "Duotone",
                    "Brands",
                    "Kit"
                ].indexOf(fontFamily[2]) ? STYLE_TO_PREFIX[fontFamily[2].toLowerCase()] : FONT_WEIGHT_TO_PREFIX[fontWeight];
                var hexValue = toHex(_content.length === 3 ? _content.substr(1, 1) : _content);
                var iconName = byUnicode(prefix, hexValue);
                var iconIdentifier = iconName; // Only convert the pseudo element in this :before/:after position into an icon if we haven't
                // already done so with the same prefix and iconName
                if (iconName && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute(DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute(DATA_ICON) !== iconIdentifier)) {
                    node.setAttribute(pendingAttribute, iconIdentifier);
                    if (alreadyProcessedPseudoElement) // Delete the old one, since we're replacing it with a new one
                    node.removeChild(alreadyProcessedPseudoElement);
                    var meta = blankMeta();
                    var extra = meta.extra;
                    extra.attributes[DATA_FA_PSEUDO_ELEMENT] = position;
                    findIcon(iconName, prefix).then(function(main) {
                        var abstract = makeInlineSvgAbstract(_objectSpread({}, meta, {
                            icons: {
                                main: main,
                                mask: emptyCanonicalIcon()
                            },
                            prefix: prefix,
                            iconName: iconIdentifier,
                            extra: extra,
                            watchable: true
                        }));
                        var element = DOCUMENT.createElement("svg");
                        if (position === ":before") node.insertBefore(element, node.firstChild);
                        else node.appendChild(element);
                        element.outerHTML = abstract.map(function(a) {
                            return toHtml(a);
                        }).join("\n");
                        node.removeAttribute(pendingAttribute);
                        resolve();
                    }).catch(reject);
                } else resolve();
            } else resolve();
        });
    }
    function replace(node) {
        return picked.all([
            replaceForPosition(node, ":before"),
            replaceForPosition(node, ":after")
        ]);
    }
    function processable(node) {
        return node.parentNode !== document.head && !~TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute(DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== "svg");
    }
    function searchPseudoElements(root) {
        if (!IS_DOM) return;
        return new picked(function(resolve, reject) {
            var operations = toArray(root.querySelectorAll("*")).filter(processable).map(replace);
            var end = perf.begin("searchPseudoElements");
            disableObservation();
            picked.all(operations).then(function() {
                end();
                enableObservation();
                resolve();
            }).catch(function() {
                end();
                enableObservation();
                reject();
            });
        });
    }
    var baseStyles = "svg:not(:root).svg-inline--fa{overflow:visible}.svg-inline--fa{display:inline-block;font-size:inherit;height:1em;overflow:visible;vertical-align:-.125em}.svg-inline--fa.fa-lg{vertical-align:-.225em}.svg-inline--fa.fa-w-1{width:.0625em}.svg-inline--fa.fa-w-2{width:.125em}.svg-inline--fa.fa-w-3{width:.1875em}.svg-inline--fa.fa-w-4{width:.25em}.svg-inline--fa.fa-w-5{width:.3125em}.svg-inline--fa.fa-w-6{width:.375em}.svg-inline--fa.fa-w-7{width:.4375em}.svg-inline--fa.fa-w-8{width:.5em}.svg-inline--fa.fa-w-9{width:.5625em}.svg-inline--fa.fa-w-10{width:.625em}.svg-inline--fa.fa-w-11{width:.6875em}.svg-inline--fa.fa-w-12{width:.75em}.svg-inline--fa.fa-w-13{width:.8125em}.svg-inline--fa.fa-w-14{width:.875em}.svg-inline--fa.fa-w-15{width:.9375em}.svg-inline--fa.fa-w-16{width:1em}.svg-inline--fa.fa-w-17{width:1.0625em}.svg-inline--fa.fa-w-18{width:1.125em}.svg-inline--fa.fa-w-19{width:1.1875em}.svg-inline--fa.fa-w-20{width:1.25em}.svg-inline--fa.fa-pull-left{margin-right:.3em;width:auto}.svg-inline--fa.fa-pull-right{margin-left:.3em;width:auto}.svg-inline--fa.fa-border{height:1.5em}.svg-inline--fa.fa-li{width:2em}.svg-inline--fa.fa-fw{width:1.25em}.fa-layers svg.svg-inline--fa{bottom:0;left:0;margin:auto;position:absolute;right:0;top:0}.fa-layers{display:inline-block;height:1em;position:relative;text-align:center;vertical-align:-.125em;width:1em}.fa-layers svg.svg-inline--fa{-webkit-transform-origin:center center;transform-origin:center center}.fa-layers-counter,.fa-layers-text{display:inline-block;position:absolute;text-align:center}.fa-layers-text{left:50%;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);-webkit-transform-origin:center center;transform-origin:center center}.fa-layers-counter{background-color:#ff253a;border-radius:1em;-webkit-box-sizing:border-box;box-sizing:border-box;color:#fff;height:1.5em;line-height:1;max-width:5em;min-width:1.5em;overflow:hidden;padding:.25em;right:0;text-overflow:ellipsis;top:0;-webkit-transform:scale(.25);transform:scale(.25);-webkit-transform-origin:top right;transform-origin:top right}.fa-layers-bottom-right{bottom:0;right:0;top:auto;-webkit-transform:scale(.25);transform:scale(.25);-webkit-transform-origin:bottom right;transform-origin:bottom right}.fa-layers-bottom-left{bottom:0;left:0;right:auto;top:auto;-webkit-transform:scale(.25);transform:scale(.25);-webkit-transform-origin:bottom left;transform-origin:bottom left}.fa-layers-top-right{right:0;top:0;-webkit-transform:scale(.25);transform:scale(.25);-webkit-transform-origin:top right;transform-origin:top right}.fa-layers-top-left{left:0;right:auto;top:0;-webkit-transform:scale(.25);transform:scale(.25);-webkit-transform-origin:top left;transform-origin:top left}.fa-lg{font-size:1.3333333333em;line-height:.75em;vertical-align:-.0667em}.fa-xs{font-size:.75em}.fa-sm{font-size:.875em}.fa-1x{font-size:1em}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-6x{font-size:6em}.fa-7x{font-size:7em}.fa-8x{font-size:8em}.fa-9x{font-size:9em}.fa-10x{font-size:10em}.fa-fw{text-align:center;width:1.25em}.fa-ul{list-style-type:none;margin-left:2.5em;padding-left:0}.fa-ul>li{position:relative}.fa-li{left:-2em;position:absolute;text-align:center;width:2em;line-height:inherit}.fa-border{border:solid .08em #eee;border-radius:.1em;padding:.2em .25em .15em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left,.fab.fa-pull-left,.fal.fa-pull-left,.far.fa-pull-left,.fas.fa-pull-left{margin-right:.3em}.fa.fa-pull-right,.fab.fa-pull-right,.fal.fa-pull-right,.far.fa-pull-right,.fas.fa-pull-right{margin-left:.3em}.fa-spin{-webkit-animation:fa-spin 2s infinite linear;animation:fa-spin 2s infinite linear}.fa-pulse{-webkit-animation:fa-spin 1s infinite steps(8);animation:fa-spin 1s infinite steps(8)}@-webkit-keyframes fa-spin{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes fa-spin{0%{-webkit-transform:rotate(0);transform:rotate(0)}100%{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.fa-rotate-90{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.fa-rotate-180{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.fa-rotate-270{-webkit-transform:rotate(270deg);transform:rotate(270deg)}.fa-flip-horizontal{-webkit-transform:scale(-1,1);transform:scale(-1,1)}.fa-flip-vertical{-webkit-transform:scale(1,-1);transform:scale(1,-1)}.fa-flip-both,.fa-flip-horizontal.fa-flip-vertical{-webkit-transform:scale(-1,-1);transform:scale(-1,-1)}:root .fa-flip-both,:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-180,:root .fa-rotate-270,:root .fa-rotate-90{-webkit-filter:none;filter:none}.fa-stack{display:inline-block;height:2em;position:relative;width:2.5em}.fa-stack-1x,.fa-stack-2x{bottom:0;left:0;margin:auto;position:absolute;right:0;top:0}.svg-inline--fa.fa-stack-1x{height:1em;width:1.25em}.svg-inline--fa.fa-stack-2x{height:2em;width:2.5em}.fa-inverse{color:#fff}.sr-only{border:0;clip:rect(0,0,0,0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}.sr-only-focusable:active,.sr-only-focusable:focus{clip:auto;height:auto;margin:0;overflow:visible;position:static;width:auto}.svg-inline--fa .fa-primary{fill:var(--fa-primary-color,currentColor);opacity:1;opacity:var(--fa-primary-opacity,1)}.svg-inline--fa .fa-secondary{fill:var(--fa-secondary-color,currentColor);opacity:.4;opacity:var(--fa-secondary-opacity,.4)}.svg-inline--fa.fa-swap-opacity .fa-primary{opacity:.4;opacity:var(--fa-secondary-opacity,.4)}.svg-inline--fa.fa-swap-opacity .fa-secondary{opacity:1;opacity:var(--fa-primary-opacity,1)}.svg-inline--fa mask .fa-primary,.svg-inline--fa mask .fa-secondary{fill:#000}.fad.fa-inverse{color:#fff}";
    function css() {
        var dfp = DEFAULT_FAMILY_PREFIX;
        var drc = DEFAULT_REPLACEMENT_CLASS;
        var fp = config.familyPrefix;
        var rc = config.replacementClass;
        var s = baseStyles;
        if (fp !== dfp || rc !== drc) {
            var dPatt = new RegExp("\\.".concat(dfp, "\\-"), "g");
            var customPropPatt = new RegExp("\\--".concat(dfp, "\\-"), "g");
            var rPatt = new RegExp("\\.".concat(drc), "g");
            s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
        }
        return s;
    }
    var Library = /*#__PURE__*/ function() {
        function Library() {
            _classCallCheck(this, Library);
            this.definitions = {};
        }
        _createClass(Library, [
            {
                key: "add",
                value: function add() {
                    var _this = this;
                    for(var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++)definitions[_key] = arguments[_key];
                    var additions = definitions.reduce(this._pullDefinitions, {});
                    Object.keys(additions).forEach(function(key) {
                        _this.definitions[key] = _objectSpread({}, _this.definitions[key] || {}, additions[key]);
                        defineIcons(key, additions[key]);
                        build();
                    });
                }
            },
            {
                key: "reset",
                value: function reset() {
                    this.definitions = {};
                }
            },
            {
                key: "_pullDefinitions",
                value: function _pullDefinitions(additions, definition) {
                    var normalized = definition.prefix && definition.iconName && definition.icon ? {
                        0: definition
                    } : definition;
                    Object.keys(normalized).map(function(key) {
                        var _normalized$key = normalized[key], prefix = _normalized$key.prefix, iconName = _normalized$key.iconName, icon = _normalized$key.icon;
                        if (!additions[prefix]) additions[prefix] = {};
                        additions[prefix][iconName] = icon;
                    });
                    return additions;
                }
            }
        ]);
        return Library;
    }();
    function ensureCss() {
        if (config.autoAddCss && !_cssInserted) {
            insertCss(css());
            _cssInserted = true;
        }
    }
    function apiObject(val, abstractCreator) {
        Object.defineProperty(val, "abstract", {
            get: abstractCreator
        });
        Object.defineProperty(val, "html", {
            get: function get() {
                return val.abstract.map(function(a) {
                    return toHtml(a);
                });
            }
        });
        Object.defineProperty(val, "node", {
            get: function get() {
                if (!IS_DOM) return;
                var container = DOCUMENT.createElement("div");
                container.innerHTML = val.html;
                return container.children;
            }
        });
        return val;
    }
    function findIconDefinition(iconLookup) {
        var _iconLookup$prefix = iconLookup.prefix, prefix = _iconLookup$prefix === void 0 ? "fa" : _iconLookup$prefix, iconName = iconLookup.iconName;
        if (!iconName) return;
        return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
    }
    function resolveIcons(next) {
        return function(maybeIconDefinition) {
            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
            var mask = params.mask;
            if (mask) mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
            return next(iconDefinition, _objectSpread({}, params, {
                mask: mask
            }));
        };
    }
    var library = new Library();
    var noAuto = function noAuto() {
        config.autoReplaceSvg = false;
        config.observeMutations = false;
        disconnect();
    };
    var _cssInserted = false;
    var dom = {
        i2svg: function i2svg() {
            var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (IS_DOM) {
                ensureCss();
                var _params$node = params.node, node = _params$node === void 0 ? DOCUMENT : _params$node, _params$callback = params.callback, callback = _params$callback === void 0 ? function() {} : _params$callback;
                if (config.searchPseudoElements) searchPseudoElements(node);
                return onTree(node, callback);
            } else return picked.reject("Operation requires a DOM of some kind.");
        },
        css: css,
        insertCss: function insertCss$$1() {
            if (!_cssInserted) {
                insertCss(css());
                _cssInserted = true;
            }
        },
        watch: function watch() {
            var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var autoReplaceSvgRoot = params.autoReplaceSvgRoot, observeMutationsRoot = params.observeMutationsRoot;
            if (config.autoReplaceSvg === false) config.autoReplaceSvg = true;
            config.observeMutations = true;
            domready(function() {
                autoReplace({
                    autoReplaceSvgRoot: autoReplaceSvgRoot
                });
                observe({
                    treeCallback: onTree,
                    nodeCallback: onNode,
                    pseudoElementsCallback: searchPseudoElements,
                    observeMutationsRoot: observeMutationsRoot
                });
            });
        }
    };
    var parse = {
        transform: function transform(transformString) {
            return parseTransformString(transformString);
        }
    };
    var icon = resolveIcons(function(iconDefinition) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$transform = params.transform, transform = _params$transform === void 0 ? meaninglessTransform : _params$transform, _params$symbol = params.symbol, symbol = _params$symbol === void 0 ? false : _params$symbol, _params$mask = params.mask, mask = _params$mask === void 0 ? null : _params$mask, _params$maskId = params.maskId, maskId = _params$maskId === void 0 ? null : _params$maskId, _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$titleId = params.titleId, titleId = _params$titleId === void 0 ? null : _params$titleId, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
        if (!iconDefinition) return;
        var prefix = iconDefinition.prefix, iconName = iconDefinition.iconName, icon = iconDefinition.icon;
        return apiObject(_objectSpread({
            type: "icon"
        }, iconDefinition), function() {
            ensureCss();
            if (config.autoA11y) {
                if (title) attributes["aria-labelledby"] = "".concat(config.replacementClass, "-title-").concat(titleId || nextUniqueId());
                else {
                    attributes["aria-hidden"] = "true";
                    attributes["focusable"] = "false";
                }
            }
            return makeInlineSvgAbstract({
                icons: {
                    main: asFoundIcon(icon),
                    mask: mask ? asFoundIcon(mask.icon) : {
                        found: false,
                        width: null,
                        height: null,
                        icon: {}
                    }
                },
                prefix: prefix,
                iconName: iconName,
                transform: _objectSpread({}, meaninglessTransform, transform),
                symbol: symbol,
                title: title,
                maskId: maskId,
                titleId: titleId,
                extra: {
                    attributes: attributes,
                    styles: styles,
                    classes: classes
                }
            });
        });
    });
    var text = function text(content) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$transform2 = params.transform, transform = _params$transform2 === void 0 ? meaninglessTransform : _params$transform2, _params$title2 = params.title, title = _params$title2 === void 0 ? null : _params$title2, _params$classes2 = params.classes, classes = _params$classes2 === void 0 ? [] : _params$classes2, _params$attributes2 = params.attributes, attributes = _params$attributes2 === void 0 ? {} : _params$attributes2, _params$styles2 = params.styles, styles = _params$styles2 === void 0 ? {} : _params$styles2;
        return apiObject({
            type: "text",
            content: content
        }, function() {
            ensureCss();
            return makeLayersTextAbstract({
                content: content,
                transform: _objectSpread({}, meaninglessTransform, transform),
                title: title,
                extra: {
                    attributes: attributes,
                    styles: styles,
                    classes: [
                        "".concat(config.familyPrefix, "-layers-text")
                    ].concat(_toConsumableArray(classes))
                }
            });
        });
    };
    var counter = function counter(content) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$title3 = params.title, title = _params$title3 === void 0 ? null : _params$title3, _params$classes3 = params.classes, classes = _params$classes3 === void 0 ? [] : _params$classes3, _params$attributes3 = params.attributes, attributes = _params$attributes3 === void 0 ? {} : _params$attributes3, _params$styles3 = params.styles, styles = _params$styles3 === void 0 ? {} : _params$styles3;
        return apiObject({
            type: "counter",
            content: content
        }, function() {
            ensureCss();
            return makeLayersCounterAbstract({
                content: content.toString(),
                title: title,
                extra: {
                    attributes: attributes,
                    styles: styles,
                    classes: [
                        "".concat(config.familyPrefix, "-layers-counter")
                    ].concat(_toConsumableArray(classes))
                }
            });
        });
    };
    var layer = function layer(assembler) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var _params$classes4 = params.classes, classes = _params$classes4 === void 0 ? [] : _params$classes4;
        return apiObject({
            type: "layer"
        }, function() {
            ensureCss();
            var children = [];
            assembler(function(args) {
                Array.isArray(args) ? args.map(function(a) {
                    children = children.concat(a.abstract);
                }) : children = children.concat(args.abstract);
            });
            return [
                {
                    tag: "span",
                    attributes: {
                        class: [
                            "".concat(config.familyPrefix, "-layers")
                        ].concat(_toConsumableArray(classes)).join(" ")
                    },
                    children: children
                }
            ];
        });
    };
    var api = {
        noAuto: noAuto,
        config: config,
        dom: dom,
        library: library,
        parse: parse,
        findIconDefinition: findIconDefinition,
        icon: icon,
        text: text,
        counter: counter,
        layer: layer,
        toHtml: toHtml
    };
    var autoReplace = function autoReplace() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var _params$autoReplaceSv = params.autoReplaceSvgRoot, autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? DOCUMENT : _params$autoReplaceSv;
        if ((Object.keys(namespace.styles).length > 0 || config.autoFetchSvg) && IS_DOM && config.autoReplaceSvg) api.dom.i2svg({
            node: autoReplaceSvgRoot
        });
    };
    function bootstrap() {
        if (IS_BROWSER) {
            if (!WINDOW.FontAwesome) WINDOW.FontAwesome = api;
            domready(function() {
                autoReplace();
                observe({
                    treeCallback: onTree,
                    nodeCallback: onNode,
                    pseudoElementsCallback: searchPseudoElements
                });
            });
        }
        namespace.hooks = _objectSpread({}, namespace.hooks, {
            addPack: function addPack(prefix, icons) {
                namespace.styles[prefix] = _objectSpread({}, namespace.styles[prefix] || {}, icons);
                build();
                autoReplace();
            },
            addShims: function addShims(shims) {
                var _namespace$shims;
                (_namespace$shims = namespace.shims).push.apply(_namespace$shims, _toConsumableArray(shims));
                build();
                autoReplace();
            }
        });
    }
    bunker(bootstrap);
})();


/*!
 * Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */ (function() {
    "use strict";
    var _WINDOW = {};
    var _DOCUMENT = {};
    try {
        if (typeof window !== "undefined") _WINDOW = window;
        if (typeof document !== "undefined") _DOCUMENT = document;
    } catch (e) {}
    var _ref = _WINDOW.navigator || {}, _ref$userAgent = _ref.userAgent, userAgent = _ref$userAgent === void 0 ? "" : _ref$userAgent;
    var WINDOW = _WINDOW;
    var DOCUMENT = _DOCUMENT;
    var IS_BROWSER = !!WINDOW.document;
    var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === "function" && typeof DOCUMENT.createElement === "function";
    var IS_IE = ~userAgent.indexOf("MSIE") || ~userAgent.indexOf("Trident/");
    var NAMESPACE_IDENTIFIER = "___FONT_AWESOME___";
    var PRODUCTION = function() {
        try {
            return true;
        } catch (e) {
            return false;
        }
    }();
    function bunker(fn) {
        try {
            fn();
        } catch (e) {
            if (!PRODUCTION) throw e;
        }
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _objectSpread(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            var ownKeys = Object.keys(source);
            if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
            ownKeys.forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
        }
        return target;
    }
    var w = WINDOW || {};
    if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
    if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
    if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
    if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
    var namespace = w[NAMESPACE_IDENTIFIER];
    function defineIcons(prefix, icons) {
        var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var _params$skipHooks = params.skipHooks, skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
        var normalized = Object.keys(icons).reduce(function(acc, iconName) {
            var icon = icons[iconName];
            var expanded = !!icon.icon;
            if (expanded) acc[icon.iconName] = icon.icon;
            else acc[iconName] = icon;
            return acc;
        }, {});
        if (typeof namespace.hooks.addPack === "function" && !skipHooks) namespace.hooks.addPack(prefix, normalized);
        else namespace.styles[prefix] = _objectSpread({}, namespace.styles[prefix] || {}, normalized);
        /**
     * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
     * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
     * for `fas` so we'll easy the upgrade process for our users by automatically defining
     * this as well.
     */ if (prefix === "fas") defineIcons("fa", icons);
    }
    var icons = {
        "ad": [
            512,
            512,
            [],
            "f641",
            "M157.52 272h36.96L176 218.78 157.52 272zM352 256c-13.23 0-24 10.77-24 24s10.77 24 24 24 24-10.77 24-24-10.77-24-24-24zM464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM250.58 352h-16.94c-6.81 0-12.88-4.32-15.12-10.75L211.15 320h-70.29l-7.38 21.25A16 16 0 0 1 118.36 352h-16.94c-11.01 0-18.73-10.85-15.12-21.25L140 176.12A23.995 23.995 0 0 1 162.67 160h26.66A23.99 23.99 0 0 1 212 176.13l53.69 154.62c3.61 10.4-4.11 21.25-15.11 21.25zM424 336c0 8.84-7.16 16-16 16h-16c-4.85 0-9.04-2.27-11.98-5.68-8.62 3.66-18.09 5.68-28.02 5.68-39.7 0-72-32.3-72-72s32.3-72 72-72c8.46 0 16.46 1.73 24 4.42V176c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v160z"
        ],
        "address-book": [
            448,
            512,
            [],
            "f2b9",
            "M436 160c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20zm-228-32c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H118.4C106 384 96 375.4 96 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
        ],
        "address-card": [
            576,
            512,
            [],
            "f2bb",
            "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-352 96c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H86.4C74 384 64 375.4 64 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2zM512 312c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-64c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"
        ],
        "adjust": [
            512,
            512,
            [],
            "f042",
            "M8 256c0 136.966 111.033 248 248 248s248-111.034 248-248S392.966 8 256 8 8 119.033 8 256zm248 184V72c101.705 0 184 82.311 184 184 0 101.705-82.311 184-184 184z"
        ],
        "air-freshener": [
            512,
            512,
            [],
            "f5d0",
            "M224 160H96C43 160 0 203 0 256V480C0 497.625 14.375 512 32 512H288C305.625 512 320 497.625 320 480V256C320 203 277 160 224 160ZM160 416C115.875 416 80 380.125 80 336S115.875 256 160 256S240 291.875 240 336S204.125 416 160 416ZM224 32C224 14.375 209.625 0 192 0H128C110.375 0 96 14.375 96 32V128H224V32ZM381.781 51.578C383 50.969 384 49.359 384 48C384 46.625 383 45.031 381.781 44.422L352 32L339.562 2.219C338.969 1 337.375 0 336 0S333.031 1 332.406 2.219L320 32L290.219 44.422C289 45.031 288 46.625 288 48C288 49.359 289 50.969 290.219 51.578L320 64L332.406 93.781C333.031 95 334.625 96 336 96S338.969 95 339.562 93.781L352 64L381.781 51.578ZM448 64L460.406 93.781C461.031 95 462.625 96 464 96S466.969 95 467.562 93.781L480 64L509.781 51.578C511 50.969 512 49.359 512 48C512 46.625 511 45.031 509.781 44.422L480 32L467.562 2.219C466.969 1 465.375 0 464 0S461.031 1 460.406 2.219L448 32L418.219 44.422C417 45.031 416 46.625 416 48C416 49.359 417 50.969 418.219 51.578L448 64ZM480 224L467.562 194.219C466.969 193 465.375 192 464 192S461.031 193 460.406 194.219L448 224L418.219 236.422C417 237.031 416 238.625 416 240C416 241.359 417 242.969 418.219 243.578L448 256L460.406 285.781C461.031 287 462.625 288 464 288S466.969 287 467.562 285.781L480 256L509.781 243.578C511 242.969 512 241.359 512 240C512 238.625 511 237.031 509.781 236.422L480 224ZM445.781 147.578C447 146.969 448 145.359 448 144C448 142.625 447 141.031 445.781 140.422L416 128L403.562 98.219C402.969 97 401.375 96 400 96S397.031 97 396.406 98.219L384 128L354.219 140.422C353 141.031 352 142.625 352 144C352 145.359 353 146.969 354.219 147.578L384 160L396.406 189.781C397.031 191 398.625 192 400 192S402.969 191 403.562 189.781L416 160L445.781 147.578Z"
        ],
        "align-center": [
            448,
            512,
            [],
            "f037",
            "M432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM108.1 96h231.81A12.09 12.09 0 0 0 352 83.9V44.09A12.09 12.09 0 0 0 339.91 32H108.1A12.09 12.09 0 0 0 96 44.09V83.9A12.1 12.1 0 0 0 108.1 96zm231.81 256A12.09 12.09 0 0 0 352 339.9v-39.81A12.09 12.09 0 0 0 339.91 288H108.1A12.09 12.09 0 0 0 96 300.09v39.81a12.1 12.1 0 0 0 12.1 12.1z"
        ],
        "align-justify": [
            448,
            512,
            [],
            "f039",
            "M432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-128H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
        ],
        "align-left": [
            448,
            512,
            [],
            "f036",
            "M12.83 352h262.34A12.82 12.82 0 0 0 288 339.17v-38.34A12.82 12.82 0 0 0 275.17 288H12.83A12.82 12.82 0 0 0 0 300.83v38.34A12.82 12.82 0 0 0 12.83 352zm0-256h262.34A12.82 12.82 0 0 0 288 83.17V44.83A12.82 12.82 0 0 0 275.17 32H12.83A12.82 12.82 0 0 0 0 44.83v38.34A12.82 12.82 0 0 0 12.83 96zM432 160H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 256H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
        ],
        "align-right": [
            448,
            512,
            [],
            "f038",
            "M16 224h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm416 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-384H172.83A12.82 12.82 0 0 0 160 44.83v38.34A12.82 12.82 0 0 0 172.83 96h262.34A12.82 12.82 0 0 0 448 83.17V44.83A12.82 12.82 0 0 0 435.17 32zm0 256H172.83A12.82 12.82 0 0 0 160 300.83v38.34A12.82 12.82 0 0 0 172.83 352h262.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288z"
        ],
        "allergies": [
            448,
            512,
            [],
            "f461",
            "M416 112c-17.6 0-32 14.4-32 32v72c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32s-32 14.4-32 32v152c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V32c0-17.6-14.4-32-32-32s-32 14.4-32 32v184c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V64c0-17.6-14.4-32-32-32S96 46.4 96 64v241l-23.6-32.5c-13-17.9-38-21.8-55.9-8.8s-21.8 38-8.8 55.9l125.6 172.7c9 12.4 23.5 19.8 38.8 19.8h197.6c22.3 0 41.6-15.3 46.7-37l26.5-112.7c3.2-13.7 4.9-28.3 5.1-42.3V144c0-17.6-14.4-32-32-32zM176 416c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm64 32c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32-128c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
        ],
        "ambulance": [
            640,
            512,
            [],
            "f0f9",
            "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm144-248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm176 248c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
        ],
        "american-sign-language-interpreting": [
            640,
            512,
            [],
            "f2a3",
            "M290.547 189.039c-20.295-10.149-44.147-11.199-64.739-3.89 42.606 0 71.208 20.475 85.578 50.576 8.576 17.899-5.148 38.071-23.617 38.071 18.429 0 32.211 20.136 23.617 38.071-14.725 30.846-46.123 50.854-80.298 50.854-.557 0-94.471-8.615-94.471-8.615l-66.406 33.347c-9.384 4.693-19.815.379-23.895-7.781L1.86 290.747c-4.167-8.615-1.111-18.897 6.946-23.621l58.072-33.069L108 159.861c6.39-57.245 34.731-109.767 79.743-146.726 11.391-9.448 28.341-7.781 37.51 3.613 9.446 11.394 7.78 28.067-3.612 37.516-12.503 10.559-23.618 22.509-32.509 35.57 21.672-14.729 46.679-24.732 74.186-28.067 14.725-1.945 28.063 8.336 29.73 23.065 1.945 14.728-8.336 28.067-23.062 29.734-16.116 1.945-31.12 7.503-44.178 15.284 26.114-5.713 58.712-3.138 88.079 11.115 13.336 6.669 18.893 22.509 12.224 35.848-6.389 13.06-22.504 18.617-35.564 12.226zm-27.229 69.472c-6.112-12.505-18.338-20.286-32.231-20.286a35.46 35.46 0 0 0-35.565 35.57c0 21.428 17.808 35.57 35.565 35.57 13.893 0 26.119-7.781 32.231-20.286 4.446-9.449 13.614-15.006 23.339-15.284-9.725-.277-18.893-5.835-23.339-15.284zm374.821-37.237c4.168 8.615 1.111 18.897-6.946 23.621l-58.071 33.069L532 352.16c-6.39 57.245-34.731 109.767-79.743 146.726-10.932 9.112-27.799 8.144-37.51-3.613-9.446-11.394-7.78-28.067 3.613-37.516 12.503-10.559 23.617-22.509 32.508-35.57-21.672 14.729-46.679 24.732-74.186 28.067-10.021 2.506-27.552-5.643-29.73-23.065-1.945-14.728 8.336-28.067 23.062-29.734 16.116-1.946 31.12-7.503 44.178-15.284-26.114 5.713-58.712 3.138-88.079-11.115-13.336-6.669-18.893-22.509-12.224-35.848 6.389-13.061 22.505-18.619 35.565-12.227 20.295 10.149 44.147 11.199 64.739 3.89-42.606 0-71.208-20.475-85.578-50.576-8.576-17.899 5.148-38.071 23.617-38.071-18.429 0-32.211-20.136-23.617-38.071 14.033-29.396 44.039-50.887 81.966-50.854l92.803 8.615 66.406-33.347c9.408-4.704 19.828-.354 23.894 7.781l44.455 88.926zm-229.227-18.618c-13.893 0-26.119 7.781-32.231 20.286-4.446 9.449-13.614 15.006-23.339 15.284 9.725.278 18.893 5.836 23.339 15.284 6.112 12.505 18.338 20.286 32.231 20.286a35.46 35.46 0 0 0 35.565-35.57c0-21.429-17.808-35.57-35.565-35.57z"
        ],
        "anchor": [
            576,
            512,
            [],
            "f13d",
            "M12.971 352h32.394C67.172 454.735 181.944 512 288 512c106.229 0 220.853-57.38 242.635-160h32.394c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0l-67.029 67.029c-7.56 7.56-2.206 20.485 8.485 20.485h35.146c-20.29 54.317-84.963 86.588-144.117 94.015V256h52c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-52v-5.47c37.281-13.178 63.995-48.725 64-90.518C384.005 43.772 341.605.738 289.37.01 235.723-.739 192 42.525 192 96c0 41.798 26.716 77.35 64 90.53V192h-52c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v190.015c-58.936-7.399-123.82-39.679-144.117-94.015h35.146c10.691 0 16.045-12.926 8.485-20.485l-67.029-67.029c-4.686-4.686-12.284-4.686-16.971 0L4.485 331.515C-3.074 339.074 2.28 352 12.971 352zM288 64c17.645 0 32 14.355 32 32s-14.355 32-32 32-32-14.355-32-32 14.355-32 32-32z"
        ],
        "angle-double-down": [
            320,
            512,
            [],
            "f103",
            "M143 256.3L7 120.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0L313 86.3c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.4 9.5-24.6 9.5-34 .1zm34 192l136-136c9.4-9.4 9.4-24.6 0-33.9l-22.6-22.6c-9.4-9.4-24.6-9.4-33.9 0L160 352.1l-96.4-96.4c-9.4-9.4-24.6-9.4-33.9 0L7 278.3c-9.4 9.4-9.4 24.6 0 33.9l136 136c9.4 9.5 24.6 9.5 34 .1z"
        ],
        "angle-double-left": [
            448,
            512,
            [],
            "f100",
            "M223.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L319.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L393.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34zm-192 34l136 136c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9L127.9 256l96.4-96.4c9.4-9.4 9.4-24.6 0-33.9L201.7 103c-9.4-9.4-24.6-9.4-33.9 0l-136 136c-9.5 9.4-9.5 24.6-.1 34z"
        ],
        "angle-double-right": [
            448,
            512,
            [],
            "f101",
            "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34zm192-34l-136-136c-9.4-9.4-24.6-9.4-33.9 0l-22.6 22.6c-9.4 9.4-9.4 24.6 0 33.9l96.4 96.4-96.4 96.4c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l136-136c9.4-9.2 9.4-24.4 0-33.8z"
        ],
        "angle-double-up": [
            320,
            512,
            [],
            "f102",
            "M177 255.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 351.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 425.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1zm-34-192L7 199.7c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l96.4-96.4 96.4 96.4c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9l-136-136c-9.2-9.4-24.4-9.4-33.8 0z"
        ],
        "angle-down": [
            320,
            512,
            [],
            "f107",
            "M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z"
        ],
        "angle-left": [
            256,
            512,
            [],
            "f104",
            "M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"
        ],
        "angle-right": [
            256,
            512,
            [],
            "f105",
            "M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z"
        ],
        "angle-up": [
            320,
            512,
            [],
            "f106",
            "M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z"
        ],
        "angry": [
            496,
            512,
            [],
            "f556",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 240c0-9.3 4.1-17.5 10.5-23.4l-31-9.3c-8.5-2.5-13.3-11.5-10.7-19.9 2.5-8.5 11.4-13.2 19.9-10.7l80 24c8.5 2.5 13.3 11.5 10.7 19.9-2.1 6.9-8.4 11.4-15.3 11.4-.5 0-1.1-.2-1.7-.2.7 2.7 1.7 5.3 1.7 8.2 0 17.7-14.3 32-32 32S136 257.7 136 240zm168 154.2c-27.8-33.4-84.2-33.4-112.1 0-13.5 16.3-38.2-4.2-24.6-20.5 20-24 49.4-37.8 80.6-37.8s60.6 13.8 80.6 37.8c13.8 16.5-11.1 36.6-24.5 20.5zm76.6-186.9l-31 9.3c6.3 5.8 10.5 14.1 10.5 23.4 0 17.7-14.3 32-32 32s-32-14.3-32-32c0-2.9.9-5.6 1.7-8.2-.6.1-1.1.2-1.7.2-6.9 0-13.2-4.5-15.3-11.4-2.5-8.5 2.3-17.4 10.7-19.9l80-24c8.4-2.5 17.4 2.3 19.9 10.7 2.5 8.5-2.3 17.4-10.8 19.9z"
        ],
        "ankh": [
            320,
            512,
            [],
            "f644",
            "M296 256h-44.62C272.46 222.01 288 181.65 288 144 288 55.63 230.69 0 160 0S32 55.63 32 144c0 37.65 15.54 78.01 36.62 112H24c-13.25 0-24 10.74-24 24v32c0 13.25 10.75 24 24 24h96v152c0 13.25 10.75 24 24 24h32c13.25 0 24-10.75 24-24V336h96c13.25 0 24-10.75 24-24v-32c0-13.26-10.75-24-24-24zM160 80c29.61 0 48 24.52 48 64 0 34.66-27.14 78.14-48 100.87-20.86-22.72-48-66.21-48-100.87 0-39.48 18.39-64 48-64z"
        ],
        "apple-alt": [
            448,
            512,
            [],
            "f5d1",
            "M350.85 129c25.97 4.67 47.27 18.67 63.92 42 14.65 20.67 24.64 46.67 29.96 78 4.67 28.67 4.32 57.33-1 86-7.99 47.33-23.97 87-47.94 119-28.64 38.67-64.59 58-107.87 58-10.66 0-22.3-3.33-34.96-10-8.66-5.33-18.31-8-28.97-8s-20.3 2.67-28.97 8c-12.66 6.67-24.3 10-34.96 10-43.28 0-79.23-19.33-107.87-58-23.97-32-39.95-71.67-47.94-119-5.32-28.67-5.67-57.33-1-86 5.32-31.33 15.31-57.33 29.96-78 16.65-23.33 37.95-37.33 63.92-42 15.98-2.67 37.95-.33 65.92 7 23.97 6.67 44.28 14.67 60.93 24 16.65-9.33 36.96-17.33 60.93-24 27.98-7.33 49.96-9.67 65.94-7zm-54.94-41c-9.32 8.67-21.65 15-36.96 19-10.66 3.33-22.3 5-34.96 5l-14.98-1c-1.33-9.33-1.33-20 0-32 2.67-24 10.32-42.33 22.97-55 9.32-8.67 21.65-15 36.96-19 10.66-3.33 22.3-5 34.96-5l14.98 1 1 15c0 12.67-1.67 24.33-4.99 35-3.99 15.33-10.31 27.67-18.98 37z"
        ],
        "archive": [
            512,
            512,
            [],
            "f187",
            "M32 448c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V160H32v288zm160-212c0-6.6 5.4-12 12-12h104c6.6 0 12 5.4 12 12v8c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-8zM480 32H32C14.3 32 0 46.3 0 64v48c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16V64c0-17.7-14.3-32-32-32z"
        ],
        "archway": [
            576,
            512,
            [],
            "f557",
            "M560 448h-16V96H32v352H16.02c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16H176c8.84 0 16-7.16 16-16V320c0-53.02 42.98-96 96-96s96 42.98 96 96l.02 160v16c0 8.84 7.16 16 16 16H560c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm0-448H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h544c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"
        ],
        "arrow-alt-circle-down": [
            512,
            512,
            [],
            "f358",
            "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM212 140v116h-70.9c-10.7 0-16.1 13-8.5 20.5l114.9 114.3c4.7 4.7 12.2 4.7 16.9 0l114.9-114.3c7.6-7.6 2.2-20.5-8.5-20.5H300V140c0-6.6-5.4-12-12-12h-64c-6.6 0-12 5.4-12 12z"
        ],
        "arrow-alt-circle-left": [
            512,
            512,
            [],
            "f359",
            "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm116-292H256v-70.9c0-10.7-13-16.1-20.5-8.5L121.2 247.5c-4.7 4.7-4.7 12.2 0 16.9l114.3 114.9c7.6 7.6 20.5 2.2 20.5-8.5V300h116c6.6 0 12-5.4 12-12v-64c0-6.6-5.4-12-12-12z"
        ],
        "arrow-alt-circle-right": [
            512,
            512,
            [],
            "f35a",
            "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zM140 300h116v70.9c0 10.7 13 16.1 20.5 8.5l114.3-114.9c4.7-4.7 4.7-12.2 0-16.9l-114.3-115c-7.6-7.6-20.5-2.2-20.5 8.5V212H140c-6.6 0-12 5.4-12 12v64c0 6.6 5.4 12 12 12z"
        ],
        "arrow-alt-circle-up": [
            512,
            512,
            [],
            "f35b",
            "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm292 116V256h70.9c10.7 0 16.1-13 8.5-20.5L264.5 121.2c-4.7-4.7-12.2-4.7-16.9 0l-115 114.3c-7.6 7.6-2.2 20.5 8.5 20.5H212v116c0 6.6 5.4 12 12 12h64c6.6 0 12-5.4 12-12z"
        ],
        "arrow-circle-down": [
            512,
            512,
            [],
            "f0ab",
            "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-143.6-28.9L288 302.6V120c0-13.3-10.7-24-24-24h-16c-13.3 0-24 10.7-24 24v182.6l-72.4-75.5c-9.3-9.7-24.8-9.9-34.3-.4l-10.9 11c-9.4 9.4-9.4 24.6 0 33.9L239 404.3c9.4 9.4 24.6 9.4 33.9 0l132.7-132.7c9.4-9.4 9.4-24.6 0-33.9l-10.9-11c-9.5-9.5-25-9.3-34.3.4z"
        ],
        "arrow-circle-left": [
            512,
            512,
            [],
            "f0a8",
            "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zm28.9-143.6L209.4 288H392c13.3 0 24-10.7 24-24v-16c0-13.3-10.7-24-24-24H209.4l75.5-72.4c9.7-9.3 9.9-24.8.4-34.3l-11-10.9c-9.4-9.4-24.6-9.4-33.9 0L107.7 239c-9.4 9.4-9.4 24.6 0 33.9l132.7 132.7c9.4 9.4 24.6 9.4 33.9 0l11-10.9c9.5-9.5 9.3-25-.4-34.3z"
        ],
        "arrow-circle-right": [
            512,
            512,
            [],
            "f0a9",
            "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm-28.9 143.6l75.5 72.4H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h182.6l-75.5 72.4c-9.7 9.3-9.9 24.8-.4 34.3l11 10.9c9.4 9.4 24.6 9.4 33.9 0L404.3 273c9.4-9.4 9.4-24.6 0-33.9L271.6 106.3c-9.4-9.4-24.6-9.4-33.9 0l-11 10.9c-9.5 9.6-9.3 25.1.4 34.4z"
        ],
        "arrow-circle-up": [
            512,
            512,
            [],
            "f0aa",
            "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm143.6 28.9l72.4-75.5V392c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24V209.4l72.4 75.5c9.3 9.7 24.8 9.9 34.3.4l10.9-11c9.4-9.4 9.4-24.6 0-33.9L273 107.7c-9.4-9.4-24.6-9.4-33.9 0L106.3 240.4c-9.4 9.4-9.4 24.6 0 33.9l10.9 11c9.6 9.5 25.1 9.3 34.4-.4z"
        ],
        "arrow-down": [
            448,
            512,
            [],
            "f063",
            "M413.1 222.5l22.2 22.2c9.4 9.4 9.4 24.6 0 33.9L241 473c-9.4 9.4-24.6 9.4-33.9 0L12.7 278.6c-9.4-9.4-9.4-24.6 0-33.9l22.2-22.2c9.5-9.5 25-9.3 34.3.4L184 343.4V56c0-13.3 10.7-24 24-24h32c13.3 0 24 10.7 24 24v287.4l114.8-120.5c9.3-9.8 24.8-10 34.3-.4z"
        ],
        "arrow-left": [
            448,
            512,
            [],
            "f060",
            "M257.5 445.1l-22.2 22.2c-9.4 9.4-24.6 9.4-33.9 0L7 273c-9.4-9.4-9.4-24.6 0-33.9L201.4 44.7c9.4-9.4 24.6-9.4 33.9 0l22.2 22.2c9.5 9.5 9.3 25-.4 34.3L136.6 216H424c13.3 0 24 10.7 24 24v32c0 13.3-10.7 24-24 24H136.6l120.5 114.8c9.8 9.3 10 24.8.4 34.3z"
        ],
        "arrow-right": [
            448,
            512,
            [],
            "f061",
            "M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z"
        ],
        "arrow-up": [
            448,
            512,
            [],
            "f062",
            "M34.9 289.5l-22.2-22.2c-9.4-9.4-9.4-24.6 0-33.9L207 39c9.4-9.4 24.6-9.4 33.9 0l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9L413 289.4c-9.5 9.5-25 9.3-34.3-.4L264 168.6V456c0 13.3-10.7 24-24 24h-32c-13.3 0-24-10.7-24-24V168.6L69.2 289.1c-9.3 9.8-24.8 10-34.3.4z"
        ],
        "arrows-alt": [
            512,
            512,
            [],
            "f0b2",
            "M352.201 425.775l-79.196 79.196c-9.373 9.373-24.568 9.373-33.941 0l-79.196-79.196c-15.119-15.119-4.411-40.971 16.971-40.97h51.162L228 284H127.196v51.162c0 21.382-25.851 32.09-40.971 16.971L7.029 272.937c-9.373-9.373-9.373-24.569 0-33.941L86.225 159.8c15.119-15.119 40.971-4.411 40.971 16.971V228H228V127.196h-51.23c-21.382 0-32.09-25.851-16.971-40.971l79.196-79.196c9.373-9.373 24.568-9.373 33.941 0l79.196 79.196c15.119 15.119 4.411 40.971-16.971 40.971h-51.162V228h100.804v-51.162c0-21.382 25.851-32.09 40.97-16.971l79.196 79.196c9.373 9.373 9.373 24.569 0 33.941L425.773 352.2c-15.119 15.119-40.971 4.411-40.97-16.971V284H284v100.804h51.23c21.382 0 32.09 25.851 16.971 40.971z"
        ],
        "arrows-alt-h": [
            512,
            512,
            [],
            "f337",
            "M377.941 169.941V216H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.568 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296h243.882v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.568 0-33.941l-86.059-86.059c-15.119-15.12-40.971-4.412-40.971 16.97z"
        ],
        "arrows-alt-v": [
            256,
            512,
            [],
            "f338",
            "M214.059 377.941H168V134.059h46.059c21.382 0 32.09-25.851 16.971-40.971L144.971 7.029c-9.373-9.373-24.568-9.373-33.941 0L24.971 93.088c-15.119 15.119-4.411 40.971 16.971 40.971H88v243.882H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.568 9.373 33.941 0l86.059-86.059c15.12-15.119 4.412-40.971-16.97-40.971z"
        ],
        "assistive-listening-systems": [
            512,
            512,
            [],
            "f2a2",
            "M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm-80 236c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zM32 448c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm480-187.993c0-1.518-.012-3.025-.045-4.531C510.076 140.525 436.157 38.47 327.994 1.511c-14.633-4.998-30.549 2.809-35.55 17.442-5 14.633 2.81 30.549 17.442 35.55 85.906 29.354 144.61 110.513 146.077 201.953l.003.188c.026 1.118.033 2.236.033 3.363 0 15.464 12.536 28 28 28s28.001-12.536 28.001-28zM152.971 439.029l-80-80L39.03 392.97l80 80 33.941-33.941z"
        ],
        "asterisk": [
            512,
            512,
            [],
            "f069",
            "M478.21 334.093L336 256l142.21-78.093c11.795-6.477 15.961-21.384 9.232-33.037l-19.48-33.741c-6.728-11.653-21.72-15.499-33.227-8.523L296 186.718l3.475-162.204C299.763 11.061 288.937 0 275.48 0h-38.96c-13.456 0-24.283 11.061-23.994 24.514L216 186.718 77.265 102.607c-11.506-6.976-26.499-3.13-33.227 8.523l-19.48 33.741c-6.728 11.653-2.562 26.56 9.233 33.037L176 256 33.79 334.093c-11.795 6.477-15.961 21.384-9.232 33.037l19.48 33.741c6.728 11.653 21.721 15.499 33.227 8.523L216 325.282l-3.475 162.204C212.237 500.939 223.064 512 236.52 512h38.961c13.456 0 24.283-11.061 23.995-24.514L296 325.282l138.735 84.111c11.506 6.976 26.499 3.13 33.227-8.523l19.48-33.741c6.728-11.653 2.563-26.559-9.232-33.036z"
        ],
        "at": [
            512,
            512,
            [],
            "f1fa",
            "M256 8C118.941 8 8 118.919 8 256c0 137.059 110.919 248 248 248 48.154 0 95.342-14.14 135.408-40.223 12.005-7.815 14.625-24.288 5.552-35.372l-10.177-12.433c-7.671-9.371-21.179-11.667-31.373-5.129C325.92 429.757 291.314 440 256 440c-101.458 0-184-82.542-184-184S154.542 72 256 72c100.139 0 184 57.619 184 160 0 38.786-21.093 79.742-58.17 83.693-17.349-.454-16.91-12.857-13.476-30.024l23.433-121.11C394.653 149.75 383.308 136 368.225 136h-44.981a13.518 13.518 0 0 0-13.432 11.993l-.01.092c-14.697-17.901-40.448-21.775-59.971-21.775-74.58 0-137.831 62.234-137.831 151.46 0 65.303 36.785 105.87 96 105.87 26.984 0 57.369-15.637 74.991-38.333 9.522 34.104 40.613 34.103 70.71 34.103C462.609 379.41 504 307.798 504 232 504 95.653 394.023 8 256 8zm-21.68 304.43c-22.249 0-36.07-15.623-36.07-40.771 0-44.993 30.779-72.729 58.63-72.729 22.292 0 35.601 15.241 35.601 40.77 0 45.061-33.875 72.73-58.161 72.73z"
        ],
        "atlas": [
            448,
            512,
            [],
            "f558",
            "M318.38 208h-39.09c-1.49 27.03-6.54 51.35-14.21 70.41 27.71-13.24 48.02-39.19 53.3-70.41zm0-32c-5.29-31.22-25.59-57.17-53.3-70.41 7.68 19.06 12.72 43.38 14.21 70.41h39.09zM224 97.31c-7.69 7.45-20.77 34.42-23.43 78.69h46.87c-2.67-44.26-15.75-71.24-23.44-78.69zm-41.08 8.28c-27.71 13.24-48.02 39.19-53.3 70.41h39.09c1.49-27.03 6.53-51.35 14.21-70.41zm0 172.82c-7.68-19.06-12.72-43.38-14.21-70.41h-39.09c5.28 31.22 25.59 57.17 53.3 70.41zM247.43 208h-46.87c2.66 44.26 15.74 71.24 23.43 78.69 7.7-7.45 20.78-34.43 23.44-78.69zM448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM224 64c70.69 0 128 57.31 128 128s-57.31 128-128 128S96 262.69 96 192 153.31 64 224 64zm160 384H96c-19.2 0-32-12.8-32-32s16-32 32-32h288v64z"
        ],
        "atom": [
            448,
            512,
            [],
            "f5d2",
            "M223.99908,224a32,32,0,1,0,32.00782,32A32.06431,32.06431,0,0,0,223.99908,224Zm214.172-96c-10.877-19.5-40.50979-50.75-116.27544-41.875C300.39168,34.875,267.63386,0,223.99908,0s-76.39066,34.875-97.89653,86.125C50.3369,77.375,20.706,108.5,9.82907,128-6.54984,157.375-5.17484,201.125,34.958,256-5.17484,310.875-6.54984,354.625,9.82907,384c29.13087,52.375,101.64652,43.625,116.27348,41.875C147.60842,477.125,180.36429,512,223.99908,512s76.3926-34.875,97.89652-86.125c14.62891,1.75,87.14456,10.5,116.27544-41.875C454.55,354.625,453.175,310.875,413.04017,256,453.175,201.125,454.55,157.375,438.171,128ZM63.33886,352c-4-7.25-.125-24.75,15.00391-48.25,6.87695,6.5,14.12891,12.875,21.88087,19.125,1.625,13.75,4,27.125,6.75,40.125C82.34472,363.875,67.09081,358.625,63.33886,352Zm36.88478-162.875c-7.752,6.25-15.00392,12.625-21.88087,19.125-15.12891-23.5-19.00392-41-15.00391-48.25,3.377-6.125,16.37891-11.5,37.88478-11.5,1.75,0,3.875.375,5.75.375C104.09864,162.25,101.84864,175.625,100.22364,189.125ZM223.99908,64c9.50195,0,22.25586,13.5,33.88282,37.25-11.252,3.75-22.50391,8-33.88282,12.875-11.377-4.875-22.62892-9.125-33.88283-12.875C201.74516,77.5,214.49712,64,223.99908,64Zm0,384c-9.502,0-22.25392-13.5-33.88283-37.25,11.25391-3.75,22.50587-8,33.88283-12.875C235.378,402.75,246.62994,407,257.8819,410.75,246.25494,434.5,233.501,448,223.99908,448Zm0-112a80,80,0,1,1,80-80A80.00023,80.00023,0,0,1,223.99908,336ZM384.6593,352c-3.625,6.625-19.00392,11.875-43.63479,11,2.752-13,5.127-26.375,6.752-40.125,7.75195-6.25,15.00391-12.625,21.87891-19.125C384.7843,327.25,388.6593,344.75,384.6593,352ZM369.65538,208.25c-6.875-6.5-14.127-12.875-21.87891-19.125-1.625-13.5-3.875-26.875-6.752-40.25,1.875,0,4.002-.375,5.752-.375,21.50391,0,34.50782,5.375,37.88283,11.5C388.6593,167.25,384.7843,184.75,369.65538,208.25Z"
        ],
        "audio-description": [
            512,
            512,
            [],
            "f29e",
            "M162.925 238.709l8.822 30.655h-25.606l9.041-30.652c1.277-4.421 2.651-9.994 3.872-15.245 1.22 5.251 2.594 10.823 3.871 15.242zm166.474-32.099h-14.523v98.781h14.523c29.776 0 46.175-17.678 46.175-49.776 0-32.239-17.49-49.005-46.175-49.005zM512 112v288c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48zM245.459 336.139l-57.097-168A12.001 12.001 0 0 0 177 160h-35.894a12.001 12.001 0 0 0-11.362 8.139l-57.097 168C70.003 343.922 75.789 352 84.009 352h29.133a12 12 0 0 0 11.535-8.693l8.574-29.906h51.367l8.793 29.977A12 12 0 0 0 204.926 352h29.172c8.22 0 14.006-8.078 11.361-15.861zm184.701-80.525c0-58.977-37.919-95.614-98.96-95.614h-57.366c-6.627 0-12 5.373-12 12v168c0 6.627 5.373 12 12 12H331.2c61.041 0 98.96-36.933 98.96-96.386z"
        ],
        "award": [
            384,
            512,
            [],
            "f559",
            "M97.12 362.63c-8.69-8.69-4.16-6.24-25.12-11.85-9.51-2.55-17.87-7.45-25.43-13.32L1.2 448.7c-4.39 10.77 3.81 22.47 15.43 22.03l52.69-2.01L105.56 507c8 8.44 22.04 5.81 26.43-4.96l52.05-127.62c-10.84 6.04-22.87 9.58-35.31 9.58-19.5 0-37.82-7.59-51.61-21.37zM382.8 448.7l-45.37-111.24c-7.56 5.88-15.92 10.77-25.43 13.32-21.07 5.64-16.45 3.18-25.12 11.85-13.79 13.78-32.12 21.37-51.62 21.37-12.44 0-24.47-3.55-35.31-9.58L252 502.04c4.39 10.77 18.44 13.4 26.43 4.96l36.25-38.28 52.69 2.01c11.62.44 19.82-11.27 15.43-22.03zM263 340c15.28-15.55 17.03-14.21 38.79-20.14 13.89-3.79 24.75-14.84 28.47-28.98 7.48-28.4 5.54-24.97 25.95-45.75 10.17-10.35 14.14-25.44 10.42-39.58-7.47-28.38-7.48-24.42 0-52.83 3.72-14.14-.25-29.23-10.42-39.58-20.41-20.78-18.47-17.36-25.95-45.75-3.72-14.14-14.58-25.19-28.47-28.98-27.88-7.61-24.52-5.62-44.95-26.41-10.17-10.35-25-14.4-38.89-10.61-27.87 7.6-23.98 7.61-51.9 0-13.89-3.79-28.72.25-38.89 10.61-20.41 20.78-17.05 18.8-44.94 26.41-13.89 3.79-24.75 14.84-28.47 28.98-7.47 28.39-5.54 24.97-25.95 45.75-10.17 10.35-14.15 25.44-10.42 39.58 7.47 28.36 7.48 24.4 0 52.82-3.72 14.14.25 29.23 10.42 39.59 20.41 20.78 18.47 17.35 25.95 45.75 3.72 14.14 14.58 25.19 28.47 28.98C104.6 325.96 106.27 325 121 340c13.23 13.47 33.84 15.88 49.74 5.82a39.676 39.676 0 0 1 42.53 0c15.89 10.06 36.5 7.65 49.73-5.82zM97.66 175.96c0-53.03 42.24-96.02 94.34-96.02s94.34 42.99 94.34 96.02-42.24 96.02-94.34 96.02-94.34-42.99-94.34-96.02z"
        ],
        "baby": [
            384,
            512,
            [],
            "f77c",
            "M192 160c44.2 0 80-35.8 80-80S236.2 0 192 0s-80 35.8-80 80 35.8 80 80 80zm-53.4 248.8l25.6-32-61.5-51.2L56.8 383c-11.4 14.2-11.7 34.4-.8 49l48 64c7.9 10.5 19.9 16 32 16 8.3 0 16.8-2.6 24-8 17.7-13.2 21.2-38.3 8-56l-29.4-39.2zm142.7-83.2l-61.5 51.2 25.6 32L216 448c-13.2 17.7-9.7 42.8 8 56 7.2 5.4 15.6 8 24 8 12.2 0 24.2-5.5 32-16l48-64c10.9-14.6 10.6-34.8-.8-49l-45.9-57.4zM376.7 145c-12.7-18.1-37.6-22.4-55.7-9.8l-40.6 28.5c-52.7 37-124.2 37-176.8 0L63 135.3C44.9 122.6 20 127 7.3 145-5.4 163.1-1 188 17 200.7l40.6 28.5c17 11.9 35.4 20.9 54.4 27.9V288h160v-30.8c19-7 37.4-16 54.4-27.9l40.6-28.5c18.1-12.8 22.4-37.7 9.7-55.8z"
        ],
        "baby-carriage": [
            512,
            512,
            [],
            "f77d",
            "M144.8 17c-11.3-17.8-37.2-22.8-54-9.4C35.3 51.9 0 118 0 192h256L144.8 17zM496 96h-48c-35.3 0-64 28.7-64 64v64H0c0 50.6 23 96.4 60.3 130.7C25.7 363.6 0 394.7 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-8.9-1.8-17.2-4.4-25.2 21.6 5.9 44.6 9.2 68.4 9.2s46.9-3.3 68.4-9.2c-2.7 8-4.4 16.3-4.4 25.2 0 44.2 35.8 80 80 80s80-35.8 80-80c0-37.3-25.7-68.4-60.3-77.3C425 320.4 448 274.6 448 224v-64h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM80 464c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm320-32c0 17.6-14.4 32-32 32s-32-14.4-32-32 14.4-32 32-32 32 14.4 32 32z"
        ],
        "backspace": [
            640,
            512,
            [],
            "f55a",
            "M576 64H205.26A63.97 63.97 0 0 0 160 82.75L9.37 233.37c-12.5 12.5-12.5 32.76 0 45.25L160 429.25c12 12 28.28 18.75 45.25 18.75H576c35.35 0 64-28.65 64-64V128c0-35.35-28.65-64-64-64zm-84.69 254.06c6.25 6.25 6.25 16.38 0 22.63l-22.62 22.62c-6.25 6.25-16.38 6.25-22.63 0L384 301.25l-62.06 62.06c-6.25 6.25-16.38 6.25-22.63 0l-22.62-22.62c-6.25-6.25-6.25-16.38 0-22.63L338.75 256l-62.06-62.06c-6.25-6.25-6.25-16.38 0-22.63l22.62-22.62c6.25-6.25 16.38-6.25 22.63 0L384 210.75l62.06-62.06c6.25-6.25 16.38-6.25 22.63 0l22.62 22.62c6.25 6.25 6.25 16.38 0 22.63L429.25 256l62.06 62.06z"
        ],
        "backward": [
            512,
            512,
            [],
            "f04a",
            "M11.5 280.6l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2zm256 0l192 160c20.6 17.2 52.5 2.8 52.5-24.6V96c0-27.4-31.9-41.8-52.5-24.6l-192 160c-15.3 12.8-15.3 36.4 0 49.2z"
        ],
        "bacon": [
            576,
            512,
            [],
            "f7e5",
            "M218.92 336.39c34.89-34.89 44.2-59.7 54.05-86 10.61-28.29 21.59-57.54 61.37-97.34s69.05-50.77 97.35-61.38c23.88-9 46.64-17.68 76.79-45.37L470.81 8.91a31 31 0 0 0-40.18-2.83c-13.64 10.1-25.15 14.39-41 20.3C247 79.52 209.26 191.29 200.65 214.1c-29.75 78.83-89.55 94.68-98.72 98.09-24.86 9.26-54.73 20.38-91.07 50.36C-3 374-3.63 395 9.07 407.61l35.76 35.51C80 410.52 107 400.15 133 390.39c26.27-9.84 51.06-19.12 85.92-54zm348-232l-35.75-35.51c-35.19 32.63-62.18 43-88.25 52.79-26.26 9.85-51.06 19.16-85.95 54s-44.19 59.69-54 86C292.33 290 281.34 319.22 241.55 359s-69 50.73-97.3 61.32c-23.86 9-46.61 17.66-76.72 45.33l37.68 37.43a31 31 0 0 0 40.18 2.82c13.6-10.06 25.09-14.34 40.94-20.24 142.2-53 180-164.1 188.94-187.69C405 219.18 464.8 203.3 474 199.86c24.87-9.27 54.74-20.4 91.11-50.41 13.89-11.4 14.52-32.45 1.82-45.05z"
        ],
        "bacteria": [
            640,
            512,
            [],
            "e059",
            "M272.35,226.4A17.71,17.71,0,0,0,281.46,203l-4-9.08a121.29,121.29,0,0,1,12.36-3.08A83.34,83.34,0,0,0,323.57,177l10,9a17.76,17.76,0,1,0,23.92-26.27l-9.72-8.76a83.12,83.12,0,0,0,11.65-48.18l11.85-3.51a17.73,17.73,0,1,0-10.15-34l-11.34,3.36a84,84,0,0,0-36.38-35.57l2.84-10.85a17.8,17.8,0,0,0-34.47-8.93l-2.82,10.78a83.25,83.25,0,0,0-16.74,1.1C250.83,27,240,30.22,229.1,33.39l-3.38-9.46a17.8,17.8,0,0,0-33.56,11.89l3.49,9.8a286.74,286.74,0,0,0-43.94,23.57l-6.32-8.43a17.9,17.9,0,0,0-24.94-3.6A17.69,17.69,0,0,0,116.84,82l6.45,8.61a286.59,286.59,0,0,0-34.95,35.33l-8.82-6.42a17.84,17.84,0,0,0-24.89,3.86,17.66,17.66,0,0,0,3.88,24.77l8.88,6.47a286.6,286.6,0,0,0-23,43.91l-10.48-3.59a17.73,17.73,0,1,0-11.59,33.52L32.67,232c-2.79,10-5.79,19.84-7.52,30.22a83.16,83.16,0,0,0-.82,19l-11.58,3.43a17.73,17.73,0,1,0,10.13,34l11.27-3.33a83.51,83.51,0,0,0,36.39,35.43l-2.88,11.06a17.81,17.81,0,0,0,34.48,8.92l2.87-11c1,0,2.07.26,3.1.26a83.39,83.39,0,0,0,45.65-13.88l8.59,8.8a17.77,17.77,0,0,0,25.56-24.7l-9.14-9.37a83.41,83.41,0,0,0,12.08-31.05,119.08,119.08,0,0,1,3.87-15.53l9,4.22a17.74,17.74,0,1,0,15.15-32.09l-8.8-4.11c.67-1,1.2-2.08,1.9-3.05a119.89,119.89,0,0,1,7.87-9.41,121.73,121.73,0,0,1,11.65-11.4,119.49,119.49,0,0,1,9.94-7.82c1.12-.77,2.32-1.42,3.47-2.15l3.92,8.85a17.86,17.86,0,0,0,16.32,10.58A18.14,18.14,0,0,0,272.35,226.4ZM128,256a32,32,0,1,1,32-32A32,32,0,0,1,128,256Zm80-96a16,16,0,1,1,16-16A16,16,0,0,1,208,160Zm431.26,45.3a17.79,17.79,0,0,0-17.06-12.69,17.55,17.55,0,0,0-5.08.74l-11.27,3.33a83.61,83.61,0,0,0-36.39-35.43l2.88-11.06a17.81,17.81,0,0,0-34.48-8.91l-2.87,11c-1,0-2.07-.26-3.1-.26a83.32,83.32,0,0,0-45.65,13.89l-8.59-8.81a17.77,17.77,0,0,0-25.56,24.7l9.14,9.37a83.28,83.28,0,0,0-12.08,31.06,119.34,119.34,0,0,1-3.87,15.52l-9-4.22a17.74,17.74,0,1,0-15.15,32.09l8.8,4.11c-.67,1-1.2,2.08-1.89,3.05a117.71,117.71,0,0,1-7.94,9.47,119,119,0,0,1-11.57,11.33,121.59,121.59,0,0,1-10,7.83c-1.12.77-2.32,1.42-3.47,2.15l-3.92-8.85a17.86,17.86,0,0,0-16.32-10.58,18.14,18.14,0,0,0-7.18,1.5A17.71,17.71,0,0,0,358.54,309l4,9.08a118.71,118.71,0,0,1-12.36,3.08,83.34,83.34,0,0,0-33.77,13.9l-10-9a17.77,17.77,0,1,0-23.92,26.28l9.72,8.75a83.12,83.12,0,0,0-11.65,48.18l-11.86,3.51a17.73,17.73,0,1,0,10.16,34l11.34-3.36A84,84,0,0,0,326.61,479l-2.84,10.85a17.8,17.8,0,0,0,34.47,8.93L361.06,488a83.3,83.3,0,0,0,16.74-1.1c11.37-1.89,22.24-5.07,33.1-8.24l3.38,9.46a17.8,17.8,0,0,0,33.56-11.89l-3.49-9.79a287.66,287.66,0,0,0,43.94-23.58l6.32,8.43a17.88,17.88,0,0,0,24.93,3.6A17.67,17.67,0,0,0,523.16,430l-6.45-8.61a287.37,287.37,0,0,0,34.95-35.34l8.82,6.42a17.76,17.76,0,1,0,21-28.63l-8.88-6.46a287.17,287.17,0,0,0,23-43.92l10.48,3.59a17.73,17.73,0,1,0,11.59-33.52L607.33,280c2.79-10,5.79-19.84,7.52-30.21a83.27,83.27,0,0,0,.82-19.05l11.58-3.43A17.7,17.7,0,0,0,639.26,205.3ZM416,416a32,32,0,1,1,32-32A32,32,0,0,1,416,416Z"
        ],
        "bacterium": [
            512,
            512,
            [],
            "e05a",
            "M511,102.93A23.76,23.76,0,0,0,481.47,87l-15.12,4.48a111.85,111.85,0,0,0-48.5-47.42l3.79-14.47a23.74,23.74,0,0,0-46-11.91l-3.76,14.37a111.94,111.94,0,0,0-22.33,1.47,386.74,386.74,0,0,0-44.33,10.41l-4.3-12a23.74,23.74,0,0,0-44.75,15.85l4.3,12.05a383.4,383.4,0,0,0-58.69,31.83l-8-10.63a23.85,23.85,0,0,0-33.24-4.8,23.57,23.57,0,0,0-4.83,33.09l8,10.63a386.14,386.14,0,0,0-46.7,47.44l-11-8a23.68,23.68,0,1,0-28,38.17l11.09,8.06a383.45,383.45,0,0,0-30.92,58.75l-12.93-4.43a23.65,23.65,0,1,0-15.47,44.69l13,4.48a385.81,385.81,0,0,0-9.3,40.53A111.58,111.58,0,0,0,32.44,375L17,379.56a23.64,23.64,0,0,0,13.51,45.31l15-4.44a111.49,111.49,0,0,0,48.53,47.24l-3.85,14.75a23.66,23.66,0,0,0,17,28.83,24.7,24.7,0,0,0,6,.75,23.73,23.73,0,0,0,23-17.7L140,479.67c1.37.05,2.77.35,4.13.35A111.22,111.22,0,0,0,205,461.5l11.45,11.74a23.7,23.7,0,0,0,34.08-32.93l-12.19-12.5a111,111,0,0,0,16.11-41.4,158.69,158.69,0,0,1,5.16-20.71l12,5.64a23.66,23.66,0,1,0,20.19-42.79l-11.72-5.49c.89-1.32,1.59-2.77,2.52-4.06a157.86,157.86,0,0,1,10.46-12.49,159.5,159.5,0,0,1,15.59-15.28,162.18,162.18,0,0,1,13.23-10.4c1.5-1,3.1-1.89,4.63-2.87l5.23,11.8a23.74,23.74,0,0,0,43.48-19.08l-5.36-12.11a158.87,158.87,0,0,1,16.49-4.1,111,111,0,0,0,45-18.54l13.33,12a23.69,23.69,0,1,0,31.88-35l-12.94-11.67A110.83,110.83,0,0,0,479.21,137L495,132.32A23.61,23.61,0,0,0,511,102.93ZM160,368a48,48,0,1,1,48-48A48,48,0,0,1,160,368Zm80-136a24,24,0,1,1,24-24A24,24,0,0,1,240,232Z"
        ],
        "bahai": [
            512,
            512,
            [],
            "f666",
            "M496.25 202.52l-110-15.44 41.82-104.34c6.67-16.64-11.6-32.18-26.59-22.63L307.44 120 273.35 12.82C270.64 4.27 263.32 0 256 0c-7.32 0-14.64 4.27-17.35 12.82l-34.09 107.19-94.04-59.89c-14.99-9.55-33.25 5.99-26.59 22.63l41.82 104.34-110 15.43c-17.54 2.46-21.68 26.27-6.03 34.67l98.16 52.66-74.48 83.54c-10.92 12.25-1.72 30.93 13.29 30.93 1.31 0 2.67-.14 4.07-.45l108.57-23.65-4.11 112.55c-.43 11.65 8.87 19.22 18.41 19.22 5.15 0 10.39-2.21 14.2-7.18l68.18-88.9 68.18 88.9c3.81 4.97 9.04 7.18 14.2 7.18 9.54 0 18.84-7.57 18.41-19.22l-4.11-112.55 108.57 23.65c17.36 3.76 29.21-17.2 17.35-30.49l-74.48-83.54 98.16-52.66c15.64-8.39 11.5-32.2-6.04-34.66zM338.51 311.68l-51.89-11.3 1.97 53.79L256 311.68l-32.59 42.49 1.96-53.79-51.89 11.3 35.6-39.93-46.92-25.17 52.57-7.38-19.99-49.87 44.95 28.62L256 166.72l16.29 51.23 44.95-28.62-19.99 49.87 52.57 7.38-46.92 25.17 35.61 39.93z"
        ],
        "balance-scale": [
            640,
            512,
            [],
            "f24e",
            "M256 336h-.02c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0C-2.06 328.75.02 320.33.02 336H0c0 44.18 57.31 80 128 80s128-35.82 128-80zM128 176l72 144H56l72-144zm511.98 160c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 320l72-144 72 144H440zm88 128H352V153.25c23.51-10.29 41.16-31.48 46.39-57.25H528c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H383.64C369.04 12.68 346.09 0 320 0s-49.04 12.68-63.64 32H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h129.61c5.23 25.76 22.87 46.96 46.39 57.25V448H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
        ],
        "balance-scale-left": [
            640,
            512,
            [],
            "f515",
            "M528 448H352V153.25c20.42-8.94 36.1-26.22 43.38-47.47l132-44.26c8.38-2.81 12.89-11.88 10.08-20.26l-10.17-30.34C524.48 2.54 515.41-1.97 507.03.84L389.11 40.37C375.3 16.36 349.69 0 320 0c-44.18 0-80 35.82-80 80 0 3.43.59 6.71 1.01 10.03l-128.39 43.05c-8.38 2.81-12.89 11.88-10.08 20.26l10.17 30.34c2.81 8.38 11.88 12.89 20.26 10.08l142.05-47.63c4.07 2.77 8.43 5.12 12.99 7.12V496c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16v-32c-.01-8.84-7.17-16-16.01-16zm111.98-144c0-16.18 1.34-8.73-85.05-181.51-17.65-35.29-68.19-35.36-85.87 0-87.12 174.26-85.04 165.84-85.04 181.51H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02zM440 288l72-144 72 144H440zm-269.07-37.51c-17.65-35.29-68.19-35.36-85.87 0C-2.06 424.75.02 416.33.02 432H0c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-16.18 1.34-8.73-85.05-181.51zM56 416l72-144 72 144H56z"
        ],
        "balance-scale-right": [
            640,
            512,
            [],
            "f516",
            "M96 464v32c0 8.84 7.16 16 16 16h224c8.84 0 16-7.16 16-16V153.25c4.56-2 8.92-4.35 12.99-7.12l142.05 47.63c8.38 2.81 17.45-1.71 20.26-10.08l10.17-30.34c2.81-8.38-1.71-17.45-10.08-20.26l-128.4-43.05c.42-3.32 1.01-6.6 1.01-10.03 0-44.18-35.82-80-80-80-29.69 0-55.3 16.36-69.11 40.37L132.96.83c-8.38-2.81-17.45 1.71-20.26 10.08l-10.17 30.34c-2.81 8.38 1.71 17.45 10.08 20.26l132 44.26c7.28 21.25 22.96 38.54 43.38 47.47V448H112c-8.84 0-16 7.16-16 16zM0 304c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0C-1.32 295.27.02 287.82.02 304H0zm56-16l72-144 72 144H56zm328.02 144H384c0 44.18 57.31 80 128 80s128-35.82 128-80h-.02c0-15.67 2.08-7.25-85.05-181.51-17.68-35.36-68.22-35.29-85.87 0-86.38 172.78-85.04 165.33-85.04 181.51zM440 416l72-144 72 144H440z"
        ],
        "ban": [
            512,
            512,
            [],
            "f05e",
            "M256 8C119.034 8 8 119.033 8 256s111.034 248 248 248 248-111.034 248-248S392.967 8 256 8zm130.108 117.892c65.448 65.448 70 165.481 20.677 235.637L150.47 105.216c70.204-49.356 170.226-44.735 235.638 20.676zM125.892 386.108c-65.448-65.448-70-165.481-20.677-235.637L361.53 406.784c-70.203 49.356-170.226 44.736-235.638-20.676z"
        ],
        "band-aid": [
            640,
            512,
            [],
            "f462",
            "M0 160v192c0 35.3 28.7 64 64 64h96V96H64c-35.3 0-64 28.7-64 64zm576-64h-96v320h96c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64zM192 416h256V96H192v320zm176-232c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm0 96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24z"
        ],
        "barcode": [
            512,
            512,
            [],
            "f02a",
            "M0 448V64h18v384H0zm26.857-.273V64H36v383.727h-9.143zm27.143 0V64h8.857v383.727H54zm44.857 0V64h8.857v383.727h-8.857zm36 0V64h17.714v383.727h-17.714zm44.857 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm18 0V64h8.857v383.727h-8.857zm35.715 0V64h18v383.727h-18zm44.857 0V64h18v383.727h-18zm35.999 0V64h18.001v383.727h-18.001zm36.001 0V64h18.001v383.727h-18.001zm26.857 0V64h18v383.727h-18zm45.143 0V64h26.857v383.727h-26.857zm35.714 0V64h9.143v383.727H476zm18 .273V64h18v384h-18z"
        ],
        "bars": [
            448,
            512,
            [],
            "f0c9",
            "M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"
        ],
        "baseball-ball": [
            496,
            512,
            [],
            "f433",
            "M368.5 363.9l28.8-13.9c11.1 22.9 26 43.2 44.1 60.9 34-42.5 54.5-96.3 54.5-154.9 0-58.5-20.4-112.2-54.2-154.6-17.8 17.3-32.6 37.1-43.6 59.5l-28.7-14.1c12.8-26 30-49 50.8-69C375.6 34.7 315 8 248 8 181.1 8 120.5 34.6 75.9 77.7c20.7 19.9 37.9 42.9 50.7 68.8l-28.7 14.1c-11-22.3-25.7-42.1-43.5-59.4C20.4 143.7 0 197.4 0 256c0 58.6 20.4 112.3 54.4 154.7 18.2-17.7 33.2-38 44.3-61l28.8 13.9c-12.9 26.7-30.3 50.3-51.5 70.7 44.5 43.1 105.1 69.7 172 69.7 66.8 0 127.3-26.5 171.9-69.5-21.1-20.4-38.5-43.9-51.4-70.6zm-228.3-32l-30.5-9.8c14.9-46.4 12.7-93.8-.6-134l30.4-10c15 45.6 18 99.9.7 153.8zm216.3-153.4l30.4 10c-13.2 40.1-15.5 87.5-.6 134l-30.5 9.8c-17.3-54-14.3-108.3.7-153.8z"
        ],
        "basketball-ball": [
            496,
            512,
            [],
            "f434",
            "M212.3 10.3c-43.8 6.3-86.2 24.1-122.2 53.8l77.4 77.4c27.8-35.8 43.3-81.2 44.8-131.2zM248 222L405.9 64.1c-42.4-35-93.6-53.5-145.5-56.1-1.2 63.9-21.5 122.3-58.7 167.7L248 222zM56.1 98.1c-29.7 36-47.5 78.4-53.8 122.2 50-1.5 95.5-17 131.2-44.8L56.1 98.1zm272.2 204.2c45.3-37.1 103.7-57.4 167.7-58.7-2.6-51.9-21.1-103.1-56.1-145.5L282 256l46.3 46.3zM248 290L90.1 447.9c42.4 34.9 93.6 53.5 145.5 56.1 1.3-64 21.6-122.4 58.7-167.7L248 290zm191.9 123.9c29.7-36 47.5-78.4 53.8-122.2-50.1 1.6-95.5 17.1-131.2 44.8l77.4 77.4zM167.7 209.7C122.3 246.9 63.9 267.3 0 268.4c2.6 51.9 21.1 103.1 56.1 145.5L214 256l-46.3-46.3zm116 292c43.8-6.3 86.2-24.1 122.2-53.8l-77.4-77.4c-27.7 35.7-43.2 81.2-44.8 131.2z"
        ],
        "bath": [
            512,
            512,
            [],
            "f2cd",
            "M32,384a95.4,95.4,0,0,0,32,71.09V496a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V480H384v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V455.09A95.4,95.4,0,0,0,480,384V336H32ZM496,256H80V69.25a21.26,21.26,0,0,1,36.28-15l19.27,19.26c-13.13,29.88-7.61,59.11,8.62,79.73l-.17.17A16,16,0,0,0,144,176l11.31,11.31a16,16,0,0,0,22.63,0L283.31,81.94a16,16,0,0,0,0-22.63L272,48a16,16,0,0,0-22.62,0l-.17.17c-20.62-16.23-49.83-21.75-79.73-8.62L150.22,20.28A69.25,69.25,0,0,0,32,69.25V256H16A16,16,0,0,0,0,272v16a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V272A16,16,0,0,0,496,256Z"
        ],
        "battery-empty": [
            640,
            512,
            [],
            "f244",
            "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48z"
        ],
        "battery-full": [
            640,
            512,
            [],
            "f240",
            "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-48 96H96v128h416V192z"
        ],
        "battery-half": [
            640,
            512,
            [],
            "f242",
            "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-240 96H96v128h224V192z"
        ],
        "battery-quarter": [
            640,
            512,
            [],
            "f243",
            "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-336 96H96v128h128V192z"
        ],
        "battery-three-quarters": [
            640,
            512,
            [],
            "f241",
            "M544 160v64h32v64h-32v64H64V160h480m16-64H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h512c26.51 0 48-21.49 48-48v-16h8c13.255 0 24-10.745 24-24V184c0-13.255-10.745-24-24-24h-8v-16c0-26.51-21.49-48-48-48zm-144 96H96v128h320V192z"
        ],
        "bed": [
            640,
            512,
            [],
            "f236",
            "M176 256c44.11 0 80-35.89 80-80s-35.89-80-80-80-80 35.89-80 80 35.89 80 80 80zm352-128H304c-8.84 0-16 7.16-16 16v144H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v352c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h512v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V240c0-61.86-50.14-112-112-112z"
        ],
        "beer": [
            448,
            512,
            [],
            "f0fc",
            "M368 96h-48V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24v-42.11l80.606-35.977C429.396 365.063 448 336.388 448 304.86V176c0-44.112-35.888-80-80-80zm16 208.86a16.018 16.018 0 0 1-9.479 14.611L320 343.805V160h48c8.822 0 16 7.178 16 16v128.86zM208 384c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16zm-96 0c-8.836 0-16-7.164-16-16V144c0-8.836 7.164-16 16-16s16 7.164 16 16v224c0 8.836-7.164 16-16 16z"
        ],
        "bell": [
            448,
            512,
            [],
            "f0f3",
            "M224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64zm215.39-149.71c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71z"
        ],
        "bell-slash": [
            640,
            512,
            [],
            "f1f6",
            "M633.82 458.1l-90.62-70.05c.19-1.38.8-2.66.8-4.06.05-7.55-2.61-15.27-8.61-21.71-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84c-40.33 8.38-74.66 31.07-97.59 62.57L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.35 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.42-6.97 4.17-17.02-2.81-22.45zM157.23 251.54c-8.61 67.96-36.41 93.33-52.62 110.75-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h241.92L157.23 251.54zM320 512c35.32 0 63.97-28.65 63.97-64H256.03c0 35.35 28.65 64 63.97 64z"
        ],
        "bezier-curve": [
            640,
            512,
            [],
            "f55b",
            "M368 32h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM208 88h-84.75C113.75 64.56 90.84 48 64 48 28.66 48 0 76.65 0 112s28.66 64 64 64c26.84 0 49.75-16.56 59.25-40h79.73c-55.37 32.52-95.86 87.32-109.54 152h49.4c11.3-41.61 36.77-77.21 71.04-101.56-3.7-8.08-5.88-16.99-5.88-26.44V88zm-48 232H64c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zM576 48c-26.84 0-49.75 16.56-59.25 40H432v72c0 9.45-2.19 18.36-5.88 26.44 34.27 24.35 59.74 59.95 71.04 101.56h49.4c-13.68-64.68-54.17-119.48-109.54-152h79.73c9.5 23.44 32.41 40 59.25 40 35.34 0 64-28.65 64-64s-28.66-64-64-64zm0 272h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
        ],
        "bible": [
            448,
            512,
            [],
            "f647",
            "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM144 144c0-8.84 7.16-16 16-16h48V80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v48h48c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-48v112c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V192h-48c-8.84 0-16-7.16-16-16v-32zm236.8 304H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"
        ],
        "bicycle": [
            640,
            512,
            [],
            "f206",
            "M512.509 192.001c-16.373-.064-32.03 2.955-46.436 8.495l-77.68-125.153A24 24 0 0 0 368.001 64h-64c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h50.649l14.896 24H256.002v-16c0-8.837-7.163-16-16-16h-87.459c-13.441 0-24.777 10.999-24.536 24.437.232 13.044 10.876 23.563 23.995 23.563h48.726l-29.417 47.52c-13.433-4.83-27.904-7.483-42.992-7.52C58.094 191.83.412 249.012.002 319.236-.413 390.279 57.055 448 128.002 448c59.642 0 109.758-40.793 123.967-96h52.033a24 24 0 0 0 20.406-11.367L410.37 201.77l14.938 24.067c-25.455 23.448-41.385 57.081-41.307 94.437.145 68.833 57.899 127.051 126.729 127.719 70.606.685 128.181-55.803 129.255-125.996 1.086-70.941-56.526-129.72-127.476-129.996zM186.75 265.772c9.727 10.529 16.673 23.661 19.642 38.228h-43.306l23.664-38.228zM128.002 400c-44.112 0-80-35.888-80-80s35.888-80 80-80c5.869 0 11.586.653 17.099 1.859l-45.505 73.509C89.715 331.327 101.213 352 120.002 352h81.3c-12.37 28.225-40.562 48-73.3 48zm162.63-96h-35.624c-3.96-31.756-19.556-59.894-42.383-80.026L237.371 184h127.547l-74.286 120zm217.057 95.886c-41.036-2.165-74.049-35.692-75.627-76.755-.812-21.121 6.633-40.518 19.335-55.263l44.433 71.586c4.66 7.508 14.524 9.816 22.032 5.156l13.594-8.437c7.508-4.66 9.817-14.524 5.156-22.032l-44.468-71.643a79.901 79.901 0 0 1 19.858-2.497c44.112 0 80 35.888 80 80-.001 45.54-38.252 82.316-84.313 79.885z"
        ],
        "biking": [
            640,
            512,
            [],
            "f84a",
            "M400 96a48 48 0 1 0-48-48 48 48 0 0 0 48 48zm-4 121a31.9 31.9 0 0 0 20 7h64a32 32 0 0 0 0-64h-52.78L356 103a31.94 31.94 0 0 0-40.81.68l-112 96a32 32 0 0 0 3.08 50.92L288 305.12V416a32 32 0 0 0 64 0V288a32 32 0 0 0-14.25-26.62l-41.36-27.57 58.25-49.92zm116 39a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64zM128 256a128 128 0 1 0 128 128 128 128 0 0 0-128-128zm0 192a64 64 0 1 1 64-64 64 64 0 0 1-64 64z"
        ],
        "binoculars": [
            512,
            512,
            [],
            "f1e5",
            "M416 48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v48h96V48zM63.91 159.99C61.4 253.84 3.46 274.22 0 404v44c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32V288h32V128H95.84c-17.63 0-31.45 14.37-31.93 31.99zm384.18 0c-.48-17.62-14.3-31.99-31.93-31.99H320v160h32v160c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-44c-3.46-129.78-61.4-150.16-63.91-244.01zM176 32h-64c-8.84 0-16 7.16-16 16v48h96V48c0-8.84-7.16-16-16-16zm48 256h64V128h-64v160z"
        ],
        "biohazard": [
            576,
            512,
            [],
            "f780",
            "M287.9 112c18.6 0 36.2 3.8 52.8 9.6 13.3-10.3 23.6-24.3 29.5-40.7-25.2-10.9-53-17-82.2-17-29.1 0-56.9 6-82.1 16.9 5.9 16.4 16.2 30.4 29.5 40.7 16.5-5.7 34-9.5 52.5-9.5zM163.6 438.7c12-11.8 20.4-26.4 24.5-42.4-32.9-26.4-54.8-65.3-58.9-109.6-8.5-2.8-17.2-4.6-26.4-4.6-7.6 0-15.2 1-22.5 3.1 4.1 62.8 35.8 118 83.3 153.5zm224.2-42.6c4.1 16 12.5 30.7 24.5 42.5 47.4-35.5 79.1-90.7 83-153.5-7.2-2-14.7-3-22.2-3-9.2 0-18 1.9-26.6 4.7-4.1 44.2-26 82.9-58.7 109.3zm113.5-205c-17.6-10.4-36.3-16.6-55.3-19.9 6-17.7 10-36.4 10-56.2 0-41-14.5-80.8-41-112.2-2.5-3-6.6-3.7-10-1.8-3.3 1.9-4.8 6-3.6 9.7 4.5 13.8 6.6 26.3 6.6 38.5 0 67.8-53.8 122.9-120 122.9S168 117 168 49.2c0-12.1 2.2-24.7 6.6-38.5 1.2-3.7-.3-7.8-3.6-9.7-3.4-1.9-7.5-1.2-10 1.8C134.6 34.2 120 74 120 115c0 19.8 3.9 38.5 10 56.2-18.9 3.3-37.7 9.5-55.3 19.9-34.6 20.5-61 53.3-74.3 92.4-1.3 3.7.2 7.7 3.5 9.8 3.3 2 7.5 1.3 10-1.6 9.4-10.8 19-19.1 29.2-25.1 57.3-33.9 130.8-13.7 163.9 45 33.1 58.7 13.4 134-43.9 167.9-10.2 6.1-22 10.4-35.8 13.4-3.7.8-6.4 4.2-6.4 8.1.1 4 2.7 7.3 6.5 8 39.7 7.8 80.6.8 115.2-19.7 18-10.6 32.9-24.5 45.3-40.1 12.4 15.6 27.3 29.5 45.3 40.1 34.6 20.5 75.5 27.5 115.2 19.7 3.8-.7 6.4-4 6.5-8 0-3.9-2.6-7.3-6.4-8.1-13.9-2.9-25.6-7.3-35.8-13.4-57.3-33.9-77-109.2-43.9-167.9s106.6-78.9 163.9-45c10.2 6.1 19.8 14.3 29.2 25.1 2.5 2.9 6.7 3.6 10 1.6s4.8-6.1 3.5-9.8c-13.1-39.1-39.5-72-74.1-92.4zm-213.4 129c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
        ],
        "birthday-cake": [
            448,
            512,
            [],
            "f1fd",
            "M448 384c-28.02 0-31.26-32-74.5-32-43.43 0-46.825 32-74.75 32-27.695 0-31.454-32-74.75-32-42.842 0-47.218 32-74.5 32-28.148 0-31.202-32-74.75-32-43.547 0-46.653 32-74.75 32v-80c0-26.5 21.5-48 48-48h16V112h64v144h64V112h64v144h64V112h64v144h16c26.5 0 48 21.5 48 48v80zm0 128H0v-96c43.356 0 46.767-32 74.75-32 27.951 0 31.253 32 74.75 32 42.843 0 47.217-32 74.5-32 28.148 0 31.201 32 74.75 32 43.357 0 46.767-32 74.75-32 27.488 0 31.252 32 74.5 32v96zM96 96c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40z"
        ],
        "blender": [
            512,
            512,
            [],
            "f517",
            "M416 384H160c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-128 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm40-416h166.54L512 0H48C21.49 0 0 21.49 0 48v160c0 26.51 21.49 48 48 48h103.27l8.73 96h256l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H328c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H328c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM64 192V64h69.82l11.64 128H64z"
        ],
        "blender-phone": [
            576,
            512,
            [],
            "f6b6",
            "M392 64h166.54L576 0H192v352h288l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h114.18l17.46-64H392c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h140.36l17.46-64H392c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8zM158.8 335.01l-25.78-63.26c-2.78-6.81-9.8-10.99-17.24-10.26l-45.03 4.42c-17.28-46.94-17.65-99.78 0-147.72l45.03 4.42c7.43.73 14.46-3.46 17.24-10.26l25.78-63.26c3.02-7.39.2-15.85-6.68-20.07l-39.28-24.1C98.51-3.87 80.09-.5 68.95 11.97c-92.57 103.6-92 259.55 2.1 362.49 9.87 10.8 29.12 12.48 41.65 4.8l39.41-24.18c6.89-4.22 9.7-12.67 6.69-20.07zM480 384H192c-35.35 0-64 28.65-64 64v32c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32v-32c0-35.35-28.65-64-64-64zm-144 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
        ],
        "blind": [
            384,
            512,
            [],
            "f29d",
            "M380.15 510.837a8 8 0 0 1-10.989-2.687l-125.33-206.427a31.923 31.923 0 0 0 12.958-9.485l126.048 207.608a8 8 0 0 1-2.687 10.991zM142.803 314.338l-32.54 89.485 36.12 88.285c6.693 16.36 25.377 24.192 41.733 17.501 16.357-6.692 24.193-25.376 17.501-41.734l-62.814-153.537zM96 88c24.301 0 44-19.699 44-44S120.301 0 96 0 52 19.699 52 44s19.699 44 44 44zm154.837 169.128l-120-152c-4.733-5.995-11.75-9.108-18.837-9.112V96H80v.026c-7.146.003-14.217 3.161-18.944 9.24L0 183.766v95.694c0 13.455 11.011 24.791 24.464 24.536C37.505 303.748 48 293.1 48 280v-79.766l16-20.571v140.698L9.927 469.055c-6.04 16.609 2.528 34.969 19.138 41.009 16.602 6.039 34.968-2.524 41.009-19.138L136 309.638V202.441l-31.406-39.816a4 4 0 1 1 6.269-4.971l102.3 129.217c9.145 11.584 24.368 11.339 33.708 3.965 10.41-8.216 12.159-23.334 3.966-33.708z"
        ],
        "blog": [
            512,
            512,
            [],
            "f781",
            "M172.2 226.8c-14.6-2.9-28.2 8.9-28.2 23.8V301c0 10.2 7.1 18.4 16.7 22 18.2 6.8 31.3 24.4 31.3 45 0 26.5-21.5 48-48 48s-48-21.5-48-48V120c0-13.3-10.7-24-24-24H24c-13.3 0-24 10.7-24 24v248c0 89.5 82.1 160.2 175 140.7 54.4-11.4 98.3-55.4 109.7-109.7 17.4-82.9-37-157.2-112.5-172.2zM209 0c-9.2-.5-17 6.8-17 16v31.6c0 8.5 6.6 15.5 15 15.9 129.4 7 233.4 112 240.9 241.5.5 8.4 7.5 15 15.9 15h32.1c9.2 0 16.5-7.8 16-17C503.4 139.8 372.2 8.6 209 0zm.3 96c-9.3-.7-17.3 6.7-17.3 16.1v32.1c0 8.4 6.5 15.3 14.8 15.9 76.8 6.3 138 68.2 144.9 145.2.8 8.3 7.6 14.7 15.9 14.7h32.2c9.3 0 16.8-8 16.1-17.3-8.4-110.1-96.5-198.2-206.6-206.7z"
        ],
        "bold": [
            384,
            512,
            [],
            "f032",
            "M333.49 238a122 122 0 0 0 27-65.21C367.87 96.49 308 32 233.42 32H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h31.87v288H34a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h209.32c70.8 0 134.14-51.75 141-122.4 4.74-48.45-16.39-92.06-50.83-119.6zM145.66 112h87.76a48 48 0 0 1 0 96h-87.76zm87.76 288h-87.76V288h87.76a56 56 0 0 1 0 112z"
        ],
        "bolt": [
            320,
            512,
            [],
            "f0e7",
            "M296 160H180.6l42.6-129.8C227.2 15 215.7 0 200 0H56C44 0 33.8 8.9 32.2 20.8l-32 240C-1.7 275.2 9.5 288 24 288h118.7L96.6 482.5c-3.6 15.2 8 29.5 23.3 29.5 8.4 0 16.4-4.4 20.8-12l176-304c9.3-15.9-2.2-36-20.7-36z"
        ],
        "bomb": [
            512,
            512,
            [],
            "f1e2",
            "M440.5 88.5l-52 52L415 167c9.4 9.4 9.4 24.6 0 33.9l-17.4 17.4c11.8 26.1 18.4 55.1 18.4 85.6 0 114.9-93.1 208-208 208S0 418.9 0 304 93.1 96 208 96c30.5 0 59.5 6.6 85.6 18.4L311 97c9.4-9.4 24.6-9.4 33.9 0l26.5 26.5 52-52 17.1 17zM500 60h-24c-6.6 0-12 5.4-12 12s5.4 12 12 12h24c6.6 0 12-5.4 12-12s-5.4-12-12-12zM440 0c-6.6 0-12 5.4-12 12v24c0 6.6 5.4 12 12 12s12-5.4 12-12V12c0-6.6-5.4-12-12-12zm33.9 55l17-17c4.7-4.7 4.7-12.3 0-17-4.7-4.7-12.3-4.7-17 0l-17 17c-4.7 4.7-4.7 12.3 0 17 4.8 4.7 12.4 4.7 17 0zm-67.8 0c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17zm67.8 34c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17l17 17c4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17l-17-17zM112 272c0-35.3 28.7-64 64-64 8.8 0 16-7.2 16-16s-7.2-16-16-16c-52.9 0-96 43.1-96 96 0 8.8 7.2 16 16 16s16-7.2 16-16z"
        ],
        "bone": [
            640,
            512,
            [],
            "f5d7",
            "M598.88 244.56c25.2-12.6 41.12-38.36 41.12-66.53v-7.64C640 129.3 606.7 96 565.61 96c-32.02 0-60.44 20.49-70.57 50.86-7.68 23.03-11.6 45.14-38.11 45.14H183.06c-27.38 0-31.58-25.54-38.11-45.14C134.83 116.49 106.4 96 74.39 96 33.3 96 0 129.3 0 170.39v7.64c0 28.17 15.92 53.93 41.12 66.53 9.43 4.71 9.43 18.17 0 22.88C15.92 280.04 0 305.8 0 333.97v7.64C0 382.7 33.3 416 74.38 416c32.02 0 60.44-20.49 70.57-50.86 7.68-23.03 11.6-45.14 38.11-45.14h273.87c27.38 0 31.58 25.54 38.11 45.14C505.17 395.51 533.6 416 565.61 416c41.08 0 74.38-33.3 74.38-74.39v-7.64c0-28.18-15.92-53.93-41.12-66.53-9.42-4.71-9.42-18.17.01-22.88z"
        ],
        "bong": [
            448,
            512,
            [],
            "f55c",
            "M302.5 512c23.18 0 44.43-12.58 56-32.66C374.69 451.26 384 418.75 384 384c0-36.12-10.08-69.81-27.44-98.62L400 241.94l9.38 9.38c6.25 6.25 16.38 6.25 22.63 0l11.3-11.32c6.25-6.25 6.25-16.38 0-22.63l-52.69-52.69c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l9.38 9.38-39.41 39.41c-11.56-11.37-24.53-21.33-38.65-29.51V63.74l15.97-.02c8.82-.01 15.97-7.16 15.98-15.98l.04-31.72C320 7.17 312.82-.01 303.97 0L80.03.26c-8.82.01-15.97 7.16-15.98 15.98l-.04 31.73c-.01 8.85 7.17 16.02 16.02 16.01L96 63.96v153.93C38.67 251.1 0 312.97 0 384c0 34.75 9.31 67.27 25.5 95.34C37.08 499.42 58.33 512 81.5 512h221zM120.06 259.43L144 245.56V63.91l96-.11v181.76l23.94 13.87c24.81 14.37 44.12 35.73 56.56 60.57h-257c12.45-24.84 31.75-46.2 56.56-60.57z"
        ],
        "book": [
            448,
            512,
            [],
            "f02d",
            "M448 360V24c0-13.3-10.7-24-24-24H96C43 0 0 43 0 96v320c0 53 43 96 96 96h328c13.3 0 24-10.7 24-24v-16c0-7.5-3.5-14.3-8.9-18.7-4.2-15.4-4.2-59.3 0-74.7 5.4-4.3 8.9-11.1 8.9-18.6zM128 134c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm0 64c0-3.3 2.7-6 6-6h212c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H134c-3.3 0-6-2.7-6-6v-20zm253.4 250H96c-17.7 0-32-14.3-32-32 0-17.6 14.4-32 32-32h285.4c-1.9 17.1-1.9 46.9 0 64z"
        ],
        "book-dead": [
            448,
            512,
            [],
            "f6b7",
            "M272 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm176 222.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM240 56c44.2 0 80 28.7 80 64 0 20.9-12.7 39.2-32 50.9V184c0 8.8-7.2 16-16 16h-64c-8.8 0-16-7.2-16-16v-13.1c-19.3-11.7-32-30-32-50.9 0-35.3 35.8-64 80-64zM124.8 223.3l6.3-14.7c1.7-4.1 6.4-5.9 10.5-4.2l98.3 42.1 98.4-42.1c4.1-1.7 8.8.1 10.5 4.2l6.3 14.7c1.7 4.1-.1 8.8-4.2 10.5L280.6 264l70.3 30.1c4.1 1.7 5.9 6.4 4.2 10.5l-6.3 14.7c-1.7 4.1-6.4 5.9-10.5 4.2L240 281.4l-98.3 42.2c-4.1 1.7-8.8-.1-10.5-4.2l-6.3-14.7c-1.7-4.1.1-8.8 4.2-10.5l70.4-30.1-70.5-30.3c-4.1-1.7-5.9-6.4-4.2-10.5zm256 224.7H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8zM208 136c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16z"
        ],
        "book-medical": [
            448,
            512,
            [],
            "f7e6",
            "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16q0-9.6-9.6-19.2c-3.2-16-3.2-60.8 0-73.6q9.6-4.8 9.6-19.2zM144 168a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8v48a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8zm236.8 280H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8z"
        ],
        "book-open": [
            576,
            512,
            [],
            "f518",
            "M542.22 32.05c-54.8 3.11-163.72 14.43-230.96 55.59-4.64 2.84-7.27 7.89-7.27 13.17v363.87c0 11.55 12.63 18.85 23.28 13.49 69.18-34.82 169.23-44.32 218.7-46.92 16.89-.89 30.02-14.43 30.02-30.66V62.75c.01-17.71-15.35-31.74-33.77-30.7zM264.73 87.64C197.5 46.48 88.58 35.17 33.78 32.05 15.36 31.01 0 45.04 0 62.75V400.6c0 16.24 13.13 29.78 30.02 30.66 49.49 2.6 149.59 12.11 218.77 46.95 10.62 5.35 23.21-1.94 23.21-13.46V100.63c0-5.29-2.62-10.14-7.27-12.99z"
        ],
        "book-reader": [
            512,
            512,
            [],
            "f5da",
            "M352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96 42.98 96 96 96 96-42.98 96-96zM233.59 241.1c-59.33-36.32-155.43-46.3-203.79-49.05C13.55 191.13 0 203.51 0 219.14v222.8c0 14.33 11.59 26.28 26.49 27.05 43.66 2.29 131.99 10.68 193.04 41.43 9.37 4.72 20.48-1.71 20.48-11.87V252.56c-.01-4.67-2.32-8.95-6.42-11.46zm248.61-49.05c-48.35 2.74-144.46 12.73-203.78 49.05-4.1 2.51-6.41 6.96-6.41 11.63v245.79c0 10.19 11.14 16.63 20.54 11.9 61.04-30.72 149.32-39.11 192.97-41.4 14.9-.78 26.49-12.73 26.49-27.06V219.14c-.01-15.63-13.56-28.01-29.81-27.09z"
        ],
        "bookmark": [
            384,
            512,
            [],
            "f02e",
            "M0 512V48C0 21.49 21.49 0 48 0h288c26.51 0 48 21.49 48 48v464L192 400 0 512z"
        ],
        "border-all": [
            448,
            512,
            [],
            "f84c",
            "M416 32H32A32 32 0 0 0 0 64v384a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V64a32 32 0 0 0-32-32zm-32 64v128H256V96zm-192 0v128H64V96zM64 416V288h128v128zm192 0V288h128v128z"
        ],
        "border-none": [
            448,
            512,
            [],
            "f850",
            "M240 224h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-288 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM240 320h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-384h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM48 224H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-192H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
        ],
        "border-style": [
            448,
            512,
            [],
            "f853",
            "M240 416h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-96 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm192 0h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm96-192h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0 96h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-288h-32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-96H32A32 32 0 0 0 0 64v400a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V96h368a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
        ],
        "bowling-ball": [
            496,
            512,
            [],
            "f436",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM120 192c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64-96c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm48 144c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
        ],
        "box": [
            512,
            512,
            [],
            "f466",
            "M509.5 184.6L458.9 32.8C452.4 13.2 434.1 0 413.4 0H272v192h238.7c-.4-2.5-.4-5-1.2-7.4zM240 0H98.6c-20.7 0-39 13.2-45.5 32.8L2.5 184.6c-.8 2.4-.8 4.9-1.2 7.4H240V0zM0 224v240c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V224H0z"
        ],
        "box-open": [
            640,
            512,
            [],
            "f49e",
            "M425.7 256c-16.9 0-32.8-9-41.4-23.4L320 126l-64.2 106.6c-8.7 14.5-24.6 23.5-41.5 23.5-4.5 0-9-.6-13.3-1.9L64 215v178c0 14.7 10 27.5 24.2 31l216.2 54.1c10.2 2.5 20.9 2.5 31 0L551.8 424c14.2-3.6 24.2-16.4 24.2-31V215l-137 39.1c-4.3 1.3-8.8 1.9-13.3 1.9zm212.6-112.2L586.8 41c-3.1-6.2-9.8-9.8-16.7-8.9L320 64l91.7 152.1c3.8 6.3 11.4 9.3 18.5 7.3l197.9-56.5c9.9-2.9 14.7-13.9 10.2-23.1zM53.2 41L1.7 143.8c-4.6 9.2.3 20.2 10.1 23l197.9 56.5c7.1 2 14.7-1 18.5-7.3L320 64 69.8 32.1c-6.9-.8-13.5 2.7-16.6 8.9z"
        ],
        "box-tissue": [
            512,
            512,
            [],
            "e05b",
            "M383.88,287.82l64-192H338.47a70.2,70.2,0,0,1-66.59-48,70.21,70.21,0,0,0-66.6-48H63.88l64,288Zm-384,192a32,32,0,0,0,32,32h448a32,32,0,0,0,32-32v-64H-.12Zm480-256H438.94l-21.33,64h14.27a16,16,0,0,1,0,32h-352a16,16,0,1,1,0-32H95.09l-14.22-64h-49a32,32,0,0,0-32,32v128h512v-128A32,32,0,0,0,479.88,223.82Z"
        ],
        "boxes": [
            576,
            512,
            [],
            "f468",
            "M560 288h-80v96l-32-21.3-32 21.3v-96h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16zm-384-64h224c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16h-80v96l-32-21.3L256 96V0h-80c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16zm64 64h-80v96l-32-21.3L96 384v-96H16c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16V304c0-8.8-7.2-16-16-16z"
        ],
        "braille": [
            640,
            512,
            [],
            "f2a1",
            "M128 256c0 35.346-28.654 64-64 64S0 291.346 0 256s28.654-64 64-64 64 28.654 64 64zM64 384c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352C28.654 32 0 60.654 0 96s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm224 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-352c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64zm160 192c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0 160c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm0-320c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
        ],
        "brain": [
            576,
            512,
            [],
            "f5dc",
            "M208 0c-29.9 0-54.7 20.5-61.8 48.2-.8 0-1.4-.2-2.2-.2-35.3 0-64 28.7-64 64 0 4.8.6 9.5 1.7 14C52.5 138 32 166.6 32 200c0 12.6 3.2 24.3 8.3 34.9C16.3 248.7 0 274.3 0 304c0 33.3 20.4 61.9 49.4 73.9-.9 4.6-1.4 9.3-1.4 14.1 0 39.8 32.2 72 72 72 4.1 0 8.1-.5 12-1.2 9.6 28.5 36.2 49.2 68 49.2 39.8 0 72-32.2 72-72V64c0-35.3-28.7-64-64-64zm368 304c0-29.7-16.3-55.3-40.3-69.1 5.2-10.6 8.3-22.3 8.3-34.9 0-33.4-20.5-62-49.7-74 1-4.5 1.7-9.2 1.7-14 0-35.3-28.7-64-64-64-.8 0-1.5.2-2.2.2C422.7 20.5 397.9 0 368 0c-35.3 0-64 28.6-64 64v376c0 39.8 32.2 72 72 72 31.8 0 58.4-20.7 68-49.2 3.9.7 7.9 1.2 12 1.2 39.8 0 72-32.2 72-72 0-4.8-.5-9.5-1.4-14.1 29-12 49.4-40.6 49.4-73.9z"
        ],
        "bread-slice": [
            576,
            512,
            [],
            "f7ec",
            "M288 0C108 0 0 93.4 0 169.14 0 199.44 24.24 224 64 224v256c0 17.67 16.12 32 36 32h376c19.88 0 36-14.33 36-32V224c39.76 0 64-24.56 64-54.86C576 93.4 468 0 288 0z"
        ],
        "briefcase": [
            512,
            512,
            [],
            "f0b1",
            "M320 336c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h416c25.6 0 48-22.4 48-48V288H320v48zm144-208h-80V80c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h512v-80c0-25.6-22.4-48-48-48zm-144 0H192V96h128v32z"
        ],
        "briefcase-medical": [
            512,
            512,
            [],
            "f469",
            "M464 128h-80V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V176c0-26.5-21.5-48-48-48zM192 96h128v32H192V96zm160 248c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48z"
        ],
        "broadcast-tower": [
            640,
            512,
            [],
            "f519",
            "M150.94 192h33.73c11.01 0 18.61-10.83 14.86-21.18-4.93-13.58-7.55-27.98-7.55-42.82s2.62-29.24 7.55-42.82C203.29 74.83 195.68 64 184.67 64h-33.73c-7.01 0-13.46 4.49-15.41 11.23C130.64 92.21 128 109.88 128 128c0 18.12 2.64 35.79 7.54 52.76 1.94 6.74 8.39 11.24 15.4 11.24zM89.92 23.34C95.56 12.72 87.97 0 75.96 0H40.63c-6.27 0-12.14 3.59-14.74 9.31C9.4 45.54 0 85.65 0 128c0 24.75 3.12 68.33 26.69 118.86 2.62 5.63 8.42 9.14 14.61 9.14h34.84c12.02 0 19.61-12.74 13.95-23.37-49.78-93.32-16.71-178.15-.17-209.29zM614.06 9.29C611.46 3.58 605.6 0 599.33 0h-35.42c-11.98 0-19.66 12.66-14.02 23.25 18.27 34.29 48.42 119.42.28 209.23-5.72 10.68 1.8 23.52 13.91 23.52h35.23c6.27 0 12.13-3.58 14.73-9.29C630.57 210.48 640 170.36 640 128s-9.42-82.48-25.94-118.71zM489.06 64h-33.73c-11.01 0-18.61 10.83-14.86 21.18 4.93 13.58 7.55 27.98 7.55 42.82s-2.62 29.24-7.55 42.82c-3.76 10.35 3.85 21.18 14.86 21.18h33.73c7.02 0 13.46-4.49 15.41-11.24 4.9-16.97 7.53-34.64 7.53-52.76 0-18.12-2.64-35.79-7.54-52.76-1.94-6.75-8.39-11.24-15.4-11.24zm-116.3 100.12c7.05-10.29 11.2-22.71 11.2-36.12 0-35.35-28.63-64-63.96-64-35.32 0-63.96 28.65-63.96 64 0 13.41 4.15 25.83 11.2 36.12l-130.5 313.41c-3.4 8.15.46 17.52 8.61 20.92l29.51 12.31c8.15 3.4 17.52-.46 20.91-8.61L244.96 384h150.07l49.2 118.15c3.4 8.16 12.76 12.01 20.91 8.61l29.51-12.31c8.15-3.4 12-12.77 8.61-20.92l-130.5-313.41zM271.62 320L320 203.81 368.38 320h-96.76z"
        ],
        "broom": [
            640,
            512,
            [],
            "f51a",
            "M256.47 216.77l86.73 109.18s-16.6 102.36-76.57 150.12C206.66 523.85 0 510.19 0 510.19s3.8-23.14 11-55.43l94.62-112.17c3.97-4.7-.87-11.62-6.65-9.5l-60.4 22.09c14.44-41.66 32.72-80.04 54.6-97.47 59.97-47.76 163.3-40.94 163.3-40.94zM636.53 31.03l-19.86-25c-5.49-6.9-15.52-8.05-22.41-2.56l-232.48 177.8-34.14-42.97c-5.09-6.41-15.14-5.21-18.59 2.21l-25.33 54.55 86.73 109.18 58.8-12.45c8-1.69 11.42-11.2 6.34-17.6l-34.09-42.92 232.48-177.8c6.89-5.48 8.04-15.53 2.55-22.44z"
        ],
        "brush": [
            384,
            512,
            [],
            "f55d",
            "M352 0H32C14.33 0 0 14.33 0 32v224h384V32c0-17.67-14.33-32-32-32zM0 320c0 35.35 28.66 64 64 64h64v64c0 35.35 28.66 64 64 64s64-28.65 64-64v-64h64c35.34 0 64-28.65 64-64v-32H0v32zm192 104c13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24s-24-10.75-24-24c0-13.26 10.75-24 24-24z"
        ],
        "bug": [
            512,
            512,
            [],
            "f188",
            "M511.988 288.9c-.478 17.43-15.217 31.1-32.653 31.1H424v16c0 21.864-4.882 42.584-13.6 61.145l60.228 60.228c12.496 12.497 12.496 32.758 0 45.255-12.498 12.497-32.759 12.496-45.256 0l-54.736-54.736C345.886 467.965 314.351 480 280 480V236c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v244c-34.351 0-65.886-12.035-90.636-32.108l-54.736 54.736c-12.498 12.497-32.759 12.496-45.256 0-12.496-12.497-12.496-32.758 0-45.255l60.228-60.228C92.882 378.584 88 357.864 88 336v-16H32.666C15.23 320 .491 306.33.013 288.9-.484 270.816 14.028 256 32 256h56v-58.745l-46.628-46.628c-12.496-12.497-12.496-32.758 0-45.255 12.498-12.497 32.758-12.497 45.256 0L141.255 160h229.489l54.627-54.627c12.498-12.497 32.758-12.497 45.256 0 12.496 12.497 12.496 32.758 0 45.255L424 197.255V256h56c17.972 0 32.484 14.816 31.988 32.9zM257 0c-61.856 0-112 50.144-112 112h224C369 50.144 318.856 0 257 0z"
        ],
        "building": [
            448,
            512,
            [],
            "f1ad",
            "M436 480h-20V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v456H12c-6.627 0-12 5.373-12 12v20h448v-20c0-6.627-5.373-12-12-12zM128 76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76zm0 96c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40zm52 148h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12zm76 160h-64v-84c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v84zm64-172c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40zm0-96c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12V76c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40z"
        ],
        "bullhorn": [
            576,
            512,
            [],
            "f0a1",
            "M576 240c0-23.63-12.95-44.04-32-55.12V32.01C544 23.26 537.02 0 512 0c-7.12 0-14.19 2.38-19.98 7.02l-85.03 68.03C364.28 109.19 310.66 128 256 128H64c-35.35 0-64 28.65-64 64v96c0 35.35 28.65 64 64 64h33.7c-1.39 10.48-2.18 21.14-2.18 32 0 39.77 9.26 77.35 25.56 110.94 5.19 10.69 16.52 17.06 28.4 17.06h74.28c26.05 0 41.69-29.84 25.9-50.56-16.4-21.52-26.15-48.36-26.15-77.44 0-11.11 1.62-21.79 4.41-32H256c54.66 0 108.28 18.81 150.98 52.95l85.03 68.03a32.023 32.023 0 0 0 19.98 7.02c24.92 0 32-22.78 32-32V295.13C563.05 284.04 576 263.63 576 240zm-96 141.42l-33.05-26.44C392.95 311.78 325.12 288 256 288v-96c69.12 0 136.95-23.78 190.95-66.98L480 98.58v282.84z"
        ],
        "bullseye": [
            496,
            512,
            [],
            "f140",
            "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 432c-101.69 0-184-82.29-184-184 0-101.69 82.29-184 184-184 101.69 0 184 82.29 184 184 0 101.69-82.29 184-184 184zm0-312c-70.69 0-128 57.31-128 128s57.31 128 128 128 128-57.31 128-128-57.31-128-128-128zm0 192c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64z"
        ],
        "burn": [
            384,
            512,
            [],
            "f46a",
            "M192 0C79.7 101.3 0 220.9 0 300.5 0 425 79 512 192 512s192-87 192-211.5c0-79.9-80.2-199.6-192-300.5zm0 448c-56.5 0-96-39-96-94.8 0-13.5 4.6-61.5 96-161.2 91.4 99.7 96 147.7 96 161.2 0 55.8-39.5 94.8-96 94.8z"
        ],
        "bus": [
            512,
            512,
            [],
            "f207",
            "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM112 400c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm16-112c-17.67 0-32-14.33-32-32V128c0-17.67 14.33-32 32-32h256c17.67 0 32 14.33 32 32v128c0 17.67-14.33 32-32 32H128zm272 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
        ],
        "bus-alt": [
            512,
            512,
            [],
            "f55e",
            "M488 128h-8V80c0-44.8-99.2-80-224-80S32 35.2 32 80v48h-8c-13.25 0-24 10.74-24 24v80c0 13.25 10.75 24 24 24h8v160c0 17.67 14.33 32 32 32v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h192v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h6.4c16 0 25.6-12.8 25.6-25.6V256h8c13.25 0 24-10.75 24-24v-80c0-13.26-10.75-24-24-24zM160 72c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H168c-4.42 0-8-3.58-8-8V72zm-48 328c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128-112H128c-17.67 0-32-14.33-32-32v-96c0-17.67 14.33-32 32-32h112v160zm32 0V128h112c17.67 0 32 14.33 32 32v96c0 17.67-14.33 32-32 32H272zm128 112c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
        ],
        "business-time": [
            640,
            512,
            [],
            "f64a",
            "M496 224c-79.59 0-144 64.41-144 144s64.41 144 144 144 144-64.41 144-144-64.41-144-144-144zm64 150.29c0 5.34-4.37 9.71-9.71 9.71h-60.57c-5.34 0-9.71-4.37-9.71-9.71v-76.57c0-5.34 4.37-9.71 9.71-9.71h12.57c5.34 0 9.71 4.37 9.71 9.71V352h38.29c5.34 0 9.71 4.37 9.71 9.71v12.58zM496 192c5.4 0 10.72.33 16 .81V144c0-25.6-22.4-48-48-48h-80V48c0-25.6-22.4-48-48-48H176c-25.6 0-48 22.4-48 48v48H48c-25.6 0-48 22.4-48 48v80h395.12c28.6-20.09 63.35-32 100.88-32zM320 96H192V64h128v32zm6.82 224H208c-8.84 0-16-7.16-16-16v-48H0v144c0 25.6 22.4 48 48 48h291.43C327.1 423.96 320 396.82 320 368c0-16.66 2.48-32.72 6.82-48z"
        ],
        "calculator": [
            448,
            512,
            [],
            "f1ec",
            "M400 0H48C22.4 0 0 22.4 0 48v416c0 25.6 22.4 48 48 48h352c25.6 0 48-22.4 48-48V48c0-25.6-22.4-48-48-48zM128 435.2c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm128 128c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8V268.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v166.4zm0-256c0 6.4-6.4 12.8-12.8 12.8H76.8c-6.4 0-12.8-6.4-12.8-12.8V76.8C64 70.4 70.4 64 76.8 64h294.4c6.4 0 12.8 6.4 12.8 12.8v102.4z"
        ],
        "calendar": [
            448,
            512,
            [],
            "f133",
            "M12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm436-44v-36c0-26.5-21.5-48-48-48h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v36c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12z"
        ],
        "calendar-alt": [
            448,
            512,
            [],
            "f073",
            "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm320-196c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM192 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40zM64 268c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zm0 128c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
        ],
        "calendar-check": [
            448,
            512,
            [],
            "f274",
            "M436 160H12c-6.627 0-12-5.373-12-12v-36c0-26.51 21.49-48 48-48h48V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h128V12c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v52h48c26.51 0 48 21.49 48 48v36c0 6.627-5.373 12-12 12zM12 192h424c6.627 0 12 5.373 12 12v260c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V204c0-6.627 5.373-12 12-12zm333.296 95.947l-28.169-28.398c-4.667-4.705-12.265-4.736-16.97-.068L194.12 364.665l-45.98-46.352c-4.667-4.705-12.266-4.736-16.971-.068l-28.397 28.17c-4.705 4.667-4.736 12.265-.068 16.97l82.601 83.269c4.667 4.705 12.265 4.736 16.97.068l142.953-141.805c4.705-4.667 4.736-12.265.068-16.97z"
        ],
        "calendar-day": [
            448,
            512,
            [],
            "f783",
            "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h96c8.8 0 16 7.2 16 16v96c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-96zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
        ],
        "calendar-minus": [
            448,
            512,
            [],
            "f272",
            "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm304 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H132c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h184z"
        ],
        "calendar-plus": [
            448,
            512,
            [],
            "f271",
            "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm316 140c0-6.6-5.4-12-12-12h-60v-60c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v60h-60c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h60v60c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-60h60c6.6 0 12-5.4 12-12v-40z"
        ],
        "calendar-times": [
            448,
            512,
            [],
            "f273",
            "M436 160H12c-6.6 0-12-5.4-12-12v-36c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48v36c0 6.6-5.4 12-12 12zM12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm257.3 160l48.1-48.1c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0L224 306.7l-48.1-48.1c-4.7-4.7-12.3-4.7-17 0l-28.3 28.3c-4.7 4.7-4.7 12.3 0 17l48.1 48.1-48.1 48.1c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l48.1-48.1 48.1 48.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L269.3 352z"
        ],
        "calendar-week": [
            448,
            512,
            [],
            "f784",
            "M0 464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V192H0v272zm64-192c0-8.8 7.2-16 16-16h288c8.8 0 16 7.2 16 16v64c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16v-64zM400 64h-48V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H160V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48H48C21.5 64 0 85.5 0 112v48h448v-48c0-26.5-21.5-48-48-48z"
        ],
        "camera": [
            512,
            512,
            [],
            "f030",
            "M512 144v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V144c0-26.5 21.5-48 48-48h88l12.3-32.9c7-18.7 24.9-31.1 44.9-31.1h125.5c20 0 37.9 12.4 44.9 31.1L376 96h88c26.5 0 48 21.5 48 48zM376 288c0-66.2-53.8-120-120-120s-120 53.8-120 120 53.8 120 120 120 120-53.8 120-120zm-32 0c0 48.5-39.5 88-88 88s-88-39.5-88-88 39.5-88 88-88 88 39.5 88 88z"
        ],
        "camera-retro": [
            512,
            512,
            [],
            "f083",
            "M48 32C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48H48zm0 32h106c3.3 0 6 2.7 6 6v20c0 3.3-2.7 6-6 6H38c-3.3 0-6-2.7-6-6V80c0-8.8 7.2-16 16-16zm426 96H38c-3.3 0-6-2.7-6-6v-36c0-3.3 2.7-6 6-6h138l30.2-45.3c1.1-1.7 3-2.7 5-2.7H464c8.8 0 16 7.2 16 16v74c0 3.3-2.7 6-6 6zM256 424c-66.2 0-120-53.8-120-120s53.8-120 120-120 120 53.8 120 120-53.8 120-120 120zm0-208c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm-48 104c-8.8 0-16-7.2-16-16 0-35.3 28.7-64 64-64 8.8 0 16 7.2 16 16s-7.2 16-16 16c-17.6 0-32 14.4-32 32 0 8.8-7.2 16-16 16z"
        ],
        "campground": [
            640,
            512,
            [],
            "f6bb",
            "M624 448h-24.68L359.54 117.75l53.41-73.55c5.19-7.15 3.61-17.16-3.54-22.35l-25.9-18.79c-7.15-5.19-17.15-3.61-22.35 3.55L320 63.3 278.83 6.6c-5.19-7.15-15.2-8.74-22.35-3.55l-25.88 18.8c-7.15 5.19-8.74 15.2-3.54 22.35l53.41 73.55L40.68 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM320 288l116.36 160H203.64L320 288z"
        ],
        "candy-cane": [
            512,
            512,
            [],
            "f786",
            "M497.5 92C469.6 33.1 411.8 0 352.4 0c-27.9 0-56.2 7.3-81.8 22.6L243.1 39c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5l27.5-16.4c5.1-3.1 10.8-4.5 16.4-4.5 10.9 0 21.5 5.6 27.5 15.6 9.1 15.1 4.1 34.8-11 43.9L15.6 397.6c-15.2 9.1-20.1 28.7-11 43.9l32.8 54.9c6 10 16.6 15.6 27.5 15.6 5.6 0 11.2-1.5 16.4-4.5L428.6 301c71.7-42.9 104.6-133.5 68.9-209zm-177.7 13l-2.5 1.5L296.8 45c9.7-4.7 19.8-8.1 30.3-10.2l20.6 61.8c-9.8.8-19.4 3.3-27.9 8.4zM145.9 431.8l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm107.5-63.9l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zM364.3 302l-60.5-38.5 30.8-18.3 60.5 38.5-30.8 18.3zm20.4-197.3l46-46c8.4 6.5 16 14.1 22.6 22.6L407.6 127c-5.7-9.3-13.7-16.9-22.9-22.3zm82.1 107.8l-59.5-19.8c3.2-5.3 5.8-10.9 7.4-17.1 1.1-4.5 1.7-9.1 1.8-13.6l60.4 20.1c-2.1 10.4-5.5 20.6-10.1 30.4z"
        ],
        "cannabis": [
            512,
            512,
            [],
            "f55f",
            "M503.47 360.25c-1.56-.82-32.39-16.89-76.78-25.81 64.25-75.12 84.05-161.67 84.93-165.64 1.18-5.33-.44-10.9-4.3-14.77-3.03-3.04-7.12-4.7-11.32-4.7-1.14 0-2.29.12-3.44.38-3.88.85-86.54 19.59-160.58 79.76.01-1.46.01-2.93.01-4.4 0-118.79-59.98-213.72-62.53-217.7A15.973 15.973 0 0 0 256 0c-5.45 0-10.53 2.78-13.47 7.37-2.55 3.98-62.53 98.91-62.53 217.7 0 1.47.01 2.94.01 4.4-74.03-60.16-156.69-78.9-160.58-79.76-1.14-.25-2.29-.38-3.44-.38-4.2 0-8.29 1.66-11.32 4.7A15.986 15.986 0 0 0 .38 168.8c.88 3.97 20.68 90.52 84.93 165.64-44.39 8.92-75.21 24.99-76.78 25.81a16.003 16.003 0 0 0-.02 28.29c2.45 1.29 60.76 31.72 133.49 31.72 6.14 0 11.96-.1 17.5-.31-11.37 22.23-16.52 38.31-16.81 39.22-1.8 5.68-.29 11.89 3.91 16.11a16.019 16.019 0 0 0 16.1 3.99c1.83-.57 37.72-11.99 77.3-39.29V504c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-64.01c39.58 27.3 75.47 38.71 77.3 39.29a16.019 16.019 0 0 0 16.1-3.99c4.2-4.22 5.71-10.43 3.91-16.11-.29-.91-5.45-16.99-16.81-39.22 5.54.21 11.37.31 17.5.31 72.72 0 131.04-30.43 133.49-31.72 5.24-2.78 8.52-8.22 8.51-14.15-.01-5.94-3.29-11.39-8.53-14.15z"
        ],
        "capsules": [
            576,
            512,
            [],
            "f46b",
            "M555.3 300.1L424.2 112.8C401.9 81 366.4 64 330.4 64c-22.6 0-45.5 6.7-65.5 20.7-19.7 13.8-33.7 32.8-41.5 53.8C220.5 79.2 172 32 112 32 50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V218.9c3.3 8.6 7.3 17.1 12.8 25L368 431.2c22.2 31.8 57.7 48.8 93.8 48.8 22.7 0 45.5-6.7 65.5-20.7 51.7-36.2 64.2-107.5 28-159.2zM160 256H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm194.8 44.9l-65.6-93.7c-7.7-11-10.7-24.4-8.3-37.6 2.3-13.2 9.7-24.8 20.7-32.5 8.5-6 18.5-9.1 28.8-9.1 16.5 0 31.9 8 41.3 21.5l65.6 93.7-82.5 57.7z"
        ],
        "car": [
            512,
            512,
            [],
            "f1b9",
            "M499.99 176h-59.87l-16.64-41.6C406.38 91.63 365.57 64 319.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4L71.87 176H12.01C4.2 176-1.53 183.34.37 190.91l6 24C7.7 220.25 12.5 224 18.01 224h20.07C24.65 235.73 16 252.78 16 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-19.22-8.65-36.27-22.07-48H494c5.51 0 10.31-3.75 11.64-9.09l6-24c1.89-7.57-3.84-14.91-11.65-14.91zm-352.06-17.83c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L384 208H128l19.93-49.83zM96 319.8c-19.2 0-32-12.76-32-31.9S76.8 256 96 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S396.8 256 416 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"
        ],
        "car-alt": [
            480,
            512,
            [],
            "f5de",
            "M438.66 212.33l-11.24-28.1-19.93-49.83C390.38 91.63 349.57 64 303.5 64h-127c-46.06 0-86.88 27.63-103.99 70.4l-19.93 49.83-11.24 28.1C17.22 221.5 0 244.66 0 272v48c0 16.12 6.16 30.67 16 41.93V416c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-54.07c9.84-11.25 16-25.8 16-41.93v-48c0-27.34-17.22-50.5-41.34-59.67zm-306.73-54.16c7.29-18.22 24.94-30.17 44.57-30.17h127c19.63 0 37.28 11.95 44.57 30.17L368 208H112l19.93-49.83zM80 319.8c-19.2 0-32-12.76-32-31.9S60.8 256 80 256s48 28.71 48 47.85-28.8 15.95-48 15.95zm320 0c-19.2 0-48 3.19-48-15.95S380.8 256 400 256s32 12.76 32 31.9-12.8 31.9-32 31.9z"
        ],
        "car-battery": [
            512,
            512,
            [],
            "f5df",
            "M480 128h-32V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v48H192V80c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v48H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32zM192 264c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm256 0c0 4.42-3.58 8-8 8h-40v40c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-40h-40c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h40v-40c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v40h40c4.42 0 8 3.58 8 8v16z"
        ],
        "car-crash": [
            640,
            512,
            [],
            "f5e1",
            "M143.25 220.81l-12.42 46.37c-3.01 11.25-3.63 22.89-2.41 34.39l-35.2 28.98c-6.57 5.41-16.31-.43-14.62-8.77l15.44-76.68c1.06-5.26-2.66-10.28-8-10.79l-77.86-7.55c-8.47-.82-11.23-11.83-4.14-16.54l65.15-43.3c4.46-2.97 5.38-9.15 1.98-13.29L21.46 93.22c-5.41-6.57.43-16.3 8.78-14.62l76.68 15.44c5.26 1.06 10.28-2.66 10.8-8l7.55-77.86c.82-8.48 11.83-11.23 16.55-4.14l43.3 65.14c2.97 4.46 9.15 5.38 13.29 1.98l60.4-49.71c6.57-5.41 16.3.43 14.62 8.77L262.1 86.38c-2.71 3.05-5.43 6.09-7.91 9.4l-32.15 42.97-10.71 14.32c-32.73 8.76-59.18 34.53-68.08 67.74zm494.57 132.51l-12.42 46.36c-3.13 11.68-9.38 21.61-17.55 29.36a66.876 66.876 0 0 1-8.76 7l-13.99 52.23c-1.14 4.27-3.1 8.1-5.65 11.38-7.67 9.84-20.74 14.68-33.54 11.25L515 502.62c-17.07-4.57-27.2-22.12-22.63-39.19l8.28-30.91-247.28-66.26-8.28 30.91c-4.57 17.07-22.12 27.2-39.19 22.63l-30.91-8.28c-12.8-3.43-21.7-14.16-23.42-26.51-.57-4.12-.35-8.42.79-12.68l13.99-52.23a66.62 66.62 0 0 1-4.09-10.45c-3.2-10.79-3.65-22.52-.52-34.2l12.42-46.37c5.31-19.8 19.36-34.83 36.89-42.21a64.336 64.336 0 0 1 18.49-4.72l18.13-24.23 32.15-42.97c3.45-4.61 7.19-8.9 11.2-12.84 8-7.89 17.03-14.44 26.74-19.51 4.86-2.54 9.89-4.71 15.05-6.49 10.33-3.58 21.19-5.63 32.24-6.04 11.05-.41 22.31.82 33.43 3.8l122.68 32.87c11.12 2.98 21.48 7.54 30.85 13.43a111.11 111.11 0 0 1 34.69 34.5c8.82 13.88 14.64 29.84 16.68 46.99l6.36 53.29 3.59 30.05a64.49 64.49 0 0 1 22.74 29.93c4.39 11.88 5.29 25.19 1.75 38.39zM255.58 234.34c-18.55-4.97-34.21 4.04-39.17 22.53-4.96 18.49 4.11 34.12 22.65 39.09 18.55 4.97 45.54 15.51 50.49-2.98 4.96-18.49-15.43-53.67-33.97-58.64zm290.61 28.17l-6.36-53.29c-.58-4.87-1.89-9.53-3.82-13.86-5.8-12.99-17.2-23.01-31.42-26.82l-122.68-32.87a48.008 48.008 0 0 0-50.86 17.61l-32.15 42.97 172 46.08 75.29 20.18zm18.49 54.65c-18.55-4.97-53.8 15.31-58.75 33.79-4.95 18.49 23.69 22.86 42.24 27.83 18.55 4.97 34.21-4.04 39.17-22.53 4.95-18.48-4.11-34.12-22.66-39.09z"
        ],
        "car-side": [
            640,
            512,
            [],
            "f5e4",
            "M544 192h-16L419.22 56.02A64.025 64.025 0 0 0 369.24 32H155.33c-26.17 0-49.7 15.93-59.42 40.23L48 194.26C20.44 201.4 0 226.21 0 256v112c0 8.84 7.16 16 16 16h48c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h48c8.84 0 16-7.16 16-16v-80c0-53.02-42.98-96-96-96zM160 432c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm72-240H116.93l38.4-96H232v96zm48 0V96h89.24l76.8 96H280zm200 240c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"
        ],
        "caravan": [
            640,
            512,
            [],
            "f8ff",
            "M416,208a16,16,0,1,0,16,16A16,16,0,0,0,416,208ZM624,320H576V160A160,160,0,0,0,416,0H64A64,64,0,0,0,0,64V320a64,64,0,0,0,64,64H96a96,96,0,0,0,192,0H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM192,432a48,48,0,1,1,48-48A48.05,48.05,0,0,1,192,432Zm64-240a32,32,0,0,1-32,32H96a32,32,0,0,1-32-32V128A32,32,0,0,1,96,96H224a32,32,0,0,1,32,32ZM448,320H320V128a32,32,0,0,1,32-32h64a32,32,0,0,1,32,32Z"
        ],
        "caret-down": [
            320,
            512,
            [],
            "f0d7",
            "M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"
        ],
        "caret-left": [
            192,
            512,
            [],
            "f0d9",
            "M192 127.338v257.324c0 17.818-21.543 26.741-34.142 14.142L29.196 270.142c-7.81-7.81-7.81-20.474 0-28.284l128.662-128.662c12.599-12.6 34.142-3.676 34.142 14.142z"
        ],
        "caret-right": [
            192,
            512,
            [],
            "f0da",
            "M0 384.662V127.338c0-17.818 21.543-26.741 34.142-14.142l128.662 128.662c7.81 7.81 7.81 20.474 0 28.284L34.142 398.804C21.543 411.404 0 402.48 0 384.662z"
        ],
        "caret-square-down": [
            448,
            512,
            [],
            "f150",
            "M448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM92.5 220.5l123 123c4.7 4.7 12.3 4.7 17 0l123-123c7.6-7.6 2.2-20.5-8.5-20.5H101c-10.7 0-16.1 12.9-8.5 20.5z"
        ],
        "caret-square-left": [
            448,
            512,
            [],
            "f191",
            "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM259.515 124.485l-123.03 123.03c-4.686 4.686-4.686 12.284 0 16.971l123.029 123.029c7.56 7.56 20.485 2.206 20.485-8.485V132.971c.001-10.691-12.925-16.045-20.484-8.486z"
        ],
        "caret-square-right": [
            448,
            512,
            [],
            "f152",
            "M48 32h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48zm140.485 355.515l123.029-123.029c4.686-4.686 4.686-12.284 0-16.971l-123.029-123.03c-7.56-7.56-20.485-2.206-20.485 8.485v246.059c0 10.691 12.926 16.045 20.485 8.486z"
        ],
        "caret-square-up": [
            448,
            512,
            [],
            "f151",
            "M0 432V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48zm355.515-140.485l-123.03-123.03c-4.686-4.686-12.284-4.686-16.971 0L92.485 291.515c-7.56 7.56-2.206 20.485 8.485 20.485h246.059c10.691 0 16.045-12.926 8.486-20.485z"
        ],
        "caret-up": [
            320,
            512,
            [],
            "f0d8",
            "M288.662 352H31.338c-17.818 0-26.741-21.543-14.142-34.142l128.662-128.662c7.81-7.81 20.474-7.81 28.284 0l128.662 128.662c12.6 12.599 3.676 34.142-14.142 34.142z"
        ],
        "carrot": [
            512,
            512,
            [],
            "f787",
            "M298.2 156.6c-52.7-25.7-114.5-10.5-150.2 32.8l55.2 55.2c6.3 6.3 6.3 16.4 0 22.6-3.1 3.1-7.2 4.7-11.3 4.7s-8.2-1.6-11.3-4.7L130.4 217 2.3 479.7c-2.9 6-3.1 13.3 0 19.7 5.4 11.1 18.9 15.7 30 10.3l133.6-65.2-49.2-49.2c-6.3-6.2-6.3-16.4 0-22.6 6.3-6.2 16.4-6.2 22.6 0l57 57 102-49.8c24-11.7 44.5-31.3 57.1-57.1 30.1-61.7 4.5-136.1-57.2-166.2zm92.1-34.9C409.8 81 399.7 32.9 360 0c-50.3 41.7-52.5 107.5-7.9 151.9l8 8c44.4 44.6 110.3 42.4 151.9-7.9-32.9-39.7-81-49.8-121.7-30.3z"
        ],
        "cart-arrow-down": [
            576,
            512,
            [],
            "f218",
            "M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM403.029 192H360v-60c0-6.627-5.373-12-12-12h-24c-6.627 0-12 5.373-12 12v60h-43.029c-10.691 0-16.045 12.926-8.485 20.485l67.029 67.029c4.686 4.686 12.284 4.686 16.971 0l67.029-67.029c7.559-7.559 2.205-20.485-8.486-20.485z"
        ],
        "cart-plus": [
            576,
            512,
            [],
            "f217",
            "M504.717 320H211.572l6.545 32h268.418c15.401 0 26.816 14.301 23.403 29.319l-5.517 24.276C523.112 414.668 536 433.828 536 456c0 31.202-25.519 56.444-56.824 55.994-29.823-.429-54.35-24.631-55.155-54.447-.44-16.287 6.085-31.049 16.803-41.548H231.176C241.553 426.165 248 440.326 248 456c0 31.813-26.528 57.431-58.67 55.938-28.54-1.325-51.751-24.385-53.251-52.917-1.158-22.034 10.436-41.455 28.051-51.586L93.883 64H24C10.745 64 0 53.255 0 40V24C0 10.745 10.745 0 24 0h102.529c11.401 0 21.228 8.021 23.513 19.19L159.208 64H551.99c15.401 0 26.816 14.301 23.403 29.319l-47.273 208C525.637 312.246 515.923 320 504.717 320zM408 168h-48v-40c0-8.837-7.163-16-16-16h-16c-8.837 0-16 7.163-16 16v40h-48c-8.837 0-16 7.163-16 16v16c0 8.837 7.163 16 16 16h48v40c0 8.837 7.163 16 16 16h16c8.837 0 16-7.163 16-16v-40h48c8.837 0 16-7.163 16-16v-16c0-8.837-7.163-16-16-16z"
        ],
        "cash-register": [
            512,
            512,
            [],
            "f788",
            "M511.1 378.8l-26.7-160c-2.6-15.4-15.9-26.7-31.6-26.7H208v-64h96c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h96v64H59.1c-15.6 0-29 11.3-31.6 26.7L.8 378.7c-.6 3.5-.9 7-.9 10.5V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-90.7c.1-3.5-.2-7-.8-10.5zM280 248c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16zm-32 64h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16zm-32-80c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16zM80 80V48h192v32H80zm40 200h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16zm16 64v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16zm216 112c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16zm24-112c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16zm48-80c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v16z"
        ],
        "cat": [
            512,
            512,
            [],
            "f6be",
            "M290.59 192c-20.18 0-106.82 1.98-162.59 85.95V192c0-52.94-43.06-96-96-96-17.67 0-32 14.33-32 32s14.33 32 32 32c17.64 0 32 14.36 32 32v256c0 35.3 28.7 64 64 64h176c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-32l128-96v144c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V289.86c-10.29 2.67-20.89 4.54-32 4.54-61.81 0-113.52-44.05-125.41-102.4zM448 96h-64l-64-64v134.4c0 53.02 42.98 96 96 96s96-42.98 96-96V32l-64 64zm-72 80c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm80 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
        ],
        "certificate": [
            512,
            512,
            [],
            "f0a3",
            "M458.622 255.92l45.985-45.005c13.708-12.977 7.316-36.039-10.664-40.339l-62.65-15.99 17.661-62.015c4.991-17.838-11.829-34.663-29.661-29.671l-61.994 17.667-15.984-62.671C337.085.197 313.765-6.276 300.99 7.228L256 53.57 211.011 7.229c-12.63-13.351-36.047-7.234-40.325 10.668l-15.984 62.671-61.995-17.667C74.87 57.907 58.056 74.738 63.046 92.572l17.661 62.015-62.65 15.99C.069 174.878-6.31 197.944 7.392 210.915l45.985 45.005-45.985 45.004c-13.708 12.977-7.316 36.039 10.664 40.339l62.65 15.99-17.661 62.015c-4.991 17.838 11.829 34.663 29.661 29.671l61.994-17.667 15.984 62.671c4.439 18.575 27.696 24.018 40.325 10.668L256 458.61l44.989 46.001c12.5 13.488 35.987 7.486 40.325-10.668l15.984-62.671 61.994 17.667c17.836 4.994 34.651-11.837 29.661-29.671l-17.661-62.015 62.65-15.99c17.987-4.302 24.366-27.367 10.664-40.339l-45.984-45.004z"
        ],
        "chair": [
            448,
            512,
            [],
            "f6c0",
            "M112 128c0-29.5 16.2-55 40-68.9V256h48V48h48v208h48V59.1c23.8 13.9 40 39.4 40 68.9v128h48V128C384 57.3 326.7 0 256 0h-64C121.3 0 64 57.3 64 128v128h48zm334.3 213.9l-10.7-32c-4.4-13.1-16.6-21.9-30.4-21.9H42.7c-13.8 0-26 8.8-30.4 21.9l-10.7 32C-5.2 362.6 10.2 384 32 384v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384h256v112c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V384c21.8 0 37.2-21.4 30.3-42.1z"
        ],
        "chalkboard": [
            640,
            512,
            [],
            "f51b",
            "M96 64h448v352h64V40c0-22.06-17.94-40-40-40H72C49.94 0 32 17.94 32 40v376h64V64zm528 384H480v-64H288v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
        ],
        "chalkboard-teacher": [
            640,
            512,
            [],
            "f51c",
            "M208 352c-2.39 0-4.78.35-7.06 1.09C187.98 357.3 174.35 360 160 360c-14.35 0-27.98-2.7-40.95-6.91-2.28-.74-4.66-1.09-7.05-1.09C49.94 352-.33 402.48 0 464.62.14 490.88 21.73 512 48 512h224c26.27 0 47.86-21.12 48-47.38.33-62.14-49.94-112.62-112-112.62zm-48-32c53.02 0 96-42.98 96-96s-42.98-96-96-96-96 42.98-96 96 42.98 96 96 96zM592 0H208c-26.47 0-48 22.25-48 49.59V96c23.42 0 45.1 6.78 64 17.8V64h352v288h-64v-64H384v64h-76.24c19.1 16.69 33.12 38.73 39.69 64H592c26.47 0 48-22.25 48-49.59V49.59C640 22.25 618.47 0 592 0z"
        ],
        "charging-station": [
            576,
            512,
            [],
            "f5e7",
            "M336 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h320c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm208-320V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-32V80c0-8.84-7.16-16-16-16s-16 7.16-16 16v48h-16c-8.84 0-16 7.16-16 16v32c0 35.76 23.62 65.69 56 75.93v118.49c0 13.95-9.5 26.92-23.26 29.19C431.22 402.5 416 388.99 416 372v-28c0-48.6-39.4-88-88-88h-8V64c0-35.35-28.65-64-64-64H96C60.65 0 32 28.65 32 64v352h288V304h8c22.09 0 40 17.91 40 40v24.61c0 39.67 28.92 75.16 68.41 79.01C481.71 452.05 520 416.41 520 372V251.93c32.38-10.24 56-40.17 56-75.93v-32c0-8.84-7.16-16-16-16h-16zm-283.91 47.76l-93.7 139c-2.2 3.33-6.21 5.24-10.39 5.24-7.67 0-13.47-6.28-11.67-12.92L167.35 224H108c-7.25 0-12.85-5.59-11.89-11.89l16-107C112.9 99.9 117.98 96 124 96h68c7.88 0 13.62 6.54 11.6 13.21L192 160h57.7c9.24 0 15.01 8.78 10.39 15.76z"
        ],
        "chart-area": [
            512,
            512,
            [],
            "f1fe",
            "M500 384c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v308h436zM372.7 159.5L288 216l-85.3-113.7c-5.1-6.8-15.5-6.3-19.9 1L96 248v104h384l-89.9-187.8c-3.2-6.5-11.4-8.7-17.4-4.7z"
        ],
        "chart-bar": [
            512,
            512,
            [],
            "f080",
            "M332.8 320h38.4c6.4 0 12.8-6.4 12.8-12.8V172.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V76.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-288 0h38.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h38.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-38.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zM496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
        ],
        "chart-line": [
            512,
            512,
            [],
            "f201",
            "M496 384H64V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM464 96H345.94c-21.38 0-32.09 25.85-16.97 40.97l32.4 32.4L288 242.75l-73.37-73.37c-12.5-12.5-32.76-12.5-45.25 0l-68.69 68.69c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L192 237.25l73.37 73.37c12.5 12.5 32.76 12.5 45.25 0l96-96 32.4 32.4c15.12 15.12 40.97 4.41 40.97-16.97V112c.01-8.84-7.15-16-15.99-16z"
        ],
        "chart-pie": [
            544,
            512,
            [],
            "f200",
            "M527.79 288H290.5l158.03 158.03c6.04 6.04 15.98 6.53 22.19.68 38.7-36.46 65.32-85.61 73.13-140.86 1.34-9.46-6.51-17.85-16.06-17.85zm-15.83-64.8C503.72 103.74 408.26 8.28 288.8.04 279.68-.59 272 7.1 272 16.24V240h223.77c9.14 0 16.82-7.68 16.19-16.8zM224 288V50.71c0-9.55-8.39-17.4-17.84-16.06C86.99 51.49-4.1 155.6.14 280.37 4.5 408.51 114.83 513.59 243.03 511.98c50.4-.63 96.97-16.87 135.26-44.03 7.9-5.6 8.42-17.23 1.57-24.08L224 288z"
        ],
        "check": [
            512,
            512,
            [],
            "f00c",
            "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
        ],
        "check-circle": [
            512,
            512,
            [],
            "f058",
            "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.249-16.379-6.249-22.628 0L216 308.118l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.249 16.379 6.249 22.628.001z"
        ],
        "check-double": [
            512,
            512,
            [],
            "f560",
            "M505 174.8l-39.6-39.6c-9.4-9.4-24.6-9.4-33.9 0L192 374.7 80.6 263.2c-9.4-9.4-24.6-9.4-33.9 0L7 302.9c-9.4 9.4-9.4 24.6 0 34L175 505c9.4 9.4 24.6 9.4 33.9 0l296-296.2c9.4-9.5 9.4-24.7.1-34zm-324.3 106c6.2 6.3 16.4 6.3 22.6 0l208-208.2c6.2-6.3 6.2-16.4 0-22.6L366.1 4.7c-6.2-6.3-16.4-6.3-22.6 0L192 156.2l-55.4-55.5c-6.2-6.3-16.4-6.3-22.6 0L68.7 146c-6.2 6.3-6.2 16.4 0 22.6l112 112.2z"
        ],
        "check-square": [
            448,
            512,
            [],
            "f14a",
            "M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z"
        ],
        "cheese": [
            512,
            512,
            [],
            "f7ef",
            "M0 288v160a32 32 0 0 0 32 32h448a32 32 0 0 0 32-32V288zM299.83 32a32 32 0 0 0-21.13 7L0 256h512c0-119.89-94-217.8-212.17-224z"
        ],
        "chess": [
            512,
            512,
            [],
            "f439",
            "M74 208H64a16 16 0 0 0-16 16v16a16 16 0 0 0 16 16h15.94A535.78 535.78 0 0 1 64 384h128a535.78 535.78 0 0 1-15.94-128H192a16 16 0 0 0 16-16v-16a16 16 0 0 0-16-16h-10l33.89-90.38a16 16 0 0 0-15-21.62H144V64h24a8 8 0 0 0 8-8V40a8 8 0 0 0-8-8h-24V8a8 8 0 0 0-8-8h-16a8 8 0 0 0-8 8v24H88a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h24v32H55.09a16 16 0 0 0-15 21.62zm173.16 251.58L224 448v-16a16 16 0 0 0-16-16H48a16 16 0 0 0-16 16v16L8.85 459.58A16 16 0 0 0 0 473.89V496a16 16 0 0 0 16 16h224a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31zm92.77-157.78l-3.29 82.2h126.72l-3.29-82.21 24.6-20.79A32 32 0 0 0 496 256.54V198a6 6 0 0 0-6-6h-26.38a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H373.1a6 6 0 0 0-6 6v26h-24.71v-26a6 6 0 0 0-6-6H310a6 6 0 0 0-6 6v58.6a32 32 0 0 0 11.36 24.4zM384 304a16 16 0 0 1 32 0v32h-32zm119.16 155.58L480 448v-16a16 16 0 0 0-16-16H336a16 16 0 0 0-16 16v16l-23.15 11.58a16 16 0 0 0-8.85 14.31V496a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-22.11a16 16 0 0 0-8.84-14.31z"
        ],
        "chess-bishop": [
            320,
            512,
            [],
            "f43a",
            "M8 287.88c0 51.64 22.14 73.83 56 84.6V416h192v-43.52c33.86-10.77 56-33 56-84.6 0-30.61-10.73-67.1-26.69-102.56L185 285.65a8 8 0 0 1-11.31 0l-11.31-11.31a8 8 0 0 1 0-11.31L270.27 155.1c-20.8-37.91-46.47-72.1-70.87-92.59C213.4 59.09 224 47.05 224 32a32 32 0 0 0-32-32h-64a32 32 0 0 0-32 32c0 15 10.6 27.09 24.6 30.51C67.81 106.8 8 214.5 8 287.88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
        ],
        "chess-board": [
            512,
            512,
            [],
            "f43c",
            "M255.9.2h-64v64h64zM0 64.17v64h64v-64zM128 .2H64v64h64zm64 255.9v64h64v-64zM0 192.12v64h64v-64zM383.85.2h-64v64h64zm128 0h-64v64h64zM128 256.1H64v64h64zM511.8 448v-64h-64v64zm0-128v-64h-64v64zM383.85 512h64v-64h-64zm128-319.88v-64h-64v64zM128 512h64v-64h-64zM0 512h64v-64H0zm255.9 0h64v-64h-64zM0 320.07v64h64v-64zm319.88-191.92v-64h-64v64zm-64 128h64v-64h-64zm-64 128v64h64v-64zm128-64h64v-64h-64zm0-127.95h64v-64h-64zm0 191.93v64h64v-64zM64 384.05v64h64v-64zm128-255.9v-64h-64v64zm191.92 255.9h64v-64h-64zm-128-191.93v-64h-64v64zm128-127.95v64h64v-64zm-128 255.9v64h64v-64zm-64-127.95H128v64h64zm191.92 64h64v-64h-64zM128 128.15H64v64h64zm0 191.92v64h64v-64z"
        ],
        "chess-king": [
            448,
            512,
            [],
            "f43f",
            "M400 448H48a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm16-288H256v-48h40a8 8 0 0 0 8-8V56a8 8 0 0 0-8-8h-40V8a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v40h-40a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h40v48H32a32 32 0 0 0-30.52 41.54L74.56 416h298.88l73.08-214.46A32 32 0 0 0 416 160z"
        ],
        "chess-knight": [
            384,
            512,
            [],
            "f441",
            "M19 272.47l40.63 18.06a32 32 0 0 0 24.88.47l12.78-5.12a32 32 0 0 0 18.76-20.5l9.22-30.65a24 24 0 0 1 12.55-15.65L159.94 208v50.33a48 48 0 0 1-26.53 42.94l-57.22 28.65A80 80 0 0 0 32 401.48V416h319.86V224c0-106-85.92-192-191.92-192H12A12 12 0 0 0 0 44a16.9 16.9 0 0 0 1.79 7.58L16 80l-9 9a24 24 0 0 0-7 17v137.21a32 32 0 0 0 19 29.26zM52 128a20 20 0 1 1-20 20 20 20 0 0 1 20-20zm316 320H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
        ],
        "chess-pawn": [
            320,
            512,
            [],
            "f443",
            "M105.1 224H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h16v5.49c0 44-4.14 86.6-24 122.51h176c-19.89-35.91-24-78.51-24-122.51V288h16a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-25.1c29.39-18.38 49.1-50.78 49.1-88a104 104 0 0 0-208 0c0 37.22 19.71 69.62 49.1 88zM304 448H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
        ],
        "chess-queen": [
            512,
            512,
            [],
            "f445",
            "M256 112a56 56 0 1 0-56-56 56 56 0 0 0 56 56zm176 336H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm72.87-263.84l-28.51-15.92c-7.44-5-16.91-2.46-22.29 4.68a47.59 47.59 0 0 1-47.23 18.23C383.7 186.86 368 164.93 368 141.4a13.4 13.4 0 0 0-13.4-13.4h-38.77c-6 0-11.61 4-12.86 9.91a48 48 0 0 1-93.94 0c-1.25-5.92-6.82-9.91-12.86-9.91H157.4a13.4 13.4 0 0 0-13.4 13.4c0 25.69-19 48.75-44.67 50.49a47.5 47.5 0 0 1-41.54-19.15c-5.28-7.09-14.73-9.45-22.09-4.54l-28.57 16a16 16 0 0 0-5.44 20.47L104.24 416h303.52l102.55-211.37a16 16 0 0 0-5.44-20.47z"
        ],
        "chess-rook": [
            384,
            512,
            [],
            "f447",
            "M368 32h-56a16 16 0 0 0-16 16v48h-48V48a16 16 0 0 0-16-16h-80a16 16 0 0 0-16 16v48H88.1V48a16 16 0 0 0-16-16H16A16 16 0 0 0 0 48v176l64 32c0 48.33-1.54 95-13.21 160h282.42C321.54 351 320 303.72 320 256l64-32V48a16 16 0 0 0-16-16zM224 320h-64v-64a32 32 0 0 1 64 0zm144 128H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h352a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
        ],
        "chevron-circle-down": [
            512,
            512,
            [],
            "f13a",
            "M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zM273 369.9l135.5-135.5c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L256 285.1 154.4 183.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L239 369.9c9.4 9.4 24.6 9.4 34 0z"
        ],
        "chevron-circle-left": [
            512,
            512,
            [],
            "f137",
            "M256 504C119 504 8 393 8 256S119 8 256 8s248 111 248 248-111 248-248 248zM142.1 273l135.5 135.5c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L226.9 256l101.6-101.6c9.4-9.4 9.4-24.6 0-33.9l-17-17c-9.4-9.4-24.6-9.4-33.9 0L142.1 239c-9.4 9.4-9.4 24.6 0 34z"
        ],
        "chevron-circle-right": [
            512,
            512,
            [],
            "f138",
            "M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm113.9 231L234.4 103.5c-9.4-9.4-24.6-9.4-33.9 0l-17 17c-9.4 9.4-9.4 24.6 0 33.9L285.1 256 183.5 357.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L369.9 273c9.4-9.4 9.4-24.6 0-34z"
        ],
        "chevron-circle-up": [
            512,
            512,
            [],
            "f139",
            "M8 256C8 119 119 8 256 8s248 111 248 248-111 248-248 248S8 393 8 256zm231-113.9L103.5 277.6c-9.4 9.4-9.4 24.6 0 33.9l17 17c9.4 9.4 24.6 9.4 33.9 0L256 226.9l101.6 101.6c9.4 9.4 24.6 9.4 33.9 0l17-17c9.4-9.4 9.4-24.6 0-33.9L273 142.1c-9.4-9.4-24.6-9.4-34 0z"
        ],
        "chevron-down": [
            448,
            512,
            [],
            "f078",
            "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
        ],
        "chevron-left": [
            320,
            512,
            [],
            "f053",
            "M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"
        ],
        "chevron-right": [
            320,
            512,
            [],
            "f054",
            "M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"
        ],
        "chevron-up": [
            448,
            512,
            [],
            "f077",
            "M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"
        ],
        "child": [
            384,
            512,
            [],
            "f1ae",
            "M120 72c0-39.765 32.235-72 72-72s72 32.235 72 72c0 39.764-32.235 72-72 72s-72-32.236-72-72zm254.627 1.373c-12.496-12.497-32.758-12.497-45.254 0L242.745 160H141.254L54.627 73.373c-12.496-12.497-32.758-12.497-45.254 0-12.497 12.497-12.497 32.758 0 45.255L104 213.254V480c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V368h16v112c0 17.673 14.327 32 32 32h16c17.673 0 32-14.327 32-32V213.254l94.627-94.627c12.497-12.497 12.497-32.757 0-45.254z"
        ],
        "church": [
            640,
            512,
            [],
            "f51d",
            "M464.46 246.68L352 179.2V128h48c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-48V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v48h-48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v51.2l-112.46 67.48A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.65-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.54A32.024 32.024 0 0 0 0 395.96zm620.61-29.42L512 320v192h112c8.84 0 16-7.16 16-16V395.96c0-12.8-7.63-24.37-19.39-29.42z"
        ],
        "circle": [
            512,
            512,
            [],
            "f111",
            "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8z"
        ],
        "circle-notch": [
            512,
            512,
            [],
            "f1ce",
            "M288 39.056v16.659c0 10.804 7.281 20.159 17.686 23.066C383.204 100.434 440 171.518 440 256c0 101.689-82.295 184-184 184-101.689 0-184-82.295-184-184 0-84.47 56.786-155.564 134.312-177.219C216.719 75.874 224 66.517 224 55.712V39.064c0-15.709-14.834-27.153-30.046-23.234C86.603 43.482 7.394 141.206 8.003 257.332c.72 137.052 111.477 246.956 248.531 246.667C393.255 503.711 504 392.788 504 256c0-115.633-79.14-212.779-186.211-240.236C302.678 11.889 288 23.456 288 39.056z"
        ],
        "city": [
            640,
            512,
            [],
            "f64f",
            "M616 192H480V24c0-13.26-10.74-24-24-24H312c-13.26 0-24 10.74-24 24v72h-64V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v80h-64V16c0-8.84-7.16-16-16-16H80c-8.84 0-16 7.16-16 16v80H24c-13.26 0-24 10.74-24 24v360c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V216c0-13.26-10.75-24-24-24zM128 404c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12H76c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm128 192c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12V76c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm160 288c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40zm0-96c0 6.63-5.37 12-12 12h-40c-6.63 0-12-5.37-12-12v-40c0-6.63 5.37-12 12-12h40c6.63 0 12 5.37 12 12v40z"
        ],
        "clinic-medical": [
            576,
            512,
            [],
            "f7f2",
            "M288 115L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2zm96 261a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8zm186.69-139.72l-255.94-226a39.85 39.85 0 0 0-53.45 0l-256 226a16 16 0 0 0-1.21 22.6L25.5 282.7a16 16 0 0 0 22.6 1.21L277.42 81.63a16 16 0 0 1 21.17 0L527.91 283.9a16 16 0 0 0 22.6-1.21l21.4-23.82a16 16 0 0 0-1.22-22.59z"
        ],
        "clipboard": [
            384,
            512,
            [],
            "f328",
            "M384 112v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h80c0-35.29 28.71-64 64-64s64 28.71 64 64h80c26.51 0 48 21.49 48 48zM192 40c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24m96 114v-20a6 6 0 0 0-6-6H102a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h180a6 6 0 0 0 6-6z"
        ],
        "clipboard-check": [
            384,
            512,
            [],
            "f46c",
            "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm121.2 231.8l-143 141.8c-4.7 4.7-12.3 4.6-17-.1l-82.6-83.3c-4.7-4.7-4.6-12.3.1-17L99.1 285c4.7-4.7 12.3-4.6 17 .1l46 46.4 106-105.2c4.7-4.7 12.3-4.6 17 .1l28.2 28.4c4.7 4.8 4.6 12.3-.1 17z"
        ],
        "clipboard-list": [
            384,
            512,
            [],
            "f46d",
            "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM96 424c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm0-96c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24zm96-192c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm128 368c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16z"
        ],
        "clock": [
            512,
            512,
            [],
            "f017",
            "M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm92.49,313h0l-20,25a16,16,0,0,1-22.49,2.5h0l-67-49.72a40,40,0,0,1-15-31.23V112a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V256l58,42.5A16,16,0,0,1,348.49,321Z"
        ],
        "clone": [
            512,
            512,
            [],
            "f24d",
            "M464 0c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48H176c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h288M176 416c-44.112 0-80-35.888-80-80V128H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48v-48H176z"
        ],
        "closed-captioning": [
            512,
            512,
            [],
            "f20a",
            "M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM218.1 287.7c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.8-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7l-17.5 30.5c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2.1 48 51.1 70.5 92.3 32.6zm190.4 0c2.8-2.5 7.1-2.1 9.2.9l19.5 27.7c1.7 2.4 1.5 5.6-.5 7.7-53.5 56.9-172.7 32.1-172.7-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7L420 222.2c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6z"
        ],
        "cloud": [
            640,
            512,
            [],
            "f0c2",
            "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4z"
        ],
        "cloud-download-alt": [
            640,
            512,
            [],
            "f381",
            "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zm-132.9 88.7L299.3 420.7c-6.2 6.2-16.4 6.2-22.6 0L171.3 315.3c-10.1-10.1-2.9-27.3 11.3-27.3H248V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v112h65.4c14.2 0 21.4 17.2 11.3 27.3z"
        ],
        "cloud-meatball": [
            512,
            512,
            [],
            "f73b",
            "M48 352c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm416 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm-119 11.1c4.6-14.5 1.6-30.8-9.8-42.3-11.5-11.5-27.8-14.4-42.3-9.9-7-13.5-20.7-23-36.9-23s-29.9 9.5-36.9 23c-14.5-4.6-30.8-1.6-42.3 9.9-11.5 11.5-14.4 27.8-9.9 42.3-13.5 7-23 20.7-23 36.9s9.5 29.9 23 36.9c-4.6 14.5-1.6 30.8 9.9 42.3 8.2 8.2 18.9 12.3 29.7 12.3 4.3 0 8.5-1.1 12.6-2.5 7 13.5 20.7 23 36.9 23s29.9-9.5 36.9-23c4.1 1.3 8.3 2.5 12.6 2.5 10.8 0 21.5-4.1 29.7-12.3 11.5-11.5 14.4-27.8 9.8-42.3 13.5-7 23-20.7 23-36.9s-9.5-29.9-23-36.9zM512 224c0-53-43-96-96-96-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h43.4c3.6-8 8.4-15.4 14.8-21.8 13.5-13.5 31.5-21.1 50.8-21.3 13.5-13.2 31.7-20.9 51-20.9s37.5 7.7 51 20.9c19.3.2 37.3 7.8 50.8 21.3 6.4 6.4 11.3 13.8 14.8 21.8H416c53 0 96-43 96-96z"
        ],
        "cloud-moon": [
            576,
            512,
            [],
            "f6c3",
            "M342.8 352.7c5.7-9.6 9.2-20.7 9.2-32.7 0-35.3-28.7-64-64-64-17.2 0-32.8 6.9-44.3 17.9-16.3-29.6-47.5-49.9-83.7-49.9-53 0-96 43-96 96 0 2 .5 3.8.6 5.7C27.1 338.8 0 374.1 0 416c0 53 43 96 96 96h240c44.2 0 80-35.8 80-80 0-41.9-32.3-75.8-73.2-79.3zm222.5-54.3c-93.1 17.7-178.5-53.7-178.5-147.7 0-54.2 29-104 76.1-130.8 7.3-4.1 5.4-15.1-2.8-16.7C448.4 1.1 436.7 0 425 0 319.1 0 233.1 85.9 233.1 192c0 8.5.7 16.8 1.8 25 5.9 4.3 11.6 8.9 16.7 14.2 11.4-4.7 23.7-7.2 36.4-7.2 52.9 0 96 43.1 96 96 0 3.6-.2 7.2-.6 10.7 23.6 10.8 42.4 29.5 53.5 52.6 54.4-3.4 103.7-29.3 137.1-70.4 5.3-6.5-.5-16.1-8.7-14.5z"
        ],
        "cloud-moon-rain": [
            576,
            512,
            [],
            "f73c",
            "M350.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C27.6 232.9 0 265.2 0 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm217.4-1.7c-70.4 13.3-135-40.3-135-110.8 0-40.6 21.9-78 57.5-98.1 5.5-3.1 4.1-11.4-2.1-12.5C479.6.8 470.7 0 461.8 0c-77.9 0-141.1 61.2-144.4 137.9 26.7 11.9 48.2 33.8 58.9 61.7 37.1 14.3 64 47.4 70.2 86.8 5.1.5 10 1.5 15.2 1.5 44.7 0 85.6-20.2 112.6-53.3 4.2-4.8-.2-12-6.4-10.8zM364.5 418.1c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"
        ],
        "cloud-rain": [
            512,
            512,
            [],
            "f73d",
            "M416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.1 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96zM88 374.2c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0zm160 0c-12.8 44.4-40 56.4-40 87.7 0 27.7 21.5 50.1 48 50.1s48-22.4 48-50.1c0-31.4-27.2-43.1-40-87.7-2.2-8.1-13.5-8.5-16 0z"
        ],
        "cloud-showers-heavy": [
            512,
            512,
            [],
            "f740",
            "M183.9 370.1c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-192 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm384 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zm-96 0c-7.6-4.4-17.4-1.8-21.8 6l-64 112c-4.4 7.7-1.7 17.5 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l64-112c4.4-7.6 1.7-17.4-6-21.8zM416 128c-.6 0-1.1.2-1.6.2 1.1-5.2 1.6-10.6 1.6-16.2 0-44.2-35.8-80-80-80-24.6 0-46.3 11.3-61 28.8C256.4 24.8 219.3 0 176 0 114.2 0 64 50.1 64 112c0 7.3.8 14.3 2.1 21.2C27.8 145.8 0 181.5 0 224c0 53 43 96 96 96h320c53 0 96-43 96-96s-43-96-96-96z"
        ],
        "cloud-sun": [
            640,
            512,
            [],
            "f6c4",
            "M575.2 325.7c.2-1.9.8-3.7.8-5.6 0-35.3-28.7-64-64-64-12.6 0-24.2 3.8-34.1 10-17.6-38.8-56.5-66-101.9-66-61.8 0-112 50.1-112 112 0 3 .7 5.8.9 8.7-49.6 3.7-88.9 44.7-88.9 95.3 0 53 43 96 96 96h272c53 0 96-43 96-96 0-42.1-27.2-77.4-64.8-90.4zm-430.4-22.6c-43.7-43.7-43.7-114.7 0-158.3 43.7-43.7 114.7-43.7 158.4 0 9.7 9.7 16.9 20.9 22.3 32.7 9.8-3.7 20.1-6 30.7-7.5L386 81.1c4-11.9-7.3-23.1-19.2-19.2L279 91.2 237.5 8.4C232-2.8 216-2.8 210.4 8.4L169 91.2 81.1 61.9C69.3 58 58 69.3 61.9 81.1l29.3 87.8-82.8 41.5c-11.2 5.6-11.2 21.5 0 27.1l82.8 41.4-29.3 87.8c-4 11.9 7.3 23.1 19.2 19.2l76.1-25.3c6.1-12.4 14-23.7 23.6-33.5-13.1-5.4-25.4-13.4-36-24zm-4.8-79.2c0 40.8 29.3 74.8 67.9 82.3 8-4.7 16.3-8.8 25.2-11.7 5.4-44.3 31-82.5 67.4-105C287.3 160.4 258 140 224 140c-46.3 0-84 37.6-84 83.9z"
        ],
        "cloud-sun-rain": [
            576,
            512,
            [],
            "f743",
            "M510.5 225.5c-6.9-37.2-39.3-65.5-78.5-65.5-12.3 0-23.9 3-34.3 8-17.4-24.1-45.6-40-77.7-40-53 0-96 43-96 96 0 .5.2 1.1.2 1.6C187.6 233 160 265.2 160 304c0 44.2 35.8 80 80 80h256c44.2 0 80-35.8 80-80 0-39.2-28.2-71.7-65.5-78.5zm-386.4 34.4c-37.4-37.4-37.4-98.3 0-135.8 34.6-34.6 89.1-36.8 126.7-7.4 20-12.9 43.6-20.7 69.2-20.7.7 0 1.3.2 2 .2l8.9-26.7c3.4-10.2-6.3-19.8-16.5-16.4l-75.3 25.1-35.5-71c-4.8-9.6-18.5-9.6-23.3 0l-35.5 71-75.3-25.1c-10.2-3.4-19.8 6.3-16.4 16.5l25.1 75.3-71 35.5c-9.6 4.8-9.6 18.5 0 23.3l71 35.5-25.1 75.3c-3.4 10.2 6.3 19.8 16.5 16.5l59.2-19.7c-.2-2.4-.7-4.7-.7-7.2 0-12.5 2.3-24.5 6.2-35.9-3.6-2.7-7.1-5.2-10.2-8.3zm69.8-58c4.3-24.5 15.8-46.4 31.9-64-9.8-6.2-21.4-9.9-33.8-9.9-35.3 0-64 28.7-64 64 0 18.7 8.2 35.4 21.1 47.1 11.3-15.9 26.6-28.9 44.8-37.2zm330.6 216.2c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8zm-96 0c-7.6-4.3-17.4-1.8-21.8 6l-36.6 64c-4.4 7.7-1.7 17.4 6 21.8 2.5 1.4 5.2 2.1 7.9 2.1 5.5 0 10.9-2.9 13.9-8.1l36.6-64c4.3-7.7 1.7-17.4-6-21.8z"
        ],
        "cloud-upload-alt": [
            640,
            512,
            [],
            "f382",
            "M537.6 226.6c4.1-10.7 6.4-22.4 6.4-34.6 0-53-43-96-96-96-19.7 0-38.1 6-53.3 16.2C367 64.2 315.3 32 256 32c-88.4 0-160 71.6-160 160 0 2.7.1 5.4.2 8.1C40.2 219.8 0 273.2 0 336c0 79.5 64.5 144 144 144h368c70.7 0 128-57.3 128-128 0-61.9-44-113.6-102.4-125.4zM393.4 288H328v112c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V288h-65.4c-14.3 0-21.4-17.2-11.3-27.3l105.4-105.4c6.2-6.2 16.4-6.2 22.6 0l105.4 105.4c10.1 10.1 2.9 27.3-11.3 27.3z"
        ],
        "cocktail": [
            576,
            512,
            [],
            "f561",
            "M296 464h-56V338.78l168.74-168.73c15.52-15.52 4.53-42.05-17.42-42.05H24.68c-21.95 0-32.94 26.53-17.42 42.05L176 338.78V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM432 0c-62.61 0-115.35 40.2-135.18 96h52.54c16.65-28.55 47.27-48 82.64-48 52.93 0 96 43.06 96 96s-43.07 96-96 96c-14.04 0-27.29-3.2-39.32-8.64l-35.26 35.26C379.23 279.92 404.59 288 432 288c79.53 0 144-64.47 144-144S511.53 0 432 0z"
        ],
        "code": [
            640,
            512,
            [],
            "f121",
            "M278.9 511.5l-61-17.7c-6.4-1.8-10-8.5-8.2-14.9L346.2 8.7c1.8-6.4 8.5-10 14.9-8.2l61 17.7c6.4 1.8 10 8.5 8.2 14.9L293.8 503.3c-1.9 6.4-8.5 10.1-14.9 8.2zm-114-112.2l43.5-46.4c4.6-4.9 4.3-12.7-.8-17.2L117 256l90.6-79.7c5.1-4.5 5.5-12.3.8-17.2l-43.5-46.4c-4.5-4.8-12.1-5.1-17-.5L3.8 247.2c-5.1 4.7-5.1 12.8 0 17.5l144.1 135.1c4.9 4.6 12.5 4.4 17-.5zm327.2.6l144.1-135.1c5.1-4.7 5.1-12.8 0-17.5L492.1 112.1c-4.8-4.5-12.4-4.3-17 .5L431.6 159c-4.6 4.9-4.3 12.7.8 17.2L523 256l-90.6 79.7c-5.1 4.5-5.5 12.3-.8 17.2l43.5 46.4c4.5 4.9 12.1 5.1 17 .6z"
        ],
        "code-branch": [
            384,
            512,
            [],
            "f126",
            "M384 144c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 36.4 24.3 67.1 57.5 76.8-.6 16.1-4.2 28.5-11 36.9-15.4 19.2-49.3 22.4-85.2 25.7-28.2 2.6-57.4 5.4-81.3 16.9v-144c32.5-10.2 56-40.5 56-76.3 0-44.2-35.8-80-80-80S0 35.8 0 80c0 35.8 23.5 66.1 56 76.3v199.3C23.5 365.9 0 396.2 0 432c0 44.2 35.8 80 80 80s80-35.8 80-80c0-34-21.2-63.1-51.2-74.6 3.1-5.2 7.8-9.8 14.9-13.4 16.2-8.2 40.4-10.4 66.1-12.8 42.2-3.9 90-8.4 118.2-43.4 14-17.4 21.1-39.8 21.6-67.9 31.6-10.8 54.4-40.7 54.4-75.9zM80 64c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16zm0 384c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm224-320c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16 7.2-16 16-16z"
        ],
        "coffee": [
            640,
            512,
            [],
            "f0f4",
            "M192 384h192c53 0 96-43 96-96h32c70.6 0 128-57.4 128-128S582.6 32 512 32H120c-13.3 0-24 10.7-24 24v232c0 53 43 96 96 96zM512 96c35.3 0 64 28.7 64 64s-28.7 64-64 64h-32V96h32zm47.7 384H48.3c-47.6 0-61-64-36-64h583.3c25 0 11.8 64-35.9 64z"
        ],
        "cog": [
            512,
            512,
            [],
            "f013",
            "M487.4 315.7l-42.6-24.6c4.3-23.2 4.3-47 0-70.2l42.6-24.6c4.9-2.8 7.1-8.6 5.5-14-11.1-35.6-30-67.8-54.7-94.6-3.8-4.1-10-5.1-14.8-2.3L380.8 110c-17.9-15.4-38.5-27.3-60.8-35.1V25.8c0-5.6-3.9-10.5-9.4-11.7-36.7-8.2-74.3-7.8-109.2 0-5.5 1.2-9.4 6.1-9.4 11.7V75c-22.2 7.9-42.8 19.8-60.8 35.1L88.7 85.5c-4.9-2.8-11-1.9-14.8 2.3-24.7 26.7-43.6 58.9-54.7 94.6-1.7 5.4.6 11.2 5.5 14L67.3 221c-4.3 23.2-4.3 47 0 70.2l-42.6 24.6c-4.9 2.8-7.1 8.6-5.5 14 11.1 35.6 30 67.8 54.7 94.6 3.8 4.1 10 5.1 14.8 2.3l42.6-24.6c17.9 15.4 38.5 27.3 60.8 35.1v49.2c0 5.6 3.9 10.5 9.4 11.7 36.7 8.2 74.3 7.8 109.2 0 5.5-1.2 9.4-6.1 9.4-11.7v-49.2c22.2-7.9 42.8-19.8 60.8-35.1l42.6 24.6c4.9 2.8 11 1.9 14.8-2.3 24.7-26.7 43.6-58.9 54.7-94.6 1.5-5.5-.7-11.3-5.6-14.1zM256 336c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
        ],
        "cogs": [
            640,
            512,
            [],
            "f085",
            "M512.1 191l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0L552 6.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zm-10.5-58.8c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.7-82.4 14.3-52.8 52.8zM386.3 286.1l33.7 16.8c10.1 5.8 14.5 18.1 10.5 29.1-8.9 24.2-26.4 46.4-42.6 65.8-7.4 8.9-20.2 11.1-30.3 5.3l-29.1-16.8c-16 13.7-34.6 24.6-54.9 31.7v33.6c0 11.6-8.3 21.6-19.7 23.6-24.6 4.2-50.4 4.4-75.9 0-11.5-2-20-11.9-20-23.6V418c-20.3-7.2-38.9-18-54.9-31.7L74 403c-10 5.8-22.9 3.6-30.3-5.3-16.2-19.4-33.3-41.6-42.2-65.7-4-10.9.4-23.2 10.5-29.1l33.3-16.8c-3.9-20.9-3.9-42.4 0-63.4L12 205.8c-10.1-5.8-14.6-18.1-10.5-29 8.9-24.2 26-46.4 42.2-65.8 7.4-8.9 20.2-11.1 30.3-5.3l29.1 16.8c16-13.7 34.6-24.6 54.9-31.7V57.1c0-11.5 8.2-21.5 19.6-23.5 24.6-4.2 50.5-4.4 76-.1 11.5 2 20 11.9 20 23.6v33.6c20.3 7.2 38.9 18 54.9 31.7l29.1-16.8c10-5.8 22.9-3.6 30.3 5.3 16.2 19.4 33.2 41.6 42.1 65.8 4 10.9.1 23.2-10 29.1l-33.7 16.8c3.9 21 3.9 42.5 0 63.5zm-117.6 21.1c59.2-77-28.7-164.9-105.7-105.7-59.2 77 28.7 164.9 105.7 105.7zm243.4 182.7l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0l8.2-14.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zM501.6 431c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.6-82.4 14.3-52.8 52.8z"
        ],
        "coins": [
            512,
            512,
            [],
            "f51e",
            "M0 405.3V448c0 35.3 86 64 192 64s192-28.7 192-64v-42.7C342.7 434.4 267.2 448 192 448S41.3 434.4 0 405.3zM320 128c106 0 192-28.7 192-64S426 0 320 0 128 28.7 128 64s86 64 192 64zM0 300.4V352c0 35.3 86 64 192 64s192-28.7 192-64v-51.6c-41.3 34-116.9 51.6-192 51.6S41.3 334.4 0 300.4zm416 11c57.3-11.1 96-31.7 96-55.4v-42.7c-23.2 16.4-57.3 27.6-96 34.5v63.6zM192 160C86 160 0 195.8 0 240s86 80 192 80 192-35.8 192-80-86-80-192-80zm219.3 56.3c60-10.8 100.7-32 100.7-56.3v-42.7c-35.5 25.1-96.5 38.6-160.7 41.8 29.5 14.3 51.2 33.5 60 57.2z"
        ],
        "columns": [
            512,
            512,
            [],
            "f0db",
            "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64V160h160v256zm224 0H288V160h160v256z"
        ],
        "comment": [
            512,
            512,
            [],
            "f075",
            "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32z"
        ],
        "comment-alt": [
            512,
            512,
            [],
            "f27a",
            "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 9.8 11.2 15.5 19.1 9.7L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64z"
        ],
        "comment-dollar": [
            512,
            512,
            [],
            "f651",
            "M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95.01 57.02 130.74C44.46 421.05 2.7 465.97 2.2 466.5A7.995 7.995 0 0 0 8 480c66.26 0 115.99-31.75 140.6-51.38C181.29 440.93 217.59 448 256 448c141.38 0 256-93.12 256-208S397.38 32 256 32zm24 302.44V352c0 8.84-7.16 16-16 16h-16c-8.84 0-16-7.16-16-16v-17.73c-11.42-1.35-22.28-5.19-31.78-11.46-6.22-4.11-6.82-13.11-1.55-18.38l17.52-17.52c3.74-3.74 9.31-4.24 14.11-2.03 3.18 1.46 6.66 2.22 10.26 2.22h32.78c4.66 0 8.44-3.78 8.44-8.42 0-3.75-2.52-7.08-6.12-8.11l-50.07-14.3c-22.25-6.35-40.01-24.71-42.91-47.67-4.05-32.07 19.03-59.43 49.32-63.05V128c0-8.84 7.16-16 16-16h16c8.84 0 16 7.16 16 16v17.73c11.42 1.35 22.28 5.19 31.78 11.46 6.22 4.11 6.82 13.11 1.55 18.38l-17.52 17.52c-3.74 3.74-9.31 4.24-14.11 2.03a24.516 24.516 0 0 0-10.26-2.22h-32.78c-4.66 0-8.44 3.78-8.44 8.42 0 3.75 2.52 7.08 6.12 8.11l50.07 14.3c22.25 6.36 40.01 24.71 42.91 47.67 4.05 32.06-19.03 59.42-49.32 63.04z"
        ],
        "comment-dots": [
            512,
            512,
            [],
            "f4ad",
            "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7S4.8 480 8 480c66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128 272c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
        ],
        "comment-medical": [
            512,
            512,
            [],
            "f7f5",
            "M256 32C114.62 32 0 125.12 0 240c0 49.56 21.41 95 57 130.74C44.46 421.05 2.7 466 2.2 466.5A8 8 0 0 0 8 480c66.26 0 116-31.75 140.6-51.38A304.66 304.66 0 0 0 256 448c141.39 0 256-93.12 256-208S397.39 32 256 32zm96 232a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8v-48a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8z"
        ],
        "comment-slash": [
            640,
            512,
            [],
            "f4b3",
            "M64 240c0 49.6 21.4 95 57 130.7-12.6 50.3-54.3 95.2-54.8 95.8-2.2 2.3-2.8 5.7-1.5 8.7 1.3 2.9 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 27.4 0 53.7-3.6 78.4-10L72.9 186.4c-5.6 17.1-8.9 35-8.9 53.6zm569.8 218.1l-114.4-88.4C554.6 334.1 576 289.2 576 240c0-114.9-114.6-208-256-208-65.1 0-124.2 20.1-169.4 52.7L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"
        ],
        "comments": [
            576,
            512,
            [],
            "f086",
            "M416 192c0-88.4-93.1-160-208-160S0 103.6 0 192c0 34.3 14.1 65.9 38 92-13.4 30.2-35.5 54.2-35.8 54.5-2.2 2.3-2.8 5.7-1.5 8.7S4.8 352 8 352c36.6 0 66.9-12.3 88.7-25 32.2 15.7 70.3 25 111.3 25 114.9 0 208-71.6 208-160zm122 220c23.9-26 38-57.7 38-92 0-66.9-53.5-124.2-129.3-148.1.9 6.6 1.3 13.3 1.3 20.1 0 105.9-107.7 192-240 192-10.8 0-21.3-.8-31.7-1.9C207.8 439.6 281.8 480 368 480c41 0 79.1-9.2 111.3-25 21.8 12.7 52.1 25 88.7 25 3.2 0 6.1-1.9 7.3-4.8 1.3-2.9.7-6.3-1.5-8.7-.3-.3-22.4-24.2-35.8-54.5z"
        ],
        "comments-dollar": [
            576,
            512,
            [],
            "f653",
            "M416 192c0-88.37-93.12-160-208-160S0 103.63 0 192c0 34.27 14.13 65.95 37.97 91.98C24.61 314.22 2.52 338.16 2.2 338.5A7.995 7.995 0 0 0 8 352c36.58 0 66.93-12.25 88.73-24.98C128.93 342.76 167.02 352 208 352c114.88 0 208-71.63 208-160zm-224 96v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V96c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07V288c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm346.01 123.99C561.87 385.96 576 354.27 576 320c0-66.94-53.49-124.2-129.33-148.07.86 6.6 1.33 13.29 1.33 20.07 0 105.87-107.66 192-240 192-10.78 0-21.32-.77-31.73-1.88C207.8 439.63 281.77 480 368 480c40.98 0 79.07-9.24 111.27-24.98C501.07 467.75 531.42 480 568 480c3.2 0 6.09-1.91 7.34-4.84 1.27-2.94.66-6.34-1.55-8.67-.31-.33-22.42-24.24-35.78-54.5z"
        ],
        "compact-disc": [
            496,
            512,
            [],
            "f51f",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 256H56c0-105.9 86.1-192 192-192v32c-88.2 0-160 71.8-160 160zm160 96c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96zm0-128c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
        ],
        "compass": [
            496,
            512,
            [],
            "f14e",
            "M225.38 233.37c-12.5 12.5-12.5 32.76 0 45.25 12.49 12.5 32.76 12.5 45.25 0 12.5-12.5 12.5-32.76 0-45.25-12.5-12.49-32.76-12.49-45.25 0zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm126.14 148.05L308.17 300.4a31.938 31.938 0 0 1-15.77 15.77l-144.34 65.97c-16.65 7.61-33.81-9.55-26.2-26.2l65.98-144.35a31.938 31.938 0 0 1 15.77-15.77l144.34-65.97c16.65-7.6 33.8 9.55 26.19 26.2z"
        ],
        "compress": [
            448,
            512,
            [],
            "f066",
            "M436 192H312c-13.3 0-24-10.7-24-24V44c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v84h84c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm-276-24V44c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v84H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24zm0 300V344c0-13.3-10.7-24-24-24H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-84h84c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12H312c-13.3 0-24 10.7-24 24v124c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"
        ],
        "compress-alt": [
            448,
            512,
            [],
            "f422",
            "M4.686 427.314L104 328l-32.922-31.029C55.958 281.851 66.666 256 88.048 256h112C213.303 256 224 266.745 224 280v112c0 21.382-25.803 32.09-40.922 16.971L152 376l-99.314 99.314c-6.248 6.248-16.379 6.248-22.627 0L4.686 449.941c-6.248-6.248-6.248-16.379 0-22.627zM443.314 84.686L344 184l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C234.697 256 224 245.255 224 232V120c0-21.382 25.803-32.09 40.922-16.971L296 136l99.314-99.314c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.248 6.248 6.248 16.379 0 22.627z"
        ],
        "compress-arrows-alt": [
            512,
            512,
            [],
            "f78c",
            "M200 288H88c-21.4 0-32.1 25.8-17 41l32.9 31-99.2 99.3c-6.2 6.2-6.2 16.4 0 22.6l25.4 25.4c6.2 6.2 16.4 6.2 22.6 0L152 408l31.1 33c15.1 15.1 40.9 4.4 40.9-17V312c0-13.3-10.7-24-24-24zm112-64h112c21.4 0 32.1-25.9 17-41l-33-31 99.3-99.3c6.2-6.2 6.2-16.4 0-22.6L481.9 4.7c-6.2-6.2-16.4-6.2-22.6 0L360 104l-31.1-33C313.8 55.9 288 66.6 288 88v112c0 13.3 10.7 24 24 24zm96 136l33-31.1c15.1-15.1 4.4-40.9-17-40.9H312c-13.3 0-24 10.7-24 24v112c0 21.4 25.9 32.1 41 17l31-32.9 99.3 99.3c6.2 6.2 16.4 6.2 22.6 0l25.4-25.4c6.2-6.2 6.2-16.4 0-22.6L408 360zM183 71.1L152 104 52.7 4.7c-6.2-6.2-16.4-6.2-22.6 0L4.7 30.1c-6.2 6.2-6.2 16.4 0 22.6L104 152l-33 31.1C55.9 198.2 66.6 224 88 224h112c13.3 0 24-10.7 24-24V88c0-21.3-25.9-32-41-16.9z"
        ],
        "concierge-bell": [
            512,
            512,
            [],
            "f562",
            "M288 130.54V112h16c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16h-96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h16v18.54C115.49 146.11 32 239.18 32 352h448c0-112.82-83.49-205.89-192-221.46zM496 384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
        ],
        "cookie": [
            512,
            512,
            [],
            "f563",
            "M510.37 254.79l-12.08-76.26a132.493 132.493 0 0 0-37.16-72.95l-54.76-54.75c-19.73-19.72-45.18-32.7-72.71-37.05l-76.7-12.15c-27.51-4.36-55.69.11-80.52 12.76L107.32 49.6a132.25 132.25 0 0 0-57.79 57.8l-35.1 68.88a132.602 132.602 0 0 0-12.82 80.94l12.08 76.27a132.493 132.493 0 0 0 37.16 72.95l54.76 54.75a132.087 132.087 0 0 0 72.71 37.05l76.7 12.14c27.51 4.36 55.69-.11 80.52-12.75l69.12-35.21a132.302 132.302 0 0 0 57.79-57.8l35.1-68.87c12.71-24.96 17.2-53.3 12.82-80.96zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
        ],
        "cookie-bite": [
            512,
            512,
            [],
            "f564",
            "M510.52 255.82c-69.97-.85-126.47-57.69-126.47-127.86-70.17 0-127-56.49-127.86-126.45-27.26-4.14-55.13.3-79.72 12.82l-69.13 35.22a132.221 132.221 0 0 0-57.79 57.81l-35.1 68.88a132.645 132.645 0 0 0-12.82 80.95l12.08 76.27a132.521 132.521 0 0 0 37.16 72.96l54.77 54.76a132.036 132.036 0 0 0 72.71 37.06l76.71 12.15c27.51 4.36 55.7-.11 80.53-12.76l69.13-35.21a132.273 132.273 0 0 0 57.79-57.81l35.1-68.88c12.56-24.64 17.01-52.58 12.91-79.91zM176 368c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm32-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm160 128c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
        ],
        "copy": [
            448,
            512,
            [],
            "f0c5",
            "M320 448v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V120c0-13.255 10.745-24 24-24h72v296c0 30.879 25.121 56 56 56h168zm0-344V0H152c-13.255 0-24 10.745-24 24v368c0 13.255 10.745 24 24 24h272c13.255 0 24-10.745 24-24V128H344c-13.2 0-24-10.8-24-24zm120.971-31.029L375.029 7.029A24 24 0 0 0 358.059 0H352v96h96v-6.059a24 24 0 0 0-7.029-16.97z"
        ],
        "copyright": [
            512,
            512,
            [],
            "f1f9",
            "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm117.134 346.753c-1.592 1.867-39.776 45.731-109.851 45.731-84.692 0-144.484-63.26-144.484-145.567 0-81.303 62.004-143.401 143.762-143.401 66.957 0 101.965 37.315 103.422 38.904a12 12 0 0 1 1.238 14.623l-22.38 34.655c-4.049 6.267-12.774 7.351-18.234 2.295-.233-.214-26.529-23.88-61.88-23.88-46.116 0-73.916 33.575-73.916 76.082 0 39.602 25.514 79.692 74.277 79.692 38.697 0 65.28-28.338 65.544-28.625 5.132-5.565 14.059-5.033 18.508 1.053l24.547 33.572a12.001 12.001 0 0 1-.553 14.866z"
        ],
        "couch": [
            640,
            512,
            [],
            "f4b8",
            "M160 224v64h320v-64c0-35.3 28.7-64 64-64h32c0-53-43-96-96-96H160c-53 0-96 43-96 96h32c35.3 0 64 28.7 64 64zm416-32h-32c-17.7 0-32 14.3-32 32v96H128v-96c0-17.7-14.3-32-32-32H64c-35.3 0-64 28.7-64 64 0 23.6 13 44 32 55.1V432c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-16h384v16c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V311.1c19-11.1 32-31.5 32-55.1 0-35.3-28.7-64-64-64z"
        ],
        "credit-card": [
            576,
            512,
            [],
            "f09d",
            "M0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V256H0v176zm192-68c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H204c-6.6 0-12-5.4-12-12v-40zm-128 0c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12v-40zM576 80v48H0V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48z"
        ],
        "crop": [
            512,
            512,
            [],
            "f125",
            "M488 352h-40V109.25l59.31-59.31c6.25-6.25 6.25-16.38 0-22.63L484.69 4.69c-6.25-6.25-16.38-6.25-22.63 0L402.75 64H192v96h114.75L160 306.75V24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v264c0 13.25 10.75 24 24 24h232v-96H205.25L352 205.25V488c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
        ],
        "crop-alt": [
            512,
            512,
            [],
            "f565",
            "M488 352h-40V96c0-17.67-14.33-32-32-32H192v96h160v328c0 13.25 10.75 24 24 24h48c13.25 0 24-10.75 24-24v-40h40c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24zM160 24c0-13.26-10.75-24-24-24H88C74.75 0 64 10.74 64 24v40H24C10.75 64 0 74.74 0 88v48c0 13.25 10.75 24 24 24h40v256c0 17.67 14.33 32 32 32h224v-96H160V24z"
        ],
        "cross": [
            384,
            512,
            [],
            "f654",
            "M352 128h-96V32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h96v224c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V256h96c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
        ],
        "crosshairs": [
            512,
            512,
            [],
            "f05b",
            "M500 224h-30.364C455.724 130.325 381.675 56.276 288 42.364V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v30.364C130.325 56.276 56.276 130.325 42.364 224H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h30.364C56.276 381.675 130.325 455.724 224 469.636V500c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-30.364C381.675 455.724 455.724 381.675 469.636 288H500c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zM288 404.634V364c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40.634C165.826 392.232 119.783 346.243 107.366 288H148c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40.634C119.768 165.826 165.757 119.783 224 107.366V148c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40.634C346.174 119.768 392.217 165.757 404.634 224H364c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40.634C392.232 346.174 346.243 392.217 288 404.634zM288 256c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z"
        ],
        "crow": [
            640,
            512,
            [],
            "f520",
            "M544 32h-16.36C513.04 12.68 490.09 0 464 0c-44.18 0-80 35.82-80 80v20.98L12.09 393.57A30.216 30.216 0 0 0 0 417.74c0 22.46 23.64 37.07 43.73 27.03L165.27 384h96.49l44.41 120.1c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38L312.94 384H352c1.91 0 3.76-.23 5.66-.29l44.51 120.38c2.27 6.23 9.15 9.44 15.38 7.17l22.55-8.21c6.23-2.27 9.44-9.15 7.17-15.38l-41.24-111.53C485.74 352.8 544 279.26 544 192v-80l96-16c0-35.35-42.98-64-96-64zm-80 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
        ],
        "crown": [
            640,
            512,
            [],
            "f521",
            "M528 448H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm64-320c-26.5 0-48 21.5-48 48 0 7.1 1.6 13.7 4.4 19.8L476 239.2c-15.4 9.2-35.3 4-44.2-11.6L350.3 85C361 76.2 368 63 368 48c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 15 7 28.2 17.7 37l-81.5 142.6c-8.9 15.6-28.9 20.8-44.2 11.6l-72.3-43.4c2.7-6 4.4-12.7 4.4-19.8 0-26.5-21.5-48-48-48S0 149.5 0 176s21.5 48 48 48c2.6 0 5.2-.4 7.7-.8L128 416h384l72.3-192.8c2.5.4 5.1.8 7.7.8 26.5 0 48-21.5 48-48s-21.5-48-48-48z"
        ],
        "crutch": [
            512,
            512,
            [],
            "f7f7",
            "M507.31 185.71l-181-181a16 16 0 0 0-22.62 0L281 27.31a16 16 0 0 0 0 22.63l181 181a16 16 0 0 0 22.63 0l22.62-22.63a16 16 0 0 0 .06-22.6zm-179.54 66.41l-67.89-67.89 55.1-55.1-45.25-45.25-109.67 109.67a96.08 96.08 0 0 0-25.67 46.29L106.65 360.1l-102 102a16 16 0 0 0 0 22.63l22.62 22.62a16 16 0 0 0 22.63 0l102-102 120.25-27.75a95.88 95.88 0 0 0 46.29-25.65l109.68-109.68L382.87 197zm-54.57 54.57a32 32 0 0 1-15.45 8.54l-79.3 18.32 18.3-79.3a32.22 32.22 0 0 1 8.56-15.45l9.31-9.31 67.89 67.89z"
        ],
        "cube": [
            512,
            512,
            [],
            "f1b2",
            "M239.1 6.3l-208 78c-18.7 7-31.1 25-31.1 45v225.1c0 18.2 10.3 34.8 26.5 42.9l208 104c13.5 6.8 29.4 6.8 42.9 0l208-104c16.3-8.1 26.5-24.8 26.5-42.9V129.3c0-20-12.4-37.9-31.1-44.9l-208-78C262 2.2 250 2.2 239.1 6.3zM256 68.4l192 72v1.1l-192 78-192-78v-1.1l192-72zm32 356V275.5l160-65v133.9l-160 80z"
        ],
        "cubes": [
            512,
            512,
            [],
            "f1b3",
            "M488.6 250.2L392 214V105.5c0-15-9.3-28.4-23.4-33.7l-100-37.5c-8.1-3.1-17.1-3.1-25.3 0l-100 37.5c-14.1 5.3-23.4 18.7-23.4 33.7V214l-96.6 36.2C9.3 255.5 0 268.9 0 283.9V394c0 13.6 7.7 26.1 19.9 32.2l100 50c10.1 5.1 22.1 5.1 32.2 0l103.9-52 103.9 52c10.1 5.1 22.1 5.1 32.2 0l100-50c12.2-6.1 19.9-18.6 19.9-32.2V283.9c0-15-9.3-28.4-23.4-33.7zM358 214.8l-85 31.9v-68.2l85-37v73.3zM154 104.1l102-38.2 102 38.2v.6l-102 41.4-102-41.4v-.6zm84 291.1l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6zm240 112l-85 42.5v-79.1l85-38.8v75.4zm0-112l-102 41.4-102-41.4v-.6l102-38.2 102 38.2v.6z"
        ],
        "cut": [
            448,
            512,
            [],
            "f0c4",
            "M278.06 256L444.48 89.57c4.69-4.69 4.69-12.29 0-16.97-32.8-32.8-85.99-32.8-118.79 0L210.18 188.12l-24.86-24.86c4.31-10.92 6.68-22.81 6.68-35.26 0-53.02-42.98-96-96-96S0 74.98 0 128s42.98 96 96 96c4.54 0 8.99-.32 13.36-.93L142.29 256l-32.93 32.93c-4.37-.61-8.83-.93-13.36-.93-53.02 0-96 42.98-96 96s42.98 96 96 96 96-42.98 96-96c0-12.45-2.37-24.34-6.68-35.26l24.86-24.86L325.69 439.4c32.8 32.8 85.99 32.8 118.79 0 4.69-4.68 4.69-12.28 0-16.97L278.06 256zM96 160c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32zm0 256c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"
        ],
        "database": [
            448,
            512,
            [],
            "f1c0",
            "M448 73.143v45.714C448 159.143 347.667 192 224 192S0 159.143 0 118.857V73.143C0 32.857 100.333 0 224 0s224 32.857 224 73.143zM448 176v102.857C448 319.143 347.667 352 224 352S0 319.143 0 278.857V176c48.125 33.143 136.208 48.572 224 48.572S399.874 209.143 448 176zm0 160v102.857C448 479.143 347.667 512 224 512S0 479.143 0 438.857V336c48.125 33.143 136.208 48.572 224 48.572S399.874 369.143 448 336z"
        ],
        "deaf": [
            512,
            512,
            [],
            "f2a4",
            "M216 260c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-44.112 35.888-80 80-80s80 35.888 80 80c0 15.464-12.536 28-28 28s-28-12.536-28-28c0-13.234-10.767-24-24-24s-24 10.766-24 24zm24-176c-97.047 0-176 78.953-176 176 0 15.464 12.536 28 28 28s28-12.536 28-28c0-66.168 53.832-120 120-120s120 53.832 120 120c0 75.164-71.009 70.311-71.997 143.622L288 404c0 28.673-23.327 52-52 52-15.464 0-28 12.536-28 28s12.536 28 28 28c59.475 0 107.876-48.328 108-107.774.595-34.428 72-48.24 72-144.226 0-97.047-78.953-176-176-176zm268.485-52.201L480.2 3.515c-4.687-4.686-12.284-4.686-16.971 0L376.2 90.544c-4.686 4.686-4.686 12.284 0 16.971l28.285 28.285c4.686 4.686 12.284 4.686 16.97 0l87.03-87.029c4.687-4.688 4.687-12.286 0-16.972zM168.97 314.745c-4.686-4.686-12.284-4.686-16.97 0L3.515 463.23c-4.686 4.686-4.686 12.284 0 16.971L31.8 508.485c4.687 4.686 12.284 4.686 16.971 0L197.256 360c4.686-4.686 4.686-12.284 0-16.971l-28.286-28.284z"
        ],
        "democrat": [
            640,
            512,
            [],
            "f747",
            "M637.3 256.9l-19.6-29.4c-28.2-42.3-75.3-67.5-126.1-67.5H256l-81.2-81.2c20.1-20.1 22.6-51.1 7.5-73.9-3.4-5.2-10.8-5.9-15.2-1.5l-41.8 41.8L82.4 2.4c-3.6-3.6-9.6-3-12.4 1.2-12.3 18.6-10.3 44 6.1 60.4 3.3 3.3 7.3 5.3 11.3 7.5-2.2 1.7-4.7 3.1-6.4 5.4L6.4 176.2c-7.3 9.7-8.4 22.7-3 33.5l14.3 28.6c5.4 10.8 16.5 17.7 28.6 17.7h31c8.5 0 16.6-3.4 22.6-9.4L138 212l54 108h352v-77.8c16.2 12.2 18.3 17.6 40.1 50.3 4.9 7.4 14.8 9.3 22.2 4.4l26.6-17.7c7.3-5 9.3-14.9 4.4-22.3zm-341.1-13.6l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L256 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L368 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zm112 0l-16.5 16.1 3.9 22.7c.7 4.1-3.6 7.2-7.2 5.3L480 276.7l-20.4 10.7c-3.6 1.9-7.9-1.2-7.2-5.3l3.9-22.7-16.5-16.1c-3-2.9-1.3-7.9 2.8-8.5l22.8-3.3 10.2-20.7c1.8-3.7 7.1-3.7 9 0l10.2 20.7 22.8 3.3c4 .6 5.6 5.6 2.6 8.5zM192 496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80h160v80c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16V352H192v144z"
        ],
        "desktop": [
            576,
            512,
            [],
            "f108",
            "M528 0H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h192l-16 48h-72c-13.3 0-24 10.7-24 24s10.7 24 24 24h272c13.3 0 24-10.7 24-24s-10.7-24-24-24h-72l-16-48h192c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-16 352H64V64h448v288z"
        ],
        "dharmachakra": [
            512,
            512,
            [],
            "f655",
            "M495 225.06l-17.22 1.08c-5.27-39.49-20.79-75.64-43.86-105.84l12.95-11.43c6.92-6.11 7.25-16.79.73-23.31L426.44 64.4c-6.53-6.53-17.21-6.19-23.31.73L391.7 78.07c-30.2-23.06-66.35-38.58-105.83-43.86L286.94 17c.58-9.21-6.74-17-15.97-17h-29.94c-9.23 0-16.54 7.79-15.97 17l1.08 17.22c-39.49 5.27-75.64 20.79-105.83 43.86l-11.43-12.95c-6.11-6.92-16.79-7.25-23.31-.73L64.4 85.56c-6.53 6.53-6.19 17.21.73 23.31l12.95 11.43c-23.06 30.2-38.58 66.35-43.86 105.84L17 225.06c-9.21-.58-17 6.74-17 15.97v29.94c0 9.23 7.79 16.54 17 15.97l17.22-1.08c5.27 39.49 20.79 75.64 43.86 105.83l-12.95 11.43c-6.92 6.11-7.25 16.79-.73 23.31l21.17 21.17c6.53 6.53 17.21 6.19 23.31-.73l11.43-12.95c30.2 23.06 66.35 38.58 105.84 43.86L225.06 495c-.58 9.21 6.74 17 15.97 17h29.94c9.23 0 16.54-7.79 15.97-17l-1.08-17.22c39.49-5.27 75.64-20.79 105.84-43.86l11.43 12.95c6.11 6.92 16.79 7.25 23.31.73l21.17-21.17c6.53-6.53 6.19-17.21-.73-23.31l-12.95-11.43c23.06-30.2 38.58-66.35 43.86-105.83l17.22 1.08c9.21.58 17-6.74 17-15.97v-29.94c-.01-9.23-7.8-16.54-17.01-15.97zM281.84 98.61c24.81 4.07 47.63 13.66 67.23 27.78l-42.62 48.29c-8.73-5.44-18.32-9.54-28.62-11.95l4.01-64.12zm-51.68 0l4.01 64.12c-10.29 2.41-19.89 6.52-28.62 11.95l-42.62-48.29c19.6-14.12 42.42-23.71 67.23-27.78zm-103.77 64.33l48.3 42.61c-5.44 8.73-9.54 18.33-11.96 28.62l-64.12-4.01c4.07-24.81 13.66-47.62 27.78-67.22zm-27.78 118.9l64.12-4.01c2.41 10.29 6.52 19.89 11.95 28.62l-48.29 42.62c-14.12-19.6-23.71-42.42-27.78-67.23zm131.55 131.55c-24.81-4.07-47.63-13.66-67.23-27.78l42.61-48.3c8.73 5.44 18.33 9.54 28.62 11.96l-4 64.12zM256 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm25.84 125.39l-4.01-64.12c10.29-2.41 19.89-6.52 28.62-11.96l42.61 48.3c-19.6 14.12-42.41 23.71-67.22 27.78zm103.77-64.33l-48.29-42.62c5.44-8.73 9.54-18.32 11.95-28.62l64.12 4.01c-4.07 24.82-13.66 47.64-27.78 67.23zm-36.34-114.89c-2.41-10.29-6.52-19.89-11.96-28.62l48.3-42.61c14.12 19.6 23.71 42.42 27.78 67.23l-64.12 4z"
        ],
        "diagnoses": [
            640,
            512,
            [],
            "f470",
            "M496 256c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm-176-80c48.5 0 88-39.5 88-88S368.5 0 320 0s-88 39.5-88 88 39.5 88 88 88zM59.8 364c10.2 15.3 29.3 17.8 42.9 9.8 16.2-9.6 56.2-31.7 105.3-48.6V416h224v-90.7c49.1 16.8 89.1 39 105.3 48.6 13.6 8 32.7 5.3 42.9-9.8l17.8-26.7c8.8-13.2 7.6-34.6-10-45.1-11.9-7.1-29.7-17-51.1-27.4-28.1 46.1-99.4 17.8-87.7-35.1C409.3 217.2 365.1 208 320 208c-57 0-112.9 14.5-160 32.2-.2 40.2-47.6 63.3-79.2 36-11.2 6-21.3 11.6-28.7 16-17.6 10.5-18.8 31.8-10 45.1L59.8 364zM368 344c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-96-96c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm-160 8c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zm512 192H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
        ],
        "dice": [
            640,
            512,
            [],
            "f522",
            "M592 192H473.26c12.69 29.59 7.12 65.2-17 89.32L320 417.58V464c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48V240c0-26.51-21.49-48-48-48zM480 376c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm-46.37-186.7L258.7 14.37c-19.16-19.16-50.23-19.16-69.39 0L14.37 189.3c-19.16 19.16-19.16 50.23 0 69.39L189.3 433.63c19.16 19.16 50.23 19.16 69.39 0L433.63 258.7c19.16-19.17 19.16-50.24 0-69.4zM96 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm0-128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm128 128c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
        ],
        "dice-d20": [
            480,
            512,
            [],
            "f6cf",
            "M106.75 215.06L1.2 370.95c-3.08 5 .1 11.5 5.93 12.14l208.26 22.07-108.64-190.1zM7.41 315.43L82.7 193.08 6.06 147.1c-2.67-1.6-6.06.32-6.06 3.43v162.81c0 4.03 5.29 5.53 7.41 2.09zM18.25 423.6l194.4 87.66c5.3 2.45 11.35-1.43 11.35-7.26v-65.67l-203.55-22.3c-4.45-.5-6.23 5.59-2.2 7.57zm81.22-257.78L179.4 22.88c4.34-7.06-3.59-15.25-10.78-11.14L17.81 110.35c-2.47 1.62-2.39 5.26.13 6.78l81.53 48.69zM240 176h109.21L253.63 7.62C250.5 2.54 245.25 0 240 0s-10.5 2.54-13.63 7.62L130.79 176H240zm233.94-28.9l-76.64 45.99 75.29 122.35c2.11 3.44 7.41 1.94 7.41-2.1V150.53c0-3.11-3.39-5.03-6.06-3.43zm-93.41 18.72l81.53-48.7c2.53-1.52 2.6-5.16.13-6.78l-150.81-98.6c-7.19-4.11-15.12 4.08-10.78 11.14l79.93 142.94zm79.02 250.21L256 438.32v65.67c0 5.84 6.05 9.71 11.35 7.26l194.4-87.66c4.03-1.97 2.25-8.06-2.2-7.56zm-86.3-200.97l-108.63 190.1 208.26-22.07c5.83-.65 9.01-7.14 5.93-12.14L373.25 215.06zM240 208H139.57L240 383.75 340.43 208H240z"
        ],
        "dice-d6": [
            448,
            512,
            [],
            "f6d1",
            "M422.19 109.95L256.21 9.07c-19.91-12.1-44.52-12.1-64.43 0L25.81 109.95c-5.32 3.23-5.29 11.27.06 14.46L224 242.55l198.14-118.14c5.35-3.19 5.38-11.22.05-14.46zm13.84 44.63L240 271.46v223.82c0 12.88 13.39 20.91 24.05 14.43l152.16-92.48c19.68-11.96 31.79-33.94 31.79-57.7v-197.7c0-6.41-6.64-10.43-11.97-7.25zM0 161.83v197.7c0 23.77 12.11 45.74 31.79 57.7l152.16 92.47c10.67 6.48 24.05-1.54 24.05-14.43V271.46L11.97 154.58C6.64 151.4 0 155.42 0 161.83z"
        ],
        "dice-five": [
            448,
            512,
            [],
            "f523",
            "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
        ],
        "dice-four": [
            448,
            512,
            [],
            "f524",
            "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
        ],
        "dice-one": [
            448,
            512,
            [],
            "f525",
            "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM224 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
        ],
        "dice-six": [
            448,
            512,
            [],
            "f526",
            "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
        ],
        "dice-three": [
            448,
            512,
            [],
            "f527",
            "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm96 96c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
        ],
        "dice-two": [
            448,
            512,
            [],
            "f528",
            "M384 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V96c0-35.35-28.65-64-64-64zM128 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm192 192c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
        ],
        "digital-tachograph": [
            640,
            512,
            [],
            "f566",
            "M608 96H32c-17.67 0-32 14.33-32 32v256c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128c0-17.67-14.33-32-32-32zM304 352c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8zM72 288v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H80c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm64 0v-16c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8zm40-64c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-48c0-8.84 7.16-16 16-16h208c8.84 0 16 7.16 16 16v48zm272 128c0 4.42-3.58 8-8 8H344c-4.42 0-8-3.58-8-8v-8c0-4.42 3.58-8 8-8h224c4.42 0 8 3.58 8 8v8z"
        ],
        "directions": [
            512,
            512,
            [],
            "f5eb",
            "M502.61 233.32L278.68 9.39c-12.52-12.52-32.83-12.52-45.36 0L9.39 233.32c-12.52 12.53-12.52 32.83 0 45.36l223.93 223.93c12.52 12.53 32.83 12.53 45.36 0l223.93-223.93c12.52-12.53 12.52-32.83 0-45.36zm-100.98 12.56l-84.21 77.73c-5.12 4.73-13.43 1.1-13.43-5.88V264h-96v64c0 4.42-3.58 8-8 8h-32c-4.42 0-8-3.58-8-8v-80c0-17.67 14.33-32 32-32h112v-53.73c0-6.97 8.3-10.61 13.43-5.88l84.21 77.73c3.43 3.17 3.43 8.59 0 11.76z"
        ],
        "disease": [
            512,
            512,
            [],
            "f7fa",
            "M472.29 195.9l-67.06-23c-19.28-6.6-33.54-20.92-38.14-38.31l-16-60.45c-11.58-43.77-76.57-57.13-110-22.62L195 99.24c-13.26 13.71-33.54 20.93-54.2 19.31l-71.9-5.62c-52-4.07-86.93 44.89-59 82.84l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24l-28.43 57C4 396.67 47.46 440.29 98.11 429.23l70-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101 7.57 104.45-37.22l4.7-61.86c1.35-17.8 12.8-33.87 30.63-43l62-31.74c44.84-22.96 39.55-80.17-8.99-96.79zM160 256a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm128 96a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm16-128a16 16 0 1 1 16-16 16 16 0 0 1-16 16z"
        ],
        "divide": [
            448,
            512,
            [],
            "f529",
            "M224 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm0-192c35.35 0 64-28.65 64-64s-28.65-64-64-64-64 28.65-64 64 28.65 64 64 64zm192 48H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
        ],
        "dizzy": [
            496,
            512,
            [],
            "f567",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-96 206.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L174.6 192l28.7 28.7c15.2 15.2-7.9 37.4-22.6 22.6L152 214.6zM248 416c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm147.3-195.3c15.2 15.2-7.9 37.4-22.6 22.6L344 214.6l-28.7 28.7c-14.8 14.8-37.8-7.5-22.6-22.6l28.7-28.7-28.7-28.7c-15-15 7.7-37.6 22.6-22.6l28.7 28.7 28.7-28.7c15-15 37.6 7.7 22.6 22.6L366.6 192l28.7 28.7z"
        ],
        "dna": [
            448,
            512,
            [],
            "f471",
            "M.1 494.1c-1.1 9.5 6.3 17.8 15.9 17.8l32.3.1c8.1 0 14.9-5.9 16-13.9.7-4.9 1.8-11.1 3.4-18.1H380c1.6 6.9 2.9 13.2 3.5 18.1 1.1 8 7.9 14 16 13.9l32.3-.1c9.6 0 17.1-8.3 15.9-17.8-4.6-37.9-25.6-129-118.9-207.7-17.6 12.4-37.1 24.2-58.5 35.4 6.2 4.6 11.4 9.4 17 14.2H159.7c21.3-18.1 47-35.6 78.7-51.4C410.5 199.1 442.1 65.8 447.9 17.9 449 8.4 441.6.1 432 .1L399.6 0c-8.1 0-14.9 5.9-16 13.9-.7 4.9-1.8 11.1-3.4 18.1H67.8c-1.6-7-2.7-13.1-3.4-18.1-1.1-8-7.9-14-16-13.9L16.1.1C6.5.1-1 8.4.1 17.9 5.3 60.8 31.4 171.8 160 256 31.5 340.2 5.3 451.2.1 494.1zM224 219.6c-25.1-13.7-46.4-28.4-64.3-43.6h128.5c-17.8 15.2-39.1 30-64.2 43.6zM355.1 96c-5.8 10.4-12.8 21.1-21 32H114c-8.3-10.9-15.3-21.6-21-32h262.1zM92.9 416c5.8-10.4 12.8-21.1 21-32h219.4c8.3 10.9 15.4 21.6 21.2 32H92.9z"
        ],
        "dog": [
            576,
            512,
            [],
            "f6d3",
            "M298.06,224,448,277.55V496a16,16,0,0,1-16,16H368a16,16,0,0,1-16-16V384H192V496a16,16,0,0,1-16,16H112a16,16,0,0,1-16-16V282.09C58.84,268.84,32,233.66,32,192a32,32,0,0,1,64,0,32.06,32.06,0,0,0,32,32ZM544,112v32a64,64,0,0,1-64,64H448v35.58L320,197.87V48c0-14.25,17.22-21.39,27.31-11.31L374.59,64h53.63c10.91,0,23.75,7.92,28.62,17.69L464,96h64A16,16,0,0,1,544,112Zm-112,0a16,16,0,1,0-16,16A16,16,0,0,0,432,112Z"
        ],
        "dollar-sign": [
            288,
            512,
            [],
            "f155",
            "M209.2 233.4l-108-31.6C88.7 198.2 80 186.5 80 173.5c0-16.3 13.2-29.5 29.5-29.5h66.3c12.2 0 24.2 3.7 34.2 10.5 6.1 4.1 14.3 3.1 19.5-2l34.8-34c7.1-6.9 6.1-18.4-1.8-24.5C238 74.8 207.4 64.1 176 64V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v48h-2.5C45.8 64-5.4 118.7.5 183.6c4.2 46.1 39.4 83.6 83.8 96.6l102.5 30c12.5 3.7 21.2 15.3 21.2 28.3 0 16.3-13.2 29.5-29.5 29.5h-66.3C100 368 88 364.3 78 357.5c-6.1-4.1-14.3-3.1-19.5 2l-34.8 34c-7.1 6.9-6.1 18.4 1.8 24.5 24.5 19.2 55.1 29.9 86.5 30v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48.2c46.6-.9 90.3-28.6 105.7-72.7 21.5-61.6-14.6-124.8-72.5-141.7z"
        ],
        "dolly": [
            576,
            512,
            [],
            "f472",
            "M294.2 277.7c18 5 34.7 13.4 49.5 24.7l161.5-53.8c8.4-2.8 12.9-11.9 10.1-20.2L454.9 47.2c-2.8-8.4-11.9-12.9-20.2-10.1l-61.1 20.4 33.1 99.4L346 177l-33.1-99.4-61.6 20.5c-8.4 2.8-12.9 11.9-10.1 20.2l53 159.4zm281 48.7L565 296c-2.8-8.4-11.9-12.9-20.2-10.1l-213.5 71.2c-17.2-22-43.6-36.4-73.5-37L158.4 21.9C154 8.8 141.8 0 128 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h88.9l92.2 276.7c-26.1 20.4-41.7 53.6-36 90.5 6.1 39.4 37.9 72.3 77.3 79.2 60.2 10.7 112.3-34.8 113.4-92.6l213.3-71.2c8.3-2.8 12.9-11.8 10.1-20.2zM256 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
        ],
        "dolly-flatbed": [
            640,
            512,
            [],
            "f474",
            "M208 320h384c8.8 0 16-7.2 16-16V48c0-8.8-7.2-16-16-16H448v128l-48-32-48 32V32H208c-8.8 0-16 7.2-16 16v256c0 8.8 7.2 16 16 16zm416 64H128V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h82.9c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H451c-1.8 5-2.9 10.4-2.9 16 0 26.5 21.5 48 48 48s48-21.5 48-48c0-5.6-1.2-11-2.9-16H624c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
        ],
        "donate": [
            512,
            512,
            [],
            "f4b9",
            "M256 416c114.9 0 208-93.1 208-208S370.9 0 256 0 48 93.1 48 208s93.1 208 208 208zM233.8 97.4V80.6c0-9.2 7.4-16.6 16.6-16.6h11.1c9.2 0 16.6 7.4 16.6 16.6v17c15.5.8 30.5 6.1 43 15.4 5.6 4.1 6.2 12.3 1.2 17.1L306 145.6c-3.8 3.7-9.5 3.8-14 1-5.4-3.4-11.4-5.1-17.8-5.1h-38.9c-9 0-16.3 8.2-16.3 18.3 0 8.2 5 15.5 12.1 17.6l62.3 18.7c25.7 7.7 43.7 32.4 43.7 60.1 0 34-26.4 61.5-59.1 62.4v16.8c0 9.2-7.4 16.6-16.6 16.6h-11.1c-9.2 0-16.6-7.4-16.6-16.6v-17c-15.5-.8-30.5-6.1-43-15.4-5.6-4.1-6.2-12.3-1.2-17.1l16.3-15.5c3.8-3.7 9.5-3.8 14-1 5.4 3.4 11.4 5.1 17.8 5.1h38.9c9 0 16.3-8.2 16.3-18.3 0-8.2-5-15.5-12.1-17.6l-62.3-18.7c-25.7-7.7-43.7-32.4-43.7-60.1.1-34 26.4-61.5 59.1-62.4zM480 352h-32.5c-19.6 26-44.6 47.7-73 64h63.8c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8h63.8c-28.4-16.3-53.3-38-73-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32z"
        ],
        "door-closed": [
            640,
            512,
            [],
            "f52a",
            "M624 448H512V50.8C512 22.78 490.47 0 464 0H175.99c-26.47 0-48 22.78-48 50.8V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM415.99 288c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32c.01 17.67-14.32 32-32 32z"
        ],
        "door-open": [
            640,
            512,
            [],
            "f52b",
            "M624 448h-80V113.45C544 86.19 522.47 64 496 64H384v64h96v384h144c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM312.24 1.01l-192 49.74C105.99 54.44 96 67.7 96 82.92V448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h336V33.18c0-21.58-19.56-37.41-39.76-32.17zM264 288c-13.25 0-24-14.33-24-32s10.75-32 24-32 24 14.33 24 32-10.75 32-24 32z"
        ],
        "dot-circle": [
            512,
            512,
            [],
            "f192",
            "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm80 248c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80z"
        ],
        "dove": [
            512,
            512,
            [],
            "f4ba",
            "M288 167.2v-28.1c-28.2-36.3-47.1-79.3-54.1-125.2-2.1-13.5-19-18.8-27.8-8.3-21.1 24.9-37.7 54.1-48.9 86.5 34.2 38.3 80 64.6 130.8 75.1zM400 64c-44.2 0-80 35.9-80 80.1v59.4C215.6 197.3 127 133 87 41.8c-5.5-12.5-23.2-13.2-29-.9C41.4 76 32 115.2 32 156.6c0 70.8 34.1 136.9 85.1 185.9 13.2 12.7 26.1 23.2 38.9 32.8l-143.9 36C1.4 414-3.4 426.4 2.6 435.7 20 462.6 63 508.2 155.8 512c8 .3 16-2.6 22.1-7.9l65.2-56.1H320c88.4 0 160-71.5 160-159.9V128l32-64H400zm0 96.1c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
        ],
        "download": [
            512,
            512,
            [],
            "f019",
            "M216 0h80c13.3 0 24 10.7 24 24v168h87.7c17.8 0 26.7 21.5 14.1 34.1L269.7 378.3c-7.5 7.5-19.8 7.5-27.3 0L90.1 226.1c-12.6-12.6-3.7-34.1 14.1-34.1H192V24c0-13.3 10.7-24 24-24zm296 376v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h146.7l49 49c20.1 20.1 52.5 20.1 72.6 0l49-49H488c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
        ],
        "drafting-compass": [
            512,
            512,
            [],
            "f568",
            "M457.01 344.42c-25.05 20.33-52.63 37.18-82.54 49.05l54.38 94.19 53.95 23.04c9.81 4.19 20.89-2.21 22.17-12.8l7.02-58.25-54.98-95.23zm42.49-94.56c4.86-7.67 1.89-17.99-6.05-22.39l-28.07-15.57c-7.48-4.15-16.61-1.46-21.26 5.72C403.01 281.15 332.25 320 256 320c-23.93 0-47.23-4.25-69.41-11.53l67.36-116.68c.7.02 1.34.21 2.04.21s1.35-.19 2.04-.21l51.09 88.5c31.23-8.96 59.56-25.75 82.61-48.92l-51.79-89.71C347.39 128.03 352 112.63 352 96c0-53.02-42.98-96-96-96s-96 42.98-96 96c0 16.63 4.61 32.03 12.05 45.66l-68.3 118.31c-12.55-11.61-23.96-24.59-33.68-39-4.79-7.1-13.97-9.62-21.38-5.33l-27.75 16.07c-7.85 4.54-10.63 14.9-5.64 22.47 15.57 23.64 34.69 44.21 55.98 62.02L0 439.66l7.02 58.25c1.28 10.59 12.36 16.99 22.17 12.8l53.95-23.04 70.8-122.63C186.13 377.28 220.62 384 256 384c99.05 0 190.88-51.01 243.5-134.14zM256 64c17.67 0 32 14.33 32 32s-14.33 32-32 32-32-14.33-32-32 14.33-32 32-32z"
        ],
        "dragon": [
            640,
            512,
            [],
            "f6d5",
            "M18.32 255.78L192 223.96l-91.28 68.69c-10.08 10.08-2.94 27.31 11.31 27.31h222.7c-9.44-26.4-14.73-54.47-14.73-83.38v-42.27l-119.73-87.6c-23.82-15.88-55.29-14.01-77.06 4.59L5.81 227.64c-12.38 10.33-3.45 30.42 12.51 28.14zm556.87 34.1l-100.66-50.31A47.992 47.992 0 0 1 448 196.65v-36.69h64l28.09 22.63c6 6 14.14 9.37 22.63 9.37h30.97a32 32 0 0 0 28.62-17.69l14.31-28.62a32.005 32.005 0 0 0-3.02-33.51l-74.53-99.38C553.02 4.7 543.54 0 533.47 0H296.02c-7.13 0-10.7 8.57-5.66 13.61L352 63.96 292.42 88.8c-5.9 2.95-5.9 11.36 0 14.31L352 127.96v108.62c0 72.08 36.03 139.39 96 179.38-195.59 6.81-344.56 41.01-434.1 60.91C5.78 478.67 0 485.88 0 494.2 0 504 7.95 512 17.76 512h499.08c63.29.01 119.61-47.56 122.99-110.76 2.52-47.28-22.73-90.4-64.64-111.36zM489.18 66.25l45.65 11.41c-2.75 10.91-12.47 18.89-24.13 18.26-12.96-.71-25.85-12.53-21.52-29.67z"
        ],
        "draw-polygon": [
            448,
            512,
            [],
            "f5ee",
            "M384 352c-.35 0-.67.1-1.02.1l-39.2-65.32c5.07-9.17 8.22-19.56 8.22-30.78s-3.14-21.61-8.22-30.78l39.2-65.32c.35.01.67.1 1.02.1 35.35 0 64-28.65 64-64s-28.65-64-64-64c-23.63 0-44.04 12.95-55.12 32H119.12C108.04 44.95 87.63 32 64 32 28.65 32 0 60.65 0 96c0 23.63 12.95 44.04 32 55.12v209.75C12.95 371.96 0 392.37 0 416c0 35.35 28.65 64 64 64 23.63 0 44.04-12.95 55.12-32h209.75c11.09 19.05 31.49 32 55.12 32 35.35 0 64-28.65 64-64 .01-35.35-28.64-64-63.99-64zm-288 8.88V151.12A63.825 63.825 0 0 0 119.12 128h208.36l-38.46 64.1c-.35-.01-.67-.1-1.02-.1-35.35 0-64 28.65-64 64s28.65 64 64 64c.35 0 .67-.1 1.02-.1l38.46 64.1H119.12A63.748 63.748 0 0 0 96 360.88zM272 256c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zM400 96c0 8.82-7.18 16-16 16s-16-7.18-16-16 7.18-16 16-16 16 7.18 16 16zM64 80c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zM48 416c0-8.82 7.18-16 16-16s16 7.18 16 16-7.18 16-16 16-16-7.18-16-16zm336 16c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16z"
        ],
        "drum": [
            512,
            512,
            [],
            "f569",
            "M431.34 122.05l73.53-47.42a16 16 0 0 0 4.44-22.19l-8.87-13.31a16 16 0 0 0-22.19-4.44l-110.06 71C318.43 96.91 271.22 96 256 96 219.55 96 0 100.55 0 208.15v160.23c0 30.27 27.5 57.68 72 77.86v-101.9a24 24 0 1 1 48 0v118.93c33.05 9.11 71.07 15.06 112 16.73V376.39a24 24 0 1 1 48 0V480c40.93-1.67 78.95-7.62 112-16.73V344.34a24 24 0 1 1 48 0v101.9c44.5-20.18 72-47.59 72-77.86V208.15c0-43.32-35.76-69.76-80.66-86.1zM256 272.24c-114.88 0-208-28.69-208-64.09s93.12-64.08 208-64.08c17.15 0 33.73.71 49.68 1.91l-72.81 47a16 16 0 0 0-4.43 22.19l8.87 13.31a16 16 0 0 0 22.19 4.44l118.64-76.52C430.09 168 464 186.84 464 208.15c0 35.4-93.13 64.09-208 64.09z"
        ],
        "drum-steelpan": [
            576,
            512,
            [],
            "f56a",
            "M288 32C128.94 32 0 89.31 0 160v192c0 70.69 128.94 128 288 128s288-57.31 288-128V160c0-70.69-128.94-128-288-128zm-82.99 158.36c-4.45 16.61-14.54 30.57-28.31 40.48C100.23 217.46 48 190.78 48 160c0-30.16 50.11-56.39 124.04-70.03l25.6 44.34c9.86 17.09 12.48 36.99 7.37 56.05zM288 240c-21.08 0-41.41-1-60.89-2.7 8.06-26.13 32.15-45.3 60.89-45.3s52.83 19.17 60.89 45.3C329.41 239 309.08 240 288 240zm64-144c0 35.29-28.71 64-64 64s-64-28.71-64-64V82.96c20.4-1.88 41.8-2.96 64-2.96s43.6 1.08 64 2.96V96zm46.93 134.9c-13.81-9.91-23.94-23.9-28.4-40.54-5.11-19.06-2.49-38.96 7.38-56.04l25.65-44.42C477.72 103.5 528 129.79 528 160c0 30.83-52.4 57.54-129.07 70.9z"
        ],
        "drumstick-bite": [
            512,
            512,
            [],
            "f6d7",
            "M462.8 49.57a169.44 169.44 0 0 0-239.5 0C187.82 85 160.13 128 160.13 192v85.83l-40.62 40.59c-9.7 9.69-24 11.07-36.78 6a60.33 60.33 0 0 0-65 98.72C33 438.39 54.24 442.7 73.85 438.21c-4.5 19.6-.18 40.83 15.1 56.1a60.35 60.35 0 0 0 98.8-65c-5.09-12.73-3.72-27 6-36.75L234.36 352h85.89a187.87 187.87 0 0 0 61.89-10c-39.64-43.89-39.83-110.23 1.05-151.07 34.38-34.36 86.76-39.46 128.74-16.8 1.3-44.96-14.81-90.28-49.13-124.56z"
        ],
        "dumbbell": [
            640,
            512,
            [],
            "f44b",
            "M104 96H56c-13.3 0-24 10.7-24 24v104H8c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h24v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm528 128h-24V120c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v272c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h24c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM456 32h-48c-13.3 0-24 10.7-24 24v168H256V56c0-13.3-10.7-24-24-24h-48c-13.3 0-24 10.7-24 24v400c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V288h128v168c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24z"
        ],
        "dumpster": [
            576,
            512,
            [],
            "f793",
            "M560 160c10.4 0 18-9.8 15.5-19.9l-24-96C549.7 37 543.3 32 536 32h-98.9l25.6 128H560zM272 32H171.5l-25.6 128H272V32zm132.5 0H304v128h126.1L404.5 32zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm544 64h-20l4-32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h320v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16l20-160h28c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
        ],
        "dumpster-fire": [
            640,
            512,
            [],
            "f794",
            "M418.7 104.1l.2-.2-14.4-72H304v128h60.8c16.2-19.3 34.2-38.2 53.9-55.8zM272 32H171.5l-25.6 128H272V32zm189.3 72.1c18.2 16.3 35.5 33.7 51.1 51.5 5.7-5.6 11.4-11.1 17.3-16.3l21.3-19 21.3 19c1.1.9 2.1 2.1 3.1 3.1-.1-.8.2-1.5 0-2.3l-24-96C549.7 37 543.3 32 536 32h-98.9l12.3 61.5 11.9 10.6zM16 160h97.3l25.6-128H40c-7.3 0-13.7 5-15.5 12.1l-24 96C-2 150.2 5.6 160 16 160zm324.6 32H32l4 32H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h28l20 160v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208.8c-30.2-33.7-48.8-77.9-48.8-126.4 0-35.9 19.9-82.9 52.6-129.6zm210.5-28.8c-14.9 13.3-28.3 27.2-40.2 41.2-19.5-25.8-43.6-52-71-76.4-70.2 62.7-120 144.3-120 193.6 0 87.5 71.6 158.4 160 158.4s160-70.9 160-158.4c.1-36.6-37-112.2-88.8-158.4zm-18.6 229.4c-14.7 10.7-32.9 17-52.5 17-49 0-88.9-33.5-88.9-88 0-27.1 16.5-51 49.4-91.9 4.7 5.6 67.1 88.1 67.1 88.1l39.8-47c2.8 4.8 5.4 9.5 7.7 14 18.6 36.7 10.8 83.6-22.6 107.8z"
        ],
        "dungeon": [
            512,
            512,
            [],
            "f6d9",
            "M128.73 195.32l-82.81-51.76c-8.04-5.02-18.99-2.17-22.93 6.45A254.19 254.19 0 0 0 .54 239.28C-.05 248.37 7.59 256 16.69 256h97.13c7.96 0 14.08-6.25 15.01-14.16 1.09-9.33 3.24-18.33 6.24-26.94 2.56-7.34.25-15.46-6.34-19.58zM319.03 8C298.86 2.82 277.77 0 256 0s-42.86 2.82-63.03 8c-9.17 2.35-13.91 12.6-10.39 21.39l37.47 104.03A16.003 16.003 0 0 0 235.1 144h41.8c6.75 0 12.77-4.23 15.05-10.58l37.47-104.03c3.52-8.79-1.22-19.03-10.39-21.39zM112 288H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm77.31-283.67l-36.32-90.8c-3.53-8.83-14.13-12.99-22.42-8.31a257.308 257.308 0 0 0-71.61 59.89c-6.06 7.32-3.85 18.48 4.22 23.52l82.93 51.83c6.51 4.07 14.66 2.62 20.11-2.79 5.18-5.15 10.79-9.85 16.79-14.05 6.28-4.41 9.15-12.17 6.3-19.29zM398.18 256h97.13c9.1 0 16.74-7.63 16.15-16.72a254.135 254.135 0 0 0-22.45-89.27c-3.94-8.62-14.89-11.47-22.93-6.45l-82.81 51.76c-6.59 4.12-8.9 12.24-6.34 19.58 3.01 8.61 5.15 17.62 6.24 26.94.93 7.91 7.05 14.16 15.01 14.16zm54.85-162.89a257.308 257.308 0 0 0-71.61-59.89c-8.28-4.68-18.88-.52-22.42 8.31l-36.32 90.8c-2.85 7.12.02 14.88 6.3 19.28 6 4.2 11.61 8.9 16.79 14.05 5.44 5.41 13.6 6.86 20.11 2.79l82.93-51.83c8.07-5.03 10.29-16.19 4.22-23.51zM496 288h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm0 128h-96c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h96c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zM240 177.62V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V177.62c-5.23-.89-10.52-1.62-16-1.62s-10.77.73-16 1.62zm-64 41.51V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V189.36c-12.78 7.45-23.84 17.47-32 29.77zm128-29.77V472c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8V219.13c-8.16-12.3-19.22-22.32-32-29.77z"
        ],
        "edit": [
            576,
            512,
            [],
            "f044",
            "M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z"
        ],
        "egg": [
            384,
            512,
            [],
            "f7fb",
            "M192 0C86 0 0 214 0 320s86 192 192 192 192-86 192-192S298 0 192 0z"
        ],
        "eject": [
            448,
            512,
            [],
            "f052",
            "M448 384v64c0 17.673-14.327 32-32 32H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h384c17.673 0 32 14.327 32 32zM48.053 320h351.886c41.651 0 63.581-49.674 35.383-80.435L259.383 47.558c-19.014-20.743-51.751-20.744-70.767 0L12.67 239.565C-15.475 270.268 6.324 320 48.053 320z"
        ],
        "ellipsis-h": [
            512,
            512,
            [],
            "f141",
            "M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z"
        ],
        "ellipsis-v": [
            192,
            512,
            [],
            "f142",
            "M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z"
        ],
        "envelope": [
            512,
            512,
            [],
            "f0e0",
            "M502.3 190.8c3.9-3.1 9.7-.2 9.7 4.7V400c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V195.6c0-5 5.7-7.8 9.7-4.7 22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4 56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3 154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7 5.8-4.5 9.2-11.5 9.2-18.9v-19c0-26.5-21.5-48-48-48H48C21.5 64 0 85.5 0 112v19c0 7.4 3.4 14.3 9.2 18.9 30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4z"
        ],
        "envelope-open": [
            512,
            512,
            [],
            "f2b6",
            "M512 464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V200.724a48 48 0 0 1 18.387-37.776c24.913-19.529 45.501-35.365 164.2-121.511C199.412 29.17 232.797-.347 256 .003c23.198-.354 56.596 29.172 73.413 41.433 118.687 86.137 139.303 101.995 164.2 121.512A48 48 0 0 1 512 200.724V464zm-65.666-196.605c-2.563-3.728-7.7-4.595-11.339-1.907-22.845 16.873-55.462 40.705-105.582 77.079-16.825 12.266-50.21 41.781-73.413 41.43-23.211.344-56.559-29.143-73.413-41.43-50.114-36.37-82.734-60.204-105.582-77.079-3.639-2.688-8.776-1.821-11.339 1.907l-9.072 13.196a7.998 7.998 0 0 0 1.839 10.967c22.887 16.899 55.454 40.69 105.303 76.868 20.274 14.781 56.524 47.813 92.264 47.573 35.724.242 71.961-32.771 92.263-47.573 49.85-36.179 82.418-59.97 105.303-76.868a7.998 7.998 0 0 0 1.839-10.967l-9.071-13.196z"
        ],
        "envelope-open-text": [
            512,
            512,
            [],
            "f658",
            "M176 216h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16zm-16 80c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16zm96 121.13c-16.42 0-32.84-5.06-46.86-15.19L0 250.86V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V250.86L302.86 401.94c-14.02 10.12-30.44 15.19-46.86 15.19zm237.61-254.18c-8.85-6.94-17.24-13.47-29.61-22.81V96c0-26.51-21.49-48-48-48h-77.55c-3.04-2.2-5.87-4.26-9.04-6.56C312.6 29.17 279.2-.35 256 0c-23.2-.35-56.59 29.17-73.41 41.44-3.17 2.3-6 4.36-9.04 6.56H96c-26.51 0-48 21.49-48 48v44.14c-12.37 9.33-20.76 15.87-29.61 22.81A47.995 47.995 0 0 0 0 200.72v10.65l96 69.35V96h320v184.72l96-69.35v-10.65c0-14.74-6.78-28.67-18.39-37.77z"
        ],
        "envelope-square": [
            448,
            512,
            [],
            "f199",
            "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM178.117 262.104C87.429 196.287 88.353 196.121 64 177.167V152c0-13.255 10.745-24 24-24h272c13.255 0 24 10.745 24 24v25.167c-24.371 18.969-23.434 19.124-114.117 84.938-10.5 7.655-31.392 26.12-45.883 25.894-14.503.218-35.367-18.227-45.883-25.895zM384 217.775V360c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V217.775c13.958 10.794 33.329 25.236 95.303 70.214 14.162 10.341 37.975 32.145 64.694 32.01 26.887.134 51.037-22.041 64.72-32.025 61.958-44.965 81.325-59.406 95.283-70.199z"
        ],
        "equals": [
            448,
            512,
            [],
            "f52c",
            "M416 304H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32zm0-192H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
        ],
        "eraser": [
            512,
            512,
            [],
            "f12d",
            "M497.941 273.941c18.745-18.745 18.745-49.137 0-67.882l-160-160c-18.745-18.745-49.136-18.746-67.883 0l-256 256c-18.745 18.745-18.745 49.137 0 67.882l96 96A48.004 48.004 0 0 0 144 480h356c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H355.883l142.058-142.059zm-302.627-62.627l137.373 137.373L265.373 416H150.628l-80-80 124.686-124.686z"
        ],
        "ethernet": [
            512,
            512,
            [],
            "f796",
            "M496 192h-48v-48c0-8.8-7.2-16-16-16h-48V80c0-8.8-7.2-16-16-16H144c-8.8 0-16 7.2-16 16v48H80c-8.8 0-16 7.2-16 16v48H16c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16h80V320h32v128h64V320h32v128h64V320h32v128h64V320h32v128h80c8.8 0 16-7.2 16-16V208c0-8.8-7.2-16-16-16z"
        ],
        "euro-sign": [
            320,
            512,
            [],
            "f153",
            "M310.706 413.765c-1.314-6.63-7.835-10.872-14.424-9.369-10.692 2.439-27.422 5.413-45.426 5.413-56.763 0-101.929-34.79-121.461-85.449h113.689a12 12 0 0 0 11.708-9.369l6.373-28.36c1.686-7.502-4.019-14.631-11.708-14.631H115.22c-1.21-14.328-1.414-28.287.137-42.245H261.95a12 12 0 0 0 11.723-9.434l6.512-29.755c1.638-7.484-4.061-14.566-11.723-14.566H130.184c20.633-44.991 62.69-75.03 117.619-75.03 14.486 0 28.564 2.25 37.851 4.145 6.216 1.268 12.347-2.498 14.002-8.623l11.991-44.368c1.822-6.741-2.465-13.616-9.326-14.917C290.217 34.912 270.71 32 249.635 32 152.451 32 74.03 92.252 45.075 176H12c-6.627 0-12 5.373-12 12v29.755c0 6.627 5.373 12 12 12h21.569c-1.009 13.607-1.181 29.287-.181 42.245H12c-6.627 0-12 5.373-12 12v28.36c0 6.627 5.373 12 12 12h30.114C67.139 414.692 145.264 480 249.635 480c26.301 0 48.562-4.544 61.101-7.788 6.167-1.595 10.027-7.708 8.788-13.957l-8.818-44.49z"
        ],
        "exchange-alt": [
            512,
            512,
            [],
            "f362",
            "M0 168v-16c0-13.255 10.745-24 24-24h360V80c0-21.367 25.899-32.042 40.971-16.971l80 80c9.372 9.373 9.372 24.569 0 33.941l-80 80C409.956 271.982 384 261.456 384 240v-48H24c-13.255 0-24-10.745-24-24zm488 152H128v-48c0-21.314-25.862-32.08-40.971-16.971l-80 80c-9.372 9.373-9.372 24.569 0 33.941l80 80C102.057 463.997 128 453.437 128 432v-48h360c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24z"
        ],
        "exclamation": [
            192,
            512,
            [],
            "f12a",
            "M176 432c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zM25.26 25.199l13.6 272C39.499 309.972 50.041 320 62.83 320h66.34c12.789 0 23.331-10.028 23.97-22.801l13.6-272C167.425 11.49 156.496 0 142.77 0H49.23C35.504 0 24.575 11.49 25.26 25.199z"
        ],
        "exclamation-circle": [
            512,
            512,
            [],
            "f06a",
            "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zm-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
        ],
        "exclamation-triangle": [
            576,
            512,
            [],
            "f071",
            "M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"
        ],
        "expand": [
            448,
            512,
            [],
            "f065",
            "M0 180V56c0-13.3 10.7-24 24-24h124c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12H64v84c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12zM288 44v40c0 6.6 5.4 12 12 12h84v84c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V56c0-13.3-10.7-24-24-24H300c-6.6 0-12 5.4-12 12zm148 276h-40c-6.6 0-12 5.4-12 12v84h-84c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h124c13.3 0 24-10.7 24-24V332c0-6.6-5.4-12-12-12zM160 468v-40c0-6.6-5.4-12-12-12H64v-84c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v124c0 13.3 10.7 24 24 24h124c6.6 0 12-5.4 12-12z"
        ],
        "expand-alt": [
            448,
            512,
            [],
            "f424",
            "M212.686 315.314L120 408l32.922 31.029c15.12 15.12 4.412 40.971-16.97 40.971h-112C10.697 480 0 469.255 0 456V344c0-21.382 25.803-32.09 40.922-16.971L72 360l92.686-92.686c6.248-6.248 16.379-6.248 22.627 0l25.373 25.373c6.249 6.248 6.249 16.378 0 22.627zm22.628-118.628L328 104l-32.922-31.029C279.958 57.851 290.666 32 312.048 32h112C437.303 32 448 42.745 448 56v112c0 21.382-25.803 32.09-40.922 16.971L376 152l-92.686 92.686c-6.248 6.248-16.379 6.248-22.627 0l-25.373-25.373c-6.249-6.248-6.249-16.378 0-22.627z"
        ],
        "expand-arrows-alt": [
            448,
            512,
            [],
            "f31e",
            "M448 344v112a23.94 23.94 0 0 1-24 24H312c-21.39 0-32.09-25.9-17-41l36.2-36.2L224 295.6 116.77 402.9 153 439c15.09 15.1 4.39 41-17 41H24a23.94 23.94 0 0 1-24-24V344c0-21.4 25.89-32.1 41-17l36.19 36.2L184.46 256 77.18 148.7 41 185c-15.1 15.1-41 4.4-41-17V56a23.94 23.94 0 0 1 24-24h112c21.39 0 32.09 25.9 17 41l-36.2 36.2L224 216.4l107.23-107.3L295 73c-15.09-15.1-4.39-41 17-41h112a23.94 23.94 0 0 1 24 24v112c0 21.4-25.89 32.1-41 17l-36.19-36.2L263.54 256l107.28 107.3L407 327.1c15.1-15.2 41-4.5 41 16.9z"
        ],
        "external-link-alt": [
            512,
            512,
            [],
            "f35d",
            "M432,320H400a16,16,0,0,0-16,16V448H64V128H208a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H48A48,48,0,0,0,0,112V464a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V336A16,16,0,0,0,432,320ZM488,0h-128c-21.37,0-32.05,25.91-17,41l35.73,35.73L135,320.37a24,24,0,0,0,0,34L157.67,377a24,24,0,0,0,34,0L435.28,133.32,471,169c15,15,41,4.5,41-17V24A24,24,0,0,0,488,0Z"
        ],
        "external-link-square-alt": [
            448,
            512,
            [],
            "f360",
            "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-88 16H248.029c-21.313 0-32.08 25.861-16.971 40.971l31.984 31.987L67.515 364.485c-4.686 4.686-4.686 12.284 0 16.971l31.029 31.029c4.687 4.686 12.285 4.686 16.971 0l195.526-195.526 31.988 31.991C358.058 263.977 384 253.425 384 231.979V120c0-13.255-10.745-24-24-24z"
        ],
        "eye": [
            576,
            512,
            [],
            "f06e",
            "M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"
        ],
        "eye-dropper": [
            512,
            512,
            [],
            "f1fb",
            "M50.75 333.25c-12 12-18.75 28.28-18.75 45.26V424L0 480l32 32 56-32h45.49c16.97 0 33.25-6.74 45.25-18.74l126.64-126.62-128-128L50.75 333.25zM483.88 28.12c-37.47-37.5-98.28-37.5-135.75 0l-77.09 77.09-13.1-13.1c-9.44-9.44-24.65-9.31-33.94 0l-40.97 40.97c-9.37 9.37-9.37 24.57 0 33.94l161.94 161.94c9.44 9.44 24.65 9.31 33.94 0L419.88 288c9.37-9.37 9.37-24.57 0-33.94l-13.1-13.1 77.09-77.09c37.51-37.48 37.51-98.26.01-135.75z"
        ],
        "eye-slash": [
            640,
            512,
            [],
            "f070",
            "M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"
        ],
        "fan": [
            512,
            512,
            [],
            "f863",
            "M352.57 128c-28.09 0-54.09 4.52-77.06 12.86l12.41-123.11C289 7.31 279.81-1.18 269.33.13 189.63 10.13 128 77.64 128 159.43c0 28.09 4.52 54.09 12.86 77.06L17.75 224.08C7.31 223-1.18 232.19.13 242.67c10 79.7 77.51 141.33 159.3 141.33 28.09 0 54.09-4.52 77.06-12.86l-12.41 123.11c-1.05 10.43 8.11 18.93 18.59 17.62 79.7-10 141.33-77.51 141.33-159.3 0-28.09-4.52-54.09-12.86-77.06l123.11 12.41c10.44 1.05 18.93-8.11 17.62-18.59-10-79.7-77.51-141.33-159.3-141.33zM256 288a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"
        ],
        "fast-backward": [
            512,
            512,
            [],
            "f049",
            "M0 436V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v151.9L235.5 71.4C256.1 54.3 288 68.6 288 96v131.9L459.5 71.4C480.1 54.3 512 68.6 512 96v320c0 27.4-31.9 41.7-52.5 24.6L288 285.3V416c0 27.4-31.9 41.7-52.5 24.6L64 285.3V436c0 6.6-5.4 12-12 12H12c-6.6 0-12-5.4-12-12z"
        ],
        "fast-forward": [
            512,
            512,
            [],
            "f050",
            "M512 76v360c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V284.1L276.5 440.6c-20.6 17.2-52.5 2.8-52.5-24.6V284.1L52.5 440.6C31.9 457.8 0 443.4 0 416V96c0-27.4 31.9-41.7 52.5-24.6L224 226.8V96c0-27.4 31.9-41.7 52.5-24.6L448 226.8V76c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12z"
        ],
        "faucet": [
            512,
            512,
            [],
            "e005",
            "M352,256H313.39c-15.71-13.44-35.46-23.07-57.39-28V180.44l-32-3.38-32,3.38V228c-21.93,5-41.68,14.6-57.39,28H16A16,16,0,0,0,0,272v96a16,16,0,0,0,16,16h92.79C129.38,421.73,173,448,224,448s94.62-26.27,115.21-64H352a32,32,0,0,1,32,32,32,32,0,0,0,32,32h64a32,32,0,0,0,32-32A160,160,0,0,0,352,256ZM81.59,159.91l142.41-15,142.41,15c9.42,1,17.59-6.81,17.59-16.8V112.89c0-10-8.17-17.8-17.59-16.81L256,107.74V80a16,16,0,0,0-16-16H208a16,16,0,0,0-16,16v27.74L81.59,96.08C72.17,95.09,64,102.9,64,112.89v30.22C64,153.1,72.17,160.91,81.59,159.91Z"
        ],
        "fax": [
            512,
            512,
            [],
            "f1ac",
            "M480 160V77.25a32 32 0 0 0-9.38-22.63L425.37 9.37A32 32 0 0 0 402.75 0H160a32 32 0 0 0-32 32v448a32 32 0 0 0 32 32h320a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM288 432a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm128 128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-128a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16zm0-112H192V64h160v48a16 16 0 0 0 16 16h48zM64 128H32a32 32 0 0 0-32 32v320a32 32 0 0 0 32 32h32a32 32 0 0 0 32-32V160a32 32 0 0 0-32-32z"
        ],
        "feather": [
            512,
            512,
            [],
            "f52d",
            "M467.14 44.84c-62.55-62.48-161.67-64.78-252.28 25.73-78.61 78.52-60.98 60.92-85.75 85.66-60.46 60.39-70.39 150.83-63.64 211.17l178.44-178.25c6.26-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.6 9.37 33.98 0l66.1-66.03C159.42 454.65 279 457.11 353.95 384h-98.19l147.57-49.14c49.99-49.93 36.38-36.18 46.31-46.86h-97.78l131.54-43.8c45.44-74.46 34.31-148.84-16.26-199.36z"
        ],
        "feather-alt": [
            512,
            512,
            [],
            "f56b",
            "M512 0C460.22 3.56 96.44 38.2 71.01 287.61c-3.09 26.66-4.84 53.44-5.99 80.24l178.87-178.69c6.25-6.25 16.4-6.25 22.65 0s6.25 16.38 0 22.63L7.04 471.03c-9.38 9.37-9.38 24.57 0 33.94 9.38 9.37 24.59 9.37 33.98 0l57.13-57.07c42.09-.14 84.15-2.53 125.96-7.36 53.48-5.44 97.02-26.47 132.58-56.54H255.74l146.79-48.88c11.25-14.89 21.37-30.71 30.45-47.12h-81.14l106.54-53.21C500.29 132.86 510.19 26.26 512 0z"
        ],
        "female": [
            256,
            512,
            [],
            "f182",
            "M128 0c35.346 0 64 28.654 64 64s-28.654 64-64 64c-35.346 0-64-28.654-64-64S92.654 0 128 0m119.283 354.179l-48-192A24 24 0 0 0 176 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H80a24 24 0 0 0-23.283 18.179l-48 192C4.935 369.305 16.383 384 32 384h56v104c0 13.255 10.745 24 24 24h32c13.255 0 24-10.745 24-24V384h56c15.591 0 27.071-14.671 23.283-29.821z"
        ],
        "fighter-jet": [
            640,
            512,
            [],
            "f0fb",
            "M544 224l-128-16-48-16h-24L227.158 44h39.509C278.333 44 288 41.375 288 38s-9.667-6-21.333-6H152v12h16v164h-48l-66.667-80H18.667L8 138.667V208h8v16h48v2.666l-64 8v42.667l64 8V288H16v16H8v69.333L18.667 384h34.667L120 304h48v164h-16v12h114.667c11.667 0 21.333-2.625 21.333-6s-9.667-6-21.333-6h-39.509L344 320h24l48-16 128-16c96-21.333 96-26.583 96-32 0-5.417 0-10.667-96-32z"
        ],
        "file": [
            384,
            512,
            [],
            "f15b",
            "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm160-14.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
        ],
        "file-alt": [
            384,
            512,
            [],
            "f15c",
            "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
        ],
        "file-archive": [
            384,
            512,
            [],
            "f1c6",
            "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zM128.4 336c-17.9 0-32.4 12.1-32.4 27 0 15 14.6 27 32.5 27s32.4-12.1 32.4-27-14.6-27-32.5-27zM224 136V0h-63.6v32h-32V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM95.9 32h32v32h-32zm32.3 384c-33.2 0-58-30.4-51.4-62.9L96.4 256v-32h32v-32h-32v-32h32v-32h-32V96h32V64h32v32h-32v32h32v32h-32v32h32v32h-32v32h22.1c5.7 0 10.7 4.1 11.8 9.7l17.3 87.7c6.4 32.4-18.4 62.6-51.4 62.6z"
        ],
        "file-audio": [
            384,
            512,
            [],
            "f1c7",
            "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-64 268c0 10.7-12.9 16-20.5 8.5L104 376H76c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h28l35.5-36.5c7.6-7.6 20.5-2.2 20.5 8.5v136zm33.2-47.6c9.1-9.3 9.1-24.1 0-33.4-22.1-22.8 12.2-56.2 34.4-33.5 27.2 27.9 27.2 72.4 0 100.4-21.8 22.3-56.9-10.4-34.4-33.5zm86-117.1c54.4 55.9 54.4 144.8 0 200.8-21.8 22.4-57-10.3-34.4-33.5 36.2-37.2 36.3-96.5 0-133.8-22.1-22.8 12.3-56.3 34.4-33.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
        ],
        "file-code": [
            384,
            512,
            [],
            "f1c9",
            "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zM123.206 400.505a5.4 5.4 0 0 1-7.633.246l-64.866-60.812a5.4 5.4 0 0 1 0-7.879l64.866-60.812a5.4 5.4 0 0 1 7.633.246l19.579 20.885a5.4 5.4 0 0 1-.372 7.747L101.65 336l40.763 35.874a5.4 5.4 0 0 1 .372 7.747l-19.579 20.884zm51.295 50.479l-27.453-7.97a5.402 5.402 0 0 1-3.681-6.692l61.44-211.626a5.402 5.402 0 0 1 6.692-3.681l27.452 7.97a5.4 5.4 0 0 1 3.68 6.692l-61.44 211.626a5.397 5.397 0 0 1-6.69 3.681zm160.792-111.045l-64.866 60.812a5.4 5.4 0 0 1-7.633-.246l-19.58-20.885a5.4 5.4 0 0 1 .372-7.747L284.35 336l-40.763-35.874a5.4 5.4 0 0 1-.372-7.747l19.58-20.885a5.4 5.4 0 0 1 7.633-.246l64.866 60.812a5.4 5.4 0 0 1-.001 7.879z"
        ],
        "file-contract": [
            384,
            512,
            [],
            "f56c",
            "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm192.81 248H304c8.84 0 16 7.16 16 16s-7.16 16-16 16h-47.19c-16.45 0-31.27-9.14-38.64-23.86-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34a15.986 15.986 0 0 1-14.31 8.84c-.38 0-.75-.02-1.14-.05-6.45-.45-12-4.75-14.03-10.89L144 354.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.77-16.19 54.05-9.7 66 14.16 2.02 4.06 5.96 6.5 10.16 6.5zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
        ],
        "file-csv": [
            384,
            512,
            [],
            "f6dd",
            "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm-96 144c0 4.42-3.58 8-8 8h-8c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h8c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-8c-26.51 0-48-21.49-48-48v-32c0-26.51 21.49-48 48-48h8c4.42 0 8 3.58 8 8v16zm44.27 104H160c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h12.27c5.95 0 10.41-3.5 10.41-6.62 0-1.3-.75-2.66-2.12-3.84l-21.89-18.77c-8.47-7.22-13.33-17.48-13.33-28.14 0-21.3 19.02-38.62 42.41-38.62H200c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8h-12.27c-5.95 0-10.41 3.5-10.41 6.62 0 1.3.75 2.66 2.12 3.84l21.89 18.77c8.47 7.22 13.33 17.48 13.33 28.14.01 21.29-19 38.62-42.39 38.62zM256 264v20.8c0 20.27 5.7 40.17 16 56.88 10.3-16.7 16-36.61 16-56.88V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v20.8c0 35.48-12.88 68.89-36.28 94.09-3.02 3.25-7.27 5.11-11.72 5.11s-8.7-1.86-11.72-5.11c-23.4-25.2-36.28-58.61-36.28-94.09V264c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8zm121-159L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
        ],
        "file-download": [
            384,
            512,
            [],
            "f56d",
            "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm76.45 211.36l-96.42 95.7c-6.65 6.61-17.39 6.61-24.04 0l-96.42-95.7C73.42 337.29 80.54 320 94.82 320H160v-80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v80h65.18c14.28 0 21.4 17.29 11.27 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
        ],
        "file-excel": [
            384,
            512,
            [],
            "f1c3",
            "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm60.1 106.5L224 336l60.1 93.5c5.1 8-.6 18.5-10.1 18.5h-34.9c-4.4 0-8.5-2.4-10.6-6.3C208.9 405.5 192 373 192 373c-6.4 14.8-10 20-36.6 68.8-2.1 3.9-6.1 6.3-10.5 6.3H110c-9.5 0-15.2-10.5-10.1-18.5l60.3-93.5-60.3-93.5c-5.2-8 .6-18.5 10.1-18.5h34.8c4.4 0 8.5 2.4 10.6 6.3 26.1 48.8 20 33.6 36.6 68.5 0 0 6.1-11.7 36.6-68.5 2.1-3.9 6.2-6.3 10.6-6.3H274c9.5-.1 15.2 10.4 10.1 18.4zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
        ],
        "file-export": [
            576,
            512,
            [],
            "f56e",
            "M384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128zM571 308l-95.7-96.4c-10.1-10.1-27.4-3-27.4 11.3V288h-64v64h64v65.2c0 14.3 17.3 21.4 27.4 11.3L571 332c6.6-6.6 6.6-17.4 0-24zm-379 28v-32c0-8.8 7.2-16 16-16h176V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V352H208c-8.8 0-16-7.2-16-16z"
        ],
        "file-image": [
            384,
            512,
            [],
            "f1c5",
            "M384 121.941V128H256V0h6.059a24 24 0 0 1 16.97 7.029l97.941 97.941a24.002 24.002 0 0 1 7.03 16.971zM248 160c-13.2 0-24-10.8-24-24V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248zm-135.455 16c26.51 0 48 21.49 48 48s-21.49 48-48 48-48-21.49-48-48 21.491-48 48-48zm208 240h-256l.485-48.485L104.545 328c4.686-4.686 11.799-4.201 16.485.485L160.545 368 264.06 264.485c4.686-4.686 12.284-4.686 16.971 0L320.545 304v112z"
        ],
        "file-import": [
            512,
            512,
            [],
            "f56f",
            "M16 288c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h112v-64zm489-183L407.1 7c-4.5-4.5-10.6-7-17-7H384v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H152c-13.3 0-24 10.7-24 24v264h128v-65.2c0-14.3 17.3-21.4 27.4-11.3L379 308c6.6 6.7 6.6 17.4 0 24l-95.7 96.4c-10.1 10.1-27.4 3-27.4-11.3V352H128v136c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H376c-13.2 0-24-10.8-24-24z"
        ],
        "file-invoice": [
            384,
            512,
            [],
            "f570",
            "M288 256H96v64h192v-64zm89-151L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 64c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm256 304c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-200v96c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-96c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16z"
        ],
        "file-invoice-dollar": [
            384,
            512,
            [],
            "f571",
            "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zM64 72c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8V72zm0 80v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8zm144 263.88V440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-24.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V232c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v24.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07z"
        ],
        "file-medical": [
            384,
            512,
            [],
            "f477",
            "M377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 160v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8z"
        ],
        "file-medical-alt": [
            448,
            512,
            [],
            "f478",
            "M288 136V0H88C74.7 0 64 10.7 64 24v232H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h140.9c3 0 5.8 1.7 7.2 4.4l19.9 39.8 56.8-113.7c2.9-5.9 11.4-5.9 14.3 0l34.7 69.5H352c8.8 0 16 7.2 16 16s-7.2 16-16 16h-89.9L240 275.8l-56.8 113.7c-2.9 5.9-11.4 5.9-14.3 0L134.1 320H64v168c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H312c-13.2 0-24-10.8-24-24zm153-31L343.1 7c-4.5-4.5-10.6-7-17-7H320v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
        ],
        "file-pdf": [
            384,
            512,
            [],
            "f1c1",
            "M181.9 256.1c-5-16-4.9-46.9-2-46.9 8.4 0 7.6 36.9 2 46.9zm-1.7 47.2c-7.7 20.2-17.3 43.3-28.4 62.7 18.3-7 39-17.2 62.9-21.9-12.7-9.6-24.9-23.4-34.5-40.8zM86.1 428.1c0 .8 13.2-5.4 34.9-40.2-6.7 6.3-29.1 24.5-34.9 40.2zM248 160h136v328c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V24C0 10.7 10.7 0 24 0h200v136c0 13.2 10.8 24 24 24zm-8 171.8c-20-12.2-33.3-29-42.7-53.8 4.5-18.5 11.6-46.6 6.2-64.2-4.7-29.4-42.4-26.5-47.8-6.8-5 18.3-.4 44.1 8.1 77-11.6 27.6-28.7 64.6-40.8 85.8-.1 0-.1.1-.2.1-27.1 13.9-73.6 44.5-54.5 68 5.6 6.9 16 10 21.5 10 17.9 0 35.7-18 61.1-61.8 25.8-8.5 54.1-19.1 79-23.2 21.7 11.8 47.1 19.5 64 19.5 29.2 0 31.2-32 19.7-43.4-13.9-13.6-54.3-9.7-73.6-7.2zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-74.1 255.3c4.1-2.7-2.5-11.9-42.8-9 37.1 15.8 42.8 9 42.8 9z"
        ],
        "file-powerpoint": [
            384,
            512,
            [],
            "f1c4",
            "M193.7 271.2c8.8 0 15.5 2.7 20.3 8.1 9.6 10.9 9.8 32.7-.2 44.1-4.9 5.6-11.9 8.5-21.1 8.5h-26.9v-60.7h27.9zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-153 31V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm53 165.2c0 90.3-88.8 77.6-111.1 77.6V436c0 6.6-5.4 12-12 12h-30.8c-6.6 0-12-5.4-12-12V236.2c0-6.6 5.4-12 12-12h81c44.5 0 72.9 32.8 72.9 77z"
        ],
        "file-prescription": [
            384,
            512,
            [],
            "f572",
            "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm68.53 179.48l11.31 11.31c6.25 6.25 6.25 16.38 0 22.63l-29.9 29.9L304 409.38c6.25 6.25 6.25 16.38 0 22.63l-11.31 11.31c-6.25 6.25-16.38 6.25-22.63 0L240 413.25l-30.06 30.06c-6.25 6.25-16.38 6.25-22.63 0L176 432c-6.25-6.25-6.25-16.38 0-22.63l30.06-30.06L146.74 320H128v48c0 8.84-7.16 16-16 16H96c-8.84 0-16-7.16-16-16V208c0-8.84 7.16-16 16-16h80c35.35 0 64 28.65 64 64 0 24.22-13.62 45.05-33.46 55.92L240 345.38l29.9-29.9c6.25-6.25 16.38-6.25 22.63 0zM176 272h-48v-32h48c8.82 0 16 7.18 16 16s-7.18 16-16 16zm208-150.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
        ],
        "file-signature": [
            576,
            512,
            [],
            "f573",
            "M218.17 424.14c-2.95-5.92-8.09-6.52-10.17-6.52s-7.22.59-10.02 6.19l-7.67 15.34c-6.37 12.78-25.03 11.37-29.48-2.09L144 386.59l-10.61 31.88c-5.89 17.66-22.38 29.53-41 29.53H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h12.39c4.83 0 9.11-3.08 10.64-7.66l18.19-54.64c3.3-9.81 12.44-16.41 22.78-16.41s19.48 6.59 22.77 16.41l13.88 41.64c19.75-16.19 54.06-9.7 66 14.16 1.89 3.78 5.49 5.95 9.36 6.26v-82.12l128-127.09V160H248c-13.2 0-24-10.8-24-24V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24v-40l-128-.11c-16.12-.31-30.58-9.28-37.83-23.75zM384 121.9c0-6.3-2.5-12.4-7-16.9L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1zm-96 225.06V416h68.99l161.68-162.78-67.88-67.88L288 346.96zm280.54-179.63l-31.87-31.87c-9.94-9.94-26.07-9.94-36.01 0l-27.25 27.25 67.88 67.88 27.25-27.25c9.95-9.94 9.95-26.07 0-36.01z"
        ],
        "file-upload": [
            384,
            512,
            [],
            "f574",
            "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm65.18 216.01H224v80c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-80H94.82c-14.28 0-21.41-17.29-11.27-27.36l96.42-95.7c6.65-6.61 17.39-6.61 24.04 0l96.42 95.7c10.15 10.07 3.03 27.36-11.25 27.36zM377 105L279.1 7c-4.5-4.5-10.6-7-17-7H256v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"
        ],
        "file-video": [
            384,
            512,
            [],
            "f1c8",
            "M384 121.941V128H256V0h6.059c6.365 0 12.47 2.529 16.971 7.029l97.941 97.941A24.005 24.005 0 0 1 384 121.941zM224 136V0H24C10.745 0 0 10.745 0 24v464c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V160H248c-13.2 0-24-10.8-24-24zm96 144.016v111.963c0 21.445-25.943 31.998-40.971 16.971L224 353.941V392c0 13.255-10.745 24-24 24H88c-13.255 0-24-10.745-24-24V280c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v38.059l55.029-55.013c15.011-15.01 40.971-4.491 40.971 16.97z"
        ],
        "file-word": [
            384,
            512,
            [],
            "f1c2",
            "M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm57.1 120H305c7.7 0 13.4 7.1 11.7 14.7l-38 168c-1.2 5.5-6.1 9.3-11.7 9.3h-38c-5.5 0-10.3-3.8-11.6-9.1-25.8-103.5-20.8-81.2-25.6-110.5h-.5c-1.1 14.3-2.4 17.4-25.6 110.5-1.3 5.3-6.1 9.1-11.6 9.1H117c-5.6 0-10.5-3.9-11.7-9.4l-37.8-168c-1.7-7.5 4-14.6 11.7-14.6h24.5c5.7 0 10.7 4 11.8 9.7 15.6 78 20.1 109.5 21 122.2 1.6-10.2 7.3-32.7 29.4-122.7 1.3-5.4 6.1-9.1 11.7-9.1h29.1c5.6 0 10.4 3.8 11.7 9.2 24 100.4 28.8 124 29.6 129.4-.2-11.2-2.6-17.8 21.6-129.2 1-5.6 5.9-9.5 11.5-9.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
        ],
        "fill": [
            512,
            512,
            [],
            "f575",
            "M502.63 217.06L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.77c-6.24-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.63l86.19 86.18-94.76 94.76c-37.49 37.49-37.49 98.26 0 135.75l117.19 117.19c18.75 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.88-28.12l221.57-221.57c12.49-12.5 12.49-32.76 0-45.26zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.61 58.6c12.49 12.49 32.75 12.49 45.24 0 12.49-12.49 12.49-32.75 0-45.24l-58.61-58.6 58.95-58.95 162.45 162.44-48.35 48.34z"
        ],
        "fill-drip": [
            576,
            512,
            [],
            "f576",
            "M512 320s-64 92.65-64 128c0 35.35 28.66 64 64 64s64-28.65 64-64-64-128-64-128zm-9.37-102.94L294.94 9.37C288.69 3.12 280.5 0 272.31 0s-16.38 3.12-22.62 9.37l-81.58 81.58L81.93 4.76c-6.25-6.25-16.38-6.25-22.62 0L36.69 27.38c-6.24 6.25-6.24 16.38 0 22.62l86.19 86.18-94.76 94.76c-37.49 37.48-37.49 98.26 0 135.75l117.19 117.19c18.74 18.74 43.31 28.12 67.87 28.12 24.57 0 49.13-9.37 67.87-28.12l221.57-221.57c12.5-12.5 12.5-32.75.01-45.25zm-116.22 70.97H65.93c1.36-3.84 3.57-7.98 7.43-11.83l13.15-13.15 81.61-81.61 58.6 58.6c12.49 12.49 32.75 12.49 45.24 0s12.49-32.75 0-45.24l-58.6-58.6 58.95-58.95 162.44 162.44-48.34 48.34z"
        ],
        "film": [
            512,
            512,
            [],
            "f008",
            "M488 64h-8v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12V64H96v20c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12V64h-8C10.7 64 0 74.7 0 88v336c0 13.3 10.7 24 24 24h8v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h320v-20c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v20h8c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24zM96 372c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12H44c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm272 208c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm0-168c0 6.6-5.4 12-12 12H156c-6.6 0-12-5.4-12-12v-96c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v96zm112 152c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-96c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"
        ],
        "filter": [
            512,
            512,
            [],
            "f0b0",
            "M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17 10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z"
        ],
        "fingerprint": [
            512,
            512,
            [],
            "f577",
            "M256.12 245.96c-13.25 0-24 10.74-24 24 1.14 72.25-8.14 141.9-27.7 211.55-2.73 9.72 2.15 30.49 23.12 30.49 10.48 0 20.11-6.92 23.09-17.52 13.53-47.91 31.04-125.41 29.48-224.52.01-13.25-10.73-24-23.99-24zm-.86-81.73C194 164.16 151.25 211.3 152.1 265.32c.75 47.94-3.75 95.91-13.37 142.55-2.69 12.98 5.67 25.69 18.64 28.36 13.05 2.67 25.67-5.66 28.36-18.64 10.34-50.09 15.17-101.58 14.37-153.02-.41-25.95 19.92-52.49 54.45-52.34 31.31.47 57.15 25.34 57.62 55.47.77 48.05-2.81 96.33-10.61 143.55-2.17 13.06 6.69 25.42 19.76 27.58 19.97 3.33 26.81-15.1 27.58-19.77 8.28-50.03 12.06-101.21 11.27-152.11-.88-55.8-47.94-101.88-104.91-102.72zm-110.69-19.78c-10.3-8.34-25.37-6.8-33.76 3.48-25.62 31.5-39.39 71.28-38.75 112 .59 37.58-2.47 75.27-9.11 112.05-2.34 13.05 6.31 25.53 19.36 27.89 20.11 3.5 27.07-14.81 27.89-19.36 7.19-39.84 10.5-80.66 9.86-121.33-.47-29.88 9.2-57.88 28-80.97 8.35-10.28 6.79-25.39-3.49-33.76zm109.47-62.33c-15.41-.41-30.87 1.44-45.78 4.97-12.89 3.06-20.87 15.98-17.83 28.89 3.06 12.89 16 20.83 28.89 17.83 11.05-2.61 22.47-3.77 34-3.69 75.43 1.13 137.73 61.5 138.88 134.58.59 37.88-1.28 76.11-5.58 113.63-1.5 13.17 7.95 25.08 21.11 26.58 16.72 1.95 25.51-11.88 26.58-21.11a929.06 929.06 0 0 0 5.89-119.85c-1.56-98.75-85.07-180.33-186.16-181.83zm252.07 121.45c-2.86-12.92-15.51-21.2-28.61-18.27-12.94 2.86-21.12 15.66-18.26 28.61 4.71 21.41 4.91 37.41 4.7 61.6-.11 13.27 10.55 24.09 23.8 24.2h.2c13.17 0 23.89-10.61 24-23.8.18-22.18.4-44.11-5.83-72.34zm-40.12-90.72C417.29 43.46 337.6 1.29 252.81.02 183.02-.82 118.47 24.91 70.46 72.94 24.09 119.37-.9 181.04.14 246.65l-.12 21.47c-.39 13.25 10.03 24.31 23.28 24.69.23.02.48.02.72.02 12.92 0 23.59-10.3 23.97-23.3l.16-23.64c-.83-52.5 19.16-101.86 56.28-139 38.76-38.8 91.34-59.67 147.68-58.86 69.45 1.03 134.73 35.56 174.62 92.39 7.61 10.86 22.56 13.45 33.42 5.86 10.84-7.62 13.46-22.59 5.84-33.43z"
        ],
        "fire": [
            384,
            512,
            [],
            "f06d",
            "M216 23.86c0-23.8-30.65-32.77-44.15-13.04C48 191.85 224 200 224 288c0 35.63-29.11 64.46-64.85 63.99-35.17-.45-63.15-29.77-63.15-64.94v-85.51c0-21.7-26.47-32.23-41.43-16.5C27.8 213.16 0 261.33 0 320c0 105.87 86.13 192 192 192s192-86.13 192-192c0-170.29-168-193-168-296.14z"
        ],
        "fire-alt": [
            448,
            512,
            [],
            "f7e4",
            "M323.56 51.2c-20.8 19.3-39.58 39.59-56.22 59.97C240.08 73.62 206.28 35.53 168 0 69.74 91.17 0 209.96 0 281.6 0 408.85 100.29 512 224 512s224-103.15 224-230.4c0-53.27-51.98-163.14-124.44-230.4zm-19.47 340.65C282.43 407.01 255.72 416 226.86 416 154.71 416 96 368.26 96 290.75c0-38.61 24.31-72.63 72.79-130.75 6.93 7.98 98.83 125.34 98.83 125.34l58.63-66.88c4.14 6.85 7.91 13.55 11.27 19.97 27.35 52.19 15.81 118.97-33.43 153.42z"
        ],
        "fire-extinguisher": [
            448,
            512,
            [],
            "f134",
            "M434.027 26.329l-168 28C254.693 56.218 256 67.8 256 72h-58.332C208.353 36.108 181.446 0 144 0c-39.435 0-66.368 39.676-52.228 76.203-52.039 13.051-75.381 54.213-90.049 90.884-4.923 12.307 1.063 26.274 13.37 31.197 12.317 4.926 26.279-1.075 31.196-13.37C75.058 112.99 106.964 120 168 120v27.076c-41.543 10.862-72 49.235-72 94.129V488c0 13.255 10.745 24 24 24h144c13.255 0 24-10.745 24-24V240c0-44.731-30.596-82.312-72-92.97V120h40c0 2.974-1.703 15.716 10.027 17.671l168 28C441.342 166.89 448 161.25 448 153.834V38.166c0-7.416-6.658-13.056-13.973-11.837zM144 72c-8.822 0-16-7.178-16-16s7.178-16 16-16 16 7.178 16 16-7.178 16-16 16z"
        ],
        "first-aid": [
            576,
            512,
            [],
            "f479",
            "M0 80v352c0 26.5 21.5 48 48 48h48V32H48C21.5 32 0 53.5 0 80zm128 400h320V32H128v448zm64-248c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48zM528 32h-48v448h48c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
        ],
        "fish": [
            576,
            512,
            [],
            "f578",
            "M327.1 96c-89.97 0-168.54 54.77-212.27 101.63L27.5 131.58c-12.13-9.18-30.24.6-27.14 14.66L24.54 256 .35 365.77c-3.1 14.06 15.01 23.83 27.14 14.66l87.33-66.05C158.55 361.23 237.13 416 327.1 416 464.56 416 576 288 576 256S464.56 96 327.1 96zm87.43 184c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24 13.26 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"
        ],
        "fist-raised": [
            384,
            512,
            [],
            "f6de",
            "M255.98 160V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v146.93c5.02-1.78 10.34-2.93 15.97-2.93h48.03zm128 95.99c-.01-35.34-28.66-63.99-63.99-63.99H207.85c-8.78 0-15.9 7.07-15.9 15.85v.56c0 26.27 21.3 47.59 47.57 47.59h35.26c9.68 0 13.2 3.58 13.2 8v16.2c0 4.29-3.59 7.78-7.88 8-44.52 2.28-64.16 24.71-96.05 72.55l-6.31 9.47a7.994 7.994 0 0 1-11.09 2.22l-13.31-8.88a7.994 7.994 0 0 1-2.22-11.09l6.31-9.47c15.73-23.6 30.2-43.26 47.31-58.08-17.27-5.51-31.4-18.12-38.87-34.45-6.59 3.41-13.96 5.52-21.87 5.52h-32c-12.34 0-23.49-4.81-32-12.48C71.48 251.19 60.33 256 48 256H16c-5.64 0-10.97-1.15-16-2.95v77.93c0 33.95 13.48 66.5 37.49 90.51L63.99 448v64h255.98v-63.96l35.91-35.92A96.035 96.035 0 0 0 384 344.21l-.02-88.22zm-32.01-90.09V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v112h32c11.28 0 21.94 2.31 32 5.9zM16 224h32c8.84 0 16-7.16 16-16V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v128c0 8.84 7.16 16 16 16zm95.99 0h32c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v160c0 8.84 7.16 16 16 16z"
        ],
        "flag": [
            512,
            512,
            [],
            "f024",
            "M349.565 98.783C295.978 98.783 251.721 64 184.348 64c-24.955 0-47.309 4.384-68.045 12.013a55.947 55.947 0 0 0 3.586-23.562C118.117 24.015 94.806 1.206 66.338.048 34.345-1.254 8 24.296 8 56c0 19.026 9.497 35.825 24 45.945V488c0 13.255 10.745 24 24 24h16c13.255 0 24-10.745 24-24v-94.4c28.311-12.064 63.582-22.122 114.435-22.122 53.588 0 97.844 34.783 165.217 34.783 48.169 0 86.667-16.294 122.505-40.858C506.84 359.452 512 349.571 512 339.045v-243.1c0-23.393-24.269-38.87-45.485-29.016-34.338 15.948-76.454 31.854-116.95 31.854z"
        ],
        "flag-checkered": [
            512,
            512,
            [],
            "f11e",
            "M243.2 189.9V258c26.1 5.9 49.3 15.6 73.6 22.3v-68.2c-26-5.8-49.4-15.5-73.6-22.2zm223.3-123c-34.3 15.9-76.5 31.9-117 31.9C296 98.8 251.7 64 184.3 64c-25 0-47.3 4.4-68 12 2.8-7.3 4.1-15.2 3.6-23.6C118.1 24 94.8 1.2 66.3 0 34.3-1.3 8 24.3 8 56c0 19 9.5 35.8 24 45.9V488c0 13.3 10.7 24 24 24h16c13.3 0 24-10.7 24-24v-94.4c28.3-12.1 63.6-22.1 114.4-22.1 53.6 0 97.8 34.8 165.2 34.8 48.2 0 86.7-16.3 122.5-40.9 8.7-6 13.8-15.8 13.8-26.4V95.9c.1-23.3-24.2-38.8-45.4-29zM169.6 325.5c-25.8 2.7-50 8.2-73.6 16.6v-70.5c26.2-9.3 47.5-15 73.6-17.4zM464 191c-23.6 9.8-46.3 19.5-73.6 23.9V286c24.8-3.4 51.4-11.8 73.6-26v70.5c-25.1 16.1-48.5 24.7-73.6 27.1V286c-27 3.7-47.9 1.5-73.6-5.6v67.4c-23.9-7.4-47.3-16.7-73.6-21.3V258c-19.7-4.4-40.8-6.8-73.6-3.8v-70c-22.4 3.1-44.6 10.2-73.6 20.9v-70.5c33.2-12.2 50.1-19.8 73.6-22v71.6c27-3.7 48.4-1.3 73.6 5.7v-67.4c23.7 7.4 47.2 16.7 73.6 21.3v68.4c23.7 5.3 47.6 6.9 73.6 2.7V143c27-4.8 52.3-13.6 73.6-22.5z"
        ],
        "flag-usa": [
            512,
            512,
            [],
            "f74d",
            "M32 0C14.3 0 0 14.3 0 32v464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32C64 14.3 49.7 0 32 0zm267.9 303.6c-57.2-15.1-111.7-28.8-203.9 11.1V384c185.7-92.2 221.7 53.3 397.5-23.1 11.4-5 18.5-16.5 18.5-28.8v-36c-43.6 17.3-80.2 24.1-112.1 24.1-37.4-.1-68.9-8.4-100-16.6zm0-96c-57.2-15.1-111.7-28.8-203.9 11.1v61.5c94.8-37.6 154.6-22.7 212.1-7.6 57.2 15.1 111.7 28.8 203.9-11.1V200c-43.6 17.3-80.2 24.1-112.1 24.1-37.4 0-68.9-8.3-100-16.5zm9.5-125.9c51.8 15.6 97.4 29 202.6-20.1V30.8c0-25.1-26.8-38.1-49.4-26.6C291.3 91.5 305.4-62.2 96 32.4v151.9c94.8-37.5 154.6-22.7 212.1-7.6 57.2 15 111.7 28.7 203.9-11.1V96.7c-53.6 23.5-93.3 31.4-126.1 31.4s-59-7.8-85.7-15.9c-4-1.2-8.1-2.4-12.1-3.5V75.5c7.2 2 14.3 4.1 21.3 6.2zM160 128.1c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16-7.2 16-16 16zm0-55.8c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm64 47.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16zm0-55.9c-8.8 0-16-7.1-16-16 0-8.8 7.2-16 16-16s16 7.1 16 16c0 8.8-7.2 16-16 16z"
        ],
        "flask": [
            448,
            512,
            [],
            "f0c3",
            "M437.2 403.5L320 215V64h8c13.3 0 24-10.7 24-24V24c0-13.3-10.7-24-24-24H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h8v151L10.8 403.5C-18.5 450.6 15.3 512 70.9 512h306.2c55.7 0 89.4-61.5 60.1-108.5zM137.9 320l48.2-77.6c3.7-5.2 5.8-11.6 5.8-18.4V64h64v160c0 6.9 2.2 13.2 5.8 18.4l48.2 77.6h-172z"
        ],
        "flushed": [
            496,
            512,
            [],
            "f579",
            "M344 200c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-192 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM80 224c0-39.8 32.2-72 72-72s72 32.2 72 72-32.2 72-72 72-72-32.2-72-72zm232 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-104c-39.8 0-72-32.2-72-72s32.2-72 72-72 72 32.2 72 72-32.2 72-72 72z"
        ],
        "folder": [
            512,
            512,
            [],
            "f07b",
            "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48z"
        ],
        "folder-minus": [
            512,
            512,
            [],
            "f65d",
            "M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm-96 168c0 8.84-7.16 16-16 16H160c-8.84 0-16-7.16-16-16v-16c0-8.84 7.16-16 16-16h192c8.84 0 16 7.16 16 16v16z"
        ],
        "folder-open": [
            576,
            512,
            [],
            "f07c",
            "M572.694 292.093L500.27 416.248A63.997 63.997 0 0 1 444.989 448H45.025c-18.523 0-30.064-20.093-20.731-36.093l72.424-124.155A64 64 0 0 1 152 256h399.964c18.523 0 30.064 20.093 20.73 36.093zM152 224h328v-48c0-26.51-21.49-48-48-48H272l-64-64H48C21.49 64 0 85.49 0 112v278.046l69.077-118.418C86.214 242.25 117.989 224 152 224z"
        ],
        "folder-plus": [
            512,
            512,
            [],
            "f65e",
            "M464,128H272L208,64H48A48,48,0,0,0,0,112V400a48,48,0,0,0,48,48H464a48,48,0,0,0,48-48V176A48,48,0,0,0,464,128ZM359.5,296a16,16,0,0,1-16,16h-64v64a16,16,0,0,1-16,16h-16a16,16,0,0,1-16-16V312h-64a16,16,0,0,1-16-16V280a16,16,0,0,1,16-16h64V200a16,16,0,0,1,16-16h16a16,16,0,0,1,16,16v64h64a16,16,0,0,1,16,16Z"
        ],
        "font": [
            448,
            512,
            [],
            "f031",
            "M432 416h-23.41L277.88 53.69A32 32 0 0 0 247.58 32h-47.16a32 32 0 0 0-30.3 21.69L39.41 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-19.58l23.3-64h152.56l23.3 64H304a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM176.85 272L224 142.51 271.15 272z"
        ],
        "font-awesome-logo-full": [
            3992,
            512,
            [
                "Font Awesome"
            ],
            "f4e6",
            "M454.6 0H57.4C25.9 0 0 25.9 0 57.4v397.3C0 486.1 25.9 512 57.4 512h397.3c31.4 0 57.4-25.9 57.4-57.4V57.4C512 25.9 486.1 0 454.6 0zm-58.9 324.9c0 4.8-4.1 6.9-8.9 8.9-19.2 8.1-39.7 15.7-61.5 15.7-40.5 0-68.7-44.8-163.2 2.5v51.8c0 30.3-45.7 30.2-45.7 0v-250c-9-7-15-17.9-15-30.3 0-21 17.1-38.2 38.2-38.2 21 0 38.2 17.1 38.2 38.2 0 12.2-5.8 23.2-14.9 30.2v21c37.1-12 65.5-34.4 146.1-3.4 26.6 11.4 68.7-15.7 76.5-15.7 5.5 0 10.3 4.1 10.3 8.9v160.4zm432.9-174.2h-137v70.1H825c39.8 0 40.4 62.2 0 62.2H691.6v105.6c0 45.5-70.7 46.4-70.7 0V128.3c0-22 18-39.8 39.8-39.8h167.8c39.6 0 40.5 62.2.1 62.2zm191.1 23.4c-169.3 0-169.1 252.4 0 252.4 169.9 0 169.9-252.4 0-252.4zm0 196.1c-81.6 0-82.1-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm372.4 53.4c-17.5 0-31.4-13.9-31.4-31.4v-117c0-62.4-72.6-52.5-99.1-16.4v133.4c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c43.3-51.6 162.4-60.4 162.4 39.3v141.5c.3 30.4-31.5 31.4-31.7 31.4zm179.7 2.9c-44.3 0-68.3-22.9-68.3-65.8V235.2H1488c-35.6 0-36.7-55.3 0-55.3h15.5v-37.3c0-41.3 63.8-42.1 63.8 0v37.5h24.9c35.4 0 35.7 55.3 0 55.3h-24.9v108.5c0 29.6 26.1 26.3 27.4 26.3 31.4 0 52.6 56.3-22.9 56.3zM1992 123c-19.5-50.2-95.5-50-114.5 0-107.3 275.7-99.5 252.7-99.5 262.8 0 42.8 58.3 51.2 72.1 14.4l13.5-35.9H2006l13 35.9c14.2 37.7 72.1 27.2 72.1-14.4 0-10.1 5.3 6.8-99.1-262.8zm-108.9 179.1l51.7-142.9 51.8 142.9h-103.5zm591.3-85.6l-53.7 176.3c-12.4 41.2-72 41-84 0l-42.3-135.9-42.3 135.9c-12.4 40.9-72 41.2-84.5 0l-54.2-176.3c-12.5-39.4 49.8-56.1 60.2-16.9L2213 342l45.3-139.5c10.9-32.7 59.6-34.7 71.2 0l45.3 139.5 39.3-142.4c10.3-38.3 72.6-23.8 60.3 16.9zm275.4 75.1c0-42.4-33.9-117.5-119.5-117.5-73.2 0-124.4 56.3-124.4 126 0 77.2 55.3 126.4 128.5 126.4 31.7 0 93-11.5 93-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-109 8.4-115.9-43.8h148.3c16.3 0 29.3-13.4 29.3-28.9zM2571 277.7c9.5-73.4 113.9-68.6 118.6 0H2571zm316.7 148.8c-31.4 0-81.6-10.5-96.6-31.9-12.4-17 2.5-39.8 21.8-39.8 16.3 0 36.8 22.9 77.7 22.9 27.4 0 40.4-11 40.4-25.8 0-39.8-142.9-7.4-142.9-102 0-40.4 35.3-75.7 98.6-75.7 31.4 0 74.1 9.9 87.6 29.4 10.8 14.8-1.4 36.2-20.9 36.2-15.1 0-26.7-17.3-66.2-17.3-22.9 0-37.8 10.5-37.8 23.8 0 35.9 142.4 6 142.4 103.1-.1 43.7-37.4 77.1-104.1 77.1zm266.8-252.4c-169.3 0-169.1 252.4 0 252.4 170.1 0 169.6-252.4 0-252.4zm0 196.1c-81.8 0-82-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm476.9 22V268.7c0-53.8-61.4-45.8-85.7-10.5v134c0 41.3-63.8 42.1-63.8 0V268.7c0-52.1-59.5-47.4-85.7-10.1v133.6c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c9.9-14.4 41.8-37.3 78.6-37.3 35.3 0 57.7 16.4 66.7 43.8 13.9-21.8 45.8-43.8 82.6-43.8 44.3 0 70.7 23.4 70.7 72.7v145.3c.5 17.3-13.5 31.4-31.9 31.4 3.5.1-31.3 1.1-31.3-31.3zM3992 291.6c0-42.4-32.4-117.5-117.9-117.5-73.2 0-127.5 56.3-127.5 126 0 77.2 58.3 126.4 131.6 126.4 31.7 0 91.5-11.5 91.5-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-110.5 8.4-117.5-43.8h149.8c16.3 0 29.1-13.4 29.3-28.9zm-180.5-13.9c9.7-74.4 115.9-68.3 120.1 0h-120.1z"
        ],
        "football-ball": [
            496,
            512,
            [],
            "f44e",
            "M481.5 60.3c-4.8-18.2-19.1-32.5-37.3-37.4C420.3 16.5 383 8.9 339.4 8L496 164.8c-.8-43.5-8.2-80.6-14.5-104.5zm-467 391.4c4.8 18.2 19.1 32.5 37.3 37.4 23.9 6.4 61.2 14 104.8 14.9L0 347.2c.8 43.5 8.2 80.6 14.5 104.5zM4.2 283.4L220.4 500c132.5-19.4 248.8-118.7 271.5-271.4L275.6 12C143.1 31.4 26.8 130.7 4.2 283.4zm317.3-123.6c3.1-3.1 8.2-3.1 11.3 0l11.3 11.3c3.1 3.1 3.1 8.2 0 11.3l-28.3 28.3 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-22.6 22.7 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L248 278.6l-22.6 22.6 28.3 28.3c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-28.3-28.3-28.3 28.3c-3.1 3.1-8.2 3.1-11.3 0l-11.3-11.3c-3.1-3.1-3.1-8.2 0-11.3l28.3-28.3-28.3-28.2c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 22.6-22.6-28.3-28.3c-3.1-3.1-3.1-8.2 0-11.3l11.3-11.3c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3 28.3-28.5z"
        ],
        "forward": [
            512,
            512,
            [],
            "f04e",
            "M500.5 231.4l-192-160C287.9 54.3 256 68.6 256 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2zm-256 0l-192-160C31.9 54.3 0 68.6 0 96v320c0 27.4 31.9 41.8 52.5 24.6l192-160c15.3-12.8 15.3-36.4 0-49.2z"
        ],
        "frog": [
            576,
            512,
            [],
            "f52e",
            "M446.53 97.43C439.67 60.23 407.19 32 368 32c-39.23 0-71.72 28.29-78.54 65.54C126.75 112.96-.5 250.12 0 416.98.11 451.9 29.08 480 64 480h304c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-79.49l35.8-48.33c24.14-36.23 10.35-88.28-33.71-106.6-23.89-9.93-51.55-4.65-72.24 10.88l-32.76 24.59c-7.06 5.31-17.09 3.91-22.41-3.19-5.3-7.08-3.88-17.11 3.19-22.41l34.78-26.09c36.84-27.66 88.28-27.62 125.13 0 10.87 8.15 45.87 39.06 40.8 93.21L469.62 480H560c8.84 0 16-7.16 16-16 0-17.67-14.33-32-32-32h-53.63l-98.52-104.68 154.44-86.65A58.16 58.16 0 0 0 576 189.94c0-21.4-11.72-40.95-30.48-51.23-40.56-22.22-98.99-41.28-98.99-41.28zM368 136c-13.26 0-24-10.75-24-24 0-13.26 10.74-24 24-24 13.25 0 24 10.74 24 24 0 13.25-10.75 24-24 24z"
        ],
        "frown": [
            496,
            512,
            [],
            "f119",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm170.2 218.2C315.8 367.4 282.9 352 248 352s-67.8 15.4-90.2 42.2c-13.5 16.3-38.1-4.2-24.6-20.5C161.7 339.6 203.6 320 248 320s86.3 19.6 114.7 53.8c13.6 16.2-11 36.7-24.5 20.4z"
        ],
        "frown-open": [
            496,
            512,
            [],
            "f57a",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm187.3 183.3c-31.2-9.6-59.4-15.3-75.3-15.3s-44.1 5.7-75.3 15.3c-11.5 3.5-22.5-6.3-20.5-18.1 7-40 60.1-61.2 95.8-61.2s88.8 21.3 95.8 61.2c2 11.9-9.1 21.6-20.5 18.1zM328 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
        ],
        "funnel-dollar": [
            640,
            512,
            [],
            "f662",
            "M433.46 165.94l101.2-111.87C554.61 34.12 540.48 0 512.26 0H31.74C3.52 0-10.61 34.12 9.34 54.07L192 256v155.92c0 12.59 5.93 24.44 16 32l79.99 60c20.86 15.64 48.47 6.97 59.22-13.57C310.8 455.38 288 406.35 288 352c0-89.79 62.05-165.17 145.46-186.06zM480 192c-88.37 0-160 71.63-160 160s71.63 160 160 160 160-71.63 160-160-71.63-160-160-160zm16 239.88V448c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V256c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.04 44.44-42.67 45.07z"
        ],
        "futbol": [
            512,
            512,
            [],
            "f1e3",
            "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-48 0l-.003-.282-26.064 22.741-62.679-58.5 16.454-84.355 34.303 3.072c-24.889-34.216-60.004-60.089-100.709-73.141l13.651 31.939L256 139l-74.953-41.525 13.651-31.939c-40.631 13.028-75.78 38.87-100.709 73.141l34.565-3.073 16.192 84.355-62.678 58.5-26.064-22.741-.003.282c0 43.015 13.497 83.952 38.472 117.991l7.704-33.897 85.138 10.447 36.301 77.826-29.902 17.786c40.202 13.122 84.29 13.148 124.572 0l-29.902-17.786 36.301-77.826 85.138-10.447 7.704 33.897C442.503 339.952 456 299.015 456 256zm-248.102 69.571l-29.894-91.312L256 177.732l77.996 56.527-29.622 91.312h-96.476z"
        ],
        "gamepad": [
            640,
            512,
            [],
            "f11b",
            "M480.07 96H160a160 160 0 1 0 114.24 272h91.52A160 160 0 1 0 480.07 96zM248 268a12 12 0 0 1-12 12h-52v52a12 12 0 0 1-12 12h-24a12 12 0 0 1-12-12v-52H84a12 12 0 0 1-12-12v-24a12 12 0 0 1 12-12h52v-52a12 12 0 0 1 12-12h24a12 12 0 0 1 12 12v52h52a12 12 0 0 1 12 12zm216 76a40 40 0 1 1 40-40 40 40 0 0 1-40 40zm64-96a40 40 0 1 1 40-40 40 40 0 0 1-40 40z"
        ],
        "gas-pump": [
            512,
            512,
            [],
            "f52f",
            "M336 448H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm157.2-340.7l-81-81c-6.2-6.2-16.4-6.2-22.6 0l-11.3 11.3c-6.2 6.2-6.2 16.4 0 22.6L416 97.9V160c0 28.1 20.9 51.3 48 55.2V376c0 13.2-10.8 24-24 24s-24-10.8-24-24v-32c0-48.6-39.4-88-88-88h-8V64c0-35.3-28.7-64-64-64H96C60.7 0 32 28.7 32 64v352h288V304h8c22.1 0 40 17.9 40 40v27.8c0 37.7 27 72 64.5 75.9 43 4.3 79.5-29.5 79.5-71.7V152.6c0-17-6.8-33.3-18.8-45.3zM256 192H96V64h160v128z"
        ],
        "gavel": [
            512,
            512,
            [],
            "f0e3",
            "M504.971 199.362l-22.627-22.627c-9.373-9.373-24.569-9.373-33.941 0l-5.657 5.657L329.608 69.255l5.657-5.657c9.373-9.373 9.373-24.569 0-33.941L312.638 7.029c-9.373-9.373-24.569-9.373-33.941 0L154.246 131.48c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l5.657-5.657 39.598 39.598-81.04 81.04-5.657-5.657c-12.497-12.497-32.758-12.497-45.255 0L9.373 412.118c-12.497 12.497-12.497 32.758 0 45.255l45.255 45.255c12.497 12.497 32.758 12.497 45.255 0l114.745-114.745c12.497-12.497 12.497-32.758 0-45.255l-5.657-5.657 81.04-81.04 39.598 39.598-5.657 5.657c-9.373 9.373-9.373 24.569 0 33.941l22.627 22.627c9.373 9.373 24.569 9.373 33.941 0l124.451-124.451c9.372-9.372 9.372-24.568 0-33.941z"
        ],
        "gem": [
            576,
            512,
            [],
            "f3a5",
            "M485.5 0L576 160H474.9L405.7 0h79.8zm-128 0l69.2 160H149.3L218.5 0h139zm-267 0h79.8l-69.2 160H0L90.5 0zM0 192h100.7l123 251.7c1.5 3.1-2.7 5.9-5 3.3L0 192zm148.2 0h279.6l-137 318.2c-1 2.4-4.5 2.4-5.5 0L148.2 192zm204.1 251.7l123-251.7H576L357.3 446.9c-2.3 2.7-6.5-.1-5-3.2z"
        ],
        "genderless": [
            288,
            512,
            [],
            "f22d",
            "M144 176c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80 35.9-80 80-80m0-64C64.5 112 0 176.5 0 256s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144z"
        ],
        "ghost": [
            384,
            512,
            [],
            "f6e2",
            "M186.1.09C81.01 3.24 0 94.92 0 200.05v263.92c0 14.26 17.23 21.39 27.31 11.31l24.92-18.53c6.66-4.95 16-3.99 21.51 2.21l42.95 48.35c6.25 6.25 16.38 6.25 22.63 0l40.72-45.85c6.37-7.17 17.56-7.17 23.92 0l40.72 45.85c6.25 6.25 16.38 6.25 22.63 0l42.95-48.35c5.51-6.2 14.85-7.17 21.51-2.21l24.92 18.53c10.08 10.08 27.31 2.94 27.31-11.31V192C384 84 294.83-3.17 186.1.09zM128 224c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm128 0c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
        ],
        "gift": [
            512,
            512,
            [],
            "f06b",
            "M32 448c0 17.7 14.3 32 32 32h160V320H32v128zm256 32h160c17.7 0 32-14.3 32-32V320H288v160zm192-320h-42.1c6.2-12.1 10.1-25.5 10.1-40 0-48.5-39.5-88-88-88-41.6 0-68.5 21.3-103 68.3-34.5-47-61.4-68.3-103-68.3-48.5 0-88 39.5-88 88 0 14.5 3.8 27.9 10.1 40H32c-17.7 0-32 14.3-32 32v80c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-80c0-17.7-14.3-32-32-32zm-326.1 0c-22.1 0-40-17.9-40-40s17.9-40 40-40c19.9 0 34.6 3.3 86.1 80h-86.1zm206.1 0h-86.1c51.4-76.5 65.7-80 86.1-80 22.1 0 40 17.9 40 40s-17.9 40-40 40z"
        ],
        "gifts": [
            640,
            512,
            [],
            "f79c",
            "M240.6 194.1c1.9-30.8 17.3-61.2 44-79.8C279.4 103.5 268.7 96 256 96h-29.4l30.7-22c7.2-5.1 8.9-15.1 3.7-22.3l-9.3-13c-5.1-7.2-15.1-8.9-22.3-3.7l-32 22.9 11.5-30.6c3.1-8.3-1.1-17.5-9.4-20.6l-15-5.6c-8.3-3.1-17.5 1.1-20.6 9.4l-19.9 53-19.9-53.1C121 2.1 111.8-2.1 103.5 1l-15 5.6C80.2 9.7 76 19 79.2 27.2l11.5 30.6L58.6 35c-7.2-5.1-17.2-3.5-22.3 3.7l-9.3 13c-5.1 7.2-3.5 17.2 3.7 22.3l30.7 22H32c-17.7 0-32 14.3-32 32v352c0 17.7 14.3 32 32 32h168.9c-5.5-9.5-8.9-20.3-8.9-32V256c0-29.9 20.8-55 48.6-61.9zM224 480c0 17.7 14.3 32 32 32h160V384H224v96zm224 32h160c17.7 0 32-14.3 32-32v-96H448v128zm160-288h-20.4c2.6-7.6 4.4-15.5 4.4-23.8 0-35.5-27-72.2-72.1-72.2-48.1 0-75.9 47.7-87.9 75.3-12.1-27.6-39.9-75.3-87.9-75.3-45.1 0-72.1 36.7-72.1 72.2 0 8.3 1.7 16.2 4.4 23.8H256c-17.7 0-32 14.3-32 32v96h192V224h15.3l.7-.2.7.2H448v128h192v-96c0-17.7-14.3-32-32-32zm-272 0c-2.7-1.4-5.1-3-7.2-4.8-7.3-6.4-8.8-13.8-8.8-19 0-9.7 6.4-24.2 24.1-24.2 18.7 0 35.6 27.4 44.5 48H336zm199.2-4.8c-2.1 1.8-4.5 3.4-7.2 4.8h-52.6c8.8-20.3 25.8-48 44.5-48 17.7 0 24.1 14.5 24.1 24.2 0 5.2-1.5 12.6-8.8 19z"
        ],
        "glass-cheers": [
            640,
            512,
            [],
            "f79f",
            "M639.4 433.6c-8.4-20.4-31.8-30.1-52.2-21.6l-22.1 9.2-38.7-101.9c47.9-35 64.8-100.3 34.5-152.8L474.3 16c-8-13.9-25.1-19.7-40-13.6L320 49.8 205.7 2.4c-14.9-6.2-32-.3-40 13.6L79.1 166.5C48.9 219 65.7 284.3 113.6 319.2L74.9 421.1l-22.1-9.2c-20.4-8.5-43.7 1.2-52.2 21.6-1.7 4.1.2 8.8 4.3 10.5l162.3 67.4c4.1 1.7 8.7-.2 10.4-4.3 8.4-20.4-1.2-43.8-21.6-52.3l-22.1-9.2L173.3 342c4.4.5 8.8 1.3 13.1 1.3 51.7 0 99.4-33.1 113.4-85.3l20.2-75.4 20.2 75.4c14 52.2 61.7 85.3 113.4 85.3 4.3 0 8.7-.8 13.1-1.3L506 445.6l-22.1 9.2c-20.4 8.5-30.1 31.9-21.6 52.3 1.7 4.1 6.4 6 10.4 4.3L635.1 444c4-1.7 6-6.3 4.3-10.4zM275.9 162.1l-112.1-46.5 36.5-63.4 94.5 39.2-18.9 70.7zm88.2 0l-18.9-70.7 94.5-39.2 36.5 63.4-112.1 46.5z"
        ],
        "glass-martini": [
            512,
            512,
            [],
            "f000",
            "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6z"
        ],
        "glass-martini-alt": [
            512,
            512,
            [],
            "f57b",
            "M502.05 57.6C523.3 36.34 508.25 0 478.2 0H33.8C3.75 0-11.3 36.34 9.95 57.6L224 271.64V464h-56c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h240c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40h-56V271.64L502.05 57.6zM443.77 48l-48 48H116.24l-48-48h375.53z"
        ],
        "glass-whiskey": [
            512,
            512,
            [],
            "f7a0",
            "M480 32H32C12.5 32-2.4 49.2.3 68.5l56 356.5c4.5 31.5 31.5 54.9 63.4 54.9h273c31.8 0 58.9-23.4 63.4-54.9l55.6-356.5C514.4 49.2 499.5 32 480 32zm-37.4 64l-30 192h-313L69.4 96h373.2z"
        ],
        "glasses": [
            576,
            512,
            [],
            "f530",
            "M574.1 280.37L528.75 98.66c-5.91-23.7-21.59-44.05-43-55.81-21.44-11.73-46.97-14.11-70.19-6.33l-15.25 5.08c-8.39 2.79-12.92 11.86-10.12 20.24l5.06 15.18c2.79 8.38 11.85 12.91 20.23 10.12l13.18-4.39c10.87-3.62 23-3.57 33.16 1.73 10.29 5.37 17.57 14.56 20.37 25.82l38.46 153.82c-22.19-6.81-49.79-12.46-81.2-12.46-34.77 0-73.98 7.02-114.85 26.74h-73.18c-40.87-19.74-80.08-26.75-114.86-26.75-31.42 0-59.02 5.65-81.21 12.46l38.46-153.83c2.79-11.25 10.09-20.45 20.38-25.81 10.16-5.3 22.28-5.35 33.15-1.73l13.17 4.39c8.38 2.79 17.44-1.74 20.23-10.12l5.06-15.18c2.8-8.38-1.73-17.45-10.12-20.24l-15.25-5.08c-23.22-7.78-48.75-5.41-70.19 6.33-21.41 11.77-37.09 32.11-43 55.8L1.9 280.37A64.218 64.218 0 0 0 0 295.86v70.25C0 429.01 51.58 480 115.2 480h37.12c60.28 0 110.37-45.94 114.88-105.37l2.93-38.63h35.75l2.93 38.63C313.31 434.06 363.4 480 423.68 480h37.12c63.62 0 115.2-50.99 115.2-113.88v-70.25c0-5.23-.64-10.43-1.9-15.5zm-370.72 89.42c-1.97 25.91-24.4 46.21-51.06 46.21H115.2C86.97 416 64 393.62 64 366.11v-37.54c18.12-6.49 43.42-12.92 72.58-12.92 23.86 0 47.26 4.33 69.93 12.92l-3.13 41.22zM512 366.12c0 27.51-22.97 49.88-51.2 49.88h-37.12c-26.67 0-49.1-20.3-51.06-46.21l-3.13-41.22c22.67-8.59 46.08-12.92 69.95-12.92 29.12 0 54.43 6.44 72.55 12.93v37.54z"
        ],
        "globe": [
            496,
            512,
            [],
            "f0ac",
            "M336.5 160C322 70.7 287.8 8 248 8s-74 62.7-88.5 152h177zM152 256c0 22.2 1.2 43.5 3.3 64h185.3c2.1-20.5 3.3-41.8 3.3-64s-1.2-43.5-3.3-64H155.3c-2.1 20.5-3.3 41.8-3.3 64zm324.7-96c-28.6-67.9-86.5-120.4-158-141.6 24.4 33.8 41.2 84.7 50 141.6h108zM177.2 18.4C105.8 39.6 47.8 92.1 19.3 160h108c8.7-56.9 25.5-107.8 49.9-141.6zM487.4 192H372.7c2.1 21 3.3 42.5 3.3 64s-1.2 43-3.3 64h114.6c5.5-20.5 8.6-41.8 8.6-64s-3.1-43.5-8.5-64zM120 256c0-21.5 1.2-43 3.3-64H8.6C3.2 212.5 0 233.8 0 256s3.2 43.5 8.6 64h114.6c-2-21-3.2-42.5-3.2-64zm39.5 96c14.5 89.3 48.7 152 88.5 152s74-62.7 88.5-152h-177zm159.3 141.6c71.4-21.2 129.4-73.7 158-141.6h-108c-8.8 56.9-25.6 107.8-50 141.6zM19.3 352c28.6 67.9 86.5 120.4 158 141.6-24.4-33.8-41.2-84.7-50-141.6h-108z"
        ],
        "globe-africa": [
            496,
            512,
            [],
            "f57c",
            "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm160 215.5v6.93c0 5.87-3.32 11.24-8.57 13.86l-15.39 7.7a15.485 15.485 0 0 1-15.53-.97l-18.21-12.14a15.52 15.52 0 0 0-13.5-1.81l-2.65.88c-9.7 3.23-13.66 14.79-7.99 23.3l13.24 19.86c2.87 4.31 7.71 6.9 12.89 6.9h8.21c8.56 0 15.5 6.94 15.5 15.5v11.34c0 3.35-1.09 6.62-3.1 9.3l-18.74 24.98c-1.42 1.9-2.39 4.1-2.83 6.43l-4.3 22.83c-.62 3.29-2.29 6.29-4.76 8.56a159.608 159.608 0 0 0-25 29.16l-13.03 19.55a27.756 27.756 0 0 1-23.09 12.36c-10.51 0-20.12-5.94-24.82-15.34a78.902 78.902 0 0 1-8.33-35.29V367.5c0-8.56-6.94-15.5-15.5-15.5h-25.88c-14.49 0-28.38-5.76-38.63-16a54.659 54.659 0 0 1-16-38.63v-14.06c0-17.19 8.1-33.38 21.85-43.7l27.58-20.69a54.663 54.663 0 0 1 32.78-10.93h.89c8.48 0 16.85 1.97 24.43 5.77l14.72 7.36c3.68 1.84 7.93 2.14 11.83.84l47.31-15.77c6.33-2.11 10.6-8.03 10.6-14.7 0-8.56-6.94-15.5-15.5-15.5h-10.09c-4.11 0-8.05-1.63-10.96-4.54l-6.92-6.92a15.493 15.493 0 0 0-10.96-4.54H199.5c-8.56 0-15.5-6.94-15.5-15.5v-4.4c0-7.11 4.84-13.31 11.74-15.04l14.45-3.61c3.74-.94 7-3.23 9.14-6.44l8.08-12.11c2.87-4.31 7.71-6.9 12.89-6.9h24.21c8.56 0 15.5-6.94 15.5-15.5v-21.7C359.23 71.63 422.86 131.02 441.93 208H423.5c-8.56 0-15.5 6.94-15.5 15.5z"
        ],
        "globe-americas": [
            496,
            512,
            [],
            "f57d",
            "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm82.29 357.6c-3.9 3.88-7.99 7.95-11.31 11.28-2.99 3-5.1 6.7-6.17 10.71-1.51 5.66-2.73 11.38-4.77 16.87l-17.39 46.85c-13.76 3-28 4.69-42.65 4.69v-27.38c1.69-12.62-7.64-36.26-22.63-51.25-6-6-9.37-14.14-9.37-22.63v-32.01c0-11.64-6.27-22.34-16.46-27.97-14.37-7.95-34.81-19.06-48.81-26.11-11.48-5.78-22.1-13.14-31.65-21.75l-.8-.72a114.792 114.792 0 0 1-18.06-20.74c-9.38-13.77-24.66-36.42-34.59-51.14 20.47-45.5 57.36-82.04 103.2-101.89l24.01 12.01C203.48 89.74 216 82.01 216 70.11v-11.3c7.99-1.29 16.12-2.11 24.39-2.42l28.3 28.3c6.25 6.25 6.25 16.38 0 22.63L264 112l-10.34 10.34c-3.12 3.12-3.12 8.19 0 11.31l4.69 4.69c3.12 3.12 3.12 8.19 0 11.31l-8 8a8.008 8.008 0 0 1-5.66 2.34h-8.99c-2.08 0-4.08.81-5.58 2.27l-9.92 9.65a8.008 8.008 0 0 0-1.58 9.31l15.59 31.19c2.66 5.32-1.21 11.58-7.15 11.58h-5.64c-1.93 0-3.79-.7-5.24-1.96l-9.28-8.06a16.017 16.017 0 0 0-15.55-3.1l-31.17 10.39a11.95 11.95 0 0 0-8.17 11.34c0 4.53 2.56 8.66 6.61 10.69l11.08 5.54c9.41 4.71 19.79 7.16 30.31 7.16s22.59 27.29 32 32h66.75c8.49 0 16.62 3.37 22.63 9.37l13.69 13.69a30.503 30.503 0 0 1 8.93 21.57 46.536 46.536 0 0 1-13.72 32.98zM417 274.25c-5.79-1.45-10.84-5-14.15-9.97l-17.98-26.97a23.97 23.97 0 0 1 0-26.62l19.59-29.38c2.32-3.47 5.5-6.29 9.24-8.15l12.98-6.49C440.2 193.59 448 223.87 448 256c0 8.67-.74 17.16-1.82 25.54L417 274.25z"
        ],
        "globe-asia": [
            496,
            512,
            [],
            "f57e",
            "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm-11.34 240.23c-2.89 4.82-8.1 7.77-13.72 7.77h-.31c-4.24 0-8.31 1.69-11.31 4.69l-5.66 5.66c-3.12 3.12-3.12 8.19 0 11.31l5.66 5.66c3 3 4.69 7.07 4.69 11.31V304c0 8.84-7.16 16-16 16h-6.11c-6.06 0-11.6-3.42-14.31-8.85l-22.62-45.23c-2.44-4.88-8.95-5.94-12.81-2.08l-19.47 19.46c-3 3-7.07 4.69-11.31 4.69H50.81C49.12 277.55 48 266.92 48 256c0-110.28 89.72-200 200-200 21.51 0 42.2 3.51 61.63 9.82l-50.16 38.53c-5.11 3.41-4.63 11.06.86 13.81l10.83 5.41c5.42 2.71 8.84 8.25 8.84 14.31V216c0 4.42-3.58 8-8 8h-3.06c-3.03 0-5.8-1.71-7.15-4.42-1.56-3.12-5.96-3.29-7.76-.3l-17.37 28.95zM408 358.43c0 4.24-1.69 8.31-4.69 11.31l-9.57 9.57c-3 3-7.07 4.69-11.31 4.69h-15.16c-4.24 0-8.31-1.69-11.31-4.69l-13.01-13.01a26.767 26.767 0 0 0-25.42-7.04l-21.27 5.32c-1.27.32-2.57.48-3.88.48h-10.34c-4.24 0-8.31-1.69-11.31-4.69l-11.91-11.91a8.008 8.008 0 0 1-2.34-5.66v-10.2c0-3.27 1.99-6.21 5.03-7.43l39.34-15.74c1.98-.79 3.86-1.82 5.59-3.05l23.71-16.89a7.978 7.978 0 0 1 4.64-1.48h12.09c3.23 0 6.15 1.94 7.39 4.93l5.35 12.85a4 4 0 0 0 3.69 2.46h3.8c1.78 0 3.35-1.18 3.84-2.88l4.2-14.47c.5-1.71 2.06-2.88 3.84-2.88h6.06c2.21 0 4 1.79 4 4v12.93c0 2.12.84 4.16 2.34 5.66l11.91 11.91c3 3 4.69 7.07 4.69 11.31v24.6z"
        ],
        "globe-europe": [
            496,
            512,
            [],
            "f7a2",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm200 248c0 22.5-3.9 44.2-10.8 64.4h-20.3c-4.3 0-8.4-1.7-11.4-4.8l-32-32.6c-4.5-4.6-4.5-12.1.1-16.7l12.5-12.5v-8.7c0-3-1.2-5.9-3.3-8l-9.4-9.4c-2.1-2.1-5-3.3-8-3.3h-16c-6.2 0-11.3-5.1-11.3-11.3 0-3 1.2-5.9 3.3-8l9.4-9.4c2.1-2.1 5-3.3 8-3.3h32c6.2 0 11.3-5.1 11.3-11.3v-9.4c0-6.2-5.1-11.3-11.3-11.3h-36.7c-8.8 0-16 7.2-16 16v4.5c0 6.9-4.4 13-10.9 15.2l-31.6 10.5c-3.3 1.1-5.5 4.1-5.5 7.6v2.2c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8s-3.6-8-8-8H247c-3 0-5.8 1.7-7.2 4.4l-9.4 18.7c-2.7 5.4-8.2 8.8-14.3 8.8H194c-8.8 0-16-7.2-16-16V199c0-4.2 1.7-8.3 4.7-11.3l20.1-20.1c4.6-4.6 7.2-10.9 7.2-17.5 0-3.4 2.2-6.5 5.5-7.6l40-13.3c1.7-.6 3.2-1.5 4.4-2.7l26.8-26.8c2.1-2.1 3.3-5 3.3-8 0-6.2-5.1-11.3-11.3-11.3H258l-16 16v8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-20c0-2.5 1.2-4.9 3.2-6.4l28.9-21.7c1.9-.1 3.8-.3 5.7-.3C358.3 56 448 145.7 448 256zM130.1 149.1c0-3 1.2-5.9 3.3-8l25.4-25.4c2.1-2.1 5-3.3 8-3.3 6.2 0 11.3 5.1 11.3 11.3v16c0 3-1.2 5.9-3.3 8l-9.4 9.4c-2.1 2.1-5 3.3-8 3.3h-16c-6.2 0-11.3-5.1-11.3-11.3zm128 306.4v-7.1c0-8.8-7.2-16-16-16h-20.2c-10.8 0-26.7-5.3-35.4-11.8l-22.2-16.7c-11.5-8.6-18.2-22.1-18.2-36.4v-23.9c0-16 8.4-30.8 22.1-39l42.9-25.7c7.1-4.2 15.2-6.5 23.4-6.5h31.2c10.9 0 21.4 3.9 29.6 10.9l43.2 37.1h18.3c8.5 0 16.6 3.4 22.6 9.4l17.3 17.3c3.4 3.4 8.1 5.3 12.9 5.3H423c-32.4 58.9-93.8 99.5-164.9 103.1z"
        ],
        "golf-ball": [
            416,
            512,
            [],
            "f450",
            "M96 416h224c0 17.7-14.3 32-32 32h-16c-17.7 0-32 14.3-32 32v20c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-20c0-17.7-14.3-32-32-32h-16c-17.7 0-32-14.3-32-32zm320-208c0 74.2-39 139.2-97.5 176h-221C39 347.2 0 282.2 0 208 0 93.1 93.1 0 208 0s208 93.1 208 208zm-180.1 43.9c18.3 0 33.1-14.8 33.1-33.1 0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1zm49.1 46.9c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1zm64-64c0-14.4-9.3-26.3-22.1-30.9 9.6 26.8-15.6 51.3-41.9 41.9 4.6 12.8 16.5 22.1 30.9 22.1 18.3 0 33.1-14.9 33.1-33.1z"
        ],
        "gopuram": [
            512,
            512,
            [],
            "f664",
            "M496 352h-16V240c0-8.8-7.2-16-16-16h-16v-80c0-8.8-7.2-16-16-16h-16V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16s-16 7.2-16 16v16h-64V16c0-8.8-7.2-16-16-16S96 7.2 96 16v112H80c-8.8 0-16 7.2-16 16v80H48c-8.8 0-16 7.2-16 16v112H16c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16h80V352h32V224h32v-96h32v96h-32v128h-32v160h80v-80c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16v80h80V352h-32V224h-32v-96h32v96h32v128h32v160h80c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zM232 176c0-8.8 7.2-16 16-16h16c8.8 0 16 7.2 16 16v48h-48zm56 176h-64v-64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16z"
        ],
        "graduation-cap": [
            640,
            512,
            [],
            "f19d",
            "M622.34 153.2L343.4 67.5c-15.2-4.67-31.6-4.67-46.79 0L17.66 153.2c-23.54 7.23-23.54 38.36 0 45.59l48.63 14.94c-10.67 13.19-17.23 29.28-17.88 46.9C38.78 266.15 32 276.11 32 288c0 10.78 5.68 19.85 13.86 25.65L20.33 428.53C18.11 438.52 25.71 448 35.94 448h56.11c10.24 0 17.84-9.48 15.62-19.47L82.14 313.65C90.32 307.85 96 298.78 96 288c0-11.57-6.47-21.25-15.66-26.87.76-15.02 8.44-28.3 20.69-36.72L296.6 284.5c9.06 2.78 26.44 6.25 46.79 0l278.95-85.7c23.55-7.24 23.55-38.36 0-45.6zM352.79 315.09c-28.53 8.76-52.84 3.92-65.59 0l-145.02-44.55L128 384c0 35.35 85.96 64 192 64s192-28.65 192-64l-14.18-113.47-145.03 44.56z"
        ],
        "greater-than": [
            384,
            512,
            [],
            "f531",
            "M365.52 209.85L59.22 67.01c-16.06-7.49-35.15-.54-42.64 15.52L3.01 111.61c-7.49 16.06-.54 35.15 15.52 42.64L236.96 256.1 18.49 357.99C2.47 365.46-4.46 384.5 3.01 400.52l13.52 29C24 445.54 43.04 452.47 59.06 445l306.47-142.91a32.003 32.003 0 0 0 18.48-29v-34.23c-.01-12.45-7.21-23.76-18.49-29.01z"
        ],
        "greater-than-equal": [
            448,
            512,
            [],
            "f532",
            "M55.22 107.69l175.56 68.09-175.44 68.05c-18.39 6.03-27.88 24.39-21.2 41l12.09 30.08c6.68 16.61 26.99 25.19 45.38 19.15L393.02 214.2c13.77-4.52 22.98-16.61 22.98-30.17v-15.96c0-13.56-9.21-25.65-22.98-30.17L91.3 17.92c-18.29-6-38.51 2.53-45.15 19.06L34.12 66.9c-6.64 16.53 2.81 34.79 21.1 40.79zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
        ],
        "grimace": [
            496,
            512,
            [],
            "f57f",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM144 400h-8c-17.7 0-32-14.3-32-32v-8h40v40zm0-56h-40v-8c0-17.7 14.3-32 32-32h8v40zm-8-136c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm72 192h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm64 56h-48v-40h48v40zm0-56h-48v-40h48v40zm-8-104c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm64 128c0 17.7-14.3 32-32 32h-8v-40h40v8zm0-24h-40v-40h8c17.7 0 32 14.3 32 32v8z"
        ],
        "grin": [
            496,
            512,
            [],
            "f580",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm80 256c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
        ],
        "grin-alt": [
            496,
            512,
            [],
            "f581",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm63.7 128.7c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zm-160 0c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
        ],
        "grin-beam": [
            496,
            512,
            [],
            "f582",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 144c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
        ],
        "grin-beam-sweat": [
            504,
            512,
            [],
            "f583",
            "M456 128c26.5 0 48-21 48-47 0-20-28.5-60.4-41.6-77.8-3.2-4.3-9.6-4.3-12.8 0C436.5 20.6 408 61 408 81c0 26 21.5 47 48 47zm0 32c-44.1 0-80-35.4-80-79 0-4.4.3-14.2 8.1-32.2C345 23.1 298.3 8 248 8 111 8 0 119 0 256s111 248 248 248 248-111 248-248c0-35.1-7.4-68.4-20.5-98.6-6.3 1.5-12.7 2.6-19.5 2.6zm-128-8c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
        ],
        "grin-hearts": [
            496,
            512,
            [],
            "f584",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM90.4 183.6c6.7-17.6 26.7-26.7 44.9-21.9l7.1 1.9 2-7.1c5-18.1 22.8-30.9 41.5-27.9 21.4 3.4 34.4 24.2 28.8 44.5L195.3 243c-1.2 4.5-5.9 7.2-10.5 6l-70.2-18.2c-20.4-5.4-31.9-27-24.2-47.2zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm133.4-201.3l-70.2 18.2c-4.5 1.2-9.2-1.5-10.5-6L281.3 173c-5.6-20.3 7.4-41.1 28.8-44.5 18.6-3 36.4 9.8 41.5 27.9l2 7.1 7.1-1.9c18.2-4.7 38.2 4.3 44.9 21.9 7.7 20.3-3.8 41.9-24.2 47.2z"
        ],
        "grin-squint": [
            496,
            512,
            [],
            "f585",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.9 9.4-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.2 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
        ],
        "grin-squint-tears": [
            512,
            512,
            [],
            "f586",
            "M409.6 111.9c22.6-3.2 73.5-12 88.3-26.8 19.2-19.2 18.9-50.6-.7-70.2S446-5 426.9 14.2c-14.8 14.8-23.5 65.7-26.8 88.3-.8 5.5 3.9 10.2 9.5 9.4zM102.4 400.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm311.7-256.5c-33 3.9-48.6-25.1-45.7-45.7 3.4-24 7.4-42.1 11.5-56.5C285.1-13.4 161.8-.5 80.6 80.6-.5 161.7-13.4 285 41.4 379.9c14.4-4.1 32.4-8 56.5-11.5 33.2-3.9 48.6 25.2 45.7 45.7-3.4 24-7.4 42.1-11.5 56.5 94.8 54.8 218.1 41.9 299.3-39.2s94-204.4 39.2-299.3c-14.4 4.1-32.5 8-56.5 11.5zM255.7 106c3.3-13.2 22.4-11.5 23.6 1.8l4.8 52.3 52.3 4.8c13.4 1.2 14.9 20.3 1.8 23.6l-90.5 22.6c-8.9 2.2-16.7-5.9-14.5-14.5l22.5-90.6zm-90.9 230.3L160 284l-52.3-4.8c-13.4-1.2-14.9-20.3-1.8-23.6l90.5-22.6c8.8-2.2 16.7 5.8 14.5 14.5L188.3 338c-3.1 13.2-22.2 11.7-23.5-1.7zm215.7 44.2c-29.3 29.3-75.7 50.4-116.7 50.4-18.9 0-36.6-4.5-51-14.7-9.8-6.9-8.7-21.8 2-27.2 28.3-14.6 63.9-42.4 97.8-76.3s61.7-69.6 76.3-97.8c5.4-10.5 20.2-11.9 27.3-2 32.3 45.3 7.1 124.7-35.7 167.6z"
        ],
        "grin-stars": [
            496,
            512,
            [],
            "f587",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM94.6 168.9l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.2 1 8.9 8.6 4.3 13.2l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L152 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.6-4.7-1.9-12.3 4.3-13.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3zm157.7-249.9l-25.4 24.6 6 34.9c1 6.2-5.3 11-11 7.9L344 233.3l-31.3 16.3c-5.7 3.1-12-1.7-11-7.9l6-34.9-25.4-24.6c-4.5-4.6-1.9-12.2 4.3-13.2l34.9-5 15.5-31.6c2.9-5.8 11-5.8 13.9 0l15.5 31.6 34.9 5c6.3.9 9 8.5 4.4 13.1z"
        ],
        "grin-tears": [
            640,
            512,
            [],
            "f588",
            "M102.4 256.1c-22.6 3.2-73.5 12-88.3 26.8-19.1 19.1-18.8 50.6.8 70.2s51 19.9 70.2.7c14.8-14.8 23.5-65.7 26.8-88.3.8-5.5-3.9-10.2-9.5-9.4zm523.4 26.8c-14.8-14.8-65.7-23.5-88.3-26.8-5.5-.8-10.3 3.9-9.5 9.5 3.2 22.6 12 73.5 26.8 88.3 19.2 19.2 50.6 18.9 70.2-.7s20-51.2.8-70.3zm-129.4-12.8c-3.8-26.6 19.1-49.5 45.7-45.7 8.9 1.3 16.8 2.7 24.3 4.1C552.7 104.5 447.7 8 320 8S87.3 104.5 73.6 228.5c7.5-1.4 15.4-2.8 24.3-4.1 33.2-3.9 48.6 25.3 45.7 45.7-11.8 82.3-29.9 100.4-35.8 106.4-.9.9-2 1.6-3 2.5 42.7 74.6 123 125 215.2 125s172.5-50.4 215.2-125.1c-1-.9-2.1-1.5-3-2.5-5.9-5.9-24-24-35.8-106.3zM400 152c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm-160 0c23.8 0 52.7 29.3 56 71.4.7 8.6-10.8 12-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.1-42.1 32-71.4 55.8-71.4zm80 280c-60.6 0-134.5-38.3-143.8-93.3-2-11.7 9.2-21.6 20.7-17.9C227.1 330.5 272 336 320 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
        ],
        "grin-tongue": [
            496,
            512,
            [],
            "f589",
            "M248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.6 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-34.9 134.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"
        ],
        "grin-tongue-squint": [
            496,
            512,
            [],
            "f58a",
            "M293.1 374.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.2-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-33.8 210.3l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.7 4.7 7.7 15.9 0 20.6zm163 30c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.8-4.7-7.8-15.9 0-20.6l80-48c11.7-6.9 23.9 7.7 15.4 18L343.6 208l33.6 40.3z"
        ],
        "grin-tongue-wink": [
            496,
            512,
            [],
            "f58b",
            "M344 184c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256c0 106.3 67 196.7 161 232-5.6-12.2-9-25.7-9-40v-45.5c-24.7-16.2-43.5-38.1-47.8-63.8-2-11.8 9.3-21.5 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.5-3.7 22.6 6.1 20.7 17.9-4.3 25.7-23.1 47.6-47.8 63.8V448c0 14.3-3.4 27.8-9 40 94-35.3 161-125.7 161-232C496 119 385 8 248 8zm-56 225l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L112 233c-8.5 7.4-21.6.3-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c1.6 11.1-11.6 18.2-20 10.8zm152 39c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm-50.9 102.6c-14.4-6.5-31.1 2.2-34.6 17.6l-1.8 7.8c-2.1 9.2-15.2 9.2-17.3 0l-1.8-7.8c-3.5-15.4-20.2-24.1-34.6-17.6-.9.4.3-.2-18.9 9.4v63c0 35.2 28 64.5 63.1 64.9 35.7.5 64.9-28.4 64.9-64v-64c-19.5-9.6-18.2-8.9-19-9.3z"
        ],
        "grin-wink": [
            496,
            512,
            [],
            "f58c",
            "M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm168 25l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.6 11-11.5 18.2-20 10.8zm-243.1 87.8C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.3-3.7 22.6 6 20.7 17.9-9.2 55-83.2 93.3-143.8 93.3s-134.5-38.3-143.8-93.3c-2-11.9 9.3-21.6 20.7-17.9z"
        ],
        "grip-horizontal": [
            448,
            512,
            [],
            "f58d",
            "M96 288H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM96 96H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm160 0h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
        ],
        "grip-lines": [
            512,
            512,
            [],
            "f7a4",
            "M496 288H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-128H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"
        ],
        "grip-lines-vertical": [
            256,
            512,
            [],
            "f7a5",
            "M96 496V16c0-8.8-7.2-16-16-16H48c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16zm128 0V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16z"
        ],
        "grip-vertical": [
            320,
            512,
            [],
            "f58e",
            "M96 32H32C14.33 32 0 46.33 0 64v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM288 32h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
        ],
        "guitar": [
            512,
            512,
            [],
            "f7a6",
            "M502.63 39L473 9.37a32 32 0 0 0-45.26 0L381.46 55.7a35.14 35.14 0 0 0-8.53 13.79L360.77 106l-76.26 76.26c-12.16-8.76-25.5-15.74-40.1-19.14-33.45-7.78-67-.88-89.88 22a82.45 82.45 0 0 0-20.24 33.47c-6 18.56-23.21 32.69-42.15 34.46-23.7 2.27-45.73 11.45-62.61 28.44C-16.11 327-7.9 409 47.58 464.45S185 528 230.56 482.52c17-16.88 26.16-38.9 28.45-62.71 1.76-18.85 15.89-36.13 34.43-42.14a82.6 82.6 0 0 0 33.48-20.25c22.87-22.88 29.74-56.36 22-89.75-3.39-14.64-10.37-28-19.16-40.2L406 151.23l36.48-12.16a35.14 35.14 0 0 0 13.79-8.53l46.33-46.32a32 32 0 0 0 .03-45.22zM208 352a48 48 0 1 1 48-48 48 48 0 0 1-48 48z"
        ],
        "h-square": [
            448,
            512,
            [],
            "f0fd",
            "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zm-112 48h-32c-8.837 0-16 7.163-16 16v80H160v-80c0-8.837-7.163-16-16-16h-32c-8.837 0-16 7.163-16 16v224c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16v-80h128v80c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16V144c0-8.837-7.163-16-16-16z"
        ],
        "hamburger": [
            512,
            512,
            [],
            "f805",
            "M464 256H48a48 48 0 0 0 0 96h416a48 48 0 0 0 0-96zm16 128H32a16 16 0 0 0-16 16v16a64 64 0 0 0 64 64h352a64 64 0 0 0 64-64v-16a16 16 0 0 0-16-16zM58.64 224h394.72c34.57 0 54.62-43.9 34.82-75.88C448 83.2 359.55 32.1 256 32c-103.54.1-192 51.2-232.18 116.11C4 180.09 24.07 224 58.64 224zM384 112a16 16 0 1 1-16 16 16 16 0 0 1 16-16zM256 80a16 16 0 1 1-16 16 16 16 0 0 1 16-16zm-128 32a16 16 0 1 1-16 16 16 16 0 0 1 16-16z"
        ],
        "hammer": [
            576,
            512,
            [],
            "f6e3",
            "M571.31 193.94l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31-28.9-28.9c5.63-21.31.36-44.9-16.35-61.61l-45.25-45.25c-62.48-62.48-163.79-62.48-226.28 0l90.51 45.25v18.75c0 16.97 6.74 33.25 18.75 45.25l49.14 49.14c16.71 16.71 40.3 21.98 61.61 16.35l28.9 28.9-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l90.51-90.51c6.23-6.24 6.23-16.37-.02-22.62zm-286.72-15.2c-3.7-3.7-6.84-7.79-9.85-11.95L19.64 404.96c-25.57 23.88-26.26 64.19-1.53 88.93s65.05 24.05 88.93-1.53l238.13-255.07c-3.96-2.91-7.9-5.87-11.44-9.41l-49.14-49.14z"
        ],
        "hamsa": [
            512,
            512,
            [],
            "f665",
            "M509.34 307.25C504.28 295.56 492.75 288 480 288h-64V80c0-22-18-40-40-40s-40 18-40 40v134c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V40c0-22-18-40-40-40s-40 18-40 40v174c0 5.52-4.48 10-10 10h-20c-5.52 0-10-4.48-10-10V80c0-22-18-40-40-40S96 58 96 80v208H32c-12.75 0-24.28 7.56-29.34 19.25a31.966 31.966 0 0 0 5.94 34.58l102.69 110.03C146.97 490.08 199.69 512 256 512s109.03-21.92 144.72-60.14L503.4 341.83a31.966 31.966 0 0 0 5.94-34.58zM256 416c-53.02 0-96-64-96-64s42.98-64 96-64 96 64 96 64-42.98 64-96 64zm0-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
        ],
        "hand-holding": [
            576,
            512,
            [],
            "f4bd",
            "M565.3 328.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
        ],
        "hand-holding-heart": [
            576,
            512,
            [],
            "f4be",
            "M275.3 250.5c7 7.4 18.4 7.4 25.5 0l108.9-114.2c31.6-33.2 29.8-88.2-5.6-118.8-30.8-26.7-76.7-21.9-104.9 7.7L288 36.9l-11.1-11.6C248.7-4.4 202.8-9.2 172 17.5c-35.3 30.6-37.2 85.6-5.6 118.8l108.9 114.2zm290 77.6c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
        ],
        "hand-holding-medical": [
            576,
            512,
            [],
            "e05c",
            "M159.88,175.82h64v64a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16v-64h64a16,16,0,0,0,16-16v-64a16,16,0,0,0-16-16h-64v-64a16,16,0,0,0-16-16h-64a16,16,0,0,0-16,16v64h-64a16,16,0,0,0-16,16v64A16,16,0,0,0,159.88,175.82ZM568.07,336.13a39.91,39.91,0,0,0-55.93-8.47L392.47,415.84H271.86a16,16,0,0,1,0-32H350.1c16,0,30.75-10.87,33.37-26.61a32.06,32.06,0,0,0-31.62-37.38h-160a117.7,117.7,0,0,0-74.12,26.25l-46.5,37.74H15.87a16.11,16.11,0,0,0-16,16v96a16.11,16.11,0,0,0,16,16h347a104.8,104.8,0,0,0,61.7-20.27L559.6,392A40,40,0,0,0,568.07,336.13Z"
        ],
        "hand-holding-usd": [
            576,
            512,
            [],
            "f4c0",
            "M271.06,144.3l54.27,14.3a8.59,8.59,0,0,1,6.63,8.1c0,4.6-4.09,8.4-9.12,8.4h-35.6a30,30,0,0,1-11.19-2.2c-5.24-2.2-11.28-1.7-15.3,2l-19,17.5a11.68,11.68,0,0,0-2.25,2.66,11.42,11.42,0,0,0,3.88,15.74,83.77,83.77,0,0,0,34.51,11.5V240c0,8.8,7.83,16,17.37,16h17.37c9.55,0,17.38-7.2,17.38-16V222.4c32.93-3.6,57.84-31,53.5-63-3.15-23-22.46-41.3-46.56-47.7L282.68,97.4a8.59,8.59,0,0,1-6.63-8.1c0-4.6,4.09-8.4,9.12-8.4h35.6A30,30,0,0,1,332,83.1c5.23,2.2,11.28,1.7,15.3-2l19-17.5A11.31,11.31,0,0,0,368.47,61a11.43,11.43,0,0,0-3.84-15.78,83.82,83.82,0,0,0-34.52-11.5V16c0-8.8-7.82-16-17.37-16H295.37C285.82,0,278,7.2,278,16V33.6c-32.89,3.6-57.85,31-53.51,63C227.63,119.6,247,137.9,271.06,144.3ZM565.27,328.1c-11.8-10.7-30.2-10-42.6,0L430.27,402a63.64,63.64,0,0,1-40,14H272a16,16,0,0,1,0-32h78.29c15.9,0,30.71-10.9,33.25-26.6a31.2,31.2,0,0,0,.46-5.46A32,32,0,0,0,352,320H192a117.66,117.66,0,0,0-74.1,26.29L71.4,384H16A16,16,0,0,0,0,400v96a16,16,0,0,0,16,16H372.77a64,64,0,0,0,40-14L564,377a32,32,0,0,0,1.28-48.9Z"
        ],
        "hand-holding-water": [
            576,
            512,
            [],
            "f4c1",
            "M288 256c53 0 96-42.1 96-94 0-40-57.1-120.7-83.2-155.6-6.4-8.5-19.2-8.5-25.6 0C249.1 41.3 192 122 192 162c0 51.9 43 94 96 94zm277.3 72.1c-11.8-10.7-30.2-10-42.6 0L430.3 402c-11.3 9.1-25.4 14-40 14H272c-8.8 0-16-7.2-16-16s7.2-16 16-16h78.3c15.9 0 30.7-10.9 33.3-26.6 3.3-20-12.1-37.4-31.6-37.4H192c-27 0-53.1 9.3-74.1 26.3L71.4 384H16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16h356.8c14.5 0 28.6-4.9 40-14L564 377c15.2-12.1 16.4-35.3 1.3-48.9z"
        ],
        "hand-lizard": [
            576,
            512,
            [],
            "f258",
            "M384 480h192V363.778a95.998 95.998 0 0 0-14.833-51.263L398.127 54.368A48 48 0 0 0 357.544 32H24C10.745 32 0 42.745 0 56v16c0 30.928 25.072 56 56 56h229.981c12.844 0 21.556 13.067 16.615 24.923l-21.41 51.385A32 32 0 0 1 251.648 224H128c-35.346 0-64 28.654-64 64v8c0 13.255 10.745 24 24 24h147.406a47.995 47.995 0 0 1 25.692 7.455l111.748 70.811A24.001 24.001 0 0 1 384 418.539V480z"
        ],
        "hand-middle-finger": [
            512,
            512,
            [],
            "f806",
            "M479.93 317.12a37.33 37.33 0 0 0-28.28-36.19L416 272v-49.59c0-11.44-9.69-21.29-23.15-23.54l-38.4-6.4C336.63 189.5 320 200.86 320 216v32a8 8 0 0 1-16 0V50c0-26.28-20.25-49.2-46.52-50A48 48 0 0 0 208 48v200a8 8 0 0 1-16 0v-32c0-15.15-16.63-26.51-34.45-23.54l-30.68 5.12c-18 3-30.87 16.12-30.87 31.38V376a8 8 0 0 1-16 0v-76l-27.36 15A37.34 37.34 0 0 0 32 348.4v73.47a37.31 37.31 0 0 0 10.93 26.39l30.93 30.93A112 112 0 0 0 153.05 512h215A112 112 0 0 0 480 400z"
        ],
        "hand-paper": [
            448,
            512,
            [],
            "f256",
            "M408.781 128.007C386.356 127.578 368 146.36 368 168.79V256h-8V79.79c0-22.43-18.356-41.212-40.781-40.783C297.488 39.423 280 57.169 280 79v177h-8V40.79C272 18.36 253.644-.422 231.219.007 209.488.423 192 18.169 192 40v216h-8V80.79c0-22.43-18.356-41.212-40.781-40.783C121.488 40.423 104 58.169 104 80v235.992l-31.648-43.519c-12.993-17.866-38.009-21.817-55.877-8.823-17.865 12.994-21.815 38.01-8.822 55.877l125.601 172.705A48 48 0 0 0 172.073 512h197.59c22.274 0 41.622-15.324 46.724-37.006l26.508-112.66a192.011 192.011 0 0 0 5.104-43.975V168c.001-21.831-17.487-39.577-39.218-39.993z"
        ],
        "hand-peace": [
            448,
            512,
            [],
            "f25b",
            "M408 216c-22.092 0-40 17.909-40 40h-8v-32c0-22.091-17.908-40-40-40s-40 17.909-40 40v32h-8V48c0-26.51-21.49-48-48-48s-48 21.49-48 48v208h-13.572L92.688 78.449C82.994 53.774 55.134 41.63 30.461 51.324 5.787 61.017-6.356 88.877 3.337 113.551l74.765 190.342-31.09 24.872c-15.381 12.306-19.515 33.978-9.741 51.081l64 112A39.998 39.998 0 0 0 136 512h240c18.562 0 34.686-12.77 38.937-30.838l32-136A39.97 39.97 0 0 0 448 336v-80c0-22.091-17.908-40-40-40z"
        ],
        "hand-point-down": [
            384,
            512,
            [],
            "f0a7",
            "M91.826 467.2V317.966c-8.248 5.841-16.558 10.57-24.918 14.153C35.098 345.752-.014 322.222 0 288c.008-18.616 10.897-32.203 29.092-40 28.286-12.122 64.329-78.648 77.323-107.534 7.956-17.857 25.479-28.453 43.845-28.464l.001-.002h171.526c11.812 0 21.897 8.596 23.703 20.269 7.25 46.837 38.483 61.76 38.315 123.731-.007 2.724.195 13.254.195 16 0 50.654-22.122 81.574-71.263 72.6-9.297 18.597-39.486 30.738-62.315 16.45-21.177 24.645-53.896 22.639-70.944 6.299V467.2c0 24.15-20.201 44.8-43.826 44.8-23.283 0-43.826-21.35-43.826-44.8zM112 72V24c0-13.255 10.745-24 24-24h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24zm212-24c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"
        ],
        "hand-point-left": [
            512,
            512,
            [],
            "f0a5",
            "M44.8 155.826h149.234c-5.841-8.248-10.57-16.558-14.153-24.918C166.248 99.098 189.778 63.986 224 64c18.616.008 32.203 10.897 40 29.092 12.122 28.286 78.648 64.329 107.534 77.323 17.857 7.956 28.453 25.479 28.464 43.845l.002.001v171.526c0 11.812-8.596 21.897-20.269 23.703-46.837 7.25-61.76 38.483-123.731 38.315-2.724-.007-13.254.195-16 .195-50.654 0-81.574-22.122-72.6-71.263-18.597-9.297-30.738-39.486-16.45-62.315-24.645-21.177-22.639-53.896-6.299-70.944H44.8c-24.15 0-44.8-20.201-44.8-43.826 0-23.283 21.35-43.826 44.8-43.826zM440 176h48c13.255 0 24 10.745 24 24v192c0 13.255-10.745 24-24 24h-48c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24zm24 212c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20z"
        ],
        "hand-point-right": [
            512,
            512,
            [],
            "f0a4",
            "M512 199.652c0 23.625-20.65 43.826-44.8 43.826h-99.851c16.34 17.048 18.346 49.766-6.299 70.944 14.288 22.829 2.147 53.017-16.45 62.315C353.574 425.878 322.654 448 272 448c-2.746 0-13.276-.203-16-.195-61.971.168-76.894-31.065-123.731-38.315C120.596 407.683 112 397.599 112 385.786V214.261l.002-.001c.011-18.366 10.607-35.889 28.464-43.845 28.886-12.994 95.413-49.038 107.534-77.323 7.797-18.194 21.384-29.084 40-29.092 34.222-.014 57.752 35.098 44.119 66.908-3.583 8.359-8.312 16.67-14.153 24.918H467.2c23.45 0 44.8 20.543 44.8 43.826zM96 200v192c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V200c0-13.255 10.745-24 24-24h48c13.255 0 24 10.745 24 24zM68 368c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z"
        ],
        "hand-point-up": [
            384,
            512,
            [],
            "f0a6",
            "M135.652 0c23.625 0 43.826 20.65 43.826 44.8v99.851c17.048-16.34 49.766-18.346 70.944 6.299 22.829-14.288 53.017-2.147 62.315 16.45C361.878 158.426 384 189.346 384 240c0 2.746-.203 13.276-.195 16 .168 61.971-31.065 76.894-38.315 123.731C343.683 391.404 333.599 400 321.786 400H150.261l-.001-.002c-18.366-.011-35.889-10.607-43.845-28.464C93.421 342.648 57.377 276.122 29.092 264 10.897 256.203.008 242.616 0 224c-.014-34.222 35.098-57.752 66.908-44.119 8.359 3.583 16.67 8.312 24.918 14.153V44.8c0-23.45 20.543-44.8 43.826-44.8zM136 416h192c13.255 0 24 10.745 24 24v48c0 13.255-10.745 24-24 24H136c-13.255 0-24-10.745-24-24v-48c0-13.255 10.745-24 24-24zm168 28c-11.046 0-20 8.954-20 20s8.954 20 20 20 20-8.954 20-20-8.954-20-20-20z"
        ],
        "hand-pointer": [
            448,
            512,
            [],
            "f25a",
            "M448 240v96c0 3.084-.356 6.159-1.063 9.162l-32 136C410.686 499.23 394.562 512 376 512H168a40.004 40.004 0 0 1-32.35-16.473l-127.997-176c-12.993-17.866-9.043-42.883 8.822-55.876 17.867-12.994 42.884-9.043 55.877 8.823L104 315.992V40c0-22.091 17.908-40 40-40s40 17.909 40 40v200h8v-40c0-22.091 17.908-40 40-40s40 17.909 40 40v40h8v-24c0-22.091 17.908-40 40-40s40 17.909 40 40v24h8c0-22.091 17.908-40 40-40s40 17.909 40 40zm-256 80h-8v96h8v-96zm88 0h-8v96h8v-96zm88 0h-8v96h8v-96z"
        ],
        "hand-rock": [
            512,
            512,
            [],
            "f255",
            "M464.8 80c-26.9-.4-48.8 21.2-48.8 48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v32h-8V80.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v48h-8V96.8c0-26.3-20.9-48.3-47.2-48.8-26.9-.4-48.8 21.2-48.8 48v136l-8-7.1v-48.1c0-26.3-20.9-48.3-47.2-48.8C21.9 127.6 0 149.2 0 176v66.4c0 27.4 11.7 53.5 32.2 71.8l111.7 99.3c10.2 9.1 16.1 22.2 16.1 35.9v6.7c0 13.3 10.7 24 24 24h240c13.3 0 24-10.7 24-24v-2.9c0-12.8 2.6-25.5 7.5-37.3l49-116.3c5-11.8 7.5-24.5 7.5-37.3V128.8c0-26.3-20.9-48.4-47.2-48.8z"
        ],
        "hand-scissors": [
            512,
            512,
            [],
            "f257",
            "M216 440c0-22.092 17.909-40 40-40v-8h-32c-22.091 0-40-17.908-40-40s17.909-40 40-40h32v-8H48c-26.51 0-48-21.49-48-48s21.49-48 48-48h208v-13.572l-177.551-69.74c-24.674-9.694-36.818-37.555-27.125-62.228 9.693-24.674 37.554-36.817 62.228-27.124l190.342 74.765 24.872-31.09c12.306-15.381 33.978-19.515 51.081-9.741l112 64A40.002 40.002 0 0 1 512 168v240c0 18.562-12.77 34.686-30.838 38.937l-136 32A39.982 39.982 0 0 1 336 480h-80c-22.091 0-40-17.908-40-40z"
        ],
        "hand-sparkles": [
            640,
            512,
            [],
            "e05d",
            "M106.66,170.64l.09,0,49.55-20.65a7.32,7.32,0,0,0,3.68-6h0a7.29,7.29,0,0,0-3.68-6l-49.57-20.67-.07,0L86,67.68a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L3.7,138A7.29,7.29,0,0,0,0,144H0a7.32,7.32,0,0,0,3.68,6L53.27,170.6l.07,0L74,220.26a6.65,6.65,0,0,0,11.92,0l20.69-49.62ZM471.38,467.41l-1-.42-1-.5a38.67,38.67,0,0,1,0-69.14l1-.49,1-.43,37.49-15.63,15.63-37.48.41-1,.47-.95c3.85-7.74,10.58-13.63,18.35-17.34,0-1.33.25-2.69.27-4V144a32,32,0,0,0-64,0v72a8,8,0,0,1-8,8H456a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H360a8,8,0,0,1-8-8V32a32,32,0,0,0-64,0V216a8,8,0,0,1-8,8H264a8,8,0,0,1-8-8V64a32,32,0,0,0-64,0v241l-23.59-32.49a40,40,0,0,0-64.71,47.09L229.3,492.21A48.07,48.07,0,0,0,268.09,512H465.7c19.24,0,35.65-11.73,43.24-28.79l-.07-.17ZM349.79,339.52,320,351.93l-12.42,29.78a4,4,0,0,1-7.15,0L288,351.93l-29.79-12.41a4,4,0,0,1,0-7.16L288,319.94l12.42-29.78a4,4,0,0,1,7.15,0L320,319.94l29.79,12.42a4,4,0,0,1,0,7.16ZM640,431.91a7.28,7.28,0,0,0-3.68-6l-49.57-20.67-.07,0L566,355.63a6.66,6.66,0,0,0-11.92,0l-20.7,49.63-.05,0L483.7,426a7.28,7.28,0,0,0-3.68,6h0a7.29,7.29,0,0,0,3.68,5.95l49.57,20.67.07,0L554,508.21a6.65,6.65,0,0,0,11.92,0l20.69-49.62h0l.09,0,49.55-20.66a7.29,7.29,0,0,0,3.68-5.95h0Z"
        ],
        "hand-spock": [
            512,
            512,
            [],
            "f259",
            "M510.9005,145.27027,442.604,432.09391A103.99507,103.99507,0,0,1,341.43745,512H214.074a135.96968,135.96968,0,0,1-93.18489-36.95291L12.59072,373.12723a39.992,39.992,0,0,1,54.8122-58.24988l60.59342,57.02528v0a283.24849,283.24849,0,0,0-11.6703-80.46734L73.63726,147.36011a40.00575,40.00575,0,1,1,76.71833-22.7187l37.15458,125.39477a8.33113,8.33113,0,0,0,16.05656-4.4414L153.26183,49.95406A39.99638,39.99638,0,1,1,230.73015,30.0166l56.09491,218.15825a10.42047,10.42047,0,0,0,20.30018-.501L344.80766,63.96966a40.052,40.052,0,0,1,51.30245-30.0893c19.86073,6.2998,30.86262,27.67378,26.67564,48.08487l-33.83869,164.966a7.55172,7.55172,0,0,0,14.74406,3.2666l29.3973-123.45874a39.99414,39.99414,0,1,1,77.81208,18.53121Z"
        ],
        "hands": [
            640,
            512,
            [],
            "f4c2",
            "M204.8 230.4c-10.6-14.1-30.7-17-44.8-6.4-14.1 10.6-17 30.7-6.4 44.8l38.1 50.8c4.8 6.4 4.1 15.3-1.5 20.9l-12.8 12.8c-6.7 6.7-17.6 6.2-23.6-1.1L64 244.4V96c0-17.7-14.3-32-32-32S0 78.3 0 96v218.4c0 10.9 3.7 21.5 10.5 30l104.1 134.3c5 6.5 8.4 13.9 10.4 21.7 1.8 6.9 8.1 11.6 15.3 11.6H272c8.8 0 16-7.2 16-16V384c0-27.7-9-54.6-25.6-76.8l-57.6-76.8zM608 64c-17.7 0-32 14.3-32 32v148.4l-89.8 107.8c-6 7.2-17 7.7-23.6 1.1l-12.8-12.8c-5.6-5.6-6.3-14.5-1.5-20.9l38.1-50.8c10.6-14.1 7.7-34.2-6.4-44.8-14.1-10.6-34.2-7.7-44.8 6.4l-57.6 76.8C361 329.4 352 356.3 352 384v112c0 8.8 7.2 16 16 16h131.7c7.1 0 13.5-4.7 15.3-11.6 2-7.8 5.4-15.2 10.4-21.7l104.1-134.3c6.8-8.5 10.5-19.1 10.5-30V96c0-17.7-14.3-32-32-32z"
        ],
        "hands-helping": [
            640,
            512,
            [],
            "f4c4",
            "M488 192H336v56c0 39.7-32.3 72-72 72s-72-32.3-72-72V126.4l-64.9 39C107.8 176.9 96 197.8 96 220.2v47.3l-80 46.2C.7 322.5-4.6 342.1 4.3 357.4l80 138.6c8.8 15.3 28.4 20.5 43.7 11.7L231.4 448H368c35.3 0 64-28.7 64-64h16c17.7 0 32-14.3 32-32v-64h8c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24zm147.7-37.4L555.7 16C546.9.7 527.3-4.5 512 4.3L408.6 64H306.4c-12 0-23.7 3.4-33.9 9.7L239 94.6c-9.4 5.8-15 16.1-15 27.1V248c0 22.1 17.9 40 40 40s40-17.9 40-40v-88h184c30.9 0 56 25.1 56 56v28.5l80-46.2c15.3-8.9 20.5-28.4 11.7-43.7z"
        ],
        "hands-wash": [
            576,
            512,
            [],
            "e05e",
            "M496,224a48,48,0,1,0-48-48A48,48,0,0,0,496,224ZM311.47,178.45A56.77,56.77,0,0,1,328,176a56,56,0,0,1,19,3.49l15.35-48.61A24,24,0,0,0,342,99.74c-11.53-1.35-22.21,6.44-25.71,17.51l-20.9,66.17ZM93.65,386.33c.8-.19,1.54-.54,2.35-.71V359.93a156,156,0,0,1,107.06-148l73.7-22.76L310.92,81.05a24,24,0,0,0-20.33-31.11c-11.53-1.34-22.22,6.45-25.72,17.52L231.42,173.88a8,8,0,0,1-15.26-4.83L259.53,31.26A24,24,0,0,0,239.2.15C227.67-1.19,217,6.6,213.49,17.66L165.56,169.37a8,8,0,1,1-15.26-4.82l38.56-122a24,24,0,0,0-20.33-31.11C157,10,146.32,17.83,142.82,28.9l-60,189.85L80.76,168.7A24,24,0,0,0,56.9,144.55c-13.23-.05-24.72,10.54-24.9,23.86V281.14A123.69,123.69,0,0,0,93.65,386.33ZM519.1,336H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,279.84,498.71,272,487.1,272H288l47.09-17.06a24,24,0,0,0-14.18-45.88L213.19,242.31A123.88,123.88,0,0,0,128,360v25.65a79.78,79.78,0,0,1,58,108.63A118.9,118.9,0,0,0,248,512H456a24,24,0,0,0,23.54-28.76C477.35,471.84,466.71,464,455.1,464H360a8,8,0,0,1,0-16H488a24,24,0,0,0,23.54-28.76C509.35,407.84,498.71,400,487.1,400H360a8,8,0,0,1,0-16H520a24,24,0,0,0,23.54-28.76C541.35,343.84,530.71,336,519.1,336ZM416,64a32,32,0,1,0-32-32A32,32,0,0,0,416,64ZM112,416a48,48,0,1,0,48,48A48,48,0,0,0,112,416Z"
        ],
        "handshake": [
            640,
            512,
            [],
            "f2b5",
            "M434.7 64h-85.9c-8 0-15.7 3-21.6 8.4l-98.3 90c-.1.1-.2.3-.3.4-16.6 15.6-16.3 40.5-2.1 56 12.7 13.9 39.4 17.6 56.1 2.7.1-.1.3-.1.4-.2l79.9-73.2c6.5-5.9 16.7-5.5 22.6 1 6 6.5 5.5 16.6-1 22.6l-26.1 23.9L504 313.8c2.9 2.4 5.5 5 7.9 7.7V128l-54.6-54.6c-5.9-6-14.1-9.4-22.6-9.4zM544 128.2v223.9c0 17.7 14.3 32 32 32h64V128.2h-96zm48 223.9c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM0 384h64c17.7 0 32-14.3 32-32V128.2H0V384zm48-63.9c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16c0-8.9 7.2-16 16-16zm435.9 18.6L334.6 217.5l-30 27.5c-29.7 27.1-75.2 24.5-101.7-4.4-26.9-29.4-24.8-74.9 4.4-101.7L289.1 64h-83.8c-8.5 0-16.6 3.4-22.6 9.4L128 128v223.9h18.3l90.5 81.9c27.4 22.3 67.7 18.1 90-9.3l.2-.2 17.9 15.5c15.9 13 39.4 10.5 52.3-5.4l31.4-38.6 5.4 4.4c13.7 11.1 33.9 9.1 45-4.7l9.5-11.7c11.2-13.8 9.1-33.9-4.6-45.1z"
        ],
        "handshake-alt-slash": [
            640,
            512,
            [],
            "e05f",
            "M358.59,195.6,504.2,313.8a63.4,63.4,0,0,1,22.21,37.91H624a16.05,16.05,0,0,0,16-16V143.91A16,16,0,0,0,624,128H512L457.41,73.41A32,32,0,0,0,434.8,64H348.91a32,32,0,0,0-21.61,8.41l-88.12,80.68-25.69-19.85L289.09,64H205.3a32,32,0,0,0-22.6,9.41l-20.34,20.3L45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.54,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45L303.4,202.72l32.69-29.92,27-24.7a16,16,0,0,1,21.61,23.61ZM16,128A16.05,16.05,0,0,0,0,144V335.91a16,16,0,0,0,16,16H146.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L23.56,128Z"
        ],
        "handshake-slash": [
            640,
            512,
            [],
            "e060",
            "M0,128.21V384H64a32,32,0,0,0,32-32V184L23.83,128.21ZM48,320.1a16,16,0,1,1-16,16A16,16,0,0,1,48,320.1Zm80,31.81h18.3l90.5,81.89a64,64,0,0,0,90-9.3l.2-.2,17.91,15.5a37.16,37.16,0,0,0,52.29-5.39l8.8-10.82L128,208.72Zm416-223.7V352.1a32,32,0,0,0,32,32h64V128.21ZM592,352.1a16,16,0,1,1,16-16A16,16,0,0,1,592,352.1ZM303.33,202.67l59.58-54.57a16,16,0,0,1,21.59,23.61L358.41,195.6,504,313.8a73.08,73.08,0,0,1,7.91,7.7V128L457.3,73.41A31.76,31.76,0,0,0,434.7,64H348.8a31.93,31.93,0,0,0-21.6,8.41l-88.07,80.64-25.64-19.81L289.09,64H205.3a32,32,0,0,0-22.6,9.41L162.36,93.72,45.47,3.38A16,16,0,0,0,23,6.19L3.38,31.46A16,16,0,0,0,6.19,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.65-25.27a16,16,0,0,0-2.82-22.45Z"
        ],
        "hanukiah": [
            640,
            512,
            [],
            "f6e6",
            "M232 160c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm-64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm224 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm64 0c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm88 8c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v120h32V168zm-440-8c-4.42 0-8 3.58-8 8v120h32V168c0-4.42-3.58-8-8-8h-16zm520 0h-32c-8.84 0-16 7.16-16 16v112c0 17.67-14.33 32-32 32H352V128c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v192H96c-17.67 0-32-14.33-32-32V176c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v112c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V176c0-8.84-7.16-16-16-16zm-16-32c13.25 0 24-11.94 24-26.67S608 48 608 48s-24 38.61-24 53.33S594.75 128 608 128zm-576 0c13.25 0 24-11.94 24-26.67S32 48 32 48 8 86.61 8 101.33 18.75 128 32 128zm288-48c13.25 0 24-11.94 24-26.67S320 0 320 0s-24 38.61-24 53.33S306.75 80 320 80zm-208 48c13.25 0 24-11.94 24-26.67S112 48 112 48s-24 38.61-24 53.33S98.75 128 112 128zm64 0c13.25 0 24-11.94 24-26.67S176 48 176 48s-24 38.61-24 53.33S162.75 128 176 128zm64 0c13.25 0 24-11.94 24-26.67S240 48 240 48s-24 38.61-24 53.33S226.75 128 240 128zm160 0c13.25 0 24-11.94 24-26.67S400 48 400 48s-24 38.61-24 53.33S386.75 128 400 128zm64 0c13.25 0 24-11.94 24-26.67S464 48 464 48s-24 38.61-24 53.33S450.75 128 464 128zm64 0c13.25 0 24-11.94 24-26.67S528 48 528 48s-24 38.61-24 53.33S514.75 128 528 128z"
        ],
        "hard-hat": [
            512,
            512,
            [],
            "f807",
            "M480 288c0-80.25-49.28-148.92-119.19-177.62L320 192V80a16 16 0 0 0-16-16h-96a16 16 0 0 0-16 16v112l-40.81-81.62C81.28 139.08 32 207.75 32 288v64h448zm16 96H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
        ],
        "hashtag": [
            448,
            512,
            [],
            "f292",
            "M440.667 182.109l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l14.623-81.891C377.123 38.754 371.468 32 363.997 32h-40.632a12 12 0 0 0-11.813 9.891L296.175 128H197.54l14.623-81.891C213.477 38.754 207.822 32 200.35 32h-40.632a12 12 0 0 0-11.813 9.891L132.528 128H53.432a12 12 0 0 0-11.813 9.891l-7.143 40C33.163 185.246 38.818 192 46.289 192h74.81L98.242 320H19.146a12 12 0 0 0-11.813 9.891l-7.143 40C-1.123 377.246 4.532 384 12.003 384h74.81L72.19 465.891C70.877 473.246 76.532 480 84.003 480h40.632a12 12 0 0 0 11.813-9.891L151.826 384h98.634l-14.623 81.891C234.523 473.246 240.178 480 247.65 480h40.632a12 12 0 0 0 11.813-9.891L315.472 384h79.096a12 12 0 0 0 11.813-9.891l7.143-40c1.313-7.355-4.342-14.109-11.813-14.109h-74.81l22.857-128h79.096a12 12 0 0 0 11.813-9.891zM261.889 320h-98.634l22.857-128h98.634l-22.857 128z"
        ],
        "hat-cowboy": [
            640,
            512,
            [],
            "f8c0",
            "M490 296.9C480.51 239.51 450.51 64 392.3 64c-14 0-26.49 5.93-37 14a58.21 58.21 0 0 1-70.58 0c-10.51-8-23-14-37-14-58.2 0-88.2 175.47-97.71 232.88C188.81 309.47 243.73 320 320 320s131.23-10.51 170-23.1zm142.9-37.18a16 16 0 0 0-19.75 1.5c-1 .9-101.27 90.78-293.16 90.78-190.82 0-292.22-89.94-293.24-90.84A16 16 0 0 0 1 278.53C1.73 280.55 78.32 480 320 480s318.27-199.45 319-201.47a16 16 0 0 0-6.09-18.81z"
        ],
        "hat-cowboy-side": [
            640,
            512,
            [],
            "f8c1",
            "M260.8 291.06c-28.63-22.94-62-35.06-96.4-35.06C87 256 21.47 318.72 1.43 412.06c-3.55 16.6-.43 33.83 8.57 47.3C18.75 472.47 31.83 480 45.88 480H592c-103.21 0-155-37.07-233.19-104.46zm234.65-18.29L468.4 116.2A64 64 0 0 0 392 64.41L200.85 105a64 64 0 0 0-50.35 55.79L143.61 226c6.9-.83 13.7-2 20.79-2 41.79 0 82 14.55 117.29 42.82l98 84.48C450.76 412.54 494.9 448 592 448a48 48 0 0 0 48-48c0-25.39-29.6-119.33-144.55-127.23z"
        ],
        "hat-wizard": [
            512,
            512,
            [],
            "f6e8",
            "M496 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-304-64l-64-32 64-32 32-64 32 64 64 32-64 32-16 32h208l-86.41-201.63a63.955 63.955 0 0 1-1.89-45.45L416 0 228.42 107.19a127.989 127.989 0 0 0-53.46 59.15L64 416h144l-16-32zm64-224l16-32 16 32 32 16-32 16-16 32-16-32-32-16 32-16z"
        ],
        "hdd": [
            576,
            512,
            [],
            "f0a0",
            "M576 304v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48zm-48-80a79.557 79.557 0 0 1 30.777 6.165L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L17.223 230.165A79.557 79.557 0 0 1 48 224h480zm-48 96c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32zm-96 0c-17.673 0-32 14.327-32 32s14.327 32 32 32 32-14.327 32-32-14.327-32-32-32z"
        ],
        "head-side-cough": [
            640,
            512,
            [],
            "e061",
            "M616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304ZM552,416a24,24,0,1,0,24,24A24,24,0,0,0,552,416Zm-64-56a24,24,0,1,0,24,24A24,24,0,0,0,488,360ZM616,464a24,24,0,1,0,24,24A24,24,0,0,0,616,464Zm0-104a24,24,0,1,0,24,24A24,24,0,0,0,616,360Zm-64-40a24,24,0,1,0,24,24A24,24,0,0,0,552,320Zm-74.78-45c-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192C86,0,0,86,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320a32,32,0,0,1,0-64h96V320h32A32,32,0,0,0,477.22,275ZM288,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,288,224Z"
        ],
        "head-side-cough-slash": [
            640,
            512,
            [],
            "e062",
            "M454.11,319.21c19.56-3.81,31.62-25,23.11-44.21-21-47.12-48.5-151.75-73.12-186.75A208.13,208.13,0,0,0,234.1,0H192A190.64,190.64,0,0,0,84.18,33.3L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45ZM313.39,210.45,263.61,172c5.88-7.14,14.43-12,24.36-12a32.06,32.06,0,0,1,32,32C320,199,317.24,205.17,313.39,210.45ZM616,304a24,24,0,1,0-24-24A24,24,0,0,0,616,304Zm-64,64a24,24,0,1,0-24-24A24,24,0,0,0,552,368ZM288,384a32,32,0,0,1,32-32h19.54L20.73,105.59A190.86,190.86,0,0,0,0,192c0,56.75,24.75,107.62,64,142.88V512H288V480h64a64,64,0,0,0,64-64H320A32,32,0,0,1,288,384Zm328-24a24,24,0,1,0,24,24A24,24,0,0,0,616,360Z"
        ],
        "head-side-mask": [
            512,
            512,
            [],
            "e063",
            "M.15,184.42C-2.17,244.21,23,298.06,64,334.88V512H224V316.51L3.67,156.25A182.28,182.28,0,0,0,.15,184.42ZM509.22,275c-21-47.12-48.5-151.75-73.12-186.75A208.11,208.11,0,0,0,266.11,0H200C117,0,42.48,50.57,13.25,123.65L239.21,288H511.76A31.35,31.35,0,0,0,509.22,275ZM320,224a32,32,0,1,1,32-32A32.07,32.07,0,0,1,320,224Zm16,144H496l16-48H256V512H401.88a64,64,0,0,0,60.71-43.76L464,464H336a16,16,0,0,1,0-32H474.67l10.67-32H336a16,16,0,0,1,0-32Z"
        ],
        "head-side-virus": [
            512,
            512,
            [],
            "e064",
            "M272,240a16,16,0,1,0,16,16A16,16,0,0,0,272,240Zm-64-64a16,16,0,1,0,16,16A16,16,0,0,0,208,176Zm301.2,99c-20.93-47.12-48.43-151.73-73.07-186.75A207.9,207.9,0,0,0,266.09,0H192C86,0,0,86,0,192A191.23,191.23,0,0,0,64,334.81V512H320V448h64a64,64,0,0,0,64-64V320H480A32,32,0,0,0,509.2,275ZM368,240H355.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C290.47,297.09,256,311.37,256,339.88V352a16,16,0,0,1-32,0V339.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H112a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V96a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C313.09,173.53,327.37,208,355.88,208H368a16,16,0,0,1,0,32Z"
        ],
        "heading": [
            512,
            512,
            [],
            "f1dc",
            "M448 96v320h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H320a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V288H160v128h32a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H32a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h32V96H32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16h-32v128h192V96h-32a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h160a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16z"
        ],
        "headphones": [
            512,
            512,
            [],
            "f025",
            "M256 32C114.52 32 0 146.496 0 288v48a32 32 0 0 0 17.689 28.622l14.383 7.191C34.083 431.903 83.421 480 144 480h24c13.255 0 24-10.745 24-24V280c0-13.255-10.745-24-24-24h-24c-31.342 0-59.671 12.879-80 33.627V288c0-105.869 86.131-192 192-192s192 86.131 192 192v1.627C427.671 268.879 399.342 256 368 256h-24c-13.255 0-24 10.745-24 24v176c0 13.255 10.745 24 24 24h24c60.579 0 109.917-48.098 111.928-108.187l14.382-7.191A32 32 0 0 0 512 336v-48c0-141.479-114.496-256-256-256z"
        ],
        "headphones-alt": [
            512,
            512,
            [],
            "f58f",
            "M160 288h-16c-35.35 0-64 28.7-64 64.12v63.76c0 35.41 28.65 64.12 64 64.12h16c17.67 0 32-14.36 32-32.06V320.06c0-17.71-14.33-32.06-32-32.06zm208 0h-16c-17.67 0-32 14.35-32 32.06v127.88c0 17.7 14.33 32.06 32 32.06h16c35.35 0 64-28.71 64-64.12v-63.76c0-35.41-28.65-64.12-64-64.12zM256 32C112.91 32 4.57 151.13 0 288v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288c0-114.67 93.33-207.8 208-207.82 114.67.02 208 93.15 208 207.82v112c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V288C507.43 151.13 399.09 32 256 32z"
        ],
        "headset": [
            512,
            512,
            [],
            "f590",
            "M192 208c0-17.67-14.33-32-32-32h-16c-35.35 0-64 28.65-64 64v48c0 35.35 28.65 64 64 64h16c17.67 0 32-14.33 32-32V208zm176 144c35.35 0 64-28.65 64-64v-48c0-35.35-28.65-64-64-64h-16c-17.67 0-32 14.33-32 32v112c0 17.67 14.33 32 32 32h16zM256 0C113.18 0 4.58 118.83 0 256v16c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-16c0-114.69 93.31-208 208-208s208 93.31 208 208h-.12c.08 2.43.12 165.72.12 165.72 0 23.35-18.93 42.28-42.28 42.28H320c0-26.51-21.49-48-48-48h-32c-26.51 0-48 21.49-48 48s21.49 48 48 48h181.72c49.86 0 90.28-40.42 90.28-90.28V256C507.42 118.83 398.82 0 256 0z"
        ],
        "heart": [
            512,
            512,
            [],
            "f004",
            "M462.3 62.6C407.5 15.9 326 24.3 275.7 76.2L256 96.5l-19.7-20.3C186.1 24.3 104.5 15.9 49.7 62.6c-62.8 53.6-66.1 149.8-9.9 207.9l193.5 199.8c12.5 12.9 32.8 12.9 45.3 0l193.5-199.8c56.3-58.1 53-154.3-9.8-207.9z"
        ],
        "heart-broken": [
            512,
            512,
            [],
            "f7a9",
            "M473.7 73.8l-2.4-2.5c-46-47-118-51.7-169.6-14.8L336 159.9l-96 64 48 128-144-144 96-64-28.6-86.5C159.7 19.6 87 24 40.7 71.4l-2.4 2.4C-10.4 123.6-12.5 202.9 31 256l212.1 218.6c7.1 7.3 18.6 7.3 25.7 0L481 255.9c43.5-53 41.4-132.3-7.3-182.1z"
        ],
        "heartbeat": [
            512,
            512,
            [],
            "f21e",
            "M320.2 243.8l-49.7 99.4c-6 12.1-23.4 11.7-28.9-.6l-56.9-126.3-30 71.7H60.6l182.5 186.5c7.1 7.3 18.6 7.3 25.7 0L451.4 288H342.3l-22.1-44.2zM473.7 73.9l-2.4-2.5c-51.5-52.6-135.8-52.6-187.4 0L256 100l-27.9-28.5c-51.5-52.7-135.9-52.7-187.4 0l-2.4 2.4C-10.4 123.7-12.5 203 31 256h102.4l35.9-86.2c5.4-12.9 23.6-13.2 29.4-.4l58.2 129.3 49-97.9c5.9-11.8 22.7-11.8 28.6 0l27.6 55.2H481c43.5-53 41.4-132.3-7.3-182.1z"
        ],
        "helicopter": [
            640,
            512,
            [],
            "f533",
            "M304 384h272c17.67 0 32-14.33 32-32 0-123.71-100.29-224-224-224V64h176c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H144c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h176v64H112L68.8 70.4C65.78 66.37 61.03 64 56 64H16.01C5.6 64-2.04 73.78.49 83.88L32 192l160 64 86.4 115.2A31.992 31.992 0 0 0 304 384zm112-188.49C478.55 208.3 528.03 257.44 540.79 320H416V195.51zm219.37 263.3l-22.15-22.2c-6.25-6.26-16.24-6.1-22.64.01-7.09 6.77-13.84 11.25-24.64 11.25H240c-8.84 0-16 7.18-16 16.03v32.06c0 8.85 7.16 16.03 16 16.03h325.94c14.88 0 35.3-.47 68.45-29.52 7.02-6.14 7.57-17.05.98-23.66z"
        ],
        "highlighter": [
            544,
            512,
            [],
            "f591",
            "M0 479.98L99.92 512l35.45-35.45-67.04-67.04L0 479.98zm124.61-240.01a36.592 36.592 0 0 0-10.79 38.1l13.05 42.83-50.93 50.94 96.23 96.23 50.86-50.86 42.74 13.08c13.73 4.2 28.65-.01 38.15-10.78l35.55-41.64-173.34-173.34-41.52 35.44zm403.31-160.7l-63.2-63.2c-20.49-20.49-53.38-21.52-75.12-2.35L190.55 183.68l169.77 169.78L530.27 154.4c19.18-21.74 18.15-54.63-2.35-75.13z"
        ],
        "hiking": [
            384,
            512,
            [],
            "f6ec",
            "M80.95 472.23c-4.28 17.16 6.14 34.53 23.28 38.81 2.61.66 5.22.95 7.8.95 14.33 0 27.37-9.7 31.02-24.23l25.24-100.97-52.78-52.78-34.56 138.22zm14.89-196.12L137 117c2.19-8.42-3.14-16.95-11.92-19.06-43.88-10.52-88.35 15.07-99.32 57.17L.49 253.24c-2.19 8.42 3.14 16.95 11.92 19.06l63.56 15.25c8.79 2.1 17.68-3.02 19.87-11.44zM368 160h-16c-8.84 0-16 7.16-16 16v16h-34.75l-46.78-46.78C243.38 134.11 228.61 128 212.91 128c-27.02 0-50.47 18.3-57.03 44.52l-26.92 107.72a32.012 32.012 0 0 0 8.42 30.39L224 397.25V480c0 17.67 14.33 32 32 32s32-14.33 32-32v-82.75c0-17.09-6.66-33.16-18.75-45.25l-46.82-46.82c.15-.5.49-.89.62-1.41l19.89-79.57 22.43 22.43c6 6 14.14 9.38 22.62 9.38h48v240c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16V176c.01-8.84-7.15-16-15.99-16zM240 96c26.51 0 48-21.49 48-48S266.51 0 240 0s-48 21.49-48 48 21.49 48 48 48z"
        ],
        "hippo": [
            640,
            512,
            [],
            "f6ed",
            "M581.12 96.2c-27.67-.15-52.5 17.58-76.6 26.62C489.98 88.27 455.83 64 416 64c-11.28 0-21.95 2.3-32 5.88V56c0-13.26-10.75-24-24-24h-16c-13.25 0-24 10.74-24 24v48.98C286.01 79.58 241.24 64 192 64 85.96 64 0 135.64 0 224v240c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16v-70.79C128.35 407.57 166.72 416 208 416s79.65-8.43 112-22.79V464c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V288h128v32c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-32c17.67 0 32-14.33 32-32v-92.02c0-34.09-24.79-67.59-58.88-67.78zM448 176c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
        ],
        "history": [
            512,
            512,
            [],
            "f1da",
            "M504 255.531c.253 136.64-111.18 248.372-247.82 248.468-59.015.042-113.223-20.53-155.822-54.911-11.077-8.94-11.905-25.541-1.839-35.607l11.267-11.267c8.609-8.609 22.353-9.551 31.891-1.984C173.062 425.135 212.781 440 256 440c101.705 0 184-82.311 184-184 0-101.705-82.311-184-184-184-48.814 0-93.149 18.969-126.068 49.932l50.754 50.754c10.08 10.08 2.941 27.314-11.313 27.314H24c-8.837 0-16-7.163-16-16V38.627c0-14.254 17.234-21.393 27.314-11.314l49.372 49.372C129.209 34.136 189.552 8 256 8c136.81 0 247.747 110.78 248 247.531zm-180.912 78.784l9.823-12.63c8.138-10.463 6.253-25.542-4.21-33.679L288 256.349V152c0-13.255-10.745-24-24-24h-16c-13.255 0-24 10.745-24 24v135.651l65.409 50.874c10.463 8.137 25.541 6.253 33.679-4.21z"
        ],
        "hockey-puck": [
            512,
            512,
            [],
            "f453",
            "M0 160c0-53 114.6-96 256-96s256 43 256 96-114.6 96-256 96S0 213 0 160zm0 82.2V352c0 53 114.6 96 256 96s256-43 256-96V242.2c-113.4 82.3-398.5 82.4-512 0z"
        ],
        "holly-berry": [
            448,
            512,
            [],
            "f7aa",
            "M144 192c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm112-48c0 26.5 21.5 48 48 48s48-21.5 48-48-21.5-48-48-48-48 21.5-48 48zm-32-48c26.5 0 48-21.5 48-48S250.5 0 224 0s-48 21.5-48 48 21.5 48 48 48zm-16.2 139.1c.1-12.4-13.1-20.1-23.8-13.7-34.3 20.3-71.4 32.7-108.7 36.2-9.7.9-15.6 11.3-11.6 20.2 6.2 13.9 11.1 28.6 14.7 43.8 3.6 15.2-5.3 30.6-20.2 35.1-14.9 4.5-30.1 7.6-45.3 9.1-9.7 1-15.7 11.3-11.7 20.2 15 32.8 22.9 69.5 23 107.7.1 14.4 15.2 23.1 27.6 16 33.2-19 68.9-30.5 104.8-33.9 9.7-.9 15.6-11.3 11.6-20.2-6.2-13.9-11.1-28.6-14.7-43.8-3.6-15.2 5.3-30.6 20.2-35.1 14.9-4.5 30.1-7.6 45.3-9.1 9.7-1 15.7-11.3 11.7-20.2-15.5-34.2-23.3-72.5-22.9-112.3zM435 365.6c-15.2-1.6-30.3-4.7-45.3-9.1-14.9-4.5-23.8-19.9-20.2-35.1 3.6-15.2 8.5-29.8 14.7-43.8 4-8.9-1.9-19.3-11.6-20.2-37.3-3.5-74.4-15.9-108.7-36.2-10.7-6.3-23.9 1.4-23.8 13.7 0 1.6-.2 3.2-.2 4.9.2 33.3 7 65.7 19.9 94 5.7 12.4 5.2 26.6-.6 38.9 4.9 1.2 9.9 2.2 14.8 3.7 14.9 4.5 23.8 19.9 20.2 35.1-3.6 15.2-8.5 29.8-14.7 43.8-4 8.9 1.9 19.3 11.6 20.2 35.9 3.4 71.6 14.9 104.8 33.9 12.5 7.1 27.6-1.6 27.6-16 .2-38.2 8-75 23-107.7 4.3-8.7-1.8-19.1-11.5-20.1z"
        ],
        "home": [
            576,
            512,
            [],
            "f015",
            "M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"
        ],
        "horse": [
            576,
            512,
            [],
            "f6f0",
            "M575.92 76.6c-.01-8.13-3.02-15.87-8.58-21.8-3.78-4.03-8.58-9.12-13.69-14.5 11.06-6.84 19.5-17.49 22.18-30.66C576.85 4.68 572.96 0 567.9 0H447.92c-70.69 0-128 57.31-128 128H160c-28.84 0-54.4 12.98-72 33.11V160c-48.53 0-88 39.47-88 88v56c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-56c0-13.22 6.87-24.39 16.78-31.68-.21 2.58-.78 5.05-.78 7.68 0 27.64 11.84 52.36 30.54 69.88l-25.72 68.6a63.945 63.945 0 0 0-2.16 37.99l24.85 99.41A15.982 15.982 0 0 0 107.02 512h65.96c10.41 0 18.05-9.78 15.52-19.88l-26.31-105.26 23.84-63.59L320 345.6V496c0 8.84 7.16 16 16 16h64c8.84 0 16-7.16 16-16V318.22c19.74-20.19 32-47.75 32-78.22 0-.22-.07-.42-.08-.64V136.89l16 7.11 18.9 37.7c7.45 14.87 25.05 21.55 40.49 15.37l32.55-13.02a31.997 31.997 0 0 0 20.12-29.74l-.06-77.71zm-64 19.4c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16z"
        ],
        "horse-head": [
            512,
            512,
            [],
            "f7ab",
            "M509.8 332.5l-69.9-164.3c-14.9-41.2-50.4-71-93-79.2 18-10.6 46.3-35.9 34.2-82.3-1.3-5-7.1-7.9-12-6.1L166.9 76.3C35.9 123.4 0 238.9 0 398.8V480c0 17.7 14.3 32 32 32h236.2c23.8 0 39.3-25 28.6-46.3L256 384v-.7c-45.6-3.5-84.6-30.7-104.3-69.6-1.6-3.1-.9-6.9 1.6-9.3l12.1-12.1c3.9-3.9 10.6-2.7 12.9 2.4 14.8 33.7 48.2 57.4 87.4 57.4 17.2 0 33-5.1 46.8-13.2l46 63.9c6 8.4 15.7 13.3 26 13.3h50.3c8.5 0 16.6-3.4 22.6-9.4l45.3-39.8c8.9-9.1 11.7-22.6 7.1-34.4zM328 224c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24-10.7 24-24 24z"
        ],
        "hospital": [
            448,
            512,
            [],
            "f0f8",
            "M448 492v20H0v-20c0-6.627 5.373-12 12-12h20V120c0-13.255 10.745-24 24-24h88V24c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v72h88c13.255 0 24 10.745 24 24v360h20c6.627 0 12 5.373 12 12zM308 192h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-168 64h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm104 128h-40c-6.627 0-12 5.373-12 12v84h64v-84c0-6.627-5.373-12-12-12zm64-96h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12zm-116 12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40zM182 96h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V96h26a6 6 0 0 0 6-6V70a6 6 0 0 0-6-6h-26V38a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6z"
        ],
        "hospital-alt": [
            576,
            512,
            [],
            "f47d",
            "M544 96H416V32c0-17.7-14.3-32-32-32H192c-17.7 0-32 14.3-32 32v64H32c-17.7 0-32 14.3-32 32v368c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16V128c0-17.7-14.3-32-32-32zM160 436c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm160 128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm16-170c0 3.3-2.7 6-6 6h-26v26c0 3.3-2.7 6-6 6h-20c-3.3 0-6-2.7-6-6v-26h-26c-3.3 0-6-2.7-6-6v-20c0-3.3 2.7-6 6-6h26V86c0-3.3 2.7-6 6-6h20c3.3 0 6 2.7 6 6v26h26c3.3 0 6 2.7 6 6v20zm144 298c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40zm0-128c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40z"
        ],
        "hospital-symbol": [
            512,
            512,
            [],
            "f47e",
            "M256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm112 376c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-88h-96v88c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V136c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v88h96v-88c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v240z"
        ],
        "hospital-user": [
            640,
            512,
            [],
            "f80d",
            "M480 320a96 96 0 1 0-96-96 96 96 0 0 0 96 96zm48 32a22.88 22.88 0 0 0-7.06 1.09 124.76 124.76 0 0 1-81.89 0A22.82 22.82 0 0 0 432 352a112 112 0 0 0-112 112.62c.14 26.26 21.73 47.38 48 47.38h224c26.27 0 47.86-21.12 48-47.38A112 112 0 0 0 528 352zm-198.09 10.45A145.19 145.19 0 0 1 352 344.62V128a32 32 0 0 0-32-32h-32V32a32 32 0 0 0-32-32H96a32 32 0 0 0-32 32v64H32a32 32 0 0 0-32 32v368a16 16 0 0 0 16 16h288.31A78.62 78.62 0 0 1 288 464.79a143.06 143.06 0 0 1 41.91-102.34zM144 404a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12H92a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm48-122a6 6 0 0 1-6 6h-20a6 6 0 0 1-6-6v-26h-26a6 6 0 0 1-6-6v-20a6 6 0 0 1 6-6h26V70a6 6 0 0 1 6-6h20a6 6 0 0 1 6 6v26h26a6 6 0 0 1 6 6v20a6 6 0 0 1-6 6h-26zm80 250a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12zm0-128a12 12 0 0 1-12 12h-40a12 12 0 0 1-12-12v-40a12 12 0 0 1 12-12h40a12 12 0 0 1 12 12z"
        ],
        "hot-tub": [
            512,
            512,
            [],
            "f593",
            "M414.21 177.65c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C378.96 6.14 372.22 0 364.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zm-108 0c1.02 8.21 7.75 14.35 15.75 14.35h16.12c9.51 0 17.08-8.57 16-18.35-4.34-39.11-22.4-74.53-50.13-97.16-17.37-14.17-28.82-36.75-31.98-62.15C270.96 6.14 264.22 0 256.23 0h-16.12c-9.51 0-17.09 8.57-16 18.35 4.34 39.11 22.4 74.53 50.13 97.16 17.36 14.17 28.82 36.75 31.97 62.14zM480 256H256l-110.93-83.2a63.99 63.99 0 0 0-38.4-12.8H64c-35.35 0-64 28.65-64 64v224c0 35.35 28.65 64 64 64h384c35.35 0 64-28.65 64-64V288c0-17.67-14.33-32-32-32zM128 440c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zm96 0c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8V328c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v112zM64 128c35.35 0 64-28.65 64-64S99.35 0 64 0 0 28.65 0 64s28.65 64 64 64z"
        ],
        "hotdog": [
            512,
            512,
            [],
            "f80f",
            "M488.56 23.44a80 80 0 0 0-113.12 0l-352 352a80 80 0 1 0 113.12 113.12l352-352a80 80 0 0 0 0-113.12zm-49.93 95.19c-19.6 19.59-37.52 22.67-51.93 25.14C373.76 146 364.4 147.6 352 160s-14 21.76-16.23 34.71c-2.48 14.4-5.55 32.33-25.15 51.92s-37.52 22.67-51.92 25.15C245.75 274 236.4 275.6 224 288s-14 21.75-16.23 34.7c-2.47 14.4-5.54 32.33-25.14 51.92s-37.53 22.68-51.93 25.15C117.76 402 108.4 403.6 96 416a16 16 0 0 1-22.63-22.63c19.6-19.59 37.52-22.67 51.92-25.14 13-2.22 22.3-3.82 34.71-16.23s14-21.75 16.22-34.7c2.48-14.4 5.55-32.33 25.15-51.92s37.52-22.67 51.92-25.14c13-2.22 22.3-3.83 34.7-16.23s14-21.76 16.24-34.71c2.47-14.4 5.54-32.33 25.14-51.92s37.52-22.68 51.92-25.15C394.24 110 403.59 108.41 416 96a16 16 0 0 1 22.63 22.63zM31.44 322.18L322.18 31.44l-11.54-11.55c-25-25-63.85-26.66-86.79-3.72L16.17 223.85c-22.94 22.94-21.27 61.79 3.72 86.78zm449.12-132.36L189.82 480.56l11.54 11.55c25 25 63.85 26.66 86.79 3.72l207.68-207.68c22.94-22.94 21.27-61.79-3.72-86.79z"
        ],
        "hotel": [
            576,
            512,
            [],
            "f594",
            "M560 64c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h15.98v384H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h240v-80c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v80h240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-16V64h16zm-304 44.8c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm0 96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zm-128-96c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4zM179.2 256h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4c0 6.4-6.4 12.8-12.8 12.8zM192 384c0-53.02 42.98-96 96-96s96 42.98 96 96H192zm256-140.8c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4zm0-96c0 6.4-6.4 12.8-12.8 12.8h-38.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h38.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"
        ],
        "hourglass": [
            384,
            512,
            [],
            "f254",
            "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64z"
        ],
        "hourglass-end": [
            384,
            512,
            [],
            "f253",
            "M360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64zM192 208c-57.787 0-104-66.518-104-144h208c0 77.945-46.51 144-104 144z"
        ],
        "hourglass-half": [
            384,
            512,
            [],
            "f252",
            "M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-75.078 384H99.08c17.059-46.797 52.096-80 92.92-80 40.821 0 75.862 33.196 92.922 80zm.019-256H99.078C91.988 108.548 88 86.748 88 64h208c0 22.805-3.987 44.587-11.059 64z"
        ],
        "hourglass-start": [
            384,
            512,
            [],
            "f251",
            "M360 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24 0 90.965 51.016 167.734 120.842 192C75.016 280.266 24 357.035 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24 0-90.965-51.016-167.734-120.842-192C308.984 231.734 360 154.965 360 64c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24zm-64 448H88c0-77.458 46.204-144 104-144 57.786 0 104 66.517 104 144z"
        ],
        "house-damage": [
            576,
            512,
            [],
            "f6f1",
            "M288 114.96L69.47 307.71c-1.62 1.46-3.69 2.14-5.47 3.35V496c0 8.84 7.16 16 16 16h149.23L192 439.19l104.11-64-60.16-119.22L384 392.75l-104.11 64L319.81 512H496c8.84 0 16-7.16 16-16V311.1c-1.7-1.16-3.72-1.82-5.26-3.2L288 114.96zm282.69 121.32L512 184.45V48c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v51.69L314.75 10.31C307.12 3.45 297.56.01 288 0s-19.1 3.41-26.7 10.27L5.31 236.28c-6.57 5.91-7.12 16.02-1.21 22.6l21.4 23.82c5.9 6.57 16.02 7.12 22.6 1.21L277.42 81.63c6.05-5.33 15.12-5.33 21.17 0L527.91 283.9c6.57 5.9 16.69 5.36 22.6-1.21l21.4-23.82c5.9-6.57 5.36-16.69-1.22-22.59z"
        ],
        "house-user": [
            576,
            512,
            [],
            "e065",
            "M570.69,236.27,512,184.44V48a16,16,0,0,0-16-16H432a16,16,0,0,0-16,16V99.67L314.78,10.3C308.5,4.61,296.53,0,288,0s-20.46,4.61-26.74,10.3l-256,226A18.27,18.27,0,0,0,0,248.2a18.64,18.64,0,0,0,4.09,10.71L25.5,282.7a21.14,21.14,0,0,0,12,5.3,21.67,21.67,0,0,0,10.69-4.11l15.9-14V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V269.88l15.91,14A21.94,21.94,0,0,0,538.63,288a20.89,20.89,0,0,0,11.87-5.31l21.41-23.81A21.64,21.64,0,0,0,576,248.19,21,21,0,0,0,570.69,236.27ZM288,176a64,64,0,1,1-64,64A64,64,0,0,1,288,176ZM400,448H176a16,16,0,0,1-16-16,96,96,0,0,1,96-96h64a96,96,0,0,1,96,96A16,16,0,0,1,400,448Z"
        ],
        "hryvnia": [
            384,
            512,
            [],
            "f6f2",
            "M368 240c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-41.86c13.41-28.63 13.74-63.33-4.13-94.05C303.34 49.84 267.1 32 229.96 32h-78.82c-24.32 0-47.86 8.53-66.54 24.09L72.83 65.9c-10.18 8.49-11.56 23.62-3.07 33.8l20.49 24.59c8.49 10.19 23.62 11.56 33.81 3.07l11.73-9.78c4.32-3.6 9.77-5.57 15.39-5.57h83.62c11.69 0 21.2 9.52 21.2 21.2 0 5.91-2.48 11.58-6.81 15.58L219.7 176H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h134.37l-34.67 32H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h41.86c-13.41 28.63-13.74 63.33 4.13 94.05C80.66 462.15 116.9 480 154.04 480h78.82c24.32 0 47.86-8.53 66.54-24.09l11.77-9.81c10.18-8.49 11.56-23.62 3.07-33.8l-20.49-24.59c-8.49-10.19-23.62-11.56-33.81-3.07l-11.75 9.8a23.992 23.992 0 0 1-15.36 5.56H149.2c-11.69 0-21.2-9.52-21.2-21.2 0-5.91 2.48-11.58 6.81-15.58L164.3 336H368c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H233.63l34.67-32H368z"
        ],
        "i-cursor": [
            256,
            512,
            [],
            "f246",
            "M256 52.048V12.065C256 5.496 250.726.148 244.158.066 211.621-.344 166.469.011 128 37.959 90.266.736 46.979-.114 11.913.114 5.318.157 0 5.519 0 12.114v39.645c0 6.687 5.458 12.078 12.145 11.998C38.111 63.447 96 67.243 96 112.182V224H60c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h36v112c0 44.932-56.075 48.031-83.95 47.959C5.404 447.942 0 453.306 0 459.952v39.983c0 6.569 5.274 11.917 11.842 11.999 32.537.409 77.689.054 116.158-37.894 37.734 37.223 81.021 38.073 116.087 37.845 6.595-.043 11.913-5.405 11.913-12V460.24c0-6.687-5.458-12.078-12.145-11.998C217.889 448.553 160 444.939 160 400V288h36c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-36V112.182c0-44.932 56.075-48.213 83.95-48.142 6.646.018 12.05-5.346 12.05-11.992z"
        ],
        "ice-cream": [
            448,
            512,
            [],
            "f810",
            "M368 160h-.94a144 144 0 1 0-286.12 0H80a48 48 0 0 0 0 96h288a48 48 0 0 0 0-96zM195.38 493.69a31.52 31.52 0 0 0 57.24 0L352 288H96z"
        ],
        "icicles": [
            512,
            512,
            [],
            "f7ad",
            "M511.4 37.9C515.1 18.2 500 0 480 0H32C10.6 0-4.8 20.7 1.4 41.2l87.1 273.4c2.5 7.2 12.7 7.2 15.1 0L140 190.5l44.2 187.3c1.9 8.3 13.7 8.3 15.6 0l46.5-196.9 34.1 133.4c2.3 7.6 13 7.6 15.3 0l45.8-172.5 66.7 363.8c1.7 8.6 14 8.6 15.7 0l87.5-467.7z"
        ],
        "icons": [
            512,
            512,
            [],
            "f86d",
            "M116.65 219.35a15.68 15.68 0 0 0 22.65 0l96.75-99.83c28.15-29 26.5-77.1-4.91-103.88C203.75-7.7 163-3.5 137.86 22.44L128 32.58l-9.85-10.14C93.05-3.5 52.25-7.7 24.86 15.64c-31.41 26.78-33 74.85-5 103.88zm143.92 100.49h-48l-7.08-14.24a27.39 27.39 0 0 0-25.66-17.78h-71.71a27.39 27.39 0 0 0-25.66 17.78l-7 14.24h-48A27.45 27.45 0 0 0 0 347.3v137.25A27.44 27.44 0 0 0 27.43 512h233.14A27.45 27.45 0 0 0 288 484.55V347.3a27.45 27.45 0 0 0-27.43-27.46zM144 468a52 52 0 1 1 52-52 52 52 0 0 1-52 52zm355.4-115.9h-60.58l22.36-50.75c2.1-6.65-3.93-13.21-12.18-13.21h-75.59c-6.3 0-11.66 3.9-12.5 9.1l-16.8 106.93c-1 6.3 4.88 11.89 12.5 11.89h62.31l-24.2 83c-1.89 6.65 4.2 12.9 12.23 12.9a13.26 13.26 0 0 0 10.92-5.25l92.4-138.91c4.88-6.91-1.16-15.7-10.87-15.7zM478.08.33L329.51 23.17C314.87 25.42 304 38.92 304 54.83V161.6a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V99.66l112-17.22v47.18a83.25 83.25 0 0 0-16-1.7c-35.35 0-64 21.48-64 48s28.65 48 64 48c35.2 0 63.73-21.32 64-47.66V32c0-19.48-16-34.42-33.92-31.67z"
        ],
        "id-badge": [
            384,
            512,
            [],
            "f2c1",
            "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM144 32h96c8.8 0 16 7.2 16 16s-7.2 16-16 16h-96c-8.8 0-16-7.2-16-16s7.2-16 16-16zm48 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 416 80 407.4 80 396.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
        ],
        "id-card": [
            576,
            512,
            [],
            "f2c2",
            "M528 32H48C21.5 32 0 53.5 0 80v16h576V80c0-26.5-21.5-48-48-48zM0 432c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V128H0v304zm352-232c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zm0 64c0-4.4 3.6-8 8-8h144c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-16zM176 192c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zM67.1 396.2C75.5 370.5 99.6 352 128 352h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.9-5.2 19.8-15.6 19.8H82.7c-10.4 0-18.8-10-15.6-19.8z"
        ],
        "id-card-alt": [
            576,
            512,
            [],
            "f47f",
            "M528 64H384v96H192V64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM288 224c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm93.3 224H194.7c-10.4 0-18.8-10-15.6-19.8 8.3-25.6 32.4-44.2 60.9-44.2h8.2c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h8.2c28.4 0 52.5 18.5 60.9 44.2 3.2 9.8-5.2 19.8-15.6 19.8zM352 32c0-17.7-14.3-32-32-32h-64c-17.7 0-32 14.3-32 32v96h128V32z"
        ],
        "igloo": [
            576,
            512,
            [],
            "f7ae",
            "M320 33.9c-10.5-1.2-21.2-1.9-32-1.9-99.8 0-187.8 50.8-239.4 128H320V33.9zM96 192H30.3C11.1 230.6 0 274 0 320h96V192zM352 39.4V160h175.4C487.2 99.9 424.8 55.9 352 39.4zM480 320h96c0-46-11.1-89.4-30.3-128H480v128zm-64 64v96h128c17.7 0 32-14.3 32-32v-96H411.5c2.6 10.3 4.5 20.9 4.5 32zm32-192H128v128h49.8c22.2-38.1 63-64 110.2-64s88 25.9 110.2 64H448V192zM0 448c0 17.7 14.3 32 32 32h128v-96c0-11.1 1.9-21.7 4.5-32H0v96zm288-160c-53 0-96 43-96 96v96h192v-96c0-53-43-96-96-96z"
        ],
        "image": [
            512,
            512,
            [],
            "f03e",
            "M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z"
        ],
        "images": [
            576,
            512,
            [],
            "f302",
            "M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v208c0 44.112 35.888 80 80 80h336zm96-80V80c0-26.51-21.49-48-48-48H144c-26.51 0-48 21.49-48 48v256c0 26.51 21.49 48 48 48h384c26.51 0 48-21.49 48-48zM256 128c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-96 144l55.515-55.515c4.686-4.686 12.284-4.686 16.971 0L272 256l135.515-135.515c4.686-4.686 12.284-4.686 16.971 0L512 208v112H160v-48z"
        ],
        "inbox": [
            576,
            512,
            [],
            "f01c",
            "M567.938 243.908L462.25 85.374A48.003 48.003 0 0 0 422.311 64H153.689a48 48 0 0 0-39.938 21.374L8.062 243.908A47.994 47.994 0 0 0 0 270.533V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V270.533a47.994 47.994 0 0 0-8.062-26.625zM162.252 128h251.497l85.333 128H376l-32 64H232l-32-64H76.918l85.334-128z"
        ],
        "indent": [
            448,
            512,
            [],
            "f03c",
            "M27.31 363.3l96-96a16 16 0 0 0 0-22.62l-96-96C17.27 138.66 0 145.78 0 160v192c0 14.31 17.33 21.3 27.31 11.3zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
        ],
        "industry": [
            512,
            512,
            [],
            "f275",
            "M475.115 163.781L336 252.309v-68.28c0-18.916-20.931-30.399-36.885-20.248L160 252.309V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56v400c0 13.255 10.745 24 24 24h464c13.255 0 24-10.745 24-24V184.029c0-18.917-20.931-30.399-36.885-20.248z"
        ],
        "infinity": [
            640,
            512,
            [],
            "f534",
            "M471.1 96C405 96 353.3 137.3 320 174.6 286.7 137.3 235 96 168.9 96 75.8 96 0 167.8 0 256s75.8 160 168.9 160c66.1 0 117.8-41.3 151.1-78.6 33.3 37.3 85 78.6 151.1 78.6 93.1 0 168.9-71.8 168.9-160S564.2 96 471.1 96zM168.9 320c-40.2 0-72.9-28.7-72.9-64s32.7-64 72.9-64c38.2 0 73.4 36.1 94 64-20.4 27.6-55.9 64-94 64zm302.2 0c-38.2 0-73.4-36.1-94-64 20.4-27.6 55.9-64 94-64 40.2 0 72.9 28.7 72.9 64s-32.7 64-72.9 64z"
        ],
        "info": [
            192,
            512,
            [],
            "f129",
            "M20 424.229h20V279.771H20c-11.046 0-20-8.954-20-20V212c0-11.046 8.954-20 20-20h112c11.046 0 20 8.954 20 20v212.229h20c11.046 0 20 8.954 20 20V492c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-47.771c0-11.046 8.954-20 20-20zM96 0C56.235 0 24 32.235 24 72s32.235 72 72 72 72-32.235 72-72S135.764 0 96 0z"
        ],
        "info-circle": [
            512,
            512,
            [],
            "f05a",
            "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
        ],
        "italic": [
            320,
            512,
            [],
            "f033",
            "M320 48v32a16 16 0 0 1-16 16h-62.76l-80 320H208a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h62.76l80-320H112a16 16 0 0 1-16-16V48a16 16 0 0 1 16-16h192a16 16 0 0 1 16 16z"
        ],
        "jedi": [
            576,
            512,
            [],
            "f669",
            "M535.95308,352c-42.64069,94.17188-137.64086,160-247.9848,160q-6.39844,0-12.84377-.29688C171.15558,506.9375,81.26481,442.23438,40.01474,352H79.93668L21.3272,293.40625a264.82522,264.82522,0,0,1-5.10938-39.42187,273.6653,273.6653,0,0,1,.5-29.98438H63.93665L22.546,182.625A269.79782,269.79782,0,0,1,130.51489,20.54688a16.06393,16.06393,0,0,1,9.28127-3,16.36332,16.36332,0,0,1,13.5,7.25,16.02739,16.02739,0,0,1,1.625,15.09374,138.387,138.387,0,0,0-9.84376,51.26563c0,45.10937,21.04691,86.57813,57.71884,113.73437a16.29989,16.29989,0,0,1,1.20313,25.39063c-26.54692,23.98437-41.17194,56.5-41.17194,91.57813,0,60.03124,42.95319,110.28124,99.89079,121.92187l2.5-65.26563L238.062,397a8.33911,8.33911,0,0,1-10-.75,8.025,8.025,0,0,1-1.39063-9.9375l20.125-33.76562-42.06257-8.73438a7.9898,7.9898,0,0,1,0-15.65625l42.06257-8.71875-20.10941-33.73438a7.99122,7.99122,0,0,1,11.35939-10.71874L268.437,295.64062,279.95265,7.67188a7.97138,7.97138,0,0,1,8-7.67188h.04687a8.02064,8.02064,0,0,1,7.95314,7.70312L307.48394,295.625l30.39068-20.67188a8.08327,8.08327,0,0,1,10,.8125,7.99866,7.99866,0,0,1,1.39062,9.90626L329.12461,319.4375l42.07819,8.73438a7.99373,7.99373,0,0,1,0,15.65624l-42.07819,8.71876,20.1094,33.73437a7.97791,7.97791,0,0,1-1.32812,9.92187A8.25739,8.25739,0,0,1,337.87462,397L310.7027,378.53125l2.5,65.34375c48.48446-9.40625,87.57828-48.15625,97.31267-96.5A123.52652,123.52652,0,0,0,371.9528,230.29688a16.30634,16.30634,0,0,1,1.20313-25.42188c36.65631-27.17188,57.6876-68.60938,57.6876-113.73438a138.01689,138.01689,0,0,0-9.85939-51.3125,15.98132,15.98132,0,0,1,1.60937-15.09374,16.36914,16.36914,0,0,1,13.5-7.23438,16.02453,16.02453,0,0,1,9.25,2.98438A271.26947,271.26947,0,0,1,553.25,182.76562L511.99992,224h46.9532C559.3125,229.76562,560,235.45312,560,241.26562a270.092,270.092,0,0,1-5.125,51.85938L495.98427,352Z"
        ],
        "joint": [
            640,
            512,
            [],
            "f595",
            "M444.34 181.1c22.38 15.68 35.66 41.16 35.66 68.59V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-43.24-21.01-83.41-56.34-108.06C463.85 125.02 448 99.34 448 70.31V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v66.4c0 43.69 24.56 81.63 60.34 106.7zM194.97 358.98C126.03 370.07 59.69 394.69 0 432c83.65 52.28 180.3 80 278.94 80h88.57L254.79 380.49c-14.74-17.2-37.45-25.11-59.82-21.51zM553.28 87.09c-5.67-3.8-9.28-9.96-9.28-16.78V8c0-4.42-3.58-8-8-8h-48c-4.42 0-8 3.58-8 8v62.31c0 22.02 10.17 43.41 28.64 55.39C550.79 153.04 576 199.54 576 249.69V280c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-30.31c0-65.44-32.41-126.19-86.72-162.6zM360.89 352.05c-34.4.06-86.81.15-88.21.17l117.8 137.43A63.987 63.987 0 0 0 439.07 512h88.45L409.57 374.4a63.955 63.955 0 0 0-48.68-22.35zM616 352H432l117.99 137.65A63.987 63.987 0 0 0 598.58 512H616c13.25 0 24-10.75 24-24V376c0-13.26-10.75-24-24-24z"
        ],
        "journal-whills": [
            448,
            512,
            [],
            "f66a",
            "M438.40625,377.59375c-3.20313,12.8125-3.20313,57.60937,0,73.60937Q447.9922,460.78907,448,470.40625v16c0,16-12.79688,25.59375-25.59375,25.59375H96c-54.40625,0-96-41.59375-96-96V96C0,41.59375,41.59375,0,96,0H422.40625C438.40625,0,448,9.59375,448,25.59375v332.8125Q448,372.79688,438.40625,377.59375ZM380.79688,384H96c-16,0-32,12.79688-32,32s12.79688,32,32,32H380.79688ZM128.01562,176.01562c0,.51563.14063.98438.14063,1.5l37.10937,32.46876A7.99954,7.99954,0,0,1,160,224h-.01562a9.17678,9.17678,0,0,1-5.25-1.98438L131.14062,201.375C142.6875,250.95312,186.90625,288,240,288s97.3125-37.04688,108.875-86.625l-23.59375,20.64062a8.02516,8.02516,0,0,1-5.26563,1.96876H320a9.14641,9.14641,0,0,1-6.01562-2.71876A9.26508,9.26508,0,0,1,312,216a9.097,9.097,0,0,1,2.73438-6.01562l37.10937-32.46876c.01563-.53124.15625-1,.15625-1.51562,0-11.04688-2.09375-21.51562-5.06251-31.59375l-21.26562,21.25a8.00467,8.00467,0,0,1-11.32812-11.3125l26.42187-26.40625a111.81517,111.81517,0,0,0-46.35937-49.26562,63.02336,63.02336,0,0,1-14.0625,82.64062A55.83846,55.83846,0,0,1,251.625,254.73438l-1.42188-34.28126,12.67188,8.625a3.967,3.967,0,0,0,2.25.6875,3.98059,3.98059,0,0,0,3.43749-6.03124l-8.53124-14.3125,17.90625-3.71876a4.00647,4.00647,0,0,0,0-7.84374l-17.90625-3.71876,8.53124-14.3125a3.98059,3.98059,0,0,0-3.43749-6.03124,4.726,4.726,0,0,0-2.25.67187L248.6875,184.125,244,71.82812a4.00386,4.00386,0,0,0-8,0l-4.625,110.8125-12-8.15624a4.003,4.003,0,0,0-5.68751,5.35937l8.53126,14.3125L204.3125,197.875a3.99686,3.99686,0,0,0,0,7.82812l17.90625,3.73438-8.53126,14.29688a4.72469,4.72469,0,0,0-.56249,2.04687,4.59547,4.59547,0,0,0,1.25,2.90625,4.01059,4.01059,0,0,0,2.75,1.09375,4.09016,4.09016,0,0,0,2.25-.6875l10.35937-7.04687L228.375,254.76562a55.86414,55.86414,0,0,1-28.71875-93.45312,63.01119,63.01119,0,0,1-14.04688-82.65625,111.93158,111.93158,0,0,0-46.375,49.26563l26.42187,26.42187a7.99917,7.99917,0,0,1-11.3125,11.3125l-21.26563-21.26563C130.09375,154.48438,128,164.95312,128.01562,176.01562Z"
        ],
        "kaaba": [
            576,
            512,
            [],
            "f66b",
            "M554.12 83.51L318.36 4.93a95.962 95.962 0 0 0-60.71 0L21.88 83.51A32.006 32.006 0 0 0 0 113.87v49.01l265.02-79.51c15.03-4.5 30.92-4.5 45.98 0l265 79.51v-49.01c0-13.77-8.81-26-21.88-30.36zm-279.9 30.52L0 196.3v228.38c0 15 10.42 27.98 25.06 31.24l242.12 53.8a95.937 95.937 0 0 0 41.65 0l242.12-53.8c14.64-3.25 25.06-16.24 25.06-31.24V196.29l-274.2-82.26c-9.04-2.72-18.59-2.72-27.59 0zM128 230.11c0 3.61-2.41 6.77-5.89 7.72l-80 21.82C37.02 261.03 32 257.2 32 251.93v-16.58c0-3.61 2.41-6.77 5.89-7.72l80-21.82c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm144-39.28c0 3.61-2.41 6.77-5.89 7.72l-96 26.18c-5.09 1.39-10.11-2.44-10.11-7.72v-16.58c0-3.61 2.41-6.77 5.89-7.72l96-26.18c5.09-1.39 10.11 2.44 10.11 7.72v16.58zm176 22.7c0-5.28 5.02-9.11 10.11-7.72l80 21.82c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-80-21.82a7.997 7.997 0 0 1-5.89-7.72v-16.58zm-144-39.27c0-5.28 5.02-9.11 10.11-7.72l96 26.18c3.48.95 5.89 4.11 5.89 7.72v16.58c0 5.28-5.02 9.11-10.11 7.72l-96-26.18a7.997 7.997 0 0 1-5.89-7.72v-16.58z"
        ],
        "key": [
            512,
            512,
            [],
            "f084",
            "M512 176.001C512 273.203 433.202 352 336 352c-11.22 0-22.19-1.062-32.827-3.069l-24.012 27.014A23.999 23.999 0 0 1 261.223 384H224v40c0 13.255-10.745 24-24 24h-40v40c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-78.059c0-6.365 2.529-12.47 7.029-16.971l161.802-161.802C163.108 213.814 160 195.271 160 176 160 78.798 238.797.001 335.999 0 433.488-.001 512 78.511 512 176.001zM336 128c0 26.51 21.49 48 48 48s48-21.49 48-48-21.49-48-48-48-48 21.49-48 48z"
        ],
        "keyboard": [
            576,
            512,
            [],
            "f11c",
            "M528 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM128 180v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"
        ],
        "khanda": [
            512,
            512,
            [],
            "f66d",
            "M415.81 66c-6.37-3.5-14.37-2.33-19.36 3.02a15.974 15.974 0 0 0-1.91 19.52c16.49 26.16 25.2 56.39 25.2 87.41-.19 53.25-26.77 102.69-71.27 132.41l-76.63 53.35v-20.1l44.05-36.09c3.92-4.2 5-10.09 2.81-15.28L310.85 273c33.84-19.26 56.94-55.25 56.94-96.99 0-40.79-22.02-76.13-54.59-95.71l5.22-11.44c2.34-5.53.93-11.83-3.57-16.04L255.86 0l-58.99 52.81c-4.5 4.21-5.9 10.51-3.57 16.04l5.22 11.44c-32.57 19.58-54.59 54.93-54.59 95.72 0 41.75 23.09 77.73 56.94 96.99l-7.85 17.24c-2.19 5.18-1.1 11.07 2.81 15.28l44.05 36.09v19.9l-76.59-53.33C119.02 278.62 92.44 229.19 92.26 176c0-31.08 8.71-61.31 25.2-87.47 3.87-6.16 2.4-13.77-2.59-19.08-5-5.34-13.68-6.2-20.02-2.7C16.32 109.6-22.3 205.3 13.36 295.99c7.07 17.99 17.89 34.38 30.46 49.06l55.97 65.36c4.87 5.69 13.04 7.24 19.65 3.72l79.35-42.23L228 392.23l-47.08 32.78c-1.67-.37-3.23-1.01-5.01-1.01-13.25 0-23.99 10.74-23.99 24 0 13.25 10.74 24 23.99 24 12.1 0 21.69-9.11 23.33-20.76l40.63-28.28v29.95c-9.39 5.57-15.99 15.38-15.99 27.1 0 17.67 14.32 32 31.98 32s31.98-14.33 31.98-32c0-11.71-6.61-21.52-15.99-27.1v-30.15l40.91 28.48C314.41 462.89 324 472 336.09 472c13.25 0 23.99-10.75 23.99-24 0-13.26-10.74-24-23.99-24-1.78 0-3.34.64-5.01 1.01L284 392.23l29.21-20.34 79.35 42.23c6.61 3.52 14.78 1.97 19.65-3.71l52.51-61.31c18.87-22.02 34-47.5 41.25-75.59 21.62-83.66-16.45-167.27-90.16-207.51zm-95.99 110c0 22.3-11.49 41.92-28.83 53.38l-5.65-12.41c-8.75-24.52-8.75-51.04 0-75.56l7.83-17.18c16.07 11.65 26.65 30.45 26.65 51.77zm-127.93 0c0-21.32 10.58-40.12 26.66-51.76l7.83 17.18c8.75 24.52 8.75 51.03 0 75.56l-5.65 12.41c-17.34-11.46-28.84-31.09-28.84-53.39z"
        ],
        "kiss": [
            496,
            512,
            [],
            "f596",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm136 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm24-156c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
        ],
        "kiss-beam": [
            496,
            512,
            [],
            "f597",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-39 219.9l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5zM304 396c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-6.1-12.2 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.6-3.6-4.8-16.5 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C290.6 368.7 304 383 304 396zm65-168.1l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.5 8.5-10.9 12-15.1 4.5z"
        ],
        "kiss-wink-heart": [
            504,
            512,
            [],
            "f598",
            "M501.1 402.5c-8-20.8-31.5-31.5-53.1-25.9l-8.4 2.2-2.3-8.4c-5.9-21.4-27-36.5-49-33-25.2 4-40.6 28.6-34 52.6l22.9 82.6c1.5 5.3 7 8.5 12.4 7.1l83-21.5c24.1-6.3 37.7-31.8 28.5-55.7zm-177.6-4c-5.6-20.3-2.3-42 9-59.7 29.7-46.3 98.7-45.5 127.8 4.3 6.4.1 12.6 1.4 18.6 2.9 10.9-27.9 17.1-58.2 17.1-90C496 119 385 8 248 8S0 119 0 256s111 248 248 248c35.4 0 68.9-7.5 99.4-20.9-.3-.7-23.9-84.6-23.9-84.6zM168 240c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm120 156c0 19.2-28.7 41.5-71.5 44-8.5.8-12.1-11.8-3.6-15.4l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-6-2.5-5.7-12.3 0-14.8l17-7.2c13-5.5 20.8-13.5 20.8-21.5s-7.8-16-20.8-21.5l-17-7.2c-8.8-3.7-4.6-16.6 3.6-15.4 42.8 2.5 71.5 24.8 71.5 44 0 13-13.4 27.3-35.2 36C274.6 368.7 288 383 288 396zm16-179c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S400 181 404 206.2c1.7 11.1-11.3 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 217z"
        ],
        "kiwi-bird": [
            576,
            512,
            [],
            "f535",
            "M575.81 217.98C572.64 157.41 518.28 112 457.63 112h-9.37c-52.82 0-104.25-16.25-147.74-46.24-41.99-28.96-96.04-41.62-153.21-28.7C129.3 41.12-.08 78.24 0 224c.04 70.95 38.68 132.8 95.99 166.01V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-54.26c15.36 3.96 31.4 6.26 48 6.26 5.44 0 10.68-.73 16-1.18V464c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-59.43c14.24-5.06 27.88-11.39 40.34-19.51C342.07 355.25 393.86 336 448.46 336c25.48 0 16.01-.31 23.05-.78l74.41 136.44c2.86 5.23 8.3 8.34 14.05 8.34 1.31 0 2.64-.16 3.95-.5 7.09-1.8 12.05-8.19 12.05-15.5 0 0 .14-240.24-.16-246.02zM463.97 248c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24zm80 153.25l-39.86-73.08c15.12-5.83 28.73-14.6 39.86-25.98v99.06z"
        ],
        "landmark": [
            512,
            512,
            [],
            "f66f",
            "M501.62 92.11L267.24 2.04a31.958 31.958 0 0 0-22.47 0L10.38 92.11A16.001 16.001 0 0 0 0 107.09V144c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-36.91c0-6.67-4.14-12.64-10.38-14.98zM64 192v160H48c-8.84 0-16 7.16-16 16v48h448v-48c0-8.84-7.16-16-16-16h-16V192h-64v160h-96V192h-64v160h-96V192H64zm432 256H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
        ],
        "language": [
            640,
            512,
            [],
            "f1ab",
            "M152.1 236.2c-3.5-12.1-7.8-33.2-7.8-33.2h-.5s-4.3 21.1-7.8 33.2l-11.1 37.5H163zM616 96H336v320h280c13.3 0 24-10.7 24-24V120c0-13.3-10.7-24-24-24zm-24 120c0 6.6-5.4 12-12 12h-11.4c-6.9 23.6-21.7 47.4-42.7 69.9 8.4 6.4 17.1 12.5 26.1 18 5.5 3.4 7.3 10.5 4.1 16.2l-7.9 13.9c-3.4 5.9-10.9 7.8-16.7 4.3-12.6-7.8-24.5-16.1-35.4-24.9-10.9 8.7-22.7 17.1-35.4 24.9-5.8 3.5-13.3 1.6-16.7-4.3l-7.9-13.9c-3.2-5.6-1.4-12.8 4.2-16.2 9.3-5.7 18-11.7 26.1-18-7.9-8.4-14.9-17-21-25.7-4-5.7-2.2-13.6 3.7-17.1l6.5-3.9 7.3-4.3c5.4-3.2 12.4-1.7 16 3.4 5 7 10.8 14 17.4 20.9 13.5-14.2 23.8-28.9 30-43.2H412c-6.6 0-12-5.4-12-12v-16c0-6.6 5.4-12 12-12h64v-16c0-6.6 5.4-12 12-12h16c6.6 0 12 5.4 12 12v16h64c6.6 0 12 5.4 12 12zM0 120v272c0 13.3 10.7 24 24 24h280V96H24c-13.3 0-24 10.7-24 24zm58.9 216.1L116.4 167c1.7-4.9 6.2-8.1 11.4-8.1h32.5c5.1 0 9.7 3.3 11.4 8.1l57.5 169.1c2.6 7.8-3.1 15.9-11.4 15.9h-22.9a12 12 0 0 1-11.5-8.6l-9.4-31.9h-60.2l-9.1 31.8c-1.5 5.1-6.2 8.7-11.5 8.7H70.3c-8.2 0-14-8.1-11.4-15.9z"
        ],
        "laptop": [
            640,
            512,
            [],
            "f109",
            "M624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"
        ],
        "laptop-code": [
            640,
            512,
            [],
            "f5fc",
            "M255.03 261.65c6.25 6.25 16.38 6.25 22.63 0l11.31-11.31c6.25-6.25 6.25-16.38 0-22.63L253.25 192l35.71-35.72c6.25-6.25 6.25-16.38 0-22.63l-11.31-11.31c-6.25-6.25-16.38-6.25-22.63 0l-58.34 58.34c-6.25 6.25-6.25 16.38 0 22.63l58.35 58.34zm96.01-11.3l11.31 11.31c6.25 6.25 16.38 6.25 22.63 0l58.34-58.34c6.25-6.25 6.25-16.38 0-22.63l-58.34-58.34c-6.25-6.25-16.38-6.25-22.63 0l-11.31 11.31c-6.25 6.25-6.25 16.38 0 22.63L386.75 192l-35.71 35.72c-6.25 6.25-6.25 16.38 0 22.63zM624 416H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33.02-17.47-32.77-32H16c-8.8 0-16 7.2-16 16v16c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v-16c0-8.8-7.2-16-16-16zM576 48c0-26.4-21.6-48-48-48H112C85.6 0 64 21.6 64 48v336h512V48zm-64 272H128V64h384v256z"
        ],
        "laptop-house": [
            640,
            512,
            [],
            "e066",
            "M272,288H208a16,16,0,0,1-16-16V208a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16v37.12C299.11,232.24,315,224,332.8,224H469.74l6.65-7.53A16.51,16.51,0,0,0,480,207a16.31,16.31,0,0,0-4.75-10.61L416,144V48a16,16,0,0,0-16-16H368a16,16,0,0,0-16,16V87.3L263.5,8.92C258,4,247.45,0,240.05,0s-17.93,4-23.47,8.92L4.78,196.42A16.15,16.15,0,0,0,0,207a16.4,16.4,0,0,0,3.55,9.39L22.34,237.7A16.22,16.22,0,0,0,33,242.48,16.51,16.51,0,0,0,42.34,239L64,219.88V384a32,32,0,0,0,32,32H272ZM629.33,448H592V288c0-17.67-12.89-32-28.8-32H332.8c-15.91,0-28.8,14.33-28.8,32V448H266.67A10.67,10.67,0,0,0,256,458.67v10.66A42.82,42.82,0,0,0,298.6,512H597.4A42.82,42.82,0,0,0,640,469.33V458.67A10.67,10.67,0,0,0,629.33,448ZM544,448H352V304H544Z"
        ],
        "laptop-medical": [
            640,
            512,
            [],
            "f812",
            "M232 224h56v56a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8v-56h56a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8h-56v-56a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v56h-56a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8zM576 48a48.14 48.14 0 0 0-48-48H112a48.14 48.14 0 0 0-48 48v336h512zm-64 272H128V64h384zm112 96H381.54c-.74 19.81-14.71 32-32.74 32H288c-18.69 0-33-17.47-32.77-32H16a16 16 0 0 0-16 16v16a64.19 64.19 0 0 0 64 64h512a64.19 64.19 0 0 0 64-64v-16a16 16 0 0 0-16-16z"
        ],
        "laugh": [
            496,
            512,
            [],
            "f599",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 152c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm88 272h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18-8.9 71-69.5 126-142.9 126z"
        ],
        "laugh-beam": [
            496,
            512,
            [],
            "f59a",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm24 199.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.2 7.4-15.8 4.1-15.1-4.5zm-160 0c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
        ],
        "laugh-squint": [
            496,
            512,
            [],
            "f59b",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 161.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 180l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM398.9 306C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
        ],
        "laugh-wink": [
            496,
            512,
            [],
            "f59c",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm20.1 198.1c4-25.2 34.2-42.1 59.9-42.1s55.9 16.9 59.9 42.1c1.7 11.1-11.4 18.3-19.8 10.8l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L288 217c-8.4 7.4-21.6.3-19.9-10.9zM168 160c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm230.9 146C390 377 329.4 432 256 432h-16c-73.4 0-134-55-142.9-126-1.2-9.5 6.3-18 15.9-18h270c9.6 0 17.1 8.4 15.9 18z"
        ],
        "layer-group": [
            512,
            512,
            [],
            "f5fd",
            "M12.41 148.02l232.94 105.67c6.8 3.09 14.49 3.09 21.29 0l232.94-105.67c16.55-7.51 16.55-32.52 0-40.03L266.65 2.31a25.607 25.607 0 0 0-21.29 0L12.41 107.98c-16.55 7.51-16.55 32.53 0 40.04zm487.18 88.28l-58.09-26.33-161.64 73.27c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.51 209.97l-58.1 26.33c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 276.3c16.55-7.5 16.55-32.5 0-40zm0 127.8l-57.87-26.23-161.86 73.37c-7.56 3.43-15.59 5.17-23.86 5.17s-16.29-1.74-23.86-5.17L70.29 337.87 12.41 364.1c-16.55 7.5-16.55 32.5 0 40l232.94 105.59c6.8 3.08 14.49 3.08 21.29 0L499.59 404.1c16.55-7.5 16.55-32.5 0-40z"
        ],
        "leaf": [
            576,
            512,
            [],
            "f06c",
            "M546.2 9.7c-5.6-12.5-21.6-13-28.3-1.2C486.9 62.4 431.4 96 368 96h-80C182 96 96 182 96 288c0 7 .8 13.7 1.5 20.5C161.3 262.8 253.4 224 384 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C132.6 256 26 410.1 2.4 468c-6.6 16.3 1.2 34.9 17.5 41.6 16.4 6.8 35-1.1 41.8-17.3 1.5-3.6 20.9-47.9 71.9-90.6 32.4 43.9 94 85.8 174.9 77.2C465.5 467.5 576 326.7 576 154.3c0-50.2-10.8-102.2-29.8-144.6z"
        ],
        "lemon": [
            512,
            512,
            [],
            "f094",
            "M489.038 22.963C465.944-.13 434.648-5.93 413.947 6.129c-58.906 34.312-181.25-53.077-321.073 86.746S40.441 355.041 6.129 413.945c-12.059 20.702-6.26 51.999 16.833 75.093 23.095 23.095 54.392 28.891 75.095 16.832 58.901-34.31 181.246 53.079 321.068-86.743S471.56 156.96 505.871 98.056c12.059-20.702 6.261-51.999-16.833-75.093zM243.881 95.522c-58.189 14.547-133.808 90.155-148.358 148.358-1.817 7.27-8.342 12.124-15.511 12.124-1.284 0-2.59-.156-3.893-.481-8.572-2.144-13.784-10.83-11.642-19.403C81.901 166.427 166.316 81.93 236.119 64.478c8.575-2.143 17.261 3.069 19.403 11.642s-3.069 17.259-11.641 19.402z"
        ],
        "less-than": [
            384,
            512,
            [],
            "f536",
            "M365.46 357.74L147.04 255.89l218.47-101.88c16.02-7.47 22.95-26.51 15.48-42.53l-13.52-29C360 66.46 340.96 59.53 324.94 67L18.48 209.91a32.014 32.014 0 0 0-18.48 29v34.24c0 12.44 7.21 23.75 18.48 29l306.31 142.83c16.06 7.49 35.15.54 42.64-15.52l13.56-29.08c7.49-16.06.54-35.15-15.53-42.64z"
        ],
        "less-than-equal": [
            448,
            512,
            [],
            "f537",
            "M54.98 214.2l301.41 119.87c18.39 6.03 38.71-2.54 45.38-19.15l12.09-30.08c6.68-16.61-2.82-34.97-21.21-41l-175.44-68.05 175.56-68.09c18.29-6 27.74-24.27 21.1-40.79l-12.03-29.92c-6.64-16.53-26.86-25.06-45.15-19.06L54.98 137.89C41.21 142.41 32 154.5 32 168.07v15.96c0 13.56 9.21 25.65 22.98 30.17zM424 400H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h400c13.25 0 24-10.75 24-24v-48c0-13.26-10.75-24-24-24z"
        ],
        "level-down-alt": [
            320,
            512,
            [],
            "f3be",
            "M313.553 392.331L209.587 504.334c-9.485 10.214-25.676 10.229-35.174 0L70.438 392.331C56.232 377.031 67.062 352 88.025 352H152V80H68.024a11.996 11.996 0 0 1-8.485-3.515l-56-56C-4.021 12.926 1.333 0 12.024 0H208c13.255 0 24 10.745 24 24v328h63.966c20.878 0 31.851 24.969 17.587 40.331z"
        ],
        "level-up-alt": [
            320,
            512,
            [],
            "f3bf",
            "M313.553 119.669L209.587 7.666c-9.485-10.214-25.676-10.229-35.174 0L70.438 119.669C56.232 134.969 67.062 160 88.025 160H152v272H68.024a11.996 11.996 0 0 0-8.485 3.515l-56 56C-4.021 499.074 1.333 512 12.024 512H208c13.255 0 24-10.745 24-24V160h63.966c20.878 0 31.851-24.969 17.587-40.331z"
        ],
        "life-ring": [
            512,
            512,
            [],
            "f1cd",
            "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm173.696 119.559l-63.399 63.399c-10.987-18.559-26.67-34.252-45.255-45.255l63.399-63.399a218.396 218.396 0 0 1 45.255 45.255zM256 352c-53.019 0-96-42.981-96-96s42.981-96 96-96 96 42.981 96 96-42.981 96-96 96zM127.559 82.304l63.399 63.399c-18.559 10.987-34.252 26.67-45.255 45.255l-63.399-63.399a218.372 218.372 0 0 1 45.255-45.255zM82.304 384.441l63.399-63.399c10.987 18.559 26.67 34.252 45.255 45.255l-63.399 63.399a218.396 218.396 0 0 1-45.255-45.255zm302.137 45.255l-63.399-63.399c18.559-10.987 34.252-26.67 45.255-45.255l63.399 63.399a218.403 218.403 0 0 1-45.255 45.255z"
        ],
        "lightbulb": [
            352,
            512,
            [],
            "f0eb",
            "M96.06 454.35c.01 6.29 1.87 12.45 5.36 17.69l17.09 25.69a31.99 31.99 0 0 0 26.64 14.28h61.71a31.99 31.99 0 0 0 26.64-14.28l17.09-25.69a31.989 31.989 0 0 0 5.36-17.69l.04-38.35H96.01l.05 38.35zM0 176c0 44.37 16.45 84.85 43.56 115.78 16.52 18.85 42.36 58.23 52.21 91.45.04.26.07.52.11.78h160.24c.04-.26.07-.51.11-.78 9.85-33.22 35.69-72.6 52.21-91.45C335.55 260.85 352 220.37 352 176 352 78.61 272.91-.3 175.45 0 73.44.31 0 82.97 0 176zm176-80c-44.11 0-80 35.89-80 80 0 8.84-7.16 16-16 16s-16-7.16-16-16c0-61.76 50.24-112 112-112 8.84 0 16 7.16 16 16s-7.16 16-16 16z"
        ],
        "link": [
            512,
            512,
            [],
            "f0c1",
            "M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z"
        ],
        "lira-sign": [
            384,
            512,
            [],
            "f195",
            "M371.994 256h-48.019C317.64 256 312 260.912 312 267.246 312 368 230.179 416 144 416V256.781l134.603-29.912A12 12 0 0 0 288 215.155v-40.976c0-7.677-7.109-13.38-14.603-11.714L144 191.219V160.78l134.603-29.912A12 12 0 0 0 288 119.154V78.179c0-7.677-7.109-13.38-14.603-11.714L144 95.219V44c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v68.997L9.397 125.131A12 12 0 0 0 0 136.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 178.558v30.439L9.397 221.131A12 12 0 0 0 0 232.845v40.976c0 7.677 7.109 13.38 14.603 11.714L64 274.558V468c0 6.627 5.373 12 12 12h79.583c134.091 0 223.255-77.834 228.408-211.592.261-6.782-5.211-12.408-11.997-12.408z"
        ],
        "list": [
            512,
            512,
            [],
            "f03a",
            "M80 368H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm0-320H16A16 16 0 0 0 0 64v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16V64a16 16 0 0 0-16-16zm0 160H16a16 16 0 0 0-16 16v64a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-64a16 16 0 0 0-16-16zm416 176H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
        ],
        "list-alt": [
            512,
            512,
            [],
            "f022",
            "M464 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zM128 120c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm0 96c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zm288-136v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12zm0 96v-32c0-6.627-5.373-12-12-12H204c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h200c6.627 0 12-5.373 12-12z"
        ],
        "list-ol": [
            512,
            512,
            [],
            "f0cb",
            "M61.77 401l17.5-20.15a19.92 19.92 0 0 0 5.07-14.19v-3.31C84.34 356 80.5 352 73 352H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h22.83a157.41 157.41 0 0 0-11 12.31l-5.61 7c-4 5.07-5.25 10.13-2.8 14.88l1.05 1.93c3 5.76 6.29 7.88 12.25 7.88h4.73c10.33 0 15.94 2.44 15.94 9.09 0 4.72-4.2 8.22-14.36 8.22a41.54 41.54 0 0 1-15.47-3.12c-6.49-3.88-11.74-3.5-15.6 3.12l-5.59 9.31c-3.72 6.13-3.19 11.72 2.63 15.94 7.71 4.69 20.38 9.44 37 9.44 34.16 0 48.5-22.75 48.5-44.12-.03-14.38-9.12-29.76-28.73-34.88zM496 224H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h64a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H64V40a8 8 0 0 0-8-8H32a8 8 0 0 0-7.14 4.42l-8 16A8 8 0 0 0 24 64h8v64H16a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8zm-3.91 160H80a8 8 0 0 0 8-8v-16a8 8 0 0 0-8-8H41.32c3.29-10.29 48.34-18.68 48.34-56.44 0-29.06-25-39.56-44.47-39.56-21.36 0-33.8 10-40.46 18.75-4.37 5.59-3 10.84 2.8 15.37l8.58 6.88c5.61 4.56 11 2.47 16.12-2.44a13.44 13.44 0 0 1 9.46-3.84c3.33 0 9.28 1.56 9.28 8.75C51 248.19 0 257.31 0 304.59v4C0 316 5.08 320 12.09 320z"
        ],
        "list-ul": [
            512,
            512,
            [],
            "f0ca",
            "M48 48a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm0 160a48 48 0 1 0 48 48 48 48 0 0 0-48-48zm448 16H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H176a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h320a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
        ],
        "location-arrow": [
            512,
            512,
            [],
            "f124",
            "M444.52 3.52L28.74 195.42c-47.97 22.39-31.98 92.75 19.19 92.75h175.91v175.91c0 51.17 70.36 67.17 92.75 19.19l191.9-415.78c15.99-38.39-25.59-79.97-63.97-63.97z"
        ],
        "lock": [
            448,
            512,
            [],
            "f023",
            "M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z"
        ],
        "lock-open": [
            576,
            512,
            [],
            "f3c1",
            "M423.5 0C339.5.3 272 69.5 272 153.5V224H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48h-48v-71.1c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v80c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-80C576 68 507.5-.3 423.5 0z"
        ],
        "long-arrow-alt-down": [
            256,
            512,
            [],
            "f309",
            "M168 345.941V44c0-6.627-5.373-12-12-12h-56c-6.627 0-12 5.373-12 12v301.941H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.569 9.373 33.941 0l86.059-86.059c15.119-15.119 4.411-40.971-16.971-40.971H168z"
        ],
        "long-arrow-alt-left": [
            448,
            512,
            [],
            "f30a",
            "M134.059 296H436c6.627 0 12-5.373 12-12v-56c0-6.627-5.373-12-12-12H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.569 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296z"
        ],
        "long-arrow-alt-right": [
            448,
            512,
            [],
            "f30b",
            "M313.941 216H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h301.941v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.569 0-33.941l-86.059-86.059c-15.119-15.119-40.971-4.411-40.971 16.971V216z"
        ],
        "long-arrow-alt-up": [
            256,
            512,
            [],
            "f30c",
            "M88 166.059V468c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12V166.059h46.059c21.382 0 32.09-25.851 16.971-40.971l-86.059-86.059c-9.373-9.373-24.569-9.373-33.941 0l-86.059 86.059c-15.119 15.119-4.411 40.971 16.971 40.971H88z"
        ],
        "low-vision": [
            576,
            512,
            [],
            "f2a8",
            "M569.344 231.631C512.96 135.949 407.81 72 288 72c-28.468 0-56.102 3.619-82.451 10.409L152.778 10.24c-7.601-10.858-22.564-13.5-33.423-5.9l-13.114 9.178c-10.86 7.601-13.502 22.566-5.9 33.426l43.131 58.395C89.449 131.73 40.228 174.683 6.682 231.581c-.01.017-.023.033-.034.05-8.765 14.875-8.964 33.528 0 48.739 38.5 65.332 99.742 115.862 172.859 141.349L55.316 244.302A272.194 272.194 0 0 1 83.61 208.39l119.4 170.58h.01l40.63 58.04a330.055 330.055 0 0 0 78.94 1.17l-189.98-271.4a277.628 277.628 0 0 1 38.777-21.563l251.836 356.544c7.601 10.858 22.564 13.499 33.423 5.9l13.114-9.178c10.86-7.601 13.502-22.567 5.9-33.426l-43.12-58.377-.007-.009c57.161-27.978 104.835-72.04 136.81-126.301a47.938 47.938 0 0 0 .001-48.739zM390.026 345.94l-19.066-27.23c24.682-32.567 27.711-76.353 8.8-111.68v.03c0 23.65-19.17 42.82-42.82 42.82-23.828 0-42.82-19.349-42.82-42.82 0-23.65 19.17-42.82 42.82-42.82h.03c-24.75-13.249-53.522-15.643-79.51-7.68l-19.068-27.237C253.758 123.306 270.488 120 288 120c75.162 0 136 60.826 136 136 0 34.504-12.833 65.975-33.974 89.94z"
        ],
        "luggage-cart": [
            640,
            512,
            [],
            "f59d",
            "M224 320h32V96h-32c-17.67 0-32 14.33-32 32v160c0 17.67 14.33 32 32 32zm352-32V128c0-17.67-14.33-32-32-32h-32v224h32c17.67 0 32-14.33 32-32zm48 96H128V16c0-8.84-7.16-16-16-16H16C7.16 0 0 7.16 0 16v32c0 8.84 7.16 16 16 16h48v368c0 8.84 7.16 16 16 16h82.94c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16h197.88c-1.79 5.03-2.94 10.36-2.94 16 0 26.51 21.49 48 48 48s48-21.49 48-48c0-5.64-1.15-10.97-2.94-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM480 96V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v272h192V96zm-48 0h-96V48h96v48z"
        ],
        "lungs": [
            640,
            512,
            [],
            "f604",
            "M636.11 390.15C614.44 308.85 580.07 231 534.1 159.13 511.98 124.56 498.03 96 454.05 96 415.36 96 384 125.42 384 161.71v60.11l-32.88-21.92a15.996 15.996 0 0 1-7.12-13.31V16c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v170.59c0 5.35-2.67 10.34-7.12 13.31L256 221.82v-60.11C256 125.42 224.64 96 185.95 96c-43.98 0-57.93 28.56-80.05 63.13C59.93 231 25.56 308.85 3.89 390.15 1.3 399.84 0 409.79 0 419.78c0 61.23 62.48 105.44 125.24 88.62l59.5-15.95c42.18-11.3 71.26-47.47 71.26-88.62v-87.49l-85.84 57.23a7.992 7.992 0 0 1-11.09-2.22l-8.88-13.31a7.992 7.992 0 0 1 2.22-11.09L320 235.23l167.59 111.72a7.994 7.994 0 0 1 2.22 11.09l-8.88 13.31a7.994 7.994 0 0 1-11.09 2.22L384 316.34v87.49c0 41.15 29.08 77.31 71.26 88.62l59.5 15.95C577.52 525.22 640 481.01 640 419.78c0-9.99-1.3-19.94-3.89-29.63z"
        ],
        "lungs-virus": [
            640,
            512,
            [],
            "e067",
            "M344,150.68V16A16,16,0,0,0,328,0H312a16,16,0,0,0-16,16V150.68a46.45,46.45,0,0,1,48,0ZM195.54,444.46a48.06,48.06,0,0,1,0-67.88l8.58-8.58H192a48,48,0,0,1,0-96h12.12l-8.58-8.57a48,48,0,0,1,60.46-74V161.75C256,125.38,224.62,96,186,96c-44,0-58,28.5-80.12,63.13a819.52,819.52,0,0,0-102,231A113.16,113.16,0,0,0,0,419.75C0,481,62.5,525.26,125.25,508.38l59.5-15.87a98.51,98.51,0,0,0,52.5-34.75,46.49,46.49,0,0,1-41.71-13.3Zm226.29-22.63a16,16,0,0,0,0-22.62l-8.58-8.58C393.09,370.47,407.37,336,435.88,336H448a16,16,0,0,0,0-32H435.88c-28.51,0-42.79-34.47-22.63-54.62l8.58-8.58a16,16,0,0,0-22.63-22.63l-8.57,8.58C370.47,246.91,336,232.63,336,204.12V192a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.58c20.16,20.15,5.88,54.62-22.63,54.62H192a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.58a16,16,0,1,0,22.63,22.62l8.57-8.57C269.53,393.1,304,407.38,304,435.88V448a16,16,0,0,0,32,0V435.88c0-28.5,34.47-42.78,54.63-22.62l8.57,8.57a16,16,0,0,0,22.63,0ZM288,304a16,16,0,1,1,16-16A16,16,0,0,1,288,304Zm64,64a16,16,0,1,1,16-16A16,16,0,0,1,352,368Zm284.12,22.13a819.52,819.52,0,0,0-102-231C512,124.5,498,96,454,96c-38.62,0-70,29.38-70,65.75v27.72a48,48,0,0,1,60.46,74L435.88,272H448a48,48,0,0,1,0,96H435.88l8.58,8.58a47.7,47.7,0,0,1-41.71,81.18,98.51,98.51,0,0,0,52.5,34.75l59.5,15.87C577.5,525.26,640,481,640,419.75A113.16,113.16,0,0,0,636.12,390.13Z"
        ],
        "magic": [
            512,
            512,
            [],
            "f0d0",
            "M224 96l16-32 32-16-32-16-16-32-16 32-32 16 32 16 16 32zM80 160l26.66-53.33L160 80l-53.34-26.67L80 0 53.34 53.33 0 80l53.34 26.67L80 160zm352 128l-26.66 53.33L352 368l53.34 26.67L432 448l26.66-53.33L512 368l-53.34-26.67L432 288zm70.62-193.77L417.77 9.38C411.53 3.12 403.34 0 395.15 0c-8.19 0-16.38 3.12-22.63 9.38L9.38 372.52c-12.5 12.5-12.5 32.76 0 45.25l84.85 84.85c6.25 6.25 14.44 9.37 22.62 9.37 8.19 0 16.38-3.12 22.63-9.37l363.14-363.15c12.5-12.48 12.5-32.75 0-45.24zM359.45 203.46l-50.91-50.91 86.6-86.6 50.91 50.91-86.6 86.6z"
        ],
        "magnet": [
            512,
            512,
            [],
            "f076",
            "M164.07 148.1H12a12 12 0 0 1-12-12v-80a36 36 0 0 1 36-36h104a36 36 0 0 1 36 36v80a11.89 11.89 0 0 1-11.93 12zm347.93-12V56a36 36 0 0 0-36-36H372a36 36 0 0 0-36 36v80a12 12 0 0 0 12 12h152a11.89 11.89 0 0 0 12-11.9zm-164 44a12 12 0 0 0-12 12v52c0 128.1-160 127.9-160 0v-52a12 12 0 0 0-12-12H12.1a12 12 0 0 0-12 12.1c.1 21.4.6 40.3 0 53.3 0 150.6 136.17 246.6 256.75 246.6s255-96 255-246.7c-.6-12.8-.2-33 0-53.2a12 12 0 0 0-12-12.1z"
        ],
        "mail-bulk": [
            576,
            512,
            [],
            "f674",
            "M160 448c-25.6 0-51.2-22.4-64-32-64-44.8-83.2-60.8-96-70.4V480c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V345.6c-12.8 9.6-32 25.6-96 70.4-12.8 9.6-38.4 32-64 32zm128-192H32c-17.67 0-32 14.33-32 32v16c25.6 19.2 22.4 19.2 115.2 86.4 9.6 6.4 28.8 25.6 44.8 25.6s35.2-19.2 44.8-22.4c92.8-67.2 89.6-67.2 115.2-86.4V288c0-17.67-14.33-32-32-32zm256-96H224c-17.67 0-32 14.33-32 32v32h96c33.21 0 60.59 25.42 63.71 57.82l.29-.22V416h192c17.67 0 32-14.33 32-32V192c0-17.67-14.33-32-32-32zm-32 128h-64v-64h64v64zm-352-96c0-35.29 28.71-64 64-64h224V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v192h96v-32z"
        ],
        "male": [
            192,
            512,
            [],
            "f183",
            "M96 0c35.346 0 64 28.654 64 64s-28.654 64-64 64-64-28.654-64-64S60.654 0 96 0m48 144h-11.36c-22.711 10.443-49.59 10.894-73.28 0H48c-26.51 0-48 21.49-48 48v136c0 13.255 10.745 24 24 24h16v136c0 13.255 10.745 24 24 24h64c13.255 0 24-10.745 24-24V352h16c13.255 0 24-10.745 24-24V192c0-26.51-21.49-48-48-48z"
        ],
        "map": [
            576,
            512,
            [],
            "f279",
            "M0 117.66v346.32c0 11.32 11.43 19.06 21.94 14.86L160 416V32L20.12 87.95A32.006 32.006 0 0 0 0 117.66zM192 416l192 64V96L192 32v384zM554.06 33.16L416 96v384l139.88-55.95A31.996 31.996 0 0 0 576 394.34V48.02c0-11.32-11.43-19.06-21.94-14.86z"
        ],
        "map-marked": [
            576,
            512,
            [],
            "f59f",
            "M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"
        ],
        "map-marked-alt": [
            576,
            512,
            [],
            "f5a0",
            "M288 0c-69.59 0-126 56.41-126 126 0 56.26 82.35 158.8 113.9 196.02 6.39 7.54 17.82 7.54 24.2 0C331.65 284.8 414 182.26 414 126 414 56.41 357.59 0 288 0zm0 168c-23.2 0-42-18.8-42-42s18.8-42 42-42 42 18.8 42 42-18.8 42-42 42zM20.12 215.95A32.006 32.006 0 0 0 0 245.66v250.32c0 11.32 11.43 19.06 21.94 14.86L160 448V214.92c-8.84-15.98-16.07-31.54-21.25-46.42L20.12 215.95zM288 359.67c-14.07 0-27.38-6.18-36.51-16.96-19.66-23.2-40.57-49.62-59.49-76.72v182l192 64V266c-18.92 27.09-39.82 53.52-59.49 76.72-9.13 10.77-22.44 16.95-36.51 16.95zm266.06-198.51L416 224v288l139.88-55.95A31.996 31.996 0 0 0 576 426.34V176.02c0-11.32-11.43-19.06-21.94-14.86z"
        ],
        "map-marker": [
            384,
            512,
            [],
            "f041",
            "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z"
        ],
        "map-marker-alt": [
            384,
            512,
            [],
            "f3c5",
            "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z"
        ],
        "map-pin": [
            288,
            512,
            [],
            "f276",
            "M112 316.94v156.69l22.02 33.02c4.75 7.12 15.22 7.12 19.97 0L176 473.63V316.94c-10.39 1.92-21.06 3.06-32 3.06s-21.61-1.14-32-3.06zM144 0C64.47 0 0 64.47 0 144s64.47 144 144 144 144-64.47 144-144S223.53 0 144 0zm0 76c-37.5 0-68 30.5-68 68 0 6.62-5.38 12-12 12s-12-5.38-12-12c0-50.73 41.28-92 92-92 6.62 0 12 5.38 12 12s-5.38 12-12 12z"
        ],
        "map-signs": [
            512,
            512,
            [],
            "f277",
            "M507.31 84.69L464 41.37c-6-6-14.14-9.37-22.63-9.37H288V16c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v16H56c-13.25 0-24 10.75-24 24v80c0 13.25 10.75 24 24 24h385.37c8.49 0 16.62-3.37 22.63-9.37l43.31-43.31c6.25-6.26 6.25-16.38 0-22.63zM224 496c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V384h-64v112zm232-272H288v-32h-64v32H70.63c-8.49 0-16.62 3.37-22.63 9.37L4.69 276.69c-6.25 6.25-6.25 16.38 0 22.63L48 342.63c6 6 14.14 9.37 22.63 9.37H456c13.25 0 24-10.75 24-24v-80c0-13.25-10.75-24-24-24z"
        ],
        "marker": [
            512,
            512,
            [],
            "f5a1",
            "M93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l75.4-75.4-128.02-128.02-75.4 75.4zM485.49 26.51c-35.35-35.35-92.67-35.35-128.02 0l-21.76 21.76-36.56-36.55c-15.62-15.62-40.95-15.62-56.56 0L138.47 115.84c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0l87.15-87.15 19.59 19.59L191.98 192 320 320.02l165.49-165.49c35.35-35.35 35.35-92.66 0-128.02z"
        ],
        "mars": [
            384,
            512,
            [],
            "f222",
            "M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c0-6.6-5.4-12-12-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
        ],
        "mars-double": [
            512,
            512,
            [],
            "f227",
            "M340 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C198.5 72.1 172.2 64 144 64 64.5 64 0 128.5 0 208s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.5 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 288c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm356-128.1h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7c-18.2-11.4-39-18.9-61.5-21.3-2.1 21.8-8.2 43.3-18.4 63.3 1.1 0 2.2-.1 3.2-.1 44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80c0-1.1 0-2.2.1-3.2-20 10.2-41.5 16.4-63.3 18.4C168.4 455.6 229.6 512 304 512c79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12v-79c0-6.7-5.4-12.1-12-12.1z"
        ],
        "mars-stroke": [
            384,
            512,
            [],
            "f229",
            "M372 64h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-17.5 17.5-14.1-14.1c-4.7-4.7-12.3-4.7-17 0L224.5 133c-4.7 4.7-4.7 12.3 0 17l14.1 14.1-18 18c-22.2-14-48.5-22.1-76.7-22.1C64.5 160 0 224.5 0 304s64.5 144 144 144 144-64.5 144-144c0-28.2-8.1-54.5-22.1-76.7l18-18 14.1 14.1c4.7 4.7 12.3 4.7 17 0l28.3-28.3c4.7-4.7 4.7-12.3 0-17L329.2 164l17.5-17.5 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V76c-.1-6.6-5.5-12-12.1-12zM144 384c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
        ],
        "mars-stroke-h": [
            480,
            512,
            [],
            "f22b",
            "M476.2 247.5l-55.9-55.9c-7.6-7.6-20.5-2.2-20.5 8.5V224H376v-20c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v20h-27.6c-5.8-25.6-18.7-49.9-38.6-69.8C189.6 98 98.4 98 42.2 154.2c-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 19.9-19.9 32.8-44.2 38.6-69.8H312v20c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-20h23.9v23.9c0 10.7 12.9 16 20.5 8.5l55.9-55.9c4.6-4.7 4.6-12.3-.1-17zm-275.6 65.1c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"
        ],
        "mars-stroke-v": [
            288,
            512,
            [],
            "f22a",
            "M245.8 234.2c-19.9-19.9-44.2-32.8-69.8-38.6v-25.4h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V81.4h23.9c10.7 0 16-12.9 8.5-20.5L152.5 5.1c-4.7-4.7-12.3-4.7-17 0L79.6 61c-7.6 7.6-2.2 20.5 8.5 20.5H112v24.7H92c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h20v25.4c-25.6 5.8-49.9 18.7-69.8 38.6-56.2 56.2-56.2 147.4 0 203.6 56.2 56.2 147.4 56.2 203.6 0 56.3-56.2 56.3-147.4 0-203.6zm-45.2 158.4c-31.2 31.2-81.9 31.2-113.1 0-31.2-31.2-31.2-81.9 0-113.1 31.2-31.2 81.9-31.2 113.1 0 31.2 31.1 31.2 81.9 0 113.1z"
        ],
        "mask": [
            640,
            512,
            [],
            "f6fa",
            "M320.67 64c-442.6 0-357.57 384-158.46 384 39.9 0 77.47-20.69 101.42-55.86l25.73-37.79c15.66-22.99 46.97-22.99 62.63 0l25.73 37.79C401.66 427.31 439.23 448 479.13 448c189.86 0 290.63-384-158.46-384zM184 308.36c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05zm272 0c-41.06 0-67.76-25.66-80.08-41.05-5.23-6.53-5.23-16.09 0-22.63 12.32-15.4 39.01-41.05 80.08-41.05s67.76 25.66 80.08 41.05c5.23 6.53 5.23 16.09 0 22.63-12.32 15.4-39.02 41.05-80.08 41.05z"
        ],
        "medal": [
            512,
            512,
            [],
            "f5a2",
            "M223.75 130.75L154.62 15.54A31.997 31.997 0 0 0 127.18 0H16.03C3.08 0-4.5 14.57 2.92 25.18l111.27 158.96c29.72-27.77 67.52-46.83 109.56-53.39zM495.97 0H384.82c-11.24 0-21.66 5.9-27.44 15.54l-69.13 115.21c42.04 6.56 79.84 25.62 109.56 53.38L509.08 25.18C516.5 14.57 508.92 0 495.97 0zM256 160c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm92.52 157.26l-37.93 36.96 8.97 52.22c1.6 9.36-8.26 16.51-16.65 12.09L256 393.88l-46.9 24.65c-8.4 4.45-18.25-2.74-16.65-12.09l8.97-52.22-37.93-36.96c-6.82-6.64-3.05-18.23 6.35-19.59l52.43-7.64 23.43-47.52c2.11-4.28 6.19-6.39 10.28-6.39 4.11 0 8.22 2.14 10.33 6.39l23.43 47.52 52.43 7.64c9.4 1.36 13.17 12.95 6.35 19.59z"
        ],
        "medkit": [
            512,
            512,
            [],
            "f0fa",
            "M96 480h320V128h-32V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v48H96v352zm96-384h128v32H192V96zm320 80v256c0 26.51-21.49 48-48 48h-16V128h16c26.51 0 48 21.49 48 48zM64 480H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v352zm288-208v32c0 8.837-7.163 16-16 16h-48v48c0 8.837-7.163 16-16 16h-32c-8.837 0-16-7.163-16-16v-48h-48c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16h48v-48c0-8.837 7.163-16 16-16h32c8.837 0 16 7.163 16 16v48h48c8.837 0 16 7.163 16 16z"
        ],
        "meh": [
            496,
            512,
            [],
            "f11a",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm176 192H152c-21.2 0-21.2-32 0-32h192c21.2 0 21.2 32 0 32zm-16-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
        ],
        "meh-blank": [
            496,
            512,
            [],
            "f5a4",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm-80 232c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm160 0c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
        ],
        "meh-rolling-eyes": [
            496,
            512,
            [],
            "f5a5",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM88 224c0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64s-64-28.7-64-64zm224 176H184c-21.2 0-21.2-32 0-32h128c21.2 0 21.2 32 0 32zm32-112c-35.3 0-64-28.7-64-64 0-24.3 13.7-45.2 33.6-56-.7 2.6-1.6 5.2-1.6 8 0 17.7 14.3 32 32 32s32-14.3 32-32c0-2.8-.9-5.4-1.6-8 19.9 10.8 33.6 31.7 33.6 56 0 35.3-28.7 64-64 64z"
        ],
        "memory": [
            640,
            512,
            [],
            "f538",
            "M640 130.94V96c0-17.67-14.33-32-32-32H32C14.33 64 0 78.33 0 96v34.94c18.6 6.61 32 24.19 32 45.06s-13.4 38.45-32 45.06V320h640v-98.94c-18.6-6.61-32-24.19-32-45.06s13.4-38.45 32-45.06zM224 256h-64V128h64v128zm128 0h-64V128h64v128zm128 0h-64V128h64v128zM0 448h64v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h128v-26.67c0-8.84 7.16-16 16-16s16 7.16 16 16V448h64v-96H0v96z"
        ],
        "menorah": [
            640,
            512,
            [],
            "f676",
            "M144 128h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm192 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm96 0h-32c-8.84 0-16 7.16-16 16v144h64V144c0-8.84-7.16-16-16-16zm80-32c17.67 0 32-14.33 32-32S608 0 608 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S512 0 512 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S416 0 416 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S320 0 320 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S224 0 224 0s-32 46.33-32 64 14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S128 0 128 0 96 46.33 96 64s14.33 32 32 32zm-96 0c17.67 0 32-14.33 32-32S32 0 32 0 0 46.33 0 64s14.33 32 32 32zm544 192c0 17.67-14.33 32-32 32H352V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v176H96c-17.67 0-32-14.33-32-32V144c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v144c0 53.02 42.98 96 96 96h192v64H112c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16H352v-64h192c53.02 0 96-42.98 96-96V144c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v144z"
        ],
        "mercury": [
            288,
            512,
            [],
            "f223",
            "M288 208c0-44.2-19.9-83.7-51.2-110.1 2.5-1.8 4.9-3.8 7.2-5.8 24.7-21.2 39.8-48.8 43.2-78.8.9-7.1-4.7-13.3-11.9-13.3h-40.5C229 0 224.1 4.1 223 9.8c-2.4 12.5-9.6 24.3-20.7 33.8C187 56.8 166.3 64 144 64s-43-7.2-58.4-20.4C74.5 34.1 67.4 22.3 64.9 9.8 63.8 4.1 58.9 0 53.2 0H12.7C5.5 0-.1 6.2.8 13.3 4.2 43.4 19.2 71 44 92.2c2.3 2 4.7 3.9 7.2 5.8C19.9 124.3 0 163.8 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"
        ],
        "meteor": [
            512,
            512,
            [],
            "f753",
            "M511.328,20.8027c-11.60759,38.70264-34.30724,111.70173-61.30311,187.70077,6.99893,2.09372,13.4042,4,18.60653,5.59368a16.06158,16.06158,0,0,1,9.49854,22.906c-22.106,42.29635-82.69047,152.795-142.47819,214.40356-.99984,1.09373-1.99969,2.5-2.99954,3.49995A194.83046,194.83046,0,1,1,57.085,179.41009c.99985-1,2.40588-2,3.49947-3,61.59994-59.90549,171.97367-120.40473,214.37343-142.4982a16.058,16.058,0,0,1,22.90274,9.49988c1.59351,5.09368,3.49947,11.5936,5.5929,18.59351C379.34818,35.00565,452.43074,12.30281,491.12794.70921A16.18325,16.18325,0,0,1,511.328,20.8027ZM319.951,320.00207A127.98041,127.98041,0,1,0,191.97061,448.00046,127.97573,127.97573,0,0,0,319.951,320.00207Zm-127.98041-31.9996a31.9951,31.9951,0,1,1-31.9951-31.9996A31.959,31.959,0,0,1,191.97061,288.00247Zm31.9951,79.999a15.99755,15.99755,0,1,1-15.99755-15.9998A16.04975,16.04975,0,0,1,223.96571,368.00147Z"
        ],
        "microchip": [
            512,
            512,
            [],
            "f2db",
            "M416 48v416c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h224c26.51 0 48 21.49 48 48zm96 58v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42V88h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zm0 96v12a6 6 0 0 1-6 6h-18v6a6 6 0 0 1-6 6h-42v-48h42a6 6 0 0 1 6 6v6h18a6 6 0 0 1 6 6zM30 376h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6zm0-96h42v48H30a6 6 0 0 1-6-6v-6H6a6 6 0 0 1-6-6v-12a6 6 0 0 1 6-6h18v-6a6 6 0 0 1 6-6z"
        ],
        "microphone": [
            352,
            512,
            [],
            "f130",
            "M176 352c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96zm160-160h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16z"
        ],
        "microphone-alt": [
            352,
            512,
            [],
            "f3c9",
            "M336 192h-16c-8.84 0-16 7.16-16 16v48c0 74.8-64.49 134.82-140.79 127.38C96.71 376.89 48 317.11 48 250.3V208c0-8.84-7.16-16-16-16H16c-8.84 0-16 7.16-16 16v40.16c0 89.64 63.97 169.55 152 181.69V464H96c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16h-56v-33.77C285.71 418.47 352 344.9 352 256v-48c0-8.84-7.16-16-16-16zM176 352c53.02 0 96-42.98 96-96h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H272c0-53.02-42.98-96-96-96S80 42.98 80 96v160c0 53.02 42.98 96 96 96z"
        ],
        "microphone-alt-slash": [
            640,
            512,
            [],
            "f539",
            "M633.82 458.1L476.26 336.33C488.74 312.21 496 284.98 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67h-43.67l-41.4-32H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416v-32h-85.33c-5.89 0-10.67-3.58-10.67-8v-16c0-4.42 4.78-8 10.67-8H416c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.78c11.71-1.62 23.1-4.28 33.96-8.08l-50.4-38.96c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"
        ],
        "microphone-slash": [
            640,
            512,
            [],
            "f131",
            "M633.82 458.1l-157.8-121.96C488.61 312.13 496 285.01 496 256v-48c0-8.84-7.16-16-16-16h-16c-8.84 0-16 7.16-16 16v48c0 17.92-3.96 34.8-10.72 50.2l-26.55-20.52c3.1-9.4 5.28-19.22 5.28-29.67V96c0-53.02-42.98-96-96-96s-96 42.98-96 96v45.36L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM400 464h-56v-33.77c11.66-1.6 22.85-4.54 33.67-8.31l-50.11-38.73c-6.71.4-13.41.87-20.35.2-55.85-5.45-98.74-48.63-111.18-101.85L144 241.31v6.85c0 89.64 63.97 169.55 152 181.69V464h-56c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h160c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16z"
        ],
        "microscope": [
            512,
            512,
            [],
            "f610",
            "M160 320h12v16c0 8.84 7.16 16 16 16h40c8.84 0 16-7.16 16-16v-16h12c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32V16c0-8.84-7.16-16-16-16h-64c-8.84 0-16 7.16-16 16v16c-17.67 0-32 14.33-32 32v224c0 17.67 14.33 32 32 32zm304 128h-1.29C493.24 413.99 512 369.2 512 320c0-105.88-86.12-192-192-192v64c70.58 0 128 57.42 128 128s-57.42 128-128 128H48c-26.51 0-48 21.49-48 48 0 8.84 7.16 16 16 16h480c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48zm-360-32h208c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8H104c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8z"
        ],
        "minus": [
            448,
            512,
            [],
            "f068",
            "M416 208H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h384c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
        ],
        "minus-circle": [
            512,
            512,
            [],
            "f056",
            "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zM124 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H124z"
        ],
        "minus-square": [
            448,
            512,
            [],
            "f146",
            "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM92 296c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h264c6.6 0 12 5.4 12 12v56c0 6.6-5.4 12-12 12H92z"
        ],
        "mitten": [
            448,
            512,
            [],
            "f7b5",
            "M368 416H48c-8.8 0-16 7.2-16 16v64c0 8.8 7.2 16 16 16h320c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16zm57-209.1c-27.2-22.6-67.5-19-90.1 8.2l-20.9 25-29.6-128.4c-18-77.5-95.4-125.9-172.8-108C34.2 21.6-14.2 98.9 3.7 176.4L51.6 384h309l72.5-87c22.7-27.2 19-67.5-8.1-90.1z"
        ],
        "mobile": [
            320,
            512,
            [],
            "f10b",
            "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
        ],
        "mobile-alt": [
            320,
            512,
            [],
            "f3cd",
            "M272 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h224c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM160 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm112-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v312z"
        ],
        "money-bill": [
            640,
            512,
            [],
            "f0d6",
            "M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 176c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 48h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"
        ],
        "money-bill-alt": [
            640,
            512,
            [],
            "f3d1",
            "M352 288h-16v-88c0-4.42-3.58-8-8-8h-13.58c-4.74 0-9.37 1.4-13.31 4.03l-15.33 10.22a7.994 7.994 0 0 0-2.22 11.09l8.88 13.31a7.994 7.994 0 0 0 11.09 2.22l.47-.31V288h-16c-4.42 0-8 3.58-8 8v16c0 4.42 3.58 8 8 8h64c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zM608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM48 400v-64c35.35 0 64 28.65 64 64H48zm0-224v-64h64c0 35.35-28.65 64-64 64zm272 192c-53.02 0-96-50.15-96-112 0-61.86 42.98-112 96-112s96 50.14 96 112c0 61.87-43 112-96 112zm272 32h-64c0-35.35 28.65-64 64-64v64zm0-224c-35.35 0-64-28.65-64-64h64v64z"
        ],
        "money-bill-wave": [
            640,
            512,
            [],
            "f53a",
            "M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM48 132.22c20.12 5.04 41.12 7.57 62.72 8.93C104.84 170.54 79 192.69 48 192.69v-60.47zm0 285v-47.78c34.37 0 62.18 27.27 63.71 61.4-22.53-1.81-43.59-6.31-63.71-13.62zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96zm272 27.78c-17.52-4.39-35.71-6.85-54.32-8.44 5.87-26.08 27.5-45.88 54.32-49.28v57.72zm0-236.11c-30.89-3.91-54.86-29.7-55.81-61.55 19.54 2.17 38.09 6.23 55.81 12.66v48.89z"
        ],
        "money-bill-wave-alt": [
            640,
            512,
            [],
            "f53b",
            "M621.16 54.46C582.37 38.19 543.55 32 504.75 32c-123.17-.01-246.33 62.34-369.5 62.34-30.89 0-61.76-3.92-92.65-13.72-3.47-1.1-6.95-1.62-10.35-1.62C15.04 79 0 92.32 0 110.81v317.26c0 12.63 7.23 24.6 18.84 29.46C57.63 473.81 96.45 480 135.25 480c123.17 0 246.34-62.35 369.51-62.35 30.89 0 61.76 3.92 92.65 13.72 3.47 1.1 6.95 1.62 10.35 1.62 17.21 0 32.25-13.32 32.25-31.81V83.93c-.01-12.64-7.24-24.6-18.85-29.47zM320 352c-44.19 0-80-42.99-80-96 0-53.02 35.82-96 80-96s80 42.98 80 96c0 53.03-35.83 96-80 96z"
        ],
        "money-check": [
            640,
            512,
            [],
            "f53c",
            "M0 448c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V128H0v320zm448-208c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-96c-8.84 0-16-7.16-16-16v-32zm0 120c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H456c-4.42 0-8-3.58-8-8v-16zM64 264c0-4.42 3.58-8 8-8h304c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zm0 96c0-4.42 3.58-8 8-8h176c4.42 0 8 3.58 8 8v16c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16zM624 32H16C7.16 32 0 39.16 0 48v48h640V48c0-8.84-7.16-16-16-16z"
        ],
        "money-check-alt": [
            640,
            512,
            [],
            "f53d",
            "M608 32H32C14.33 32 0 46.33 0 64v384c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zM176 327.88V344c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-16.29c-11.29-.58-22.27-4.52-31.37-11.35-3.9-2.93-4.1-8.77-.57-12.14l11.75-11.21c2.77-2.64 6.89-2.76 10.13-.73 3.87 2.42 8.26 3.72 12.82 3.72h28.11c6.5 0 11.8-5.92 11.8-13.19 0-5.95-3.61-11.19-8.77-12.73l-45-13.5c-18.59-5.58-31.58-23.42-31.58-43.39 0-24.52 19.05-44.44 42.67-45.07V152c0-4.42 3.58-8 8-8h16c4.42 0 8 3.58 8 8v16.29c11.29.58 22.27 4.51 31.37 11.35 3.9 2.93 4.1 8.77.57 12.14l-11.75 11.21c-2.77 2.64-6.89 2.76-10.13.73-3.87-2.43-8.26-3.72-12.82-3.72h-28.11c-6.5 0-11.8 5.92-11.8 13.19 0 5.95 3.61 11.19 8.77 12.73l45 13.5c18.59 5.58 31.58 23.42 31.58 43.39 0 24.53-19.05 44.44-42.67 45.07zM416 312c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h112c4.42 0 8 3.58 8 8v16zm160 0c0 4.42-3.58 8-8 8h-80c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h80c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H296c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h272c4.42 0 8 3.58 8 8v16z"
        ],
        "monument": [
            384,
            512,
            [],
            "f5a6",
            "M368 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h352c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-78.86-347.26a31.97 31.97 0 0 0-9.21-19.44L203.31 4.69c-6.25-6.25-16.38-6.25-22.63 0l-76.6 76.61a31.97 31.97 0 0 0-9.21 19.44L64 416h256l-30.86-315.26zM240 307.2c0 6.4-6.4 12.8-12.8 12.8h-70.4c-6.4 0-12.8-6.4-12.8-12.8v-38.4c0-6.4 6.4-12.8 12.8-12.8h70.4c6.4 0 12.8 6.4 12.8 12.8v38.4z"
        ],
        "moon": [
            512,
            512,
            [],
            "f186",
            "M283.211 512c78.962 0 151.079-35.925 198.857-94.792 7.068-8.708-.639-21.43-11.562-19.35-124.203 23.654-238.262-71.576-238.262-196.954 0-72.222 38.662-138.635 101.498-174.394 9.686-5.512 7.25-20.197-3.756-22.23A258.156 258.156 0 0 0 283.211 0c-141.309 0-256 114.511-256 256 0 141.309 114.511 256 256 256z"
        ],
        "mortar-pestle": [
            512,
            512,
            [],
            "f5a7",
            "M501.54 60.91c17.22-17.22 12.51-46.25-9.27-57.14a35.696 35.696 0 0 0-37.37 3.37L251.09 160h151.37l99.08-99.09zM496 192H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c0 80.98 50.2 150.11 121.13 178.32-12.76 16.87-21.72 36.8-24.95 58.69-1.46 9.92 6.04 18.98 16.07 18.98h223.5c10.03 0 17.53-9.06 16.07-18.98-3.22-21.89-12.18-41.82-24.95-58.69C429.8 406.11 480 336.98 480 256h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16z"
        ],
        "mosque": [
            640,
            512,
            [],
            "f678",
            "M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z"
        ],
        "motorcycle": [
            640,
            512,
            [],
            "f21c",
            "M512.9 192c-14.9-.1-29.1 2.3-42.4 6.9L437.6 144H520c13.3 0 24-10.7 24-24V88c0-13.3-10.7-24-24-24h-45.3c-6.8 0-13.3 2.9-17.8 7.9l-37.5 41.7-22.8-38C392.2 68.4 384.4 64 376 64h-80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h66.4l19.2 32H227.9c-17.7-23.1-44.9-40-99.9-40H72.5C59 104 47.7 115 48 128.5c.2 13 10.9 23.5 24 23.5h56c24.5 0 38.7 10.9 47.8 24.8l-11.3 20.5c-13-3.9-26.9-5.7-41.3-5.2C55.9 194.5 1.6 249.6 0 317c-1.6 72.1 56.3 131 128 131 59.6 0 109.7-40.8 124-96h84.2c13.7 0 24.6-11.4 24-25.1-2.1-47.1 17.5-93.7 56.2-125l12.5 20.8c-27.6 23.7-45.1 58.9-44.8 98.2.5 69.6 57.2 126.5 126.8 127.1 71.6.7 129.8-57.5 129.2-129.1-.7-69.6-57.6-126.4-127.2-126.9zM128 400c-44.1 0-80-35.9-80-80s35.9-80 80-80c4.2 0 8.4.3 12.5 1L99 316.4c-8.8 16 2.8 35.6 21 35.6h81.3c-12.4 28.2-40.6 48-73.3 48zm463.9-75.6c-2.2 40.6-35 73.4-75.5 75.5-46.1 2.5-84.4-34.3-84.4-79.9 0-21.4 8.4-40.8 22.1-55.1l49.4 82.4c4.5 7.6 14.4 10 22 5.5l13.7-8.2c7.6-4.5 10-14.4 5.5-22l-48.6-80.9c5.2-1.1 10.5-1.6 15.9-1.6 45.6-.1 82.3 38.2 79.9 84.3z"
        ],
        "mountain": [
            640,
            512,
            [],
            "f6fc",
            "M634.92 462.7l-288-448C341.03 5.54 330.89 0 320 0s-21.03 5.54-26.92 14.7l-288 448a32.001 32.001 0 0 0-1.17 32.64A32.004 32.004 0 0 0 32 512h576c11.71 0 22.48-6.39 28.09-16.67a31.983 31.983 0 0 0-1.17-32.63zM320 91.18L405.39 224H320l-64 64-38.06-38.06L320 91.18z"
        ],
        "mouse": [
            384,
            512,
            [],
            "f8cc",
            "M0 352a160 160 0 0 0 160 160h64a160 160 0 0 0 160-160V224H0zM176 0h-16A160 160 0 0 0 0 160v32h176zm48 0h-16v192h176v-32A160 160 0 0 0 224 0z"
        ],
        "mouse-pointer": [
            320,
            512,
            [],
            "f245",
            "M302.189 329.126H196.105l55.831 135.993c3.889 9.428-.555 19.999-9.444 23.999l-49.165 21.427c-9.165 4-19.443-.571-23.332-9.714l-53.053-129.136-86.664 89.138C18.729 472.71 0 463.554 0 447.977V18.299C0 1.899 19.921-6.096 30.277 5.443l284.412 292.542c11.472 11.179 3.007 31.141-12.5 31.141z"
        ],
        "mug-hot": [
            512,
            512,
            [],
            "f7b6",
            "M127.1 146.5c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C111.8 5.9 105 0 96.8 0H80.4C70.6 0 63 8.5 64.1 18c3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zm112 0c1.3 7.7 8 13.5 16 13.5h16.5c9.8 0 17.6-8.5 16.3-18-3.8-28.2-16.4-54.2-36.6-74.7-14.4-14.7-23.6-33.3-26.4-53.5C223.8 5.9 217 0 208.8 0h-16.4c-9.8 0-17.5 8.5-16.3 18 3.9 31.9 18 61.3 40.6 84.4 12 12.2 19.7 27.5 22.4 44.1zM400 192H32c-17.7 0-32 14.3-32 32v192c0 53 43 96 96 96h192c53 0 96-43 96-96h16c61.8 0 112-50.2 112-112s-50.2-112-112-112zm0 160h-16v-96h16c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
        ],
        "music": [
            512,
            512,
            [],
            "f001",
            "M470.38 1.51L150.41 96A32 32 0 0 0 128 126.51v261.41A139 139 0 0 0 96 384c-53 0-96 28.66-96 64s43 64 96 64 96-28.66 96-64V214.32l256-75v184.61a138.4 138.4 0 0 0-32-3.93c-53 0-96 28.66-96 64s43 64 96 64 96-28.65 96-64V32a32 32 0 0 0-41.62-30.49z"
        ],
        "network-wired": [
            640,
            512,
            [],
            "f6ff",
            "M640 264v-16c0-8.84-7.16-16-16-16H344v-40h72c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H224c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h72v40H16c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h104v40H64c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h304v40h-56c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h160c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32h-56v-40h104c8.84 0 16-7.16 16-16zM256 128V64h128v64H256zm-64 320H96v-64h96v64zm352 0h-96v-64h96v64z"
        ],
        "neuter": [
            288,
            512,
            [],
            "f22c",
            "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V468c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12V316.4c64.1-14.5 112-71.9 112-140.4zm-144 80c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
        ],
        "newspaper": [
            576,
            512,
            [],
            "f1ea",
            "M552 64H88c-13.255 0-24 10.745-24 24v8H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h472c26.51 0 48-21.49 48-48V88c0-13.255-10.745-24-24-24zM56 400a8 8 0 0 1-8-8V144h16v248a8 8 0 0 1-8 8zm236-16H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm-208-96H140c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm208 0H348c-6.627 0-12-5.373-12-12v-8c0-6.627 5.373-12 12-12h152c6.627 0 12 5.373 12 12v8c0 6.627-5.373 12-12 12zm0-96H140c-6.627 0-12-5.373-12-12v-40c0-6.627 5.373-12 12-12h360c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12z"
        ],
        "not-equal": [
            448,
            512,
            [],
            "f53e",
            "M416 208c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32h-23.88l51.87-66.81c5.37-7.02 4.04-17.06-2.97-22.43L415.61 3.3c-7.02-5.38-17.06-4.04-22.44 2.97L311.09 112H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h204.56l-74.53 96H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h55.49l-51.87 66.81c-5.37 7.01-4.04 17.05 2.97 22.43L64 508.7c7.02 5.38 17.06 4.04 22.43-2.97L168.52 400H416c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32H243.05l74.53-96H416z"
        ],
        "notes-medical": [
            384,
            512,
            [],
            "f481",
            "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm96 304c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48zm0-192c0 4.4-3.6 8-8 8H104c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h176c4.4 0 8 3.6 8 8v16z"
        ],
        "object-group": [
            512,
            512,
            [],
            "f247",
            "M480 128V96h20c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v20H64V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v40c0 6.627 5.373 12 12 12h20v320H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-20h384v20c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-20V128zM96 276V140c0-6.627 5.373-12 12-12h168c6.627 0 12 5.373 12 12v136c0 6.627-5.373 12-12 12H108c-6.627 0-12-5.373-12-12zm320 96c0 6.627-5.373 12-12 12H236c-6.627 0-12-5.373-12-12v-52h72c13.255 0 24-10.745 24-24v-72h84c6.627 0 12 5.373 12 12v136z"
        ],
        "object-ungroup": [
            576,
            512,
            [],
            "f248",
            "M64 320v26a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6v-52a6 6 0 0 1 6-6h26V96H6a6 6 0 0 1-6-6V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v26h288V38a6 6 0 0 1 6-6h52a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-26v192h26a6 6 0 0 1 6 6v52a6 6 0 0 1-6 6h-52a6 6 0 0 1-6-6v-26H64zm480-64v-32h26a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-52a6 6 0 0 0-6 6v26H408v72h8c13.255 0 24 10.745 24 24v64c0 13.255-10.745 24-24 24h-64c-13.255 0-24-10.745-24-24v-8H192v72h-26a6 6 0 0 0-6 6v52a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-26h288v26a6 6 0 0 0 6 6h52a6 6 0 0 0 6-6v-52a6 6 0 0 0-6-6h-26V256z"
        ],
        "oil-can": [
            640,
            512,
            [],
            "f613",
            "M629.8 160.31L416 224l-50.49-25.24a64.07 64.07 0 0 0-28.62-6.76H280v-48h56c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16H176c-8.84 0-16 7.16-16 16v16c0 8.84 7.16 16 16 16h56v48h-56L37.72 166.86a31.9 31.9 0 0 0-5.79-.53C14.67 166.33 0 180.36 0 198.34v94.95c0 15.46 11.06 28.72 26.28 31.48L96 337.46V384c0 17.67 14.33 32 32 32h274.63c8.55 0 16.75-3.42 22.76-9.51l212.26-214.75c1.5-1.5 2.34-3.54 2.34-5.66V168c.01-5.31-5.08-9.15-10.19-7.69zM96 288.67l-48-8.73v-62.43l48 8.73v62.43zm453.33 84.66c0 23.56 19.1 42.67 42.67 42.67s42.67-19.1 42.67-42.67S592 288 592 288s-42.67 61.77-42.67 85.33z"
        ],
        "om": [
            512,
            512,
            [],
            "f679",
            "M360.6 60.94a10.43 10.43 0 0 0 14.76 0l21.57-21.56a10.43 10.43 0 0 0 0-14.76L375.35 3.06c-4.08-4.07-10.68-4.07-14.76 0l-21.57 21.56a10.43 10.43 0 0 0 0 14.76l21.58 21.56zM412.11 192c-26.69 0-51.77 10.39-70.64 29.25l-24.25 24.25c-6.78 6.77-15.78 10.5-25.38 10.5H245c10.54-22.1 14.17-48.11 7.73-75.23-10.1-42.55-46.36-76.11-89.52-83.19-36.15-5.93-70.9 5.04-96.01 28.78-7.36 6.96-6.97 18.85 1.12 24.93l26.15 19.63c5.72 4.3 13.66 4.32 19.2-.21 8.45-6.9 19.02-10.71 30.27-10.71 26.47 0 48.01 21.53 48.01 48s-21.54 48-48.01 48h-31.9c-11.96 0-19.74 12.58-14.39 23.28l16.09 32.17c2.53 5.06 7.6 8.1 13.17 8.55h33.03c35.3 0 64.01 28.7 64.01 64s-28.71 64-64.01 64c-96.02 0-122.35-54.02-145.15-92.03-4.53-7.55-14.77-3.58-14.79 5.22C-.09 416 41.13 512 159.94 512c70.59 0 128.02-57.42 128.02-128 0-23.42-6.78-45.1-17.81-64h21.69c26.69 0 51.77-10.39 70.64-29.25l24.25-24.25c6.78-6.77 15.78-10.5 25.38-10.5 19.78 0 35.88 16.09 35.88 35.88V392c0 13.23-18.77 24-32.01 24-39.4 0-66.67-24.24-81.82-42.89-4.77-5.87-14.2-2.54-14.2 5.02V416s0 64 96.02 64c48.54 0 96.02-39.47 96.02-88V291.88c0-55.08-44.8-99.88-99.89-99.88zm42.18-124.73c-85.55 65.12-169.05 2.75-172.58.05-6.02-4.62-14.44-4.38-20.14.55-5.74 4.92-7.27 13.17-3.66 19.8 1.61 2.95 40.37 72.34 118.8 72.34 79.92 0 98.78-31.36 101.75-37.66 1.02-2.12 1.53-4.47 1.53-6.83V80c0-13.22-15.14-20.69-25.7-12.73z"
        ],
        "otter": [
            640,
            512,
            [],
            "f700",
            "M608 32h-32l-13.25-13.25A63.97 63.97 0 0 0 517.49 0H497c-11.14 0-22.08 2.91-31.75 8.43L312 96h-56C149.96 96 64 181.96 64 288v1.61c0 32.75-16 62.14-39.56 84.89-18.19 17.58-28.1 43.68-23.19 71.8 6.76 38.8 42.9 65.7 82.28 65.7H192c17.67 0 32-14.33 32-32s-14.33-32-32-32H80c-8.83 0-16-7.17-16-16s7.17-16 16-16h224c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-64l149.49-80.5L448 416h80c8.84 0 16-7.16 16-16v-16c0-17.67-14.33-32-32-32h-28.22l-55.11-110.21L521.14 192H544c53.02 0 96-42.98 96-96V64c0-17.67-14.33-32-32-32zm-96 16c8.84 0 16 7.16 16 16s-7.16 16-16 16-16-7.16-16-16 7.16-16 16-16zm32 96h-34.96L407.2 198.84l-13.77-27.55L512 112h77.05c-6.62 18.58-24.22 32-45.05 32z"
        ],
        "outdent": [
            448,
            512,
            [],
            "f03b",
            "M100.69 363.29c10 10 27.31 2.93 27.31-11.31V160c0-14.32-17.33-21.31-27.31-11.31l-96 96a16 16 0 0 0 0 22.62zM432 416H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm3.17-128H204.83A12.82 12.82 0 0 0 192 300.83v38.34A12.82 12.82 0 0 0 204.83 352h230.34A12.82 12.82 0 0 0 448 339.17v-38.34A12.82 12.82 0 0 0 435.17 288zm0-128H204.83A12.82 12.82 0 0 0 192 172.83v38.34A12.82 12.82 0 0 0 204.83 224h230.34A12.82 12.82 0 0 0 448 211.17v-38.34A12.82 12.82 0 0 0 435.17 160zM432 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
        ],
        "pager": [
            512,
            512,
            [],
            "f815",
            "M448 64H64a64 64 0 0 0-64 64v256a64 64 0 0 0 64 64h384a64 64 0 0 0 64-64V128a64 64 0 0 0-64-64zM160 368H80a16 16 0 0 1-16-16v-16a16 16 0 0 1 16-16h80zm128-16a16 16 0 0 1-16 16h-80v-48h80a16 16 0 0 1 16 16zm160-128a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32v-64a32 32 0 0 1 32-32h320a32 32 0 0 1 32 32z"
        ],
        "paint-brush": [
            512,
            512,
            [],
            "f1fc",
            "M167.02 309.34c-40.12 2.58-76.53 17.86-97.19 72.3-2.35 6.21-8 9.98-14.59 9.98-11.11 0-45.46-27.67-55.25-34.35C0 439.62 37.93 512 128 512c75.86 0 128-43.77 128-120.19 0-3.11-.65-6.08-.97-9.13l-88.01-73.34zM457.89 0c-15.16 0-29.37 6.71-40.21 16.45C213.27 199.05 192 203.34 192 257.09c0 13.7 3.25 26.76 8.73 38.7l63.82 53.18c7.21 1.8 14.64 3.03 22.39 3.03 62.11 0 98.11-45.47 211.16-256.46 7.38-14.35 13.9-29.85 13.9-45.99C512 20.64 486 0 457.89 0z"
        ],
        "paint-roller": [
            512,
            512,
            [],
            "f5aa",
            "M416 128V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32h352c17.67 0 32-14.33 32-32zm32-64v128c0 17.67-14.33 32-32 32H256c-35.35 0-64 28.65-64 64v32c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32v-32h160c53.02 0 96-42.98 96-96v-64c0-35.35-28.65-64-64-64z"
        ],
        "palette": [
            512,
            512,
            [],
            "f53f",
            "M204.3 5C104.9 24.4 24.8 104.3 5.2 203.4c-37 187 131.7 326.4 258.8 306.7 41.2-6.4 61.4-54.6 42.5-91.7-23.1-45.4 9.9-98.4 60.9-98.4h79.7c35.8 0 64.8-29.6 64.9-65.3C511.5 97.1 368.1-26.9 204.3 5zM96 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm32-128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128-64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm128 64c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
        ],
        "pallet": [
            640,
            512,
            [],
            "f482",
            "M144 256h352c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H384v128l-64-32-64 32V0H144c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16zm480 128c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v64H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-64h48zm-336 64H128v-64h160v64zm224 0H352v-64h160v64z"
        ],
        "paper-plane": [
            512,
            512,
            [],
            "f1d8",
            "M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z"
        ],
        "paperclip": [
            448,
            512,
            [],
            "f0c6",
            "M43.246 466.142c-58.43-60.289-57.341-157.511 1.386-217.581L254.392 34c44.316-45.332 116.351-45.336 160.671 0 43.89 44.894 43.943 117.329 0 162.276L232.214 383.128c-29.855 30.537-78.633 30.111-107.982-.998-28.275-29.97-27.368-77.473 1.452-106.953l143.743-146.835c6.182-6.314 16.312-6.422 22.626-.241l22.861 22.379c6.315 6.182 6.422 16.312.241 22.626L171.427 319.927c-4.932 5.045-5.236 13.428-.648 18.292 4.372 4.634 11.245 4.711 15.688.165l182.849-186.851c19.613-20.062 19.613-52.725-.011-72.798-19.189-19.627-49.957-19.637-69.154 0L90.39 293.295c-34.763 35.56-35.299 93.12-1.191 128.313 34.01 35.093 88.985 35.137 123.058.286l172.06-175.999c6.177-6.319 16.307-6.433 22.626-.256l22.877 22.364c6.319 6.177 6.434 16.307.256 22.626l-172.06 175.998c-59.576 60.938-155.943 60.216-214.77-.485z"
        ],
        "parachute-box": [
            512,
            512,
            [],
            "f4cd",
            "M511.9 175c-9.1-75.6-78.4-132.4-158.3-158.7C390 55.7 416 116.9 416 192h28.1L327.5 321.5c-2.5-.6-4.8-1.5-7.5-1.5h-48V192h112C384 76.8 315.1 0 256 0S128 76.8 128 192h112v128h-48c-2.7 0-5 .9-7.5 1.5L67.9 192H96c0-75.1 26-136.3 62.4-175.7C78.5 42.7 9.2 99.5.1 175c-1.1 9.1 6.8 17 16 17h8.7l136.7 151.9c-.7 2.6-1.6 5.2-1.6 8.1v128c0 17.7 14.3 32 32 32h128c17.7 0 32-14.3 32-32V352c0-2.9-.9-5.4-1.6-8.1L487.1 192h8.7c9.3 0 17.2-7.8 16.1-17z"
        ],
        "paragraph": [
            448,
            512,
            [],
            "f1dd",
            "M448 48v32a16 16 0 0 1-16 16h-48v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V96h-32v368a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V352h-32a160 160 0 0 1 0-320h240a16 16 0 0 1 16 16z"
        ],
        "parking": [
            448,
            512,
            [],
            "f540",
            "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM240 320h-48v48c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16V144c0-8.8 7.2-16 16-16h96c52.9 0 96 43.1 96 96s-43.1 96-96 96zm0-128h-48v64h48c17.6 0 32-14.4 32-32s-14.4-32-32-32z"
        ],
        "passport": [
            448,
            512,
            [],
            "f5ab",
            "M129.62 176h39.09c1.49-27.03 6.54-51.35 14.21-70.41-27.71 13.24-48.02 39.19-53.3 70.41zm0 32c5.29 31.22 25.59 57.17 53.3 70.41-7.68-19.06-12.72-43.38-14.21-70.41h-39.09zM224 286.69c7.69-7.45 20.77-34.42 23.43-78.69h-46.87c2.67 44.26 15.75 71.24 23.44 78.69zM200.57 176h46.87c-2.66-44.26-15.74-71.24-23.43-78.69-7.7 7.45-20.78 34.43-23.44 78.69zm64.51 102.41c27.71-13.24 48.02-39.19 53.3-70.41h-39.09c-1.49 27.03-6.53 51.35-14.21 70.41zM416 0H64C28.65 0 0 28.65 0 64v384c0 35.35 28.65 64 64 64h352c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32zm-80 416H112c-8.8 0-16-7.2-16-16s7.2-16 16-16h224c8.8 0 16 7.2 16 16s-7.2 16-16 16zm-112-96c-70.69 0-128-57.31-128-128S153.31 64 224 64s128 57.31 128 128-57.31 128-128 128zm41.08-214.41c7.68 19.06 12.72 43.38 14.21 70.41h39.09c-5.28-31.22-25.59-57.17-53.3-70.41z"
        ],
        "pastafarianism": [
            640,
            512,
            [],
            "f67b",
            "M624.54 347.67c-32.7-12.52-57.36 4.25-75.37 16.45-17.06 11.53-23.25 14.42-31.41 11.36-8.12-3.09-10.83-9.38-15.89-29.38-3.33-13.15-7.44-29.32-17.95-42.65 2.24-2.91 4.43-5.79 6.38-8.57C500.47 304.45 513.71 312 532 312c33.95 0 50.87-25.78 62.06-42.83 10.59-16.14 15-21.17 21.94-21.17 13.25 0 24-10.75 24-24s-10.75-24-24-24c-33.95 0-50.87 25.78-62.06 42.83-10.6 16.14-15 21.17-21.94 21.17-17.31 0-37.48-61.43-97.26-101.91l17.25-34.5C485.43 125.5 512 97.98 512 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 13.02 3.94 25.1 10.62 35.21l-18.15 36.3c-16.98-4.6-35.6-7.51-56.46-7.51s-39.49 2.91-56.46 7.51l-18.15-36.3C252.06 89.1 256 77.02 256 64c0-35.35-28.65-64-64-64s-64 28.65-64 64c0 33.98 26.56 61.5 60.02 63.6l17.25 34.5C145.68 202.44 125.15 264 108 264c-6.94 0-11.34-5.03-21.94-21.17C74.88 225.78 57.96 200 24 200c-13.25 0-24 10.75-24 24s10.75 24 24 24c6.94 0 11.34 5.03 21.94 21.17C57.13 286.22 74.05 312 108 312c18.29 0 31.53-7.55 41.7-17.11 1.95 2.79 4.14 5.66 6.38 8.57-10.51 13.33-14.62 29.5-17.95 42.65-5.06 20-7.77 26.28-15.89 29.38-8.11 3.06-14.33.17-31.41-11.36-18.03-12.2-42.72-28.92-75.37-16.45-12.39 4.72-18.59 18.58-13.87 30.97 4.72 12.41 18.61 18.61 30.97 13.88 8.16-3.09 14.34-.19 31.39 11.36 13.55 9.16 30.83 20.86 52.42 20.84 7.17 0 14.83-1.28 22.97-4.39 32.66-12.44 39.98-41.33 45.33-62.44 2.21-8.72 3.99-14.49 5.95-18.87 16.62 13.61 36.95 25.88 61.64 34.17-9.96 37-32.18 90.8-60.26 90.8-13.25 0-24 10.75-24 24s10.75 24 24 24c66.74 0 97.05-88.63 107.42-129.14 6.69.6 13.42 1.14 20.58 1.14s13.89-.54 20.58-1.14C350.95 423.37 381.26 512 448 512c13.25 0 24-10.75 24-24s-10.75-24-24-24c-27.94 0-50.21-53.81-60.22-90.81 24.69-8.29 45-20.56 61.62-34.16 1.96 4.38 3.74 10.15 5.95 18.87 5.34 21.11 12.67 50 45.33 62.44 8.14 3.11 15.8 4.39 22.97 4.39 21.59 0 38.87-11.69 52.42-20.84 17.05-11.55 23.28-14.45 31.39-11.36 12.39 4.75 26.27-1.47 30.97-13.88 4.71-12.4-1.49-26.26-13.89-30.98zM448 48c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16zm-256 0c8.82 0 16 7.18 16 16s-7.18 16-16 16-16-7.18-16-16 7.18-16 16-16z"
        ],
        "paste": [
            448,
            512,
            [],
            "f0ea",
            "M128 184c0-30.879 25.122-56 56-56h136V56c0-13.255-10.745-24-24-24h-80.61C204.306 12.89 183.637 0 160 0s-44.306 12.89-55.39 32H24C10.745 32 0 42.745 0 56v336c0 13.255 10.745 24 24 24h104V184zm32-144c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24zm184 248h104v200c0 13.255-10.745 24-24 24H184c-13.255 0-24-10.745-24-24V184c0-13.255 10.745-24 24-24h136v104c0 13.2 10.8 24 24 24zm104-38.059V256h-96v-96h6.059a24 24 0 0 1 16.97 7.029l65.941 65.941a24.002 24.002 0 0 1 7.03 16.971z"
        ],
        "pause": [
            448,
            512,
            [],
            "f04c",
            "M144 479H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zm304-48V79c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v352c0 26.5 21.5 48 48 48h96c26.5 0 48-21.5 48-48z"
        ],
        "pause-circle": [
            512,
            512,
            [],
            "f28b",
            "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-16 328c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160zm112 0c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v160z"
        ],
        "paw": [
            512,
            512,
            [],
            "f1b0",
            "M256 224c-79.41 0-192 122.76-192 200.25 0 34.9 26.81 55.75 71.74 55.75 48.84 0 81.09-25.08 120.26-25.08 39.51 0 71.85 25.08 120.26 25.08 44.93 0 71.74-20.85 71.74-55.75C448 346.76 335.41 224 256 224zm-147.28-12.61c-10.4-34.65-42.44-57.09-71.56-50.13-29.12 6.96-44.29 40.69-33.89 75.34 10.4 34.65 42.44 57.09 71.56 50.13 29.12-6.96 44.29-40.69 33.89-75.34zm84.72-20.78c30.94-8.14 46.42-49.94 34.58-93.36s-46.52-72.01-77.46-63.87-46.42 49.94-34.58 93.36c11.84 43.42 46.53 72.02 77.46 63.87zm281.39-29.34c-29.12-6.96-61.15 15.48-71.56 50.13-10.4 34.65 4.77 68.38 33.89 75.34 29.12 6.96 61.15-15.48 71.56-50.13 10.4-34.65-4.77-68.38-33.89-75.34zm-156.27 29.34c30.94 8.14 65.62-20.45 77.46-63.87 11.84-43.42-3.64-85.21-34.58-93.36s-65.62 20.45-77.46 63.87c-11.84 43.42 3.64 85.22 34.58 93.36z"
        ],
        "peace": [
            496,
            512,
            [],
            "f67c",
            "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm184 248c0 31.93-8.2 61.97-22.57 88.17L280 240.63V74.97c86.23 15.21 152 90.5 152 181.03zM216 437.03c-33.86-5.97-64.49-21.2-89.29-43.02L216 322.57v114.46zm64-114.46L369.29 394c-24.8 21.82-55.43 37.05-89.29 43.02V322.57zm-64-247.6v165.66L86.57 344.17C72.2 317.97 64 287.93 64 256c0-90.53 65.77-165.82 152-181.03z"
        ],
        "pen": [
            512,
            512,
            [],
            "f304",
            "M290.74 93.24l128.02 128.02-277.99 277.99-114.14 12.6C11.35 513.54-1.56 500.62.14 485.34l12.7-114.22 277.9-277.88zm207.2-19.06l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.76 18.75-49.16 0-67.91z"
        ],
        "pen-alt": [
            512,
            512,
            [],
            "f305",
            "M497.94 74.17l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91zm-246.8-20.53c-15.62-15.62-40.94-15.62-56.56 0L75.8 172.43c-6.25 6.25-6.25 16.38 0 22.62l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l101.82-101.82 22.63 22.62L93.95 290.03A327.038 327.038 0 0 0 .17 485.11l-.03.23c-1.7 15.28 11.21 28.2 26.49 26.51a327.02 327.02 0 0 0 195.34-93.8l196.79-196.79-82.77-82.77-84.85-84.85z"
        ],
        "pen-fancy": [
            512,
            512,
            [],
            "f5ac",
            "M79.18 282.94a32.005 32.005 0 0 0-20.24 20.24L0 480l4.69 4.69 92.89-92.89c-.66-2.56-1.57-5.03-1.57-7.8 0-17.67 14.33-32 32-32s32 14.33 32 32-14.33 32-32 32c-2.77 0-5.24-.91-7.8-1.57l-92.89 92.89L32 512l176.82-58.94a31.983 31.983 0 0 0 20.24-20.24l33.07-84.07-98.88-98.88-84.07 33.07zM369.25 28.32L186.14 227.81l97.85 97.85 199.49-183.11C568.4 67.48 443.73-55.94 369.25 28.32z"
        ],
        "pen-nib": [
            512,
            512,
            [],
            "f5ad",
            "M136.6 138.79a64.003 64.003 0 0 0-43.31 41.35L0 460l14.69 14.69L164.8 324.58c-2.99-6.26-4.8-13.18-4.8-20.58 0-26.51 21.49-48 48-48s48 21.49 48 48-21.49 48-48 48c-7.4 0-14.32-1.81-20.58-4.8L37.31 497.31 52 512l279.86-93.29a64.003 64.003 0 0 0 41.35-43.31L416 224 288 96l-151.4 42.79zm361.34-64.62l-60.11-60.11c-18.75-18.75-49.16-18.75-67.91 0l-56.55 56.55 128.02 128.02 56.55-56.55c18.75-18.75 18.75-49.15 0-67.91z"
        ],
        "pen-square": [
            448,
            512,
            [],
            "f14b",
            "M400 480H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48v352c0 26.5-21.5 48-48 48zM238.1 177.9L102.4 313.6l-6.3 57.1c-.8 7.6 5.6 14.1 13.3 13.3l57.1-6.3L302.2 242c2.3-2.3 2.3-6.1 0-8.5L246.7 178c-2.5-2.4-6.3-2.4-8.6-.1zM345 165.1L314.9 135c-9.4-9.4-24.6-9.4-33.9 0l-23.1 23.1c-2.3 2.3-2.3 6.1 0 8.5l55.5 55.5c2.3 2.3 6.1 2.3 8.5 0L345 199c9.3-9.3 9.3-24.5 0-33.9z"
        ],
        "pencil-alt": [
            512,
            512,
            [],
            "f303",
            "M497.9 142.1l-46.1 46.1c-4.7 4.7-12.3 4.7-17 0l-111-111c-4.7-4.7-4.7-12.3 0-17l46.1-46.1c18.7-18.7 49.1-18.7 67.9 0l60.1 60.1c18.8 18.7 18.8 49.1 0 67.9zM284.2 99.8L21.6 362.4.4 483.9c-2.9 16.4 11.4 30.6 27.8 27.8l121.5-21.3 262.6-262.6c4.7-4.7 4.7-12.3 0-17l-111-111c-4.8-4.7-12.4-4.7-17.1 0zM124.1 339.9c-5.5-5.5-5.5-14.3 0-19.8l154-154c5.5-5.5 14.3-5.5 19.8 0s5.5 14.3 0 19.8l-154 154c-5.5 5.5-14.3 5.5-19.8 0zM88 424h48v36.3l-64.5 11.3-31.1-31.1L51.7 376H88v48z"
        ],
        "pencil-ruler": [
            512,
            512,
            [],
            "f5ae",
            "M109.46 244.04l134.58-134.56-44.12-44.12-61.68 61.68a7.919 7.919 0 0 1-11.21 0l-11.21-11.21c-3.1-3.1-3.1-8.12 0-11.21l61.68-61.68-33.64-33.65C131.47-3.1 111.39-3.1 99 9.29L9.29 99c-12.38 12.39-12.39 32.47 0 44.86l100.17 100.18zm388.47-116.8c18.76-18.76 18.75-49.17 0-67.93l-45.25-45.25c-18.76-18.76-49.18-18.76-67.95 0l-46.02 46.01 113.2 113.2 46.02-46.03zM316.08 82.71l-297 296.96L.32 487.11c-2.53 14.49 10.09 27.11 24.59 24.56l107.45-18.84L429.28 195.9 316.08 82.71zm186.63 285.43l-33.64-33.64-61.68 61.68c-3.1 3.1-8.12 3.1-11.21 0l-11.21-11.21c-3.09-3.1-3.09-8.12 0-11.21l61.68-61.68-44.14-44.14L267.93 402.5l100.21 100.2c12.39 12.39 32.47 12.39 44.86 0l89.71-89.7c12.39-12.39 12.39-32.47 0-44.86z"
        ],
        "people-arrows": [
            576,
            512,
            [],
            "e068",
            "M96,128A64,64,0,1,0,32,64,64,64,0,0,0,96,128Zm0,176.08a44.11,44.11,0,0,1,13.64-32L181.77,204c1.65-1.55,3.77-2.31,5.61-3.57A63.91,63.91,0,0,0,128,160H64A64,64,0,0,0,0,224v96a32,32,0,0,0,32,32V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V383.61l-50.36-47.53A44.08,44.08,0,0,1,96,304.08ZM480,128a64,64,0,1,0-64-64A64,64,0,0,0,480,128Zm32,32H448a63.91,63.91,0,0,0-59.38,40.42c1.84,1.27,4,2,5.62,3.59l72.12,68.06a44.37,44.37,0,0,1,0,64L416,383.62V480a32,32,0,0,0,32,32h64a32,32,0,0,0,32-32V352a32,32,0,0,0,32-32V224A64,64,0,0,0,512,160ZM444.4,295.34l-72.12-68.06A12,12,0,0,0,352,236v36H224V236a12,12,0,0,0-20.28-8.73L131.6,295.34a12.4,12.4,0,0,0,0,17.47l72.12,68.07A12,12,0,0,0,224,372.14V336H352v36.14a12,12,0,0,0,20.28,8.74l72.12-68.07A12.4,12.4,0,0,0,444.4,295.34Z"
        ],
        "people-carry": [
            640,
            512,
            [],
            "f4ce",
            "M128 96c26.5 0 48-21.5 48-48S154.5 0 128 0 80 21.5 80 48s21.5 48 48 48zm384 0c26.5 0 48-21.5 48-48S538.5 0 512 0s-48 21.5-48 48 21.5 48 48 48zm125.7 372.1l-44-110-41.1 46.4-2 18.2 27.7 69.2c5 12.5 17 20.1 29.7 20.1 4 0 8-.7 11.9-2.3 16.4-6.6 24.4-25.2 17.8-41.6zm-34.2-209.8L585 178.1c-4.6-20-18.6-36.8-37.5-44.9-18.5-8-39-6.7-56.1 3.3-22.7 13.4-39.7 34.5-48.1 59.4L432 229.8 416 240v-96c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v96l-16.1-10.2-11.3-33.9c-8.3-25-25.4-46-48.1-59.4-17.2-10-37.6-11.3-56.1-3.3-18.9 8.1-32.9 24.9-37.5 44.9l-18.4 80.2c-4.6 20 .7 41.2 14.4 56.7l67.2 75.9 10.1 92.6C130 499.8 143.8 512 160 512c1.2 0 2.3-.1 3.5-.2 17.6-1.9 30.2-17.7 28.3-35.3l-10.1-92.8c-1.5-13-6.9-25.1-15.6-35l-43.3-49 17.6-70.3 6.8 20.4c4.1 12.5 11.9 23.4 24.5 32.6l51.1 32.5c4.6 2.9 12.1 4.6 17.2 5h160c5.1-.4 12.6-2.1 17.2-5l51.1-32.5c12.6-9.2 20.4-20 24.5-32.6l6.8-20.4 17.6 70.3-43.3 49c-8.7 9.9-14.1 22-15.6 35l-10.1 92.8c-1.9 17.6 10.8 33.4 28.3 35.3 1.2.1 2.3.2 3.5.2 16.1 0 30-12.1 31.8-28.5l10.1-92.6 67.2-75.9c13.6-15.5 19-36.7 14.4-56.7zM46.3 358.1l-44 110c-6.6 16.4 1.4 35 17.8 41.6 16.8 6.6 35.1-1.7 41.6-17.8l27.7-69.2-2-18.2-41.1-46.4z"
        ],
        "pepper-hot": [
            512,
            512,
            [],
            "f816",
            "M330.67 263.12V173.4l-52.75-24.22C219.44 218.76 197.58 400 56 400a56 56 0 0 0 0 112c212.64 0 370.65-122.87 419.18-210.34l-37.05-38.54zm131.09-128.37C493.92 74.91 477.18 26.48 458.62 3a8 8 0 0 0-11.93-.59l-22.9 23a8.06 8.06 0 0 0-.89 10.23c6.86 10.36 17.05 35.1-1.4 72.32A142.85 142.85 0 0 0 364.34 96c-28 0-54 8.54-76.34 22.59l74.67 34.29v78.24h89.09L506.44 288c3.26-12.62 5.56-25.63 5.56-39.31a154 154 0 0 0-50.24-113.94z"
        ],
        "percent": [
            448,
            512,
            [],
            "f295",
            "M112 224c61.9 0 112-50.1 112-112S173.9 0 112 0 0 50.1 0 112s50.1 112 112 112zm0-160c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48 21.5-48 48-48zm224 224c-61.9 0-112 50.1-112 112s50.1 112 112 112 112-50.1 112-112-50.1-112-112-112zm0 160c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zM392.3.2l31.6-.1c19.4-.1 30.9 21.8 19.7 37.8L77.4 501.6a23.95 23.95 0 0 1-19.6 10.2l-33.4.1c-19.5 0-30.9-21.9-19.7-37.8l368-463.7C377.2 4 384.5.2 392.3.2z"
        ],
        "percentage": [
            384,
            512,
            [],
            "f541",
            "M109.25 173.25c24.99-24.99 24.99-65.52 0-90.51-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 25 25 65.52 25 90.51 0zm256 165.49c-24.99-24.99-65.52-24.99-90.51 0-24.99 24.99-24.99 65.52 0 90.51 24.99 24.99 65.52 24.99 90.51 0 25-24.99 25-65.51 0-90.51zm-1.94-231.43l-22.62-22.62c-12.5-12.5-32.76-12.5-45.25 0L20.69 359.44c-12.5 12.5-12.5 32.76 0 45.25l22.62 22.62c12.5 12.5 32.76 12.5 45.25 0l274.75-274.75c12.5-12.49 12.5-32.75 0-45.25z"
        ],
        "person-booth": [
            576,
            512,
            [],
            "f756",
            "M192 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320h-64v176zm32-272h-50.9l-45.2-45.3C115.8 166.6 99.7 160 82.7 160H64c-17.1 0-33.2 6.7-45.3 18.8C6.7 190.9 0 207 0 224.1L.2 320 0 480c0 17.7 14.3 32 31.9 32 17.6 0 32-14.3 32-32l.1-100.7c.9.5 1.6 1.3 2.5 1.7l29.1 43v56c0 17.7 14.3 32 32 32s32-14.3 32-32v-56.5c0-9.9-2.3-19.8-6.7-28.6l-41.2-61.3V253l20.9 20.9c9.1 9.1 21.1 14.1 33.9 14.1H224c17.7 0 32-14.3 32-32s-14.3-32-32-32zM64 128c26.5 0 48-21.5 48-48S90.5 32 64 32 16 53.5 16 80s21.5 48 48 48zm224-96l31.5 223.1-30.9 154.6c-4.3 21.6 13 38.3 31.4 38.3 15.2 0 28-9.1 32.3-30.4.9 16.9 14.6 30.4 31.7 30.4 17.7 0 32-14.3 32-32 0 17.7 14.3 32 32 32s32-14.3 32-32V0H288v32zm-96 0v160h64V0h-32c-17.7 0-32 14.3-32 32zM544 0h-32v496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V32c0-17.7-14.3-32-32-32z"
        ],
        "phone": [
            512,
            512,
            [],
            "f095",
            "M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z"
        ],
        "phone-alt": [
            512,
            512,
            [],
            "f879",
            "M497.39 361.8l-112-48a24 24 0 0 0-28 6.9l-49.6 60.6A370.66 370.66 0 0 1 130.6 204.11l60.6-49.6a23.94 23.94 0 0 0 6.9-28l-48-112A24.16 24.16 0 0 0 122.6.61l-104 24A24 24 0 0 0 0 48c0 256.5 207.9 464 464 464a24 24 0 0 0 23.4-18.6l24-104a24.29 24.29 0 0 0-14.01-27.6z"
        ],
        "phone-slash": [
            640,
            512,
            [],
            "f3dd",
            "M268.2 381.4l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48c-10.7 4.6-16.5 16.1-13.9 27.5l24 104c2.5 10.8 12.1 18.6 23.4 18.6 100.7 0 193.7-32.4 269.7-86.9l-80-61.8c-10.9 6.5-22.1 12.7-33.6 18.1zm365.6 76.7L475.1 335.5C537.9 256.4 576 156.9 576 48c0-11.2-7.7-20.9-18.6-23.4l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-12.2 26.1-27.9 50.3-46 72.8L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3z"
        ],
        "phone-square": [
            448,
            512,
            [],
            "f098",
            "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM94 416c-7.033 0-13.057-4.873-14.616-11.627l-14.998-65a15 15 0 0 1 8.707-17.16l69.998-29.999a15 15 0 0 1 17.518 4.289l30.997 37.885c48.944-22.963 88.297-62.858 110.781-110.78l-37.886-30.997a15.001 15.001 0 0 1-4.289-17.518l30-69.998a15 15 0 0 1 17.16-8.707l65 14.998A14.997 14.997 0 0 1 384 126c0 160.292-129.945 290-290 290z"
        ],
        "phone-square-alt": [
            448,
            512,
            [],
            "f87b",
            "M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h352a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48zm-16.39 307.37l-15 65A15 15 0 0 1 354 416C194 416 64 286.29 64 126a15.7 15.7 0 0 1 11.63-14.61l65-15A18.23 18.23 0 0 1 144 96a16.27 16.27 0 0 1 13.79 9.09l30 70A17.9 17.9 0 0 1 189 181a17 17 0 0 1-5.5 11.61l-37.89 31a231.91 231.91 0 0 0 110.78 110.78l31-37.89A17 17 0 0 1 299 291a17.85 17.85 0 0 1 5.91 1.21l70 30A16.25 16.25 0 0 1 384 336a17.41 17.41 0 0 1-.39 3.37z"
        ],
        "phone-volume": [
            384,
            512,
            [],
            "f2a0",
            "M97.333 506.966c-129.874-129.874-129.681-340.252 0-469.933 5.698-5.698 14.527-6.632 21.263-2.422l64.817 40.513a17.187 17.187 0 0 1 6.849 20.958l-32.408 81.021a17.188 17.188 0 0 1-17.669 10.719l-55.81-5.58c-21.051 58.261-20.612 122.471 0 179.515l55.811-5.581a17.188 17.188 0 0 1 17.669 10.719l32.408 81.022a17.188 17.188 0 0 1-6.849 20.958l-64.817 40.513a17.19 17.19 0 0 1-21.264-2.422zM247.126 95.473c11.832 20.047 11.832 45.008 0 65.055-3.95 6.693-13.108 7.959-18.718 2.581l-5.975-5.726c-3.911-3.748-4.793-9.622-2.261-14.41a32.063 32.063 0 0 0 0-29.945c-2.533-4.788-1.65-10.662 2.261-14.41l5.975-5.726c5.61-5.378 14.768-4.112 18.718 2.581zm91.787-91.187c60.14 71.604 60.092 175.882 0 247.428-4.474 5.327-12.53 5.746-17.552.933l-5.798-5.557c-4.56-4.371-4.977-11.529-.93-16.379 49.687-59.538 49.646-145.933 0-205.422-4.047-4.85-3.631-12.008.93-16.379l5.798-5.557c5.022-4.813 13.078-4.394 17.552.933zm-45.972 44.941c36.05 46.322 36.108 111.149 0 157.546-4.39 5.641-12.697 6.251-17.856 1.304l-5.818-5.579c-4.4-4.219-4.998-11.095-1.285-15.931 26.536-34.564 26.534-82.572 0-117.134-3.713-4.836-3.115-11.711 1.285-15.931l5.818-5.579c5.159-4.947 13.466-4.337 17.856 1.304z"
        ],
        "photo-video": [
            640,
            512,
            [],
            "f87c",
            "M608 0H160a32 32 0 0 0-32 32v96h160V64h192v320h128a32 32 0 0 0 32-32V32a32 32 0 0 0-32-32zM232 103a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm352 208a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9v-30a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm0-104a9 9 0 0 1-9 9h-30a9 9 0 0 1-9-9V73a9 9 0 0 1 9-9h30a9 9 0 0 1 9 9zm-168 57H32a32 32 0 0 0-32 32v288a32 32 0 0 0 32 32h384a32 32 0 0 0 32-32V192a32 32 0 0 0-32-32zM96 224a32 32 0 1 1-32 32 32 32 0 0 1 32-32zm288 224H64v-32l64-64 32 32 128-128 96 96z"
        ],
        "piggy-bank": [
            576,
            512,
            [],
            "f4d3",
            "M560 224h-29.5c-8.8-20-21.6-37.7-37.4-52.5L512 96h-32c-29.4 0-55.4 13.5-73 34.3-7.6-1.1-15.1-2.3-23-2.3H256c-77.4 0-141.9 55-156.8 128H56c-14.8 0-26.5-13.5-23.5-28.8C34.7 215.8 45.4 208 57 208h1c3.3 0 6-2.7 6-6v-20c0-3.3-2.7-6-6-6-28.5 0-53.9 20.4-57.5 48.6C-3.9 258.8 22.7 288 56 288h40c0 52.2 25.4 98.1 64 127.3V496c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-48h128v48c0 8.8 7.2 16 16 16h64c8.8 0 16-7.2 16-16v-80.7c11.8-8.9 22.3-19.4 31.3-31.3H560c8.8 0 16-7.2 16-16V240c0-8.8-7.2-16-16-16zm-128 64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zM256 96h128c5.4 0 10.7.4 15.9.8 0-.3.1-.5.1-.8 0-53-43-96-96-96s-96 43-96 96c0 2.1.5 4.1.6 6.2 15.2-3.9 31-6.2 47.4-6.2z"
        ],
        "pills": [
            576,
            512,
            [],
            "f484",
            "M112 32C50.1 32 0 82.1 0 144v224c0 61.9 50.1 112 112 112s112-50.1 112-112V144c0-61.9-50.1-112-112-112zm48 224H64V144c0-26.5 21.5-48 48-48s48 21.5 48 48v112zm139.7-29.7c-3.5-3.5-9.4-3.1-12.3.8-45.3 62.5-40.4 150.1 15.9 206.4 56.3 56.3 143.9 61.2 206.4 15.9 4-2.9 4.3-8.8.8-12.3L299.7 226.3zm229.8-19c-56.3-56.3-143.9-61.2-206.4-15.9-4 2.9-4.3 8.8-.8 12.3l210.8 210.8c3.5 3.5 9.4 3.1 12.3-.8 45.3-62.6 40.5-150.1-15.9-206.4z"
        ],
        "pizza-slice": [
            512,
            512,
            [],
            "f818",
            "M158.87.15c-16.16-1.52-31.2 8.42-35.33 24.12l-14.81 56.27c187.62 5.49 314.54 130.61 322.48 317l56.94-15.78c15.72-4.36 25.49-19.68 23.62-35.9C490.89 165.08 340.78 17.32 158.87.15zm-58.47 112L.55 491.64a16.21 16.21 0 0 0 20 19.75l379-105.1c-4.27-174.89-123.08-292.14-299.15-294.1zM128 416a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm48-152a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm104 104a32 32 0 1 1 32-32 32 32 0 0 1-32 32z"
        ],
        "place-of-worship": [
            640,
            512,
            [],
            "f67f",
            "M620.61 366.55L512 320v192h112c8.84 0 16-7.16 16-16V395.96a32 32 0 0 0-19.39-29.41zM0 395.96V496c0 8.84 7.16 16 16 16h112V320L19.39 366.55A32 32 0 0 0 0 395.96zm464.46-149.28L416 217.6V102.63c0-8.49-3.37-16.62-9.38-22.63L331.31 4.69c-6.25-6.25-16.38-6.25-22.62 0L233.38 80c-6 6-9.38 14.14-9.38 22.63V217.6l-48.46 29.08A31.997 31.997 0 0 0 160 274.12V512h96v-96c0-35.35 28.66-64 64-64s64 28.65 64 64v96h96V274.12c0-11.24-5.9-21.66-15.54-27.44z"
        ],
        "plane": [
            576,
            512,
            [],
            "f072",
            "M480 192H365.71L260.61 8.06A16.014 16.014 0 0 0 246.71 0h-65.5c-10.63 0-18.3 10.17-15.38 20.39L214.86 192H112l-43.2-57.6c-3.02-4.03-7.77-6.4-12.8-6.4H16.01C5.6 128-2.04 137.78.49 147.88L32 256 .49 364.12C-2.04 374.22 5.6 384 16.01 384H56c5.04 0 9.78-2.37 12.8-6.4L112 320h102.86l-49.03 171.6c-2.92 10.22 4.75 20.4 15.38 20.4h65.5c5.74 0 11.04-3.08 13.89-8.06L365.71 320H480c35.35 0 96-28.65 96-64s-60.65-64-96-64z"
        ],
        "plane-arrival": [
            640,
            512,
            [],
            "f5af",
            "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM44.81 205.66l88.74 80a62.607 62.607 0 0 0 25.47 13.93l287.6 78.35c26.48 7.21 54.56 8.72 81 1.36 29.67-8.27 43.44-21.21 47.25-35.71 3.83-14.5-1.73-32.71-23.37-54.96-19.28-19.82-44.35-32.79-70.83-40l-97.51-26.56L282.8 30.22c-1.51-5.81-5.95-10.35-11.66-11.91L206.05.58c-10.56-2.88-20.9 5.32-20.71 16.44l47.92 164.21-102.2-27.84-27.59-67.88c-1.93-4.89-6.01-8.57-11.02-9.93L52.72 64.75c-10.34-2.82-20.53 5-20.72 15.88l.23 101.78c.19 8.91 6.03 17.34 12.58 23.25z"
        ],
        "plane-departure": [
            640,
            512,
            [],
            "f5b0",
            "M624 448H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h608c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM80.55 341.27c6.28 6.84 15.1 10.72 24.33 10.71l130.54-.18a65.62 65.62 0 0 0 29.64-7.12l290.96-147.65c26.74-13.57 50.71-32.94 67.02-58.31 18.31-28.48 20.3-49.09 13.07-63.65-7.21-14.57-24.74-25.27-58.25-27.45-29.85-1.94-59.54 5.92-86.28 19.48l-98.51 49.99-218.7-82.06a17.799 17.799 0 0 0-18-1.11L90.62 67.29c-10.67 5.41-13.25 19.65-5.17 28.53l156.22 98.1-103.21 52.38-72.35-36.47a17.804 17.804 0 0 0-16.07.02L9.91 230.22c-10.44 5.3-13.19 19.12-5.57 28.08l76.21 82.97z"
        ],
        "plane-slash": [
            640,
            512,
            [],
            "e069",
            "M32.48,147.88,64,256,32.48,364.13A16,16,0,0,0,48,384H88a16,16,0,0,0,12.8-6.41L144,320H246.85l-49,171.59A16,16,0,0,0,213.2,512h65.5a16,16,0,0,0,13.89-8.06l66.6-116.54L34.35,136.34A15.47,15.47,0,0,0,32.48,147.88ZM633.82,458.09,455.14,320H512c35.34,0,96-28.66,96-64s-60.66-64-96-64H397.7L292.61,8.06C290.06,3.61,283.84,0,278.71,0H213.2a16,16,0,0,0-15.38,20.39l36.94,129.29L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09Z"
        ],
        "play": [
            448,
            512,
            [],
            "f04b",
            "M424.4 214.7L72.4 6.6C43.8-10.3 0 6.1 0 47.9V464c0 37.5 40.7 60.1 72.4 41.3l352-208c31.4-18.5 31.5-64.1 0-82.6z"
        ],
        "play-circle": [
            512,
            512,
            [],
            "f144",
            "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm115.7 272l-176 101c-15.8 8.8-35.7-2.5-35.7-21V152c0-18.4 19.8-29.8 35.7-21l176 107c16.4 9.2 16.4 32.9 0 42z"
        ],
        "plug": [
            384,
            512,
            [],
            "f1e6",
            "M320,32a32,32,0,0,0-64,0v96h64Zm48,128H16A16,16,0,0,0,0,176v32a16,16,0,0,0,16,16H32v32A160.07,160.07,0,0,0,160,412.8V512h64V412.8A160.07,160.07,0,0,0,352,256V224h16a16,16,0,0,0,16-16V176A16,16,0,0,0,368,160ZM128,32a32,32,0,0,0-64,0v96h64Z"
        ],
        "plus": [
            448,
            512,
            [],
            "f067",
            "M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z"
        ],
        "plus-circle": [
            512,
            512,
            [],
            "f055",
            "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"
        ],
        "plus-square": [
            448,
            512,
            [],
            "f0fe",
            "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-32 252c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92H92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z"
        ],
        "podcast": [
            448,
            512,
            [],
            "f2ce",
            "M267.429 488.563C262.286 507.573 242.858 512 224 512c-18.857 0-38.286-4.427-43.428-23.437C172.927 460.134 160 388.898 160 355.75c0-35.156 31.142-43.75 64-43.75s64 8.594 64 43.75c0 32.949-12.871 104.179-20.571 132.813zM156.867 288.554c-18.693-18.308-29.958-44.173-28.784-72.599 2.054-49.724 42.395-89.956 92.124-91.881C274.862 121.958 320 165.807 320 220c0 26.827-11.064 51.116-28.866 68.552-2.675 2.62-2.401 6.986.628 9.187 9.312 6.765 16.46 15.343 21.234 25.363 1.741 3.654 6.497 4.66 9.449 1.891 28.826-27.043 46.553-65.783 45.511-108.565-1.855-76.206-63.595-138.208-139.793-140.369C146.869 73.753 80 139.215 80 220c0 41.361 17.532 78.7 45.55 104.989 2.953 2.771 7.711 1.77 9.453-1.887 4.774-10.021 11.923-18.598 21.235-25.363 3.029-2.2 3.304-6.566.629-9.185zM224 0C100.204 0 0 100.185 0 224c0 89.992 52.602 165.647 125.739 201.408 4.333 2.118 9.267-1.544 8.535-6.31-2.382-15.512-4.342-30.946-5.406-44.339-.146-1.836-1.149-3.486-2.678-4.512-47.4-31.806-78.564-86.016-78.187-147.347.592-96.237 79.29-174.648 175.529-174.899C320.793 47.747 400 126.797 400 224c0 61.932-32.158 116.49-80.65 147.867-.999 14.037-3.069 30.588-5.624 47.23-.732 4.767 4.203 8.429 8.535 6.31C395.227 389.727 448 314.187 448 224 448 100.205 347.815 0 224 0zm0 160c-35.346 0-64 28.654-64 64s28.654 64 64 64 64-28.654 64-64-28.654-64-64-64z"
        ],
        "poll": [
            448,
            512,
            [],
            "f681",
            "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM160 368c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V240c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v128zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16V144c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v224zm96 0c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-64c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v64z"
        ],
        "poll-h": [
            448,
            512,
            [],
            "f682",
            "M448 432V80c0-26.5-21.5-48-48-48H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48zM112 192c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h128c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h224c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16H112zm0 96c-8.84 0-16-7.16-16-16v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32c0 8.84-7.16 16-16 16h-64z"
        ],
        "poo": [
            512,
            512,
            [],
            "f2fe",
            "M451.4 369.1C468.7 356 480 335.4 480 312c0-39.8-32.2-72-72-72h-14.1c13.4-11.7 22.1-28.8 22.1-48 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C250.3 14.6 256 30.6 256 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 19.2 8.7 36.3 22.1 48H104c-39.8 0-72 32.2-72 72 0 23.4 11.3 44 28.6 57.1C26.3 374.6 0 404.1 0 440c0 39.8 32.2 72 72 72h368c39.8 0 72-32.2 72-72 0-35.9-26.3-65.4-60.6-70.9zM192 256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm159.5 139C341 422.9 293 448 256 448s-85-25.1-95.5-53c-2-5.3 2-11 7.8-11h175.4c5.8 0 9.8 5.7 7.8 11zM320 320c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
        ],
        "poo-storm": [
            448,
            512,
            [],
            "f75a",
            "M308 336h-57.7l17.3-64.9c2-7.6-3.7-15.1-11.6-15.1h-68c-6 0-11.1 4.5-11.9 10.4l-16 120c-1 7.2 4.6 13.6 11.9 13.6h59.3l-23 97.2c-1.8 7.6 4 14.8 11.7 14.8 4.2 0 8.2-2.2 10.4-6l88-152c4.6-8-1.2-18-10.4-18zm66.4-111.3c5.9-9.6 9.6-20.6 9.6-32.7 0-35.3-28.7-64-64-64h-5.9c3.6-10.1 5.9-20.7 5.9-32 0-53-43-96-96-96-5.2 0-10.2.7-15.1 1.5C218.3 14.6 224 30.6 224 48c0 44.2-35.8 80-80 80h-16c-35.3 0-64 28.7-64 64 0 12.1 3.7 23.1 9.6 32.7C32.6 228 0 262.2 0 304c0 44 36 80 80 80h48.3c.1-.6 0-1.2 0-1.8l16-120c3-21.8 21.7-38.2 43.7-38.2h68c13.8 0 26.5 6.3 34.9 17.2s11.2 24.8 7.6 38.1l-6.6 24.7h16c15.7 0 30.3 8.4 38.1 22 7.8 13.6 7.8 30.5 0 44l-8.1 14h30c44 0 80-36 80-80 .1-41.8-32.5-76-73.5-79.3z"
        ],
        "poop": [
            512,
            512,
            [],
            "f619",
            "M451.36 369.14C468.66 355.99 480 335.41 480 312c0-39.77-32.24-72-72-72h-14.07c13.42-11.73 22.07-28.78 22.07-48 0-35.35-28.65-64-64-64h-5.88c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96-5.17 0-10.15.74-15.11 1.52C250.31 14.64 256 30.62 256 48c0 44.18-35.82 80-80 80h-16c-35.35 0-64 28.65-64 64 0 19.22 8.65 36.27 22.07 48H104c-39.76 0-72 32.23-72 72 0 23.41 11.34 43.99 28.64 57.14C26.31 374.62 0 404.12 0 440c0 39.76 32.24 72 72 72h368c39.76 0 72-32.24 72-72 0-35.88-26.31-65.38-60.64-70.86z"
        ],
        "portrait": [
            384,
            512,
            [],
            "f3e0",
            "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM192 128c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm112 236.8c0 10.6-10 19.2-22.4 19.2H102.4C90 384 80 375.4 80 364.8v-19.2c0-31.8 30.1-57.6 67.2-57.6h5c12.3 5.1 25.7 8 39.8 8s27.6-2.9 39.8-8h5c37.1 0 67.2 25.8 67.2 57.6v19.2z"
        ],
        "pound-sign": [
            320,
            512,
            [],
            "f154",
            "M308 352h-45.495c-6.627 0-12 5.373-12 12v50.848H128V288h84c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-84v-63.556c0-32.266 24.562-57.086 61.792-57.086 23.658 0 45.878 11.505 57.652 18.849 5.151 3.213 11.888 2.051 15.688-2.685l28.493-35.513c4.233-5.276 3.279-13.005-2.119-17.081C273.124 54.56 236.576 32 187.931 32 106.026 32 48 84.742 48 157.961V224H20c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h28v128H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h296c6.627 0 12-5.373 12-12V364c0-6.627-5.373-12-12-12z"
        ],
        "power-off": [
            512,
            512,
            [],
            "f011",
            "M400 54.1c63 45 104 118.6 104 201.9 0 136.8-110.8 247.7-247.5 248C120 504.3 8.2 393 8 256.4 7.9 173.1 48.9 99.3 111.8 54.2c11.7-8.3 28-4.8 35 7.7L162.6 90c5.9 10.5 3.1 23.8-6.6 31-41.5 30.8-68 79.6-68 134.9-.1 92.3 74.5 168.1 168 168.1 91.6 0 168.6-74.2 168-169.1-.3-51.8-24.7-101.8-68.1-134-9.7-7.2-12.4-20.5-6.5-30.9l15.8-28.1c7-12.4 23.2-16.1 34.8-7.8zM296 264V24c0-13.3-10.7-24-24-24h-32c-13.3 0-24 10.7-24 24v240c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24z"
        ],
        "pray": [
            384,
            512,
            [],
            "f683",
            "M256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-30.63 169.75c14.06 16.72 39 19.09 55.97 5.22l88-72.02c17.09-13.98 19.59-39.19 5.62-56.28-13.97-17.11-39.19-19.59-56.31-5.62l-57.44 47-38.91-46.31c-15.44-18.39-39.22-27.92-64-25.33-24.19 2.48-45.25 16.27-56.37 36.92l-49.37 92.03c-23.4 43.64-8.69 96.37 34.19 123.75L131.56 432H40c-22.09 0-40 17.91-40 40s17.91 40 40 40h208c34.08 0 53.77-42.79 28.28-68.28L166.42 333.86l34.8-64.87 24.15 28.76z"
        ],
        "praying-hands": [
            640,
            512,
            [],
            "f684",
            "M272 191.91c-17.6 0-32 14.4-32 32v80c0 8.84-7.16 16-16 16s-16-7.16-16-16v-76.55c0-17.39 4.72-34.47 13.69-49.39l77.75-129.59c9.09-15.16 4.19-34.81-10.97-43.91-14.45-8.67-32.72-4.3-42.3 9.21-.2.23-.62.21-.79.48l-117.26 175.9C117.56 205.9 112 224.31 112 243.29v80.23l-90.12 30.04A31.974 31.974 0 0 0 0 383.91v96c0 10.82 8.52 32 32 32 2.69 0 5.41-.34 8.06-1.03l179.19-46.62C269.16 449.99 304 403.8 304 351.91v-128c0-17.6-14.4-32-32-32zm346.12 161.73L528 323.6v-80.23c0-18.98-5.56-37.39-16.12-53.23L394.62 14.25c-.18-.27-.59-.24-.79-.48-9.58-13.51-27.85-17.88-42.3-9.21-15.16 9.09-20.06 28.75-10.97 43.91l77.75 129.59c8.97 14.92 13.69 32 13.69 49.39V304c0 8.84-7.16 16-16 16s-16-7.16-16-16v-80c0-17.6-14.4-32-32-32s-32 14.4-32 32v128c0 51.89 34.84 98.08 84.75 112.34l179.19 46.62c2.66.69 5.38 1.03 8.06 1.03 23.48 0 32-21.18 32-32v-96c0-13.77-8.81-25.99-21.88-30.35z"
        ],
        "prescription": [
            384,
            512,
            [],
            "f5b1",
            "M301.26 352l78.06-78.06c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0L256 306.74l-83.96-83.96C219.31 216.8 256 176.89 256 128c0-53.02-42.98-96-96-96H16C7.16 32 0 39.16 0 48v256c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-80h18.75l128 128-78.06 78.06c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0L256 397.25l78.06 78.06c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63L301.26 352zM64 96h96c17.64 0 32 14.36 32 32s-14.36 32-32 32H64V96z"
        ],
        "prescription-bottle": [
            384,
            512,
            [],
            "f485",
            "M32 192h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64h120c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H32v64c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v64zM360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24z"
        ],
        "prescription-bottle-alt": [
            384,
            512,
            [],
            "f486",
            "M360 0H24C10.8 0 0 10.8 0 24v48c0 13.2 10.8 24 24 24h336c13.2 0 24-10.8 24-24V24c0-13.2-10.8-24-24-24zM32 480c0 17.6 14.4 32 32 32h256c17.6 0 32-14.4 32-32V128H32v352zm64-184c0-4.4 3.6-8 8-8h56v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56h56c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8h-56v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56h-56c-4.4 0-8-3.6-8-8v-48z"
        ],
        "print": [
            512,
            512,
            [],
            "f02f",
            "M448 192V77.25c0-8.49-3.37-16.62-9.37-22.63L393.37 9.37c-6-6-14.14-9.37-22.63-9.37H96C78.33 0 64 14.33 64 32v160c-35.35 0-64 28.65-64 64v112c0 8.84 7.16 16 16 16h48v96c0 17.67 14.33 32 32 32h320c17.67 0 32-14.33 32-32v-96h48c8.84 0 16-7.16 16-16V256c0-35.35-28.65-64-64-64zm-64 256H128v-96h256v96zm0-224H128V64h192v48c0 8.84 7.16 16 16 16h48v96zm48 72c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
        ],
        "procedures": [
            640,
            512,
            [],
            "f487",
            "M528 224H272c-8.8 0-16 7.2-16 16v144H64V144c0-8.8-7.2-16-16-16H16c-8.8 0-16 7.2-16 16v352c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h512v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V336c0-61.9-50.1-112-112-112zM136 96h126.1l27.6 55.2c5.9 11.8 22.7 11.8 28.6 0L368 51.8 390.1 96H512c8.8 0 16-7.2 16-16s-7.2-16-16-16H409.9L382.3 8.8C376.4-3 359.6-3 353.7 8.8L304 108.2l-19.9-39.8c-1.4-2.7-4.1-4.4-7.2-4.4H136c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm24 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"
        ],
        "project-diagram": [
            640,
            512,
            [],
            "f542",
            "M384 320H256c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM192 32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v128c0 17.67 14.33 32 32 32h95.72l73.16 128.04C211.98 300.98 232.4 288 256 288h.28L192 175.51V128h224V64H192V32zM608 0H480c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h128c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32z"
        ],
        "pump-medical": [
            384,
            512,
            [],
            "e06a",
            "M235.51,159.82H84.24A64,64,0,0,0,20.51,218L.14,442a64,64,0,0,0,63.74,69.8h192A64,64,0,0,0,319.61,442L299.24,218A64,64,0,0,0,235.51,159.82Zm4.37,173.33a13.35,13.35,0,0,1-13.34,13.34h-40v40a13.33,13.33,0,0,1-13.33,13.33H146.54a13.33,13.33,0,0,1-13.33-13.33v-40h-40a13.34,13.34,0,0,1-13.33-13.34V306.49a13.33,13.33,0,0,1,13.33-13.34h40v-40a13.33,13.33,0,0,1,13.33-13.33h26.67a13.33,13.33,0,0,1,13.33,13.33v40h40a13.34,13.34,0,0,1,13.34,13.34ZM379.19,93.88,335.87,50.56a64,64,0,0,0-45.24-18.74H223.88a32,32,0,0,0-32-32h-64a32,32,0,0,0-32,32v96h128v-32h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.19,93.88Z"
        ],
        "pump-soap": [
            384,
            512,
            [],
            "e06b",
            "M235.63,160H84.37a64,64,0,0,0-63.74,58.21L.27,442.21A64,64,0,0,0,64,512H256a64,64,0,0,0,63.74-69.79l-20.36-224A64,64,0,0,0,235.63,160ZM160,416c-33.12,0-60-26.33-60-58.75,0-25,35.7-75.47,52-97.27A10,10,0,0,1,168,260c16.33,21.8,52,72.27,52,97.27C220,389.67,193.12,416,160,416ZM379.31,94.06,336,50.74A64,64,0,0,0,290.75,32H224A32,32,0,0,0,192,0H128A32,32,0,0,0,96,32v96H224V96h66.75l43.31,43.31a16,16,0,0,0,22.63,0l22.62-22.62A16,16,0,0,0,379.31,94.06Z"
        ],
        "puzzle-piece": [
            576,
            512,
            [],
            "f12e",
            "M519.442 288.651c-41.519 0-59.5 31.593-82.058 31.593C377.409 320.244 432 144 432 144s-196.288 80-196.288-3.297c0-35.827 36.288-46.25 36.288-85.985C272 19.216 243.885 0 210.539 0c-34.654 0-66.366 18.891-66.366 56.346 0 41.364 31.711 59.277 31.711 81.75C175.885 207.719 0 166.758 0 166.758v333.237s178.635 41.047 178.635-28.662c0-22.473-40-40.107-40-81.471 0-37.456 29.25-56.346 63.577-56.346 33.673 0 61.788 19.216 61.788 54.717 0 39.735-36.288 50.158-36.288 85.985 0 60.803 129.675 25.73 181.23 25.73 0 0-34.725-120.101 25.827-120.101 35.962 0 46.423 36.152 86.308 36.152C556.712 416 576 387.99 576 354.443c0-34.199-18.962-65.792-56.558-65.792z"
        ],
        "qrcode": [
            448,
            512,
            [],
            "f029",
            "M0 224h192V32H0v192zM64 96h64v64H64V96zm192-64v192h192V32H256zm128 128h-64V96h64v64zM0 480h192V288H0v192zm64-128h64v64H64v-64zm352-64h32v128h-96v-32h-32v96h-64V288h96v32h64v-32zm0 160h32v32h-32v-32zm-64 0h32v32h-32v-32z"
        ],
        "question": [
            384,
            512,
            [],
            "f128",
            "M202.021 0C122.202 0 70.503 32.703 29.914 91.026c-7.363 10.58-5.093 25.086 5.178 32.874l43.138 32.709c10.373 7.865 25.132 6.026 33.253-4.148 25.049-31.381 43.63-49.449 82.757-49.449 30.764 0 68.816 19.799 68.816 49.631 0 22.552-18.617 34.134-48.993 51.164-35.423 19.86-82.299 44.576-82.299 106.405V320c0 13.255 10.745 24 24 24h72.471c13.255 0 24-10.745 24-24v-5.773c0-42.86 125.268-44.645 125.268-160.627C377.504 66.256 286.902 0 202.021 0zM192 373.459c-38.196 0-69.271 31.075-69.271 69.271 0 38.195 31.075 69.27 69.271 69.27s69.271-31.075 69.271-69.271-31.075-69.27-69.271-69.27z"
        ],
        "question-circle": [
            512,
            512,
            [],
            "f059",
            "M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248zM262.655 90c-54.497 0-89.255 22.957-116.549 63.758-3.536 5.286-2.353 12.415 2.715 16.258l34.699 26.31c5.205 3.947 12.621 3.008 16.665-2.122 17.864-22.658 30.113-35.797 57.303-35.797 20.429 0 45.698 13.148 45.698 32.958 0 14.976-12.363 22.667-32.534 33.976C247.128 238.528 216 254.941 216 296v4c0 6.627 5.373 12 12 12h56c6.627 0 12-5.373 12-12v-1.333c0-28.462 83.186-29.647 83.186-106.667 0-58.002-60.165-102-116.531-102zM256 338c-25.365 0-46 20.635-46 46 0 25.364 20.635 46 46 46s46-20.636 46-46c0-25.365-20.635-46-46-46z"
        ],
        "quidditch": [
            640,
            512,
            [],
            "f458",
            "M256.5 216.8L343.2 326s-16.6 102.4-76.6 150.1C206.7 523.8 0 510.2 0 510.2s3.8-23.1 11-55.4l94.6-112.2c4-4.7-.9-11.6-6.6-9.5l-60.4 22.1c14.4-41.7 32.7-80 54.6-97.5 59.9-47.8 163.3-40.9 163.3-40.9zm238 135c-44 0-79.8 35.8-79.8 79.9 0 44.1 35.7 79.9 79.8 79.9 44.1 0 79.8-35.8 79.8-79.9 0-44.2-35.8-79.9-79.8-79.9zM636.5 31L616.7 6c-5.5-6.9-15.5-8-22.4-2.6L361.8 181.3l-34.1-43c-5.1-6.4-15.1-5.2-18.6 2.2l-25.3 54.6 86.7 109.2 58.8-12.4c8-1.7 11.4-11.2 6.3-17.6l-34.1-42.9L634 53.5c6.9-5.5 8-15.6 2.5-22.5z"
        ],
        "quote-left": [
            512,
            512,
            [],
            "f10d",
            "M464 256h-80v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8c-88.4 0-160 71.6-160 160v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zm-288 0H96v-64c0-35.3 28.7-64 64-64h8c13.3 0 24-10.7 24-24V56c0-13.3-10.7-24-24-24h-8C71.6 32 0 103.6 0 192v240c0 26.5 21.5 48 48 48h128c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
        ],
        "quote-right": [
            512,
            512,
            [],
            "f10e",
            "M464 32H336c-26.5 0-48 21.5-48 48v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48zm-288 0H48C21.5 32 0 53.5 0 80v128c0 26.5 21.5 48 48 48h80v64c0 35.3-28.7 64-64 64h-8c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24h8c88.4 0 160-71.6 160-160V80c0-26.5-21.5-48-48-48z"
        ],
        "quran": [
            448,
            512,
            [],
            "f687",
            "M448 358.4V25.6c0-16-9.6-25.6-25.6-25.6H96C41.6 0 0 41.6 0 96v320c0 54.4 41.6 96 96 96h326.4c12.8 0 25.6-9.6 25.6-25.6v-16c0-6.4-3.2-12.8-9.6-19.2-3.2-16-3.2-60.8 0-73.6 6.4-3.2 9.6-9.6 9.6-19.2zM301.08 145.82c.6-1.21 1.76-1.82 2.92-1.82s2.32.61 2.92 1.82l11.18 22.65 25 3.63c2.67.39 3.74 3.67 1.81 5.56l-18.09 17.63 4.27 24.89c.36 2.11-1.31 3.82-3.21 3.82-.5 0-1.02-.12-1.52-.38L304 211.87l-22.36 11.75c-.5.26-1.02.38-1.52.38-1.9 0-3.57-1.71-3.21-3.82l4.27-24.89-18.09-17.63c-1.94-1.89-.87-5.17 1.81-5.56l24.99-3.63 11.19-22.65zm-57.89-69.01c13.67 0 27.26 2.49 40.38 7.41a6.775 6.775 0 1 1-2.38 13.12c-.67 0-3.09-.21-4.13-.21-52.31 0-94.86 42.55-94.86 94.86 0 52.3 42.55 94.86 94.86 94.86 1.03 0 3.48-.21 4.13-.21 3.93 0 6.8 3.14 6.8 6.78 0 2.98-1.94 5.51-4.62 6.42-13.07 4.87-26.59 7.34-40.19 7.34C179.67 307.19 128 255.51 128 192c0-63.52 51.67-115.19 115.19-115.19zM380.8 448H96c-19.2 0-32-12.8-32-32s16-32 32-32h284.8v64z"
        ],
        "radiation": [
            496,
            512,
            [],
            "f7b9",
            "M328.2 255.8h151.6c9.1 0 16.8-7.7 16.2-16.8-5.1-75.8-44.4-142.2-102.5-184.2-7.4-5.3-17.9-2.9-22.7 4.8L290.4 188c22.6 14.3 37.8 39.2 37.8 67.8zm-37.8 67.7c-12.3 7.7-26.8 12.4-42.4 12.4-15.6 0-30-4.7-42.4-12.4L125.2 452c-4.8 7.7-2.4 18.1 5.6 22.4C165.7 493.2 205.6 504 248 504s82.3-10.8 117.2-29.6c8-4.3 10.4-14.8 5.6-22.4l-80.4-128.5zM248 303.8c26.5 0 48-21.5 48-48s-21.5-48-48-48-48 21.5-48 48 21.5 48 48 48zm-231.8-48h151.6c0-28.6 15.2-53.5 37.8-67.7L125.2 59.7c-4.8-7.7-15.3-10.2-22.7-4.8C44.4 96.9 5.1 163.3 0 239.1c-.6 9 7.1 16.7 16.2 16.7z"
        ],
        "radiation-alt": [
            496,
            512,
            [],
            "f7ba",
            "M312 256h79.1c9.2 0 16.9-7.7 16-16.8-4.6-43.6-27-81.8-59.5-107.8-7.6-6.1-18.8-4.5-24 3.8L281.9 202c18 11.2 30.1 31.2 30.1 54zm-97.8 54.1L172.4 377c-4.9 7.8-2.4 18.4 5.8 22.5 21.1 10.4 44.7 16.5 69.8 16.5s48.7-6.1 69.9-16.5c8.2-4.1 10.6-14.7 5.8-22.5l-41.8-66.9c-9.8 6.2-21.4 9.9-33.8 9.9s-24.1-3.7-33.9-9.9zM104.9 256H184c0-22.8 12.1-42.8 30.2-54.1l-41.7-66.8c-5.2-8.3-16.4-9.9-24-3.8-32.6 26-54.9 64.2-59.5 107.8-1.1 9.2 6.7 16.9 15.9 16.9zM248 504c137 0 248-111 248-248S385 8 248 8 0 119 0 256s111 248 248 248zm0-432c101.5 0 184 82.5 184 184s-82.5 184-184 184S64 357.5 64 256 146.5 72 248 72zm0 216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
        ],
        "rainbow": [
            576,
            512,
            [],
            "f75b",
            "M268.3 32.7C115.4 42.9 0 176.9 0 330.2V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C64 186.8 180.9 80.3 317.5 97.9 430.4 112.4 512 214 512 327.8V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-165.3-140-298.6-307.7-287.3zm-5.6 96.9C166 142 96 229.1 96 326.7V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-74.8 64.5-134.8 140.8-127.4 66.5 6.5 115.2 66.2 115.2 133.1V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-114.2-100.2-205.4-217.3-190.4zm6.2 96.3c-45.6 8.9-76.9 51.5-76.9 97.9V464c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-17.6 14.3-32 32-32s32 14.4 32 32v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320c0-59.2-53.8-106-115.1-94.1z"
        ],
        "random": [
            512,
            512,
            [],
            "f074",
            "M504.971 359.029c9.373 9.373 9.373 24.569 0 33.941l-80 79.984c-15.01 15.01-40.971 4.49-40.971-16.971V416h-58.785a12.004 12.004 0 0 1-8.773-3.812l-70.556-75.596 53.333-57.143L352 336h32v-39.981c0-21.438 25.943-31.998 40.971-16.971l80 79.981zM12 176h84l52.781 56.551 53.333-57.143-70.556-75.596A11.999 11.999 0 0 0 122.785 96H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12zm372 0v39.984c0 21.46 25.961 31.98 40.971 16.971l80-79.984c9.373-9.373 9.373-24.569 0-33.941l-80-79.981C409.943 24.021 384 34.582 384 56.019V96h-58.785a12.004 12.004 0 0 0-8.773 3.812L96 336H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h110.785c3.326 0 6.503-1.381 8.773-3.812L352 176h32z"
        ],
        "receipt": [
            384,
            512,
            [],
            "f543",
            "M358.4 3.2L320 48 265.6 3.2a15.9 15.9 0 0 0-19.2 0L192 48 137.6 3.2a15.9 15.9 0 0 0-19.2 0L64 48 25.6 3.2C15-4.7 0 2.8 0 16v480c0 13.2 15 20.7 25.6 12.8L64 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L192 464l54.4 44.8a15.9 15.9 0 0 0 19.2 0L320 464l38.4 44.8c10.5 7.9 25.6.4 25.6-12.8V16c0-13.2-15-20.7-25.6-12.8zM320 360c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16z"
        ],
        "record-vinyl": [
            512,
            512,
            [],
            "f8d9",
            "M256 152a104 104 0 1 0 104 104 104 104 0 0 0-104-104zm0 128a24 24 0 1 1 24-24 24 24 0 0 1-24 24zm0-272C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 376a128 128 0 1 1 128-128 128 128 0 0 1-128 128z"
        ],
        "recycle": [
            512,
            512,
            [],
            "f1b8",
            "M184.561 261.903c3.232 13.997-12.123 24.635-24.068 17.168l-40.736-25.455-50.867 81.402C55.606 356.273 70.96 384 96.012 384H148c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12H96.115c-75.334 0-121.302-83.048-81.408-146.88l50.822-81.388-40.725-25.448c-12.081-7.547-8.966-25.961 4.879-29.158l110.237-25.45c8.611-1.988 17.201 3.381 19.189 11.99l25.452 110.237zm98.561-182.915l41.289 66.076-40.74 25.457c-12.051 7.528-9 25.953 4.879 29.158l110.237 25.45c8.672 1.999 17.215-3.438 19.189-11.99l25.45-110.237c3.197-13.844-11.99-24.719-24.068-17.168l-40.687 25.424-41.263-66.082c-37.521-60.033-125.209-60.171-162.816 0l-17.963 28.766c-3.51 5.62-1.8 13.021 3.82 16.533l33.919 21.195c5.62 3.512 13.024 1.803 16.536-3.817l17.961-28.743c12.712-20.341 41.973-19.676 54.257-.022zM497.288 301.12l-27.515-44.065c-3.511-5.623-10.916-7.334-16.538-3.821l-33.861 21.159c-5.62 3.512-7.33 10.915-3.818 16.536l27.564 44.112c13.257 21.211-2.057 48.96-27.136 48.96H320V336.02c0-14.213-17.242-21.383-27.313-11.313l-80 79.981c-6.249 6.248-6.249 16.379 0 22.627l80 79.989C302.689 517.308 320 510.3 320 495.989V448h95.88c75.274 0 121.335-82.997 81.408-146.88z"
        ],
        "redo": [
            512,
            512,
            [],
            "f01e",
            "M500.33 0h-47.41a12 12 0 0 0-12 12.57l4 82.76A247.42 247.42 0 0 0 256 8C119.34 8 7.9 119.53 8 256.19 8.1 393.07 119.1 504 256 504a247.1 247.1 0 0 0 166.18-63.91 12 12 0 0 0 .48-17.43l-34-34a12 12 0 0 0-16.38-.55A176 176 0 1 1 402.1 157.8l-101.53-4.87a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12h200.33a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12z"
        ],
        "redo-alt": [
            512,
            512,
            [],
            "f2f9",
            "M256.455 8c66.269.119 126.437 26.233 170.859 68.685l35.715-35.715C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.75c-30.864-28.899-70.801-44.907-113.23-45.273-92.398-.798-170.283 73.977-169.484 169.442C88.764 348.009 162.184 424 256 424c41.127 0 79.997-14.678 110.629-41.556 4.743-4.161 11.906-3.908 16.368.553l39.662 39.662c4.872 4.872 4.631 12.815-.482 17.433C378.202 479.813 319.926 504 256 504 119.034 504 8.001 392.967 8 256.002 7.999 119.193 119.646 7.755 256.455 8z"
        ],
        "registered": [
            512,
            512,
            [],
            "f25d",
            "M285.363 207.475c0 18.6-9.831 28.431-28.431 28.431h-29.876v-56.14h23.378c28.668 0 34.929 8.773 34.929 27.709zM504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM363.411 360.414c-46.729-84.825-43.299-78.636-44.702-80.98 23.432-15.172 37.945-42.979 37.945-74.486 0-54.244-31.5-89.252-105.498-89.252h-70.667c-13.255 0-24 10.745-24 24V372c0 13.255 10.745 24 24 24h22.567c13.255 0 24-10.745 24-24v-71.663h25.556l44.129 82.937a24.001 24.001 0 0 0 21.188 12.727h24.464c18.261-.001 29.829-19.591 21.018-35.587z"
        ],
        "remove-format": [
            640,
            512,
            [],
            "f87d",
            "M336 416h-11.17l9.26-27.77L267 336.4 240.49 416H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm297.82 42.1L377 259.59 426.17 112H544v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16H176a16 16 0 0 0-16 16v43.9L45.46 3.38A16 16 0 0 0 23 6.19L3.37 31.46a16 16 0 0 0 2.81 22.45l588.36 454.72a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zM309.91 207.76L224 141.36V112h117.83z"
        ],
        "reply": [
            512,
            512,
            [],
            "f3e5",
            "M8.309 189.836L184.313 37.851C199.719 24.546 224 35.347 224 56.015v80.053c160.629 1.839 288 34.032 288 186.258 0 61.441-39.581 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 45.344-145.012-21.507-183.51-176.59-185.742V360c0 20.7-24.3 31.453-39.687 18.164l-176.004-152c-11.071-9.562-11.086-26.753 0-36.328z"
        ],
        "reply-all": [
            576,
            512,
            [],
            "f122",
            "M136.309 189.836L312.313 37.851C327.72 24.546 352 35.348 352 56.015v82.763c129.182 10.231 224 52.212 224 183.548 0 61.441-39.582 122.309-83.333 154.132-13.653 9.931-33.111-2.533-28.077-18.631 38.512-123.162-3.922-169.482-112.59-182.015v84.175c0 20.701-24.3 31.453-39.687 18.164L136.309 226.164c-11.071-9.561-11.086-26.753 0-36.328zm-128 36.328L184.313 378.15C199.7 391.439 224 380.687 224 359.986v-15.818l-108.606-93.785A55.96 55.96 0 0 1 96 207.998a55.953 55.953 0 0 1 19.393-42.38L224 71.832V56.015c0-20.667-24.28-31.469-39.687-18.164L8.309 189.836c-11.086 9.575-11.071 26.767 0 36.328z"
        ],
        "republican": [
            640,
            512,
            [],
            "f75e",
            "M544 192c0-88.4-71.6-160-160-160H160C71.6 32 0 103.6 0 192v64h544v-64zm-367.7-21.6l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L128 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L272 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zm144 0l-19.8 19.3 4.7 27.3c.8 4.9-4.3 8.6-8.7 6.3L416 210.4l-24.5 12.9c-4.3 2.3-9.5-1.4-8.7-6.3l4.7-27.3-19.8-19.3c-3.6-3.5-1.6-9.5 3.3-10.2l27.4-4 12.2-24.8c2.2-4.5 8.6-4.4 10.7 0l12.2 24.8 27.4 4c5 .7 6.9 6.7 3.4 10.2zM624 320h-32c-8.8 0-16 7.2-16 16v64c0 8.8-7.2 16-16 16s-16-7.2-16-16V288H0v176c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16v-80h192v80c0 8.8 7.2 16 16 16h96c8.8 0 16-7.2 16-16V352h32v43.3c0 41.8 30 80.1 71.6 84.3 47.8 4.9 88.4-32.7 88.4-79.6v-64c0-8.8-7.2-16-16-16z"
        ],
        "restroom": [
            640,
            512,
            [],
            "f7bd",
            "M128 128c35.3 0 64-28.7 64-64S163.3 0 128 0 64 28.7 64 64s28.7 64 64 64zm384 0c35.3 0 64-28.7 64-64S547.3 0 512 0s-64 28.7-64 64 28.7 64 64 64zm127.3 226.5l-45.6-185.8c-3.3-13.5-15.5-23-29.8-24.2-15 9.7-32.8 15.5-52 15.5-19.2 0-37-5.8-52-15.5-14.3 1.2-26.5 10.7-29.8 24.2l-45.6 185.8C381 369.6 393 384 409.2 384H464v104c0 13.3 10.7 24 24 24h48c13.3 0 24-10.7 24-24V384h54.8c16.2 0 28.2-14.4 24.5-29.5zM336 0h-32c-8.8 0-16 7.2-16 16v480c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zM180.1 144.4c-15 9.8-32.9 15.6-52.1 15.6-19.2 0-37.1-5.8-52.1-15.6C51.3 146.5 32 166.9 32 192v136c0 13.3 10.7 24 24 24h8v136c0 13.3 10.7 24 24 24h80c13.3 0 24-10.7 24-24V352h8c13.3 0 24-10.7 24-24V192c0-25.1-19.3-45.5-43.9-47.6z"
        ],
        "retweet": [
            640,
            512,
            [],
            "f079",
            "M629.657 343.598L528.971 444.284c-9.373 9.372-24.568 9.372-33.941 0L394.343 343.598c-9.373-9.373-9.373-24.569 0-33.941l10.823-10.823c9.562-9.562 25.133-9.34 34.419.492L480 342.118V160H292.451a24.005 24.005 0 0 1-16.971-7.029l-16-16C244.361 121.851 255.069 96 276.451 96H520c13.255 0 24 10.745 24 24v222.118l40.416-42.792c9.285-9.831 24.856-10.054 34.419-.492l10.823 10.823c9.372 9.372 9.372 24.569-.001 33.941zm-265.138 15.431A23.999 23.999 0 0 0 347.548 352H160V169.881l40.416 42.792c9.286 9.831 24.856 10.054 34.419.491l10.822-10.822c9.373-9.373 9.373-24.569 0-33.941L144.971 67.716c-9.373-9.373-24.569-9.373-33.941 0L10.343 168.402c-9.373 9.373-9.373 24.569 0 33.941l10.822 10.822c9.562 9.562 25.133 9.34 34.419-.491L96 169.881V392c0 13.255 10.745 24 24 24h243.549c21.382 0 32.09-25.851 16.971-40.971l-16.001-16z"
        ],
        "ribbon": [
            448,
            512,
            [],
            "f4d6",
            "M6.1 444.3c-9.6 10.8-7.5 27.6 4.5 35.7l68.8 27.9c9.9 6.7 23.3 5 31.3-3.8l91.8-101.9-79.2-87.9-117.2 130zm435.8 0s-292-324.6-295.4-330.1c15.4-8.4 40.2-17.9 77.5-17.9s62.1 9.5 77.5 17.9c-3.3 5.6-56 64.6-56 64.6l79.1 87.7 34.2-38c28.7-31.9 33.3-78.6 11.4-115.5l-43.7-73.5c-4.3-7.2-9.9-13.3-16.8-18-40.7-27.6-127.4-29.7-171.4 0-6.9 4.7-12.5 10.8-16.8 18l-43.6 73.2c-1.5 2.5-37.1 62.2 11.5 116L337.5 504c8 8.9 21.4 10.5 31.3 3.8l68.8-27.9c11.9-8 14-24.8 4.3-35.6z"
        ],
        "ring": [
            512,
            512,
            [],
            "f70b",
            "M256 64C110.06 64 0 125.91 0 208v98.13C0 384.48 114.62 448 256 448s256-63.52 256-141.87V208c0-82.09-110.06-144-256-144zm0 64c106.04 0 192 35.82 192 80 0 9.26-3.97 18.12-10.91 26.39C392.15 208.21 328.23 192 256 192s-136.15 16.21-181.09 42.39C67.97 226.12 64 217.26 64 208c0-44.18 85.96-80 192-80zM120.43 264.64C155.04 249.93 201.64 240 256 240s100.96 9.93 135.57 24.64C356.84 279.07 308.93 288 256 288s-100.84-8.93-135.57-23.36z"
        ],
        "road": [
            576,
            512,
            [],
            "f018",
            "M573.19 402.67l-139.79-320C428.43 71.29 417.6 64 405.68 64h-97.59l2.45 23.16c.5 4.72-3.21 8.84-7.96 8.84h-29.16c-4.75 0-8.46-4.12-7.96-8.84L267.91 64h-97.59c-11.93 0-22.76 7.29-27.73 18.67L2.8 402.67C-6.45 423.86 8.31 448 30.54 448h196.84l10.31-97.68c.86-8.14 7.72-14.32 15.91-14.32h68.8c8.19 0 15.05 6.18 15.91 14.32L348.62 448h196.84c22.23 0 36.99-24.14 27.73-45.33zM260.4 135.16a8 8 0 0 1 7.96-7.16h39.29c4.09 0 7.53 3.09 7.96 7.16l4.6 43.58c.75 7.09-4.81 13.26-11.93 13.26h-40.54c-7.13 0-12.68-6.17-11.93-13.26l4.59-43.58zM315.64 304h-55.29c-9.5 0-16.91-8.23-15.91-17.68l5.07-48c.86-8.14 7.72-14.32 15.91-14.32h45.15c8.19 0 15.05 6.18 15.91 14.32l5.07 48c1 9.45-6.41 17.68-15.91 17.68z"
        ],
        "robot": [
            640,
            512,
            [],
            "f544",
            "M32,224H64V416H32A31.96166,31.96166,0,0,1,0,384V256A31.96166,31.96166,0,0,1,32,224Zm512-48V448a64.06328,64.06328,0,0,1-64,64H160a64.06328,64.06328,0,0,1-64-64V176a79.974,79.974,0,0,1,80-80H288V32a32,32,0,0,1,64,0V96H464A79.974,79.974,0,0,1,544,176ZM264,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,264,256Zm-8,128H192v32h64Zm96,0H288v32h64ZM456,256a40,40,0,1,0-40,40A39.997,39.997,0,0,0,456,256Zm-8,128H384v32h64ZM640,256V384a31.96166,31.96166,0,0,1-32,32H576V224h32A31.96166,31.96166,0,0,1,640,256Z"
        ],
        "rocket": [
            512,
            512,
            [],
            "f135",
            "M505.12019,19.09375c-1.18945-5.53125-6.65819-11-12.207-12.1875C460.716,0,435.507,0,410.40747,0,307.17523,0,245.26909,55.20312,199.05238,128H94.83772c-16.34763.01562-35.55658,11.875-42.88664,26.48438L2.51562,253.29688A28.4,28.4,0,0,0,0,264a24.00867,24.00867,0,0,0,24.00582,24H127.81618l-22.47457,22.46875c-11.36521,11.36133-12.99607,32.25781,0,45.25L156.24582,406.625c11.15623,11.1875,32.15619,13.15625,45.27726,0l22.47457-22.46875V488a24.00867,24.00867,0,0,0,24.00581,24,28.55934,28.55934,0,0,0,10.707-2.51562l98.72834-49.39063c14.62888-7.29687,26.50776-26.5,26.50776-42.85937V312.79688c72.59753-46.3125,128.03493-108.40626,128.03493-211.09376C512.07526,76.5,512.07526,51.29688,505.12019,19.09375ZM384.04033,168A40,40,0,1,1,424.05,128,40.02322,40.02322,0,0,1,384.04033,168Z"
        ],
        "route": [
            512,
            512,
            [],
            "f4d7",
            "M416 320h-96c-17.6 0-32-14.4-32-32s14.4-32 32-32h96s96-107 96-160-43-96-96-96-96 43-96 96c0 25.5 22.2 63.4 45.3 96H320c-52.9 0-96 43.1-96 96s43.1 96 96 96h96c17.6 0 32 14.4 32 32s-14.4 32-32 32H185.5c-16 24.8-33.8 47.7-47.3 64H416c52.9 0 96-43.1 96-96s-43.1-96-96-96zm0-256c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM96 256c-53 0-96 43-96 96s96 160 96 160 96-107 96-160-43-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
        ],
        "rss": [
            448,
            512,
            [],
            "f09e",
            "M128.081 415.959c0 35.369-28.672 64.041-64.041 64.041S0 451.328 0 415.959s28.672-64.041 64.041-64.041 64.04 28.673 64.04 64.041zm175.66 47.25c-8.354-154.6-132.185-278.587-286.95-286.95C7.656 175.765 0 183.105 0 192.253v48.069c0 8.415 6.49 15.472 14.887 16.018 111.832 7.284 201.473 96.702 208.772 208.772.547 8.397 7.604 14.887 16.018 14.887h48.069c9.149.001 16.489-7.655 15.995-16.79zm144.249.288C439.596 229.677 251.465 40.445 16.503 32.01 7.473 31.686 0 38.981 0 48.016v48.068c0 8.625 6.835 15.645 15.453 15.999 191.179 7.839 344.627 161.316 352.465 352.465.353 8.618 7.373 15.453 15.999 15.453h48.068c9.034-.001 16.329-7.474 16.005-16.504z"
        ],
        "rss-square": [
            448,
            512,
            [],
            "f143",
            "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM112 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm157.533 0h-34.335c-6.011 0-11.051-4.636-11.442-10.634-5.214-80.05-69.243-143.92-149.123-149.123-5.997-.39-10.633-5.431-10.633-11.441v-34.335c0-6.535 5.468-11.777 11.994-11.425 110.546 5.974 198.997 94.536 204.964 204.964.352 6.526-4.89 11.994-11.425 11.994zm103.027 0h-34.334c-6.161 0-11.175-4.882-11.427-11.038-5.598-136.535-115.204-246.161-251.76-251.76C68.882 152.949 64 147.935 64 141.774V107.44c0-6.454 5.338-11.664 11.787-11.432 167.83 6.025 302.21 141.191 308.205 308.205.232 6.449-4.978 11.787-11.432 11.787z"
        ],
        "ruble-sign": [
            384,
            512,
            [],
            "f158",
            "M239.36 320C324.48 320 384 260.542 384 175.071S324.48 32 239.36 32H76c-6.627 0-12 5.373-12 12v206.632H12c-6.627 0-12 5.373-12 12V308c0 6.627 5.373 12 12 12h52v32H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h52v52c0 6.627 5.373 12 12 12h58.56c6.627 0 12-5.373 12-12v-52H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12H146.56v-32h92.8zm-92.8-219.252h78.72c46.72 0 74.88 29.11 74.88 74.323 0 45.832-28.16 75.561-76.16 75.561h-77.44V100.748z"
        ],
        "ruler": [
            640,
            512,
            [],
            "f545",
            "M635.7 167.2L556.1 31.7c-8.8-15-28.3-20.1-43.5-11.5l-69 39.1L503.3 161c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L416 75l-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L333.2 122 278 153.3 337.8 255c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-59.7-101.7-55.2 31.3 27.9 47.4c2.2 3.8.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9l-27.9-47.5-55.2 31.3 59.7 101.7c2.2 3.7.9 8.5-2.9 10.7l-13.8 7.8c-3.8 2.2-8.7.9-10.9-2.9L84.9 262.9l-69 39.1C.7 310.7-4.6 329.8 4.2 344.8l79.6 135.6c8.8 15 28.3 20.1 43.5 11.5L624.1 210c15.2-8.6 20.4-27.8 11.6-42.8z"
        ],
        "ruler-combined": [
            512,
            512,
            [],
            "f546",
            "M160 288h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56v-64h-56c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h56V96h-56c-4.42 0-8-3.58-8-8V72c0-4.42 3.58-8 8-8h56V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 2.77.91 5.24 1.57 7.8L160 329.38V288zm320 64h-32v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-64v56c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-56h-41.37L24.2 510.43c2.56.66 5.04 1.57 7.8 1.57h448c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
        ],
        "ruler-horizontal": [
            576,
            512,
            [],
            "f547",
            "M544 128h-48v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8h-16c-4.42 0-8-3.58-8-8v-88h-64v88c0 4.42-3.58 8-8 8H88c-4.42 0-8-3.58-8-8v-88H32c-17.67 0-32 14.33-32 32v192c0 17.67 14.33 32 32 32h512c17.67 0 32-14.33 32-32V160c0-17.67-14.33-32-32-32z"
        ],
        "ruler-vertical": [
            256,
            512,
            [],
            "f548",
            "M168 416c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88v-64h-88c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h88V32c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v448c0 17.67 14.33 32 32 32h192c17.67 0 32-14.33 32-32v-64h-88z"
        ],
        "running": [
            416,
            512,
            [],
            "f70c",
            "M272 96c26.51 0 48-21.49 48-48S298.51 0 272 0s-48 21.49-48 48 21.49 48 48 48zM113.69 317.47l-14.8 34.52H32c-17.67 0-32 14.33-32 32s14.33 32 32 32h77.45c19.25 0 36.58-11.44 44.11-29.09l8.79-20.52-10.67-6.3c-17.32-10.23-30.06-25.37-37.99-42.61zM384 223.99h-44.03l-26.06-53.25c-12.5-25.55-35.45-44.23-61.78-50.94l-71.08-21.14c-28.3-6.8-57.77-.55-80.84 17.14l-39.67 30.41c-14.03 10.75-16.69 30.83-5.92 44.86s30.84 16.66 44.86 5.92l39.69-30.41c7.67-5.89 17.44-8 25.27-6.14l14.7 4.37-37.46 87.39c-12.62 29.48-1.31 64.01 26.3 80.31l84.98 50.17-27.47 87.73c-5.28 16.86 4.11 34.81 20.97 40.09 3.19 1 6.41 1.48 9.58 1.48 13.61 0 26.23-8.77 30.52-22.45l31.64-101.06c5.91-20.77-2.89-43.08-21.64-54.39l-61.24-36.14 31.31-78.28 20.27 41.43c8 16.34 24.92 26.89 43.11 26.89H384c17.67 0 32-14.33 32-32s-14.33-31.99-32-31.99z"
        ],
        "rupee-sign": [
            320,
            512,
            [],
            "f156",
            "M308 96c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v44.748c0 6.627 5.373 12 12 12h85.28c27.308 0 48.261 9.958 60.97 27.252H12c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h158.757c-6.217 36.086-32.961 58.632-74.757 58.632H12c-6.627 0-12 5.373-12 12v53.012c0 3.349 1.4 6.546 3.861 8.818l165.052 152.356a12.001 12.001 0 0 0 8.139 3.182h82.562c10.924 0 16.166-13.408 8.139-20.818L116.871 319.906c76.499-2.34 131.144-53.395 138.318-127.906H308c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-58.69c-3.486-11.541-8.28-22.246-14.252-32H308z"
        ],
        "sad-cry": [
            496,
            512,
            [],
            "f5b3",
            "M248 8C111 8 0 119 0 256c0 90.1 48.2 168.7 120 212.1V288c0-8.8 7.2-16 16-16s16 7.2 16 16v196.7c29.5 12.4 62 19.3 96 19.3s66.5-6.9 96-19.3V288c0-8.8 7.2-16 16-16s16 7.2 16 16v180.1C447.8 424.7 496 346 496 256 496 119 385 8 248 8zm-65.5 216.5c-14.8-13.2-46.2-13.2-61 0L112 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S208 197 212 222.2c.8 5-1.7 10-6.1 12.4-5.8 3.1-11.2.7-13.7-1.6l-9.7-8.5zM248 416c-26.5 0-48-28.7-48-64s21.5-64 48-64 48 28.7 48 64-21.5 64-48 64zm149.8-181.5c-5.8 3.1-11.2.7-13.7-1.6l-9.5-8.5c-14.8-13.2-46.2-13.2-61 0L304 233c-3.8 3.3-9.3 4-13.7 1.6-4.4-2.4-6.9-7.4-6.1-12.4 4-25.2 34.2-42.1 59.9-42.1S400 197 404 222.2c.6 4.9-1.8 9.9-6.2 12.3z"
        ],
        "sad-tear": [
            496,
            512,
            [],
            "f5b4",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zM152 416c-26.5 0-48-21-48-47 0-20 28.5-60.4 41.6-77.8 3.2-4.3 9.6-4.3 12.8 0C171.5 308.6 200 349 200 369c0 26-21.5 47-48 47zm16-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm170.2 154.2C315.8 367.4 282.9 352 248 352c-21.2 0-21.2-32 0-32 44.4 0 86.3 19.6 114.7 53.8 13.8 16.4-11.2 36.5-24.5 20.4z"
        ],
        "satellite": [
            512,
            512,
            [],
            "f7bf",
            "M502.60969,310.04206l-96.70393,96.71625a31.88151,31.88151,0,0,1-45.00765,0L280.572,326.34115l-9.89231,9.90759a190.56343,190.56343,0,0,1-5.40716,168.52287c-4.50077,8.50115-16.39342,9.59505-23.20707,2.79725L134.54715,400.05428l-17.7999,17.79929c.70324,2.60972,1.60965,5.00067,1.60965,7.79793a32.00544,32.00544,0,1,1-32.00544-32.00434c2.79735,0,5.18838.90637,7.7982,1.60959l17.7999-17.79929L4.43129,269.94287c-6.798-6.81342-5.70409-18.6119,2.79735-23.20627a190.58161,190.58161,0,0,1,168.52864-5.407l9.79854-9.79821-80.31053-80.41716a32.002,32.002,0,0,1,0-45.09987L201.96474,9.29814A31.62639,31.62639,0,0,1,224.46868,0a31.99951,31.99951,0,0,1,22.59759,9.29814l80.32615,80.30777,47.805-47.89713a33.6075,33.6075,0,0,1,47.50808,0l47.50807,47.50645a33.63308,33.63308,0,0,1,0,47.50644l-47.805,47.89713L502.71908,265.036A31.78938,31.78938,0,0,1,502.60969,310.04206ZM219.56159,197.433l73.82505-73.82252-68.918-68.9-73.80942,73.80689Zm237.74352,90.106-68.90233-68.9156-73.825,73.82252,68.918,68.9Z"
        ],
        "satellite-dish": [
            512,
            512,
            [],
            "f7c0",
            "M305.44954,462.59c7.39157,7.29792,6.18829,20.09661-3.00038,25.00356-77.713,41.80281-176.72559,29.9105-242.34331-35.7082C-5.49624,386.28227-17.404,287.362,24.41381,209.554c4.89125-9.095,17.68975-10.29834,25.00318-3.00043L166.22872,323.36708l27.39411-27.39452c-.68759-2.60974-1.594-5.00071-1.594-7.81361a32.00407,32.00407,0,1,1,32.00407,32.00455c-2.79723,0-5.20378-.89075-7.79786-1.594l-27.40974,27.41015ZM511.9758,303.06732a16.10336,16.10336,0,0,1-16.002,17.00242H463.86031a15.96956,15.96956,0,0,1-15.89265-15.00213C440.46671,175.5492,336.45348,70.53427,207.03078,63.53328a15.84486,15.84486,0,0,1-15.00191-15.90852V16.02652A16.09389,16.09389,0,0,1,209.031.02425C372.25491,8.61922,503.47472,139.841,511.9758,303.06732Zm-96.01221-.29692a16.21093,16.21093,0,0,1-16.11142,17.29934H367.645a16.06862,16.06862,0,0,1-15.89265-14.70522c-6.90712-77.01094-68.118-138.91037-144.92467-145.22376a15.94,15.94,0,0,1-14.79876-15.89289V112.13393a16.134,16.134,0,0,1,17.29908-16.096C319.45132,104.5391,407.55627,192.64538,415.96359,302.7704Z"
        ],
        "save": [
            448,
            512,
            [],
            "f0c7",
            "M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM224 416c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64zm96-304.52V212c0 6.627-5.373 12-12 12H76c-6.627 0-12-5.373-12-12V108c0-6.627 5.373-12 12-12h228.52c3.183 0 6.235 1.264 8.485 3.515l3.48 3.48A11.996 11.996 0 0 1 320 111.48z"
        ],
        "school": [
            640,
            512,
            [],
            "f549",
            "M0 224v272c0 8.84 7.16 16 16 16h80V192H32c-17.67 0-32 14.33-32 32zm360-48h-24v-40c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v64c0 4.42 3.58 8 8 8h48c4.42 0 8-3.58 8-8v-16c0-4.42-3.58-8-8-8zm137.75-63.96l-160-106.67a32.02 32.02 0 0 0-35.5 0l-160 106.67A32.002 32.002 0 0 0 128 138.66V512h128V368c0-8.84 7.16-16 16-16h96c8.84 0 16 7.16 16 16v144h128V138.67c0-10.7-5.35-20.7-14.25-26.63zM320 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm288-64h-64v320h80c8.84 0 16-7.16 16-16V224c0-17.67-14.33-32-32-32z"
        ],
        "screwdriver": [
            512,
            512,
            [],
            "f54a",
            "M448 0L320 96v62.06l-83.03 83.03c6.79 4.25 13.27 9.06 19.07 14.87 5.8 5.8 10.62 12.28 14.87 19.07L353.94 192H416l96-128-64-64zM128 278.59L10.92 395.67c-14.55 14.55-14.55 38.15 0 52.71l52.7 52.7c14.56 14.56 38.15 14.56 52.71 0L233.41 384c29.11-29.11 29.11-76.3 0-105.41s-76.3-29.11-105.41 0z"
        ],
        "scroll": [
            640,
            512,
            [],
            "f70e",
            "M48 0C21.53 0 0 21.53 0 48v64c0 8.84 7.16 16 16 16h80V48C96 21.53 74.47 0 48 0zm208 412.57V352h288V96c0-52.94-43.06-96-96-96H111.59C121.74 13.41 128 29.92 128 48v368c0 38.87 34.65 69.65 74.75 63.12C234.22 474 256 444.46 256 412.57zM288 384v32c0 52.93-43.06 96-96 96h336c61.86 0 112-50.14 112-112 0-8.84-7.16-16-16-16H288z"
        ],
        "sd-card": [
            384,
            512,
            [],
            "f7c2",
            "M320 0H128L0 128v320c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zM160 160h-48V64h48v96zm80 0h-48V64h48v96zm80 0h-48V64h48v96z"
        ],
        "search": [
            512,
            512,
            [],
            "f002",
            "M505 442.7L405.3 343c-4.5-4.5-10.6-7-17-7H372c27.6-35.3 44-79.7 44-128C416 93.1 322.9 0 208 0S0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.4 128-44v16.3c0 6.4 2.5 12.5 7 17l99.7 99.7c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.6.1-34zM208 336c-70.7 0-128-57.2-128-128 0-70.7 57.2-128 128-128 70.7 0 128 57.2 128 128 0 70.7-57.2 128-128 128z"
        ],
        "search-dollar": [
            512,
            512,
            [],
            "f688",
            "M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm27.11-152.54l-45.01-13.5c-5.16-1.55-8.77-6.78-8.77-12.73 0-7.27 5.3-13.19 11.8-13.19h28.11c4.56 0 8.96 1.29 12.82 3.72 3.24 2.03 7.36 1.91 10.13-.73l11.75-11.21c3.53-3.37 3.33-9.21-.57-12.14-9.1-6.83-20.08-10.77-31.37-11.35V112c0-4.42-3.58-8-8-8h-16c-4.42 0-8 3.58-8 8v16.12c-23.63.63-42.68 20.55-42.68 45.07 0 19.97 12.99 37.81 31.58 43.39l45.01 13.5c5.16 1.55 8.77 6.78 8.77 12.73 0 7.27-5.3 13.19-11.8 13.19h-28.1c-4.56 0-8.96-1.29-12.82-3.72-3.24-2.03-7.36-1.91-10.13.73l-11.75 11.21c-3.53 3.37-3.33 9.21.57 12.14 9.1 6.83 20.08 10.77 31.37 11.35V304c0 4.42 3.58 8 8 8h16c4.42 0 8-3.58 8-8v-16.12c23.63-.63 42.68-20.54 42.68-45.07 0-19.97-12.99-37.81-31.59-43.39z"
        ],
        "search-location": [
            512,
            512,
            [],
            "f689",
            "M505.04 442.66l-99.71-99.69c-4.5-4.5-10.6-7-17-7h-16.3c27.6-35.3 44-79.69 44-127.99C416.03 93.09 322.92 0 208.02 0S0 93.09 0 207.98s93.11 207.98 208.02 207.98c48.3 0 92.71-16.4 128.01-44v16.3c0 6.4 2.5 12.5 7 17l99.71 99.69c9.4 9.4 24.6 9.4 33.9 0l28.3-28.3c9.4-9.4 9.4-24.59.1-33.99zm-297.02-90.7c-79.54 0-144-64.34-144-143.98 0-79.53 64.35-143.98 144-143.98 79.54 0 144 64.34 144 143.98 0 79.53-64.35 143.98-144 143.98zm.02-239.96c-40.78 0-73.84 33.05-73.84 73.83 0 32.96 48.26 93.05 66.75 114.86a9.24 9.24 0 0 0 14.18 0c18.49-21.81 66.75-81.89 66.75-114.86 0-40.78-33.06-73.83-73.84-73.83zm0 96c-13.26 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
        ],
        "search-minus": [
            512,
            512,
            [],
            "f010",
            "M304 192v32c0 6.6-5.4 12-12 12H124c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"
        ],
        "search-plus": [
            512,
            512,
            [],
            "f00e",
            "M304 192v32c0 6.6-5.4 12-12 12h-56v56c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-56h-56c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h56v-56c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v56h56c6.6 0 12 5.4 12 12zm201 284.7L476.7 505c-9.4 9.4-24.6 9.4-33.9 0L343 405.3c-4.5-4.5-7-10.6-7-17V372c-35.3 27.6-79.7 44-128 44C93.1 416 0 322.9 0 208S93.1 0 208 0s208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7l99.7 99.7c9.3 9.4 9.3 24.6 0 34zM344 208c0-75.2-60.8-136-136-136S72 132.8 72 208s60.8 136 136 136 136-60.8 136-136z"
        ],
        "seedling": [
            512,
            512,
            [],
            "f4d8",
            "M64 96H0c0 123.7 100.3 224 224 224v144c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V320C288 196.3 187.7 96 64 96zm384-64c-84.2 0-157.4 46.5-195.7 115.2 27.7 30.2 48.2 66.9 59 107.6C424 243.1 512 147.9 512 32h-64z"
        ],
        "server": [
            512,
            512,
            [],
            "f233",
            "M480 160H32c-17.673 0-32-14.327-32-32V64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm112 248H32c-17.673 0-32-14.327-32-32v-64c0-17.673 14.327-32 32-32h448c17.673 0 32 14.327 32 32v64c0 17.673-14.327 32-32 32zm-48-88c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24zm-64 0c-13.255 0-24 10.745-24 24s10.745 24 24 24 24-10.745 24-24-10.745-24-24-24z"
        ],
        "shapes": [
            512,
            512,
            [],
            "f61f",
            "M128,256A128,128,0,1,0,256,384,128,128,0,0,0,128,256Zm379-54.86L400.07,18.29a37.26,37.26,0,0,0-64.14,0L229,201.14C214.76,225.52,232.58,256,261.09,256H474.91C503.42,256,521.24,225.52,507,201.14ZM480,288H320a32,32,0,0,0-32,32V480a32,32,0,0,0,32,32H480a32,32,0,0,0,32-32V320A32,32,0,0,0,480,288Z"
        ],
        "share": [
            512,
            512,
            [],
            "f064",
            "M503.691 189.836L327.687 37.851C312.281 24.546 288 35.347 288 56.015v80.053C127.371 137.907 0 170.1 0 322.326c0 61.441 39.581 122.309 83.333 154.132 13.653 9.931 33.111-2.533 28.077-18.631C66.066 312.814 132.917 274.316 288 272.085V360c0 20.7 24.3 31.453 39.687 18.164l176.004-152c11.071-9.562 11.086-26.753 0-36.328z"
        ],
        "share-alt": [
            448,
            512,
            [],
            "f1e0",
            "M352 320c-22.608 0-43.387 7.819-59.79 20.895l-102.486-64.054a96.551 96.551 0 0 0 0-41.683l102.486-64.054C308.613 184.181 329.392 192 352 192c53.019 0 96-42.981 96-96S405.019 0 352 0s-96 42.981-96 96c0 7.158.79 14.13 2.276 20.841L155.79 180.895C139.387 167.819 118.608 160 96 160c-53.019 0-96 42.981-96 96s42.981 96 96 96c22.608 0 43.387-7.819 59.79-20.895l102.486 64.054A96.301 96.301 0 0 0 256 416c0 53.019 42.981 96 96 96s96-42.981 96-96-42.981-96-96-96z"
        ],
        "share-alt-square": [
            448,
            512,
            [],
            "f1e1",
            "M448 80v352c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48zM304 296c-14.562 0-27.823 5.561-37.783 14.671l-67.958-40.775a56.339 56.339 0 0 0 0-27.793l67.958-40.775C276.177 210.439 289.438 216 304 216c30.928 0 56-25.072 56-56s-25.072-56-56-56-56 25.072-56 56c0 4.797.605 9.453 1.74 13.897l-67.958 40.775C171.823 205.561 158.562 200 144 200c-30.928 0-56 25.072-56 56s25.072 56 56 56c14.562 0 27.823-5.561 37.783-14.671l67.958 40.775a56.088 56.088 0 0 0-1.74 13.897c0 30.928 25.072 56 56 56s56-25.072 56-56C360 321.072 334.928 296 304 296z"
        ],
        "share-square": [
            576,
            512,
            [],
            "f14d",
            "M568.482 177.448L424.479 313.433C409.3 327.768 384 317.14 384 295.985v-71.963c-144.575.97-205.566 35.113-164.775 171.353 4.483 14.973-12.846 26.567-25.006 17.33C155.252 383.105 120 326.488 120 269.339c0-143.937 117.599-172.5 264-173.312V24.012c0-21.174 25.317-31.768 40.479-17.448l144.003 135.988c10.02 9.463 10.028 25.425 0 34.896zM384 379.128V448H64V128h50.916a11.99 11.99 0 0 0 8.648-3.693c14.953-15.568 32.237-27.89 51.014-37.676C185.708 80.83 181.584 64 169.033 64H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48v-88.806c0-8.288-8.197-14.066-16.011-11.302a71.83 71.83 0 0 1-34.189 3.377c-7.27-1.046-13.8 4.514-13.8 11.859z"
        ],
        "shekel-sign": [
            448,
            512,
            [],
            "f20b",
            "M248 168v168c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V168c0-75.11-60.89-136-136-136H24C10.75 32 0 42.74 0 56v408c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112h112c30.93 0 56 25.07 56 56zM432 32h-48c-8.84 0-16 7.16-16 16v296c0 30.93-25.07 56-56 56H200V176c0-8.84-7.16-16-16-16h-48c-8.84 0-16 7.16-16 16v280c0 13.25 10.75 24 24 24h168c75.11 0 136-60.89 136-136V48c0-8.84-7.16-16-16-16z"
        ],
        "shield-alt": [
            512,
            512,
            [],
            "f3ed",
            "M466.5 83.7l-192-80a48.15 48.15 0 0 0-36.9 0l-192 80C27.7 91.1 16 108.6 16 128c0 198.5 114.5 335.7 221.5 380.3 11.8 4.9 25.1 4.9 36.9 0C360.1 472.6 496 349.3 496 128c0-19.4-11.7-36.9-29.5-44.3zM256.1 446.3l-.1-381 175.9 73.3c-3.3 151.4-82.1 261.1-175.8 307.7z"
        ],
        "shield-virus": [
            512,
            512,
            [],
            "e06c",
            "M224,192a16,16,0,1,0,16,16A16,16,0,0,0,224,192ZM466.5,83.68l-192-80A57.4,57.4,0,0,0,256.05,0a57.4,57.4,0,0,0-18.46,3.67l-192,80A47.93,47.93,0,0,0,16,128C16,326.5,130.5,463.72,237.5,508.32a48.09,48.09,0,0,0,36.91,0C360.09,472.61,496,349.3,496,128A48,48,0,0,0,466.5,83.68ZM384,256H371.88c-28.51,0-42.79,34.47-22.63,54.63l8.58,8.57a16,16,0,1,1-22.63,22.63l-8.57-8.58C306.47,313.09,272,327.37,272,355.88V368a16,16,0,0,1-32,0V355.88c0-28.51-34.47-42.79-54.63-22.63l-8.57,8.58a16,16,0,0,1-22.63-22.63l8.58-8.57c20.16-20.16,5.88-54.63-22.63-54.63H128a16,16,0,0,1,0-32h12.12c28.51,0,42.79-34.47,22.63-54.63l-8.58-8.57a16,16,0,0,1,22.63-22.63l8.57,8.58c20.16,20.16,54.63,5.88,54.63-22.63V112a16,16,0,0,1,32,0v12.12c0,28.51,34.47,42.79,54.63,22.63l8.57-8.58a16,16,0,0,1,22.63,22.63l-8.58,8.57C329.09,189.53,343.37,224,371.88,224H384a16,16,0,0,1,0,32Zm-96,0a16,16,0,1,0,16,16A16,16,0,0,0,288,256Z"
        ],
        "ship": [
            640,
            512,
            [],
            "f21a",
            "M496.616 372.639l70.012-70.012c16.899-16.9 9.942-45.771-12.836-53.092L512 236.102V96c0-17.673-14.327-32-32-32h-64V24c0-13.255-10.745-24-24-24H248c-13.255 0-24 10.745-24 24v40h-64c-17.673 0-32 14.327-32 32v140.102l-41.792 13.433c-22.753 7.313-29.754 36.173-12.836 53.092l70.012 70.012C125.828 416.287 85.587 448 24 448c-13.255 0-24 10.745-24 24v16c0 13.255 10.745 24 24 24 61.023 0 107.499-20.61 143.258-59.396C181.677 487.432 216.021 512 256 512h128c39.979 0 74.323-24.568 88.742-59.396C508.495 491.384 554.968 512 616 512c13.255 0 24-10.745 24-24v-16c0-13.255-10.745-24-24-24-60.817 0-101.542-31.001-119.384-75.361zM192 128h256v87.531l-118.208-37.995a31.995 31.995 0 0 0-19.584 0L192 215.531V128z"
        ],
        "shipping-fast": [
            640,
            512,
            [],
            "f48b",
            "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H112C85.5 0 64 21.5 64 48v48H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h272c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H40c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H8c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8h208c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H64v128c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
        ],
        "shoe-prints": [
            640,
            512,
            [],
            "f54b",
            "M192 160h32V32h-32c-35.35 0-64 28.65-64 64s28.65 64 64 64zM0 416c0 35.35 28.65 64 64 64h32V352H64c-35.35 0-64 28.65-64 64zm337.46-128c-34.91 0-76.16 13.12-104.73 32-24.79 16.38-44.52 32-104.73 32v128l57.53 15.97c26.21 7.28 53.01 13.12 80.31 15.05 32.69 2.31 65.6.67 97.58-6.2C472.9 481.3 512 429.22 512 384c0-64-84.18-96-174.54-96zM491.42 7.19C459.44.32 426.53-1.33 393.84.99c-27.3 1.93-54.1 7.77-80.31 15.04L256 32v128c60.2 0 79.94 15.62 104.73 32 28.57 18.88 69.82 32 104.73 32C555.82 224 640 192 640 128c0-45.22-39.1-97.3-148.58-120.81z"
        ],
        "shopping-bag": [
            448,
            512,
            [],
            "f290",
            "M352 160v-32C352 57.42 294.579 0 224 0 153.42 0 96 57.42 96 128v32H0v272c0 44.183 35.817 80 80 80h288c44.183 0 80-35.817 80-80V160h-96zm-192-32c0-35.29 28.71-64 64-64s64 28.71 64 64v32H160v-32zm160 120c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm-192 0c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24z"
        ],
        "shopping-basket": [
            576,
            512,
            [],
            "f291",
            "M576 216v16c0 13.255-10.745 24-24 24h-8l-26.113 182.788C514.509 462.435 494.257 480 470.37 480H105.63c-23.887 0-44.139-17.565-47.518-41.212L32 256h-8c-13.255 0-24-10.745-24-24v-16c0-13.255 10.745-24 24-24h67.341l106.78-146.821c10.395-14.292 30.407-17.453 44.701-7.058 14.293 10.395 17.453 30.408 7.058 44.701L170.477 192h235.046L326.12 82.821c-10.395-14.292-7.234-34.306 7.059-44.701 14.291-10.395 34.306-7.235 44.701 7.058L484.659 192H552c13.255 0 24 10.745 24 24zM312 392V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm112 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24zm-224 0V280c0-13.255-10.745-24-24-24s-24 10.745-24 24v112c0 13.255 10.745 24 24 24s24-10.745 24-24z"
        ],
        "shopping-cart": [
            576,
            512,
            [],
            "f07a",
            "M528.12 301.319l47.273-208C578.806 78.301 567.391 64 551.99 64H159.208l-9.166-44.81C147.758 8.021 137.93 0 126.529 0H24C10.745 0 0 10.745 0 24v16c0 13.255 10.745 24 24 24h69.883l70.248 343.435C147.325 417.1 136 435.222 136 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-15.674-6.447-29.835-16.824-40h209.647C430.447 426.165 424 440.326 424 456c0 30.928 25.072 56 56 56s56-25.072 56-56c0-22.172-12.888-41.332-31.579-50.405l5.517-24.276c3.413-15.018-8.002-29.319-23.403-29.319H218.117l-6.545-32h293.145c11.206 0 20.92-7.754 23.403-18.681z"
        ],
        "shower": [
            512,
            512,
            [],
            "f2cc",
            "M304,320a16,16,0,1,0,16,16A16,16,0,0,0,304,320Zm32-96a16,16,0,1,0,16,16A16,16,0,0,0,336,224Zm32,64a16,16,0,1,0-16-16A16,16,0,0,0,368,288Zm-32,32a16,16,0,1,0-16-16A16,16,0,0,0,336,320Zm-32-64a16,16,0,1,0,16,16A16,16,0,0,0,304,256Zm128-32a16,16,0,1,0-16-16A16,16,0,0,0,432,224Zm-48,16a16,16,0,1,0,16-16A16,16,0,0,0,384,240Zm-16-48a16,16,0,1,0,16,16A16,16,0,0,0,368,192Zm96,32a16,16,0,1,0,16,16A16,16,0,0,0,464,224Zm32-32a16,16,0,1,0,16,16A16,16,0,0,0,496,192Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,432,256Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,400,288Zm-64,64a16,16,0,1,0,16,16A16,16,0,0,0,336,352Zm-32,32a16,16,0,1,0,16,16A16,16,0,0,0,304,384Zm64-64a16,16,0,1,0,16,16A16,16,0,0,0,368,320Zm21.65-218.35-11.3-11.31a16,16,0,0,0-22.63,0L350.05,96A111.19,111.19,0,0,0,272,64c-19.24,0-37.08,5.3-52.9,13.85l-10-10A121.72,121.72,0,0,0,123.44,32C55.49,31.5,0,92.91,0,160.85V464a16,16,0,0,0,16,16H48a16,16,0,0,0,16-16V158.4c0-30.15,21-58.2,51-61.93a58.38,58.38,0,0,1,48.93,16.67l10,10C165.3,138.92,160,156.76,160,176a111.23,111.23,0,0,0,32,78.05l-5.66,5.67a16,16,0,0,0,0,22.62l11.3,11.31a16,16,0,0,0,22.63,0L389.65,124.28A16,16,0,0,0,389.65,101.65Z"
        ],
        "shuttle-van": [
            640,
            512,
            [],
            "f5b6",
            "M628.88 210.65L494.39 49.27A48.01 48.01 0 0 0 457.52 32H32C14.33 32 0 46.33 0 64v288c0 17.67 14.33 32 32 32h32c0 53.02 42.98 96 96 96s96-42.98 96-96h128c0 53.02 42.98 96 96 96s96-42.98 96-96h32c17.67 0 32-14.33 32-32V241.38c0-11.23-3.94-22.1-11.12-30.73zM64 192V96h96v96H64zm96 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm160-240h-96V96h96v96zm160 240c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-96-240V96h66.02l80 96H384z"
        ],
        "sign": [
            512,
            512,
            [],
            "f4d9",
            "M496 64H128V16c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16v48H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h48v368c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V128h368c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16zM160 384h320V160H160v224z"
        ],
        "sign-in-alt": [
            512,
            512,
            [],
            "f2f6",
            "M416 448h-84c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h84c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32h-84c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h84c53 0 96 43 96 96v192c0 53-43 96-96 96zm-47-201L201 79c-15-15-41-4.5-41 17v96H24c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24h136v96c0 21.5 26 32 41 17l168-168c9.3-9.4 9.3-24.6 0-34z"
        ],
        "sign-language": [
            448,
            512,
            [],
            "f2a7",
            "M91.434 483.987c-.307-16.018 13.109-29.129 29.13-29.129h62.293v-5.714H56.993c-16.021 0-29.437-13.111-29.13-29.129C28.16 404.491 40.835 392 56.428 392h126.429v-5.714H29.136c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h154.286v-5.714H57.707c-16.021 0-29.437-13.111-29.13-29.129.297-15.522 12.973-28.013 28.566-28.013h168.566l-31.085-22.606c-12.762-9.281-15.583-27.149-6.302-39.912 9.281-12.761 27.15-15.582 39.912-6.302l123.361 89.715a34.287 34.287 0 0 1 14.12 27.728v141.136c0 15.91-10.946 29.73-26.433 33.374l-80.471 18.934a137.16 137.16 0 0 1-31.411 3.646H120c-15.593-.001-28.269-12.492-28.566-28.014zm73.249-225.701h36.423l-11.187-8.136c-18.579-13.511-20.313-40.887-3.17-56.536l-13.004-16.7c-9.843-12.641-28.43-15.171-40.88-5.088-12.065 9.771-14.133 27.447-4.553 39.75l36.371 46.71zm283.298-2.103l-5.003-152.452c-.518-15.771-13.722-28.136-29.493-27.619-15.773.518-28.137 13.722-27.619 29.493l1.262 38.415L283.565 11.019c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l76.889 98.745-4.509 3.511-94.79-121.734c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l94.443 121.288-4.509 3.511-77.675-99.754c-9.58-12.303-27.223-14.63-39.653-5.328-12.827 9.599-14.929 28.24-5.086 40.881l52.053 66.849c12.497-8.257 29.055-8.285 41.69.904l123.36 89.714c10.904 7.93 17.415 20.715 17.415 34.198v16.999l61.064-47.549a34.285 34.285 0 0 0 13.202-28.177z"
        ],
        "sign-out-alt": [
            512,
            512,
            [],
            "f2f5",
            "M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z"
        ],
        "signal": [
            640,
            512,
            [],
            "f012",
            "M216 288h-48c-8.84 0-16 7.16-16 16v192c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V304c0-8.84-7.16-16-16-16zM88 384H40c-8.84 0-16 7.16-16 16v96c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16v-96c0-8.84-7.16-16-16-16zm256-192h-48c-8.84 0-16 7.16-16 16v288c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V208c0-8.84-7.16-16-16-16zm128-96h-48c-8.84 0-16 7.16-16 16v384c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V112c0-8.84-7.16-16-16-16zM600 0h-48c-8.84 0-16 7.16-16 16v480c0 8.84 7.16 16 16 16h48c8.84 0 16-7.16 16-16V16c0-8.84-7.16-16-16-16z"
        ],
        "signature": [
            640,
            512,
            [],
            "f5b7",
            "M623.2 192c-51.8 3.5-125.7 54.7-163.1 71.5-29.1 13.1-54.2 24.4-76.1 24.4-22.6 0-26-16.2-21.3-51.9 1.1-8 11.7-79.2-42.7-76.1-25.1 1.5-64.3 24.8-169.5 126L192 182.2c30.4-75.9-53.2-151.5-129.7-102.8L7.4 116.3C0 121-2.2 130.9 2.5 138.4l17.2 27c4.7 7.5 14.6 9.7 22.1 4.9l58-38.9c18.4-11.7 40.7 7.2 32.7 27.1L34.3 404.1C27.5 421 37 448 64 448c8.3 0 16.5-3.2 22.6-9.4 42.2-42.2 154.7-150.7 211.2-195.8-2.2 28.5-2.1 58.9 20.6 83.8 15.3 16.8 37.3 25.3 65.5 25.3 35.6 0 68-14.6 102.3-30 33-14.8 99-62.6 138.4-65.8 8.5-.7 15.2-7.3 15.2-15.8v-32.1c.2-9.1-7.5-16.8-16.6-16.2z"
        ],
        "sim-card": [
            384,
            512,
            [],
            "f7c4",
            "M0 64v384c0 35.3 28.7 64 64 64h256c35.3 0 64-28.7 64-64V128L256 0H64C28.7 0 0 28.7 0 64zm224 192h-64v-64h64v64zm96 0h-64v-64h32c17.7 0 32 14.3 32 32v32zm-64 128h64v32c0 17.7-14.3 32-32 32h-32v-64zm-96 0h64v64h-64v-64zm-96 0h64v64H96c-17.7 0-32-14.3-32-32v-32zm0-96h256v64H64v-64zm0-64c0-17.7 14.3-32 32-32h32v64H64v-32z"
        ],
        "sink": [
            512,
            512,
            [],
            "e06d",
            "M32,416a96,96,0,0,0,96,96H384a96,96,0,0,0,96-96V384H32ZM496,288H400V256h64a16,16,0,0,0,16-16V224a16,16,0,0,0-16-16H384a32,32,0,0,0-32,32v48H288V96a32,32,0,0,1,64,0v16a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V96A96.16,96.16,0,0,0,300.87,1.86C255.29,10.71,224,53.36,224,99.79V288H160V240a32,32,0,0,0-32-32H48a16,16,0,0,0-16,16v16a16,16,0,0,0,16,16h64v32H16A16,16,0,0,0,0,304v32a16,16,0,0,0,16,16H496a16,16,0,0,0,16-16V304A16,16,0,0,0,496,288Z"
        ],
        "sitemap": [
            640,
            512,
            [],
            "f0e8",
            "M128 352H32c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm-24-80h192v48h48v-48h192v48h48v-57.59c0-21.17-17.23-38.41-38.41-38.41H344v-64h40c17.67 0 32-14.33 32-32V32c0-17.67-14.33-32-32-32H256c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h40v64H94.41C73.23 224 56 241.23 56 262.41V320h48v-48zm264 80h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32zm240 0h-96c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32z"
        ],
        "skating": [
            448,
            512,
            [],
            "f7c5",
            "M400 0c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48zm0 448c-8.8 0-16 7.2-16 16s-7.2 16-16 16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16h96c26.5 0 48-21.5 48-48 0-8.8-7.2-16-16-16zm-282.2 8.6c-6.2 6.2-16.4 6.3-22.6 0l-67.9-67.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l67.9 67.9c9.4 9.4 21.7 14 34 14s24.6-4.7 33.9-14c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.3-22.7 0zm56.1-179.8l-93.7 93.7c-12.5 12.5-12.5 32.8 0 45.2 6.2 6.2 14.4 9.4 22.6 9.4s16.4-3.1 22.6-9.4l91.9-91.9-30.2-30.2c-5-5-9.4-10.7-13.2-16.8zM128 160h105.5l-20.1 17.2c-13.5 11.5-21.6 28.4-22.3 46.1-.7 17.8 6.1 35.2 18.7 47.7l78.2 78.2V432c0 17.7 14.3 32 32 32s32-14.3 32-32v-89.4c0-12.6-5.1-25-14.1-33.9l-61-61c.5-.4 1.2-.6 1.7-1.1l82.3-82.3c11.5-11.5 14.9-28.6 8.7-43.6-6.2-15-20.7-24.7-37-24.7H128c-17.7 0-32 14.3-32 32s14.3 32 32 32z"
        ],
        "skiing": [
            512,
            512,
            [],
            "f7c9",
            "M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm73 356.1c-9.4-9.4-24.6-9.4-33.9 0-12.1 12.1-30.5 15.4-45.1 8.7l-135.8-70.2 49.2-73.8c12.7-19 10.2-44.5-6-60.6L293 215.7l-107-53.1c-2.9 19.9 3.4 40 17.7 54.4l75.1 75.2-45.9 68.8L35 258.7c-11.7-6-26.2-1.5-32.3 10.3-6.1 11.8-1.5 26.3 10.3 32.3l391.9 202.5c11.9 5.5 24.5 8.1 37.1 8.1 23.2 0 46-9 63-26 9.3-9.3 9.3-24.5 0-33.8zM120 91.6l-11.5 22.5c14.4 7.3 31.2 4.9 42.8-4.8l47.2 23.4c-.1.1-.1.2-.2.3l114.5 56.8 32.4-13 6.4 19.1c4 12.1 12.6 22 24 27.7l58.1 29c15.9 7.9 35 1.5 42.9-14.3 7.9-15.8 1.5-35-14.3-42.9l-52.1-26.1-17.1-51.2c-8.1-24.2-40.9-56.6-84.5-39.2l-81.2 32.5-62.5-31c.3-14.5-7.2-28.6-20.9-35.6l-11.1 21.7h-.2l-34.4-7c-1.8-.4-3.7.2-5 1.7-1.9 2.2-1.7 5.5.5 7.4l26.2 23z"
        ],
        "skiing-nordic": [
            576,
            512,
            [],
            "f7ca",
            "M336 96c26.5 0 48-21.5 48-48S362.5 0 336 0s-48 21.5-48 48 21.5 48 48 48zm216 320c-13.2 0-24 10.7-24 24 0 13.2-10.8 24-24 24h-69.5L460 285.6c11.7-4.7 20.1-16.2 20.1-29.6 0-17.7-14.3-32-32-32h-44L378 170.8c-12.5-25.5-35.5-44.2-61.8-50.9L245 98.7c-28.3-6.8-57.8-.5-80.8 17.1l-39.7 30.4c-14 10.7-16.7 30.8-5.9 44.9.7.9 1.7 1.3 2.4 2.1L66.9 464H24c-13.2 0-24 10.7-24 24s10.8 24 24 24h480c39.7 0 72-32.3 72-72 0-13.2-10.8-24-24-24zm-260.5 48h-96.9l43.1-91-22-13c-12.1-7.2-21.9-16.9-29.5-27.8L123.7 464H99.5l52.3-261.4c4.1-1 8.1-2.9 11.7-5.6l39.7-30.4c7.7-5.9 17.4-8 25.3-6.1l14.7 4.4-37.5 87.4c-12.6 29.5-1.3 64 26.3 80.3l85 50.2-25.5 81.2zm110.6 0h-43.6l23.6-75.5c5.9-20.8-2.9-43.1-21.6-54.4L299.3 298l31.3-78.3 20.3 41.4c8 16.3 24.9 26.9 43.1 26.9h33.3l-25.2 176z"
        ],
        "skull": [
            512,
            512,
            [],
            "f54c",
            "M256 0C114.6 0 0 100.3 0 224c0 70.1 36.9 132.6 94.5 173.7 9.6 6.9 15.2 18.1 13.5 29.9l-9.4 66.2c-1.4 9.6 6 18.2 15.7 18.2H192v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h64v-56c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v56h77.7c9.7 0 17.1-8.6 15.7-18.2l-9.4-66.2c-1.7-11.7 3.8-23 13.5-29.9C475.1 356.6 512 294.1 512 224 512 100.3 397.4 0 256 0zm-96 320c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm192 0c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z"
        ],
        "skull-crossbones": [
            448,
            512,
            [],
            "f714",
            "M439.15 453.06L297.17 384l141.99-69.06c7.9-3.95 11.11-13.56 7.15-21.46L432 264.85c-3.95-7.9-13.56-11.11-21.47-7.16L224 348.41 37.47 257.69c-7.9-3.95-17.51-.75-21.47 7.16L1.69 293.48c-3.95 7.9-.75 17.51 7.15 21.46L150.83 384 8.85 453.06c-7.9 3.95-11.11 13.56-7.15 21.47l14.31 28.63c3.95 7.9 13.56 11.11 21.47 7.15L224 419.59l186.53 90.72c7.9 3.95 17.51.75 21.47-7.15l14.31-28.63c3.95-7.91.74-17.52-7.16-21.47zM150 237.28l-5.48 25.87c-2.67 12.62 5.42 24.85 16.45 24.85h126.08c11.03 0 19.12-12.23 16.45-24.85l-5.5-25.87c41.78-22.41 70-62.75 70-109.28C368 57.31 303.53 0 224 0S80 57.31 80 128c0 46.53 28.22 86.87 70 109.28zM280 112c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32zm-112 0c17.65 0 32 14.35 32 32s-14.35 32-32 32-32-14.35-32-32 14.35-32 32-32z"
        ],
        "slash": [
            640,
            512,
            [],
            "f715",
            "M594.53 508.63L6.18 53.9c-6.97-5.42-8.23-15.47-2.81-22.45L23.01 6.18C28.43-.8 38.49-2.06 45.47 3.37L633.82 458.1c6.97 5.42 8.23 15.47 2.81 22.45l-19.64 25.27c-5.42 6.98-15.48 8.23-22.46 2.81z"
        ],
        "sleigh": [
            640,
            512,
            [],
            "f7cc",
            "M612.7 350.7l-9.3-7.4c-6.9-5.5-17-4.4-22.5 2.5l-10 12.5c-5.5 6.9-4.4 17 2.5 22.5l9.3 7.4c5.9 4.7 9.2 11.7 9.2 19.2 0 13.6-11 24.6-24.6 24.6H48c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h516c39 0 73.7-29.3 75.9-68.3 1.4-23.8-8.7-46.3-27.2-61zM32 224c0 59.6 40.9 109.2 96 123.5V400h64v-48h192v48h64v-48c53 0 96-43 96-96v-96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-96v64c0 35.3-28.7 64-64 64h-20.7c-65.8 0-125.9-37.2-155.3-96-29.4-58.8-89.6-96-155.3-96H32C14.3 32 0 46.3 0 64s14.3 32 32 32v128z"
        ],
        "sliders-h": [
            512,
            512,
            [],
            "f1de",
            "M496 384H160v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h80v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h336c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160h-80v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h336v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h80c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm0-160H288V48c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16h208v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h208c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16z"
        ],
        "smile": [
            496,
            512,
            [],
            "f118",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm80 168c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-160 0c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm194.8 170.2C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.6-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.4-16.2 38.1 4.2 24.6 20.5z"
        ],
        "smile-beam": [
            496,
            512,
            [],
            "f5b8",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM112 223.4c3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.7 8.6-10.8 11.9-14.9 4.5l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.3 7.4-15.8 4-15.1-4.5zm250.8 122.8C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11-36.7 24.6-20.5 22.4 26.9 55.2 42.2 90.2 42.2s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.3 24.6 20.5zm6.2-118.3l-9.5-17c-7.7-13.7-19.2-21.6-31.5-21.6s-23.8 7.9-31.5 21.6l-9.5 17c-4.1 7.3-15.6 4-14.9-4.5 3.3-42.1 32.2-71.4 56-71.4s52.7 29.3 56 71.4c.6 8.6-11 11.9-15.1 4.5z"
        ],
        "smile-wink": [
            496,
            512,
            [],
            "f4da",
            "M0 256c0 137 111 248 248 248s248-111 248-248S385 8 248 8 0 119 0 256zm200-48c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm158.5 16.5c-14.8-13.2-46.2-13.2-61 0L288 233c-8.3 7.4-21.6.4-19.8-10.8 4-25.2 34.2-42.1 59.9-42.1S384 197 388 222.2c1.7 11.1-11.4 18.3-19.8 10.8l-9.7-8.5zM157.8 325.8C180.2 352.7 213 368 248 368s67.8-15.4 90.2-42.2c13.6-16.2 38.1 4.2 24.6 20.5C334.3 380.4 292.5 400 248 400s-86.3-19.6-114.8-53.8c-13.5-16.3 11.2-36.7 24.6-20.4z"
        ],
        "smog": [
            640,
            512,
            [],
            "f75f",
            "M624 368H80c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h544c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm-480 96H16c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zm416 0H224c-8.8 0-16 7.2-16 16v16c0 8.8 7.2 16 16 16h336c8.8 0 16-7.2 16-16v-16c0-8.8-7.2-16-16-16zM144 288h156.1c22.5 19.7 51.6 32 83.9 32s61.3-12.3 83.9-32H528c61.9 0 112-50.1 112-112S589.9 64 528 64c-18 0-34.7 4.6-49.7 12.1C454 31 406.8 0 352 0c-41 0-77.8 17.3-104 44.8C221.8 17.3 185 0 144 0 64.5 0 0 64.5 0 144s64.5 144 144 144z"
        ],
        "smoking": [
            640,
            512,
            [],
            "f48d",
            "M632 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zM553.3 87.1c-5.7-3.8-9.3-10-9.3-16.8V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v62.3c0 22 10.2 43.4 28.6 55.4 42.2 27.3 67.4 73.8 67.4 124V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-65.5-32.4-126.2-86.7-162.6zM432 352H48c-26.5 0-48 21.5-48 48v64c0 26.5 21.5 48 48 48h384c8.8 0 16-7.2 16-16V368c0-8.8-7.2-16-16-16zm-32 112H224v-64h176v64zm87.7-322.4C463.8 125 448 99.3 448 70.3V8c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v66.4c0 43.7 24.6 81.6 60.3 106.7 22.4 15.7 35.7 41.2 35.7 68.6V280c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-30.3c0-43.3-21-83.4-56.3-108.1zM536 352h-48c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z"
        ],
        "smoking-ban": [
            512,
            512,
            [],
            "f54d",
            "M96 304c0 8.8 7.2 16 16 16h117.5l-96-96H112c-8.8 0-16 7.2-16 16v64zM256 0C114.6 0 0 114.6 0 256s114.6 256 256 256 256-114.6 256-256S397.4 0 256 0zm0 448c-105.9 0-192-86.1-192-192 0-41.4 13.3-79.7 35.7-111.1l267.4 267.4C335.7 434.7 297.4 448 256 448zm45.2-192H384v32h-50.8l-32-32zm111.1 111.1L365.2 320H400c8.8 0 16-7.2 16-16v-64c0-8.8-7.2-16-16-16H269.2L144.9 99.7C176.3 77.3 214.6 64 256 64c105.9 0 192 86.1 192 192 0 41.4-13.3 79.7-35.7 111.1zM320.6 128c-15.6 0-28.6-11.2-31.4-25.9-.7-3.6-4-6.1-7.7-6.1h-16.2c-5 0-8.7 4.5-8 9.4 4.6 30.9 31.2 54.6 63.3 54.6 15.6 0 28.6 11.2 31.4 25.9.7 3.6 4 6.1 7.7 6.1h16.2c5 0 8.7-4.5 8-9.4-4.6-30.9-31.2-54.6-63.3-54.6z"
        ],
        "sms": [
            512,
            512,
            [],
            "f7cd",
            "M256 32C114.6 32 0 125.1 0 240c0 49.6 21.4 95 57 130.7C44.5 421.1 2.7 466 2.2 466.5c-2.2 2.3-2.8 5.7-1.5 8.7 1.3 3 4.1 4.8 7.3 4.8 66.3 0 116-31.8 140.6-51.4 32.7 12.3 69 19.4 107.4 19.4 141.4 0 256-93.1 256-208S397.4 32 256 32zM128.2 304H116c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H156c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-19 38.6-42.4 38.6zm191.8-8c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8v-68.2l-24.8 55.8c-2.9 5.9-11.4 5.9-14.3 0L224 227.8V296c0 4.4-3.6 8-8 8h-16c-4.4 0-8-3.6-8-8V192c0-8.8 7.2-16 16-16h16c6.1 0 11.6 3.4 14.3 8.8l17.7 35.4 17.7-35.4c2.7-5.4 8.3-8.8 14.3-8.8h16c8.8 0 16 7.2 16 16v104zm48.3 8H356c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h12.3c6 0 10.4-3.5 10.4-6.6 0-1.3-.8-2.7-2.1-3.8l-21.9-18.8c-8.5-7.2-13.3-17.5-13.3-28.1 0-21.3 19-38.6 42.4-38.6H396c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8h-12.3c-6 0-10.4 3.5-10.4 6.6 0 1.3.8 2.7 2.1 3.8l21.9 18.8c8.5 7.2 13.3 17.5 13.3 28.1.1 21.3-18.9 38.6-42.3 38.6z"
        ],
        "snowboarding": [
            512,
            512,
            [],
            "f7ce",
            "M432 96c26.5 0 48-21.5 48-48S458.5 0 432 0s-48 21.5-48 48 21.5 48 48 48zm28.8 153.6c5.8 4.3 12.5 6.4 19.2 6.4 9.7 0 19.3-4.4 25.6-12.8 10.6-14.1 7.8-34.2-6.4-44.8l-111.4-83.5c-13.8-10.3-29.1-18.4-45.4-23.8l-63.7-21.2-26.1-52.1C244.7 2 225.5-4.4 209.7 3.5c-15.8 7.9-22.2 27.1-14.3 42.9l29.1 58.1c5.7 11.4 15.6 19.9 27.7 24l16.4 5.5-41.2 20.6c-21.8 10.9-35.4 32.8-35.4 57.2v53.1l-74.1 24.7c-16.8 5.6-25.8 23.7-20.2 40.5 1.7 5.2 4.9 9.4 8.7 12.9l-38.7-14.1c-9.7-3.5-17.4-10.6-21.8-20-5.6-12-19.9-17.2-31.9-11.6s-17.2 19.9-11.6 31.9c9.8 21 27.1 36.9 48.9 44.8l364.8 132.7c9.7 3.5 19.7 5.3 29.7 5.3 12.5 0 24.9-2.7 36.5-8.2 12-5.6 17.2-19.9 11.6-31.9S474 454.7 462 460.3c-9.3 4.4-19.8 4.8-29.5 1.3l-90.8-33.1c8.7-4.1 15.6-11.8 17.8-21.9l21.9-102c3.9-18.2-3.2-37.2-18.1-48.4l-52-39 66-30.5 83.5 62.9zm-144.4 51.7l-19.7 92c-1.5 7.1-.1 13.9 2.8 20l-169.4-61.6c2.7-.2 5.4-.4 8-1.3l85-28.4c19.6-6.5 32.8-24.8 32.8-45.5V256l60.5 45.3z"
        ],
        "snowflake": [
            448,
            512,
            [],
            "f2dc",
            "M440.3 345.2l-33.8-19.5 26-7c8.2-2.2 13.1-10.7 10.9-18.9l-4-14.9c-2.2-8.2-10.7-13.1-18.9-10.9l-70.8 19-63.9-37 63.8-36.9 70.8 19c8.2 2.2 16.7-2.7 18.9-10.9l4-14.9c2.2-8.2-2.7-16.7-10.9-18.9l-26-7 33.8-19.5c7.4-4.3 9.9-13.7 5.7-21.1L430.4 119c-4.3-7.4-13.7-9.9-21.1-5.7l-33.8 19.5 7-26c2.2-8.2-2.7-16.7-10.9-18.9l-14.9-4c-8.2-2.2-16.7 2.7-18.9 10.9l-19 70.8-62.8 36.2v-77.5l53.7-53.7c6.2-6.2 6.2-16.4 0-22.6l-11.3-11.3c-6.2-6.2-16.4-6.2-22.6 0L256 56.4V16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v40.4l-19.7-19.7c-6.2-6.2-16.4-6.2-22.6 0L138.3 48c-6.3 6.2-6.3 16.4 0 22.6l53.7 53.7v77.5l-62.8-36.2-19-70.8c-2.2-8.2-10.7-13.1-18.9-10.9l-14.9 4c-8.2 2.2-13.1 10.7-10.9 18.9l7 26-33.8-19.5c-7.4-4.3-16.8-1.7-21.1 5.7L2.1 145.7c-4.3 7.4-1.7 16.8 5.7 21.1l33.8 19.5-26 7c-8.3 2.2-13.2 10.7-11 19l4 14.9c2.2 8.2 10.7 13.1 18.9 10.9l70.8-19 63.8 36.9-63.8 36.9-70.8-19c-8.2-2.2-16.7 2.7-18.9 10.9l-4 14.9c-2.2 8.2 2.7 16.7 10.9 18.9l26 7-33.8 19.6c-7.4 4.3-9.9 13.7-5.7 21.1l15.5 26.8c4.3 7.4 13.7 9.9 21.1 5.7l33.8-19.5-7 26c-2.2 8.2 2.7 16.7 10.9 18.9l14.9 4c8.2 2.2 16.7-2.7 18.9-10.9l19-70.8 62.8-36.2v77.5l-53.7 53.7c-6.3 6.2-6.3 16.4 0 22.6l11.3 11.3c6.2 6.2 16.4 6.2 22.6 0l19.7-19.7V496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-40.4l19.7 19.7c6.2 6.2 16.4 6.2 22.6 0l11.3-11.3c6.2-6.2 6.2-16.4 0-22.6L256 387.7v-77.5l62.8 36.2 19 70.8c2.2 8.2 10.7 13.1 18.9 10.9l14.9-4c8.2-2.2 13.1-10.7 10.9-18.9l-7-26 33.8 19.5c7.4 4.3 16.8 1.7 21.1-5.7l15.5-26.8c4.3-7.3 1.8-16.8-5.6-21z"
        ],
        "snowman": [
            512,
            512,
            [],
            "f7d0",
            "M510.9 152.3l-5.9-14.5c-3.3-8-12.6-11.9-20.8-8.7L456 140.6v-29c0-8.6-7.2-15.6-16-15.6h-16c-8.8 0-16 7-16 15.6v46.9c0 .5.3 1 .3 1.5l-56.4 23c-5.9-10-13.3-18.9-22-26.6 13.6-16.6 22-37.4 22-60.5 0-53-43-96-96-96s-96 43-96 96c0 23.1 8.5 43.9 22 60.5-8.7 7.7-16 16.6-22 26.6l-56.4-23c.1-.5.3-1 .3-1.5v-46.9C104 103 96.8 96 88 96H72c-8.8 0-16 7-16 15.6v29l-28.1-11.5c-8.2-3.2-17.5.7-20.8 8.7l-5.9 14.5c-3.3 8 .7 17.1 8.9 20.3l135.2 55.2c-.4 4-1.2 8-1.2 12.2 0 10.1 1.7 19.6 4.2 28.9C120.9 296.4 104 334.2 104 376c0 54 28.4 100.9 70.8 127.8 9.3 5.9 20.3 8.2 31.3 8.2h99.2c13.3 0 26.3-4.1 37.2-11.7 46.5-32.3 74.4-89.4 62.9-152.6-5.5-30.2-20.5-57.6-41.6-79 2.5-9.2 4.2-18.7 4.2-28.7 0-4.2-.8-8.1-1.2-12.2L502 172.6c8.1-3.1 12.1-12.2 8.9-20.3zM224 96c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm32 272c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-64c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16zm0-88s-16-23.2-16-32 7.2-16 16-16 16 7.2 16 16-16 32-16 32zm32-56c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
        ],
        "snowplow": [
            640,
            512,
            [],
            "f7d2",
            "M120 376c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm80 0c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm238.6 49.4c-14.5-14.5-22.6-34.1-22.6-54.6V269.2c0-20.5 8.1-40.1 22.6-54.6l36.7-36.7c6.2-6.2 6.2-16.4 0-22.6l-22.6-22.6c-6.2-6.2-16.4-6.2-22.6 0l-36.7 36.7c-26.5 26.5-41.4 62.4-41.4 99.9V288h-64v-50.9c0-8.7-1.8-17.2-5.2-25.2L364.5 29.1C356.9 11.4 339.6 0 320.3 0H176c-26.5 0-48 21.5-48 48v112h-16c-26.5 0-48 21.5-48 48v91.2C26.3 317.2 0 355.4 0 400c0 61.9 50.1 112 112 112h256c61.9 0 112-50.1 112-112 0-17.3-4.2-33.4-11.2-48H512v18.7c0 37.5 14.9 73.4 41.4 99.9l36.7 36.7c6.2 6.2 16.4 6.2 22.6 0l22.6-22.6c6.2-6.2 6.2-16.4 0-22.6l-36.7-36.7zM192 64h117.8l68.6 160H256l-64-64V64zm176 384H112c-26.5 0-48-21.5-48-48s21.5-48 48-48h256c26.5 0 48 21.5 48 48s-21.5 48-48 48z"
        ],
        "soap": [
            512,
            512,
            [],
            "e06e",
            "M416,192a95.42,95.42,0,0,1-30.94,70.21A95.8,95.8,0,0,1,352,448H160a96,96,0,0,1,0-192h88.91A95.3,95.3,0,0,1,224,192H96A96,96,0,0,0,0,288V416a96,96,0,0,0,96,96H416a96,96,0,0,0,96-96V288A96,96,0,0,0,416,192Zm-96,64a64,64,0,1,0-64-64A64,64,0,0,0,320,256ZM208,96a48,48,0,1,0-48-48A48,48,0,0,0,208,96ZM384,64a32,32,0,1,0-32-32A32,32,0,0,0,384,64ZM160,288a64,64,0,0,0,0,128H352a64,64,0,0,0,0-128Z"
        ],
        "socks": [
            512,
            512,
            [],
            "f696",
            "M214.66 311.01L288 256V96H128v176l-86.65 64.61c-39.4 29.56-53.86 84.42-29.21 127.06C30.39 495.25 63.27 512 96.08 512c20.03 0 40.25-6.25 57.52-19.2l21.86-16.39c-29.85-55.38-13.54-125.84 39.2-165.4zM288 32c0-11.05 3.07-21.3 8.02-30.38C293.4.92 290.85 0 288 0H160c-17.67 0-32 14.33-32 32v32h160V32zM480 0H352c-17.67 0-32 14.33-32 32v32h192V32c0-17.67-14.33-32-32-32zM320 272l-86.13 64.61c-39.4 29.56-53.86 84.42-29.21 127.06 18.25 31.58 50.61 48.33 83.42 48.33 20.03 0 40.25-6.25 57.52-19.2l115.2-86.4A127.997 127.997 0 0 0 512 304V96H320v176z"
        ],
        "solar-panel": [
            640,
            512,
            [],
            "f5ba",
            "M431.98 448.01l-47.97.05V416h-128v32.21l-47.98.05c-8.82.01-15.97 7.16-15.98 15.99l-.05 31.73c-.01 8.85 7.17 16.03 16.02 16.02l223.96-.26c8.82-.01 15.97-7.16 15.98-15.98l.04-31.73c.01-8.85-7.17-16.03-16.02-16.02zM585.2 26.74C582.58 11.31 568.99 0 553.06 0H86.93C71 0 57.41 11.31 54.79 26.74-3.32 369.16.04 348.08.03 352c-.03 17.32 14.29 32 32.6 32h574.74c18.23 0 32.51-14.56 32.59-31.79.02-4.08 3.35 16.95-54.76-325.47zM259.83 64h120.33l9.77 96H250.06l9.77-96zm-75.17 256H71.09L90.1 208h105.97l-11.41 112zm16.29-160H98.24l16.29-96h96.19l-9.77 96zm32.82 160l11.4-112h149.65l11.4 112H233.77zm195.5-256h96.19l16.29 96H439.04l-9.77-96zm26.06 256l-11.4-112H549.9l19.01 112H455.33z"
        ],
        "sort": [
            320,
            512,
            [],
            "f0dc",
            "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41zm255-105L177 64c-9.4-9.4-24.6-9.4-33.9 0L24 183c-15.1 15.1-4.4 41 17 41h238c21.4 0 32.1-25.9 17-41z"
        ],
        "sort-alpha-down": [
            448,
            512,
            [],
            "f15d",
            "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm240-64H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"
        ],
        "sort-alpha-down-alt": [
            448,
            512,
            [],
            "f881",
            "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm112-128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"
        ],
        "sort-alpha-up": [
            448,
            512,
            [],
            "f15e",
            "M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm400 128H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 446.37V464a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 321.63V304a16 16 0 0 0-16-16zm31.06-85.38l-59.27-160A16 16 0 0 0 372.72 32h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 224h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 224H432a16 16 0 0 0 15.06-21.38zM335.61 144L352 96l16.39 48z"
        ],
        "sort-alpha-up-alt": [
            448,
            512,
            [],
            "f882",
            "M16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160zm272 64h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-56l61.26-70.45A32 32 0 0 0 432 65.63V48a16 16 0 0 0-16-16H288a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h56l-61.26 70.45A32 32 0 0 0 272 190.37V208a16 16 0 0 0 16 16zm159.06 234.62l-59.27-160A16 16 0 0 0 372.72 288h-41.44a16 16 0 0 0-15.07 10.62l-59.27 160A16 16 0 0 0 272 480h24.83a16 16 0 0 0 15.23-11.08l4.42-12.92h71l4.41 12.92A16 16 0 0 0 407.16 480H432a16 16 0 0 0 15.06-21.38zM335.61 400L352 352l16.39 48z"
        ],
        "sort-amount-down": [
            512,
            512,
            [],
            "f160",
            "M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-128-64h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm256-192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
        ],
        "sort-amount-down-alt": [
            512,
            512,
            [],
            "f884",
            "M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm-64 0h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.37 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"
        ],
        "sort-amount-up": [
            512,
            512,
            [],
            "f161",
            "M304 416h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h64a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.77 160 16 160zm416 0H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-64 128H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM496 32H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
        ],
        "sort-amount-up-alt": [
            512,
            512,
            [],
            "f885",
            "M240 96h64a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16h-64a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm0 128h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm256 192H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h256a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-256-64h192a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H240a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zM16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.39-17.24 11.31-27.31l-80-96a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160z"
        ],
        "sort-down": [
            320,
            512,
            [],
            "f0dd",
            "M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z"
        ],
        "sort-numeric-down": [
            448,
            512,
            [],
            "f162",
            "M304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zm26.15 162.91a79 79 0 0 0-55 54.17c-14.25 51.05 21.21 97.77 68.85 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zm-176-4h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352z"
        ],
        "sort-numeric-down-alt": [
            448,
            512,
            [],
            "f886",
            "M176 352h-48V48a16 16 0 0 0-16-16H80a16 16 0 0 0-16 16v304H16c-14.19 0-21.36 17.24-11.29 27.31l80 96a16 16 0 0 0 22.62 0l80-96C197.35 369.26 190.22 352 176 352zm224 64h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"
        ],
        "sort-numeric-up": [
            448,
            512,
            [],
            "f163",
            "M330.17 258.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.76 86.25-61.61 86.25-132V336c-.02-51.21-48.4-91.34-101.85-77.09zM352 356a20 20 0 1 1 20-20 20 20 0 0 1-20 20zM304 96h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-16V48a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 96zM107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31z"
        ],
        "sort-numeric-up-alt": [
            448,
            512,
            [],
            "f887",
            "M107.31 36.69a16 16 0 0 0-22.62 0l-80 96C-5.35 142.74 1.78 160 16 160h48v304a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V160h48c14.21 0 21.38-17.24 11.31-27.31zM400 416h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 304 352h16v64h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM330.17 34.91a79 79 0 0 0-55 54.17c-14.27 51.05 21.19 97.77 68.83 102.53a84.07 84.07 0 0 1-20.85 12.91c-7.57 3.4-10.8 12.47-8.18 20.34l9.9 20c2.87 8.63 12.53 13.49 20.9 9.91 58-24.77 86.25-61.61 86.25-132V112c-.02-51.21-48.4-91.34-101.85-77.09zM352 132a20 20 0 1 1 20-20 20 20 0 0 1-20 20z"
        ],
        "sort-up": [
            320,
            512,
            [],
            "f0de",
            "M279 224H41c-21.4 0-32.1-25.9-17-41L143 64c9.4-9.4 24.6-9.4 33.9 0l119 119c15.2 15.1 4.5 41-16.9 41z"
        ],
        "spa": [
            576,
            512,
            [],
            "f5bb",
            "M568.25 192c-29.04.13-135.01 6.16-213.84 83-33.12 29.63-53.36 63.3-66.41 94.86-13.05-31.56-33.29-65.23-66.41-94.86-78.83-76.84-184.8-82.87-213.84-83-4.41-.02-7.79 3.4-7.75 7.82.23 27.92 7.14 126.14 88.77 199.3C172.79 480.94 256 480 288 480s115.19.95 199.23-80.88c81.64-73.17 88.54-171.38 88.77-199.3.04-4.42-3.34-7.84-7.75-7.82zM287.98 302.6c12.82-18.85 27.6-35.78 44.09-50.52 19.09-18.61 39.58-33.3 60.26-45.18-16.44-70.5-51.72-133.05-96.73-172.22-4.11-3.58-11.02-3.58-15.14 0-44.99 39.14-80.27 101.63-96.74 172.07 20.37 11.7 40.5 26.14 59.22 44.39a282.768 282.768 0 0 1 45.04 51.46z"
        ],
        "space-shuttle": [
            640,
            512,
            [],
            "f197",
            "M592.604 208.244C559.735 192.836 515.777 184 472 184H186.327c-4.952-6.555-10.585-11.978-16.72-16H376C229.157 137.747 219.403 32 96.003 32H96v128H80V32c-26.51 0-48 28.654-48 64v64c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v16c-23.197 0-32 10.032-32 24v40c0 13.983 8.819 24 32 24v64c0 35.346 21.49 64 48 64V352h16v128h.003c123.4 0 133.154-105.747 279.997-136H169.606c6.135-4.022 11.768-9.445 16.72-16H472c43.777 0 87.735-8.836 120.604-24.244C622.282 289.845 640 271.992 640 256s-17.718-33.845-47.396-47.756zM488 296a8 8 0 0 1-8-8v-64a8 8 0 0 1 8-8c31.909 0 31.942 80 0 80z"
        ],
        "spell-check": [
            576,
            512,
            [],
            "f891",
            "M272 256h91.36c43.2 0 82-32.2 84.51-75.34a79.82 79.82 0 0 0-25.26-63.07 79.81 79.81 0 0 0 9.06-44.91C427.9 30.57 389.3 0 347 0h-75a16 16 0 0 0-16 16v224a16 16 0 0 0 16 16zm40-200h40a24 24 0 0 1 0 48h-40zm0 96h56a24 24 0 0 1 0 48h-56zM155.12 22.25A32 32 0 0 0 124.64 0H99.36a32 32 0 0 0-30.48 22.25L.59 235.73A16 16 0 0 0 16 256h24.93a16 16 0 0 0 15.42-11.73L68.29 208h87.42l11.94 36.27A16 16 0 0 0 183.07 256H208a16 16 0 0 0 15.42-20.27zM89.37 144L112 75.3l22.63 68.7zm482 132.48l-45.21-45.3a15.88 15.88 0 0 0-22.59 0l-151.5 151.5-55.41-55.5a15.88 15.88 0 0 0-22.59 0l-45.3 45.3a16 16 0 0 0 0 22.59l112 112.21a15.89 15.89 0 0 0 22.6 0l208-208.21a16 16 0 0 0-.02-22.59z"
        ],
        "spider": [
            576,
            512,
            [],
            "f717",
            "M151.17 167.35L177.1 176h4.67l5.22-26.12c.72-3.58 1.8-7.58 3.21-11.79l-20.29-40.58 23.8-71.39c2.79-8.38-1.73-17.44-10.12-20.24L168.42.82c-8.38-2.8-17.45 1.73-20.24 10.12l-25.89 77.68a32.04 32.04 0 0 0 1.73 24.43l27.15 54.3zm422.14 182.03l-52.75-79.12a32.002 32.002 0 0 0-26.62-14.25H416l68.99-24.36a32.03 32.03 0 0 0 16.51-12.61l53.6-80.41c4.9-7.35 2.91-17.29-4.44-22.19l-13.31-8.88c-7.35-4.9-17.29-2.91-22.19 4.44l-50.56 75.83L404.1 208H368l-10.37-51.85C355.44 145.18 340.26 96 288 96c-52.26 0-67.44 49.18-69.63 60.15L208 208h-36.1l-60.49-20.17L60.84 112c-4.9-7.35-14.83-9.34-22.19-4.44l-13.31 8.88c-7.35 4.9-9.34 14.83-4.44 22.19l53.6 80.41a32.03 32.03 0 0 0 16.51 12.61L160 256H82.06a32.02 32.02 0 0 0-26.63 14.25L2.69 349.38c-4.9 7.35-2.92 17.29 4.44 22.19l13.31 8.88c7.35 4.9 17.29 2.91 22.19-4.44l48-72h47.06l-60.83 97.33A31.988 31.988 0 0 0 72 418.3V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-73.11l74.08-118.53c-1.01 14.05-2.08 28.11-2.08 42.21C192 399.64 232.76 448 288 448s96-48.36 96-101.43c0-14.1-1.08-28.16-2.08-42.21L456 422.89V496c0 8.84 7.16 16 16 16h16c8.84 0 16-7.16 16-16v-77.71c0-6-1.69-11.88-4.86-16.96L438.31 304h47.06l48 72c4.9 7.35 14.84 9.34 22.19 4.44l13.31-8.88c7.36-4.9 9.34-14.83 4.44-22.18zM406.09 97.51l-20.29 40.58c1.41 4.21 2.49 8.21 3.21 11.79l5.22 26.12h4.67l25.93-8.65 27.15-54.3a31.995 31.995 0 0 0 1.73-24.43l-25.89-77.68C425.03 2.56 415.96-1.98 407.58.82l-15.17 5.06c-8.38 2.8-12.91 11.86-10.12 20.24l23.8 71.39z"
        ],
        "spinner": [
            512,
            512,
            [],
            "f110",
            "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
        ],
        "splotch": [
            512,
            512,
            [],
            "f5bc",
            "M472.29 195.89l-67.06-22.95c-19.28-6.6-33.54-20.92-38.14-38.3L351.1 74.19c-11.58-43.77-76.57-57.13-109.98-22.62l-46.14 47.67c-13.26 13.71-33.54 20.93-54.2 19.31l-71.88-5.62c-52.05-4.07-86.93 44.88-59.03 82.83l38.54 52.42c11.08 15.07 12.82 33.86 4.64 50.24L24.62 355.4c-20.59 41.25 22.84 84.87 73.49 73.81l69.96-15.28c20.11-4.39 41.45 0 57.07 11.73l54.32 40.83c39.32 29.56 101.04 7.57 104.45-37.22l4.7-61.86c1.35-17.79 12.8-33.86 30.63-42.99l62-31.74c44.88-22.96 39.59-80.17-8.95-96.79z"
        ],
        "spray-can": [
            512,
            512,
            [],
            "f5bd",
            "M224 32c0-17.67-14.33-32-32-32h-64c-17.67 0-32 14.33-32 32v96h128V32zm256 96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-256 32H96c-53.02 0-96 42.98-96 96v224c0 17.67 14.33 32 32 32h256c17.67 0 32-14.33 32-32V256c0-53.02-42.98-96-96-96zm-64 256c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zM480 96c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm-96 32c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm-96-96c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 0c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32zm96 192c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
        ],
        "square": [
            448,
            512,
            [],
            "f0c8",
            "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
        ],
        "square-full": [
            512,
            512,
            [],
            "f45c",
            "M512 512H0V0h512v512z"
        ],
        "square-root-alt": [
            576,
            512,
            [],
            "f698",
            "M571.31 251.31l-22.62-22.62c-6.25-6.25-16.38-6.25-22.63 0L480 274.75l-46.06-46.06c-6.25-6.25-16.38-6.25-22.63 0l-22.62 22.62c-6.25 6.25-6.25 16.38 0 22.63L434.75 320l-46.06 46.06c-6.25 6.25-6.25 16.38 0 22.63l22.62 22.62c6.25 6.25 16.38 6.25 22.63 0L480 365.25l46.06 46.06c6.25 6.25 16.38 6.25 22.63 0l22.62-22.62c6.25-6.25 6.25-16.38 0-22.63L525.25 320l46.06-46.06c6.25-6.25 6.25-16.38 0-22.63zM552 0H307.65c-14.54 0-27.26 9.8-30.95 23.87l-84.79 322.8-58.41-106.1A32.008 32.008 0 0 0 105.47 224H24c-13.25 0-24 10.74-24 24v48c0 13.25 10.75 24 24 24h43.62l88.88 163.73C168.99 503.5 186.3 512 204.94 512c17.27 0 44.44-9 54.28-41.48L357.03 96H552c13.25 0 24-10.75 24-24V24c0-13.26-10.75-24-24-24z"
        ],
        "stamp": [
            512,
            512,
            [],
            "f5bf",
            "M32 512h448v-64H32v64zm384-256h-66.56c-16.26 0-29.44-13.18-29.44-29.44v-9.46c0-27.37 8.88-53.41 21.46-77.72 9.11-17.61 12.9-38.39 9.05-60.42-6.77-38.78-38.47-70.7-77.26-77.45C212.62-9.04 160 37.33 160 96c0 14.16 3.12 27.54 8.69 39.58C182.02 164.43 192 194.7 192 226.49v.07c0 16.26-13.18 29.44-29.44 29.44H96c-53.02 0-96 42.98-96 96v32c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-32c0-53.02-42.98-96-96-96z"
        ],
        "star": [
            576,
            512,
            [],
            "f005",
            "M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"
        ],
        "star-and-crescent": [
            512,
            512,
            [],
            "f699",
            "M340.47 466.36c-1.45 0-6.89.46-9.18.46-116.25 0-210.82-94.57-210.82-210.82S215.04 45.18 331.29 45.18c2.32 0 7.7.46 9.18.46 7.13 0 13.33-5.03 14.75-12.07 1.46-7.25-2.55-14.49-9.47-17.09C316.58 5.54 286.39 0 256 0 114.84 0 0 114.84 0 256s114.84 256 256 256c30.23 0 60.28-5.49 89.32-16.32 5.96-2.02 10.28-7.64 10.28-14.26 0-8.09-6.39-15.06-15.13-15.06zm162.99-252.5l-76.38-11.1-34.16-69.21c-1.83-3.7-5.38-5.55-8.93-5.55s-7.1 1.85-8.93 5.55l-34.16 69.21-76.38 11.1c-8.17 1.18-11.43 11.22-5.52 16.99l55.27 53.87-13.05 76.07c-1.11 6.44 4.01 11.66 9.81 11.66 1.53 0 3.11-.36 4.64-1.17L384 335.37l68.31 35.91c1.53.8 3.11 1.17 4.64 1.17 5.8 0 10.92-5.23 9.81-11.66l-13.05-76.07 55.27-53.87c5.91-5.77 2.65-15.81-5.52-16.99z"
        ],
        "star-half": [
            576,
            512,
            [],
            "f089",
            "M288 0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6V0z"
        ],
        "star-half-alt": [
            536,
            512,
            [],
            "f5c0",
            "M508.55 171.51L362.18 150.2 296.77 17.81C290.89 5.98 279.42 0 267.95 0c-11.4 0-22.79 5.9-28.69 17.81l-65.43 132.38-146.38 21.29c-26.25 3.8-36.77 36.09-17.74 54.59l105.89 103-25.06 145.48C86.98 495.33 103.57 512 122.15 512c4.93 0 10-1.17 14.87-3.75l130.95-68.68 130.94 68.7c4.86 2.55 9.92 3.71 14.83 3.71 18.6 0 35.22-16.61 31.66-37.4l-25.03-145.49 105.91-102.98c19.04-18.5 8.52-50.8-17.73-54.6zm-121.74 123.2l-18.12 17.62 4.28 24.88 19.52 113.45-102.13-53.59-22.38-11.74.03-317.19 51.03 103.29 11.18 22.63 25.01 3.64 114.23 16.63-82.65 80.38z"
        ],
        "star-of-david": [
            464,
            512,
            [],
            "f69a",
            "M405.68 256l53.21-89.39C473.3 142.4 455.48 112 426.88 112H319.96l-55.95-93.98C256.86 6.01 244.43 0 232 0s-24.86 6.01-32.01 18.02L144.04 112H37.11c-28.6 0-46.42 30.4-32.01 54.61L58.32 256 5.1 345.39C-9.31 369.6 8.51 400 37.11 400h106.93l55.95 93.98C207.14 505.99 219.57 512 232 512s24.86-6.01 32.01-18.02L319.96 400h106.93c28.6 0 46.42-30.4 32.01-54.61L405.68 256zm-12.78-88l-19.8 33.26L353.3 168h39.6zm-52.39 88l-52.39 88H175.88l-52.39-88 52.38-88h112.25l52.39 88zM232 73.72L254.79 112h-45.57L232 73.72zM71.1 168h39.6l-19.8 33.26L71.1 168zm0 176l19.8-33.26L110.7 344H71.1zM232 438.28L209.21 400h45.57L232 438.28zM353.29 344l19.8-33.26L392.9 344h-39.61z"
        ],
        "star-of-life": [
            480,
            512,
            [],
            "f621",
            "M471.99 334.43L336.06 256l135.93-78.43c7.66-4.42 10.28-14.2 5.86-21.86l-32.02-55.43c-4.42-7.65-14.21-10.28-21.87-5.86l-135.93 78.43V16c0-8.84-7.17-16-16.01-16h-64.04c-8.84 0-16.01 7.16-16.01 16v156.86L56.04 94.43c-7.66-4.42-17.45-1.79-21.87 5.86L2.15 155.71c-4.42 7.65-1.8 17.44 5.86 21.86L143.94 256 8.01 334.43c-7.66 4.42-10.28 14.21-5.86 21.86l32.02 55.43c4.42 7.65 14.21 10.27 21.87 5.86l135.93-78.43V496c0 8.84 7.17 16 16.01 16h64.04c8.84 0 16.01-7.16 16.01-16V339.14l135.93 78.43c7.66 4.42 17.45 1.8 21.87-5.86l32.02-55.43c4.42-7.65 1.8-17.43-5.86-21.85z"
        ],
        "step-backward": [
            448,
            512,
            [],
            "f048",
            "M64 468V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12v176.4l195.5-181C352.1 22.3 384 36.6 384 64v384c0 27.4-31.9 41.7-52.5 24.6L136 292.7V468c0 6.6-5.4 12-12 12H76c-6.6 0-12-5.4-12-12z"
        ],
        "step-forward": [
            448,
            512,
            [],
            "f051",
            "M384 44v424c0 6.6-5.4 12-12 12h-48c-6.6 0-12-5.4-12-12V291.6l-195.5 181C95.9 489.7 64 475.4 64 448V64c0-27.4 31.9-41.7 52.5-24.6L312 219.3V44c0-6.6 5.4-12 12-12h48c6.6 0 12 5.4 12 12z"
        ],
        "stethoscope": [
            512,
            512,
            [],
            "f0f1",
            "M447.1 112c-34.2.5-62.3 28.4-63 62.6-.5 24.3 12.5 45.6 32 56.8V344c0 57.3-50.2 104-112 104-60 0-109.2-44.1-111.9-99.2C265 333.8 320 269.2 320 192V36.6c0-11.4-8.1-21.3-19.3-23.5L237.8.5c-13-2.6-25.6 5.8-28.2 18.8L206.4 35c-2.6 13 5.8 25.6 18.8 28.2l30.7 6.1v121.4c0 52.9-42.2 96.7-95.1 97.2-53.4.5-96.9-42.7-96.9-96V69.4l30.7-6.1c13-2.6 21.4-15.2 18.8-28.2l-3.1-15.7C107.7 6.4 95.1-2 82.1.6L19.3 13C8.1 15.3 0 25.1 0 36.6V192c0 77.3 55.1 142 128.1 156.8C130.7 439.2 208.6 512 304 512c97 0 176-75.4 176-168V231.4c19.1-11.1 32-31.7 32-55.4 0-35.7-29.2-64.5-64.9-64zm.9 80c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16-7.2 16-16 16z"
        ],
        "sticky-note": [
            448,
            512,
            [],
            "f249",
            "M312 320h136V56c0-13.3-10.7-24-24-24H24C10.7 32 0 42.7 0 56v400c0 13.3 10.7 24 24 24h264V344c0-13.2 10.8-24 24-24zm129 55l-98 98c-4.5 4.5-10.6 7-17 7h-6V352h128v6.1c0 6.3-2.5 12.4-7 16.9z"
        ],
        "stop": [
            448,
            512,
            [],
            "f04d",
            "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48z"
        ],
        "stop-circle": [
            512,
            512,
            [],
            "f28d",
            "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm96 328c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16v160z"
        ],
        "stopwatch": [
            448,
            512,
            [],
            "f2f2",
            "M432 304c0 114.9-93.1 208-208 208S16 418.9 16 304c0-104 76.3-190.2 176-205.5V64h-28c-6.6 0-12-5.4-12-12V12c0-6.6 5.4-12 12-12h120c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-28v34.5c37.5 5.8 71.7 21.6 99.7 44.6l27.5-27.5c4.7-4.7 12.3-4.7 17 0l28.3 28.3c4.7 4.7 4.7 12.3 0 17l-29.4 29.4-.6.6C419.7 223.3 432 262.2 432 304zm-176 36V188.5c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12V340c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12z"
        ],
        "stopwatch-20": [
            448,
            512,
            [],
            "e06f",
            "M398.5,190.91l.59-.61,26.59-26.58a16,16,0,0,0,0-22.63L403,118.41a16,16,0,0,0-22.63,0l-24.68,24.68A206.68,206.68,0,0,0,256,98.5V64h32a16,16,0,0,0,16-16V16A16,16,0,0,0,288,0H160a16.05,16.05,0,0,0-16,16V48a16.05,16.05,0,0,0,16,16h32V98.5A207.92,207.92,0,0,0,16.09,297.57C12.64,411.5,106.76,510.22,220.72,512,337.13,513.77,432,420,432,304A206,206,0,0,0,398.5,190.91ZM204.37,377.55a8.2,8.2,0,0,1,8.32,8.07v22.31a8.2,8.2,0,0,1-8.32,8.07H121.52a16.46,16.46,0,0,1-16.61-17.62c2.78-35.22,14.67-57.41,38.45-91.37,20.42-29.19,27.1-37.32,27.1-62.34,0-16.92-1.79-24.27-12.21-24.27-9.39,0-12.69,7.4-12.69,22.68v5.23a8.2,8.2,0,0,1-8.33,8.07h-24.9a8.2,8.2,0,0,1-8.33-8.07v-4.07c0-27.3,8.48-60.24,56.43-60.24,43,0,55.57,25.85,55.57,61,0,35.58-12.44,51.21-34.35,81.31-11.56,15-24.61,35.57-26.41,51.2ZM344,352.32c0,35.16-12.3,63.68-57.23,63.68C243.19,416,232,386.48,232,352.55V247.22c0-40.73,19.58-63.22,56.2-63.22C325,184,344,206.64,344,245.3ZM287.87,221.73c-9.41,0-13.23,7.5-13.23,20V357.68c0,13.11,3.59,20.59,13.23,20.59s13-8,13-21.27V241.06C300.89,229.79,297.88,221.73,287.87,221.73Z"
        ],
        "store": [
            616,
            512,
            [],
            "f54e",
            "M602 118.6L537.1 15C531.3 5.7 521 0 510 0H106C95 0 84.7 5.7 78.9 15L14 118.6c-33.5 53.5-3.8 127.9 58.8 136.4 4.5.6 9.1.9 13.7.9 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18 20.1 44.3 33.1 73.8 33.1 29.6 0 55.8-13 73.8-33.1 18.1 20.1 44.3 33.1 73.8 33.1 4.7 0 9.2-.3 13.7-.9 62.8-8.4 92.6-82.8 59-136.4zM529.5 288c-10 0-19.9-1.5-29.5-3.8V384H116v-99.8c-9.6 2.2-19.5 3.8-29.5 3.8-6 0-12.1-.4-18-1.2-5.6-.8-11.1-2.1-16.4-3.6V480c0 17.7 14.3 32 32 32h448c17.7 0 32-14.3 32-32V283.2c-5.4 1.6-10.8 2.9-16.4 3.6-6.1.8-12.1 1.2-18.2 1.2z"
        ],
        "store-alt": [
            640,
            512,
            [],
            "f54f",
            "M320 384H128V224H64v256c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V224h-64v160zm314.6-241.8l-85.3-128c-6-8.9-16-14.2-26.7-14.2H117.4c-10.7 0-20.7 5.3-26.6 14.2l-85.3 128c-14.2 21.3 1 49.8 26.6 49.8H608c25.5 0 40.7-28.5 26.6-49.8zM512 496c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V224h-64v272z"
        ],
        "store-alt-slash": [
            640,
            512,
            [],
            "e070",
            "M17.89,123.62,5.51,142.2c-14.2,21.3,1,49.8,26.59,49.8h74.26ZM576,413.42V224H512V364L384,265V224H330.92l-41.4-32H608c25.5,0,40.7-28.5,26.59-49.8l-85.29-128A32.18,32.18,0,0,0,522.6,0H117.42A31.87,31.87,0,0,0,90.81,14.2l-10.66,16L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.81l19.64-25.26a16,16,0,0,0-2.81-22.45ZM320,384H128V224H64V480a32,32,0,0,0,32,32H352a32,32,0,0,0,32-32V406.59l-64-49.47Z"
        ],
        "store-slash": [
            640,
            512,
            [],
            "e071",
            "M121.51,384V284.2a119.43,119.43,0,0,1-28,3.8,123.46,123.46,0,0,1-17.1-1.2,114.88,114.88,0,0,1-15.58-3.6V480c0,17.7,13.59,32,30.4,32H505.75L348.42,384Zm-28-128.09c25.1,0,47.29-10.72,64-27.24L24,120.05c-30.52,53.39-2.45,126.53,56.49,135A95.68,95.68,0,0,0,93.48,255.91ZM602.13,458.09,547.2,413.41V283.2a93.5,93.5,0,0,1-15.57,3.6,127.31,127.31,0,0,1-17.29,1.2,114.89,114.89,0,0,1-28-3.8v79.68L348.52,251.77a88.06,88.06,0,0,0,25.41,4.14c28.11,0,53-13,70.11-33.11,17.19,20.11,42.08,33.11,70.11,33.11a94.31,94.31,0,0,0,13-.91c59.66-8.41,88-82.8,56.06-136.4L521.55,15A30.1,30.1,0,0,0,495.81,0H112A30.11,30.11,0,0,0,86.27,15L76.88,30.78,43.19,3.38A14.68,14.68,0,0,0,21.86,6.19L3.2,31.45A16.58,16.58,0,0,0,5.87,53.91L564.81,508.63a14.69,14.69,0,0,0,21.33-2.82l18.66-25.26A16.58,16.58,0,0,0,602.13,458.09Z"
        ],
        "stream": [
            512,
            512,
            [],
            "f550",
            "M16 128h416c8.84 0 16-7.16 16-16V48c0-8.84-7.16-16-16-16H16C7.16 32 0 39.16 0 48v64c0 8.84 7.16 16 16 16zm480 80H80c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16zm-64 176H16c-8.84 0-16 7.16-16 16v64c0 8.84 7.16 16 16 16h416c8.84 0 16-7.16 16-16v-64c0-8.84-7.16-16-16-16z"
        ],
        "street-view": [
            512,
            512,
            [],
            "f21d",
            "M367.9 329.76c-4.62 5.3-9.78 10.1-15.9 13.65v22.94c66.52 9.34 112 28.05 112 49.65 0 30.93-93.12 56-208 56S48 446.93 48 416c0-21.6 45.48-40.3 112-49.65v-22.94c-6.12-3.55-11.28-8.35-15.9-13.65C58.87 345.34 0 378.05 0 416c0 53.02 114.62 96 256 96s256-42.98 256-96c0-37.95-58.87-70.66-144.1-86.24zM256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-64 192v96c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-96c17.67 0 32-14.33 32-32v-96c0-26.51-21.49-48-48-48h-11.8c-11.07 5.03-23.26 8-36.2 8s-25.13-2.97-36.2-8H208c-26.51 0-48 21.49-48 48v96c0 17.67 14.33 32 32 32z"
        ],
        "strikethrough": [
            512,
            512,
            [],
            "f0cc",
            "M496 224H293.9l-87.17-26.83A43.55 43.55 0 0 1 219.55 112h66.79A49.89 49.89 0 0 1 331 139.58a16 16 0 0 0 21.46 7.15l42.94-21.47a16 16 0 0 0 7.16-21.46l-.53-1A128 128 0 0 0 287.51 32h-68a123.68 123.68 0 0 0-123 135.64c2 20.89 10.1 39.83 21.78 56.36H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h480a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-180.24 96A43 43 0 0 1 336 356.45 43.59 43.59 0 0 1 292.45 400h-66.79A49.89 49.89 0 0 1 181 372.42a16 16 0 0 0-21.46-7.15l-42.94 21.47a16 16 0 0 0-7.16 21.46l.53 1A128 128 0 0 0 224.49 480h68a123.68 123.68 0 0 0 123-135.64 114.25 114.25 0 0 0-5.34-24.36z"
        ],
        "stroopwafel": [
            512,
            512,
            [],
            "f551",
            "M188.12 210.74L142.86 256l45.25 45.25L233.37 256l-45.25-45.26zm113.13-22.62L256 142.86l-45.25 45.25L256 233.37l45.25-45.25zm-90.5 135.76L256 369.14l45.26-45.26L256 278.63l-45.25 45.25zM256 0C114.62 0 0 114.62 0 256s114.62 256 256 256 256-114.62 256-256S397.38 0 256 0zm186.68 295.6l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-28.29-28.29-45.25 45.25 33.94 33.94 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-33.94-33.94-45.26 45.26 28.29 28.29c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0L256 414.39l-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l28.29-28.29-45.25-45.26-33.94 33.94 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 33.94-33.94-45.25-45.25-28.29 28.29c-3.12 3.12-8.19 3.12-11.31 0L69.32 295.6c-3.12-3.12-3.12-8.19 0-11.31L97.61 256l-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l28.29 28.29 45.25-45.26-33.94-33.94-16.97 16.97c-3.12 3.12-8.19 3.12-11.31 0l-11.31-11.31c-3.12-3.12-3.12-8.19 0-11.31l16.97-16.97-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 33.94 33.94 45.26-45.25-28.29-28.29c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0L256 97.61l28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-28.29 28.29 45.26 45.25 33.94-33.94-16.97-16.97c-3.12-3.12-3.12-8.19 0-11.31l11.31-11.31c3.12-3.12 8.19-3.12 11.31 0l16.97 16.97 16.97-16.97c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31l-16.97 16.97 16.97 16.97c3.12 3.12 3.12 8.19 0 11.31l-11.31 11.31c-3.12 3.12-8.19 3.12-11.31 0l-16.97-16.97-33.94 33.94 45.25 45.26 28.29-28.29c3.12-3.12 8.19-3.12 11.31 0l11.31 11.31c3.12 3.12 3.12 8.19 0 11.31L414.39 256l28.29 28.28a8.015 8.015 0 0 1 0 11.32zM278.63 256l45.26 45.25L369.14 256l-45.25-45.26L278.63 256z"
        ],
        "subscript": [
            512,
            512,
            [],
            "f12c",
            "M496 448h-16V304a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 352h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"
        ],
        "subway": [
            448,
            512,
            [],
            "f239",
            "M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zM200 232V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm200 0V120c0-13.255-10.745-24-24-24H272c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h104c13.255 0 24-10.745 24-24zm-48 56c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm-256 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"
        ],
        "suitcase": [
            512,
            512,
            [],
            "f0f2",
            "M128 480h256V80c0-26.5-21.5-48-48-48H176c-26.5 0-48 21.5-48 48v400zm64-384h128v32H192V96zm320 80v256c0 26.5-21.5 48-48 48h-48V128h48c26.5 0 48 21.5 48 48zM96 480H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h48v352z"
        ],
        "suitcase-rolling": [
            384,
            512,
            [],
            "f5c1",
            "M336 160H48c-26.51 0-48 21.49-48 48v224c0 26.51 21.49 48 48 48h16v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h128v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16h16c26.51 0 48-21.49 48-48V208c0-26.51-21.49-48-48-48zm-16 216c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zm0-96c0 4.42-3.58 8-8 8H72c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h240c4.42 0 8 3.58 8 8v16zM144 48h96v80h48V48c0-26.51-21.49-48-48-48h-96c-26.51 0-48 21.49-48 48v80h48V48z"
        ],
        "sun": [
            512,
            512,
            [],
            "f185",
            "M256 160c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm246.4 80.5l-94.7-47.3 33.5-100.4c4.5-13.6-8.4-26.5-21.9-21.9l-100.4 33.5-47.4-94.8c-6.4-12.8-24.6-12.8-31 0l-47.3 94.7L92.7 70.8c-13.6-4.5-26.5 8.4-21.9 21.9l33.5 100.4-94.7 47.4c-12.8 6.4-12.8 24.6 0 31l94.7 47.3-33.5 100.5c-4.5 13.6 8.4 26.5 21.9 21.9l100.4-33.5 47.3 94.7c6.4 12.8 24.6 12.8 31 0l47.3-94.7 100.4 33.5c13.6 4.5 26.5-8.4 21.9-21.9l-33.5-100.4 94.7-47.3c13-6.5 13-24.7.2-31.1zm-155.9 106c-49.9 49.9-131.1 49.9-181 0-49.9-49.9-49.9-131.1 0-181 49.9-49.9 131.1-49.9 181 0 49.9 49.9 49.9 131.1 0 181z"
        ],
        "superscript": [
            512,
            512,
            [],
            "f12b",
            "M496 160h-16V16a16 16 0 0 0-16-16h-48a16 16 0 0 0-14.29 8.83l-16 32A16 16 0 0 0 400 64h16v96h-16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h96a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zM336 64h-67a16 16 0 0 0-13.14 6.87l-79.9 115-79.9-115A16 16 0 0 0 83 64H16A16 16 0 0 0 0 80v48a16 16 0 0 0 16 16h33.48l77.81 112-77.81 112H16a16 16 0 0 0-16 16v48a16 16 0 0 0 16 16h67a16 16 0 0 0 13.14-6.87l79.9-115 79.9 115A16 16 0 0 0 269 448h67a16 16 0 0 0 16-16v-48a16 16 0 0 0-16-16h-33.48l-77.81-112 77.81-112H336a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16z"
        ],
        "surprise": [
            496,
            512,
            [],
            "f5c2",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zM136 208c0-17.7 14.3-32 32-32s32 14.3 32 32-14.3 32-32 32-32-14.3-32-32zm112 208c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm80-176c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
        ],
        "swatchbook": [
            512,
            512,
            [],
            "f5c3",
            "M434.66,167.71h0L344.5,77.36a31.83,31.83,0,0,0-45-.07h0l-.07.07L224,152.88V424L434.66,212.9A32,32,0,0,0,434.66,167.71ZM480,320H373.09L186.68,506.51c-2.06,2.07-4.5,3.58-6.68,5.49H480a32,32,0,0,0,32-32V352A32,32,0,0,0,480,320ZM192,32A32,32,0,0,0,160,0H32A32,32,0,0,0,0,32V416a96,96,0,0,0,192,0ZM96,440a24,24,0,1,1,24-24A24,24,0,0,1,96,440Zm32-184H64V192h64Zm0-128H64V64h64Z"
        ],
        "swimmer": [
            640,
            512,
            [],
            "f5c4",
            "M189.61 310.58c3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c16.02-14.77 34.5-22.58 53.46-22.58h16.3c18.96 0 37.45 7.81 53.46 22.58 3.54 3.26 15.27 9.42 34.39 9.42s30.86-6.16 34.39-9.42c14.86-13.71 31.88-21.12 49.39-22.16l-112.84-80.6 18-12.86c3.64-2.58 8.28-3.52 12.62-2.61l100.35 21.53c25.91 5.53 51.44-10.97 57-36.88 5.55-25.92-10.95-51.44-36.88-57L437.68 98.47c-30.73-6.58-63.02.12-88.56 18.38l-80.02 57.17c-10.38 7.39-19.36 16.44-26.72 26.94L173.75 299c5.47 3.23 10.82 6.93 15.86 11.58zM624 352h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 343.58 442.04 352 416 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 343.58 250.04 352 224 352s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 343.58 58.04 352 32 352H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-512-96c44.18 0 80-35.82 80-80s-35.82-80-80-80-80 35.82-80 80 35.82 80 80 80z"
        ],
        "swimming-pool": [
            640,
            512,
            [],
            "f5c5",
            "M624 416h-16c-26.04 0-45.8-8.42-56.09-17.9-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C461.8 407.58 442.04 416 416 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C269.8 407.58 250.04 416 224 416s-45.8-8.42-56.09-17.9c-8.9-8.21-19.66-14.1-31.77-14.1h-16.3c-12.11 0-22.87 5.89-31.77 14.1C77.8 407.58 58.04 416 32 416H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16c38.62 0 72.72-12.19 96-31.84 23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84s72.72-12.19 96-31.84c23.28 19.66 57.38 31.84 96 31.84h16c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-400-32v-96h192v96c19.12 0 30.86-6.16 34.39-9.42 9.17-8.46 19.2-14.34 29.61-18.07V128c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v96H224v-96c0-17.64 14.36-32 32-32s32 14.36 32 32v16c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-16c0-52.94-43.06-96-96-96s-96 43.06-96 96v228.5c10.41 3.73 20.44 9.62 29.61 18.07 3.53 3.27 15.27 9.43 34.39 9.43z"
        ],
        "synagogue": [
            640,
            512,
            [],
            "f69b",
            "M70 196.51L6.67 268.29A26.643 26.643 0 0 0 0 285.93V512h128V239.58l-38-43.07c-5.31-6.01-14.69-6.01-20 0zm563.33 71.78L570 196.51c-5.31-6.02-14.69-6.02-20 0l-38 43.07V512h128V285.93c0-6.5-2.37-12.77-6.67-17.64zM339.99 7.01c-11.69-9.35-28.29-9.35-39.98 0l-128 102.4A32.005 32.005 0 0 0 160 134.4V512h96v-92.57c0-31.88 21.78-61.43 53.25-66.55C349.34 346.35 384 377.13 384 416v96h96V134.4c0-9.72-4.42-18.92-12.01-24.99l-128-102.4zm52.07 215.55c1.98 3.15-.29 7.24-4 7.24h-38.94L324 269.79c-1.85 2.95-6.15 2.95-8 0l-25.12-39.98h-38.94c-3.72 0-5.98-4.09-4-7.24l19.2-30.56-19.2-30.56c-1.98-3.15.29-7.24 4-7.24h38.94l25.12-40c1.85-2.95 6.15-2.95 8 0l25.12 39.98h38.95c3.71 0 5.98 4.09 4 7.24L372.87 192l19.19 30.56z"
        ],
        "sync": [
            512,
            512,
            [],
            "f021",
            "M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z"
        ],
        "sync-alt": [
            512,
            512,
            [],
            "f2f1",
            "M370.72 133.28C339.458 104.008 298.888 87.962 255.848 88c-77.458.068-144.328 53.178-162.791 126.85-1.344 5.363-6.122 9.15-11.651 9.15H24.103c-7.498 0-13.194-6.807-11.807-14.176C33.933 94.924 134.813 8 256 8c66.448 0 126.791 26.136 171.315 68.685L463.03 40.97C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.749zM32 296h134.059c21.382 0 32.09 25.851 16.971 40.971l-41.75 41.75c31.262 29.273 71.835 45.319 114.876 45.28 77.418-.07 144.315-53.144 162.787-126.849 1.344-5.363 6.122-9.15 11.651-9.15h57.304c7.498 0 13.194 6.807 11.807 14.176C478.067 417.076 377.187 504 256 504c-66.448 0-126.791-26.136-171.315-68.685L48.97 471.03C33.851 486.149 8 475.441 8 454.059V320c0-13.255 10.745-24 24-24z"
        ],
        "syringe": [
            512,
            512,
            [],
            "f48e",
            "M201.5 174.8l55.7 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-55.7-55.8-45.3 45.3 55.8 55.8c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L111 265.2l-26.4 26.4c-17.3 17.3-25.6 41.1-23 65.4l7.1 63.6L2.3 487c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l66.3-66.3 63.6 7.1c23.9 2.6 47.9-5.4 65.4-23l181.9-181.9-135.7-135.7-64.9 65zm308.2-93.3L430.5 2.3c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l28.3 28.3-45.3 45.3-56.6-56.6-17-17c-3.1-3.1-8.2-3.1-11.3 0l-33.9 33.9c-3.1 3.1-3.1 8.2 0 11.3l17 17L424.8 223l17 17c3.1 3.1 8.2 3.1 11.3 0l33.9-34c3.1-3.1 3.1-8.2 0-11.3l-73.5-73.5 45.3-45.3 28.3 28.3c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.2 3.1-8.2 0-11.4z"
        ],
        "table": [
            512,
            512,
            [],
            "f0ce",
            "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zM224 416H64v-96h160v96zm0-160H64v-96h160v96zm224 160H288v-96h160v96zm0-160H288v-96h160v96z"
        ],
        "table-tennis": [
            512,
            512,
            [],
            "f45d",
            "M496.2 296.5C527.7 218.7 512 126.2 449 63.1 365.1-21 229-21 145.1 63.1l-56 56.1 211.5 211.5c46.1-62.1 131.5-77.4 195.6-34.2zm-217.9 79.7L57.9 155.9c-27.3 45.3-21.7 105 17.3 144.1l34.5 34.6L6.7 424c-8.6 7.5-9.1 20.7-1 28.8l53.4 53.5c8 8.1 21.2 7.6 28.7-1L177.1 402l35.7 35.7c19.7 19.7 44.6 30.5 70.3 33.3-7.1-17-11-35.6-11-55.1-.1-13.8 2.5-27 6.2-39.7zM416 320c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96z"
        ],
        "tablet": [
            448,
            512,
            [],
            "f10a",
            "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z"
        ],
        "tablet-alt": [
            448,
            512,
            [],
            "f3fa",
            "M400 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zM224 480c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm176-108c0 6.6-5.4 12-12 12H60c-6.6 0-12-5.4-12-12V60c0-6.6 5.4-12 12-12h328c6.6 0 12 5.4 12 12v312z"
        ],
        "tablets": [
            640,
            512,
            [],
            "f490",
            "M160 192C78.9 192 12.5 250.5.1 326.7c-.8 4.8 3.3 9.3 8.3 9.3h303.3c5 0 9.1-4.5 8.3-9.3C307.5 250.5 241.1 192 160 192zm151.6 176H8.4c-5 0-9.1 4.5-8.3 9.3C12.5 453.5 78.9 512 160 512s147.5-58.5 159.9-134.7c.8-4.8-3.3-9.3-8.3-9.3zM593.4 46.6c-56.5-56.5-144.2-61.4-206.9-16-4 2.9-4.3 8.9-.8 12.3L597 254.3c3.5 3.5 9.5 3.2 12.3-.8 45.5-62.7 40.6-150.4-15.9-206.9zM363 65.7c-3.5-3.5-9.5-3.2-12.3.8-45.4 62.7-40.5 150.4 15.9 206.9 56.5 56.5 144.2 61.4 206.9 15.9 4-2.9 4.3-8.9.8-12.3L363 65.7z"
        ],
        "tachometer-alt": [
            576,
            512,
            [],
            "f3fd",
            "M288 32C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm0 64c14.71 0 26.58 10.13 30.32 23.65-1.11 2.26-2.64 4.23-3.45 6.67l-9.22 27.67c-5.13 3.49-10.97 6.01-17.64 6.01-17.67 0-32-14.33-32-32S270.33 96 288 96zM96 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm48-160c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm246.77-72.41l-61.33 184C343.13 347.33 352 364.54 352 384c0 11.72-3.38 22.55-8.88 32H232.88c-5.5-9.45-8.88-20.28-8.88-32 0-33.94 26.5-61.43 59.9-63.59l61.34-184.01c4.17-12.56 17.73-19.45 30.36-15.17 12.57 4.19 19.35 17.79 15.17 30.36zm14.66 57.2l15.52-46.55c3.47-1.29 7.13-2.23 11.05-2.23 17.67 0 32 14.33 32 32s-14.33 32-32 32c-11.38-.01-20.89-6.28-26.57-15.22zM480 384c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
        ],
        "tag": [
            512,
            512,
            [],
            "f02b",
            "M0 252.118V48C0 21.49 21.49 0 48 0h204.118a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882L293.823 497.941c-18.745 18.745-49.137 18.745-67.882 0L14.059 286.059A48 48 0 0 1 0 252.118zM112 64c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48z"
        ],
        "tags": [
            640,
            512,
            [],
            "f02c",
            "M497.941 225.941L286.059 14.059A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v204.118a48 48 0 0 0 14.059 33.941l211.882 211.882c18.744 18.745 49.136 18.746 67.882 0l204.118-204.118c18.745-18.745 18.745-49.137 0-67.882zM112 160c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm513.941 133.823L421.823 497.941c-18.745 18.745-49.137 18.745-67.882 0l-.36-.36L527.64 323.522c16.999-16.999 26.36-39.6 26.36-63.64s-9.362-46.641-26.36-63.64L331.397 0h48.721a48 48 0 0 1 33.941 14.059l211.882 211.882c18.745 18.745 18.745 49.137 0 67.882z"
        ],
        "tape": [
            640,
            512,
            [],
            "f4db",
            "M224 192c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm400 224H380.6c41.5-40.7 67.4-97.3 67.4-160 0-123.7-100.3-224-224-224S0 132.3 0 256s100.3 224 224 224h400c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400-64c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"
        ],
        "tasks": [
            512,
            512,
            [],
            "f0ae",
            "M139.61 35.5a12 12 0 0 0-17 0L58.93 98.81l-22.7-22.12a12 12 0 0 0-17 0L3.53 92.41a12 12 0 0 0 0 17l47.59 47.4a12.78 12.78 0 0 0 17.61 0l15.59-15.62L156.52 69a12.09 12.09 0 0 0 .09-17zm0 159.19a12 12 0 0 0-17 0l-63.68 63.72-22.7-22.1a12 12 0 0 0-17 0L3.53 252a12 12 0 0 0 0 17L51 316.5a12.77 12.77 0 0 0 17.6 0l15.7-15.69 72.2-72.22a12 12 0 0 0 .09-16.9zM64 368c-26.49 0-48.59 21.5-48.59 48S37.53 464 64 464a48 48 0 0 0 0-96zm432 16H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm0-320H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16V80a16 16 0 0 0-16-16zm0 160H208a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h288a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
        ],
        "taxi": [
            512,
            512,
            [],
            "f1ba",
            "M462 241.64l-22-84.84c-9.6-35.2-41.6-60.8-76.8-60.8H352V64c0-17.67-14.33-32-32-32H192c-17.67 0-32 14.33-32 32v32h-11.2c-35.2 0-67.2 25.6-76.8 60.8l-22 84.84C21.41 248.04 0 273.47 0 304v48c0 23.63 12.95 44.04 32 55.12V448c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-32h256v32c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32v-40.88c19.05-11.09 32-31.5 32-55.12v-48c0-30.53-21.41-55.96-50-62.36zM96 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm20.55-112l17.2-66.36c2.23-8.16 9.59-13.64 15.06-13.64h214.4c5.47 0 12.83 5.48 14.85 12.86L395.45 240h-278.9zM416 352c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
        ],
        "teeth": [
            640,
            512,
            [],
            "f62e",
            "M544 0H96C42.98 0 0 42.98 0 96v320c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96V96c0-53.02-42.98-96-96-96zM160 368c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm144 120c0 30.93-25.07 56-56 56s-56-25.07-56-56v-56c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v56zm0-120c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-88c0-30.93 25.07-56 56-56s56 25.07 56 56v88zm128 128c0 26.51-21.49 48-48 48s-48-21.49-48-48v-64c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v64zm0-128c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-64c0-26.51 21.49-48 48-48s48 21.49 48 48v64z"
        ],
        "teeth-open": [
            640,
            512,
            [],
            "f62f",
            "M544 0H96C42.98 0 0 42.98 0 96v64c0 35.35 28.66 64 64 64h512c35.34 0 64-28.65 64-64V96c0-53.02-42.98-96-96-96zM160 176c0 8.84-7.16 16-16 16H80c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm144 0c0 8.84-7.16 16-16 16h-80c-8.84 0-16-7.16-16-16v-56c0-30.93 25.07-56 56-56s56 25.07 56 56v56zm128 0c0 8.84-7.16 16-16 16h-64c-8.84 0-16-7.16-16-16v-32c0-26.51 21.49-48 48-48s48 21.49 48 48v32zm0 144H64c-35.34 0-64 28.65-64 64v32c0 53.02 42.98 96 96 96h448c53.02 0 96-42.98 96-96v-32c0-35.35-28.66-64-64-64zm-416 80c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32zm144-8c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm144 0c0 30.93-25.07 56-56 56s-56-25.07-56-56v-24c0-8.84 7.16-16 16-16h80c8.84 0 16 7.16 16 16v24zm128 8c0 26.51-21.49 48-48 48s-48-21.49-48-48v-32c0-8.84 7.16-16 16-16h64c8.84 0 16 7.16 16 16v32z"
        ],
        "temperature-high": [
            512,
            512,
            [],
            "f769",
            "M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V112c0-8.8-7.2-16-16-16s-16 7.2-16 16v210.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"
        ],
        "temperature-low": [
            512,
            512,
            [],
            "f76b",
            "M416 0c-52.9 0-96 43.1-96 96s43.1 96 96 96 96-43.1 96-96-43.1-96-96-96zm0 128c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm-160-16C256 50.1 205.9 0 144 0S32 50.1 32 112v166.5C12.3 303.2 0 334 0 368c0 79.5 64.5 144 144 144s144-64.5 144-144c0-34-12.3-64.9-32-89.5V112zM144 448c-44.1 0-80-35.9-80-80 0-25.5 12.2-48.9 32-63.8V112c0-26.5 21.5-48 48-48s48 21.5 48 48v192.2c19.8 14.8 32 38.3 32 63.8 0 44.1-35.9 80-80 80zm16-125.1V304c0-8.8-7.2-16-16-16s-16 7.2-16 16v18.9c-18.6 6.6-32 24.2-32 45.1 0 26.5 21.5 48 48 48s48-21.5 48-48c0-20.9-13.4-38.5-32-45.1z"
        ],
        "tenge": [
            384,
            512,
            [],
            "f7d7",
            "M372 160H12c-6.6 0-12 5.4-12 12v56c0 6.6 5.4 12 12 12h140v228c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12V240h140c6.6 0 12-5.4 12-12v-56c0-6.6-5.4-12-12-12zm0-128H12C5.4 32 0 37.4 0 44v56c0 6.6 5.4 12 12 12h360c6.6 0 12-5.4 12-12V44c0-6.6-5.4-12-12-12z"
        ],
        "terminal": [
            640,
            512,
            [],
            "f120",
            "M257.981 272.971L63.638 467.314c-9.373 9.373-24.569 9.373-33.941 0L7.029 444.647c-9.357-9.357-9.375-24.522-.04-33.901L161.011 256 6.99 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L257.981 239.03c9.373 9.372 9.373 24.568 0 33.941zM640 456v-32c0-13.255-10.745-24-24-24H312c-13.255 0-24 10.745-24 24v32c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24z"
        ],
        "text-height": [
            576,
            512,
            [],
            "f034",
            "M304 32H16A16 16 0 0 0 0 48v96a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32h56v304H80a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h160a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-40V112h56v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm256 336h-48V144h48c14.31 0 21.33-17.31 11.31-27.31l-80-80a16 16 0 0 0-22.62 0l-80 80C379.36 126 384.36 144 400 144h48v224h-48c-14.31 0-21.32 17.31-11.31 27.31l80 80a16 16 0 0 0 22.62 0l80-80C580.64 386 575.64 368 560 368z"
        ],
        "text-width": [
            448,
            512,
            [],
            "f035",
            "M432 32H16A16 16 0 0 0 0 48v80a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-16h120v112h-24a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16h-24V112h120v16a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm-68.69 260.69C354 283.36 336 288.36 336 304v48H112v-48c0-14.31-17.31-21.32-27.31-11.31l-80 80a16 16 0 0 0 0 22.62l80 80C94 484.64 112 479.64 112 464v-48h224v48c0 14.31 17.31 21.33 27.31 11.31l80-80a16 16 0 0 0 0-22.62z"
        ],
        "th": [
            512,
            512,
            [],
            "f00a",
            "M149.333 56v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zm181.334 240v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm32-240v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24zm-32 80V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.256 0 24.001-10.745 24.001-24zm-205.334 56H24c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm386.667-56H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm0 160H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H386.667c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zM181.333 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24z"
        ],
        "th-large": [
            512,
            512,
            [],
            "f009",
            "M296 32h192c13.255 0 24 10.745 24 24v160c0 13.255-10.745 24-24 24H296c-13.255 0-24-10.745-24-24V56c0-13.255 10.745-24 24-24zm-80 0H24C10.745 32 0 42.745 0 56v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zM0 296v160c0 13.255 10.745 24 24 24h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zm296 184h192c13.255 0 24-10.745 24-24V296c0-13.255-10.745-24-24-24H296c-13.255 0-24 10.745-24 24v160c0 13.255 10.745 24 24 24z"
        ],
        "th-list": [
            512,
            512,
            [],
            "f00b",
            "M149.333 216v80c0 13.255-10.745 24-24 24H24c-13.255 0-24-10.745-24-24v-80c0-13.255 10.745-24 24-24h101.333c13.255 0 24 10.745 24 24zM0 376v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H24c-13.255 0-24 10.745-24 24zM125.333 32H24C10.745 32 0 42.745 0 56v80c0 13.255 10.745 24 24 24h101.333c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24zm80 448H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24zm-24-424v80c0 13.255 10.745 24 24 24H488c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24zm24 264H488c13.255 0 24-10.745 24-24v-80c0-13.255-10.745-24-24-24H205.333c-13.255 0-24 10.745-24 24v80c0 13.255 10.745 24 24 24z"
        ],
        "theater-masks": [
            640,
            512,
            [],
            "f630",
            "M206.86 245.15c-35.88 10.45-59.95 41.2-57.53 74.1 11.4-12.72 28.81-23.7 49.9-30.92l7.63-43.18zM95.81 295L64.08 115.49c-.29-1.62.28-2.62.24-2.65 57.76-32.06 123.12-49.01 189.01-49.01 1.61 0 3.23.17 4.85.19 13.95-13.47 31.73-22.83 51.59-26 18.89-3.02 38.05-4.55 57.18-5.32-9.99-13.95-24.48-24.23-41.77-27C301.27 1.89 277.24 0 253.32 0 176.66 0 101.02 19.42 33.2 57.06 9.03 70.48-3.92 98.48 1.05 126.58l31.73 179.51c14.23 80.52 136.33 142.08 204.45 142.08 3.59 0 6.75-.46 10.01-.8-13.52-17.08-28.94-40.48-39.5-67.58-47.61-12.98-106.06-51.62-111.93-84.79zm97.55-137.46c-.73-4.12-2.23-7.87-4.07-11.4-8.25 8.91-20.67 15.75-35.32 18.32-14.65 2.58-28.67.4-39.48-5.17-.52 3.94-.64 7.98.09 12.1 3.84 21.7 24.58 36.19 46.34 32.37 21.75-3.82 36.28-24.52 32.44-46.22zM606.8 120.9c-88.98-49.38-191.43-67.41-291.98-51.35-27.31 4.36-49.08 26.26-54.04 54.36l-31.73 179.51c-15.39 87.05 95.28 196.27 158.31 207.35 63.03 11.09 204.47-53.79 219.86-140.84l31.73-179.51c4.97-28.11-7.98-56.11-32.15-69.52zm-273.24 96.8c3.84-21.7 24.58-36.19 46.34-32.36 21.76 3.83 36.28 24.52 32.45 46.22-.73 4.12-2.23 7.87-4.07 11.4-8.25-8.91-20.67-15.75-35.32-18.32-14.65-2.58-28.67-.4-39.48 5.17-.53-3.95-.65-7.99.08-12.11zm70.47 198.76c-55.68-9.79-93.52-59.27-89.04-112.9 20.6 25.54 56.21 46.17 99.49 53.78 43.28 7.61 83.82.37 111.93-16.6-14.18 51.94-66.71 85.51-122.38 75.72zm130.3-151.34c-8.25-8.91-20.68-15.75-35.33-18.32-14.65-2.58-28.67-.4-39.48 5.17-.52-3.94-.64-7.98.09-12.1 3.84-21.7 24.58-36.19 46.34-32.37 21.75 3.83 36.28 24.52 32.45 46.22-.73 4.13-2.23 7.88-4.07 11.4z"
        ],
        "thermometer": [
            512,
            512,
            [],
            "f491",
            "M476.8 20.4c-37.5-30.7-95.5-26.3-131.9 10.2l-45.7 46 50.5 50.5c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.4-50.5-45.1 45.4 50.3 50.4c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0L209 167.4l-45.1 45.4L214 263c3.1 3.1 3.1 8.2 0 11.3l-11.3 11.3c-3.1 3.1-8.2 3.1-11.3 0l-50.1-50.2L96 281.1V382L7 471c-9.4 9.4-9.4 24.6 0 33.9 9.4 9.4 24.6 9.4 33.9 0l89-89h99.9L484 162.6c34.9-34.9 42.2-101.5-7.2-142.2z"
        ],
        "thermometer-empty": [
            256,
            512,
            [],
            "f2cb",
            "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
        ],
        "thermometer-full": [
            256,
            512,
            [],
            "f2c7",
            "M224 96c0-53.019-42.981-96-96-96S32 42.981 32 96v203.347C12.225 321.756.166 351.136.002 383.333c-.359 70.303 56.787 128.176 127.089 128.664.299.002.61.003.909.003 70.698 0 128-57.304 128-128 0-32.459-12.088-62.09-32-84.653V96zm-96 368l-.576-.002c-43.86-.304-79.647-36.544-79.423-80.42.173-33.98 19.266-51.652 31.999-66.08V96c0-26.467 21.533-48 48-48s48 21.533 48 48v221.498c12.63 14.312 32 32.164 32 66.502 0 44.112-35.888 80-80 80zm64-80c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V96c0-17.673 14.327-32 32-32s32 14.327 32 32v232.583c19.124 11.068 32 31.732 32 55.417z"
        ],
        "thermometer-half": [
            256,
            512,
            [],
            "f2c9",
            "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V224c0-17.673 14.327-32 32-32s32 14.327 32 32v104.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
        ],
        "thermometer-quarter": [
            256,
            512,
            [],
            "f2ca",
            "M192 384c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-23.685 12.876-44.349 32-55.417V288c0-17.673 14.327-32 32-32s32 14.327 32 32v40.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
        ],
        "thermometer-three-quarters": [
            256,
            512,
            [],
            "f2c8",
            "M192 384c0 35.346-28.654 64-64 64-35.346 0-64-28.654-64-64 0-23.685 12.876-44.349 32-55.417V160c0-17.673 14.327-32 32-32s32 14.327 32 32v168.583c19.124 11.068 32 31.732 32 55.417zm32-84.653c19.912 22.563 32 52.194 32 84.653 0 70.696-57.303 128-128 128-.299 0-.609-.001-.909-.003C56.789 511.509-.357 453.636.002 383.333.166 351.135 12.225 321.755 32 299.347V96c0-53.019 42.981-96 96-96s96 42.981 96 96v203.347zM208 384c0-34.339-19.37-52.19-32-66.502V96c0-26.467-21.533-48-48-48S80 69.533 80 96v221.498c-12.732 14.428-31.825 32.1-31.999 66.08-.224 43.876 35.563 80.116 79.423 80.42L128 464c44.112 0 80-35.888 80-80z"
        ],
        "thumbs-down": [
            512,
            512,
            [],
            "f165",
            "M0 56v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V56c0-13.255-10.745-24-24-24H24C10.745 32 0 42.745 0 56zm40 200c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24zm272 256c-20.183 0-29.485-39.293-33.931-57.795-5.206-21.666-10.589-44.07-25.393-58.902-32.469-32.524-49.503-73.967-89.117-113.111a11.98 11.98 0 0 1-3.558-8.521V59.901c0-6.541 5.243-11.878 11.783-11.998 15.831-.29 36.694-9.079 52.651-16.178C256.189 17.598 295.709.017 343.995 0h2.844c42.777 0 93.363.413 113.774 29.737 8.392 12.057 10.446 27.034 6.148 44.632 16.312 17.053 25.063 48.863 16.382 74.757 17.544 23.432 19.143 56.132 9.308 79.469l.11.11c11.893 11.949 19.523 31.259 19.439 49.197-.156 30.352-26.157 58.098-59.553 58.098H350.723C358.03 364.34 384 388.132 384 430.548 384 504 336 512 312 512z"
        ],
        "thumbs-up": [
            512,
            512,
            [],
            "f164",
            "M104 224H24c-13.255 0-24 10.745-24 24v240c0 13.255 10.745 24 24 24h80c13.255 0 24-10.745 24-24V248c0-13.255-10.745-24-24-24zM64 472c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zM384 81.452c0 42.416-25.97 66.208-33.277 94.548h101.723c33.397 0 59.397 27.746 59.553 58.098.084 17.938-7.546 37.249-19.439 49.197l-.11.11c9.836 23.337 8.237 56.037-9.308 79.469 8.681 25.895-.069 57.704-16.382 74.757 4.298 17.598 2.244 32.575-6.148 44.632C440.202 511.587 389.616 512 346.839 512l-2.845-.001c-48.287-.017-87.806-17.598-119.56-31.725-15.957-7.099-36.821-15.887-52.651-16.178-6.54-.12-11.783-5.457-11.783-11.998v-213.77c0-3.2 1.282-6.271 3.558-8.521 39.614-39.144 56.648-80.587 89.117-113.111 14.804-14.832 20.188-37.236 25.393-58.902C282.515 39.293 291.817 0 312 0c24 0 72 8 72 81.452z"
        ],
        "thumbtack": [
            384,
            512,
            [],
            "f08d",
            "M298.028 214.267L285.793 96H328c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H56C42.745 0 32 10.745 32 24v48c0 13.255 10.745 24 24 24h42.207L85.972 214.267C37.465 236.82 0 277.261 0 328c0 13.255 10.745 24 24 24h136v104.007c0 1.242.289 2.467.845 3.578l24 48c2.941 5.882 11.364 5.893 14.311 0l24-48a8.008 8.008 0 0 0 .845-3.578V352h136c13.255 0 24-10.745 24-24-.001-51.183-37.983-91.42-85.973-113.733z"
        ],
        "ticket-alt": [
            576,
            512,
            [],
            "f3ff",
            "M128 160h320v192H128V160zm400 96c0 26.51 21.49 48 48 48v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c26.51 0 48-21.49 48-48s-21.49-48-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v96c-26.51 0-48 21.49-48 48zm-48-104c0-13.255-10.745-24-24-24H120c-13.255 0-24 10.745-24 24v208c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V152z"
        ],
        "times": [
            352,
            512,
            [],
            "f00d",
            "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
        ],
        "times-circle": [
            512,
            512,
            [],
            "f057",
            "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"
        ],
        "tint": [
            352,
            512,
            [],
            "f043",
            "M205.22 22.09c-7.94-28.78-49.44-30.12-58.44 0C100.01 179.85 0 222.72 0 333.91 0 432.35 78.72 512 176 512s176-79.65 176-178.09c0-111.75-99.79-153.34-146.78-311.82zM176 448c-61.75 0-112-50.25-112-112 0-8.84 7.16-16 16-16s16 7.16 16 16c0 44.11 35.89 80 80 80 8.84 0 16 7.16 16 16s-7.16 16-16 16z"
        ],
        "tint-slash": [
            640,
            512,
            [],
            "f5c7",
            "M633.82 458.1L494.97 350.78c.52-5.57 1.03-11.16 1.03-16.87 0-111.76-99.79-153.34-146.78-311.82-7.94-28.78-49.44-30.12-58.44 0-15.52 52.34-36.87 91.96-58.49 125.68L45.47 3.37C38.49-2.05 28.43-.8 23.01 6.18L3.37 31.45C-2.05 38.42-.8 48.47 6.18 53.9l588.36 454.73c6.98 5.43 17.03 4.17 22.46-2.81l19.64-25.27c5.41-6.97 4.16-17.02-2.82-22.45zM144 333.91C144 432.35 222.72 512 320 512c44.71 0 85.37-16.96 116.4-44.7L162.72 255.78c-11.41 23.5-18.72 48.35-18.72 78.13z"
        ],
        "tired": [
            496,
            512,
            [],
            "f5c8",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm33.8 189.7l80-48c11.6-6.9 24 7.7 15.4 18L343.6 208l33.6 40.3c8.7 10.4-3.9 24.8-15.4 18l-80-48c-7.7-4.7-7.7-15.9 0-20.6zm-163-30c-8.6-10.3 3.8-24.9 15.4-18l80 48c7.8 4.7 7.8 15.9 0 20.6l-80 48c-11.5 6.8-24-7.6-15.4-18l33.6-40.3-33.6-40.3zM248 288c51.9 0 115.3 43.8 123.2 106.7 1.7 13.6-8 24.6-17.7 20.4-25.9-11.1-64.4-17.4-105.5-17.4s-79.6 6.3-105.5 17.4c-9.8 4.2-19.4-7-17.7-20.4C132.7 331.8 196.1 288 248 288z"
        ],
        "toggle-off": [
            576,
            512,
            [],
            "f204",
            "M384 64H192C85.961 64 0 149.961 0 256s85.961 192 192 192h192c106.039 0 192-85.961 192-192S490.039 64 384 64zM64 256c0-70.741 57.249-128 128-128 70.741 0 128 57.249 128 128 0 70.741-57.249 128-128 128-70.741 0-128-57.249-128-128zm320 128h-48.905c65.217-72.858 65.236-183.12 0-256H384c70.741 0 128 57.249 128 128 0 70.74-57.249 128-128 128z"
        ],
        "toggle-on": [
            576,
            512,
            [],
            "f205",
            "M384 64H192C86 64 0 150 0 256s86 192 192 192h192c106 0 192-86 192-192S490 64 384 64zm0 320c-70.8 0-128-57.3-128-128 0-70.8 57.3-128 128-128 70.8 0 128 57.3 128 128 0 70.8-57.3 128-128 128z"
        ],
        "toilet": [
            384,
            512,
            [],
            "f7d8",
            "M368 48c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16H16C7.2 0 0 7.2 0 16v16c0 8.8 7.2 16 16 16h16v156.7C11.8 214.8 0 226.9 0 240c0 67.2 34.6 126.2 86.8 160.5l-21.4 70.2C59.1 491.2 74.5 512 96 512h192c21.5 0 36.9-20.8 30.6-41.3l-21.4-70.2C349.4 366.2 384 307.2 384 240c0-13.1-11.8-25.2-32-35.3V48h16zM80 72c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H88c-4.4 0-8-3.6-8-8V72zm112 200c-77.1 0-139.6-14.3-139.6-32s62.5-32 139.6-32 139.6 14.3 139.6 32-62.5 32-139.6 32z"
        ],
        "toilet-paper": [
            576,
            512,
            [],
            "f71e",
            "M128 0C74.98 0 32 85.96 32 192v172.07c0 41.12-9.8 62.77-31.17 126.87C-2.62 501.3 5.09 512 16.01 512h280.92c13.77 0 26-8.81 30.36-21.88 12.83-38.48 24.71-72.4 24.71-126.05V192c0-83.6 23.67-153.52 60.44-192H128zM96 224c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zm64 0c-8.84 0-16-7.16-16-16s7.16-16 16-16 16 7.16 16 16-7.16 16-16 16zM480 0c-53.02 0-96 85.96-96 192s42.98 192 96 192 96-85.96 96-192S533.02 0 480 0zm0 256c-17.67 0-32-28.65-32-64s14.33-64 32-64 32 28.65 32 64-14.33 64-32 64z"
        ],
        "toilet-paper-slash": [
            640,
            512,
            [],
            "e072",
            "M64,192V364.13c0,41.12-9.75,62.75-31.12,126.87A16,16,0,0,0,48,512H328.86a31.87,31.87,0,0,0,30.38-21.87c9.31-27.83,18-53.35,22.18-85.55l-316-244.25C64.53,170.66,64,181.19,64,192ZM633.82,458.09l-102-78.81C575.28,360.91,608,284.32,608,192,608,86,565,0,512,0s-96,86-96,192c0,42,7,80.4,18.43,112L384,265V192c0-83.62,23.63-153.5,60.5-192H160c-23.33,0-44.63,16.83-61.26,44.53L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.45A16,16,0,0,0,6.18,53.91L594.54,508.63A16,16,0,0,0,617,505.81l19.64-25.26A16,16,0,0,0,633.82,458.09ZM512,256c-17.63,0-32-28.62-32-64s14.37-64,32-64,32,28.63,32,64S529.62,256,512,256Z"
        ],
        "toolbox": [
            512,
            512,
            [],
            "f552",
            "M502.63 214.63l-45.25-45.25c-6-6-14.14-9.37-22.63-9.37H384V80c0-26.51-21.49-48-48-48H176c-26.51 0-48 21.49-48 48v80H77.25c-8.49 0-16.62 3.37-22.63 9.37L9.37 214.63c-6 6-9.37 14.14-9.37 22.63V320h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-16c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v16h128v-82.75c0-8.48-3.37-16.62-9.37-22.62zM320 160H192V96h128v64zm64 208c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H192v16c0 8.84-7.16 16-16 16h-32c-8.84 0-16-7.16-16-16v-16H0v96c0 17.67 14.33 32 32 32h448c17.67 0 32-14.33 32-32v-96H384v16z"
        ],
        "tools": [
            512,
            512,
            [],
            "f7d9",
            "M501.1 395.7L384 278.6c-23.1-23.1-57.6-27.6-85.4-13.9L192 158.1V96L64 0 0 64l96 128h62.1l106.6 106.6c-13.6 27.8-9.2 62.3 13.9 85.4l117.1 117.1c14.6 14.6 38.2 14.6 52.7 0l52.7-52.7c14.5-14.6 14.5-38.2 0-52.7zM331.7 225c28.3 0 54.9 11 74.9 31l19.4 19.4c15.8-6.9 30.8-16.5 43.8-29.5 37.1-37.1 49.7-89.3 37.9-136.7-2.2-9-13.5-12.1-20.1-5.5l-74.4 74.4-67.9-11.3L334 98.9l74.4-74.4c6.6-6.6 3.4-17.9-5.7-20.2-47.4-11.7-99.6.9-136.6 37.9-28.5 28.5-41.9 66.1-41.2 103.6l82.1 82.1c8.1-1.9 16.5-2.9 24.7-2.9zm-103.9 82l-56.7-56.7L18.7 402.8c-25 25-25 65.5 0 90.5s65.5 25 90.5 0l123.6-123.6c-7.6-19.9-9.9-41.6-5-62.7zM64 472c-13.2 0-24-10.8-24-24 0-13.3 10.7-24 24-24s24 10.7 24 24c0 13.2-10.7 24-24 24z"
        ],
        "tooth": [
            448,
            512,
            [],
            "f5c9",
            "M443.98 96.25c-11.01-45.22-47.11-82.06-92.01-93.72-32.19-8.36-63 5.1-89.14 24.33-3.25 2.39-6.96 3.73-10.5 5.48l28.32 18.21c7.42 4.77 9.58 14.67 4.8 22.11-4.46 6.95-14.27 9.86-22.11 4.8L162.83 12.84c-20.7-10.85-43.38-16.4-66.81-10.31-44.9 11.67-81 48.5-92.01 93.72-10.13 41.62-.42 80.81 21.5 110.43 23.36 31.57 32.68 68.66 36.29 107.35 4.4 47.16 10.33 94.16 20.94 140.32l7.8 33.95c3.19 13.87 15.49 23.7 29.67 23.7 13.97 0 26.15-9.55 29.54-23.16l34.47-138.42c4.56-18.32 20.96-31.16 39.76-31.16s35.2 12.85 39.76 31.16l34.47 138.42c3.39 13.61 15.57 23.16 29.54 23.16 14.18 0 26.48-9.83 29.67-23.7l7.8-33.95c10.61-46.15 16.53-93.16 20.94-140.32 3.61-38.7 12.93-75.78 36.29-107.35 21.95-29.61 31.66-68.8 21.53-110.43z"
        ],
        "torah": [
            640,
            512,
            [],
            "f6a0",
            "M320.05 366.48l17.72-29.64h-35.46zm99.21-166H382.4l18.46 30.82zM48 0C21.49 0 0 14.33 0 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32C96 14.33 74.51 0 48 0zm172.74 311.5h36.85l-18.46-30.82zm161.71 0h36.86l-18.45-30.8zM128 464h384V48H128zm66.77-278.13a21.22 21.22 0 0 1 18.48-10.71h59.45l29.13-48.71a21.13 21.13 0 0 1 18.22-10.37A20.76 20.76 0 0 1 338 126.29l29.25 48.86h59.52a21.12 21.12 0 0 1 18.1 32L415.63 256 445 305a20.69 20.69 0 0 1 .24 21.12 21.25 21.25 0 0 1-18.48 10.72h-59.47l-29.13 48.7a21.13 21.13 0 0 1-18.16 10.4 20.79 20.79 0 0 1-18-10.22l-29.25-48.88h-59.5a21.11 21.11 0 0 1-18.1-32L224.36 256 195 207a20.7 20.7 0 0 1-.23-21.13zM592 0c-26.51 0-48 14.33-48 32v448c0 17.67 21.49 32 48 32s48-14.33 48-32V32c0-17.67-21.49-32-48-32zM320 145.53l-17.78 29.62h35.46zm-62.45 55h-36.81l18.44 30.8zm29.58 111h65.79L386.09 256l-33.23-55.52h-65.79L253.9 256z"
        ],
        "torii-gate": [
            512,
            512,
            [],
            "f6a1",
            "M376.45 32h-240.9A303.17 303.17 0 0 1 0 0v96c0 17.67 14.33 32 32 32h32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h48v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h256v240c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16V256h48c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16h-48v-64h32c17.67 0 32-14.33 32-32V0a303.17 303.17 0 0 1-135.55 32zM128 128h96v64h-96v-64zm256 64h-96v-64h96v64z"
        ],
        "tractor": [
            640,
            512,
            [],
            "f722",
            "M528 336c-48.6 0-88 39.4-88 88s39.4 88 88 88 88-39.4 88-88-39.4-88-88-88zm0 112c-13.23 0-24-10.77-24-24s10.77-24 24-24 24 10.77 24 24-10.77 24-24 24zm80-288h-64v-40.2c0-14.12 4.7-27.76 13.15-38.84 4.42-5.8 3.55-14.06-1.32-19.49L534.2 37.3c-6.66-7.45-18.32-6.92-24.7.78C490.58 60.9 480 89.81 480 119.8V160H377.67L321.58 29.14A47.914 47.914 0 0 0 277.45 0H144c-26.47 0-48 21.53-48 48v146.52c-8.63-6.73-20.96-6.46-28.89 1.47L36 227.1c-8.59 8.59-8.59 22.52 0 31.11l5.06 5.06c-4.99 9.26-8.96 18.82-11.91 28.72H22c-12.15 0-22 9.85-22 22v44c0 12.15 9.85 22 22 22h7.14c2.96 9.91 6.92 19.46 11.91 28.73l-5.06 5.06c-8.59 8.59-8.59 22.52 0 31.11L67.1 476c8.59 8.59 22.52 8.59 31.11 0l5.06-5.06c9.26 4.99 18.82 8.96 28.72 11.91V490c0 12.15 9.85 22 22 22h44c12.15 0 22-9.85 22-22v-7.14c9.9-2.95 19.46-6.92 28.72-11.91l5.06 5.06c8.59 8.59 22.52 8.59 31.11 0l31.11-31.11c8.59-8.59 8.59-22.52 0-31.11l-5.06-5.06c4.99-9.26 8.96-18.82 11.91-28.72H330c12.15 0 22-9.85 22-22v-6h80.54c21.91-28.99 56.32-48 95.46-48 18.64 0 36.07 4.61 51.8 12.2l50.82-50.82c6-6 9.37-14.14 9.37-22.63V192c.01-17.67-14.32-32-31.99-32zM176 416c-44.18 0-80-35.82-80-80s35.82-80 80-80 80 35.82 80 80-35.82 80-80 80zm22-256h-38V64h106.89l41.15 96H198z"
        ],
        "trademark": [
            640,
            512,
            [],
            "f25c",
            "M260.6 96H12c-6.6 0-12 5.4-12 12v43.1c0 6.6 5.4 12 12 12h85.1V404c0 6.6 5.4 12 12 12h54.3c6.6 0 12-5.4 12-12V163.1h85.1c6.6 0 12-5.4 12-12V108c.1-6.6-5.3-12-11.9-12zM640 403l-24-296c-.5-6.2-5.7-11-12-11h-65.4c-5.1 0-9.7 3.3-11.3 8.1l-43.8 127.1c-7.2 20.6-16.1 52.8-16.1 52.8h-.9s-8.9-32.2-16.1-52.8l-43.8-127.1c-1.7-4.8-6.2-8.1-11.3-8.1h-65.4c-6.2 0-11.4 4.8-12 11l-24.4 296c-.6 7 4.9 13 12 13H360c6.3 0 11.5-4.9 12-11.2l9.1-132.9c1.8-24.2 0-53.7 0-53.7h.9s10.7 33.6 17.9 53.7l30.7 84.7c1.7 4.7 6.2 7.9 11.3 7.9h50.3c5.1 0 9.6-3.2 11.3-7.9l30.7-84.7c7.2-20.1 17.9-53.7 17.9-53.7h.9s-1.8 29.5 0 53.7l9.1 132.9c.4 6.3 5.7 11.2 12 11.2H628c7 0 12.5-6 12-13z"
        ],
        "traffic-light": [
            384,
            512,
            [],
            "f637",
            "M384 192h-64v-37.88c37.2-13.22 64-48.38 64-90.12h-64V32c0-17.67-14.33-32-32-32H96C78.33 0 64 14.33 64 32v32H0c0 41.74 26.8 76.9 64 90.12V192H0c0 41.74 26.8 76.9 64 90.12V320H0c0 42.84 28.25 78.69 66.99 91.05C79.42 468.72 130.6 512 192 512s112.58-43.28 125.01-100.95C355.75 398.69 384 362.84 384 320h-64v-37.88c37.2-13.22 64-48.38 64-90.12zM192 416c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm0-128c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"
        ],
        "trailer": [
            640,
            512,
            [],
            "e041",
            "M624,320H544V80a16,16,0,0,0-16-16H16A16,16,0,0,0,0,80V368a16,16,0,0,0,16,16H65.61c7.83-54.21,54-96,110.39-96s102.56,41.79,110.39,96H624a16,16,0,0,0,16-16V336A16,16,0,0,0,624,320ZM96,243.68a176.29,176.29,0,0,0-32,20.71V136a8,8,0,0,1,8-8H88a8,8,0,0,1,8,8Zm96-18.54c-5.31-.49-10.57-1.14-16-1.14s-10.69.65-16,1.14V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,39.25a176.29,176.29,0,0,0-32-20.71V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8ZM384,320H352V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm96,0H448V136a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8Zm-304,0a80,80,0,1,0,80,80A80,80,0,0,0,176,320Zm0,112a32,32,0,1,1,32-32A32,32,0,0,1,176,432Z"
        ],
        "train": [
            448,
            512,
            [],
            "f238",
            "M448 96v256c0 51.815-61.624 96-130.022 96l62.98 49.721C386.905 502.417 383.562 512 376 512H72c-7.578 0-10.892-9.594-4.957-14.279L130.022 448C61.82 448 0 403.954 0 352V96C0 42.981 64 0 128 0h192c65 0 128 42.981 128 96zm-48 136V120c0-13.255-10.745-24-24-24H72c-13.255 0-24 10.745-24 24v112c0 13.255 10.745 24 24 24h304c13.255 0 24-10.745 24-24zm-176 64c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56z"
        ],
        "tram": [
            512,
            512,
            [],
            "f7da",
            "M288 64c17.7 0 32-14.3 32-32S305.7 0 288 0s-32 14.3-32 32 14.3 32 32 32zm223.5-12.1c-2.3-8.6-11-13.6-19.6-11.3l-480 128c-8.5 2.3-13.6 11-11.3 19.6C2.5 195.3 8.9 200 16 200c1.4 0 2.8-.2 4.1-.5L240 140.8V224H64c-17.7 0-32 14.3-32 32v224c0 17.7 14.3 32 32 32h384c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32H272v-91.7l228.1-60.8c8.6-2.3 13.6-11.1 11.4-19.6zM176 384H80v-96h96v96zm160-96h96v96h-96v-96zm-32 0v96h-96v-96h96zM192 96c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
        ],
        "transgender": [
            384,
            512,
            [],
            "f224",
            "M372 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C198.5 104.1 172.2 96 144 96 64.5 96 0 160.5 0 240c0 68.5 47.9 125.9 112 140.4V408H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM144 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
        ],
        "transgender-alt": [
            480,
            512,
            [],
            "f225",
            "M468 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-80.7 80.7C294.5 104.1 268.2 96 240 96c-28.2 0-54.5 8.1-76.7 22.1l-16.5-16.5 19.8-19.8c4.7-4.7 4.7-12.3 0-17l-28.3-28.3c-4.7-4.7-12.3-4.7-17 0l-19.8 19.8-19-19 16.9-16.9C107.1 12.9 101.7 0 91 0H12C5.4 0 0 5.4 0 12v79c0 10.7 12.9 16 20.5 8.5l16.9-16.9 19 19-19.8 19.8c-4.7 4.7-4.7 12.3 0 17l28.3 28.3c4.7 4.7 12.3 4.7 17 0l19.8-19.8 16.5 16.5C104.1 185.5 96 211.8 96 240c0 68.5 47.9 125.9 112 140.4V408h-36c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v28c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-28h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-27.6c64.1-14.6 112-71.9 112-140.4 0-28.2-8.1-54.5-22.1-76.7l80.7-80.7 16.9 16.9c7.6 7.6 20.5 2.2 20.5-8.5V12c0-6.6-5.4-12-12-12zM240 320c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
        ],
        "trash": [
            448,
            512,
            [],
            "f1f8",
            "M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"
        ],
        "trash-alt": [
            448,
            512,
            [],
            "f2ed",
            "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm272-256a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zm-96 0a16 16 0 0 1 32 0v224a16 16 0 0 1-32 0zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
        ],
        "trash-restore": [
            448,
            512,
            [],
            "f829",
            "M53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32zm70.11-175.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
        ],
        "trash-restore-alt": [
            448,
            512,
            [],
            "f82a",
            "M32 464a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128H32zm91.31-172.8l89.38-94.26a15.41 15.41 0 0 1 22.62 0l89.38 94.26c10.08 10.62 2.94 28.8-11.32 28.8H256v112a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16V320h-57.37c-14.26 0-21.4-18.18-11.32-28.8zM432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16z"
        ],
        "tree": [
            384,
            512,
            [],
            "f1bb",
            "M378.31 378.49L298.42 288h30.63c9.01 0 16.98-5 20.78-13.06 3.8-8.04 2.55-17.26-3.28-24.05L268.42 160h28.89c9.1 0 17.3-5.35 20.86-13.61 3.52-8.13 1.86-17.59-4.24-24.08L203.66 4.83c-6.03-6.45-17.28-6.45-23.32 0L70.06 122.31c-6.1 6.49-7.75 15.95-4.24 24.08C69.38 154.65 77.59 160 86.69 160h28.89l-78.14 90.91c-5.81 6.78-7.06 15.99-3.27 24.04C37.97 283 45.93 288 54.95 288h30.63L5.69 378.49c-6 6.79-7.36 16.09-3.56 24.26 3.75 8.05 12 13.25 21.01 13.25H160v24.45l-30.29 48.4c-5.32 10.64 2.42 23.16 14.31 23.16h95.96c11.89 0 19.63-12.52 14.31-23.16L224 440.45V416h136.86c9.01 0 17.26-5.2 21.01-13.25 3.8-8.17 2.44-17.47-3.56-24.26z"
        ],
        "trophy": [
            576,
            512,
            [],
            "f091",
            "M552 64H448V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v40H24C10.7 64 0 74.7 0 88v56c0 35.7 22.5 72.4 61.9 100.7 31.5 22.7 69.8 37.1 110 41.7C203.3 338.5 240 360 240 360v72h-48c-35.3 0-64 20.7-64 56v12c0 6.6 5.4 12 12 12h296c6.6 0 12-5.4 12-12v-12c0-35.3-28.7-56-64-56h-48v-72s36.7-21.5 68.1-73.6c40.3-4.6 78.6-19 110-41.7 39.3-28.3 61.9-65 61.9-100.7V88c0-13.3-10.7-24-24-24zM99.3 192.8C74.9 175.2 64 155.6 64 144v-16h64.2c1 32.6 5.8 61.2 12.8 86.2-15.1-5.2-29.2-12.4-41.7-21.4zM512 144c0 16.1-17.7 36.1-35.3 48.8-12.5 9-26.7 16.2-41.8 21.4 7-25 11.8-53.6 12.8-86.2H512v16z"
        ],
        "truck": [
            640,
            512,
            [],
            "f0d1",
            "M624 352h-16V243.9c0-12.7-5.1-24.9-14.1-33.9L494 110.1c-9-9-21.2-14.1-33.9-14.1H416V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v320c0 26.5 21.5 48 48 48h16c0 53 43 96 96 96s96-43 96-96h128c0 53 43 96 96 96s96-43 96-96h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM160 464c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm320 0c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm80-208H416V144h44.1l99.9 99.9V256z"
        ],
        "truck-loading": [
            640,
            512,
            [],
            "f4de",
            "M50.2 375.6c2.3 8.5 11.1 13.6 19.6 11.3l216.4-58c8.5-2.3 13.6-11.1 11.3-19.6l-49.7-185.5c-2.3-8.5-11.1-13.6-19.6-11.3L151 133.3l24.8 92.7-61.8 16.5-24.8-92.7-77.3 20.7C3.4 172.8-1.7 181.6.6 190.1l49.6 185.5zM384 0c-17.7 0-32 14.3-32 32v323.6L5.9 450c-4.3 1.2-6.8 5.6-5.6 9.8l12.6 46.3c1.2 4.3 5.6 6.8 9.8 5.6l393.7-107.4C418.8 464.1 467.6 512 528 512c61.9 0 112-50.1 112-112V0H384zm144 448c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48z"
        ],
        "truck-monster": [
            640,
            512,
            [],
            "f63b",
            "M624 224h-16v-64c0-17.67-14.33-32-32-32h-73.6L419.22 24.02A64.025 64.025 0 0 0 369.24 0H256c-17.67 0-32 14.33-32 32v96H48c-8.84 0-16 7.16-16 16v80H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16.72c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64h65.45c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-336-96V64h81.24l51.2 64H288zm304 224h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 512 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67A110.85 110.85 0 0 0 373.2 352H368c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32c-.02-8.84-7.18-16-16.02-16zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-208-80h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 192 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0L58.18 304.8c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67a110.85 110.85 0 0 0-8.65 20.89H48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32C288 359.16 280.84 352 272 352zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z"
        ],
        "truck-moving": [
            640,
            512,
            [],
            "f4df",
            "M621.3 237.3l-58.5-58.5c-12-12-28.3-18.7-45.3-18.7H480V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v336c0 44.2 35.8 80 80 80 26.3 0 49.4-12.9 64-32.4 14.6 19.6 37.7 32.4 64 32.4 44.2 0 80-35.8 80-80 0-5.5-.6-10.8-1.6-16h163.2c-1.1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H624c8.8 0 16-7.2 16-16v-85.5c0-17-6.7-33.2-18.7-45.2zM80 432c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm128 0c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm272-224h37.5c4.3 0 8.3 1.7 11.3 4.7l43.3 43.3H480v-48zm48 224c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32z"
        ],
        "truck-pickup": [
            640,
            512,
            [],
            "f63c",
            "M624 288h-16v-64c0-17.67-14.33-32-32-32h-48L419.22 56.02A64.025 64.025 0 0 0 369.24 32H256c-17.67 0-32 14.33-32 32v128H64c-17.67 0-32 14.33-32 32v64H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h49.61c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16h67.23c-.76 5.27-1.61 10.52-1.61 16 0 61.86 50.14 112 112 112s112-50.14 112-112c0-5.48-.85-10.73-1.61-16H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zM288 96h81.24l76.8 96H288V96zM176 416c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48zm288 0c-26.47 0-48-21.53-48-48s21.53-48 48-48 48 21.53 48 48-21.53 48-48 48z"
        ],
        "tshirt": [
            640,
            512,
            [],
            "f553",
            "M631.2 96.5L436.5 0C416.4 27.8 371.9 47.2 320 47.2S223.6 27.8 203.5 0L8.8 96.5c-7.9 4-11.1 13.6-7.2 21.5l57.2 114.5c4 7.9 13.6 11.1 21.5 7.2l56.6-27.7c10.6-5.2 23 2.5 23 14.4V480c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V226.3c0-11.8 12.4-19.6 23-14.4l56.6 27.7c7.9 4 17.5.8 21.5-7.2L638.3 118c4-7.9.8-17.6-7.1-21.5z"
        ],
        "tty": [
            512,
            512,
            [],
            "f1e4",
            "M5.37 103.822c138.532-138.532 362.936-138.326 501.262 0 6.078 6.078 7.074 15.496 2.583 22.681l-43.214 69.138a18.332 18.332 0 0 1-22.356 7.305l-86.422-34.569a18.335 18.335 0 0 1-11.434-18.846L351.741 90c-62.145-22.454-130.636-21.986-191.483 0l5.953 59.532a18.331 18.331 0 0 1-11.434 18.846l-86.423 34.568a18.334 18.334 0 0 1-22.356-7.305L2.787 126.502a18.333 18.333 0 0 1 2.583-22.68zM96 308v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H92c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zM96 500v-40c0-6.627-5.373-12-12-12H44c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H140c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z"
        ],
        "tv": [
            640,
            512,
            [],
            "f26c",
            "M592 0H48A48 48 0 0 0 0 48v320a48 48 0 0 0 48 48h240v32H112a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16H352v-32h240a48 48 0 0 0 48-48V48a48 48 0 0 0-48-48zm-16 352H64V64h512z"
        ],
        "umbrella": [
            576,
            512,
            [],
            "f0e9",
            "M575.7 280.8C547.1 144.5 437.3 62.6 320 49.9V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v17.9C138.3 62.6 29.5 144.5.3 280.8c-2.2 10.1 8.5 21.3 18.7 11.4 52-55 107.7-52.4 158.6 37 5.3 9.5 14.9 8.6 19.7 0 20.2-35.4 44.9-73.2 90.7-73.2 58.5 0 88.2 68.8 90.7 73.2 4.8 8.6 14.4 9.5 19.7 0 51-89.5 107.1-91.4 158.6-37 10.3 10 20.9-1.3 18.7-11.4zM256 301.7V432c0 8.8-7.2 16-16 16-7.8 0-13.2-5.3-15.1-10.7-5.9-16.7-24.1-25.4-40.8-19.5-16.7 5.9-25.4 24.2-19.5 40.8 11.2 31.9 41.6 53.3 75.4 53.3 44.1 0 80-35.9 80-80V301.6c-9.1-7.9-19.8-13.6-32-13.6-12.3.1-22.4 4.8-32 13.7z"
        ],
        "umbrella-beach": [
            640,
            512,
            [],
            "f5ca",
            "M115.38 136.9l102.11 37.18c35.19-81.54 86.21-144.29 139-173.7-95.88-4.89-188.78 36.96-248.53 111.8-6.69 8.4-2.66 21.05 7.42 24.72zm132.25 48.16l238.48 86.83c35.76-121.38 18.7-231.66-42.63-253.98-7.4-2.7-15.13-4-23.09-4-58.02.01-128.27 69.17-172.76 171.15zM521.48 60.5c6.22 16.3 10.83 34.6 13.2 55.19 5.74 49.89-1.42 108.23-18.95 166.98l102.62 37.36c10.09 3.67 21.31-3.43 21.57-14.17 2.32-95.69-41.91-187.44-118.44-245.36zM560 447.98H321.06L386 269.5l-60.14-21.9-72.9 200.37H16c-8.84 0-16 7.16-16 16.01v32.01C0 504.83 7.16 512 16 512h544c8.84 0 16-7.17 16-16.01v-32.01c0-8.84-7.16-16-16-16z"
        ],
        "underline": [
            448,
            512,
            [],
            "f0cd",
            "M32 64h32v160c0 88.22 71.78 160 160 160s160-71.78 160-160V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H272a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h32v160a80 80 0 0 1-160 0V64h32a16 16 0 0 0 16-16V16a16 16 0 0 0-16-16H32a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16zm400 384H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16z"
        ],
        "undo": [
            512,
            512,
            [],
            "f0e2",
            "M212.333 224.333H12c-6.627 0-12-5.373-12-12V12C0 5.373 5.373 0 12 0h48c6.627 0 12 5.373 12 12v78.112C117.773 39.279 184.26 7.47 258.175 8.007c136.906.994 246.448 111.623 246.157 248.532C504.041 393.258 393.12 504 256.333 504c-64.089 0-122.496-24.313-166.51-64.215-5.099-4.622-5.334-12.554-.467-17.42l33.967-33.967c4.474-4.474 11.662-4.717 16.401-.525C170.76 415.336 211.58 432 256.333 432c97.268 0 176-78.716 176-176 0-97.267-78.716-176-176-176-58.496 0-110.28 28.476-142.274 72.333h98.274c6.627 0 12 5.373 12 12v48c0 6.627-5.373 12-12 12z"
        ],
        "undo-alt": [
            512,
            512,
            [],
            "f2ea",
            "M255.545 8c-66.269.119-126.438 26.233-170.86 68.685L48.971 40.971C33.851 25.851 8 36.559 8 57.941V192c0 13.255 10.745 24 24 24h134.059c21.382 0 32.09-25.851 16.971-40.971l-41.75-41.75c30.864-28.899 70.801-44.907 113.23-45.273 92.398-.798 170.283 73.977 169.484 169.442C423.236 348.009 349.816 424 256 424c-41.127 0-79.997-14.678-110.63-41.556-4.743-4.161-11.906-3.908-16.368.553L89.34 422.659c-4.872 4.872-4.631 12.815.482 17.433C133.798 479.813 192.074 504 256 504c136.966 0 247.999-111.033 248-247.998C504.001 119.193 392.354 7.755 255.545 8z"
        ],
        "universal-access": [
            512,
            512,
            [],
            "f29a",
            "M256 48c114.953 0 208 93.029 208 208 0 114.953-93.029 208-208 208-114.953 0-208-93.029-208-208 0-114.953 93.029-208 208-208m0-40C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 56C149.961 64 64 149.961 64 256s85.961 192 192 192 192-85.961 192-192S362.039 64 256 64zm0 44c19.882 0 36 16.118 36 36s-16.118 36-36 36-36-16.118-36-36 16.118-36 36-36zm117.741 98.023c-28.712 6.779-55.511 12.748-82.14 15.807.851 101.023 12.306 123.052 25.037 155.621 3.617 9.26-.957 19.698-10.217 23.315-9.261 3.617-19.699-.957-23.316-10.217-8.705-22.308-17.086-40.636-22.261-78.549h-9.686c-5.167 37.851-13.534 56.208-22.262 78.549-3.615 9.255-14.05 13.836-23.315 10.217-9.26-3.617-13.834-14.056-10.217-23.315 12.713-32.541 24.185-54.541 25.037-155.621-26.629-3.058-53.428-9.027-82.141-15.807-8.6-2.031-13.926-10.648-11.895-19.249s10.647-13.926 19.249-11.895c96.686 22.829 124.283 22.783 220.775 0 8.599-2.03 17.218 3.294 19.249 11.895 2.029 8.601-3.297 17.219-11.897 19.249z"
        ],
        "university": [
            512,
            512,
            [],
            "f19c",
            "M496 128v16a8 8 0 0 1-8 8h-24v12c0 6.627-5.373 12-12 12H60c-6.627 0-12-5.373-12-12v-12H24a8 8 0 0 1-8-8v-16a8 8 0 0 1 4.941-7.392l232-88a7.996 7.996 0 0 1 6.118 0l232 88A8 8 0 0 1 496 128zm-24 304H40c-13.255 0-24 10.745-24 24v16a8 8 0 0 0 8 8h464a8 8 0 0 0 8-8v-16c0-13.255-10.745-24-24-24zM96 192v192H60c-6.627 0-12 5.373-12 12v20h416v-20c0-6.627-5.373-12-12-12h-36V192h-64v192h-64V192h-64v192h-64V192H96z"
        ],
        "unlink": [
            512,
            512,
            [],
            "f127",
            "M304.083 405.907c4.686 4.686 4.686 12.284 0 16.971l-44.674 44.674c-59.263 59.262-155.693 59.266-214.961 0-59.264-59.265-59.264-155.696 0-214.96l44.675-44.675c4.686-4.686 12.284-4.686 16.971 0l39.598 39.598c4.686 4.686 4.686 12.284 0 16.971l-44.675 44.674c-28.072 28.073-28.072 73.75 0 101.823 28.072 28.072 73.75 28.073 101.824 0l44.674-44.674c4.686-4.686 12.284-4.686 16.971 0l39.597 39.598zm-56.568-260.216c4.686 4.686 12.284 4.686 16.971 0l44.674-44.674c28.072-28.075 73.75-28.073 101.824 0 28.072 28.073 28.072 73.75 0 101.823l-44.675 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.598 39.598c4.686 4.686 12.284 4.686 16.971 0l44.675-44.675c59.265-59.265 59.265-155.695 0-214.96-59.266-59.264-155.695-59.264-214.961 0l-44.674 44.674c-4.686 4.686-4.686 12.284 0 16.971l39.597 39.598zm234.828 359.28l22.627-22.627c9.373-9.373 9.373-24.569 0-33.941L63.598 7.029c-9.373-9.373-24.569-9.373-33.941 0L7.029 29.657c-9.373 9.373-9.373 24.569 0 33.941l441.373 441.373c9.373 9.372 24.569 9.372 33.941 0z"
        ],
        "unlock": [
            448,
            512,
            [],
            "f09c",
            "M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48z"
        ],
        "unlock-alt": [
            448,
            512,
            [],
            "f13e",
            "M400 256H152V152.9c0-39.6 31.7-72.5 71.3-72.9 40-.4 72.7 32.1 72.7 72v16c0 13.3 10.7 24 24 24h32c13.3 0 24-10.7 24-24v-16C376 68 307.5-.3 223.5 0 139.5.3 72 69.5 72 153.5V256H48c-26.5 0-48 21.5-48 48v160c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V304c0-26.5-21.5-48-48-48zM264 408c0 22.1-17.9 40-40 40s-40-17.9-40-40v-48c0-22.1 17.9-40 40-40s40 17.9 40 40v48z"
        ],
        "upload": [
            512,
            512,
            [],
            "f093",
            "M296 384h-80c-13.3 0-24-10.7-24-24V192h-87.7c-17.8 0-26.7-21.5-14.1-34.1L242.3 5.7c7.5-7.5 19.8-7.5 27.3 0l152.2 152.2c12.6 12.6 3.7 34.1-14.1 34.1H320v168c0 13.3-10.7 24-24 24zm216-8v112c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V376c0-13.3 10.7-24 24-24h136v8c0 30.9 25.1 56 56 56h80c30.9 0 56-25.1 56-56v-8h136c13.3 0 24 10.7 24 24zm-124 88c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20zm64 0c0-11-9-20-20-20s-20 9-20 20 9 20 20 20 20-9 20-20z"
        ],
        "user": [
            448,
            512,
            [],
            "f007",
            "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
        ],
        "user-alt": [
            512,
            512,
            [],
            "f406",
            "M256 288c79.5 0 144-64.5 144-144S335.5 0 256 0 112 64.5 112 144s64.5 144 144 144zm128 32h-55.1c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16H128C57.3 320 0 377.3 0 448v16c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-16c0-70.7-57.3-128-128-128z"
        ],
        "user-alt-slash": [
            640,
            512,
            [],
            "f4fa",
            "M633.8 458.1L389.6 269.3C433.8 244.7 464 198.1 464 144 464 64.5 399.5 0 320 0c-67.1 0-123 46.1-139 108.2L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM198.4 320C124.2 320 64 380.2 64 454.4v9.6c0 26.5 21.5 48 48 48h382.2L245.8 320h-47.4z"
        ],
        "user-astronaut": [
            448,
            512,
            [],
            "f4fb",
            "M64 224h13.5c24.7 56.5 80.9 96 146.5 96s121.8-39.5 146.5-96H384c8.8 0 16-7.2 16-16v-96c0-8.8-7.2-16-16-16h-13.5C345.8 39.5 289.6 0 224 0S102.2 39.5 77.5 96H64c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16zm40-88c0-22.1 21.5-40 48-40h144c26.5 0 48 17.9 48 40v24c0 53-43 96-96 96h-48c-53 0-96-43-96-96v-24zm72 72l12-36 36-12-36-12-12-36-12 36-36 12 36 12 12 36zm151.6 113.4C297.7 340.7 262.2 352 224 352s-73.7-11.3-103.6-30.6C52.9 328.5 0 385 0 454.4v9.6c0 26.5 21.5 48 48 48h80v-64c0-17.7 14.3-32 32-32h128c17.7 0 32 14.3 32 32v64h80c26.5 0 48-21.5 48-48v-9.6c0-69.4-52.9-125.9-120.4-133zM272 448c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-96 0c-8.8 0-16 7.2-16 16v48h32v-48c0-8.8-7.2-16-16-16z"
        ],
        "user-check": [
            640,
            512,
            [],
            "f4fc",
            "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4zm323-128.4l-27.8-28.1c-4.6-4.7-12.1-4.7-16.8-.1l-104.8 104-45.5-45.8c-4.6-4.7-12.1-4.7-16.8-.1l-28.1 27.9c-4.7 4.6-4.7 12.1-.1 16.8l81.7 82.3c4.6 4.7 12.1 4.7 16.8.1l141.3-140.2c4.6-4.7 4.7-12.2.1-16.8z"
        ],
        "user-circle": [
            496,
            512,
            [],
            "f2bd",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
        ],
        "user-clock": [
            640,
            512,
            [],
            "f4fd",
            "M496 224c-79.6 0-144 64.4-144 144s64.4 144 144 144 144-64.4 144-144-64.4-144-144-144zm64 150.3c0 5.3-4.4 9.7-9.7 9.7h-60.6c-5.3 0-9.7-4.4-9.7-9.7v-76.6c0-5.3 4.4-9.7 9.7-9.7h12.6c5.3 0 9.7 4.4 9.7 9.7V352h38.3c5.3 0 9.7 4.4 9.7 9.7v12.6zM320 368c0-27.8 6.7-54.1 18.2-77.5-8-1.5-16.2-2.5-24.6-2.5h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h347.1c-45.3-31.9-75.1-84.5-75.1-144zm-96-112c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128z"
        ],
        "user-cog": [
            640,
            512,
            [],
            "f4fe",
            "M610.5 373.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 400.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm201.2 226.5c-2.3-1.2-4.6-2.6-6.8-3.9l-7.9 4.6c-6 3.4-12.8 5.3-19.6 5.3-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-5.5-17.7 1.9-36.4 17.9-45.7l7.9-4.6c-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-16-9.2-23.4-28-17.9-45.7.9-2.9 2.2-5.8 3.2-8.7-3.8-.3-7.5-1.2-11.4-1.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c10.1 0 19.5-3.2 27.2-8.5-1.2-3.8-2-7.7-2-11.8v-9.2z"
        ],
        "user-edit": [
            640,
            512,
            [],
            "f4ff",
            "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h274.9c-2.4-6.8-3.4-14-2.6-21.3l6.8-60.9 1.2-11.1 7.9-7.9 77.3-77.3c-24.5-27.7-60-45.5-99.9-45.5zm45.3 145.3l-6.8 61c-1.1 10.2 7.5 18.8 17.6 17.6l60.9-6.8 137.9-137.9-71.7-71.7-137.9 137.8zM633 268.9L595.1 231c-9.3-9.3-24.5-9.3-33.8 0l-37.8 37.8-4.1 4.1 71.8 71.7 41.8-41.8c9.3-9.4 9.3-24.5 0-33.9z"
        ],
        "user-friends": [
            640,
            512,
            [],
            "f500",
            "M192 256c61.9 0 112-50.1 112-112S253.9 32 192 32 80 82.1 80 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C51.6 288 0 339.6 0 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zM480 256c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zm48 32h-3.8c-13.9 4.8-28.6 8-44.2 8s-30.3-3.2-44.2-8H432c-20.4 0-39.2 5.9-55.7 15.4 24.4 26.3 39.7 61.2 39.7 99.8v38.4c0 2.2-.5 4.3-.6 6.4H592c26.5 0 48-21.5 48-48 0-61.9-50.1-112-112-112z"
        ],
        "user-graduate": [
            448,
            512,
            [],
            "f501",
            "M319.4 320.6L224 416l-95.4-95.4C57.1 323.7 0 382.2 0 454.4v9.6c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-9.6c0-72.2-57.1-130.7-128.6-133.8zM13.6 79.8l6.4 1.5v58.4c-7 4.2-12 11.5-12 20.3 0 8.4 4.6 15.4 11.1 19.7L3.5 242c-1.7 6.9 2.1 14 7.6 14h41.8c5.5 0 9.3-7.1 7.6-14l-15.6-62.3C51.4 175.4 56 168.4 56 160c0-8.8-5-16.1-12-20.3V87.1l66 15.9c-8.6 17.2-14 36.4-14 57 0 70.7 57.3 128 128 128s128-57.3 128-128c0-20.6-5.3-39.8-14-57l96.3-23.2c18.2-4.4 18.2-27.1 0-31.5l-190.4-46c-13-3.1-26.7-3.1-39.7 0L13.6 48.2c-18.1 4.4-18.1 27.2 0 31.6z"
        ],
        "user-injured": [
            448,
            512,
            [],
            "f728",
            "M277.37 11.98C261.08 4.47 243.11 0 224 0c-53.69 0-99.5 33.13-118.51 80h81.19l90.69-68.02zM342.51 80c-7.9-19.47-20.67-36.2-36.49-49.52L239.99 80h102.52zM224 256c70.69 0 128-57.31 128-128 0-5.48-.95-10.7-1.61-16H97.61c-.67 5.3-1.61 10.52-1.61 16 0 70.69 57.31 128 128 128zM80 299.7V512h128.26l-98.45-221.52A132.835 132.835 0 0 0 80 299.7zM0 464c0 26.51 21.49 48 48 48V320.24C18.88 344.89 0 381.26 0 422.4V464zm256-48h-55.38l42.67 96H256c26.47 0 48-21.53 48-48s-21.53-48-48-48zm57.6-128h-16.71c-22.24 10.18-46.88 16-72.89 16s-50.65-5.82-72.89-16h-7.37l42.67 96H256c44.11 0 80 35.89 80 80 0 18.08-6.26 34.59-16.41 48H400c26.51 0 48-21.49 48-48v-41.6c0-74.23-60.17-134.4-134.4-134.4z"
        ],
        "user-lock": [
            640,
            512,
            [],
            "f502",
            "M224 256A128 128 0 1 0 96 128a128 128 0 0 0 128 128zm96 64a63.08 63.08 0 0 1 8.1-30.5c-4.8-.5-9.5-1.5-14.5-1.5h-16.7a174.08 174.08 0 0 1-145.8 0h-16.7A134.43 134.43 0 0 0 0 422.4V464a48 48 0 0 0 48 48h280.9a63.54 63.54 0 0 1-8.9-32zm288-32h-32v-80a80 80 0 0 0-160 0v80h-32a32 32 0 0 0-32 32v160a32 32 0 0 0 32 32h224a32 32 0 0 0 32-32V320a32 32 0 0 0-32-32zM496 432a32 32 0 1 1 32-32 32 32 0 0 1-32 32zm32-144h-64v-80a32 32 0 0 1 64 0z"
        ],
        "user-md": [
            448,
            512,
            [],
            "f0f0",
            "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zM104 424c0 13.3 10.7 24 24 24s24-10.7 24-24-10.7-24-24-24-24 10.7-24 24zm216-135.4v49c36.5 7.4 64 39.8 64 78.4v41.7c0 7.6-5.4 14.2-12.9 15.7l-32.2 6.4c-4.3.9-8.5-1.9-9.4-6.3l-3.1-15.7c-.9-4.3 1.9-8.6 6.3-9.4l19.3-3.9V416c0-62.8-96-65.1-96 1.9v26.7l19.3 3.9c4.3.9 7.1 5.1 6.3 9.4l-3.1 15.7c-.9 4.3-5.1 7.1-9.4 6.3l-31.2-4.2c-7.9-1.1-13.8-7.8-13.8-15.9V416c0-38.6 27.5-70.9 64-78.4v-45.2c-2.2.7-4.4 1.1-6.6 1.9-18 6.3-37.3 9.8-57.4 9.8s-39.4-3.5-57.4-9.8c-7.4-2.6-14.9-4.2-22.6-5.2v81.6c23.1 6.9 40 28.1 40 53.4 0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.3 16.9-46.5 40-53.4v-80.4C48.5 301 0 355.8 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-72-56.8-130.3-128-133.8z"
        ],
        "user-minus": [
            640,
            512,
            [],
            "f503",
            "M624 208H432c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h192c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
        ],
        "user-ninja": [
            448,
            512,
            [],
            "f504",
            "M325.4 289.2L224 390.6 122.6 289.2C54 295.3 0 352.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-70.2-54-127.1-122.6-133.2zM32 192c27.3 0 51.8-11.5 69.2-29.7 15.1 53.9 64 93.7 122.8 93.7 70.7 0 128-57.3 128-128S294.7 0 224 0c-50.4 0-93.6 29.4-114.5 71.8C92.1 47.8 64 32 32 32c0 33.4 17.1 62.8 43.1 80-26 17.2-43.1 46.6-43.1 80zm144-96h96c17.7 0 32 14.3 32 32H144c0-17.7 14.3-32 32-32z"
        ],
        "user-nurse": [
            448,
            512,
            [],
            "f82f",
            "M319.41,320,224,415.39,128.59,320C57.1,323.1,0,381.6,0,453.79A58.21,58.21,0,0,0,58.21,512H389.79A58.21,58.21,0,0,0,448,453.79C448,381.6,390.9,323.1,319.41,320ZM224,304A128,128,0,0,0,352,176V65.82a32,32,0,0,0-20.76-30L246.47,4.07a64,64,0,0,0-44.94,0L116.76,35.86A32,32,0,0,0,96,65.82V176A128,128,0,0,0,224,304ZM184,71.67a5,5,0,0,1,5-5h21.67V45a5,5,0,0,1,5-5h16.66a5,5,0,0,1,5,5V66.67H259a5,5,0,0,1,5,5V88.33a5,5,0,0,1-5,5H237.33V115a5,5,0,0,1-5,5H215.67a5,5,0,0,1-5-5V93.33H189a5,5,0,0,1-5-5ZM144,160H304v16a80,80,0,0,1-160,0Z"
        ],
        "user-plus": [
            640,
            512,
            [],
            "f234",
            "M624 208h-64v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v64h-64c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64h64c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400 48c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
        ],
        "user-secret": [
            448,
            512,
            [],
            "f21b",
            "M383.9 308.3l23.9-62.6c4-10.5-3.7-21.7-15-21.7h-58.5c11-18.9 17.8-40.6 17.8-64v-.3c39.2-7.8 64-19.1 64-31.7 0-13.3-27.3-25.1-70.1-33-9.2-32.8-27-65.8-40.6-82.8-9.5-11.9-25.9-15.6-39.5-8.8l-27.6 13.8c-9 4.5-19.6 4.5-28.6 0L182.1 3.4c-13.6-6.8-30-3.1-39.5 8.8-13.5 17-31.4 50-40.6 82.8-42.7 7.9-70 19.7-70 33 0 12.6 24.8 23.9 64 31.7v.3c0 23.4 6.8 45.1 17.8 64H56.3c-11.5 0-19.2 11.7-14.7 22.3l25.8 60.2C27.3 329.8 0 372.7 0 422.4v44.8C0 491.9 20.1 512 44.8 512h358.4c24.7 0 44.8-20.1 44.8-44.8v-44.8c0-48.4-25.8-90.4-64.1-114.1zM176 480l-41.6-192 49.6 32 24 40-32 120zm96 0l-32-120 24-40 49.6-32L272 480zm41.7-298.5c-3.9 11.9-7 24.6-16.5 33.4-10.1 9.3-48 22.4-64-25-2.8-8.4-15.4-8.4-18.3 0-17 50.2-56 32.4-64 25-9.5-8.8-12.7-21.5-16.5-33.4-.8-2.5-6.3-5.7-6.3-5.8v-10.8c28.3 3.6 61 5.8 96 5.8s67.7-2.1 96-5.8v10.8c-.1.1-5.6 3.2-6.4 5.8z"
        ],
        "user-shield": [
            640,
            512,
            [],
            "f505",
            "M622.3 271.1l-115.2-45c-4.1-1.6-12.6-3.7-22.2 0l-115.2 45c-10.7 4.2-17.7 14-17.7 24.9 0 111.6 68.7 188.8 132.9 213.9 9.6 3.7 18 1.6 22.2 0C558.4 489.9 640 420.5 640 296c0-10.9-7-20.7-17.7-24.9zM496 462.4V273.3l95.5 37.3c-5.6 87.1-60.9 135.4-95.5 151.8zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm96 40c0-2.5.8-4.8 1.1-7.2-2.5-.1-4.9-.8-7.5-.8h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c6.8 0 13.3-1.5 19.2-4-54-42.9-99.2-116.7-99.2-212z"
        ],
        "user-slash": [
            640,
            512,
            [],
            "f506",
            "M633.8 458.1L362.3 248.3C412.1 230.7 448 183.8 448 128 448 57.3 390.7 0 320 0c-67.1 0-121.5 51.8-126.9 117.4L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4l588.4 454.7c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.4-6.8 4.1-16.9-2.9-22.3zM96 422.4V464c0 26.5 21.5 48 48 48h350.2L207.4 290.3C144.2 301.3 96 356 96 422.4z"
        ],
        "user-tag": [
            640,
            512,
            [],
            "f507",
            "M630.6 364.9l-90.3-90.2c-12-12-28.3-18.7-45.3-18.7h-79.3c-17.7 0-32 14.3-32 32v79.2c0 17 6.7 33.2 18.7 45.2l90.3 90.2c12.5 12.5 32.8 12.5 45.3 0l92.5-92.5c12.6-12.5 12.6-32.7.1-45.2zm-182.8-21c-13.3 0-24-10.7-24-24s10.7-24 24-24 24 10.7 24 24c0 13.2-10.7 24-24 24zm-223.8-88c70.7 0 128-57.3 128-128C352 57.3 294.7 0 224 0S96 57.3 96 128c0 70.6 57.3 127.9 128 127.9zm127.8 111.2V294c-12.2-3.6-24.9-6.2-38.2-6.2h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 287.9 0 348.1 0 422.3v41.6c0 26.5 21.5 48 48 48h352c15.5 0 29.1-7.5 37.9-18.9l-58-58c-18.1-18.1-28.1-42.2-28.1-67.9z"
        ],
        "user-tie": [
            448,
            512,
            [],
            "f508",
            "M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm95.8 32.6L272 480l-32-136 32-56h-96l32 56-32 136-47.8-191.4C56.9 292 0 350.3 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-72.1-56.9-130.4-128.2-133.8z"
        ],
        "user-times": [
            640,
            512,
            [],
            "f235",
            "M589.6 240l45.6-45.6c6.3-6.3 6.3-16.5 0-22.8l-22.8-22.8c-6.3-6.3-16.5-6.3-22.8 0L544 194.4l-45.6-45.6c-6.3-6.3-16.5-6.3-22.8 0l-22.8 22.8c-6.3 6.3-6.3 16.5 0 22.8l45.6 45.6-45.6 45.6c-6.3 6.3-6.3 16.5 0 22.8l22.8 22.8c6.3 6.3 16.5 6.3 22.8 0l45.6-45.6 45.6 45.6c6.3 6.3 16.5 6.3 22.8 0l22.8-22.8c6.3-6.3 6.3-16.5 0-22.8L589.6 240zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z"
        ],
        "users": [
            640,
            512,
            [],
            "f0c0",
            "M96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm448 0c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm32 32h-64c-17.6 0-33.5 7.1-45.1 18.6 40.3 22.1 68.9 62 75.1 109.4h66c17.7 0 32-14.3 32-32v-32c0-35.3-28.7-64-64-64zm-256 0c61.9 0 112-50.1 112-112S381.9 32 320 32 208 82.1 208 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zm-223.7-13.4C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"
        ],
        "users-cog": [
            640,
            512,
            [],
            "f509",
            "M610.5 341.3c2.6-14.1 2.6-28.5 0-42.6l25.8-14.9c3-1.7 4.3-5.2 3.3-8.5-6.7-21.6-18.2-41.2-33.2-57.4-2.3-2.5-6-3.1-9-1.4l-25.8 14.9c-10.9-9.3-23.4-16.5-36.9-21.3v-29.8c0-3.4-2.4-6.4-5.7-7.1-22.3-5-45-4.8-66.2 0-3.3.7-5.7 3.7-5.7 7.1v29.8c-13.5 4.8-26 12-36.9 21.3l-25.8-14.9c-2.9-1.7-6.7-1.1-9 1.4-15 16.2-26.5 35.8-33.2 57.4-1 3.3.4 6.8 3.3 8.5l25.8 14.9c-2.6 14.1-2.6 28.5 0 42.6l-25.8 14.9c-3 1.7-4.3 5.2-3.3 8.5 6.7 21.6 18.2 41.1 33.2 57.4 2.3 2.5 6 3.1 9 1.4l25.8-14.9c10.9 9.3 23.4 16.5 36.9 21.3v29.8c0 3.4 2.4 6.4 5.7 7.1 22.3 5 45 4.8 66.2 0 3.3-.7 5.7-3.7 5.7-7.1v-29.8c13.5-4.8 26-12 36.9-21.3l25.8 14.9c2.9 1.7 6.7 1.1 9-1.4 15-16.2 26.5-35.8 33.2-57.4 1-3.3-.4-6.8-3.3-8.5l-25.8-14.9zM496 368.5c-26.8 0-48.5-21.8-48.5-48.5s21.8-48.5 48.5-48.5 48.5 21.8 48.5 48.5-21.7 48.5-48.5 48.5zM96 224c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm224 32c1.9 0 3.7-.5 5.6-.6 8.3-21.7 20.5-42.1 36.3-59.2 7.4-8 17.9-12.6 28.9-12.6 6.9 0 13.7 1.8 19.6 5.3l7.9 4.6c.8-.5 1.6-.9 2.4-1.4 7-14.6 11.2-30.8 11.2-48 0-61.9-50.1-112-112-112S208 82.1 208 144c0 61.9 50.1 112 112 112zm105.2 194.5c-2.3-1.2-4.6-2.6-6.8-3.9-8.2 4.8-15.3 9.8-27.5 9.8-10.9 0-21.4-4.6-28.9-12.6-18.3-19.8-32.3-43.9-40.2-69.6-10.7-34.5 24.9-49.7 25.8-50.3-.1-2.6-.1-5.2 0-7.8l-7.9-4.6c-3.8-2.2-7-5-9.8-8.1-3.3.2-6.5.6-9.8.6-24.6 0-47.6-6-68.5-16h-8.3C179.6 288 128 339.6 128 403.2V432c0 26.5 21.5 48 48 48h255.4c-3.7-6-6.2-12.8-6.2-20.3v-9.2zM173.1 274.6C161.5 263.1 145.6 256 128 256H64c-35.3 0-64 28.7-64 64v32c0 17.7 14.3 32 32 32h65.9c6.3-47.4 34.9-87.3 75.2-109.4z"
        ],
        "users-slash": [
            640,
            512,
            [],
            "e073",
            "M132.65,212.32,36.21,137.78A63.4,63.4,0,0,0,32,160a63.84,63.84,0,0,0,100.65,52.32Zm40.44,62.28A63.79,63.79,0,0,0,128,256H64A64.06,64.06,0,0,0,0,320v32a32,32,0,0,0,32,32H97.91A146.62,146.62,0,0,1,173.09,274.6ZM544,224a64,64,0,1,0-64-64A64.06,64.06,0,0,0,544,224ZM500.56,355.11a114.24,114.24,0,0,0-84.47-65.28L361,247.23c41.46-16.3,71-55.92,71-103.23A111.93,111.93,0,0,0,320,32c-57.14,0-103.69,42.83-110.6,98.08L45.46,3.38A16,16,0,0,0,23,6.19L3.37,31.46A16,16,0,0,0,6.18,53.91L594.53,508.63A16,16,0,0,0,617,505.82l19.64-25.27a16,16,0,0,0-2.81-22.45ZM128,403.21V432a48,48,0,0,0,48,48H464a47.45,47.45,0,0,0,12.57-1.87L232,289.13C173.74,294.83,128,343.42,128,403.21ZM576,256H512a63.79,63.79,0,0,0-45.09,18.6A146.29,146.29,0,0,1,542,384h66a32,32,0,0,0,32-32V320A64.06,64.06,0,0,0,576,256Z"
        ],
        "utensil-spoon": [
            512,
            512,
            [],
            "f2e5",
            "M480.1 31.9c-55-55.1-164.9-34.5-227.8 28.5-49.3 49.3-55.1 110-28.8 160.4L9 413.2c-11.6 10.5-12.1 28.5-1 39.5L59.3 504c11 11 29.1 10.5 39.5-1.1l192.4-214.4c50.4 26.3 111.1 20.5 160.4-28.8 63-62.9 83.6-172.8 28.5-227.8z"
        ],
        "utensils": [
            416,
            512,
            [],
            "f2e7",
            "M207.9 15.2c.8 4.7 16.1 94.5 16.1 128.8 0 52.3-27.8 89.6-68.9 104.6L168 486.7c.7 13.7-10.2 25.3-24 25.3H80c-13.7 0-24.7-11.5-24-25.3l12.9-238.1C27.7 233.6 0 196.2 0 144 0 109.6 15.3 19.9 16.1 15.2 19.3-5.1 61.4-5.4 64 16.3v141.2c1.3 3.4 15.1 3.2 16 0 1.4-25.3 7.9-139.2 8-141.8 3.3-20.8 44.7-20.8 47.9 0 .2 2.7 6.6 116.5 8 141.8.9 3.2 14.8 3.4 16 0V16.3c2.6-21.6 44.8-21.4 48-1.1zm119.2 285.7l-15 185.1c-1.2 14 9.9 26 23.9 26h56c13.3 0 24-10.7 24-24V24c0-13.2-10.7-24-24-24-82.5 0-221.4 178.5-64.9 300.9z"
        ],
        "vector-square": [
            512,
            512,
            [],
            "f5cb",
            "M512 128V32c0-17.67-14.33-32-32-32h-96c-17.67 0-32 14.33-32 32H160c0-17.67-14.33-32-32-32H32C14.33 0 0 14.33 0 32v96c0 17.67 14.33 32 32 32v192c-17.67 0-32 14.33-32 32v96c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32h192c0 17.67 14.33 32 32 32h96c17.67 0 32-14.33 32-32v-96c0-17.67-14.33-32-32-32V160c17.67 0 32-14.33 32-32zm-96-64h32v32h-32V64zM64 64h32v32H64V64zm32 384H64v-32h32v32zm352 0h-32v-32h32v32zm-32-96h-32c-17.67 0-32 14.33-32 32v32H160v-32c0-17.67-14.33-32-32-32H96V160h32c17.67 0 32-14.33 32-32V96h192v32c0 17.67 14.33 32 32 32h32v192z"
        ],
        "venus": [
            288,
            512,
            [],
            "f221",
            "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80z"
        ],
        "venus-double": [
            512,
            512,
            [],
            "f226",
            "M288 176c0-79.5-64.5-144-144-144S0 96.5 0 176c0 68.5 47.9 125.9 112 140.4V368H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.5 112-71.9 112-140.4zm-224 0c0-44.1 35.9-80 80-80s80 35.9 80 80-35.9 80-80 80-80-35.9-80-80zm336 140.4V368h36c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-36v36c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12v-36h-36c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h36v-51.6c-21.2-4.8-40.6-14.3-57.2-27.3 14-16.7 25-36 32.1-57.1 14.5 14.8 34.7 24 57.1 24 44.1 0 80-35.9 80-80s-35.9-80-80-80c-22.3 0-42.6 9.2-57.1 24-7.1-21.1-18-40.4-32.1-57.1C303.4 43.6 334.3 32 368 32c79.5 0 144 64.5 144 144 0 68.5-47.9 125.9-112 140.4z"
        ],
        "venus-mars": [
            576,
            512,
            [],
            "f228",
            "M564 0h-79c-10.7 0-16 12.9-8.5 20.5l16.9 16.9-48.7 48.7C422.5 72.1 396.2 64 368 64c-33.7 0-64.6 11.6-89.2 30.9 14 16.7 25 36 32.1 57.1 14.5-14.8 34.7-24 57.1-24 44.1 0 80 35.9 80 80s-35.9 80-80 80c-22.3 0-42.6-9.2-57.1-24-7.1 21.1-18 40.4-32.1 57.1 24.5 19.4 55.5 30.9 89.2 30.9 79.5 0 144-64.5 144-144 0-28.2-8.1-54.5-22.1-76.7l48.7-48.7 16.9 16.9c2.4 2.4 5.4 3.5 8.4 3.5 6.2 0 12.1-4.8 12.1-12V12c0-6.6-5.4-12-12-12zM144 64C64.5 64 0 128.5 0 208c0 68.5 47.9 125.9 112 140.4V400H76c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h36v36c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12v-36h36c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-36v-51.6c64.1-14.6 112-71.9 112-140.4 0-79.5-64.5-144-144-144zm0 224c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z"
        ],
        "vest": [
            448,
            512,
            [],
            "e085",
            "M437.252,239.877,384,160V32A32,32,0,0,0,352,0H320a24.021,24.021,0,0,0-13.312,4.031l-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672A24.021,24.021,0,0,0,128,0H96A32,32,0,0,0,64,32V160L10.748,239.877A64,64,0,0,0,0,275.377V480a32,32,0,0,0,32,32H192V288a31.987,31.987,0,0,1,1.643-10.119L207.135,237.4,150.188,66.564A151.518,151.518,0,0,0,224,86.234a151.55,151.55,0,0,0,73.812-19.672L224,288V512H416a32,32,0,0,0,32-32V275.377A64,64,0,0,0,437.252,239.877ZM131.312,371.312l-48,48a16,16,0,0,1-22.624-22.624l48-48a16,16,0,0,1,22.624,22.624Zm256,48a15.992,15.992,0,0,1-22.624,0l-48-48a16,16,0,0,1,22.624-22.624l48,48A15.993,15.993,0,0,1,387.312,419.312Z"
        ],
        "vest-patches": [
            448,
            512,
            [],
            "e086",
            "M437.252,239.877,384,160V32A32,32,0,0,0,352,0H320a23.982,23.982,0,0,0-13.312,4.031l-25,16.672a103.794,103.794,0,0,1-115.376,0l-25-16.672A23.982,23.982,0,0,0,128,0H96A32,32,0,0,0,64,32V160L10.748,239.877A64,64,0,0,0,0,275.377V480a32,32,0,0,0,32,32H192V288a31.987,31.987,0,0,1,1.643-10.119L207.135,237.4,150.188,66.561A151.579,151.579,0,0,0,224,86.234a151.565,151.565,0,0,0,73.811-19.668L224,288V512H416a32,32,0,0,0,32-32V275.377A64,64,0,0,0,437.252,239.877ZM63.5,272.484a12.01,12.01,0,0,1,17-16.968l15.5,15.5,15.5-15.5a12.01,12.01,0,0,1,17,16.968L112.984,288,128.5,303.516a12.01,12.01,0,0,1-17,16.968L96,304.984l-15.5,15.5a12.01,12.01,0,0,1-17-16.968L79.016,288ZM96,456a40,40,0,1,1,40-40A40,40,0,0,1,96,456ZM359.227,335.785,310.7,336a6.671,6.671,0,0,1-6.7-6.7l.215-48.574A24.987,24.987,0,0,1,331.43,256.1c12.789,1.162,22.129,12.619,22.056,25.419l-.037,5.057,5.051-.037c12.826-.035,24.236,9.275,25.4,22.076A24.948,24.948,0,0,1,359.227,335.785Z"
        ],
        "vial": [
            480,
            512,
            [],
            "f492",
            "M477.7 186.1L309.5 18.3c-3.1-3.1-8.2-3.1-11.3 0l-34 33.9c-3.1 3.1-3.1 8.2 0 11.3l11.2 11.1L33 316.5c-38.8 38.7-45.1 102-9.4 143.5 20.6 24 49.5 36 78.4 35.9 26.4 0 52.8-10 72.9-30.1l246.3-245.7 11.2 11.1c3.1 3.1 8.2 3.1 11.3 0l34-33.9c3.1-3 3.1-8.1 0-11.2zM318 256H161l148-147.7 78.5 78.3L318 256z"
        ],
        "vials": [
            640,
            512,
            [],
            "f493",
            "M72 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64zm480 384H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM360 64h24v240c0 44.1 35.9 80 80 80s80-35.9 80-80V64h24c4.4 0 8-3.6 8-8V8c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm72 0h64v96h-64V64z"
        ],
        "video": [
            576,
            512,
            [],
            "f03d",
            "M336.2 64H47.8C21.4 64 0 85.4 0 111.8v288.4C0 426.6 21.4 448 47.8 448h288.4c26.4 0 47.8-21.4 47.8-47.8V111.8c0-26.4-21.4-47.8-47.8-47.8zm189.4 37.7L416 177.3v157.4l109.6 75.5c21.2 14.6 50.4-.3 50.4-25.8V127.5c0-25.4-29.1-40.4-50.4-25.8z"
        ],
        "video-slash": [
            640,
            512,
            [],
            "f4e2",
            "M633.8 458.1l-55-42.5c15.4-1.4 29.2-13.7 29.2-31.1v-257c0-25.5-29.1-40.4-50.4-25.8L448 177.3v137.2l-32-24.7v-178c0-26.4-21.4-47.8-47.8-47.8H123.9L45.5 3.4C38.5-2 28.5-.8 23 6.2L3.4 31.4c-5.4 7-4.2 17 2.8 22.4L42.7 82 416 370.6l178.5 138c7 5.4 17 4.2 22.5-2.8l19.6-25.3c5.5-6.9 4.2-17-2.8-22.4zM32 400.2c0 26.4 21.4 47.8 47.8 47.8h288.4c11.2 0 21.4-4 29.6-10.5L32 154.7v245.5z"
        ],
        "vihara": [
            640,
            512,
            [],
            "f6a7",
            "M632.88 400.71L544 352v-64l55.16-17.69c11.79-5.9 11.79-22.72 0-28.62L480 192v-64l27.31-16.3c7.72-7.72 5.61-20.74-4.16-25.62L320 0 136.85 86.07c-9.77 4.88-11.88 17.9-4.16 25.62L160 128v64L40.84 241.69c-11.79 5.9-11.79 22.72 0 28.62L96 288v64L7.12 400.71c-5.42 3.62-7.7 9.63-7 15.29.62 5.01 3.57 9.75 8.72 12.33L64 448v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48h160v48c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-48l55.15-19.67c5.16-2.58 8.1-7.32 8.72-12.33.71-5.67-1.57-11.68-6.99-15.29zM224 128h192v64H224v-64zm-64 224v-64h320v64H160z"
        ],
        "virus": [
            512,
            512,
            [],
            "e074",
            "M483.55,227.55H462c-50.68,0-76.07-61.27-40.23-97.11L437,115.19A28.44,28.44,0,0,0,396.8,75L381.56,90.22c-35.84,35.83-97.11,10.45-97.11-40.23V28.44a28.45,28.45,0,0,0-56.9,0V50c0,50.68-61.27,76.06-97.11,40.23L115.2,75A28.44,28.44,0,0,0,75,115.19l15.25,15.25c35.84,35.84,10.45,97.11-40.23,97.11H28.45a28.45,28.45,0,1,0,0,56.89H50c50.68,0,76.07,61.28,40.23,97.12L75,396.8A28.45,28.45,0,0,0,115.2,437l15.24-15.25c35.84-35.84,97.11-10.45,97.11,40.23v21.54a28.45,28.45,0,0,0,56.9,0V462c0-50.68,61.27-76.07,97.11-40.23L396.8,437A28.45,28.45,0,0,0,437,396.8l-15.25-15.24c-35.84-35.84-10.45-97.12,40.23-97.12h21.54a28.45,28.45,0,1,0,0-56.89ZM224,272a48,48,0,1,1,48-48A48,48,0,0,1,224,272Zm80,56a24,24,0,1,1,24-24A24,24,0,0,1,304,328Z"
        ],
        "virus-slash": [
            640,
            512,
            [],
            "e075",
            "M114,227.6H92.4C76.7,227.6,64,240.3,64,256s12.7,28.4,28.4,28.4H114c50.7,0,76.1,61.3,40.2,97.1L139,396.8 c-11.5,10.7-12.2,28.7-1.6,40.2s28.7,12.2,40.2,1.6c0.5-0.5,1.1-1,1.6-1.6l15.2-15.2c35.8-35.8,97.1-10.5,97.1,40.2v21.5 c0,15.7,12.8,28.4,28.5,28.4c15.7,0,28.4-12.7,28.4-28.4V462c0-26.6,17-45.9,38.2-53.4l-244.5-189 C133.7,224.7,123.9,227.5,114,227.6z M617,505.8l19.6-25.3c5.4-7,4.2-17-2.8-22.5L470.6,332c4.2-25.4,24.9-47.5,55.4-47.5h21.5 c15.7,0,28.4-12.7,28.4-28.4s-12.7-28.4-28.4-28.4H526c-50.7,0-76.1-61.3-40.2-97.1l15.2-15.3c10.7-11.5,10-29.5-1.6-40.2 c-10.9-10.1-27.7-10.1-38.6,0l-15.2,15.2c-35.8,35.8-97.1,10.5-97.1-40.2V28.5C348.4,12.7,335.7,0,320,0 c-15.7,0-28.4,12.7-28.4,28.4V50c0,50.7-61.3,76.1-97.1,40.2L179.2,75c-11.1-11.1-29.4-10.6-40.5,0.5L45.5,3.4 c-7-5.4-17-4.2-22.5,2.8L3.4,31.5c-5.4,7-4.2,17,2.8,22.5l588.4,454.7C601.5,514.1,611.6,512.8,617,505.8z M335.4,227.5l-62.9-48.6 c4.9-1.8,10.2-2.8,15.4-2.9c26.5,0,48,21.5,48,48C336,225.2,335.5,226.3,335.4,227.5z"
        ],
        "viruses": [
            640,
            512,
            [],
            "e076",
            "M624,352H611.88c-28.51,0-42.79-34.47-22.63-54.63l8.58-8.57a16,16,0,1,0-22.63-22.63l-8.57,8.58C546.47,294.91,512,280.63,512,252.12V240a16,16,0,0,0-32,0v12.12c0,28.51-34.47,42.79-54.63,22.63l-8.57-8.58a16,16,0,0,0-22.63,22.63l8.58,8.57c20.16,20.16,5.88,54.63-22.63,54.63H368a16,16,0,0,0,0,32h12.12c28.51,0,42.79,34.47,22.63,54.63l-8.58,8.57a16,16,0,1,0,22.63,22.63l8.57-8.58c20.16-20.16,54.63-5.88,54.63,22.63V496a16,16,0,0,0,32,0V483.88c0-28.51,34.47-42.79,54.63-22.63l8.57,8.58a16,16,0,1,0,22.63-22.63l-8.58-8.57C569.09,418.47,583.37,384,611.88,384H624a16,16,0,0,0,0-32ZM480,384a32,32,0,1,1,32-32A32,32,0,0,1,480,384ZM346.51,213.33h16.16a21.33,21.33,0,0,0,0-42.66H346.51c-38,0-57.05-46-30.17-72.84l11.43-11.44A21.33,21.33,0,0,0,297.6,56.23L286.17,67.66c-26.88,26.88-72.84,7.85-72.84-30.17V21.33a21.33,21.33,0,0,0-42.66,0V37.49c0,38-46,57.05-72.84,30.17L86.4,56.23A21.33,21.33,0,0,0,56.23,86.39L67.66,97.83c26.88,26.88,7.85,72.84-30.17,72.84H21.33a21.33,21.33,0,0,0,0,42.66H37.49c38,0,57.05,46,30.17,72.84L56.23,297.6A21.33,21.33,0,1,0,86.4,327.77l11.43-11.43c26.88-26.88,72.84-7.85,72.84,30.17v16.16a21.33,21.33,0,0,0,42.66,0V346.51c0-38,46-57.05,72.84-30.17l11.43,11.43a21.33,21.33,0,0,0,30.17-30.17l-11.43-11.43C289.46,259.29,308.49,213.33,346.51,213.33ZM160,192a32,32,0,1,1,32-32A32,32,0,0,1,160,192Zm80,32a16,16,0,1,1,16-16A16,16,0,0,1,240,224Z"
        ],
        "voicemail": [
            640,
            512,
            [],
            "f897",
            "M496 128a144 144 0 0 0-119.74 224H263.74A144 144 0 1 0 144 416h352a144 144 0 0 0 0-288zM64 272a80 80 0 1 1 80 80 80 80 0 0 1-80-80zm432 80a80 80 0 1 1 80-80 80 80 0 0 1-80 80z"
        ],
        "volleyball-ball": [
            512,
            512,
            [],
            "f45f",
            "M231.39 243.48a285.56 285.56 0 0 0-22.7-105.7c-90.8 42.4-157.5 122.4-180.3 216.8a249 249 0 0 0 56.9 81.1 333.87 333.87 0 0 1 146.1-192.2zm-36.9-134.4a284.23 284.23 0 0 0-57.4-70.7c-91 49.8-144.8 152.9-125 262.2 33.4-83.1 98.4-152 182.4-191.5zm187.6 165.1c8.6-99.8-27.3-197.5-97.5-264.4-14.7-1.7-51.6-5.5-98.9 8.5A333.87 333.87 0 0 1 279.19 241a285 285 0 0 0 102.9 33.18zm-124.7 9.5a286.33 286.33 0 0 0-80.2 72.6c82 57.3 184.5 75.1 277.5 47.8a247.15 247.15 0 0 0 42.2-89.9 336.1 336.1 0 0 1-80.9 10.4c-54.6-.1-108.9-14.1-158.6-40.9zm-98.3 99.7c-15.2 26-25.7 54.4-32.1 84.2a247.07 247.07 0 0 0 289-22.1c-112.9 16.1-203.3-24.8-256.9-62.1zm180.3-360.6c55.3 70.4 82.5 161.2 74.6 253.6a286.59 286.59 0 0 0 89.7-14.2c0-2 .3-4 .3-6 0-107.8-68.7-199.1-164.6-233.4z"
        ],
        "volume-down": [
            384,
            512,
            [],
            "f027",
            "M215.03 72.04L126.06 161H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V89.02c0-21.47-25.96-31.98-40.97-16.98zm123.2 108.08c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 229.28 336 242.62 336 257c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.87z"
        ],
        "volume-mute": [
            512,
            512,
            [],
            "f6a9",
            "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zM461.64 256l45.64-45.64c6.3-6.3 6.3-16.52 0-22.82l-22.82-22.82c-6.3-6.3-16.52-6.3-22.82 0L416 210.36l-45.64-45.64c-6.3-6.3-16.52-6.3-22.82 0l-22.82 22.82c-6.3 6.3-6.3 16.52 0 22.82L370.36 256l-45.63 45.63c-6.3 6.3-6.3 16.52 0 22.82l22.82 22.82c6.3 6.3 16.52 6.3 22.82 0L416 301.64l45.64 45.64c6.3 6.3 16.52 6.3 22.82 0l22.82-22.82c6.3-6.3 6.3-16.52 0-22.82L461.64 256z"
        ],
        "volume-off": [
            256,
            512,
            [],
            "f026",
            "M215 71l-89 89H24a24 24 0 0 0-24 24v144a24 24 0 0 0 24 24h102.06L215 441c15 15 41 4.47 41-17V88c0-21.47-26-32-41-17z"
        ],
        "volume-up": [
            576,
            512,
            [],
            "f028",
            "M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zm233.32-51.08c-11.17-7.33-26.18-4.24-33.51 6.95-7.34 11.17-4.22 26.18 6.95 33.51 66.27 43.49 105.82 116.6 105.82 195.58 0 78.98-39.55 152.09-105.82 195.58-11.17 7.32-14.29 22.34-6.95 33.5 7.04 10.71 21.93 14.56 33.51 6.95C528.27 439.58 576 351.33 576 256S528.27 72.43 448.35 19.97zM480 256c0-63.53-32.06-121.94-85.77-156.24-11.19-7.14-26.03-3.82-33.12 7.46s-3.78 26.21 7.41 33.36C408.27 165.97 432 209.11 432 256s-23.73 90.03-63.48 115.42c-11.19 7.14-14.5 22.07-7.41 33.36 6.51 10.36 21.12 15.14 33.12 7.46C447.94 377.94 480 319.54 480 256zm-141.77-76.87c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 228.28 336 241.63 336 256c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.86z"
        ],
        "vote-yea": [
            640,
            512,
            [],
            "f772",
            "M608 320h-64v64h22.4c5.3 0 9.6 3.6 9.6 8v16c0 4.4-4.3 8-9.6 8H73.6c-5.3 0-9.6-3.6-9.6-8v-16c0-4.4 4.3-8 9.6-8H96v-64H32c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32h576c17.7 0 32-14.3 32-32v-96c0-17.7-14.3-32-32-32zm-96 64V64.3c0-17.9-14.5-32.3-32.3-32.3H160.4C142.5 32 128 46.5 128 64.3V384h384zM211.2 202l25.5-25.3c4.2-4.2 11-4.2 15.2.1l41.3 41.6 95.2-94.4c4.2-4.2 11-4.2 15.2.1l25.3 25.5c4.2 4.2 4.2 11-.1 15.2L300.5 292c-4.2 4.2-11 4.2-15.2-.1l-74.1-74.7c-4.3-4.2-4.2-11 0-15.2z"
        ],
        "vr-cardboard": [
            640,
            512,
            [],
            "f729",
            "M608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h160.22c25.19 0 48.03-14.77 58.36-37.74l27.74-61.64C286.21 331.08 302.35 320 320 320s33.79 11.08 41.68 28.62l27.74 61.64C399.75 433.23 422.6 448 447.78 448H608c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zM160 304c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64zm320 0c-35.35 0-64-28.65-64-64s28.65-64 64-64 64 28.65 64 64-28.65 64-64 64z"
        ],
        "walking": [
            320,
            512,
            [],
            "f554",
            "M208 96c26.5 0 48-21.5 48-48S234.5 0 208 0s-48 21.5-48 48 21.5 48 48 48zm94.5 149.1l-23.3-11.8-9.7-29.4c-14.7-44.6-55.7-75.8-102.2-75.9-36-.1-55.9 10.1-93.3 25.2-21.6 8.7-39.3 25.2-49.7 46.2L17.6 213c-7.8 15.8-1.5 35 14.2 42.9 15.6 7.9 34.6 1.5 42.5-14.3L81 228c3.5-7 9.3-12.5 16.5-15.4l26.8-10.8-15.2 60.7c-5.2 20.8.4 42.9 14.9 58.8l59.9 65.4c7.2 7.9 12.3 17.4 14.9 27.7l18.3 73.3c4.3 17.1 21.7 27.6 38.8 23.3 17.1-4.3 27.6-21.7 23.3-38.8l-22.2-89c-2.6-10.3-7.7-19.9-14.9-27.7l-45.5-49.7 17.2-68.7 5.5 16.5c5.3 16.1 16.7 29.4 31.7 37l23.3 11.8c15.6 7.9 34.6 1.5 42.5-14.3 7.7-15.7 1.4-35.1-14.3-43zM73.6 385.8c-3.2 8.1-8 15.4-14.2 21.5l-50 50.1c-12.5 12.5-12.5 32.8 0 45.3s32.7 12.5 45.2 0l59.4-59.4c6.1-6.1 10.9-13.4 14.2-21.5l13.5-33.8c-55.3-60.3-38.7-41.8-47.4-53.7l-20.7 51.5z"
        ],
        "wallet": [
            512,
            512,
            [],
            "f555",
            "M461.2 128H80c-8.84 0-16-7.16-16-16s7.16-16 16-16h384c8.84 0 16-7.16 16-16 0-26.51-21.49-48-48-48H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h397.2c28.02 0 50.8-21.53 50.8-48V176c0-26.47-22.78-48-50.8-48zM416 336c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32z"
        ],
        "warehouse": [
            640,
            512,
            [],
            "f494",
            "M504 352H136.4c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 96H136.1c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0-192H136.6c-4.4 0-8 3.6-8 8l-.1 48c0 4.4 3.6 8 8 8H504c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm106.5-139L338.4 3.7a48.15 48.15 0 0 0-36.9 0L29.5 117C11.7 124.5 0 141.9 0 161.3V504c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V256c0-17.6 14.6-32 32.6-32h382.8c18 0 32.6 14.4 32.6 32v248c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8V161.3c0-19.4-11.7-36.8-29.5-44.3z"
        ],
        "water": [
            576,
            512,
            [],
            "f773",
            "M562.1 383.9c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144c-21.5-2.4-42.1-10.5-57.9-22.9-14.1-11.1-34.2-11.3-48.2 0-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3zm0-144C540.6 93.4 520 85.4 504.2 73 490.1 61.9 470 61.7 456 73c-37.9 30.4-107.2 30.4-145.7-1.5-13.5-11.2-33-9.1-46.7 1.8-38 30.1-106.9 30-145.2-1.7-13.5-11.2-33.3-8.9-47.1 2-15.5 12.2-36 20.1-57.7 22.4-7.9.8-13.6 7.8-13.6 15.7v32.2c0 9.1 7.6 16.8 16.7 16 28.8-2.5 56.1-11.4 79.4-25.9 56.5 34.6 137 34.1 192 0 56.5 34.6 137 34.1 192 0 23.3 14.2 50.9 23.3 79.1 25.8 9.1.8 16.7-6.9 16.7-16v-31.6c.1-8-5.7-15.4-13.8-16.3z"
        ],
        "wave-square": [
            640,
            512,
            [],
            "f83e",
            "M476 480H324a36 36 0 0 1-36-36V96h-96v156a36 36 0 0 1-36 36H16a16 16 0 0 1-16-16v-32a16 16 0 0 1 16-16h112V68a36 36 0 0 1 36-36h152a36 36 0 0 1 36 36v348h96V260a36 36 0 0 1 36-36h140a16 16 0 0 1 16 16v32a16 16 0 0 1-16 16H512v156a36 36 0 0 1-36 36z"
        ],
        "weight": [
            512,
            512,
            [],
            "f496",
            "M448 64h-25.98C438.44 92.28 448 125.01 448 160c0 105.87-86.13 192-192 192S64 265.87 64 160c0-34.99 9.56-67.72 25.98-96H64C28.71 64 0 92.71 0 128v320c0 35.29 28.71 64 64 64h384c35.29 0 64-28.71 64-64V128c0-35.29-28.71-64-64-64zM256 320c88.37 0 160-71.63 160-160S344.37 0 256 0 96 71.63 96 160s71.63 160 160 160zm-.3-151.94l33.58-78.36c3.5-8.17 12.94-11.92 21.03-8.41 8.12 3.48 11.88 12.89 8.41 21l-33.67 78.55C291.73 188 296 197.45 296 208c0 22.09-17.91 40-40 40s-40-17.91-40-40c0-21.98 17.76-39.77 39.7-39.94z"
        ],
        "weight-hanging": [
            512,
            512,
            [],
            "f5cd",
            "M510.28 445.86l-73.03-292.13c-3.8-15.19-16.44-25.72-30.87-25.72h-60.25c3.57-10.05 5.88-20.72 5.88-32 0-53.02-42.98-96-96-96s-96 42.98-96 96c0 11.28 2.3 21.95 5.88 32h-60.25c-14.43 0-27.08 10.54-30.87 25.72L1.72 445.86C-6.61 479.17 16.38 512 48.03 512h415.95c31.64 0 54.63-32.83 46.3-66.14zM256 128c-17.64 0-32-14.36-32-32s14.36-32 32-32 32 14.36 32 32-14.36 32-32 32z"
        ],
        "wheelchair": [
            512,
            512,
            [],
            "f193",
            "M496.101 385.669l14.227 28.663c3.929 7.915.697 17.516-7.218 21.445l-65.465 32.886c-16.049 7.967-35.556 1.194-43.189-15.055L331.679 320H192c-15.925 0-29.426-11.71-31.679-27.475C126.433 55.308 128.38 70.044 128 64c0-36.358 30.318-65.635 67.052-63.929 33.271 1.545 60.048 28.905 60.925 62.201.868 32.933-23.152 60.423-54.608 65.039l4.67 32.69H336c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H215.182l4.572 32H352a32 32 0 0 1 28.962 18.392L438.477 396.8l36.178-18.349c7.915-3.929 17.517-.697 21.446 7.218zM311.358 352h-24.506c-7.788 54.204-54.528 96-110.852 96-61.757 0-112-50.243-112-112 0-41.505 22.694-77.809 56.324-97.156-3.712-25.965-6.844-47.86-9.488-66.333C45.956 198.464 0 261.963 0 336c0 97.047 78.953 176 176 176 71.87 0 133.806-43.308 161.11-105.192L311.358 352z"
        ],
        "wifi": [
            640,
            512,
            [],
            "f1eb",
            "M634.91 154.88C457.74-8.99 182.19-8.93 5.09 154.88c-6.66 6.16-6.79 16.59-.35 22.98l34.24 33.97c6.14 6.1 16.02 6.23 22.4.38 145.92-133.68 371.3-133.71 517.25 0 6.38 5.85 16.26 5.71 22.4-.38l34.24-33.97c6.43-6.39 6.3-16.82-.36-22.98zM320 352c-35.35 0-64 28.65-64 64s28.65 64 64 64 64-28.65 64-64-28.65-64-64-64zm202.67-83.59c-115.26-101.93-290.21-101.82-405.34 0-6.9 6.1-7.12 16.69-.57 23.15l34.44 33.99c6 5.92 15.66 6.32 22.05.8 83.95-72.57 209.74-72.41 293.49 0 6.39 5.52 16.05 5.13 22.05-.8l34.44-33.99c6.56-6.46 6.33-17.06-.56-23.15z"
        ],
        "wind": [
            512,
            512,
            [],
            "f72e",
            "M156.7 256H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h142.2c15.9 0 30.8 10.9 33.4 26.6 3.3 20-12.1 37.4-31.6 37.4-14.1 0-26.1-9.2-30.4-21.9-2.1-6.3-8.6-10.1-15.2-10.1H81.6c-9.8 0-17.7 8.8-15.9 18.4 8.6 44.1 47.6 77.6 94.2 77.6 57.1 0 102.7-50.1 95.2-108.6C249 291 205.4 256 156.7 256zM16 224h336c59.7 0 106.8-54.8 93.8-116.7-7.6-36.2-36.9-65.5-73.1-73.1-55.4-11.6-105.1 24.9-114.9 75.5-1.9 9.6 6.1 18.3 15.8 18.3h32.8c6.7 0 13.1-3.8 15.2-10.1C325.9 105.2 337.9 96 352 96c19.4 0 34.9 17.4 31.6 37.4-2.6 15.7-17.4 26.6-33.4 26.6H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16zm384 32H243.7c19.3 16.6 33.2 38.8 39.8 64H400c26.5 0 48 21.5 48 48s-21.5 48-48 48c-17.9 0-33.3-9.9-41.6-24.4-2.9-5-8.7-7.6-14.5-7.6h-33.8c-10.9 0-19 10.8-15.3 21.1 17.8 50.6 70.5 84.8 129.4 72.3 41.2-8.7 75.1-41.6 84.7-82.7C526 321.5 470.5 256 400 256z"
        ],
        "window-close": [
            512,
            512,
            [],
            "f410",
            "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-83.6 290.5c4.8 4.8 4.8 12.6 0 17.4l-40.5 40.5c-4.8 4.8-12.6 4.8-17.4 0L256 313.3l-66.5 67.1c-4.8 4.8-12.6 4.8-17.4 0l-40.5-40.5c-4.8-4.8-4.8-12.6 0-17.4l67.1-66.5-67.1-66.5c-4.8-4.8-4.8-12.6 0-17.4l40.5-40.5c4.8-4.8 12.6-4.8 17.4 0l66.5 67.1 66.5-67.1c4.8-4.8 12.6-4.8 17.4 0l40.5 40.5c4.8 4.8 4.8 12.6 0 17.4L313.3 256l67.1 66.5z"
        ],
        "window-maximize": [
            512,
            512,
            [],
            "f2d0",
            "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-16 160H64v-84c0-6.6 5.4-12 12-12h360c6.6 0 12 5.4 12 12v84z"
        ],
        "window-minimize": [
            512,
            512,
            [],
            "f2d1",
            "M464 352H48c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48z"
        ],
        "window-restore": [
            512,
            512,
            [],
            "f2d2",
            "M512 48v288c0 26.5-21.5 48-48 48h-48V176c0-44.1-35.9-80-80-80H128V48c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zM384 176v288c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V176c0-26.5 21.5-48 48-48h288c26.5 0 48 21.5 48 48zm-68 28c0-6.6-5.4-12-12-12H76c-6.6 0-12 5.4-12 12v52h252v-52z"
        ],
        "wine-bottle": [
            512,
            512,
            [],
            "f72f",
            "M507.31 72.57L439.43 4.69c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l-76.67 76.67c-46.58-19.7-102.4-10.73-140.37 27.23L18.75 312.23c-24.99 24.99-24.99 65.52 0 90.51l90.51 90.51c24.99 24.99 65.52 24.99 90.51 0l158.39-158.39c37.96-37.96 46.93-93.79 27.23-140.37l76.67-76.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.24-6.24 6.24-16.37-.01-22.62zM179.22 423.29l-90.51-90.51 122.04-122.04 90.51 90.51-122.04 122.04z"
        ],
        "wine-glass": [
            288,
            512,
            [],
            "f4e3",
            "M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40z"
        ],
        "wine-glass-alt": [
            288,
            512,
            [],
            "f5ce",
            "M216 464h-40V346.81c68.47-15.89 118.05-79.91 111.4-154.16l-15.95-178.1C270.71 6.31 263.9 0 255.74 0H32.26c-8.15 0-14.97 6.31-15.7 14.55L.6 192.66C-6.05 266.91 43.53 330.93 112 346.82V464H72c-22.09 0-40 17.91-40 40 0 4.42 3.58 8 8 8h208c4.42 0 8-3.58 8-8 0-22.09-17.91-40-40-40zM61.75 48h164.5l7.17 80H54.58l7.17-80z"
        ],
        "won-sign": [
            576,
            512,
            [],
            "f159",
            "M564 192c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-48l18.6-80.6c1.7-7.5-4-14.7-11.7-14.7h-46.1c-5.7 0-10.6 4-11.7 9.5L450.7 128H340.8l-19.7-86c-1.3-5.5-6.1-9.3-11.7-9.3h-44c-5.6 0-10.4 3.8-11.7 9.3l-20 86H125l-17.5-85.7c-1.1-5.6-6.1-9.6-11.8-9.6H53.6c-7.7 0-13.4 7.1-11.7 14.6L60 128H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h62.3l7.2 32H12c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h83.9l40.9 182.6c1.2 5.5 6.1 9.4 11.7 9.4h56.8c5.6 0 10.4-3.9 11.7-9.3L259.3 288h55.1l42.4 182.7c1.3 5.4 6.1 9.3 11.7 9.3h56.8c5.6 0 10.4-3.9 11.7-9.3L479.1 288H564c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-70.1l7.4-32zM183.8 342c-6.2 25.8-6.8 47.2-7.3 47.2h-1.1s-1.7-22-6.8-47.2l-11-54h38.8zm27.5-118h-66.8l-6.5-32h80.8zm62.9 0l2-8.6c1.9-8 3.5-16 4.8-23.4h11.8c1.3 7.4 2.9 15.4 4.8 23.4l2 8.6zm130.9 118c-5.1 25.2-6.8 47.2-6.8 47.2h-1.1c-.6 0-1.1-21.4-7.3-47.2l-12.4-54h39.1zm25.2-118h-67.4l-7.3-32h81.6z"
        ],
        "wrench": [
            512,
            512,
            [],
            "f0ad",
            "M507.73 109.1c-2.24-9.03-13.54-12.09-20.12-5.51l-74.36 74.36-67.88-11.31-11.31-67.88 74.36-74.36c6.62-6.62 3.43-17.9-5.66-20.16-47.38-11.74-99.55.91-136.58 37.93-39.64 39.64-50.55 97.1-34.05 147.2L18.74 402.76c-24.99 24.99-24.99 65.51 0 90.5 24.99 24.99 65.51 24.99 90.5 0l213.21-213.21c50.12 16.71 107.47 5.68 147.37-34.22 37.07-37.07 49.7-89.32 37.91-136.73zM64 472c-13.25 0-24-10.75-24-24 0-13.26 10.75-24 24-24s24 10.74 24 24c0 13.25-10.75 24-24 24z"
        ],
        "x-ray": [
            640,
            512,
            [],
            "f497",
            "M240 384c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm160 32c8.8 0 16-7.2 16-16s-7.2-16-16-16-16 7.2-16 16 7.2 16 16 16zM624 0H16C7.2 0 0 7.2 0 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16V16c0-8.8-7.2-16-16-16zm0 448h-48V96H64v352H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h608c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM480 248c0 4.4-3.6 8-8 8H336v32h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h64c26.5 0 48 21.5 48 48s-21.5 48-48 48-48-21.5-48-48v-16h-64v16c0 26.5-21.5 48-48 48s-48-21.5-48-48 21.5-48 48-48h64v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-32H168c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h136v-32H200c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h104v-24c0-4.4 3.6-8 8-8h16c4.4 0 8 3.6 8 8v24h104c4.4 0 8 3.6 8 8v16c0 4.4-3.6 8-8 8H336v32h136c4.4 0 8 3.6 8 8v16z"
        ],
        "yen-sign": [
            384,
            512,
            [],
            "f157",
            "M351.2 32h-65.3c-4.6 0-8.8 2.6-10.8 6.7l-55.4 113.2c-14.5 34.7-27.1 71.9-27.1 71.9h-1.3s-12.6-37.2-27.1-71.9L108.8 38.7c-2-4.1-6.2-6.7-10.8-6.7H32.8c-9.1 0-14.8 9.7-10.6 17.6L102.3 200H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h88.2l19.8 37.2V320H44c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h108v92c0 6.6 5.4 12 12 12h56c6.6 0 12-5.4 12-12v-92h108c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12H232v-26.8l19.8-37.2H340c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12h-58.3l80.1-150.4c4.3-7.9-1.5-17.6-10.6-17.6z"
        ],
        "yin-yang": [
            496,
            512,
            [],
            "f6ad",
            "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 376c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32-14.33 32-32 32zm0-128c-53.02 0-96 42.98-96 96s42.98 96 96 96c-106.04 0-192-85.96-192-192S141.96 64 248 64c53.02 0 96 42.98 96 96s-42.98 96-96 96zm0-128c-17.67 0-32 14.33-32 32s14.33 32 32 32 32-14.33 32-32-14.33-32-32-32z"
        ]
    };
    bunker(function() {
        defineIcons("fas", icons);
    });
})();


/*!
 * Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */ (function() {
    "use strict";
    var _WINDOW = {};
    var _DOCUMENT = {};
    try {
        if (typeof window !== "undefined") _WINDOW = window;
        if (typeof document !== "undefined") _DOCUMENT = document;
    } catch (e) {}
    var _ref = _WINDOW.navigator || {}, _ref$userAgent = _ref.userAgent, userAgent = _ref$userAgent === void 0 ? "" : _ref$userAgent;
    var WINDOW = _WINDOW;
    var DOCUMENT = _DOCUMENT;
    var IS_BROWSER = !!WINDOW.document;
    var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === "function" && typeof DOCUMENT.createElement === "function";
    var IS_IE = ~userAgent.indexOf("MSIE") || ~userAgent.indexOf("Trident/");
    var NAMESPACE_IDENTIFIER = "___FONT_AWESOME___";
    var PRODUCTION = function() {
        try {
            return true;
        } catch (e) {
            return false;
        }
    }();
    function bunker(fn) {
        try {
            fn();
        } catch (e) {
            if (!PRODUCTION) throw e;
        }
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _objectSpread(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            var ownKeys = Object.keys(source);
            if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
            ownKeys.forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
        }
        return target;
    }
    var w = WINDOW || {};
    if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
    if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
    if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
    if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
    var namespace = w[NAMESPACE_IDENTIFIER];
    function defineIcons(prefix, icons) {
        var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var _params$skipHooks = params.skipHooks, skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
        var normalized = Object.keys(icons).reduce(function(acc, iconName) {
            var icon = icons[iconName];
            var expanded = !!icon.icon;
            if (expanded) acc[icon.iconName] = icon.icon;
            else acc[iconName] = icon;
            return acc;
        }, {});
        if (typeof namespace.hooks.addPack === "function" && !skipHooks) namespace.hooks.addPack(prefix, normalized);
        else namespace.styles[prefix] = _objectSpread({}, namespace.styles[prefix] || {}, normalized);
        /**
     * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
     * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
     * for `fas` so we'll easy the upgrade process for our users by automatically defining
     * this as well.
     */ if (prefix === "fas") defineIcons("fa", icons);
    }
    var icons = {
        "address-book": [
            448,
            512,
            [],
            "f2b9",
            "M436 160c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20V48c0-26.5-21.5-48-48-48H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-20v-64h20zm-68 304H48V48h320v416zM208 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2z"
        ],
        "address-card": [
            576,
            512,
            [],
            "f2bb",
            "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 400H48V80h480v352zM208 256c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2zM360 320h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8z"
        ],
        "angry": [
            496,
            512,
            [],
            "f556",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm0-144c-33.6 0-65.2 14.8-86.8 40.6-8.5 10.2-7.1 25.3 3.1 33.8s25.3 7.2 33.8-3c24.8-29.7 75-29.7 99.8 0 8.1 9.7 23.2 11.9 33.8 3 10.2-8.5 11.5-23.6 3.1-33.8-21.6-25.8-53.2-40.6-86.8-40.6zm-48-72c10.3 0 19.9-6.7 23-17.1 3.8-12.7-3.4-26.1-16.1-29.9l-80-24c-12.8-3.9-26.1 3.4-29.9 16.1-3.8 12.7 3.4 26.1 16.1 29.9l28.2 8.5c-3.1 4.9-5.3 10.4-5.3 16.6 0 17.7 14.3 32 32 32s32-14.4 32-32.1zm199-54.9c-3.8-12.7-17.1-19.9-29.9-16.1l-80 24c-12.7 3.8-19.9 17.2-16.1 29.9 3.1 10.4 12.7 17.1 23 17.1 0 17.7 14.3 32 32 32s32-14.3 32-32c0-6.2-2.2-11.7-5.3-16.6l28.2-8.5c12.7-3.7 19.9-17.1 16.1-29.8z"
        ],
        "arrow-alt-circle-down": [
            512,
            512,
            [],
            "f358",
            "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm-32-316v116h-67c-10.7 0-16 12.9-8.5 20.5l99 99c4.7 4.7 12.3 4.7 17 0l99-99c7.6-7.6 2.2-20.5-8.5-20.5h-67V140c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12z"
        ],
        "arrow-alt-circle-left": [
            512,
            512,
            [],
            "f359",
            "M8 256c0 137 111 248 248 248s248-111 248-248S393 8 256 8 8 119 8 256zm448 0c0 110.5-89.5 200-200 200S56 366.5 56 256 145.5 56 256 56s200 89.5 200 200zm-72-20v40c0 6.6-5.4 12-12 12H256v67c0 10.7-12.9 16-20.5 8.5l-99-99c-4.7-4.7-4.7-12.3 0-17l99-99c7.6-7.6 20.5-2.2 20.5 8.5v67h116c6.6 0 12 5.4 12 12z"
        ],
        "arrow-alt-circle-right": [
            512,
            512,
            [],
            "f35a",
            "M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256zm72 20v-40c0-6.6 5.4-12 12-12h116v-67c0-10.7 12.9-16 20.5-8.5l99 99c4.7 4.7 4.7 12.3 0 17l-99 99c-7.6 7.6-20.5 2.2-20.5-8.5v-67H140c-6.6 0-12-5.4-12-12z"
        ],
        "arrow-alt-circle-up": [
            512,
            512,
            [],
            "f35b",
            "M256 504c137 0 248-111 248-248S393 8 256 8 8 119 8 256s111 248 248 248zm0-448c110.5 0 200 89.5 200 200s-89.5 200-200 200S56 366.5 56 256 145.5 56 256 56zm20 328h-40c-6.6 0-12-5.4-12-12V256h-67c-10.7 0-16-12.9-8.5-20.5l99-99c4.7-4.7 12.3-4.7 17 0l99 99c7.6 7.6 2.2 20.5-8.5 20.5h-67v116c0 6.6-5.4 12-12 12z"
        ],
        "bell": [
            448,
            512,
            [],
            "f0f3",
            "M439.39 362.29c-19.32-20.76-55.47-51.99-55.47-154.29 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84C118.56 68.1 64.08 130.3 64.08 208c0 102.3-36.15 133.53-55.47 154.29-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h383.8c19.12 0 32-15.6 32.1-32 .05-7.55-2.61-15.27-8.61-21.71zM67.53 368c21.22-27.97 44.42-74.33 44.53-159.42 0-.2-.06-.38-.06-.58 0-61.86 50.14-112 112-112s112 50.14 112 112c0 .2-.06.38-.06.58.11 85.1 23.31 131.46 44.53 159.42H67.53zM224 512c35.32 0 63.97-28.65 63.97-64H160.03c0 35.35 28.65 64 63.97 64z"
        ],
        "bell-slash": [
            640,
            512,
            [],
            "f1f6",
            "M633.99 471.02L36 3.51C29.1-2.01 19.03-.9 13.51 6l-10 12.49C-2.02 25.39-.9 35.46 6 40.98l598 467.51c6.9 5.52 16.96 4.4 22.49-2.49l10-12.49c5.52-6.9 4.41-16.97-2.5-22.49zM163.53 368c16.71-22.03 34.48-55.8 41.4-110.58l-45.47-35.55c-3.27 90.73-36.47 120.68-54.84 140.42-6 6.45-8.66 14.16-8.61 21.71.11 16.4 12.98 32 32.1 32h279.66l-61.4-48H163.53zM320 96c61.86 0 112 50.14 112 112 0 .2-.06.38-.06.58.02 16.84 1.16 31.77 2.79 45.73l59.53 46.54c-8.31-22.13-14.34-51.49-14.34-92.85 0-77.7-54.48-139.9-127.94-155.16V32c0-17.67-14.32-32-31.98-32s-31.98 14.33-31.98 32v20.84c-26.02 5.41-49.45 16.94-69.13 32.72l38.17 29.84C275 103.18 296.65 96 320 96zm0 416c35.32 0 63.97-28.65 63.97-64H256.03c0 35.35 28.65 64 63.97 64z"
        ],
        "bookmark": [
            384,
            512,
            [],
            "f02e",
            "M336 0H48C21.49 0 0 21.49 0 48v464l192-112 192 112V48c0-26.51-21.49-48-48-48zm0 428.43l-144-84-144 84V54a6 6 0 0 1 6-6h276c3.314 0 6 2.683 6 5.996V428.43z"
        ],
        "building": [
            448,
            512,
            [],
            "f1ad",
            "M128 148v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12h-40c-6.6 0-12-5.4-12-12zm140 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm-128 96h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm128 0h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm-76 84v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm76 12h40c6.6 0 12-5.4 12-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12zm180 124v36H0v-36c0-6.6 5.4-12 12-12h19.5V24c0-13.3 10.7-24 24-24h337c13.3 0 24 10.7 24 24v440H436c6.6 0 12 5.4 12 12zM79.5 463H192v-67c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v67h112.5V49L80 48l-.5 415z"
        ],
        "calendar": [
            448,
            512,
            [],
            "f133",
            "M400 64h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V160h352v298c0 3.3-2.7 6-6 6z"
        ],
        "calendar-alt": [
            448,
            512,
            [],
            "f073",
            "M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
        ],
        "calendar-check": [
            448,
            512,
            [],
            "f274",
            "M400 64h-48V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v52H160V12c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v52H48C21.49 64 0 85.49 0 112v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 400H54a6 6 0 0 1-6-6V160h352v298a6 6 0 0 1-6 6zm-52.849-200.65L198.842 404.519c-4.705 4.667-12.303 4.637-16.971-.068l-75.091-75.699c-4.667-4.705-4.637-12.303.068-16.971l22.719-22.536c4.705-4.667 12.303-4.637 16.97.069l44.104 44.461 111.072-110.181c4.705-4.667 12.303-4.637 16.971.068l22.536 22.718c4.667 4.705 4.636 12.303-.069 16.97z"
        ],
        "calendar-minus": [
            448,
            512,
            [],
            "f272",
            "M124 328c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h200c6.6 0 12 5.4 12 12v24c0 6.6-5.4 12-12 12H124zm324-216v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
        ],
        "calendar-plus": [
            448,
            512,
            [],
            "f271",
            "M336 292v24c0 6.6-5.4 12-12 12h-76v76c0 6.6-5.4 12-12 12h-24c-6.6 0-12-5.4-12-12v-76h-76c-6.6 0-12-5.4-12-12v-24c0-6.6 5.4-12 12-12h76v-76c0-6.6 5.4-12 12-12h24c6.6 0 12 5.4 12 12v76h76c6.6 0 12 5.4 12 12zm112-180v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
        ],
        "calendar-times": [
            448,
            512,
            [],
            "f273",
            "M311.7 374.7l-17 17c-4.7 4.7-12.3 4.7-17 0L224 337.9l-53.7 53.7c-4.7 4.7-12.3 4.7-17 0l-17-17c-4.7-4.7-4.7-12.3 0-17l53.7-53.7-53.7-53.7c-4.7-4.7-4.7-12.3 0-17l17-17c4.7-4.7 12.3-4.7 17 0l53.7 53.7 53.7-53.7c4.7-4.7 12.3-4.7 17 0l17 17c4.7 4.7 4.7 12.3 0 17L257.9 304l53.7 53.7c4.8 4.7 4.8 12.3.1 17zM448 112v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
        ],
        "caret-square-down": [
            448,
            512,
            [],
            "f150",
            "M125.1 208h197.8c10.7 0 16.1 13 8.5 20.5l-98.9 98.3c-4.7 4.7-12.2 4.7-16.9 0l-98.9-98.3c-7.7-7.5-2.3-20.5 8.4-20.5zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
        ],
        "caret-square-left": [
            448,
            512,
            [],
            "f191",
            "M272 157.1v197.8c0 10.7-13 16.1-20.5 8.5l-98.3-98.9c-4.7-4.7-4.7-12.2 0-16.9l98.3-98.9c7.5-7.7 20.5-2.3 20.5 8.4zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
        ],
        "caret-square-right": [
            448,
            512,
            [],
            "f152",
            "M176 354.9V157.1c0-10.7 13-16.1 20.5-8.5l98.3 98.9c4.7 4.7 4.7 12.2 0 16.9l-98.3 98.9c-7.5 7.7-20.5 2.3-20.5-8.4zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
        ],
        "caret-square-up": [
            448,
            512,
            [],
            "f151",
            "M322.9 304H125.1c-10.7 0-16.1-13-8.5-20.5l98.9-98.3c4.7-4.7 12.2-4.7 16.9 0l98.9 98.3c7.7 7.5 2.3 20.5-8.4 20.5zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
        ],
        "chart-bar": [
            512,
            512,
            [],
            "f080",
            "M396.8 352h22.4c6.4 0 12.8-6.4 12.8-12.8V108.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v230.4c0 6.4 6.4 12.8 12.8 12.8zm-192 0h22.4c6.4 0 12.8-6.4 12.8-12.8V140.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v198.4c0 6.4 6.4 12.8 12.8 12.8zm96 0h22.4c6.4 0 12.8-6.4 12.8-12.8V204.8c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v134.4c0 6.4 6.4 12.8 12.8 12.8zM496 400H48V80c0-8.84-7.16-16-16-16H16C7.16 64 0 71.16 0 80v336c0 17.67 14.33 32 32 32h464c8.84 0 16-7.16 16-16v-16c0-8.84-7.16-16-16-16zm-387.2-48h22.4c6.4 0 12.8-6.4 12.8-12.8v-70.4c0-6.4-6.4-12.8-12.8-12.8h-22.4c-6.4 0-12.8 6.4-12.8 12.8v70.4c0 6.4 6.4 12.8 12.8 12.8z"
        ],
        "check-circle": [
            512,
            512,
            [],
            "f058",
            "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z"
        ],
        "check-square": [
            448,
            512,
            [],
            "f14a",
            "M400 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm0 400H48V80h352v352zm-35.864-241.724L191.547 361.48c-4.705 4.667-12.303 4.637-16.97-.068l-90.781-91.516c-4.667-4.705-4.637-12.303.069-16.971l22.719-22.536c4.705-4.667 12.303-4.637 16.97.069l59.792 60.277 141.352-140.216c4.705-4.667 12.303-4.637 16.97.068l22.536 22.718c4.667 4.706 4.637 12.304-.068 16.971z"
        ],
        "circle": [
            512,
            512,
            [],
            "f111",
            "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200z"
        ],
        "clipboard": [
            384,
            512,
            [],
            "f328",
            "M336 64h-80c0-35.3-28.7-64-64-64s-64 28.7-64 64H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zM192 40c13.3 0 24 10.7 24 24s-10.7 24-24 24-24-10.7-24-24 10.7-24 24-24zm144 418c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h42v36c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-36h42c3.3 0 6 2.7 6 6z"
        ],
        "clock": [
            512,
            512,
            [],
            "f017",
            "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm61.8-104.4l-84.9-61.7c-3.1-2.3-4.9-5.9-4.9-9.7V116c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v141.7l66.8 48.6c5.4 3.9 6.5 11.4 2.6 16.8L334.6 349c-3.9 5.3-11.4 6.5-16.8 2.6z"
        ],
        "clone": [
            512,
            512,
            [],
            "f24d",
            "M464 0H144c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h320c26.51 0 48-21.49 48-48v-48h48c26.51 0 48-21.49 48-48V48c0-26.51-21.49-48-48-48zM362 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h42v224c0 26.51 21.49 48 48 48h224v42a6 6 0 0 1-6 6zm96-96H150a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h308a6 6 0 0 1 6 6v308a6 6 0 0 1-6 6z"
        ],
        "closed-captioning": [
            512,
            512,
            [],
            "f20a",
            "M464 64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V112c0-26.5-21.5-48-48-48zm-6 336H54c-3.3 0-6-2.7-6-6V118c0-3.3 2.7-6 6-6h404c3.3 0 6 2.7 6 6v276c0 3.3-2.7 6-6 6zm-211.1-85.7c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.8-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7l-17.5 30.5c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6 2.8-2.5 7.1-2.1 9.2.9l19.6 27.7zm190.4 0c1.7 2.4 1.5 5.6-.5 7.7-53.6 56.9-172.8 32.1-172.8-67.9 0-97.3 121.7-119.5 172.5-70.1 2.1 2 2.5 3.2 1 5.7L420 220.2c-1.9 3.1-6.2 4-9.1 1.7-40.8-32-94.6-14.9-94.6 31.2 0 48 51 70.5 92.2 32.6 2.8-2.5 7.1-2.1 9.2.9l19.6 27.7z"
        ],
        "comment": [
            512,
            512,
            [],
            "f075",
            "M256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"
        ],
        "comment-alt": [
            512,
            512,
            [],
            "f27a",
            "M448 0H64C28.7 0 0 28.7 0 64v288c0 35.3 28.7 64 64 64h96v84c0 7.1 5.8 12 12 12 2.4 0 4.9-.7 7.1-2.4L304 416h144c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64zm16 352c0 8.8-7.2 16-16 16H288l-12.8 9.6L208 428v-60H64c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16h384c8.8 0 16 7.2 16 16v288z"
        ],
        "comment-dots": [
            512,
            512,
            [],
            "f4ad",
            "M144 208c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z"
        ],
        "comments": [
            576,
            512,
            [],
            "f086",
            "M532 386.2c27.5-27.1 44-61.1 44-98.2 0-80-76.5-146.1-176.2-157.9C368.3 72.5 294.3 32 208 32 93.1 32 0 103.6 0 192c0 37 16.5 71 44 98.2-15.3 30.7-37.3 54.5-37.7 54.9-6.3 6.7-8.1 16.5-4.4 25 3.6 8.5 12 14 21.2 14 53.5 0 96.7-20.2 125.2-38.8 9.2 2.1 18.7 3.7 28.4 4.9C208.1 407.6 281.8 448 368 448c20.8 0 40.8-2.4 59.8-6.8C456.3 459.7 499.4 480 553 480c9.2 0 17.5-5.5 21.2-14 3.6-8.5 1.9-18.3-4.4-25-.4-.3-22.5-24.1-37.8-54.8zm-392.8-92.3L122.1 305c-14.1 9.1-28.5 16.3-43.1 21.4 2.7-4.7 5.4-9.7 8-14.8l15.5-31.1L77.7 256C64.2 242.6 48 220.7 48 192c0-60.7 73.3-112 160-112s160 51.3 160 112-73.3 112-160 112c-16.5 0-33-1.9-49-5.6l-19.8-4.5zM498.3 352l-24.7 24.4 15.5 31.1c2.6 5.1 5.3 10.1 8 14.8-14.6-5.1-29-12.3-43.1-21.4l-17.1-11.1-19.9 4.6c-16 3.7-32.5 5.6-49 5.6-54 0-102.2-20.1-131.3-49.7C338 339.5 416 272.9 416 192c0-3.4-.4-6.7-.7-10C479.7 196.5 528 238.8 528 288c0 28.7-16.2 50.6-29.7 64z"
        ],
        "compass": [
            496,
            512,
            [],
            "f14e",
            "M347.94 129.86L203.6 195.83a31.938 31.938 0 0 0-15.77 15.77l-65.97 144.34c-7.61 16.65 9.54 33.81 26.2 26.2l144.34-65.97a31.938 31.938 0 0 0 15.77-15.77l65.97-144.34c7.61-16.66-9.54-33.81-26.2-26.2zm-77.36 148.72c-12.47 12.47-32.69 12.47-45.16 0-12.47-12.47-12.47-32.69 0-45.16 12.47-12.47 32.69-12.47 45.16 0 12.47 12.47 12.47 32.69 0 45.16zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 448c-110.28 0-200-89.72-200-200S137.72 56 248 56s200 89.72 200 200-89.72 200-200 200z"
        ],
        "copy": [
            448,
            512,
            [],
            "f0c5",
            "M433.941 65.941l-51.882-51.882A48 48 0 0 0 348.118 0H176c-26.51 0-48 21.49-48 48v48H48c-26.51 0-48 21.49-48 48v320c0 26.51 21.49 48 48 48h224c26.51 0 48-21.49 48-48v-48h80c26.51 0 48-21.49 48-48V99.882a48 48 0 0 0-14.059-33.941zM266 464H54a6 6 0 0 1-6-6V150a6 6 0 0 1 6-6h74v224c0 26.51 21.49 48 48 48h96v42a6 6 0 0 1-6 6zm128-96H182a6 6 0 0 1-6-6V54a6 6 0 0 1 6-6h106v88c0 13.255 10.745 24 24 24h88v202a6 6 0 0 1-6 6zm6-256h-64V48h9.632c1.591 0 3.117.632 4.243 1.757l48.368 48.368a6 6 0 0 1 1.757 4.243V112z"
        ],
        "copyright": [
            512,
            512,
            [],
            "f1f9",
            "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 448c-110.532 0-200-89.451-200-200 0-110.531 89.451-200 200-200 110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200zm107.351-101.064c-9.614 9.712-45.53 41.396-104.065 41.396-82.43 0-140.484-61.425-140.484-141.567 0-79.152 60.275-139.401 139.762-139.401 55.531 0 88.738 26.62 97.593 34.779a11.965 11.965 0 0 1 1.936 15.322l-18.155 28.113c-3.841 5.95-11.966 7.282-17.499 2.921-8.595-6.776-31.814-22.538-61.708-22.538-48.303 0-77.916 35.33-77.916 80.082 0 41.589 26.888 83.692 78.277 83.692 32.657 0 56.843-19.039 65.726-27.225 5.27-4.857 13.596-4.039 17.82 1.738l19.865 27.17a11.947 11.947 0 0 1-1.152 15.518z"
        ],
        "credit-card": [
            576,
            512,
            [],
            "f09d",
            "M527.9 32H48.1C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48.1 48h479.8c26.6 0 48.1-21.5 48.1-48V80c0-26.5-21.5-48-48.1-48zM54.1 80h467.8c3.3 0 6 2.7 6 6v42H48.1V86c0-3.3 2.7-6 6-6zm467.8 352H54.1c-3.3 0-6-2.7-6-6V256h479.8v170c0 3.3-2.7 6-6 6zM192 332v40c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12zm192 0v40c0 6.6-5.4 12-12 12H236c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12z"
        ],
        "dizzy": [
            496,
            512,
            [],
            "f567",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-33.8-217.9c7.8-7.8 7.8-20.5 0-28.3L196.3 192l17.9-17.9c7.8-7.8 7.8-20.5 0-28.3-7.8-7.8-20.5-7.8-28.3 0L168 163.7l-17.8-17.8c-7.8-7.8-20.5-7.8-28.3 0-7.8 7.8-7.8 20.5 0 28.3l17.9 17.9-17.9 17.9c-7.8 7.8-7.8 20.5 0 28.3 7.8 7.8 20.5 7.8 28.3 0l17.8-17.8 17.8 17.8c7.9 7.7 20.5 7.7 28.4-.2zm160-92.2c-7.8-7.8-20.5-7.8-28.3 0L328 163.7l-17.8-17.8c-7.8-7.8-20.5-7.8-28.3 0-7.8 7.8-7.8 20.5 0 28.3l17.9 17.9-17.9 17.9c-7.8 7.8-7.8 20.5 0 28.3 7.8 7.8 20.5 7.8 28.3 0l17.8-17.8 17.8 17.8c7.8 7.8 20.5 7.8 28.3 0 7.8-7.8 7.8-20.5 0-28.3l-17.8-18 17.9-17.9c7.7-7.8 7.7-20.4 0-28.2zM248 272c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64z"
        ],
        "dot-circle": [
            512,
            512,
            [],
            "f192",
            "M256 56c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m0-48C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 168c-44.183 0-80 35.817-80 80s35.817 80 80 80 80-35.817 80-80-35.817-80-80-80z"
        ],
        "edit": [
            576,
            512,
            [],
            "f044",
            "M402.3 344.9l32-32c5-5 13.7-1.5 13.7 5.7V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h273.5c7.1 0 10.7 8.6 5.7 13.7l-32 32c-1.5 1.5-3.5 2.3-5.7 2.3H48v352h352V350.5c0-2.1.8-4.1 2.3-5.6zm156.6-201.8L296.3 405.7l-90.4 10c-26.2 2.9-48.5-19.2-45.6-45.6l10-90.4L432.9 17.1c22.9-22.9 59.9-22.9 82.7 0l43.2 43.2c22.9 22.9 22.9 60 .1 82.8zM460.1 174L402 115.9 216.2 301.8l-7.3 65.3 65.3-7.3L460.1 174zm64.8-79.7l-43.2-43.2c-4.1-4.1-10.8-4.1-14.8 0L436 82l58.1 58.1 30.9-30.9c4-4.2 4-10.8-.1-14.9z"
        ],
        "envelope": [
            512,
            512,
            [],
            "f0e0",
            "M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm0 48v40.805c-22.422 18.259-58.168 46.651-134.587 106.49-16.841 13.247-50.201 45.072-73.413 44.701-23.208.375-56.579-31.459-73.413-44.701C106.18 199.465 70.425 171.067 48 152.805V112h416zM48 400V214.398c22.914 18.251 55.409 43.862 104.938 82.646 21.857 17.205 60.134 55.186 103.062 54.955 42.717.231 80.509-37.199 103.053-54.947 49.528-38.783 82.032-64.401 104.947-82.653V400H48z"
        ],
        "envelope-open": [
            512,
            512,
            [],
            "f2b6",
            "M494.586 164.516c-4.697-3.883-111.723-89.95-135.251-108.657C337.231 38.191 299.437 0 256 0c-43.205 0-80.636 37.717-103.335 55.859-24.463 19.45-131.07 105.195-135.15 108.549A48.004 48.004 0 0 0 0 201.485V464c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V201.509a48 48 0 0 0-17.414-36.993zM464 458a6 6 0 0 1-6 6H54a6 6 0 0 1-6-6V204.347c0-1.813.816-3.526 2.226-4.665 15.87-12.814 108.793-87.554 132.364-106.293C200.755 78.88 232.398 48 256 48c23.693 0 55.857 31.369 73.41 45.389 23.573 18.741 116.503 93.493 132.366 106.316a5.99 5.99 0 0 1 2.224 4.663V458zm-31.991-187.704c4.249 5.159 3.465 12.795-1.745 16.981-28.975 23.283-59.274 47.597-70.929 56.863C336.636 362.283 299.205 400 256 400c-43.452 0-81.287-38.237-103.335-55.86-11.279-8.967-41.744-33.413-70.927-56.865-5.21-4.187-5.993-11.822-1.745-16.981l15.258-18.528c4.178-5.073 11.657-5.843 16.779-1.726 28.618 23.001 58.566 47.035 70.56 56.571C200.143 320.631 232.307 352 256 352c23.602 0 55.246-30.88 73.41-45.389 11.994-9.535 41.944-33.57 70.563-56.568 5.122-4.116 12.601-3.346 16.778 1.727l15.258 18.526z"
        ],
        "eye": [
            576,
            512,
            [],
            "f06e",
            "M288 144a110.94 110.94 0 0 0-31.24 5 55.4 55.4 0 0 1 7.24 27 56 56 0 0 1-56 56 55.4 55.4 0 0 1-27-7.24A111.71 111.71 0 1 0 288 144zm284.52 97.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400c-98.65 0-189.09-55-237.93-144C98.91 167 189.34 112 288 112s189.09 55 237.93 144C477.1 345 386.66 400 288 400z"
        ],
        "eye-slash": [
            640,
            512,
            [],
            "f070",
            "M634 471L36 3.51A16 16 0 0 0 13.51 6l-10 12.49A16 16 0 0 0 6 41l598 467.49a16 16 0 0 0 22.49-2.49l10-12.49A16 16 0 0 0 634 471zM296.79 146.47l134.79 105.38C429.36 191.91 380.48 144 320 144a112.26 112.26 0 0 0-23.21 2.47zm46.42 219.07L208.42 260.16C210.65 320.09 259.53 368 320 368a113 113 0 0 0 23.21-2.46zM320 112c98.65 0 189.09 55 237.93 144a285.53 285.53 0 0 1-44 60.2l37.74 29.5a333.7 333.7 0 0 0 52.9-75.11 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64c-36.7 0-71.71 7-104.63 18.81l46.41 36.29c18.94-4.3 38.34-7.1 58.22-7.1zm0 288c-98.65 0-189.08-55-237.93-144a285.47 285.47 0 0 1 44.05-60.19l-37.74-29.5a333.6 333.6 0 0 0-52.89 75.1 32.35 32.35 0 0 0 0 29.19C89.72 376.41 197.08 448 320 448c36.7 0 71.71-7.05 104.63-18.81l-46.41-36.28C359.28 397.2 339.89 400 320 400z"
        ],
        "file": [
            384,
            512,
            [],
            "f15b",
            "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48z"
        ],
        "file-alt": [
            384,
            512,
            [],
            "f15c",
            "M288 248v28c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-28c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm-12 72H108c-6.6 0-12 5.4-12 12v28c0 6.6 5.4 12 12 12h168c6.6 0 12-5.4 12-12v-28c0-6.6-5.4-12-12-12zm108-188.1V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V48C0 21.5 21.5 0 48 0h204.1C264.8 0 277 5.1 286 14.1L369.9 98c9 8.9 14.1 21.2 14.1 33.9zm-128-80V128h76.1L256 51.9zM336 464V176H232c-13.3 0-24-10.7-24-24V48H48v416h288z"
        ],
        "file-archive": [
            384,
            512,
            [],
            "f1c6",
            "M128.3 160v32h32v-32zm64-96h-32v32h32zm-64 32v32h32V96zm64 32h-32v32h32zm177.6-30.1L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM256 51.9l76.1 76.1H256zM336 464H48V48h79.7v16h32V48H208v104c0 13.3 10.7 24 24 24h104zM194.2 265.7c-1.1-5.6-6-9.7-11.8-9.7h-22.1v-32h-32v32l-19.7 97.1C102 385.6 126.8 416 160 416c33.1 0 57.9-30.2 51.5-62.6zm-33.9 124.4c-17.9 0-32.4-12.1-32.4-27s14.5-27 32.4-27 32.4 12.1 32.4 27-14.5 27-32.4 27zm32-198.1h-32v32h32z"
        ],
        "file-audio": [
            384,
            512,
            [],
            "f1c7",
            "M369.941 97.941l-83.882-83.882A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48V131.882a48 48 0 0 0-14.059-33.941zM332.118 128H256V51.882L332.118 128zM48 464V48h160v104c0 13.255 10.745 24 24 24h104v288H48zm144-76.024c0 10.691-12.926 16.045-20.485 8.485L136 360.486h-28c-6.627 0-12-5.373-12-12v-56c0-6.627 5.373-12 12-12h28l35.515-36.947c7.56-7.56 20.485-2.206 20.485 8.485v135.952zm41.201-47.13c9.051-9.297 9.06-24.133.001-33.439-22.149-22.752 12.235-56.246 34.395-33.481 27.198 27.94 27.212 72.444.001 100.401-21.793 22.386-56.947-10.315-34.397-33.481z"
        ],
        "file-code": [
            384,
            512,
            [],
            "f1c9",
            "M149.9 349.1l-.2-.2-32.8-28.9 32.8-28.9c3.6-3.2 4-8.8.8-12.4l-.2-.2-17.4-18.6c-3.4-3.6-9-3.7-12.4-.4l-57.7 54.1c-3.7 3.5-3.7 9.4 0 12.8l57.7 54.1c1.6 1.5 3.8 2.4 6 2.4 2.4 0 4.8-1 6.4-2.8l17.4-18.6c3.3-3.5 3.1-9.1-.4-12.4zm220-251.2L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM256 51.9l76.1 76.1H256zM336 464H48V48h160v104c0 13.3 10.7 24 24 24h104zM209.6 214c-4.7-1.4-9.5 1.3-10.9 6L144 408.1c-1.4 4.7 1.3 9.6 6 10.9l24.4 7.1c4.7 1.4 9.6-1.4 10.9-6L240 231.9c1.4-4.7-1.3-9.6-6-10.9zm24.5 76.9l.2.2 32.8 28.9-32.8 28.9c-3.6 3.2-4 8.8-.8 12.4l.2.2 17.4 18.6c3.3 3.5 8.9 3.7 12.4.4l57.7-54.1c3.7-3.5 3.7-9.4 0-12.8l-57.7-54.1c-3.5-3.3-9.1-3.2-12.4.4l-17.4 18.6c-3.3 3.5-3.1 9.1.4 12.4z"
        ],
        "file-excel": [
            384,
            512,
            [],
            "f1c3",
            "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm212-240h-28.8c-4.4 0-8.4 2.4-10.5 6.3-18 33.1-22.2 42.4-28.6 57.7-13.9-29.1-6.9-17.3-28.6-57.7-2.1-3.9-6.2-6.3-10.6-6.3H124c-9.3 0-15 10-10.4 18l46.3 78-46.3 78c-4.7 8 1.1 18 10.4 18h28.9c4.4 0 8.4-2.4 10.5-6.3 21.7-40 23-45 28.6-57.7 14.9 30.2 5.9 15.9 28.6 57.7 2.1 3.9 6.2 6.3 10.6 6.3H260c9.3 0 15-10 10.4-18L224 320c.7-1.1 30.3-50.5 46.3-78 4.7-8-1.1-18-10.3-18z"
        ],
        "file-image": [
            384,
            512,
            [],
            "f1c5",
            "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm32-48h224V288l-23.5-23.5c-4.7-4.7-12.3-4.7-17 0L176 352l-39.5-39.5c-4.7-4.7-12.3-4.7-17 0L80 352v64zm48-240c-26.5 0-48 21.5-48 48s21.5 48 48 48 48-21.5 48-48-21.5-48-48-48z"
        ],
        "file-pdf": [
            384,
            512,
            [],
            "f1c1",
            "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm250.2-143.7c-12.2-12-47-8.7-64.4-6.5-17.2-10.5-28.7-25-36.8-46.3 3.9-16.1 10.1-40.6 5.4-56-4.2-26.2-37.8-23.6-42.6-5.9-4.4 16.1-.4 38.5 7 67.1-10 23.9-24.9 56-35.4 74.4-20 10.3-47 26.2-51 46.2-3.3 15.8 26 55.2 76.1-31.2 22.4-7.4 46.8-16.5 68.4-20.1 18.9 10.2 41 17 55.8 17 25.5 0 28-28.2 17.5-38.7zm-198.1 77.8c5.1-13.7 24.5-29.5 30.4-35-19 30.3-30.4 35.7-30.4 35zm81.6-190.6c7.4 0 6.7 32.1 1.8 40.8-4.4-13.9-4.3-40.8-1.8-40.8zm-24.4 136.6c9.7-16.9 18-37 24.7-54.7 8.3 15.1 18.9 27.2 30.1 35.5-20.8 4.3-38.9 13.1-54.8 19.2zm131.6-5s-5 6-37.3-7.8c35.1-2.6 40.9 5.4 37.3 7.8z"
        ],
        "file-powerpoint": [
            384,
            512,
            [],
            "f1c4",
            "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm72-60V236c0-6.6 5.4-12 12-12h69.2c36.7 0 62.8 27 62.8 66.3 0 74.3-68.7 66.5-95.5 66.5V404c0 6.6-5.4 12-12 12H132c-6.6 0-12-5.4-12-12zm48.5-87.4h23c7.9 0 13.9-2.4 18.1-7.2 8.5-9.8 8.4-28.5.1-37.8-4.1-4.6-9.9-7-17.4-7h-23.9v52z"
        ],
        "file-video": [
            384,
            512,
            [],
            "f1c8",
            "M369.941 97.941l-83.882-83.882A48 48 0 0 0 252.118 0H48C21.49 0 0 21.49 0 48v416c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48V131.882a48 48 0 0 0-14.059-33.941zM332.118 128H256V51.882L332.118 128zM48 464V48h160v104c0 13.255 10.745 24 24 24h104v288H48zm228.687-211.303L224 305.374V268c0-11.046-8.954-20-20-20H100c-11.046 0-20 8.954-20 20v104c0 11.046 8.954 20 20 20h104c11.046 0 20-8.954 20-20v-37.374l52.687 52.674C286.704 397.318 304 390.28 304 375.986V264.011c0-14.311-17.309-21.319-27.313-11.314z"
        ],
        "file-word": [
            384,
            512,
            [],
            "f1c2",
            "M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm220.1-208c-5.7 0-10.6 4-11.7 9.5-20.6 97.7-20.4 95.4-21 103.5-.2-1.2-.4-2.6-.7-4.3-.8-5.1.3.2-23.6-99.5-1.3-5.4-6.1-9.2-11.7-9.2h-13.3c-5.5 0-10.3 3.8-11.7 9.1-24.4 99-24 96.2-24.8 103.7-.1-1.1-.2-2.5-.5-4.2-.7-5.2-14.1-73.3-19.1-99-1.1-5.6-6-9.7-11.8-9.7h-16.8c-7.8 0-13.5 7.3-11.7 14.8 8 32.6 26.7 109.5 33.2 136 1.3 5.4 6.1 9.1 11.7 9.1h25.2c5.5 0 10.3-3.7 11.6-9.1l17.9-71.4c1.5-6.2 2.5-12 3-17.3l2.9 17.3c.1.4 12.6 50.5 17.9 71.4 1.3 5.3 6.1 9.1 11.6 9.1h24.7c5.5 0 10.3-3.7 11.6-9.1 20.8-81.9 30.2-119 34.5-136 1.9-7.6-3.8-14.9-11.6-14.9h-15.8z"
        ],
        "flag": [
            512,
            512,
            [],
            "f024",
            "M336.174 80c-49.132 0-93.305-32-161.913-32-31.301 0-58.303 6.482-80.721 15.168a48.04 48.04 0 0 0 2.142-20.727C93.067 19.575 74.167 1.594 51.201.104 23.242-1.71 0 20.431 0 48c0 17.764 9.657 33.262 24 41.562V496c0 8.837 7.163 16 16 16h16c8.837 0 16-7.163 16-16v-83.443C109.869 395.28 143.259 384 199.826 384c49.132 0 93.305 32 161.913 32 58.479 0 101.972-22.617 128.548-39.981C503.846 367.161 512 352.051 512 335.855V95.937c0-34.459-35.264-57.768-66.904-44.117C409.193 67.309 371.641 80 336.174 80zM464 336c-21.783 15.412-60.824 32-102.261 32-59.945 0-102.002-32-161.913-32-43.361 0-96.379 9.403-127.826 24V128c21.784-15.412 60.824-32 102.261-32 59.945 0 102.002 32 161.913 32 43.271 0 96.32-17.366 127.826-32v240z"
        ],
        "flushed": [
            496,
            512,
            [],
            "f579",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm96-312c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80zm0 128c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm-112 24c0-44.2-35.8-80-80-80s-80 35.8-80 80 35.8 80 80 80 80-35.8 80-80zm-80 48c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zm160 144H184c-13.2 0-24 10.8-24 24s10.8 24 24 24h128c13.2 0 24-10.8 24-24s-10.8-24-24-24z"
        ],
        "folder": [
            512,
            512,
            [],
            "f07b",
            "M464 128H272l-54.63-54.63c-6-6-14.14-9.37-22.63-9.37H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48zm0 272H48V112h140.12l54.63 54.63c6 6 14.14 9.37 22.63 9.37H464v224z"
        ],
        "folder-open": [
            576,
            512,
            [],
            "f07c",
            "M527.9 224H480v-48c0-26.5-21.5-48-48-48H272l-64-64H48C21.5 64 0 85.5 0 112v288c0 26.5 21.5 48 48 48h400c16.5 0 31.9-8.5 40.7-22.6l79.9-128c20-31.9-3-73.4-40.7-73.4zM48 118c0-3.3 2.7-6 6-6h134.1l64 64H426c3.3 0 6 2.7 6 6v42H152c-16.8 0-32.4 8.8-41.1 23.2L48 351.4zm400 282H72l77.2-128H528z"
        ],
        "font-awesome-logo-full": [
            3992,
            512,
            [
                "Font Awesome"
            ],
            "f4e6",
            "M454.6 0H57.4C25.9 0 0 25.9 0 57.4v397.3C0 486.1 25.9 512 57.4 512h397.3c31.4 0 57.4-25.9 57.4-57.4V57.4C512 25.9 486.1 0 454.6 0zm-58.9 324.9c0 4.8-4.1 6.9-8.9 8.9-19.2 8.1-39.7 15.7-61.5 15.7-40.5 0-68.7-44.8-163.2 2.5v51.8c0 30.3-45.7 30.2-45.7 0v-250c-9-7-15-17.9-15-30.3 0-21 17.1-38.2 38.2-38.2 21 0 38.2 17.1 38.2 38.2 0 12.2-5.8 23.2-14.9 30.2v21c37.1-12 65.5-34.4 146.1-3.4 26.6 11.4 68.7-15.7 76.5-15.7 5.5 0 10.3 4.1 10.3 8.9v160.4zm432.9-174.2h-137v70.1H825c39.8 0 40.4 62.2 0 62.2H691.6v105.6c0 45.5-70.7 46.4-70.7 0V128.3c0-22 18-39.8 39.8-39.8h167.8c39.6 0 40.5 62.2.1 62.2zm191.1 23.4c-169.3 0-169.1 252.4 0 252.4 169.9 0 169.9-252.4 0-252.4zm0 196.1c-81.6 0-82.1-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm372.4 53.4c-17.5 0-31.4-13.9-31.4-31.4v-117c0-62.4-72.6-52.5-99.1-16.4v133.4c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c43.3-51.6 162.4-60.4 162.4 39.3v141.5c.3 30.4-31.5 31.4-31.7 31.4zm179.7 2.9c-44.3 0-68.3-22.9-68.3-65.8V235.2H1488c-35.6 0-36.7-55.3 0-55.3h15.5v-37.3c0-41.3 63.8-42.1 63.8 0v37.5h24.9c35.4 0 35.7 55.3 0 55.3h-24.9v108.5c0 29.6 26.1 26.3 27.4 26.3 31.4 0 52.6 56.3-22.9 56.3zM1992 123c-19.5-50.2-95.5-50-114.5 0-107.3 275.7-99.5 252.7-99.5 262.8 0 42.8 58.3 51.2 72.1 14.4l13.5-35.9H2006l13 35.9c14.2 37.7 72.1 27.2 72.1-14.4 0-10.1 5.3 6.8-99.1-262.8zm-108.9 179.1l51.7-142.9 51.8 142.9h-103.5zm591.3-85.6l-53.7 176.3c-12.4 41.2-72 41-84 0l-42.3-135.9-42.3 135.9c-12.4 40.9-72 41.2-84.5 0l-54.2-176.3c-12.5-39.4 49.8-56.1 60.2-16.9L2213 342l45.3-139.5c10.9-32.7 59.6-34.7 71.2 0l45.3 139.5 39.3-142.4c10.3-38.3 72.6-23.8 60.3 16.9zm275.4 75.1c0-42.4-33.9-117.5-119.5-117.5-73.2 0-124.4 56.3-124.4 126 0 77.2 55.3 126.4 128.5 126.4 31.7 0 93-11.5 93-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-109 8.4-115.9-43.8h148.3c16.3 0 29.3-13.4 29.3-28.9zM2571 277.7c9.5-73.4 113.9-68.6 118.6 0H2571zm316.7 148.8c-31.4 0-81.6-10.5-96.6-31.9-12.4-17 2.5-39.8 21.8-39.8 16.3 0 36.8 22.9 77.7 22.9 27.4 0 40.4-11 40.4-25.8 0-39.8-142.9-7.4-142.9-102 0-40.4 35.3-75.7 98.6-75.7 31.4 0 74.1 9.9 87.6 29.4 10.8 14.8-1.4 36.2-20.9 36.2-15.1 0-26.7-17.3-66.2-17.3-22.9 0-37.8 10.5-37.8 23.8 0 35.9 142.4 6 142.4 103.1-.1 43.7-37.4 77.1-104.1 77.1zm266.8-252.4c-169.3 0-169.1 252.4 0 252.4 170.1 0 169.6-252.4 0-252.4zm0 196.1c-81.8 0-82-139.8 0-139.8 82.5 0 82.4 139.8 0 139.8zm476.9 22V268.7c0-53.8-61.4-45.8-85.7-10.5v134c0 41.3-63.8 42.1-63.8 0V268.7c0-52.1-59.5-47.4-85.7-10.1v133.6c0 41.5-63.3 41.8-63.3 0V208c0-40 63.1-41.6 63.1 0v3.4c9.9-14.4 41.8-37.3 78.6-37.3 35.3 0 57.7 16.4 66.7 43.8 13.9-21.8 45.8-43.8 82.6-43.8 44.3 0 70.7 23.4 70.7 72.7v145.3c.5 17.3-13.5 31.4-31.9 31.4 3.5.1-31.3 1.1-31.3-31.3zM3992 291.6c0-42.4-32.4-117.5-117.9-117.5-73.2 0-127.5 56.3-127.5 126 0 77.2 58.3 126.4 131.6 126.4 31.7 0 91.5-11.5 91.5-39.8 0-18.3-21.1-31.5-39.3-22.4-49.4 26.2-110.5 8.4-117.5-43.8h149.8c16.3 0 29.1-13.4 29.3-28.9zm-180.5-13.9c9.7-74.4 115.9-68.3 120.1 0h-120.1z"
        ],
        "frown": [
            496,
            512,
            [],
            "f119",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-80 128c-40.2 0-78 17.7-103.8 48.6-8.5 10.2-7.1 25.3 3.1 33.8 10.2 8.4 25.3 7.1 33.8-3.1 16.6-19.9 41-31.4 66.9-31.4s50.3 11.4 66.9 31.4c8.1 9.7 23.1 11.9 33.8 3.1 10.2-8.5 11.5-23.6 3.1-33.8C326 321.7 288.2 304 248 304z"
        ],
        "frown-open": [
            496,
            512,
            [],
            "f57a",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-48-248c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm128-32c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-80 112c-35.6 0-88.8 21.3-95.8 61.2-2 11.8 9 21.5 20.5 18.1 31.2-9.6 59.4-15.3 75.3-15.3s44.1 5.7 75.3 15.3c11.4 3.5 22.5-6.3 20.5-18.1-7-39.9-60.2-61.2-95.8-61.2z"
        ],
        "futbol": [
            496,
            512,
            [],
            "f1e3",
            "M483.8 179.4C449.8 74.6 352.6 8 248.1 8c-25.4 0-51.2 3.9-76.7 12.2C41.2 62.5-30.1 202.4 12.2 332.6 46.2 437.4 143.4 504 247.9 504c25.4 0 51.2-3.9 76.7-12.2 130.2-42.3 201.5-182.2 159.2-312.4zm-74.5 193.7l-52.2 6.4-43.7-60.9 24.4-75.2 71.1-22.1 38.9 36.4c-.2 30.7-7.4 61.1-21.7 89.2-4.7 9.3-10.7 17.8-16.8 26.2zm0-235.4l-10.4 53.1-70.7 22-64.2-46.5V92.5l47.4-26.2c39.2 13 73.4 38 97.9 71.4zM184.9 66.4L232 92.5v73.8l-64.2 46.5-70.6-22-10.1-52.5c24.3-33.4 57.9-58.6 97.8-71.9zM139 379.5L85.9 373c-14.4-20.1-37.3-59.6-37.8-115.3l39-36.4 71.1 22.2 24.3 74.3-43.5 61.7zm48.2 67l-22.4-48.1 43.6-61.7H287l44.3 61.7-22.4 48.1c-6.2 1.8-57.6 20.4-121.7 0z"
        ],
        "gem": [
            576,
            512,
            [],
            "f3a5",
            "M464 0H112c-4 0-7.8 2-10 5.4L2 152.6c-2.9 4.4-2.6 10.2.7 14.2l276 340.8c4.8 5.9 13.8 5.9 18.6 0l276-340.8c3.3-4.1 3.6-9.8.7-14.2L474.1 5.4C471.8 2 468.1 0 464 0zm-19.3 48l63.3 96h-68.4l-51.7-96h56.8zm-202.1 0h90.7l51.7 96H191l51.6-96zm-111.3 0h56.8l-51.7 96H68l63.3-96zm-43 144h51.4L208 352 88.3 192zm102.9 0h193.6L288 435.3 191.2 192zM368 352l68.2-160h51.4L368 352z"
        ],
        "grimace": [
            496,
            512,
            [],
            "f57f",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm16 16H152c-26.5 0-48 21.5-48 48v32c0 26.5 21.5 48 48 48h192c26.5 0 48-21.5 48-48v-32c0-26.5-21.5-48-48-48zm-168 96h-24c-8.8 0-16-7.2-16-16v-8h40v24zm0-40h-40v-8c0-8.8 7.2-16 16-16h24v24zm64 40h-48v-24h48v24zm0-40h-48v-24h48v24zm64 40h-48v-24h48v24zm0-40h-48v-24h48v24zm56 24c0 8.8-7.2 16-16 16h-24v-24h40v8zm0-24h-40v-24h24c8.8 0 16 7.2 16 16v8z"
        ],
        "grin": [
            496,
            512,
            [],
            "f580",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.4-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zM168 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32z"
        ],
        "grin-alt": [
            496,
            512,
            [],
            "f581",
            "M200.3 248c12.4-18.7 15.1-37.3 15.7-56-.5-18.7-3.3-37.3-15.7-56-8-12-25.1-11.4-32.7 0-12.4 18.7-15.1 37.3-15.7 56 .5 18.7 3.3 37.3 15.7 56 8.1 12 25.2 11.4 32.7 0zm128 0c12.4-18.7 15.1-37.3 15.7-56-.5-18.7-3.3-37.3-15.7-56-8-12-25.1-11.4-32.7 0-12.4 18.7-15.1 37.3-15.7 56 .5 18.7 3.3 37.3 15.7 56 8.1 12 25.2 11.4 32.7 0zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3z"
        ],
        "grin-beam": [
            496,
            512,
            [],
            "f582",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-235.9-72.9c3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3zm160 0c3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3z"
        ],
        "grin-beam-sweat": [
            496,
            512,
            [],
            "f583",
            "M440 160c29.5 0 53.3-26.3 53.3-58.7 0-25-31.7-75.5-46.2-97.3-3.6-5.3-10.7-5.3-14.2 0-14.5 21.8-46.2 72.3-46.2 97.3 0 32.4 23.8 58.7 53.3 58.7zM248 400c51.9 0 115.3-32.9 123.3-80 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 8 47.1 71.4 80 123.3 80zm130.3-168.3c3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.6 6.2 4.6 9.3 3.7zm105.3-52.9c-24.6 15.7-46 12.9-46.4 12.9 6.9 20.2 10.8 41.8 10.8 64.3 0 110.3-89.7 200-200 200S48 366.3 48 256 137.7 56 248 56c39.8 0 76.8 11.8 108 31.9 1.7-9.5 6.3-24.1 17.2-45.7C336.4 20.6 293.7 8 248 8 111 8 0 119 0 256s111 248 248 248 248-111 248-248c0-27-4.4-52.9-12.4-77.2zM168 189.4c12.3 0 23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.8 19.2-21.6 31.5-21.6z"
        ],
        "grin-hearts": [
            496,
            512,
            [],
            "f584",
            "M353.6 304.6c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-152.8-48.9c4.5 1.2 9.2-1.5 10.5-6l19.4-69.9c5.6-20.3-7.4-41.1-28.8-44.5-18.6-3-36.4 9.8-41.5 27.9l-2 7.1-7.1-1.9c-18.2-4.7-38.2 4.3-44.9 22-7.7 20.2 3.8 41.9 24.2 47.2l70.2 18.1zm188.8-65.3c-6.7-17.6-26.7-26.7-44.9-22l-7.1 1.9-2-7.1c-5-18.1-22.8-30.9-41.5-27.9-21.4 3.4-34.4 24.2-28.8 44.5l19.4 69.9c1.2 4.5 5.9 7.2 10.5 6l70.2-18.2c20.4-5.3 31.9-26.9 24.2-47.1zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200z"
        ],
        "grin-squint": [
            496,
            512,
            [],
            "f585",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.4-17.7 15.3 7.9 47.1 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-234.7-40.8c3.6 4.2 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3s-2.2-8.1-5.8-10.3l-80-48c-5.1-3-11.4-1.9-15.3 2.5-3.8 4.5-3.8 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11.1.1 15.5zm242.9 2.5c5.4 3.2 11.7 1.7 15.3-2.5 3.8-4.5 3.8-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11-.1-15.5-3.8-4.4-10.2-5.4-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48z"
        ],
        "grin-squint-tears": [
            512,
            512,
            [],
            "f586",
            "M117.1 384.1c-25.8 3.7-84 13.7-100.9 30.6-21.9 21.9-21.5 57.9.9 80.3s58.3 22.8 80.3.9C114.3 479 124.3 420.8 128 395c.8-6.4-4.6-11.8-10.9-10.9zm-41.2-41.7C40.3 268 53 176.1 114.6 114.6 152.4 76.8 202.6 56 256 56c36.2 0 70.8 9.8 101.2 27.7 3.8-20.3 8-36.1 12-48.3C333.8 17.2 294.9 8 256 8 192.5 8 129.1 32.2 80.6 80.6c-74.1 74.1-91.3 183.4-52 274 12.2-4.1 27.7-8.3 47.3-12.2zm352.3-187.6c45 76.6 34.9 176.9-30.8 242.6-37.8 37.8-88 58.6-141.4 58.6-30.5 0-59.8-7-86.4-19.8-3.9 19.5-8 35-12.2 47.2 31.4 13.6 65 20.6 98.7 20.6 63.5 0 126.9-24.2 175.4-72.6 78.1-78.1 93.1-195.4 45.2-288.6-12.3 4-28.2 8.1-48.5 12zm-33.3-26.9c25.8-3.7 84-13.7 100.9-30.6 21.9-21.9 21.5-57.9-.9-80.3s-58.3-22.8-80.3-.9C397.7 33 387.7 91.2 384 117c-.8 6.4 4.6 11.8 10.9 10.9zm-187 108.3c-3-3-7.2-4.2-11.4-3.2L106 255.7c-5.7 1.4-9.5 6.7-9.1 12.6.5 5.8 5.1 10.5 10.9 11l52.3 4.8 4.8 52.3c.5 5.8 5.2 10.4 11 10.9h.9c5.5 0 10.3-3.7 11.7-9.1l22.6-90.5c1-4.2-.2-8.5-3.2-11.5zm39.7-25.1l90.5-22.6c5.7-1.4 9.5-6.7 9.1-12.6-.5-5.8-5.1-10.5-10.9-11l-52.3-4.8-4.8-52.3c-.5-5.8-5.2-10.4-11-10.9-5.6-.1-11.2 3.4-12.6 9.1L233 196.5c-1 4.1.2 8.4 3.2 11.4 5 5 11.3 3.2 11.4 3.2zm52 88.5c-29.1 29.1-59.7 52.9-83.9 65.4-9.2 4.8-10 17.5-1.7 23.4 38.9 27.7 107 6.2 143.7-30.6S416 253 388.3 214.1c-5.8-8.2-18.5-7.6-23.4 1.7-12.3 24.2-36.2 54.7-65.3 83.8z"
        ],
        "grin-stars": [
            496,
            512,
            [],
            "f587",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm105.6-151.4c-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 7.9 47.2 71.3 80 123.3 80s115.3-32.9 123.3-80c1.6-9.8-7.7-18.4-17.7-15.3zm-227.9-57.5c-1 6.2 5.4 11 11 7.9l31.3-16.3 31.3 16.3c5.6 3.1 12-1.7 11-7.9l-6-34.9 25.4-24.6c4.5-4.5 1.9-12.2-4.3-13.2l-34.9-5-15.5-31.6c-2.9-5.8-11-5.8-13.9 0l-15.5 31.6-34.9 5c-6.2.9-8.9 8.6-4.3 13.2l25.4 24.6-6.1 34.9zm259.7-72.7l-34.9-5-15.5-31.6c-2.9-5.8-11-5.8-13.9 0l-15.5 31.6-34.9 5c-6.2.9-8.9 8.6-4.3 13.2l25.4 24.6-6 34.9c-1 6.2 5.4 11 11 7.9l31.3-16.3 31.3 16.3c5.6 3.1 12-1.7 11-7.9l-6-34.9 25.4-24.6c4.5-4.6 1.8-12.2-4.4-13.2z"
        ],
        "grin-tears": [
            640,
            512,
            [],
            "f588",
            "M117.1 256.1c-25.8 3.7-84 13.7-100.9 30.6-21.9 21.9-21.5 57.9.9 80.3s58.3 22.8 80.3.9C114.3 351 124.3 292.8 128 267c.8-6.4-4.6-11.8-10.9-10.9zm506.7 30.6c-16.9-16.9-75.1-26.9-100.9-30.6-6.3-.9-11.7 4.5-10.8 10.8 3.7 25.8 13.7 84 30.6 100.9 21.9 21.9 57.9 21.5 80.3-.9 22.3-22.3 22.7-58.3.8-80.2zm-126.6 61.7C463.8 412.3 396.9 456 320 456c-76.9 0-143.8-43.7-177.2-107.6-12.5 37.4-25.2 43.9-28.3 46.5C159.1 460.7 234.5 504 320 504s160.9-43.3 205.5-109.1c-3.2-2.7-15.9-9.2-28.3-46.5zM122.7 224.5C137.9 129.2 220.5 56 320 56c99.5 0 182.1 73.2 197.3 168.5 2.1-.2 5.2-2.4 49.5 7C554.4 106 448.7 8 320 8S85.6 106 73.2 231.4c44.5-9.4 47.1-7.2 49.5-6.9zM320 400c51.9 0 115.3-32.9 123.3-80 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.8-3.1-19.4 5.3-17.7 15.3 8 47.1 71.4 80 123.3 80zm130.3-168.3c3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.6 6.2 4.6 9.3 3.7zM240 189.4c12.3 0 23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.8 19.2-21.6 31.5-21.6z"
        ],
        "grin-tongue": [
            496,
            512,
            [],
            "f589",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3zM168 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
        ],
        "grin-tongue-squint": [
            496,
            512,
            [],
            "f58a",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3zm36.9-281.1c-3.8-4.4-10.3-5.5-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48c5.4 3.2 11.7 1.7 15.3-2.5 3.8-4.5 3.8-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11.1-.1-15.5zm-162.9 45.5l-80-48c-5-3-11.4-2-15.3 2.5-3.8 4.5-3.8 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11 .1 15.5 3.6 4.2 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3s-2.2-8.1-5.8-10.3z"
        ],
        "grin-tongue-wink": [
            496,
            512,
            [],
            "f58b",
            "M152 180c-25.7 0-55.9 16.9-59.8 42.1-.8 5 1.7 10 6.1 12.4 4.4 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.2 8 4.7 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-3.9-25.2-34.1-42.1-59.8-42.1zm176-52c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80zm0 128c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-72c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm64 400c0 35.6-29.1 64.5-64.9 64-35.1-.5-63.1-29.8-63.1-65v-42.8l17.7-8.8c15-7.5 31.5 1.7 34.9 16.5l2.8 12.1c2.1 9.2 15.2 9.2 17.3 0l2.8-12.1c3.4-14.8 19.8-24.1 34.9-16.5l17.7 8.8V408zm28.2 25.3c2.2-8.1 3.8-16.5 3.8-25.3v-43.5c14.2-12.4 24.4-27.5 27.3-44.5 1.7-9.9-7.7-18.5-17.7-15.3-25.9 8.3-64.4 13.1-105.6 13.1s-79.6-4.8-105.6-13.1c-9.9-3.1-19.4 5.3-17.7 15.3 2.9 17 13.1 32.1 27.3 44.5V408c0 8.8 1.6 17.2 3.8 25.3C91.8 399.9 48 333 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 77-43.8 143.9-107.8 177.3z"
        ],
        "grin-wink": [
            496,
            512,
            [],
            "f58c",
            "M328 180c-25.69 0-55.88 16.92-59.86 42.12-1.75 11.22 11.5 18.24 19.83 10.84l9.55-8.48c14.81-13.19 46.16-13.19 60.97 0l9.55 8.48c8.48 7.43 21.56.25 19.83-10.84C383.88 196.92 353.69 180 328 180zm-160 60c17.67 0 32-14.33 32-32s-14.33-32-32-32-32 14.33-32 32 14.33 32 32 32zm185.55 64.64c-25.93 8.3-64.4 13.06-105.55 13.06s-79.62-4.75-105.55-13.06c-9.94-3.13-19.4 5.37-17.71 15.34C132.67 367.13 196.06 400 248 400s115.33-32.87 123.26-80.02c1.68-9.89-7.67-18.48-17.71-15.34zM248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 448c-110.28 0-200-89.72-200-200S137.72 56 248 56s200 89.72 200 200-89.72 200-200 200z"
        ],
        "hand-lizard": [
            576,
            512,
            [],
            "f258",
            "M556.686 290.542L410.328 64.829C397.001 44.272 374.417 32 349.917 32H56C25.121 32 0 57.122 0 88v8c0 44.112 35.888 80 80 80h196.042l-18.333 48H144c-48.523 0-88 39.477-88 88 0 30.879 25.121 56 56 56h131.552c2.987 0 5.914.549 8.697 1.631L352 408.418V480h224V355.829c0-23.225-6.679-45.801-19.314-65.287zM528 432H400v-23.582c0-19.948-12.014-37.508-30.604-44.736l-99.751-38.788A71.733 71.733 0 0 0 243.552 320H112c-4.411 0-8-3.589-8-8 0-22.056 17.944-40 40-40h113.709c19.767 0 37.786-12.407 44.84-30.873l24.552-64.281c8.996-23.553-8.428-48.846-33.63-48.846H80c-17.645 0-32-14.355-32-32v-8c0-4.411 3.589-8 8-8h293.917c8.166 0 15.693 4.09 20.137 10.942l146.358 225.715A71.84 71.84 0 0 1 528 355.829V432z"
        ],
        "hand-paper": [
            448,
            512,
            [],
            "f256",
            "M372.57 112.641v-10.825c0-43.612-40.52-76.691-83.039-65.546-25.629-49.5-94.09-47.45-117.982.747C130.269 26.456 89.144 57.945 89.144 102v126.13c-19.953-7.427-43.308-5.068-62.083 8.871-29.355 21.796-35.794 63.333-14.55 93.153L132.48 498.569a32 32 0 0 0 26.062 13.432h222.897c14.904 0 27.835-10.289 31.182-24.813l30.184-130.958A203.637 203.637 0 0 0 448 310.564V179c0-40.62-35.523-71.992-75.43-66.359zm27.427 197.922c0 11.731-1.334 23.469-3.965 34.886L368.707 464h-201.92L51.591 302.303c-14.439-20.27 15.023-42.776 29.394-22.605l27.128 38.079c8.995 12.626 29.031 6.287 29.031-9.283V102c0-25.645 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V67c0-25.663 36.571-24.81 36.571.691V256c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16V101.125c0-25.672 36.57-24.81 36.57.691V256c0 8.837 7.163 16 16 16h6.857c8.837 0 16-7.163 16-16v-76.309c0-26.242 36.57-25.64 36.57-.691v131.563z"
        ],
        "hand-peace": [
            448,
            512,
            [],
            "f25b",
            "M362.146 191.976c-13.71-21.649-38.761-34.016-65.006-30.341V74c0-40.804-32.811-74-73.141-74-40.33 0-73.14 33.196-73.14 74L160 168l-18.679-78.85C126.578 50.843 83.85 32.11 46.209 47.208 8.735 62.238-9.571 104.963 5.008 142.85l55.757 144.927c-30.557 24.956-43.994 57.809-24.733 92.218l54.853 97.999C102.625 498.97 124.73 512 148.575 512h205.702c30.744 0 57.558-21.44 64.555-51.797l27.427-118.999a67.801 67.801 0 0 0 1.729-15.203L448 256c0-44.956-43.263-77.343-85.854-64.024zM399.987 326c0 1.488-.169 2.977-.502 4.423l-27.427 119.001c-1.978 8.582-9.29 14.576-17.782 14.576H148.575c-6.486 0-12.542-3.621-15.805-9.449l-54.854-98c-4.557-8.141-2.619-18.668 4.508-24.488l26.647-21.764a16 16 0 0 0 4.812-18.139l-64.09-166.549C37.226 92.956 84.37 74.837 96.51 106.389l59.784 155.357A16 16 0 0 0 171.227 272h11.632c8.837 0 16-7.163 16-16V74c0-34.375 50.281-34.43 50.281 0v182c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16v-28c0-25.122 36.567-25.159 36.567 0v28c0 8.837 7.163 16 16 16h6.856c8.837 0 16-7.163 16-16 0-25.12 36.567-25.16 36.567 0v70z"
        ],
        "hand-point-down": [
            448,
            512,
            [],
            "f0a7",
            "M188.8 512c45.616 0 83.2-37.765 83.2-83.2v-35.647a93.148 93.148 0 0 0 22.064-7.929c22.006 2.507 44.978-3.503 62.791-15.985C409.342 368.1 448 331.841 448 269.299V248c0-60.063-40-98.512-40-127.2v-2.679c4.952-5.747 8-13.536 8-22.12V32c0-17.673-12.894-32-28.8-32H156.8C140.894 0 128 14.327 128 32v64c0 8.584 3.048 16.373 8 22.12v2.679c0 6.964-6.193 14.862-23.668 30.183l-.148.129-.146.131c-9.937 8.856-20.841 18.116-33.253 25.851C48.537 195.798 0 207.486 0 252.8c0 56.928 35.286 92 83.2 92 8.026 0 15.489-.814 22.4-2.176V428.8c0 45.099 38.101 83.2 83.2 83.2zm0-48c-18.7 0-35.2-16.775-35.2-35.2V270.4c-17.325 0-35.2 26.4-70.4 26.4-26.4 0-35.2-20.625-35.2-44 0-8.794 32.712-20.445 56.1-34.926 14.575-9.074 27.225-19.524 39.875-30.799 18.374-16.109 36.633-33.836 39.596-59.075h176.752C364.087 170.79 400 202.509 400 248v21.299c0 40.524-22.197 57.124-61.325 50.601-8.001 14.612-33.979 24.151-53.625 12.925-18.225 19.365-46.381 17.787-61.05 4.95V428.8c0 18.975-16.225 35.2-35.2 35.2zM328 64c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24z"
        ],
        "hand-point-left": [
            512,
            512,
            [],
            "f0a5",
            "M0 220.8C0 266.416 37.765 304 83.2 304h35.647a93.148 93.148 0 0 0 7.929 22.064c-2.507 22.006 3.503 44.978 15.985 62.791C143.9 441.342 180.159 480 242.701 480H264c60.063 0 98.512-40 127.2-40h2.679c5.747 4.952 13.536 8 22.12 8h64c17.673 0 32-12.894 32-28.8V188.8c0-15.906-14.327-28.8-32-28.8h-64c-8.584 0-16.373 3.048-22.12 8H391.2c-6.964 0-14.862-6.193-30.183-23.668l-.129-.148-.131-.146c-8.856-9.937-18.116-20.841-25.851-33.253C316.202 80.537 304.514 32 259.2 32c-56.928 0-92 35.286-92 83.2 0 8.026.814 15.489 2.176 22.4H83.2C38.101 137.6 0 175.701 0 220.8zm48 0c0-18.7 16.775-35.2 35.2-35.2h158.4c0-17.325-26.4-35.2-26.4-70.4 0-26.4 20.625-35.2 44-35.2 8.794 0 20.445 32.712 34.926 56.1 9.074 14.575 19.524 27.225 30.799 39.875 16.109 18.374 33.836 36.633 59.075 39.596v176.752C341.21 396.087 309.491 432 264 432h-21.299c-40.524 0-57.124-22.197-50.601-61.325-14.612-8.001-24.151-33.979-12.925-53.625-19.365-18.225-17.787-46.381-4.95-61.05H83.2C64.225 256 48 239.775 48 220.8zM448 360c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24z"
        ],
        "hand-point-right": [
            512,
            512,
            [],
            "f0a4",
            "M428.8 137.6h-86.177a115.52 115.52 0 0 0 2.176-22.4c0-47.914-35.072-83.2-92-83.2-45.314 0-57.002 48.537-75.707 78.784-7.735 12.413-16.994 23.317-25.851 33.253l-.131.146-.129.148C135.662 161.807 127.764 168 120.8 168h-2.679c-5.747-4.952-13.536-8-22.12-8H32c-17.673 0-32 12.894-32 28.8v230.4C0 435.106 14.327 448 32 448h64c8.584 0 16.373-3.048 22.12-8h2.679c28.688 0 67.137 40 127.2 40h21.299c62.542 0 98.8-38.658 99.94-91.145 12.482-17.813 18.491-40.785 15.985-62.791A93.148 93.148 0 0 0 393.152 304H428.8c45.435 0 83.2-37.584 83.2-83.2 0-45.099-38.101-83.2-83.2-83.2zm0 118.4h-91.026c12.837 14.669 14.415 42.825-4.95 61.05 11.227 19.646 1.687 45.624-12.925 53.625 6.524 39.128-10.076 61.325-50.6 61.325H248c-45.491 0-77.21-35.913-120-39.676V215.571c25.239-2.964 42.966-21.222 59.075-39.596 11.275-12.65 21.725-25.3 30.799-39.875C232.355 112.712 244.006 80 252.8 80c23.375 0 44 8.8 44 35.2 0 35.2-26.4 53.075-26.4 70.4h158.4c18.425 0 35.2 16.5 35.2 35.2 0 18.975-16.225 35.2-35.2 35.2zM88 384c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24z"
        ],
        "hand-point-up": [
            448,
            512,
            [],
            "f0a6",
            "M105.6 83.2v86.177a115.52 115.52 0 0 0-22.4-2.176c-47.914 0-83.2 35.072-83.2 92 0 45.314 48.537 57.002 78.784 75.707 12.413 7.735 23.317 16.994 33.253 25.851l.146.131.148.129C129.807 376.338 136 384.236 136 391.2v2.679c-4.952 5.747-8 13.536-8 22.12v64c0 17.673 12.894 32 28.8 32h230.4c15.906 0 28.8-14.327 28.8-32v-64c0-8.584-3.048-16.373-8-22.12V391.2c0-28.688 40-67.137 40-127.2v-21.299c0-62.542-38.658-98.8-91.145-99.94-17.813-12.482-40.785-18.491-62.791-15.985A93.148 93.148 0 0 0 272 118.847V83.2C272 37.765 234.416 0 188.8 0c-45.099 0-83.2 38.101-83.2 83.2zm118.4 0v91.026c14.669-12.837 42.825-14.415 61.05 4.95 19.646-11.227 45.624-1.687 53.625 12.925 39.128-6.524 61.325 10.076 61.325 50.6V264c0 45.491-35.913 77.21-39.676 120H183.571c-2.964-25.239-21.222-42.966-39.596-59.075-12.65-11.275-25.3-21.725-39.875-30.799C80.712 279.645 48 267.994 48 259.2c0-23.375 8.8-44 35.2-44 35.2 0 53.075 26.4 70.4 26.4V83.2c0-18.425 16.5-35.2 35.2-35.2 18.975 0 35.2 16.225 35.2 35.2zM352 424c13.255 0 24 10.745 24 24s-10.745 24-24 24-24-10.745-24-24 10.745-24 24-24z"
        ],
        "hand-pointer": [
            448,
            512,
            [],
            "f25a",
            "M358.182 179.361c-19.493-24.768-52.679-31.945-79.872-19.098-15.127-15.687-36.182-22.487-56.595-19.629V67c0-36.944-29.736-67-66.286-67S89.143 30.056 89.143 67v161.129c-19.909-7.41-43.272-5.094-62.083 8.872-29.355 21.795-35.793 63.333-14.55 93.152l109.699 154.001C134.632 501.59 154.741 512 176 512h178.286c30.802 0 57.574-21.5 64.557-51.797l27.429-118.999A67.873 67.873 0 0 0 448 326v-84c0-46.844-46.625-79.273-89.818-62.639zM80.985 279.697l27.126 38.079c8.995 12.626 29.031 6.287 29.031-9.283V67c0-25.12 36.571-25.16 36.571 0v175c0 8.836 7.163 16 16 16h6.857c8.837 0 16-7.164 16-16v-35c0-25.12 36.571-25.16 36.571 0v35c0 8.836 7.163 16 16 16H272c8.837 0 16-7.164 16-16v-21c0-25.12 36.571-25.16 36.571 0v21c0 8.836 7.163 16 16 16h6.857c8.837 0 16-7.164 16-16 0-25.121 36.571-25.16 36.571 0v84c0 1.488-.169 2.977-.502 4.423l-27.43 119.001c-1.978 8.582-9.29 14.576-17.782 14.576H176c-5.769 0-11.263-2.878-14.697-7.697l-109.712-154c-14.406-20.223 14.994-42.818 29.394-22.606zM176.143 400v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.733 0-14-7.163-14-16zm75.428 0v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.732 0-14-7.163-14-16zM327 400v-96c0-8.837 6.268-16 14-16h6c7.732 0 14 7.163 14 16v96c0 8.837-6.268 16-14 16h-6c-7.732 0-14-7.163-14-16z"
        ],
        "hand-rock": [
            512,
            512,
            [],
            "f255",
            "M408.864 79.052c-22.401-33.898-66.108-42.273-98.813-23.588-29.474-31.469-79.145-31.093-108.334-.022-47.16-27.02-108.71 5.055-110.671 60.806C44.846 105.407 0 140.001 0 187.429v56.953c0 32.741 14.28 63.954 39.18 85.634l97.71 85.081c4.252 3.702 3.11 5.573 3.11 32.903 0 17.673 14.327 32 32 32h252c17.673 0 32-14.327 32-32 0-23.513-1.015-30.745 3.982-42.37l42.835-99.656c6.094-14.177 9.183-29.172 9.183-44.568V146.963c0-52.839-54.314-88.662-103.136-67.911zM464 261.406a64.505 64.505 0 0 1-5.282 25.613l-42.835 99.655c-5.23 12.171-7.883 25.04-7.883 38.25V432H188v-10.286c0-16.37-7.14-31.977-19.59-42.817l-97.71-85.08C56.274 281.255 48 263.236 48 244.381v-56.953c0-33.208 52-33.537 52 .677v41.228a16 16 0 0 0 5.493 12.067l7 6.095A16 16 0 0 0 139 235.429V118.857c0-33.097 52-33.725 52 .677v26.751c0 8.836 7.164 16 16 16h7c8.836 0 16-7.164 16-16v-41.143c0-33.134 52-33.675 52 .677v40.466c0 8.836 7.163 16 16 16h7c8.837 0 16-7.164 16-16v-27.429c0-33.03 52-33.78 52 .677v26.751c0 8.836 7.163 16 16 16h7c8.837 0 16-7.164 16-16 0-33.146 52-33.613 52 .677v114.445z"
        ],
        "hand-scissors": [
            512,
            512,
            [],
            "f257",
            "M256 480l70-.013c5.114 0 10.231-.583 15.203-1.729l118.999-27.427C490.56 443.835 512 417.02 512 386.277V180.575c0-23.845-13.03-45.951-34.005-57.69l-97.999-54.853c-34.409-19.261-67.263-5.824-92.218 24.733L142.85 37.008c-37.887-14.579-80.612 3.727-95.642 41.201-15.098 37.642 3.635 80.37 41.942 95.112L168 192l-94-9.141c-40.804 0-74 32.811-74 73.14 0 40.33 33.196 73.141 74 73.141h87.635c-3.675 26.245 8.692 51.297 30.341 65.006C178.657 436.737 211.044 480 256 480zm0-48.013c-25.16 0-25.12-36.567 0-36.567 8.837 0 16-7.163 16-16v-6.856c0-8.837-7.163-16-16-16h-28c-25.159 0-25.122-36.567 0-36.567h28c8.837 0 16-7.163 16-16v-6.856c0-8.837-7.163-16-16-16H74c-34.43 0-34.375-50.281 0-50.281h182c8.837 0 16-7.163 16-16v-11.632a16 16 0 0 0-10.254-14.933L106.389 128.51c-31.552-12.14-13.432-59.283 19.222-46.717l166.549 64.091a16.001 16.001 0 0 0 18.139-4.812l21.764-26.647c5.82-7.127 16.348-9.064 24.488-4.508l98 54.854c5.828 3.263 9.449 9.318 9.449 15.805v205.701c0 8.491-5.994 15.804-14.576 17.782l-119.001 27.427a19.743 19.743 0 0 1-4.423.502h-70z"
        ],
        "hand-spock": [
            512,
            512,
            [],
            "f259",
            "M501.03053,116.17605c-19.39059-31.50779-51.24406-35.72849-66.31044-35.01756-14.11325-50.81051-62.0038-54.08-70.73816-54.08a74.03091,74.03091,0,0,0-72.23816,58.916l-4.64648,22.66014-13.68357-53.207c-9.09569-35.37107-46.412-64.05074-89.66-53.07223a73.89749,73.89749,0,0,0-55.121,78.94722,73.68273,73.68273,0,0,0-64.8495,94.42181l24.35933,82.19721c-38.24017-7.54492-62.79677,16.18358-68.11512,21.84764a73.6791,73.6791,0,0,0,3.19921,104.19329l91.36509,85.9765A154.164,154.164,0,0,0,220.62279,512h107.4549A127.30079,127.30079,0,0,0,452.3392,413.86139l57.623-241.96272A73.20274,73.20274,0,0,0,501.03053,116.17605Zm-37.7597,44.60544L405.64788,402.74812a79.46616,79.46616,0,0,1-77.57019,61.25972H220.62279a106.34052,106.34052,0,0,1-73.1366-28.998l-91.369-85.98041C31.34381,325.72669,66.61133,288.131,91.39644,311.5392l51.123,48.10739c5.42577,5.10937,13.48239.71679,13.48239-5.82617a246.79914,246.79914,0,0,0-10.17771-70.1523l-36.01362-121.539c-9.7324-32.88279,39.69916-47.27145,49.38664-14.625l31.3437,105.77923c5.59374,18.90428,33.78119,10.71288,28.9648-8.00781L177.06427,80.23662c-8.50389-33.1035,41.43157-45.64646,49.86515-12.83593l47.32609,184.035c4.42773,17.24218,29.16207,16.5039,32.71089-.80468l31.791-154.9706c6.81054-33.1074,57.51748-24.10741,50.11906,11.96288L360.32764,246.78924c-3.72265,18.10936,23.66793,24.63084,28.05659,6.21679L413.185,148.85962C421.1498,115.512,471.14,127.79713,463.27083,160.78149Z"
        ],
        "handshake": [
            640,
            512,
            [],
            "f2b5",
            "M519.2 127.9l-47.6-47.6A56.252 56.252 0 0 0 432 64H205.2c-14.8 0-29.1 5.9-39.6 16.3L118 127.9H0v255.7h64c17.6 0 31.8-14.2 31.9-31.7h9.1l84.6 76.4c30.9 25.1 73.8 25.7 105.6 3.8 12.5 10.8 26 15.9 41.1 15.9 18.2 0 35.3-7.4 48.8-24 22.1 8.7 48.2 2.6 64-16.8l26.2-32.3c5.6-6.9 9.1-14.8 10.9-23h57.9c.1 17.5 14.4 31.7 31.9 31.7h64V127.9H519.2zM48 351.6c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.9-7.2 16-16 16zm390-6.9l-26.1 32.2c-2.8 3.4-7.8 4-11.3 1.2l-23.9-19.4-30 36.5c-6 7.3-15 4.8-18 2.4l-36.8-31.5-15.6 19.2c-13.9 17.1-39.2 19.7-55.3 6.6l-97.3-88H96V175.8h41.9l61.7-61.6c2-.8 3.7-1.5 5.7-2.3H262l-38.7 35.5c-29.4 26.9-31.1 72.3-4.4 101.3 14.8 16.2 61.2 41.2 101.5 4.4l8.2-7.5 108.2 87.8c3.4 2.8 3.9 7.9 1.2 11.3zm106-40.8h-69.2c-2.3-2.8-4.9-5.4-7.7-7.7l-102.7-83.4 12.5-11.4c6.5-6 7-16.1 1-22.6L367 167.1c-6-6.5-16.1-6.9-22.6-1l-55.2 50.6c-9.5 8.7-25.7 9.4-34.6 0-9.3-9.9-8.5-25.1 1.2-33.9l65.6-60.1c7.4-6.8 17-10.5 27-10.5l83.7-.2c2.1 0 4.1.8 5.5 2.3l61.7 61.6H544v128zm48 47.7c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.9-7.2 16-16 16z"
        ],
        "hdd": [
            576,
            512,
            [],
            "f0a0",
            "M567.403 235.642L462.323 84.589A48 48 0 0 0 422.919 64H153.081a48 48 0 0 0-39.404 20.589L8.597 235.642A48.001 48.001 0 0 0 0 263.054V400c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V263.054c0-9.801-3-19.366-8.597-27.412zM153.081 112h269.838l77.913 112H75.168l77.913-112zM528 400H48V272h480v128zm-32-64c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32zm-96 0c0 17.673-14.327 32-32 32s-32-14.327-32-32 14.327-32 32-32 32 14.327 32 32z"
        ],
        "heart": [
            512,
            512,
            [],
            "f004",
            "M458.4 64.3C400.6 15.7 311.3 23 256 79.3 200.7 23 111.4 15.6 53.6 64.3-21.6 127.6-10.6 230.8 43 285.5l175.4 178.7c10 10.2 23.4 15.9 37.6 15.9 14.3 0 27.6-5.6 37.6-15.8L469 285.6c53.5-54.7 64.7-157.9-10.6-221.3zm-23.6 187.5L259.4 430.5c-2.4 2.4-4.4 2.4-6.8 0L77.2 251.8c-36.5-37.2-43.9-107.6 7.3-150.7 38.9-32.7 98.9-27.8 136.5 10.5l35 35.7 35-35.7c37.8-38.5 97.8-43.2 136.5-10.6 51.1 43.1 43.5 113.9 7.3 150.8z"
        ],
        "hospital": [
            448,
            512,
            [],
            "f0f8",
            "M128 244v-40c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v40c0 6.627-5.373 12-12 12h-40c-6.627 0-12-5.373-12-12zm140 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm-76 84v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm76 12h40c6.627 0 12-5.373 12-12v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12zm180 124v36H0v-36c0-6.627 5.373-12 12-12h19.5V85.035C31.5 73.418 42.245 64 55.5 64H144V24c0-13.255 10.745-24 24-24h112c13.255 0 24 10.745 24 24v40h88.5c13.255 0 24 9.418 24 21.035V464H436c6.627 0 12 5.373 12 12zM79.5 463H192v-67c0-6.627 5.373-12 12-12h40c6.627 0 12 5.373 12 12v67h112.5V112H304v24c0 13.255-10.745 24-24 24H168c-13.255 0-24-10.745-24-24v-24H79.5v351zM266 64h-26V38a6 6 0 0 0-6-6h-20a6 6 0 0 0-6 6v26h-26a6 6 0 0 0-6 6v20a6 6 0 0 0 6 6h26v26a6 6 0 0 0 6 6h20a6 6 0 0 0 6-6V96h26a6 6 0 0 0 6-6V70a6 6 0 0 0-6-6z"
        ],
        "hourglass": [
            384,
            512,
            [],
            "f254",
            "M368 48h4c6.627 0 12-5.373 12-12V12c0-6.627-5.373-12-12-12H12C5.373 0 0 5.373 0 12v24c0 6.627 5.373 12 12 12h4c0 80.564 32.188 165.807 97.18 208C47.899 298.381 16 383.9 16 464h-4c-6.627 0-12 5.373-12 12v24c0 6.627 5.373 12 12 12h360c6.627 0 12-5.373 12-12v-24c0-6.627-5.373-12-12-12h-4c0-80.564-32.188-165.807-97.18-208C336.102 213.619 368 128.1 368 48zM64 48h256c0 101.62-57.307 184-128 184S64 149.621 64 48zm256 416H64c0-101.62 57.308-184 128-184s128 82.38 128 184z"
        ],
        "id-badge": [
            384,
            512,
            [],
            "f2c1",
            "M336 0H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm0 464H48V48h288v416zM144 112h96c8.8 0 16-7.2 16-16s-7.2-16-16-16h-96c-8.8 0-16 7.2-16 16s7.2 16 16 16zm48 176c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64zm-89.6 128h179.2c12.4 0 22.4-8.6 22.4-19.2v-19.2c0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6v19.2c0 10.6 10 19.2 22.4 19.2z"
        ],
        "id-card": [
            576,
            512,
            [],
            "f2c2",
            "M528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 400H303.2c.9-4.5.8 3.6.8-22.4 0-31.8-30.1-57.6-67.2-57.6-10.8 0-18.7 8-44.8 8-26.9 0-33.4-8-44.8-8-37.1 0-67.2 25.8-67.2 57.6 0 26-.2 17.9.8 22.4H48V144h480v288zm-168-80h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm0-64h112c4.4 0 8-3.6 8-8v-16c0-4.4-3.6-8-8-8H360c-4.4 0-8 3.6-8 8v16c0 4.4 3.6 8 8 8zm-168 96c35.3 0 64-28.7 64-64s-28.7-64-64-64-64 28.7-64 64 28.7 64 64 64z"
        ],
        "image": [
            512,
            512,
            [],
            "f03e",
            "M464 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm-6 336H54a6 6 0 0 1-6-6V118a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v276a6 6 0 0 1-6 6zM128 152c-22.091 0-40 17.909-40 40s17.909 40 40 40 40-17.909 40-40-17.909-40-40-40zM96 352h320v-80l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L192 304l-39.515-39.515c-4.686-4.686-12.284-4.686-16.971 0L96 304v48z"
        ],
        "images": [
            576,
            512,
            [],
            "f302",
            "M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v48H54a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6v-10h48zm42-336H150a6 6 0 0 0-6 6v244a6 6 0 0 0 6 6h372a6 6 0 0 0 6-6V86a6 6 0 0 0-6-6zm6-48c26.51 0 48 21.49 48 48v256c0 26.51-21.49 48-48 48H144c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h384zM264 144c0 22.091-17.909 40-40 40s-40-17.909-40-40 17.909-40 40-40 40 17.909 40 40zm-72 96l39.515-39.515c4.686-4.686 12.284-4.686 16.971 0L288 240l103.515-103.515c4.686-4.686 12.284-4.686 16.971 0L480 208v80H192v-48z"
        ],
        "keyboard": [
            576,
            512,
            [],
            "f11c",
            "M528 64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h480c26.51 0 48-21.49 48-48V112c0-26.51-21.49-48-48-48zm8 336c0 4.411-3.589 8-8 8H48c-4.411 0-8-3.589-8-8V112c0-4.411 3.589-8 8-8h480c4.411 0 8 3.589 8 8v288zM170 270v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm-336 82v-28c0-6.627-5.373-12-12-12H82c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm384 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zM122 188v-28c0-6.627-5.373-12-12-12H82c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm96 0v-28c0-6.627-5.373-12-12-12h-28c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h28c6.627 0 12-5.373 12-12zm-98 158v-16c0-6.627-5.373-12-12-12H180c-6.627 0-12 5.373-12 12v16c0 6.627 5.373 12 12 12h216c6.627 0 12-5.373 12-12z"
        ],
        "kiss": [
            496,
            512,
            [],
            "f596",
            "M168 176c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm136 132c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36C290.6 335.3 304 321 304 308zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm80-280c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
        ],
        "kiss-beam": [
            496,
            512,
            [],
            "f597",
            "M168 152c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2 7.2 5.6 8.3 3.5 1 7.5-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 5.9-4.5 5.6-8.3-3.1-42.1-32-71.4-55.8-71.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm56-148c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36C290.6 335.3 304 321 304 308zm24-156c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2 7.2 5.6 8.3 3.5 1 7.5-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 5.9-4.5 5.6-8.3-3.1-42.1-32-71.4-55.8-71.4z"
        ],
        "kiss-wink-heart": [
            504,
            512,
            [],
            "f598",
            "M304 308.5c0-19.2-28.8-41.5-71.5-44-3.8-.4-7.4 2.4-8.2 6.2-.9 3.8 1.1 7.7 4.7 9.2l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-5.7 2.4-6 12.2 0 14.8l16.9 7.2c13 5.5 20.8 13.5 20.8 21.5s-7.8 16-20.7 21.5l-17 7.2c-3.6 1.5-5.6 5.4-4.7 9.2.8 3.6 4.1 6.2 7.8 6.2h.5c42.8-2.5 71.5-24.8 71.5-44 0-13-13.4-27.3-35.2-36 21.7-9.1 35.1-23.4 35.1-36.4zm70.5-83.5l9.5 8.5c3.8 3.3 9.3 4 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-4-25.2-34.2-42.1-59.8-42.1s-55.9 16.9-59.8 42.1c-.8 5 1.7 10 6.1 12.4 5.8 3.1 11.2.7 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0zM136 208.5c0 17.7 14.3 32 32 32s32-14.3 32-32-14.3-32-32-32-32 14.3-32 32zm365.1 194c-8-20.8-31.5-31.5-53.1-25.9l-8.4 2.2-2.3-8.4c-5.9-21.4-27-36.5-49-33-25.2 4-40.6 28.6-34 52.6l22.9 82.6c1.5 5.3 7 8.5 12.4 7.1l83-21.5c24.1-6.3 37.7-31.8 28.5-55.7zM334 436.3c-26.1 12.5-55.2 19.7-86 19.7-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200c0 22.1-3.7 43.3-10.4 63.2 9 6.4 17 14.2 22.6 23.9 6.4.1 12.6 1.4 18.6 2.9 10.9-27.9 17.1-58.2 17.1-90C496 119 385 8 248 8S0 119 0 256s111 248 248 248c35.4 0 68.9-7.5 99.4-20.9-2.5-7.3 4.3 17.2-13.4-46.8z"
        ],
        "laugh": [
            496,
            512,
            [],
            "f599",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM328 224c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm-160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm194.4 64H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
        ],
        "laugh-beam": [
            496,
            512,
            [],
            "f59a",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM328 152c-23.8 0-52.7 29.3-56 71.4-.7 8.6 10.8 11.9 14.9 4.5l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c4.1 7.4 15.6 4 14.9-4.5-3.1-42.1-32-71.4-55.8-71.4zm-201 75.9l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c4.1 7.4 15.6 4 14.9-4.5-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.6 8.5 10.9 11.9 15.1 4.5zM362.4 288H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
        ],
        "laugh-squint": [
            496,
            512,
            [],
            "f59b",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6S48 309.4 48 256s20.8-103.6 58.6-141.4S194.6 56 248 56s103.6 20.8 141.4 58.6S448 202.6 448 256s-20.8 103.6-58.6 141.4zM343.6 196l33.6-40.3c8.6-10.3-3.8-24.8-15.4-18l-80 48c-7.8 4.7-7.8 15.9 0 20.6l80 48c11.5 6.8 24-7.6 15.4-18L343.6 196zm-209.4 58.3l80-48c7.8-4.7 7.8-15.9 0-20.6l-80-48c-11.6-6.9-24 7.7-15.4 18l33.6 40.3-33.6 40.3c-8.7 10.4 3.8 24.8 15.4 18zM362.4 288H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
        ],
        "laugh-wink": [
            496,
            512,
            [],
            "f59c",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm141.4 389.4c-37.8 37.8-88 58.6-141.4 58.6s-103.6-20.8-141.4-58.6C68.8 359.6 48 309.4 48 256s20.8-103.6 58.6-141.4C144.4 76.8 194.6 56 248 56s103.6 20.8 141.4 58.6c37.8 37.8 58.6 88 58.6 141.4s-20.8 103.6-58.6 141.4zM328 164c-25.7 0-55.9 16.9-59.9 42.1-1.7 11.2 11.5 18.2 19.8 10.8l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c8.5 7.4 21.6.3 19.8-10.8-3.8-25.2-34-42.1-59.7-42.1zm-160 60c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm194.4 64H133.6c-8.2 0-14.5 7-13.5 15 7.5 59.2 58.9 105 121.1 105h13.6c62.2 0 113.6-45.8 121.1-105 1-8-5.3-15-13.5-15z"
        ],
        "lemon": [
            512,
            512,
            [],
            "f094",
            "M484.112 27.889C455.989-.233 416.108-8.057 387.059 8.865 347.604 31.848 223.504-41.111 91.196 91.197-41.277 223.672 31.923 347.472 8.866 387.058c-16.922 29.051-9.1 68.932 19.022 97.054 28.135 28.135 68.011 35.938 97.057 19.021 39.423-22.97 163.557 49.969 295.858-82.329 132.474-132.477 59.273-256.277 82.331-295.861 16.922-29.05 9.1-68.931-19.022-97.054zm-22.405 72.894c-38.8 66.609 45.6 165.635-74.845 286.08-120.44 120.443-219.475 36.048-286.076 74.843-22.679 13.207-64.035-27.241-50.493-50.488 38.8-66.609-45.6-165.635 74.845-286.08C245.573 4.702 344.616 89.086 411.219 50.292c22.73-13.24 64.005 27.288 50.488 50.491zm-169.861 8.736c1.37 10.96-6.404 20.957-17.365 22.327-54.846 6.855-135.779 87.787-142.635 142.635-1.373 10.989-11.399 18.734-22.326 17.365-10.961-1.37-18.735-11.366-17.365-22.326 9.162-73.286 104.167-168.215 177.365-177.365 10.953-1.368 20.956 6.403 22.326 17.364z"
        ],
        "life-ring": [
            512,
            512,
            [],
            "f1cd",
            "M256 504c136.967 0 248-111.033 248-248S392.967 8 256 8 8 119.033 8 256s111.033 248 248 248zm-103.398-76.72l53.411-53.411c31.806 13.506 68.128 13.522 99.974 0l53.411 53.411c-63.217 38.319-143.579 38.319-206.796 0zM336 256c0 44.112-35.888 80-80 80s-80-35.888-80-80 35.888-80 80-80 80 35.888 80 80zm91.28 103.398l-53.411-53.411c13.505-31.806 13.522-68.128 0-99.974l53.411-53.411c38.319 63.217 38.319 143.579 0 206.796zM359.397 84.72l-53.411 53.411c-31.806-13.505-68.128-13.522-99.973 0L152.602 84.72c63.217-38.319 143.579-38.319 206.795 0zM84.72 152.602l53.411 53.411c-13.506 31.806-13.522 68.128 0 99.974L84.72 359.398c-38.319-63.217-38.319-143.579 0-206.796z"
        ],
        "lightbulb": [
            352,
            512,
            [],
            "f0eb",
            "M176 80c-52.94 0-96 43.06-96 96 0 8.84 7.16 16 16 16s16-7.16 16-16c0-35.3 28.72-64 64-64 8.84 0 16-7.16 16-16s-7.16-16-16-16zM96.06 459.17c0 3.15.93 6.22 2.68 8.84l24.51 36.84c2.97 4.46 7.97 7.14 13.32 7.14h78.85c5.36 0 10.36-2.68 13.32-7.14l24.51-36.84c1.74-2.62 2.67-5.7 2.68-8.84l.05-43.18H96.02l.04 43.18zM176 0C73.72 0 0 82.97 0 176c0 44.37 16.45 84.85 43.56 115.78 16.64 18.99 42.74 58.8 52.42 92.16v.06h48v-.12c-.01-4.77-.72-9.51-2.15-14.07-5.59-17.81-22.82-64.77-62.17-109.67-20.54-23.43-31.52-53.15-31.61-84.14-.2-73.64 59.67-128 127.95-128 70.58 0 128 57.42 128 128 0 30.97-11.24 60.85-31.65 84.14-39.11 44.61-56.42 91.47-62.1 109.46a47.507 47.507 0 0 0-2.22 14.3v.1h48v-.05c9.68-33.37 35.78-73.18 52.42-92.16C335.55 260.85 352 220.37 352 176 352 78.8 273.2 0 176 0z"
        ],
        "list-alt": [
            512,
            512,
            [],
            "f022",
            "M464 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V80c0-26.51-21.49-48-48-48zm-6 400H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h404a6 6 0 0 1 6 6v340a6 6 0 0 1-6 6zm-42-92v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm0-96v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm0-96v24c0 6.627-5.373 12-12 12H204c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h200c6.627 0 12 5.373 12 12zm-252 12c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36zm0 96c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36zm0 96c0 19.882-16.118 36-36 36s-36-16.118-36-36 16.118-36 36-36 36 16.118 36 36z"
        ],
        "map": [
            576,
            512,
            [],
            "f279",
            "M560.02 32c-1.96 0-3.98.37-5.96 1.16L384.01 96H384L212 35.28A64.252 64.252 0 0 0 191.76 32c-6.69 0-13.37 1.05-19.81 3.14L20.12 87.95A32.006 32.006 0 0 0 0 117.66v346.32C0 473.17 7.53 480 15.99 480c1.96 0 3.97-.37 5.96-1.16L192 416l172 60.71a63.98 63.98 0 0 0 40.05.15l151.83-52.81A31.996 31.996 0 0 0 576 394.34V48.02c0-9.19-7.53-16.02-15.98-16.02zM224 90.42l128 45.19v285.97l-128-45.19V90.42zM48 418.05V129.07l128-44.53v286.2l-.64.23L48 418.05zm480-35.13l-128 44.53V141.26l.64-.24L528 93.95v288.97z"
        ],
        "meh": [
            496,
            512,
            [],
            "f11a",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm8 144H160c-13.2 0-24 10.8-24 24s10.8 24 24 24h176c13.2 0 24-10.8 24-24s-10.8-24-24-24z"
        ],
        "meh-blank": [
            496,
            512,
            [],
            "f5a4",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-280c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm160 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
        ],
        "meh-rolling-eyes": [
            496,
            512,
            [],
            "f5a5",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm88-304c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm0 112c-22.1 0-40-17.9-40-40 0-13.6 7.3-25.1 17.7-32.3-1 2.6-1.7 5.3-1.7 8.3 0 13.3 10.7 24 24 24s24-10.7 24-24c0-2.9-.7-5.7-1.7-8.3 10.4 7.2 17.7 18.7 17.7 32.3 0 22.1-17.9 40-40 40zm-104-40c0-39.8-32.2-72-72-72s-72 32.2-72 72 32.2 72 72 72 72-32.2 72-72zm-112 0c0-13.6 7.3-25.1 17.7-32.3-1 2.6-1.7 5.3-1.7 8.3 0 13.3 10.7 24 24 24s24-10.7 24-24c0-2.9-.7-5.7-1.7-8.3 10.4 7.2 17.7 18.7 17.7 32.3 0 22.1-17.9 40-40 40s-40-17.9-40-40zm192 128H184c-13.2 0-24 10.8-24 24s10.8 24 24 24h128c13.2 0 24-10.8 24-24s-10.8-24-24-24z"
        ],
        "minus-square": [
            448,
            512,
            [],
            "f146",
            "M108 284c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h232c6.6 0 12 5.4 12 12v32c0 6.6-5.4 12-12 12H108zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
        ],
        "money-bill-alt": [
            640,
            512,
            [],
            "f3d1",
            "M320 144c-53.02 0-96 50.14-96 112 0 61.85 42.98 112 96 112 53 0 96-50.13 96-112 0-61.86-42.98-112-96-112zm40 168c0 4.42-3.58 8-8 8h-64c-4.42 0-8-3.58-8-8v-16c0-4.42 3.58-8 8-8h16v-55.44l-.47.31a7.992 7.992 0 0 1-11.09-2.22l-8.88-13.31a7.992 7.992 0 0 1 2.22-11.09l15.33-10.22a23.99 23.99 0 0 1 13.31-4.03H328c4.42 0 8 3.58 8 8v88h16c4.42 0 8 3.58 8 8v16zM608 64H32C14.33 64 0 78.33 0 96v320c0 17.67 14.33 32 32 32h576c17.67 0 32-14.33 32-32V96c0-17.67-14.33-32-32-32zm-16 272c-35.35 0-64 28.65-64 64H112c0-35.35-28.65-64-64-64V176c35.35 0 64-28.65 64-64h416c0 35.35 28.65 64 64 64v160z"
        ],
        "moon": [
            512,
            512,
            [],
            "f186",
            "M279.135 512c78.756 0 150.982-35.804 198.844-94.775 28.27-34.831-2.558-85.722-46.249-77.401-82.348 15.683-158.272-47.268-158.272-130.792 0-48.424 26.06-92.292 67.434-115.836 38.745-22.05 28.999-80.788-15.022-88.919A257.936 257.936 0 0 0 279.135 0c-141.36 0-256 114.575-256 256 0 141.36 114.576 256 256 256zm0-464c12.985 0 25.689 1.201 38.016 3.478-54.76 31.163-91.693 90.042-91.693 157.554 0 113.848 103.641 199.2 215.252 177.944C402.574 433.964 344.366 464 279.135 464c-114.875 0-208-93.125-208-208s93.125-208 208-208z"
        ],
        "newspaper": [
            576,
            512,
            [],
            "f1ea",
            "M552 64H112c-20.858 0-38.643 13.377-45.248 32H24c-13.255 0-24 10.745-24 24v272c0 30.928 25.072 56 56 56h496c13.255 0 24-10.745 24-24V88c0-13.255-10.745-24-24-24zM48 392V144h16v248c0 4.411-3.589 8-8 8s-8-3.589-8-8zm480 8H111.422c.374-2.614.578-5.283.578-8V112h416v288zM172 280h136c6.627 0 12-5.373 12-12v-96c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v96c0 6.627 5.373 12 12 12zm28-80h80v40h-80v-40zm-40 140v-24c0-6.627 5.373-12 12-12h136c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H172c-6.627 0-12-5.373-12-12zm192 0v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12zm0-144v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12zm0 72v-24c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H364c-6.627 0-12-5.373-12-12z"
        ],
        "object-group": [
            512,
            512,
            [],
            "f247",
            "M500 128c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12H96V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v72c0 6.627 5.373 12 12 12h12v256H12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h320v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12V128h12zm-52-64h32v32h-32V64zM32 64h32v32H32V64zm32 384H32v-32h32v32zm416 0h-32v-32h32v32zm-40-64h-12c-6.627 0-12 5.373-12 12v12H96v-12c0-6.627-5.373-12-12-12H72V128h12c6.627 0 12-5.373 12-12v-12h320v12c0 6.627 5.373 12 12 12h12v256zm-36-192h-84v-52c0-6.628-5.373-12-12-12H108c-6.627 0-12 5.372-12 12v168c0 6.628 5.373 12 12 12h84v52c0 6.628 5.373 12 12 12h200c6.627 0 12-5.372 12-12V204c0-6.628-5.373-12-12-12zm-268-24h144v112H136V168zm240 176H232v-24h76c6.627 0 12-5.372 12-12v-76h56v112z"
        ],
        "object-ungroup": [
            576,
            512,
            [],
            "f248",
            "M564 224c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12h-88v-24h12c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12h-72c-6.627 0-12 5.373-12 12v12H96V44c0-6.627-5.373-12-12-12H12C5.373 32 0 37.373 0 44v72c0 6.627 5.373 12 12 12h12v160H12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h88v24h-12c-6.627 0-12 5.373-12 12v72c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-12h224v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12V224h12zM352 64h32v32h-32V64zm0 256h32v32h-32v-32zM64 352H32v-32h32v32zm0-256H32V64h32v32zm32 216v-12c0-6.627-5.373-12-12-12H72V128h12c6.627 0 12-5.373 12-12v-12h224v12c0 6.627 5.373 12 12 12h12v160h-12c-6.627 0-12 5.373-12 12v12H96zm128 136h-32v-32h32v32zm280-64h-12c-6.627 0-12 5.373-12 12v12H256v-12c0-6.627-5.373-12-12-12h-12v-24h88v12c0 6.627 5.373 12 12 12h72c6.627 0 12-5.373 12-12v-72c0-6.627-5.373-12-12-12h-12v-88h88v12c0 6.627 5.373 12 12 12h12v160zm40 64h-32v-32h32v32zm0-256h-32v-32h32v32z"
        ],
        "paper-plane": [
            512,
            512,
            [],
            "f1d8",
            "M440 6.5L24 246.4c-34.4 19.9-31.1 70.8 5.7 85.9L144 379.6V464c0 46.4 59.2 65.5 86.6 28.6l43.8-59.1 111.9 46.2c5.9 2.4 12.1 3.6 18.3 3.6 8.2 0 16.3-2.1 23.6-6.2 12.8-7.2 21.6-20 23.9-34.5l59.4-387.2c6.1-40.1-36.9-68.8-71.5-48.9zM192 464v-64.6l36.6 15.1L192 464zm212.6-28.7l-153.8-63.5L391 169.5c10.7-15.5-9.5-33.5-23.7-21.2L155.8 332.6 48 288 464 48l-59.4 387.3z"
        ],
        "pause-circle": [
            512,
            512,
            [],
            "f28b",
            "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm96-280v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16zm-112 0v160c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16z"
        ],
        "play-circle": [
            512,
            512,
            [],
            "f144",
            "M371.7 238l-176-107c-15.8-8.8-35.7 2.5-35.7 21v208c0 18.4 19.8 29.8 35.7 21l176-101c16.4-9.1 16.4-32.8 0-42zM504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256z"
        ],
        "plus-square": [
            448,
            512,
            [],
            "f0fe",
            "M352 240v32c0 6.6-5.4 12-12 12h-88v88c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-88h-88c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h88v-88c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v88h88c6.6 0 12 5.4 12 12zm96-160v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z"
        ],
        "question-circle": [
            512,
            512,
            [],
            "f059",
            "M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm107.244-255.2c0 67.052-72.421 68.084-72.421 92.863V300c0 6.627-5.373 12-12 12h-45.647c-6.627 0-12-5.373-12-12v-8.659c0-35.745 27.1-50.034 47.579-61.516 17.561-9.845 28.324-16.541 28.324-29.579 0-17.246-21.999-28.693-39.784-28.693-23.189 0-33.894 10.977-48.942 29.969-4.057 5.12-11.46 6.071-16.666 2.124l-27.824-21.098c-5.107-3.872-6.251-11.066-2.644-16.363C184.846 131.491 214.94 112 261.794 112c49.071 0 101.45 38.304 101.45 88.8zM298 368c0 23.159-18.841 42-42 42s-42-18.841-42-42 18.841-42 42-42 42 18.841 42 42z"
        ],
        "registered": [
            512,
            512,
            [],
            "f25d",
            "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 448c-110.532 0-200-89.451-200-200 0-110.531 89.451-200 200-200 110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200zm110.442-81.791c-53.046-96.284-50.25-91.468-53.271-96.085 24.267-13.879 39.482-41.563 39.482-73.176 0-52.503-30.247-85.252-101.498-85.252h-78.667c-6.617 0-12 5.383-12 12V380c0 6.617 5.383 12 12 12h38.568c6.617 0 12-5.383 12-12v-83.663h31.958l47.515 89.303a11.98 11.98 0 0 0 10.593 6.36h42.81c9.14 0 14.914-9.799 10.51-17.791zM256.933 239.906h-33.875v-64.14h27.377c32.417 0 38.929 12.133 38.929 31.709-.001 20.913-11.518 32.431-32.431 32.431z"
        ],
        "sad-cry": [
            496,
            512,
            [],
            "f5b3",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm144 386.4V280c0-13.2-10.8-24-24-24s-24 10.8-24 24v151.4C315.5 447 282.8 456 248 456s-67.5-9-96-24.6V280c0-13.2-10.8-24-24-24s-24 10.8-24 24v114.4c-34.6-36-56-84.7-56-138.4 0-110.3 89.7-200 200-200s200 89.7 200 200c0 53.7-21.4 102.5-56 138.4zM205.8 234.5c4.4-2.4 6.9-7.4 6.1-12.4-4-25.2-34.2-42.1-59.8-42.1s-55.9 16.9-59.8 42.1c-.8 5 1.7 10 6.1 12.4 4.4 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.3 7.9 4.8 13.7 1.6zM344 180c-25.7 0-55.9 16.9-59.8 42.1-.8 5 1.7 10 6.1 12.4 4.5 2.4 9.9 1.8 13.7-1.6l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c2.5 2.2 8 4.7 13.7 1.6 4.4-2.4 6.9-7.4 6.1-12.4-3.9-25.2-34.1-42.1-59.8-42.1zm-96 92c-30.9 0-56 28.7-56 64s25.1 64 56 64 56-28.7 56-64-25.1-64-56-64z"
        ],
        "sad-tear": [
            496,
            512,
            [],
            "f5b4",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm8-152c-13.2 0-24 10.8-24 24s10.8 24 24 24c23.8 0 46.3 10.5 61.6 28.8 8.1 9.8 23.2 11.9 33.8 3.1 10.2-8.5 11.6-23.6 3.1-33.8C330 320.8 294.1 304 256 304zm-88-64c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-64c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-165.6 98.8C151 290.1 126 325.4 126 342.9c0 22.7 18.8 41.1 42 41.1s42-18.4 42-41.1c0-17.5-25-52.8-36.4-68.1-2.8-3.7-8.4-3.7-11.2 0z"
        ],
        "save": [
            448,
            512,
            [],
            "f0c7",
            "M433.941 129.941l-83.882-83.882A48 48 0 0 0 316.118 32H48C21.49 32 0 53.49 0 80v352c0 26.51 21.49 48 48 48h352c26.51 0 48-21.49 48-48V163.882a48 48 0 0 0-14.059-33.941zM272 80v80H144V80h128zm122 352H54a6 6 0 0 1-6-6V86a6 6 0 0 1 6-6h42v104c0 13.255 10.745 24 24 24h176c13.255 0 24-10.745 24-24V83.882l78.243 78.243a6 6 0 0 1 1.757 4.243V426a6 6 0 0 1-6 6zM224 232c-48.523 0-88 39.477-88 88s39.477 88 88 88 88-39.477 88-88-39.477-88-88-88zm0 128c-22.056 0-40-17.944-40-40s17.944-40 40-40 40 17.944 40 40-17.944 40-40 40z"
        ],
        "share-square": [
            576,
            512,
            [],
            "f14d",
            "M561.938 158.06L417.94 14.092C387.926-15.922 336 5.097 336 48.032v57.198c-42.45 1.88-84.03 6.55-120.76 17.99-35.17 10.95-63.07 27.58-82.91 49.42C108.22 199.2 96 232.6 96 271.94c0 61.697 33.178 112.455 84.87 144.76 37.546 23.508 85.248-12.651 71.02-55.74-15.515-47.119-17.156-70.923 84.11-78.76V336c0 42.993 51.968 63.913 81.94 33.94l143.998-144c18.75-18.74 18.75-49.14 0-67.88zM384 336V232.16C255.309 234.082 166.492 255.35 206.31 376 176.79 357.55 144 324.08 144 271.94c0-109.334 129.14-118.947 240-119.85V48l144 144-144 144zm24.74 84.493a82.658 82.658 0 0 0 20.974-9.303c7.976-4.952 18.286.826 18.286 10.214V464c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h132c6.627 0 12 5.373 12 12v4.486c0 4.917-2.987 9.369-7.569 11.152-13.702 5.331-26.396 11.537-38.05 18.585a12.138 12.138 0 0 1-6.28 1.777H54a6 6 0 0 0-6 6v340a6 6 0 0 0 6 6h340a6 6 0 0 0 6-6v-25.966c0-5.37 3.579-10.059 8.74-11.541z"
        ],
        "smile": [
            496,
            512,
            [],
            "f118",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm-80-216c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160 0c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm4 72.6c-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.7-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8-10.1-8.4-25.3-7.1-33.8 3.1z"
        ],
        "smile-beam": [
            496,
            512,
            [],
            "f5b8",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm84-143.4c-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.6-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8-10.2-8.4-25.3-7.1-33.8 3.1zM136.5 211c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4s-52.7 29.3-56 71.4c-.3 3.7 2.1 7.2 5.7 8.3 3.4 1.1 7.4-.5 9.3-3.7l9.5-17zM328 152c-23.8 0-52.7 29.3-56 71.4-.3 3.7 2.1 7.2 5.7 8.3 3.5 1.1 7.4-.5 9.3-3.7l9.5-17c7.7-13.7 19.2-21.6 31.5-21.6s23.8 7.9 31.5 21.6l9.5 17c2.1 3.7 6.2 4.7 9.3 3.7 3.6-1.1 6-4.5 5.7-8.3-3.3-42.1-32.2-71.4-56-71.4z"
        ],
        "smile-wink": [
            496,
            512,
            [],
            "f4da",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm117.8-146.4c-10.2-8.5-25.3-7.1-33.8 3.1-20.8 25-51.5 39.4-84 39.4s-63.2-14.3-84-39.4c-8.5-10.2-23.7-11.5-33.8-3.1-10.2 8.5-11.5 23.6-3.1 33.8 30 36 74.1 56.6 120.9 56.6s90.9-20.6 120.9-56.6c8.5-10.2 7.1-25.3-3.1-33.8zM168 240c17.7 0 32-14.3 32-32s-14.3-32-32-32-32 14.3-32 32 14.3 32 32 32zm160-60c-25.7 0-55.9 16.9-59.9 42.1-1.7 11.2 11.5 18.2 19.8 10.8l9.5-8.5c14.8-13.2 46.2-13.2 61 0l9.5 8.5c8.5 7.4 21.6.3 19.8-10.8-3.8-25.2-34-42.1-59.7-42.1z"
        ],
        "snowflake": [
            448,
            512,
            [],
            "f2dc",
            "M440.1 355.2l-39.2-23 34.1-9.3c8.4-2.3 13.4-11.1 11.1-19.6l-4.1-15.5c-2.2-8.5-10.9-13.6-19.3-11.3L343 298.2 271.2 256l71.9-42.2 79.7 21.7c8.4 2.3 17-2.8 19.3-11.3l4.1-15.5c2.2-8.5-2.7-17.3-11.1-19.6l-34.1-9.3 39.2-23c7.5-4.4 10.1-14.2 5.8-21.9l-7.9-13.9c-4.3-7.7-14-10.3-21.5-5.9l-39.2 23 9.1-34.7c2.2-8.5-2.7-17.3-11.1-19.6l-15.2-4.1c-8.4-2.3-17 2.8-19.3 11.3l-21.3 81-71.9 42.2v-84.5L306 70.4c6.1-6.2 6.1-16.4 0-22.6l-11.1-11.3c-6.1-6.2-16.1-6.2-22.2 0l-24.9 25.4V16c0-8.8-7-16-15.7-16h-15.7c-8.7 0-15.7 7.2-15.7 16v46.1l-24.9-25.4c-6.1-6.2-16.1-6.2-22.2 0L142.1 48c-6.1 6.2-6.1 16.4 0 22.6l58.3 59.3v84.5l-71.9-42.2-21.3-81c-2.2-8.5-10.9-13.6-19.3-11.3L72.7 84c-8.4 2.3-13.4 11.1-11.1 19.6l9.1 34.7-39.2-23c-7.5-4.4-17.1-1.8-21.5 5.9l-7.9 13.9c-4.3 7.7-1.8 17.4 5.8 21.9l39.2 23-34.1 9.1c-8.4 2.3-13.4 11.1-11.1 19.6L6 224.2c2.2 8.5 10.9 13.6 19.3 11.3l79.7-21.7 71.9 42.2-71.9 42.2-79.7-21.7c-8.4-2.3-17 2.8-19.3 11.3l-4.1 15.5c-2.2 8.5 2.7 17.3 11.1 19.6l34.1 9.3-39.2 23c-7.5 4.4-10.1 14.2-5.8 21.9L10 391c4.3 7.7 14 10.3 21.5 5.9l39.2-23-9.1 34.7c-2.2 8.5 2.7 17.3 11.1 19.6l15.2 4.1c8.4 2.3 17-2.8 19.3-11.3l21.3-81 71.9-42.2v84.5l-58.3 59.3c-6.1 6.2-6.1 16.4 0 22.6l11.1 11.3c6.1 6.2 16.1 6.2 22.2 0l24.9-25.4V496c0 8.8 7 16 15.7 16h15.7c8.7 0 15.7-7.2 15.7-16v-46.1l24.9 25.4c6.1 6.2 16.1 6.2 22.2 0l11.1-11.3c6.1-6.2 6.1-16.4 0-22.6l-58.3-59.3v-84.5l71.9 42.2 21.3 81c2.2 8.5 10.9 13.6 19.3 11.3L375 428c8.4-2.3 13.4-11.1 11.1-19.6l-9.1-34.7 39.2 23c7.5 4.4 17.1 1.8 21.5-5.9l7.9-13.9c4.6-7.5 2.1-17.3-5.5-21.7z"
        ],
        "square": [
            448,
            512,
            [],
            "f0c8",
            "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6z"
        ],
        "star": [
            576,
            512,
            [],
            "f005",
            "M528.1 171.5L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6zM388.6 312.3l23.7 138.4L288 385.4l-124.3 65.3 23.7-138.4-100.6-98 139-20.2 62.2-126 62.2 126 139 20.2-100.6 98z"
        ],
        "star-half": [
            576,
            512,
            [],
            "f089",
            "M288 385.3l-124.3 65.4 23.7-138.4-100.6-98 139-20.2 62.2-126V0c-11.4 0-22.8 5.9-28.7 17.8L194 150.2 47.9 171.4c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.1 23 46 46.4 33.7L288 439.6v-54.3z"
        ],
        "sticky-note": [
            448,
            512,
            [],
            "f249",
            "M448 348.106V80c0-26.51-21.49-48-48-48H48C21.49 32 0 53.49 0 80v351.988c0 26.51 21.49 48 48 48h268.118a48 48 0 0 0 33.941-14.059l83.882-83.882A48 48 0 0 0 448 348.106zm-128 80v-76.118h76.118L320 428.106zM400 80v223.988H296c-13.255 0-24 10.745-24 24v104H48V80h352z"
        ],
        "stop-circle": [
            512,
            512,
            [],
            "f28d",
            "M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256zm296-80v160c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16z"
        ],
        "sun": [
            512,
            512,
            [],
            "f185",
            "M494.2 221.9l-59.8-40.5 13.7-71c2.6-13.2-1.6-26.8-11.1-36.4-9.6-9.5-23.2-13.7-36.2-11.1l-70.9 13.7-40.4-59.9c-15.1-22.3-51.9-22.3-67 0l-40.4 59.9-70.8-13.7C98 60.4 84.5 64.5 75 74.1c-9.5 9.6-13.7 23.1-11.1 36.3l13.7 71-59.8 40.5C6.6 229.5 0 242 0 255.5s6.7 26 17.8 33.5l59.8 40.5-13.7 71c-2.6 13.2 1.6 26.8 11.1 36.3 9.5 9.5 22.9 13.7 36.3 11.1l70.8-13.7 40.4 59.9C230 505.3 242.6 512 256 512s26-6.7 33.5-17.8l40.4-59.9 70.9 13.7c13.4 2.7 26.8-1.6 36.3-11.1 9.5-9.5 13.6-23.1 11.1-36.3l-13.7-71 59.8-40.5c11.1-7.5 17.8-20.1 17.8-33.5-.1-13.6-6.7-26.1-17.9-33.7zm-112.9 85.6l17.6 91.2-91-17.6L256 458l-51.9-77-90.9 17.6 17.6-91.2-76.8-52 76.8-52-17.6-91.2 91 17.6L256 53l51.9 76.9 91-17.6-17.6 91.1 76.8 52-76.8 52.1zM256 152c-57.3 0-104 46.7-104 104s46.7 104 104 104 104-46.7 104-104-46.7-104-104-104zm0 160c-30.9 0-56-25.1-56-56s25.1-56 56-56 56 25.1 56 56-25.1 56-56 56z"
        ],
        "surprise": [
            496,
            512,
            [],
            "f5c2",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm0-176c-35.3 0-64 28.7-64 64s28.7 64 64 64 64-28.7 64-64-28.7-64-64-64zm-48-72c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32zm128-32c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z"
        ],
        "thumbs-down": [
            512,
            512,
            [],
            "f165",
            "M466.27 225.31c4.674-22.647.864-44.538-8.99-62.99 2.958-23.868-4.021-48.565-17.34-66.99C438.986 39.423 404.117 0 327 0c-7 0-15 .01-22.22.01C201.195.01 168.997 40 128 40h-10.845c-5.64-4.975-13.042-8-21.155-8H32C14.327 32 0 46.327 0 64v240c0 17.673 14.327 32 32 32h64c11.842 0 22.175-6.438 27.708-16h7.052c19.146 16.953 46.013 60.653 68.76 83.4 13.667 13.667 10.153 108.6 71.76 108.6 57.58 0 95.27-31.936 95.27-104.73 0-18.41-3.93-33.73-8.85-46.54h36.48c48.602 0 85.82-41.565 85.82-85.58 0-19.15-4.96-34.99-13.73-49.84zM64 296c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm330.18 16.73H290.19c0 37.82 28.36 55.37 28.36 94.54 0 23.75 0 56.73-47.27 56.73-18.91-18.91-9.46-66.18-37.82-94.54C206.9 342.89 167.28 272 138.92 272H128V85.83c53.611 0 100.001-37.82 171.64-37.82h37.82c35.512 0 60.82 17.12 53.12 65.9 15.2 8.16 26.5 36.44 13.94 57.57 21.581 20.384 18.699 51.065 5.21 65.62 9.45 0 22.36 18.91 22.27 37.81-.09 18.91-16.71 37.82-37.82 37.82z"
        ],
        "thumbs-up": [
            512,
            512,
            [],
            "f164",
            "M466.27 286.69C475.04 271.84 480 256 480 236.85c0-44.015-37.218-85.58-85.82-85.58H357.7c4.92-12.81 8.85-28.13 8.85-46.54C366.55 31.936 328.86 0 271.28 0c-61.607 0-58.093 94.933-71.76 108.6-22.747 22.747-49.615 66.447-68.76 83.4H32c-17.673 0-32 14.327-32 32v240c0 17.673 14.327 32 32 32h64c14.893 0 27.408-10.174 30.978-23.95 44.509 1.001 75.06 39.94 177.802 39.94 7.22 0 15.22.01 22.22.01 77.117 0 111.986-39.423 112.94-95.33 13.319-18.425 20.299-43.122 17.34-66.99 9.854-18.452 13.664-40.343 8.99-62.99zm-61.75 53.83c12.56 21.13 1.26 49.41-13.94 57.57 7.7 48.78-17.608 65.9-53.12 65.9h-37.82c-71.639 0-118.029-37.82-171.64-37.82V240h10.92c28.36 0 67.98-70.89 94.54-97.46 28.36-28.36 18.91-75.63 37.82-94.54 47.27 0 47.27 32.98 47.27 56.73 0 39.17-28.36 56.72-28.36 94.54h103.99c21.11 0 37.73 18.91 37.82 37.82.09 18.9-12.82 37.81-22.27 37.81 13.489 14.555 16.371 45.236-5.21 65.62zM88 432c0 13.255-10.745 24-24 24s-24-10.745-24-24 10.745-24 24-24 24 10.745 24 24z"
        ],
        "times-circle": [
            512,
            512,
            [],
            "f057",
            "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 448c-110.5 0-200-89.5-200-200S145.5 56 256 56s200 89.5 200 200-89.5 200-200 200zm101.8-262.2L295.6 256l62.2 62.2c4.7 4.7 4.7 12.3 0 17l-22.6 22.6c-4.7 4.7-12.3 4.7-17 0L256 295.6l-62.2 62.2c-4.7 4.7-12.3 4.7-17 0l-22.6-22.6c-4.7-4.7-4.7-12.3 0-17l62.2-62.2-62.2-62.2c-4.7-4.7-4.7-12.3 0-17l22.6-22.6c4.7-4.7 12.3-4.7 17 0l62.2 62.2 62.2-62.2c4.7-4.7 12.3-4.7 17 0l22.6 22.6c4.7 4.7 4.7 12.3 0 17z"
        ],
        "tired": [
            496,
            512,
            [],
            "f5c8",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-110.3 0-200-89.7-200-200S137.7 56 248 56s200 89.7 200 200-89.7 200-200 200zm129.1-303.8c-3.8-4.4-10.3-5.4-15.3-2.5l-80 48c-3.6 2.2-5.8 6.1-5.8 10.3s2.2 8.1 5.8 10.3l80 48c5.4 3.2 11.8 1.6 15.3-2.5 3.8-4.5 3.9-11 .1-15.5L343.6 208l33.6-40.3c3.8-4.5 3.7-11.1-.1-15.5zM220 208c0-4.2-2.2-8.1-5.8-10.3l-80-48c-5-3-11.5-1.9-15.3 2.5-3.8 4.5-3.9 11-.1 15.5l33.6 40.3-33.6 40.3c-3.8 4.5-3.7 11 .1 15.5 3.5 4.1 9.9 5.7 15.3 2.5l80-48c3.6-2.2 5.8-6.1 5.8-10.3zm28 64c-45.4 0-100.9 38.3-107.8 93.3-1.5 11.8 6.9 21.6 15.5 17.9C178.4 373.5 212 368 248 368s69.6 5.5 92.3 15.2c8.5 3.7 17-6 15.5-17.9-6.9-55-62.4-93.3-107.8-93.3z"
        ],
        "trash-alt": [
            448,
            512,
            [],
            "f2ed",
            "M268 416h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12zM432 80h-82.41l-34-56.7A48 48 0 0 0 274.41 0H173.59a48 48 0 0 0-41.16 23.3L98.41 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16v336a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM171.84 50.91A6 6 0 0 1 177 48h94a6 6 0 0 1 5.15 2.91L293.61 80H154.39zM368 464H80V128h288zm-212-48h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12z"
        ],
        "user": [
            448,
            512,
            [],
            "f007",
            "M313.6 304c-28.7 0-42.5 16-89.6 16-47.1 0-60.8-16-89.6-16C60.2 304 0 364.2 0 438.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-25.6c0-74.2-60.2-134.4-134.4-134.4zM400 464H48v-25.6c0-47.6 38.8-86.4 86.4-86.4 14.6 0 38.3 16 89.6 16 51.7 0 74.9-16 89.6-16 47.6 0 86.4 38.8 86.4 86.4V464zM224 288c79.5 0 144-64.5 144-144S303.5 0 224 0 80 64.5 80 144s64.5 144 144 144zm0-240c52.9 0 96 43.1 96 96s-43.1 96-96 96-96-43.1-96-96 43.1-96 96-96z"
        ],
        "user-circle": [
            496,
            512,
            [],
            "f2bd",
            "M248 104c-53 0-96 43-96 96s43 96 96 96 96-43 96-96-43-96-96-96zm0 144c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zm0-240C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 448c-49.7 0-95.1-18.3-130.1-48.4 14.9-23 40.4-38.6 69.6-39.5 20.8 6.4 40.6 9.6 60.5 9.6s39.7-3.1 60.5-9.6c29.2 1 54.7 16.5 69.6 39.5-35 30.1-80.4 48.4-130.1 48.4zm162.7-84.1c-24.4-31.4-62.1-51.9-105.1-51.9-10.2 0-26 9.6-57.6 9.6-31.5 0-47.4-9.6-57.6-9.6-42.9 0-80.6 20.5-105.1 51.9C61.9 339.2 48 299.2 48 256c0-110.3 89.7-200 200-200s200 89.7 200 200c0 43.2-13.9 83.2-37.3 115.9z"
        ],
        "window-close": [
            512,
            512,
            [],
            "f410",
            "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 394c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h404c3.3 0 6 2.7 6 6v340zM356.5 194.6L295.1 256l61.4 61.4c4.6 4.6 4.6 12.1 0 16.8l-22.3 22.3c-4.6 4.6-12.1 4.6-16.8 0L256 295.1l-61.4 61.4c-4.6 4.6-12.1 4.6-16.8 0l-22.3-22.3c-4.6-4.6-4.6-12.1 0-16.8l61.4-61.4-61.4-61.4c-4.6-4.6-4.6-12.1 0-16.8l22.3-22.3c4.6-4.6 12.1-4.6 16.8 0l61.4 61.4 61.4-61.4c4.6-4.6 12.1-4.6 16.8 0l22.3 22.3c4.7 4.6 4.7 12.1 0 16.8z"
        ],
        "window-maximize": [
            512,
            512,
            [],
            "f2d0",
            "M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm0 394c0 3.3-2.7 6-6 6H54c-3.3 0-6-2.7-6-6V192h416v234z"
        ],
        "window-minimize": [
            512,
            512,
            [],
            "f2d1",
            "M480 480H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h448c17.7 0 32 14.3 32 32s-14.3 32-32 32z"
        ],
        "window-restore": [
            512,
            512,
            [],
            "f2d2",
            "M464 0H144c-26.5 0-48 21.5-48 48v48H48c-26.5 0-48 21.5-48 48v320c0 26.5 21.5 48 48 48h320c26.5 0 48-21.5 48-48v-48h48c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48zm-96 464H48V256h320v208zm96-96h-48V144c0-26.5-21.5-48-48-48H144V48h320v320z"
        ]
    };
    bunker(function() {
        defineIcons("far", icons);
    });
})();


/*!
 * Font Awesome Free 5.15.4 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 */ (function() {
    "use strict";
    var _WINDOW = {};
    var _DOCUMENT = {};
    try {
        if (typeof window !== "undefined") _WINDOW = window;
        if (typeof document !== "undefined") _DOCUMENT = document;
    } catch (e) {}
    var _ref = _WINDOW.navigator || {}, _ref$userAgent = _ref.userAgent, userAgent = _ref$userAgent === void 0 ? "" : _ref$userAgent;
    var WINDOW = _WINDOW;
    var DOCUMENT = _DOCUMENT;
    var IS_BROWSER = !!WINDOW.document;
    var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === "function" && typeof DOCUMENT.createElement === "function";
    var IS_IE = ~userAgent.indexOf("MSIE") || ~userAgent.indexOf("Trident/");
    var NAMESPACE_IDENTIFIER = "___FONT_AWESOME___";
    var PRODUCTION = function() {
        try {
            return true;
        } catch (e) {
            return false;
        }
    }();
    function bunker(fn) {
        try {
            fn();
        } catch (e) {
            if (!PRODUCTION) throw e;
        }
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function _objectSpread(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            var ownKeys = Object.keys(source);
            if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
            ownKeys.forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
        }
        return target;
    }
    var w = WINDOW || {};
    if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
    if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
    if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
    if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
    var namespace = w[NAMESPACE_IDENTIFIER];
    function defineIcons(prefix, icons) {
        var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var _params$skipHooks = params.skipHooks, skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
        var normalized = Object.keys(icons).reduce(function(acc, iconName) {
            var icon = icons[iconName];
            var expanded = !!icon.icon;
            if (expanded) acc[icon.iconName] = icon.icon;
            else acc[iconName] = icon;
            return acc;
        }, {});
        if (typeof namespace.hooks.addPack === "function" && !skipHooks) namespace.hooks.addPack(prefix, normalized);
        else namespace.styles[prefix] = _objectSpread({}, namespace.styles[prefix] || {}, normalized);
        /**
     * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
     * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
     * for `fas` so we'll easy the upgrade process for our users by automatically defining
     * this as well.
     */ if (prefix === "fas") defineIcons("fa", icons);
    }
    var icons = {
        "500px": [
            448,
            512,
            [],
            "f26e",
            "M103.3 344.3c-6.5-14.2-6.9-18.3 7.4-23.1 25.6-8 8 9.2 43.2 49.2h.3v-93.9c1.2-50.2 44-92.2 97.7-92.2 53.9 0 97.7 43.5 97.7 96.8 0 63.4-60.8 113.2-128.5 93.3-10.5-4.2-2.1-31.7 8.5-28.6 53 0 89.4-10.1 89.4-64.4 0-61-77.1-89.6-116.9-44.6-23.5 26.4-17.6 42.1-17.6 157.6 50.7 31 118.3 22 160.4-20.1 24.8-24.8 38.5-58 38.5-93 0-35.2-13.8-68.2-38.8-93.3-24.8-24.8-57.8-38.5-93.3-38.5s-68.8 13.8-93.5 38.5c-.3.3-16 16.5-21.2 23.9l-.5.6c-3.3 4.7-6.3 9.1-20.1 6.1-6.9-1.7-14.3-5.8-14.3-11.8V20c0-5 3.9-10.5 10.5-10.5h241.3c8.3 0 8.3 11.6 8.3 15.1 0 3.9 0 15.1-8.3 15.1H130.3v132.9h.3c104.2-109.8 282.8-36 282.8 108.9 0 178.1-244.8 220.3-310.1 62.8zm63.3-260.8c-.5 4.2 4.6 24.5 14.6 20.6C306 56.6 384 144.5 390.6 144.5c4.8 0 22.8-15.3 14.3-22.8-93.2-89-234.5-57-238.3-38.2zM393 414.7C283 524.6 94 475.5 61 310.5c0-12.2-30.4-7.4-28.9 3.3 24 173.4 246 256.9 381.6 121.3 6.9-7.8-12.6-28.4-20.7-20.4zM213.6 306.6c0 4 4.3 7.3 5.5 8.5 3 3 6.1 4.4 8.5 4.4 3.8 0 2.6.2 22.3-19.5 19.6 19.3 19.1 19.5 22.3 19.5 5.4 0 18.5-10.4 10.7-18.2L265.6 284l18.2-18.2c6.3-6.8-10.1-21.8-16.2-15.7L249.7 268c-18.6-18.8-18.4-19.5-21.5-19.5-5 0-18 11.7-12.4 17.3L234 284c-18.1 17.9-20.4 19.2-20.4 22.6z"
        ],
        "accessible-icon": [
            448,
            512,
            [],
            "f368",
            "M423.9 255.8L411 413.1c-3.3 40.7-63.9 35.1-60.6-4.9l10-122.5-41.1 2.3c10.1 20.7 15.8 43.9 15.8 68.5 0 41.2-16.1 78.7-42.3 106.5l-39.3-39.3c57.9-63.7 13.1-167.2-74-167.2-25.9 0-49.5 9.9-67.2 26L73 243.2c22-20.7 50.1-35.1 81.4-40.2l75.3-85.7-42.6-24.8-51.6 46c-30 26.8-70.6-18.5-40.5-45.4l68-60.7c9.8-8.8 24.1-10.2 35.5-3.6 0 0 139.3 80.9 139.5 81.1 16.2 10.1 20.7 36 6.1 52.6L285.7 229l106.1-5.9c18.5-1.1 33.6 14.4 32.1 32.7zm-64.9-154c28.1 0 50.9-22.8 50.9-50.9C409.9 22.8 387.1 0 359 0c-28.1 0-50.9 22.8-50.9 50.9 0 28.1 22.8 50.9 50.9 50.9zM179.6 456.5c-80.6 0-127.4-90.6-82.7-156.1l-39.7-39.7C36.4 287 24 320.3 24 356.4c0 130.7 150.7 201.4 251.4 122.5l-39.7-39.7c-16 10.9-35.3 17.3-56.1 17.3z"
        ],
        "accusoft": [
            640,
            512,
            [],
            "f369",
            "M322.1 252v-1l-51.2-65.8s-12 1.6-25 15.1c-9 9.3-242.1 239.1-243.4 240.9-7 10 1.6 6.8 15.7 1.7.8 0 114.5-36.6 114.5-36.6.5-.6-.1-.1.6-.6-.4-5.1-.8-26.2-1-27.7-.6-5.2 2.2-6.9 7-8.9l92.6-33.8c.6-.8 88.5-81.7 90.2-83.3zm160.1 120.1c13.3 16.1 20.7 13.3 30.8 9.3 3.2-1.2 115.4-47.6 117.8-48.9 8-4.3-1.7-16.7-7.2-23.4-2.1-2.5-205.1-245.6-207.2-248.3-9.7-12.2-14.3-12.9-38.4-12.8-10.2 0-106.8.5-116.5.6-19.2.1-32.9-.3-19.2 16.9C250 75 476.5 365.2 482.2 372.1zm152.7 1.6c-2.3-.3-24.6-4.7-38-7.2 0 0-115 50.4-117.5 51.6-16 7.3-26.9-3.2-36.7-14.6l-57.1-74c-5.4-.9-60.4-9.6-65.3-9.3-3.1.2-9.6.8-14.4 2.9-4.9 2.1-145.2 52.8-150.2 54.7-5.1 2-11.4 3.6-11.1 7.6.2 2.5 2 2.6 4.6 3.5 2.7.8 300.9 67.6 308 69.1 15.6 3.3 38.5 10.5 53.6 1.7 2.1-1.2 123.8-76.4 125.8-77.8 5.4-4 4.3-6.8-1.7-8.2z"
        ],
        "acquisitions-incorporated": [
            384,
            512,
            [],
            "f6af",
            "M357.45 468.2c-1.2-7.7-1.3-7.6-9.6-7.6-99.8.2-111.8-2.4-112.7-2.6-12.3-1.7-20.6-10.5-21-23.1-.1-1.6-.2-71.6-1-129.1-.1-4.7 1.6-6.4 5.9-7.5 12.5-3 24.9-6.1 37.3-9.7 4.3-1.3 6.8-.2 8.4 3.5 4.5 10.3 8.8 20.6 13.2 30.9 1.6 3.7.1 4.4-3.4 4.4-10-.2-20-.1-30.4-.1v27h116c-1.4-9.5-2.7-18.1-4-27.5-7 0-13.8.4-20.4-.1-22.6-1.6-18.3-4.4-84-158.6-8.8-20.1-27.9-62.1-36.5-89.2-4.4-14 5.5-25.4 18.9-26.6 18.6-1.7 37.5-1.6 56.2-2 20.6-.4 41.2-.4 61.8-.5 3.1 0 4-1.4 4.3-4.3 1.2-9.8 2.7-19.5 4-29.2.8-5.3 1.6-10.7 2.4-16.1L23.75 0c-3.6 0-5.3 1.1-4.6 5.3 2.2 13.2-.8.8 6.4 45.3 63.4 0 71.8.9 101.8.5 12.3-.2 37 3.5 37.7 22.1.4 11.4-1.1 11.3-32.6 87.4-53.8 129.8-50.7 120.3-67.3 161-1.7 4.1-3.6 5.2-7.6 5.2-8.5-.2-17-.3-25.4.1-1.9.1-5.2 1.8-5.5 3.2-1.5 8.1-2.2 16.3-3.2 24.9h114.3v-27.6c-6.9 0-33.5.4-35.3-2.9 5.3-12.3 10.4-24.4 15.7-36.7 16.3 4 31.9 7.8 47.6 11.7 3.4.9 4.6 3 4.6 6.8-.1 42.9.1 85.9.2 128.8 0 10.2-5.5 19.1-14.9 23.1-6.5 2.7-3.3 3.4-121.4 2.4-5.3 0-7.1 2-7.6 6.8-1.5 12.9-2.9 25.9-5 38.8-.8 5 1.3 5.7 5.3 5.7 183.2.6-30.7 0 337.1 0-2.5-15-4.4-29.4-6.6-43.7zm-174.9-205.7c-13.3-4.2-26.6-8.2-39.9-12.5a44.53 44.53 0 0 1-5.8-2.9c17.2-44.3 34.2-88.1 51.3-132.1 7.5 2.4 7.9-.8 9.4 0 9.3 22.5 18.1 60.1 27 82.8 6.6 16.7 13 33.5 19.7 50.9a35.78 35.78 0 0 1-3.9 2.1c-13.1 3.9-26.4 7.5-39.4 11.7a27.66 27.66 0 0 1-18.4 0z"
        ],
        "adn": [
            496,
            512,
            [],
            "f170",
            "M248 167.5l64.9 98.8H183.1l64.9-98.8zM496 256c0 136.9-111.1 248-248 248S0 392.9 0 256 111.1 8 248 8s248 111.1 248 248zm-99.8 82.7L248 115.5 99.8 338.7h30.4l33.6-51.7h168.6l33.6 51.7h30.2z"
        ],
        "adversal": [
            512,
            512,
            [],
            "f36a",
            "M482.1 32H28.7C5.8 32 0 37.9 0 60.9v390.2C0 474.4 5.8 480 28.7 480h453.4c24.4 0 29.9-5.2 29.9-29.7V62.2c0-24.6-5.4-30.2-29.9-30.2zM178.4 220.3c-27.5-20.2-72.1-8.7-84.2 23.4-4.3 11.1-9.3 9.5-17.5 8.3-9.7-1.5-17.2-3.2-22.5-5.5-28.8-11.4 8.6-55.3 24.9-64.3 41.1-21.4 83.4-22.2 125.3-4.8 40.9 16.8 34.5 59.2 34.5 128.5 2.7 25.8-4.3 58.3 9.3 88.8 1.9 4.4.4 7.9-2.7 10.7-8.4 6.7-39.3 2.2-46.6-7.4-1.9-2.2-1.8-3.6-3.9-6.2-3.6-3.9-7.3-2.2-11.9 1-57.4 36.4-140.3 21.4-147-43.3-3.1-29.3 12.4-57.1 39.6-71 38.2-19.5 112.2-11.8 114-30.9 1.1-10.2-1.9-20.1-11.3-27.3zm286.7 222c0 15.1-11.1 9.9-17.8 9.9H52.4c-7.4 0-18.2 4.8-17.8-10.7.4-13.9 10.5-9.1 17.1-9.1 132.3-.4 264.5-.4 396.8 0 6.8 0 16.6-4.4 16.6 9.9zm3.8-340.5v291c0 5.7-.7 13.9-8.1 13.9-12.4-.4-27.5 7.1-36.1-5.6-5.8-8.7-7.8-4-12.4-1.2-53.4 29.7-128.1 7.1-144.4-85.2-6.1-33.4-.7-67.1 15.7-100 11.8-23.9 56.9-76.1 136.1-30.5v-71c0-26.2-.1-26.2 26-26.2 3.1 0 6.6.4 9.7 0 10.1-.8 13.6 4.4 13.6 14.3-.1.2-.1.3-.1.5zm-51.5 232.3c-19.5 47.6-72.9 43.3-90 5.2-15.1-33.3-15.5-68.2.4-101.5 16.3-34.1 59.7-35.7 81.5-4.8 20.6 28.8 14.9 84.6 8.1 101.1zm-294.8 35.3c-7.5-1.3-33-3.3-33.7-27.8-.4-13.9 7.8-23 19.8-25.8 24.4-5.9 49.3-9.9 73.7-14.7 8.9-2 7.4 4.4 7.8 9.5 1.4 33-26.1 59.2-67.6 58.8z"
        ],
        "affiliatetheme": [
            512,
            512,
            [],
            "f36b",
            "M159.7 237.4C108.4 308.3 43.1 348.2 14 326.6-15.2 304.9 2.8 230 54.2 159.1c51.3-70.9 116.6-110.8 145.7-89.2 29.1 21.6 11.1 96.6-40.2 167.5zm351.2-57.3C437.1 303.5 319 367.8 246.4 323.7c-25-15.2-41.3-41.2-49-73.8-33.6 64.8-92.8 113.8-164.1 133.2 49.8 59.3 124.1 96.9 207 96.9 150 0 271.6-123.1 271.6-274.9.1-8.5-.3-16.8-1-25z"
        ],
        "airbnb": [
            448,
            512,
            [],
            "f834",
            "M224 373.12c-25.24-31.67-40.08-59.43-45-83.18-22.55-88 112.61-88 90.06 0-5.45 24.25-20.29 52-45 83.18zm138.15 73.23c-42.06 18.31-83.67-10.88-119.3-50.47 103.9-130.07 46.11-200-18.85-200-54.92 0-85.16 46.51-73.28 100.5 6.93 29.19 25.23 62.39 54.43 99.5-32.53 36.05-60.55 52.69-85.15 54.92-50 7.43-89.11-41.06-71.3-91.09 15.1-39.16 111.72-231.18 115.87-241.56 15.75-30.07 25.56-57.4 59.38-57.4 32.34 0 43.4 25.94 60.37 59.87 36 70.62 89.35 177.48 114.84 239.09 13.17 33.07-1.37 71.29-37.01 86.64zm47-136.12C280.27 35.93 273.13 32 224 32c-45.52 0-64.87 31.67-84.66 72.79C33.18 317.1 22.89 347.19 22 349.81-3.22 419.14 48.74 480 111.63 480c21.71 0 60.61-6.06 112.37-62.4 58.68 63.78 101.26 62.4 112.37 62.4 62.89.05 114.85-60.86 89.61-130.19.02-3.89-16.82-38.9-16.82-39.58z"
        ],
        "algolia": [
            448,
            512,
            [],
            "f36c",
            "M229.3 182.6c-49.3 0-89.2 39.9-89.2 89.2 0 49.3 39.9 89.2 89.2 89.2s89.2-39.9 89.2-89.2c0-49.3-40-89.2-89.2-89.2zm62.7 56.6l-58.9 30.6c-1.8.9-3.8-.4-3.8-2.3V201c0-1.5 1.3-2.7 2.7-2.6 26.2 1 48.9 15.7 61.1 37.1.7 1.3.2 3-1.1 3.7zM389.1 32H58.9C26.4 32 0 58.4 0 90.9V421c0 32.6 26.4 59 58.9 59H389c32.6 0 58.9-26.4 58.9-58.9V90.9C448 58.4 421.6 32 389.1 32zm-202.6 84.7c0-10.8 8.7-19.5 19.5-19.5h45.3c10.8 0 19.5 8.7 19.5 19.5v15.4c0 1.8-1.7 3-3.3 2.5-12.3-3.4-25.1-5.1-38.1-5.1-13.5 0-26.7 1.8-39.4 5.5-1.7.5-3.4-.8-3.4-2.5v-15.8zm-84.4 37l9.2-9.2c7.6-7.6 19.9-7.6 27.5 0l7.7 7.7c1.1 1.1 1 3-.3 4-6.2 4.5-12.1 9.4-17.6 14.9-5.4 5.4-10.4 11.3-14.8 17.4-1 1.3-2.9 1.5-4 .3l-7.7-7.7c-7.6-7.5-7.6-19.8 0-27.4zm127.2 244.8c-70 0-126.6-56.7-126.6-126.6s56.7-126.6 126.6-126.6c70 0 126.6 56.6 126.6 126.6 0 69.8-56.7 126.6-126.6 126.6z"
        ],
        "alipay": [
            448,
            512,
            [],
            "f642",
            "M377.74 32H70.26C31.41 32 0 63.41 0 102.26v307.48C0 448.59 31.41 480 70.26 480h307.48c38.52 0 69.76-31.08 70.26-69.6-45.96-25.62-110.59-60.34-171.6-88.44-32.07 43.97-84.14 81-148.62 81-70.59 0-93.73-45.3-97.04-76.37-3.97-39.01 14.88-81.5 99.52-81.5 35.38 0 79.35 10.25 127.13 24.96 16.53-30.09 26.45-60.34 26.45-60.34h-178.2v-16.7h92.08v-31.24H88.28v-19.01h109.44V92.34h50.92v50.42h109.44v19.01H248.63v31.24h88.77s-15.21 46.62-38.35 90.92c48.93 16.7 100.01 36.04 148.62 52.74V102.26C447.83 63.57 416.43 32 377.74 32zM47.28 322.95c.99 20.17 10.25 53.73 69.93 53.73 52.07 0 92.58-39.68 117.87-72.9-44.63-18.68-84.48-31.41-109.44-31.41-67.45 0-79.35 33.06-78.36 50.58z"
        ],
        "amazon": [
            448,
            512,
            [],
            "f270",
            "M257.2 162.7c-48.7 1.8-169.5 15.5-169.5 117.5 0 109.5 138.3 114 183.5 43.2 6.5 10.2 35.4 37.5 45.3 46.8l56.8-56S341 288.9 341 261.4V114.3C341 89 316.5 32 228.7 32 140.7 32 94 87 94 136.3l73.5 6.8c16.3-49.5 54.2-49.5 54.2-49.5 40.7-.1 35.5 29.8 35.5 69.1zm0 86.8c0 80-84.2 68-84.2 17.2 0-47.2 50.5-56.7 84.2-57.8v40.6zm136 163.5c-7.7 10-70 67-174.5 67S34.2 408.5 9.7 379c-6.8-7.7 1-11.3 5.5-8.3C88.5 415.2 203 488.5 387.7 401c7.5-3.7 13.3 2 5.5 12zm39.8 2.2c-6.5 15.8-16 26.8-21.2 31-5.5 4.5-9.5 2.7-6.5-3.8s19.3-46.5 12.7-55c-6.5-8.3-37-4.3-48-3.2-10.8 1-13 2-14-.3-2.3-5.7 21.7-15.5 37.5-17.5 15.7-1.8 41-.8 46 5.7 3.7 5.1 0 27.1-6.5 43.1z"
        ],
        "amazon-pay": [
            640,
            512,
            [],
            "f42c",
            "M14 325.3c2.3-4.2 5.2-4.9 9.7-2.5 10.4 5.6 20.6 11.4 31.2 16.7a595.88 595.88 0 0 0 127.4 46.3 616.61 616.61 0 0 0 63.2 11.8 603.33 603.33 0 0 0 95 5.2c17.4-.4 34.8-1.8 52.1-3.8a603.66 603.66 0 0 0 163.3-42.8c2.9-1.2 5.9-2 9.1-1.2 6.7 1.8 9 9 4.1 13.9a70 70 0 0 1-9.6 7.4c-30.7 21.1-64.2 36.4-99.6 47.9a473.31 473.31 0 0 1-75.1 17.6 431 431 0 0 1-53.2 4.8 21.3 21.3 0 0 0-2.5.3H308a21.3 21.3 0 0 0-2.5-.3c-3.6-.2-7.2-.3-10.7-.4a426.3 426.3 0 0 1-50.4-5.3A448.4 448.4 0 0 1 164 420a443.33 443.33 0 0 1-145.6-87c-1.8-1.6-3-3.8-4.4-5.7zM172 65.1l-4.3.6a80.92 80.92 0 0 0-38 15.1c-2.4 1.7-4.6 3.5-7.1 5.4a4.29 4.29 0 0 1-.4-1.4c-.4-2.7-.8-5.5-1.3-8.2-.7-4.6-3-6.6-7.6-6.6h-11.5c-6.9 0-8.2 1.3-8.2 8.2v209.3c0 1 0 2 .1 3 .2 3 2 4.9 4.9 5 7 .1 14.1.1 21.1 0 2.9 0 4.7-2 5-5 .1-1 .1-2 .1-3v-72.4c1.1.9 1.7 1.4 2.2 1.9 17.9 14.9 38.5 19.8 61 15.4 20.4-4 34.6-16.5 43.8-34.9 7-13.9 9.9-28.7 10.3-44.1.5-17.1-1.2-33.9-8.1-49.8-8.5-19.6-22.6-32.5-43.9-36.9-3.2-.7-6.5-1-9.8-1.5-2.8-.1-5.5-.1-8.3-.1zM124.6 107a3.48 3.48 0 0 1 1.7-3.3c13.7-9.5 28.8-14.5 45.6-13.2 14.9 1.1 27.1 8.4 33.5 25.9 3.9 10.7 4.9 21.8 4.9 33 0 10.4-.8 20.6-4 30.6-6.8 21.3-22.4 29.4-42.6 28.5-14-.6-26.2-6-37.4-13.9a3.57 3.57 0 0 1-1.7-3.3c.1-14.1 0-28.1 0-42.2s.1-28 0-42.1zm205.7-41.9c-1 .1-2 .3-2.9.4a148 148 0 0 0-28.9 4.1c-6.1 1.6-12 3.8-17.9 5.8-3.6 1.2-5.4 3.8-5.3 7.7.1 3.3-.1 6.6 0 9.9.1 4.8 2.1 6.1 6.8 4.9 7.8-2 15.6-4.2 23.5-5.7 12.3-2.3 24.7-3.3 37.2-1.4 6.5 1 12.6 2.9 16.8 8.4 3.7 4.8 5.1 10.5 5.3 16.4.3 8.3.2 16.6.3 24.9a7.84 7.84 0 0 1-.2 1.4c-.5-.1-.9 0-1.3-.1a180.56 180.56 0 0 0-32-4.9c-11.3-.6-22.5.1-33.3 3.9-12.9 4.5-23.3 12.3-29.4 24.9-4.7 9.8-5.4 20.2-3.9 30.7 2 14 9 24.8 21.4 31.7 11.9 6.6 24.8 7.4 37.9 5.4 15.1-2.3 28.5-8.7 40.3-18.4a7.36 7.36 0 0 1 1.6-1.1c.6 3.8 1.1 7.4 1.8 11 .6 3.1 2.5 5.1 5.4 5.2 5.4.1 10.9.1 16.3 0a4.84 4.84 0 0 0 4.8-4.7 26.2 26.2 0 0 0 .1-2.8v-106a80 80 0 0 0-.9-12.9c-1.9-12.9-7.4-23.5-19-30.4-6.7-4-14.1-6-21.8-7.1-3.6-.5-7.2-.8-10.8-1.3-3.9.1-7.9.1-11.9.1zm35 127.7a3.33 3.33 0 0 1-1.5 3c-11.2 8.1-23.5 13.5-37.4 14.9-5.7.6-11.4.4-16.8-1.8a20.08 20.08 0 0 1-12.4-13.3 32.9 32.9 0 0 1-.1-19.4c2.5-8.3 8.4-13 16.4-15.6a61.33 61.33 0 0 1 24.8-2.2c8.4.7 16.6 2.3 25 3.4 1.6.2 2.1 1 2.1 2.6-.1 4.8 0 9.5 0 14.3s-.2 9.4-.1 14.1zm259.9 129.4c-1-5-4.8-6.9-9.1-8.3a88.42 88.42 0 0 0-21-3.9 147.32 147.32 0 0 0-39.2 1.9c-14.3 2.7-27.9 7.3-40 15.6a13.75 13.75 0 0 0-3.7 3.5 5.11 5.11 0 0 0-.5 4c.4 1.5 2.1 1.9 3.6 1.8a16.2 16.2 0 0 0 2.2-.1c7.8-.8 15.5-1.7 23.3-2.5 11.4-1.1 22.9-1.8 34.3-.9a71.64 71.64 0 0 1 14.4 2.7c5.1 1.4 7.4 5.2 7.6 10.4.4 8-1.4 15.7-3.5 23.3-4.1 15.4-10 30.3-15.8 45.1a17.6 17.6 0 0 0-1 3c-.5 2.9 1.2 4.8 4.1 4.1a10.56 10.56 0 0 0 4.8-2.5 145.91 145.91 0 0 0 12.7-13.4c12.8-16.4 20.3-35.3 24.7-55.6.8-3.6 1.4-7.3 2.1-10.9v-17.3zM493.1 199q-19.35-53.55-38.7-107.2c-2-5.7-4.2-11.3-6.3-16.9-1.1-2.9-3.2-4.8-6.4-4.8-7.6-.1-15.2-.2-22.9-.1-2.5 0-3.7 2-3.2 4.5a43.1 43.1 0 0 0 1.9 6.1q29.4 72.75 59.1 145.5c1.7 4.1 2.1 7.6.2 11.8-3.3 7.3-5.9 15-9.3 22.3-3 6.5-8 11.4-15.2 13.3a42.13 42.13 0 0 1-15.4 1.1c-2.5-.2-5-.8-7.5-1-3.4-.2-5.1 1.3-5.2 4.8q-.15 5 0 9.9c.1 5.5 2 8 7.4 8.9a108.18 108.18 0 0 0 16.9 2c17.1.4 30.7-6.5 39.5-21.4a131.63 131.63 0 0 0 9.2-18.4q35.55-89.7 70.6-179.6a26.62 26.62 0 0 0 1.6-5.5c.4-2.8-.9-4.4-3.7-4.4-6.6-.1-13.3 0-19.9 0a7.54 7.54 0 0 0-7.7 5.2c-.5 1.4-1.1 2.7-1.6 4.1l-34.8 100c-2.5 7.2-5.1 14.5-7.7 22.2-.4-1.1-.6-1.7-.9-2.4z"
        ],
        "amilia": [
            448,
            512,
            [],
            "f36d",
            "M240.1 32c-61.9 0-131.5 16.9-184.2 55.4-5.1 3.1-9.1 9.2-7.2 19.4 1.1 5.1 5.1 27.4 10.2 39.6 4.1 10.2 14.2 10.2 20.3 6.1 32.5-22.3 96.5-47.7 152.3-47.7 57.9 0 58.9 28.4 58.9 73.1v38.5C203 227.7 78.2 251 46.7 264.2 11.2 280.5 16.3 357.7 16.3 376s15.2 104 124.9 104c47.8 0 113.7-20.7 153.3-42.1v25.4c0 3 2.1 8.2 6.1 9.1 3.1 1 50.7 2 59.9 2s62.5.3 66.5-.7c4.1-1 5.1-6.1 5.1-9.1V168c-.1-80.3-57.9-136-192-136zm50.2 348c-21.4 13.2-48.7 24.4-79.1 24.4-52.8 0-58.9-33.5-59-44.7 0-12.2-3-42.7 18.3-52.9 24.3-13.2 75.1-29.4 119.8-33.5z"
        ],
        "android": [
            576,
            512,
            [],
            "f17b",
            "M420.55,301.93a24,24,0,1,1,24-24,24,24,0,0,1-24,24m-265.1,0a24,24,0,1,1,24-24,24,24,0,0,1-24,24m273.7-144.48,47.94-83a10,10,0,1,0-17.27-10h0l-48.54,84.07a301.25,301.25,0,0,0-246.56,0L116.18,64.45a10,10,0,1,0-17.27,10h0l47.94,83C64.53,202.22,8.24,285.55,0,384H576c-8.24-98.45-64.54-181.78-146.85-226.55"
        ],
        "angellist": [
            448,
            512,
            [],
            "f209",
            "M347.1 215.4c11.7-32.6 45.4-126.9 45.4-157.1 0-26.6-15.7-48.9-43.7-48.9-44.6 0-84.6 131.7-97.1 163.1C242 144 196.6 0 156.6 0c-31.1 0-45.7 22.9-45.7 51.7 0 35.3 34.2 126.8 46.6 162-6.3-2.3-13.1-4.3-20-4.3-23.4 0-48.3 29.1-48.3 52.6 0 8.9 4.9 21.4 8 29.7-36.9 10-51.1 34.6-51.1 71.7C46 435.6 114.4 512 210.6 512c118 0 191.4-88.6 191.4-202.9 0-43.1-6.9-82-54.9-93.7zM311.7 108c4-12.3 21.1-64.3 37.1-64.3 8.6 0 10.9 8.9 10.9 16 0 19.1-38.6 124.6-47.1 148l-34-6 33.1-93.7zM142.3 48.3c0-11.9 14.5-45.7 46.3 47.1l34.6 100.3c-15.6-1.3-27.7-3-35.4 1.4-10.9-28.8-45.5-119.7-45.5-148.8zM140 244c29.3 0 67.1 94.6 67.1 107.4 0 5.1-4.9 11.4-10.6 11.4-20.9 0-76.9-76.9-76.9-97.7.1-7.7 12.7-21.1 20.4-21.1zm184.3 186.3c-29.1 32-66.3 48.6-109.7 48.6-59.4 0-106.3-32.6-128.9-88.3-17.1-43.4 3.8-68.3 20.6-68.3 11.4 0 54.3 60.3 54.3 73.1 0 4.9-7.7 8.3-11.7 8.3-16.1 0-22.4-15.5-51.1-51.4-29.7 29.7 20.5 86.9 58.3 86.9 26.1 0 43.1-24.2 38-42 3.7 0 8.3.3 11.7-.6 1.1 27.1 9.1 59.4 41.7 61.7 0-.9 2-7.1 2-7.4 0-17.4-10.6-32.6-10.6-50.3 0-28.3 21.7-55.7 43.7-71.7 8-6 17.7-9.7 27.1-13.1 9.7-3.7 20-8 27.4-15.4-1.1-11.2-5.7-21.1-16.9-21.1-27.7 0-120.6 4-120.6-39.7 0-6.7.1-13.1 17.4-13.1 32.3 0 114.3 8 138.3 29.1 18.1 16.1 24.3 113.2-31 174.7zm-98.6-126c9.7 3.1 19.7 4 29.7 6-7.4 5.4-14 12-20.3 19.1-2.8-8.5-6.2-16.8-9.4-25.1z"
        ],
        "angrycreative": [
            640,
            512,
            [],
            "f36e",
            "M640 238.2l-3.2 28.2-34.5 2.3-2 18.1 34.5-2.3-3.2 28.2-34.4 2.2-2.3 20.1 34.4-2.2-3 26.1-64.7 4.1 12.7-113.2L527 365.2l-31.9 2-23.8-117.8 30.3-2 13.6 79.4 31.7-82.4 93.1-6.2zM426.8 371.5l28.3-1.8L468 249.6l-28.4 1.9-12.8 120zM162 388.1l-19.4-36-3.5 37.4-28.2 1.7 2.7-29.1c-11 18-32 34.3-56.9 35.8C23.9 399.9-3 377 .3 339.7c2.6-29.3 26.7-62.8 67.5-65.4 37.7-2.4 47.6 23.2 51.3 28.8l2.8-30.8 38.9-2.5c20.1-1.3 38.7 3.7 42.5 23.7l2.6-26.6 64.8-4.2-2.7 27.9-36.4 2.4-1.7 17.9 36.4-2.3-2.7 27.9-36.4 2.3-1.9 19.9 36.3-2.3-2.1 20.8 55-117.2 23.8-1.6L370.4 369l8.9-85.6-22.3 1.4 2.9-27.9 75-4.9-3 28-24.3 1.6-9.7 91.9-58 3.7-4.3-15.6-39.4 2.5-8 16.3-126.2 7.7zm-44.3-70.2l-26.4 1.7C84.6 307.2 76.9 303 65 303.8c-19 1.2-33.3 17.5-34.6 33.3-1.4 16 7.3 32.5 28.7 31.2 12.8-.8 21.3-8.6 28.9-18.9l27-1.7 2.7-29.8zm56.1-7.7c1.2-12.9-7.6-13.6-26.1-12.4l-2.7 28.5c14.2-.9 27.5-2.1 28.8-16.1zm21.1 70.8l5.8-60c-5 13.5-14.7 21.1-27.9 26.6l22.1 33.4zm135.4-45l-7.9-37.8-15.8 39.3 23.7-1.5zm-170.1-74.6l-4.3-17.5-39.6 2.6-8.1 18.2-31.9 2.1 57-121.9 23.9-1.6 30.7 102 9.9-104.7 27-1.8 37.8 63.6 6.5-66.6 28.5-1.9-4 41.2c7.4-13.5 22.9-44.7 63.6-47.5 40.5-2.8 52.4 29.3 53.4 30.3l3.3-32 39.3-2.7c12.7-.9 27.8.3 36.3 9.7l-4.4-11.9 32.2-2.2 12.9 43.2 23-45.7 31-2.2-43.6 78.4-4.8 44.3-28.4 1.9 4.8-44.3-15.8-43c1 22.3-9.2 40.1-32 49.6l25.2 38.8-36.4 2.4-19.2-36.8-4 38.3-28.4 1.9 3.3-31.5c-6.7 9.3-19.7 35.4-59.6 38-26.2 1.7-45.6-10.3-55.4-39.2l-4 40.3-25 1.6-37.6-63.3-6.3 66.2-56.8 3.7zm276.6-82.1c10.2-.7 17.5-2.1 21.6-4.3 4.5-2.4 7-6.4 7.6-12.1.6-5.3-.6-8.8-3.4-10.4-3.6-2.1-10.6-2.8-22.9-2l-2.9 28.8zM327.7 214c5.6 5.9 12.7 8.5 21.3 7.9 4.7-.3 9.1-1.8 13.3-4.1 5.5-3 10.6-8 15.1-14.3l-34.2 2.3 2.4-23.9 63.1-4.3 1.2-12-31.2 2.1c-4.1-3.7-7.8-6.6-11.1-8.1-4-1.7-8.1-2.8-12.2-2.5-8 .5-15.3 3.6-22 9.2-7.7 6.4-12 14.5-12.9 24.4-1.1 9.6 1.4 17.3 7.2 23.3zm-201.3 8.2l23.8-1.6-8.3-37.6-15.5 39.2z"
        ],
        "angular": [
            448,
            512,
            [],
            "f420",
            "M185.7 268.1h76.2l-38.1-91.6-38.1 91.6zM223.8 32L16 106.4l31.8 275.7 176 97.9 176-97.9 31.8-275.7zM354 373.8h-48.6l-26.2-65.4H168.6l-26.2 65.4H93.7L223.8 81.5z"
        ],
        "app-store": [
            512,
            512,
            [],
            "f36f",
            "M255.9 120.9l9.1-15.7c5.6-9.8 18.1-13.1 27.9-7.5 9.8 5.6 13.1 18.1 7.5 27.9l-87.5 151.5h63.3c20.5 0 32 24.1 23.1 40.8H113.8c-11.3 0-20.4-9.1-20.4-20.4 0-11.3 9.1-20.4 20.4-20.4h52l66.6-115.4-20.8-36.1c-5.6-9.8-2.3-22.2 7.5-27.9 9.8-5.6 22.2-2.3 27.9 7.5l8.9 15.7zm-78.7 218l-19.6 34c-5.6 9.8-18.1 13.1-27.9 7.5-9.8-5.6-13.1-18.1-7.5-27.9l14.6-25.2c16.4-5.1 29.8-1.2 40.4 11.6zm168.9-61.7h53.1c11.3 0 20.4 9.1 20.4 20.4 0 11.3-9.1 20.4-20.4 20.4h-29.5l19.9 34.5c5.6 9.8 2.3 22.2-7.5 27.9-9.8 5.6-22.2 2.3-27.9-7.5-33.5-58.1-58.7-101.6-75.4-130.6-17.1-29.5-4.9-59.1 7.2-69.1 13.4 23 33.4 57.7 60.1 104zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm216 248c0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216 0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216z"
        ],
        "app-store-ios": [
            448,
            512,
            [],
            "f370",
            "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM127 384.5c-5.5 9.6-17.8 12.8-27.3 7.3-9.6-5.5-12.8-17.8-7.3-27.3l14.3-24.7c16.1-4.9 29.3-1.1 39.6 11.4L127 384.5zm138.9-53.9H84c-11 0-20-9-20-20s9-20 20-20h51l65.4-113.2-20.5-35.4c-5.5-9.6-2.2-21.8 7.3-27.3 9.6-5.5 21.8-2.2 27.3 7.3l8.9 15.4 8.9-15.4c5.5-9.6 17.8-12.8 27.3-7.3 9.6 5.5 12.8 17.8 7.3 27.3l-85.8 148.6h62.1c20.2 0 31.5 23.7 22.7 40zm98.1 0h-29l19.6 33.9c5.5 9.6 2.2 21.8-7.3 27.3-9.6 5.5-21.8 2.2-27.3-7.3-32.9-56.9-57.5-99.7-74-128.1-16.7-29-4.8-58 7.1-67.8 13.1 22.7 32.7 56.7 58.9 102h52c11 0 20 9 20 20 0 11.1-9 20-20 20z"
        ],
        "apper": [
            640,
            512,
            [],
            "f371",
            "M42.1 239.1c22.2 0 29 2.8 33.5 14.6h.8v-22.9c0-11.3-4.8-15.4-17.9-15.4-11.3 0-14.4 2.5-15.1 12.8H4.8c.3-13.9 1.5-19.1 5.8-24.4C17.9 195 29.5 192 56.7 192c33 0 47.1 5 53.9 18.9 2 4.3 4 15.6 4 23.7v76.3H76.3l1.3-19.1h-1c-5.3 15.6-13.6 20.4-35.5 20.4-30.3 0-41.1-10.1-41.1-37.3 0-25.2 12.3-35.8 42.1-35.8zm17.1 48.1c13.1 0 16.9-3 16.9-13.4 0-9.1-4.3-11.6-19.6-11.6-13.1 0-17.9 3-17.9 12.1-.1 10.4 3.7 12.9 20.6 12.9zm77.8-94.9h38.3l-1.5 20.6h.8c9.1-17.1 15.9-20.9 37.5-20.9 14.4 0 24.7 3 31.5 9.1 9.8 8.6 12.8 20.4 12.8 48.1 0 30-3 43.1-12.1 52.9-6.8 7.3-16.4 10.1-33.2 10.1-20.4 0-29.2-5.5-33.8-21.2h-.8v70.3H137v-169zm80.9 60.7c0-27.5-3.3-32.5-20.7-32.5-16.9 0-20.7 5-20.7 28.7 0 28 3.5 33.5 21.2 33.5 16.4 0 20.2-5.6 20.2-29.7zm57.9-60.7h38.3l-1.5 20.6h.8c9.1-17.1 15.9-20.9 37.5-20.9 14.4 0 24.7 3 31.5 9.1 9.8 8.6 12.8 20.4 12.8 48.1 0 30-3 43.1-12.1 52.9-6.8 7.3-16.4 10.1-33.3 10.1-20.4 0-29.2-5.5-33.8-21.2h-.8v70.3h-39.5v-169zm80.9 60.7c0-27.5-3.3-32.5-20.7-32.5-16.9 0-20.7 5-20.7 28.7 0 28 3.5 33.5 21.2 33.5 16.4 0 20.2-5.6 20.2-29.7zm53.8-3.8c0-25.4 3.3-37.8 12.3-45.8 8.8-8.1 22.2-11.3 45.1-11.3 42.8 0 55.7 12.8 55.7 55.7v11.1h-75.3c-.3 2-.3 4-.3 4.8 0 16.9 4.5 21.9 20.1 21.9 13.9 0 17.9-3 17.9-13.9h37.5v2.3c0 9.8-2.5 18.9-6.8 24.7-7.3 9.8-19.6 13.6-44.3 13.6-27.5 0-41.6-3.3-50.6-12.3-8.5-8.5-11.3-21.3-11.3-50.8zm76.4-11.6c-.3-1.8-.3-3.3-.3-3.8 0-12.3-3.3-14.6-19.6-14.6-14.4 0-17.1 3-18.1 15.1l-.3 3.3h38.3zm55.6-45.3h38.3l-1.8 19.9h.7c6.8-14.9 14.4-20.2 29.7-20.2 10.8 0 19.1 3.3 23.4 9.3 5.3 7.3 6.8 14.4 6.8 34 0 1.5 0 5 .2 9.3h-35c.3-1.8.3-3.3.3-4 0-15.4-2-19.4-10.3-19.4-6.3 0-10.8 3.3-13.1 9.3-1 3-1 4.3-1 12.3v68h-38.3V192.3z"
        ],
        "apple": [
            384,
            512,
            [],
            "f179",
            "M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"
        ],
        "apple-pay": [
            640,
            512,
            [],
            "f415",
            "M116.9 158.5c-7.5 8.9-19.5 15.9-31.5 14.9-1.5-12 4.4-24.8 11.3-32.6 7.5-9.1 20.6-15.6 31.3-16.1 1.2 12.4-3.7 24.7-11.1 33.8m10.9 17.2c-17.4-1-32.3 9.9-40.5 9.9-8.4 0-21-9.4-34.8-9.1-17.9.3-34.5 10.4-43.6 26.5-18.8 32.3-4.9 80 13.3 106.3 8.9 13 19.5 27.3 33.5 26.8 13.3-.5 18.5-8.6 34.5-8.6 16.1 0 20.8 8.6 34.8 8.4 14.5-.3 23.6-13 32.5-26 10.1-14.8 14.3-29.1 14.5-29.9-.3-.3-28-10.9-28.3-42.9-.3-26.8 21.9-39.5 22.9-40.3-12.5-18.6-32-20.6-38.8-21.1m100.4-36.2v194.9h30.3v-66.6h41.9c38.3 0 65.1-26.3 65.1-64.3s-26.4-64-64.1-64h-73.2zm30.3 25.5h34.9c26.3 0 41.3 14 41.3 38.6s-15 38.8-41.4 38.8h-34.8V165zm162.2 170.9c19 0 36.6-9.6 44.6-24.9h.6v23.4h28v-97c0-28.1-22.5-46.3-57.1-46.3-32.1 0-55.9 18.4-56.8 43.6h27.3c2.3-12 13.4-19.9 28.6-19.9 18.5 0 28.9 8.6 28.9 24.5v10.8l-37.8 2.3c-35.1 2.1-54.1 16.5-54.1 41.5.1 25.2 19.7 42 47.8 42zm8.2-23.1c-16.1 0-26.4-7.8-26.4-19.6 0-12.3 9.9-19.4 28.8-20.5l33.6-2.1v11c0 18.2-15.5 31.2-36 31.2zm102.5 74.6c29.5 0 43.4-11.3 55.5-45.4L640 193h-30.8l-35.6 115.1h-.6L537.4 193h-31.6L557 334.9l-2.8 8.6c-4.6 14.6-12.1 20.3-25.5 20.3-2.4 0-7-.3-8.9-.5v23.4c1.8.4 9.3.7 11.6.7z"
        ],
        "artstation": [
            512,
            512,
            [],
            "f77a",
            "M2 377.4l43 74.3A51.35 51.35 0 0 0 90.9 480h285.4l-59.2-102.6zM501.8 350L335.6 59.3A51.38 51.38 0 0 0 290.2 32h-88.4l257.3 447.6 40.7-70.5c1.9-3.2 21-29.7 2-59.1zM275 304.5l-115.5-200L44 304.5z"
        ],
        "asymmetrik": [
            576,
            512,
            [],
            "f372",
            "M517.5 309.2c38.8-40 58.1-80 58.5-116.1.8-65.5-59.4-118.2-169.4-135C277.9 38.4 118.1 73.6 0 140.5 52 114 110.6 92.3 170.7 82.3c74.5-20.5 153-25.4 221.3-14.8C544.5 91.3 588.8 195 490.8 299.2c-10.2 10.8-22 21.1-35 30.6L304.9 103.4 114.7 388.9c-65.6-29.4-76.5-90.2-19.1-151.2 20.8-22.2 48.3-41.9 79.5-58.1 20-12.2 39.7-22.6 62-30.7-65.1 20.3-122.7 52.9-161.6 92.9-27.7 28.6-41.4 57.1-41.7 82.9-.5 35.1 23.4 65.1 68.4 83l-34.5 51.7h101.6l22-34.4c22.2 1 45.3 0 68.6-2.7l-22.8 37.1h135.5L340 406.3c18.6-5.3 36.9-11.5 54.5-18.7l45.9 71.8H542L468.6 349c18.5-12.1 35-25.5 48.9-39.8zm-187.6 80.5l-25-40.6-32.7 53.3c-23.4 3.5-46.7 5.1-69.2 4.4l101.9-159.3 78.7 123c-17.2 7.4-35.3 13.9-53.7 19.2z"
        ],
        "atlassian": [
            512,
            512,
            [],
            "f77b",
            "M152.2 236.4c-7.7-8.2-19.7-7.7-24.8 2.8L1.6 490.2c-5 10 2.4 21.7 13.4 21.7h175c5.8.1 11-3.2 13.4-8.4 37.9-77.8 15.1-196.3-51.2-267.1zM244.4 8.1c-122.3 193.4-8.5 348.6 65 495.5 2.5 5.1 7.7 8.4 13.4 8.4H497c11.2 0 18.4-11.8 13.4-21.7 0 0-234.5-470.6-240.4-482.3-5.3-10.6-18.8-10.8-25.6.1z"
        ],
        "audible": [
            640,
            512,
            [],
            "f373",
            "M640 199.9v54l-320 200L0 254v-54l320 200 320-200.1zm-194.5 72l47.1-29.4c-37.2-55.8-100.7-92.6-172.7-92.6-72 0-135.5 36.7-172.6 92.4h.3c2.5-2.3 5.1-4.5 7.7-6.7 89.7-74.4 219.4-58.1 290.2 36.3zm-220.1 18.8c16.9-11.9 36.5-18.7 57.4-18.7 34.4 0 65.2 18.4 86.4 47.6l45.4-28.4c-20.9-29.9-55.6-49.5-94.8-49.5-38.9 0-73.4 19.4-94.4 49zM103.6 161.1c131.8-104.3 318.2-76.4 417.5 62.1l.7 1 48.8-30.4C517.1 112.1 424.8 58.1 319.9 58.1c-103.5 0-196.6 53.5-250.5 135.6 9.9-10.5 22.7-23.5 34.2-32.6zm467 32.7z"
        ],
        "autoprefixer": [
            640,
            512,
            [],
            "f41c",
            "M318.4 16l-161 480h77.5l25.4-81.4h119.5L405 496h77.5L318.4 16zm-40.3 341.9l41.2-130.4h1.5l40.9 130.4h-83.6zM640 405l-10-31.4L462.1 358l19.4 56.5L640 405zm-462.1-47L10 373.7 0 405l158.5 9.4 19.4-56.4z"
        ],
        "avianex": [
            512,
            512,
            [],
            "f374",
            "M453.1 32h-312c-38.9 0-76.2 31.2-83.3 69.7L1.2 410.3C-5.9 448.8 19.9 480 58.9 480h312c38.9 0 76.2-31.2 83.3-69.7l56.7-308.5c7-38.6-18.8-69.8-57.8-69.8zm-58.2 347.3l-32 13.5-115.4-110c-14.7 10-29.2 19.5-41.7 27.1l22.1 64.2-17.9 12.7-40.6-61-52.4-48.1 15.7-15.4 58 31.1c9.3-10.5 20.8-22.6 32.8-34.9L203 228.9l-68.8-99.8 18.8-28.9 8.9-4.8L265 207.8l4.9 4.5c19.4-18.8 33.8-32.4 33.8-32.4 7.7-6.5 21.5-2.9 30.7 7.9 9 10.5 10.6 24.7 2.7 31.3-1.8 1.3-15.5 11.4-35.3 25.6l4.5 7.3 94.9 119.4-6.3 7.9z"
        ],
        "aviato": [
            640,
            512,
            [],
            "f421",
            "M107.2 283.5l-19-41.8H36.1l-19 41.8H0l62.2-131.4 62.2 131.4h-17.2zm-45-98.1l-19.6 42.5h39.2l-19.6-42.5zm112.7 102.4l-62.2-131.4h17.1l45.1 96 45.1-96h17l-62.1 131.4zm80.6-4.3V156.4H271v127.1h-15.5zm209.1-115.6v115.6h-17.3V167.9h-41.2v-11.5h99.6v11.5h-41.1zM640 218.8c0 9.2-1.7 17.8-5.1 25.8-3.4 8-8.2 15.1-14.2 21.1-6 6-13.1 10.8-21.1 14.2-8 3.4-16.6 5.1-25.8 5.1s-17.8-1.7-25.8-5.1c-8-3.4-15.1-8.2-21.1-14.2-6-6-10.8-13-14.2-21.1-3.4-8-5.1-16.6-5.1-25.8s1.7-17.8 5.1-25.8c3.4-8 8.2-15.1 14.2-21.1 6-6 13-8.4 21.1-11.9 8-3.4 16.6-5.1 25.8-5.1s17.8 1.7 25.8 5.1c8 3.4 15.1 5.8 21.1 11.9 6 6 10.7 13.1 14.2 21.1 3.4 8 5.1 16.6 5.1 25.8zm-15.5 0c0-7.3-1.3-14-3.9-20.3-2.6-6.3-6.2-11.7-10.8-16.3-4.6-4.6-10-8.2-16.2-10.9-6.2-2.7-12.8-4-19.8-4s-13.6 1.3-19.8 4c-6.2 2.7-11.6 6.3-16.2 10.9-4.6 4.6-8.2 10-10.8 16.3-2.6 6.3-3.9 13.1-3.9 20.3 0 7.3 1.3 14 3.9 20.3 2.6 6.3 6.2 11.7 10.8 16.3 4.6 4.6 10 8.2 16.2 10.9 6.2 2.7 12.8 4 19.8 4s13.6-1.3 19.8-4c6.2-2.7 11.6-6.3 16.2-10.9 4.6-4.6 8.2-10 10.8-16.3 2.6-6.3 3.9-13.1 3.9-20.3zm-94.8 96.7v-6.3l88.9-10-242.9 13.4c.6-2.2 1.1-4.6 1.4-7.2.3-2 .5-4.2.6-6.5l64.8-8.1-64.9 1.9c0-.4-.1-.7-.1-1.1-2.8-17.2-25.5-23.7-25.5-23.7l-1.1-26.3h23.8l19 41.8h17.1L348.6 152l-62.2 131.4h17.1l19-41.8h23.6L345 268s-22.7 6.5-25.5 23.7c-.1.3-.1.7-.1 1.1l-64.9-1.9 64.8 8.1c.1 2.3.3 4.4.6 6.5.3 2.6.8 5 1.4 7.2L78.4 299.2l88.9 10v6.3c-5.9.9-10.5 6-10.5 12.2 0 6.8 5.6 12.4 12.4 12.4 6.8 0 12.4-5.6 12.4-12.4 0-6.2-4.6-11.3-10.5-12.2v-5.8l80.3 9v5.4c-5.7 1.1-9.9 6.2-9.9 12.1 0 6.8 5.6 10.2 12.4 10.2 6.8 0 12.4-3.4 12.4-10.2 0-6-4.3-11-9.9-12.1v-4.9l28.4 3.2v23.7h-5.9V360h5.9v-6.6h5v6.6h5.9v-13.8h-5.9V323l38.3 4.3c8.1 11.4 19 13.6 19 13.6l-.1 6.7-5.1.2-.1 12.1h4.1l.1-5h5.2l.1 5h4.1l-.1-12.1-5.1-.2-.1-6.7s10.9-2.1 19-13.6l38.3-4.3v23.2h-5.9V360h5.9v-6.6h5v6.6h5.9v-13.8h-5.9v-23.7l28.4-3.2v4.9c-5.7 1.1-9.9 6.2-9.9 12.1 0 6.8 5.6 10.2 12.4 10.2 6.8 0 12.4-3.4 12.4-10.2 0-6-4.3-11-9.9-12.1v-5.4l80.3-9v5.8c-5.9.9-10.5 6-10.5 12.2 0 6.8 5.6 12.4 12.4 12.4 6.8 0 12.4-5.6 12.4-12.4-.2-6.3-4.7-11.4-10.7-12.3zm-200.8-87.6l19.6-42.5 19.6 42.5h-17.9l-1.7-40.3-1.7 40.3h-17.9z"
        ],
        "aws": [
            640,
            512,
            [],
            "f375",
            "M180.41 203.01c-.72 22.65 10.6 32.68 10.88 39.05a8.164 8.164 0 0 1-4.1 6.27l-12.8 8.96a10.66 10.66 0 0 1-5.63 1.92c-.43-.02-8.19 1.83-20.48-25.61a78.608 78.608 0 0 1-62.61 29.45c-16.28.89-60.4-9.24-58.13-56.21-1.59-38.28 34.06-62.06 70.93-60.05 7.1.02 21.6.37 46.99 6.27v-15.62c2.69-26.46-14.7-46.99-44.81-43.91-2.4.01-19.4-.5-45.84 10.11-7.36 3.38-8.3 2.82-10.75 2.82-7.41 0-4.36-21.48-2.94-24.2 5.21-6.4 35.86-18.35 65.94-18.18a76.857 76.857 0 0 1 55.69 17.28 70.285 70.285 0 0 1 17.67 52.36l-.01 69.29zM93.99 235.4c32.43-.47 46.16-19.97 49.29-30.47 2.46-10.05 2.05-16.41 2.05-27.4-9.67-2.32-23.59-4.85-39.56-4.87-15.15-1.14-42.82 5.63-41.74 32.26-1.24 16.79 11.12 31.4 29.96 30.48zm170.92 23.05c-7.86.72-11.52-4.86-12.68-10.37l-49.8-164.65c-.97-2.78-1.61-5.65-1.92-8.58a4.61 4.61 0 0 1 3.86-5.25c.24-.04-2.13 0 22.25 0 8.78-.88 11.64 6.03 12.55 10.37l35.72 140.83 33.16-140.83c.53-3.22 2.94-11.07 12.8-10.24h17.16c2.17-.18 11.11-.5 12.68 10.37l33.42 142.63L420.98 80.1c.48-2.18 2.72-11.37 12.68-10.37h19.72c.85-.13 6.15-.81 5.25 8.58-.43 1.85 3.41-10.66-52.75 169.9-1.15 5.51-4.82 11.09-12.68 10.37h-18.69c-10.94 1.15-12.51-9.66-12.68-10.75L328.67 110.7l-32.78 136.99c-.16 1.09-1.73 11.9-12.68 10.75h-18.3zm273.48 5.63c-5.88.01-33.92-.3-57.36-12.29a12.802 12.802 0 0 1-7.81-11.91v-10.75c0-8.45 6.2-6.9 8.83-5.89 10.04 4.06 16.48 7.14 28.81 9.6 36.65 7.53 52.77-2.3 56.72-4.48 13.15-7.81 14.19-25.68 5.25-34.95-10.48-8.79-15.48-9.12-53.13-21-4.64-1.29-43.7-13.61-43.79-52.36-.61-28.24 25.05-56.18 69.52-55.95 12.67-.01 46.43 4.13 55.57 15.62 1.35 2.09 2.02 4.55 1.92 7.04v10.11c0 4.44-1.62 6.66-4.87 6.66-7.71-.86-21.39-11.17-49.16-10.75-6.89-.36-39.89.91-38.41 24.97-.43 18.96 26.61 26.07 29.7 26.89 36.46 10.97 48.65 12.79 63.12 29.58 17.14 22.25 7.9 48.3 4.35 55.44-19.08 37.49-68.42 34.44-69.26 34.42zm40.2 104.86c-70.03 51.72-171.69 79.25-258.49 79.25A469.127 469.127 0 0 1 2.83 327.46c-6.53-5.89-.77-13.96 7.17-9.47a637.37 637.37 0 0 0 316.88 84.12 630.22 630.22 0 0 0 241.59-49.55c11.78-5 21.77 7.8 10.12 16.38zm29.19-33.29c-8.96-11.52-59.28-5.38-81.81-2.69-6.79.77-7.94-5.12-1.79-9.47 40.07-28.17 105.88-20.1 113.44-10.63 7.55 9.47-2.05 75.41-39.56 106.91-5.76 4.87-11.27 2.3-8.71-4.1 8.44-21.25 27.39-68.49 18.43-80.02z"
        ],
        "bandcamp": [
            512,
            512,
            [],
            "f2d5",
            "M256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8Zm48.2,326.1h-181L207.9,178h181Z"
        ],
        "battle-net": [
            512,
            512,
            [],
            "f835",
            "M448.61 225.62c26.87.18 35.57-7.43 38.92-12.37 12.47-16.32-7.06-47.6-52.85-71.33 17.76-33.58 30.11-63.68 36.34-85.3 3.38-11.83 1.09-19 .45-20.25-1.72 10.52-15.85 48.46-48.2 100.05-25-11.22-56.52-20.1-93.77-23.8-8.94-16.94-34.88-63.86-60.48-88.93C252.18 7.14 238.7 1.07 228.18.22h-.05c-13.83-1.55-22.67 5.85-27.4 11-17.2 18.53-24.33 48.87-25 84.07-7.24-12.35-17.17-24.63-28.5-25.93h-.18c-20.66-3.48-38.39 29.22-36 81.29-38.36 1.38-71 5.75-93 11.23-9.9 2.45-16.22 7.27-17.76 9.72 1-.38 22.4-9.22 111.56-9.22 5.22 53 29.75 101.82 26 93.19-9.73 15.4-38.24 62.36-47.31 97.7-5.87 22.88-4.37 37.61.15 47.14 5.57 12.75 16.41 16.72 23.2 18.26 25 5.71 55.38-3.63 86.7-21.14-7.53 12.84-13.9 28.51-9.06 39.34 7.31 19.65 44.49 18.66 88.44-9.45 20.18 32.18 40.07 57.94 55.7 74.12a39.79 39.79 0 0 0 8.75 7.09c5.14 3.21 8.58 3.37 8.58 3.37-8.24-6.75-34-38-62.54-91.78 22.22-16 45.65-38.87 67.47-69.27 122.82 4.6 143.29-24.76 148-31.64 14.67-19.88 3.43-57.44-57.32-93.69zm-77.85 106.22c23.81-37.71 30.34-67.77 29.45-92.33 27.86 17.57 47.18 37.58 49.06 58.83 1.14 12.93-8.1 29.12-78.51 33.5zM216.9 387.69c9.76-6.23 19.53-13.12 29.2-20.49 6.68 13.33 13.6 26.1 20.6 38.19-40.6 21.86-68.84 12.76-49.8-17.7zm215-171.35c-10.29-5.34-21.16-10.34-32.38-15.05a722.459 722.459 0 0 0 22.74-36.9c39.06 24.1 45.9 53.18 9.64 51.95zM279.18 398c-5.51-11.35-11-23.5-16.5-36.44 43.25 1.27 62.42-18.73 63.28-20.41 0 .07-25 15.64-62.53 12.25a718.78 718.78 0 0 0 85.06-84q13.06-15.31 24.93-31.11c-.36-.29-1.54-3-16.51-12-51.7 60.27-102.34 98-132.75 115.92-20.59-11.18-40.84-31.78-55.71-61.49-20-39.92-30-82.39-31.57-116.07 12.3.91 25.27 2.17 38.85 3.88-22.29 36.8-14.39 63-13.47 64.23 0-.07-.95-29.17 20.14-59.57a695.23 695.23 0 0 0 44.67 152.84c.93-.38 1.84.88 18.67-8.25-26.33-74.47-33.76-138.17-34-173.43 20-12.42 48.18-19.8 81.63-17.81 44.57 2.67 86.36 15.25 116.32 30.71q-10.69 15.66-23.33 32.47C365.63 152 339.1 145.84 337.5 146c.11 0 25.9 14.07 41.52 47.22a717.63 717.63 0 0 0-115.34-31.71 646.608 646.608 0 0 0-39.39-6.05c-.07.45-1.81 1.85-2.16 20.33C300 190.28 358.78 215.68 389.36 233c.74 23.55-6.95 51.61-25.41 79.57-24.6 37.31-56.39 67.23-84.77 85.43zm27.4-287c-44.56-1.66-73.58 7.43-94.69 20.67 2-52.3 21.31-76.38 38.21-75.28C267 52.15 305 108.55 306.58 111zm-130.65 3.1c.48 12.11 1.59 24.62 3.21 37.28-14.55-.85-28.74-1.25-42.4-1.26-.08 3.24-.12-51 24.67-49.59h.09c5.76 1.09 10.63 6.88 14.43 13.57zm-28.06 162c20.76 39.7 43.3 60.57 65.25 72.31-46.79 24.76-77.53 20-84.92 4.51-.2-.21-11.13-15.3 19.67-76.81zm210.06 74.8"
        ],
        "behance": [
            576,
            512,
            [],
            "f1b4",
            "M232 237.2c31.8-15.2 48.4-38.2 48.4-74 0-70.6-52.6-87.8-113.3-87.8H0v354.4h171.8c64.4 0 124.9-30.9 124.9-102.9 0-44.5-21.1-77.4-64.7-89.7zM77.9 135.9H151c28.1 0 53.4 7.9 53.4 40.5 0 30.1-19.7 42.2-47.5 42.2h-79v-82.7zm83.3 233.7H77.9V272h84.9c34.3 0 56 14.3 56 50.6 0 35.8-25.9 47-57.6 47zm358.5-240.7H376V94h143.7v34.9zM576 305.2c0-75.9-44.4-139.2-124.9-139.2-78.2 0-131.3 58.8-131.3 135.8 0 79.9 50.3 134.7 131.3 134.7 61.3 0 101-27.6 120.1-86.3H509c-6.7 21.9-34.3 33.5-55.7 33.5-41.3 0-63-24.2-63-65.3h185.1c.3-4.2.6-8.7.6-13.2zM390.4 274c2.3-33.7 24.7-54.8 58.5-54.8 35.4 0 53.2 20.8 56.2 54.8H390.4z"
        ],
        "behance-square": [
            448,
            512,
            [],
            "f1b5",
            "M186.5 293c0 19.3-14 25.4-31.2 25.4h-45.1v-52.9h46c18.6.1 30.3 7.8 30.3 27.5zm-7.7-82.3c0-17.7-13.7-21.9-28.9-21.9h-39.6v44.8H153c15.1 0 25.8-6.6 25.8-22.9zm132.3 23.2c-18.3 0-30.5 11.4-31.7 29.7h62.2c-1.7-18.5-11.3-29.7-30.5-29.7zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM271.7 185h77.8v-18.9h-77.8V185zm-43 110.3c0-24.1-11.4-44.9-35-51.6 17.2-8.2 26.2-17.7 26.2-37 0-38.2-28.5-47.5-61.4-47.5H68v192h93.1c34.9-.2 67.6-16.9 67.6-55.9zM380 280.5c0-41.1-24.1-75.4-67.6-75.4-42.4 0-71.1 31.8-71.1 73.6 0 43.3 27.3 73 71.1 73 33.2 0 54.7-14.9 65.1-46.8h-33.7c-3.7 11.9-18.6 18.1-30.2 18.1-22.4 0-34.1-13.1-34.1-35.3h100.2c.1-2.3.3-4.8.3-7.2z"
        ],
        "bimobject": [
            448,
            512,
            [],
            "f378",
            "M416 32H32C14.4 32 0 46.4 0 64v384c0 17.6 14.4 32 32 32h384c17.6 0 32-14.4 32-32V64c0-17.6-14.4-32-32-32zm-64 257.4c0 49.4-11.4 82.6-103.8 82.6h-16.9c-44.1 0-62.4-14.9-70.4-38.8h-.9V368H96V136h64v74.7h1.1c4.6-30.5 39.7-38.8 69.7-38.8h17.3c92.4 0 103.8 33.1 103.8 82.5v35zm-64-28.9v22.9c0 21.7-3.4 33.8-38.4 33.8h-45.3c-28.9 0-44.1-6.5-44.1-35.7v-19c0-29.3 15.2-35.7 44.1-35.7h45.3c35-.2 38.4 12 38.4 33.7z"
        ],
        "bitbucket": [
            512,
            512,
            [],
            "f171",
            "M22.2 32A16 16 0 0 0 6 47.8a26.35 26.35 0 0 0 .2 2.8l67.9 412.1a21.77 21.77 0 0 0 21.3 18.2h325.7a16 16 0 0 0 16-13.4L505 50.7a16 16 0 0 0-13.2-18.3 24.58 24.58 0 0 0-2.8-.2L22.2 32zm285.9 297.8h-104l-28.1-147h157.3l-25.2 147z"
        ],
        "bitcoin": [
            512,
            512,
            [],
            "f379",
            "M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zm-141.651-35.33c4.937-32.999-20.191-50.739-54.55-62.573l11.146-44.702-27.213-6.781-10.851 43.524c-7.154-1.783-14.502-3.464-21.803-5.13l10.929-43.81-27.198-6.781-11.153 44.686c-5.922-1.349-11.735-2.682-17.377-4.084l.031-.14-37.53-9.37-7.239 29.062s20.191 4.627 19.765 4.913c11.022 2.751 13.014 10.044 12.68 15.825l-12.696 50.925c.76.194 1.744.473 2.829.907-.907-.225-1.876-.473-2.876-.713l-17.796 71.338c-1.349 3.348-4.767 8.37-12.471 6.464.271.395-19.78-4.937-19.78-4.937l-13.51 31.147 35.414 8.827c6.588 1.651 13.045 3.379 19.4 5.006l-11.262 45.213 27.182 6.781 11.153-44.733a1038.209 1038.209 0 0 0 21.687 5.627l-11.115 44.523 27.213 6.781 11.262-45.128c46.404 8.781 81.299 5.239 95.986-36.727 11.836-33.79-.589-53.281-25.004-65.991 17.78-4.098 31.174-15.792 34.747-39.949zm-62.177 87.179c-8.41 33.79-65.308 15.523-83.755 10.943l14.944-59.899c18.446 4.603 77.6 13.717 68.811 48.956zm8.417-87.667c-7.673 30.736-55.031 15.12-70.393 11.292l13.548-54.327c15.363 3.828 64.836 10.973 56.845 43.035z"
        ],
        "bity": [
            496,
            512,
            [],
            "f37a",
            "M78.4 67.2C173.8-22 324.5-24 421.5 71c14.3 14.1-6.4 37.1-22.4 21.5-84.8-82.4-215.8-80.3-298.9-3.2-16.3 15.1-36.5-8.3-21.8-22.1zm98.9 418.6c19.3 5.7 29.3-23.6 7.9-30C73 421.9 9.4 306.1 37.7 194.8c5-19.6-24.9-28.1-30.2-7.1-32.1 127.4 41.1 259.8 169.8 298.1zm148.1-2c121.9-40.2 192.9-166.9 164.4-291-4.5-19.7-34.9-13.8-30 7.9 24.2 107.7-37.1 217.9-143.2 253.4-21.2 7-10.4 36 8.8 29.7zm-62.9-79l.2-71.8c0-8.2-6.6-14.8-14.8-14.8-8.2 0-14.8 6.7-14.8 14.8l-.2 71.8c0 8.2 6.6 14.8 14.8 14.8s14.8-6.6 14.8-14.8zm71-269c2.1 90.9 4.7 131.9-85.5 132.5-92.5-.7-86.9-44.3-85.5-132.5 0-21.8-32.5-19.6-32.5 0v71.6c0 69.3 60.7 90.9 118 90.1 57.3.8 118-20.8 118-90.1v-71.6c0-19.6-32.5-21.8-32.5 0z"
        ],
        "black-tie": [
            448,
            512,
            [],
            "f27e",
            "M0 32v448h448V32H0zm316.5 325.2L224 445.9l-92.5-88.7 64.5-184-64.5-86.6h184.9L252 173.2l64.5 184z"
        ],
        "blackberry": [
            512,
            512,
            [],
            "f37b",
            "M166 116.9c0 23.4-16.4 49.1-72.5 49.1H23.4l21-88.8h67.8c42.1 0 53.8 23.3 53.8 39.7zm126.2-39.7h-67.8L205.7 166h70.1c53.8 0 70.1-25.7 70.1-49.1.1-16.4-11.6-39.7-53.7-39.7zM88.8 208.1H21L0 296.9h70.1c56.1 0 72.5-23.4 72.5-49.1 0-16.3-11.7-39.7-53.8-39.7zm180.1 0h-67.8l-18.7 88.8h70.1c53.8 0 70.1-23.4 70.1-49.1 0-16.3-11.7-39.7-53.7-39.7zm189.3-53.8h-67.8l-18.7 88.8h70.1c53.8 0 70.1-23.4 70.1-49.1.1-16.3-11.6-39.7-53.7-39.7zm-28 137.9h-67.8L343.7 381h70.1c56.1 0 70.1-23.4 70.1-49.1 0-16.3-11.6-39.7-53.7-39.7zM240.8 346H173l-18.7 88.8h70.1c56.1 0 70.1-25.7 70.1-49.1.1-16.3-11.6-39.7-53.7-39.7z"
        ],
        "blogger": [
            448,
            512,
            [],
            "f37c",
            "M162.4 196c4.8-4.9 6.2-5.1 36.4-5.1 27.2 0 28.1.1 32.1 2.1 5.8 2.9 8.3 7 8.3 13.6 0 5.9-2.4 10-7.6 13.4-2.8 1.8-4.5 1.9-31.1 2.1-16.4.1-29.5-.2-31.5-.8-10.3-2.9-14.1-17.7-6.6-25.3zm61.4 94.5c-53.9 0-55.8.2-60.2 4.1-3.5 3.1-5.7 9.4-5.1 13.9.7 4.7 4.8 10.1 9.2 12 2.2 1 14.1 1.7 56.3 1.2l47.9-.6 9.2-1.5c9-5.1 10.5-17.4 3.1-24.4-5.3-4.7-5-4.7-60.4-4.7zm223.4 130.1c-3.5 28.4-23 50.4-51.1 57.5-7.2 1.8-9.7 1.9-172.9 1.8-157.8 0-165.9-.1-172-1.8-8.4-2.2-15.6-5.5-22.3-10-5.6-3.8-13.9-11.8-17-16.4-3.8-5.6-8.2-15.3-10-22C.1 423 0 420.3 0 256.3 0 93.2 0 89.7 1.8 82.6 8.1 57.9 27.7 39 53 33.4c7.3-1.6 332.1-1.9 340-.3 21.2 4.3 37.9 17.1 47.6 36.4 7.7 15.3 7-1.5 7.3 180.6.2 115.8 0 164.5-.7 170.5zm-85.4-185.2c-1.1-5-4.2-9.6-7.7-11.5-1.1-.6-8-1.3-15.5-1.7-12.4-.6-13.8-.8-17.8-3.1-6.2-3.6-7.9-7.6-8-18.3 0-20.4-8.5-39.4-25.3-56.5-12-12.2-25.3-20.5-40.6-25.1-3.6-1.1-11.8-1.5-39.2-1.8-42.9-.5-52.5.4-67.1 6.2-27 10.7-46.3 33.4-53.4 62.4-1.3 5.4-1.6 14.2-1.9 64.3-.4 62.8 0 72.1 4 84.5 9.7 30.7 37.1 53.4 64.6 58.4 9.2 1.7 122.2 2.1 133.7.5 20.1-2.7 35.9-10.8 50.7-25.9 10.7-10.9 17.4-22.8 21.8-38.5 3.2-10.9 2.9-88.4 1.7-93.9z"
        ],
        "blogger-b": [
            448,
            512,
            [],
            "f37d",
            "M446.6 222.7c-1.8-8-6.8-15.4-12.5-18.5-1.8-1-13-2.2-25-2.7-20.1-.9-22.3-1.3-28.7-5-10.1-5.9-12.8-12.3-12.9-29.5-.1-33-13.8-63.7-40.9-91.3-19.3-19.7-40.9-33-65.5-40.5-5.9-1.8-19.1-2.4-63.3-2.9-69.4-.8-84.8.6-108.4 10C45.9 59.5 14.7 96.1 3.3 142.9 1.2 151.7.7 165.8.2 246.8c-.6 101.5.1 116.4 6.4 136.5 15.6 49.6 59.9 86.3 104.4 94.3 14.8 2.7 197.3 3.3 216 .8 32.5-4.4 58-17.5 81.9-41.9 17.3-17.7 28.1-36.8 35.2-62.1 4.9-17.6 4.5-142.8 2.5-151.7zm-322.1-63.6c7.8-7.9 10-8.2 58.8-8.2 43.9 0 45.4.1 51.8 3.4 9.3 4.7 13.4 11.3 13.4 21.9 0 9.5-3.8 16.2-12.3 21.6-4.6 2.9-7.3 3.1-50.3 3.3-26.5.2-47.7-.4-50.8-1.2-16.6-4.7-22.8-28.5-10.6-40.8zm191.8 199.8l-14.9 2.4-77.5.9c-68.1.8-87.3-.4-90.9-2-7.1-3.1-13.8-11.7-14.9-19.4-1.1-7.3 2.6-17.3 8.2-22.4 7.1-6.4 10.2-6.6 97.3-6.7 89.6-.1 89.1-.1 97.6 7.8 12.1 11.3 9.5 31.2-4.9 39.4z"
        ],
        "bluetooth": [
            448,
            512,
            [],
            "f293",
            "M292.6 171.1L249.7 214l-.3-86 43.2 43.1m-43.2 219.8l43.1-43.1-42.9-42.9-.2 86zM416 259.4C416 465 344.1 512 230.9 512S32 465 32 259.4 115.4 0 228.6 0 416 53.9 416 259.4zm-158.5 0l79.4-88.6L211.8 36.5v176.9L138 139.6l-27 26.9 92.7 93-92.7 93 26.9 26.9 73.8-73.8 2.3 170 127.4-127.5-83.9-88.7z"
        ],
        "bluetooth-b": [
            320,
            512,
            [],
            "f294",
            "M196.48 260.023l92.626-103.333L143.125 0v206.33l-86.111-86.111-31.406 31.405 108.061 108.399L25.608 368.422l31.406 31.405 86.111-86.111L145.84 512l148.552-148.644-97.912-103.333zm40.86-102.996l-49.977 49.978-.338-100.295 50.315 50.317zM187.363 313.04l49.977 49.978-50.315 50.316.338-100.294z"
        ],
        "bootstrap": [
            576,
            512,
            [],
            "f836",
            "M333.5,201.4c0-22.1-15.6-34.3-43-34.3h-50.4v71.2h42.5C315.4,238.2,333.5,225,333.5,201.4z M517,188.6 c-9.5-30.9-10.9-68.8-9.8-98.1c1.1-30.5-22.7-58.5-54.7-58.5H123.7c-32.1,0-55.8,28.1-54.7,58.5c1,29.3-0.3,67.2-9.8,98.1 c-9.6,31-25.7,50.6-52.2,53.1v28.5c26.4,2.5,42.6,22.1,52.2,53.1c9.5,30.9,10.9,68.8,9.8,98.1c-1.1,30.5,22.7,58.5,54.7,58.5h328.7 c32.1,0,55.8-28.1,54.7-58.5c-1-29.3,0.3-67.2,9.8-98.1c9.6-31,25.7-50.6,52.1-53.1v-28.5C542.7,239.2,526.5,219.6,517,188.6z M300.2,375.1h-97.9V136.8h97.4c43.3,0,71.7,23.4,71.7,59.4c0,25.3-19.1,47.9-43.5,51.8v1.3c33.2,3.6,55.5,26.6,55.5,58.3 C383.4,349.7,352.1,375.1,300.2,375.1z M290.2,266.4h-50.1v78.4h52.3c34.2,0,52.3-13.7,52.3-39.5 C344.7,279.6,326.1,266.4,290.2,266.4z"
        ],
        "btc": [
            384,
            512,
            [],
            "f15a",
            "M310.204 242.638c27.73-14.18 45.377-39.39 41.28-81.3-5.358-57.351-52.458-76.573-114.85-81.929V0h-48.528v77.203c-12.605 0-25.525.315-38.444.63V0h-48.528v79.409c-17.842.539-38.622.276-97.37 0v51.678c38.314-.678 58.417-3.14 63.023 21.427v217.429c-2.925 19.492-18.524 16.685-53.255 16.071L3.765 443.68c88.481 0 97.37.315 97.37.315V512h48.528v-67.06c13.234.315 26.154.315 38.444.315V512h48.528v-68.005c81.299-4.412 135.647-24.894 142.895-101.467 5.671-61.446-23.32-88.862-69.326-99.89zM150.608 134.553c27.415 0 113.126-8.507 113.126 48.528 0 54.515-85.71 48.212-113.126 48.212v-96.74zm0 251.776V279.821c32.772 0 133.127-9.138 133.127 53.255-.001 60.186-100.355 53.253-133.127 53.253z"
        ],
        "buffer": [
            448,
            512,
            [],
            "f837",
            "M427.84 380.67l-196.5 97.82a18.6 18.6 0 0 1-14.67 0L20.16 380.67c-4-2-4-5.28 0-7.29L67.22 350a18.65 18.65 0 0 1 14.69 0l134.76 67a18.51 18.51 0 0 0 14.67 0l134.76-67a18.62 18.62 0 0 1 14.68 0l47.06 23.43c4.05 1.96 4.05 5.24 0 7.24zm0-136.53l-47.06-23.43a18.62 18.62 0 0 0-14.68 0l-134.76 67.08a18.68 18.68 0 0 1-14.67 0L81.91 220.71a18.65 18.65 0 0 0-14.69 0l-47.06 23.43c-4 2-4 5.29 0 7.31l196.51 97.8a18.6 18.6 0 0 0 14.67 0l196.5-97.8c4.05-2.02 4.05-5.3 0-7.31zM20.16 130.42l196.5 90.29a20.08 20.08 0 0 0 14.67 0l196.51-90.29c4-1.86 4-4.89 0-6.74L231.33 33.4a19.88 19.88 0 0 0-14.67 0l-196.5 90.28c-4.05 1.85-4.05 4.88 0 6.74z"
        ],
        "buromobelexperte": [
            448,
            512,
            [],
            "f37f",
            "M0 32v128h128V32H0zm120 120H8V40h112v112zm40-120v128h128V32H160zm120 120H168V40h112v112zm40-120v128h128V32H320zm120 120H328V40h112v112zM0 192v128h128V192H0zm120 120H8V200h112v112zm40-120v128h128V192H160zm120 120H168V200h112v112zm40-120v128h128V192H320zm120 120H328V200h112v112zM0 352v128h128V352H0zm120 120H8V360h112v112zm40-120v128h128V352H160zm120 120H168V360h112v112zm40-120v128h128V352H320z"
        ],
        "buy-n-large": [
            576,
            512,
            [],
            "f8a6",
            "M288 32C133.27 32 7.79 132.32 7.79 256S133.27 480 288 480s280.21-100.32 280.21-224S442.73 32 288 32zm-85.39 357.19L64.1 390.55l77.25-290.74h133.44c63.15 0 84.93 28.65 78 72.84a60.24 60.24 0 0 1-1.5 6.85 77.39 77.39 0 0 0-17.21-1.93c-42.35 0-76.69 33.88-76.69 75.65 0 37.14 27.14 68 62.93 74.45-18.24 37.16-56.16 60.92-117.71 61.52zM358 207.11h32l-22.16 90.31h-35.41l-11.19-35.63-7.83 35.63h-37.83l26.63-90.31h31.34l15 36.75zm145.86 182.08H306.79L322.63 328a78.8 78.8 0 0 0 11.47.83c42.34 0 76.69-33.87 76.69-75.65 0-32.65-21-60.46-50.38-71.06l21.33-82.35h92.5l-53.05 205.36h103.87zM211.7 269.39H187l-13.8 56.47h24.7c16.14 0 32.11-3.18 37.94-26.65 5.56-22.31-7.99-29.82-24.14-29.82zM233 170h-21.34L200 217.71h21.37c18 0 35.38-14.64 39.21-30.14C265.23 168.71 251.07 170 233 170z"
        ],
        "buysellads": [
            448,
            512,
            [],
            "f20d",
            "M224 150.7l42.9 160.7h-85.8L224 150.7zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-65.3 325.3l-94.5-298.7H159.8L65.3 405.3H156l111.7-91.6 24.2 91.6h90.8z"
        ],
        "canadian-maple-leaf": [
            512,
            512,
            [],
            "f785",
            "M383.8 351.7c2.5-2.5 105.2-92.4 105.2-92.4l-17.5-7.5c-10-4.9-7.4-11.5-5-17.4 2.4-7.6 20.1-67.3 20.1-67.3s-47.7 10-57.7 12.5c-7.5 2.4-10-2.5-12.5-7.5s-15-32.4-15-32.4-52.6 59.9-55.1 62.3c-10 7.5-20.1 0-17.6-10 0-10 27.6-129.6 27.6-129.6s-30.1 17.4-40.1 22.4c-7.5 5-12.6 5-17.6-5C293.5 72.3 255.9 0 255.9 0s-37.5 72.3-42.5 79.8c-5 10-10 10-17.6 5-10-5-40.1-22.4-40.1-22.4S183.3 182 183.3 192c2.5 10-7.5 17.5-17.6 10-2.5-2.5-55.1-62.3-55.1-62.3S98.1 167 95.6 172s-5 9.9-12.5 7.5C73 177 25.4 167 25.4 167s17.6 59.7 20.1 67.3c2.4 6 5 12.5-5 17.4L23 259.3s102.6 89.9 105.2 92.4c5.1 5 10 7.5 5.1 22.5-5.1 15-10.1 35.1-10.1 35.1s95.2-20.1 105.3-22.6c8.7-.9 18.3 2.5 18.3 12.5S241 512 241 512h30s-5.8-102.7-5.8-112.8 9.5-13.4 18.4-12.5c10 2.5 105.2 22.6 105.2 22.6s-5-20.1-10-35.1 0-17.5 5-22.5z"
        ],
        "cc-amazon-pay": [
            576,
            512,
            [],
            "f42d",
            "M124.7 201.8c.1-11.8 0-23.5 0-35.3v-35.3c0-1.3.4-2 1.4-2.7 11.5-8 24.1-12.1 38.2-11.1 12.5.9 22.7 7 28.1 21.7 3.3 8.9 4.1 18.2 4.1 27.7 0 8.7-.7 17.3-3.4 25.6-5.7 17.8-18.7 24.7-35.7 23.9-11.7-.5-21.9-5-31.4-11.7-.9-.8-1.4-1.6-1.3-2.8zm154.9 14.6c4.6 1.8 9.3 2 14.1 1.5 11.6-1.2 21.9-5.7 31.3-12.5.9-.6 1.3-1.3 1.3-2.5-.1-3.9 0-7.9 0-11.8 0-4-.1-8 0-12 0-1.4-.4-2-1.8-2.2-7-.9-13.9-2.2-20.9-2.9-7-.6-14-.3-20.8 1.9-6.7 2.2-11.7 6.2-13.7 13.1-1.6 5.4-1.6 10.8.1 16.2 1.6 5.5 5.2 9.2 10.4 11.2zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zm-207.5 23.9c.4 1.7.9 3.4 1.6 5.1 16.5 40.6 32.9 81.3 49.5 121.9 1.4 3.5 1.7 6.4.2 9.9-2.8 6.2-4.9 12.6-7.8 18.7-2.6 5.5-6.7 9.5-12.7 11.2-4.2 1.1-8.5 1.3-12.9.9-2.1-.2-4.2-.7-6.3-.8-2.8-.2-4.2 1.1-4.3 4-.1 2.8-.1 5.6 0 8.3.1 4.6 1.6 6.7 6.2 7.5 4.7.8 9.4 1.6 14.2 1.7 14.3.3 25.7-5.4 33.1-17.9 2.9-4.9 5.6-10.1 7.7-15.4 19.8-50.1 39.5-100.3 59.2-150.5.6-1.5 1.1-3 1.3-4.6.4-2.4-.7-3.6-3.1-3.7-5.6-.1-11.1 0-16.7 0-3.1 0-5.3 1.4-6.4 4.3-.4 1.1-.9 2.3-1.3 3.4l-29.1 83.7c-2.1 6.1-4.2 12.1-6.5 18.6-.4-.9-.6-1.4-.8-1.9-10.8-29.9-21.6-59.9-32.4-89.8-1.7-4.7-3.5-9.5-5.3-14.2-.9-2.5-2.7-4-5.4-4-6.4-.1-12.8-.2-19.2-.1-2.2 0-3.3 1.6-2.8 3.7zM242.4 206c1.7 11.7 7.6 20.8 18 26.6 9.9 5.5 20.7 6.2 31.7 4.6 12.7-1.9 23.9-7.3 33.8-15.5.4-.3.8-.6 1.4-1 .5 3.2.9 6.2 1.5 9.2.5 2.6 2.1 4.3 4.5 4.4 4.6.1 9.1.1 13.7 0 2.3-.1 3.8-1.6 4-3.9.1-.8.1-1.6.1-2.3v-88.8c0-3.6-.2-7.2-.7-10.8-1.6-10.8-6.2-19.7-15.9-25.4-5.6-3.3-11.8-5-18.2-5.9-3-.4-6-.7-9.1-1.1h-10c-.8.1-1.6.3-2.5.3-8.2.4-16.3 1.4-24.2 3.5-5.1 1.3-10 3.2-15 4.9-3 1-4.5 3.2-4.4 6.5.1 2.8-.1 5.6 0 8.3.1 4.1 1.8 5.2 5.7 4.1 6.5-1.7 13.1-3.5 19.7-4.8 10.3-1.9 20.7-2.7 31.1-1.2 5.4.8 10.5 2.4 14.1 7 3.1 4 4.2 8.8 4.4 13.7.3 6.9.2 13.9.3 20.8 0 .4-.1.7-.2 1.2-.4 0-.8 0-1.1-.1-8.8-2.1-17.7-3.6-26.8-4.1-9.5-.5-18.9.1-27.9 3.2-10.8 3.8-19.5 10.3-24.6 20.8-4.1 8.3-4.6 17-3.4 25.8zM98.7 106.9v175.3c0 .8 0 1.7.1 2.5.2 2.5 1.7 4.1 4.1 4.2 5.9.1 11.8.1 17.7 0 2.5 0 4-1.7 4.1-4.1.1-.8.1-1.7.1-2.5v-60.7c.9.7 1.4 1.2 1.9 1.6 15 12.5 32.2 16.6 51.1 12.9 17.1-3.4 28.9-13.9 36.7-29.2 5.8-11.6 8.3-24.1 8.7-37 .5-14.3-1-28.4-6.8-41.7-7.1-16.4-18.9-27.3-36.7-30.9-2.7-.6-5.5-.8-8.2-1.2h-7c-1.2.2-2.4.3-3.6.5-11.7 1.4-22.3 5.8-31.8 12.7-2 1.4-3.9 3-5.9 4.5-.1-.5-.3-.8-.4-1.2-.4-2.3-.7-4.6-1.1-6.9-.6-3.9-2.5-5.5-6.4-5.6h-9.7c-5.9-.1-6.9 1-6.9 6.8zM493.6 339c-2.7-.7-5.1 0-7.6 1-43.9 18.4-89.5 30.2-136.8 35.8-14.5 1.7-29.1 2.8-43.7 3.2-26.6.7-53.2-.8-79.6-4.3-17.8-2.4-35.5-5.7-53-9.9-37-8.9-72.7-21.7-106.7-38.8-8.8-4.4-17.4-9.3-26.1-14-3.8-2.1-6.2-1.5-8.2 2.1v1.7c1.2 1.6 2.2 3.4 3.7 4.8 36 32.2 76.6 56.5 122 72.9 21.9 7.9 44.4 13.7 67.3 17.5 14 2.3 28 3.8 42.2 4.5 3 .1 6 .2 9 .4.7 0 1.4.2 2.1.3h17.7c.7-.1 1.4-.3 2.1-.3 14.9-.4 29.8-1.8 44.6-4 21.4-3.2 42.4-8.1 62.9-14.7 29.6-9.6 57.7-22.4 83.4-40.1 2.8-1.9 5.7-3.8 8-6.2 4.3-4.4 2.3-10.4-3.3-11.9zm50.4-27.7c-.8-4.2-4-5.8-7.6-7-5.7-1.9-11.6-2.8-17.6-3.3-11-.9-22-.4-32.8 1.6-12 2.2-23.4 6.1-33.5 13.1-1.2.8-2.4 1.8-3.1 3-.6.9-.7 2.3-.5 3.4.3 1.3 1.7 1.6 3 1.5.6 0 1.2 0 1.8-.1l19.5-2.1c9.6-.9 19.2-1.5 28.8-.8 4.1.3 8.1 1.2 12 2.2 4.3 1.1 6.2 4.4 6.4 8.7.3 6.7-1.2 13.1-2.9 19.5-3.5 12.9-8.3 25.4-13.3 37.8-.3.8-.7 1.7-.8 2.5-.4 2.5 1 4 3.4 3.5 1.4-.3 3-1.1 4-2.1 3.7-3.6 7.5-7.2 10.6-11.2 10.7-13.8 17-29.6 20.7-46.6.7-3 1.2-6.1 1.7-9.1.2-4.7.2-9.6.2-14.5z"
        ],
        "cc-amex": [
            576,
            512,
            [],
            "f1f3",
            "M325.1 167.8c0-16.4-14.1-18.4-27.4-18.4l-39.1-.3v69.3H275v-25.1h18c18.4 0 14.5 10.3 14.8 25.1h16.6v-13.5c0-9.2-1.5-15.1-11-18.4 7.4-3 11.8-10.7 11.7-18.7zm-29.4 11.3H275v-15.3h21c5.1 0 10.7 1 10.7 7.4 0 6.6-5.3 7.9-11 7.9zM279 268.6h-52.7l-21 22.8-20.5-22.8h-66.5l-.1 69.3h65.4l21.3-23 20.4 23h32.2l.1-23.3c18.9 0 49.3 4.6 49.3-23.3 0-17.3-12.3-22.7-27.9-22.7zm-103.8 54.7h-40.6v-13.8h36.3v-14.1h-36.3v-12.5h41.7l17.9 20.2zm65.8 8.2l-25.3-28.1L241 276zm37.8-31h-21.2v-17.6h21.5c5.6 0 10.2 2.3 10.2 8.4 0 6.4-4.6 9.2-10.5 9.2zm-31.6-136.7v-14.6h-55.5v69.3h55.5v-14.3h-38.9v-13.8h37.8v-14.1h-37.8v-12.5zM576 255.4h-.2zm-194.6 31.9c0-16.4-14.1-18.7-27.1-18.7h-39.4l-.1 69.3h16.6l.1-25.3h17.6c11 0 14.8 2 14.8 13.8l-.1 11.5h16.6l.1-13.8c0-8.9-1.8-15.1-11-18.4 7.7-3.1 11.8-10.8 11.9-18.4zm-29.2 11.2h-20.7v-15.6h21c5.1 0 10.7 1 10.7 7.4 0 6.9-5.4 8.2-11 8.2zm-172.8-80v-69.3h-27.6l-19.7 47-21.7-47H83.3v65.7l-28.1-65.7H30.7L1 218.5h17.9l6.4-15.3h34.5l6.4 15.3H100v-54.2l24 54.2h14.6l24-54.2v54.2zM31.2 188.8l11.2-27.6 11.5 27.6zm477.4 158.9v-4.5c-10.8 5.6-3.9 4.5-156.7 4.5 0-25.2.1-23.9 0-25.2-1.7-.1-3.2-.1-9.4-.1 0 17.9-.1 6.8-.1 25.3h-39.6c0-12.1.1-15.3.1-29.2-10 6-22.8 6.4-34.3 6.2 0 14.7-.1 8.3-.1 23h-48.9c-5.1-5.7-2.7-3.1-15.4-17.4-3.2 3.5-12.8 13.9-16.1 17.4h-82v-92.3h83.1c5 5.6 2.8 3.1 15.5 17.2 3.2-3.5 12.2-13.4 15.7-17.2h58c9.8 0 18 1.9 24.3 5.6v-5.6c54.3 0 64.3-1.4 75.7 5.1v-5.1h78.2v5.2c11.4-6.9 19.6-5.2 64.9-5.2v5c10.3-5.9 16.6-5.2 54.3-5V80c0-26.5-21.5-48-48-48h-480c-26.5 0-48 21.5-48 48v109.8c9.4-21.9 19.7-46 23.1-53.9h39.7c4.3 10.1 1.6 3.7 9 21.1v-21.1h46c2.9 6.2 11.1 24 13.9 30 5.8-13.6 10.1-23.9 12.6-30h103c0-.1 11.5 0 11.6 0 43.7.2 53.6-.8 64.4 5.3v-5.3H363v9.3c7.6-6.1 17.9-9.3 30.7-9.3h27.6c0 .5 1.9.3 2.3.3H456c4.2 9.8 2.6 6 8.8 20.6v-20.6h43.3c4.9 8-1-1.8 11.2 18.4v-18.4h39.9v92h-41.6c-5.4-9-1.4-2.2-13.2-21.9v21.9h-52.8c-6.4-14.8-.1-.3-6.6-15.3h-19c-4.2 10-2.2 5.2-6.4 15.3h-26.8c-12.3 0-22.3-3-29.7-8.9v8.9h-66.5c-.3-13.9-.1-24.8-.1-24.8-1.8-.3-3.4-.2-9.8-.2v25.1H151.2v-11.4c-2.5 5.6-2.7 5.9-5.1 11.4h-29.5c-4-8.9-2.9-6.4-5.1-11.4v11.4H58.6c-4.2-10.1-2.2-5.3-6.4-15.3H33c-4.2 10-2.2 5.2-6.4 15.3H0V432c0 26.5 21.5 48 48 48h480.1c26.5 0 48-21.5 48-48v-90.4c-12.7 8.3-32.7 6.1-67.5 6.1zm36.3-64.5H575v-14.6h-32.9c-12.8 0-23.8 6.6-23.8 20.7 0 33 42.7 12.8 42.7 27.4 0 5.1-4.3 6.4-8.4 6.4h-32l-.1 14.8h32c8.4 0 17.6-1.8 22.5-8.9v-25.8c-10.5-13.8-39.3-1.3-39.3-13.5 0-5.8 4.6-6.5 9.2-6.5zm-57 39.8h-32.2l-.1 14.8h32.2c14.8 0 26.2-5.6 26.2-22 0-33.2-42.9-11.2-42.9-26.3 0-5.6 4.9-6.4 9.2-6.4h30.4v-14.6h-33.2c-12.8 0-23.5 6.6-23.5 20.7 0 33 42.7 12.5 42.7 27.4-.1 5.4-4.7 6.4-8.8 6.4zm-42.2-40.1v-14.3h-55.2l-.1 69.3h55.2l.1-14.3-38.6-.3v-13.8H445v-14.1h-37.8v-12.5zm-56.3-108.1c-.3.2-1.4 2.2-1.4 7.6 0 6 .9 7.7 1.1 7.9.2.1 1.1.5 3.4.5l7.3-16.9c-1.1 0-2.1-.1-3.1-.1-5.6 0-7 .7-7.3 1zm20.4-10.5h-.1zm-16.2-15.2c-23.5 0-34 12-34 35.3 0 22.2 10.2 34 33 34h19.2l6.4-15.3h34.3l6.6 15.3h33.7v-51.9l31.2 51.9h23.6v-69h-16.9v48.1l-29.1-48.1h-25.3v65.4l-27.9-65.4h-24.8l-23.5 54.5h-7.4c-13.3 0-16.1-8.1-16.1-19.9 0-23.8 15.7-20 33.1-19.7v-15.2zm42.1 12.1l11.2 27.6h-22.8zm-101.1-12v69.3h16.9v-69.3z"
        ],
        "cc-apple-pay": [
            576,
            512,
            [],
            "f416",
            "M302.2 218.4c0 17.2-10.5 27.1-29 27.1h-24.3v-54.2h24.4c18.4 0 28.9 9.8 28.9 27.1zm47.5 62.6c0 8.3 7.2 13.7 18.5 13.7 14.4 0 25.2-9.1 25.2-21.9v-7.7l-23.5 1.5c-13.3.9-20.2 5.8-20.2 14.4zM576 79v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V79c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM127.8 197.2c8.4.7 16.8-4.2 22.1-10.4 5.2-6.4 8.6-15 7.7-23.7-7.4.3-16.6 4.9-21.9 11.3-4.8 5.5-8.9 14.4-7.9 22.8zm60.6 74.5c-.2-.2-19.6-7.6-19.8-30-.2-18.7 15.3-27.7 16-28.2-8.8-13-22.4-14.4-27.1-14.7-12.2-.7-22.6 6.9-28.4 6.9-5.9 0-14.7-6.6-24.3-6.4-12.5.2-24.2 7.3-30.5 18.6-13.1 22.6-3.4 56 9.3 74.4 6.2 9.1 13.7 19.1 23.5 18.7 9.3-.4 13-6 24.2-6 11.3 0 14.5 6 24.3 5.9 10.2-.2 16.5-9.1 22.8-18.2 6.9-10.4 9.8-20.4 10-21zm135.4-53.4c0-26.6-18.5-44.8-44.9-44.8h-51.2v136.4h21.2v-46.6h29.3c26.8 0 45.6-18.4 45.6-45zm90 23.7c0-19.7-15.8-32.4-40-32.4-22.5 0-39.1 12.9-39.7 30.5h19.1c1.6-8.4 9.4-13.9 20-13.9 13 0 20.2 6 20.2 17.2v7.5l-26.4 1.6c-24.6 1.5-37.9 11.6-37.9 29.1 0 17.7 13.7 29.4 33.4 29.4 13.3 0 25.6-6.7 31.2-17.4h.4V310h19.6v-68zM516 210.9h-21.5l-24.9 80.6h-.4l-24.9-80.6H422l35.9 99.3-1.9 6c-3.2 10.2-8.5 14.2-17.9 14.2-1.7 0-4.9-.2-6.2-.3v16.4c1.2.4 6.5.5 8.1.5 20.7 0 30.4-7.9 38.9-31.8L516 210.9z"
        ],
        "cc-diners-club": [
            576,
            512,
            [],
            "f24c",
            "M239.7 79.9c-96.9 0-175.8 78.6-175.8 175.8 0 96.9 78.9 175.8 175.8 175.8 97.2 0 175.8-78.9 175.8-175.8 0-97.2-78.6-175.8-175.8-175.8zm-39.9 279.6c-41.7-15.9-71.4-56.4-71.4-103.8s29.7-87.9 71.4-104.1v207.9zm79.8.3V151.6c41.7 16.2 71.4 56.7 71.4 104.1s-29.7 87.9-71.4 104.1zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM329.7 448h-90.3c-106.2 0-193.8-85.5-193.8-190.2C45.6 143.2 133.2 64 239.4 64h90.3c105 0 200.7 79.2 200.7 193.8 0 104.7-95.7 190.2-200.7 190.2z"
        ],
        "cc-discover": [
            576,
            512,
            [],
            "f1f2",
            "M520.4 196.1c0-7.9-5.5-12.1-15.6-12.1h-4.9v24.9h4.7c10.3 0 15.8-4.4 15.8-12.8zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-44.1 138.9c22.6 0 52.9-4.1 52.9 24.4 0 12.6-6.6 20.7-18.7 23.2l25.8 34.4h-19.6l-22.2-32.8h-2.2v32.8h-16zm-55.9.1h45.3v14H444v18.2h28.3V217H444v22.2h29.3V253H428zm-68.7 0l21.9 55.2 22.2-55.2h17.5l-35.5 84.2h-8.6l-35-84.2zm-55.9-3c24.7 0 44.6 20 44.6 44.6 0 24.7-20 44.6-44.6 44.6-24.7 0-44.6-20-44.6-44.6 0-24.7 20-44.6 44.6-44.6zm-49.3 6.1v19c-20.1-20.1-46.8-4.7-46.8 19 0 25 27.5 38.5 46.8 19.2v19c-29.7 14.3-63.3-5.7-63.3-38.2 0-31.2 33.1-53 63.3-38zm-97.2 66.3c11.4 0 22.4-15.3-3.3-24.4-15-5.5-20.2-11.4-20.2-22.7 0-23.2 30.6-31.4 49.7-14.3l-8.4 10.8c-10.4-11.6-24.9-6.2-24.9 2.5 0 4.4 2.7 6.9 12.3 10.3 18.2 6.6 23.6 12.5 23.6 25.6 0 29.5-38.8 37.4-56.6 11.3l10.3-9.9c3.7 7.1 9.9 10.8 17.5 10.8zM55.4 253H32v-82h23.4c26.1 0 44.1 17 44.1 41.1 0 18.5-13.2 40.9-44.1 40.9zm67.5 0h-16v-82h16zM544 433c0 8.2-6.8 15-15 15H128c189.6-35.6 382.7-139.2 416-160zM74.1 191.6c-5.2-4.9-11.6-6.6-21.9-6.6H48v54.2h4.2c10.3 0 17-2 21.9-6.4 5.7-5.2 8.9-12.8 8.9-20.7s-3.2-15.5-8.9-20.5z"
        ],
        "cc-jcb": [
            576,
            512,
            [],
            "f24b",
            "M431.5 244.3V212c41.2 0 38.5.2 38.5.2 7.3 1.3 13.3 7.3 13.3 16 0 8.8-6 14.5-13.3 15.8-1.2.4-3.3.3-38.5.3zm42.8 20.2c-2.8-.7-3.3-.5-42.8-.5v35c39.6 0 40 .2 42.8-.5 7.5-1.5 13.5-8 13.5-17 0-8.7-6-15.5-13.5-17zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM182 192.3h-57c0 67.1 10.7 109.7-35.8 109.7-19.5 0-38.8-5.7-57.2-14.8v28c30 8.3 68 8.3 68 8.3 97.9 0 82-47.7 82-131.2zm178.5 4.5c-63.4-16-165-14.9-165 59.3 0 77.1 108.2 73.6 165 59.2V287C312.9 311.7 253 309 253 256s59.8-55.6 107.5-31.2v-28zM544 286.5c0-18.5-16.5-30.5-38-32v-.8c19.5-2.7 30.3-15.5 30.3-30.2 0-19-15.7-30-37-31 0 0 6.3-.3-120.3-.3v127.5h122.7c24.3.1 42.3-12.9 42.3-33.2z"
        ],
        "cc-mastercard": [
            576,
            512,
            [],
            "f1f1",
            "M482.9 410.3c0 6.8-4.6 11.7-11.2 11.7-6.8 0-11.2-5.2-11.2-11.7 0-6.5 4.4-11.7 11.2-11.7 6.6 0 11.2 5.2 11.2 11.7zm-310.8-11.7c-7.1 0-11.2 5.2-11.2 11.7 0 6.5 4.1 11.7 11.2 11.7 6.5 0 10.9-4.9 10.9-11.7-.1-6.5-4.4-11.7-10.9-11.7zm117.5-.3c-5.4 0-8.7 3.5-9.5 8.7h19.1c-.9-5.7-4.4-8.7-9.6-8.7zm107.8.3c-6.8 0-10.9 5.2-10.9 11.7 0 6.5 4.1 11.7 10.9 11.7 6.8 0 11.2-4.9 11.2-11.7 0-6.5-4.4-11.7-11.2-11.7zm105.9 26.1c0 .3.3.5.3 1.1 0 .3-.3.5-.3 1.1-.3.3-.3.5-.5.8-.3.3-.5.5-1.1.5-.3.3-.5.3-1.1.3-.3 0-.5 0-1.1-.3-.3 0-.5-.3-.8-.5-.3-.3-.5-.5-.5-.8-.3-.5-.3-.8-.3-1.1 0-.5 0-.8.3-1.1 0-.5.3-.8.5-1.1.3-.3.5-.3.8-.5.5-.3.8-.3 1.1-.3.5 0 .8 0 1.1.3.5.3.8.3 1.1.5s.2.6.5 1.1zm-2.2 1.4c.5 0 .5-.3.8-.3.3-.3.3-.5.3-.8 0-.3 0-.5-.3-.8-.3 0-.5-.3-1.1-.3h-1.6v3.5h.8V426h.3l1.1 1.4h.8l-1.1-1.3zM576 81v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V81c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM64 220.6c0 76.5 62.1 138.5 138.5 138.5 27.2 0 53.9-8.2 76.5-23.1-72.9-59.3-72.4-171.2 0-230.5-22.6-15-49.3-23.1-76.5-23.1-76.4-.1-138.5 62-138.5 138.2zm224 108.8c70.5-55 70.2-162.2 0-217.5-70.2 55.3-70.5 162.6 0 217.5zm-142.3 76.3c0-8.7-5.7-14.4-14.7-14.7-4.6 0-9.5 1.4-12.8 6.5-2.4-4.1-6.5-6.5-12.2-6.5-3.8 0-7.6 1.4-10.6 5.4V392h-8.2v36.7h8.2c0-18.9-2.5-30.2 9-30.2 10.2 0 8.2 10.2 8.2 30.2h7.9c0-18.3-2.5-30.2 9-30.2 10.2 0 8.2 10 8.2 30.2h8.2v-23zm44.9-13.7h-7.9v4.4c-2.7-3.3-6.5-5.4-11.7-5.4-10.3 0-18.2 8.2-18.2 19.3 0 11.2 7.9 19.3 18.2 19.3 5.2 0 9-1.9 11.7-5.4v4.6h7.9V392zm40.5 25.6c0-15-22.9-8.2-22.9-15.2 0-5.7 11.9-4.8 18.5-1.1l3.3-6.5c-9.4-6.1-30.2-6-30.2 8.2 0 14.3 22.9 8.3 22.9 15 0 6.3-13.5 5.8-20.7.8l-3.5 6.3c11.2 7.6 32.6 6 32.6-7.5zm35.4 9.3l-2.2-6.8c-3.8 2.1-12.2 4.4-12.2-4.1v-16.6h13.1V392h-13.1v-11.2h-8.2V392h-7.6v7.3h7.6V416c0 17.6 17.3 14.4 22.6 10.9zm13.3-13.4h27.5c0-16.2-7.4-22.6-17.4-22.6-10.6 0-18.2 7.9-18.2 19.3 0 20.5 22.6 23.9 33.8 14.2l-3.8-6c-7.8 6.4-19.6 5.8-21.9-4.9zm59.1-21.5c-4.6-2-11.6-1.8-15.2 4.4V392h-8.2v36.7h8.2V408c0-11.6 9.5-10.1 12.8-8.4l2.4-7.6zm10.6 18.3c0-11.4 11.6-15.1 20.7-8.4l3.8-6.5c-11.6-9.1-32.7-4.1-32.7 15 0 19.8 22.4 23.8 32.7 15l-3.8-6.5c-9.2 6.5-20.7 2.6-20.7-8.6zm66.7-18.3H408v4.4c-8.3-11-29.9-4.8-29.9 13.9 0 19.2 22.4 24.7 29.9 13.9v4.6h8.2V392zm33.7 0c-2.4-1.2-11-2.9-15.2 4.4V392h-7.9v36.7h7.9V408c0-11 9-10.3 12.8-8.4l2.4-7.6zm40.3-14.9h-7.9v19.3c-8.2-10.9-29.9-5.1-29.9 13.9 0 19.4 22.5 24.6 29.9 13.9v4.6h7.9v-51.7zm7.6-75.1v4.6h.8V302h1.9v-.8h-4.6v.8h1.9zm6.6 123.8c0-.5 0-1.1-.3-1.6-.3-.3-.5-.8-.8-1.1-.3-.3-.8-.5-1.1-.8-.5 0-1.1-.3-1.6-.3-.3 0-.8.3-1.4.3-.5.3-.8.5-1.1.8-.5.3-.8.8-.8 1.1-.3.5-.3 1.1-.3 1.6 0 .3 0 .8.3 1.4 0 .3.3.8.8 1.1.3.3.5.5 1.1.8.5.3 1.1.3 1.4.3.5 0 1.1 0 1.6-.3.3-.3.8-.5 1.1-.8.3-.3.5-.8.8-1.1.3-.6.3-1.1.3-1.4zm3.2-124.7h-1.4l-1.6 3.5-1.6-3.5h-1.4v5.4h.8v-4.1l1.6 3.5h1.1l1.4-3.5v4.1h1.1v-5.4zm4.4-80.5c0-76.2-62.1-138.3-138.5-138.3-27.2 0-53.9 8.2-76.5 23.1 72.1 59.3 73.2 171.5 0 230.5 22.6 15 49.5 23.1 76.5 23.1 76.4.1 138.5-61.9 138.5-138.4z"
        ],
        "cc-paypal": [
            576,
            512,
            [],
            "f1f4",
            "M186.3 258.2c0 12.2-9.7 21.5-22 21.5-9.2 0-16-5.2-16-15 0-12.2 9.5-22 21.7-22 9.3 0 16.3 5.7 16.3 15.5zM80.5 209.7h-4.7c-1.5 0-3 1-3.2 2.7l-4.3 26.7 8.2-.3c11 0 19.5-1.5 21.5-14.2 2.3-13.4-6.2-14.9-17.5-14.9zm284 0H360c-1.8 0-3 1-3.2 2.7l-4.2 26.7 8-.3c13 0 22-3 22-18-.1-10.6-9.6-11.1-18.1-11.1zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM128.3 215.4c0-21-16.2-28-34.7-28h-40c-2.5 0-5 2-5.2 4.7L32 294.2c-.3 2 1.2 4 3.2 4h19c2.7 0 5.2-2.9 5.5-5.7l4.5-26.6c1-7.2 13.2-4.7 18-4.7 28.6 0 46.1-17 46.1-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.2 8.2-5.8-8.5-14.2-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9 0 20.2-4.9 26.5-11.9-.5 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H200c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm40.5 97.9l63.7-92.6c.5-.5.5-1 .5-1.7 0-1.7-1.5-3.5-3.2-3.5h-19.2c-1.7 0-3.5 1-4.5 2.5l-26.5 39-11-37.5c-.8-2.2-3-4-5.5-4h-18.7c-1.7 0-3.2 1.8-3.2 3.5 0 1.2 19.5 56.8 21.2 62.1-2.7 3.8-20.5 28.6-20.5 31.6 0 1.8 1.5 3.2 3.2 3.2h19.2c1.8-.1 3.5-1.1 4.5-2.6zm159.3-106.7c0-21-16.2-28-34.7-28h-39.7c-2.7 0-5.2 2-5.5 4.7l-16.2 102c-.2 2 1.3 4 3.2 4h20.5c2 0 3.5-1.5 4-3.2l4.5-29c1-7.2 13.2-4.7 18-4.7 28.4 0 45.9-17 45.9-45.8zm84.2 8.8h-19c-3.8 0-4 5.5-4.3 8.2-5.5-8.5-14-10-23.7-10-24.5 0-43.2 21.5-43.2 45.2 0 19.5 12.2 32.2 31.7 32.2 9.3 0 20.5-4.9 26.5-11.9-.3 1.5-1 4.7-1 6.2 0 2.3 1 4 3.2 4H484c2.7 0 5-2.9 5.5-5.7l10.2-64.3c.3-1.9-1.2-3.9-3.2-3.9zm47.5-33.3c0-2-1.5-3.5-3.2-3.5h-18.5c-1.5 0-3 1.2-3.2 2.7l-16.2 104-.3.5c0 1.8 1.5 3.5 3.5 3.5h16.5c2.5 0 5-2.9 5.2-5.7L544 191.2v-.3zm-90 51.8c-12.2 0-21.7 9.7-21.7 22 0 9.7 7 15 16.2 15 12 0 21.7-9.2 21.7-21.5.1-9.8-6.9-15.5-16.2-15.5z"
        ],
        "cc-stripe": [
            576,
            512,
            [],
            "f1f5",
            "M492.4 220.8c-8.9 0-18.7 6.7-18.7 22.7h36.7c0-16-9.3-22.7-18-22.7zM375 223.4c-8.2 0-13.3 2.9-17 7l.2 52.8c3.5 3.7 8.5 6.7 16.8 6.7 13.1 0 21.9-14.3 21.9-33.4 0-18.6-9-33.2-21.9-33.1zM528 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h480c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM122.2 281.1c0 25.6-20.3 40.1-49.9 40.3-12.2 0-25.6-2.4-38.8-8.1v-33.9c12 6.4 27.1 11.3 38.9 11.3 7.9 0 13.6-2.1 13.6-8.7 0-17-54-10.6-54-49.9 0-25.2 19.2-40.2 48-40.2 11.8 0 23.5 1.8 35.3 6.5v33.4c-10.8-5.8-24.5-9.1-35.3-9.1-7.5 0-12.1 2.2-12.1 7.7 0 16 54.3 8.4 54.3 50.7zm68.8-56.6h-27V275c0 20.9 22.5 14.4 27 12.6v28.9c-4.7 2.6-13.3 4.7-24.9 4.7-21.1 0-36.9-15.5-36.9-36.5l.2-113.9 34.7-7.4v30.8H191zm74 2.4c-4.5-1.5-18.7-3.6-27.1 7.4v84.4h-35.5V194.2h30.7l2.2 10.5c8.3-15.3 24.9-12.2 29.6-10.5h.1zm44.1 91.8h-35.7V194.2h35.7zm0-142.9l-35.7 7.6v-28.9l35.7-7.6zm74.1 145.5c-12.4 0-20-5.3-25.1-9l-.1 40.2-35.5 7.5V194.2h31.3l1.8 8.8c4.9-4.5 13.9-11.1 27.8-11.1 24.9 0 48.4 22.5 48.4 63.8 0 45.1-23.2 65.5-48.6 65.6zm160.4-51.5h-69.5c1.6 16.6 13.8 21.5 27.6 21.5 14.1 0 25.2-3 34.9-7.9V312c-9.7 5.3-22.4 9.2-39.4 9.2-34.6 0-58.8-21.7-58.8-64.5 0-36.2 20.5-64.9 54.3-64.9 33.7 0 51.3 28.7 51.3 65.1 0 3.5-.3 10.9-.4 12.9z"
        ],
        "cc-visa": [
            576,
            512,
            [],
            "f1f0",
            "M470.1 231.3s7.6 37.2 9.3 45H446c3.3-8.9 16-43.5 16-43.5-.2.3 3.3-9.1 5.3-14.9l2.8 13.4zM576 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h480c26.5 0 48 21.5 48 48zM152.5 331.2L215.7 176h-42.5l-39.3 106-4.3-21.5-14-71.4c-2.3-9.9-9.4-12.7-18.2-13.1H32.7l-.7 3.1c15.8 4 29.9 9.8 42.2 17.1l35.8 135h42.5zm94.4.2L272.1 176h-40.2l-25.1 155.4h40.1zm139.9-50.8c.2-17.7-10.6-31.2-33.7-42.3-14.1-7.1-22.7-11.9-22.7-19.2.2-6.6 7.3-13.4 23.1-13.4 13.1-.3 22.7 2.8 29.9 5.9l3.6 1.7 5.5-33.6c-7.9-3.1-20.5-6.6-36-6.6-39.7 0-67.6 21.2-67.8 51.4-.3 22.3 20 34.7 35.2 42.2 15.5 7.6 20.8 12.6 20.8 19.3-.2 10.4-12.6 15.2-24.1 15.2-16 0-24.6-2.5-37.7-8.3l-5.3-2.5-5.6 34.9c9.4 4.3 26.8 8.1 44.8 8.3 42.2.1 69.7-20.8 70-53zM528 331.4L495.6 176h-31.1c-9.6 0-16.9 2.8-21 12.9l-59.7 142.5H426s6.9-19.2 8.4-23.3H486c1.2 5.5 4.8 23.3 4.8 23.3H528z"
        ],
        "centercode": [
            512,
            512,
            [],
            "f380",
            "M329.2 268.6c-3.8 35.2-35.4 60.6-70.6 56.8-35.2-3.8-60.6-35.4-56.8-70.6 3.8-35.2 35.4-60.6 70.6-56.8 35.1 3.8 60.6 35.4 56.8 70.6zm-85.8 235.1C96.7 496-8.2 365.5 10.1 224.3c11.2-86.6 65.8-156.9 139.1-192 161-77.1 349.7 37.4 354.7 216.6 4.1 147-118.4 262.2-260.5 254.8zm179.9-180c27.9-118-160.5-205.9-237.2-234.2-57.5 56.3-69.1 188.6-33.8 344.4 68.8 15.8 169.1-26.4 271-110.2z"
        ],
        "centos": [
            448,
            512,
            [],
            "f789",
            "M289.6 97.5l31.6 31.7-76.3 76.5V97.5zm-162.4 31.7l76.3 76.5V97.5h-44.7zm41.5-41.6h44.7v127.9l10.8 10.8 10.8-10.8V87.6h44.7L224.2 32zm26.2 168.1l-10.8-10.8H55.5v-44.8L0 255.7l55.5 55.6v-44.8h128.6l10.8-10.8zm79.3-20.7h107.9v-44.8l-31.6-31.7zm173.3 20.7L392 200.1v44.8H264.3l-10.8 10.8 10.8 10.8H392v44.8l55.5-55.6zM65.4 176.2l32.5-31.7 90.3 90.5h15.3v-15.3l-90.3-90.5 31.6-31.7H65.4zm316.7-78.7h-78.5l31.6 31.7-90.3 90.5V235h15.3l90.3-90.5 31.6 31.7zM203.5 413.9V305.8l-76.3 76.5 31.6 31.7h44.7zM65.4 235h108.8l-76.3-76.5-32.5 31.7zm316.7 100.2l-31.6 31.7-90.3-90.5h-15.3v15.3l90.3 90.5-31.6 31.7h78.5zm0-58.8H274.2l76.3 76.5 31.6-31.7zm-60.9 105.8l-76.3-76.5v108.1h44.7zM97.9 352.9l76.3-76.5H65.4v44.8zm181.8 70.9H235V295.9l-10.8-10.8-10.8 10.8v127.9h-44.7l55.5 55.6zm-166.5-41.6l90.3-90.5v-15.3h-15.3l-90.3 90.5-32.5-31.7v78.7h79.4z"
        ],
        "chrome": [
            496,
            512,
            [],
            "f268",
            "M131.5 217.5L55.1 100.1c47.6-59.2 119-91.8 192-92.1 42.3-.3 85.5 10.5 124.8 33.2 43.4 25.2 76.4 61.4 97.4 103L264 133.4c-58.1-3.4-113.4 29.3-132.5 84.1zm32.9 38.5c0 46.2 37.4 83.6 83.6 83.6s83.6-37.4 83.6-83.6-37.4-83.6-83.6-83.6-83.6 37.3-83.6 83.6zm314.9-89.2L339.6 174c37.9 44.3 38.5 108.2 6.6 157.2L234.1 503.6c46.5 2.5 94.4-7.7 137.8-32.9 107.4-62 150.9-192 107.4-303.9zM133.7 303.6L40.4 120.1C14.9 159.1 0 205.9 0 256c0 124 90.8 226.7 209.5 244.9l63.7-124.8c-57.6 10.8-113.2-20.8-139.5-72.5z"
        ],
        "chromecast": [
            512,
            512,
            [],
            "f838",
            "M447.8,64H64c-23.6,0-42.7,19.1-42.7,42.7v63.9H64v-63.9h383.8v298.6H298.6V448H448c23.6,0,42.7-19.1,42.7-42.7V106.7 C490.7,83.1,471.4,64,447.8,64z M21.3,383.6L21.3,383.6l0,63.9h63.9C85.2,412.2,56.6,383.6,21.3,383.6L21.3,383.6z M21.3,298.6V341 c58.9,0,106.6,48.1,106.6,107h42.7C170.7,365.6,103.7,298.7,21.3,298.6z M213.4,448h42.7c-0.5-129.5-105.3-234.3-234.8-234.6l0,42.4 C127.3,255.6,213.3,342,213.4,448z"
        ],
        "cloudflare": [
            640,
            512,
            [],
            "e07d",
            "M407.906,319.913l-230.8-2.928a4.58,4.58,0,0,1-3.632-1.926,4.648,4.648,0,0,1-.494-4.147,6.143,6.143,0,0,1,5.361-4.076L411.281,303.9c27.631-1.26,57.546-23.574,68.022-50.784l13.286-34.542a7.944,7.944,0,0,0,.524-2.936,7.735,7.735,0,0,0-.164-1.631A151.91,151.91,0,0,0,201.257,198.4,68.12,68.12,0,0,0,94.2,269.59C41.924,271.106,0,313.728,0,366.12a96.054,96.054,0,0,0,1.029,13.958,4.508,4.508,0,0,0,4.445,3.871l426.1.051c.043,0,.08-.019.122-.02a5.606,5.606,0,0,0,5.271-4l3.273-11.265c3.9-13.4,2.448-25.8-4.1-34.9C430.124,325.423,420.09,320.487,407.906,319.913ZM513.856,221.1c-2.141,0-4.271.062-6.391.164a3.771,3.771,0,0,0-3.324,2.653l-9.077,31.193c-3.9,13.4-2.449,25.786,4.1,34.89,6.02,8.4,16.054,13.323,28.238,13.9l49.2,2.939a4.491,4.491,0,0,1,3.51,1.894,4.64,4.64,0,0,1,.514,4.169,6.153,6.153,0,0,1-5.351,4.075l-51.125,2.939c-27.754,1.27-57.669,23.574-68.145,50.784l-3.695,9.606a2.716,2.716,0,0,0,2.427,3.68c.046,0,.088.017.136.017h175.91a4.69,4.69,0,0,0,4.539-3.37,124.807,124.807,0,0,0,4.682-34C640,277.3,583.524,221.1,513.856,221.1Z"
        ],
        "cloudscale": [
            448,
            512,
            [],
            "f383",
            "M318.1 154l-9.4 7.6c-22.5-19.3-51.5-33.6-83.3-33.6C153.8 128 96 188.8 96 260.3c0 6.6.4 13.1 1.4 19.4-2-56 41.8-97.4 92.6-97.4 24.2 0 46.2 9.4 62.6 24.7l-25.2 20.4c-8.3-.9-16.8 1.8-23.1 8.1-11.1 11-11.1 28.9 0 40 11.1 11 28.9 11 40 0 6.3-6.3 9-14.9 8.1-23.1l75.2-88.8c6.3-6.5-3.3-15.9-9.5-9.6zm-83.8 111.5c-5.6 5.5-14.6 5.5-20.2 0-5.6-5.6-5.6-14.6 0-20.2s14.6-5.6 20.2 0 5.6 14.7 0 20.2zM224 32C100.5 32 0 132.5 0 256s100.5 224 224 224 224-100.5 224-224S347.5 32 224 32zm0 384c-88.2 0-160-71.8-160-160S135.8 96 224 96s160 71.8 160 160-71.8 160-160 160z"
        ],
        "cloudsmith": [
            332,
            512,
            [],
            "f384",
            "M332.5 419.9c0 46.4-37.6 84.1-84 84.1s-84-37.7-84-84.1 37.6-84 84-84 84 37.6 84 84zm-84-243.9c46.4 0 80-37.6 80-84s-33.6-84-80-84-88 37.6-88 84-29.6 76-76 76-84 41.6-84 88 37.6 80 84 80 84-33.6 84-80 33.6-80 80-80z"
        ],
        "cloudversify": [
            616,
            512,
            [],
            "f385",
            "M148.6 304c8.2 68.5 67.4 115.5 146 111.3 51.2 43.3 136.8 45.8 186.4-5.6 69.2 1.1 118.5-44.6 131.5-99.5 14.8-62.5-18.2-132.5-92.1-155.1-33-88.1-131.4-101.5-186.5-85-57.3 17.3-84.3 53.2-99.3 109.7-7.8 2.7-26.5 8.9-45 24.1 11.7 0 15.2 8.9 15.2 19.5v20.4c0 10.7-8.7 19.5-19.5 19.5h-20.2c-10.7 0-19.5-6-19.5-16.7V240H98.8C95 240 88 244.3 88 251.9v40.4c0 6.4 5.3 11.8 11.7 11.8h48.9zm227.4 8c-10.7 46.3 21.7 72.4 55.3 86.8C324.1 432.6 259.7 348 296 288c-33.2 21.6-33.7 71.2-29.2 92.9-17.9-12.4-53.8-32.4-57.4-79.8-3-39.9 21.5-75.7 57-93.9C297 191.4 369.9 198.7 400 248c-14.1-48-53.8-70.1-101.8-74.8 30.9-30.7 64.4-50.3 114.2-43.7 69.8 9.3 133.2 82.8 67.7 150.5 35-16.3 48.7-54.4 47.5-76.9l10.5 19.6c11.8 22 15.2 47.6 9.4 72-9.2 39-40.6 68.8-79.7 76.5-32.1 6.3-83.1-5.1-91.8-59.2zM128 208H88.2c-8.9 0-16.2-7.3-16.2-16.2v-39.6c0-8.9 7.3-16.2 16.2-16.2H128c8.9 0 16.2 7.3 16.2 16.2v39.6c0 8.9-7.3 16.2-16.2 16.2zM10.1 168C4.5 168 0 163.5 0 157.9v-27.8c0-5.6 4.5-10.1 10.1-10.1h27.7c5.5 0 10.1 4.5 10.1 10.1v27.8c0 5.6-4.5 10.1-10.1 10.1H10.1zM168 142.7v-21.4c0-5.1 4.2-9.3 9.3-9.3h21.4c5.1 0 9.3 4.2 9.3 9.3v21.4c0 5.1-4.2 9.3-9.3 9.3h-21.4c-5.1 0-9.3-4.2-9.3-9.3zM56 235.5v25c0 6.3-5.1 11.5-11.4 11.5H19.4C13.1 272 8 266.8 8 260.5v-25c0-6.3 5.1-11.5 11.4-11.5h25.1c6.4 0 11.5 5.2 11.5 11.5z"
        ],
        "codepen": [
            512,
            512,
            [],
            "f1cb",
            "M502.285 159.704l-234-156c-7.987-4.915-16.511-4.96-24.571 0l-234 156C3.714 163.703 0 170.847 0 177.989v155.999c0 7.143 3.714 14.286 9.715 18.286l234 156.022c7.987 4.915 16.511 4.96 24.571 0l234-156.022c6-3.999 9.715-11.143 9.715-18.286V177.989c-.001-7.142-3.715-14.286-9.716-18.285zM278 63.131l172.286 114.858-76.857 51.429L278 165.703V63.131zm-44 0v102.572l-95.429 63.715-76.857-51.429L234 63.131zM44 219.132l55.143 36.857L44 292.846v-73.714zm190 229.715L61.714 333.989l76.857-51.429L234 346.275v102.572zm22-140.858l-77.715-52 77.715-52 77.715 52-77.715 52zm22 140.858V346.275l95.429-63.715 76.857 51.429L278 448.847zm190-156.001l-55.143-36.857L468 219.132v73.714z"
        ],
        "codiepie": [
            472,
            512,
            [],
            "f284",
            "M422.5 202.9c30.7 0 33.5 53.1-.3 53.1h-10.8v44.3h-26.6v-97.4h37.7zM472 352.6C429.9 444.5 350.4 504 248 504 111 504 0 393 0 256S111 8 248 8c97.4 0 172.8 53.7 218.2 138.4l-186 108.8L472 352.6zm-38.5 12.5l-60.3-30.7c-27.1 44.3-70.4 71.4-122.4 71.4-82.5 0-149.2-66.7-149.2-148.9 0-82.5 66.7-149.2 149.2-149.2 48.4 0 88.9 23.5 116.9 63.4l59.5-34.6c-40.7-62.6-104.7-100-179.2-100-121.2 0-219.5 98.3-219.5 219.5S126.8 475.5 248 475.5c78.6 0 146.5-42.1 185.5-110.4z"
        ],
        "confluence": [
            512,
            512,
            [],
            "f78d",
            "M2.3 412.2c-4.5 7.6-2.1 17.5 5.5 22.2l105.9 65.2c7.7 4.7 17.7 2.4 22.4-5.3 0-.1.1-.2.1-.2 67.1-112.2 80.5-95.9 280.9-.7 8.1 3.9 17.8.4 21.7-7.7.1-.1.1-.3.2-.4l50.4-114.1c3.6-8.1-.1-17.6-8.1-21.3-22.2-10.4-66.2-31.2-105.9-50.3C127.5 179 44.6 345.3 2.3 412.2zm507.4-312.1c4.5-7.6 2.1-17.5-5.5-22.2L398.4 12.8c-7.5-5-17.6-3.1-22.6 4.4-.2.3-.4.6-.6 1-67.3 112.6-81.1 95.6-280.6.9-8.1-3.9-17.8-.4-21.7 7.7-.1.1-.1.3-.2.4L22.2 141.3c-3.6 8.1.1 17.6 8.1 21.3 22.2 10.4 66.3 31.2 106 50.4 248 120 330.8-45.4 373.4-112.9z"
        ],
        "connectdevelop": [
            576,
            512,
            [],
            "f20e",
            "M550.5 241l-50.089-86.786c1.071-2.142 1.875-4.553 1.875-7.232 0-8.036-6.696-14.733-14.732-15.001l-55.447-95.893c.536-1.607 1.071-3.214 1.071-4.821 0-8.571-6.964-15.268-15.268-15.268-4.821 0-8.839 2.143-11.786 5.625H299.518C296.839 18.143 292.821 16 288 16s-8.839 2.143-11.518 5.625H170.411C167.464 18.143 163.447 16 158.625 16c-8.303 0-15.268 6.696-15.268 15.268 0 1.607.536 3.482 1.072 4.821l-55.983 97.233c-5.356 2.41-9.107 7.5-9.107 13.661 0 .535.268 1.071.268 1.607l-53.304 92.143c-7.232 1.339-12.59 7.5-12.59 15 0 7.232 5.089 13.393 12.054 15l55.179 95.358c-.536 1.607-.804 2.946-.804 4.821 0 7.232 5.089 13.393 12.054 14.732l51.697 89.732c-.536 1.607-1.071 3.482-1.071 5.357 0 8.571 6.964 15.268 15.268 15.268 4.821 0 8.839-2.143 11.518-5.357h106.875C279.161 493.857 283.447 496 288 496s8.839-2.143 11.518-5.357h107.143c2.678 2.946 6.696 4.821 10.982 4.821 8.571 0 15.268-6.964 15.268-15.268 0-1.607-.267-2.946-.803-4.285l51.697-90.268c6.964-1.339 12.054-7.5 12.054-14.732 0-1.607-.268-3.214-.804-4.821l54.911-95.358c6.964-1.339 12.322-7.5 12.322-15-.002-7.232-5.092-13.393-11.788-14.732zM153.535 450.732l-43.66-75.803h43.66v75.803zm0-83.839h-43.66c-.268-1.071-.804-2.142-1.339-3.214l44.999-47.41v50.624zm0-62.411l-50.357 53.304c-1.339-.536-2.679-1.34-4.018-1.607L43.447 259.75c.535-1.339.535-2.679.535-4.018s0-2.41-.268-3.482l51.965-90c2.679-.268 5.357-1.072 7.768-2.679l50.089 51.965v92.946zm0-102.322l-45.803-47.41c1.339-2.143 2.143-4.821 2.143-7.767 0-.268-.268-.804-.268-1.072l43.928-15.804v72.053zm0-80.625l-43.66 15.804 43.66-75.536v59.732zm326.519 39.108l.804 1.339L445.5 329.125l-63.75-67.232 98.036-101.518.268.268zM291.75 355.107l11.518 11.786H280.5l11.25-11.786zm-.268-11.25l-83.303-85.446 79.553-84.375 83.036 87.589-79.286 82.232zm5.357 5.893l79.286-82.232 67.5 71.25-5.892 28.125H313.714l-16.875-17.143zM410.411 44.393c1.071.536 2.142 1.072 3.482 1.34l57.857 100.714v.536c0 2.946.803 5.624 2.143 7.767L376.393 256l-83.035-87.589L410.411 44.393zm-9.107-2.143L287.732 162.518l-57.054-60.268 166.339-60h4.287zm-123.483 0c2.678 2.678 6.16 4.285 10.179 4.285s7.5-1.607 10.179-4.285h75L224.786 95.821 173.893 42.25h103.928zm-116.249 5.625l1.071-2.142a33.834 33.834 0 0 0 2.679-.804l51.161 53.84-54.911 19.821V47.875zm0 79.286l60.803-21.964 59.732 63.214-79.553 84.107-40.982-42.053v-83.304zm0 92.678L198 257.607l-36.428 38.304v-76.072zm0 87.858l42.053-44.464 82.768 85.982-17.143 17.678H161.572v-59.196zm6.964 162.053c-1.607-1.607-3.482-2.678-5.893-3.482l-1.071-1.607v-89.732h99.91l-91.607 94.821h-1.339zm129.911 0c-2.679-2.41-6.428-4.285-10.447-4.285s-7.767 1.875-10.447 4.285h-96.429l91.607-94.821h38.304l91.607 94.821H298.447zm120-11.786l-4.286 7.5c-1.339.268-2.41.803-3.482 1.339l-89.196-91.875h114.376l-17.412 83.036zm12.856-22.232l12.858-60.803h21.964l-34.822 60.803zm34.822-68.839h-20.357l4.553-21.16 17.143 18.214c-.535.803-1.071 1.874-1.339 2.946zm66.161-107.411l-55.447 96.697c-1.339.535-2.679 1.071-4.018 1.874l-20.625-21.964 34.554-163.928 45.803 79.286c-.267 1.339-.803 2.678-.803 4.285 0 1.339.268 2.411.536 3.75z"
        ],
        "contao": [
            512,
            512,
            [],
            "f26d",
            "M45.4 305c14.4 67.1 26.4 129 68.2 175H34c-18.7 0-34-15.2-34-34V66c0-18.7 15.2-34 34-34h57.7C77.9 44.6 65.6 59.2 54.8 75.6c-45.4 70-27 146.8-9.4 229.4zM478 32h-90.2c21.4 21.4 39.2 49.5 52.7 84.1l-137.1 29.3c-14.9-29-37.8-53.3-82.6-43.9-24.6 5.3-41 19.3-48.3 34.6-8.8 18.7-13.2 39.8 8.2 140.3 21.1 100.2 33.7 117.7 49.5 131.2 12.9 11.1 33.4 17 58.3 11.7 44.5-9.4 55.7-40.7 57.4-73.2l137.4-29.6c3.2 71.5-18.7 125.2-57.4 163.6H478c18.7 0 34-15.2 34-34V66c0-18.8-15.2-34-34-34z"
        ],
        "cotton-bureau": [
            512,
            512,
            [],
            "f89e",
            "M474.31 330.41c-23.66 91.85-94.23 144.59-201.9 148.35V429.6c0-48 26.41-74.39 74.39-74.39 62 0 99.2-37.2 99.2-99.21 0-61.37-36.53-98.28-97.38-99.06-33-69.32-146.5-64.65-177.24 0C110.52 157.72 74 194.63 74 256c0 62.13 37.27 99.41 99.4 99.41 48 0 74.55 26.23 74.55 74.39V479c-134.43-5-211.1-85.07-211.1-223 0-141.82 81.35-223.2 223.2-223.2 114.77 0 189.84 53.2 214.69 148.81H500C473.88 71.51 388.22 8 259.82 8 105 8 12 101.19 12 255.82 12 411.14 105.19 504.34 259.82 504c128.27 0 213.87-63.81 239.67-173.59zM357 182.33c41.37 3.45 64.2 29 64.2 73.67 0 48-26.43 74.41-74.4 74.41-28.61 0-49.33-9.59-61.59-27.33 83.06-16.55 75.59-99.67 71.79-120.75zm-81.68 97.36c-2.46-10.34-16.33-87 56.23-97 2.27 10.09 16.52 87.11-56.26 97zM260 132c28.61 0 49 9.67 61.44 27.61-28.36 5.48-49.36 20.59-61.59 43.45-12.23-22.86-33.23-38-61.6-43.45 12.41-17.69 33.27-27.35 61.57-27.35zm-71.52 50.72c73.17 10.57 58.91 86.81 56.49 97-72.41-9.84-59-86.95-56.25-97zM173.2 330.41c-48 0-74.4-26.4-74.4-74.41 0-44.36 22.86-70 64.22-73.67-6.75 37.2-1.38 106.53 71.65 120.75-12.14 17.63-32.84 27.3-61.14 27.3zm53.21 12.39A80.8 80.8 0 0 0 260 309.25c7.77 14.49 19.33 25.54 33.82 33.55a80.28 80.28 0 0 0-33.58 33.83c-8-14.5-19.07-26.23-33.56-33.83z"
        ],
        "cpanel": [
            640,
            512,
            [],
            "f388",
            "M210.3 220.2c-5.6-24.8-26.9-41.2-51-41.2h-37c-7.1 0-12.5 4.5-14.3 10.9L73.1 320l24.7-.1c6.8 0 12.3-4.5 14.2-10.7l25.8-95.7h19.8c8.4 0 16.2 5.6 18.3 14.8 2.5 10.9-5.9 22.6-18.3 22.6h-10.3c-7 0-12.5 4.6-14.3 10.8l-6.4 23.8h32c37.2 0 58.3-36.2 51.7-65.3zm-156.5 28h18.6c6.9 0 12.4-4.4 14.3-10.9l6.2-23.6h-40C30 213.7 9 227.8 1.7 254.8-7 288.6 18.5 320 52 320h12.4l7.1-26.1c1.2-4.4-2.2-8.3-6.4-8.3H53.8c-24.7 0-24.9-37.4 0-37.4zm247.5-34.8h-77.9l-3.5 13.4c-2.4 9.6 4.5 18.5 14.2 18.5h57.5c4 0 2.4 4.3 2.1 5.3l-8.6 31.8c-.4 1.4-.9 5.3-5.5 5.3h-34.9c-5.3 0-5.3-7.9 0-7.9h21.6c6.8 0 12.3-4.6 14.2-10.8l3.5-13.2h-48.4c-39.2 0-43.6 63.8-.7 63.8l57.5.2c11.2 0 20.6-7.2 23.4-17.8l14-51.8c4.8-19.2-9.7-36.8-28.5-36.8zM633.1 179h-18.9c-4.9 0-9.2 3.2-10.4 7.9L568.2 320c20.7 0 39.8-13.8 44.9-34.5l26.5-98.2c1.2-4.3-2-8.3-6.5-8.3zm-236.3 34.7v.1h-48.3l-26.2 98c-1.2 4.4 2.2 8.3 6.4 8.3h18.9c4.8 0 9.2-3 10.4-7.8l17.2-64H395c12.5 0 21.4 11.8 18.1 23.4l-10.6 40c-1.2 4.3 1.9 8.3 6.4 8.3H428c4.6 0 9.1-2.9 10.3-7.8l8.8-33.1c9-33.1-15.9-65.4-50.3-65.4zm98.3 74.6c-3.6 0-6-3.4-5.1-6.7l8-30c.9-3.9 3.7-6 7.8-6h32.9c2.6 0 4.6 2.4 3.9 5.1l-.7 2.6c-.6 2-1.9 3-3.9 3h-21.6c-7 0-12.6 4.6-14.2 10.8l-3.5 13h53.4c10.5 0 20.3-6.6 23.2-17.6l3.2-12c4.9-19.1-9.3-36.8-28.3-36.8h-47.3c-17.9 0-33.8 12-38.6 29.6l-10.8 40c-5 17.7 8.3 36.7 28.3 36.7h66.7c6.8 0 12.3-4.5 14.2-10.7l5.7-21z"
        ],
        "creative-commons": [
            496,
            512,
            [],
            "f25e",
            "M245.83 214.87l-33.22 17.28c-9.43-19.58-25.24-19.93-27.46-19.93-22.13 0-33.22 14.61-33.22 43.84 0 23.57 9.21 43.84 33.22 43.84 14.47 0 24.65-7.09 30.57-21.26l30.55 15.5c-6.17 11.51-25.69 38.98-65.1 38.98-22.6 0-73.96-10.32-73.96-77.05 0-58.69 43-77.06 72.63-77.06 30.72-.01 52.7 11.95 65.99 35.86zm143.05 0l-32.78 17.28c-9.5-19.77-25.72-19.93-27.9-19.93-22.14 0-33.22 14.61-33.22 43.84 0 23.55 9.23 43.84 33.22 43.84 14.45 0 24.65-7.09 30.54-21.26l31 15.5c-2.1 3.75-21.39 38.98-65.09 38.98-22.69 0-73.96-9.87-73.96-77.05 0-58.67 42.97-77.06 72.63-77.06 30.71-.01 52.58 11.95 65.56 35.86zM247.56 8.05C104.74 8.05 0 123.11 0 256.05c0 138.49 113.6 248 247.56 248 129.93 0 248.44-100.87 248.44-248 0-137.87-106.62-248-248.44-248zm.87 450.81c-112.54 0-203.7-93.04-203.7-202.81 0-105.42 85.43-203.27 203.72-203.27 112.53 0 202.82 89.46 202.82 203.26-.01 121.69-99.68 202.82-202.84 202.82z"
        ],
        "creative-commons-by": [
            496,
            512,
            [],
            "f4e7",
            "M314.9 194.4v101.4h-28.3v120.5h-77.1V295.9h-28.3V194.4c0-4.4 1.6-8.2 4.6-11.3 3.1-3.1 6.9-4.7 11.3-4.7H299c4.1 0 7.8 1.6 11.1 4.7 3.1 3.2 4.8 6.9 4.8 11.3zm-101.5-63.7c0-23.3 11.5-35 34.5-35s34.5 11.7 34.5 35c0 23-11.5 34.5-34.5 34.5s-34.5-11.5-34.5-34.5zM247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3z"
        ],
        "creative-commons-nc": [
            496,
            512,
            [],
            "f4e8",
            "M247.6 8C387.4 8 496 115.9 496 256c0 147.2-118.5 248-248.4 248C113.1 504 0 393.2 0 256 0 123.1 104.7 8 247.6 8zM55.8 189.1c-7.4 20.4-11.1 42.7-11.1 66.9 0 110.9 92.1 202.4 203.7 202.4 122.4 0 177.2-101.8 178.5-104.1l-93.4-41.6c-7.7 37.1-41.2 53-68.2 55.4v38.1h-28.8V368c-27.5-.3-52.6-10.2-75.3-29.7l34.1-34.5c31.7 29.4 86.4 31.8 86.4-2.2 0-6.2-2.2-11.2-6.6-15.1-14.2-6-1.8-.1-219.3-97.4zM248.4 52.3c-38.4 0-112.4 8.7-170.5 93l94.8 42.5c10-31.3 40.4-42.9 63.8-44.3v-38.1h28.8v38.1c22.7 1.2 43.4 8.9 62 23L295 199.7c-42.7-29.9-83.5-8-70 11.1 53.4 24.1 43.8 19.8 93 41.6l127.1 56.7c4.1-17.4 6.2-35.1 6.2-53.1 0-57-19.8-105-59.3-143.9-39.3-39.9-87.2-59.8-143.6-59.8z"
        ],
        "creative-commons-nc-eu": [
            496,
            512,
            [],
            "f4e9",
            "M247.7 8C103.6 8 0 124.8 0 256c0 136.3 111.7 248 247.7 248C377.9 504 496 403.1 496 256 496 117 388.4 8 247.7 8zm.6 450.7c-112 0-203.6-92.5-203.6-202.7 0-23.2 3.7-45.2 10.9-66l65.7 29.1h-4.7v29.5h23.3c0 6.2-.4 3.2-.4 19.5h-22.8v29.5h27c11.4 67 67.2 101.3 124.6 101.3 26.6 0 50.6-7.9 64.8-15.8l-10-46.1c-8.7 4.6-28.2 10.8-47.3 10.8-28.2 0-58.1-10.9-67.3-50.2h90.3l128.3 56.8c-1.5 2.1-56.2 104.3-178.8 104.3zm-16.7-190.6l-.5-.4.9.4h-.4zm77.2-19.5h3.7v-29.5h-70.3l-28.6-12.6c2.5-5.5 5.4-10.5 8.8-14.3 12.9-15.8 31.1-22.4 51.1-22.4 18.3 0 35.3 5.4 46.1 10l11.6-47.3c-15-6.6-37-12.4-62.3-12.4-39 0-72.2 15.8-95.9 42.3-5.3 6.1-9.8 12.9-13.9 20.1l-81.6-36.1c64.6-96.8 157.7-93.6 170.7-93.6 113 0 203 90.2 203 203.4 0 18.7-2.1 36.3-6.3 52.9l-136.1-60.5z"
        ],
        "creative-commons-nc-jp": [
            496,
            512,
            [],
            "f4ea",
            "M247.7 8C103.6 8 0 124.8 0 256c0 136.4 111.8 248 247.7 248C377.9 504 496 403.2 496 256 496 117.2 388.5 8 247.7 8zm.6 450.7c-112 0-203.6-92.5-203.6-202.7 0-21.1 3-41.2 9-60.3l127 56.5h-27.9v38.6h58.1l5.7 11.8v18.7h-63.8V360h63.8v56h61.7v-56h64.2v-35.7l81 36.1c-1.5 2.2-57.1 98.3-175.2 98.3zm87.6-137.3h-57.6v-18.7l2.9-5.6 54.7 24.3zm6.5-51.4v-17.8h-38.6l63-116H301l-43.4 96-23-10.2-39.6-85.7h-65.8l27.3 51-81.9-36.5c27.8-44.1 82.6-98.1 173.7-98.1 112.8 0 203 90 203 203.4 0 21-2.7 40.6-7.9 59l-101-45.1z"
        ],
        "creative-commons-nd": [
            496,
            512,
            [],
            "f4eb",
            "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm94 144.3v42.5H162.1V197h180.3zm0 79.8v42.5H162.1v-42.5h180.3z"
        ],
        "creative-commons-pd": [
            496,
            512,
            [],
            "f4ec",
            "M248 8C111 8 0 119.1 0 256c0 137 111 248 248 248s248-111 248-248C496 119.1 385 8 248 8zm0 449.5c-139.2 0-235.8-138-190.2-267.9l78.8 35.1c-2.1 10.5-3.3 21.5-3.3 32.9 0 99 73.9 126.9 120.4 126.9 22.9 0 53.5-6.7 79.4-29.5L297 311.1c-5.5 6.3-17.6 16.7-36.3 16.7-37.8 0-53.7-39.9-53.9-71.9 230.4 102.6 216.5 96.5 217.9 96.8-34.3 62.4-100.6 104.8-176.7 104.8zm194.2-150l-224-100c18.8-34 54.9-30.7 74.7-11l40.4-41.6c-27.1-23.3-58-27.5-78.1-27.5-47.4 0-80.9 20.5-100.7 51.6l-74.9-33.4c36.1-54.9 98.1-91.2 168.5-91.2 111.1 0 201.5 90.4 201.5 201.5 0 18-2.4 35.4-6.8 52-.3-.1-.4-.2-.6-.4z"
        ],
        "creative-commons-pd-alt": [
            496,
            512,
            [],
            "f4ed",
            "M247.6 8C104.7 8 0 123.1 0 256c0 138.5 113.6 248 247.6 248C377.5 504 496 403.1 496 256 496 118.1 389.4 8 247.6 8zm.8 450.8c-112.5 0-203.7-93-203.7-202.8 0-105.4 85.5-203.3 203.7-203.3 112.6 0 202.9 89.5 202.8 203.3 0 121.7-99.6 202.8-202.8 202.8zM316.7 186h-53.2v137.2h53.2c21.4 0 70-5.1 70-68.6 0-63.4-48.6-68.6-70-68.6zm.8 108.5h-19.9v-79.7l19.4-.1c3.8 0 35-2.1 35 39.9 0 24.6-10.5 39.9-34.5 39.9zM203.7 186h-68.2v137.3h34.6V279h27c54.1 0 57.1-37.5 57.1-46.5 0-31-16.8-46.5-50.5-46.5zm-4.9 67.3h-29.2v-41.6h28.3c30.9 0 28.8 41.6.9 41.6z"
        ],
        "creative-commons-remix": [
            496,
            512,
            [],
            "f4ee",
            "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm161.7 207.7l4.9 2.2v70c-7.2 3.6-63.4 27.5-67.3 28.8-6.5-1.8-113.7-46.8-137.3-56.2l-64.2 26.6-63.3-27.5v-63.8l59.3-24.8c-.7-.7-.4 5-.4-70.4l67.3-29.7L361 178.5v61.6l49.1 20.3zm-70.4 81.5v-43.8h-.4v-1.8l-113.8-46.5V295l113.8 46.9v-.4l.4.4zm7.5-57.6l39.9-16.4-36.8-15.5-39 16.4 35.9 15.5zm52.3 38.1v-43L355.2 298v43.4l44.3-19z"
        ],
        "creative-commons-sa": [
            496,
            512,
            [],
            "f4ef",
            "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zM137.7 221c13-83.9 80.5-95.7 108.9-95.7 99.8 0 127.5 82.5 127.5 134.2 0 63.6-41 132.9-128.9 132.9-38.9 0-99.1-20-109.4-97h62.5c1.5 30.1 19.6 45.2 54.5 45.2 23.3 0 58-18.2 58-82.8 0-82.5-49.1-80.6-56.7-80.6-33.1 0-51.7 14.6-55.8 43.8h18.2l-49.2 49.2-49-49.2h19.4z"
        ],
        "creative-commons-sampling": [
            496,
            512,
            [],
            "f4f0",
            "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm3.6 53.2c2.8-.3 11.5 1 11.5 11.5l6.6 107.2 4.9-59.3c0-6 4.7-10.6 10.6-10.6 5.9 0 10.6 4.7 10.6 10.6 0 2.5-.5-5.7 5.7 81.5l5.8-64.2c.3-2.9 2.9-9.3 10.2-9.3 3.8 0 9.9 2.3 10.6 8.9l11.5 96.5 5.3-12.8c1.8-4.4 5.2-6.6 10.2-6.6h58v21.3h-50.9l-18.2 44.3c-3.9 9.9-19.5 9.1-20.8-3.1l-4-31.9-7.5 92.6c-.3 3-3 9.3-10.2 9.3-3 0-9.8-2.1-10.6-9.3 0-1.9.6 5.8-6.2-77.9l-5.3 72.2c-1.1 4.8-4.8 9.3-10.6 9.3-2.9 0-9.8-2-10.6-9.3 0-1.9.5 6.7-5.8-87.7l-5.8 94.8c0 6.3-3.6 12.4-10.6 12.4-5.2 0-10.6-4.1-10.6-12l-5.8-87.7c-5.8 92.5-5.3 84-5.3 85.9-1.1 4.8-4.8 9.3-10.6 9.3-3 0-9.8-2.1-10.6-9.3 0-.7-.4-1.1-.4-2.6l-6.2-88.6L182 348c-.7 6.5-6.7 9.3-10.6 9.3-5.8 0-9.6-4.1-10.6-8.9L149.7 272c-2 4-3.5 8.4-11.1 8.4H87.2v-21.3H132l13.7-27.9c4.4-9.9 18.2-7.2 19.9 2.7l3.1 20.4 8.4-97.9c0-6 4.8-10.6 10.6-10.6.5 0 10.6-.2 10.6 12.4l4.9 69.1 6.6-92.6c0-10.1 9.5-10.6 10.2-10.6.6 0 10.6.7 10.6 10.6l5.3 80.6 6.2-97.9c.1-1.1-.6-10.3 9.9-11.5z"
        ],
        "creative-commons-sampling-plus": [
            496,
            512,
            [],
            "f4f1",
            "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm107 205.6c-4.7 0-9 2.8-10.7 7.2l-4 9.5-11-92.8c-1.7-13.9-22-13.4-23.1.4l-4.3 51.4-5.2-68.8c-1.1-14.3-22.1-14.2-23.2 0l-3.5 44.9-5.9-94.3c-.9-14.5-22.3-14.4-23.2 0l-5.1 83.7-4.3-66.3c-.9-14.4-22.2-14.4-23.2 0l-5.3 80.2-4.1-57c-1.1-14.3-22-14.3-23.2-.2l-7.7 89.8-1.8-12.2c-1.7-11.4-17.1-13.6-22-3.3l-13.2 27.7H87.5v23.2h51.3c4.4 0 8.4-2.5 10.4-6.4l10.7 73.1c2 13.5 21.9 13 23.1-.7l3.8-43.6 5.7 78.3c1.1 14.4 22.3 14.2 23.2-.1l4.6-70.4 4.8 73.3c.9 14.4 22.3 14.4 23.2-.1l4.9-80.5 4.5 71.8c.9 14.3 22.1 14.5 23.2.2l4.6-58.6 4.9 64.4c1.1 14.3 22 14.2 23.1.1l6.8-83 2.7 22.3c1.4 11.8 17.7 14.1 22.3 3.1l18-43.4h50.5V258l-58.4.3zm-78 5.2h-21.9v21.9c0 4.1-3.3 7.5-7.5 7.5-4.1 0-7.5-3.3-7.5-7.5v-21.9h-21.9c-4.1 0-7.5-3.3-7.5-7.5 0-4.1 3.4-7.5 7.5-7.5h21.9v-21.9c0-4.1 3.4-7.5 7.5-7.5s7.5 3.3 7.5 7.5v21.9h21.9c4.1 0 7.5 3.3 7.5 7.5 0 4.1-3.4 7.5-7.5 7.5z"
        ],
        "creative-commons-share": [
            496,
            512,
            [],
            "f4f2",
            "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm101 132.4c7.8 0 13.7 6.1 13.7 13.7v182.5c0 7.7-6.1 13.7-13.7 13.7H214.3c-7.7 0-13.7-6-13.7-13.7v-54h-54c-7.8 0-13.7-6-13.7-13.7V131.1c0-8.2 6.6-12.7 12.4-13.7h136.4c7.7 0 13.7 6 13.7 13.7v54h54zM159.9 300.3h40.7V198.9c0-7.4 5.8-12.6 12-13.7h55.8v-40.3H159.9v155.4zm176.2-88.1H227.6v155.4h108.5V212.2z"
        ],
        "creative-commons-zero": [
            496,
            512,
            [],
            "f4f3",
            "M247.6 8C389.4 8 496 118.1 496 256c0 147.1-118.5 248-248.4 248C113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zm.8 44.7C130.2 52.7 44.7 150.6 44.7 256c0 109.8 91.2 202.8 203.7 202.8 103.2 0 202.8-81.1 202.8-202.8.1-113.8-90.2-203.3-202.8-203.3zm-.4 60.5c-81.9 0-102.5 77.3-102.5 142.8 0 65.5 20.6 142.8 102.5 142.8S350.5 321.5 350.5 256c0-65.5-20.6-142.8-102.5-142.8zm0 53.9c3.3 0 6.4.5 9.2 1.2 5.9 5.1 8.8 12.1 3.1 21.9l-54.5 100.2c-1.7-12.7-1.9-25.1-1.9-34.4 0-28.8 2-88.9 44.1-88.9zm40.8 46.2c2.9 15.4 3.3 31.4 3.3 42.7 0 28.9-2 88.9-44.1 88.9-13.5 0-32.6-7.7-20.1-26.4l60.9-105.2z"
        ],
        "critical-role": [
            448,
            512,
            [],
            "f6c9",
            "M225.82 0c.26.15 216.57 124.51 217.12 124.72 3 1.18 3.7 3.46 3.7 6.56q-.11 125.17 0 250.36a5.88 5.88 0 0 1-3.38 5.78c-21.37 12-207.86 118.29-218.93 124.58h-3C142 466.34 3.08 386.56 2.93 386.48a3.29 3.29 0 0 1-1.88-3.24c0-.87 0-225.94-.05-253.1a5 5 0 0 1 2.93-4.93C27.19 112.11 213.2 6 224.07 0zM215.4 20.42l-.22-.16Q118.06 75.55 21 130.87c0 .12.08.23.13.35l30.86 11.64c-7.71 6-8.32 6-10.65 5.13-.1 0-24.17-9.28-26.8-10v230.43c.88-1.41 64.07-110.91 64.13-111 1.62-2.82 3-1.92 9.12-1.52 1.4.09 1.48.22.78 1.42-41.19 71.33-36.4 63-67.48 116.94-.81 1.4-.61 1.13 1.25 1.13h186.5c1.44 0 1.69-.23 1.7-1.64v-8.88c0-1.34 2.36-.81-18.37-1-7.46-.07-14.14-3.22-21.38-12.7-7.38-9.66-14.62-19.43-21.85-29.21-2.28-3.08-3.45-2.38-16.76-2.38-1.75 0-1.78 0-1.76 1.82.29 26.21.15 25.27 1 32.66.52 4.37 2.16 4.2 9.69 4.81 3.14.26 3.88 4.08.52 4.92-1.57.39-31.6.51-33.67-.1a2.42 2.42 0 0 1 .3-4.73c3.29-.76 6.16.81 6.66-4.44 1.3-13.66 1.17-9 1.1-79.42 0-10.82-.35-12.58-5.36-13.55-1.22-.24-3.54-.16-4.69-.55-2.88-1-2-4.84 1.77-4.85 33.67 0 46.08-1.07 56.06 4.86 7.74 4.61 12 11.48 12.51 20.4.88 14.59-6.51 22.35-15 32.59a1.46 1.46 0 0 0 0 2.22c2.6 3.25 5 6.63 7.71 9.83 27.56 33.23 24.11 30.54 41.28 33.06.89.13 1-.42 1-1.15v-11c0-1 .32-1.43 1.41-1.26a72.37 72.37 0 0 0 23.58-.3c1.08-.15 1.5.2 1.48 1.33 0 .11.88 26.69.87 26.8-.05 1.52.67 1.62 1.89 1.62h186.71Q386.51 304.6 346 234.33c2.26-.66-.4 0 6.69-1.39 2-.39 2.05-.41 3.11 1.44 7.31 12.64 77.31 134 77.37 134.06V138c-1.72.5-103.3 38.72-105.76 39.68-1.08.42-1.55.2-1.91-.88-.63-1.9-1.34-3.76-2.09-5.62-.32-.79-.09-1.13.65-1.39.1 0 95.53-35.85 103-38.77-65.42-37.57-130.56-75-196-112.6l86.82 150.39-.28.33c-9.57-.9-10.46-1.6-11.8-3.94-1-1.69-73.5-127.71-82-142.16-9.1 14.67-83.56 146.21-85.37 146.32-2.93.17-5.88.08-9.25.08q43.25-74.74 86.18-149zm51.93 129.92a37.68 37.68 0 0 0 5.54-.85c1.69-.3 2.53.2 2.6 1.92 0 .11.07 19.06-.86 20.45s-1.88 1.22-2.6-.19c-5-9.69 6.22-9.66-39.12-12-.7 0-1 .23-1 .93 0 .13 3.72 122 3.73 122.11 0 .89.52 1.2 1.21 1.51a83.92 83.92 0 0 1 8.7 4.05c7.31 4.33 11.38 10.84 12.41 19.31 1.44 11.8-2.77 35.77-32.21 37.14-2.75.13-28.26 1.08-34.14-23.25-4.66-19.26 8.26-32.7 19.89-36.4a2.45 2.45 0 0 0 2-2.66c.1-5.63 3-107.1 3.71-121.35.05-1.08-.62-1.16-1.35-1.15-32.35.52-36.75-.34-40.22 8.52-2.42 6.18-4.14 1.32-3.95.23q1.59-9 3.31-18c.4-2.11 1.43-2.61 3.43-1.86 5.59 2.11 6.72 1.7 37.25 1.92 1.73 0 1.78-.08 1.82-1.85.68-27.49.58-22.59 1-29.55a2.69 2.69 0 0 0-1.63-2.8c-5.6-2.91-8.75-7.55-8.9-13.87-.35-14.81 17.72-21.67 27.38-11.51 6.84 7.19 5.8 18.91-2.45 24.15a4.35 4.35 0 0 0-2.22 4.34c0 .59-.11-4.31 1 30.05 0 .9.43 1.12 1.24 1.11.1 0 23-.09 34.47-.37zM68.27 141.7c19.84-4.51 32.68-.56 52.49 1.69 2.76.31 3.74 1.22 3.62 4-.21 5-1.16 22.33-1.24 23.15a2.65 2.65 0 0 1-1.63 2.34c-4.06 1.7-3.61-4.45-4-7.29-3.13-22.43-73.87-32.7-74.63 25.4-.31 23.92 17 53.63 54.08 50.88 27.24-2 19-20.19 24.84-20.47a2.72 2.72 0 0 1 3 3.36c-1.83 10.85-3.42 18.95-3.45 19.15-1.54 9.17-86.7 22.09-93.35-42.06-2.71-25.85 10.44-53.37 40.27-60.15zm80 87.67h-19.49a2.57 2.57 0 0 1-2.66-1.79c2.38-3.75 5.89.92 5.86-6.14-.08-25.75.21-38 .23-40.1 0-3.42-.53-4.65-3.32-4.94-7-.72-3.11-3.37-1.11-3.38 11.84-.1 22.62-.18 30.05.72 8.77 1.07 16.71 12.63 7.93 22.62-2 2.25-4 4.42-6.14 6.73.95 1.15 6.9 8.82 17.28 19.68 2.66 2.78 6.15 3.51 9.88 3.13a2.21 2.21 0 0 0 2.23-2.12c.3-3.42.26 4.73.45-40.58 0-5.65-.34-6.58-3.23-6.83-3.95-.35-4-2.26-.69-3.37l19.09-.09c.32 0 4.49.53 1 3.38 0 .05-.16 0-.24 0-3.61.26-3.94 1-4 4.62-.27 43.93.07 40.23.41 42.82.11.84.27 2.23 5.1 2.14 2.49 0 3.86 3.37 0 3.4-10.37.08-20.74 0-31.11.07-10.67 0-13.47-6.2-24.21-20.82-1.6-2.18-8.31-2.36-8.2-.37.88 16.47 0 17.78 4 17.67 4.75-.1 4.73 3.57.83 3.55zm275-10.15c-1.21 7.13.17 10.38-5.3 10.34-61.55-.42-47.82-.22-50.72-.31a18.4 18.4 0 0 1-3.63-.73c-2.53-.6 1.48-1.23-.38-5.6-1.43-3.37-2.78-6.78-4.11-10.19a1.94 1.94 0 0 0-2-1.44 138 138 0 0 0-14.58.07 2.23 2.23 0 0 0-1.62 1.06c-1.58 3.62-3.07 7.29-4.51 11-1.27 3.23 7.86 1.32 12.19 2.16 3 .57 4.53 3.72.66 3.73H322.9c-2.92 0-3.09-3.15-.74-3.21a6.3 6.3 0 0 0 5.92-3.47c1.5-3 2.8-6 4.11-9.09 18.18-42.14 17.06-40.17 18.42-41.61a1.83 1.83 0 0 1 3 0c2.93 3.34 18.4 44.71 23.62 51.92 2 2.7 5.74 2 6.36 2 3.61.13 4-1.11 4.13-4.29.09-1.87.08 1.17.07-41.24 0-4.46-2.36-3.74-5.55-4.27-.26 0-2.56-.63-.08-3.06.21-.2-.89-.24 21.7-.15 2.32 0 5.32 2.75-1.21 3.45a2.56 2.56 0 0 0-2.66 2.83c-.07 1.63-.19 38.89.29 41.21a3.06 3.06 0 0 0 3.23 2.43c13.25.43 14.92.44 16-3.41 1.67-5.78 4.13-2.52 3.73-.19zm-104.72 64.37c-4.24 0-4.42-3.39-.61-3.41 35.91-.16 28.11.38 37.19-.65 1.68-.19 2.38.24 2.25 1.89-.26 3.39-.64 6.78-1 10.16-.25 2.16-3.2 2.61-3.4-.15-.38-5.31-2.15-4.45-15.63-5.08-1.58-.07-1.64 0-1.64 1.52V304c0 1.65 0 1.6 1.62 1.47 3.12-.25 10.31.34 15.69-1.52.47-.16 3.3-1.79 3.07 1.76 0 .21-.76 10.35-1.18 11.39-.53 1.29-1.88 1.51-2.58.32-1.17-2 0-5.08-3.71-5.3-15.42-.9-12.91-2.55-12.91 6 0 12.25-.76 16.11 3.89 16.24 16.64.48 14.4 0 16.43-5.71.84-2.37 3.5-1.77 3.18.58-.44 3.21-.85 6.43-1.23 9.64 0 .36-.16 2.4-4.66 2.39-37.16-.08-34.54-.19-35.21-.31-2.72-.51-2.2-3 .22-3.45 1.1-.19 4 .54 4.16-2.56 2.44-56.22-.07-51.34-3.91-51.33zm-.41-109.52c2.46.61 3.13 1.76 2.95 4.65-.33 5.3-.34 9-.55 9.69-.66 2.23-3.15 2.12-3.34-.27-.38-4.81-3.05-7.82-7.57-9.15-26.28-7.73-32.81 15.46-27.17 30.22 5.88 15.41 22 15.92 28.86 13.78 5.92-1.85 5.88-6.5 6.91-7.58 1.23-1.3 2.25-1.84 3.12 1.1 0 .1.57 11.89-6 12.75-1.6.21-19.38 3.69-32.68-3.39-21-11.19-16.74-35.47-6.88-45.33 14-14.06 39.91-7.06 42.32-6.47zM289.8 280.14c3.28 0 3.66 3 .16 3.43-2.61.32-5-.42-5 5.46 0 2-.19 29.05.4 41.45.11 2.29 1.15 3.52 3.44 3.65 22 1.21 14.95-1.65 18.79-6.34 1.83-2.24 2.76.84 2.76 1.08.35 13.62-4 12.39-5.19 12.4l-38.16-.19c-1.93-.23-2.06-3-.42-3.38 2-.48 4.94.4 5.13-2.8 1-15.87.57-44.65.34-47.81-.27-3.77-2.8-3.27-5.68-3.71-2.47-.38-2-3.22.34-3.22 1.45-.02 17.97-.03 23.09-.02zm-31.63-57.79c.07 4.08 2.86 3.46 6 3.58 2.61.1 2.53 3.41-.07 3.43-6.48 0-13.7 0-21.61-.06-3.84 0-3.38-3.35 0-3.37 4.49 0 3.24 1.61 3.41-45.54 0-5.08-3.27-3.54-4.72-4.23-2.58-1.23-1.36-3.09.41-3.15 1.29 0 20.19-.41 21.17.21s1.87 1.65-.42 2.86c-1 .52-3.86-.28-4.15 2.47 0 .21-.82 1.63-.07 43.8zm-36.91 274.27a2.93 2.93 0 0 0 3.26 0c17-9.79 182-103.57 197.42-112.51-.14-.43 11.26-.18-181.52-.27-1.22 0-1.57.37-1.53 1.56 0 .1 1.25 44.51 1.22 50.38a28.33 28.33 0 0 1-1.36 7.71c-.55 1.83.38-.5-13.5 32.23-.73 1.72-1 2.21-2-.08-4.19-10.34-8.28-20.72-12.57-31a23.6 23.6 0 0 1-2-10.79c.16-2.46.8-16.12 1.51-48 0-1.95 0-2-2-2h-183c2.58 1.63 178.32 102.57 196 112.76zm-90.9-188.75c0 2.4.36 2.79 2.76 3 11.54 1.17 21 3.74 25.64-7.32 6-14.46 2.66-34.41-12.48-38.84-2-.59-16-2.76-15.94 1.51.05 8.04.01 11.61.02 41.65zm105.75-15.05c0 2.13 1.07 38.68 1.09 39.13.34 9.94-25.58 5.77-25.23-2.59.08-2 1.37-37.42 1.1-39.43-14.1 7.44-14.42 40.21 6.44 48.8a17.9 17.9 0 0 0 22.39-7.07c4.91-7.76 6.84-29.47-5.43-39a2.53 2.53 0 0 1-.36.12zm-12.28-198c-9.83 0-9.73 14.75-.07 14.87s10.1-14.88.07-14.91zm-80.15 103.83c0 1.8.41 2.4 2.17 2.58 13.62 1.39 12.51-11 12.16-13.36-1.69-11.22-14.38-10.2-14.35-7.81.05 4.5-.03 13.68.02 18.59zm212.32 6.4l-6.1-15.84c-2.16 5.48-4.16 10.57-6.23 15.84z"
        ],
        "css3": [
            512,
            512,
            [],
            "f13c",
            "M480 32l-64 368-223.3 80L0 400l19.6-94.8h82l-8 40.6L210 390.2l134.1-44.4 18.8-97.1H29.5l16-82h333.7l10.5-52.7H56.3l16.3-82H480z"
        ],
        "css3-alt": [
            384,
            512,
            [],
            "f38b",
            "M0 32l34.9 395.8L192 480l157.1-52.2L384 32H0zm313.1 80l-4.8 47.3L193 208.6l-.3.1h111.5l-12.8 146.6-98.2 28.7-98.8-29.2-6.4-73.9h48.9l3.2 38.3 52.6 13.3 54.7-15.4 3.7-61.6-166.3-.5v-.1l-.2.1-3.6-46.3L193.1 162l6.5-2.7H76.7L70.9 112h242.2z"
        ],
        "cuttlefish": [
            440,
            512,
            [],
            "f38c",
            "M344 305.5c-17.5 31.6-57.4 54.5-96 54.5-56.6 0-104-47.4-104-104s47.4-104 104-104c38.6 0 78.5 22.9 96 54.5 13.7-50.9 41.7-93.3 87-117.8C385.7 39.1 320.5 8 248 8 111 8 0 119 0 256s111 248 248 248c72.5 0 137.7-31.1 183-80.7-45.3-24.5-73.3-66.9-87-117.8z"
        ],
        "d-and-d": [
            576,
            512,
            [],
            "f38d",
            "M82.5 98.9c-.6-17.2 2-33.8 12.7-48.2.3 7.4 1.2 14.5 4.2 21.6 5.9-27.5 19.7-49.3 42.3-65.5-1.9 5.9-3.5 11.8-3 17.7 8.7-7.4 18.8-17.8 44.4-22.7 14.7-2.8 29.7-2 42.1 1 38.5 9.3 61 34.3 69.7 72.3 5.3 23.1.7 45-8.3 66.4-5.2 12.4-12 24.4-20.7 35.1-2-1.9-3.9-3.8-5.8-5.6-42.8-40.8-26.8-25.2-37.4-37.4-1.1-1.2-1-2.2-.1-3.6 8.3-13.5 11.8-28.2 10-44-1.1-9.8-4.3-18.9-11.3-26.2-14.5-15.3-39.2-15-53.5.6-11.4 12.5-14.1 27.4-10.9 43.6.2 1.3.4 2.7 0 3.9-3.4 13.7-4.6 27.6-2.5 41.6.1.5.1 1.1.1 1.6 0 .3-.1.5-.2 1.1-21.8-11-36-28.3-43.2-52.2-8.3 17.8-11.1 35.5-6.6 54.1-15.6-15.2-21.3-34.3-22-55.2zm469.6 123.2c-11.6-11.6-25-20.4-40.1-26.6-12.8-5.2-26-7.9-39.9-7.1-10 .6-19.6 3.1-29 6.4-2.5.9-5.1 1.6-7.7 2.2-4.9 1.2-7.3-3.1-4.7-6.8 3.2-4.6 3.4-4.2 15-12 .6-.4 1.2-.8 2.2-1.5h-2.5c-.6 0-1.2.2-1.9.3-19.3 3.3-30.7 15.5-48.9 29.6-10.4 8.1-13.8 3.8-12-.5 1.4-3.5 3.3-6.7 5.1-10 1-1.8 2.3-3.4 3.5-5.1-.2-.2-.5-.3-.7-.5-27 18.3-46.7 42.4-57.7 73.3.3.3.7.6 1 .9.3-.6.5-1.2.9-1.7 10.4-12.1 22.8-21.8 36.6-29.8 18.2-10.6 37.5-18.3 58.7-20.2 4.3-.4 8.7-.1 13.1-.1-1.8.7-3.5.9-5.3 1.1-18.5 2.4-35.5 9-51.5 18.5-30.2 17.9-54.5 42.2-75.1 70.4-.3.4-.4.9-.7 1.3 14.5 5.3 24 17.3 36.1 25.6.2-.1.3-.2.4-.4l1.2-2.7c12.2-26.9 27-52.3 46.7-74.5 16.7-18.8 38-25.3 62.5-20 5.9 1.3 11.4 4.4 17.2 6.8 2.3-1.4 5.1-3.2 8-4.7 8.4-4.3 17.4-7 26.7-9 14.7-3.1 29.5-4.9 44.5-1.3v-.5c-.5-.4-1.2-.8-1.7-1.4zM316.7 397.6c-39.4-33-22.8-19.5-42.7-35.6-.8.9 0-.2-1.9 3-11.2 19.1-25.5 35.3-44 47.6-10.3 6.8-21.5 11.8-34.1 11.8-21.6 0-38.2-9.5-49.4-27.8-12-19.5-13.3-40.7-8.2-62.6 7.8-33.8 30.1-55.2 38.6-64.3-18.7-6.2-33 1.7-46.4 13.9.8-13.9 4.3-26.2 11.8-37.3-24.3 10.6-45.9 25-64.8 43.9-.3-5.8 5.4-43.7 5.6-44.7.3-2.7-.6-5.3-3-7.4-24.2 24.7-44.5 51.8-56.1 84.6 7.4-5.9 14.9-11.4 23.6-16.2-8.3 22.3-19.6 52.8-7.8 101.1 4.6 19 11.9 36.8 24.1 52.3 2.9 3.7 6.3 6.9 9.5 10.3.2-.2.4-.3.6-.5-1.4-7-2.2-14.1-1.5-21.9 2.2 3.2 3.9 6 5.9 8.6 12.6 16 28.7 27.4 47.2 35.6 25 11.3 51.1 13.3 77.9 8.6 54.9-9.7 90.7-48.6 116-98.8 1-1.8.6-2.9-.9-4.2zm172-46.4c-9.5-3.1-22.2-4.2-28.7-2.9 9.9 4 14.1 6.6 18.8 12 12.6 14.4 10.4 34.7-5.4 45.6-11.7 8.1-24.9 10.5-38.9 9.1-1.2-.1-2.3-.4-3-.6 2.8-3.7 6-7 8.1-10.8 9.4-16.8 5.4-42.1-8.7-56.1-2.1-2.1-4.6-3.9-7-5.9-.3 1.3-.1 2.1.1 2.8 4.2 16.6-8.1 32.4-24.8 31.8-7.6-.3-13.9-3.8-19.6-8.5-19.5-16.1-39.1-32.1-58.5-48.3-5.9-4.9-12.5-8.1-20.1-8.7-4.6-.4-9.3-.6-13.9-.9-5.9-.4-8.8-2.8-10.4-8.4-.9-3.4-1.5-6.8-2.2-10.2-1.5-8.1-6.2-13-14.3-14.2-4.4-.7-8.9-1-13.3-1.5-13-1.4-19.8-7.4-22.6-20.3-5 11-1.6 22.4 7.3 29.9 4.5 3.8 9.3 7.3 13.8 11.2 4.6 3.8 7.4 8.7 7.9 14.8.4 4.7.8 9.5 1.8 14.1 2.2 10.6 8.9 18.4 17 25.1 16.5 13.7 33 27.3 49.5 41.1 17.9 15 13.9 32.8 13 56-.9 22.9 12.2 42.9 33.5 51.2 1 .4 2 .6 3.6 1.1-15.7-18.2-10.1-44.1.7-52.3.3 2.2.4 4.3.9 6.4 9.4 44.1 45.4 64.2 85 56.9 16-2.9 30.6-8.9 42.9-19.8 2-1.8 3.7-4.1 5.9-6.5-19.3 4.6-35.8.1-50.9-10.6.7-.3 1.3-.3 1.9-.3 21.3 1.8 40.6-3.4 57-17.4 19.5-16.6 26.6-42.9 17.4-66-8.3-20.1-23.6-32.3-43.8-38.9zM99.4 179.3c-5.3-9.2-13.2-15.6-22.1-21.3 13.7-.5 26.6.2 39.6 3.7-7-12.2-8.5-24.7-5-38.7 5.3 11.9 13.7 20.1 23.6 26.8 19.7 13.2 35.7 19.6 46.7 30.2 3.4 3.3 6.3 7.1 9.6 10.9-.8-2.1-1.4-4.1-2.2-6-5-10.6-13-18.6-22.6-25-1.8-1.2-2.8-2.5-3.4-4.5-3.3-12.5-3-25.1-.7-37.6 1-5.5 2.8-10.9 4.5-16.3.8-2.4 2.3-4.6 4-6.6.6 6.9 0 25.5 19.6 46 10.8 11.3 22.4 21.9 33.9 32.7 9 8.5 18.3 16.7 25.5 26.8 1.1 1.6 2.2 3.3 3.8 4.7-5-13-14.2-24.1-24.2-33.8-9.6-9.3-19.4-18.4-29.2-27.4-3.3-3-4.6-6.7-5.1-10.9-1.2-10.4 0-20.6 4.3-30.2.5-1 1.1-2 1.9-3.3.5 4.2.6 7.9 1.4 11.6 4.8 23.1 20.4 36.3 49.3 63.5 10 9.4 19.3 19.2 25.6 31.6 4.8 9.3 7.3 19 5.7 29.6-.1.6.5 1.7 1.1 2 6.2 2.6 10 6.9 9.7 14.3 7.7-2.6 12.5-8 16.4-14.5 4.2 20.2-9.1 50.3-27.2 58.7.4-4.5 5-23.4-16.5-27.7-6.8-1.3-12.8-1.3-22.9-2.1 4.7-9 10.4-20.6.5-22.4-24.9-4.6-52.8 1.9-57.8 4.6 8.2.4 16.3 1 23.5 3.3-2 6.5-4 12.7-5.8 18.9-1.9 6.5 2.1 14.6 9.3 9.6 1.2-.9 2.3-1.9 3.3-2.7-3.1 17.9-2.9 15.9-2.8 18.3.3 10.2 9.5 7.8 15.7 7.3-2.5 11.8-29.5 27.3-45.4 25.8 7-4.7 12.7-10.3 15.9-17.9-6.5.8-12.9 1.6-19.2 2.4l-.3-.9c4.7-3.4 8-7.8 10.2-13.1 8.7-21.1-3.6-38-25-39.9-9.1-.8-17.8.8-25.9 5.5 6.2-15.6 17.2-26.6 32.6-34.5-15.2-4.3-8.9-2.7-24.6-6.3 14.6-9.3 30.2-13.2 46.5-14.6-5.2-3.2-48.1-3.6-70.2 20.9 7.9 1.4 15.5 2.8 23.2 4.2-23.8 7-44 19.7-62.4 35.6 1.1-4.8 2.7-9.5 3.3-14.3.6-4.5.8-9.2.1-13.6-1.5-9.4-8.9-15.1-19.7-16.3-7.9-.9-15.6.1-23.3 1.3-.9.1-1.7.3-2.9 0 15.8-14.8 36-21.7 53.1-33.5 6-4.5 6.8-8.2 3-14.9zm128.4 26.8c3.3 16 12.6 25.5 23.8 24.3-4.6-11.3-12.1-19.5-23.8-24.3z"
        ],
        "d-and-d-beyond": [
            640,
            512,
            [],
            "f6ca",
            "M313.8 241.5c13.8 0 21-10.1 24.8-17.9-1-1.1-5-4.2-7.4-6.6-2.4 4.3-8.2 10.7-13.9 10.7-10.2 0-15.4-14.7-3.2-26.6-.5-.2-4.3-1.8-8 2.4 0-3 1-5.1 2.1-6.6-3.5 1.3-9.8 5.6-11.4 7.9.2-5.8 1.6-7.5.6-9l-.2-.2s-8.5 5.6-9.3 14.7c0 0 1.1-1.6 2.1-1.9.6-.3 1.3 0 .6 1.9-.2.6-5.8 15.7 5.1 26-.6-1.6-1.9-7.6 2.4-1.9-.3.1 5.8 7.1 15.7 7.1zm52.4-21.1c0-4-4.9-4.4-5.6-4.5 2 3.9.9 7.5.2 9 2.5-.4 5.4-1.6 5.4-4.5zm10.3 5.2c0-6.4-6.2-11.4-13.5-10.7 8 1.3 5.6 13.8-5 11.4 3.7-2.6 3.2-9.9-1.3-12.5 1.4 4.2-3 8.2-7.4 4.6-2.4-1.9-8-6.6-10.6-8.6-2.4-2.1-5.5-1-6.6-1.8-1.3-1.1-.5-3.8-2.2-5-1.6-.8-3-.3-4.8-1-1.6-.6-2.7-1.9-2.6-3.5-2.5 4.4 3.4 6.3 4.5 8.5 1 1.9-.8 4.8 4 8.5 14.8 11.6 9.1 8 10.4 18.1.6 4.3 4.2 6.7 6.4 7.4-2.1-1.9-2.9-6.4 0-9.3 0 13.9 19.2 13.3 23.1 6.4-2.4 1.1-7-.2-9-1.9 7.7 1 14.2-4.1 14.6-10.6zm-39.4-18.4c2 .8 1.6.7 6.4 4.5 10.2-24.5 21.7-15.7 22-15.5 2.2-1.9 9.8-3.8 13.8-2.7-2.4-2.7-7.5-6.2-13.3-6.2-4.7 0-7.4 2.2-8 1.3-.8-1.4 3.2-3.4 3.2-3.4-5.4.2-9.6 6.7-11.2 5.9-1.1-.5 1.4-3.7 1.4-3.7-5.1 2.9-9.3 9.1-10.2 13 4.6-5.8 13.8-9.8 19.7-9-10.5.5-19.5 9.7-23.8 15.8zm242.5 51.9c-20.7 0-40 1.3-50.3 2.1l7.4 8.2v77.2l-7.4 8.2c10.4.8 30.9 2.1 51.6 2.1 42.1 0 59.1-20.7 59.1-48.9 0-29.3-23.2-48.9-60.4-48.9zm-15.1 75.6v-53.3c30.1-3.3 46.8 3.8 46.8 26.3 0 25.6-21.4 30.2-46.8 27zM301.6 181c-1-3.4-.2-6.9 1.1-9.4 1 3 2.6 6.4 7.5 9-.5-2.4-.2-5.6.5-8-1.4-5.4 2.1-9.9 6.4-9.9 6.9 0 8.5 8.8 4.7 14.4 2.1 3.2 5.5 5.6 7.7 7.8 3.2-3.7 5.5-9.5 5.5-13.8 0-8.2-5.5-15.9-16.7-16.5-20-.9-20.2 16.6-20 18.9.5 5.2 3.4 7.8 3.3 7.5zm-.4 6c-.5 1.8-7 3.7-10.2 6.9 4.8-1 7-.2 7.8 1.8.5 1.4-.2 3.4-.5 5.6 1.6-1.8 7-5.5 11-6.2-1-.3-3.4-.8-4.3-.8 2.9-3.4 9.3-4.5 12.8-3.7-2.2-.2-6.7 1.1-8.5 2.6 1.6.3 3 .6 4.3 1.1-2.1.8-4.8 3.4-5.8 6.1 7-5 13.1 5.2 7 8.2.8.2 2.7 0 3.5-.5-.3 1.1-1.9 3-3 3.4 2.9 0 7-1.9 8.2-4.6 0 0-1.8.6-2.6-.2s.3-4.3.3-4.3c-2.3 2.9-3.4-1.3-1.3-4.2-1-.3-3.5-.6-4.6-.5 3.2-1.1 10.4-1.8 11.2-.3.6 1.1-1 3.4-1 3.4 4-.5 8.3 1.1 6.7 5.1 2.9-1.4 5.5-5.9 4.8-10.4-.3 1-1.6 2.4-2.9 2.7.2-1.4-1-2.2-1.9-2.6 1.7-9.6-14.6-14.2-14.1-23.9-1 1.3-1.8 5-.8 7.1 2.7 3.2 8.7 6.7 10.1 12.2-2.6-6.4-15.1-11.4-14.6-20.2-1.6 1.6-2.6 7.8-1.3 11 2.4 1.4 4.5 3.8 4.8 6.1-2.2-5.1-11.4-6.1-13.9-12.2-.6 2.2-.3 5 1 6.7 0 0-2.2-.8-7-.6 1.7.6 5.1 3.5 4.8 5.2zm25.9 7.4c-2.7 0-3.5-2.1-4.2-4.3 3.3 1.3 4.2 4.3 4.2 4.3zm38.9 3.7l-1-.6c-1.1-1-2.9-1.4-4.7-1.4-2.9 0-5.8 1.3-7.5 3.4-.8.8-1.4 1.8-2.1 2.6v15.7c3.5 2.6 7.1-2.9 3-7.2 1.5.3 4.6 2.7 5.1 3.2 0 0 2.6-.5 5-.5 2.1 0 3.9.3 5.6 1.1V196c-1.1.5-2.2 1-2.7 1.4zM79.9 305.9c17.2-4.6 16.2-18 16.2-19.9 0-20.6-24.1-25-37-25H3l8.3 8.6v29.5H0l11.4 14.6V346L3 354.6c61.7 0 73.8 1.5 86.4-5.9 6.7-4 9.9-9.8 9.9-17.6 0-5.1 2.6-18.8-19.4-25.2zm-41.3-27.5c20 0 29.6-.8 29.6 9.1v3c0 12.1-19 8.8-29.6 8.8zm0 59.2V315c12.2 0 32.7-2.3 32.7 8.8v4.5h.2c0 11.2-12.5 9.3-32.9 9.3zm101.2-19.3l23.1.2v-.2l14.1-21.2h-37.2v-14.9h52.4l-14.1-21v-.2l-73.5.2 7.4 8.2v77.1l-7.4 8.2h81.2l14.1-21.2-60.1.2zm214.7-60.1c-73.9 0-77.5 99.3-.3 99.3 77.9 0 74.1-99.3.3-99.3zm-.3 77.5c-37.4 0-36.9-55.3.2-55.3 36.8.1 38.8 55.3-.2 55.3zm-91.3-8.3l44.1-66.2h-41.7l6.1 7.2-20.5 37.2h-.3l-21-37.2 6.4-7.2h-44.9l44.1 65.8.2 19.4-7.7 8.2h42.6l-7.2-8.2zm-28.4-151.3c1.6 1.3 2.9 2.4 2.9 6.6v38.8c0 4.2-.8 5.3-2.7 6.4-.1.1-7.5 4.5-7.9 4.6h35.1c10 0 17.4-1.5 26-8.6-.6-5 .2-9.5.8-12 0-.2-1.8 1.4-2.7 3.5 0-5.7 1.6-15.4 9.6-20.5-.1 0-3.7-.8-9 1.1 2-3.1 10-7.9 10.4-7.9-8.2-26-38-22.9-32.2-22.9-30.9 0-32.6.3-39.9-4 .1.8.5 8.2 9.6 14.9zm21.5 5.5c4.6 0 23.1-3.3 23.1 17.3 0 20.7-18.4 17.3-23.1 17.3zm228.9 79.6l7 8.3V312h-.3c-5.4-14.4-42.3-41.5-45.2-50.9h-31.6l7.4 8.5v76.9l-7.2 8.3h39l-7.4-8.2v-47.4h.3c3.7 10.6 44.5 42.9 48.5 55.6h21.3v-85.2l7.4-8.3zm-106.7-96.1c-32.2 0-32.8.2-39.9-4 .1.7.5 8.3 9.6 14.9 3.1 2 2.9 4.3 2.9 9.5 1.8-1.1 3.8-2.2 6.1-3-1.1 1.1-2.7 2.7-3.5 4.5 1-1.1 7.5-5.1 14.6-3.5-1.6.3-4 1.1-6.1 2.9.1 0 2.1-1.1 7.5-.3v-4.3c4.7 0 23.1-3.4 23.1 17.3 0 20.5-18.5 17.3-19.7 17.3 5.7 4.4 5.8 12 2.2 16.3h.3c33.4 0 36.7-27.3 36.7-34 0-3.8-1.1-32-33.8-33.6z"
        ],
        "dailymotion": [
            448,
            512,
            [],
            "e052",
            "M298.93,267a48.4,48.4,0,0,0-24.36-6.21q-19.83,0-33.44,13.27t-13.61,33.42q0,21.16,13.28,34.6t33.43,13.44q20.5,0,34.11-13.78T322,307.47A47.13,47.13,0,0,0,315.9,284,44.13,44.13,0,0,0,298.93,267ZM0,32V480H448V32ZM374.71,405.26h-53.1V381.37h-.67q-15.79,26.2-55.78,26.2-27.56,0-48.89-13.1a88.29,88.29,0,0,1-32.94-35.77q-11.6-22.68-11.59-50.89,0-27.56,11.76-50.22a89.9,89.9,0,0,1,32.93-35.78q21.18-13.09,47.72-13.1a80.87,80.87,0,0,1,29.74,5.21q13.28,5.21,25,17V153l55.79-12.09Z"
        ],
        "dashcube": [
            448,
            512,
            [],
            "f210",
            "M326.6 104H110.4c-51.1 0-91.2 43.3-91.2 93.5V427c0 50.5 40.1 85 91.2 85h227.2c51.1 0 91.2-34.5 91.2-85V0L326.6 104zM153.9 416.5c-17.7 0-32.4-15.1-32.4-32.8V240.8c0-17.7 14.7-32.5 32.4-32.5h140.7c17.7 0 32 14.8 32 32.5v123.5l51.1 52.3H153.9z"
        ],
        "deezer": [
            576,
            512,
            [],
            "e077",
            "M451.46,244.71H576V172H451.46Zm0-173.89v72.67H576V70.82Zm0,275.06H576V273.2H451.46ZM0,447.09H124.54V374.42H0Zm150.47,0H275V374.42H150.47Zm150.52,0H425.53V374.42H301Zm150.47,0H576V374.42H451.46ZM301,345.88H425.53V273.2H301Zm-150.52,0H275V273.2H150.47Zm0-101.17H275V172H150.47Z"
        ],
        "delicious": [
            448,
            512,
            [],
            "f1a5",
            "M446.5 68c-.4-1.5-.9-3-1.4-4.5-.9-2.5-2-4.8-3.3-7.1-1.4-2.4-3-4.8-4.7-6.9-2.1-2.5-4.4-4.8-6.9-6.8-1.1-.9-2.2-1.7-3.3-2.5-1.3-.9-2.6-1.7-4-2.4-1.8-1-3.6-1.8-5.5-2.5-1.7-.7-3.5-1.3-5.4-1.7-3.8-1-7.9-1.5-12-1.5H48C21.5 32 0 53.5 0 80v352c0 4.1.5 8.2 1.5 12 2 7.7 5.8 14.6 11 20.3 1 1.1 2.1 2.2 3.3 3.3 5.7 5.2 12.6 9 20.3 11 3.8 1 7.9 1.5 12 1.5h352c26.5 0 48-21.5 48-48V80c-.1-4.1-.6-8.2-1.6-12zM416 432c0 8.8-7.2 16-16 16H224V256H32V80c0-8.8 7.2-16 16-16h176v192h192z"
        ],
        "deploydog": [
            512,
            512,
            [],
            "f38e",
            "M382.2 136h51.7v239.6h-51.7v-20.7c-19.8 24.8-52.8 24.1-73.8 14.7-26.2-11.7-44.3-38.1-44.3-71.8 0-29.8 14.8-57.9 43.3-70.8 20.2-9.1 52.7-10.6 74.8 12.9V136zm-64.7 161.8c0 18.2 13.6 33.5 33.2 33.5 19.8 0 33.2-16.4 33.2-32.9 0-17.1-13.7-33.2-33.2-33.2-19.6 0-33.2 16.4-33.2 32.6zM188.5 136h51.7v239.6h-51.7v-20.7c-19.8 24.8-52.8 24.1-73.8 14.7-26.2-11.7-44.3-38.1-44.3-71.8 0-29.8 14.8-57.9 43.3-70.8 20.2-9.1 52.7-10.6 74.8 12.9V136zm-64.7 161.8c0 18.2 13.6 33.5 33.2 33.5 19.8 0 33.2-16.4 33.2-32.9 0-17.1-13.7-33.2-33.2-33.2-19.7 0-33.2 16.4-33.2 32.6zM448 96c17.5 0 32 14.4 32 32v256c0 17.5-14.4 32-32 32H64c-17.5 0-32-14.4-32-32V128c0-17.5 14.4-32 32-32h384m0-32H64C28.8 64 0 92.8 0 128v256c0 35.2 28.8 64 64 64h384c35.2 0 64-28.8 64-64V128c0-35.2-28.8-64-64-64z"
        ],
        "deskpro": [
            480,
            512,
            [],
            "f38f",
            "M205.9 512l31.1-38.4c12.3-.2 25.6-1.4 36.5-6.6 38.9-18.6 38.4-61.9 38.3-63.8-.1-5-.8-4.4-28.9-37.4H362c-.2 50.1-7.3 68.5-10.2 75.7-9.4 23.7-43.9 62.8-95.2 69.4-8.7 1.1-32.8 1.2-50.7 1.1zm200.4-167.7c38.6 0 58.5-13.6 73.7-30.9l-175.5-.3-17.4 31.3 119.2-.1zm-43.6-223.9v168.3h-73.5l-32.7 55.5H250c-52.3 0-58.1-56.5-58.3-58.9-1.2-13.2-21.3-11.6-20.1 1.8 1.4 15.8 8.8 40 26.4 57.1h-91c-25.5 0-110.8-26.8-107-114V16.9C0 .9 9.7.3 15 .1h82c.2 0 .3.1.5.1 4.3-.4 50.1-2.1 50.1 43.7 0 13.3 20.2 13.4 20.2 0 0-18.2-5.5-32.8-15.8-43.7h84.2c108.7-.4 126.5 79.4 126.5 120.2zm-132.5 56l64 29.3c13.3-45.5-42.2-71.7-64-29.3z"
        ],
        "dev": [
            448,
            512,
            [],
            "f6cc",
            "M120.12 208.29c-3.88-2.9-7.77-4.35-11.65-4.35H91.03v104.47h17.45c3.88 0 7.77-1.45 11.65-4.35 3.88-2.9 5.82-7.25 5.82-13.06v-69.65c-.01-5.8-1.96-10.16-5.83-13.06zM404.1 32H43.9C19.7 32 .06 51.59 0 75.8v360.4C.06 460.41 19.7 480 43.9 480h360.2c24.21 0 43.84-19.59 43.9-43.8V75.8c-.06-24.21-19.7-43.8-43.9-43.8zM154.2 291.19c0 18.81-11.61 47.31-48.36 47.25h-46.4V172.98h47.38c35.44 0 47.36 28.46 47.37 47.28l.01 70.93zm100.68-88.66H201.6v38.42h32.57v29.57H201.6v38.41h53.29v29.57h-62.18c-11.16.29-20.44-8.53-20.72-19.69V193.7c-.27-11.15 8.56-20.41 19.71-20.69h63.19l-.01 29.52zm103.64 115.29c-13.2 30.75-36.85 24.63-47.44 0l-38.53-144.8h32.57l29.71 113.72 29.57-113.72h32.58l-38.46 144.8z"
        ],
        "deviantart": [
            320,
            512,
            [],
            "f1bd",
            "M320 93.2l-98.2 179.1 7.4 9.5H320v127.7H159.1l-13.5 9.2-43.7 84c-.3 0-8.6 8.6-9.2 9.2H0v-93.2l93.2-179.4-7.4-9.2H0V102.5h156l13.5-9.2 43.7-84c.3 0 8.6-8.6 9.2-9.2H320v93.1z"
        ],
        "dhl": [
            640,
            512,
            [],
            "f790",
            "M238 301.2h58.7L319 271h-58.7L238 301.2zM0 282.9v6.4h81.8l4.7-6.4H0zM172.9 271c-8.7 0-6-3.6-4.6-5.5 2.8-3.8 7.6-10.4 10.4-14.1 2.8-3.7 2.8-5.9-2.8-5.9h-51l-41.1 55.8h100.1c33.1 0 51.5-22.5 57.2-30.3h-68.2zm317.5-6.9l39.3-53.4h-62.2l-39.3 53.4h62.2zM95.3 271H0v6.4h90.6l4.7-6.4zm111-26.6c-2.8 3.8-7.5 10.4-10.3 14.2-1.4 2-4.1 5.5 4.6 5.5h45.6s7.3-10 13.5-18.4c8.4-11.4.7-35-29.2-35H112.6l-20.4 27.8h111.4c5.6 0 5.5 2.2 2.7 5.9zM0 301.2h73.1l4.7-6.4H0v6.4zm323 0h58.7L404 271h-58.7c-.1 0-22.3 30.2-22.3 30.2zm222 .1h95v-6.4h-90.3l-4.7 6.4zm22.3-30.3l-4.7 6.4H640V271h-72.7zm-13.5 18.3H640v-6.4h-81.5l-4.7 6.4zm-164.2-78.6l-22.5 30.6h-26.2l22.5-30.6h-58.7l-39.3 53.4H409l39.3-53.4h-58.7zm33.5 60.3s-4.3 5.9-6.4 8.7c-7.4 10-.9 21.6 23.2 21.6h94.3l22.3-30.3H423.1z"
        ],
        "diaspora": [
            512,
            512,
            [],
            "f791",
            "M251.64 354.55c-1.4 0-88 119.9-88.7 119.9S76.34 414 76 413.25s86.6-125.7 86.6-127.4c0-2.2-129.6-44-137.6-47.1-1.3-.5 31.4-101.8 31.7-102.1.6-.7 144.4 47 145.5 47 .4 0 .9-.6 1-1.3.4-2 1-148.6 1.7-149.6.8-1.2 104.5-.7 105.1-.3 1.5 1 3.5 156.1 6.1 156.1 1.4 0 138.7-47 139.3-46.3.8.9 31.9 102.2 31.5 102.6-.9.9-140.2 47.1-140.6 48.8-.3 1.4 82.8 122.1 82.5 122.9s-85.5 63.5-86.3 63.5c-1-.2-89-125.5-90.9-125.5z"
        ],
        "digg": [
            512,
            512,
            [],
            "f1a6",
            "M81.7 172.3H0v174.4h132.7V96h-51v76.3zm0 133.4H50.9v-92.3h30.8v92.3zm297.2-133.4v174.4h81.8v28.5h-81.8V416H512V172.3H378.9zm81.8 133.4h-30.8v-92.3h30.8v92.3zm-235.6 41h82.1v28.5h-82.1V416h133.3V172.3H225.1v174.4zm51.2-133.3h30.8v92.3h-30.8v-92.3zM153.3 96h51.3v51h-51.3V96zm0 76.3h51.3v174.4h-51.3V172.3z"
        ],
        "digital-ocean": [
            512,
            512,
            [],
            "f391",
            "M87 481.8h73.7v-73.6H87zM25.4 346.6v61.6H87v-61.6zm466.2-169.7c-23-74.2-82.4-133.3-156.6-156.6C164.9-32.8 8 93.7 8 255.9h95.8c0-101.8 101-180.5 208.1-141.7 39.7 14.3 71.5 46.1 85.8 85.7 39.1 107-39.7 207.8-141.4 208v.3h-.3V504c162.6 0 288.8-156.8 235.6-327.1zm-235.3 231v-95.3h-95.6v95.6H256v-.3z"
        ],
        "discord": [
            640,
            512,
            [],
            "f392",
            "M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z"
        ],
        "discourse": [
            448,
            512,
            [],
            "f393",
            "M225.9 32C103.3 32 0 130.5 0 252.1 0 256 .1 480 .1 480l225.8-.2c122.7 0 222.1-102.3 222.1-223.9C448 134.3 348.6 32 225.9 32zM224 384c-19.4 0-37.9-4.3-54.4-12.1L88.5 392l22.9-75c-9.8-18.1-15.4-38.9-15.4-61 0-70.7 57.3-128 128-128s128 57.3 128 128-57.3 128-128 128z"
        ],
        "dochub": [
            416,
            512,
            [],
            "f394",
            "M397.9 160H256V19.6L397.9 160zM304 192v130c0 66.8-36.5 100.1-113.3 100.1H96V84.8h94.7c12 0 23.1.8 33.1 2.5v-84C212.9 1.1 201.4 0 189.2 0H0v512h189.2C329.7 512 400 447.4 400 318.1V192h-96z"
        ],
        "docker": [
            640,
            512,
            [],
            "f395",
            "M349.9 236.3h-66.1v-59.4h66.1v59.4zm0-204.3h-66.1v60.7h66.1V32zm78.2 144.8H362v59.4h66.1v-59.4zm-156.3-72.1h-66.1v60.1h66.1v-60.1zm78.1 0h-66.1v60.1h66.1v-60.1zm276.8 100c-14.4-9.7-47.6-13.2-73.1-8.4-3.3-24-16.7-44.9-41.1-63.7l-14-9.3-9.3 14c-18.4 27.8-23.4 73.6-3.7 103.8-8.7 4.7-25.8 11.1-48.4 10.7H2.4c-8.7 50.8 5.8 116.8 44 162.1 37.1 43.9 92.7 66.2 165.4 66.2 157.4 0 273.9-72.5 328.4-204.2 21.4.4 67.6.1 91.3-45.2 1.5-2.5 6.6-13.2 8.5-17.1l-13.3-8.9zm-511.1-27.9h-66v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm78.1 0h-66.1v59.4h66.1v-59.4zm-78.1-72.1h-66.1v60.1h66.1v-60.1z"
        ],
        "draft2digital": [
            480,
            512,
            [],
            "f396",
            "M480 398.1l-144-82.2v64.7h-91.3c30.8-35 81.8-95.9 111.8-149.3 35.2-62.6 16.1-123.4-12.8-153.3-4.4-4.6-62.2-62.9-166-41.2-59.1 12.4-89.4 43.4-104.3 67.3-13.1 20.9-17 39.8-18.2 47.7-5.5 33 19.4 67.1 56.7 67.1 31.7 0 57.3-25.7 57.3-57.4 0-27.1-19.7-52.1-48-56.8 1.8-7.3 17.7-21.1 26.3-24.7 41.1-17.3 78 5.2 83.3 33.5 8.3 44.3-37.1 90.4-69.7 127.6C84.5 328.1 18.3 396.8 0 415.9l336-.1V480zM369.9 371l47.1 27.2-47.1 27.2zM134.2 161.4c0 12.4-10 22.4-22.4 22.4s-22.4-10-22.4-22.4 10-22.4 22.4-22.4 22.4 10.1 22.4 22.4zM82.5 380.5c25.6-27.4 97.7-104.7 150.8-169.9 35.1-43.1 40.3-82.4 28.4-112.7-7.4-18.8-17.5-30.2-24.3-35.7 45.3 2.1 68 23.4 82.2 38.3 0 0 42.4 48.2 5.8 113.3-37 65.9-110.9 147.5-128.5 166.7z"
        ],
        "dribbble": [
            512,
            512,
            [],
            "f17d",
            "M256 8C119.252 8 8 119.252 8 256s111.252 248 248 248 248-111.252 248-248S392.748 8 256 8zm163.97 114.366c29.503 36.046 47.369 81.957 47.835 131.955-6.984-1.477-77.018-15.682-147.502-6.818-5.752-14.041-11.181-26.393-18.617-41.614 78.321-31.977 113.818-77.482 118.284-83.523zM396.421 97.87c-3.81 5.427-35.697 48.286-111.021 76.519-34.712-63.776-73.185-116.168-79.04-124.008 67.176-16.193 137.966 1.27 190.061 47.489zm-230.48-33.25c5.585 7.659 43.438 60.116 78.537 122.509-99.087 26.313-186.36 25.934-195.834 25.809C62.38 147.205 106.678 92.573 165.941 64.62zM44.17 256.323c0-2.166.043-4.322.108-6.473 9.268.19 111.92 1.513 217.706-30.146 6.064 11.868 11.857 23.915 17.174 35.949-76.599 21.575-146.194 83.527-180.531 142.306C64.794 360.405 44.17 310.73 44.17 256.323zm81.807 167.113c22.127-45.233 82.178-103.622 167.579-132.756 29.74 77.283 42.039 142.053 45.189 160.638-68.112 29.013-150.015 21.053-212.768-27.882zm248.38 8.489c-2.171-12.886-13.446-74.897-41.152-151.033 66.38-10.626 124.7 6.768 131.947 9.055-9.442 58.941-43.273 109.844-90.795 141.978z"
        ],
        "dribbble-square": [
            448,
            512,
            [],
            "f397",
            "M90.2 228.2c8.9-42.4 37.4-77.7 75.7-95.7 3.6 4.9 28 38.8 50.7 79-64 17-120.3 16.8-126.4 16.7zM314.6 154c-33.6-29.8-79.3-41.1-122.6-30.6 3.8 5.1 28.6 38.9 51 80 48.6-18.3 69.1-45.9 71.6-49.4zM140.1 364c40.5 31.6 93.3 36.7 137.3 18-2-12-10-53.8-29.2-103.6-55.1 18.8-93.8 56.4-108.1 85.6zm98.8-108.2c-3.4-7.8-7.2-15.5-11.1-23.2C159.6 253 93.4 252.2 87.4 252c0 1.4-.1 2.8-.1 4.2 0 35.1 13.3 67.1 35.1 91.4 22.2-37.9 67.1-77.9 116.5-91.8zm34.9 16.3c17.9 49.1 25.1 89.1 26.5 97.4 30.7-20.7 52.5-53.6 58.6-91.6-4.6-1.5-42.3-12.7-85.1-5.8zm-20.3-48.4c4.8 9.8 8.3 17.8 12 26.8 45.5-5.7 90.7 3.4 95.2 4.4-.3-32.3-11.8-61.9-30.9-85.1-2.9 3.9-25.8 33.2-76.3 53.9zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-64 176c0-88.2-71.8-160-160-160S64 167.8 64 256s71.8 160 160 160 160-71.8 160-160z"
        ],
        "dropbox": [
            528,
            512,
            [],
            "f16b",
            "M264.4 116.3l-132 84.3 132 84.3-132 84.3L0 284.1l132.3-84.3L0 116.3 132.3 32l132.1 84.3zM131.6 395.7l132-84.3 132 84.3-132 84.3-132-84.3zm132.8-111.6l132-84.3-132-83.6L395.7 32 528 116.3l-132.3 84.3L528 284.8l-132.3 84.3-131.3-85z"
        ],
        "drupal": [
            448,
            512,
            [],
            "f1a9",
            "M319.5 114.7c-22.2-14-43.5-19.5-64.7-33.5-13-8.8-31.3-30-46.5-48.3-2.7 29.3-11.5 41.2-22 49.5-21.3 17-34.8 22.2-53.5 32.3C117 123 32 181.5 32 290.5 32 399.7 123.8 480 225.8 480 327.5 480 416 406 416 294c0-112.3-83-171-96.5-179.3zm2.5 325.6c-20.1 20.1-90.1 28.7-116.7 4.2-4.8-4.8.3-12 6.5-12 0 0 17 13.3 51.5 13.3 27 0 46-7.7 54.5-14 6.1-4.6 8.4 4.3 4.2 8.5zm-54.5-52.6c8.7-3.6 29-3.8 36.8 1.3 4.1 2.8 16.1 18.8 6.2 23.7-8.4 4.2-1.2-15.7-26.5-15.7-14.7 0-19.5 5.2-26.7 11-7 6-9.8 8-12.2 4.7-6-8.2 15.9-22.3 22.4-25zM360 405c-15.2-1-45.5-48.8-65-49.5-30.9-.9-104.1 80.7-161.3 42-38.8-26.6-14.6-104.8 51.8-105.2 49.5-.5 83.8 49 108.5 48.5 21.3-.3 61.8-41.8 81.8-41.8 48.7 0 23.3 109.3-15.8 106z"
        ],
        "dyalog": [
            416,
            512,
            [],
            "f399",
            "M0 32v119.2h64V96h107.2C284.6 96 352 176.2 352 255.9 352 332 293.4 416 171.2 416H0v64h171.2C331.9 480 416 367.3 416 255.9c0-58.7-22.1-113.4-62.3-154.3C308.9 56 245.7 32 171.2 32H0z"
        ],
        "earlybirds": [
            480,
            512,
            [],
            "f39a",
            "M313.2 47.5c1.2-13 21.3-14 36.6-8.7.9.3 26.2 9.7 19 15.2-27.9-7.4-56.4 18.2-55.6-6.5zm-201 6.9c30.7-8.1 62 20 61.1-7.1-1.3-14.2-23.4-15.3-40.2-9.6-1 .3-28.7 10.5-20.9 16.7zM319.4 160c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm-159.7 0c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16zm318.5 163.2c-9.9 24-40.7 11-63.9-1.2-13.5 69.1-58.1 111.4-126.3 124.2.3.9-2-.1 24 1 33.6 1.4 63.8-3.1 97.4-8-19.8-13.8-11.4-37.1-9.8-38.1 1.4-.9 14.7 1.7 21.6 11.5 8.6-12.5 28.4-14.8 30.2-13.6 1.6 1.1 6.6 20.9-6.9 34.6 4.7-.9 8.2-1.6 9.8-2.1 2.6-.8 17.7 11.3 3.1 13.3-14.3 2.3-22.6 5.1-47.1 10.8-45.9 10.7-85.9 11.8-117.7 12.8l1 11.6c3.8 18.1-23.4 24.3-27.6 6.2.8 17.9-27.1 21.8-28.4-1l-.5 5.3c-.7 18.4-28.4 17.9-28.3-.6-7.5 13.5-28.1 6.8-26.4-8.5l1.2-12.4c-36.7.9-59.7 3.1-61.8 3.1-20.9 0-20.9-31.6 0-31.6 2.4 0 27.7 1.3 63.2 2.8-61.1-15.5-103.7-55-114.9-118.2-25 12.8-57.5 26.8-68.2.8-10.5-25.4 21.5-42.6 66.8-73.4.7-6.6 1.6-13.3 2.7-19.8-14.4-19.6-11.6-36.3-16.1-60.4-16.8 2.4-23.2-9.1-23.6-23.1.3-7.3 2.1-14.9 2.4-15.4 1.1-1.8 10.1-2 12.7-2.6 6-31.7 50.6-33.2 90.9-34.5 19.7-21.8 45.2-41.5 80.9-48.3C203.3 29 215.2 8.5 216.2 8c1.7-.8 21.2 4.3 26.3 23.2 5.2-8.8 18.3-11.4 19.6-10.7 1.1.6 6.4 15-4.9 25.9 40.3 3.5 72.2 24.7 96 50.7 36.1 1.5 71.8 5.9 77.1 34 2.7.6 11.6.8 12.7 2.6.3.5 2.1 8.1 2.4 15.4-.5 13.9-6.8 25.4-23.6 23.1-3.2 17.3-2.7 32.9-8.7 47.7 2.4 11.7 4 23.8 4.8 36.4 37 25.4 70.3 42.5 60.3 66.9zM207.4 159.9c.9-44-37.9-42.2-78.6-40.3-21.7 1-38.9 1.9-45.5 13.9-11.4 20.9 5.9 92.9 23.2 101.2 9.8 4.7 73.4 7.9 86.3-7.1 8.2-9.4 15-49.4 14.6-67.7zm52 58.3c-4.3-12.4-6-30.1-15.3-32.7-2-.5-9-.5-11 0-10 2.8-10.8 22.1-17 37.2 15.4 0 19.3 9.7 23.7 9.7 4.3 0 6.3-11.3 19.6-14.2zm135.7-84.7c-6.6-12.1-24.8-12.9-46.5-13.9-40.2-1.9-78.2-3.8-77.3 40.3-.5 18.3 5 58.3 13.2 67.8 13 14.9 76.6 11.8 86.3 7.1 15.8-7.6 36.5-78.9 24.3-101.3z"
        ],
        "ebay": [
            640,
            512,
            [],
            "f4f4",
            "M606 189.5l-54.8 109.9-54.9-109.9h-37.5l10.9 20.6c-11.5-19-35.9-26-63.3-26-31.8 0-67.9 8.7-71.5 43.1h33.7c1.4-13.8 15.7-21.8 35-21.8 26 0 41 9.6 41 33v3.4c-12.7 0-28 .1-41.7.4-42.4.9-69.6 10-76.7 34.4 1-5.2 1.5-10.6 1.5-16.2 0-52.1-39.7-76.2-75.4-76.2-21.3 0-43 5.5-58.7 24.2v-80.6h-32.1v169.5c0 10.3-.6 22.9-1.1 33.1h31.5c.7-6.3 1.1-12.9 1.1-19.5 13.6 16.6 35.4 24.9 58.7 24.9 36.9 0 64.9-21.9 73.3-54.2-.5 2.8-.7 5.8-.7 9 0 24.1 21.1 45 60.6 45 26.6 0 45.8-5.7 61.9-25.5 0 6.6.3 13.3 1.1 20.2h29.8c-.7-8.2-1-17.5-1-26.8v-65.6c0-9.3-1.7-17.2-4.8-23.8l61.5 116.1-28.5 54.1h35.9L640 189.5zM243.7 313.8c-29.6 0-50.2-21.5-50.2-53.8 0-32.4 20.6-53.8 50.2-53.8 29.8 0 50.2 21.4 50.2 53.8 0 32.3-20.4 53.8-50.2 53.8zm200.9-47.3c0 30-17.9 48.4-51.6 48.4-25.1 0-35-13.4-35-25.8 0-19.1 18.1-24.4 47.2-25.3 13.1-.5 27.6-.6 39.4-.6zm-411.9 1.6h128.8v-8.5c0-51.7-33.1-75.4-78.4-75.4-56.8 0-83 30.8-83 77.6 0 42.5 25.3 74 82.5 74 31.4 0 68-11.7 74.4-46.1h-33.1c-12 35.8-87.7 36.7-91.2-21.6zm95-21.4H33.3c6.9-56.6 92.1-54.7 94.4 0z"
        ],
        "edge": [
            512,
            512,
            [],
            "f282",
            "M481.92,134.48C440.87,54.18,352.26,8,255.91,8,137.05,8,37.51,91.68,13.47,203.66c26-46.49,86.22-79.14,149.46-79.14,79.27,0,121.09,48.93,122.25,50.18,22,23.8,33,50.39,33,83.1,0,10.4-5.31,25.82-15.11,38.57-1.57,2-6.39,4.84-6.39,11,0,5.06,3.29,9.92,9.14,14,27.86,19.37,80.37,16.81,80.51,16.81A115.39,115.39,0,0,0,444.94,322a118.92,118.92,0,0,0,58.95-102.44C504.39,176.13,488.39,147.26,481.92,134.48ZM212.77,475.67a154.88,154.88,0,0,1-46.64-45c-32.94-47.42-34.24-95.6-20.1-136A155.5,155.5,0,0,1,203,215.75c59-45.2,94.84-5.65,99.06-1a80,80,0,0,0-4.89-10.14c-9.24-15.93-24-36.41-56.56-53.51-33.72-17.69-70.59-18.59-77.64-18.59-38.71,0-77.9,13-107.53,35.69C35.68,183.3,12.77,208.72,8.6,243c-1.08,12.31-2.75,62.8,23,118.27a248,248,0,0,0,248.3,141.61C241.78,496.26,214.05,476.24,212.77,475.67Zm250.72-98.33a7.76,7.76,0,0,0-7.92-.23,181.66,181.66,0,0,1-20.41,9.12,197.54,197.54,0,0,1-69.55,12.52c-91.67,0-171.52-63.06-171.52-144A61.12,61.12,0,0,1,200.61,228,168.72,168.72,0,0,0,161.85,278c-14.92,29.37-33,88.13,13.33,151.66,6.51,8.91,23,30,56,47.67,23.57,12.65,49,19.61,71.7,19.61,35.14,0,115.43-33.44,163-108.87A7.75,7.75,0,0,0,463.49,377.34Z"
        ],
        "edge-legacy": [
            512,
            512,
            [],
            "e078",
            "M25.71,228.16l.35-.48c0,.16,0,.32-.07.48Zm460.58,15.51c0-44-7.76-84.46-28.81-122.4C416.5,47.88,343.91,8,258.89,8,119,7.72,40.62,113.21,26.06,227.68c42.42-61.31,117.07-121.38,220.37-125,0,0,109.67,0,99.42,105H170c6.37-37.39,18.55-59,34.34-78.93-75.05,34.9-121.85,96.1-120.75,188.32.83,71.45,50.13,144.84,120.75,172,83.35,31.84,192.77,7.2,240.13-21.33V363.31C363.6,419.8,173.6,424.23,172.21,295.74H486.29V243.67Z"
        ],
        "elementor": [
            448,
            512,
            [],
            "f430",
            "M425.6 32H22.4C10 32 0 42 0 54.4v403.2C0 470 10 480 22.4 480h403.2c12.4 0 22.4-10 22.4-22.4V54.4C448 42 438 32 425.6 32M164.3 355.5h-39.8v-199h39.8v199zm159.3 0H204.1v-39.8h119.5v39.8zm0-79.6H204.1v-39.8h119.5v39.8zm0-79.7H204.1v-39.8h119.5v39.8z"
        ],
        "ello": [
            496,
            512,
            [],
            "f5f1",
            "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm143.84 285.2C375.31 358.51 315.79 404.8 248 404.8s-127.31-46.29-143.84-111.6c-1.65-7.44 2.48-15.71 9.92-17.36 7.44-1.65 15.71 2.48 17.36 9.92 14.05 52.91 62 90.11 116.56 90.11s102.51-37.2 116.56-90.11c1.65-7.44 9.92-12.4 17.36-9.92 7.44 1.65 12.4 9.92 9.92 17.36z"
        ],
        "ember": [
            640,
            512,
            [],
            "f423",
            "M639.9 254.6c-1.1-10.7-10.7-6.8-10.7-6.8s-15.6 12.1-29.3 10.7c-13.7-1.3-9.4-32-9.4-32s3-28.1-5.1-30.4c-8.1-2.4-18 7.3-18 7.3s-12.4 13.7-18.3 31.2l-1.6.5s1.9-30.6-.3-37.6c-1.6-3.5-16.4-3.2-18.8 3s-14.2 49.2-15 67.2c0 0-23.1 19.6-43.3 22.8s-25-9.4-25-9.4 54.8-15.3 52.9-59.1-44.2-27.6-49-24c-4.6 3.5-29.4 18.4-36.6 59.7-.2 1.4-.7 7.5-.7 7.5s-21.2 14.2-33 18c0 0 33-55.6-7.3-80.9-11.4-6.8-21.3-.5-27.2 5.3 13.6-17.3 46.4-64.2 36.9-105.2-5.8-24.4-18-27.1-29.2-23.1-17 6.7-23.5 16.7-23.5 16.7s-22 32-27.1 79.5-12.6 105.1-12.6 105.1-10.5 10.2-20.2 10.7-5.4-28.7-5.4-28.7 7.5-44.6 7-52.1-1.1-11.6-9.9-14.2c-8.9-2.7-18.5 8.6-18.5 8.6s-25.5 38.7-27.7 44.6l-1.3 2.4-1.3-1.6s18-52.7.8-53.5-28.5 18.8-28.5 18.8-19.6 32.8-20.4 36.5l-1.3-1.6s8.1-38.2 6.4-47.6c-1.6-9.4-10.5-7.5-10.5-7.5s-11.3-1.3-14.2 5.9-13.7 55.3-15 70.7c0 0-28.2 20.2-46.8 20.4-18.5.3-16.7-11.8-16.7-11.8s68-23.3 49.4-69.2c-8.3-11.8-18-15.5-31.7-15.3-13.7.3-30.3 8.6-41.3 33.3-5.3 11.8-6.8 23-7.8 31.5 0 0-12.3 2.4-18.8-2.9s-10 0-10 0-11.2 14-.1 18.3 28.1 6.1 28.1 6.1c1.6 7.5 6.2 19.5 19.6 29.7 20.2 15.3 58.8-1.3 58.8-1.3l15.9-8.8s.5 14.6 12.1 16.7 16.4 1 36.5-47.9c11.8-25 12.6-23.6 12.6-23.6l1.3-.3s-9.1 46.8-5.6 59.7C187.7 319.4 203 318 203 318s8.3 2.4 15-21.2 19.6-49.9 19.6-49.9h1.6s-5.6 48.1 3 63.7 30.9 5.3 30.9 5.3 15.6-7.8 18-10.2c0 0 18.5 15.8 44.6 12.9 58.3-11.5 79.1-25.9 79.1-25.9s10 24.4 41.1 26.7c35.5 2.7 54.8-18.6 54.8-18.6s-.3 13.5 12.1 18.6 20.7-22.8 20.7-22.8l20.7-57.2h1.9s1.1 37.3 21.5 43.2 47-13.7 47-13.7 6.4-3.5 5.3-14.3zm-578 5.3c.8-32 21.8-45.9 29-39 7.3 7 4.6 22-9.1 31.4-13.7 9.5-19.9 7.6-19.9 7.6zm272.8-123.8s19.1-49.7 23.6-25.5-40 96.2-40 96.2c.5-16.2 16.4-70.7 16.4-70.7zm22.8 138.4c-12.6 33-43.3 19.6-43.3 19.6s-3.5-11.8 6.4-44.9 33.3-20.2 33.3-20.2 16.2 12.4 3.6 45.5zm84.6-14.6s-3-10.5 8.1-30.6c11-20.2 19.6-9.1 19.6-9.1s9.4 10.2-1.3 25.5-26.4 14.2-26.4 14.2z"
        ],
        "empire": [
            496,
            512,
            [],
            "f1d1",
            "M287.6 54.2c-10.8-2.2-22.1-3.3-33.5-3.6V32.4c78.1 2.2 146.1 44 184.6 106.6l-15.8 9.1c-6.1-9.7-12.7-18.8-20.2-27.1l-18 15.5c-26-29.6-61.4-50.7-101.9-58.4l4.8-23.9zM53.4 322.4l23-7.7c-6.4-18.3-10-38.2-10-58.7s3.3-40.4 9.7-58.7l-22.7-7.7c3.6-10.8 8.3-21.3 13.6-31l-15.8-9.1C34 181 24.1 217.5 24.1 256s10 75 27.1 106.6l15.8-9.1c-5.3-10-9.7-20.3-13.6-31.1zM213.1 434c-40.4-8-75.8-29.1-101.9-58.7l-18 15.8c-7.5-8.6-14.4-17.7-20.2-27.4l-16 9.4c38.5 62.3 106.8 104.3 184.9 106.6v-18.3c-11.3-.3-22.7-1.7-33.5-3.6l4.7-23.8zM93.3 120.9l18 15.5c26-29.6 61.4-50.7 101.9-58.4l-4.7-23.8c10.8-2.2 22.1-3.3 33.5-3.6V32.4C163.9 34.6 95.9 76.4 57.4 139l15.8 9.1c6-9.7 12.6-18.9 20.1-27.2zm309.4 270.2l-18-15.8c-26 29.6-61.4 50.7-101.9 58.7l4.7 23.8c-10.8 1.9-22.1 3.3-33.5 3.6v18.3c78.1-2.2 146.4-44.3 184.9-106.6l-16.1-9.4c-5.7 9.7-12.6 18.8-20.1 27.4zM496 256c0 137-111 248-248 248S0 393 0 256 111 8 248 8s248 111 248 248zm-12.2 0c0-130.1-105.7-235.8-235.8-235.8S12.2 125.9 12.2 256 117.9 491.8 248 491.8 483.8 386.1 483.8 256zm-39-106.6l-15.8 9.1c5.3 9.7 10 20.2 13.6 31l-22.7 7.7c6.4 18.3 9.7 38.2 9.7 58.7s-3.6 40.4-10 58.7l23 7.7c-3.9 10.8-8.3 21-13.6 31l15.8 9.1C462 331 471.9 294.5 471.9 256s-9.9-75-27.1-106.6zm-183 177.7c16.3-3.3 30.4-11.6 40.7-23.5l51.2 44.8c11.9-13.6 21.3-29.3 27.1-46.8l-64.2-22.1c2.5-7.5 3.9-15.2 3.9-23.5s-1.4-16.1-3.9-23.5l64.5-22.1c-6.1-17.4-15.5-33.2-27.4-46.8l-51.2 44.8c-10.2-11.9-24.4-20.5-40.7-23.8l13.3-66.4c-8.6-1.9-17.7-2.8-27.1-2.8-9.4 0-18.5.8-27.1 2.8l13.3 66.4c-16.3 3.3-30.4 11.9-40.7 23.8l-51.2-44.8c-11.9 13.6-21.3 29.3-27.4 46.8l64.5 22.1c-2.5 7.5-3.9 15.2-3.9 23.5s1.4 16.1 3.9 23.5l-64.2 22.1c5.8 17.4 15.2 33.2 27.1 46.8l51.2-44.8c10.2 11.9 24.4 20.2 40.7 23.5l-13.3 66.7c8.6 1.7 17.7 2.8 27.1 2.8 9.4 0 18.5-1.1 27.1-2.8l-13.3-66.7z"
        ],
        "envira": [
            448,
            512,
            [],
            "f299",
            "M0 32c477.6 0 366.6 317.3 367.1 366.3L448 480h-26l-70.4-71.2c-39 4.2-124.4 34.5-214.4-37C47 300.3 52 214.7 0 32zm79.7 46c-49.7-23.5-5.2 9.2-5.2 9.2 45.2 31.2 66 73.7 90.2 119.9 31.5 60.2 79 139.7 144.2 167.7 65 28 34.2 12.5 6-8.5-28.2-21.2-68.2-87-91-130.2-31.7-60-61-118.6-144.2-158.1z"
        ],
        "erlang": [
            640,
            512,
            [],
            "f39d",
            "M87.2 53.5H0v405h100.4c-49.7-52.6-78.8-125.3-78.7-212.1-.1-76.7 24-142.7 65.5-192.9zm238.2 9.7c-45.9.1-85.1 33.5-89.2 83.2h169.9c-1.1-49.7-34.5-83.1-80.7-83.2zm230.7-9.6h.3l-.1-.1zm.3 0c31.4 42.7 48.7 97.5 46.2 162.7.5 6 .5 11.7 0 24.1H230.2c-.2 109.7 38.9 194.9 138.6 195.3 68.5-.3 118-51 151.9-106.1l96.4 48.2c-17.4 30.9-36.5 57.8-57.9 80.8H640v-405z"
        ],
        "ethereum": [
            320,
            512,
            [],
            "f42e",
            "M311.9 260.8L160 353.6 8 260.8 160 0l151.9 260.8zM160 383.4L8 290.6 160 512l152-221.4-152 92.8z"
        ],
        "etsy": [
            384,
            512,
            [],
            "f2d7",
            "M384 348c-1.75 10.75-13.75 110-15.5 132-117.879-4.299-219.895-4.743-368.5 0v-25.5c45.457-8.948 60.627-8.019 61-35.25 1.793-72.322 3.524-244.143 0-322-1.029-28.46-12.13-26.765-61-36v-25.5c73.886 2.358 255.933 8.551 362.999-3.75-3.5 38.25-7.75 126.5-7.75 126.5H332C320.947 115.665 313.241 68 277.25 68h-137c-10.25 0-10.75 3.5-10.75 9.75V241.5c58 .5 88.5-2.5 88.5-2.5 29.77-.951 27.56-8.502 40.75-65.251h25.75c-4.407 101.351-3.91 61.829-1.75 160.25H257c-9.155-40.086-9.065-61.045-39.501-61.5 0 0-21.5-2-88-2v139c0 26 14.25 38.25 44.25 38.25H263c63.636 0 66.564-24.996 98.751-99.75H384z"
        ],
        "evernote": [
            384,
            512,
            [],
            "f839",
            "M120.82 132.21c1.6 22.31-17.55 21.59-21.61 21.59-68.93 0-73.64-1-83.58 3.34-.56.22-.74 0-.37-.37L123.79 46.45c.38-.37.6-.22.38.37-4.35 9.99-3.35 15.09-3.35 85.39zm79 308c-14.68-37.08 13-76.93 52.52-76.62 17.49 0 22.6 23.21 7.95 31.42-6.19 3.3-24.95 1.74-25.14 19.2-.05 17.09 19.67 25 31.2 24.89A45.64 45.64 0 0 0 312 393.45v-.08c0-11.63-7.79-47.22-47.54-55.34-7.72-1.54-65-6.35-68.35-50.52-3.74 16.93-17.4 63.49-43.11 69.09-8.74 1.94-69.68 7.64-112.92-36.77 0 0-18.57-15.23-28.23-57.95-3.38-15.75-9.28-39.7-11.14-62 0-18 11.14-30.45 25.07-32.2 81 0 90 2.32 101-7.8 9.82-9.24 7.8-15.5 7.8-102.78 1-8.3 7.79-30.81 53.41-24.14 6 .86 31.91 4.18 37.48 30.64l64.26 11.15c20.43 3.71 70.94 7 80.6 57.94 22.66 121.09 8.91 238.46 7.8 238.46C362.15 485.53 267.06 480 267.06 480c-18.95-.23-54.25-9.4-67.27-39.83zm80.94-204.84c-1 1.92-2.2 6 .85 7 14.09 4.93 39.75 6.84 45.88 5.53 3.11-.25 3.05-4.43 2.48-6.65-3.53-21.85-40.83-26.5-49.24-5.92z"
        ],
        "expeditedssl": [
            496,
            512,
            [],
            "f23e",
            "M248 43.4C130.6 43.4 35.4 138.6 35.4 256S130.6 468.6 248 468.6 460.6 373.4 460.6 256 365.4 43.4 248 43.4zm-97.4 132.9c0-53.7 43.7-97.4 97.4-97.4s97.4 43.7 97.4 97.4v26.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-26.6c0-82.1-124-82.1-124 0v26.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-26.6zM389.7 380c0 9.7-8 17.7-17.7 17.7H124c-9.7 0-17.7-8-17.7-17.7V238.3c0-9.7 8-17.7 17.7-17.7h248c9.7 0 17.7 8 17.7 17.7V380zm-248-137.3v132.9c0 2.5-1.9 4.4-4.4 4.4h-8.9c-2.5 0-4.4-1.9-4.4-4.4V242.7c0-2.5 1.9-4.4 4.4-4.4h8.9c2.5 0 4.4 1.9 4.4 4.4zm141.7 48.7c0 13-7.2 24.4-17.7 30.4v31.6c0 5-3.9 8.9-8.9 8.9h-17.7c-5 0-8.9-3.9-8.9-8.9v-31.6c-10.5-6.1-17.7-17.4-17.7-30.4 0-19.7 15.8-35.4 35.4-35.4s35.5 15.8 35.5 35.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 478.3C121 486.3 17.7 383 17.7 256S121 25.7 248 25.7 478.3 129 478.3 256 375 486.3 248 486.3z"
        ],
        "facebook": [
            512,
            512,
            [],
            "f09a",
            "M504 256C504 119 393 8 256 8S8 119 8 256c0 123.78 90.69 226.38 209.25 245V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.28c-30.8 0-40.41 19.12-40.41 38.73V256h68.78l-11 71.69h-57.78V501C413.31 482.38 504 379.78 504 256z"
        ],
        "facebook-f": [
            320,
            512,
            [],
            "f39e",
            "M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
        ],
        "facebook-messenger": [
            512,
            512,
            [],
            "f39f",
            "M256.55 8C116.52 8 8 110.34 8 248.57c0 72.3 29.71 134.78 78.07 177.94 8.35 7.51 6.63 11.86 8.05 58.23A19.92 19.92 0 0 0 122 502.31c52.91-23.3 53.59-25.14 62.56-22.7C337.85 521.8 504 423.7 504 248.57 504 110.34 396.59 8 256.55 8zm149.24 185.13l-73 115.57a37.37 37.37 0 0 1-53.91 9.93l-58.08-43.47a15 15 0 0 0-18 0l-78.37 59.44c-10.46 7.93-24.16-4.6-17.11-15.67l73-115.57a37.36 37.36 0 0 1 53.91-9.93l58.06 43.46a15 15 0 0 0 18 0l78.41-59.38c10.44-7.98 24.14 4.54 17.09 15.62z"
        ],
        "facebook-square": [
            448,
            512,
            [],
            "f082",
            "M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"
        ],
        "fantasy-flight-games": [
            512,
            512,
            [],
            "f6dc",
            "M256 32.86L32.86 256 256 479.14 479.14 256 256 32.86zM88.34 255.83c1.96-2 11.92-12.3 96.49-97.48 41.45-41.75 86.19-43.77 119.77-18.69 24.63 18.4 62.06 58.9 62.15 59 .68.74 1.07 2.86.58 3.38-11.27 11.84-22.68 23.54-33.5 34.69-34.21-32.31-40.52-38.24-48.51-43.95-17.77-12.69-41.4-10.13-56.98 5.1-2.17 2.13-1.79 3.43.12 5.35 2.94 2.95 28.1 28.33 35.09 35.78-11.95 11.6-23.66 22.97-35.69 34.66-12.02-12.54-24.48-25.53-36.54-38.11-21.39 21.09-41.69 41.11-61.85 60.99a42569.01 42569.01 0 0 1-41.13-40.72zm234.82 101.6c-35.49 35.43-78.09 38.14-106.99 20.47-22.08-13.5-39.38-32.08-72.93-66.84 12.05-12.37 23.79-24.42 35.37-36.31 33.02 31.91 37.06 36.01 44.68 42.09 18.48 14.74 42.52 13.67 59.32-1.8 3.68-3.39 3.69-3.64.14-7.24-10.59-10.73-21.19-21.44-31.77-32.18-1.32-1.34-3.03-2.48-.8-4.69 10.79-10.71 21.48-21.52 32.21-32.29.26-.26.65-.38 1.91-1.07 12.37 12.87 24.92 25.92 37.25 38.75 21.01-20.73 41.24-40.68 61.25-60.42 13.68 13.4 27.13 26.58 40.86 40.03-20.17 20.86-81.68 82.71-100.5 101.5zM256 0L0 256l256 256 256-256L256 0zM16 256L256 16l240 240-240 240L16 256z"
        ],
        "fedex": [
            640,
            512,
            [],
            "f797",
            "M586 284.5l53.3-59.9h-62.4l-21.7 24.8-22.5-24.8H414v-16h56.1v-48.1H318.9V236h-.5c-9.6-11-21.5-14.8-35.4-14.8-28.4 0-49.8 19.4-57.3 44.9-18-59.4-97.4-57.6-121.9-14v-24.2H49v-26.2h60v-41.1H0V345h49v-77.5h48.9c-1.5 5.7-2.3 11.8-2.3 18.2 0 73.1 102.6 91.4 130.2 23.7h-42c-14.7 20.9-45.8 8.9-45.8-14.6h85.5c3.7 30.5 27.4 56.9 60.1 56.9 14.1 0 27-6.9 34.9-18.6h.5V345h212.2l22.1-25 22.3 25H640l-54-60.5zm-446.7-16.6c6.1-26.3 41.7-25.6 46.5 0h-46.5zm153.4 48.9c-34.6 0-34-62.8 0-62.8 32.6 0 34.5 62.8 0 62.8zm167.8 19.1h-94.4V169.4h95v30.2H405v33.9h55.5v28.1h-56.1v44.7h56.1v29.6zm-45.9-39.8v-24.4h56.1v-44l50.7 57-50.7 57v-45.6h-56.1zm138.6 10.3l-26.1 29.5H489l45.6-51.2-45.6-51.2h39.7l26.6 29.3 25.6-29.3h38.5l-45.4 51 46 51.4h-40.5l-26.3-29.5z"
        ],
        "fedora": [
            448,
            512,
            [],
            "f798",
            "M225 32C101.3 31.7.8 131.7.4 255.4L0 425.7a53.6 53.6 0 0 0 53.6 53.9l170.2.4c123.7.3 224.3-99.7 224.6-223.4S348.7 32.3 225 32zm169.8 157.2L333 126.6c2.3-4.7 3.8-9.2 3.8-14.3v-1.6l55.2 56.1a101 101 0 0 1 2.8 22.4zM331 94.3a106.06 106.06 0 0 1 58.5 63.8l-54.3-54.6a26.48 26.48 0 0 0-4.2-9.2zM118.1 247.2a49.66 49.66 0 0 0-7.7 11.4l-8.5-8.5a85.78 85.78 0 0 1 16.2-2.9zM97 251.4l11.8 11.9-.9 8a34.74 34.74 0 0 0 2.4 12.5l-27-27.2a80.6 80.6 0 0 1 13.7-5.2zm-18.2 7.4l38.2 38.4a53.17 53.17 0 0 0-14.1 4.7L67.6 266a107 107 0 0 1 11.2-7.2zm-15.2 9.8l35.3 35.5a67.25 67.25 0 0 0-10.5 8.5L53.5 278a64.33 64.33 0 0 1 10.1-9.4zm-13.3 12.3l34.9 35a56.84 56.84 0 0 0-7.7 11.4l-35.8-35.9c2.8-3.8 5.7-7.2 8.6-10.5zm-11 14.3l36.4 36.6a48.29 48.29 0 0 0-3.6 15.2l-39.5-39.8a99.81 99.81 0 0 1 6.7-12zm-8.8 16.3l41.3 41.8a63.47 63.47 0 0 0 6.7 26.2L25.8 326c1.4-4.9 2.9-9.6 4.7-14.5zm-7.9 43l61.9 62.2a31.24 31.24 0 0 0-3.6 14.3v1.1l-55.4-55.7a88.27 88.27 0 0 1-2.9-21.9zm5.3 30.7l54.3 54.6a28.44 28.44 0 0 0 4.2 9.2 106.32 106.32 0 0 1-58.5-63.8zm-5.3-37a80.69 80.69 0 0 1 2.1-17l72.2 72.5a37.59 37.59 0 0 0-9.9 8.7zm253.3-51.8l-42.6-.1-.1 56c-.2 69.3-64.4 115.8-125.7 102.9-5.7 0-19.9-8.7-19.9-24.2a24.89 24.89 0 0 1 24.5-24.6c6.3 0 6.3 1.6 15.7 1.6a55.91 55.91 0 0 0 56.1-55.9l.1-47c0-4.5-4.5-9-8.9-9l-33.6-.1c-32.6-.1-32.5-49.4.1-49.3l42.6.1.1-56a105.18 105.18 0 0 1 105.6-105 86.35 86.35 0 0 1 20.2 2.3c11.2 1.8 19.9 11.9 19.9 24 0 15.5-14.9 27.8-30.3 23.9-27.4-5.9-65.9 14.4-66 54.9l-.1 47a8.94 8.94 0 0 0 8.9 9l33.6.1c32.5.2 32.4 49.5-.2 49.4zm23.5-.3a35.58 35.58 0 0 0 7.6-11.4l8.5 8.5a102 102 0 0 1-16.1 2.9zm21-4.2L308.6 280l.9-8.1a34.74 34.74 0 0 0-2.4-12.5l27 27.2a74.89 74.89 0 0 1-13.7 5.3zm18-7.4l-38-38.4c4.9-1.1 9.6-2.4 13.7-4.7l36.2 35.9c-3.8 2.5-7.9 5-11.9 7.2zm15.5-9.8l-35.3-35.5a61.06 61.06 0 0 0 10.5-8.5l34.9 35a124.56 124.56 0 0 1-10.1 9zm13.2-12.3l-34.9-35a63.18 63.18 0 0 0 7.7-11.4l35.8 35.9a130.28 130.28 0 0 1-8.6 10.5zm11-14.3l-36.4-36.6a48.29 48.29 0 0 0 3.6-15.2l39.5 39.8a87.72 87.72 0 0 1-6.7 12zm13.5-30.9a140.63 140.63 0 0 1-4.7 14.3L345.6 190a58.19 58.19 0 0 0-7.1-26.2zm1-5.6l-71.9-72.1a32 32 0 0 0 9.9-9.2l64.3 64.7a90.93 90.93 0 0 1-2.3 16.6z"
        ],
        "figma": [
            384,
            512,
            [],
            "f799",
            "M14 95.7924C14 42.8877 56.8878 0 109.793 0H274.161C327.066 0 369.954 42.8877 369.954 95.7924C369.954 129.292 352.758 158.776 326.711 175.897C352.758 193.019 369.954 222.502 369.954 256.002C369.954 308.907 327.066 351.795 274.161 351.795H272.081C247.279 351.795 224.678 342.369 207.666 326.904V415.167C207.666 468.777 163.657 512 110.309 512C57.5361 512 14 469.243 14 416.207C14 382.709 31.1945 353.227 57.2392 336.105C31.1945 318.983 14 289.5 14 256.002C14 222.502 31.196 193.019 57.2425 175.897C31.196 158.776 14 129.292 14 95.7924ZM176.288 191.587H109.793C74.2172 191.587 45.3778 220.427 45.3778 256.002C45.3778 291.44 73.9948 320.194 109.381 320.416C109.518 320.415 109.655 320.415 109.793 320.415H176.288V191.587ZM207.666 256.002C207.666 291.577 236.505 320.417 272.081 320.417H274.161C309.737 320.417 338.576 291.577 338.576 256.002C338.576 220.427 309.737 191.587 274.161 191.587H272.081C236.505 191.587 207.666 220.427 207.666 256.002ZM109.793 351.795C109.655 351.795 109.518 351.794 109.381 351.794C73.9948 352.015 45.3778 380.769 45.3778 416.207C45.3778 451.652 74.6025 480.622 110.309 480.622C146.591 480.622 176.288 451.186 176.288 415.167V351.795H109.793ZM109.793 31.3778C74.2172 31.3778 45.3778 60.2173 45.3778 95.7924C45.3778 131.368 74.2172 160.207 109.793 160.207H176.288V31.3778H109.793ZM207.666 160.207H274.161C309.737 160.207 338.576 131.368 338.576 95.7924C338.576 60.2173 309.737 31.3778 274.161 31.3778H207.666V160.207Z"
        ],
        "firefox": [
            512,
            512,
            [],
            "f269",
            "M503.52,241.48c-.12-1.56-.24-3.12-.24-4.68v-.12l-.36-4.68v-.12a245.86,245.86,0,0,0-7.32-41.15c0-.12,0-.12-.12-.24l-1.08-4c-.12-.24-.12-.48-.24-.6-.36-1.2-.72-2.52-1.08-3.72-.12-.24-.12-.6-.24-.84-.36-1.2-.72-2.4-1.08-3.48-.12-.36-.24-.6-.36-1-.36-1.2-.72-2.28-1.2-3.48l-.36-1.08c-.36-1.08-.84-2.28-1.2-3.36a8.27,8.27,0,0,0-.36-1c-.48-1.08-.84-2.28-1.32-3.36-.12-.24-.24-.6-.36-.84-.48-1.2-1-2.28-1.44-3.48,0-.12-.12-.24-.12-.36-1.56-3.84-3.24-7.68-5-11.4l-.36-.72c-.48-1-.84-1.8-1.32-2.64-.24-.48-.48-1.08-.72-1.56-.36-.84-.84-1.56-1.2-2.4-.36-.6-.6-1.2-1-1.8s-.84-1.44-1.2-2.28c-.36-.6-.72-1.32-1.08-1.92s-.84-1.44-1.2-2.16a18.07,18.07,0,0,0-1.2-2c-.36-.72-.84-1.32-1.2-2s-.84-1.32-1.2-2-.84-1.32-1.2-1.92-.84-1.44-1.32-2.16a15.63,15.63,0,0,0-1.2-1.8L463.2,119a15.63,15.63,0,0,0-1.2-1.8c-.48-.72-1.08-1.56-1.56-2.28-.36-.48-.72-1.08-1.08-1.56l-1.8-2.52c-.36-.48-.6-.84-1-1.32-1-1.32-1.8-2.52-2.76-3.72a248.76,248.76,0,0,0-23.51-26.64A186.82,186.82,0,0,0,412,62.46c-4-3.48-8.16-6.72-12.48-9.84a162.49,162.49,0,0,0-24.6-15.12c-2.4-1.32-4.8-2.52-7.2-3.72a254,254,0,0,0-55.43-19.56c-1.92-.36-3.84-.84-5.64-1.2h-.12c-1-.12-1.8-.36-2.76-.48a236.35,236.35,0,0,0-38-4H255.14a234.62,234.62,0,0,0-45.48,5c-33.59,7.08-63.23,21.24-82.91,39-1.08,1-1.92,1.68-2.4,2.16l-.48.48H124l-.12.12.12-.12a.12.12,0,0,0,.12-.12l-.12.12a.42.42,0,0,1,.24-.12c14.64-8.76,34.92-16,49.44-19.56l5.88-1.44c.36-.12.84-.12,1.2-.24,1.68-.36,3.36-.72,5.16-1.08.24,0,.6-.12.84-.12C250.94,20.94,319.34,40.14,367,85.61a171.49,171.49,0,0,1,26.88,32.76c30.36,49.2,27.48,111.11,3.84,147.59-34.44,53-111.35,71.27-159,24.84a84.19,84.19,0,0,1-25.56-59,74.05,74.05,0,0,1,6.24-31c1.68-3.84,13.08-25.67,18.24-24.59-13.08-2.76-37.55,2.64-54.71,28.19-15.36,22.92-14.52,58.2-5,83.28a132.85,132.85,0,0,1-12.12-39.24c-12.24-82.55,43.31-153,94.31-170.51-27.48-24-96.47-22.31-147.71,15.36-29.88,22-51.23,53.16-62.51,90.36,1.68-20.88,9.6-52.08,25.8-83.88-17.16,8.88-39,37-49.8,62.88-15.6,37.43-21,82.19-16.08,124.79.36,3.24.72,6.36,1.08,9.6,19.92,117.11,122,206.38,244.78,206.38C392.77,503.42,504,392.19,504,255,503.88,250.48,503.76,245.92,503.52,241.48Z"
        ],
        "firefox-browser": [
            512,
            512,
            [],
            "e007",
            "M189.37,152.86Zm-58.74-29.37C130.79,123.5,130.71,123.5,130.63,123.49Zm351.42,45.35c-10.61-25.5-32.08-53-48.94-61.73,13.72,26.89,21.67,53.88,24.7,74,0,0,0,.14.05.41-27.58-68.75-74.35-96.47-112.55-156.83-1.93-3.05-3.86-6.11-5.74-9.33-1-1.65-1.86-3.34-2.69-5.05A44.88,44.88,0,0,1,333.24.69a.63.63,0,0,0-.55-.66.9.9,0,0,0-.46,0l-.12.07-.18.1.1-.14c-54.23,31.77-76.72,87.38-82.5,122.78a130,130,0,0,0-48.33,12.33,6.25,6.25,0,0,0-3.09,7.75,6.13,6.13,0,0,0,7.79,3.79l.52-.21a117.84,117.84,0,0,1,42.11-11l1.42-.1c2-.12,4-.2,6-.22A122.61,122.61,0,0,1,291,140c.67.2,1.32.42,2,.63,1.89.57,3.76,1.2,5.62,1.87,1.36.5,2.71,1,4.05,1.58,1.09.44,2.18.88,3.25,1.35q2.52,1.13,5,2.35c.75.37,1.5.74,2.25,1.13q2.4,1.26,4.74,2.63,1.51.87,3,1.8a124.89,124.89,0,0,1,42.66,44.13c-13-9.15-36.35-18.19-58.82-14.28,87.74,43.86,64.18,194.9-57.39,189.2a108.43,108.43,0,0,1-31.74-6.12c-2.42-.91-4.8-1.89-7.16-2.93-1.38-.63-2.76-1.27-4.12-2C174.5,346,149.9,316.92,146.83,281.59c0,0,11.25-41.95,80.62-41.95,7.5,0,28.93-20.92,29.33-27-.09-2-42.54-18.87-59.09-35.18-8.85-8.71-13.05-12.91-16.77-16.06a69.58,69.58,0,0,0-6.31-4.77A113.05,113.05,0,0,1,173.92,97c-25.06,11.41-44.55,29.45-58.71,45.37h-.12c-9.67-12.25-9-52.65-8.43-61.08-.12-.53-7.22,3.68-8.15,4.31a178.54,178.54,0,0,0-23.84,20.43A214,214,0,0,0,51.9,133.36l0,0a.08.08,0,0,1,0,0,205.84,205.84,0,0,0-32.73,73.9c-.06.27-2.33,10.21-4,22.48q-.42,2.87-.78,5.74c-.57,3.69-1,7.71-1.44,14,0,.24,0,.48-.05.72-.18,2.71-.34,5.41-.49,8.12,0,.41,0,.82,0,1.24,0,134.7,109.21,243.89,243.92,243.89,120.64,0,220.82-87.58,240.43-202.62.41-3.12.74-6.26,1.11-9.41,4.85-41.83-.54-85.79-15.82-122.55Z"
        ],
        "first-order": [
            448,
            512,
            [],
            "f2b0",
            "M12.9 229.2c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4h-.2zM224 96.6c-7.1 0-14.6.6-21.4 1.7l3.7 67.4-22-64c-14.3 3.7-27.7 9.4-40 16.6l29.4 61.4-45.1-50.9c-11.4 8.9-21.7 19.1-30.6 30.9l50.6 45.4-61.1-29.7c-7.1 12.3-12.9 25.7-16.6 40l64.3 22.6-68-4c-.9 7.1-1.4 14.6-1.4 22s.6 14.6 1.4 21.7l67.7-4-64 22.6c3.7 14.3 9.4 27.7 16.6 40.3l61.1-29.7L97.7 352c8.9 11.7 19.1 22.3 30.9 30.9l44.9-50.9-29.5 61.4c12.3 7.4 25.7 13.1 40 16.9l22.3-64.6-4 68c7.1 1.1 14.6 1.7 21.7 1.7 7.4 0 14.6-.6 21.7-1.7l-4-68.6 22.6 65.1c14.3-4 27.7-9.4 40-16.9L274.9 332l44.9 50.9c11.7-8.9 22-19.1 30.6-30.9l-50.6-45.1 61.1 29.4c7.1-12.3 12.9-25.7 16.6-40.3l-64-22.3 67.4 4c1.1-7.1 1.4-14.3 1.4-21.7s-.3-14.9-1.4-22l-67.7 4 64-22.3c-3.7-14.3-9.1-28-16.6-40.3l-60.9 29.7 50.6-45.4c-8.9-11.7-19.1-22-30.6-30.9l-45.1 50.9 29.4-61.1c-12.3-7.4-25.7-13.1-40-16.9L241.7 166l4-67.7c-7.1-1.2-14.3-1.7-21.7-1.7zM443.4 128v256L224 512 4.6 384V128L224 0l219.4 128zm-17.1 10.3L224 20.9 21.7 138.3v235.1L224 491.1l202.3-117.7V138.3zM224 37.1l187.7 109.4v218.9L224 474.9 36.3 365.4V146.6L224 37.1zm0 50.9c-92.3 0-166.9 75.1-166.9 168 0 92.6 74.6 167.7 166.9 167.7 92 0 166.9-75.1 166.9-167.7 0-92.9-74.9-168-166.9-168z"
        ],
        "first-order-alt": [
            496,
            512,
            [],
            "f50a",
            "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm0 488.21C115.34 496.21 7.79 388.66 7.79 256S115.34 15.79 248 15.79 488.21 123.34 488.21 256 380.66 496.21 248 496.21zm0-459.92C126.66 36.29 28.29 134.66 28.29 256S126.66 475.71 248 475.71 467.71 377.34 467.71 256 369.34 36.29 248 36.29zm0 431.22c-116.81 0-211.51-94.69-211.51-211.51S131.19 44.49 248 44.49 459.51 139.19 459.51 256 364.81 467.51 248 467.51zm186.23-162.98a191.613 191.613 0 0 1-20.13 48.69l-74.13-35.88 61.48 54.82a193.515 193.515 0 0 1-37.2 37.29l-54.8-61.57 35.88 74.27a190.944 190.944 0 0 1-48.63 20.23l-27.29-78.47 4.79 82.93c-8.61 1.18-17.4 1.8-26.33 1.8s-17.72-.62-26.33-1.8l4.76-82.46-27.15 78.03a191.365 191.365 0 0 1-48.65-20.2l35.93-74.34-54.87 61.64a193.85 193.85 0 0 1-37.22-37.28l61.59-54.9-74.26 35.93a191.638 191.638 0 0 1-20.14-48.69l77.84-27.11-82.23 4.76c-1.16-8.57-1.78-17.32-1.78-26.21 0-9 .63-17.84 1.82-26.51l82.38 4.77-77.94-27.16a191.726 191.726 0 0 1 20.23-48.67l74.22 35.92-61.52-54.86a193.85 193.85 0 0 1 37.28-37.22l54.76 61.53-35.83-74.17a191.49 191.49 0 0 1 48.65-20.13l26.87 77.25-4.71-81.61c8.61-1.18 17.39-1.8 26.32-1.8s17.71.62 26.32 1.8l-4.74 82.16 27.05-77.76c17.27 4.5 33.6 11.35 48.63 20.17l-35.82 74.12 54.72-61.47a193.13 193.13 0 0 1 37.24 37.23l-61.45 54.77 74.12-35.86a191.515 191.515 0 0 1 20.2 48.65l-77.81 27.1 82.24-4.75c1.19 8.66 1.82 17.5 1.82 26.49 0 8.88-.61 17.63-1.78 26.19l-82.12-4.75 77.72 27.09z"
        ],
        "firstdraft": [
            384,
            512,
            [],
            "f3a1",
            "M384 192h-64v128H192v128H0v-25.6h166.4v-128h128v-128H384V192zm-25.6 38.4v128h-128v128H64V512h192V384h128V230.4h-25.6zm25.6 192h-89.6V512H320v-64h64v-25.6zM0 0v384h128V256h128V128h128V0H0z"
        ],
        "flickr": [
            448,
            512,
            [],
            "f16e",
            "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM144.5 319c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5zm159 0c-35.1 0-63.5-28.4-63.5-63.5s28.4-63.5 63.5-63.5 63.5 28.4 63.5 63.5-28.4 63.5-63.5 63.5z"
        ],
        "flipboard": [
            448,
            512,
            [],
            "f44d",
            "M0 32v448h448V32H0zm358.4 179.2h-89.6v89.6h-89.6v89.6H89.6V121.6h268.8v89.6z"
        ],
        "fly": [
            384,
            512,
            [],
            "f417",
            "M197.8 427.8c12.9 11.7 33.7 33.3 33.2 50.7 0 .8-.1 1.6-.1 2.5-1.8 19.8-18.8 31.1-39.1 31-25-.1-39.9-16.8-38.7-35.8 1-16.2 20.5-36.7 32.4-47.6 2.3-2.1 2.7-2.7 5.6-3.6 3.4 0 3.9.3 6.7 2.8zM331.9 67.3c-16.3-25.7-38.6-40.6-63.3-52.1C243.1 4.5 214-.2 192 0c-44.1 0-71.2 13.2-81.1 17.3C57.3 45.2 26.5 87.2 28 158.6c7.1 82.2 97 176 155.8 233.8 1.7 1.6 4.5 4.5 6.2 5.1l3.3.1c2.1-.7 1.8-.5 3.5-2.1 52.3-49.2 140.7-145.8 155.9-215.7 7-39.2 3.1-72.5-20.8-112.5zM186.8 351.9c-28-51.1-65.2-130.7-69.3-189-3.4-47.5 11.4-131.2 69.3-136.7v325.7zM328.7 180c-16.4 56.8-77.3 128-118.9 170.3C237.6 298.4 275 217 277 158.4c1.6-45.9-9.8-105.8-48-131.4 88.8 18.3 115.5 98.1 99.7 153z"
        ],
        "font-awesome": [
            448,
            512,
            [],
            "f2b4",
            "M400 32H48A48 48 0 0 0 0 80V432a48 48 0 0 0 48 48H400a48 48 0 0 0 48-48V80A48 48 0 0 0 400 32ZM336 312c-31.6 11.2-41.2 16-59.8 16-31.4 0-43.2-16-74.6-16a80 80 0 0 0-25.6 4V284a85.9 85.9 0 0 1 25.6-4c31.2 0 43.2 16 74.6 16 10.2 0 17.8-1.4 27.8-4.6v-96c-10 3.2-17.6 4.6-27.8 4.6-31.4 0-43.2-16-74.6-16-25.4 0-37.4 10.4-57.6 14.4V352a16 16 0 0 1-32 0V160a16 16 0 0 1 32 0v6.4c20.2-4 32.2-14.4 57.6-14.4 31.2 0 43.2 16 74.6 16 18.6 0 28.2-4.8 59.8-16Z"
        ],
        "font-awesome-alt": [
            448,
            512,
            [],
            "f35c",
            "M400 32H48A48 48 0 0 0 0 80V432a48 48 0 0 0 48 48H400a48 48 0 0 0 48-48V80A48 48 0 0 0 400 32Zm16 400a16 16 0 0 1-16 16H48a16 16 0 0 1-16-16V80A16 16 0 0 1 48 64H400a16 16 0 0 1 16 16ZM201.6 152c-25.4 0-37.4 10.4-57.6 14.4V160a16 16 0 0 0-32 0V352a16 16 0 0 0 32 0V198.4c20.2-4 32.2-14.4 57.6-14.4 31.4 0 43.2 16 74.6 16 10.2 0 17.8-1.4 27.8-4.6v96c-10 3.2-17.6 4.6-27.8 4.6-31.4 0-43.4-16-74.6-16a85.9 85.9 0 0 0-25.6 4v32a80 80 0 0 1 25.6-4c31.4 0 43.2 16 74.6 16 18.6 0 28.2-4.8 59.8-16V152c-31.6 11.2-41.2 16-59.8 16C244.8 168 232.8 152 201.6 152Z"
        ],
        "font-awesome-flag": [
            448,
            512,
            [],
            "f425",
            "M448 48V384c-63 23-82 32-119 32-63 0-87-32-150-32-20 0-36 4-51 8V328c15-4 31-8 51-8 63 0 87 32 150 32 20 0 35-3 55-9V135c-20 6-35 9-55 9-63 0-87-32-150-32-51 0-75 21-115 29V448a31.6 31.6 0 0 1-32 32A31.6 31.6 0 0 1 0 448V64A31.6 31.6 0 0 1 32 32 31.6 31.6 0 0 1 64 64V77c40-8 64-29 115-29 63 0 87 32 150 32C366 80 385 71 448 48Z"
        ],
        "font-awesome-logo-full": [
            3992,
            512,
            [
                "Font Awesome"
            ],
            "f4e6",
            "M1209.7 156.5c-57.8 0-102 43.9-102 99.1 0 56 44.6 99.1 102 99.1 57.4 0 102-43.1 102-99.1C1311.7 200.4 1267.5 156.5 1209.7 156.5Zm0 152.7c-35.1 0-51.8-27.4-51.8-53.2 0-25.8 16.7-53.2 51.8-53.2 35.1 0 51.8 27.8 51.8 53.2C1261.1 281.8 1244.8 309.2 1209.7 309.2Zm962.1-136.1c-4.4-10.9-12.3-16.5-23.5-16.5s-19.1 5.6-23.5 16.5l-59.4 145.8c-7.2 17.7 2.8 27.4 4.4 29a24.6 24.6 0 0 0 17.5 6.8c10.8 0 18.7-6 23.1-18.1l4-10.1h67.7l4 10.1c4.8 12.1 12.3 18.1 23.1 18.1a24.6 24.6 0 0 0 17.5-6.8c10-10.1 6.8-22.6 4.4-29Zm-43 113.6 19.1-56 19.1 56Zm-574.5-130.1c-14.3 0-24.7 10.9-24.7 25.4v76.5l-68.5-85.8c-4.4-5.6-11.6-16.1-25.5-16.1-19.1 0-24.3 17.7-24.3 25.4V329.7c0 14.1 10.4 25.4 24.7 25.4 14.3 0 24.7-10.9 24.7-25.4V252.8l68.9 86.2c4.8 5.6 11.6 16.1 25.5 16.1 19.1 0 23.9-17.3 23.9-25.4V181.9C1579 167.4 1568.6 156.5 1554.3 156.5Zm-554.1 1.6H916.5c-19.9 0-25.1 17.3-25.1 25.4V328.1c0 19.7 16.7 25.4 24.7 25.4 8 0 24.7-5.2 24.7-25.4V285h44.6c12.8 0 22.7-9.3 22.7-22.6 0-17.7-15.5-22.1-22.7-22.1H940.8V203.6h59.4c12.8 0 22.7-9.3 22.7-22.6C1022.9 163 1007.3 158.1 1000.2 158.1Zm815.1 0H1691.7c-7.2 0-22.7 4.4-22.7 22.2 0 13.3 10 22.6 22.7 22.6h37V327.7c0 14.1 10.4 25.4 24.7 25.4 14.3 0 24.7-10.9 24.7-25.4V202.8h37c12.7 0 22.7-9.3 22.7-22.6C1837.9 163 1822.4 158.1 1815.2 158.1Zm1789.5-1.6c-9.6 0-17.5 6-25.1 18.1l-46.6 76.1L3486.4 174.6q-10.8-18.1-25.1-18.1c-19.5 0-24.7 18.1-24.7 25.8V329.7c0 14.1 10.4 25.4 24.7 25.4s24.7-10.9 24.7-25.4V262.8L3510.7 302.7c6.4 10.1 13.9 15.3 22.3 15.3 8.8 0 15.9-5.2 22.3-15.3l24.7-39.9v66.9c0 14.1 10.3 25.4 24.7 25.4 14.3 0 24.7-10.9 24.7-25.4V182.3C3629.4 174.2 3624.6 156.5 3604.7 156.5Zm248.6 149.8h-65.7V272.9h39.4c11.9 0 21.1-8.9 21.1-20.9 0-12.1-9.2-20.9-21.1-20.9h-39.4V204.8h62.1c12.8 0 22.7-9.3 22.7-22.6 0-17.7-15.6-22.2-22.7-22.2h-86.4c-19.9 0-25.1 17.3-25.1 25.4V326.5c0 8.1 5.2 25.4 25.1 25.4h90c12.8 0 22.7-9.3 22.7-22.6C3876 311.2 3860.5 306.3 3853.3 306.3ZM3235 156.5c-57.8 0-102 43.9-102 99.1 0 56 44.6 99.1 102 99.1 57.4 0 102-43.1 102-99.1C3337 200.4 3292.8 156.5 3235 156.5Zm0 152.7c-35.1 0-51.8-27.4-51.8-53.2 0-25.8 16.7-53.2 51.8-53.2 35.1 0 51.8 27.8 51.8 53.2C3286.8 281.8 3270.1 309.2 3235 309.2ZM2550.2 156.5c-11.2 0-19.1 5.6-23.1 16.5l-34.3 94.7-31.5-92.2c-4.4-12.5-12.3-18.9-24.3-18.9-11.9 0-19.9 6.4-24.3 18.9l-31.5 92.2-34.3-95.5q-5.4-15.7-22.7-15.7c-6.8 0-12.3 2.4-17.5 7.3-5.2 5.2-10.8 14.5-4.8 28.6l55.8 145.8c4 11.3 11.6 16.9 23.1 16.9q16.7 0 22.7-16.9l33.5-91.8 33.5 91.8q6 16.9 22.7 16.9c11.2 0 19.1-5.6 23.1-16.9l55.8-145.8c3.6-9.3 4.4-19.3-4.8-28.6A23 23 0 0 0 2550.2 156.5Zm444.2 81-21.9-9.3c-11.9-4.8-16.3-8.5-16.3-15.7q0-12.1 16.7-12.1c12.7 0 19.5 7.7 24.3 10.9 7.2 5.2 18.3 6.8 27.9-2 10.8-10.5 6.8-23.8 1.2-30.6-12.3-14.9-30.3-22.2-53.8-22.2-19.1 0-35.1 5.2-47.4 15.7-12.3 10.5-18.7 24.2-18.7 41.1 0 24.2 15.9 43.5 47.8 57.6l19.5 8.9c15.9 6.8 19.1 9.7 19.1 17.7 0 9.3-6.4 14.1-19.5 14.1-19.1 0-34.7-14.9-36.3-16.1-10.8-7.3-21.5-2-26.3 2.8-6.8 6.4-12.7 20.9 3.2 36.2 6.8 6.4 15.5 11.7 26.7 15.3a94.6 94.6 0 0 0 32.7 5.6c19.9 0 36.7-5.2 49.8-16.1 13.1-10.9 19.5-25.4 19.5-43.5q0-20.5-12-33.8C3022.7 253.2 3010.7 244.3 2994.4 237.5Zm-206.4 68.9h-65.7V272.9h39.4c12 0 21.1-8.9 21.1-20.9 0-12.1-9.2-20.9-21.1-20.9h-39.4V204.8h62.1c12.8 0 22.7-9.3 22.7-22.6 0-17.7-15.5-22.2-22.7-22.2h-86.4c-19.9 0-25.1 17.3-25.1 25.4V326.5c0 8.1 5.2 25.4 25.1 25.4h90c12.7 0 22.7-9.3 22.7-22.6C2810.8 311.2 2795.2 306.3 2788 306.3ZM178.3 49.1c-50.5 0-74.4 20.7-114.6 28.7V65A31.8 31.8 0 1 0 0 65V447a31.8 31.8 0 0 0 63.7 0V141.4c40.2-8 64.1-28.7 114.6-28.7 62.5 0 86 31.8 148.4 31.8 20.3 0 35.4-2.8 55.3-9.2v191c-19.9 6.4-35 9.2-55.3 9.2-62.5 0-86.4-31.8-148.4-31.8-20.3 0-36.2 3.6-50.9 8V375.4a159.1 159.1 0 0 1 50.9-8c62.5 0 86 31.8 148.4 31.8 37 0 56.1-9.6 119-31.8V49.1C382.8 71.4 363.7 80.9 326.7 80.9 264.2 80.9 240.4 49.1 178.3 49.1Z"
        ],
        "fonticons": [
            448,
            512,
            [],
            "f280",
            "M0 32v448h448V32zm187 140.9c-18.4 0-19 9.9-19 27.4v23.3c0 2.4-3.5 4.4-.6 4.4h67.4l-11.1 37.3H168v112.9c0 5.8-2 6.7 3.2 7.3l43.5 4.1v25.1H84V389l21.3-2c5.2-.6 6.7-2.3 6.7-7.9V267.7c0-2.3-2.9-2.3-5.8-2.3H84V228h28v-21c0-49.6 26.5-70 77.3-70 34.1 0 64.7 8.2 64.7 52.8l-50.7 6.1c.3-18.7-4.4-23-16.3-23zm74.3 241.8v-25.1l20.4-2.6c5.2-.6 7.6-1.7 7.6-7.3V271.8c0-4.1-2.9-6.7-6.7-7.9l-24.2-6.4 6.7-29.5h80.2v151.7c0 5.8-2.6 6.4 2.9 7.3l15.7 2.6v25.1zm80.8-255.5l9 33.2-7.3 7.3-31.2-16.6-31.2 16.6-7.3-7.3 9-33.2-21.8-24.2 3.5-9.6h27.7l15.5-28h9.3l15.5 28h27.7l3.5 9.6z"
        ],
        "fonticons-fi": [
            384,
            512,
            [],
            "f3a2",
            "M114.4 224h92.4l-15.2 51.2h-76.4V433c0 8-2.8 9.2 4.4 10l59.6 5.6V483H0v-35.2l29.2-2.8c7.2-.8 9.2-3.2 9.2-10.8V278.4c0-3.2-4-3.2-8-3.2H0V224h38.4v-28.8c0-68 36.4-96 106-96 46.8 0 88.8 11.2 88.8 72.4l-69.6 8.4c.4-25.6-6-31.6-22.4-31.6-25.2 0-26 13.6-26 37.6v32c0 3.2-4.8 6-.8 6zM384 483H243.2v-34.4l28-3.6c7.2-.8 10.4-2.4 10.4-10V287c0-5.6-4-9.2-9.2-10.8l-33.2-8.8 9.2-40.4h110v208c0 8-3.6 8.8 4 10l21.6 3.6V483zm-30-347.2l12.4 45.6-10 10-42.8-22.8-42.8 22.8-10-10 12.4-45.6-30-36.4 4.8-10h38L307.2 51H320l21.2 38.4h38l4.8 13.2-30 33.2z"
        ],
        "fort-awesome": [
            512,
            512,
            [],
            "f286",
            "M489.2 287.9h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6V146.2c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6v-32c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32h-36.6v-32c0-6-8-4.6-11.7-4.6v-38c8.3-2 17.1-3.4 25.7-3.4 10.9 0 20.9 4.3 31.4 4.3 4.6 0 27.7-1.1 27.7-8v-60c0-2.6-2-4.6-4.6-4.6-5.1 0-15.1 4.3-24 4.3-9.7 0-20.9-4.3-32.6-4.3-8 0-16 1.1-23.7 2.9v-4.9c5.4-2.6 9.1-8.3 9.1-14.3 0-20.7-31.4-20.8-31.4 0 0 6 3.7 11.7 9.1 14.3v111.7c-3.7 0-11.7-1.4-11.7 4.6v32h-36.6v-32c0-2.6-2-4.6-4.6-4.6h-27.4c-2.6 0-4.6 2-4.6 4.6v32H128v-32c0-2.6-2-4.6-4.6-4.6H96c-2.6 0-4.6 2-4.6 4.6v178.3H54.8v-32c0-2.6-2-4.6-4.6-4.6H22.8c-2.6 0-4.6 2-4.6 4.6V512h182.9v-96c0-72.6 109.7-72.6 109.7 0v96h182.9V292.5c.1-2.6-1.9-4.6-4.5-4.6zm-288.1-4.5c0 2.6-2 4.6-4.6 4.6h-27.4c-2.6 0-4.6-2-4.6-4.6v-64c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v64zm146.4 0c0 2.6-2 4.6-4.6 4.6h-27.4c-2.6 0-4.6-2-4.6-4.6v-64c0-2.6 2-4.6 4.6-4.6h27.4c2.6 0 4.6 2 4.6 4.6v64z"
        ],
        "fort-awesome-alt": [
            512,
            512,
            [],
            "f3a3",
            "M208 237.4h-22.2c-2.1 0-3.7 1.6-3.7 3.7v51.7c0 2.1 1.6 3.7 3.7 3.7H208c2.1 0 3.7-1.6 3.7-3.7v-51.7c0-2.1-1.6-3.7-3.7-3.7zm118.2 0H304c-2.1 0-3.7 1.6-3.7 3.7v51.7c0 2.1 1.6 3.7 3.7 3.7h22.2c2.1 0 3.7-1.6 3.7-3.7v-51.7c-.1-2.1-1.7-3.7-3.7-3.7zm132-125.1c-2.3-3.2-4.6-6.4-7.1-9.5-9.8-12.5-20.8-24-32.8-34.4-4.5-3.9-9.1-7.6-13.9-11.2-1.6-1.2-3.2-2.3-4.8-3.5C372 34.1 340.3 20 306 13c-16.2-3.3-32.9-5-50-5s-33.9 1.7-50 5c-34.3 7.1-66 21.2-93.3 40.8-1.6 1.1-3.2 2.3-4.8 3.5-4.8 3.6-9.4 7.3-13.9 11.2-3 2.6-5.9 5.3-8.8 8s-5.7 5.5-8.4 8.4c-5.5 5.7-10.7 11.8-15.6 18-2.4 3.1-4.8 6.3-7.1 9.5C25.2 153 8.3 202.5 8.3 256c0 2 .1 4 .1 6 .1.7.1 1.3.1 2 .1 1.3.1 2.7.2 4 0 .8.1 1.5.1 2.3 0 1.3.1 2.5.2 3.7.1.8.1 1.6.2 2.4.1 1.1.2 2.3.3 3.5 0 .8.1 1.6.2 2.4.1 1.2.3 2.4.4 3.6.1.8.2 1.5.3 2.3.1 1.3.3 2.6.5 3.9.1.6.2 1.3.3 1.9l.9 5.7c.1.6.2 1.1.3 1.7.3 1.3.5 2.7.8 4 .2.8.3 1.6.5 2.4.2 1 .5 2.1.7 3.2.2.9.4 1.7.6 2.6.2 1 .4 2 .7 3 .2.9.5 1.8.7 2.7.3 1 .5 1.9.8 2.9.3.9.5 1.8.8 2.7.2.9.5 1.9.8 2.8s.5 1.8.8 2.7c.3 1 .6 1.9.9 2.8.6 1.6 1.1 3.3 1.7 4.9.4 1 .7 1.9 1 2.8.3 1 .7 2 1.1 3 .3.8.6 1.5.9 2.3l1.2 3c.3.7.6 1.5.9 2.2.4 1 .9 2 1.3 3l.9 2.1c.5 1 .9 2 1.4 3 .3.7.6 1.3.9 2 .5 1 1 2.1 1.5 3.1.2.6.5 1.1.8 1.7.6 1.1 1.1 2.2 1.7 3.3.1.2.2.3.3.5 2.2 4.1 4.4 8.2 6.8 12.2.2.4.5.8.7 1.2.7 1.1 1.3 2.2 2 3.3.3.5.6.9.9 1.4.6 1.1 1.3 2.1 2 3.2.3.5.6.9.9 1.4.7 1.1 1.4 2.1 2.1 3.2.2.4.5.8.8 1.2.7 1.1 1.5 2.2 2.3 3.3.2.2.3.5.5.7 37.5 51.7 94.4 88.5 160 99.4.9.1 1.7.3 2.6.4 1 .2 2.1.4 3.1.5s1.9.3 2.8.4c1 .2 2 .3 3 .4.9.1 1.9.2 2.9.3s1.9.2 2.9.3 2.1.2 3.1.3c.9.1 1.8.1 2.7.2 1.1.1 2.3.1 3.4.2.8 0 1.7.1 2.5.1 1.3 0 2.6.1 3.9.1.7.1 1.4.1 2.1.1 2 .1 4 .1 6 .1s4-.1 6-.1c.7 0 1.4-.1 2.1-.1 1.3 0 2.6 0 3.9-.1.8 0 1.7-.1 2.5-.1 1.1-.1 2.3-.1 3.4-.2.9 0 1.8-.1 2.7-.2 1-.1 2.1-.2 3.1-.3s1.9-.2 2.9-.3c.9-.1 1.9-.2 2.9-.3s2-.3 3-.4 1.9-.3 2.8-.4c1-.2 2.1-.3 3.1-.5.9-.1 1.7-.3 2.6-.4 65.6-11 122.5-47.7 160.1-102.4.2-.2.3-.5.5-.7.8-1.1 1.5-2.2 2.3-3.3.2-.4.5-.8.8-1.2.7-1.1 1.4-2.1 2.1-3.2.3-.5.6-.9.9-1.4.6-1.1 1.3-2.1 2-3.2.3-.5.6-.9.9-1.4.7-1.1 1.3-2.2 2-3.3.2-.4.5-.8.7-1.2 2.4-4 4.6-8.1 6.8-12.2.1-.2.2-.3.3-.5.6-1.1 1.1-2.2 1.7-3.3.2-.6.5-1.1.8-1.7.5-1 1-2.1 1.5-3.1.3-.7.6-1.3.9-2 .5-1 1-2 1.4-3l.9-2.1c.5-1 .9-2 1.3-3 .3-.7.6-1.5.9-2.2l1.2-3c.3-.8.6-1.5.9-2.3.4-1 .7-2 1.1-3s.7-1.9 1-2.8c.6-1.6 1.2-3.3 1.7-4.9.3-1 .6-1.9.9-2.8s.5-1.8.8-2.7c.2-.9.5-1.9.8-2.8s.6-1.8.8-2.7c.3-1 .5-1.9.8-2.9.2-.9.5-1.8.7-2.7.2-1 .5-2 .7-3 .2-.9.4-1.7.6-2.6.2-1 .5-2.1.7-3.2.2-.8.3-1.6.5-2.4.3-1.3.6-2.7.8-4 .1-.6.2-1.1.3-1.7l.9-5.7c.1-.6.2-1.3.3-1.9.1-1.3.3-2.6.5-3.9.1-.8.2-1.5.3-2.3.1-1.2.3-2.4.4-3.6 0-.8.1-1.6.2-2.4.1-1.1.2-2.3.3-3.5.1-.8.1-1.6.2-2.4.1 1.7.1.5.2-.7 0-.8.1-1.5.1-2.3.1-1.3.2-2.7.2-4 .1-.7.1-1.3.1-2 .1-2 .1-4 .1-6 0-53.5-16.9-103-45.8-143.7zM448 371.5c-9.4 15.5-20.6 29.9-33.6 42.9-20.6 20.6-44.5 36.7-71.2 48-13.9 5.8-28.2 10.3-42.9 13.2v-75.8c0-58.6-88.6-58.6-88.6 0v75.8c-14.7-2.9-29-7.3-42.9-13.2-26.7-11.3-50.6-27.4-71.2-48-13-13-24.2-27.4-33.6-42.9v-71.3c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7V326h29.6V182c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7H208c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-4.8 6.5-3.7 9.5-3.7V88.1c-4.4-2-7.4-6.7-7.4-11.5 0-16.8 25.4-16.8 25.4 0 0 4.8-3 9.4-7.4 11.5V92c6.3-1.4 12.7-2.3 19.2-2.3 9.4 0 18.4 3.5 26.3 3.5 7.2 0 15.2-3.5 19.4-3.5 2.1 0 3.7 1.6 3.7 3.7v48.4c0 5.6-18.7 6.5-22.4 6.5-8.6 0-16.6-3.5-25.4-3.5-7 0-14.1 1.2-20.8 2.8v30.7c3 0 9.5-1.1 9.5 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7h22.2c2.1 0 3.7 1.6 3.7 3.7v25.9h29.5V182c0-2.1 1.6-3.7 3.7-3.7h22.1c2.1 0 3.7 1.6 3.7 3.7v144h29.5v-25.8c0-2.1 1.6-3.7 3.7-3.7h22.2c2.1 0 3.7 1.6 3.7 3.7z"
        ],
        "forumbee": [
            448,
            512,
            [],
            "f211",
            "M5.8 309.7C2 292.7 0 275.5 0 258.3 0 135 99.8 35 223.1 35c16.6 0 33.3 2 49.3 5.5C149 87.5 51.9 186 5.8 309.7zm392.9-189.2C385 103 369 87.8 350.9 75.2c-149.6 44.3-266.3 162.1-309.7 312 12.5 18.1 28 35.6 45.2 49 43.1-151.3 161.2-271.7 312.3-315.7zm15.8 252.7c15.2-25.1 25.4-53.7 29.5-82.8-79.4 42.9-145 110.6-187.6 190.3 30-4.4 58.9-15.3 84.6-31.3 35 13.1 70.9 24.3 107 33.6-9.3-36.5-20.4-74.5-33.5-109.8zm29.7-145.5c-2.6-19.5-7.9-38.7-15.8-56.8C290.5 216.7 182 327.5 137.1 466c18.1 7.6 37 12.5 56.6 15.2C240 367.1 330.5 274.4 444.2 227.7z"
        ],
        "foursquare": [
            368,
            512,
            [],
            "f180",
            "M323.1 3H49.9C12.4 3 0 31.3 0 49.1v433.8c0 20.3 12.1 27.7 18.2 30.1 6.2 2.5 22.8 4.6 32.9-7.1C180 356.5 182.2 354 182.2 354c3.1-3.4 3.4-3.1 6.8-3.1h83.4c35.1 0 40.6-25.2 44.3-39.7l48.6-243C373.8 25.8 363.1 3 323.1 3zm-16.3 73.8l-11.4 59.7c-1.2 6.5-9.5 13.2-16.9 13.2H172.1c-12 0-20.6 8.3-20.6 20.3v13c0 12 8.6 20.6 20.6 20.6h90.4c8.3 0 16.6 9.2 14.8 18.2-1.8 8.9-10.5 53.8-11.4 58.8-.9 4.9-6.8 13.5-16.9 13.5h-73.5c-13.5 0-17.2 1.8-26.5 12.6 0 0-8.9 11.4-89.5 108.3-.9.9-1.8.6-1.8-.3V75.9c0-7.7 6.8-16.6 16.6-16.6h219c8.2 0 15.6 7.7 13.5 17.5z"
        ],
        "free-code-camp": [
            576,
            512,
            [],
            "f2c5",
            "M97.22,96.21c10.36-10.65,16-17.12,16-21.9,0-2.76-1.92-5.51-3.83-7.42A14.81,14.81,0,0,0,101,64.05c-8.48,0-20.92,8.79-35.84,25.69C23.68,137,2.51,182.81,3.37,250.34s17.47,117,54.06,161.87C76.22,435.86,90.62,448,100.9,448a13.55,13.55,0,0,0,8.37-3.84c1.91-2.76,3.81-5.63,3.81-8.38,0-5.63-3.86-12.2-13.2-20.55-44.45-42.33-67.32-97-67.48-165C32.25,188.8,54,137.83,97.22,96.21ZM239.47,420.07c.58.37.91.55.91.55Zm93.79.55.17-.13C333.24,420.62,333.17,420.67,333.26,420.62Zm3.13-158.18c-16.24-4.15,50.41-82.89-68.05-177.17,0,0,15.54,49.38-62.83,159.57-74.27,104.35,23.46,168.73,34,175.23-6.73-4.35-47.4-35.7,9.55-128.64,11-18.3,25.53-34.87,43.5-72.16,0,0,15.91,22.45,7.6,71.13C287.7,364,354,342.91,355,343.94c22.75,26.78-17.72,73.51-21.58,76.55,5.49-3.65,117.71-78,33-188.1C360.43,238.4,352.62,266.59,336.39,262.44ZM510.88,89.69C496,72.79,483.52,64,475,64a14.81,14.81,0,0,0-8.39,2.84c-1.91,1.91-3.83,4.66-3.83,7.42,0,4.78,5.6,11.26,16,21.9,43.23,41.61,65,92.59,64.82,154.06-.16,68-23,122.63-67.48,165-9.34,8.35-13.18,14.92-13.2,20.55,0,2.75,1.9,5.62,3.81,8.38A13.61,13.61,0,0,0,475.1,448c10.28,0,24.68-12.13,43.47-35.79,36.59-44.85,53.14-94.38,54.06-161.87S552.32,137,510.88,89.69Z"
        ],
        "freebsd": [
            448,
            512,
            [],
            "f3a4",
            "M303.7 96.2c11.1-11.1 115.5-77 139.2-53.2 23.7 23.7-42.1 128.1-53.2 139.2-11.1 11.1-39.4.9-63.1-22.9-23.8-23.7-34.1-52-22.9-63.1zM109.9 68.1C73.6 47.5 22 24.6 5.6 41.1c-16.6 16.6 7.1 69.4 27.9 105.7 18.5-32.2 44.8-59.3 76.4-78.7zM406.7 174c3.3 11.3 2.7 20.7-2.7 26.1-20.3 20.3-87.5-27-109.3-70.1-18-32.3-11.1-53.4 14.9-48.7 5.7-3.6 12.3-7.6 19.6-11.6-29.8-15.5-63.6-24.3-99.5-24.3-119.1 0-215.6 96.5-215.6 215.6 0 119 96.5 215.6 215.6 215.6S445.3 380.1 445.3 261c0-38.4-10.1-74.5-27.7-105.8-3.9 7-7.6 13.3-10.9 18.8z"
        ],
        "fulcrum": [
            320,
            512,
            [],
            "f50b",
            "M95.75 164.14l-35.38 43.55L25 164.14l35.38-43.55zM144.23 0l-20.54 198.18L72.72 256l51 57.82L144.23 512V300.89L103.15 256l41.08-44.89zm79.67 164.14l35.38 43.55 35.38-43.55-35.38-43.55zm-48.48 47L216.5 256l-41.08 44.89V512L196 313.82 247 256l-51-57.82L175.42 0z"
        ],
        "galactic-republic": [
            496,
            512,
            [],
            "f50c",
            "M248 504C111.25 504 0 392.75 0 256S111.25 8 248 8s248 111.25 248 248-111.25 248-248 248zm0-479.47C120.37 24.53 16.53 128.37 16.53 256S120.37 487.47 248 487.47 479.47 383.63 479.47 256 375.63 24.53 248 24.53zm27.62 21.81v24.62a185.933 185.933 0 0 1 83.57 34.54l17.39-17.36c-28.75-22.06-63.3-36.89-100.96-41.8zm-55.37.07c-37.64 4.94-72.16 19.8-100.88 41.85l17.28 17.36h.08c24.07-17.84 52.55-30.06 83.52-34.67V46.41zm12.25 50.17v82.87c-10.04 2.03-19.42 5.94-27.67 11.42l-58.62-58.59-21.93 21.93 58.67 58.67c-5.47 8.23-9.45 17.59-11.47 27.62h-82.9v31h82.9c2.02 10.02 6.01 19.31 11.47 27.54l-58.67 58.69 21.93 21.93 58.62-58.62a77.873 77.873 0 0 0 27.67 11.47v82.9h31v-82.9c10.05-2.03 19.37-6.06 27.62-11.55l58.67 58.69 21.93-21.93-58.67-58.69c5.46-8.23 9.47-17.52 11.5-27.54h82.87v-31h-82.87c-2.02-10.02-6.03-19.38-11.5-27.62l58.67-58.67-21.93-21.93-58.67 58.67c-8.25-5.49-17.57-9.47-27.62-11.5V96.58h-31zm183.24 30.72l-17.36 17.36a186.337 186.337 0 0 1 34.67 83.67h24.62c-4.95-37.69-19.83-72.29-41.93-101.03zm-335.55.13c-22.06 28.72-36.91 63.26-41.85 100.91h24.65c4.6-30.96 16.76-59.45 34.59-83.52l-17.39-17.39zM38.34 283.67c4.92 37.64 19.75 72.18 41.8 100.9l17.36-17.39c-17.81-24.07-29.92-52.57-34.51-83.52H38.34zm394.7 0c-4.61 30.99-16.8 59.5-34.67 83.6l17.36 17.36c22.08-28.74 36.98-63.29 41.93-100.96h-24.62zM136.66 406.38l-17.36 17.36c28.73 22.09 63.3 36.98 100.96 41.93v-24.64c-30.99-4.63-59.53-16.79-83.6-34.65zm222.53.05c-24.09 17.84-52.58 30.08-83.57 34.67v24.57c37.67-4.92 72.21-19.79 100.96-41.85l-17.31-17.39h-.08z"
        ],
        "galactic-senate": [
            512,
            512,
            [],
            "f50d",
            "M249.86 33.48v26.07C236.28 80.17 226 168.14 225.39 274.9c11.74-15.62 19.13-33.33 19.13-48.24v-16.88c-.03-5.32.75-10.53 2.19-15.65.65-2.14 1.39-4.08 2.62-5.82 1.23-1.75 3.43-3.79 6.68-3.79 3.24 0 5.45 2.05 6.68 3.79 1.23 1.75 1.97 3.68 2.62 5.82 1.44 5.12 2.22 10.33 2.19 15.65v16.88c0 14.91 7.39 32.62 19.13 48.24-.63-106.76-10.91-194.73-24.49-215.35V33.48h-12.28zm-26.34 147.77c-9.52 2.15-18.7 5.19-27.46 9.08 8.9 16.12 9.76 32.64 1.71 37.29-8 4.62-21.85-4.23-31.36-19.82-11.58 8.79-21.88 19.32-30.56 31.09 14.73 9.62 22.89 22.92 18.32 30.66-4.54 7.7-20.03 7.14-35.47-.96-5.78 13.25-9.75 27.51-11.65 42.42 9.68.18 18.67 2.38 26.18 6.04 17.78-.3 32.77-1.96 40.49-4.22 5.55-26.35 23.02-48.23 46.32-59.51.73-25.55 1.88-49.67 3.48-72.07zm64.96 0c1.59 22.4 2.75 46.52 3.47 72.07 23.29 11.28 40.77 33.16 46.32 59.51 7.72 2.26 22.71 3.92 40.49 4.22 7.51-3.66 16.5-5.85 26.18-6.04-1.9-14.91-5.86-29.17-11.65-42.42-15.44 8.1-30.93 8.66-35.47.96-4.57-7.74 3.6-21.05 18.32-30.66-8.68-11.77-18.98-22.3-30.56-31.09-9.51 15.59-23.36 24.44-31.36 19.82-8.05-4.65-7.19-21.16 1.71-37.29a147.49 147.49 0 0 0-27.45-9.08zm-32.48 8.6c-3.23 0-5.86 8.81-6.09 19.93h-.05v16.88c0 41.42-49.01 95.04-93.49 95.04-52 0-122.75-1.45-156.37 29.17v2.51c9.42 17.12 20.58 33.17 33.18 47.97C45.7 380.26 84.77 360.4 141.2 360c45.68 1.02 79.03 20.33 90.76 40.87.01.01-.01.04 0 .05 7.67 2.14 15.85 3.23 24.04 3.21 8.19.02 16.37-1.07 24.04-3.21.01-.01-.01-.04 0-.05 11.74-20.54 45.08-39.85 90.76-40.87 56.43.39 95.49 20.26 108.02 41.35 12.6-14.8 23.76-30.86 33.18-47.97v-2.51c-33.61-30.62-104.37-29.17-156.37-29.17-44.48 0-93.49-53.62-93.49-95.04v-16.88h-.05c-.23-11.12-2.86-19.93-6.09-19.93zm0 96.59c22.42 0 40.6 18.18 40.6 40.6s-18.18 40.65-40.6 40.65-40.6-18.23-40.6-40.65c0-22.42 18.18-40.6 40.6-40.6zm0 7.64c-18.19 0-32.96 14.77-32.96 32.96S237.81 360 256 360s32.96-14.77 32.96-32.96-14.77-32.96-32.96-32.96zm0 6.14c14.81 0 26.82 12.01 26.82 26.82s-12.01 26.82-26.82 26.82-26.82-12.01-26.82-26.82 12.01-26.82 26.82-26.82zm-114.8 66.67c-10.19.07-21.6.36-30.5 1.66.43 4.42 1.51 18.63 7.11 29.76 9.11-2.56 18.36-3.9 27.62-3.9 41.28.94 71.48 34.35 78.26 74.47l.11 4.7c10.4 1.91 21.19 2.94 32.21 2.94 11.03 0 21.81-1.02 32.21-2.94l.11-4.7c6.78-40.12 36.98-73.53 78.26-74.47 9.26 0 18.51 1.34 27.62 3.9 5.6-11.13 6.68-25.34 7.11-29.76-8.9-1.3-20.32-1.58-30.5-1.66-18.76.42-35.19 4.17-48.61 9.67-12.54 16.03-29.16 30.03-49.58 33.07-.09.02-.17.04-.27.05-.05.01-.11.04-.16.05-5.24 1.07-10.63 1.6-16.19 1.6-5.55 0-10.95-.53-16.19-1.6-.05-.01-.11-.04-.16-.05-.1-.02-.17-.04-.27-.05-20.42-3.03-37.03-17.04-49.58-33.07-13.42-5.49-29.86-9.25-48.61-9.67z"
        ],
        "get-pocket": [
            448,
            512,
            [],
            "f265",
            "M407.6 64h-367C18.5 64 0 82.5 0 104.6v135.2C0 364.5 99.7 464 224.2 464c124 0 223.8-99.5 223.8-224.2V104.6c0-22.4-17.7-40.6-40.4-40.6zm-162 268.5c-12.4 11.8-31.4 11.1-42.4 0C89.5 223.6 88.3 227.4 88.3 209.3c0-16.9 13.8-30.7 30.7-30.7 17 0 16.1 3.8 105.2 89.3 90.6-86.9 88.6-89.3 105.5-89.3 16.9 0 30.7 13.8 30.7 30.7 0 17.8-2.9 15.7-114.8 123.2z"
        ],
        "gg": [
            512,
            512,
            [],
            "f260",
            "M179.2 230.4l102.4 102.4-102.4 102.4L0 256 179.2 76.8l44.8 44.8-25.6 25.6-19.2-19.2-128 128 128 128 51.5-51.5-77.1-76.5 25.6-25.6zM332.8 76.8L230.4 179.2l102.4 102.4 25.6-25.6-77.1-76.5 51.5-51.5 128 128-128 128-19.2-19.2-25.6 25.6 44.8 44.8L512 256 332.8 76.8z"
        ],
        "gg-circle": [
            512,
            512,
            [],
            "f261",
            "M257 8C120 8 9 119 9 256s111 248 248 248 248-111 248-248S394 8 257 8zm-49.5 374.8L81.8 257.1l125.7-125.7 35.2 35.4-24.2 24.2-11.1-11.1-77.2 77.2 77.2 77.2 26.6-26.6-53.1-52.9 24.4-24.4 77.2 77.2-75 75.2zm99-2.2l-35.2-35.2 24.1-24.4 11.1 11.1 77.2-77.2-77.2-77.2-26.5 26.5 53.1 52.9-24.4 24.4-77.2-77.2 75-75L432.2 255 306.5 380.6z"
        ],
        "git": [
            512,
            512,
            [],
            "f1d3",
            "M216.29 158.39H137C97 147.9 6.51 150.63 6.51 233.18c0 30.09 15 51.23 35 61-25.1 23-37 33.85-37 49.21 0 11 4.47 21.14 17.89 26.81C8.13 383.61 0 393.35 0 411.65c0 32.11 28.05 50.82 101.63 50.82 70.75 0 111.79-26.42 111.79-73.18 0-58.66-45.16-56.5-151.63-63l13.43-21.55c27.27 7.58 118.7 10 118.7-67.89 0-18.7-7.73-31.71-15-41.07l37.41-2.84zm-63.42 241.9c0 32.06-104.89 32.1-104.89 2.43 0-8.14 5.27-15 10.57-21.54 77.71 5.3 94.32 3.37 94.32 19.11zm-50.81-134.58c-52.8 0-50.46-71.16 1.2-71.16 49.54 0 50.82 71.16-1.2 71.16zm133.3 100.51v-32.1c26.75-3.66 27.24-2 27.24-11V203.61c0-8.5-2.05-7.38-27.24-16.26l4.47-32.92H324v168.71c0 6.51.4 7.32 6.51 8.14l20.73 2.84v32.1zm52.45-244.31c-23.17 0-36.59-13.43-36.59-36.61s13.42-35.77 36.59-35.77c23.58 0 37 12.62 37 35.77s-13.42 36.61-37 36.61zM512 350.46c-17.49 8.53-43.1 16.26-66.28 16.26-48.38 0-66.67-19.5-66.67-65.46V194.75c0-5.42 1.05-4.06-31.71-4.06V154.5c35.78-4.07 50-22 54.47-66.27h38.63c0 65.83-1.34 61.81 3.26 61.81H501v40.65h-60.56v97.15c0 6.92-4.92 51.41 60.57 26.84z"
        ],
        "git-alt": [
            448,
            512,
            [],
            "f841",
            "M439.55 236.05L244 40.45a28.87 28.87 0 0 0-40.81 0l-40.66 40.63 51.52 51.52c27.06-9.14 52.68 16.77 43.39 43.68l49.66 49.66c34.23-11.8 61.18 31 35.47 56.69-26.49 26.49-70.21-2.87-56-37.34L240.22 199v121.85c25.3 12.54 22.26 41.85 9.08 55a34.34 34.34 0 0 1-48.55 0c-17.57-17.6-11.07-46.91 11.25-56v-123c-20.8-8.51-24.6-30.74-18.64-45L142.57 101 8.45 235.14a28.86 28.86 0 0 0 0 40.81l195.61 195.6a28.86 28.86 0 0 0 40.8 0l194.69-194.69a28.86 28.86 0 0 0 0-40.81z"
        ],
        "git-square": [
            448,
            512,
            [],
            "f1d2",
            "M100.59 334.24c48.57 3.31 58.95 2.11 58.95 11.94 0 20-65.55 20.06-65.55 1.52.01-5.09 3.29-9.4 6.6-13.46zm27.95-116.64c-32.29 0-33.75 44.47-.75 44.47 32.51 0 31.71-44.47.75-44.47zM448 80v352a48 48 0 0 1-48 48H48a48 48 0 0 1-48-48V80a48 48 0 0 1 48-48h352a48 48 0 0 1 48 48zm-227 69.31c0 14.49 8.38 22.88 22.86 22.88 14.74 0 23.13-8.39 23.13-22.88S258.62 127 243.88 127c-14.48 0-22.88 7.84-22.88 22.31zM199.18 195h-49.55c-25-6.55-81.56-4.85-81.56 46.75 0 18.8 9.4 32 21.85 38.11C74.23 294.23 66.8 301 66.8 310.6c0 6.87 2.79 13.22 11.18 16.76-8.9 8.4-14 14.48-14 25.92C64 373.35 81.53 385 127.52 385c44.22 0 69.87-16.51 69.87-45.73 0-36.67-28.23-35.32-94.77-39.38l8.38-13.43c17 4.74 74.19 6.23 74.19-42.43 0-11.69-4.83-19.82-9.4-25.67l23.38-1.78zm84.34 109.84l-13-1.78c-3.82-.51-4.07-1-4.07-5.09V192.52h-52.6l-2.79 20.57c15.75 5.55 17 4.86 17 10.17V298c0 5.62-.31 4.58-17 6.87v20.06h72.42zM384 315l-6.87-22.37c-40.93 15.37-37.85-12.41-37.85-16.73v-60.72h37.85v-25.41h-35.82c-2.87 0-2 2.52-2-38.63h-24.18c-2.79 27.7-11.68 38.88-34 41.42v22.62c20.47 0 19.82-.85 19.82 2.54v66.57c0 28.72 11.43 40.91 41.67 40.91 14.45 0 30.45-4.83 41.38-10.2z"
        ],
        "github": [
            496,
            512,
            [],
            "f09b",
            "M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
        ],
        "github-alt": [
            480,
            512,
            [],
            "f113",
            "M186.1 328.7c0 20.9-10.9 55.1-36.7 55.1s-36.7-34.2-36.7-55.1 10.9-55.1 36.7-55.1 36.7 34.2 36.7 55.1zM480 278.2c0 31.9-3.2 65.7-17.5 95-37.9 76.6-142.1 74.8-216.7 74.8-75.8 0-186.2 2.7-225.6-74.8-14.6-29-20.2-63.1-20.2-95 0-41.9 13.9-81.5 41.5-113.6-5.2-15.8-7.7-32.4-7.7-48.8 0-21.5 4.9-32.3 14.6-51.8 45.3 0 74.3 9 108.8 36 29-6.9 58.8-10 88.7-10 27 0 54.2 2.9 80.4 9.2 34-26.7 63-35.2 107.8-35.2 9.8 19.5 14.6 30.3 14.6 51.8 0 16.4-2.6 32.7-7.7 48.2 27.5 32.4 39 72.3 39 114.2zm-64.3 50.5c0-43.9-26.7-82.6-73.5-82.6-18.9 0-37 3.4-56 6-14.9 2.3-29.8 3.2-45.1 3.2-15.2 0-30.1-.9-45.1-3.2-18.7-2.6-37-6-56-6-46.8 0-73.5 38.7-73.5 82.6 0 87.8 80.4 101.3 150.4 101.3h48.2c70.3 0 150.6-13.4 150.6-101.3zm-82.6-55.1c-25.8 0-36.7 34.2-36.7 55.1s10.9 55.1 36.7 55.1 36.7-34.2 36.7-55.1-10.9-55.1-36.7-55.1z"
        ],
        "github-square": [
            448,
            512,
            [],
            "f092",
            "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM277.3 415.7c-8.4 1.5-11.5-3.7-11.5-8 0-5.4.2-33 .2-55.3 0-15.6-5.2-25.5-11.3-30.7 37-4.1 76-9.2 76-73.1 0-18.2-6.5-27.3-17.1-39 1.7-4.3 7.4-22-1.7-45-13.9-4.3-45.7 17.9-45.7 17.9-13.2-3.7-27.5-5.6-41.6-5.6-14.1 0-28.4 1.9-41.6 5.6 0 0-31.8-22.2-45.7-17.9-9.1 22.9-3.5 40.6-1.7 45-10.6 11.7-15.6 20.8-15.6 39 0 63.6 37.3 69 74.3 73.1-4.8 4.3-9.1 11.7-10.6 22.3-9.5 4.3-33.8 11.7-48.3-13.9-9.1-15.8-25.5-17.1-25.5-17.1-16.2-.2-1.1 10.2-1.1 10.2 10.8 5 18.4 24.2 18.4 24.2 9.7 29.7 56.1 19.7 56.1 19.7 0 13.9.2 36.5.2 40.6 0 4.3-3 9.5-11.5 8-66-22.1-112.2-84.9-112.2-158.3 0-91.8 70.2-161.5 162-161.5S388 165.6 388 257.4c.1 73.4-44.7 136.3-110.7 158.3zm-98.1-61.1c-1.9.4-3.7-.4-3.9-1.7-.2-1.5 1.1-2.8 3-3.2 1.9-.2 3.7.6 3.9 1.9.3 1.3-1 2.6-3 3zm-9.5-.9c0 1.3-1.5 2.4-3.5 2.4-2.2.2-3.7-.9-3.7-2.4 0-1.3 1.5-2.4 3.5-2.4 1.9-.2 3.7.9 3.7 2.4zm-13.7-1.1c-.4 1.3-2.4 1.9-4.1 1.3-1.9-.4-3.2-1.9-2.8-3.2.4-1.3 2.4-1.9 4.1-1.5 2 .6 3.3 2.1 2.8 3.4zm-12.3-5.4c-.9 1.1-2.8.9-4.3-.6-1.5-1.3-1.9-3.2-.9-4.1.9-1.1 2.8-.9 4.3.6 1.3 1.3 1.8 3.3.9 4.1zm-9.1-9.1c-.9.6-2.6 0-3.7-1.5s-1.1-3.2 0-3.9c1.1-.9 2.8-.2 3.7 1.3 1.1 1.5 1.1 3.3 0 4.1zm-6.5-9.7c-.9.9-2.4.4-3.5-.6-1.1-1.3-1.3-2.8-.4-3.5.9-.9 2.4-.4 3.5.6 1.1 1.3 1.3 2.8.4 3.5zm-6.7-7.4c-.4.9-1.7 1.1-2.8.4-1.3-.6-1.9-1.7-1.5-2.6.4-.6 1.5-.9 2.8-.4 1.3.7 1.9 1.8 1.5 2.6z"
        ],
        "gitkraken": [
            592,
            512,
            [],
            "f3a6",
            "M565.7 118.1c-2.3-6.1-9.3-9.2-15.3-6.6-5.7 2.4-8.5 8.9-6.3 14.6 10.9 29 16.9 60.5 16.9 93.3 0 134.6-100.3 245.7-230.2 262.7V358.4c7.9-1.5 15.5-3.6 23-6.2v104c106.7-25.9 185.9-122.1 185.9-236.8 0-91.8-50.8-171.8-125.8-213.3-5.7-3.2-13-.9-15.9 5-2.7 5.5-.6 12.2 4.7 15.1 67.9 37.6 113.9 110 113.9 193.2 0 93.3-57.9 173.1-139.8 205.4v-92.2c14.2-4.5 24.9-17.7 24.9-33.5 0-13.1-6.8-24.4-17.3-30.5 8.3-79.5 44.5-58.6 44.5-83.9V170c0-38-87.9-161.8-129-164.7-2.5-.2-5-.2-7.6 0C251.1 8.3 163.2 132 163.2 170v14.8c0 25.3 36.3 4.3 44.5 83.9-10.6 6.1-17.3 17.4-17.3 30.5 0 15.8 10.6 29 24.8 33.5v92.2c-81.9-32.2-139.8-112-139.8-205.4 0-83.1 46-155.5 113.9-193.2 5.4-3 7.4-9.6 4.7-15.1-2.9-5.9-10.1-8.2-15.9-5-75 41.5-125.8 121.5-125.8 213.3 0 114.7 79.2 210.8 185.9 236.8v-104c7.6 2.5 15.1 4.6 23 6.2v123.7C131.4 465.2 31 354.1 31 219.5c0-32.8 6-64.3 16.9-93.3 2.2-5.8-.6-12.2-6.3-14.6-6-2.6-13 .4-15.3 6.6C14.5 149.7 8 183.8 8 219.5c0 155.1 122.6 281.6 276.3 287.8V361.4c6.8.4 15 .5 23.4 0v145.8C461.4 501.1 584 374.6 584 219.5c0-35.7-6.5-69.8-18.3-101.4zM365.9 275.5c13 0 23.7 10.5 23.7 23.7 0 13.1-10.6 23.7-23.7 23.7-13 0-23.7-10.5-23.7-23.7 0-13.1 10.6-23.7 23.7-23.7zm-139.8 47.3c-13.2 0-23.7-10.7-23.7-23.7s10.5-23.7 23.7-23.7c13.1 0 23.7 10.6 23.7 23.7 0 13-10.5 23.7-23.7 23.7z"
        ],
        "gitlab": [
            512,
            512,
            [],
            "f296",
            "M105.2 24.9c-3.1-8.9-15.7-8.9-18.9 0L29.8 199.7h132c-.1 0-56.6-174.8-56.6-174.8zM.9 287.7c-2.6 8 .3 16.9 7.1 22l247.9 184-226.2-294zm160.8-88l94.3 294 94.3-294zm349.4 88l-28.8-88-226.3 294 247.9-184c6.9-5.1 9.7-14 7.2-22zM425.7 24.9c-3.1-8.9-15.7-8.9-18.9 0l-56.6 174.8h132z"
        ],
        "gitter": [
            384,
            512,
            [],
            "f426",
            "M66.4 322.5H16V0h50.4v322.5zM166.9 76.1h-50.4V512h50.4V76.1zm100.6 0h-50.4V512h50.4V76.1zM368 76h-50.4v247H368V76z"
        ],
        "glide": [
            448,
            512,
            [],
            "f2a5",
            "M252.8 148.6c0 8.8-1.6 17.7-3.4 26.4-5.8 27.8-11.6 55.8-17.3 83.6-1.4 6.3-8.3 4.9-13.7 4.9-23.8 0-30.5-26-30.5-45.5 0-29.3 11.2-68.1 38.5-83.1 4.3-2.5 9.2-4.2 14.1-4.2 11.4 0 12.3 8.3 12.3 17.9zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-64 187c0-5.1-20.8-37.7-25.5-39.5-2.2-.9-7.2-2.3-9.6-2.3-23.1 0-38.7 10.5-58.2 21.5l-.5-.5c4.3-29.4 14.6-57.2 14.6-87.4 0-44.6-23.8-62.7-67.5-62.7-71.7 0-108 70.8-108 123.5 0 54.7 32 85 86.3 85 7.5 0 6.9-.6 6.9 2.3-10.5 80.3-56.5 82.9-56.5 58.9 0-24.4 28-36.5 28.3-38-.2-7.6-29.3-17.2-36.7-17.2-21.1 0-32.7 33-32.7 50.6 0 32.3 20.4 54.7 53.3 54.7 48.2 0 83.4-49.7 94.3-91.7 9.4-37.7 7-39.4 12.3-42.1 20-10.1 35.8-16.8 58.4-16.8 11.1 0 19 2.3 36.7 5.2 1.8.1 4.1-1.7 4.1-3.5z"
        ],
        "glide-g": [
            448,
            512,
            [],
            "f2a6",
            "M407.1 211.2c-3.5-1.4-11.6-3.8-15.4-3.8-37.1 0-62.2 16.8-93.5 34.5l-.9-.9c7-47.3 23.5-91.9 23.5-140.4C320.8 29.1 282.6 0 212.4 0 97.3 0 39 113.7 39 198.4 39 286.3 90.3 335 177.6 335c12 0 11-1 11 3.8-16.9 128.9-90.8 133.1-90.8 94.6 0-39.2 45-58.6 45.5-61-.3-12.2-47-27.6-58.9-27.6-33.9.1-52.4 51.2-52.4 79.3C32 476 64.8 512 117.5 512c77.4 0 134-77.8 151.4-145.4 15.1-60.5 11.2-63.3 19.7-67.6 32.2-16.2 57.5-27 93.8-27 17.8 0 30.5 3.7 58.9 8.4 2.9 0 6.7-2.9 6.7-5.8 0-8-33.4-60.5-40.9-63.4zm-175.3-84.4c-9.3 44.7-18.6 89.6-27.8 134.3-2.3 10.2-13.3 7.8-22 7.8-38.3 0-49-41.8-49-73.1 0-47 18-109.3 61.8-133.4 7-4.1 14.8-6.7 22.6-6.7 18.6 0 20 13.3 20 28.7-.1 14.3-2.7 28.5-5.6 42.4z"
        ],
        "gofore": [
            400,
            512,
            [],
            "f3a7",
            "M324 319.8h-13.2v34.7c-24.5 23.1-56.3 35.8-89.9 35.8-73.2 0-132.4-60.2-132.4-134.4 0-74.1 59.2-134.4 132.4-134.4 35.3 0 68.6 14 93.6 39.4l62.3-63.3C335 55.3 279.7 32 220.7 32 98 32 0 132.6 0 256c0 122.5 97 224 220.7 224 63.2 0 124.5-26.2 171-82.5-2-27.6-13.4-77.7-67.7-77.7zm-12.1-112.5H205.6v89H324c33.5 0 60.5 15.1 76 41.8v-30.6c0-65.2-40.4-100.2-88.1-100.2z"
        ],
        "goodreads": [
            448,
            512,
            [],
            "f3a8",
            "M299.9 191.2c5.1 37.3-4.7 79-35.9 100.7-22.3 15.5-52.8 14.1-70.8 5.7-37.1-17.3-49.5-58.6-46.8-97.2 4.3-60.9 40.9-87.9 75.3-87.5 46.9-.2 71.8 31.8 78.2 78.3zM448 88v336c0 30.9-25.1 56-56 56H56c-30.9 0-56-25.1-56-56V88c0-30.9 25.1-56 56-56h336c30.9 0 56 25.1 56 56zM330 313.2s-.1-34-.1-217.3h-29v40.3c-.8.3-1.2-.5-1.6-1.2-9.6-20.7-35.9-46.3-76-46-51.9.4-87.2 31.2-100.6 77.8-4.3 14.9-5.8 30.1-5.5 45.6 1.7 77.9 45.1 117.8 112.4 115.2 28.9-1.1 54.5-17 69-45.2.5-1 1.1-1.9 1.7-2.9.2.1.4.1.6.2.3 3.8.2 30.7.1 34.5-.2 14.8-2 29.5-7.2 43.5-7.8 21-22.3 34.7-44.5 39.5-17.8 3.9-35.6 3.8-53.2-1.2-21.5-6.1-36.5-19-41.1-41.8-.3-1.6-1.3-1.3-2.3-1.3h-26.8c.8 10.6 3.2 20.3 8.5 29.2 24.2 40.5 82.7 48.5 128.2 37.4 49.9-12.3 67.3-54.9 67.4-106.3z"
        ],
        "goodreads-g": [
            384,
            512,
            [],
            "f3a9",
            "M42.6 403.3h2.8c12.7 0 25.5 0 38.2.1 1.6 0 3.1-.4 3.6 2.1 7.1 34.9 30 54.6 62.9 63.9 26.9 7.6 54.1 7.8 81.3 1.8 33.8-7.4 56-28.3 68-60.4 8-21.5 10.7-43.8 11-66.5.1-5.8.3-47-.2-52.8l-.9-.3c-.8 1.5-1.7 2.9-2.5 4.4-22.1 43.1-61.3 67.4-105.4 69.1-103 4-169.4-57-172-176.2-.5-23.7 1.8-46.9 8.3-69.7C58.3 47.7 112.3.6 191.6 0c61.3-.4 101.5 38.7 116.2 70.3.5 1.1 1.3 2.3 2.4 1.9V10.6h44.3c0 280.3.1 332.2.1 332.2-.1 78.5-26.7 143.7-103 162.2-69.5 16.9-159 4.8-196-57.2-8-13.5-11.8-28.3-13-44.5zM188.9 36.5c-52.5-.5-108.5 40.7-115 133.8-4.1 59 14.8 122.2 71.5 148.6 27.6 12.9 74.3 15 108.3-8.7 47.6-33.2 62.7-97 54.8-154-9.7-71.1-47.8-120-119.6-119.7z"
        ],
        "google": [
            488,
            512,
            [],
            "f1a0",
            "M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"
        ],
        "google-drive": [
            512,
            512,
            [],
            "f3aa",
            "M339 314.9L175.4 32h161.2l163.6 282.9H339zm-137.5 23.6L120.9 480h310.5L512 338.5H201.5zM154.1 67.4L0 338.5 80.6 480 237 208.8 154.1 67.4z"
        ],
        "google-pay": [
            640,
            512,
            [],
            "e079",
            "M105.72,215v41.25h57.1a49.66,49.66,0,0,1-21.14,32.6c-9.54,6.55-21.72,10.28-36,10.28-27.6,0-50.93-18.91-59.3-44.22a65.61,65.61,0,0,1,0-41l0,0c8.37-25.46,31.7-44.37,59.3-44.37a56.43,56.43,0,0,1,40.51,16.08L176.47,155a101.24,101.24,0,0,0-70.75-27.84,105.55,105.55,0,0,0-94.38,59.11,107.64,107.64,0,0,0,0,96.18v.15a105.41,105.41,0,0,0,94.38,59c28.47,0,52.55-9.53,70-25.91,20-18.61,31.41-46.15,31.41-78.91A133.76,133.76,0,0,0,205.38,215Zm389.41-4c-10.13-9.38-23.93-14.14-41.39-14.14-22.46,0-39.34,8.34-50.5,24.86l20.85,13.26q11.45-17,31.26-17a34.05,34.05,0,0,1,22.75,8.79A28.14,28.14,0,0,1,487.79,248v5.51c-9.1-5.07-20.55-7.75-34.64-7.75-16.44,0-29.65,3.88-39.49,11.77s-14.82,18.31-14.82,31.56a39.74,39.74,0,0,0,13.94,31.27c9.25,8.34,21,12.51,34.79,12.51,16.29,0,29.21-7.3,39-21.89h1v17.72h22.61V250C510.25,233.45,505.26,220.34,495.13,211ZM475.9,300.3a37.32,37.32,0,0,1-26.57,11.16A28.61,28.61,0,0,1,431,305.21a19.41,19.41,0,0,1-7.77-15.63c0-7,3.22-12.81,9.54-17.42s14.53-7,24.07-7C470,265,480.3,268,487.64,273.94,487.64,284.07,483.68,292.85,475.9,300.3Zm-93.65-142A55.71,55.71,0,0,0,341.74,142H279.07V328.74H302.7V253.1h39c16,0,29.5-5.36,40.51-15.93.88-.89,1.76-1.79,2.65-2.68A54.45,54.45,0,0,0,382.25,158.26Zm-16.58,62.23a30.65,30.65,0,0,1-23.34,9.68H302.7V165h39.63a32,32,0,0,1,22.6,9.23A33.18,33.18,0,0,1,365.67,220.49ZM614.31,201,577.77,292.7h-.45L539.9,201H514.21L566,320.55l-29.35,64.32H561L640,201Z"
        ],
        "google-play": [
            512,
            512,
            [],
            "f3ab",
            "M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"
        ],
        "google-plus": [
            512,
            512,
            [],
            "f2b3",
            "M256,8C119.1,8,8,119.1,8,256S119.1,504,256,504,504,392.9,504,256,392.9,8,256,8ZM185.3,380a124,124,0,0,1,0-248c31.3,0,60.1,11,83,32.3l-33.6,32.6c-13.2-12.9-31.3-19.1-49.4-19.1-42.9,0-77.2,35.5-77.2,78.1S142.3,334,185.3,334c32.6,0,64.9-19.1,70.1-53.3H185.3V238.1H302.2a109.2,109.2,0,0,1,1.9,20.7c0,70.8-47.5,121.2-118.8,121.2ZM415.5,273.8v35.5H380V273.8H344.5V238.3H380V202.8h35.5v35.5h35.2v35.5Z"
        ],
        "google-plus-g": [
            640,
            512,
            [],
            "f0d5",
            "M386.061 228.496c1.834 9.692 3.143 19.384 3.143 31.956C389.204 370.205 315.599 448 204.8 448c-106.084 0-192-85.915-192-192s85.916-192 192-192c51.864 0 95.083 18.859 128.611 50.292l-52.126 50.03c-14.145-13.621-39.028-29.599-76.485-29.599-65.484 0-118.92 54.221-118.92 121.277 0 67.056 53.436 121.277 118.92 121.277 75.961 0 104.513-54.745 108.965-82.773H204.8v-66.009h181.261zm185.406 6.437V179.2h-56.001v55.733h-55.733v56.001h55.733v55.733h56.001v-55.733H627.2v-56.001h-55.733z"
        ],
        "google-plus-square": [
            448,
            512,
            [],
            "f0d4",
            "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM164 356c-55.3 0-100-44.7-100-100s44.7-100 100-100c27 0 49.5 9.8 67 26.2l-27.1 26.1c-7.4-7.1-20.3-15.4-39.8-15.4-34.1 0-61.9 28.2-61.9 63.2 0 34.9 27.8 63.2 61.9 63.2 39.6 0 54.4-28.5 56.8-43.1H164v-34.4h94.4c1 5 1.6 10.1 1.6 16.6 0 57.1-38.3 97.6-96 97.6zm220-81.8h-29v29h-29.2v-29h-29V245h29v-29H355v29h29v29.2z"
        ],
        "google-wallet": [
            448,
            512,
            [],
            "f1ee",
            "M156.8 126.8c37.6 60.6 64.2 113.1 84.3 162.5-8.3 33.8-18.8 66.5-31.3 98.3-13.2-52.3-26.5-101.3-56-148.5 6.5-36.4 2.3-73.6 3-112.3zM109.3 200H16.1c-6.5 0-10.5 7.5-6.5 12.7C51.8 267 81.3 330.5 101.3 400h103.5c-16.2-69.7-38.7-133.7-82.5-193.5-3-4-8-6.5-13-6.5zm47.8-88c68.5 108 130 234.5 138.2 368H409c-12-138-68.4-265-143.2-368H157.1zm251.8-68.5c-1.8-6.8-8.2-11.5-15.2-11.5h-88.3c-5.3 0-9 5-7.8 10.3 13.2 46.5 22.3 95.5 26.5 146 48.2 86.2 79.7 178.3 90.6 270.8 15.8-60.5 25.3-133.5 25.3-203 0-73.6-12.1-145.1-31.1-212.6z"
        ],
        "gratipay": [
            496,
            512,
            [],
            "f184",
            "M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm114.6 226.4l-113 152.7-112.7-152.7c-8.7-11.9-19.1-50.4 13.6-72 28.1-18.1 54.6-4.2 68.5 11.9 15.9 17.9 46.6 16.9 61.7 0 13.9-16.1 40.4-30 68.1-11.9 32.9 21.6 22.6 60 13.8 72z"
        ],
        "grav": [
            512,
            512,
            [],
            "f2d6",
            "M301.1 212c4.4 4.4 4.4 11.9 0 16.3l-9.7 9.7c-4.4 4.7-11.9 4.7-16.6 0l-10.5-10.5c-4.4-4.7-4.4-11.9 0-16.6l9.7-9.7c4.4-4.4 11.9-4.4 16.6 0l10.5 10.8zm-30.2-19.7c3-3 3-7.8 0-10.5-2.8-3-7.5-3-10.5 0-2.8 2.8-2.8 7.5 0 10.5 3.1 2.8 7.8 2.8 10.5 0zm-26 5.3c-3 2.8-3 7.5 0 10.2 2.8 3 7.5 3 10.5 0 2.8-2.8 2.8-7.5 0-10.2-3-3-7.7-3-10.5 0zm72.5-13.3c-19.9-14.4-33.8-43.2-11.9-68.1 21.6-24.9 40.7-17.2 59.8.8 11.9 11.3 29.3 24.9 17.2 48.2-12.5 23.5-45.1 33.2-65.1 19.1zm47.7-44.5c-8.9-10-23.3 6.9-15.5 16.1 7.4 9 32.1 2.4 15.5-16.1zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-66.2 42.6c2.5-16.1-20.2-16.6-25.2-25.7-13.6-24.1-27.7-36.8-54.5-30.4 11.6-8 23.5-6.1 23.5-6.1.3-6.4 0-13-9.4-24.9 3.9-12.5.3-22.4.3-22.4 15.5-8.6 26.8-24.4 29.1-43.2 3.6-31-18.8-59.2-49.8-62.8-22.1-2.5-43.7 7.7-54.3 25.7-23.2 40.1 1.4 70.9 22.4 81.4-14.4-1.4-34.3-11.9-40.1-34.3-6.6-25.7 2.8-49.8 8.9-61.4 0 0-4.4-5.8-8-8.9 0 0-13.8 0-24.6 5.3 11.9-15.2 25.2-14.4 25.2-14.4 0-6.4-.6-14.9-3.6-21.6-5.4-11-23.8-12.9-31.7 2.8.1-.2.3-.4.4-.5-5 11.9-1.1 55.9 16.9 87.2-2.5 1.4-9.1 6.1-13 10-21.6 9.7-56.2 60.3-56.2 60.3-28.2 10.8-77.2 50.9-70.6 79.7.3 3 1.4 5.5 3 7.5-2.8 2.2-5.5 5-8.3 8.3-11.9 13.8-5.3 35.2 17.7 24.4 15.8-7.2 29.6-20.2 36.3-30.4 0 0-5.5-5-16.3-4.4 27.7-6.6 34.3-9.4 46.2-9.1 8 3.9 8-34.3 8-34.3 0-14.7-2.2-31-11.1-41.5 12.5 12.2 29.1 32.7 28 60.6-.8 18.3-15.2 23-15.2 23-9.1 16.6-43.2 65.9-30.4 106 0 0-9.7-14.9-10.2-22.1-17.4 19.4-46.5 52.3-24.6 64.5 26.6 14.7 108.8-88.6 126.2-142.3 34.6-20.8 55.4-47.3 63.9-65 22 43.5 95.3 94.5 101.1 59z"
        ],
        "gripfire": [
            384,
            512,
            [],
            "f3ac",
            "M112.5 301.4c0-73.8 105.1-122.5 105.1-203 0-47.1-34-88-39.1-90.4.4 3.3.6 6.7.6 10C179.1 110.1 32 171.9 32 286.6c0 49.8 32.2 79.2 66.5 108.3 65.1 46.7 78.1 71.4 78.1 86.6 0 10.1-4.8 17-4.8 22.3 13.1-16.7 17.4-31.9 17.5-46.4 0-29.6-21.7-56.3-44.2-86.5-16-22.3-32.6-42.6-32.6-69.5zm205.3-39c-12.1-66.8-78-124.4-94.7-130.9l4 7.2c2.4 5.1 3.4 10.9 3.4 17.1 0 44.7-54.2 111.2-56.6 116.7-2.2 5.1-3.2 10.5-3.2 15.8 0 20.1 15.2 42.1 17.9 42.1 2.4 0 56.6-55.4 58.1-87.7 6.4 11.7 9.1 22.6 9.1 33.4 0 41.2-41.8 96.9-41.8 96.9 0 11.6 31.9 53.2 35.5 53.2 1 0 2.2-1.4 3.2-2.4 37.9-39.3 67.3-85 67.3-136.8 0-8-.7-16.2-2.2-24.6z"
        ],
        "grunt": [
            384,
            512,
            [],
            "f3ad",
            "M61.3 189.3c-1.1 10 5.2 19.1 5.2 19.1.7-7.5 2.2-12.8 4-16.6.4 10.3 3.2 23.5 12.8 34.1 6.9 7.6 35.6 23.3 54.9 6.1 1 2.4 2.1 5.3 3 8.5 2.9 10.3-2.7 25.3-2.7 25.3s15.1-17.1 13.9-32.5c10.8-.5 21.4-8.4 21.1-19.5 0 0-18.9 10.4-35.5-8.8-9.7-11.2-40.9-42-83.1-31.8 4.3 1 8.9 2.4 13.5 4.1h-.1c-4.2 2-6.5 7.1-7 12zm28.3-1.8c19.5 11 37.4 25.7 44.9 37-5.7 3.3-21.7 10.4-38-1.7-10.3-7.6-9.8-26.2-6.9-35.3zm142.1 45.8c-1.2 15.5 13.9 32.5 13.9 32.5s-5.6-15-2.7-25.3c.9-3.2 2-6 3-8.5 19.3 17.3 48 1.5 54.8-6.1 9.6-10.6 12.3-23.8 12.8-34.1 1.8 3.8 3.4 9.1 4 16.6 0 0 6.4-9.1 5.2-19.1-.6-5-2.9-10-7-11.8h-.1c4.6-1.8 9.2-3.2 13.5-4.1-42.3-10.2-73.4 20.6-83.1 31.8-16.7 19.2-35.5 8.8-35.5 8.8-.2 10.9 10.4 18.9 21.2 19.3zm62.7-45.8c3 9.1 3.4 27.7-7 35.4-16.3 12.1-32.2 5-37.9 1.6 7.5-11.4 25.4-26 44.9-37zM160 418.5h-29.4c-5.5 0-8.2 1.6-9.5 2.9-1.9 2-2.2 4.7-.9 8.1 3.5 9.1 11.4 16.5 13.7 18.6 3.1 2.7 7.5 4.3 11.8 4.3 4.4 0 8.3-1.7 11-4.6 7.5-8.2 11.9-17.1 13-19.8.6-1.5 1.3-4.5-.9-6.8-1.8-1.8-4.7-2.7-8.8-2.7zm189.2-101.2c-2.4 17.9-13 33.8-24.6 43.7-3.1-22.7-3.7-55.5-3.7-62.4 0-14.7 9.5-24.5 12.2-26.1 2.5-1.5 5.4-3 8.3-4.6 18-9.6 40.4-21.6 40.4-43.7 0-16.2-9.3-23.2-15.4-27.8-.8-.6-1.5-1.1-2.2-1.7-2.1-1.7-3.7-3-4.3-4.4-4.4-9.8-3.6-34.2-1.7-37.6.6-.6 16.7-20.9 11.8-39.2-2-7.4-6.9-13.3-14.1-17-5.3-2.7-11.9-4.2-19.5-4.5-.1-2-.5-3.9-.9-5.9-.6-2.6-1.1-5.3-.9-8.1.4-4.7.8-9 2.2-11.3 8.4-13.3 28.8-17.6 29-17.6l12.3-2.4-8.1-9.5c-.1-.2-17.3-17.5-46.3-17.5-7.9 0-16 1.3-24.1 3.9-24.2 7.8-42.9 30.5-49.4 39.3-3.1-1-6.3-1.9-9.6-2.7-4.2-15.8 9-38.5 9-38.5s-13.6-3-33.7 15.2c-2.6-6.5-8.1-20.5-1.8-37.2C184.6 10.1 177.2 26 175 40.4c-7.6-5.4-6.7-23.1-7.2-27.6-7.5.9-29.2 21.9-28.2 48.3-2 .5-3.9 1.1-5.9 1.7-6.5-8.8-25.1-31.5-49.4-39.3-7.9-2.2-16-3.5-23.9-3.5-29 0-46.1 17.3-46.3 17.5L6 46.9l12.3 2.4c.2 0 20.6 4.3 29 17.6 1.4 2.2 1.8 6.6 2.2 11.3.2 2.8-.4 5.5-.9 8.1-.4 1.9-.8 3.9-.9 5.9-7.7.3-14.2 1.8-19.5 4.5-7.2 3.7-12.1 9.6-14.1 17-5 18.2 11.2 38.5 11.8 39.2 1.9 3.4 2.7 27.8-1.7 37.6-.6 1.4-2.2 2.7-4.3 4.4-.7.5-1.4 1.1-2.2 1.7-6.1 4.6-15.4 11.7-15.4 27.8 0 22.1 22.4 34.1 40.4 43.7 3 1.6 5.8 3.1 8.3 4.6 2.7 1.6 12.2 11.4 12.2 26.1 0 6.9-.6 39.7-3.7 62.4-11.6-9.9-22.2-25.9-24.6-43.8 0 0-29.2 22.6-20.6 70.8 5.2 29.5 23.2 46.1 47 54.7 8.8 19.1 29.4 45.7 67.3 49.6C143 504.3 163 512 192.2 512h.2c29.1 0 49.1-7.7 63.6-19.5 37.9-3.9 58.5-30.5 67.3-49.6 23.8-8.7 41.7-25.2 47-54.7 8.2-48.4-21.1-70.9-21.1-70.9zM305.7 37.7c5.6-1.8 11.6-2.7 17.7-2.7 11 0 19.9 3 24.7 5-3.1 1.4-6.4 3.2-9.7 5.3-2.4-.4-5.6-.8-9.2-.8-10.5 0-20.5 3.1-28.7 8.9-12.3 8.7-18 16.9-20.7 22.4-2.2-1.3-4.5-2.5-7.1-3.7-1.6-.8-3.1-1.5-4.7-2.2 6.1-9.1 19.9-26.5 37.7-32.2zm21 18.2c-.8 1-1.6 2.1-2.3 3.2-3.3 5.2-3.9 11.6-4.4 17.8-.5 6.4-1.1 12.5-4.4 17-4.2.8-8.1 1.7-11.5 2.7-2.3-3.1-5.6-7-10.5-11.2 1.4-4.8 5.5-16.1 13.5-22.5 5.6-4.3 12.2-6.7 19.6-7zM45.6 45.3c-3.3-2.2-6.6-4-9.7-5.3 4.8-2 13.7-5 24.7-5 6.1 0 12 .9 17.7 2.7 17.8 5.8 31.6 23.2 37.7 32.1-1.6.7-3.2 1.4-4.8 2.2-2.5 1.2-4.9 2.5-7.1 3.7-2.6-5.4-8.3-13.7-20.7-22.4-8.3-5.8-18.2-8.9-28.8-8.9-3.4.1-6.6.5-9 .9zm44.7 40.1c-4.9 4.2-8.3 8-10.5 11.2-3.4-.9-7.3-1.9-11.5-2.7C65 89.5 64.5 83.4 64 77c-.5-6.2-1.1-12.6-4.4-17.8-.7-1.1-1.5-2.2-2.3-3.2 7.4.3 14 2.6 19.5 7 8 6.3 12.1 17.6 13.5 22.4zM58.1 259.9c-2.7-1.6-5.6-3.1-8.4-4.6-14.9-8-30.2-16.3-30.2-30.5 0-11.1 4.3-14.6 8.9-18.2l.5-.4c.7-.6 1.4-1.2 2.2-1.8-.9 7.2-1.9 13.3-2.7 14.9 0 0 12.1-15 15.7-44.3 1.4-11.5-1.1-34.3-5.1-43 .2 4.9 0 9.8-.3 14.4-.4-.8-.8-1.6-1.3-2.2-3.2-4-11.8-17.5-9.4-26.6.9-3.5 3.1-6 6.7-7.8 3.8-1.9 8.8-2.9 15.1-2.9 12.3 0 25.9 3.7 32.9 6 25.1 8 55.4 30.9 64.1 37.7.2.2.4.3.4.3l5.6 3.9-3.5-5.8c-.2-.3-19.1-31.4-53.2-46.5 2-2.9 7.4-8.1 21.6-15.1 21.4-10.5 46.5-15.8 74.3-15.8 27.9 0 52.9 5.3 74.3 15.8 14.2 6.9 19.6 12.2 21.6 15.1-34 15.1-52.9 46.2-53.1 46.5l-3.5 5.8 5.6-3.9s.2-.1.4-.3c8.7-6.8 39-29.8 64.1-37.7 7-2.2 20.6-6 32.9-6 6.3 0 11.3 1 15.1 2.9 3.5 1.8 5.7 4.4 6.7 7.8 2.5 9.1-6.1 22.6-9.4 26.6-.5.6-.9 1.3-1.3 2.2-.3-4.6-.5-9.5-.3-14.4-4 8.8-6.5 31.5-5.1 43 3.6 29.3 15.7 44.3 15.7 44.3-.8-1.6-1.8-7.7-2.7-14.9.7.6 1.5 1.2 2.2 1.8l.5.4c4.6 3.7 8.9 7.1 8.9 18.2 0 14.2-15.4 22.5-30.2 30.5-2.9 1.5-5.7 3.1-8.4 4.6-8.7 5-18 16.7-19.1 34.2-.9 14.6.9 49.9 3.4 75.9-12.4 4.8-26.7 6.4-39.7 6.8-2-4.1-3.9-8.5-5.5-13.1-.7-2-19.6-51.1-26.4-62.2 5.5 39 17.5 73.7 23.5 89.6-3.5-.5-7.3-.7-11.7-.7h-117c-4.4 0-8.3.3-11.7.7 6-15.9 18.1-50.6 23.5-89.6-6.8 11.2-25.7 60.3-26.4 62.2-1.6 4.6-3.5 9-5.5 13.1-13-.4-27.2-2-39.7-6.8 2.5-26 4.3-61.2 3.4-75.9-.9-17.4-10.3-29.2-19-34.2zM34.8 404.6c-12.1-20-8.7-54.1-3.7-59.1 10.9 34.4 47.2 44.3 74.4 45.4-2.7 4.2-5.2 7.6-7 10l-1.4 1.4c-7.2 7.8-8.6 18.5-4.1 31.8-22.7-.1-46.3-9.8-58.2-29.5zm45.7 43.5c6 1.1 12.2 1.9 18.6 2.4 3.5 8 7.4 15.9 12.3 23.1-14.4-5.9-24.4-16-30.9-25.5zM192 498.2c-60.6-.1-78.3-45.8-84.9-64.7-3.7-10.5-3.4-18.2.9-23.1 2.9-3.3 9.5-7.2 24.6-7.2h118.8c15.1 0 21.8 3.9 24.6 7.2 4.2 4.8 4.5 12.6.9 23.1-6.6 18.8-24.3 64.6-84.9 64.7zm80.6-24.6c4.9-7.2 8.8-15.1 12.3-23.1 6.4-.5 12.6-1.3 18.6-2.4-6.5 9.5-16.5 19.6-30.9 25.5zm76.6-69c-12 19.7-35.6 29.3-58.1 29.7 4.5-13.3 3.1-24.1-4.1-31.8-.4-.5-.9-1-1.4-1.5-1.8-2.4-4.3-5.8-7-10 27.2-1.2 63.5-11 74.4-45.4 5 5 8.4 39.1-3.8 59zM191.9 187.7h.2c12.7-.1 27.2-17.8 27.2-17.8-9.9 6-18.8 8.1-27.3 8.3-8.5-.2-17.4-2.3-27.3-8.3 0 0 14.5 17.6 27.2 17.8zm61.7 230.7h-29.4c-4.2 0-7.2.9-8.9 2.7-2.2 2.3-1.5 5.2-.9 6.7 1 2.6 5.5 11.3 13 19.3 2.7 2.9 6.6 4.5 11 4.5s8.7-1.6 11.8-4.2c2.3-2 10.2-9.2 13.7-18.1 1.3-3.3 1-6-.9-7.9-1.3-1.3-4-2.9-9.4-3z"
        ],
        "guilded": [
            448,
            512,
            [],
            "e07e",
            "M443.427,64H4.571c0,103.26,22.192,180.06,43.418,222.358C112.046,414.135,224,448,225.256,448a312.824,312.824,0,0,0,140.55-103.477c25.907-33.923,53.1-87.19,65.916-145.761H171.833c4.14,36.429,22.177,67.946,45.1,86.944h88.589c-17.012,28.213-48.186,54.4-80.456,69.482-31.232-13.259-69.09-46.544-96.548-98.362-26.726-53.833-27.092-105.883-27.092-105.883H437.573A625.91,625.91,0,0,0,443.427,64Z"
        ],
        "gulp": [
            256,
            512,
            [],
            "f3ae",
            "M209.8 391.1l-14.1 24.6-4.6 80.2c0 8.9-28.3 16.1-63.1 16.1s-63.1-7.2-63.1-16.1l-5.8-79.4-14.9-25.4c41.2 17.3 126 16.7 165.6 0zm-196-253.3l13.6 125.5c5.9-20 20.8-47 40-55.2 6.3-2.7 12.7-2.7 18.7.9 5.2 3 9.6 9.3 10.1 11.8 1.2 6.5-2 9.1-4.5 9.1-3 0-5.3-4.6-6.8-7.3-4.1-7.3-10.3-7.6-16.9-2.8-6.9 5-12.9 13.4-17.1 20.7-5.1 8.8-9.4 18.5-12 28.2-1.5 5.6-2.9 14.6-.6 19.9 1 2.2 2.5 3.6 4.9 3.6 5 0 12.3-6.6 15.8-10.1 4.5-4.5 10.3-11.5 12.5-16l5.2-15.5c2.6-6.8 9.9-5.6 9.9 0 0 10.2-3.7 13.6-10 34.7-5.8 19.5-7.6 25.8-7.6 25.8-.7 2.8-3.4 7.5-6.3 7.5-1.2 0-2.1-.4-2.6-1.2-1-1.4-.9-5.3-.8-6.3.2-3.2 6.3-22.2 7.3-25.2-2 2.2-4.1 4.4-6.4 6.6-5.4 5.1-14.1 11.8-21.5 11.8-3.4 0-5.6-.9-7.7-2.4l7.6 79.6c2 5 39.2 17.1 88.2 17.1 49.1 0 86.3-12.2 88.2-17.1l10.9-94.6c-5.7 5.2-12.3 11.6-19.6 14.8-5.4 2.3-17.4 3.8-17.4-5.7 0-5.2 9.1-14.8 14.4-21.5 1.4-1.7 4.7-5.9 4.7-8.1 0-2.9-6-2.2-11.7 2.5-3.2 2.7-6.2 6.3-8.7 9.7-4.3 6-6.6 11.2-8.5 15.5-6.2 14.2-4.1 8.6-9.1 22-5 13.3-4.2 11.8-5.2 14-.9 1.9-2.2 3.5-4 4.5-1.9 1-4.5.9-6.1-.3-.9-.6-1.3-1.9-1.3-3.7 0-.9.1-1.8.3-2.7 1.5-6.1 7.8-18.1 15-34.3 1.6-3.7 1-2.6.8-2.3-6.2 6-10.9 8.9-14.4 10.5-5.8 2.6-13 2.6-14.5-4.1-.1-.4-.1-.8-.2-1.2-11.8 9.2-24.3 11.7-20-8.1-4.6 8.2-12.6 14.9-22.4 14.9-4.1 0-7.1-1.4-8.6-5.1-2.3-5.5 1.3-14.9 4.6-23.8 1.7-4.5 4-9.9 7.1-16.2 1.6-3.4 4.2-5.4 7.6-4.5.6.2 1.1.4 1.6.7 2.6 1.8 1.6 4.5.3 7.2-3.8 7.5-7.1 13-9.3 20.8-.9 3.3-2 9 1.5 9 2.4 0 4.7-.8 6.9-2.4 4.6-3.4 8.3-8.5 11.1-13.5 2-3.6 4.4-8.3 5.6-12.3.5-1.7 1.1-3.3 1.8-4.8 1.1-2.5 2.6-5.1 5.2-5.1 1.3 0 2.4.5 3.2 1.5 1.7 2.2 1.3 4.5.4 6.9-2 5.6-4.7 10.6-6.9 16.7-1.3 3.5-2.7 8-2.7 11.7 0 3.4 3.7 2.6 6.8 1.2 2.4-1.1 4.8-2.8 6.8-4.5 1.2-4.9.9-3.8 26.4-68.2 1.3-3.3 3.7-4.7 6.1-4.7 1.2 0 2.2.4 3.2 1.1 1.7 1.3 1.7 4.1 1 6.2-.7 1.9-.6 1.3-4.5 10.5-5.2 12.1-8.6 20.8-13.2 31.9-1.9 4.6-7.7 18.9-8.7 22.3-.6 2.2-1.3 5.8 1 5.8 5.4 0 19.3-13.1 23.1-17 .2-.3.5-.4.9-.6.6-1.9 1.2-3.7 1.7-5.5 1.4-3.8 2.7-8.2 5.3-11.3.8-1 1.7-1.6 2.7-1.6 2.8 0 4.2 1.2 4.2 4 0 1.1-.7 5.1-1.1 6.2 1.4-1.5 2.9-3 4.5-4.5 15-13.9 25.7-6.8 25.7.2 0 7.4-8.9 17.7-13.8 23.4-1.6 1.9-4.9 5.4-5 6.4 0 1.3.9 1.8 2.2 1.8 2 0 6.4-3.5 8-4.7 5-3.9 11.8-9.9 16.6-14.1l14.8-136.8c-30.5 17.1-197.6 17.2-228.3.2zm229.7-8.5c0 21-231.2 21-231.2 0 0-8.8 51.8-15.9 115.6-15.9 9 0 17.8.1 26.3.4l12.6-48.7L228.1.6c1.4-1.4 5.8-.2 9.9 3.5s6.6 7.9 5.3 9.3l-.1.1L185.9 74l-10 40.7c39.9 2.6 67.6 8.1 67.6 14.6zm-69.4 4.6c0-.8-.9-1.5-2.5-2.1l-.2.8c0 1.3-5 2.4-11.1 2.4s-11.1-1.1-11.1-2.4c0-.1 0-.2.1-.3l.2-.7c-1.8.6-3 1.4-3 2.3 0 2.1 6.2 3.7 13.7 3.7 7.7.1 13.9-1.6 13.9-3.7z"
        ],
        "hacker-news": [
            448,
            512,
            [],
            "f1d4",
            "M0 32v448h448V32H0zm21.2 197.2H21c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4zm218 53.9V384h-31.4V281.3L128 128h37.3c52.5 98.3 49.2 101.2 59.3 125.6 12.3-27 5.8-24.4 60.6-125.6H320l-80.8 155.1z"
        ],
        "hacker-news-square": [
            448,
            512,
            [],
            "f3af",
            "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM21.2 229.2H21c.1-.1.2-.3.3-.4 0 .1 0 .3-.1.4zm218 53.9V384h-31.4V281.3L128 128h37.3c52.5 98.3 49.2 101.2 59.3 125.6 12.3-27 5.8-24.4 60.6-125.6H320l-80.8 155.1z"
        ],
        "hackerrank": [
            512,
            512,
            [],
            "f5f7",
            "M477.5 128C463 103.05 285.13 0 256.16 0S49.25 102.79 34.84 128s-14.49 230.8 0 256 192.38 128 221.32 128S463 409.08 477.49 384s14.51-231 .01-256zM316.13 414.22c-4 0-40.91-35.77-38-38.69.87-.87 6.26-1.48 17.55-1.83 0-26.23.59-68.59.94-86.32 0-2-.44-3.43-.44-5.85h-79.93c0 7.1-.46 36.2 1.37 72.88.23 4.54-1.58 6-5.74 5.94-10.13 0-20.27-.11-30.41-.08-4.1 0-5.87-1.53-5.74-6.11.92-33.44 3-84-.15-212.67v-3.17c-9.67-.35-16.38-1-17.26-1.84-2.92-2.92 34.54-38.69 38.49-38.69s41.17 35.78 38.27 38.69c-.87.87-7.9 1.49-16.77 1.84v3.16c-2.42 25.75-2 79.59-2.63 105.39h80.26c0-4.55.39-34.74-1.2-83.64-.1-3.39.95-5.17 4.21-5.2 11.07-.08 22.15-.13 33.23-.06 3.46 0 4.57 1.72 4.5 5.38C333 354.64 336 341.29 336 373.69c8.87.35 16.82 1 17.69 1.84 2.88 2.91-33.62 38.69-37.58 38.69z"
        ],
        "hips": [
            640,
            512,
            [],
            "f452",
            "M251.6 157.6c0-1.9-.9-2.8-2.8-2.8h-40.9c-1.6 0-2.7 1.4-2.7 2.8v201.8c0 1.4 1.1 2.8 2.7 2.8h40.9c1.9 0 2.8-.9 2.8-2.8zM156.5 168c-16.1-11.8-36.3-17.9-60.3-18-18.1-.1-34.6 3.7-49.8 11.4V80.2c0-1.8-.9-2.7-2.8-2.7H2.7c-1.8 0-2.7.9-2.7 2.7v279.2c0 1.9.9 2.8 2.7 2.8h41c1.9 0 2.8-.9 2.8-2.8V223.3c0-.8-2.8-27 45.8-27 48.5 0 45.8 26.1 45.8 27v122.6c0 9 7.3 16.3 16.4 16.3h27.3c1.8 0 2.7-.9 2.7-2.8V223.3c0-23.4-9.3-41.8-28-55.3zm478.4 110.1c-6.8-15.7-18.4-27-34.9-34.1l-57.6-25.3c-8.6-3.6-9.2-11.2-2.6-16.1 7.4-5.5 44.3-13.9 84 6.8 1.7 1 4-.3 4-2.4v-44.7c0-1.3-.6-2.1-1.9-2.6-17.7-6.6-36.1-9.9-55.1-9.9-26.5 0-45.3 5.8-58.5 15.4-.5.4-28.4 20-22.7 53.7 3.4 19.6 15.8 34.2 37.2 43.6l53.6 23.5c11.6 5.1 15.2 13.3 12.2 21.2-3.7 9.1-13.2 13.6-36.5 13.6-24.3 0-44.7-8.9-58.4-19.1-2.1-1.4-4.4.2-4.4 2.3v34.4c0 10.4 4.9 17.3 14.6 20.7 15.6 5.5 31.6 8.2 48.2 8.2 12.7 0 25.8-1.2 36.3-4.3.7-.3 36-8.9 45.6-45.8 3.5-13.5 2.4-26.5-3.1-39.1zM376.2 149.8c-31.7 0-104.2 20.1-104.2 103.5v183.5c0 .8.6 2.7 2.7 2.7h40.9c1.9 0 2.8-.9 2.8-2.7V348c16.5 12.7 35.8 19.1 57.7 19.1 60.5 0 108.7-48.5 108.7-108.7.1-60.3-48.2-108.6-108.6-108.6zm0 170.9c-17.2 0-31.9-6.1-44-18.2-12.2-12.2-18.2-26.8-18.2-44 0-34.5 27.6-62.2 62.2-62.2 34.5 0 62.2 27.6 62.2 62.2.1 34.3-27.3 62.2-62.2 62.2zM228.3 72.5c-15.9 0-28.8 12.9-28.9 28.9 0 15.6 12.7 28.9 28.9 28.9s28.9-13.1 28.9-28.9c0-16.2-13-28.9-28.9-28.9z"
        ],
        "hire-a-helper": [
            512,
            512,
            [],
            "f3b0",
            "M443.1 0H71.9C67.9 37.3 37.4 67.8 0 71.7v371.5c37.4 4.9 66 32.4 71.9 68.8h372.2c3-36.4 32.5-65.8 67.9-69.8V71.7c-36.4-5.9-65-35.3-68.9-71.7zm-37 404.9c-36.3 0-18.8-2-55.1-2-35.8 0-21 2-56.1 2-5.9 0-4.9-8.2 0-9.8 22.8-7.6 22.9-10.2 24.6-12.8 10.4-15.6 5.9-83 5.9-113 0-5.3-6.4-12.8-13.8-12.8H200.4c-7.4 0-13.8 7.5-13.8 12.8 0 30-4.5 97.4 5.9 113 1.7 2.5 1.8 5.2 24.6 12.8 4.9 1.6 6 9.8 0 9.8-35.1 0-20.3-2-56.1-2-36.3 0-18.8 2-55.1 2-7.9 0-5.8-10.8 0-10.8 10.2-3.4 13.5-3.5 21.7-13.8 7.7-12.9 7.9-44.4 7.9-127.8V151.3c0-22.2-12.2-28.3-28.6-32.4-8.8-2.2-4-11.8 1-11.8 36.5 0 20.6 2 57.1 2 32.7 0 16.5-2 49.2-2 3.3 0 8.5 8.3 1 10.8-4.9 1.6-27.6 3.7-27.6 39.3 0 45.6-.2 55.8 1 68.8 0 1.3 2.3 12.8 12.8 12.8h109.2c10.5 0 12.8-11.5 12.8-12.8 1.2-13 1-23.2 1-68.8 0-35.6-22.7-37.7-27.6-39.3-7.5-2.5-2.3-10.8 1-10.8 32.7 0 16.5 2 49.2 2 36.5 0 20.6-2 57.1-2 4.9 0 9.9 9.6 1 11.8-16.4 4.1-28.6 10.3-28.6 32.4v101.2c0 83.4.1 114.9 7.9 127.8 8.2 10.2 11.4 10.4 21.7 13.8 5.8 0 7.8 10.8 0 10.8z"
        ],
        "hive": [
            512,
            512,
            [],
            "e07f",
            "M260.353,254.878,131.538,33.1a2.208,2.208,0,0,0-3.829.009L.3,254.887A2.234,2.234,0,0,0,.3,257.122L129.116,478.9a2.208,2.208,0,0,0,3.83-.009L260.358,257.113A2.239,2.239,0,0,0,260.353,254.878Zm39.078-25.713a2.19,2.19,0,0,0,1.9,1.111h66.509a2.226,2.226,0,0,0,1.9-3.341L259.115,33.111a2.187,2.187,0,0,0-1.9-1.111H190.707a2.226,2.226,0,0,0-1.9,3.341ZM511.7,254.886,384.9,33.112A2.2,2.2,0,0,0,382.99,32h-66.6a2.226,2.226,0,0,0-1.906,3.34L440.652,256,314.481,476.66a2.226,2.226,0,0,0,1.906,3.34h66.6a2.2,2.2,0,0,0,1.906-1.112L511.7,257.114A2.243,2.243,0,0,0,511.7,254.886ZM366.016,284.917H299.508a2.187,2.187,0,0,0-1.9,1.111l-108.8,190.631a2.226,2.226,0,0,0,1.9,3.341h66.509a2.187,2.187,0,0,0,1.9-1.111l108.8-190.631A2.226,2.226,0,0,0,366.016,284.917Z"
        ],
        "hooli": [
            640,
            512,
            [],
            "f427",
            "M144.5 352l38.3.8c-13.2-4.6-26-10.2-38.3-16.8zm57.7-5.3v5.3l-19.4.8c36.5 12.5 69.9 14.2 94.7 7.2-19.9.2-45.8-2.6-75.3-13.3zm408.9-115.2c15.9 0 28.9-12.9 28.9-28.9s-12.9-24.5-28.9-24.5c-15.9 0-28.9 8.6-28.9 24.5s12.9 28.9 28.9 28.9zm-29 120.5H640V241.5h-57.9zm-73.7 0h57.9V156.7L508.4 184zm-31-119.4c-18.2-18.2-50.4-17.1-50.4-17.1s-32.3-1.1-50.4 17.1c-18.2 18.2-16.8 33.9-16.8 52.6s-1.4 34.3 16.8 52.5 50.4 17.1 50.4 17.1 32.3 1.1 50.4-17.1c18.2-18.2 16.8-33.8 16.8-52.5-.1-18.8 1.3-34.5-16.8-52.6zm-39.8 71.9c0 3.6-1.8 12.5-10.7 12.5s-10.7-8.9-10.7-12.5v-40.4c0-8.7 7.3-10.9 10.7-10.9s10.7 2.1 10.7 10.9zm-106.2-71.9c-18.2-18.2-50.4-17.1-50.4-17.1s-32.2-1.1-50.4 17.1c-1.9 1.9-3.7 3.9-5.3 6-38.2-29.6-72.5-46.5-102.1-61.1v-20.7l-22.5 10.6c-54.4-22.1-89-18.2-97.3.1 0 0-24.9 32.8 61.8 110.8V352h57.9v-28.6c-6.5-4.2-13-8.7-19.4-13.6-14.8-11.2-27.4-21.6-38.4-31.4v-31c13.1 14.7 30.5 31.4 53.4 50.3l4.5 3.6v-29.8c0-6.9 1.7-18.2 10.8-18.2s10.6 6.9 10.6 15V317c18 12.2 37.3 22.1 57.7 29.6v-93.9c0-18.7-13.4-37.4-40.6-37.4-15.8-.1-30.5 8.2-38.5 21.9v-54.3c41.9 20.9 83.9 46.5 99.9 58.3-10.2 14.6-9.3 28.1-9.3 43.7 0 18.7-1.4 34.3 16.8 52.5s50.4 17.1 50.4 17.1 32.3 1.1 50.4-17.1c18.2-18.2 16.7-33.8 16.7-52.5 0-18.5 1.5-34.2-16.7-52.3zM65.2 184v63.3c-48.7-54.5-38.9-76-35.2-79.1 13.5-11.4 37.5-8 64.4 2.1zm226.5 120.5c0 3.6-1.8 12.5-10.7 12.5s-10.7-8.9-10.7-12.5v-40.4c0-8.7 7.3-10.9 10.7-10.9s10.7 2.1 10.7 10.9z"
        ],
        "hornbill": [
            512,
            512,
            [],
            "f592",
            "M76.38 370.3a37.8 37.8 0 1 1-32.07-32.42c-78.28-111.35 52-190.53 52-190.53-5.86 43-8.24 91.16-8.24 91.16-67.31 41.49.93 64.06 39.81 72.87a140.38 140.38 0 0 0 131.66 91.94c1.92 0 3.77-.21 5.67-.28l.11 18.86c-99.22 1.39-158.7-29.14-188.94-51.6zm108-327.7A37.57 37.57 0 0 0 181 21.45a37.95 37.95 0 1 0-31.17 54.22c-22.55 29.91-53.83 89.57-52.42 190l21.84-.15c0-.9-.14-1.77-.14-2.68A140.42 140.42 0 0 1 207 132.71c8-37.71 30.7-114.3 73.8-44.29 0 0 48.14 2.38 91.18 8.24 0 0-77.84-128-187.59-54.06zm304.19 134.17a37.94 37.94 0 1 0-53.84-28.7C403 126.13 344.89 99 251.28 100.33l.14 22.5c2.7-.15 5.39-.41 8.14-.41a140.37 140.37 0 0 1 130.49 88.76c39.1 9 105.06 31.58 38.46 72.54 0 0-2.34 48.13-8.21 91.16 0 0 133.45-81.16 49-194.61a37.45 37.45 0 0 0 19.31-3.5zM374.06 436.24c21.43-32.46 46.42-89.69 45.14-179.66l-19.52.14c.08 2.06.3 4.07.3 6.15a140.34 140.34 0 0 1-91.39 131.45c-8.85 38.95-31.44 106.66-72.77 39.49 0 0-48.12-2.34-91.19-8.22 0 0 79.92 131.34 191.9 51a37.5 37.5 0 0 0 3.64 14 37.93 37.93 0 1 0 33.89-54.29z"
        ],
        "hotjar": [
            448,
            512,
            [],
            "f3b1",
            "M414.9 161.5C340.2 29 121.1 0 121.1 0S222.2 110.4 93 197.7C11.3 252.8-21 324.4 14 402.6c26.8 59.9 83.5 84.3 144.6 93.4-29.2-55.1-6.6-122.4-4.1-129.6 57.1 86.4 165 0 110.8-93.9 71 15.4 81.6 138.6 27.1 215.5 80.5-25.3 134.1-88.9 148.8-145.6 15.5-59.3 3.7-127.9-26.3-180.9z"
        ],
        "houzz": [
            448,
            512,
            [],
            "f27c",
            "M275.9 330.7H171.3V480H17V32h109.5v104.5l305.1 85.6V480H275.9z"
        ],
        "html5": [
            384,
            512,
            [],
            "f13b",
            "M0 32l34.9 395.8L191.5 480l157.6-52.2L384 32H0zm308.2 127.9H124.4l4.1 49.4h175.6l-13.6 148.4-97.9 27v.3h-1.1l-98.7-27.3-6-75.8h47.7L138 320l53.5 14.5 53.7-14.5 6-62.2H84.3L71.5 112.2h241.1l-4.4 47.7z"
        ],
        "hubspot": [
            512,
            512,
            [],
            "f3b2",
            "M267.4 211.6c-25.1 23.7-40.8 57.3-40.8 94.6 0 29.3 9.7 56.3 26 78L203.1 434c-4.4-1.6-9.1-2.5-14-2.5-10.8 0-20.9 4.2-28.5 11.8-7.6 7.6-11.8 17.8-11.8 28.6s4.2 20.9 11.8 28.5c7.6 7.6 17.8 11.6 28.5 11.6 10.8 0 20.9-3.9 28.6-11.6 7.6-7.6 11.8-17.8 11.8-28.5 0-4.2-.6-8.2-1.9-12.1l50-50.2c22 16.9 49.4 26.9 79.3 26.9 71.9 0 130-58.3 130-130.2 0-65.2-47.7-119.2-110.2-128.7V116c17.5-7.4 28.2-23.8 28.2-42.9 0-26.1-20.9-47.9-47-47.9S311.2 47 311.2 73.1c0 19.1 10.7 35.5 28.2 42.9v61.2c-15.2 2.1-29.6 6.7-42.7 13.6-27.6-20.9-117.5-85.7-168.9-124.8 1.2-4.4 2-9 2-13.8C129.8 23.4 106.3 0 77.4 0 48.6 0 25.2 23.4 25.2 52.2c0 28.9 23.4 52.3 52.2 52.3 9.8 0 18.9-2.9 26.8-7.6l163.2 114.7zm89.5 163.6c-38.1 0-69-30.9-69-69s30.9-69 69-69 69 30.9 69 69-30.9 69-69 69z"
        ],
        "ideal": [
            576,
            512,
            [],
            "e013",
            "M125.61,165.48a49.07,49.07,0,1,0,49.06,49.06A49.08,49.08,0,0,0,125.61,165.48ZM86.15,425.84h78.94V285.32H86.15Zm151.46-211.6c0-20-10-22.53-18.74-22.53H204.82V237.5h14.05C228.62,237.5,237.61,234.69,237.61,214.24Zm201.69,46V168.93h22.75V237.5h33.69C486.5,113.08,388.61,86.19,299.67,86.19H204.84V169h14c25.6,0,41.5,17.35,41.5,45.26,0,28.81-15.52,46-41.5,46h-14V425.88h94.83c144.61,0,194.94-67.16,196.72-165.64Zm-109.75,0H273.3V169h54.43v22.73H296v10.58h30V225H296V237.5h33.51Zm74.66,0-5.16-17.67H369.31l-5.18,17.67H340.47L368,168.92h32.35l27.53,91.34ZM299.65,32H32V480H299.65c161.85,0,251-79.73,251-224.52C550.62,172,518,32,299.65,32Zm0,426.92H53.07V53.07H299.65c142.1,0,229.9,64.61,229.9,202.41C529.55,389.57,448.55,458.92,299.65,458.92Zm83.86-264.85L376,219.88H392.4l-7.52-25.81Z"
        ],
        "imdb": [
            448,
            512,
            [],
            "f2d8",
            "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM21.3 229.2H21c.1-.1.2-.3.3-.4zM97 319.8H64V192h33zm113.2 0h-28.7v-86.4l-11.6 86.4h-20.6l-12.2-84.5v84.5h-29V192h42.8c3.3 19.8 6 39.9 8.7 59.9l7.6-59.9h43zm11.4 0V192h24.6c17.6 0 44.7-1.6 49 20.9 1.7 7.6 1.4 16.3 1.4 24.4 0 88.5 11.1 82.6-75 82.5zm160.9-29.2c0 15.7-2.4 30.9-22.2 30.9-9 0-15.2-3-20.9-9.8l-1.9 8.1h-29.8V192h31.7v41.7c6-6.5 12-9.2 20.9-9.2 21.4 0 22.2 12.8 22.2 30.1zM265 229.9c0-9.7 1.6-16-10.3-16v83.7c12.2.3 10.3-8.7 10.3-18.4zm85.5 26.1c0-5.4 1.1-12.7-6.2-12.7-6 0-4.9 8.9-4.9 12.7 0 .6-1.1 39.6 1.1 44.7.8 1.6 2.2 2.4 3.8 2.4 7.8 0 6.2-9 6.2-14.4z"
        ],
        "innosoft": [
            448,
            512,
            [],
            "e080",
            "M422.559,159.71a27.379,27.379,0,0,0-13.866-23.337,26.42,26.42,0,0,0-26.211.133L73.943,314.647V176.261a11.955,11.955,0,0,1,6.047-10.34L218.066,86.208a12.153,12.153,0,0,1,11.922.025l32.656,18.853L112.581,191.723v56L359.642,105.086,241.129,36.679c-10.992-6.129-22.3-6.255-33.8-.27l-164.6,95.026c-10.634,6.12-16.771,16.39-17.29,29.124l0,191.5c.17,10.135,5.08,18.672,13.474,23.428a27.037,27.037,0,0,0,26.736-.045L374.057,197.376V335.657a11.976,11.976,0,0,1-5.92,10.368L230.025,425.77a12.175,12.175,0,0,1-11.937.062l-32.723-18.9,150.051-86.627v-56L88.367,406.932l118.794,68.583a33.88,33.88,0,0,0,34.25-.327l164.527-94.995c10.746-6.631,16.649-17.118,16.624-29.528Z"
        ],
        "instagram": [
            448,
            512,
            [],
            "f16d",
            "M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
        ],
        "instagram-square": [
            448,
            512,
            [],
            "e055",
            "M224,202.66A53.34,53.34,0,1,0,277.36,256,53.38,53.38,0,0,0,224,202.66Zm124.71-41a54,54,0,0,0-30.41-30.41c-21-8.29-71-6.43-94.3-6.43s-73.25-1.93-94.31,6.43a54,54,0,0,0-30.41,30.41c-8.28,21-6.43,71.05-6.43,94.33S91,329.26,99.32,350.33a54,54,0,0,0,30.41,30.41c21,8.29,71,6.43,94.31,6.43s73.24,1.93,94.3-6.43a54,54,0,0,0,30.41-30.41c8.35-21,6.43-71.05,6.43-94.33S357.1,182.74,348.75,161.67ZM224,338a82,82,0,1,1,82-82A81.9,81.9,0,0,1,224,338Zm85.38-148.3a19.14,19.14,0,1,1,19.13-19.14A19.1,19.1,0,0,1,309.42,189.74ZM400,32H48A48,48,0,0,0,0,80V432a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V80A48,48,0,0,0,400,32ZM382.88,322c-1.29,25.63-7.14,48.34-25.85,67s-41.4,24.63-67,25.85c-26.41,1.49-105.59,1.49-132,0-25.63-1.29-48.26-7.15-67-25.85s-24.63-41.42-25.85-67c-1.49-26.42-1.49-105.61,0-132,1.29-25.63,7.07-48.34,25.85-67s41.47-24.56,67-25.78c26.41-1.49,105.59-1.49,132,0,25.63,1.29,48.33,7.15,67,25.85s24.63,41.42,25.85,67.05C384.37,216.44,384.37,295.56,382.88,322Z"
        ],
        "instalod": [
            512,
            512,
            [],
            "e081",
            "M153.384,480H387.113L502.554,275.765,204.229,333.211ZM504.726,240.078,387.113,32H155.669L360.23,267.9ZM124.386,48.809,7.274,256,123.236,461.154,225.627,165.561Z"
        ],
        "intercom": [
            448,
            512,
            [],
            "f7af",
            "M392 32H56C25.1 32 0 57.1 0 88v336c0 30.9 25.1 56 56 56h336c30.9 0 56-25.1 56-56V88c0-30.9-25.1-56-56-56zm-108.3 82.1c0-19.8 29.9-19.8 29.9 0v199.5c0 19.8-29.9 19.8-29.9 0V114.1zm-74.6-7.5c0-19.8 29.9-19.8 29.9 0v216.5c0 19.8-29.9 19.8-29.9 0V106.6zm-74.7 7.5c0-19.8 29.9-19.8 29.9 0v199.5c0 19.8-29.9 19.8-29.9 0V114.1zM59.7 144c0-19.8 29.9-19.8 29.9 0v134.3c0 19.8-29.9 19.8-29.9 0V144zm323.4 227.8c-72.8 63-241.7 65.4-318.1 0-15-12.8 4.4-35.5 19.4-22.7 65.9 55.3 216.1 53.9 279.3 0 14.9-12.9 34.3 9.8 19.4 22.7zm5.2-93.5c0 19.8-29.9 19.8-29.9 0V144c0-19.8 29.9-19.8 29.9 0v134.3z"
        ],
        "internet-explorer": [
            512,
            512,
            [],
            "f26b",
            "M483.049 159.706c10.855-24.575 21.424-60.438 21.424-87.871 0-72.722-79.641-98.371-209.673-38.577-107.632-7.181-211.221 73.67-237.098 186.457 30.852-34.862 78.271-82.298 121.977-101.158C125.404 166.85 79.128 228.002 43.992 291.725 23.246 329.651 0 390.94 0 436.747c0 98.575 92.854 86.5 180.251 42.006 31.423 15.43 66.559 15.573 101.695 15.573 97.124 0 184.249-54.294 216.814-146.022H377.927c-52.509 88.593-196.819 52.996-196.819-47.436H509.9c6.407-43.581-1.655-95.715-26.851-141.162zM64.559 346.877c17.711 51.15 53.703 95.871 100.266 123.304-88.741 48.94-173.267 29.096-100.266-123.304zm115.977-108.873c2-55.151 50.276-94.871 103.98-94.871 53.418 0 101.981 39.72 103.981 94.871H180.536zm184.536-187.6c21.425-10.287 48.563-22.003 72.558-22.003 31.422 0 54.274 21.717 54.274 53.722 0 20.003-7.427 49.007-14.569 67.867-26.28-42.292-65.986-81.584-112.263-99.586z"
        ],
        "invision": [
            448,
            512,
            [],
            "f7b0",
            "M407.4 32H40.6C18.2 32 0 50.2 0 72.6v366.8C0 461.8 18.2 480 40.6 480h366.8c22.4 0 40.6-18.2 40.6-40.6V72.6c0-22.4-18.2-40.6-40.6-40.6zM176.1 145.6c.4 23.4-22.4 27.3-26.6 27.4-14.9 0-27.1-12-27.1-27 .1-35.2 53.1-35.5 53.7-.4zM332.8 377c-65.6 0-34.1-74-25-106.6 14.1-46.4-45.2-59-59.9.7l-25.8 103.3H177l8.1-32.5c-31.5 51.8-94.6 44.4-94.6-4.3.1-14.3.9-14 23-104.1H81.7l9.7-35.6h76.4c-33.6 133.7-32.6 126.9-32.9 138.2 0 20.9 40.9 13.5 57.4-23.2l19.8-79.4h-32.3l9.7-35.6h68.8l-8.9 40.5c40.5-75.5 127.9-47.8 101.8 38-14.2 51.1-14.6 50.7-14.9 58.8 0 15.5 17.5 22.6 31.8-16.9L386 325c-10.5 36.7-29.4 52-53.2 52z"
        ],
        "ioxhost": [
            640,
            512,
            [],
            "f208",
            "M616 160h-67.3C511.2 70.7 422.9 8 320 8 183 8 72 119 72 256c0 16.4 1.6 32.5 4.7 48H24c-13.3 0-24 10.8-24 24 0 13.3 10.7 24 24 24h67.3c37.5 89.3 125.8 152 228.7 152 137 0 248-111 248-248 0-16.4-1.6-32.5-4.7-48H616c13.3 0 24-10.8 24-24 0-13.3-10.7-24-24-24zm-96 96c0 110.5-89.5 200-200 200-75.7 0-141.6-42-175.5-104H424c13.3 0 24-10.8 24-24 0-13.3-10.7-24-24-24H125.8c-3.8-15.4-5.8-31.4-5.8-48 0-110.5 89.5-200 200-200 75.7 0 141.6 42 175.5 104H216c-13.3 0-24 10.8-24 24 0 13.3 10.7 24 24 24h298.2c3.8 15.4 5.8 31.4 5.8 48zm-304-24h208c13.3 0 24 10.7 24 24 0 13.2-10.7 24-24 24H216c-13.3 0-24-10.7-24-24 0-13.2 10.7-24 24-24z"
        ],
        "itch-io": [
            512,
            512,
            [],
            "f83a",
            "M71.92 34.77C50.2 47.67 7.4 96.84 7 109.73v21.34c0 27.06 25.29 50.84 48.25 50.84 27.57 0 50.54-22.85 50.54-50 0 27.12 22.18 50 49.76 50s49-22.85 49-50c0 27.12 23.59 50 51.16 50h.5c27.57 0 51.16-22.85 51.16-50 0 27.12 21.47 50 49 50s49.76-22.85 49.76-50c0 27.12 23 50 50.54 50 23 0 48.25-23.78 48.25-50.84v-21.34c-.4-12.9-43.2-62.07-64.92-75C372.56 32.4 325.76 32 256 32S91.14 33.1 71.92 34.77zm132.32 134.39c-22 38.4-77.9 38.71-99.85.25-13.17 23.14-43.17 32.07-56 27.66-3.87 40.15-13.67 237.13 17.73 269.15 80 18.67 302.08 18.12 379.76 0 31.65-32.27 21.32-232 17.75-269.15-12.92 4.44-42.88-4.6-56-27.66-22 38.52-77.85 38.1-99.85-.24-7.1 12.49-23.05 28.94-51.76 28.94a57.54 57.54 0 0 1-51.75-28.94zm-41.58 53.77c16.47 0 31.09 0 49.22 19.78a436.91 436.91 0 0 1 88.18 0C318.22 223 332.85 223 349.31 223c52.33 0 65.22 77.53 83.87 144.45 17.26 62.15-5.52 63.67-33.95 63.73-42.15-1.57-65.49-32.18-65.49-62.79-39.25 6.43-101.93 8.79-155.55 0 0 30.61-23.34 61.22-65.49 62.79-28.42-.06-51.2-1.58-33.94-63.73 18.67-67 31.56-144.45 83.88-144.45zM256 270.79s-44.38 40.77-52.35 55.21l29-1.17v25.32c0 1.55 21.34.16 23.33.16 11.65.54 23.31 1 23.31-.16v-25.28l29 1.17c-8-14.48-52.35-55.24-52.35-55.24z"
        ],
        "itunes": [
            448,
            512,
            [],
            "f3b4",
            "M223.6 80.3C129 80.3 52.5 157 52.5 251.5S129 422.8 223.6 422.8s171.2-76.7 171.2-171.2c0-94.6-76.7-171.3-171.2-171.3zm79.4 240c-3.2 13.6-13.5 21.2-27.3 23.8-12.1 2.2-22.2 2.8-31.9-5-11.8-10-12-26.4-1.4-36.8 8.4-8 20.3-9.6 38-12.8 3-.5 5.6-1.2 7.7-3.7 3.2-3.6 2.2-2 2.2-80.8 0-5.6-2.7-7.1-8.4-6.1-4 .7-91.9 17.1-91.9 17.1-5 1.1-6.7 2.6-6.7 8.3 0 116.1.5 110.8-1.2 118.5-2.1 9-7.6 15.8-14.9 19.6-8.3 4.6-23.4 6.6-31.4 5.2-21.4-4-28.9-28.7-14.4-42.9 8.4-8 20.3-9.6 38-12.8 3-.5 5.6-1.2 7.7-3.7 5-5.7.9-127 2.6-133.7.4-2.6 1.5-4.8 3.5-6.4 2.1-1.7 5.8-2.7 6.7-2.7 101-19 113.3-21.4 115.1-21.4 5.7-.4 9 3 9 8.7-.1 170.6.4 161.4-1 167.6zM345.2 32H102.8C45.9 32 0 77.9 0 134.8v242.4C0 434.1 45.9 480 102.8 480h242.4c57 0 102.8-45.9 102.8-102.8V134.8C448 77.9 402.1 32 345.2 32zM223.6 444c-106.3 0-192.5-86.2-192.5-192.5S117.3 59 223.6 59s192.5 86.2 192.5 192.5S329.9 444 223.6 444z"
        ],
        "itunes-note": [
            384,
            512,
            [],
            "f3b5",
            "M381.9 388.2c-6.4 27.4-27.2 42.8-55.1 48-24.5 4.5-44.9 5.6-64.5-10.2-23.9-20.1-24.2-53.4-2.7-74.4 17-16.2 40.9-19.5 76.8-25.8 6-1.1 11.2-2.5 15.6-7.4 6.4-7.2 4.4-4.1 4.4-163.2 0-11.2-5.5-14.3-17-12.3-8.2 1.4-185.7 34.6-185.7 34.6-10.2 2.2-13.4 5.2-13.4 16.7 0 234.7 1.1 223.9-2.5 239.5-4.2 18.2-15.4 31.9-30.2 39.5-16.8 9.3-47.2 13.4-63.4 10.4-43.2-8.1-58.4-58-29.1-86.6 17-16.2 40.9-19.5 76.8-25.8 6-1.1 11.2-2.5 15.6-7.4 10.1-11.5 1.8-256.6 5.2-270.2.8-5.2 3-9.6 7.1-12.9 4.2-3.5 11.8-5.5 13.4-5.5 204-38.2 228.9-43.1 232.4-43.1 11.5-.8 18.1 6 18.1 17.6.2 344.5 1.1 326-1.8 338.5z"
        ],
        "java": [
            384,
            512,
            [],
            "f4e4",
            "M277.74 312.9c9.8-6.7 23.4-12.5 23.4-12.5s-38.7 7-77.2 10.2c-47.1 3.9-97.7 4.7-123.1 1.3-60.1-8 33-30.1 33-30.1s-36.1-2.4-80.6 19c-52.5 25.4 130 37 224.5 12.1zm-85.4-32.1c-19-42.7-83.1-80.2 0-145.8C296 53.2 242.84 0 242.84 0c21.5 84.5-75.6 110.1-110.7 162.6-23.9 35.9 11.7 74.4 60.2 118.2zm114.6-176.2c.1 0-175.2 43.8-91.5 140.2 24.7 28.4-6.5 54-6.5 54s62.7-32.4 33.9-72.9c-26.9-37.8-47.5-56.6 64.1-121.3zm-6.1 270.5a12.19 12.19 0 0 1-2 2.6c128.3-33.7 81.1-118.9 19.8-97.3a17.33 17.33 0 0 0-8.2 6.3 70.45 70.45 0 0 1 11-3c31-6.5 75.5 41.5-20.6 91.4zM348 437.4s14.5 11.9-15.9 21.2c-57.9 17.5-240.8 22.8-291.6.7-18.3-7.9 16-19 26.8-21.3 11.2-2.4 17.7-2 17.7-2-20.3-14.3-131.3 28.1-56.4 40.2C232.84 509.4 401 461.3 348 437.4zM124.44 396c-78.7 22 47.9 67.4 148.1 24.5a185.89 185.89 0 0 1-28.2-13.8c-44.7 8.5-65.4 9.1-106 4.5-33.5-3.8-13.9-15.2-13.9-15.2zm179.8 97.2c-78.7 14.8-175.8 13.1-233.3 3.6 0-.1 11.8 9.7 72.4 13.6 92.2 5.9 233.8-3.3 237.1-46.9 0 0-6.4 16.5-76.2 29.7zM260.64 353c-59.2 11.4-93.5 11.1-136.8 6.6-33.5-3.5-11.6-19.7-11.6-19.7-86.8 28.8 48.2 61.4 169.5 25.9a60.37 60.37 0 0 1-21.1-12.8z"
        ],
        "jedi-order": [
            448,
            512,
            [],
            "f50e",
            "M398.5 373.6c95.9-122.1 17.2-233.1 17.2-233.1 45.4 85.8-41.4 170.5-41.4 170.5 105-171.5-60.5-271.5-60.5-271.5 96.9 72.7-10.1 190.7-10.1 190.7 85.8 158.4-68.6 230.1-68.6 230.1s-.4-16.9-2.2-85.7c4.3 4.5 34.5 36.2 34.5 36.2l-24.2-47.4 62.6-9.1-62.6-9.1 20.2-55.5-31.4 45.9c-2.2-87.7-7.8-305.1-7.9-306.9v-2.4 1-1 2.4c0 1-5.6 219-7.9 306.9l-31.4-45.9 20.2 55.5-62.6 9.1 62.6 9.1-24.2 47.4 34.5-36.2c-1.8 68.8-2.2 85.7-2.2 85.7s-154.4-71.7-68.6-230.1c0 0-107-118.1-10.1-190.7 0 0-165.5 99.9-60.5 271.5 0 0-86.8-84.8-41.4-170.5 0 0-78.7 111 17.2 233.1 0 0-26.2-16.1-49.4-77.7 0 0 16.9 183.3 222 185.7h4.1c205-2.4 222-185.7 222-185.7-23.6 61.5-49.9 77.7-49.9 77.7z"
        ],
        "jenkins": [
            512,
            512,
            [],
            "f3b6",
            "M487.1 425c-1.4-11.2-19-23.1-28.2-31.9-5.1-5-29-23.1-30.4-29.9-1.4-6.6 9.7-21.5 13.3-28.9 5.1-10.7 8.8-23.7 11.3-32.6 18.8-66.1 20.7-156.9-6.2-211.2-10.2-20.6-38.6-49-56.4-62.5-42-31.7-119.6-35.3-170.1-16.6-14.1 5.2-27.8 9.8-40.1 17.1-33.1 19.4-68.3 32.5-78.1 71.6-24.2 10.8-31.5 41.8-30.3 77.8.2 7 4.1 15.8 2.7 22.4-.7 3.3-5.2 7.6-6.1 9.8-11.6 27.7-2.3 64 11.1 83.7 8.1 11.9 21.5 22.4 39.2 25.2.7 10.6 3.3 19.7 8.2 30.4 3.1 6.8 14.7 19 10.4 27.7-2.2 4.4-21 13.8-27.3 17.6C89 407.2 73.7 415 54.2 429c-12.6 9-32.3 10.2-29.2 31.1 2.1 14.1 10.1 31.6 14.7 45.8.7 2 1.4 4.1 2.1 6h422c4.9-15.3 9.7-30.9 14.6-47.2 3.4-11.4 10.2-27.8 8.7-39.7zM205.9 33.7c1.8-.5 3.4.7 4.9 2.4-.2 5.2-5.4 5.1-8.9 6.8-5.4 6.7-13.4 9.8-20 17.2-6.8 7.5-14.4 27.7-23.4 30-4.5 1.1-9.7-.8-13.6-.5-10.4.7-17.7 6-28.3 7.5 13.6-29.9 56.1-54 89.3-63.4zm-104.8 93.6c13.5-14.9 32.1-24.1 54.8-25.9 11.7 29.7-8.4 65-.9 97.6 2.3 9.9 10.2 25.4-2.4 25.7.3-28.3-34.8-46.3-61.3-29.6-1.8-21.5-4.9-51.7 9.8-67.8zm36.7 200.2c-1-4.1-2.7-12.9-2.3-15.1 1.6-8.7 17.1-12.5 11-24.7-11.3-.1-13.8 10.2-24.1 11.3-26.7 2.6-45.6-35.4-44.4-58.4 1-19.5 17.6-38.2 40.1-35.8 16 1.8 21.4 19.2 24.5 34.7 9.2.5 22.5-.4 26.9-7.6-.6-17.5-8.8-31.6-8.2-47.7 1-30.3 17.5-57.6 4.8-87.4 13.6-30.9 53.5-55.3 83.1-70 36.6-18.3 94.9-3.7 129.3 15.8 19.7 11.1 34.4 32.7 48.3 50.7-19.5-5.8-36.1 4.2-33.1 20.3 16.3-14.9 44.2-.2 52.5 16.4 7.9 15.8 7.8 39.3 9 62.8 2.9 57-10.4 115.9-39.1 157.1-7.7 11-14.1 23-24.9 30.6-26 18.2-65.4 34.7-99.2 23.4-44.7-15-65-44.8-89.5-78.8.7 18.7 13.8 34.1 26.8 48.4 11.3 12.5 25 26.6 39.7 32.4-12.3-2.9-31.1-3.8-36.2 7.2-28.6-1.9-55.1-4.8-68.7-24.2-10.6-15.4-21.4-41.4-26.3-61.4zm222 124.1c4.1-3 11.1-2.9 17.4-3.6-5.4-2.7-13-3.7-19.3-2.2-.1-4.2-2-6.8-3.2-10.2 10.6-3.8 35.5-28.5 49.6-20.3 6.7 3.9 9.5 26.2 10.1 37 .4 9-.8 18-4.5 22.8-18.8-.6-35.8-2.8-50.7-7 .9-6.1-1-12.1.6-16.5zm-17.2-20c-16.8.8-26-1.2-38.3-10.8.2-.8 1.4-.5 1.5-1.4 18 8 40.8-3.3 59-4.9-7.9 5.1-14.6 11.6-22.2 17.1zm-12.1 33.2c-1.6-9.4-3.5-12-2.8-20.2 25-16.6 29.7 28.6 2.8 20.2zM226 438.6c-11.6-.7-48.1-14-38.5-23.7 9.4 6.5 27.5 4.9 41.3 7.3.8 4.4-2.8 10.2-2.8 16.4zM57.7 497.1c-4.3-12.7-9.2-25.1-14.8-36.9 30.8-23.8 65.3-48.9 102.2-63.5 2.8-1.1 23.2 25.4 26.2 27.6 16.5 11.7 37 21 56.2 30.2 1.2 8.8 3.9 20.2 8.7 35.5.7 2.3 1.4 4.7 2.2 7.2H57.7zm240.6 5.7h-.8c.3-.2.5-.4.8-.5v.5zm7.5-5.7c2.1-1.4 4.3-2.8 6.4-4.3 1.1 1.4 2.2 2.8 3.2 4.3h-9.6zm15.1-24.7c-10.8 7.3-20.6 18.3-33.3 25.2-6 3.3-27 11.7-33.4 10.2-3.6-.8-3.9-5.3-5.4-9.5-3.1-9-10.1-23.4-10.8-37-.8-17.2-2.5-46 16-42.4 14.9 2.9 32.3 9.7 43.9 16.1 7.1 3.9 11.1 8.6 21.9 9.5-.1 1.4-.1 2.8-.2 4.3-5.9 3.9-15.3 3.8-21.8 7.1 9.5.4 17 2.7 23.5 5.9-.1 3.4-.3 7-.4 10.6zm53.4 24.7h-14c-.1-3.2-2.8-5.8-6.1-5.8s-5.9 2.6-6.1 5.8h-17.4c-2.8-4.4-5.7-8.6-8.9-12.5 2.1-2.2 4-4.7 6-6.9 9 3.7 14.8-4.9 21.7-4.2 7.9.8 14.2 11.7 25.4 11l-.6 12.6zm8.7 0c.2-4 .4-7.8.6-11.5 15.6-7.3 29 1.3 35.7 11.5H383zm83.4-37c-2.3 11.2-5.8 24-9.9 37.1-.2-.1-.4-.1-.6-.1H428c.6-1.1 1.2-2.2 1.9-3.3-2.6-6.1-9-8.7-10.9-15.5 12.1-22.7 6.5-93.4-24.2-78.5 4.3-6.3 15.6-11.5 20.8-19.3 13 10.4 20.8 20.3 33.2 31.4 6.8 6 20 13.3 21.4 23.1.8 5.5-2.6 18.9-3.8 25.1zM222.2 130.5c5.4-14.9 27.2-34.7 45-32 7.7 1.2 18 8.2 12.2 17.7-30.2-7-45.2 12.6-54.4 33.1-8.1-2-4.9-13.1-2.8-18.8zm184.1 63.1c8.2-3.6 22.4-.7 29.6-5.3-4.2-11.5-10.3-21.4-9.3-37.7.5 0 1 0 1.4.1 6.8 14.2 12.7 29.2 21.4 41.7-5.7 13.5-43.6 25.4-43.1 1.2zm20.4-43zm-117.2 45.7c-6.8-10.9-19-32.5-14.5-45.3 6.5 11.9 8.6 24.4 17.8 33.3 4.1 4 12.2 9 8.2 20.2-.9 2.7-7.8 8.6-11.7 9.7-14.4 4.3-47.9.9-36.6-17.1 11.9.7 27.9 7.8 36.8-.8zm27.3 70c3.8 6.6 1.4 18.7 12.1 20.6 20.2 3.4 43.6-12.3 58.1-17.8 9-15.2-.8-20.7-8.9-30.5-16.6-20-38.8-44.8-38-74.7 6.7-4.9 7.3 7.4 8.2 9.7 8.7 20.3 30.4 46.2 46.3 63.5 3.9 4.3 10.3 8.4 11 11.2 2.1 8.2-5.4 18-4.5 23.5-21.7 13.9-45.8 29.1-81.4 25.6-7.4-6.7-10.3-21.4-2.9-31.1zm-201.3-9.2c-6.8-3.9-8.4-21-16.4-21.4-11.4-.7-9.3 22.2-9.3 35.5-7.8-7.1-9.2-29.1-3.5-40.3-6.6-3.2-9.5 3.6-13.1 5.9 4.7-34.1 49.8-15.8 42.3 20.3zm299.6 28.8c-10.1 19.2-24.4 40.4-54 41-.6-6.2-1.1-15.6 0-19.4 22.7-2.2 36.6-13.7 54-21.6zm-141.9 12.4c18.9 9.9 53.6 11 79.3 10.2 1.4 5.6 1.3 12.6 1.4 19.4-33 1.8-72-6.4-80.7-29.6zm92.2 46.7c-1.7 4.3-5.3 9.3-9.8 11.1-12.1 4.9-45.6 8.7-62.4-.3-10.7-5.7-17.5-18.5-23.4-26-2.8-3.6-16.9-12.9-.2-12.9 13.1 32.7 58 29 95.8 28.1z"
        ],
        "jira": [
            496,
            512,
            [],
            "f7b1",
            "M490 241.7C417.1 169 320.6 71.8 248.5 0 83 164.9 6 241.7 6 241.7c-7.9 7.9-7.9 20.7 0 28.7C138.8 402.7 67.8 331.9 248.5 512c379.4-378 15.7-16.7 241.5-241.7 8-7.9 8-20.7 0-28.6zm-241.5 90l-76-75.7 76-75.7 76 75.7-76 75.7z"
        ],
        "joget": [
            496,
            512,
            [],
            "f3b7",
            "M378.1 45C337.6 19.9 292.6 8 248.2 8 165 8 83.8 49.9 36.9 125.9c-71.9 116.6-35.6 269.3 81 341.2s269.3 35.6 341.2-80.9c71.9-116.6 35.6-269.4-81-341.2zm51.8 323.2c-40.4 65.5-110.4 101.5-182 101.5-6.8 0-13.6-.4-20.4-1-9-13.6-19.9-33.3-23.7-42.4-5.7-13.7-27.2-45.6 31.2-67.1 51.7-19.1 176.7-16.5 208.8-17.6-4 9-8.6 17.9-13.9 26.6zm-200.8-86.3c-55.5-1.4-81.7-20.8-58.5-48.2s51.1-40.7 68.9-51.2c17.9-10.5 27.3-33.7-23.6-29.7C87.3 161.5 48.6 252.1 37.6 293c-8.8-49.7-.1-102.7 28.5-149.1C128 43.4 259.6 12.2 360.1 74.1c74.8 46.1 111.2 130.9 99.3 212.7-24.9-.5-179.3-3.6-230.3-4.9zm183.8-54.8c-22.7-6-57 11.3-86.7 27.2-29.7 15.8-31.1 8.2-31.1 8.2s40.2-28.1 50.7-34.5 31.9-14 13.4-24.6c-3.2-1.8-6.7-2.7-10.4-2.7-17.8 0-41.5 18.7-67.5 35.6-31.5 20.5-65.3 31.3-65.3 31.3l169.5-1.6 46.5-23.4s3.6-9.5-19.1-15.5z"
        ],
        "joomla": [
            448,
            512,
            [],
            "f1aa",
            "M.6 92.1C.6 58.8 27.4 32 60.4 32c30 0 54.5 21.9 59.2 50.2 32.6-7.6 67.1.6 96.5 30l-44.3 44.3c-20.5-20.5-42.6-16.3-55.4-3.5-14.3 14.3-14.3 37.9 0 52.2l99.5 99.5-44 44.3c-87.7-87.2-49.7-49.7-99.8-99.7-26.8-26.5-35-64.8-24.8-98.9C20.4 144.6.6 120.7.6 92.1zm129.5 116.4l44.3 44.3c10-10 89.7-89.7 99.7-99.8 14.3-14.3 37.6-14.3 51.9 0 12.8 12.8 17 35-3.5 55.4l44 44.3c31.2-31.2 38.5-67.6 28.9-101.2 29.2-4.1 51.9-29.2 51.9-59.5 0-33.2-26.8-60.1-59.8-60.1-30.3 0-55.4 22.5-59.5 51.6-33.8-9.9-71.7-1.5-98.3 25.1-18.3 19.1-71.1 71.5-99.6 99.9zm266.3 152.2c8.2-32.7-.9-68.5-26.3-93.9-11.8-12.2 5 4.7-99.5-99.7l-44.3 44.3 99.7 99.7c14.3 14.3 14.3 37.6 0 51.9-12.8 12.8-35 17-55.4-3.5l-44 44.3c27.6 30.2 68 38.8 102.7 28 5.5 27.4 29.7 48.1 58.9 48.1 33 0 59.8-26.8 59.8-60.1 0-30.2-22.5-55-51.6-59.1zm-84.3-53.1l-44-44.3c-87 86.4-50.4 50.4-99.7 99.8-14.3 14.3-37.6 14.3-51.9 0-13.1-13.4-16.9-35.3 3.2-55.4l-44-44.3c-30.2 30.2-38 65.2-29.5 98.3-26.7 6-46.2 29.9-46.2 58.2C0 453.2 26.8 480 59.8 480c28.6 0 52.5-19.8 58.6-46.7 32.7 8.2 68.5-.6 94.2-26 32.1-32 12.2-12.4 99.5-99.7z"
        ],
        "js": [
            448,
            512,
            [],
            "f3b8",
            "M0 32v448h448V32H0zm243.8 349.4c0 43.6-25.6 63.5-62.9 63.5-33.7 0-53.2-17.4-63.2-38.5l34.3-20.7c6.6 11.7 12.6 21.6 27.1 21.6 13.8 0 22.6-5.4 22.6-26.5V237.7h42.1v143.7zm99.6 63.5c-39.1 0-64.4-18.6-76.7-43l34.3-19.8c9 14.7 20.8 25.6 41.5 25.6 17.4 0 28.6-8.7 28.6-20.8 0-14.4-11.4-19.5-30.7-28l-10.5-4.5c-30.4-12.9-50.5-29.2-50.5-63.5 0-31.6 24.1-55.6 61.6-55.6 26.8 0 46 9.3 59.8 33.7L368 290c-7.2-12.9-15-18-27.1-18-12.3 0-20.1 7.8-20.1 18 0 12.6 7.8 17.7 25.9 25.6l10.5 4.5c35.8 15.3 55.9 31 55.9 66.2 0 37.8-29.8 58.6-69.7 58.6z"
        ],
        "js-square": [
            448,
            512,
            [],
            "f3b9",
            "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM243.8 381.4c0 43.6-25.6 63.5-62.9 63.5-33.7 0-53.2-17.4-63.2-38.5l34.3-20.7c6.6 11.7 12.6 21.6 27.1 21.6 13.8 0 22.6-5.4 22.6-26.5V237.7h42.1v143.7zm99.6 63.5c-39.1 0-64.4-18.6-76.7-43l34.3-19.8c9 14.7 20.8 25.6 41.5 25.6 17.4 0 28.6-8.7 28.6-20.8 0-14.4-11.4-19.5-30.7-28l-10.5-4.5c-30.4-12.9-50.5-29.2-50.5-63.5 0-31.6 24.1-55.6 61.6-55.6 26.8 0 46 9.3 59.8 33.7L368 290c-7.2-12.9-15-18-27.1-18-12.3 0-20.1 7.8-20.1 18 0 12.6 7.8 17.7 25.9 25.6l10.5 4.5c35.8 15.3 55.9 31 55.9 66.2 0 37.8-29.8 58.6-69.7 58.6z"
        ],
        "jsfiddle": [
            576,
            512,
            [],
            "f1cc",
            "M510.634 237.462c-4.727-2.621-5.664-5.748-6.381-10.776-2.352-16.488-3.539-33.619-9.097-49.095-35.895-99.957-153.99-143.386-246.849-91.646-27.37 15.25-48.971 36.369-65.493 63.903-3.184-1.508-5.458-2.71-7.824-3.686-30.102-12.421-59.049-10.121-85.331 9.167-25.531 18.737-36.422 44.548-32.676 76.408.355 3.025-1.967 7.621-4.514 9.545-39.712 29.992-56.031 78.065-41.902 124.615 13.831 45.569 57.514 79.796 105.608 81.433 30.291 1.031 60.637.546 90.959.539 84.041-.021 168.09.531 252.12-.48 52.664-.634 96.108-36.873 108.212-87.293 11.54-48.074-11.144-97.3-56.832-122.634zm21.107 156.88c-18.23 22.432-42.343 35.253-71.28 35.65-56.874.781-113.767.23-170.652.23 0 .7-163.028.159-163.728.154-43.861-.332-76.739-19.766-95.175-59.995-18.902-41.245-4.004-90.848 34.186-116.106 9.182-6.073 12.505-11.566 10.096-23.136-5.49-26.361 4.453-47.956 26.42-62.981 22.987-15.723 47.422-16.146 72.034-3.083 10.269 5.45 14.607 11.564 22.198-2.527 14.222-26.399 34.557-46.727 60.671-61.294 97.46-54.366 228.37 7.568 230.24 132.697.122 8.15 2.412 12.428 9.848 15.894 57.56 26.829 74.456 96.122 35.142 144.497zm-87.789-80.499c-5.848 31.157-34.622 55.096-66.666 55.095-16.953-.001-32.058-6.545-44.079-17.705-27.697-25.713-71.141-74.98-95.937-93.387-20.056-14.888-41.99-12.333-60.272 3.782-49.996 44.071 15.859 121.775 67.063 77.188 4.548-3.96 7.84-9.543 12.744-12.844 8.184-5.509 20.766-.884 13.168 10.622-17.358 26.284-49.33 38.197-78.863 29.301-28.897-8.704-48.84-35.968-48.626-70.179 1.225-22.485 12.364-43.06 35.414-55.965 22.575-12.638 46.369-13.146 66.991 2.474C295.68 280.7 320.467 323.97 352.185 343.47c24.558 15.099 54.254 7.363 68.823-17.506 28.83-49.209-34.592-105.016-78.868-63.46-3.989 3.744-6.917 8.932-11.41 11.72-10.975 6.811-17.333-4.113-12.809-10.353 20.703-28.554 50.464-40.44 83.271-28.214 31.429 11.714 49.108 44.366 42.76 78.186z"
        ],
        "kaggle": [
            320,
            512,
            [],
            "f5fa",
            "M304.2 501.5L158.4 320.3 298.2 185c2.6-2.7 1.7-10.5-5.3-10.5h-69.2c-3.5 0-7 1.8-10.5 5.3L80.9 313.5V7.5q0-7.5-7.5-7.5H21.5Q14 0 14 7.5v497q0 7.5 7.5 7.5h51.9q7.5 0 7.5-7.5v-109l30.8-29.3 110.5 140.6c3 3.5 6.5 5.3 10.5 5.3h66.9q5.25 0 6-3z"
        ],
        "keybase": [
            448,
            512,
            [],
            "f4f5",
            "M286.17 419a18 18 0 1 0 18 18 18 18 0 0 0-18-18zm111.92-147.6c-9.5-14.62-39.37-52.45-87.26-73.71q-9.1-4.06-18.38-7.27a78.43 78.43 0 0 0-47.88-104.13c-12.41-4.1-23.33-6-32.41-5.77-.6-2-1.89-11 9.4-35L198.66 32l-5.48 7.56c-8.69 12.06-16.92 23.55-24.34 34.89a51 51 0 0 0-8.29-1.25c-41.53-2.45-39-2.33-41.06-2.33-50.61 0-50.75 52.12-50.75 45.88l-2.36 36.68c-1.61 27 19.75 50.21 47.63 51.85l8.93.54a214 214 0 0 0-46.29 35.54C14 304.66 14 374 14 429.77v33.64l23.32-29.8a148.6 148.6 0 0 0 14.56 37.56c5.78 10.13 14.87 9.45 19.64 7.33 4.21-1.87 10-6.92 3.75-20.11a178.29 178.29 0 0 1-15.76-53.13l46.82-59.83-24.66 74.11c58.23-42.4 157.38-61.76 236.25-38.59 34.2 10.05 67.45.69 84.74-23.84.72-1 1.2-2.16 1.85-3.22a156.09 156.09 0 0 1 2.8 28.43c0 23.3-3.69 52.93-14.88 81.64-2.52 6.46 1.76 14.5 8.6 15.74 7.42 1.57 15.33-3.1 18.37-11.15C429 443 434 414 434 382.32c0-38.58-13-77.46-35.91-110.92zM142.37 128.58l-15.7-.93-1.39 21.79 13.13.78a93 93 0 0 0 .32 19.57l-22.38-1.34a12.28 12.28 0 0 1-11.76-12.79L107 119c1-12.17 13.87-11.27 13.26-11.32l29.11 1.73a144.35 144.35 0 0 0-7 19.17zm148.42 172.18a10.51 10.51 0 0 1-14.35-1.39l-9.68-11.49-34.42 27a8.09 8.09 0 0 1-11.13-1.08l-15.78-18.64a7.38 7.38 0 0 1 1.34-10.34l34.57-27.18-14.14-16.74-17.09 13.45a7.75 7.75 0 0 1-10.59-1s-3.72-4.42-3.8-4.53a7.38 7.38 0 0 1 1.37-10.34L214 225.19s-18.51-22-18.6-22.14a9.56 9.56 0 0 1 1.74-13.42 10.38 10.38 0 0 1 14.3 1.37l81.09 96.32a9.58 9.58 0 0 1-1.74 13.44zM187.44 419a18 18 0 1 0 18 18 18 18 0 0 0-18-18z"
        ],
        "keycdn": [
            512,
            512,
            [],
            "f3ba",
            "M63.8 409.3l60.5-59c32.1 42.8 71.1 66 126.6 67.4 30.5.7 60.3-7 86.4-22.4 5.1 5.3 18.5 19.5 20.9 22-32.2 20.7-69.6 31.1-108.1 30.2-43.3-1.1-84.6-16.7-117.7-44.4.3-.6-38.2 37.5-38.6 37.9 9.5 29.8-13.1 62.4-46.3 62.4C20.7 503.3 0 481.7 0 454.9c0-34.3 33.1-56.6 63.8-45.6zm354.9-252.4c19.1 31.3 29.6 67.4 28.7 104-1.1 44.8-19 87.5-48.6 121 .3.3 23.8 25.2 24.1 25.5 9.6-1.3 19.2 2 25.9 9.1 11.3 12 10.9 30.9-1.1 42.4-12 11.3-30.9 10.9-42.4-1.1-6.7-7-9.4-16.8-7.6-26.3-24.9-26.6-44.4-47.2-44.4-47.2 42.7-34.1 63.3-79.6 64.4-124.2.7-28.9-7.2-57.2-21.1-82.2l22.1-21zM104 53.1c6.7 7 9.4 16.8 7.6 26.3l45.9 48.1c-4.7 3.8-13.3 10.4-22.8 21.3-25.4 28.5-39.6 64.8-40.7 102.9-.7 28.9 6.1 57.2 20 82.4l-22 21.5C72.7 324 63.1 287.9 64.2 250.9c1-44.6 18.3-87.6 47.5-121.1l-25.3-26.4c-9.6 1.3-19.2-2-25.9-9.1-11.3-12-10.9-30.9 1.1-42.4C73.5 40.7 92.2 41 104 53.1zM464.9 8c26 0 47.1 22.4 47.1 48.3S490.9 104 464.9 104c-6.3.1-14-1.1-15.9-1.8l-62.9 59.7c-32.7-43.6-76.7-65.9-126.9-67.2-30.5-.7-60.3 6.8-86.2 22.4l-21.1-22C184.1 74.3 221.5 64 260 64.9c43.3 1.1 84.6 16.7 117.7 44.6l41.1-38.6c-1.5-4.7-2.2-9.6-2.2-14.5C416.5 29.7 438.9 8 464.9 8zM256.7 113.4c5.5 0 10.9.4 16.4 1.1 78.1 9.8 133.4 81.1 123.8 159.1-9.8 78.1-81.1 133.4-159.1 123.8-78.1-9.8-133.4-81.1-123.8-159.2 9.3-72.4 70.1-124.6 142.7-124.8zm-59 119.4c.6 22.7 12.2 41.8 32.4 52.2l-11 51.7h73.7l-11-51.7c20.1-10.9 32.1-29 32.4-52.2-.4-32.8-25.8-57.5-58.3-58.3-32.1.8-57.3 24.8-58.2 58.3zM256 160"
        ],
        "kickstarter": [
            448,
            512,
            [],
            "f3bb",
            "M400 480H48c-26.4 0-48-21.6-48-48V80c0-26.4 21.6-48 48-48h352c26.4 0 48 21.6 48 48v352c0 26.4-21.6 48-48 48zM199.6 178.5c0-30.7-17.6-45.1-39.7-45.1-25.8 0-40 19.8-40 44.5v154.8c0 25.8 13.7 45.6 40.5 45.6 21.5 0 39.2-14 39.2-45.6v-41.8l60.6 75.7c12.3 14.9 39 16.8 55.8 0 14.6-15.1 14.8-36.8 4-50.4l-49.1-62.8 40.5-58.7c9.4-13.5 9.5-34.5-5.6-49.1-16.4-15.9-44.6-17.3-61.4 7l-44.8 64.7v-38.8z"
        ],
        "kickstarter-k": [
            384,
            512,
            [],
            "f3bc",
            "M147.3 114.4c0-56.2-32.5-82.4-73.4-82.4C26.2 32 0 68.2 0 113.4v283c0 47.3 25.3 83.4 74.9 83.4 39.8 0 72.4-25.6 72.4-83.4v-76.5l112.1 138.3c22.7 27.2 72.1 30.7 103.2 0 27-27.6 27.3-67.4 7.4-92.2l-90.8-114.8 74.9-107.4c17.4-24.7 17.5-63.1-10.4-89.8-30.3-29-82.4-31.6-113.6 12.8L147.3 185v-70.6z"
        ],
        "korvue": [
            446,
            512,
            [],
            "f42f",
            "M386.5 34h-327C26.8 34 0 60.8 0 93.5v327.1C0 453.2 26.8 480 59.5 480h327.1c33 0 59.5-26.8 59.5-59.5v-327C446 60.8 419.2 34 386.5 34zM87.1 120.8h96v116l61.8-116h110.9l-81.2 132H87.1v-132zm161.8 272.1l-65.7-113.6v113.6h-96V262.1h191.5l88.6 130.8H248.9z"
        ],
        "laravel": [
            512,
            512,
            [],
            "f3bd",
            "M504.4,115.83a5.72,5.72,0,0,0-.28-.68,8.52,8.52,0,0,0-.53-1.25,6,6,0,0,0-.54-.71,9.36,9.36,0,0,0-.72-.94c-.23-.22-.52-.4-.77-.6a8.84,8.84,0,0,0-.9-.68L404.4,55.55a8,8,0,0,0-8,0L300.12,111h0a8.07,8.07,0,0,0-.88.69,7.68,7.68,0,0,0-.78.6,8.23,8.23,0,0,0-.72.93c-.17.24-.39.45-.54.71a9.7,9.7,0,0,0-.52,1.25c-.08.23-.21.44-.28.68a8.08,8.08,0,0,0-.28,2.08V223.18l-80.22,46.19V63.44a7.8,7.8,0,0,0-.28-2.09c-.06-.24-.2-.45-.28-.68a8.35,8.35,0,0,0-.52-1.24c-.14-.26-.37-.47-.54-.72a9.36,9.36,0,0,0-.72-.94,9.46,9.46,0,0,0-.78-.6,9.8,9.8,0,0,0-.88-.68h0L115.61,1.07a8,8,0,0,0-8,0L11.34,56.49h0a6.52,6.52,0,0,0-.88.69,7.81,7.81,0,0,0-.79.6,8.15,8.15,0,0,0-.71.93c-.18.25-.4.46-.55.72a7.88,7.88,0,0,0-.51,1.24,6.46,6.46,0,0,0-.29.67,8.18,8.18,0,0,0-.28,2.1v329.7a8,8,0,0,0,4,6.95l192.5,110.84a8.83,8.83,0,0,0,1.33.54c.21.08.41.2.63.26a7.92,7.92,0,0,0,4.1,0c.2-.05.37-.16.55-.22a8.6,8.6,0,0,0,1.4-.58L404.4,400.09a8,8,0,0,0,4-6.95V287.88l92.24-53.11a8,8,0,0,0,4-7V117.92A8.63,8.63,0,0,0,504.4,115.83ZM111.6,17.28h0l80.19,46.15-80.2,46.18L31.41,63.44Zm88.25,60V278.6l-46.53,26.79-33.69,19.4V123.5l46.53-26.79Zm0,412.78L23.37,388.5V77.32L57.06,96.7l46.52,26.8V338.68a6.94,6.94,0,0,0,.12.9,8,8,0,0,0,.16,1.18h0a5.92,5.92,0,0,0,.38.9,6.38,6.38,0,0,0,.42,1v0a8.54,8.54,0,0,0,.6.78,7.62,7.62,0,0,0,.66.84l0,0c.23.22.52.38.77.58a8.93,8.93,0,0,0,.86.66l0,0,0,0,92.19,52.18Zm8-106.17-80.06-45.32,84.09-48.41,92.26-53.11,80.13,46.13-58.8,33.56Zm184.52,4.57L215.88,490.11V397.8L346.6,323.2l45.77-26.15Zm0-119.13L358.68,250l-46.53-26.79V131.79l33.69,19.4L392.37,178Zm8-105.28-80.2-46.17,80.2-46.16,80.18,46.15Zm8,105.28V178L455,151.19l33.68-19.4v91.39h0Z"
        ],
        "lastfm": [
            512,
            512,
            [],
            "f202",
            "M225.8 367.1l-18.8-51s-30.5 34-76.2 34c-40.5 0-69.2-35.2-69.2-91.5 0-72.1 36.4-97.9 72.1-97.9 66.5 0 74.8 53.3 100.9 134.9 18.8 56.9 54 102.6 155.4 102.6 72.7 0 122-22.3 122-80.9 0-72.9-62.7-80.6-115-92.1-25.8-5.9-33.4-16.4-33.4-34 0-19.9 15.8-31.7 41.6-31.7 28.2 0 43.4 10.6 45.7 35.8l58.6-7c-4.7-52.8-41.1-74.5-100.9-74.5-52.8 0-104.4 19.9-104.4 83.9 0 39.9 19.4 65.1 68 76.8 44.9 10.6 79.8 13.8 79.8 45.7 0 21.7-21.1 30.5-61 30.5-59.2 0-83.9-31.1-97.9-73.9-32-96.8-43.6-163-161.3-163C45.7 113.8 0 168.3 0 261c0 89.1 45.7 137.2 127.9 137.2 66.2 0 97.9-31.1 97.9-31.1z"
        ],
        "lastfm-square": [
            448,
            512,
            [],
            "f203",
            "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-92.2 312.9c-63.4 0-85.4-28.6-97.1-64.1-16.3-51-21.5-84.3-63-84.3-22.4 0-45.1 16.1-45.1 61.2 0 35.2 18 57.2 43.3 57.2 28.6 0 47.6-21.3 47.6-21.3l11.7 31.9s-19.8 19.4-61.2 19.4c-51.3 0-79.9-30.1-79.9-85.8 0-57.9 28.6-92 82.5-92 73.5 0 80.8 41.4 100.8 101.9 8.8 26.8 24.2 46.2 61.2 46.2 24.9 0 38.1-5.5 38.1-19.1 0-19.9-21.8-22-49.9-28.6-30.4-7.3-42.5-23.1-42.5-48 0-40 32.3-52.4 65.2-52.4 37.4 0 60.1 13.6 63 46.6l-36.7 4.4c-1.5-15.8-11-22.4-28.6-22.4-16.1 0-26 7.3-26 19.8 0 11 4.8 17.6 20.9 21.3 32.7 7.1 71.8 12 71.8 57.5.1 36.7-30.7 50.6-76.1 50.6z"
        ],
        "leanpub": [
            576,
            512,
            [],
            "f212",
            "M386.539 111.485l15.096 248.955-10.979-.275c-36.232-.824-71.64 8.783-102.657 27.997-31.016-19.214-66.424-27.997-102.657-27.997-45.564 0-82.07 10.705-123.516 27.723L93.117 129.6c28.546-11.803 61.484-18.115 92.226-18.115 41.173 0 73.836 13.175 102.657 42.544 27.723-28.271 59.013-41.721 98.539-42.544zM569.07 448c-25.526 0-47.485-5.215-70.542-15.645-34.31-15.645-69.993-24.978-107.871-24.978-38.977 0-74.934 12.901-102.657 40.623-27.723-27.723-63.68-40.623-102.657-40.623-37.878 0-73.561 9.333-107.871 24.978C55.239 442.236 32.731 448 8.303 448H6.93L49.475 98.859C88.726 76.626 136.486 64 181.775 64 218.83 64 256.984 71.685 288 93.095 319.016 71.685 357.17 64 394.225 64c45.289 0 93.049 12.626 132.3 34.859L569.07 448zm-43.368-44.741l-34.036-280.246c-30.742-13.999-67.248-21.41-101.009-21.41-38.428 0-74.385 12.077-102.657 38.702-28.272-26.625-64.228-38.702-102.657-38.702-33.761 0-70.267 7.411-101.009 21.41L50.298 403.259c47.211-19.487 82.894-33.486 135.045-33.486 37.604 0 70.817 9.606 102.657 29.644 31.84-20.038 65.052-29.644 102.657-29.644 52.151 0 87.834 13.999 135.045 33.486z"
        ],
        "less": [
            640,
            512,
            [],
            "f41d",
            "M612.7 219c0-20.5 3.2-32.6 3.2-54.6 0-34.2-12.6-45.2-40.5-45.2h-20.5v24.2h6.3c14.2 0 17.3 4.7 17.3 22.1 0 16.3-1.6 32.6-1.6 51.5 0 24.2 7.9 33.6 23.6 37.3v1.6c-15.8 3.7-23.6 13.1-23.6 37.3 0 18.9 1.6 34.2 1.6 51.5 0 17.9-3.7 22.6-17.3 22.6v.5h-6.3V393h20.5c27.8 0 40.5-11 40.5-45.2 0-22.6-3.2-34.2-3.2-54.6 0-11 6.8-22.6 27.3-23.6v-27.3c-20.5-.7-27.3-12.3-27.3-23.3zm-105.6 32c-15.8-6.3-30.5-10-30.5-20.5 0-7.9 6.3-12.6 17.9-12.6s22.1 4.7 33.6 13.1l21-27.8c-13.1-10-31-20.5-55.2-20.5-35.7 0-59.9 20.5-59.9 49.4 0 25.7 22.6 38.9 41.5 46.2 16.3 6.3 32.1 11.6 32.1 22.1 0 7.9-6.3 13.1-20.5 13.1-13.1 0-26.3-5.3-40.5-16.3l-21 30.5c15.8 13.1 39.9 22.1 59.9 22.1 42 0 64.6-22.1 64.6-51s-22.5-41-43-47.8zm-358.9 59.4c-3.7 0-8.4-3.2-8.4-13.1V119.1H65.2c-28.4 0-41 11-41 45.2 0 22.6 3.2 35.2 3.2 54.6 0 11-6.8 22.6-27.3 23.6v27.3c20.5.5 27.3 12.1 27.3 23.1 0 19.4-3.2 31-3.2 53.6 0 34.2 12.6 45.2 40.5 45.2h20.5v-24.2h-6.3c-13.1 0-17.3-5.3-17.3-22.6s1.6-32.1 1.6-51.5c0-24.2-7.9-33.6-23.6-37.3v-1.6c15.8-3.7 23.6-13.1 23.6-37.3 0-18.9-1.6-34.2-1.6-51.5s3.7-22.1 17.3-22.1H93v150.8c0 32.1 11 53.1 43.1 53.1 10 0 17.9-1.6 23.6-3.7l-5.3-34.2c-3.1.8-4.6.8-6.2.8zM379.9 251c-16.3-6.3-31-10-31-20.5 0-7.9 6.3-12.6 17.9-12.6 11.6 0 22.1 4.7 33.6 13.1l21-27.8c-13.1-10-31-20.5-55.2-20.5-35.7 0-59.9 20.5-59.9 49.4 0 25.7 22.6 38.9 41.5 46.2 16.3 6.3 32.1 11.6 32.1 22.1 0 7.9-6.3 13.1-20.5 13.1-13.1 0-26.3-5.3-40.5-16.3l-20.5 30.5c15.8 13.1 39.9 22.1 59.9 22.1 42 0 64.6-22.1 64.6-51 .1-28.9-22.5-41-43-47.8zm-155-68.8c-38.4 0-75.1 32.1-74.1 82.5 0 52 34.2 82.5 79.3 82.5 18.9 0 39.9-6.8 56.2-17.9l-15.8-27.8c-11.6 6.8-22.6 10-34.2 10-21 0-37.3-10-41.5-34.2H290c.5-3.7 1.6-11 1.6-19.4.6-42.6-22.6-75.7-66.7-75.7zm-30 66.2c3.2-21 15.8-31 30.5-31 18.9 0 26.3 13.1 26.3 31h-56.8z"
        ],
        "line": [
            448,
            512,
            [],
            "f3c0",
            "M272.1 204.2v71.1c0 1.8-1.4 3.2-3.2 3.2h-11.4c-1.1 0-2.1-.6-2.6-1.3l-32.6-44v42.2c0 1.8-1.4 3.2-3.2 3.2h-11.4c-1.8 0-3.2-1.4-3.2-3.2v-71.1c0-1.8 1.4-3.2 3.2-3.2H219c1 0 2.1.5 2.6 1.4l32.6 44v-42.2c0-1.8 1.4-3.2 3.2-3.2h11.4c1.8-.1 3.3 1.4 3.3 3.1zm-82-3.2h-11.4c-1.8 0-3.2 1.4-3.2 3.2v71.1c0 1.8 1.4 3.2 3.2 3.2h11.4c1.8 0 3.2-1.4 3.2-3.2v-71.1c0-1.7-1.4-3.2-3.2-3.2zm-27.5 59.6h-31.1v-56.4c0-1.8-1.4-3.2-3.2-3.2h-11.4c-1.8 0-3.2 1.4-3.2 3.2v71.1c0 .9.3 1.6.9 2.2.6.5 1.3.9 2.2.9h45.7c1.8 0 3.2-1.4 3.2-3.2v-11.4c0-1.7-1.4-3.2-3.1-3.2zM332.1 201h-45.7c-1.7 0-3.2 1.4-3.2 3.2v71.1c0 1.7 1.4 3.2 3.2 3.2h45.7c1.8 0 3.2-1.4 3.2-3.2v-11.4c0-1.8-1.4-3.2-3.2-3.2H301v-12h31.1c1.8 0 3.2-1.4 3.2-3.2V234c0-1.8-1.4-3.2-3.2-3.2H301v-12h31.1c1.8 0 3.2-1.4 3.2-3.2v-11.4c-.1-1.7-1.5-3.2-3.2-3.2zM448 113.7V399c-.1 44.8-36.8 81.1-81.7 81H81c-44.8-.1-81.1-36.9-81-81.7V113c.1-44.8 36.9-81.1 81.7-81H367c44.8.1 81.1 36.8 81 81.7zm-61.6 122.6c0-73-73.2-132.4-163.1-132.4-89.9 0-163.1 59.4-163.1 132.4 0 65.4 58 120.2 136.4 130.6 19.1 4.1 16.9 11.1 12.6 36.8-.7 4.1-3.3 16.1 14.1 8.8 17.4-7.3 93.9-55.3 128.2-94.7 23.6-26 34.9-52.3 34.9-81.5z"
        ],
        "linkedin": [
            448,
            512,
            [],
            "f08c",
            "M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"
        ],
        "linkedin-in": [
            448,
            512,
            [],
            "f0e1",
            "M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"
        ],
        "linode": [
            448,
            512,
            [],
            "f2b8",
            "M437.4 226.3c-.3-.9-.9-1.4-1.4-2l-70-38.6c-.9-.6-2-.6-3.1 0l-58.9 36c-.9.6-1.4 1.7-1.4 2.6l-.9 31.4-24-16c-.9-.6-2.3-.6-3.1 0L240 260.9l-1.4-35.1c0-.9-.6-2-1.4-2.3l-36-24.3 33.7-17.4c1.1-.6 1.7-1.7 1.7-2.9l-5.7-132.3c0-.9-.9-2-1.7-2.6L138.6.3c-.9-.3-1.7-.3-2.3-.3L12.6 38.6c-1.4.6-2.3 2-2 3.7L38 175.4c.9 3.4 34 27.4 38.6 30.9l-26.9 12.9c-1.4.9-2 2.3-1.7 3.4l20.6 100.3c.6 2.9 23.7 23.1 27.1 26.3l-17.4 10.6c-.9.6-1.7 2-1.4 3.1 1.4 7.1 15.4 77.7 16.9 79.1l65.1 69.1c.6.6 1.4.6 2.3.9.6 0 1.1-.3 1.7-.6l83.7-66.9c.9-.6 1.1-1.4 1.1-2.3l-2-46 28 23.7c1.1.9 2.9.9 4 0l66.9-53.4c.9-.6 1.1-1.4 1.1-2.3l2.3-33.4 20.3 14c1.1.9 2.6.9 3.7 0l54.6-43.7c.6-.3 1.1-1.1 1.1-2 .9-6.5 10.3-70.8 9.7-72.8zm-204.8 4.8l4 92.6-90.6 61.2-14-96.6 100.6-57.2zm-7.7-180l5.4 126-106.6 55.4L104 97.7l120.9-46.6zM44 173.1L18 48l79.7 49.4 19.4 132.9L44 173.1zm30.6 147.8L55.7 230l70 58.3 13.7 93.4-64.8-60.8zm24.3 117.7l-13.7-67.1 61.7 60.9 9.7 67.4-57.7-61.2zm64.5 64.5l-10.6-70.9 85.7-61.4 3.1 70-78.2 62.3zm82-115.1c0-3.4.9-22.9-2-25.1l-24.3-20 22.3-14.9c2.3-1.7 1.1-5.7 1.1-8l29.4 22.6.6 68.3-27.1-22.9zm94.3-25.4l-60.9 48.6-.6-68.6 65.7-46.9-4.2 66.9zm27.7-25.7l-19.1-13.4 2-34c.3-.9-.3-2-1.1-2.6L308 259.7l.6-30 64.6 40.6-5.8 66.6zm54.6-39.8l-48.3 38.3 5.7-65.1 51.1-36.6-8.5 63.4z"
        ],
        "linux": [
            448,
            512,
            [],
            "f17c",
            "M220.8 123.3c1 .5 1.8 1.7 3 1.7 1.1 0 2.8-.4 2.9-1.5.2-1.4-1.9-2.3-3.2-2.9-1.7-.7-3.9-1-5.5-.1-.4.2-.8.7-.6 1.1.3 1.3 2.3 1.1 3.4 1.7zm-21.9 1.7c1.2 0 2-1.2 3-1.7 1.1-.6 3.1-.4 3.5-1.6.2-.4-.2-.9-.6-1.1-1.6-.9-3.8-.6-5.5.1-1.3.6-3.4 1.5-3.2 2.9.1 1 1.8 1.5 2.8 1.4zM420 403.8c-3.6-4-5.3-11.6-7.2-19.7-1.8-8.1-3.9-16.8-10.5-22.4-1.3-1.1-2.6-2.1-4-2.9-1.3-.8-2.7-1.5-4.1-2 9.2-27.3 5.6-54.5-3.7-79.1-11.4-30.1-31.3-56.4-46.5-74.4-17.1-21.5-33.7-41.9-33.4-72C311.1 85.4 315.7.1 234.8 0 132.4-.2 158 103.4 156.9 135.2c-1.7 23.4-6.4 41.8-22.5 64.7-18.9 22.5-45.5 58.8-58.1 96.7-6 17.9-8.8 36.1-6.2 53.3-6.5 5.8-11.4 14.7-16.6 20.2-4.2 4.3-10.3 5.9-17 8.3s-14 6-18.5 14.5c-2.1 3.9-2.8 8.1-2.8 12.4 0 3.9.6 7.9 1.2 11.8 1.2 8.1 2.5 15.7.8 20.8-5.2 14.4-5.9 24.4-2.2 31.7 3.8 7.3 11.4 10.5 20.1 12.3 17.3 3.6 40.8 2.7 59.3 12.5 19.8 10.4 39.9 14.1 55.9 10.4 11.6-2.6 21.1-9.6 25.9-20.2 12.5-.1 26.3-5.4 48.3-6.6 14.9-1.2 33.6 5.3 55.1 4.1.6 2.3 1.4 4.6 2.5 6.7v.1c8.3 16.7 23.8 24.3 40.3 23 16.6-1.3 34.1-11 48.3-27.9 13.6-16.4 36-23.2 50.9-32.2 7.4-4.5 13.4-10.1 13.9-18.3.4-8.2-4.4-17.3-15.5-29.7zM223.7 87.3c9.8-22.2 34.2-21.8 44-.4 6.5 14.2 3.6 30.9-4.3 40.4-1.6-.8-5.9-2.6-12.6-4.9 1.1-1.2 3.1-2.7 3.9-4.6 4.8-11.8-.2-27-9.1-27.3-7.3-.5-13.9 10.8-11.8 23-4.1-2-9.4-3.5-13-4.4-1-6.9-.3-14.6 2.9-21.8zM183 75.8c10.1 0 20.8 14.2 19.1 33.5-3.5 1-7.1 2.5-10.2 4.6 1.2-8.9-3.3-20.1-9.6-19.6-8.4.7-9.8 21.2-1.8 28.1 1 .8 1.9-.2-5.9 5.5-15.6-14.6-10.5-52.1 8.4-52.1zm-13.6 60.7c6.2-4.6 13.6-10 14.1-10.5 4.7-4.4 13.5-14.2 27.9-14.2 7.1 0 15.6 2.3 25.9 8.9 6.3 4.1 11.3 4.4 22.6 9.3 8.4 3.5 13.7 9.7 10.5 18.2-2.6 7.1-11 14.4-22.7 18.1-11.1 3.6-19.8 16-38.2 14.9-3.9-.2-7-1-9.6-2.1-8-3.5-12.2-10.4-20-15-8.6-4.8-13.2-10.4-14.7-15.3-1.4-4.9 0-9 4.2-12.3zm3.3 334c-2.7 35.1-43.9 34.4-75.3 18-29.9-15.8-68.6-6.5-76.5-21.9-2.4-4.7-2.4-12.7 2.6-26.4v-.2c2.4-7.6.6-16-.6-23.9-1.2-7.8-1.8-15 .9-20 3.5-6.7 8.5-9.1 14.8-11.3 10.3-3.7 11.8-3.4 19.6-9.9 5.5-5.7 9.5-12.9 14.3-18 5.1-5.5 10-8.1 17.7-6.9 8.1 1.2 15.1 6.8 21.9 16l19.6 35.6c9.5 19.9 43.1 48.4 41 68.9zm-1.4-25.9c-4.1-6.6-9.6-13.6-14.4-19.6 7.1 0 14.2-2.2 16.7-8.9 2.3-6.2 0-14.9-7.4-24.9-13.5-18.2-38.3-32.5-38.3-32.5-13.5-8.4-21.1-18.7-24.6-29.9s-3-23.3-.3-35.2c5.2-22.9 18.6-45.2 27.2-59.2 2.3-1.7.8 3.2-8.7 20.8-8.5 16.1-24.4 53.3-2.6 82.4.6-20.7 5.5-41.8 13.8-61.5 12-27.4 37.3-74.9 39.3-112.7 1.1.8 4.6 3.2 6.2 4.1 4.6 2.7 8.1 6.7 12.6 10.3 12.4 10 28.5 9.2 42.4 1.2 6.2-3.5 11.2-7.5 15.9-9 9.9-3.1 17.8-8.6 22.3-15 7.7 30.4 25.7 74.3 37.2 95.7 6.1 11.4 18.3 35.5 23.6 64.6 3.3-.1 7 .4 10.9 1.4 13.8-35.7-11.7-74.2-23.3-84.9-4.7-4.6-4.9-6.6-2.6-6.5 12.6 11.2 29.2 33.7 35.2 59 2.8 11.6 3.3 23.7.4 35.7 16.4 6.8 35.9 17.9 30.7 34.8-2.2-.1-3.2 0-4.2 0 3.2-10.1-3.9-17.6-22.8-26.1-19.6-8.6-36-8.6-38.3 12.5-12.1 4.2-18.3 14.7-21.4 27.3-2.8 11.2-3.6 24.7-4.4 39.9-.5 7.7-3.6 18-6.8 29-32.1 22.9-76.7 32.9-114.3 7.2zm257.4-11.5c-.9 16.8-41.2 19.9-63.2 46.5-13.2 15.7-29.4 24.4-43.6 25.5s-26.5-4.8-33.7-19.3c-4.7-11.1-2.4-23.1 1.1-36.3 3.7-14.2 9.2-28.8 9.9-40.6.8-15.2 1.7-28.5 4.2-38.7 2.6-10.3 6.6-17.2 13.7-21.1.3-.2.7-.3 1-.5.8 13.2 7.3 26.6 18.8 29.5 12.6 3.3 30.7-7.5 38.4-16.3 9-.3 15.7-.9 22.6 5.1 9.9 8.5 7.1 30.3 17.1 41.6 10.6 11.6 14 19.5 13.7 24.6zM173.3 148.7c2 1.9 4.7 4.5 8 7.1 6.6 5.2 15.8 10.6 27.3 10.6 11.6 0 22.5-5.9 31.8-10.8 4.9-2.6 10.9-7 14.8-10.4s5.9-6.3 3.1-6.6-2.6 2.6-6 5.1c-4.4 3.2-9.7 7.4-13.9 9.8-7.4 4.2-19.5 10.2-29.9 10.2s-18.7-4.8-24.9-9.7c-3.1-2.5-5.7-5-7.7-6.9-1.5-1.4-1.9-4.6-4.3-4.9-1.4-.1-1.8 3.7 1.7 6.5z"
        ],
        "lyft": [
            512,
            512,
            [],
            "f3c3",
            "M0 81.1h77.8v208.7c0 33.1 15 52.8 27.2 61-12.7 11.1-51.2 20.9-80.2-2.8C7.8 334 0 310.7 0 289V81.1zm485.9 173.5v-22h23.8v-76.8h-26.1c-10.1-46.3-51.2-80.7-100.3-80.7-56.6 0-102.7 46-102.7 102.7V357c16 2.3 35.4-.3 51.7-14 17.1-14 24.8-37.2 24.8-59v-6.7h38.8v-76.8h-38.8v-23.3c0-34.6 52.2-34.6 52.2 0v77.1c0 56.6 46 102.7 102.7 102.7v-76.5c-14.5 0-26.1-11.7-26.1-25.9zm-294.3-99v113c0 15.4-23.8 15.4-23.8 0v-113H91v132.7c0 23.8 8 54 45 63.9 37 9.8 58.2-10.6 58.2-10.6-2.1 13.4-14.5 23.3-34.9 25.3-15.5 1.6-35.2-3.6-45-7.8v70.3c25.1 7.5 51.5 9.8 77.6 4.7 47.1-9.1 76.8-48.4 76.8-100.8V155.1h-77.1v.5z"
        ],
        "magento": [
            448,
            512,
            [],
            "f3c4",
            "M445.7 127.9V384l-63.4 36.5V164.7L223.8 73.1 65.2 164.7l.4 255.9L2.3 384V128.1L224.2 0l221.5 127.9zM255.6 420.5L224 438.9l-31.8-18.2v-256l-63.3 36.6.1 255.9 94.9 54.9 95.1-54.9v-256l-63.4-36.6v255.9z"
        ],
        "mailchimp": [
            448,
            512,
            [],
            "f59e",
            "M330.61 243.52a36.15 36.15 0 0 1 9.3 0c1.66-3.83 1.95-10.43.45-17.61-2.23-10.67-5.25-17.14-11.48-16.13s-6.47 8.74-4.24 19.42c1.26 6 3.49 11.14 6 14.32zM277.05 252c4.47 2 7.2 3.26 8.28 2.13 1.89-1.94-3.48-9.39-12.12-13.09a31.44 31.44 0 0 0-30.61 3.68c-3 2.18-5.81 5.22-5.41 7.06.85 3.74 10-2.71 22.6-3.48 7-.44 12.8 1.75 17.26 3.71zm-9 5.13c-9.07 1.42-15 6.53-13.47 10.1.9.34 1.17.81 5.21-.81a37 37 0 0 1 18.72-1.95c2.92.34 4.31.52 4.94-.49 1.46-2.22-5.71-8-15.39-6.85zm54.17 17.1c3.38-6.87-10.9-13.93-14.3-7s10.92 13.88 14.32 6.97zm15.66-20.47c-7.66-.13-7.95 15.8-.26 15.93s7.98-15.81.28-15.96zm-218.79 78.9c-1.32.31-6 1.45-8.47-2.35-5.2-8 11.11-20.38 3-35.77-9.1-17.47-27.82-13.54-35.05-5.54-8.71 9.6-8.72 23.54-5 24.08 4.27.57 4.08-6.47 7.38-11.63a12.83 12.83 0 0 1 17.85-3.72c11.59 7.59 1.37 17.76 2.28 28.62 1.39 16.68 18.42 16.37 21.58 9a2.08 2.08 0 0 0-.2-2.33c.03.89.68-1.3-3.35-.39zm299.72-17.07c-3.35-11.73-2.57-9.22-6.78-20.52 2.45-3.67 15.29-24-3.07-43.25-10.4-10.92-33.9-16.54-41.1-18.54-1.5-11.39 4.65-58.7-21.52-83 20.79-21.55 33.76-45.29 33.73-65.65-.06-39.16-48.15-51-107.42-26.47l-12.55 5.33c-.06-.05-22.71-22.27-23.05-22.57C169.5-18-41.77 216.81 25.78 273.85l14.76 12.51a72.49 72.49 0 0 0-4.1 33.5c3.36 33.4 36 60.42 67.53 60.38 57.73 133.06 267.9 133.28 322.29 3 1.74-4.47 9.11-24.61 9.11-42.38s-10.09-25.27-16.53-25.27zm-316 48.16c-22.82-.61-47.46-21.15-49.91-45.51-6.17-61.31 74.26-75.27 84-12.33 4.54 29.64-4.67 58.49-34.12 57.81zM84.3 249.55C69.14 252.5 55.78 261.09 47.6 273c-4.88-4.07-14-12-15.59-15-13.01-24.85 14.24-73 33.3-100.21C112.42 90.56 186.19 39.68 220.36 48.91c5.55 1.57 23.94 22.89 23.94 22.89s-34.15 18.94-65.8 45.35c-42.66 32.85-74.89 80.59-94.2 132.4zM323.18 350.7s-35.74 5.3-69.51-7.07c6.21-20.16 27 6.1 96.4-13.81 15.29-4.38 35.37-13 51-25.35a102.85 102.85 0 0 1 7.12 24.28c3.66-.66 14.25-.52 11.44 18.1-3.29 19.87-11.73 36-25.93 50.84A106.86 106.86 0 0 1 362.55 421a132.45 132.45 0 0 1-20.34 8.58c-53.51 17.48-108.3-1.74-126-43a66.33 66.33 0 0 1-3.55-9.74c-7.53-27.2-1.14-59.83 18.84-80.37 1.23-1.31 2.48-2.85 2.48-4.79a8.45 8.45 0 0 0-1.92-4.54c-7-10.13-31.19-27.4-26.33-60.83 3.5-24 24.49-40.91 44.07-39.91l5 .29c8.48.5 15.89 1.59 22.88 1.88 11.69.5 22.2-1.19 34.64-11.56 4.2-3.5 7.57-6.54 13.26-7.51a17.45 17.45 0 0 1 13.6 2.24c10 6.64 11.4 22.73 11.92 34.49.29 6.72 1.1 23 1.38 27.63.63 10.67 3.43 12.17 9.11 14 3.19 1.05 6.15 1.83 10.51 3.06 13.21 3.71 21 7.48 26 12.31a16.38 16.38 0 0 1 4.74 9.29c1.56 11.37-8.82 25.4-36.31 38.16-46.71 21.68-93.68 14.45-100.48 13.68-20.15-2.71-31.63 23.32-19.55 41.15 22.64 33.41 122.4 20 151.37-21.35.69-1 .12-1.59-.73-1-41.77 28.58-97.06 38.21-128.46 26-4.77-1.85-14.73-6.44-15.94-16.67 43.6 13.49 71 .74 71 .74s2.03-2.79-.56-2.53zm-68.47-5.7zm-83.4-187.5c16.74-19.35 37.36-36.18 55.83-45.63a.73.73 0 0 1 1 1c-1.46 2.66-4.29 8.34-5.19 12.65a.75.75 0 0 0 1.16.79c11.49-7.83 31.48-16.22 49-17.3a.77.77 0 0 1 .52 1.38 41.86 41.86 0 0 0-7.71 7.74.75.75 0 0 0 .59 1.19c12.31.09 29.66 4.4 41 10.74.76.43.22 1.91-.64 1.72-69.55-15.94-123.08 18.53-134.5 26.83a.76.76 0 0 1-1-1.12z"
        ],
        "mandalorian": [
            448,
            512,
            [],
            "f50f",
            "M232.27 511.89c-1-3.26-1.69-15.83-1.39-24.58.55-15.89 1-24.72 1.4-28.76.64-6.2 2.87-20.72 3.28-21.38.6-1 .4-27.87-.24-33.13-.31-2.58-.63-11.9-.69-20.73-.13-16.47-.53-20.12-2.73-24.76-1.1-2.32-1.23-3.84-1-11.43a92.38 92.38 0 0 0-.34-12.71c-2-13-3.46-27.7-3.25-33.9s.43-7.15 2.06-9.67c3.05-4.71 6.51-14 8.62-23.27 2.26-9.86 3.88-17.18 4.59-20.74a109.54 109.54 0 0 1 4.42-15.05c2.27-6.25 2.49-15.39.37-15.39-.3 0-1.38 1.22-2.41 2.71s-4.76 4.8-8.29 7.36c-8.37 6.08-11.7 9.39-12.66 12.58s-1 7.23-.16 7.76c.34.21 1.29 2.4 2.11 4.88a28.83 28.83 0 0 1 .72 15.36c-.39 1.77-1 5.47-1.46 8.23s-1 6.46-1.25 8.22a9.85 9.85 0 0 1-1.55 4.26c-1 1-1.14.91-2.05-.53a14.87 14.87 0 0 1-1.44-4.75c-.25-1.74-1.63-7.11-3.08-11.93-3.28-10.9-3.52-16.15-1-21a14.24 14.24 0 0 0 1.67-4.61c0-2.39-2.2-5.32-7.41-9.89-7-6.18-8.63-7.92-10.23-11.3-1.71-3.6-3.06-4.06-4.54-1.54-1.78 3-2.6 9.11-3 22l-.34 12.19 2 2.25c3.21 3.7 12.07 16.45 13.78 19.83 3.41 6.74 4.34 11.69 4.41 23.56s.95 22.75 2 24.71c.36.66.51 1.35.34 1.52s.41 2.09 1.29 4.27a38.14 38.14 0 0 1 2.06 9 91 91 0 0 0 1.71 10.37c2.23 9.56 2.77 14.08 2.39 20.14-.2 3.27-.53 11.07-.73 17.32-1.31 41.76-1.85 58-2 61.21-.12 2-.39 11.51-.6 21.07-.36 16.3-1.3 27.37-2.42 28.65-.64.73-8.07-4.91-12.52-9.49-3.75-3.87-4-4.79-2.83-9.95.7-3 2.26-18.29 3.33-32.62.36-4.78.81-10.5 1-12.71.83-9.37 1.66-20.35 2.61-34.78.56-8.46 1.33-16.44 1.72-17.73s.89-9.89 1.13-19.11l.43-16.77-2.26-4.3c-1.72-3.28-4.87-6.94-13.22-15.34-6-6.07-11.84-12.3-12.91-13.85l-1.95-2.81.75-10.9c1.09-15.71 1.1-48.57 0-59.06l-.89-8.7-3.28-4.52c-5.86-8.08-5.8-7.75-6.22-33.27-.1-6.07-.38-11.5-.63-12.06-.83-1.87-3.05-2.66-8.54-3.05-8.86-.62-11-1.9-23.85-14.55-6.15-6-12.34-12-13.75-13.19-2.81-2.42-2.79-2-.56-9.63l1.35-4.65-1.69-3a32.22 32.22 0 0 0-2.59-4.07c-1.33-1.51-5.5-10.89-6-13.49a4.24 4.24 0 0 1 .87-3.9c2.23-2.86 3.4-5.68 4.45-10.73 2.33-11.19 7.74-26.09 10.6-29.22 3.18-3.47 7.7-1 9.41 5 1.34 4.79 1.37 9.79.1 18.55a101.2 101.2 0 0 0-1 11.11c0 4 .19 4.69 2.25 7.39 3.33 4.37 7.73 7.41 15.2 10.52a18.67 18.67 0 0 1 4.72 2.85c11.17 10.72 18.62 16.18 22.95 16.85 5.18.8 8 4.54 10 13.39 1.31 5.65 4 11.14 5.46 11.14a9.38 9.38 0 0 0 3.33-1.39c2-1.22 2.25-1.73 2.25-4.18a132.88 132.88 0 0 0-2-17.84c-.37-1.66-.78-4.06-.93-5.35s-.61-3.85-1-5.69c-2.55-11.16-3.65-15.46-4.1-16-1.55-2-4.08-10.2-4.93-15.92-1.64-11.11-4-14.23-12.91-17.39A43.15 43.15 0 0 1 165.24 78c-1.15-1-4-3.22-6.35-5.06s-4.41-3.53-4.6-3.76a22.7 22.7 0 0 0-2.69-2c-6.24-4.22-8.84-7-11.26-12l-2.44-5-.22-13-.22-13 6.91-6.55c3.95-3.75 8.48-7.35 10.59-8.43 3.31-1.69 4.45-1.89 11.37-2 8.53-.19 10.12 0 11.66 1.56s1.36 6.4-.29 8.5a6.66 6.66 0 0 0-1.34 2.32c0 .58-2.61 4.91-5.42 9a30.39 30.39 0 0 0-2.37 6.82c20.44 13.39 21.55 3.77 14.07 29L194 66.92c3.11-8.66 6.47-17.26 8.61-26.22.29-7.63-12-4.19-15.4-8.68-2.33-5.93 3.13-14.18 6.06-19.2 1.6-2.34 6.62-4.7 8.82-4.15.88.22 4.16-.35 7.37-1.28a45.3 45.3 0 0 1 7.55-1.68 29.57 29.57 0 0 0 6-1.29c3.65-1.11 4.5-1.17 6.35-.4a29.54 29.54 0 0 0 5.82 1.36 18.18 18.18 0 0 1 6 1.91 22.67 22.67 0 0 0 5 2.17c2.51.68 3 .57 7.05-1.67l4.35-2.4L268.32 5c10.44-.4 10.81-.47 15.26-2.68L288.16 0l2.46 1.43c1.76 1 3.14 2.73 4.85 6 2.36 4.51 2.38 4.58 1.37 7.37-.88 2.44-.89 3.3-.1 6.39a35.76 35.76 0 0 0 2.1 5.91 13.55 13.55 0 0 1 1.31 4c.31 4.33 0 5.3-2.41 6.92-2.17 1.47-7 7.91-7 9.34a14.77 14.77 0 0 1-1.07 3c-5 11.51-6.76 13.56-14.26 17-9.2 4.2-12.3 5.19-16.21 5.19-3.1 0-4 .25-4.54 1.26a18.33 18.33 0 0 1-4.09 3.71 13.62 13.62 0 0 0-4.38 4.78 5.89 5.89 0 0 1-2.49 2.91 6.88 6.88 0 0 0-2.45 1.71 67.62 67.62 0 0 1-7 5.38c-3.33 2.34-6.87 5-7.87 6A7.27 7.27 0 0 1 224 100a5.76 5.76 0 0 0-2.13 1.65c-1.31 1.39-1.49 2.11-1.14 4.6a36.45 36.45 0 0 0 1.42 5.88c1.32 3.8 1.31 7.86 0 10.57s-.89 6.65 1.35 9.59c2 2.63 2.16 4.56.71 8.84a33.45 33.45 0 0 0-1.06 8.91c0 4.88.22 6.28 1.46 8.38s1.82 2.48 3.24 2.32c2-.23 2.3-1.05 4.71-12.12 2.18-10 3.71-11.92 13.76-17.08 2.94-1.51 7.46-4 10-5.44s6.79-3.69 9.37-4.91a40.09 40.09 0 0 0 15.22-11.67c7.11-8.79 10-16.22 12.85-33.3a18.37 18.37 0 0 1 2.86-7.73 20.39 20.39 0 0 0 2.89-7.31c1-5.3 2.85-9.08 5.58-11.51 4.7-4.18 6-1.09 4.59 10.87-.46 3.86-1.1 10.33-1.44 14.38l-.61 7.36 4.45 4.09 4.45 4.09.11 8.42c.06 4.63.47 9.53.92 10.89l.82 2.47-6.43 6.28c-8.54 8.33-12.88 13.93-16.76 21.61-1.77 3.49-3.74 7.11-4.38 8-2.18 3.11-6.46 13-8.76 20.26l-2.29 7.22-7 6.49c-3.83 3.57-8 7.25-9.17 8.17-3.05 2.32-4.26 5.15-4.26 10a14.62 14.62 0 0 0 1.59 7.26 42 42 0 0 1 2.09 4.83 9.28 9.28 0 0 0 1.57 2.89c1.4 1.59 1.92 16.12.83 23.22-.68 4.48-3.63 12-4.7 12-1.79 0-4.06 9.27-5.07 20.74-.18 2-.62 5.94-1 8.7s-1 10-1.35 16.05c-.77 12.22-.19 18.77 2 23.15 3.41 6.69.52 12.69-11 22.84l-4 3.49.07 5.19a40.81 40.81 0 0 0 1.14 8.87c4.61 16 4.73 16.92 4.38 37.13-.46 26.4-.26 40.27.63 44.15a61.31 61.31 0 0 1 1.08 7c.17 2 .66 5.33 1.08 7.36.47 2.26.78 11 .79 22.74v19.06l-1.81 2.63c-2.71 3.91-15.11 13.54-15.49 12.29zm29.53-45.11c-.18-.3-.33-6.87-.33-14.59 0-14.06-.89-27.54-2.26-34.45-.4-2-.81-9.7-.9-17.06-.15-11.93-1.4-24.37-2.64-26.38-.66-1.07-3-17.66-3-21.3 0-4.23 1-6 5.28-9.13s4.86-3.14 5.48-.72c.28 1.1 1.45 5.62 2.6 10 3.93 15.12 4.14 16.27 4.05 21.74-.1 5.78-.13 6.13-1.74 17.73-1 7.07-1.17 12.39-1 28.43.17 19.4-.64 35.73-2 41.27-.71 2.78-2.8 5.48-3.43 4.43zm-71-37.58a101 101 0 0 1-1.73-10.79 100.5 100.5 0 0 0-1.73-10.79 37.53 37.53 0 0 1-1-6.49c-.31-3.19-.91-7.46-1.33-9.48-1-4.79-3.35-19.35-3.42-21.07 0-.74-.34-4.05-.7-7.36-.67-6.21-.84-27.67-.22-28.29 1-1 6.63 2.76 11.33 7.43l5.28 5.25-.45 6.47c-.25 3.56-.6 10.23-.78 14.83s-.49 9.87-.67 11.71-.61 9.36-.94 16.72c-.79 17.41-1.94 31.29-2.65 32a.62.62 0 0 1-1-.14zm-87.18-266.59c21.07 12.79 17.84 14.15 28.49 17.66 13 4.29 18.87 7.13 23.15 16.87C111.6 233.28 86.25 255 78.55 268c-31 52-6 101.59 62.75 87.21-14.18 29.23-78 28.63-98.68-4.9-24.68-39.95-22.09-118.3 61-187.66zm210.79 179c56.66 6.88 82.32-37.74 46.54-89.23 0 0-26.87-29.34-64.28-68 3-15.45 9.49-32.12 30.57-53.82 89.2 63.51 92 141.61 92.46 149.36 4.3 70.64-78.7 91.18-105.29 61.71z"
        ],
        "markdown": [
            640,
            512,
            [],
            "f60f",
            "M593.8 59.1H46.2C20.7 59.1 0 79.8 0 105.2v301.5c0 25.5 20.7 46.2 46.2 46.2h547.7c25.5 0 46.2-20.7 46.1-46.1V105.2c0-25.4-20.7-46.1-46.2-46.1zM338.5 360.6H277v-120l-61.5 76.9-61.5-76.9v120H92.3V151.4h61.5l61.5 76.9 61.5-76.9h61.5v209.2zm135.3 3.1L381.5 256H443V151.4h61.5V256H566z"
        ],
        "mastodon": [
            448,
            512,
            [],
            "f4f6",
            "M433 179.11c0-97.2-63.71-125.7-63.71-125.7-62.52-28.7-228.56-28.4-290.48 0 0 0-63.72 28.5-63.72 125.7 0 115.7-6.6 259.4 105.63 289.1 40.51 10.7 75.32 13 103.33 11.4 50.81-2.8 79.32-18.1 79.32-18.1l-1.7-36.9s-36.31 11.4-77.12 10.1c-40.41-1.4-83-4.4-89.63-54a102.54 102.54 0 0 1-.9-13.9c85.63 20.9 158.65 9.1 178.75 6.7 56.12-6.7 105-41.3 111.23-72.9 9.8-49.8 9-121.5 9-121.5zm-75.12 125.2h-46.63v-114.2c0-49.7-64-51.6-64 6.9v62.5h-46.33V197c0-58.5-64-56.6-64-6.9v114.2H90.19c0-122.1-5.2-147.9 18.41-175 25.9-28.9 79.82-30.8 103.83 6.1l11.6 19.5 11.6-19.5c24.11-37.1 78.12-34.8 103.83-6.1 23.71 27.3 18.4 53 18.4 175z"
        ],
        "maxcdn": [
            512,
            512,
            [],
            "f136",
            "M461.1 442.7h-97.4L415.6 200c2.3-10.2.9-19.5-4.4-25.7-5-6.1-13.7-9.6-24.2-9.6h-49.3l-59.5 278h-97.4l59.5-278h-83.4l-59.5 278H0l59.5-278-44.6-95.4H387c39.4 0 75.3 16.3 98.3 44.9 23.3 28.6 31.8 67.4 23.6 105.9l-47.8 222.6z"
        ],
        "mdb": [
            576,
            512,
            [],
            "f8ca",
            "M17.37 160.41L7 352h43.91l5.59-79.83L84.43 352h44.71l25.54-77.43 4.79 77.43H205l-12.79-191.59H146.7L106 277.74 63.67 160.41zm281 0h-47.9V352h47.9s95 .8 94.2-95.79c-.78-94.21-94.18-95.78-94.18-95.78zm-1.2 146.46V204.78s46 4.27 46.8 50.57-46.78 51.54-46.78 51.54zm238.29-74.24a56.16 56.16 0 0 0 8-38.31c-5.34-35.76-55.08-34.32-55.08-34.32h-51.9v191.58H482s87 4.79 87-63.85c0-43.14-33.52-55.08-33.52-55.08zm-51.9-31.94s13.57-1.59 16 9.59c1.43 6.66-4 12-4 12h-12v-21.57zm-.1 109.46l.1-24.92V267h.08s41.58-4.73 41.19 22.43c-.33 25.65-41.35 20.74-41.35 20.74z"
        ],
        "medapps": [
            320,
            512,
            [],
            "f3c6",
            "M118.3 238.4c3.5-12.5 6.9-33.6 13.2-33.6 8.3 1.8 9.6 23.4 18.6 36.6 4.6-23.5 5.3-85.1 14.1-86.7 9-.7 19.7 66.5 22 77.5 9.9 4.1 48.9 6.6 48.9 6.6 1.9 7.3-24 7.6-40 7.8-4.6 14.8-5.4 27.7-11.4 28-4.7.2-8.2-28.8-17.5-49.6l-9.4 65.5c-4.4 13-15.5-22.5-21.9-39.3-3.3-.1-62.4-1.6-47.6-7.8l31-5zM228 448c21.2 0 21.2-32 0-32H92c-21.2 0-21.2 32 0 32h136zm-24 64c21.2 0 21.2-32 0-32h-88c-21.2 0-21.2 32 0 32h88zm34.2-141.5c3.2-18.9 5.2-36.4 11.9-48.8 7.9-14.7 16.1-28.1 24-41 24.6-40.4 45.9-75.2 45.9-125.5C320 69.6 248.2 0 160 0S0 69.6 0 155.2c0 50.2 21.3 85.1 45.9 125.5 7.9 12.9 16 26.3 24 41 6.7 12.5 8.7 29.8 11.9 48.9 3.5 21 36.1 15.7 32.6-5.1-3.6-21.7-5.6-40.7-15.3-58.6C66.5 246.5 33 211.3 33 155.2 33 87.3 90 32 160 32s127 55.3 127 123.2c0 56.1-33.5 91.3-66.1 151.6-9.7 18-11.7 37.4-15.3 58.6-3.4 20.6 29 26.4 32.6 5.1z"
        ],
        "medium": [
            448,
            512,
            [],
            "f23a",
            "M0 32v448h448V32H0zm372.2 106.1l-24 23c-2.1 1.6-3.1 4.2-2.7 6.7v169.3c-.4 2.6.6 5.2 2.7 6.7l23.5 23v5.1h-118V367l24.3-23.6c2.4-2.4 2.4-3.1 2.4-6.7V199.8l-67.6 171.6h-9.1L125 199.8v115c-.7 4.8 1 9.7 4.4 13.2l31.6 38.3v5.1H71.2v-5.1l31.6-38.3c3.4-3.5 4.9-8.4 4.1-13.2v-133c.4-3.7-1-7.3-3.8-9.8L75 138.1V133h87.3l67.4 148L289 133.1h83.2v5z"
        ],
        "medium-m": [
            512,
            512,
            [],
            "f3c7",
            "M71.5 142.3c.6-5.9-1.7-11.8-6.1-15.8L20.3 72.1V64h140.2l108.4 237.7L364.2 64h133.7v8.1l-38.6 37c-3.3 2.5-5 6.7-4.3 10.8v272c-.7 4.1 1 8.3 4.3 10.8l37.7 37v8.1H307.3v-8.1l39.1-37.9c3.8-3.8 3.8-5 3.8-10.8V171.2L241.5 447.1h-14.7L100.4 171.2v184.9c-1.1 7.8 1.5 15.6 7 21.2l50.8 61.6v8.1h-144v-8L65 377.3c5.4-5.6 7.9-13.5 6.5-21.2V142.3z"
        ],
        "medrt": [
            544,
            512,
            [],
            "f3c8",
            "M113.7 256c0 121.8 83.9 222.8 193.5 241.1-18.7 4.5-38.2 6.9-58.2 6.9C111.4 504 0 393 0 256S111.4 8 248.9 8c20.1 0 39.6 2.4 58.2 6.9C197.5 33.2 113.7 134.2 113.7 256m297.4 100.3c-77.7 55.4-179.6 47.5-240.4-14.6 5.5 14.1 12.7 27.7 21.7 40.5 61.6 88.2 182.4 109.3 269.7 47 87.3-62.3 108.1-184.3 46.5-272.6-9-12.9-19.3-24.3-30.5-34.2 37.4 78.8 10.7 178.5-67 233.9m-218.8-244c-1.4 1-2.7 2.1-4 3.1 64.3-17.8 135.9 4 178.9 60.5 35.7 47 42.9 106.6 24.4 158 56.7-56.2 67.6-142.1 22.3-201.8-50-65.5-149.1-74.4-221.6-19.8M296 224c-4.4 0-8-3.6-8-8v-40c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v40c0 4.4-3.6 8-8 8h-40c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h40c4.4 0 8 3.6 8 8v40c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-40z"
        ],
        "meetup": [
            512,
            512,
            [],
            "f2e0",
            "M99 414.3c1.1 5.7-2.3 11.1-8 12.3-5.4 1.1-10.9-2.3-12-8-1.1-5.4 2.3-11.1 7.7-12.3 5.4-1.2 11.1 2.3 12.3 8zm143.1 71.4c-6.3 4.6-8 13.4-3.7 20 4.6 6.6 13.4 8.3 20 3.7 6.3-4.6 8-13.4 3.4-20-4.2-6.5-13.1-8.3-19.7-3.7zm-86-462.3c6.3-1.4 10.3-7.7 8.9-14-1.1-6.6-7.4-10.6-13.7-9.1-6.3 1.4-10.3 7.7-9.1 14 1.4 6.6 7.6 10.6 13.9 9.1zM34.4 226.3c-10-6.9-23.7-4.3-30.6 6-6.9 10-4.3 24 5.7 30.9 10 7.1 23.7 4.6 30.6-5.7 6.9-10.4 4.3-24.1-5.7-31.2zm272-170.9c10.6-6.3 13.7-20 7.7-30.3-6.3-10.6-19.7-14-30-7.7s-13.7 20-7.4 30.6c6 10.3 19.4 13.7 29.7 7.4zm-191.1 58c7.7-5.4 9.4-16 4.3-23.7s-15.7-9.4-23.1-4.3c-7.7 5.4-9.4 16-4.3 23.7 5.1 7.8 15.6 9.5 23.1 4.3zm372.3 156c-7.4 1.7-12.3 9.1-10.6 16.9 1.4 7.4 8.9 12.3 16.3 10.6 7.4-1.4 12.3-8.9 10.6-16.6-1.5-7.4-8.9-12.3-16.3-10.9zm39.7-56.8c-1.1-5.7-6.6-9.1-12-8-5.7 1.1-9.1 6.9-8 12.6 1.1 5.4 6.6 9.1 12.3 8 5.4-1.5 9.1-6.9 7.7-12.6zM447 138.9c-8.6 6-10.6 17.7-4.9 26.3 5.7 8.6 17.4 10.6 26 4.9 8.3-6 10.3-17.7 4.6-26.3-5.7-8.7-17.4-10.9-25.7-4.9zm-6.3 139.4c26.3 43.1 15.1 100-26.3 129.1-17.4 12.3-37.1 17.7-56.9 17.1-12 47.1-69.4 64.6-105.1 32.6-1.1.9-2.6 1.7-3.7 2.9-39.1 27.1-92.3 17.4-119.4-22.3-9.7-14.3-14.6-30.6-15.1-46.9-65.4-10.9-90-94-41.1-139.7-28.3-46.9.6-107.4 53.4-114.9C151.6 70 234.1 38.6 290.1 82c67.4-22.3 136.3 29.4 130.9 101.1 41.1 12.6 52.8 66.9 19.7 95.2zm-70 74.3c-3.1-20.6-40.9-4.6-43.1-27.1-3.1-32 43.7-101.1 40-128-3.4-24-19.4-29.1-33.4-29.4-13.4-.3-16.9 2-21.4 4.6-2.9 1.7-6.6 4.9-11.7-.3-6.3-6-11.1-11.7-19.4-12.9-12.3-2-17.7 2-26.6 9.7-3.4 2.9-12 12.9-20 9.1-3.4-1.7-15.4-7.7-24-11.4-16.3-7.1-40 4.6-48.6 20-12.9 22.9-38 113.1-41.7 125.1-8.6 26.6 10.9 48.6 36.9 47.1 11.1-.6 18.3-4.6 25.4-17.4 4-7.4 41.7-107.7 44.6-112.6 2-3.4 8.9-8 14.6-5.1 5.7 3.1 6.9 9.4 6 15.1-1.1 9.7-28 70.9-28.9 77.7-3.4 22.9 26.9 26.6 38.6 4 3.7-7.1 45.7-92.6 49.4-98.3 4.3-6.3 7.4-8.3 11.7-8 3.1 0 8.3.9 7.1 10.9-1.4 9.4-35.1 72.3-38.9 87.7-4.6 20.6 6.6 41.4 24.9 50.6 11.4 5.7 62.5 15.7 58.5-11.1zm5.7 92.3c-10.3 7.4-12.9 22-5.7 32.6 7.1 10.6 21.4 13.1 32 6 10.6-7.4 13.1-22 6-32.6-7.4-10.6-21.7-13.5-32.3-6z"
        ],
        "megaport": [
            496,
            512,
            [],
            "f5a3",
            "M214.5 209.6v66.2l33.5 33.5 33.3-33.3v-66.4l-33.4-33.4zM248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm145.1 414.4L367 441.6l-26-19.2v-65.5l-33.4-33.4-33.4 33.4v65.5L248 441.6l-26.1-19.2v-65.5l-33.4-33.4-33.5 33.4v65.5l-26.1 19.2-26.1-19.2v-87l59.5-59.5V188l59.5-59.5V52.9l26.1-19.2L274 52.9v75.6l59.5 59.5v87.6l59.7 59.7v87.1z"
        ],
        "mendeley": [
            640,
            512,
            [],
            "f7b3",
            "M624.6 325.2c-12.3-12.4-29.7-19.2-48.4-17.2-43.3-1-49.7-34.9-37.5-98.8 22.8-57.5-14.9-131.5-87.4-130.8-77.4.7-81.7 82-130.9 82-48.1 0-54-81.3-130.9-82-72.9-.8-110.1 73.3-87.4 130.8 12.2 63.9 5.8 97.8-37.5 98.8-21.2-2.3-37 6.5-53 22.5-19.9 19.7-19.3 94.8 42.6 102.6 47.1 5.9 81.6-42.9 61.2-87.8-47.3-103.7 185.9-106.1 146.5-8.2-.1.1-.2.2-.3.4-26.8 42.8 6.8 97.4 58.8 95.2 52.1 2.1 85.4-52.6 58.8-95.2-.1-.2-.2-.3-.3-.4-39.4-97.9 193.8-95.5 146.5 8.2-4.6 10-6.7 21.3-5.7 33 4.9 53.4 68.7 74.1 104.9 35.2 17.8-14.8 23.1-65.6 0-88.3zm-303.9-19.1h-.6c-43.4 0-62.8-37.5-62.8-62.8 0-34.7 28.2-62.8 62.8-62.8h.6c34.7 0 62.8 28.1 62.8 62.8 0 25-19.2 62.8-62.8 62.8z"
        ],
        "microblog": [
            448,
            512,
            [],
            "e01a",
            "M399.36,362.23c29.49-34.69,47.1-78.34,47.1-125.79C446.46,123.49,346.86,32,224,32S1.54,123.49,1.54,236.44,101.14,440.87,224,440.87a239.28,239.28,0,0,0,79.44-13.44,7.18,7.18,0,0,1,8.12,2.56c18.58,25.09,47.61,42.74,79.89,49.92a4.42,4.42,0,0,0,5.22-3.43,4.37,4.37,0,0,0-.85-3.62,87,87,0,0,1,3.69-110.69ZM329.52,212.4l-57.3,43.49L293,324.75a6.5,6.5,0,0,1-9.94,7.22L224,290.92,164.94,332a6.51,6.51,0,0,1-9.95-7.22l20.79-68.86-57.3-43.49a6.5,6.5,0,0,1,3.8-11.68l71.88-1.51,23.66-67.92a6.5,6.5,0,0,1,12.28,0l23.66,67.92,71.88,1.51a6.5,6.5,0,0,1,3.88,11.68Z"
        ],
        "microsoft": [
            448,
            512,
            [],
            "f3ca",
            "M0 32h214.6v214.6H0V32zm233.4 0H448v214.6H233.4V32zM0 265.4h214.6V480H0V265.4zm233.4 0H448V480H233.4V265.4z"
        ],
        "mix": [
            448,
            512,
            [],
            "f3cb",
            "M0 64v348.9c0 56.2 88 58.1 88 0V174.3c7.9-52.9 88-50.4 88 6.5v175.3c0 57.9 96 58 96 0V240c5.3-54.7 88-52.5 88 4.3v23.8c0 59.9 88 56.6 88 0V64H0z"
        ],
        "mixcloud": [
            640,
            512,
            [],
            "f289",
            "M424.43 219.729C416.124 134.727 344.135 68 256.919 68c-72.266 0-136.224 46.516-159.205 114.074-54.545 8.029-96.63 54.822-96.63 111.582 0 62.298 50.668 112.966 113.243 112.966h289.614c52.329 0 94.969-42.362 94.969-94.693 0-45.131-32.118-83.063-74.48-92.2zm-20.489 144.53H114.327c-39.04 0-70.881-31.564-70.881-70.604s31.841-70.604 70.881-70.604c18.827 0 36.548 7.475 49.838 20.766 19.963 19.963 50.133-10.227 30.18-30.18-14.675-14.398-32.672-24.365-52.053-29.349 19.935-44.3 64.79-73.926 114.628-73.926 69.496 0 125.979 56.483 125.979 125.702 0 13.568-2.215 26.857-6.369 39.594-8.943 27.517 32.133 38.939 40.147 13.29 2.769-8.306 4.984-16.889 6.369-25.472 19.381 7.476 33.502 26.303 33.502 48.453 0 28.795-23.535 52.33-52.607 52.33zm235.069-52.33c0 44.024-12.737 86.386-37.102 122.657-4.153 6.092-10.798 9.414-17.72 9.414-16.317 0-27.127-18.826-17.443-32.949 19.381-29.349 29.903-63.682 29.903-99.122s-10.521-69.773-29.903-98.845c-15.655-22.831 19.361-47.24 35.163-23.534 24.366 35.993 37.102 78.356 37.102 122.379zm-70.88 0c0 31.565-9.137 62.021-26.857 88.325-4.153 6.091-10.798 9.136-17.72 9.136-17.201 0-27.022-18.979-17.443-32.948 13.013-19.104 19.658-41.255 19.658-64.513 0-22.981-6.645-45.408-19.658-64.512-15.761-22.986 19.008-47.095 35.163-23.535 17.719 26.026 26.857 56.483 26.857 88.047z"
        ],
        "mixer": [
            512,
            512,
            [],
            "e056",
            "M114.57,76.07a45.71,45.71,0,0,0-67.51-6.41c-17.58,16.18-19,43.52-4.75,62.77l91.78,123L41.76,379.58c-14.23,19.25-13.11,46.59,4.74,62.77A45.71,45.71,0,0,0,114,435.94L242.89,262.7a12.14,12.14,0,0,0,0-14.23ZM470.24,379.58,377.91,255.45l91.78-123c14.22-19.25,12.83-46.59-4.75-62.77a45.71,45.71,0,0,0-67.51,6.41l-128,172.12a12.14,12.14,0,0,0,0,14.23L398,435.94a45.71,45.71,0,0,0,67.51,6.41C483.35,426.17,484.47,398.83,470.24,379.58Z"
        ],
        "mizuni": [
            496,
            512,
            [],
            "f3cc",
            "M248 8C111 8 0 119.1 0 256c0 137 111 248 248 248s248-111 248-248C496 119.1 385 8 248 8zm-80 351.9c-31.4 10.6-58.8 27.3-80 48.2V136c0-22.1 17.9-40 40-40s40 17.9 40 40v223.9zm120-9.9c-12.9-2-26.2-3.1-39.8-3.1-13.8 0-27.2 1.1-40.2 3.1V136c0-22.1 17.9-40 40-40s40 17.9 40 40v214zm120 57.7c-21.2-20.8-48.6-37.4-80-48V136c0-22.1 17.9-40 40-40s40 17.9 40 40v271.7z"
        ],
        "modx": [
            448,
            512,
            [],
            "f285",
            "M356 241.8l36.7 23.7V480l-133-83.8L356 241.8zM440 75H226.3l-23 37.8 153.5 96.5L440 75zm-89 142.8L55.2 32v214.5l46 29L351 217.8zM97 294.2L8 437h213.7l125-200.5L97 294.2z"
        ],
        "monero": [
            496,
            512,
            [],
            "f3d0",
            "M352 384h108.4C417 455.9 338.1 504 248 504S79 455.9 35.6 384H144V256.2L248 361l104-105v128zM88 336V128l159.4 159.4L408 128v208h74.8c8.5-25.1 13.2-52 13.2-80C496 119 385 8 248 8S0 119 0 256c0 28 4.6 54.9 13.2 80H88z"
        ],
        "napster": [
            496,
            512,
            [],
            "f3d2",
            "M298.3 373.6c-14.2 13.6-31.3 24.1-50.4 30.5-19-6.4-36.2-16.9-50.3-30.5h100.7zm44-199.6c20-16.9 43.6-29.2 69.6-36.2V299c0 219.4-328 217.6-328 .3V137.7c25.9 6.9 49.6 19.6 69.5 36.4 56.8-40 132.5-39.9 188.9-.1zm-208.8-58.5c64.4-60 164.3-60.1 228.9-.2-7.1 3.5-13.9 7.3-20.6 11.5-58.7-30.5-129.2-30.4-187.9.1-6.3-4-13.9-8.2-20.4-11.4zM43.8 93.2v69.3c-58.4 36.5-58.4 121.1.1 158.3 26.4 245.1 381.7 240.3 407.6 1.5l.3-1.7c58.7-36.3 58.9-121.7.2-158.2V93.2c-17.3.5-34 3-50.1 7.4-82-91.5-225.5-91.5-307.5.1-16.3-4.4-33.1-7-50.6-7.5zM259.2 352s36-.3 61.3-1.5c10.2-.5 21.1-4 25.5-6.5 26.3-15.1 25.4-39.2 26.2-47.4-79.5-.6-99.9-3.9-113 55.4zm-135.5-55.3c.8 8.2-.1 32.3 26.2 47.4 4.4 2.5 15.2 6 25.5 6.5 25.3 1.1 61.3 1.5 61.3 1.5-13.2-59.4-33.7-56.1-113-55.4zm169.1 123.4c-3.2-5.3-6.9-7.3-6.9-7.3-24.8 7.3-52.2 6.9-75.9 0 0 0-2.9 1.5-6.4 6.6-2.8 4.1-3.7 9.6-3.7 9.6 29.1 17.6 67.1 17.6 96.2 0-.1-.1-.3-4-3.3-8.9z"
        ],
        "neos": [
            512,
            512,
            [],
            "f612",
            "M415.44 512h-95.11L212.12 357.46v91.1L125.69 512H28V29.82L68.47 0h108.05l123.74 176.13V63.45L386.69 0h97.69v461.5zM38.77 35.27V496l72-52.88V194l215.5 307.64h84.79l52.35-38.17h-78.27L69 13zm82.54 466.61l80-58.78v-101l-79.76-114.4v220.94L49 501.89h72.34zM80.63 10.77l310.6 442.57h82.37V10.77h-79.75v317.56L170.91 10.77zM311 191.65l72 102.81V15.93l-72 53v122.72z"
        ],
        "nimblr": [
            384,
            512,
            [],
            "f5a8",
            "M246.6 299.29c15.57 0 27.15 11.46 27.15 27s-11.62 27-27.15 27c-15.7 0-27.15-11.57-27.15-27s11.55-27 27.15-27zM113 326.25c0-15.61 11.68-27 27.15-27s27.15 11.46 27.15 27-11.47 27-27.15 27c-15.44 0-27.15-11.31-27.15-27M191.76 159C157 159 89.45 178.77 59.25 227L14 0v335.48C14 433.13 93.61 512 191.76 512s177.76-78.95 177.76-176.52S290.13 159 191.76 159zm0 308.12c-73.27 0-132.51-58.9-132.51-131.59s59.24-131.59 132.51-131.59 132.51 58.86 132.51 131.54S265 467.07 191.76 467.07z"
        ],
        "node": [
            640,
            512,
            [],
            "f419",
            "M316.3 452c-2.1 0-4.2-.6-6.1-1.6L291 439c-2.9-1.6-1.5-2.2-.5-2.5 3.8-1.3 4.6-1.6 8.7-4 .4-.2 1-.1 1.4.1l14.8 8.8c.5.3 1.3.3 1.8 0L375 408c.5-.3.9-.9.9-1.6v-66.7c0-.7-.3-1.3-.9-1.6l-57.8-33.3c-.5-.3-1.2-.3-1.8 0l-57.8 33.3c-.6.3-.9 1-.9 1.6v66.7c0 .6.4 1.2.9 1.5l15.8 9.1c8.6 4.3 13.9-.8 13.9-5.8v-65.9c0-.9.7-1.7 1.7-1.7h7.3c.9 0 1.7.7 1.7 1.7v65.9c0 11.5-6.2 18-17.1 18-3.3 0-6 0-13.3-3.6l-15.2-8.7c-3.7-2.2-6.1-6.2-6.1-10.5v-66.7c0-4.3 2.3-8.4 6.1-10.5l57.8-33.4c3.7-2.1 8.5-2.1 12.1 0l57.8 33.4c3.7 2.2 6.1 6.2 6.1 10.5v66.7c0 4.3-2.3 8.4-6.1 10.5l-57.8 33.4c-1.7 1.1-3.8 1.7-6 1.7zm46.7-65.8c0-12.5-8.4-15.8-26.2-18.2-18-2.4-19.8-3.6-19.8-7.8 0-3.5 1.5-8.1 14.8-8.1 11.9 0 16.3 2.6 18.1 10.6.2.8.8 1.3 1.6 1.3h7.5c.5 0 .9-.2 1.2-.5.3-.4.5-.8.4-1.3-1.2-13.8-10.3-20.2-28.8-20.2-16.5 0-26.3 7-26.3 18.6 0 12.7 9.8 16.1 25.6 17.7 18.9 1.9 20.4 4.6 20.4 8.3 0 6.5-5.2 9.2-17.4 9.2-15.3 0-18.7-3.8-19.8-11.4-.1-.8-.8-1.4-1.7-1.4h-7.5c-.9 0-1.7.7-1.7 1.7 0 9.7 5.3 21.3 30.6 21.3 18.5 0 29-7.2 29-19.8zm54.5-50.1c0 6.1-5 11.1-11.1 11.1s-11.1-5-11.1-11.1c0-6.3 5.2-11.1 11.1-11.1 6-.1 11.1 4.8 11.1 11.1zm-1.8 0c0-5.2-4.2-9.3-9.4-9.3-5.1 0-9.3 4.1-9.3 9.3 0 5.2 4.2 9.4 9.3 9.4 5.2-.1 9.4-4.3 9.4-9.4zm-4.5 6.2h-2.6c-.1-.6-.5-3.8-.5-3.9-.2-.7-.4-1.1-1.3-1.1h-2.2v5h-2.4v-12.5h4.3c1.5 0 4.4 0 4.4 3.3 0 2.3-1.5 2.8-2.4 3.1 1.7.1 1.8 1.2 2.1 2.8.1 1 .3 2.7.6 3.3zm-2.8-8.8c0-1.7-1.2-1.7-1.8-1.7h-2v3.5h1.9c1.6 0 1.9-1.1 1.9-1.8zM137.3 191c0-2.7-1.4-5.1-3.7-6.4l-61.3-35.3c-1-.6-2.2-.9-3.4-1h-.6c-1.2 0-2.3.4-3.4 1L3.7 184.6C1.4 185.9 0 188.4 0 191l.1 95c0 1.3.7 2.5 1.8 3.2 1.1.7 2.5.7 3.7 0L42 268.3c2.3-1.4 3.7-3.8 3.7-6.4v-44.4c0-2.6 1.4-5.1 3.7-6.4l15.5-8.9c1.2-.7 2.4-1 3.7-1 1.3 0 2.6.3 3.7 1l15.5 8.9c2.3 1.3 3.7 3.8 3.7 6.4v44.4c0 2.6 1.4 5.1 3.7 6.4l36.4 20.9c1.1.7 2.6.7 3.7 0 1.1-.6 1.8-1.9 1.8-3.2l.2-95zM472.5 87.3v176.4c0 2.6-1.4 5.1-3.7 6.4l-61.3 35.4c-2.3 1.3-5.1 1.3-7.4 0l-61.3-35.4c-2.3-1.3-3.7-3.8-3.7-6.4v-70.8c0-2.6 1.4-5.1 3.7-6.4l61.3-35.4c2.3-1.3 5.1-1.3 7.4 0l15.3 8.8c1.7 1 3.9-.3 3.9-2.2v-94c0-2.8 3-4.6 5.5-3.2l36.5 20.4c2.3 1.2 3.8 3.7 3.8 6.4zm-46 128.9c0-.7-.4-1.3-.9-1.6l-21-12.2c-.6-.3-1.3-.3-1.9 0l-21 12.2c-.6.3-.9.9-.9 1.6v24.3c0 .7.4 1.3.9 1.6l21 12.1c.6.3 1.3.3 1.8 0l21-12.1c.6-.3.9-.9.9-1.6v-24.3zm209.8-.7c2.3-1.3 3.7-3.8 3.7-6.4V192c0-2.6-1.4-5.1-3.7-6.4l-60.9-35.4c-2.3-1.3-5.1-1.3-7.4 0l-61.3 35.4c-2.3 1.3-3.7 3.8-3.7 6.4v70.8c0 2.7 1.4 5.1 3.7 6.4l60.9 34.7c2.2 1.3 5 1.3 7.3 0l36.8-20.5c2.5-1.4 2.5-5 0-6.4L550 241.6c-1.2-.7-1.9-1.9-1.9-3.2v-22.2c0-1.3.7-2.5 1.9-3.2l19.2-11.1c1.1-.7 2.6-.7 3.7 0l19.2 11.1c1.1.7 1.9 1.9 1.9 3.2v17.4c0 2.8 3.1 4.6 5.6 3.2l36.7-21.3zM559 219c-.4.3-.7.7-.7 1.2v13.6c0 .5.3 1 .7 1.2l11.8 6.8c.4.3 1 .3 1.4 0L584 235c.4-.3.7-.7.7-1.2v-13.6c0-.5-.3-1-.7-1.2l-11.8-6.8c-.4-.3-1-.3-1.4 0L559 219zm-254.2 43.5v-70.4c0-2.6-1.6-5.1-3.9-6.4l-61.1-35.2c-2.1-1.2-5-1.4-7.4 0l-61.1 35.2c-2.3 1.3-3.9 3.7-3.9 6.4v70.4c0 2.8 1.9 5.2 4 6.4l61.2 35.2c2.4 1.4 5.2 1.3 7.4 0l61-35.2c1.8-1 3.1-2.7 3.6-4.7.1-.5.2-1.1.2-1.7zm-74.3-124.9l-.8.5h1.1l-.3-.5zm76.2 130.2l-.4-.7v.9l.4-.2z"
        ],
        "node-js": [
            448,
            512,
            [],
            "f3d3",
            "M224 508c-6.7 0-13.5-1.8-19.4-5.2l-61.7-36.5c-9.2-5.2-4.7-7-1.7-8 12.3-4.3 14.8-5.2 27.9-12.7 1.4-.8 3.2-.5 4.6.4l47.4 28.1c1.7 1 4.1 1 5.7 0l184.7-106.6c1.7-1 2.8-3 2.8-5V149.3c0-2.1-1.1-4-2.9-5.1L226.8 37.7c-1.7-1-4-1-5.7 0L36.6 144.3c-1.8 1-2.9 3-2.9 5.1v213.1c0 2 1.1 4 2.9 4.9l50.6 29.2c27.5 13.7 44.3-2.4 44.3-18.7V167.5c0-3 2.4-5.3 5.4-5.3h23.4c2.9 0 5.4 2.3 5.4 5.3V378c0 36.6-20 57.6-54.7 57.6-10.7 0-19.1 0-42.5-11.6l-48.4-27.9C8.1 389.2.7 376.3.7 362.4V149.3c0-13.8 7.4-26.8 19.4-33.7L204.6 9c11.7-6.6 27.2-6.6 38.8 0l184.7 106.7c12 6.9 19.4 19.8 19.4 33.7v213.1c0 13.8-7.4 26.7-19.4 33.7L243.4 502.8c-5.9 3.4-12.6 5.2-19.4 5.2zm149.1-210.1c0-39.9-27-50.5-83.7-58-57.4-7.6-63.2-11.5-63.2-24.9 0-11.1 4.9-25.9 47.4-25.9 37.9 0 51.9 8.2 57.7 33.8.5 2.4 2.7 4.2 5.2 4.2h24c1.5 0 2.9-.6 3.9-1.7s1.5-2.6 1.4-4.1c-3.7-44.1-33-64.6-92.2-64.6-52.7 0-84.1 22.2-84.1 59.5 0 40.4 31.3 51.6 81.8 56.6 60.5 5.9 65.2 14.8 65.2 26.7 0 20.6-16.6 29.4-55.5 29.4-48.9 0-59.6-12.3-63.2-36.6-.4-2.6-2.6-4.5-5.3-4.5h-23.9c-3 0-5.3 2.4-5.3 5.3 0 31.1 16.9 68.2 97.8 68.2 58.4-.1 92-23.2 92-63.4z"
        ],
        "npm": [
            576,
            512,
            [],
            "f3d4",
            "M288 288h-32v-64h32v64zm288-128v192H288v32H160v-32H0V160h576zm-416 32H32v128h64v-96h32v96h32V192zm160 0H192v160h64v-32h64V192zm224 0H352v128h64v-96h32v96h32v-96h32v96h32V192z"
        ],
        "ns8": [
            640,
            512,
            [],
            "f3d5",
            "M104.324,269.172h26.067V242.994H104.324Zm52.466-26.178-.055-26.178v-.941a39.325,39.325,0,0,0-78.644.941v.166h26.4v-.166a12.98,12.98,0,0,1,25.956,0v26.178Zm52.356,25.846a91.1,91.1,0,0,1-91.1,91.1h-.609a91.1,91.1,0,0,1-91.1-91.1H0v.166A117.33,117.33,0,0,0,117.44,386.28h.775A117.331,117.331,0,0,0,235.49,268.84V242.828H209.146Zm-157.233,0a65.362,65.362,0,0,0,130.723,0H156.292a39.023,39.023,0,0,1-78.035,0V242.883H51.968v-26.62A65.42,65.42,0,0,1,182.8,217.48v25.293h26.344V217.48a91.761,91.761,0,0,0-183.522,0v25.4H51.913Zm418.4-71.173c13.67,0,24.573,6.642,30.052,18.264l.719,1.549,23.245-11.511-.609-1.439c-8.025-19.26-28.5-31.27-53.407-31.27-23.134,0-43.611,11.4-50.972,28.447-.123,26.876-.158,23.9,0,24.85,4.7,11.013,14.555,19.37,28.668,24.241a102.033,102.033,0,0,0,19.813,3.984c5.479.72,10.626,1.384,15.829,3.1,6.364,2.1,10.46,5.257,12.84,9.851v9.851c-3.708,7.527-13.781,12.342-25.791,12.342-14.334,0-25.956-6.918-31.933-19.039l-.72-1.494L415.026,280.9l.553,1.439c7.915,19.426,29.609,32.044,55.289,32.044,23.632,0,44.608-11.4,52.3-28.447l.166-25.9-.166-.664c-4.87-11.014-15.219-19.647-28.944-24.241-7.693-2.712-14.335-3.6-20.7-4.427a83.777,83.777,0,0,1-14.832-2.878c-6.31-1.937-10.4-5.092-12.619-9.63v-8.412C449.45,202.427,458.969,197.667,470.315,197.667ZM287.568,311.344h26.067v-68.4H287.568Zm352.266-53.3c-2.933-6.254-8.3-12.01-15.441-16.714A37.99,37.99,0,0,0,637.4,226l.166-25.347-.166-.664C630.038,184,610.667,173.26,589.25,173.26S548.461,184,541.1,199.992l-.166,25.347.166.664a39.643,39.643,0,0,0,13.006,15.331c-7.2,4.7-12.508,10.46-15.441,16.714l-.166,28.889.166.72c7.582,15.994,27.893,26.731,50.585,26.731s43.057-10.737,50.584-26.731l.166-28.89Zm-73.22-50.806c3.6-6.31,12.563-10.516,22.58-10.516s19.038,4.206,22.636,10.516v13.725c-3.542,6.2-12.563,10.349-22.636,10.349s-19.094-4.15-22.58-10.349Zm47.319,72.169c-3.764,6.641-13.338,10.9-24.683,10.9-11.125,0-20.976-4.372-24.684-10.9V263.25c3.708-6.309,13.5-10.515,24.684-10.515,11.345,0,20.919,4.15,24.683,10.515ZM376.4,265.962l-59.827-89.713h-29v40.623h26.51v.387l62.539,94.085H402.3V176.249H376.4Z"
        ],
        "nutritionix": [
            400,
            512,
            [],
            "f3d6",
            "M88 8.1S221.4-.1 209 112.5c0 0 19.1-74.9 103-40.6 0 0-17.7 74-88 56 0 0 14.6-54.6 66.1-56.6 0 0-39.9-10.3-82.1 48.8 0 0-19.8-94.5-93.6-99.7 0 0 75.2 19.4 77.6 107.5 0 .1-106.4 7-104-119.8zm312 315.6c0 48.5-9.7 95.3-32 132.3-42.2 30.9-105 48-168 48-62.9 0-125.8-17.1-168-48C9.7 419 0 372.2 0 323.7 0 275.3 17.7 229 40 192c42.2-30.9 97.1-48.6 160-48.6 63 0 117.8 17.6 160 48.6 22.3 37 40 83.3 40 131.7zM120 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM192 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM264 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zM336 428c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm0-66.2c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28zm24-39.6c-4.8-22.3-7.4-36.9-16-56-38.8-19.9-90.5-32-144-32S94.8 180.1 56 200c-8.8 19.5-11.2 33.9-16 56 42.2-7.9 98.7-14.8 160-14.8s117.8 6.9 160 14.8z"
        ],
        "octopus-deploy": [
            512,
            512,
            [],
            "e082",
            "M455.6,349.2c-45.891-39.09-36.67-77.877-16.095-128.11C475.16,134.04,415.967,34.14,329.93,8.3,237.04-19.6,134.252,24.341,99.677,117.147a180.862,180.862,0,0,0-10.988,73.544c1.733,29.543,14.717,52.97,24.09,80.3,17.2,50.161-28.1,92.743-66.662,117.582-46.806,30.2-36.319,39.857-8.428,41.858,23.378,1.68,44.478-4.548,65.265-15.045,9.2-4.647,40.687-18.931,45.13-28.588C135.9,413.388,111.122,459.5,126.621,488.9c19.1,36.229,67.112-31.77,76.709-45.812,8.591-12.572,42.963-81.279,63.627-46.926,18.865,31.361,8.6,76.391,35.738,104.622,32.854,34.2,51.155-18.312,51.412-44.221.163-16.411-6.1-95.852,29.9-59.944C405.428,418,436.912,467.8,472.568,463.642c38.736-4.516-22.123-67.967-28.262-78.695,5.393,4.279,53.665,34.128,53.818,9.52C498.234,375.678,468.039,359.8,455.6,349.2Z"
        ],
        "odnoklassniki": [
            320,
            512,
            [],
            "f263",
            "M275.1 334c-27.4 17.4-65.1 24.3-90 26.9l20.9 20.6 76.3 76.3c27.9 28.6-17.5 73.3-45.7 45.7-19.1-19.4-47.1-47.4-76.3-76.6L84 503.4c-28.2 27.5-73.6-17.6-45.4-45.7 19.4-19.4 47.1-47.4 76.3-76.3l20.6-20.6c-24.6-2.6-62.9-9.1-90.6-26.9-32.6-21-46.9-33.3-34.3-59 7.4-14.6 27.7-26.9 54.6-5.7 0 0 36.3 28.9 94.9 28.9s94.9-28.9 94.9-28.9c26.9-21.1 47.1-8.9 54.6 5.7 12.4 25.7-1.9 38-34.5 59.1zM30.3 129.7C30.3 58 88.6 0 160 0s129.7 58 129.7 129.7c0 71.4-58.3 129.4-129.7 129.4s-129.7-58-129.7-129.4zm66 0c0 35.1 28.6 63.7 63.7 63.7s63.7-28.6 63.7-63.7c0-35.4-28.6-64-63.7-64s-63.7 28.6-63.7 64z"
        ],
        "odnoklassniki-square": [
            448,
            512,
            [],
            "f264",
            "M184.2 177.1c0-22.1 17.9-40 39.8-40s39.8 17.9 39.8 40c0 22-17.9 39.8-39.8 39.8s-39.8-17.9-39.8-39.8zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-305.1 97.1c0 44.6 36.4 80.9 81.1 80.9s81.1-36.2 81.1-80.9c0-44.8-36.4-81.1-81.1-81.1s-81.1 36.2-81.1 81.1zm174.5 90.7c-4.6-9.1-17.3-16.8-34.1-3.6 0 0-22.7 18-59.3 18s-59.3-18-59.3-18c-16.8-13.2-29.5-5.5-34.1 3.6-7.9 16.1 1.1 23.7 21.4 37 17.3 11.1 41.2 15.2 56.6 16.8l-12.9 12.9c-18.2 18-35.5 35.5-47.7 47.7-17.6 17.6 10.7 45.8 28.4 28.6l47.7-47.9c18.2 18.2 35.7 35.7 47.7 47.9 17.6 17.2 46-10.7 28.6-28.6l-47.7-47.7-13-12.9c15.5-1.6 39.1-5.9 56.2-16.8 20.4-13.3 29.3-21 21.5-37z"
        ],
        "old-republic": [
            496,
            512,
            [],
            "f510",
            "M235.76 10.23c7.5-.31 15-.28 22.5-.09 3.61.14 7.2.4 10.79.73 4.92.27 9.79 1.03 14.67 1.62 2.93.43 5.83.98 8.75 1.46 7.9 1.33 15.67 3.28 23.39 5.4 12.24 3.47 24.19 7.92 35.76 13.21 26.56 12.24 50.94 29.21 71.63 49.88 20.03 20.09 36.72 43.55 48.89 69.19 1.13 2.59 2.44 5.1 3.47 7.74 2.81 6.43 5.39 12.97 7.58 19.63 4.14 12.33 7.34 24.99 9.42 37.83.57 3.14 1.04 6.3 1.4 9.47.55 3.83.94 7.69 1.18 11.56.83 8.34.84 16.73.77 25.1-.07 4.97-.26 9.94-.75 14.89-.24 3.38-.51 6.76-.98 10.12-.39 2.72-.63 5.46-1.11 8.17-.9 5.15-1.7 10.31-2.87 15.41-4.1 18.5-10.3 36.55-18.51 53.63-15.77 32.83-38.83 62.17-67.12 85.12a246.503 246.503 0 0 1-56.91 34.86c-6.21 2.68-12.46 5.25-18.87 7.41-3.51 1.16-7.01 2.38-10.57 3.39-6.62 1.88-13.29 3.64-20.04 5-4.66.91-9.34 1.73-14.03 2.48-5.25.66-10.5 1.44-15.79 1.74-6.69.66-13.41.84-20.12.81-6.82.03-13.65-.12-20.45-.79-3.29-.23-6.57-.5-9.83-.95-2.72-.39-5.46-.63-8.17-1.11-4.12-.72-8.25-1.37-12.35-2.22-4.25-.94-8.49-1.89-12.69-3.02-8.63-2.17-17.08-5.01-25.41-8.13-10.49-4.12-20.79-8.75-30.64-14.25-2.14-1.15-4.28-2.29-6.35-3.57-11.22-6.58-21.86-14.1-31.92-22.34-34.68-28.41-61.41-66.43-76.35-108.7-3.09-8.74-5.71-17.65-7.8-26.68-1.48-6.16-2.52-12.42-3.58-18.66-.4-2.35-.61-4.73-.95-7.09-.6-3.96-.75-7.96-1.17-11.94-.8-9.47-.71-18.99-.51-28.49.14-3.51.34-7.01.7-10.51.31-3.17.46-6.37.92-9.52.41-2.81.65-5.65 1.16-8.44.7-3.94 1.3-7.9 2.12-11.82 3.43-16.52 8.47-32.73 15.26-48.18 1.15-2.92 2.59-5.72 3.86-8.59 8.05-16.71 17.9-32.56 29.49-47.06 20-25.38 45.1-46.68 73.27-62.47 7.5-4.15 15.16-8.05 23.07-11.37 15.82-6.88 32.41-11.95 49.31-15.38 3.51-.67 7.04-1.24 10.56-1.85 2.62-.47 5.28-.7 7.91-1.08 3.53-.53 7.1-.68 10.65-1.04 2.46-.24 4.91-.36 7.36-.51m8.64 24.41c-9.23.1-18.43.99-27.57 2.23-7.3 1.08-14.53 2.6-21.71 4.3-13.91 3.5-27.48 8.34-40.46 14.42-10.46 4.99-20.59 10.7-30.18 17.22-4.18 2.92-8.4 5.8-12.34 9.03-5.08 3.97-9.98 8.17-14.68 12.59-2.51 2.24-4.81 4.7-7.22 7.06-28.22 28.79-48.44 65.39-57.5 104.69-2.04 8.44-3.54 17.02-4.44 25.65-1.1 8.89-1.44 17.85-1.41 26.8.11 7.14.38 14.28 1.22 21.37.62 7.12 1.87 14.16 3.2 21.18 1.07 4.65 2.03 9.32 3.33 13.91 6.29 23.38 16.5 45.7 30.07 65.75 8.64 12.98 18.78 24.93 29.98 35.77 16.28 15.82 35.05 29.04 55.34 39.22 7.28 3.52 14.66 6.87 22.27 9.63 5.04 1.76 10.06 3.57 15.22 4.98 11.26 3.23 22.77 5.6 34.39 7.06 2.91.29 5.81.61 8.72.9 13.82 1.08 27.74 1 41.54-.43 4.45-.6 8.92-.99 13.35-1.78 3.63-.67 7.28-1.25 10.87-2.1 4.13-.98 8.28-1.91 12.36-3.07 26.5-7.34 51.58-19.71 73.58-36.2 15.78-11.82 29.96-25.76 42.12-41.28 3.26-4.02 6.17-8.31 9.13-12.55 3.39-5.06 6.58-10.25 9.6-15.54 2.4-4.44 4.74-8.91 6.95-13.45 5.69-12.05 10.28-24.62 13.75-37.49 2.59-10.01 4.75-20.16 5.9-30.45 1.77-13.47 1.94-27.1 1.29-40.65-.29-3.89-.67-7.77-1-11.66-2.23-19.08-6.79-37.91-13.82-55.8-5.95-15.13-13.53-29.63-22.61-43.13-12.69-18.8-28.24-35.68-45.97-49.83-25.05-20-54.47-34.55-85.65-42.08-7.78-1.93-15.69-3.34-23.63-4.45-3.91-.59-7.85-.82-11.77-1.24-7.39-.57-14.81-.72-22.22-.58zM139.26 83.53c13.3-8.89 28.08-15.38 43.3-20.18-3.17 1.77-6.44 3.38-9.53 5.29-11.21 6.68-21.52 14.9-30.38 24.49-6.8 7.43-12.76 15.73-17.01 24.89-3.29 6.86-5.64 14.19-6.86 21.71-.93 4.85-1.3 9.81-1.17 14.75.13 13.66 4.44 27.08 11.29 38.82 5.92 10.22 13.63 19.33 22.36 27.26 4.85 4.36 10.24 8.09 14.95 12.6 2.26 2.19 4.49 4.42 6.43 6.91 2.62 3.31 4.89 6.99 5.99 11.1.9 3.02.66 6.2.69 9.31.02 4.1-.04 8.2.03 12.3.14 3.54-.02 7.09.11 10.63.08 2.38.02 4.76.05 7.14.16 5.77.06 11.53.15 17.3.11 2.91.02 5.82.13 8.74.03 1.63.13 3.28-.03 4.91-.91.12-1.82.18-2.73.16-10.99 0-21.88-2.63-31.95-6.93-6-2.7-11.81-5.89-17.09-9.83-5.75-4.19-11.09-8.96-15.79-14.31-6.53-7.24-11.98-15.39-16.62-23.95-1.07-2.03-2.24-4.02-3.18-6.12-1.16-2.64-2.62-5.14-3.67-7.82-4.05-9.68-6.57-19.94-8.08-30.31-.49-4.44-1.09-8.88-1.2-13.35-.7-15.73.84-31.55 4.67-46.82 2.12-8.15 4.77-16.18 8.31-23.83 6.32-14.2 15.34-27.18 26.3-38.19 6.28-6.2 13.13-11.84 20.53-16.67zm175.37-20.12c2.74.74 5.41 1.74 8.09 2.68 6.36 2.33 12.68 4.84 18.71 7.96 13.11 6.44 25.31 14.81 35.82 24.97 10.2 9.95 18.74 21.6 25.14 34.34 1.28 2.75 2.64 5.46 3.81 8.26 6.31 15.1 10 31.26 11.23 47.57.41 4.54.44 9.09.45 13.64.07 11.64-1.49 23.25-4.3 34.53-1.97 7.27-4.35 14.49-7.86 21.18-3.18 6.64-6.68 13.16-10.84 19.24-6.94 10.47-15.6 19.87-25.82 27.22-10.48 7.64-22.64 13.02-35.4 15.38-3.51.69-7.08 1.08-10.66 1.21-1.85.06-3.72.16-5.56-.1-.28-2.15 0-4.31-.01-6.46-.03-3.73.14-7.45.1-11.17.19-7.02.02-14.05.21-21.07.03-2.38-.03-4.76.03-7.14.17-5.07-.04-10.14.14-15.21.1-2.99-.24-6.04.51-8.96.66-2.5 1.78-4.86 3.09-7.08 4.46-7.31 11.06-12.96 17.68-18.26 5.38-4.18 10.47-8.77 15.02-13.84 7.68-8.37 14.17-17.88 18.78-28.27 2.5-5.93 4.52-12.1 5.55-18.46.86-4.37 1.06-8.83 1.01-13.27-.02-7.85-1.4-15.65-3.64-23.17-1.75-5.73-4.27-11.18-7.09-16.45-3.87-6.93-8.65-13.31-13.96-19.2-9.94-10.85-21.75-19.94-34.6-27.1-1.85-1.02-3.84-1.82-5.63-2.97zm-100.8 58.45c.98-1.18 1.99-2.33 3.12-3.38-.61.93-1.27 1.81-1.95 2.68-3.1 3.88-5.54 8.31-7.03 13.06-.87 3.27-1.68 6.6-1.73 10-.07 2.52-.08 5.07.32 7.57 1.13 7.63 4.33 14.85 8.77 21.12 2 2.7 4.25 5.27 6.92 7.33 1.62 1.27 3.53 2.09 5.34 3.05 3.11 1.68 6.32 3.23 9.07 5.48 2.67 2.09 4.55 5.33 4.4 8.79-.01 73.67 0 147.34-.01 221.02 0 1.35-.08 2.7.04 4.04.13 1.48.82 2.83 1.47 4.15.86 1.66 1.78 3.34 3.18 4.62.85.77 1.97 1.4 3.15 1.24 1.5-.2 2.66-1.35 3.45-2.57.96-1.51 1.68-3.16 2.28-4.85.76-2.13.44-4.42.54-6.63.14-4.03-.02-8.06.14-12.09.03-5.89.03-11.77.06-17.66.14-3.62.03-7.24.11-10.86.15-4.03-.02-8.06.14-12.09.03-5.99.03-11.98.07-17.97.14-3.62.02-7.24.11-10.86.14-3.93-.02-7.86.14-11.78.03-5.99.03-11.98.06-17.97.16-3.94-.01-7.88.19-11.82.29 1.44.13 2.92.22 4.38.19 3.61.42 7.23.76 10.84.32 3.44.44 6.89.86 10.32.37 3.1.51 6.22.95 9.31.57 4.09.87 8.21 1.54 12.29 1.46 9.04 2.83 18.11 5.09 26.99 1.13 4.82 2.4 9.61 4 14.3 2.54 7.9 5.72 15.67 10.31 22.62 1.73 2.64 3.87 4.98 6.1 7.21.27.25.55.51.88.71.6.25 1.31-.07 1.7-.57.71-.88 1.17-1.94 1.7-2.93 4.05-7.8 8.18-15.56 12.34-23.31.7-1.31 1.44-2.62 2.56-3.61 1.75-1.57 3.84-2.69 5.98-3.63 2.88-1.22 5.9-2.19 9.03-2.42 6.58-.62 13.11.75 19.56 1.85 3.69.58 7.4 1.17 11.13 1.41 3.74.1 7.48.05 11.21-.28 8.55-.92 16.99-2.96 24.94-6.25 5.3-2.24 10.46-4.83 15.31-7.93 11.46-7.21 21.46-16.57 30.04-27.01 1.17-1.42 2.25-2.9 3.46-4.28-1.2 3.24-2.67 6.37-4.16 9.48-1.25 2.9-2.84 5.61-4.27 8.42-5.16 9.63-11.02 18.91-17.75 27.52-4.03 5.21-8.53 10.05-13.33 14.57-6.64 6.05-14.07 11.37-22.43 14.76-8.21 3.37-17.31 4.63-26.09 3.29-3.56-.58-7.01-1.69-10.41-2.88-2.79-.97-5.39-2.38-8.03-3.69-3.43-1.71-6.64-3.81-9.71-6.08 2.71 3.06 5.69 5.86 8.7 8.61 4.27 3.76 8.74 7.31 13.63 10.23 3.98 2.45 8.29 4.4 12.84 5.51 1.46.37 2.96.46 4.45.6-1.25 1.1-2.63 2.04-3.99 2.98-9.61 6.54-20.01 11.86-30.69 16.43-20.86 8.7-43.17 13.97-65.74 15.34-4.66.24-9.32.36-13.98.36-4.98-.11-9.97-.13-14.92-.65-11.2-.76-22.29-2.73-33.17-5.43-10.35-2.71-20.55-6.12-30.3-10.55-8.71-3.86-17.12-8.42-24.99-13.79-1.83-1.31-3.74-2.53-5.37-4.08 6.6-1.19 13.03-3.39 18.99-6.48 5.74-2.86 10.99-6.66 15.63-11.07 2.24-2.19 4.29-4.59 6.19-7.09-3.43 2.13-6.93 4.15-10.62 5.78-4.41 2.16-9.07 3.77-13.81 5.02-5.73 1.52-11.74 1.73-17.61 1.14-8.13-.95-15.86-4.27-22.51-8.98-4.32-2.94-8.22-6.43-11.96-10.06-9.93-10.16-18.2-21.81-25.66-33.86-3.94-6.27-7.53-12.75-11.12-19.22-1.05-2.04-2.15-4.05-3.18-6.1 2.85 2.92 5.57 5.97 8.43 8.88 8.99 8.97 18.56 17.44 29.16 24.48 7.55 4.9 15.67 9.23 24.56 11.03 3.11.73 6.32.47 9.47.81 2.77.28 5.56.2 8.34.3 5.05.06 10.11.04 15.16-.16 3.65-.16 7.27-.66 10.89-1.09 2.07-.25 4.11-.71 6.14-1.2 3.88-.95 8.11-.96 11.83.61 4.76 1.85 8.44 5.64 11.38 9.71 2.16 3.02 4.06 6.22 5.66 9.58 1.16 2.43 2.46 4.79 3.55 7.26 1 2.24 2.15 4.42 3.42 6.52.67 1.02 1.4 2.15 2.62 2.55 1.06-.75 1.71-1.91 2.28-3.03 2.1-4.16 3.42-8.65 4.89-13.05 2.02-6.59 3.78-13.27 5.19-20.02 2.21-9.25 3.25-18.72 4.54-28.13.56-3.98.83-7.99 1.31-11.97.87-10.64 1.9-21.27 2.24-31.94.08-1.86.24-3.71.25-5.57.01-4.35.25-8.69.22-13.03-.01-2.38-.01-4.76 0-7.13.05-5.07-.2-10.14-.22-15.21-.2-6.61-.71-13.2-1.29-19.78-.73-5.88-1.55-11.78-3.12-17.51-2.05-7.75-5.59-15.03-9.8-21.82-3.16-5.07-6.79-9.88-11.09-14.03-3.88-3.86-8.58-7.08-13.94-8.45-1.5-.41-3.06-.45-4.59-.64.07-2.99.7-5.93 1.26-8.85 1.59-7.71 3.8-15.3 6.76-22.6 1.52-4.03 3.41-7.9 5.39-11.72 3.45-6.56 7.62-12.79 12.46-18.46zm31.27 1.7c.35-.06.71-.12 1.07-.19.19 1.79.09 3.58.1 5.37v38.13c-.01 1.74.13 3.49-.15 5.22-.36-.03-.71-.05-1.06-.05-.95-3.75-1.72-7.55-2.62-11.31-.38-1.53-.58-3.09-1.07-4.59-1.7-.24-3.43-.17-5.15-.2-5.06-.01-10.13 0-15.19-.01-1.66-.01-3.32.09-4.98-.03-.03-.39-.26-.91.16-1.18 1.28-.65 2.72-.88 4.06-1.35 3.43-1.14 6.88-2.16 10.31-3.31 1.39-.48 2.9-.72 4.16-1.54.04-.56.02-1.13-.05-1.68-1.23-.55-2.53-.87-3.81-1.28-3.13-1.03-6.29-1.96-9.41-3.02-1.79-.62-3.67-1-5.41-1.79-.03-.37-.07-.73-.11-1.09 5.09-.19 10.2.06 15.3-.12 3.36-.13 6.73.08 10.09-.07.12-.39.26-.77.37-1.16 1.08-4.94 2.33-9.83 3.39-14.75zm5.97-.2c.36.05.72.12 1.08.2.98 3.85 1.73 7.76 2.71 11.61.36 1.42.56 2.88 1.03 4.27 2.53.18 5.07-.01 7.61.05 5.16.12 10.33.12 15.49.07.76-.01 1.52.03 2.28.08-.04.36-.07.72-.1 1.08-1.82.83-3.78 1.25-5.67 1.89-3.73 1.23-7.48 2.39-11.22 3.57-.57.17-1.12.42-1.67.64-.15.55-.18 1.12-.12 1.69.87.48 1.82.81 2.77 1.09 4.88 1.52 9.73 3.14 14.63 4.6.38.13.78.27 1.13.49.4.27.23.79.15 1.18-1.66.13-3.31.03-4.97.04-5.17.01-10.33-.01-15.5.01-1.61.03-3.22-.02-4.82.21-.52 1.67-.72 3.42-1.17 5.11-.94 3.57-1.52 7.24-2.54 10.78-.36.01-.71.02-1.06.06-.29-1.73-.15-3.48-.15-5.22v-38.13c.02-1.78-.08-3.58.11-5.37zM65.05 168.33c1.12-2.15 2.08-4.4 3.37-6.46-1.82 7.56-2.91 15.27-3.62 23-.8 7.71-.85 15.49-.54 23.23 1.05 19.94 5.54 39.83 14.23 57.88 2.99 5.99 6.35 11.83 10.5 17.11 6.12 7.47 12.53 14.76 19.84 21.09 4.8 4.1 9.99 7.78 15.54 10.8 3.27 1.65 6.51 3.39 9.94 4.68 5.01 2.03 10.19 3.61 15.42 4.94 3.83.96 7.78 1.41 11.52 2.71 5 1.57 9.47 4.61 13.03 8.43 4.93 5.23 8.09 11.87 10.2 18.67.99 2.9 1.59 5.91 2.17 8.92.15.75.22 1.52.16 2.29-6.5 2.78-13.26 5.06-20.26 6.18-4.11.78-8.29.99-12.46 1.08-10.25.24-20.47-1.76-30.12-5.12-3.74-1.42-7.49-2.85-11.03-4.72-8.06-3.84-15.64-8.7-22.46-14.46-2.92-2.55-5.83-5.13-8.4-8.03-9.16-9.83-16.3-21.41-21.79-33.65-2.39-5.55-4.61-11.18-6.37-16.96-1.17-3.94-2.36-7.89-3.26-11.91-.75-2.94-1.22-5.95-1.87-8.92-.46-2.14-.69-4.32-1.03-6.48-.85-5.43-1.28-10.93-1.33-16.43.11-6.18.25-12.37 1.07-18.5.4-2.86.67-5.74 1.15-8.6.98-5.7 2.14-11.37 3.71-16.93 3.09-11.65 7.48-22.95 12.69-33.84zm363.73-6.44c1.1 1.66 1.91 3.48 2.78 5.26 2.1 4.45 4.24 8.9 6.02 13.49 7.61 18.76 12.3 38.79 13.04 59.05.02 1.76.07 3.52.11 5.29.13 9.57-1.27 19.09-3.18 28.45-.73 3.59-1.54 7.17-2.58 10.69-4.04 14.72-10 29-18.41 41.78-8.21 12.57-19.01 23.55-31.84 31.41-5.73 3.59-11.79 6.64-18.05 9.19-5.78 2.19-11.71 4.03-17.8 5.11-6.4 1.05-12.91 1.52-19.4 1.23-7.92-.48-15.78-2.07-23.21-4.85-1.94-.8-3.94-1.46-5.84-2.33-.21-1.51.25-2.99.53-4.46 1.16-5.74 3.03-11.36 5.7-16.58 2.37-4.51 5.52-8.65 9.46-11.9 2.43-2.05 5.24-3.61 8.16-4.83 3.58-1.5 7.47-1.97 11.24-2.83 7.23-1.71 14.37-3.93 21.15-7 10.35-4.65 19.71-11.38 27.65-19.46 1.59-1.61 3.23-3.18 4.74-4.87 3.37-3.76 6.71-7.57 9.85-11.53 7.48-10.07 12.82-21.59 16.71-33.48 1.58-5.3 3.21-10.6 4.21-16.05.63-2.87 1.04-5.78 1.52-8.68.87-6.09 1.59-12.22 1.68-18.38.12-6.65.14-13.32-.53-19.94-.73-7.99-1.87-15.96-3.71-23.78z"
        ],
        "opencart": [
            640,
            512,
            [],
            "f23d",
            "M423.3 440.7c0 25.3-20.3 45.6-45.6 45.6s-45.8-20.3-45.8-45.6 20.6-45.8 45.8-45.8c25.4 0 45.6 20.5 45.6 45.8zm-253.9-45.8c-25.3 0-45.6 20.6-45.6 45.8s20.3 45.6 45.6 45.6 45.8-20.3 45.8-45.6-20.5-45.8-45.8-45.8zm291.7-270C158.9 124.9 81.9 112.1 0 25.7c34.4 51.7 53.3 148.9 373.1 144.2 333.3-5 130 86.1 70.8 188.9 186.7-166.7 319.4-233.9 17.2-233.9z"
        ],
        "openid": [
            448,
            512,
            [],
            "f19b",
            "M271.5 432l-68 32C88.5 453.7 0 392.5 0 318.2c0-71.5 82.5-131 191.7-144.3v43c-71.5 12.5-124 53-124 101.3 0 51 58.5 93.3 135.7 103v-340l68-33.2v384zM448 291l-131.3-28.5 36.8-20.7c-19.5-11.5-43.5-20-70-24.8v-43c46.2 5.5 87.7 19.5 120.3 39.3l35-19.8L448 291z"
        ],
        "opera": [
            496,
            512,
            [],
            "f26a",
            "M313.9 32.7c-170.2 0-252.6 223.8-147.5 355.1 36.5 45.4 88.6 75.6 147.5 75.6 36.3 0 70.3-11.1 99.4-30.4-43.8 39.2-101.9 63-165.3 63-3.9 0-8 0-11.9-.3C104.6 489.6 0 381.1 0 248 0 111 111 0 248 0h.8c63.1.3 120.7 24.1 164.4 63.1-29-19.4-63.1-30.4-99.3-30.4zm101.8 397.7c-40.9 24.7-90.7 23.6-132-5.8 56.2-20.5 97.7-91.6 97.7-176.6 0-84.7-41.2-155.8-97.4-176.6 41.8-29.2 91.2-30.3 132.9-5 105.9 98.7 105.5 265.7-1.2 364z"
        ],
        "optin-monster": [
            576,
            512,
            [],
            "f23c",
            "M572.6 421.4c5.6-9.5 4.7-15.2-5.4-11.6-3-4.9-7-9.5-11.1-13.8 2.9-9.7-.7-14.2-10.8-9.2-4.6-3.2-10.3-6.5-15.9-9.2 0-15.1-11.6-11.6-17.6-5.7-10.4-1.5-18.7-.3-26.8 5.7.3-6.5.3-13 .3-19.7 12.6 0 40.2-11 45.9-36.2 1.4-6.8 1.6-13.8-.3-21.9-3-13.5-14.3-21.3-25.1-25.7-.8-5.9-7.6-14.3-14.9-15.9s-12.4 4.9-14.1 10.3c-8.5 0-19.2 2.8-21.1 8.4-5.4-.5-11.1-1.4-16.8-1.9 2.7-1.9 5.4-3.5 8.4-4.6 5.4-9.2 14.6-11.4 25.7-11.6V256c19.5-.5 43-5.9 53.8-18.1 12.7-13.8 14.6-37.3 12.4-55.1-2.4-17.3-9.7-37.6-24.6-48.1-8.4-5.9-21.6-.8-22.7 9.5-2.2 19.6 1.2 30-38.6 25.1-10.3-23.8-24.6-44.6-42.7-60C341 49.6 242.9 55.5 166.4 71.7c19.7 4.6 41.1 8.6 59.7 16.5-26.2 2.4-52.7 11.3-76.2 23.2-32.8 17-44 29.9-56.7 42.4 14.9-2.2 28.9-5.1 43.8-3.8-9.7 5.4-18.4 12.2-26.5 20-25.8.9-23.8-5.3-26.2-25.9-1.1-10.5-14.3-15.4-22.7-9.7-28.1 19.9-33.5 79.9-12.2 103.5 10.8 12.2 35.1 17.3 54.9 17.8-.3 1.1-.3 1.9-.3 2.7 10.8.5 19.5 2.7 24.6 11.6 3 1.1 5.7 2.7 8.1 4.6-5.4.5-11.1 1.4-16.5 1.9-3.3-6.6-13.7-8.1-21.1-8.1-1.6-5.7-6.5-12.2-14.1-10.3-6.8 1.9-14.1 10-14.9 15.9-22.5 9.5-30.1 26.8-25.1 47.6 5.3 24.8 33 36.2 45.9 36.2v19.7c-6.6-5-14.3-7.5-26.8-5.7-5.5-5.5-17.3-10.1-17.3 5.7-5.9 2.7-11.4 5.9-15.9 9.2-9.8-4.9-13.6-1.7-11.1 9.2-4.1 4.3-7.8 8.6-11.1 13.8-10.2-3.7-11 2.2-5.4 11.6-1.1 3.5-1.6 7-1.9 10.8-.5 31.6 44.6 64 73.5 65.1 17.3.5 34.6-8.4 43-23.5 113.2 4.9 226.7 4.1 340.2 0 8.1 15.1 25.4 24.3 42.7 23.5 29.2-1.1 74.3-33.5 73.5-65.1.2-3.7-.7-7.2-1.7-10.7zm-73.8-254c1.1-3 2.4-8.4 2.4-14.6 0-5.9 6.8-8.1 14.1-.8 11.1 11.6 14.9 40.5 13.8 51.1-4.1-13.6-13-29-30.3-35.7zm-4.6 6.7c19.5 6.2 28.6 27.6 29.7 48.9-1.1 2.7-3 5.4-4.9 7.6-5.7 5.9-15.4 10-26.2 12.2 4.3-21.3.3-47.3-12.7-63 4.9-.8 10.9-2.4 14.1-5.7zm-24.1 6.8c13.8 11.9 20 39.2 14.1 63.5-4.1.5-8.1.8-11.6.8-1.9-21.9-6.8-44-14.3-64.6 3.7.3 8.1.3 11.8.3zM47.5 203c-1.1-10.5 2.4-39.5 13.8-51.1 7-7.3 14.1-5.1 14.1.8 0 6.2 1.4 11.6 2.4 14.6-17.3 6.8-26.2 22.2-30.3 35.7zm9.7 27.6c-1.9-2.2-3.5-4.9-4.9-7.6 1.4-21.3 10.3-42.7 29.7-48.9 3.2 3.2 9.2 4.9 14.1 5.7-13 15.7-17 41.6-12.7 63-10.8-2.2-20.5-6-26.2-12.2zm47.9 14.6c-4.1 0-8.1-.3-12.7-.8-4.6-18.6-1.9-38.9 5.4-53v.3l12.2-5.1c4.9-1.9 9.7-3.8 14.9-4.9-10.7 19.7-17.4 41.3-19.8 63.5zm184-162.7c41.9 0 76.2 34 76.2 75.9 0 42.2-34.3 76.2-76.2 76.2s-76.2-34-76.2-76.2c0-41.8 34.3-75.9 76.2-75.9zm115.6 174.3c-.3 17.8-7 48.9-23 57-13.2 6.6-6.5-7.5-16.5-58.1 13.3.3 26.6.3 39.5 1.1zm-54-1.6c.8 4.9 3.8 40.3-1.6 41.9-11.6 3.5-40 4.3-51.1-1.1-4.1-3-4.6-35.9-4.3-41.1v.3c18.9-.3 38.1-.3 57 0zM278.3 309c-13 3.5-41.6 4.1-54.6-1.6-6.5-2.7-3.8-42.4-1.9-51.6 19.2-.5 38.4-.5 57.8-.8v.3c1.1 8.3 3.3 51.2-1.3 53.7zm-106.5-51.1c12.2-.8 24.6-1.4 36.8-1.6-2.4 15.4-3 43.5-4.9 52.2-1.1 6.8-4.3 6.8-9.7 4.3-21.9-9.8-27.6-35.2-22.2-54.9zm-35.4 31.3c7.8-1.1 15.7-1.9 23.5-2.7 1.6 6.2 3.8 11.9 7 17.6 10 17 44 35.7 45.1 7 6.2 14.9 40.8 12.2 54.9 10.8 15.7-1.4 23.8-1.4 26.8-14.3 12.4 4.3 30.8 4.1 44 3 11.3-.8 20.8-.5 24.6-8.9 1.1 5.1 1.9 11.6 4.6 16.8 10.8 21.3 37.3 1.4 46.8-31.6 8.6.8 17.6 1.9 26.5 2.7-.4 1.3-3.8 7.3 7.3 11.6-47.6 47-95.7 87.8-163.2 107-63.2-20.8-112.1-59.5-155.9-106.5 9.6-3.4 10.4-8.8 8-12.5zm-21.6 172.5c-3.8 17.8-21.9 29.7-39.7 28.9-19.2-.8-46.5-17-59.2-36.5-2.7-31.1 43.8-61.3 66.2-54.6 14.9 4.3 27.8 30.8 33.5 54 0 3-.3 5.7-.8 8.2zm-8.7-66c-.5-13.5-.5-27-.3-40.5h.3c2.7-1.6 5.7-3.8 7.8-6.5 6.5-1.6 13-5.1 15.1-9.2 3.3-7.1-7-7.5-5.4-12.4 2.7-1.1 5.7-2.2 7.8-3.5 29.2 29.2 58.6 56.5 97.3 77-36.8 11.3-72.4 27.6-105.9 47-1.2-18.6-7.7-35.9-16.7-51.9zm337.6 64.6c-103 3.5-206.2 4.1-309.4 0 0 .3 0 .3-.3.3v-.3h.3c35.1-21.6 72.2-39.2 112.4-50.8 11.6 5.1 23 9.5 34.9 13.2 2.2.8 2.2.8 4.3 0 14.3-4.1 28.4-9.2 42.2-15.4 41.5 11.7 78.8 31.7 115.6 53zm10.5-12.4c-35.9-19.5-73-35.9-111.9-47.6 38.1-20 71.9-47.3 103.5-76.7 2.2 1.4 4.6 2.4 7.6 3.2 0 .8.3 1.9.5 2.4-4.6 2.7-7.8 6.2-5.9 10.3 2.2 3.8 8.6 7.6 15.1 8.9 2.4 2.7 5.1 5.1 8.1 6.8 0 13.8-.3 27.6-.8 41.3l.3-.3c-9.3 15.9-15.5 37-16.5 51.7zm105.9 6.2c-12.7 19.5-40 35.7-59.2 36.5-19.3.9-40.5-13.2-40.5-37 5.7-23.2 18.9-49.7 33.5-54 22.7-6.9 69.2 23.4 66.2 54.5zM372.9 75.2c-3.8-72.1-100.8-79.7-126-23.5 44.6-24.3 90.3-15.7 126 23.5zM74.8 407.1c-15.7 1.6-49.5 25.4-49.5 43.2 0 11.6 15.7 19.5 32.2 14.9 12.2-3.2 31.1-17.6 35.9-27.3 6-11.6-3.7-32.7-18.6-30.8zm215.9-176.2c28.6 0 51.9-21.6 51.9-48.4 0-36.1-40.5-58.1-72.2-44.3 9.5 3 16.5 11.6 16.5 21.6 0 23.3-33.3 32-46.5 11.3-7.3 34.1 19.4 59.8 50.3 59.8zM68 474.1c.5 6.5 12.2 12.7 21.6 9.5 6.8-2.7 14.6-10.5 17.3-16.2 3-7-1.1-20-9.7-18.4-8.9 1.6-29.7 16.7-29.2 25.1zm433.2-67c-14.9-1.9-24.6 19.2-18.9 30.8 4.9 9.7 24.1 24.1 36.2 27.3 16.5 4.6 32.2-3.2 32.2-14.9 0-17.8-33.8-41.6-49.5-43.2zM478.8 449c-8.4-1.6-12.4 11.3-9.5 18.4 2.4 5.7 10.3 13.5 17.3 16.2 9.2 3.2 21.1-3 21.3-9.5.9-8.4-20.2-23.5-29.1-25.1z"
        ],
        "orcid": [
            512,
            512,
            [],
            "f8d2",
            "M294.75 188.19h-45.92V342h47.47c67.62 0 83.12-51.34 83.12-76.91 0-41.64-26.54-76.9-84.67-76.9zM256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm-80.79 360.76h-29.84v-207.5h29.84zm-14.92-231.14a19.57 19.57 0 1 1 19.57-19.57 19.64 19.64 0 0 1-19.57 19.57zM300 369h-81V161.26h80.6c76.73 0 110.44 54.83 110.44 103.85C410 318.39 368.38 369 300 369z"
        ],
        "osi": [
            512,
            512,
            [],
            "f41a",
            "M8 266.44C10.3 130.64 105.4 34 221.8 18.34c138.8-18.6 255.6 75.8 278 201.1 21.3 118.8-44 230-151.6 274-9.3 3.8-14.4 1.7-18-7.7q-26.7-69.45-53.4-139c-3.1-8.1-1-13.2 7-16.8 24.2-11 39.3-29.4 43.3-55.8a71.47 71.47 0 0 0-64.5-82.2c-39-3.4-71.8 23.7-77.5 59.7-5.2 33 11.1 63.7 41.9 77.7 9.6 4.4 11.5 8.6 7.8 18.4q-26.85 69.9-53.7 139.9c-2.6 6.9-8.3 9.3-15.5 6.5-52.6-20.3-101.4-61-130.8-119-24.9-49.2-25.2-87.7-26.8-108.7zm20.9-1.9c.4 6.6.6 14.3 1.3 22.1 6.3 71.9 49.6 143.5 131 183.1 3.2 1.5 4.4.8 5.6-2.3q22.35-58.65 45-117.3c1.3-3.3.6-4.8-2.4-6.7-31.6-19.9-47.3-48.5-45.6-86 1-21.6 9.3-40.5 23.8-56.3 30-32.7 77-39.8 115.5-17.6a91.64 91.64 0 0 1 45.2 90.4c-3.6 30.6-19.3 53.9-45.7 69.8-2.7 1.6-3.5 2.9-2.3 6q22.8 58.8 45.2 117.7c1.2 3.1 2.4 3.8 5.6 2.3 35.5-16.6 65.2-40.3 88.1-72 34.8-48.2 49.1-101.9 42.3-161-13.7-117.5-119.4-214.8-255.5-198-106.1 13-195.3 102.5-197.1 225.8z"
        ],
        "page4": [
            496,
            512,
            [],
            "f3d7",
            "M248 504C111 504 0 393 0 256S111 8 248 8c20.9 0 41.3 2.6 60.7 7.5L42.3 392H248v112zm0-143.6V146.8L98.6 360.4H248zm96 31.6v92.7c45.7-19.2 84.5-51.7 111.4-92.7H344zm57.4-138.2l-21.2 8.4 21.2 8.3v-16.7zm-20.3 54.5c-6.7 0-8 6.3-8 12.9v7.7h16.2v-10c0-5.9-2.3-10.6-8.2-10.6zM496 256c0 37.3-8.2 72.7-23 104.4H344V27.3C433.3 64.8 496 153.1 496 256zM360.4 143.6h68.2V96h-13.9v32.6h-13.9V99h-13.9v29.6h-12.7V96h-13.9v47.6zm68.1 185.3H402v-11c0-15.4-5.6-25.2-20.9-25.2-15.4 0-20.7 10.6-20.7 25.9v25.3h68.2v-15zm0-103l-68.2 29.7V268l68.2 29.5v-16.6l-14.4-5.7v-26.5l14.4-5.9v-16.9zm-4.8-68.5h-35.6V184H402v-12.2h11c8.6 15.8 1.3 35.3-18.6 35.3-22.5 0-28.3-25.3-15.5-37.7l-11.6-10.6c-16.2 17.5-12.2 63.9 27.1 63.9 34 0 44.7-35.9 29.3-65.3z"
        ],
        "pagelines": [
            384,
            512,
            [],
            "f18c",
            "M384 312.7c-55.1 136.7-187.1 54-187.1 54-40.5 81.8-107.4 134.4-184.6 134.7-16.1 0-16.6-24.4 0-24.4 64.4-.3 120.5-42.7 157.2-110.1-41.1 15.9-118.6 27.9-161.6-82.2 109-44.9 159.1 11.2 178.3 45.5 9.9-24.4 17-50.9 21.6-79.7 0 0-139.7 21.9-149.5-98.1 119.1-47.9 152.6 76.7 152.6 76.7 1.6-16.7 3.3-52.6 3.3-53.4 0 0-106.3-73.7-38.1-165.2 124.6 43 61.4 162.4 61.4 162.4.5 1.6.5 23.8 0 33.4 0 0 45.2-89 136.4-57.5-4.2 134-141.9 106.4-141.9 106.4-4.4 27.4-11.2 53.4-20 77.5 0 0 83-91.8 172-20z"
        ],
        "palfed": [
            576,
            512,
            [],
            "f3d8",
            "M384.9 193.9c0-47.4-55.2-44.2-95.4-29.8-1.3 39.4-2.5 80.7-3 119.8.7 2.8 2.6 6.2 15.1 6.2 36.8 0 83.4-42.8 83.3-96.2zm-194.5 72.2c.2 0 6.5-2.7 11.2-2.7 26.6 0 20.7 44.1-14.4 44.1-21.5 0-37.1-18.1-37.1-43 0-42 42.9-95.6 100.7-126.5 1-12.4 3-22 10.5-28.2 11.2-9 26.6-3.5 29.5 11.1 72.2-22.2 135.2 1 135.2 72 0 77.9-79.3 152.6-140.1 138.2-.1 39.4.9 74.4 2.7 100v.2c.2 3.4.6 12.5-5.3 19.1-9.6 10.6-33.4 10-36.4-22.3-4.1-44.4.2-206.1 1.4-242.5-21.5 15-58.5 50.3-58.5 75.9.2 2.5.4 4 .6 4.6zM8 181.1s-.1 37.4 38.4 37.4h30l22.4 217.2s0 44.3 44.7 44.3h288.9s44.7-.4 44.7-44.3l22.4-217.2h30s38.4 1.2 38.4-37.4c0 0 .1-37.4-38.4-37.4h-30.1c-7.3-25.6-30.2-74.3-119.4-74.3h-28V50.3s-2.7-18.4-21.1-18.4h-85.8s-21.1 0-21.1 18.4v19.1h-28.1s-105 4.2-120.5 74.3h-29S8 142.5 8 181.1z"
        ],
        "patreon": [
            512,
            512,
            [],
            "f3d9",
            "M512 194.8c0 101.3-82.4 183.8-183.8 183.8-101.7 0-184.4-82.4-184.4-183.8 0-101.6 82.7-184.3 184.4-184.3C429.6 10.5 512 93.2 512 194.8zM0 501.5h90v-491H0v491z"
        ],
        "paypal": [
            384,
            512,
            [],
            "f1ed",
            "M111.4 295.9c-3.5 19.2-17.4 108.7-21.5 134-.3 1.8-1 2.5-3 2.5H12.3c-7.6 0-13.1-6.6-12.1-13.9L58.8 46.6c1.5-9.6 10.1-16.9 20-16.9 152.3 0 165.1-3.7 204 11.4 60.1 23.3 65.6 79.5 44 140.3-21.5 62.6-72.5 89.5-140.1 90.3-43.4.7-69.5-7-75.3 24.2zM357.1 152c-1.8-1.3-2.5-1.8-3 1.3-2 11.4-5.1 22.5-8.8 33.6-39.9 113.8-150.5 103.9-204.5 103.9-6.1 0-10.1 3.3-10.9 9.4-22.6 140.4-27.1 169.7-27.1 169.7-1 7.1 3.5 12.9 10.6 12.9h63.5c8.6 0 15.7-6.3 17.4-14.9.7-5.4-1.1 6.1 14.4-91.3 4.6-22 14.3-19.7 29.3-19.7 71 0 126.4-28.8 142.9-112.3 6.5-34.8 4.6-71.4-23.8-92.6z"
        ],
        "penny-arcade": [
            640,
            512,
            [],
            "f704",
            "M421.91 164.27c-4.49 19.45-1.4 6.06-15.1 65.29l39.73-10.61c-22.34-49.61-17.29-38.41-24.63-54.68zm-206.09 51.11c-20.19 5.4-11.31 3.03-39.63 10.58l4.46 46.19c28.17-7.59 20.62-5.57 34.82-9.34 42.3-9.79 32.85-56.42.35-47.43zm326.16-26.19l-45.47-99.2c-5.69-12.37-19.46-18.84-32.62-15.33-70.27 18.75-38.72 10.32-135.59 36.23a27.618 27.618 0 0 0-18.89 17.41C144.26 113.27 0 153.75 0 226.67c0 33.5 30.67 67.11 80.9 95.37l1.74 17.88a27.891 27.891 0 0 0-17.77 28.67l4.3 44.48c1.39 14.31 13.43 25.21 27.8 25.2 5.18-.01-3.01 1.78 122.53-31.76 12.57-3.37 21.12-15.02 20.58-28.02 216.59 45.5 401.99-5.98 399.89-84.83.01-28.15-22.19-66.56-97.99-104.47zM255.14 298.3l-21.91 5.88-48.44 12.91 2.46 23.55 20.53-5.51 4.51 44.51-115.31 30.78-4.3-44.52 20.02-5.35-11.11-114.64-20.12 5.39-4.35-44.5c178.15-47.54 170.18-46.42 186.22-46.65 56.66-1.13 64.15 71.84 42.55 104.43a86.7 86.7 0 0 1-50.75 33.72zm199.18 16.62l-3.89-39.49 14.9-3.98-6.61-14.68-57.76 15.42-4.1 17.54 19.2-5.12 4.05 39.54-112.85 30.07-4.46-44.43 20.99-5.59 33.08-126.47-17.15 4.56-4.2-44.48c93.36-24.99 65.01-17.41 135.59-36.24l66.67 145.47 20.79-5.56 4.3 44.48-108.55 28.96z"
        ],
        "perbyte": [
            448,
            512,
            [],
            "e083",
            "M305.314,284.578H246.6V383.3h58.711q24.423,0,38.193-13.77t13.77-36.11q0-21.826-14.032-35.335T305.314,284.578ZM149.435,128.7H90.724v98.723h58.711q24.42,0,38.19-13.773t13.77-36.107q0-21.826-14.029-35.338T149.435,128.7ZM366.647,32H81.353A81.445,81.445,0,0,0,0,113.352V398.647A81.445,81.445,0,0,0,81.353,480H366.647A81.445,81.445,0,0,0,448,398.647V113.352A81.445,81.445,0,0,0,366.647,32Zm63.635,366.647a63.706,63.706,0,0,1-63.635,63.635H81.353a63.706,63.706,0,0,1-63.635-63.635V113.352A63.706,63.706,0,0,1,81.353,49.718H366.647a63.706,63.706,0,0,1,63.635,63.634ZM305.314,128.7H246.6v98.723h58.711q24.423,0,38.193-13.773t13.77-36.107q0-21.826-14.032-35.338T305.314,128.7Z"
        ],
        "periscope": [
            448,
            512,
            [],
            "f3da",
            "M370 63.6C331.4 22.6 280.5 0 226.6 0 111.9 0 18.5 96.2 18.5 214.4c0 75.1 57.8 159.8 82.7 192.7C137.8 455.5 192.6 512 226.6 512c41.6 0 112.9-94.2 120.9-105 24.6-33.1 82-118.3 82-192.6 0-56.5-21.1-110.1-59.5-150.8zM226.6 493.9c-42.5 0-190-167.3-190-279.4 0-107.4 83.9-196.3 190-196.3 100.8 0 184.7 89 184.7 196.3.1 112.1-147.4 279.4-184.7 279.4zM338 206.8c0 59.1-51.1 109.7-110.8 109.7-100.6 0-150.7-108.2-92.9-181.8v.4c0 24.5 20.1 44.4 44.8 44.4 24.7 0 44.8-19.9 44.8-44.4 0-18.2-11.1-33.8-26.9-40.7 76.6-19.2 141 39.3 141 112.4z"
        ],
        "phabricator": [
            496,
            512,
            [],
            "f3db",
            "M323 262.1l-.1-13s21.7-19.8 21.1-21.2l-9.5-20c-.6-1.4-29.5-.5-29.5-.5l-9.4-9.3s.2-28.5-1.2-29.1l-20.1-9.2c-1.4-.6-20.7 21-20.7 21l-13.1-.2s-20.5-21.4-21.9-20.8l-20 8.3c-1.4.5.2 28.9.2 28.9l-9.1 9.1s-29.2-.9-29.7.4l-8.1 19.8c-.6 1.4 21 21 21 21l.1 12.9s-21.7 19.8-21.1 21.2l9.5 20c.6 1.4 29.5.5 29.5.5l9.4 9.3s-.2 31.8 1.2 32.3l20.1 8.3c1.4.6 20.7-23.5 20.7-23.5l13.1.2s20.5 23.8 21.8 23.3l20-7.5c1.4-.6-.2-32.1-.2-32.1l9.1-9.1s29.2.9 29.7-.5l8.1-19.8c.7-1.1-20.9-20.7-20.9-20.7zm-44.9-8.7c.7 17.1-12.8 31.6-30.1 32.4-17.3.8-32.1-12.5-32.8-29.6-.7-17.1 12.8-31.6 30.1-32.3 17.3-.8 32.1 12.5 32.8 29.5zm201.2-37.9l-97-97-.1.1c-75.1-73.3-195.4-72.8-269.8 1.6-50.9 51-27.8 27.9-95.7 95.3-22.3 22.3-22.3 58.7 0 81 69.9 69.4 46.4 46 97.4 97l.1-.1c75.1 73.3 195.4 72.9 269.8-1.6 51-50.9 27.9-27.9 95.3-95.3 22.3-22.3 22.3-58.7 0-81zM140.4 363.8c-59.6-59.5-59.6-156 0-215.5 59.5-59.6 156-59.5 215.6 0 59.5 59.5 59.6 156 0 215.6-59.6 59.5-156 59.4-215.6-.1z"
        ],
        "phoenix-framework": [
            640,
            512,
            [],
            "f3dc",
            "M212.9 344.3c3.8-.1 22.8-1.4 25.6-2.2-2.4-2.6-43.6-1-68-49.6-4.3-8.6-7.5-17.6-6.4-27.6 2.9-25.5 32.9-30 52-18.5 36 21.6 63.3 91.3 113.7 97.5 37 4.5 84.6-17 108.2-45.4-.6-.1-.8-.2-1-.1-.4.1-.8.2-1.1.3-33.3 12.1-94.3 9.7-134.7-14.8-37.6-22.8-53.1-58.7-51.8-74.6 1.8-21.3 22.9-23.2 35.9-19.6 14.4 3.9 24.4 17.6 38.9 27.4 15.6 10.4 32.9 13.7 51.3 10.3 14.9-2.7 34.4-12.3 36.5-14.5-1.1-.1-1.8-.1-2.5-.2-6.2-.6-12.4-.8-18.5-1.7C279.8 194.5 262.1 47.4 138.5 37.9 94.2 34.5 39.1 46 2.2 72.9c-.8.6-1.5 1.2-2.2 1.8.1.2.1.3.2.5.8 0 1.6-.1 2.4-.2 6.3-1 12.5-.8 18.7.3 23.8 4.3 47.7 23.1 55.9 76.5 5.3 34.3-.7 50.8 8 86.1 19 77.1 91 107.6 127.7 106.4zM75.3 64.9c-.9-1-.9-1.2-1.3-2 12.1-2.6 24.2-4.1 36.6-4.8-1.1 14.7-22.2 21.3-35.3 6.8zm196.9 350.5c-42.8 1.2-92-26.7-123.5-61.4-4.6-5-16.8-20.2-18.6-23.4l.4-.4c6.6 4.1 25.7 18.6 54.8 27 24.2 7 48.1 6.3 71.6-3.3 22.7-9.3 41-.5 43.1 2.9-18.5 3.8-20.1 4.4-24 7.9-5.1 4.4-4.6 11.7 7 17.2 26.2 12.4 63-2.8 97.2 25.4 2.4 2 8.1 7.8 10.1 10.7-.1.2-.3.3-.4.5-4.8-1.5-16.4-7.5-40.2-9.3-24.7-2-46.3 5.3-77.5 6.2zm174.8-252c16.4-5.2 41.3-13.4 66.5-3.3 16.1 6.5 26.2 18.7 32.1 34.6 3.5 9.4 5.1 19.7 5.1 28.7-.2 0-.4 0-.6.1-.2-.4-.4-.9-.5-1.3-5-22-29.9-43.8-67.6-29.9-50.2 18.6-130.4 9.7-176.9-48-.7-.9-2.4-1.7-1.3-3.2.1-.2 2.1.6 3 1.3 18.1 13.4 38.3 21.9 60.3 26.2 30.5 6.1 54.6 2.9 79.9-5.2zm102.7 117.5c-32.4.2-33.8 50.1-103.6 64.4-18.2 3.7-38.7 4.6-44.9 4.2v-.4c2.8-1.5 14.7-2.6 29.7-16.6 7.9-7.3 15.3-15.1 22.8-22.9 19.5-20.2 41.4-42.2 81.9-39 23.1 1.8 29.3 8.2 36.1 12.7.3.2.4.5.7.9-.5 0-.7.1-.9 0-7-2.7-14.3-3.3-21.8-3.3zm-12.3-24.1c-.1.2-.1.4-.2.6-28.9-4.4-48-7.9-68.5 4-17 9.9-31.4 20.5-62 24.4-27.1 3.4-45.1 2.4-66.1-8-.3-.2-.6-.4-1-.6 0-.2.1-.3.1-.5 24.9 3.8 36.4 5.1 55.5-5.8 22.3-12.9 40.1-26.6 71.3-31 29.6-4.1 51.3 2.5 70.9 16.9zM268.6 97.3c-.6-.6-1.1-1.2-2.1-2.3 7.6 0 29.7-1.2 53.4 8.4 19.7 8 32.2 21 50.2 32.9 11.1 7.3 23.4 9.3 36.4 8.1 4.3-.4 8.5-1.2 12.8-1.7.4-.1.9 0 1.5.3-.6.4-1.2.9-1.8 1.2-8.1 4-16.7 6.3-25.6 7.1-26.1 2.6-50.3-3.7-73.4-15.4-19.3-9.9-36.4-22.9-51.4-38.6zM640 335.7c-3.5 3.1-22.7 11.6-42.7 5.3-12.3-3.9-19.5-14.9-31.6-24.1-10-7.6-20.9-7.9-28.1-8.4.6-.8.9-1.2 1.2-1.4 14.8-9.2 30.5-12.2 47.3-6.5 12.5 4.2 19.2 13.5 30.4 24.2 10.8 10.4 21 9.9 23.1 10.5.1-.1.2 0 .4.4zm-212.5 137c2.2 1.2 1.6 1.5 1.5 2-18.5-1.4-33.9-7.6-46.8-22.2-21.8-24.7-41.7-27.9-48.6-29.7.5-.2.8-.4 1.1-.4 13.1.1 26.1.7 38.9 3.9 25.3 6.4 35 25.4 41.6 35.3 3.2 4.8 7.3 8.3 12.3 11.1z"
        ],
        "phoenix-squadron": [
            512,
            512,
            [],
            "f511",
            "M96 63.38C142.49 27.25 201.55 7.31 260.51 8.81c29.58-.38 59.11 5.37 86.91 15.33-24.13-4.63-49-6.34-73.38-2.45C231.17 27 191 48.84 162.21 80.87c5.67-1 10.78-3.67 16-5.86 18.14-7.87 37.49-13.26 57.23-14.83 19.74-2.13 39.64-.43 59.28 1.92-14.42 2.79-29.12 4.57-43 9.59-34.43 11.07-65.27 33.16-86.3 62.63-13.8 19.71-23.63 42.86-24.67 67.13-.35 16.49 5.22 34.81 19.83 44a53.27 53.27 0 0 0 37.52 6.74c15.45-2.46 30.07-8.64 43.6-16.33 11.52-6.82 22.67-14.55 32-24.25 3.79-3.22 2.53-8.45 2.62-12.79-2.12-.34-4.38-1.11-6.3.3a203 203 0 0 1-35.82 15.37c-20 6.17-42.16 8.46-62.1.78 12.79 1.73 26.06.31 37.74-5.44 20.23-9.72 36.81-25.2 54.44-38.77a526.57 526.57 0 0 1 88.9-55.31c25.71-12 52.94-22.78 81.57-24.12-15.63 13.72-32.15 26.52-46.78 41.38-14.51 14-27.46 29.5-40.11 45.18-3.52 4.6-8.95 6.94-13.58 10.16a150.7 150.7 0 0 0-51.89 60.1c-9.33 19.68-14.5 41.85-11.77 63.65 1.94 13.69 8.71 27.59 20.9 34.91 12.9 8 29.05 8.07 43.48 5.1 32.8-7.45 61.43-28.89 81-55.84 20.44-27.52 30.52-62.2 29.16-96.35-.52-7.5-1.57-15-1.66-22.49 8 19.48 14.82 39.71 16.65 60.83 2 14.28.75 28.76-1.62 42.9-1.91 11-5.67 21.51-7.78 32.43a165 165 0 0 0 39.34-81.07 183.64 183.64 0 0 0-14.21-104.64c20.78 32 32.34 69.58 35.71 107.48.49 12.73.49 25.51 0 38.23A243.21 243.21 0 0 1 482 371.34c-26.12 47.34-68 85.63-117.19 108-78.29 36.23-174.68 31.32-248-14.68A248.34 248.34 0 0 1 25.36 366 238.34 238.34 0 0 1 0 273.08v-31.34C3.93 172 40.87 105.82 96 63.38m222 80.33a79.13 79.13 0 0 0 16-4.48c5-1.77 9.24-5.94 10.32-11.22-8.96 4.99-17.98 9.92-26.32 15.7z"
        ],
        "php": [
            640,
            512,
            [],
            "f457",
            "M320 104.5c171.4 0 303.2 72.2 303.2 151.5S491.3 407.5 320 407.5c-171.4 0-303.2-72.2-303.2-151.5S148.7 104.5 320 104.5m0-16.8C143.3 87.7 0 163 0 256s143.3 168.3 320 168.3S640 349 640 256 496.7 87.7 320 87.7zM218.2 242.5c-7.9 40.5-35.8 36.3-70.1 36.3l13.7-70.6c38 0 63.8-4.1 56.4 34.3zM97.4 350.3h36.7l8.7-44.8c41.1 0 66.6 3 90.2-19.1 26.1-24 32.9-66.7 14.3-88.1-9.7-11.2-25.3-16.7-46.5-16.7h-70.7L97.4 350.3zm185.7-213.6h36.5l-8.7 44.8c31.5 0 60.7-2.3 74.8 10.7 14.8 13.6 7.7 31-8.3 113.1h-37c15.4-79.4 18.3-86 12.7-92-5.4-5.8-17.7-4.6-47.4-4.6l-18.8 96.6h-36.5l32.7-168.6zM505 242.5c-8 41.1-36.7 36.3-70.1 36.3l13.7-70.6c38.2 0 63.8-4.1 56.4 34.3zM384.2 350.3H421l8.7-44.8c43.2 0 67.1 2.5 90.2-19.1 26.1-24 32.9-66.7 14.3-88.1-9.7-11.2-25.3-16.7-46.5-16.7H417l-32.8 168.7z"
        ],
        "pied-piper": [
            480,
            512,
            [],
            "f2ae",
            "M455.93,23.2C429.23,30,387.79,51.69,341.35,90.66A206,206,0,0,0,240,64C125.13,64,32,157.12,32,272s93.13,208,208,208,208-93.13,208-208a207.25,207.25,0,0,0-58.75-144.81,155.35,155.35,0,0,0-17,27.4A176.16,176.16,0,0,1,417.1,272c0,97.66-79.44,177.11-177.09,177.11a175.81,175.81,0,0,1-87.63-23.4c82.94-107.33,150.79-37.77,184.31-226.65,5.79-32.62,28-94.26,126.23-160.18C471,33.45,465.35,20.8,455.93,23.2ZM125,406.4A176.66,176.66,0,0,1,62.9,272C62.9,174.34,142.35,94.9,240,94.9a174,174,0,0,1,76.63,17.75C250.64,174.76,189.77,265.52,125,406.4Z"
        ],
        "pied-piper-alt": [
            576,
            512,
            [],
            "f1a8",
            "M244 246c-3.2-2-6.3-2.9-10.1-2.9-6.6 0-12.6 3.2-19.3 3.7l1.7 4.9zm135.9 197.9c-19 0-64.1 9.5-79.9 19.8l6.9 45.1c35.7 6.1 70.1 3.6 106-9.8-4.8-10-23.5-55.1-33-55.1zM340.8 177c6.6 2.8 11.5 9.2 22.7 22.1 2-1.4 7.5-5.2 7.5-8.6 0-4.9-11.8-13.2-13.2-23 11.2-5.7 25.2-6 37.6-8.9 68.1-16.4 116.3-52.9 146.8-116.7C548.3 29.3 554 16.1 554.6 2l-2 2.6c-28.4 50-33 63.2-81.3 100-31.9 24.4-69.2 40.2-106.6 54.6l-6.3-.3v-21.8c-19.6 1.6-19.7-14.6-31.6-23-18.7 20.6-31.6 40.8-58.9 51.1-12.7 4.8-19.6 10-25.9 21.8 34.9-16.4 91.2-13.5 98.8-10zM555.5 0l-.6 1.1-.3.9.6-.6zm-59.2 382.1c-33.9-56.9-75.3-118.4-150-115.5l-.3-6c-1.1-13.5 32.8 3.2 35.1-31l-14.4 7.2c-19.8-45.7-8.6-54.3-65.5-54.3-14.7 0-26.7 1.7-41.4 4.6 2.9 18.6 2.2 36.7-10.9 50.3l19.5 5.5c-1.7 3.2-2.9 6.3-2.9 9.8 0 21 42.8 2.9 42.8 33.6 0 18.4-36.8 60.1-54.9 60.1-8 0-53.7-50-53.4-60.1l.3-4.6 52.3-11.5c13-2.6 12.3-22.7-2.9-22.7-3.7 0-43.1 9.2-49.4 10.6-2-5.2-7.5-14.1-13.8-14.1-3.2 0-6.3 3.2-9.5 4-9.2 2.6-31 2.9-21.5 20.1L15.9 298.5c-5.5 1.1-8.9 6.3-8.9 11.8 0 6 5.5 10.9 11.5 10.9 8 0 131.3-28.4 147.4-32.2 2.6 3.2 4.6 6.3 7.8 8.6 20.1 14.4 59.8 85.9 76.4 85.9 24.1 0 58-22.4 71.3-41.9 3.2-4.3 6.9-7.5 12.4-6.9.6 13.8-31.6 34.2-33 43.7-1.4 10.2-1 35.2-.3 41.1 26.7 8.1 52-3.6 77.9-2.9 4.3-21 10.6-41.9 9.8-63.5l-.3-9.5c-1.4-34.2-10.9-38.5-34.8-58.6-1.1-1.1-2.6-2.6-3.7-4 2.2-1.4 1.1-1 4.6-1.7 88.5 0 56.3 183.6 111.5 229.9 33.1-15 72.5-27.9 103.5-47.2-29-25.6-52.6-45.7-72.7-79.9zm-196.2 46.1v27.2l11.8-3.4-2.9-23.8zm-68.7-150.4l24.1 61.2 21-13.8-31.3-50.9zm84.4 154.9l2 12.4c9-1.5 58.4-6.6 58.4-14.1 0-1.4-.6-3.2-.9-4.6-26.8 0-36.9 3.8-59.5 6.3z"
        ],
        "pied-piper-hat": [
            640,
            512,
            [],
            "f4e5",
            "M640 24.9c-80.8 53.6-89.4 92.5-96.4 104.4-6.7 12.2-11.7 60.3-23.3 83.6-11.7 23.6-54.2 42.2-66.1 50-11.7 7.8-28.3 38.1-41.9 64.2-108.1-4.4-167.4 38.8-259.2 93.6 29.4-9.7 43.3-16.7 43.3-16.7 94.2-36 139.3-68.3 281.1-49.2 1.1 0 1.9.6 2.8.8 3.9 2.2 5.3 6.9 3.1 10.8l-53.9 95.8c-2.5 4.7-7.8 7.2-13.1 6.1-126.8-23.8-226.9 17.3-318.9 18.6C24.1 488 0 453.4 0 451.8c0-1.1.6-1.7 1.7-1.7 0 0 38.3 0 103.1-15.3C178.4 294.5 244 245.4 315.4 245.4c0 0 71.7 0 90.6 61.9 22.8-39.7 28.3-49.2 28.3-49.2 5.3-9.4 35-77.2 86.4-141.4 51.5-64 90.4-79.9 119.3-91.8z"
        ],
        "pied-piper-pp": [
            448,
            512,
            [],
            "f1a7",
            "M205.3 174.6c0 21.1-14.2 38.1-31.7 38.1-7.1 0-12.8-1.2-17.2-3.7v-68c4.4-2.7 10.1-4.2 17.2-4.2 17.5 0 31.7 16.9 31.7 37.8zm52.6 67c-7.1 0-12.8 1.5-17.2 4.2v68c4.4 2.5 10.1 3.7 17.2 3.7 17.4 0 31.7-16.9 31.7-37.8 0-21.1-14.3-38.1-31.7-38.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zM185 255.1c41 0 74.2-35.6 74.2-79.6 0-44-33.2-79.6-74.2-79.6-12 0-24.1 3.2-34.6 8.8h-45.7V311l51.8-10.1v-50.6c8.6 3.1 18.1 4.8 28.5 4.8zm158.4 25.3c0-44-33.2-79.6-73.9-79.6-3.2 0-6.4.2-9.6.7-3.7 12.5-10.1 23.8-19.2 33.4-13.8 15-32.2 23.8-51.8 24.8V416l51.8-10.1v-50.6c8.6 3.2 18.2 4.7 28.7 4.7 40.8 0 74-35.6 74-79.6z"
        ],
        "pied-piper-square": [
            448,
            512,
            [],
            "e01e",
            "M32 419L0 479.2l.8-328C.8 85.3 54 32 120 32h327.2c-93 28.9-189.9 94.2-253.9 168.6C122.7 282 82.6 338 32 419M448 32S305.2 98.8 261.6 199.1c-23.2 53.6-28.9 118.1-71 158.6-28.9 27.8-69.8 38.2-105.3 56.3-23.2 12-66.4 40.5-84.9 66h328.4c66 0 119.3-53.3 119.3-119.2-.1 0-.1-328.8-.1-328.8z"
        ],
        "pinterest": [
            496,
            512,
            [],
            "f0d2",
            "M496 256c0 137-111 248-248 248-25.6 0-50.2-3.9-73.4-11.1 10.1-16.5 25.2-43.5 30.8-65 3-11.6 15.4-59 15.4-59 8.1 15.4 31.7 28.5 56.8 28.5 74.8 0 128.7-68.8 128.7-154.3 0-81.9-66.9-143.2-152.9-143.2-107 0-163.9 71.8-163.9 150.1 0 36.4 19.4 81.7 50.3 96.1 4.7 2.2 7.2 1.2 8.3-3.3.8-3.4 5-20.3 6.9-28.1.6-2.5.3-4.7-1.7-7.1-10.1-12.5-18.3-35.3-18.3-56.6 0-54.7 41.4-107.6 112-107.6 60.9 0 103.6 41.5 103.6 100.9 0 67.1-33.9 113.6-78 113.6-24.3 0-42.6-20.1-36.7-44.8 7-29.5 20.5-61.3 20.5-82.6 0-19-10.2-34.9-31.4-34.9-24.9 0-44.9 25.7-44.9 60.2 0 22 7.4 36.8 7.4 36.8s-24.5 103.8-29 123.2c-5 21.4-3 51.6-.9 71.2C65.4 450.9 0 361.1 0 256 0 119 111 8 248 8s248 111 248 248z"
        ],
        "pinterest-p": [
            384,
            512,
            [],
            "f231",
            "M204 6.5C101.4 6.5 0 74.9 0 185.6 0 256 39.6 296 63.6 296c9.9 0 15.6-27.6 15.6-35.4 0-9.3-23.7-29.1-23.7-67.8 0-80.4 61.2-137.4 140.4-137.4 68.1 0 118.5 38.7 118.5 109.8 0 53.1-21.3 152.7-90.3 152.7-24.9 0-46.2-18-46.2-43.8 0-37.8 26.4-74.4 26.4-113.4 0-66.2-93.9-54.2-93.9 25.8 0 16.8 2.1 35.4 9.6 50.7-13.8 59.4-42 147.9-42 209.1 0 18.9 2.7 37.5 4.5 56.4 3.4 3.8 1.7 3.4 6.9 1.5 50.4-69 48.6-82.5 71.4-172.8 12.3 23.4 44.1 36 69.3 36 106.2 0 153.9-103.5 153.9-196.8C384 71.3 298.2 6.5 204 6.5z"
        ],
        "pinterest-square": [
            448,
            512,
            [],
            "f0d3",
            "M448 80v352c0 26.5-21.5 48-48 48H154.4c9.8-16.4 22.4-40 27.4-59.3 3-11.5 15.3-58.4 15.3-58.4 8 15.3 31.4 28.2 56.3 28.2 74.1 0 127.4-68.1 127.4-152.7 0-81.1-66.2-141.8-151.4-141.8-106 0-162.2 71.1-162.2 148.6 0 36 19.2 80.8 49.8 95.1 4.7 2.2 7.1 1.2 8.2-3.3.8-3.4 5-20.1 6.8-27.8.6-2.5.3-4.6-1.7-7-10.1-12.3-18.3-34.9-18.3-56 0-54.2 41-106.6 110.9-106.6 60.3 0 102.6 41.1 102.6 99.9 0 66.4-33.5 112.4-77.2 112.4-24.1 0-42.1-19.9-36.4-44.4 6.9-29.2 20.3-60.7 20.3-81.8 0-53-75.5-45.7-75.5 25 0 21.7 7.3 36.5 7.3 36.5-31.4 132.8-36.1 134.5-29.6 192.6l2.2.8H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48z"
        ],
        "playstation": [
            576,
            512,
            [],
            "f3df",
            "M570.9 372.3c-11.3 14.2-38.8 24.3-38.8 24.3L327 470.2v-54.3l150.9-53.8c17.1-6.1 19.8-14.8 5.8-19.4-13.9-4.6-39.1-3.3-56.2 2.9L327 381.1v-56.4c23.2-7.8 47.1-13.6 75.7-16.8 40.9-4.5 90.9.6 130.2 15.5 44.2 14 49.2 34.7 38 48.9zm-224.4-92.5v-139c0-16.3-3-31.3-18.3-35.6-11.7-3.8-19 7.1-19 23.4v347.9l-93.8-29.8V32c39.9 7.4 98 24.9 129.2 35.4C424.1 94.7 451 128.7 451 205.2c0 74.5-46 102.8-104.5 74.6zM43.2 410.2c-45.4-12.8-53-39.5-32.3-54.8 19.1-14.2 51.7-24.9 51.7-24.9l134.5-47.8v54.5l-96.8 34.6c-17.1 6.1-19.7 14.8-5.8 19.4 13.9 4.6 39.1 3.3 56.2-2.9l46.4-16.9v48.8c-51.6 9.3-101.4 7.3-153.9-10z"
        ],
        "product-hunt": [
            512,
            512,
            [],
            "f288",
            "M326.3 218.8c0 20.5-16.7 37.2-37.2 37.2h-70.3v-74.4h70.3c20.5 0 37.2 16.7 37.2 37.2zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-128.1-37.2c0-47.9-38.9-86.8-86.8-86.8H169.2v248h49.6v-74.4h70.3c47.9 0 86.8-38.9 86.8-86.8z"
        ],
        "pushed": [
            432,
            512,
            [],
            "f3e1",
            "M407 111.9l-98.5-9 14-33.4c10.4-23.5-10.8-40.4-28.7-37L22.5 76.9c-15.1 2.7-26 18.3-21.4 36.6l105.1 348.3c6.5 21.3 36.7 24.2 47.7 7l35.3-80.8 235.2-231.3c16.4-16.8 4.3-42.9-17.4-44.8zM297.6 53.6c5.1-.7 7.5 2.5 5.2 7.4L286 100.9 108.6 84.6l189-31zM22.7 107.9c-3.1-5.1 1-10 6.1-9.1l248.7 22.7-96.9 230.7L22.7 107.9zM136 456.4c-2.6 4-7.9 3.1-9.4-1.2L43.5 179.7l127.7 197.6c-7 15-35.2 79.1-35.2 79.1zm272.8-314.5L210.1 337.3l89.7-213.7 106.4 9.7c4 1.1 5.7 5.3 2.6 8.6z"
        ],
        "python": [
            448,
            512,
            [],
            "f3e2",
            "M439.8 200.5c-7.7-30.9-22.3-54.2-53.4-54.2h-40.1v47.4c0 36.8-31.2 67.8-66.8 67.8H172.7c-29.2 0-53.4 25-53.4 54.3v101.8c0 29 25.2 46 53.4 54.3 33.8 9.9 66.3 11.7 106.8 0 26.9-7.8 53.4-23.5 53.4-54.3v-40.7H226.2v-13.6h160.2c31.1 0 42.6-21.7 53.4-54.2 11.2-33.5 10.7-65.7 0-108.6zM286.2 404c11.1 0 20.1 9.1 20.1 20.3 0 11.3-9 20.4-20.1 20.4-11 0-20.1-9.2-20.1-20.4.1-11.3 9.1-20.3 20.1-20.3zM167.8 248.1h106.8c29.7 0 53.4-24.5 53.4-54.3V91.9c0-29-24.4-50.7-53.4-55.6-35.8-5.9-74.7-5.6-106.8.1-45.2 8-53.4 24.7-53.4 55.6v40.7h106.9v13.6h-147c-31.1 0-58.3 18.7-66.8 54.2-9.8 40.7-10.2 66.1 0 108.6 7.6 31.6 25.7 54.2 56.8 54.2H101v-48.8c0-35.3 30.5-66.4 66.8-66.4zm-6.7-142.6c-11.1 0-20.1-9.1-20.1-20.3.1-11.3 9-20.4 20.1-20.4 11 0 20.1 9.2 20.1 20.4s-9 20.3-20.1 20.3z"
        ],
        "qq": [
            448,
            512,
            [],
            "f1d6",
            "M433.754 420.445c-11.526 1.393-44.86-52.741-44.86-52.741 0 31.345-16.136 72.247-51.051 101.786 16.842 5.192 54.843 19.167 45.803 34.421-7.316 12.343-125.51 7.881-159.632 4.037-34.122 3.844-152.316 8.306-159.632-4.037-9.045-15.25 28.918-29.214 45.783-34.415-34.92-29.539-51.059-70.445-51.059-101.792 0 0-33.334 54.134-44.859 52.741-5.37-.65-12.424-29.644 9.347-99.704 10.261-33.024 21.995-60.478 40.144-105.779C60.683 98.063 108.982.006 224 0c113.737.006 163.156 96.133 160.264 214.963 18.118 45.223 29.912 72.85 40.144 105.778 21.768 70.06 14.716 99.053 9.346 99.704z"
        ],
        "quinscape": [
            512,
            512,
            [],
            "f459",
            "M313.6 474.6h-1a158.1 158.1 0 0 1 0-316.2c94.9 0 168.2 83.1 157 176.6 4 5.1 8.2 9.6 11.2 15.3 13.4-30.3 20.3-62.4 20.3-97.7C501.1 117.5 391.6 8 256.5 8S12 117.5 12 252.6s109.5 244.6 244.5 244.6a237.36 237.36 0 0 0 70.4-10.1c-5.2-3.5-8.9-8.1-13.3-12.5zm-.1-.1l.4.1zm78.4-168.9a99.2 99.2 0 1 0 99.2 99.2 99.18 99.18 0 0 0-99.2-99.2z"
        ],
        "quora": [
            448,
            512,
            [],
            "f2c4",
            "M440.5 386.7h-29.3c-1.5 13.5-10.5 30.8-33 30.8-20.5 0-35.3-14.2-49.5-35.8 44.2-34.2 74.7-87.5 74.7-153C403.5 111.2 306.8 32 205 32 105.3 32 7.3 111.7 7.3 228.7c0 134.1 131.3 221.6 249 189C276 451.3 302 480 351.5 480c81.8 0 90.8-75.3 89-93.3zM297 329.2C277.5 300 253.3 277 205.5 277c-30.5 0-54.3 10-69 22.8l12.2 24.3c6.2-3 13-4 19.8-4 35.5 0 53.7 30.8 69.2 61.3-10 3-20.7 4.2-32.7 4.2-75 0-107.5-53-107.5-156.7C97.5 124.5 130 71 205 71c76.2 0 108.7 53.5 108.7 157.7.1 41.8-5.4 75.6-16.7 100.5z"
        ],
        "r-project": [
            581,
            512,
            [],
            "f4f7",
            "M581 226.6C581 119.1 450.9 32 290.5 32S0 119.1 0 226.6C0 322.4 103.3 402 239.4 418.1V480h99.1v-61.5c24.3-2.7 47.6-7.4 69.4-13.9L448 480h112l-67.4-113.7c54.5-35.4 88.4-84.9 88.4-139.7zm-466.8 14.5c0-73.5 98.9-133 220.8-133s211.9 40.7 211.9 133c0 50.1-26.5 85-70.3 106.4-2.4-1.6-4.7-2.9-6.4-3.7-10.2-5.2-27.8-10.5-27.8-10.5s86.6-6.4 86.6-92.7-90.6-87.9-90.6-87.9h-199V361c-74.1-21.5-125.2-67.1-125.2-119.9zm225.1 38.3v-55.6c57.8 0 87.8-6.8 87.8 27.3 0 36.5-38.2 28.3-87.8 28.3zm-.9 72.5H365c10.8 0 18.9 11.7 24 19.2-16.1 1.9-33 2.8-50.6 2.9v-22.1z"
        ],
        "raspberry-pi": [
            407,
            512,
            [],
            "f7bb",
            "M372 232.5l-3.7-6.5c.1-46.4-21.4-65.3-46.5-79.7 7.6-2 15.4-3.6 17.6-13.2 13.1-3.3 15.8-9.4 17.1-15.8 3.4-2.3 14.8-8.7 13.6-19.7 6.4-4.4 10-10.1 8.1-18.1 6.9-7.5 8.7-13.7 5.8-19.4 8.3-10.3 4.6-15.6 1.1-20.9 6.2-11.2.7-23.2-16.6-21.2-6.9-10.1-21.9-7.8-24.2-7.8-2.6-3.2-6-6-16.5-4.7-6.8-6.1-14.4-5-22.3-2.1-9.3-7.3-15.5-1.4-22.6.8C271.6.6 269 5.5 263.5 7.6c-12.3-2.6-16.1 3-22 8.9l-6.9-.1c-18.6 10.8-27.8 32.8-31.1 44.1-3.3-11.3-12.5-33.3-31.1-44.1l-6.9.1c-5.9-5.9-9.7-11.5-22-8.9-5.6-2-8.1-7-19.4-3.4-4.6-1.4-8.9-4.4-13.9-4.3-2.6.1-5.5 1-8.7 3.5-7.9-3-15.5-4-22.3 2.1-10.5-1.3-14 1.4-16.5 4.7-2.3 0-17.3-2.3-24.2 7.8C21.2 16 15.8 28 22 39.2c-3.5 5.4-7.2 10.7 1.1 20.9-2.9 5.7-1.1 11.9 5.8 19.4-1.8 8 1.8 13.7 8.1 18.1-1.2 11 10.2 17.4 13.6 19.7 1.3 6.4 4 12.4 17.1 15.8 2.2 9.5 10 11.2 17.6 13.2-25.1 14.4-46.6 33.3-46.5 79.7l-3.7 6.5c-28.8 17.2-54.7 72.7-14.2 117.7 2.6 14.1 7.1 24.2 11 35.4 5.9 45.2 44.5 66.3 54.6 68.8 14.9 11.2 30.8 21.8 52.2 29.2C159 504.2 181 512 203 512h1c22.1 0 44-7.8 64.2-28.4 21.5-7.4 37.3-18 52.2-29.2 10.2-2.5 48.7-23.6 54.6-68.8 3.9-11.2 8.4-21.3 11-35.4 40.6-45.1 14.7-100.5-14-117.7zm-22.2-8c-1.5 18.7-98.9-65.1-82.1-67.9 45.7-7.5 83.6 19.2 82.1 67.9zm-43 93.1c-24.5 15.8-59.8 5.6-78.8-22.8s-14.6-64.2 9.9-80c24.5-15.8 59.8-5.6 78.8 22.8s14.6 64.2-9.9 80zM238.9 29.3c.8 4.2 1.8 6.8 2.9 7.6 5.4-5.8 9.8-11.7 16.8-17.3 0 3.3-1.7 6.8 2.5 9.4 3.7-5 8.8-9.5 15.5-13.3-3.2 5.6-.6 7.3 1.2 9.6 5.1-4.4 10-8.8 19.4-12.3-2.6 3.1-6.2 6.2-2.4 9.8 5.3-3.3 10.6-6.6 23.1-8.9-2.8 3.1-8.7 6.3-5.1 9.4 6.6-2.5 14-4.4 22.1-5.4-3.9 3.2-7.1 6.3-3.9 8.8 7.1-2.2 16.9-5.1 26.4-2.6l-6 6.1c-.7.8 14.1.6 23.9.8-3.6 5-7.2 9.7-9.3 18.2 1 1 5.8.4 10.4 0-4.7 9.9-12.8 12.3-14.7 16.6 2.9 2.2 6.8 1.6 11.2.1-3.4 6.9-10.4 11.7-16 17.3 1.4 1 3.9 1.6 9.7.9-5.2 5.5-11.4 10.5-18.8 15 1.3 1.5 5.8 1.5 10 1.6-6.7 6.5-15.3 9.9-23.4 14.2 4 2.7 6.9 2.1 10 2.1-5.7 4.7-15.4 7.1-24.4 10 1.7 2.7 3.4 3.4 7.1 4.1-9.5 5.3-23.2 2.9-27 5.6.9 2.7 3.6 4.4 6.7 5.8-15.4.9-57.3-.6-65.4-32.3 15.7-17.3 44.4-37.5 93.7-62.6-38.4 12.8-73 30-102 53.5-34.3-15.9-10.8-55.9 5.8-71.8zm-34.4 114.6c24.2-.3 54.1 17.8 54 34.7-.1 15-21 27.1-53.8 26.9-32.1-.4-53.7-15.2-53.6-29.8 0-11.9 26.2-32.5 53.4-31.8zm-123-12.8c3.7-.7 5.4-1.5 7.1-4.1-9-2.8-18.7-5.3-24.4-10 3.1 0 6 .7 10-2.1-8.1-4.3-16.7-7.7-23.4-14.2 4.2-.1 8.7 0 10-1.6-7.4-4.5-13.6-9.5-18.8-15 5.8.7 8.3.1 9.7-.9-5.6-5.6-12.7-10.4-16-17.3 4.3 1.5 8.3 2 11.2-.1-1.9-4.2-10-6.7-14.7-16.6 4.6.4 9.4 1 10.4 0-2.1-8.5-5.8-13.3-9.3-18.2 9.8-.1 24.6 0 23.9-.8l-6-6.1c9.5-2.5 19.3.4 26.4 2.6 3.2-2.5-.1-5.6-3.9-8.8 8.1 1.1 15.4 2.9 22.1 5.4 3.5-3.1-2.3-6.3-5.1-9.4 12.5 2.3 17.8 5.6 23.1 8.9 3.8-3.6.2-6.7-2.4-9.8 9.4 3.4 14.3 7.9 19.4 12.3 1.7-2.3 4.4-4 1.2-9.6 6.7 3.8 11.8 8.3 15.5 13.3 4.1-2.6 2.5-6.2 2.5-9.4 7 5.6 11.4 11.5 16.8 17.3 1.1-.8 2-3.4 2.9-7.6 16.6 15.9 40.1 55.9 6 71.8-29-23.5-63.6-40.7-102-53.5 49.3 25 78 45.3 93.7 62.6-8 31.8-50 33.2-65.4 32.3 3.1-1.4 5.8-3.2 6.7-5.8-4-2.8-17.6-.4-27.2-5.6zm60.1 24.1c16.8 2.8-80.6 86.5-82.1 67.9-1.5-48.7 36.5-75.5 82.1-67.9zM38.2 342c-23.7-18.8-31.3-73.7 12.6-98.3 26.5-7 9 107.8-12.6 98.3zm91 98.2c-13.3 7.9-45.8 4.7-68.8-27.9-15.5-27.4-13.5-55.2-2.6-63.4 16.3-9.8 41.5 3.4 60.9 25.6 16.9 20 24.6 55.3 10.5 65.7zm-26.4-119.7c-24.5-15.8-28.9-51.6-9.9-80s54.3-38.6 78.8-22.8 28.9 51.6 9.9 80c-19.1 28.4-54.4 38.6-78.8 22.8zM205 496c-29.4 1.2-58.2-23.7-57.8-32.3-.4-12.7 35.8-22.6 59.3-22 23.7-1 55.6 7.5 55.7 18.9.5 11-28.8 35.9-57.2 35.4zm58.9-124.9c.2 29.7-26.2 53.8-58.8 54-32.6.2-59.2-23.8-59.4-53.4v-.6c-.2-29.7 26.2-53.8 58.8-54 32.6-.2 59.2 23.8 59.4 53.4v.6zm82.2 42.7c-25.3 34.6-59.6 35.9-72.3 26.3-13.3-12.4-3.2-50.9 15.1-72 20.9-23.3 43.3-38.5 58.9-26.6 10.5 10.3 16.7 49.1-1.7 72.3zm22.9-73.2c-21.5 9.4-39-105.3-12.6-98.3 43.9 24.7 36.3 79.6 12.6 98.3z"
        ],
        "ravelry": [
            512,
            512,
            [],
            "f2d9",
            "M498.252,234.223c-1.208-10.34-1.7-20.826-3.746-31a310.306,310.306,0,0,0-9.622-36.6,184.068,184.068,0,0,0-30.874-57.5,251.154,251.154,0,0,0-18.818-21.689,237.362,237.362,0,0,0-47.113-36.116A240.8,240.8,0,0,0,331.356,26.65c-11.018-3.1-22.272-5.431-33.515-7.615-6.78-1.314-13.749-1.667-20.627-2.482-.316-.036-.6-.358-.9-.553q-16.143.009-32.288.006c-2.41.389-4.808.925-7.236,1.15a179.331,179.331,0,0,0-34.256,7.1,221.5,221.5,0,0,0-39.768,16.355,281.385,281.385,0,0,0-38.08,24.158c-6.167,4.61-12.268,9.36-17.974,14.518C96.539,88.494,86.34,97.72,76.785,107.555a243.878,243.878,0,0,0-33.648,43.95,206.488,206.488,0,0,0-20.494,44.6,198.2,198.2,0,0,0-7.691,34.759A201.13,201.13,0,0,0,13.4,266.385a299.716,299.716,0,0,0,4.425,40.24,226.865,226.865,0,0,0,16.73,53.3,210.543,210.543,0,0,0,24,39.528,213.589,213.589,0,0,0,26.358,28.416A251.313,251.313,0,0,0,126.7,458.455a287.831,287.831,0,0,0,55.9,25.277,269.5,269.5,0,0,0,40.641,9.835c6.071,1.01,12.275,1.253,18.412,1.873a4.149,4.149,0,0,1,1.19.56h32.289c2.507-.389,5-.937,7.527-1.143,16.336-1.332,32.107-5.335,47.489-10.717A219.992,219.992,0,0,0,379.1,460.322c9.749-6.447,19.395-13.077,28.737-20.1,5.785-4.348,10.988-9.5,16.3-14.457,3.964-3.7,7.764-7.578,11.51-11.5a232.162,232.162,0,0,0,31.427-41.639c9.542-16.045,17.355-32.905,22.3-50.926,2.859-10.413,4.947-21.045,7.017-31.652,1.032-5.279,1.251-10.723,1.87-16.087.036-.317.358-.6.552-.9V236.005A9.757,9.757,0,0,1,498.252,234.223Zm-161.117-1.15s-16.572-2.98-28.47-2.98c-27.2,0-33.57,14.9-33.57,37.04V360.8H201.582V170.062H275.1v31.931c8.924-26.822,26.771-36.189,62.04-36.189Z"
        ],
        "react": [
            512,
            512,
            [],
            "f41b",
            "M418.2 177.2c-5.4-1.8-10.8-3.5-16.2-5.1.9-3.7 1.7-7.4 2.5-11.1 12.3-59.6 4.2-107.5-23.1-123.3-26.3-15.1-69.2.6-112.6 38.4-4.3 3.7-8.5 7.6-12.5 11.5-2.7-2.6-5.5-5.2-8.3-7.7-45.5-40.4-91.1-57.4-118.4-41.5-26.2 15.2-34 60.3-23 116.7 1.1 5.6 2.3 11.1 3.7 16.7-6.4 1.8-12.7 3.8-18.6 5.9C38.3 196.2 0 225.4 0 255.6c0 31.2 40.8 62.5 96.3 81.5 4.5 1.5 9 3 13.6 4.3-1.5 6-2.8 11.9-4 18-10.5 55.5-2.3 99.5 23.9 114.6 27 15.6 72.4-.4 116.6-39.1 3.5-3.1 7-6.3 10.5-9.7 4.4 4.3 9 8.4 13.6 12.4 42.8 36.8 85.1 51.7 111.2 36.6 27-15.6 35.8-62.9 24.4-120.5-.9-4.4-1.9-8.9-3-13.5 3.2-.9 6.3-1.9 9.4-2.9 57.7-19.1 99.5-50 99.5-81.7 0-30.3-39.4-59.7-93.8-78.4zM282.9 92.3c37.2-32.4 71.9-45.1 87.7-36 16.9 9.7 23.4 48.9 12.8 100.4-.7 3.4-1.4 6.7-2.3 10-22.2-5-44.7-8.6-67.3-10.6-13-18.6-27.2-36.4-42.6-53.1 3.9-3.7 7.7-7.2 11.7-10.7zM167.2 307.5c5.1 8.7 10.3 17.4 15.8 25.9-15.6-1.7-31.1-4.2-46.4-7.5 4.4-14.4 9.9-29.3 16.3-44.5 4.6 8.8 9.3 17.5 14.3 26.1zm-30.3-120.3c14.4-3.2 29.7-5.8 45.6-7.8-5.3 8.3-10.5 16.8-15.4 25.4-4.9 8.5-9.7 17.2-14.2 26-6.3-14.9-11.6-29.5-16-43.6zm27.4 68.9c6.6-13.8 13.8-27.3 21.4-40.6s15.8-26.2 24.4-38.9c15-1.1 30.3-1.7 45.9-1.7s31 .6 45.9 1.7c8.5 12.6 16.6 25.5 24.3 38.7s14.9 26.7 21.7 40.4c-6.7 13.8-13.9 27.4-21.6 40.8-7.6 13.3-15.7 26.2-24.2 39-14.9 1.1-30.4 1.6-46.1 1.6s-30.9-.5-45.6-1.4c-8.7-12.7-16.9-25.7-24.6-39s-14.8-26.8-21.5-40.6zm180.6 51.2c5.1-8.8 9.9-17.7 14.6-26.7 6.4 14.5 12 29.2 16.9 44.3-15.5 3.5-31.2 6.2-47 8 5.4-8.4 10.5-17 15.5-25.6zm14.4-76.5c-4.7-8.8-9.5-17.6-14.5-26.2-4.9-8.5-10-16.9-15.3-25.2 16.1 2 31.5 4.7 45.9 8-4.6 14.8-10 29.2-16.1 43.4zM256.2 118.3c10.5 11.4 20.4 23.4 29.6 35.8-19.8-.9-39.7-.9-59.5 0 9.8-12.9 19.9-24.9 29.9-35.8zM140.2 57c16.8-9.8 54.1 4.2 93.4 39 2.5 2.2 5 4.6 7.6 7-15.5 16.7-29.8 34.5-42.9 53.1-22.6 2-45 5.5-67.2 10.4-1.3-5.1-2.4-10.3-3.5-15.5-9.4-48.4-3.2-84.9 12.6-94zm-24.5 263.6c-4.2-1.2-8.3-2.5-12.4-3.9-21.3-6.7-45.5-17.3-63-31.2-10.1-7-16.9-17.8-18.8-29.9 0-18.3 31.6-41.7 77.2-57.6 5.7-2 11.5-3.8 17.3-5.5 6.8 21.7 15 43 24.5 63.6-9.6 20.9-17.9 42.5-24.8 64.5zm116.6 98c-16.5 15.1-35.6 27.1-56.4 35.3-11.1 5.3-23.9 5.8-35.3 1.3-15.9-9.2-22.5-44.5-13.5-92 1.1-5.6 2.3-11.2 3.7-16.7 22.4 4.8 45 8.1 67.9 9.8 13.2 18.7 27.7 36.6 43.2 53.4-3.2 3.1-6.4 6.1-9.6 8.9zm24.5-24.3c-10.2-11-20.4-23.2-30.3-36.3 9.6.4 19.5.6 29.5.6 10.3 0 20.4-.2 30.4-.7-9.2 12.7-19.1 24.8-29.6 36.4zm130.7 30c-.9 12.2-6.9 23.6-16.5 31.3-15.9 9.2-49.8-2.8-86.4-34.2-4.2-3.6-8.4-7.5-12.7-11.5 15.3-16.9 29.4-34.8 42.2-53.6 22.9-1.9 45.7-5.4 68.2-10.5 1 4.1 1.9 8.2 2.7 12.2 4.9 21.6 5.7 44.1 2.5 66.3zm18.2-107.5c-2.8.9-5.6 1.8-8.5 2.6-7-21.8-15.6-43.1-25.5-63.8 9.6-20.4 17.7-41.4 24.5-62.9 5.2 1.5 10.2 3.1 15 4.7 46.6 16 79.3 39.8 79.3 58 0 19.6-34.9 44.9-84.8 61.4zm-149.7-15c25.3 0 45.8-20.5 45.8-45.8s-20.5-45.8-45.8-45.8c-25.3 0-45.8 20.5-45.8 45.8s20.5 45.8 45.8 45.8z"
        ],
        "reacteurope": [
            576,
            512,
            [],
            "f75d",
            "M250.6 211.74l5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.1-.1-2.3-6.8-2.3 6.8-7.2.1 5.7 4.3zm63.7 0l5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.2-.1-2.3-6.8-2.3 6.8-7.2.1 5.7 4.3zm-91.3 50.5h-3.4c-4.8 0-3.8 4-3.8 12.1 0 4.7-2.3 6.1-5.8 6.1s-5.8-1.4-5.8-6.1v-36.6c0-4.7 2.3-6.1 5.8-6.1s5.8 1.4 5.8 6.1c0 7.2-.7 10.5 3.8 10.5h3.4c4.7-.1 3.8-3.9 3.8-12.3 0-9.9-6.7-14.1-16.8-14.1h-.2c-10.1 0-16.8 4.2-16.8 14.1V276c0 10.4 6.7 14.1 16.8 14.1h.2c10.1 0 16.8-3.8 16.8-14.1 0-9.86 1.1-13.76-3.8-13.76zm-80.7 17.4h-14.7v-19.3H139c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-11.4v-18.3H142c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-21.7c-2.4-.1-3.7 1.3-3.7 3.8v59.1c0 2.5 1.3 3.8 3.8 3.8h21.9c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8zm-42-18.5c4.6-2 7.3-6 7.3-12.4v-11.9c0-10.1-6.7-14.1-16.8-14.1H77.4c-2.5 0-3.8 1.3-3.8 3.8v59.1c0 2.5 1.3 3.8 3.8 3.8h3.4c2.5 0 3.8-1.3 3.8-3.8v-22.9h5.6l7.4 23.5a4.1 4.1 0 0 0 4.3 3.2h3.3c2.8 0 4-1.8 3.2-4.4zm-3.8-14c0 4.8-2.5 6.1-6.1 6.1h-5.8v-20.9h5.8c3.6 0 6.1 1.3 6.1 6.1zM176 226a3.82 3.82 0 0 0-4.2-3.4h-6.9a3.68 3.68 0 0 0-4 3.4l-11 59.2c-.5 2.7.9 4.1 3.4 4.1h3a3.74 3.74 0 0 0 4.1-3.5l1.8-11.3h12.2l1.8 11.3a3.74 3.74 0 0 0 4.1 3.5h3.5c2.6 0 3.9-1.4 3.4-4.1zm-12.3 39.3l4.7-29.7 4.7 29.7zm89.3 20.2v-53.2h7.5c2.5 0 3.8-1.3 3.8-3.8v-2.1c0-2.5-1.3-3.8-3.8-3.8h-25.8c-2.5 0-3.8 1.3-3.8 3.8v2.1c0 2.5 1.3 3.8 3.8 3.8h7.3v53.2c0 2.5 1.3 3.8 3.8 3.8h3.4c2.5.04 3.8-1.3 3.8-3.76zm248-.8h-19.4V258h16.1a1.89 1.89 0 0 0 2-2v-.8a1.89 1.89 0 0 0-2-2h-16.1v-25.8h19.1a1.89 1.89 0 0 0 2-2v-.8a1.77 1.77 0 0 0-2-1.9h-22.2a1.62 1.62 0 0 0-2 1.8v63a1.81 1.81 0 0 0 2 1.9H501a1.81 1.81 0 0 0 2-1.9v-.8a1.84 1.84 0 0 0-2-1.96zm-93.1-62.9h-.8c-10.1 0-15.3 4.7-15.3 14.1V276c0 9.3 5.2 14.1 15.3 14.1h.8c10.1 0 15.3-4.8 15.3-14.1v-40.1c0-9.36-5.2-14.06-15.3-14.06zm10.2 52.4c-.1 8-3 11.1-10.5 11.1s-10.5-3.1-10.5-11.1v-36.6c0-7.9 3-11.1 10.5-11.1s10.5 3.2 10.5 11.1zm-46.5-14.5c6.1-1.6 9.2-6.1 9.2-13.3v-9.7c0-9.4-5.2-14.1-15.3-14.1h-13.7a1.81 1.81 0 0 0-2 1.9v63a1.81 1.81 0 0 0 2 1.9h1.2a1.74 1.74 0 0 0 1.9-1.9v-26.9h11.6l10.4 27.2a2.32 2.32 0 0 0 2.3 1.5h1.5c1.4 0 2-1 1.5-2.3zm-6.4-3.9H355v-28.5h10.2c7.5 0 10.5 3.1 10.5 11.1v6.4c0 7.84-3 11.04-10.5 11.04zm85.9-33.1h-13.7a1.62 1.62 0 0 0-2 1.8v63a1.81 1.81 0 0 0 2 1.9h1.2a1.74 1.74 0 0 0 1.9-1.9v-26.1h10.6c10.1 0 15.3-4.8 15.3-14.1v-10.5c0-9.4-5.2-14.1-15.3-14.1zm10.2 22.8c0 7.9-3 11.1-10.5 11.1h-10.2v-29.2h10.2c7.5-.1 10.5 3.1 10.5 11zM259.5 308l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm227.6-136.1a364.42 364.42 0 0 0-35.6-11.3c19.6-78 11.6-134.7-22.3-153.9C394.7-12.66 343.3 11 291 61.94q5.1 4.95 10.2 10.2c82.5-80 119.6-53.5 120.9-52.8 22.4 12.7 36 55.8 15.5 137.8a587.83 587.83 0 0 0-84.6-13C281.1 43.64 212.4 2 170.8 2 140 2 127 23 123.2 29.74c-18.1 32-13.3 84.2.1 133.8-70.5 20.3-120.7 54.1-120.3 95 .5 59.6 103.2 87.8 122.1 92.8-20.5 81.9-10.1 135.6 22.3 153.9 28 15.8 75.1 6 138.2-55.2q-5.1-4.95-10.2-10.2c-82.5 80-119.7 53.5-120.9 52.8-22.3-12.6-36-55.6-15.5-137.9 12.4 2.9 41.8 9.5 84.6 13 71.9 100.4 140.6 142 182.1 142 30.8 0 43.8-21 47.6-27.7 18-31.9 13.3-84.1-.1-133.8 152.3-43.8 156.2-130.2 33.9-176.3zM135.9 36.84c2.9-5.1 11.9-20.3 34.9-20.3 36.8 0 98.8 39.6 163.3 126.2a714 714 0 0 0-93.9.9 547.76 547.76 0 0 1 42.2-52.4Q277.3 86 272.2 81a598.25 598.25 0 0 0-50.7 64.2 569.69 569.69 0 0 0-84.4 14.6c-.2-1.4-24.3-82.2-1.2-123zm304.8 438.3c-2.9 5.1-11.8 20.3-34.9 20.3-36.7 0-98.7-39.4-163.3-126.2a695.38 695.38 0 0 0 93.9-.9 547.76 547.76 0 0 1-42.2 52.4q5.1 5.25 10.2 10.2a588.47 588.47 0 0 0 50.7-64.2c47.3-4.7 80.3-13.5 84.4-14.6 22.7 84.4 4.5 117 1.2 123zm9.1-138.6c-3.6-11.9-7.7-24.1-12.4-36.4a12.67 12.67 0 0 1-10.7-5.7l-.1.1a19.61 19.61 0 0 1-5.4 3.6c5.7 14.3 10.6 28.4 14.7 42.2a535.3 535.3 0 0 1-72 13c3.5-5.3 17.2-26.2 32.2-54.2a24.6 24.6 0 0 1-6-3.2c-1.1 1.2-3.6 4.2-10.9 4.2-6.2 11.2-17.4 30.9-33.9 55.2a711.91 711.91 0 0 1-112.4 1c-7.9-11.2-21.5-31.1-36.8-57.8a21 21 0 0 1-3-1.5c-1.9 1.6-3.9 3.2-12.6 3.2 6.3 11.2 17.5 30.7 33.8 54.6a548.81 548.81 0 0 1-72.2-11.7q5.85-21 14.1-42.9c-3.2 0-5.4.2-8.4-1a17.58 17.58 0 0 1-6.9 1c-4.9 13.4-9.1 26.5-12.7 39.4C-31.7 297-12.1 216 126.7 175.64c3.6 11.9 7.7 24.1 12.4 36.4 10.4 0 12.9 3.4 14.4 5.3a12 12 0 0 1 2.3-2.2c-5.8-14.7-10.9-29.2-15.2-43.3 7-1.8 32.4-8.4 72-13-15.9 24.3-26.7 43.9-32.8 55.3a14.22 14.22 0 0 1 6.4 8 23.42 23.42 0 0 1 10.2-8.4c6.5-11.7 17.9-31.9 34.8-56.9a711.72 711.72 0 0 1 112.4-1c31.5 44.6 28.9 48.1 42.5 64.5a21.42 21.42 0 0 1 10.4-7.4c-6.4-11.4-17.6-31-34.3-55.5 40.4 4.1 65 10 72.2 11.7-4 14.4-8.9 29.2-14.6 44.2a20.74 20.74 0 0 1 6.8 4.3l.1.1a12.72 12.72 0 0 1 8.9-5.6c4.9-13.4 9.2-26.6 12.8-39.5a359.71 359.71 0 0 1 34.5 11c106.1 39.9 74 87.9 72.6 90.4-19.8 35.1-80.1 55.2-105.7 62.5zm-114.4-114h-1.2a1.74 1.74 0 0 0-1.9 1.9v49.8c0 7.9-2.6 11.1-10.1 11.1s-10.1-3.1-10.1-11.1v-49.8a1.69 1.69 0 0 0-1.9-1.9H309a1.81 1.81 0 0 0-2 1.9v51.5c0 9.6 5 14.1 15.1 14.1h.4c10.1 0 15.1-4.6 15.1-14.1v-51.5a2 2 0 0 0-2.2-1.9zM321.7 308l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm-31.1 7.4l-2.3-6.8-2.3 6.8-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3zm5.1-30.8h-19.4v-26.7h16.1a1.89 1.89 0 0 0 2-2v-.8a1.89 1.89 0 0 0-2-2h-16.1v-25.8h19.1a1.89 1.89 0 0 0 2-2v-.8a1.77 1.77 0 0 0-2-1.9h-22.2a1.81 1.81 0 0 0-2 1.9v63a1.81 1.81 0 0 0 2 1.9h22.5a1.77 1.77 0 0 0 2-1.9v-.8a1.83 1.83 0 0 0-2-2.06zm-7.4-99.4L286 192l-7.1.1 5.7 4.3-2.1 6.8 5.8-4.1 5.8 4.1-2.1-6.8 5.7-4.3-7.1-.1z"
        ],
        "readme": [
            576,
            512,
            [],
            "f4d5",
            "M528.3 46.5H388.5c-48.1 0-89.9 33.3-100.4 80.3-10.6-47-52.3-80.3-100.4-80.3H48c-26.5 0-48 21.5-48 48v245.8c0 26.5 21.5 48 48 48h89.7c102.2 0 132.7 24.4 147.3 75 .7 2.8 5.2 2.8 6 0 14.7-50.6 45.2-75 147.3-75H528c26.5 0 48-21.5 48-48V94.6c0-26.4-21.3-47.9-47.7-48.1zM242 311.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5V289c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5V251zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H78.2c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm259.3 121.7c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5v-22.9c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5V228c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5v22.9zm0-60.9c0 1.9-1.5 3.5-3.5 3.5H337.5c-1.9 0-3.5-1.5-3.5-3.5v-22.8c0-1.9 1.5-3.5 3.5-3.5h160.4c1.9 0 3.5 1.5 3.5 3.5V190z"
        ],
        "rebel": [
            512,
            512,
            [],
            "f1d0",
            "M256.5 504C117.2 504 9 387.8 13.2 249.9 16 170.7 56.4 97.7 129.7 49.5c.3 0 1.9-.6 1.1.8-5.8 5.5-111.3 129.8-14.1 226.4 49.8 49.5 90 2.5 90 2.5 38.5-50.1-.6-125.9-.6-125.9-10-24.9-45.7-40.1-45.7-40.1l28.8-31.8c24.4 10.5 43.2 38.7 43.2 38.7.8-29.6-21.9-61.4-21.9-61.4L255.1 8l44.3 50.1c-20.5 28.8-21.9 62.6-21.9 62.6 13.8-23 43.5-39.3 43.5-39.3l28.5 31.8c-27.4 8.9-45.4 39.9-45.4 39.9-15.8 28.5-27.1 89.4.6 127.3 32.4 44.6 87.7-2.8 87.7-2.8 102.7-91.9-10.5-225-10.5-225-6.1-5.5.8-2.8.8-2.8 50.1 36.5 114.6 84.4 116.2 204.8C500.9 400.2 399 504 256.5 504z"
        ],
        "red-river": [
            448,
            512,
            [],
            "f3e3",
            "M353.2 32H94.8C42.4 32 0 74.4 0 126.8v258.4C0 437.6 42.4 480 94.8 480h258.4c52.4 0 94.8-42.4 94.8-94.8V126.8c0-52.4-42.4-94.8-94.8-94.8zM144.9 200.9v56.3c0 27-21.9 48.9-48.9 48.9V151.9c0-13.2 10.7-23.9 23.9-23.9h154.2c0 27-21.9 48.9-48.9 48.9h-56.3c-12.3-.6-24.6 11.6-24 24zm176.3 72h-56.3c-12.3-.6-24.6 11.6-24 24v56.3c0 27-21.9 48.9-48.9 48.9V247.9c0-13.2 10.7-23.9 23.9-23.9h154.2c0 27-21.9 48.9-48.9 48.9z"
        ],
        "reddit": [
            512,
            512,
            [],
            "f1a1",
            "M201.5 305.5c-13.8 0-24.9-11.1-24.9-24.6 0-13.8 11.1-24.9 24.9-24.9 13.6 0 24.6 11.1 24.6 24.9 0 13.6-11.1 24.6-24.6 24.6zM504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248zm-132.3-41.2c-9.4 0-17.7 3.9-23.8 10-22.4-15.5-52.6-25.5-86.1-26.6l17.4-78.3 55.4 12.5c0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.3 24.9-24.9s-11.1-24.9-24.9-24.9c-9.7 0-18 5.8-22.1 13.8l-61.2-13.6c-3-.8-6.1 1.4-6.9 4.4l-19.1 86.4c-33.2 1.4-63.1 11.3-85.5 26.8-6.1-6.4-14.7-10.2-24.1-10.2-34.9 0-46.3 46.9-14.4 62.8-1.1 5-1.7 10.2-1.7 15.5 0 52.6 59.2 95.2 132 95.2 73.1 0 132.3-42.6 132.3-95.2 0-5.3-.6-10.8-1.9-15.8 31.3-16 19.8-62.5-14.9-62.5zM302.8 331c-18.2 18.2-76.1 17.9-93.6 0-2.2-2.2-6.1-2.2-8.3 0-2.5 2.5-2.5 6.4 0 8.6 22.8 22.8 87.3 22.8 110.2 0 2.5-2.2 2.5-6.1 0-8.6-2.2-2.2-6.1-2.2-8.3 0zm7.7-75c-13.6 0-24.6 11.1-24.6 24.9 0 13.6 11.1 24.6 24.6 24.6 13.8 0 24.9-11.1 24.9-24.6 0-13.8-11-24.9-24.9-24.9z"
        ],
        "reddit-alien": [
            512,
            512,
            [],
            "f281",
            "M440.3 203.5c-15 0-28.2 6.2-37.9 15.9-35.7-24.7-83.8-40.6-137.1-42.3L293 52.3l88.2 19.8c0 21.6 17.6 39.2 39.2 39.2 22 0 39.7-18.1 39.7-39.7s-17.6-39.7-39.7-39.7c-15.4 0-28.7 9.3-35.3 22l-97.4-21.6c-4.9-1.3-9.7 2.2-11 7.1L246.3 177c-52.9 2.2-100.5 18.1-136.3 42.8-9.7-10.1-23.4-16.3-38.4-16.3-55.6 0-73.8 74.6-22.9 100.1-1.8 7.9-2.6 16.3-2.6 24.7 0 83.8 94.4 151.7 210.3 151.7 116.4 0 210.8-67.9 210.8-151.7 0-8.4-.9-17.2-3.1-25.1 49.9-25.6 31.5-99.7-23.8-99.7zM129.4 308.9c0-22 17.6-39.7 39.7-39.7 21.6 0 39.2 17.6 39.2 39.7 0 21.6-17.6 39.2-39.2 39.2-22 .1-39.7-17.6-39.7-39.2zm214.3 93.5c-36.4 36.4-139.1 36.4-175.5 0-4-3.5-4-9.7 0-13.7 3.5-3.5 9.7-3.5 13.2 0 27.8 28.5 120 29 149 0 3.5-3.5 9.7-3.5 13.2 0 4.1 4 4.1 10.2.1 13.7zm-.8-54.2c-21.6 0-39.2-17.6-39.2-39.2 0-22 17.6-39.7 39.2-39.7 22 0 39.7 17.6 39.7 39.7-.1 21.5-17.7 39.2-39.7 39.2z"
        ],
        "reddit-square": [
            448,
            512,
            [],
            "f1a2",
            "M283.2 345.5c2.7 2.7 2.7 6.8 0 9.2-24.5 24.5-93.8 24.6-118.4 0-2.7-2.4-2.7-6.5 0-9.2 2.4-2.4 6.5-2.4 8.9 0 18.7 19.2 81 19.6 100.5 0 2.4-2.3 6.6-2.3 9 0zm-91.3-53.8c0-14.9-11.9-26.8-26.5-26.8-14.9 0-26.8 11.9-26.8 26.8 0 14.6 11.9 26.5 26.8 26.5 14.6 0 26.5-11.9 26.5-26.5zm90.7-26.8c-14.6 0-26.5 11.9-26.5 26.8 0 14.6 11.9 26.5 26.5 26.5 14.9 0 26.8-11.9 26.8-26.5 0-14.9-11.9-26.8-26.8-26.8zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-99.7 140.6c-10.1 0-19 4.2-25.6 10.7-24.1-16.7-56.5-27.4-92.5-28.6l18.7-84.2 59.5 13.4c0 14.6 11.9 26.5 26.5 26.5 14.9 0 26.8-12.2 26.8-26.8 0-14.6-11.9-26.8-26.8-26.8-10.4 0-19.3 6.2-23.8 14.9l-65.7-14.6c-3.3-.9-6.5 1.5-7.4 4.8l-20.5 92.8c-35.7 1.5-67.8 12.2-91.9 28.9-6.5-6.8-15.8-11-25.9-11-37.5 0-49.8 50.4-15.5 67.5-1.2 5.4-1.8 11-1.8 16.7 0 56.5 63.7 102.3 141.9 102.3 78.5 0 142.2-45.8 142.2-102.3 0-5.7-.6-11.6-2.1-17 33.6-17.2 21.2-67.2-16.1-67.2z"
        ],
        "redhat": [
            512,
            512,
            [],
            "f7bc",
            "M341.52 285.56c33.65 0 82.34-6.94 82.34-47 .22-6.74.86-1.82-20.88-96.24-4.62-19.15-8.68-27.84-42.31-44.65-26.09-13.34-82.92-35.37-99.73-35.37-15.66 0-20.2 20.17-38.87 20.17-18 0-31.31-15.06-48.12-15.06-16.14 0-26.66 11-34.78 33.62-27.5 77.55-26.28 74.27-26.12 78.27 0 24.8 97.64 106.11 228.47 106.11M429 254.84c4.65 22 4.65 24.35 4.65 27.25 0 37.66-42.33 58.56-98 58.56-125.74.08-235.91-73.65-235.91-122.33a49.55 49.55 0 0 1 4.06-19.72C58.56 200.86 0 208.93 0 260.63c0 84.67 200.63 189 359.49 189 121.79 0 152.51-55.08 152.51-98.58 0-34.21-29.59-73.05-82.93-96.24"
        ],
        "renren": [
            512,
            512,
            [],
            "f18b",
            "M214 169.1c0 110.4-61 205.4-147.6 247.4C30 373.2 8 317.7 8 256.6 8 133.9 97.1 32.2 214 12.5v156.6zM255 504c-42.9 0-83.3-11-118.5-30.4C193.7 437.5 239.9 382.9 255 319c15.5 63.9 61.7 118.5 118.8 154.7C338.7 493 298.3 504 255 504zm190.6-87.5C359 374.5 298 279.6 298 169.1V12.5c116.9 19.7 206 121.4 206 244.1 0 61.1-22 116.6-58.4 159.9z"
        ],
        "replyd": [
            448,
            512,
            [],
            "f3e6",
            "M320 480H128C57.6 480 0 422.4 0 352V160C0 89.6 57.6 32 128 32h192c70.4 0 128 57.6 128 128v192c0 70.4-57.6 128-128 128zM193.4 273.2c-6.1-2-11.6-3.1-16.4-3.1-7.2 0-13.5 1.9-18.9 5.6-5.4 3.7-9.6 9-12.8 15.8h-1.1l-4.2-18.3h-28v138.9h36.1v-89.7c1.5-5.4 4.4-9.8 8.7-13.2 4.3-3.4 9.8-5.1 16.2-5.1 4.6 0 9.8 1 15.6 3.1l4.8-34zm115.2 103.4c-3.2 2.4-7.7 4.8-13.7 7.1-6 2.3-12.8 3.5-20.4 3.5-12.2 0-21.1-3-26.5-8.9-5.5-5.9-8.5-14.7-9-26.4h83.3c.9-4.8 1.6-9.4 2.1-13.9.5-4.4.7-8.6.7-12.5 0-10.7-1.6-19.7-4.7-26.9-3.2-7.2-7.3-13-12.5-17.2-5.2-4.3-11.1-7.3-17.8-9.2-6.7-1.8-13.5-2.8-20.6-2.8-21.1 0-37.5 6.1-49.2 18.3s-17.5 30.5-17.5 55c0 22.8 5.2 40.7 15.6 53.7 10.4 13.1 26.8 19.6 49.2 19.6 10.7 0 20.9-1.5 30.4-4.6 9.5-3.1 17.1-6.8 22.6-11.2l-12-23.6zm-21.8-70.3c3.8 5.4 5.3 13.1 4.6 23.1h-51.7c.9-9.4 3.7-17 8.2-22.6 4.5-5.6 11.5-8.5 21-8.5 8.2-.1 14.1 2.6 17.9 8zm79.9 2.5c4.1 3.9 9.4 5.8 16.1 5.8 7 0 12.6-1.9 16.7-5.8s6.1-9.1 6.1-15.6-2-11.6-6.1-15.4c-4.1-3.8-9.6-5.7-16.7-5.7-6.7 0-12 1.9-16.1 5.7-4.1 3.8-6.1 8.9-6.1 15.4s2 11.7 6.1 15.6zm0 100.5c4.1 3.9 9.4 5.8 16.1 5.8 7 0 12.6-1.9 16.7-5.8s6.1-9.1 6.1-15.6-2-11.6-6.1-15.4c-4.1-3.8-9.6-5.7-16.7-5.7-6.7 0-12 1.9-16.1 5.7-4.1 3.8-6.1 8.9-6.1 15.4 0 6.6 2 11.7 6.1 15.6z"
        ],
        "researchgate": [
            448,
            512,
            [],
            "f4f8",
            "M0 32v448h448V32H0zm262.2 334.4c-6.6 3-33.2 6-50-14.2-9.2-10.6-25.3-33.3-42.2-63.6-8.9 0-14.7 0-21.4-.6v46.4c0 23.5 6 21.2 25.8 23.9v8.1c-6.9-.3-23.1-.8-35.6-.8-13.1 0-26.1.6-33.6.8v-8.1c15.5-2.9 22-1.3 22-23.9V225c0-22.6-6.4-21-22-23.9V193c25.8 1 53.1-.6 70.9-.6 31.7 0 55.9 14.4 55.9 45.6 0 21.1-16.7 42.2-39.2 47.5 13.6 24.2 30 45.6 42.2 58.9 7.2 7.8 17.2 14.7 27.2 14.7v7.3zm22.9-135c-23.3 0-32.2-15.7-32.2-32.2V167c0-12.2 8.8-30.4 34-30.4s30.4 17.9 30.4 17.9l-10.7 7.2s-5.5-12.5-19.7-12.5c-7.9 0-19.7 7.3-19.7 19.7v26.8c0 13.4 6.6 23.3 17.9 23.3 14.1 0 21.5-10.9 21.5-26.8h-17.9v-10.7h30.4c0 20.5 4.7 49.9-34 49.9zm-116.5 44.7c-9.4 0-13.6-.3-20-.8v-69.7c6.4-.6 15-.6 22.5-.6 23.3 0 37.2 12.2 37.2 34.5 0 21.9-15 36.6-39.7 36.6z"
        ],
        "resolving": [
            496,
            512,
            [],
            "f3e7",
            "M281.2 278.2c46-13.3 49.6-23.5 44-43.4L314 195.5c-6.1-20.9-18.4-28.1-71.1-12.8L54.7 236.8l28.6 98.6 197.9-57.2zM248.5 8C131.4 8 33.2 88.7 7.2 197.5l221.9-63.9c34.8-10.2 54.2-11.7 79.3-8.2 36.3 6.1 52.7 25 61.4 55.2l10.7 37.8c8.2 28.1 1 50.6-23.5 73.6-19.4 17.4-31.2 24.5-61.4 33.2L203 351.8l220.4 27.1 9.7 34.2-48.1 13.3-286.8-37.3 23 80.2c36.8 22 80.3 34.7 126.3 34.7 137 0 248.5-111.4 248.5-248.3C497 119.4 385.5 8 248.5 8zM38.3 388.6L0 256.8c0 48.5 14.3 93.4 38.3 131.8z"
        ],
        "rev": [
            448,
            512,
            [],
            "f5b2",
            "M289.67 274.89a65.57 65.57 0 1 1-65.56-65.56 65.64 65.64 0 0 1 65.56 65.56zm139.55-5.05h-.13a204.69 204.69 0 0 0-74.32-153l-45.38 26.2a157.07 157.07 0 0 1 71.81 131.84C381.2 361.5 310.73 432 224.11 432S67 361.5 67 274.88c0-81.88 63-149.27 143-156.43v39.12l108.77-62.79L210 32v38.32c-106.7 7.25-191 96-191 204.57 0 111.59 89.12 202.29 200.06 205v.11h210.16V269.84z"
        ],
        "rocketchat": [
            576,
            512,
            [],
            "f3e8",
            "M284.046,224.8a34.114,34.114,0,1,0,34.317,34.113A34.217,34.217,0,0,0,284.046,224.8Zm-110.45,0a34.114,34.114,0,1,0,34.317,34.113A34.217,34.217,0,0,0,173.6,224.8Zm220.923,0a34.114,34.114,0,1,0,34.317,34.113A34.215,34.215,0,0,0,394.519,224.8Zm153.807-55.319c-15.535-24.172-37.31-45.57-64.681-63.618-52.886-34.817-122.374-54-195.666-54a405.975,405.975,0,0,0-72.032,6.357,238.524,238.524,0,0,0-49.51-36.588C99.684-11.7,40.859.711,11.135,11.421A14.291,14.291,0,0,0,5.58,34.782C26.542,56.458,61.222,99.3,52.7,138.252c-33.142,33.9-51.112,74.776-51.112,117.337,0,43.372,17.97,84.248,51.112,118.148,8.526,38.956-26.154,81.816-47.116,103.491a14.284,14.284,0,0,0,5.555,23.34c29.724,10.709,88.549,23.147,155.324-10.2a238.679,238.679,0,0,0,49.51-36.589A405.972,405.972,0,0,0,288,460.14c73.313,0,142.8-19.159,195.667-53.975,27.371-18.049,49.145-39.426,64.679-63.619,17.309-26.923,26.07-55.916,26.07-86.125C574.394,225.4,565.634,196.43,548.326,169.485ZM284.987,409.9a345.65,345.65,0,0,1-89.446-11.5l-20.129,19.393a184.366,184.366,0,0,1-37.138,27.585,145.767,145.767,0,0,1-52.522,14.87c.983-1.771,1.881-3.563,2.842-5.356q30.258-55.68,16.325-100.078c-32.992-25.962-52.778-59.2-52.778-95.4,0-83.1,104.254-150.469,232.846-150.469s232.867,67.373,232.867,150.469C517.854,342.525,413.6,409.9,284.987,409.9Z"
        ],
        "rockrms": [
            496,
            512,
            [],
            "f3e9",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm157.4 419.5h-90l-112-131.3c-17.9-20.4-3.9-56.1 26.6-56.1h75.3l-84.6-99.3-84.3 98.9h-90L193.5 67.2c14.4-18.4 41.3-17.3 54.5 0l157.7 185.1c19 22.8 2 57.2-27.6 56.1-.6 0-74.2.2-74.2.2l101.5 118.9z"
        ],
        "rust": [
            512,
            512,
            [],
            "e07a",
            "M508.52,249.75,486.7,236.24c-.17-2-.34-3.93-.55-5.88l18.72-17.5a7.35,7.35,0,0,0-2.44-12.25l-24-9c-.54-1.88-1.08-3.78-1.67-5.64l15-20.83a7.35,7.35,0,0,0-4.79-11.54l-25.42-4.15c-.9-1.73-1.79-3.45-2.73-5.15l10.68-23.42a7.35,7.35,0,0,0-6.95-10.39l-25.82.91q-1.79-2.22-3.61-4.4L439,81.84A7.36,7.36,0,0,0,430.16,73L405,78.93q-2.17-1.83-4.4-3.61l.91-25.82a7.35,7.35,0,0,0-10.39-7L367.7,53.23c-1.7-.94-3.43-1.84-5.15-2.73L358.4,25.08a7.35,7.35,0,0,0-11.54-4.79L326,35.26c-1.86-.59-3.75-1.13-5.64-1.67l-9-24a7.35,7.35,0,0,0-12.25-2.44l-17.5,18.72c-1.95-.21-3.91-.38-5.88-.55L262.25,3.48a7.35,7.35,0,0,0-12.5,0L236.24,25.3c-2,.17-3.93.34-5.88.55L212.86,7.13a7.35,7.35,0,0,0-12.25,2.44l-9,24c-1.89.55-3.79,1.08-5.66,1.68l-20.82-15a7.35,7.35,0,0,0-11.54,4.79l-4.15,25.41c-1.73.9-3.45,1.79-5.16,2.73L120.88,42.55a7.35,7.35,0,0,0-10.39,7l.92,25.81c-1.49,1.19-3,2.39-4.42,3.61L81.84,73A7.36,7.36,0,0,0,73,81.84L78.93,107c-1.23,1.45-2.43,2.93-3.62,4.41l-25.81-.91a7.42,7.42,0,0,0-6.37,3.26,7.35,7.35,0,0,0-.57,7.13l10.66,23.41c-.94,1.7-1.83,3.43-2.73,5.16L25.08,153.6a7.35,7.35,0,0,0-4.79,11.54l15,20.82c-.59,1.87-1.13,3.77-1.68,5.66l-24,9a7.35,7.35,0,0,0-2.44,12.25l18.72,17.5c-.21,1.95-.38,3.91-.55,5.88L3.48,249.75a7.35,7.35,0,0,0,0,12.5L25.3,275.76c.17,2,.34,3.92.55,5.87L7.13,299.13a7.35,7.35,0,0,0,2.44,12.25l24,9c.55,1.89,1.08,3.78,1.68,5.65l-15,20.83a7.35,7.35,0,0,0,4.79,11.54l25.42,4.15c.9,1.72,1.79,3.45,2.73,5.14L42.56,391.12a7.35,7.35,0,0,0,.57,7.13,7.13,7.13,0,0,0,6.37,3.26l25.83-.91q1.77,2.22,3.6,4.4L73,430.16A7.36,7.36,0,0,0,81.84,439L107,433.07q2.18,1.83,4.41,3.61l-.92,25.82a7.35,7.35,0,0,0,10.39,6.95l23.43-10.68c1.69.94,3.42,1.83,5.14,2.73l4.15,25.42a7.34,7.34,0,0,0,11.54,4.78l20.83-15c1.86.6,3.76,1.13,5.65,1.68l9,24a7.36,7.36,0,0,0,12.25,2.44l17.5-18.72c1.95.21,3.92.38,5.88.55l13.51,21.82a7.35,7.35,0,0,0,12.5,0l13.51-21.82c2-.17,3.93-.34,5.88-.56l17.5,18.73a7.36,7.36,0,0,0,12.25-2.44l9-24c1.89-.55,3.78-1.08,5.65-1.68l20.82,15a7.34,7.34,0,0,0,11.54-4.78l4.15-25.42c1.72-.9,3.45-1.79,5.15-2.73l23.42,10.68a7.35,7.35,0,0,0,10.39-6.95l-.91-25.82q2.22-1.79,4.4-3.61L430.16,439a7.36,7.36,0,0,0,8.84-8.84L433.07,405q1.83-2.17,3.61-4.4l25.82.91a7.23,7.23,0,0,0,6.37-3.26,7.35,7.35,0,0,0,.58-7.13L458.77,367.7c.94-1.7,1.83-3.43,2.73-5.15l25.42-4.15a7.35,7.35,0,0,0,4.79-11.54l-15-20.83c.59-1.87,1.13-3.76,1.67-5.65l24-9a7.35,7.35,0,0,0,2.44-12.25l-18.72-17.5c.21-1.95.38-3.91.55-5.87l21.82-13.51a7.35,7.35,0,0,0,0-12.5Zm-151,129.08A13.91,13.91,0,0,0,341,389.51l-7.64,35.67A187.51,187.51,0,0,1,177,424.44l-7.64-35.66a13.87,13.87,0,0,0-16.46-10.68l-31.51,6.76a187.38,187.38,0,0,1-16.26-19.21H258.3c1.72,0,2.89-.29,2.89-1.91V309.55c0-1.57-1.17-1.91-2.89-1.91H213.47l.05-34.35H262c4.41,0,23.66,1.28,29.79,25.87,1.91,7.55,6.17,32.14,9.06,40,2.89,8.82,14.6,26.46,27.1,26.46H407a187.3,187.3,0,0,1-17.34,20.09Zm25.77,34.49A15.24,15.24,0,1,1,368,398.08h.44A15.23,15.23,0,0,1,383.24,413.32Zm-225.62-.68a15.24,15.24,0,1,1-15.25-15.25h.45A15.25,15.25,0,0,1,157.62,412.64ZM69.57,234.15l32.83-14.6a13.88,13.88,0,0,0,7.06-18.33L102.69,186h26.56V305.73H75.65A187.65,187.65,0,0,1,69.57,234.15ZM58.31,198.09a15.24,15.24,0,0,1,15.23-15.25H74a15.24,15.24,0,1,1-15.67,15.24Zm155.16,24.49.05-35.32h63.26c3.28,0,23.07,3.77,23.07,18.62,0,12.29-15.19,16.7-27.68,16.7ZM399,306.71c-9.8,1.13-20.63-4.12-22-10.09-5.78-32.49-15.39-39.4-30.57-51.4,18.86-11.95,38.46-29.64,38.46-53.26,0-25.52-17.49-41.59-29.4-49.48-16.76-11-35.28-13.23-40.27-13.23H116.32A187.49,187.49,0,0,1,221.21,70.06l23.47,24.6a13.82,13.82,0,0,0,19.6.44l26.26-25a187.51,187.51,0,0,1,128.37,91.43l-18,40.57A14,14,0,0,0,408,220.43l34.59,15.33a187.12,187.12,0,0,1,.4,32.54H423.71c-1.91,0-2.69,1.27-2.69,3.13v8.82C421,301,409.31,305.58,399,306.71ZM240,60.21A15.24,15.24,0,0,1,255.21,45h.45A15.24,15.24,0,1,1,240,60.21ZM436.84,214a15.24,15.24,0,1,1,0-30.48h.44a15.24,15.24,0,0,1-.44,30.48Z"
        ],
        "safari": [
            512,
            512,
            [],
            "f267",
            "M274.69,274.69l-37.38-37.38L166,346ZM256,8C119,8,8,119,8,256S119,504,256,504,504,393,504,256,393,8,256,8ZM411.85,182.79l14.78-6.13A8,8,0,0,1,437.08,181h0a8,8,0,0,1-4.33,10.46L418,197.57a8,8,0,0,1-10.45-4.33h0A8,8,0,0,1,411.85,182.79ZM314.43,94l6.12-14.78A8,8,0,0,1,331,74.92h0a8,8,0,0,1,4.33,10.45l-6.13,14.78a8,8,0,0,1-10.45,4.33h0A8,8,0,0,1,314.43,94ZM256,60h0a8,8,0,0,1,8,8V84a8,8,0,0,1-8,8h0a8,8,0,0,1-8-8V68A8,8,0,0,1,256,60ZM181,74.92a8,8,0,0,1,10.46,4.33L197.57,94a8,8,0,1,1-14.78,6.12l-6.13-14.78A8,8,0,0,1,181,74.92Zm-63.58,42.49h0a8,8,0,0,1,11.31,0L140,128.72A8,8,0,0,1,140,140h0a8,8,0,0,1-11.31,0l-11.31-11.31A8,8,0,0,1,117.41,117.41ZM60,256h0a8,8,0,0,1,8-8H84a8,8,0,0,1,8,8h0a8,8,0,0,1-8,8H68A8,8,0,0,1,60,256Zm40.15,73.21-14.78,6.13A8,8,0,0,1,74.92,331h0a8,8,0,0,1,4.33-10.46L94,314.43a8,8,0,0,1,10.45,4.33h0A8,8,0,0,1,100.15,329.21Zm4.33-136h0A8,8,0,0,1,94,197.57l-14.78-6.12A8,8,0,0,1,74.92,181h0a8,8,0,0,1,10.45-4.33l14.78,6.13A8,8,0,0,1,104.48,193.24ZM197.57,418l-6.12,14.78a8,8,0,0,1-14.79-6.12l6.13-14.78A8,8,0,1,1,197.57,418ZM264,444a8,8,0,0,1-8,8h0a8,8,0,0,1-8-8V428a8,8,0,0,1,8-8h0a8,8,0,0,1,8,8Zm67-6.92h0a8,8,0,0,1-10.46-4.33L314.43,418a8,8,0,0,1,4.33-10.45h0a8,8,0,0,1,10.45,4.33l6.13,14.78A8,8,0,0,1,331,437.08Zm63.58-42.49h0a8,8,0,0,1-11.31,0L372,383.28A8,8,0,0,1,372,372h0a8,8,0,0,1,11.31,0l11.31,11.31A8,8,0,0,1,394.59,394.59ZM286.25,286.25,110.34,401.66,225.75,225.75,401.66,110.34ZM437.08,331h0a8,8,0,0,1-10.45,4.33l-14.78-6.13a8,8,0,0,1-4.33-10.45h0A8,8,0,0,1,418,314.43l14.78,6.12A8,8,0,0,1,437.08,331ZM444,264H428a8,8,0,0,1-8-8h0a8,8,0,0,1,8-8h16a8,8,0,0,1,8,8h0A8,8,0,0,1,444,264Z"
        ],
        "salesforce": [
            640,
            512,
            [],
            "f83b",
            "M248.89 245.64h-26.35c.69-5.16 3.32-14.12 13.64-14.12 6.75 0 11.97 3.82 12.71 14.12zm136.66-13.88c-.47 0-14.11-1.77-14.11 20s13.63 20 14.11 20c13 0 14.11-13.54 14.11-20 0-21.76-13.66-20-14.11-20zm-243.22 23.76a8.63 8.63 0 0 0-3.29 7.29c0 4.78 2.08 6.05 3.29 7.05 4.7 3.7 15.07 2.12 20.93.95v-16.94c-5.32-1.07-16.73-1.96-20.93 1.65zM640 232c0 87.58-80 154.39-165.36 136.43-18.37 33-70.73 70.75-132.2 41.63-41.16 96.05-177.89 92.18-213.81-5.17C8.91 428.78-50.19 266.52 53.36 205.61 18.61 126.18 76 32 167.67 32a124.24 124.24 0 0 1 98.56 48.7c20.7-21.4 49.4-34.81 81.15-34.81 42.34 0 79 23.52 98.8 58.57C539 63.78 640 132.69 640 232zm-519.55 31.8c0-11.76-11.69-15.17-17.87-17.17-5.27-2.11-13.41-3.51-13.41-8.94 0-9.46 17-6.66 25.17-2.12 0 0 1.17.71 1.64-.47.24-.7 2.36-6.58 2.59-7.29a1.13 1.13 0 0 0-.7-1.41c-12.33-7.63-40.7-8.51-40.7 12.7 0 12.46 11.49 15.44 17.88 17.17 4.72 1.58 13.17 3 13.17 8.7 0 4-3.53 7.06-9.17 7.06a31.76 31.76 0 0 1-19-6.35c-.47-.23-1.42-.71-1.65.71l-2.4 7.47c-.47.94.23 1.18.23 1.41 1.75 1.4 10.3 6.59 22.82 6.59 13.17 0 21.4-7.06 21.4-18.11zm32-42.58c-10.13 0-18.66 3.17-21.4 5.18a1 1 0 0 0-.24 1.41l2.59 7.06a1 1 0 0 0 1.18.7c.65 0 6.8-4 16.93-4 4 0 7.06.71 9.18 2.36 3.6 2.8 3.06 8.29 3.06 10.58-4.79-.3-19.11-3.44-29.41 3.76a16.92 16.92 0 0 0-7.34 14.54c0 5.9 1.51 10.4 6.59 14.35 12.24 8.16 36.28 2 38.1 1.41 1.58-.32 3.53-.66 3.53-1.88v-33.88c.04-4.61.32-21.64-22.78-21.64zM199 200.24a1.11 1.11 0 0 0-1.18-1.18H188a1.11 1.11 0 0 0-1.17 1.18v79a1.11 1.11 0 0 0 1.17 1.18h9.88a1.11 1.11 0 0 0 1.18-1.18zm55.75 28.93c-2.1-2.31-6.79-7.53-17.65-7.53-3.51 0-14.16.23-20.7 8.94-6.35 7.63-6.58 18.11-6.58 21.41 0 3.12.15 14.26 7.06 21.17 2.64 2.91 9.06 8.23 22.81 8.23 10.82 0 16.47-2.35 18.58-3.76.47-.24.71-.71.24-1.88l-2.35-6.83a1.26 1.26 0 0 0-1.41-.7c-2.59.94-6.35 2.82-15.29 2.82-17.42 0-16.85-14.74-16.94-16.7h37.17a1.23 1.23 0 0 0 1.17-.94c-.29 0 2.07-14.7-6.09-24.23zm36.69 52.69c13.17 0 21.41-7.06 21.41-18.11 0-11.76-11.7-15.17-17.88-17.17-4.14-1.66-13.41-3.38-13.41-8.94 0-3.76 3.29-6.35 8.47-6.35a38.11 38.11 0 0 1 16.7 4.23s1.18.71 1.65-.47c.23-.7 2.35-6.58 2.58-7.29a1.13 1.13 0 0 0-.7-1.41c-7.91-4.9-16.74-4.94-20.23-4.94-12 0-20.46 7.29-20.46 17.64 0 12.46 11.48 15.44 17.87 17.17 6.11 2 13.17 3.26 13.17 8.7 0 4-3.52 7.06-9.17 7.06a31.8 31.8 0 0 1-19-6.35 1 1 0 0 0-1.65.71l-2.35 7.52c-.47.94.23 1.18.23 1.41 1.72 1.4 10.33 6.59 22.79 6.59zM357.09 224c0-.71-.24-1.18-1.18-1.18h-11.76c0-.14.94-8.94 4.47-12.47 4.16-4.15 11.76-1.64 12-1.64 1.17.47 1.41 0 1.64-.47l2.83-7.77c.7-.94 0-1.17-.24-1.41-5.09-2-17.35-2.87-24.46 4.24-5.48 5.48-7 13.92-8 19.52h-8.47a1.28 1.28 0 0 0-1.17 1.18l-1.42 7.76c0 .7.24 1.17 1.18 1.17h8.23c-8.51 47.9-8.75 50.21-10.35 55.52-1.08 3.62-3.29 6.9-5.88 7.76-.09 0-3.88 1.68-9.64-.24 0 0-.94-.47-1.41.71-.24.71-2.59 6.82-2.83 7.53s0 1.41.47 1.41c5.11 2 13 1.77 17.88 0 6.28-2.28 9.72-7.89 11.53-12.94 2.75-7.71 2.81-9.79 11.76-59.74h12.23a1.29 1.29 0 0 0 1.18-1.18zm53.39 16c-.56-1.68-5.1-18.11-25.17-18.11-15.25 0-23 10-25.16 18.11-1 3-3.18 14 0 23.52.09.3 4.41 18.12 25.16 18.12 14.95 0 22.9-9.61 25.17-18.12 3.21-9.61 1.01-20.52 0-23.52zm45.4-16.7c-5-1.65-16.62-1.9-22.11 5.41v-4.47a1.11 1.11 0 0 0-1.18-1.17h-9.4a1.11 1.11 0 0 0-1.18 1.17v55.28a1.12 1.12 0 0 0 1.18 1.18h9.64a1.12 1.12 0 0 0 1.18-1.18v-27.77c0-2.91.05-11.37 4.46-15.05 4.9-4.9 12-3.36 13.41-3.06a1.57 1.57 0 0 0 1.41-.94 74 74 0 0 0 3.06-8 1.16 1.16 0 0 0-.47-1.41zm46.81 54.1l-2.12-7.29c-.47-1.18-1.41-.71-1.41-.71-4.23 1.82-10.15 1.89-11.29 1.89-4.64 0-17.17-1.13-17.17-19.76 0-6.23 1.85-19.76 16.47-19.76a34.85 34.85 0 0 1 11.52 1.65s.94.47 1.18-.71c.94-2.59 1.64-4.47 2.59-7.53.23-.94-.47-1.17-.71-1.17-11.59-3.87-22.34-2.53-27.76 0-1.59.74-16.23 6.49-16.23 27.52 0 2.9-.58 30.11 28.94 30.11a44.45 44.45 0 0 0 15.52-2.83 1.3 1.3 0 0 0 .47-1.42zm53.87-39.52c-.8-3-5.37-16.23-22.35-16.23-16 0-23.52 10.11-25.64 18.59a38.58 38.58 0 0 0-1.65 11.76c0 25.87 18.84 29.4 29.88 29.4 10.82 0 16.46-2.35 18.58-3.76.47-.24.71-.71.24-1.88l-2.36-6.83a1.26 1.26 0 0 0-1.41-.7c-2.59.94-6.35 2.82-15.29 2.82-17.42 0-16.85-14.74-16.93-16.7h37.16a1.25 1.25 0 0 0 1.18-.94c-.24-.01.94-7.07-1.41-15.54zm-23.29-6.35c-10.33 0-13 9-13.64 14.12H546c-.88-11.92-7.62-14.13-12.73-14.13z"
        ],
        "sass": [
            640,
            512,
            [],
            "f41e",
            "M301.84 378.92c-.3.6-.6 1.08 0 0zm249.13-87a131.16 131.16 0 0 0-58 13.5c-5.9-11.9-12-22.3-13-30.1-1.2-9.1-2.5-14.5-1.1-25.3s7.7-26.1 7.6-27.2-1.4-6.6-14.3-6.7-24 2.5-25.29 5.9a122.83 122.83 0 0 0-5.3 19.1c-2.3 11.7-25.79 53.5-39.09 75.3-4.4-8.5-8.1-16-8.9-22-1.2-9.1-2.5-14.5-1.1-25.3s7.7-26.1 7.6-27.2-1.4-6.6-14.29-6.7-24 2.5-25.3 5.9-2.7 11.4-5.3 19.1-33.89 77.3-42.08 95.4c-4.2 9.2-7.8 16.6-10.4 21.6-.4.8-.7 1.3-.9 1.7.3-.5.5-1 .5-.8-2.2 4.3-3.5 6.7-3.5 6.7v.1c-1.7 3.2-3.6 6.1-4.5 6.1-.6 0-1.9-8.4.3-19.9 4.7-24.2 15.8-61.8 15.7-63.1-.1-.7 2.1-7.2-7.3-10.7-9.1-3.3-12.4 2.2-13.2 2.2s-1.4 2-1.4 2 10.1-42.4-19.39-42.4c-18.4 0-44 20.2-56.58 38.5-7.9 4.3-25 13.6-43 23.5-6.9 3.8-14 7.7-20.7 11.4-.5-.5-.9-1-1.4-1.5-35.79-38.2-101.87-65.2-99.07-116.5 1-18.7 7.5-67.8 127.07-127.4 98-48.8 176.35-35.4 189.84-5.6 19.4 42.5-41.89 121.6-143.66 133-38.79 4.3-59.18-10.7-64.28-16.3-5.3-5.9-6.1-6.2-8.1-5.1-3.3 1.8-1.2 7 0 10.1 3 7.9 15.5 21.9 36.79 28.9 18.7 6.1 64.18 9.5 119.17-11.8 61.78-23.8 109.87-90.1 95.77-145.6C386.52 18.32 293-.18 204.57 31.22c-52.69 18.7-109.67 48.1-150.66 86.4-48.69 45.6-56.48 85.3-53.28 101.9 11.39 58.9 92.57 97.3 125.06 125.7-1.6.9-3.1 1.7-4.5 2.5-16.29 8.1-78.18 40.5-93.67 74.7-17.5 38.8 2.9 66.6 16.29 70.4 41.79 11.6 84.58-9.3 107.57-43.6s20.2-79.1 9.6-99.5c-.1-.3-.3-.5-.4-.8 4.2-2.5 8.5-5 12.8-7.5 8.29-4.9 16.39-9.4 23.49-13.3-4 10.8-6.9 23.8-8.4 42.6-1.8 22 7.3 50.5 19.1 61.7 5.2 4.9 11.49 5 15.39 5 13.8 0 20-11.4 26.89-25 8.5-16.6 16-35.9 16-35.9s-9.4 52.2 16.3 52.2c9.39 0 18.79-12.1 23-18.3v.1s.2-.4.7-1.2c1-1.5 1.5-2.4 1.5-2.4v-.3c3.8-6.5 12.1-21.4 24.59-46 16.2-31.8 31.69-71.5 31.69-71.5a201.24 201.24 0 0 0 6.2 25.8c2.8 9.5 8.7 19.9 13.4 30-3.8 5.2-6.1 8.2-6.1 8.2a.31.31 0 0 0 .1.2c-3 4-6.4 8.3-9.9 12.5-12.79 15.2-28 32.6-30 37.6-2.4 5.9-1.8 10.3 2.8 13.7 3.4 2.6 9.4 3 15.69 2.5 11.5-.8 19.6-3.6 23.5-5.4a82.2 82.2 0 0 0 20.19-10.6c12.5-9.2 20.1-22.4 19.4-39.8-.4-9.6-3.5-19.2-7.3-28.2 1.1-1.6 2.3-3.3 3.4-5C434.8 301.72 450.1 270 450.1 270a201.24 201.24 0 0 0 6.2 25.8c2.4 8.1 7.09 17 11.39 25.7-18.59 15.1-30.09 32.6-34.09 44.1-7.4 21.3-1.6 30.9 9.3 33.1 4.9 1 11.9-1.3 17.1-3.5a79.46 79.46 0 0 0 21.59-11.1c12.5-9.2 24.59-22.1 23.79-39.6-.3-7.9-2.5-15.8-5.4-23.4 15.7-6.6 36.09-10.2 62.09-7.2 55.68 6.5 66.58 41.3 64.48 55.8s-13.8 22.6-17.7 25-5.1 3.3-4.8 5.1c.5 2.6 2.3 2.5 5.6 1.9 4.6-.8 29.19-11.8 30.29-38.7 1.6-34-31.09-71.4-89-71.1zm-429.18 144.7c-18.39 20.1-44.19 27.7-55.28 21.3C54.61 451 59.31 421.42 82 400c13.8-13 31.59-25 43.39-32.4 2.7-1.6 6.6-4 11.4-6.9.8-.5 1.2-.7 1.2-.7.9-.6 1.9-1.1 2.9-1.7 8.29 30.4.3 57.2-19.1 78.3zm134.36-91.4c-6.4 15.7-19.89 55.7-28.09 53.6-7-1.8-11.3-32.3-1.4-62.3 5-15.1 15.6-33.1 21.9-40.1 10.09-11.3 21.19-14.9 23.79-10.4 3.5 5.9-12.2 49.4-16.2 59.2zm111 53c-2.7 1.4-5.2 2.3-6.4 1.6-.9-.5 1.1-2.4 1.1-2.4s13.9-14.9 19.4-21.7c3.2-4 6.9-8.7 10.89-13.9 0 .5.1 1 .1 1.6-.13 17.9-17.32 30-25.12 34.8zm85.58-19.5c-2-1.4-1.7-6.1 5-20.7 2.6-5.7 8.59-15.3 19-24.5a36.18 36.18 0 0 1 1.9 10.8c-.1 22.5-16.2 30.9-25.89 34.4z"
        ],
        "schlix": [
            448,
            512,
            [],
            "f3ea",
            "M350.5 157.7l-54.2-46.1 73.4-39 78.3 44.2-97.5 40.9zM192 122.1l45.7-28.2 34.7 34.6-55.4 29-25-35.4zm-65.1 6.6l31.9-22.1L176 135l-36.7 22.5-12.4-28.8zm-23.3 88.2l-8.8-34.8 29.6-18.3 13.1 35.3-33.9 17.8zm-21.2-83.7l23.9-18.1 8.9 24-26.7 18.3-6.1-24.2zM59 206.5l-3.6-28.4 22.3-15.5 6.1 28.7L59 206.5zm-30.6 16.6l20.8-12.8 3.3 33.4-22.9 12-1.2-32.6zM1.4 268l19.2-10.2.4 38.2-21 8.8L1.4 268zm59.1 59.3l-28.3 8.3-1.6-46.8 25.1-10.7 4.8 49.2zM99 263.2l-31.1 13-5.2-40.8L90.1 221l8.9 42.2zM123.2 377l-41.6 5.9-8.1-63.5 35.2-10.8 14.5 68.4zm28.5-139.9l21.2 57.1-46.2 13.6-13.7-54.1 38.7-16.6zm85.7 230.5l-70.9-3.3-24.3-95.8 55.2-8.6 40 107.7zm-84.9-279.7l42.2-22.4 28 45.9-50.8 21.3-19.4-44.8zm41 94.9l61.3-18.7 52.8 86.6-79.8 11.3-34.3-79.2zm51.4-85.6l67.3-28.8 65.5 65.4-88.6 26.2-44.2-62.8z"
        ],
        "scribd": [
            384,
            512,
            [],
            "f28a",
            "M42.3 252.7c-16.1-19-24.7-45.9-24.8-79.9 0-100.4 75.2-153.1 167.2-153.1 98.6-1.6 156.8 49 184.3 70.6l-50.5 72.1-37.3-24.6 26.9-38.6c-36.5-24-79.4-36.5-123-35.8-50.7-.8-111.7 27.2-111.7 76.2 0 18.7 11.2 20.7 28.6 15.6 23.3-5.3 41.9.6 55.8 14 26.4 24.3 23.2 67.6-.7 91.9-29.2 29.5-85.2 27.3-114.8-8.4zm317.7 5.9c-15.5-18.8-38.9-29.4-63.2-28.6-38.1-2-71.1 28-70.5 67.2-.7 16.8 6 33 18.4 44.3 14.1 13.9 33 19.7 56.3 14.4 17.4-5.1 28.6-3.1 28.6 15.6 0 4.3-.5 8.5-1.4 12.7-16.7 40.9-59.5 64.4-121.4 64.4-51.9.2-102.4-16.4-144.1-47.3l33.7-39.4-35.6-27.4L0 406.3l15.4 13.8c52.5 46.8 120.4 72.5 190.7 72.2 51.4 0 94.4-10.5 133.6-44.1 57.1-51.4 54.2-149.2 20.3-189.6z"
        ],
        "searchengin": [
            460,
            512,
            [],
            "f3eb",
            "M220.6 130.3l-67.2 28.2V43.2L98.7 233.5l54.7-24.2v130.3l67.2-209.3zm-83.2-96.7l-1.3 4.7-15.2 52.9C80.6 106.7 52 145.8 52 191.5c0 52.3 34.3 95.9 83.4 105.5v53.6C57.5 340.1 0 272.4 0 191.6c0-80.5 59.8-147.2 137.4-158zm311.4 447.2c-11.2 11.2-23.1 12.3-28.6 10.5-5.4-1.8-27.1-19.9-60.4-44.4-33.3-24.6-33.6-35.7-43-56.7-9.4-20.9-30.4-42.6-57.5-52.4l-9.7-14.7c-24.7 16.9-53 26.9-81.3 28.7l2.1-6.6 15.9-49.5c46.5-11.9 80.9-54 80.9-104.2 0-54.5-38.4-102.1-96-107.1V32.3C254.4 37.4 320 106.8 320 191.6c0 33.6-11.2 64.7-29 90.4l14.6 9.6c9.8 27.1 31.5 48 52.4 57.4s32.2 9.7 56.8 43c24.6 33.2 42.7 54.9 44.5 60.3s.7 17.3-10.5 28.5zm-9.9-17.9c0-4.4-3.6-8-8-8s-8 3.6-8 8 3.6 8 8 8 8-3.6 8-8z"
        ],
        "sellcast": [
            448,
            512,
            [],
            "f2da",
            "M353.4 32H94.7C42.6 32 0 74.6 0 126.6v258.7C0 437.4 42.6 480 94.7 480h258.7c52.1 0 94.7-42.6 94.7-94.6V126.6c0-52-42.6-94.6-94.7-94.6zm-50 316.4c-27.9 48.2-89.9 64.9-138.2 37.2-22.9 39.8-54.9 8.6-42.3-13.2l15.7-27.2c5.9-10.3 19.2-13.9 29.5-7.9 18.6 10.8-.1-.1 18.5 10.7 27.6 15.9 63.4 6.3 79.4-21.3 15.9-27.6 6.3-63.4-21.3-79.4-17.8-10.2-.6-.4-18.6-10.6-24.6-14.2-3.4-51.9 21.6-37.5 18.6 10.8-.1-.1 18.5 10.7 48.4 28 65.1 90.3 37.2 138.5zm21.8-208.8c-17 29.5-16.3 28.8-19 31.5-6.5 6.5-16.3 8.7-26.5 3.6-18.6-10.8.1.1-18.5-10.7-27.6-15.9-63.4-6.3-79.4 21.3s-6.3 63.4 21.3 79.4c0 0 18.5 10.6 18.6 10.6 24.6 14.2 3.4 51.9-21.6 37.5-18.6-10.8.1.1-18.5-10.7-48.2-27.8-64.9-90.1-37.1-138.4 27.9-48.2 89.9-64.9 138.2-37.2l4.8-8.4c14.3-24.9 52-3.3 37.7 21.5z"
        ],
        "sellsy": [
            640,
            512,
            [],
            "f213",
            "M539.71 237.308c3.064-12.257 4.29-24.821 4.29-37.384C544 107.382 468.618 32 376.076 32c-77.22 0-144.634 53.012-163.02 127.781-15.322-13.176-34.934-20.53-55.157-20.53-46.271 0-83.962 37.69-83.962 83.961 0 7.354.92 15.015 3.065 22.369-42.9 20.225-70.785 63.738-70.785 111.234C6.216 424.843 61.68 480 129.401 480h381.198c67.72 0 123.184-55.157 123.184-123.184.001-56.384-38.916-106.025-94.073-119.508zM199.88 401.554c0 8.274-7.048 15.321-15.321 15.321H153.61c-8.274 0-15.321-7.048-15.321-15.321V290.626c0-8.273 7.048-15.321 15.321-15.321h30.949c8.274 0 15.321 7.048 15.321 15.321v110.928zm89.477 0c0 8.274-7.048 15.321-15.322 15.321h-30.949c-8.274 0-15.321-7.048-15.321-15.321V270.096c0-8.274 7.048-15.321 15.321-15.321h30.949c8.274 0 15.322 7.048 15.322 15.321v131.458zm89.477 0c0 8.274-7.047 15.321-15.321 15.321h-30.949c-8.274 0-15.322-7.048-15.322-15.321V238.84c0-8.274 7.048-15.321 15.322-15.321h30.949c8.274 0 15.321 7.048 15.321 15.321v162.714zm87.027 0c0 8.274-7.048 15.321-15.322 15.321h-28.497c-8.274 0-15.321-7.048-15.321-15.321V176.941c0-8.579 7.047-15.628 15.321-15.628h28.497c8.274 0 15.322 7.048 15.322 15.628v224.613z"
        ],
        "servicestack": [
            496,
            512,
            [],
            "f3ec",
            "M88 216c81.7 10.2 273.7 102.3 304 232H0c99.5-8.1 184.5-137 88-232zm32-152c32.3 35.6 47.7 83.9 46.4 133.6C249.3 231.3 373.7 321.3 400 448h96C455.3 231.9 222.8 79.5 120 64z"
        ],
        "shirtsinbulk": [
            448,
            512,
            [],
            "f214",
            "M100 410.3l30.6 13.4 4.4-9.9-30.6-13.4zm39.4 17.5l30.6 13.4 4.4-9.9-30.6-13.4zm172.1-14l4.4 9.9 30.6-13.4-4.4-9.9zM179.1 445l30.3 13.7 4.4-9.9-30.3-13.4zM60.4 392.8L91 406.2l4.4-9.6-30.6-13.7zm211.4 38.5l4.4 9.9 30.6-13.4-4.4-9.9zm-39.3 17.5l4.4 9.9 30.6-13.7-4.4-9.6zm118.4-52.2l4.4 9.6 30.6-13.4-4.4-9.9zM170 46.6h-33.5v10.5H170zm-47.2 0H89.2v10.5h33.5zm-47.3 0H42.3v10.5h33.3zm141.5 0h-33.2v10.5H217zm94.5 0H278v10.5h33.5zm47.3 0h-33.5v10.5h33.5zm-94.6 0H231v10.5h33.2zm141.5 0h-33.3v10.5h33.3zM52.8 351.1H42v33.5h10.8zm70-215.9H89.2v10.5h33.5zm-70 10.6h22.8v-10.5H42v33.5h10.8zm168.9 228.6c50.5 0 91.3-40.8 91.3-91.3 0-50.2-40.8-91.3-91.3-91.3-50.2 0-91.3 41.1-91.3 91.3 0 50.5 41.1 91.3 91.3 91.3zm-48.2-111.1c0-25.4 29.5-31.8 49.6-31.8 16.9 0 29.2 5.8 44.3 12l-8.8 16.9h-.9c-6.4-9.9-24.8-13.1-35.6-13.1-9 0-29.8 1.8-29.8 14.9 0 21.6 78.5-10.2 78.5 37.9 0 25.4-31.5 31.2-51 31.2-18.1 0-32.4-2.9-47.2-12.2l9-18.4h.9c6.1 12.2 23.6 14.9 35.9 14.9 8.7 0 32.7-1.2 32.7-14.3 0-26.1-77.6 6.3-77.6-38zM52.8 178.4H42V212h10.8zm342.4 206.2H406v-33.5h-10.8zM52.8 307.9H42v33.5h10.8zM0 3.7v406l221.7 98.6L448 409.7V3.7zm418.8 387.1L222 476.5 29.2 390.8V120.7h389.7v270.1zm0-299.3H29.2V32.9h389.7v58.6zm-366 130.1H42v33.5h10.8zm0 43.2H42v33.5h10.8zM170 135.2h-33.5v10.5H170zm225.2 163.1H406v-33.5h-10.8zm0-43.2H406v-33.5h-10.8zM217 135.2h-33.2v10.5H217zM395.2 212H406v-33.5h-10.8zm0 129.5H406V308h-10.8zm-131-206.3H231v10.5h33.2zm47.3 0H278v10.5h33.5zm83.7 33.6H406v-33.5h-33.5v10.5h22.8zm-36.4-33.6h-33.5v10.5h33.5z"
        ],
        "shopify": [
            448,
            512,
            [],
            "e057",
            "M388.32,104.1a4.66,4.66,0,0,0-4.4-4c-2,0-37.23-.8-37.23-.8s-21.61-20.82-29.62-28.83V503.2L442.76,472S388.72,106.5,388.32,104.1ZM288.65,70.47a116.67,116.67,0,0,0-7.21-17.61C271,32.85,255.42,22,237,22a15,15,0,0,0-4,.4c-.4-.8-1.2-1.2-1.6-2C223.4,11.63,213,7.63,200.58,8c-24,.8-48,18-67.25,48.83-13.61,21.62-24,48.84-26.82,70.06-27.62,8.4-46.83,14.41-47.23,14.81-14,4.4-14.41,4.8-16,18-1.2,10-38,291.82-38,291.82L307.86,504V65.67a41.66,41.66,0,0,0-4.4.4S297.86,67.67,288.65,70.47ZM233.41,87.69c-16,4.8-33.63,10.4-50.84,15.61,4.8-18.82,14.41-37.63,25.62-50,4.4-4.4,10.41-9.61,17.21-12.81C232.21,54.86,233.81,74.48,233.41,87.69ZM200.58,24.44A27.49,27.49,0,0,1,215,28c-6.4,3.2-12.81,8.41-18.81,14.41-15.21,16.42-26.82,42-31.62,66.45-14.42,4.41-28.83,8.81-42,12.81C131.33,83.28,163.75,25.24,200.58,24.44ZM154.15,244.61c1.6,25.61,69.25,31.22,73.25,91.66,2.8,47.64-25.22,80.06-65.65,82.47-48.83,3.2-75.65-25.62-75.65-25.62l10.4-44s26.82,20.42,48.44,18.82c14-.8,19.22-12.41,18.81-20.42-2-33.62-57.24-31.62-60.84-86.86-3.2-46.44,27.22-93.27,94.47-97.68,26-1.6,39.23,4.81,39.23,4.81L221.4,225.39s-17.21-8-37.63-6.4C154.15,221,153.75,239.8,154.15,244.61ZM249.42,82.88c0-12-1.6-29.22-7.21-43.63,18.42,3.6,27.22,24,31.23,36.43Q262.63,78.68,249.42,82.88Z"
        ],
        "shopware": [
            512,
            512,
            [],
            "f5b5",
            "M403.5 455.41A246.17 246.17 0 0 1 256 504C118.81 504 8 393 8 256 8 118.81 119 8 256 8a247.39 247.39 0 0 1 165.7 63.5 3.57 3.57 0 0 1-2.86 6.18A418.62 418.62 0 0 0 362.13 74c-129.36 0-222.4 53.47-222.4 155.35 0 109 92.13 145.88 176.83 178.73 33.64 13 65.4 25.36 87 41.59a3.58 3.58 0 0 1 0 5.72zM503 233.09a3.64 3.64 0 0 0-1.27-2.44c-51.76-43-93.62-60.48-144.48-60.48-84.13 0-80.25 52.17-80.25 53.63 0 42.6 52.06 62 112.34 84.49 31.07 11.59 63.19 23.57 92.68 39.93a3.57 3.57 0 0 0 5-1.82A249 249 0 0 0 503 233.09z"
        ],
        "simplybuilt": [
            512,
            512,
            [],
            "f215",
            "M481.2 64h-106c-14.5 0-26.6 11.8-26.6 26.3v39.6H163.3V90.3c0-14.5-12-26.3-26.6-26.3h-106C16.1 64 4.3 75.8 4.3 90.3v331.4c0 14.5 11.8 26.3 26.6 26.3h450.4c14.8 0 26.6-11.8 26.6-26.3V90.3c-.2-14.5-12-26.3-26.7-26.3zM149.8 355.8c-36.6 0-66.4-29.7-66.4-66.4 0-36.9 29.7-66.6 66.4-66.6 36.9 0 66.6 29.7 66.6 66.6 0 36.7-29.7 66.4-66.6 66.4zm212.4 0c-36.9 0-66.6-29.7-66.6-66.6 0-36.6 29.7-66.4 66.6-66.4 36.6 0 66.4 29.7 66.4 66.4 0 36.9-29.8 66.6-66.4 66.6z"
        ],
        "sistrix": [
            448,
            512,
            [],
            "f3ee",
            "M448 449L301.2 300.2c20-27.9 31.9-62.2 31.9-99.2 0-93.1-74.7-168.9-166.5-168.9C74.7 32 0 107.8 0 200.9s74.7 168.9 166.5 168.9c39.8 0 76.3-14.2 105-37.9l146 148.1 30.5-31zM166.5 330.8c-70.6 0-128.1-58.3-128.1-129.9S95.9 71 166.5 71s128.1 58.3 128.1 129.9-57.4 129.9-128.1 129.9z"
        ],
        "sith": [
            448,
            512,
            [],
            "f512",
            "M0 32l69.71 118.75-58.86-11.52 69.84 91.03a146.741 146.741 0 0 0 0 51.45l-69.84 91.03 58.86-11.52L0 480l118.75-69.71-11.52 58.86 91.03-69.84c17.02 3.04 34.47 3.04 51.48 0l91.03 69.84-11.52-58.86L448 480l-69.71-118.78 58.86 11.52-69.84-91.03c3.03-17.01 3.04-34.44 0-51.45l69.84-91.03-58.86 11.52L448 32l-118.75 69.71 11.52-58.9-91.06 69.87c-8.5-1.52-17.1-2.29-25.71-2.29s-17.21.78-25.71 2.29l-91.06-69.87 11.52 58.9L0 32zm224 99.78c31.8 0 63.6 12.12 87.85 36.37 48.5 48.5 48.49 127.21 0 175.7s-127.2 48.46-175.7-.03c-48.5-48.5-48.49-127.21 0-175.7 24.24-24.25 56.05-36.34 87.85-36.34zm0 36.66c-22.42 0-44.83 8.52-61.92 25.61-34.18 34.18-34.19 89.68 0 123.87s89.65 34.18 123.84 0c34.18-34.18 34.19-89.68 0-123.87-17.09-17.09-39.5-25.61-61.92-25.61z"
        ],
        "sketch": [
            512,
            512,
            [],
            "f7c6",
            "M27.5 162.2L9 187.1h90.5l6.9-130.7-78.9 105.8zM396.3 45.7L267.7 32l135.7 147.2-7.1-133.5zM112.2 218.3l-11.2-22H9.9L234.8 458zm2-31.2h284l-81.5-88.5L256.3 33zm297.3 9.1L277.6 458l224.8-261.7h-90.9zM415.4 69L406 56.4l.9 17.3 6.1 113.4h90.3zM113.5 93.5l-4.6 85.6L244.7 32 116.1 45.7zm287.7 102.7h-290l42.4 82.9L256.3 480l144.9-283.8z"
        ],
        "skyatlas": [
            640,
            512,
            [],
            "f216",
            "M640 329.3c0 65.9-52.5 114.4-117.5 114.4-165.9 0-196.6-249.7-359.7-249.7-146.9 0-147.1 212.2 5.6 212.2 42.5 0 90.9-17.8 125.3-42.5 5.6-4.1 16.9-16.3 22.8-16.3s10.9 5 10.9 10.9c0 7.8-13.1 19.1-18.7 24.1-40.9 35.6-100.3 61.2-154.7 61.2-83.4.1-154-59-154-144.9s67.5-149.1 152.8-149.1c185.3 0 222.5 245.9 361.9 245.9 99.9 0 94.8-139.7 3.4-139.7-17.5 0-35 11.6-46.9 11.6-8.4 0-15.9-7.2-15.9-15.6 0-11.6 5.3-23.7 5.3-36.3 0-66.6-50.9-114.7-116.9-114.7-53.1 0-80 36.9-88.8 36.9-6.2 0-11.2-5-11.2-11.2 0-5.6 4.1-10.3 7.8-14.4 25.3-28.8 64.7-43.7 102.8-43.7 79.4 0 139.1 58.4 139.1 137.8 0 6.9-.3 13.7-1.2 20.6 11.9-3.1 24.1-4.7 35.9-4.7 60.7 0 111.9 45.3 111.9 107.2z"
        ],
        "skype": [
            448,
            512,
            [],
            "f17e",
            "M424.7 299.8c2.9-14 4.7-28.9 4.7-43.8 0-113.5-91.9-205.3-205.3-205.3-14.9 0-29.7 1.7-43.8 4.7C161.3 40.7 137.7 32 112 32 50.2 32 0 82.2 0 144c0 25.7 8.7 49.3 23.3 68.2-2.9 14-4.7 28.9-4.7 43.8 0 113.5 91.9 205.3 205.3 205.3 14.9 0 29.7-1.7 43.8-4.7 19 14.6 42.6 23.3 68.2 23.3 61.8 0 112-50.2 112-112 .1-25.6-8.6-49.2-23.2-68.1zm-194.6 91.5c-65.6 0-120.5-29.2-120.5-65 0-16 9-30.6 29.5-30.6 31.2 0 34.1 44.9 88.1 44.9 25.7 0 42.3-11.4 42.3-26.3 0-18.7-16-21.6-42-28-62.5-15.4-117.8-22-117.8-87.2 0-59.2 58.6-81.1 109.1-81.1 55.1 0 110.8 21.9 110.8 55.4 0 16.9-11.4 31.8-30.3 31.8-28.3 0-29.2-33.5-75-33.5-25.7 0-42 7-42 22.5 0 19.8 20.8 21.8 69.1 33 41.4 9.3 90.7 26.8 90.7 77.6 0 59.1-57.1 86.5-112 86.5z"
        ],
        "slack": [
            448,
            512,
            [],
            "f198",
            "M94.12 315.1c0 25.9-21.16 47.06-47.06 47.06S0 341 0 315.1c0-25.9 21.16-47.06 47.06-47.06h47.06v47.06zm23.72 0c0-25.9 21.16-47.06 47.06-47.06s47.06 21.16 47.06 47.06v117.84c0 25.9-21.16 47.06-47.06 47.06s-47.06-21.16-47.06-47.06V315.1zm47.06-188.98c-25.9 0-47.06-21.16-47.06-47.06S139 32 164.9 32s47.06 21.16 47.06 47.06v47.06H164.9zm0 23.72c25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06H47.06C21.16 243.96 0 222.8 0 196.9s21.16-47.06 47.06-47.06H164.9zm188.98 47.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06s-21.16 47.06-47.06 47.06h-47.06V196.9zm-23.72 0c0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06V79.06c0-25.9 21.16-47.06 47.06-47.06 25.9 0 47.06 21.16 47.06 47.06V196.9zM283.1 385.88c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06-25.9 0-47.06-21.16-47.06-47.06v-47.06h47.06zm0-23.72c-25.9 0-47.06-21.16-47.06-47.06 0-25.9 21.16-47.06 47.06-47.06h117.84c25.9 0 47.06 21.16 47.06 47.06 0 25.9-21.16 47.06-47.06 47.06H283.1z"
        ],
        "slack-hash": [
            448,
            512,
            [],
            "f3ef",
            "M446.2 270.4c-6.2-19-26.9-29.1-46-22.9l-45.4 15.1-30.3-90 45.4-15.1c19.1-6.2 29.1-26.8 23-45.9-6.2-19-26.9-29.1-46-22.9l-45.4 15.1-15.7-47c-6.2-19-26.9-29.1-46-22.9-19.1 6.2-29.1 26.8-23 45.9l15.7 47-93.4 31.2-15.7-47c-6.2-19-26.9-29.1-46-22.9-19.1 6.2-29.1 26.8-23 45.9l15.7 47-45.3 15c-19.1 6.2-29.1 26.8-23 45.9 5 14.5 19.1 24 33.6 24.6 6.8 1 12-1.6 57.7-16.8l30.3 90L78 354.8c-19 6.2-29.1 26.9-23 45.9 5 14.5 19.1 24 33.6 24.6 6.8 1 12-1.6 57.7-16.8l15.7 47c5.9 16.9 24.7 29 46 22.9 19.1-6.2 29.1-26.8 23-45.9l-15.7-47 93.6-31.3 15.7 47c5.9 16.9 24.7 29 46 22.9 19.1-6.2 29.1-26.8 23-45.9l-15.7-47 45.4-15.1c19-6 29.1-26.7 22.9-45.7zm-254.1 47.2l-30.3-90.2 93.5-31.3 30.3 90.2-93.5 31.3z"
        ],
        "slideshare": [
            512,
            512,
            [],
            "f1e7",
            "M187.7 153.7c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7s61.7-26 61.7-57.7c0-32-27.7-57.7-61.7-57.7zm143.4 0c-34 0-61.7 25.7-61.7 57.7 0 31.7 27.7 57.7 61.7 57.7 34.3 0 61.7-26 61.7-57.7.1-32-27.4-57.7-61.7-57.7zm156.6 90l-6 4.3V49.7c0-27.4-20.6-49.7-46-49.7H76.6c-25.4 0-46 22.3-46 49.7V248c-2-1.4-4.3-2.9-6.3-4.3-15.1-10.6-25.1 4-16 17.7 18.3 22.6 53.1 50.3 106.3 72C58.3 525.1 252 555.7 248.9 457.5c0-.7.3-56.6.3-96.6 5.1 1.1 9.4 2.3 13.7 3.1 0 39.7.3 92.8.3 93.5-3.1 98.3 190.6 67.7 134.3-124 53.1-21.7 88-49.4 106.3-72 9.1-13.8-.9-28.3-16.1-17.8zm-30.5 19.2c-68.9 37.4-128.3 31.1-160.6 29.7-23.7-.9-32.6 9.1-33.7 24.9-10.3-7.7-18.6-15.5-20.3-17.1-5.1-5.4-13.7-8-27.1-7.7-31.7 1.1-89.7 7.4-157.4-28V72.3c0-34.9 8.9-45.7 40.6-45.7h317.7c30.3 0 40.9 12.9 40.9 45.7v190.6z"
        ],
        "snapchat": [
            496,
            512,
            [],
            "f2ab",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm169.5 338.9c-3.5 8.1-18.1 14-44.8 18.2-1.4 1.9-2.5 9.8-4.3 15.9-1.1 3.7-3.7 5.9-8.1 5.9h-.2c-6.2 0-12.8-2.9-25.8-2.9-17.6 0-23.7 4-37.4 13.7-14.5 10.3-28.4 19.1-49.2 18.2-21 1.6-38.6-11.2-48.5-18.2-13.8-9.7-19.8-13.7-37.4-13.7-12.5 0-20.4 3.1-25.8 3.1-5.4 0-7.5-3.3-8.3-6-1.8-6.1-2.9-14.1-4.3-16-13.8-2.1-44.8-7.5-45.5-21.4-.2-3.6 2.3-6.8 5.9-7.4 46.3-7.6 67.1-55.1 68-57.1 0-.1.1-.2.2-.3 2.5-5 3-9.2 1.6-12.5-3.4-7.9-17.9-10.7-24-13.2-15.8-6.2-18-13.4-17-18.3 1.6-8.5 14.4-13.8 21.9-10.3 5.9 2.8 11.2 4.2 15.7 4.2 3.3 0 5.5-.8 6.6-1.4-1.4-23.9-4.7-58 3.8-77.1C183.1 100 230.7 96 244.7 96c.6 0 6.1-.1 6.7-.1 34.7 0 68 17.8 84.3 54.3 8.5 19.1 5.2 53.1 3.8 77.1 1.1.6 2.9 1.3 5.7 1.4 4.3-.2 9.2-1.6 14.7-4.2 4-1.9 9.6-1.6 13.6 0 6.3 2.3 10.3 6.8 10.4 11.9.1 6.5-5.7 12.1-17.2 16.6-1.4.6-3.1 1.1-4.9 1.7-6.5 2.1-16.4 5.2-19 11.5-1.4 3.3-.8 7.5 1.6 12.5.1.1.1.2.2.3.9 2 21.7 49.5 68 57.1 4 1 7.1 5.5 4.9 10.8z"
        ],
        "snapchat-ghost": [
            512,
            512,
            [],
            "f2ac",
            "M510.846 392.673c-5.211 12.157-27.239 21.089-67.36 27.318-2.064 2.786-3.775 14.686-6.507 23.956-1.625 5.566-5.623 8.869-12.128 8.869l-.297-.005c-9.395 0-19.203-4.323-38.852-4.323-26.521 0-35.662 6.043-56.254 20.588-21.832 15.438-42.771 28.764-74.027 27.399-31.646 2.334-58.025-16.908-72.871-27.404-20.714-14.643-29.828-20.582-56.241-20.582-18.864 0-30.736 4.72-38.852 4.72-8.073 0-11.213-4.922-12.422-9.04-2.703-9.189-4.404-21.263-6.523-24.13-20.679-3.209-67.31-11.344-68.498-32.15a10.627 10.627 0 0 1 8.877-11.069c69.583-11.455 100.924-82.901 102.227-85.934.074-.176.155-.344.237-.515 3.713-7.537 4.544-13.849 2.463-18.753-5.05-11.896-26.872-16.164-36.053-19.796-23.715-9.366-27.015-20.128-25.612-27.504 2.437-12.836 21.725-20.735 33.002-15.453 8.919 4.181 16.843 6.297 23.547 6.297 5.022 0 8.212-1.204 9.96-2.171-2.043-35.936-7.101-87.29 5.687-115.969C158.122 21.304 229.705 15.42 250.826 15.42c.944 0 9.141-.089 10.11-.089 52.148 0 102.254 26.78 126.723 81.643 12.777 28.65 7.749 79.792 5.695 116.009 1.582.872 4.357 1.942 8.599 2.139 6.397-.286 13.815-2.389 22.069-6.257 6.085-2.846 14.406-2.461 20.48.058l.029.01c9.476 3.385 15.439 10.215 15.589 17.87.184 9.747-8.522 18.165-25.878 25.018-2.118.835-4.694 1.655-7.434 2.525-9.797 3.106-24.6 7.805-28.616 17.271-2.079 4.904-1.256 11.211 2.46 18.748.087.168.166.342.239.515 1.301 3.03 32.615 74.46 102.23 85.934 6.427 1.058 11.163 7.877 7.725 15.859z"
        ],
        "snapchat-square": [
            448,
            512,
            [],
            "f2ad",
            "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6.5 314.9c-3.5 8.1-18.1 14-44.8 18.2-1.4 1.9-2.5 9.8-4.3 15.9-1.1 3.7-3.7 5.9-8.1 5.9h-.2c-6.2 0-12.8-2.9-25.8-2.9-17.6 0-23.7 4-37.4 13.7-14.5 10.3-28.4 19.1-49.2 18.2-21 1.6-38.6-11.2-48.5-18.2-13.8-9.7-19.8-13.7-37.4-13.7-12.5 0-20.4 3.1-25.8 3.1-5.4 0-7.5-3.3-8.3-6-1.8-6.1-2.9-14.1-4.3-16-13.8-2.1-44.8-7.5-45.5-21.4-.2-3.6 2.3-6.8 5.9-7.4 46.3-7.6 67.1-55.1 68-57.1 0-.1.1-.2.2-.3 2.5-5 3-9.2 1.6-12.5-3.4-7.9-17.9-10.7-24-13.2-15.8-6.2-18-13.4-17-18.3 1.6-8.5 14.4-13.8 21.9-10.3 5.9 2.8 11.2 4.2 15.7 4.2 3.3 0 5.5-.8 6.6-1.4-1.4-23.9-4.7-58 3.8-77.1C159.1 100 206.7 96 220.7 96c.6 0 6.1-.1 6.7-.1 34.7 0 68 17.8 84.3 54.3 8.5 19.1 5.2 53.1 3.8 77.1 1.1.6 2.9 1.3 5.7 1.4 4.3-.2 9.2-1.6 14.7-4.2 4-1.9 9.6-1.6 13.6 0 6.3 2.3 10.3 6.8 10.4 11.9.1 6.5-5.7 12.1-17.2 16.6-1.4.6-3.1 1.1-4.9 1.7-6.5 2.1-16.4 5.2-19 11.5-1.4 3.3-.8 7.5 1.6 12.5.1.1.1.2.2.3.9 2 21.7 49.5 68 57.1 4 1 7.1 5.5 4.9 10.8z"
        ],
        "soundcloud": [
            640,
            512,
            [],
            "f1be",
            "M111.4 256.3l5.8 65-5.8 68.3c-.3 2.5-2.2 4.4-4.4 4.4s-4.2-1.9-4.2-4.4l-5.6-68.3 5.6-65c0-2.2 1.9-4.2 4.2-4.2 2.2 0 4.1 2 4.4 4.2zm21.4-45.6c-2.8 0-4.7 2.2-5 5l-5 105.6 5 68.3c.3 2.8 2.2 5 5 5 2.5 0 4.7-2.2 4.7-5l5.8-68.3-5.8-105.6c0-2.8-2.2-5-4.7-5zm25.5-24.1c-3.1 0-5.3 2.2-5.6 5.3l-4.4 130 4.4 67.8c.3 3.1 2.5 5.3 5.6 5.3 2.8 0 5.3-2.2 5.3-5.3l5.3-67.8-5.3-130c0-3.1-2.5-5.3-5.3-5.3zM7.2 283.2c-1.4 0-2.2 1.1-2.5 2.5L0 321.3l4.7 35c.3 1.4 1.1 2.5 2.5 2.5s2.2-1.1 2.5-2.5l5.6-35-5.6-35.6c-.3-1.4-1.1-2.5-2.5-2.5zm23.6-21.9c-1.4 0-2.5 1.1-2.5 2.5l-6.4 57.5 6.4 56.1c0 1.7 1.1 2.8 2.5 2.8s2.5-1.1 2.8-2.5l7.2-56.4-7.2-57.5c-.3-1.4-1.4-2.5-2.8-2.5zm25.3-11.4c-1.7 0-3.1 1.4-3.3 3.3L47 321.3l5.8 65.8c.3 1.7 1.7 3.1 3.3 3.1 1.7 0 3.1-1.4 3.1-3.1l6.9-65.8-6.9-68.1c0-1.9-1.4-3.3-3.1-3.3zm25.3-2.2c-1.9 0-3.6 1.4-3.6 3.6l-5.8 70 5.8 67.8c0 2.2 1.7 3.6 3.6 3.6s3.6-1.4 3.9-3.6l6.4-67.8-6.4-70c-.3-2.2-2-3.6-3.9-3.6zm241.4-110.9c-1.1-.8-2.8-1.4-4.2-1.4-2.2 0-4.2.8-5.6 1.9-1.9 1.7-3.1 4.2-3.3 6.7v.8l-3.3 176.7 1.7 32.5 1.7 31.7c.3 4.7 4.2 8.6 8.9 8.6s8.6-3.9 8.6-8.6l3.9-64.2-3.9-177.5c-.4-3-2-5.8-4.5-7.2zm-26.7 15.3c-1.4-.8-2.8-1.4-4.4-1.4s-3.1.6-4.4 1.4c-2.2 1.4-3.6 3.9-3.6 6.7l-.3 1.7-2.8 160.8s0 .3 3.1 65.6v.3c0 1.7.6 3.3 1.7 4.7 1.7 1.9 3.9 3.1 6.4 3.1 2.2 0 4.2-1.1 5.6-2.5 1.7-1.4 2.5-3.3 2.5-5.6l.3-6.7 3.1-58.6-3.3-162.8c-.3-2.8-1.7-5.3-3.9-6.7zm-111.4 22.5c-3.1 0-5.8 2.8-5.8 6.1l-4.4 140.6 4.4 67.2c.3 3.3 2.8 5.8 5.8 5.8 3.3 0 5.8-2.5 6.1-5.8l5-67.2-5-140.6c-.2-3.3-2.7-6.1-6.1-6.1zm376.7 62.8c-10.8 0-21.1 2.2-30.6 6.1-6.4-70.8-65.8-126.4-138.3-126.4-17.8 0-35 3.3-50.3 9.4-6.1 2.2-7.8 4.4-7.8 9.2v249.7c0 5 3.9 8.6 8.6 9.2h218.3c43.3 0 78.6-35 78.6-78.3.1-43.6-35.2-78.9-78.5-78.9zm-296.7-60.3c-4.2 0-7.5 3.3-7.8 7.8l-3.3 136.7 3.3 65.6c.3 4.2 3.6 7.5 7.8 7.5 4.2 0 7.5-3.3 7.5-7.5l3.9-65.6-3.9-136.7c-.3-4.5-3.3-7.8-7.5-7.8zm-53.6-7.8c-3.3 0-6.4 3.1-6.4 6.7l-3.9 145.3 3.9 66.9c.3 3.6 3.1 6.4 6.4 6.4 3.6 0 6.4-2.8 6.7-6.4l4.4-66.9-4.4-145.3c-.3-3.6-3.1-6.7-6.7-6.7zm26.7 3.4c-3.9 0-6.9 3.1-6.9 6.9L227 321.3l3.9 66.4c.3 3.9 3.1 6.9 6.9 6.9s6.9-3.1 6.9-6.9l4.2-66.4-4.2-141.7c0-3.9-3-6.9-6.9-6.9z"
        ],
        "sourcetree": [
            448,
            512,
            [],
            "f7d3",
            "M427.2 203c0-112.1-90.9-203-203-203C112.1-.2 21.2 90.6 21 202.6A202.86 202.86 0 0 0 161.5 396v101.7a14.3 14.3 0 0 0 14.3 14.3h96.4a14.3 14.3 0 0 0 14.3-14.3V396.1A203.18 203.18 0 0 0 427.2 203zm-271.6 0c0-90.8 137.3-90.8 137.3 0-.1 89.9-137.3 91-137.3 0z"
        ],
        "speakap": [
            448,
            512,
            [],
            "f3f3",
            "M64 391.78C-15.41 303.59-8 167.42 80.64 87.64s224.8-73 304.21 15.24 72 224.36-16.64 304.14c-18.74 16.87 64 43.09 42 52.26-82.06 34.21-253.91 35-346.23-67.5zm213.31-211.6l38.5-40.86c-9.61-8.89-32-26.83-76.17-27.6-52.33-.91-95.86 28.3-96.77 80-.2 11.33.29 36.72 29.42 54.83 34.46 21.42 86.52 21.51 86 52.26-.37 21.28-26.42 25.81-38.59 25.6-3-.05-30.23-.46-47.61-24.62l-40 42.61c28.16 27 59 32.62 83.49 33.05 10.23.18 96.42.33 97.84-81 .28-15.81-2.07-39.72-28.86-56.59-34.36-21.64-85-19.45-84.43-49.75.41-23.25 31-25.37 37.53-25.26.43 0 26.62.26 39.62 17.37z"
        ],
        "speaker-deck": [
            512,
            512,
            [],
            "f83c",
            "M213.86 296H100a100 100 0 0 1 0-200h132.84a40 40 0 0 1 0 80H98c-26.47 0-26.45 40 0 40h113.82a100 100 0 0 1 0 200H40a40 40 0 0 1 0-80h173.86c26.48 0 26.46-40 0-40zM298 416a120.21 120.21 0 0 0 51.11-80h64.55a19.83 19.83 0 0 0 19.66-20V196a19.83 19.83 0 0 0-19.66-20H296.42a60.77 60.77 0 0 0 0-80h136.93c43.44 0 78.65 35.82 78.65 80v160c0 44.18-35.21 80-78.65 80z"
        ],
        "spotify": [
            496,
            512,
            [],
            "f1bc",
            "M248 8C111.1 8 0 119.1 0 256s111.1 248 248 248 248-111.1 248-248S384.9 8 248 8zm100.7 364.9c-4.2 0-6.8-1.3-10.7-3.6-62.4-37.6-135-39.2-206.7-24.5-3.9 1-9 2.6-11.9 2.6-9.7 0-15.8-7.7-15.8-15.8 0-10.3 6.1-15.2 13.6-16.8 81.9-18.1 165.6-16.5 237 26.2 6.1 3.9 9.7 7.4 9.7 16.5s-7.1 15.4-15.2 15.4zm26.9-65.6c-5.2 0-8.7-2.3-12.3-4.2-62.5-37-155.7-51.9-238.6-29.4-4.8 1.3-7.4 2.6-11.9 2.6-10.7 0-19.4-8.7-19.4-19.4s5.2-17.8 15.5-20.7c27.8-7.8 56.2-13.6 97.8-13.6 64.9 0 127.6 16.1 177 45.5 8.1 4.8 11.3 11 11.3 19.7-.1 10.8-8.5 19.5-19.4 19.5zm31-76.2c-5.2 0-8.4-1.3-12.9-3.9-71.2-42.5-198.5-52.7-280.9-29.7-3.6 1-8.1 2.6-12.9 2.6-13.2 0-23.3-10.3-23.3-23.6 0-13.6 8.4-21.3 17.4-23.9 35.2-10.3 74.6-15.2 117.5-15.2 73 0 149.5 15.2 205.4 47.8 7.8 4.5 12.9 10.7 12.9 22.6 0 13.6-11 23.3-23.2 23.3z"
        ],
        "squarespace": [
            512,
            512,
            [],
            "f5be",
            "M186.12 343.34c-9.65 9.65-9.65 25.29 0 34.94 9.65 9.65 25.29 9.65 34.94 0L378.24 221.1c19.29-19.29 50.57-19.29 69.86 0s19.29 50.57 0 69.86L293.95 445.1c19.27 19.29 50.53 19.31 69.82.04l.04-.04 119.25-119.24c38.59-38.59 38.59-101.14 0-139.72-38.59-38.59-101.15-38.59-139.72 0l-157.22 157.2zm244.53-104.8c-9.65-9.65-25.29-9.65-34.93 0l-157.2 157.18c-19.27 19.29-50.53 19.31-69.82.05l-.05-.05c-9.64-9.64-25.27-9.65-34.92-.01l-.01.01c-9.65 9.64-9.66 25.28-.02 34.93l.02.02c38.58 38.57 101.14 38.57 139.72 0l157.2-157.2c9.65-9.65 9.65-25.29.01-34.93zm-261.99 87.33l157.18-157.18c9.64-9.65 9.64-25.29 0-34.94-9.64-9.64-25.27-9.64-34.91 0L133.72 290.93c-19.28 19.29-50.56 19.3-69.85.01l-.01-.01c-19.29-19.28-19.31-50.54-.03-69.84l.03-.03L218.03 66.89c-19.28-19.29-50.55-19.3-69.85-.02l-.02.02L28.93 186.14c-38.58 38.59-38.58 101.14 0 139.72 38.6 38.59 101.13 38.59 139.73.01zm-87.33-52.4c9.64 9.64 25.27 9.64 34.91 0l157.21-157.19c19.28-19.29 50.55-19.3 69.84-.02l.02.02c9.65 9.65 25.29 9.65 34.93 0 9.65-9.65 9.65-25.29 0-34.93-38.59-38.59-101.13-38.59-139.72 0L81.33 238.54c-9.65 9.64-9.65 25.28-.01 34.93h.01z"
        ],
        "stack-exchange": [
            448,
            512,
            [],
            "f18d",
            "M17.7 332.3h412.7v22c0 37.7-29.3 68-65.3 68h-19L259.3 512v-89.7H83c-36 0-65.3-30.3-65.3-68v-22zm0-23.6h412.7v-85H17.7v85zm0-109.4h412.7v-85H17.7v85zM365 0H83C47 0 17.7 30.3 17.7 67.7V90h412.7V67.7C430.3 30.3 401 0 365 0z"
        ],
        "stack-overflow": [
            384,
            512,
            [],
            "f16c",
            "M290.7 311L95 269.7 86.8 309l195.7 41zm51-87L188.2 95.7l-25.5 30.8 153.5 128.3zm-31.2 39.7L129.2 179l-16.7 36.5L293.7 300zM262 32l-32 24 119.3 160.3 32-24zm20.5 328h-200v39.7h200zm39.7 80H42.7V320h-40v160h359.5V320h-40z"
        ],
        "stackpath": [
            448,
            512,
            [],
            "f842",
            "M244.6 232.4c0 8.5-4.26 20.49-21.34 20.49h-19.61v-41.47h19.61c17.13 0 21.34 12.36 21.34 20.98zM448 32v448H0V32zM151.3 287.84c0-21.24-12.12-34.54-46.72-44.85-20.57-7.41-26-10.91-26-18.63s7-14.61 20.41-14.61c14.09 0 20.79 8.45 20.79 18.35h30.7l.19-.57c.5-19.57-15.06-41.65-51.12-41.65-23.37 0-52.55 10.75-52.55 38.29 0 19.4 9.25 31.29 50.74 44.37 17.26 6.15 21.91 10.4 21.91 19.48 0 15.2-19.13 14.23-19.47 14.23-20.4 0-25.65-9.1-25.65-21.9h-30.8l-.18.56c-.68 31.32 28.38 45.22 56.63 45.22 29.98 0 51.12-13.55 51.12-38.29zm125.38-55.63c0-25.3-18.43-45.46-53.42-45.46h-51.78v138.18h32.17v-47.36h19.61c30.25 0 53.42-15.95 53.42-45.36zM297.94 325L347 186.78h-31.09L268 325zm106.52-138.22h-31.09L325.46 325h29.94z"
        ],
        "staylinked": [
            440,
            512,
            [],
            "f3f5",
            "M382.7 292.5l2.7 2.7-170-167.3c-3.5-3.5-9.7-3.7-13.8-.5L144.3 171c-4.2 3.2-4.6 8.7-1.1 12.2l68.1 64.3c3.6 3.5 9.9 3.7 14 .5l.1-.1c4.1-3.2 10.4-3 14 .5l84 81.3c3.6 3.5 3.2 9-.9 12.2l-93.2 74c-4.2 3.3-10.5 3.1-14.2-.4L63.2 268c-3.5-3.5-9.7-3.7-13.9-.5L3.5 302.4c-4.2 3.2-4.7 8.7-1.2 12.2L211 510.7s7.4 6.8 17.3-.8l198-163.9c4-3.2 4.4-8.7.7-12.2zm54.5-83.4L226.7 2.5c-1.5-1.2-8-5.5-16.3 1.1L3.6 165.7c-4.2 3.2-4.8 8.7-1.2 12.2l42.3 41.7 171.7 165.1c3.7 3.5 10.1 3.7 14.3.4l50.2-38.8-.3-.3 7.7-6c4.2-3.2 4.6-8.7.9-12.2l-57.1-54.4c-3.6-3.5-10-3.7-14.2-.5l-.1.1c-4.2 3.2-10.5 3.1-14.2-.4L109 180.8c-3.6-3.5-3.1-8.9 1.1-12.2l92.2-71.5c4.1-3.2 10.3-3 13.9.5l160.4 159c3.7 3.5 10 3.7 14.1.5l45.8-35.8c4.1-3.2 4.4-8.7.7-12.2z"
        ],
        "steam": [
            496,
            512,
            [],
            "f1b6",
            "M496 256c0 137-111.2 248-248.4 248-113.8 0-209.6-76.3-239-180.4l95.2 39.3c6.4 32.1 34.9 56.4 68.9 56.4 39.2 0 71.9-32.4 70.2-73.5l84.5-60.2c52.1 1.3 95.8-40.9 95.8-93.5 0-51.6-42-93.5-93.7-93.5s-93.7 42-93.7 93.5v1.2L176.6 279c-15.5-.9-30.7 3.4-43.5 12.1L0 236.1C10.2 108.4 117.1 8 247.6 8 384.8 8 496 119 496 256zM155.7 384.3l-30.5-12.6a52.79 52.79 0 0 0 27.2 25.8c26.9 11.2 57.8-1.6 69-28.4 5.4-13 5.5-27.3.1-40.3-5.4-13-15.5-23.2-28.5-28.6-12.9-5.4-26.7-5.2-38.9-.6l31.5 13c19.8 8.2 29.2 30.9 20.9 50.7-8.3 19.9-31 29.2-50.8 21zm173.8-129.9c-34.4 0-62.4-28-62.4-62.3s28-62.3 62.4-62.3 62.4 28 62.4 62.3-27.9 62.3-62.4 62.3zm.1-15.6c25.9 0 46.9-21 46.9-46.8 0-25.9-21-46.8-46.9-46.8s-46.9 21-46.9 46.8c.1 25.8 21.1 46.8 46.9 46.8z"
        ],
        "steam-square": [
            448,
            512,
            [],
            "f1b7",
            "M185.2 356.5c7.7-18.5-1-39.7-19.6-47.4l-29.5-12.2c11.4-4.3 24.3-4.5 36.4.5 12.2 5.1 21.6 14.6 26.7 26.7 5 12.2 5 25.6-.1 37.7-10.5 25.1-39.4 37-64.6 26.5-11.6-4.8-20.4-13.6-25.4-24.2l28.5 11.8c18.6 7.8 39.9-.9 47.6-19.4zM400 32H48C21.5 32 0 53.5 0 80v160.7l116.6 48.1c12-8.2 26.2-12.1 40.7-11.3l55.4-80.2v-1.1c0-48.2 39.3-87.5 87.6-87.5s87.6 39.3 87.6 87.5c0 49.2-40.9 88.7-89.6 87.5l-79 56.3c1.6 38.5-29.1 68.8-65.7 68.8-31.8 0-58.5-22.7-64.5-52.7L0 319.2V432c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-99.7 222.5c-32.2 0-58.4-26.1-58.4-58.3s26.2-58.3 58.4-58.3 58.4 26.2 58.4 58.3-26.2 58.3-58.4 58.3zm.1-14.6c24.2 0 43.9-19.6 43.9-43.8 0-24.2-19.6-43.8-43.9-43.8-24.2 0-43.9 19.6-43.9 43.8 0 24.2 19.7 43.8 43.9 43.8z"
        ],
        "steam-symbol": [
            448,
            512,
            [],
            "f3f6",
            "M395.5 177.5c0 33.8-27.5 61-61 61-33.8 0-61-27.3-61-61s27.3-61 61-61c33.5 0 61 27.2 61 61zm52.5.2c0 63-51 113.8-113.7 113.8L225 371.3c-4 43-40.5 76.8-84.5 76.8-40.5 0-74.7-28.8-83-67L0 358V250.7L97.2 290c15.1-9.2 32.2-13.3 52-11.5l71-101.7c.5-62.3 51.5-112.8 114-112.8C397 64 448 115 448 177.7zM203 363c0-34.7-27.8-62.5-62.5-62.5-4.5 0-9 .5-13.5 1.5l26 10.5c25.5 10.2 38 39 27.7 64.5-10.2 25.5-39.2 38-64.7 27.5-10.2-4-20.5-8.3-30.7-12.2 10.5 19.7 31.2 33.2 55.2 33.2 34.7 0 62.5-27.8 62.5-62.5zm207.5-185.3c0-42-34.3-76.2-76.2-76.2-42.3 0-76.5 34.2-76.5 76.2 0 42.2 34.3 76.2 76.5 76.2 41.9.1 76.2-33.9 76.2-76.2z"
        ],
        "sticker-mule": [
            576,
            512,
            [],
            "f3f7",
            "M561.7 199.6c-1.3.3.3 0 0 0zm-6.2-77.4c-7.7-22.3-5.1-7.2-13.4-36.9-1.6-6.5-3.6-14.5-6.2-20-4.4-8.7-4.6-7.5-4.6-9.5 0-5.3 30.7-45.3 19-46.9-5.7-.6-12.2 11.6-20.6 17-8.6 4.2-8 5-10.3 5-2.6 0-5.7-3-6.2-5-2-5.7 1.9-25.9-3.6-25.9-3.6 0-12.3 24.8-17 25.8-5.2 1.3-27.9-11.4-75.1 18-25.3 13.2-86.9 65.2-87 65.3-6.7 4.7-20 4.7-35.5 16-44.4 30.1-109.6 9.4-110.7 9-110.6-26.8-128-15.2-159 11.5-20.8 17.9-23.7 36.5-24.2 38.9-4.2 20.4 5.2 48.3 6.7 64.3 1.8 19.3-2.7 17.7 7.7 98.3.5 1 4.1 0 5.1 1.5 0 8.4-3.8 12.1-4.1 13-1.5 4.5-1.5 10.5 0 16 2.3 8.2 8.2 37.2 8.2 46.9 0 41.8.4 44 2.6 49.4 3.9 10 12.5 9.1 17 12 3.1 3.5-.5 8.5 1 12.5.5 2 3.6 4 6.2 5 9.2 3.6 27 .3 29.9-2.5 1.6-1.5.5-4.5 3.1-5 5.1 0 10.8-.5 14.4-2.5 5.1-2.5 4.1-6 1.5-10.5-.4-.8-7-13.3-9.8-16-2.1-2-5.1-3-7.2-4.5-5.8-4.9-10.3-19.4-10.3-19.5-4.6-19.4-10.3-46.3-4.1-66.8 4.6-17.2 39.5-87.7 39.6-87.8 4.1-6.5 17-11.5 27.3-7 6 1.9 19.3 22 65.4 30.9 47.9 8.7 97.4-2 112.2-2 2.8 2-1.9 13-.5 38.9 0 26.4-.4 13.7-4.1 29.9-2.2 9.7 3.4 23.2-1.5 46.9-1.4 9.8-9.9 32.7-8.2 43.4.5 1 1 2 1.5 3.5.5 4.5 1.5 8.5 4.6 10 7.3 3.6 12-3.5 9.8 11.5-.7 3.1-2.6 12 1.5 15 4.4 3.7 30.6 3.4 36.5.5 2.6-1.5 1.6-4.5 6.4-7.4 1.9-.9 11.3-.4 11.3-6.5.3-1.8-9.2-19.9-9.3-20-2.6-3.5-9.2-4.5-11.3-8-6.9-10.1-1.7-52.6.5-59.4 3-11 5.6-22.4 8.7-32.4 11-42.5 10.3-50.6 16.5-68.3.8-1.8 6.4-23.1 10.3-29.9 9.3-17 21.7-32.4 33.5-47.4 18-22.9 34-46.9 52-69.8 6.1-7 8.2-13.7 18-8 10.8 5.7 21.6 7 31.9 17 14.6 12.8 10.2 18.2 11.8 22.9 1.5 5 7.7 10.5 14.9 9.5 10.4-2 13-2.5 13.4-2.5 2.6-.5 5.7-5 7.2-8 3.1-5.5 7.2-9 7.2-16.5 0-7.7-.4-2.8-20.6-52.9z"
        ],
        "strava": [
            384,
            512,
            [],
            "f428",
            "M158.4 0L7 292h89.2l62.2-116.1L220.1 292h88.5zm150.2 292l-43.9 88.2-44.6-88.2h-67.6l112.2 220 111.5-220z"
        ],
        "stripe": [
            640,
            512,
            [],
            "f429",
            "M165 144.7l-43.3 9.2-.2 142.4c0 26.3 19.8 43.3 46.1 43.3 14.6 0 25.3-2.7 31.2-5.9v-33.8c-5.7 2.3-33.7 10.5-33.7-15.7V221h33.7v-37.8h-33.7zm89.1 51.6l-2.7-13.1H213v153.2h44.3V233.3c10.5-13.8 28.2-11.1 33.9-9.3v-40.8c-6-2.1-26.7-6-37.1 13.1zm92.3-72.3l-44.6 9.5v36.2l44.6-9.5zM44.9 228.3c0-6.9 5.8-9.6 15.1-9.7 13.5 0 30.7 4.1 44.2 11.4v-41.8c-14.7-5.8-29.4-8.1-44.1-8.1-36 0-60 18.8-60 50.2 0 49.2 67.5 41.2 67.5 62.4 0 8.2-7.1 10.9-17 10.9-14.7 0-33.7-6.1-48.6-14.2v40c16.5 7.1 33.2 10.1 48.5 10.1 36.9 0 62.3-15.8 62.3-47.8 0-52.9-67.9-43.4-67.9-63.4zM640 261.6c0-45.5-22-81.4-64.2-81.4s-67.9 35.9-67.9 81.1c0 53.5 30.3 78.2 73.5 78.2 21.2 0 37.1-4.8 49.2-11.5v-33.4c-12.1 6.1-26 9.8-43.6 9.8-17.3 0-32.5-6.1-34.5-26.9h86.9c.2-2.3.6-11.6.6-15.9zm-87.9-16.8c0-20 12.3-28.4 23.4-28.4 10.9 0 22.5 8.4 22.5 28.4zm-112.9-64.6c-17.4 0-28.6 8.2-34.8 13.9l-2.3-11H363v204.8l44.4-9.4.1-50.2c6.4 4.7 15.9 11.2 31.4 11.2 31.8 0 60.8-23.2 60.8-79.6.1-51.6-29.3-79.7-60.5-79.7zm-10.6 122.5c-10.4 0-16.6-3.8-20.9-8.4l-.3-66c4.6-5.1 11-8.8 21.2-8.8 16.2 0 27.4 18.2 27.4 41.4.1 23.9-10.9 41.8-27.4 41.8zm-126.7 33.7h44.6V183.2h-44.6z"
        ],
        "stripe-s": [
            384,
            512,
            [],
            "f42a",
            "M155.3 154.6c0-22.3 18.6-30.9 48.4-30.9 43.4 0 98.5 13.3 141.9 36.7V26.1C298.3 7.2 251.1 0 203.8 0 88.1 0 11 60.4 11 161.4c0 157.9 216.8 132.3 216.8 200.4 0 26.4-22.9 34.9-54.7 34.9-47.2 0-108.2-19.5-156.1-45.5v128.5a396.09 396.09 0 0 0 156 32.4c118.6 0 200.3-51 200.3-153.6 0-170.2-218-139.7-218-203.9z"
        ],
        "studiovinari": [
            512,
            512,
            [],
            "f3f8",
            "M480.3 187.7l4.2 28v28l-25.1 44.1-39.8 78.4-56.1 67.5-79.1 37.8-17.7 24.5-7.7 12-9.6 4s17.3-63.6 19.4-63.6c2.1 0 20.3.7 20.3.7l66.7-38.6-92.5 26.1-55.9 36.8-22.8 28-6.6 1.4 20.8-73.6 6.9-5.5 20.7 12.9 88.3-45.2 56.8-51.5 14.8-68.4-125.4 23.3 15.2-18.2-173.4-53.3 81.9-10.5-166-122.9L133.5 108 32.2 0l252.9 126.6-31.5-38L378 163 234.7 64l18.7 38.4-49.6-18.1L158.3 0l194.6 122L310 66.2l108 96.4 12-8.9-21-16.4 4.2-37.8L451 89.1l29.2 24.7 11.5 4.2-7 6.2 8.5 12-13.1 7.4-10.3 20.2 10.5 23.9z"
        ],
        "stumbleupon": [
            512,
            512,
            [],
            "f1a4",
            "M502.9 266v69.7c0 62.1-50.3 112.4-112.4 112.4-61.8 0-112.4-49.8-112.4-111.3v-70.2l34.3 16 51.1-15.2V338c0 14.7 12 26.5 26.7 26.5S417 352.7 417 338v-72h85.9zm-224.7-58.2l34.3 16 51.1-15.2V173c0-60.5-51.1-109-112.1-109-60.8 0-112.1 48.2-112.1 108.2v162.4c0 14.9-12 26.7-26.7 26.7S86 349.5 86 334.6V266H0v69.7C0 397.7 50.3 448 112.4 448c61.6 0 112.4-49.5 112.4-110.8V176.9c0-14.7 12-26.7 26.7-26.7s26.7 12 26.7 26.7v30.9z"
        ],
        "stumbleupon-circle": [
            496,
            512,
            [],
            "f1a3",
            "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm0 177.5c-9.8 0-17.8 8-17.8 17.8v106.9c0 40.9-33.9 73.9-74.9 73.9-41.4 0-74.9-33.5-74.9-74.9v-46.5h57.3v45.8c0 10 8 17.8 17.8 17.8s17.8-7.9 17.8-17.8V200.1c0-40 34.2-72.1 74.7-72.1 40.7 0 74.7 32.3 74.7 72.6v23.7l-34.1 10.1-22.9-10.7v-20.6c.1-9.6-7.9-17.6-17.7-17.6zm167.6 123.6c0 41.4-33.5 74.9-74.9 74.9-41.2 0-74.9-33.2-74.9-74.2V263l22.9 10.7 34.1-10.1v47.1c0 9.8 8 17.6 17.8 17.6s17.8-7.9 17.8-17.6v-48h57.3c-.1 45.9-.1 46.4-.1 46.4z"
        ],
        "superpowers": [
            448,
            512,
            [],
            "f2dd",
            "M448 32c-83.3 11-166.8 22-250 33-92 12.5-163.3 86.7-169 180-3.3 55.5 18 109.5 57.8 148.2L0 480c83.3-11 166.5-22 249.8-33 91.8-12.5 163.3-86.8 168.7-179.8 3.5-55.5-18-109.5-57.7-148.2L448 32zm-79.7 232.3c-4.2 79.5-74 139.2-152.8 134.5-79.5-4.7-140.7-71-136.3-151 4.5-79.2 74.3-139.3 153-134.5 79.3 4.7 140.5 71 136.1 151z"
        ],
        "supple": [
            640,
            512,
            [],
            "f3f9",
            "M640 262.5c0 64.1-109 116.1-243.5 116.1-24.8 0-48.6-1.8-71.1-5 7.7.4 15.5.6 23.4.6 134.5 0 243.5-56.9 243.5-127.1 0-29.4-19.1-56.4-51.2-78 60 21.1 98.9 55.1 98.9 93.4zM47.7 227.9c-.1-70.2 108.8-127.3 243.3-127.6 7.9 0 15.6.2 23.3.5-22.5-3.2-46.3-4.9-71-4.9C108.8 96.3-.1 148.5 0 212.6c.1 38.3 39.1 72.3 99.3 93.3-32.3-21.5-51.5-48.6-51.6-78zm60.2 39.9s10.5 13.2 29.3 13.2c17.9 0 28.4-11.5 28.4-25.1 0-28-40.2-25.1-40.2-39.7 0-5.4 5.3-9.1 12.5-9.1 5.7 0 11.3 2.6 11.3 6.6v3.9h14.2v-7.9c0-12.1-15.4-16.8-25.4-16.8-16.5 0-28.5 10.2-28.5 24.1 0 26.6 40.2 25.4 40.2 39.9 0 6.6-5.8 10.1-12.3 10.1-11.9 0-20.7-10.1-20.7-10.1l-8.8 10.9zm120.8-73.6v54.4c0 11.3-7.1 17.8-17.8 17.8-10.7 0-17.8-6.5-17.8-17.7v-54.5h-15.8v55c0 18.9 13.4 31.9 33.7 31.9 20.1 0 33.4-13 33.4-31.9v-55h-15.7zm34.4 85.4h15.8v-29.5h15.5c16 0 27.2-11.5 27.2-28.1s-11.2-27.8-27.2-27.8h-39.1v13.4h7.8v72zm15.8-43v-29.1h12.9c8.7 0 13.7 5.7 13.7 14.4 0 8.9-5.1 14.7-14 14.7h-12.6zm57 43h15.8v-29.5h15.5c16 0 27.2-11.5 27.2-28.1s-11.2-27.8-27.2-27.8h-39.1v13.4h7.8v72zm15.7-43v-29.1h12.9c8.7 0 13.7 5.7 13.7 14.4 0 8.9-5 14.7-14 14.7h-12.6zm57.1 34.8c0 5.8 2.4 8.2 8.2 8.2h37.6c5.8 0 8.2-2.4 8.2-8.2v-13h-14.3v5.2c0 1.7-1 2.6-2.6 2.6h-18.6c-1.7 0-2.6-1-2.6-2.6v-61.2c0-5.7-2.4-8.2-8.2-8.2H401v13.4h5.2c1.7 0 2.6 1 2.6 2.6v61.2zm63.4 0c0 5.8 2.4 8.2 8.2 8.2H519c5.7 0 8.2-2.4 8.2-8.2v-13h-14.3v5.2c0 1.7-1 2.6-2.6 2.6h-19.7c-1.7 0-2.6-1-2.6-2.6v-20.3h27.7v-13.4H488v-22.4h19.2c1.7 0 2.6 1 2.6 2.6v5.2H524v-13c0-5.7-2.5-8.2-8.2-8.2h-51.6v13.4h7.8v63.9zm58.9-76v5.9h1.6v-5.9h2.7v-1.2h-7v1.2h2.7zm5.7-1.2v7.1h1.5v-5.7l2.3 5.7h1.3l2.3-5.7v5.7h1.5v-7.1h-2.3l-2.1 5.1-2.1-5.1h-2.4z"
        ],
        "suse": [
            640,
            512,
            [],
            "f7d6",
            "M471.08 102.66s-.3 18.3-.3 20.3c-9.1-3-74.4-24.1-135.7-26.3-51.9-1.8-122.8-4.3-223 57.3-19.4 12.4-73.9 46.1-99.6 109.7C7 277-.12 307 7 335.06a111 111 0 0 0 16.5 35.7c17.4 25 46.6 41.6 78.1 44.4 44.4 3.9 78.1-16 90-53.3 8.2-25.8 0-63.6-31.5-82.9-25.6-15.7-53.3-12.1-69.2-1.6-13.9 9.2-21.8 23.5-21.6 39.2.3 27.8 24.3 42.6 41.5 42.6a49 49 0 0 0 15.8-2.7c6.5-1.8 13.3-6.5 13.3-14.9 0-12.1-11.6-14.8-16.8-13.9-2.9.5-4.5 2-11.8 2.4-2-.2-12-3.1-12-14V316c.2-12.3 13.2-18 25.5-16.9 32.3 2.8 47.7 40.7 28.5 65.7-18.3 23.7-76.6 23.2-99.7-20.4-26-49.2 12.7-111.2 87-98.4 33.2 5.7 83.6 35.5 102.4 104.3h45.9c-5.7-17.6-8.9-68.3 42.7-68.3 56.7 0 63.9 39.9 79.8 68.3H460c-12.8-18.3-21.7-38.7-18.9-55.8 5.6-33.8 39.7-18.4 82.4-17.4 66.5.4 102.1-27 103.1-28 3.7-3.1 6.5-15.8 7-17.7 1.3-5.1-3.2-2.4-3.2-2.4-8.7 5.2-30.5 15.2-50.9 15.6-25.3.5-76.2-25.4-81.6-28.2-.3-.4.1 1.2-11-25.5 88.4 58.3 118.3 40.5 145.2 21.7.8-.6 4.3-2.9 3.6-5.7-13.8-48.1-22.4-62.7-34.5-69.6-37-21.6-125-34.7-129.2-35.3.1-.1-.9-.3-.9.7zm60.4 72.8a37.54 37.54 0 0 1 38.9-36.3c33.4 1.2 48.8 42.3 24.4 65.2-24.2 22.7-64.4 4.6-63.3-28.9zm38.6-25.3a26.27 26.27 0 1 0 25.4 27.2 26.19 26.19 0 0 0-25.4-27.2zm4.3 28.8c-15.4 0-15.4-15.6 0-15.6s15.4 15.64 0 15.64z"
        ],
        "swift": [
            448,
            512,
            [],
            "f8e1",
            "M448 156.09c0-4.51-.08-9-.2-13.52a196.31 196.31 0 0 0-2.58-29.42 99.62 99.62 0 0 0-9.22-28A94.08 94.08 0 0 0 394.84 44a99.17 99.17 0 0 0-28-9.22 195 195 0 0 0-29.43-2.59c-4.51-.12-9-.17-13.52-.2H124.14c-4.51 0-9 .08-13.52.2-2.45.07-4.91.15-7.37.27a171.68 171.68 0 0 0-22.06 2.32 103.06 103.06 0 0 0-21.21 6.1q-3.46 1.45-6.81 3.12a94.66 94.66 0 0 0-18.39 12.32c-1.88 1.61-3.69 3.28-5.43 5A93.86 93.86 0 0 0 12 85.17a99.45 99.45 0 0 0-9.22 28 196.31 196.31 0 0 0-2.54 29.4c-.13 4.51-.18 9-.21 13.52v199.83c0 4.51.08 9 .21 13.51a196.08 196.08 0 0 0 2.58 29.42 99.3 99.3 0 0 0 9.22 28A94.31 94.31 0 0 0 53.17 468a99.47 99.47 0 0 0 28 9.21 195 195 0 0 0 29.43 2.59c4.5.12 9 .17 13.52.2H323.91c4.51 0 9-.08 13.52-.2a196.59 196.59 0 0 0 29.44-2.59 99.57 99.57 0 0 0 28-9.21A94.22 94.22 0 0 0 436 426.84a99.3 99.3 0 0 0 9.22-28 194.79 194.79 0 0 0 2.59-29.42c.12-4.5.17-9 .2-13.51V172.14c-.01-5.35-.01-10.7-.01-16.05zm-69.88 241c-20-38.93-57.23-29.27-76.31-19.47-1.72 1-3.48 2-5.25 3l-.42.25c-39.5 21-92.53 22.54-145.85-.38A234.64 234.64 0 0 1 45 290.12a230.63 230.63 0 0 0 39.17 23.37c56.36 26.4 113 24.49 153 0-57-43.85-104.6-101-141.09-147.22a197.09 197.09 0 0 1-18.78-25.9c43.7 40 112.7 90.22 137.48 104.12-52.57-55.49-98.89-123.94-96.72-121.74 82.79 83.42 159.18 130.59 159.18 130.59 2.88 1.58 5 2.85 6.73 4a127.44 127.44 0 0 0 4.16-12.47c13.22-48.33-1.66-103.58-35.31-149.2C329.61 141.75 375 229.34 356.4 303.42c-.44 1.73-.95 3.4-1.44 5.09 38.52 47.4 28.04 98.17 23.13 88.59z"
        ],
        "symfony": [
            512,
            512,
            [],
            "f83d",
            "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm133.74 143.54c-11.47.41-19.4-6.45-19.77-16.87-.27-9.18 6.68-13.44 6.53-18.85-.23-6.55-10.16-6.82-12.87-6.67-39.78 1.29-48.59 57-58.89 113.85 21.43 3.15 36.65-.72 45.14-6.22 12-7.75-3.34-15.72-1.42-24.56 4-18.16 32.55-19 32 5.3-.36 17.86-25.92 41.81-77.6 35.7-10.76 59.52-18.35 115-58.2 161.72-29 34.46-58.4 39.82-71.58 40.26-24.65.85-41-12.31-41.58-29.84-.56-17 14.45-26.26 24.31-26.59 21.89-.75 30.12 25.67 14.88 34-12.09 9.71.11 12.61 2.05 12.55 10.42-.36 17.34-5.51 22.18-9 24-20 33.24-54.86 45.35-118.35 8.19-49.66 17-78 18.23-82-16.93-12.75-27.08-28.55-49.85-34.72-15.61-4.23-25.12-.63-31.81 7.83-7.92 10-5.29 23 2.37 30.7l12.63 14c15.51 17.93 24 31.87 20.8 50.62-5.06 29.93-40.72 52.9-82.88 39.94-36-11.11-42.7-36.56-38.38-50.62 7.51-24.15 42.36-11.72 34.62 13.6-2.79 8.6-4.92 8.68-6.28 13.07-4.56 14.77 41.85 28.4 51-1.39 4.47-14.52-5.3-21.71-22.25-39.85-28.47-31.75-16-65.49 2.95-79.67C204.23 140.13 251.94 197 262 205.29c37.17-109 100.53-105.46 102.43-105.53 25.16-.81 44.19 10.59 44.83 28.65.25 7.69-4.17 22.59-19.52 23.13z"
        ],
        "teamspeak": [
            512,
            512,
            [],
            "f4f9",
            "M244.2 346.79c2.4-12.3-12-30-32.4-48.7-20.9-19.2-48.2-39.1-63.4-46.6-21.7-12-41.7-1.8-46.3 22.7-5 26.2 0 51.4 14.5 73.9 10.2 15.5 25.4 22.7 43.4 24 11.6.6 52.5 2.2 61.7-1 11.9-4.3 20.1-11.8 22.5-24.3zm205 20.8a5.22 5.22 0 0 0-8.3 2.4c-8 25.4-44.7 112.5-172.1 121.5-149.7 10.5 80.3 43.6 145.4-6.4 22.7-17.4 47.6-35 46.6-85.4-.4-10.1-4.9-26.69-11.6-32.1zm62-122.4c-.3-18.9-8.6-33.4-26-42.2-2.9-1.3-5-2.7-5.9-6.4A222.64 222.64 0 0 0 438.9 103c-1.1-1.5-3.5-3.2-2.2-5 8.5-11.5-.3-18-7-24.4Q321.4-31.11 177.4 13.09c-40.1 12.3-73.9 35.6-102 67.4-4 4.3-6.7 9.1-3 14.5 3 4 1.3 6.2-1 9.3C51.6 132 38.2 162.59 32.1 196c-.7 4.3-2.9 6-6.4 7.8-14.2 7-22.5 18.5-24.9 34L0 264.29v20.9c0 30.8 21 50.4 51.8 49 7.7-.3 11.7-4.3 12-11.5 2-77.5-2.4-95.4 3.7-125.8C92.1 72.39 234.3 5 345.3 65.39 411.4 102 445.7 159 447.6 234.79c.8 28.2 0 56.5 0 84.6 0 7 2.2 12.5 9.4 14.2 24.1 5 49.2-12 53.2-36.7 2.9-17.1 1-34.5 1-51.7zm-159.6 131.5c36.5 2.8 59.3-28.5 58.4-60.5-2.1-45.2-66.2-16.5-87.8-8-73.2 28.1-45 54.9-22.2 60.8z"
        ],
        "telegram": [
            496,
            512,
            [],
            "f2c6",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm121.8 169.9l-40.7 191.8c-3 13.6-11.1 16.9-22.4 10.5l-62-45.7-29.9 28.8c-3.3 3.3-6.1 6.1-12.5 6.1l4.4-63.1 114.9-103.8c5-4.4-1.1-6.9-7.7-2.5l-142 89.4-61.2-19.1c-13.3-4.2-13.6-13.3 2.8-19.7l239.1-92.2c11.1-4 20.8 2.7 17.2 19.5z"
        ],
        "telegram-plane": [
            448,
            512,
            [],
            "f3fe",
            "M446.7 98.6l-67.6 318.8c-5.1 22.5-18.4 28.1-37.3 17.5l-103-75.9-49.7 47.8c-5.5 5.5-10.1 10.1-20.7 10.1l7.4-104.9 190.9-172.5c8.3-7.4-1.8-11.5-12.9-4.1L117.8 284 16.2 252.2c-22.1-6.9-22.5-22.1 4.6-32.7L418.2 66.4c18.4-6.9 34.5 4.1 28.5 32.2z"
        ],
        "tencent-weibo": [
            384,
            512,
            [],
            "f1d5",
            "M72.3 495.8c1.4 19.9-27.6 22.2-29.7 2.9C31 368.8 73.7 259.2 144 185.5c-15.6-34 9.2-77.1 50.6-77.1 30.3 0 55.1 24.6 55.1 55.1 0 44-49.5 70.8-86.9 45.1-65.7 71.3-101.4 169.8-90.5 287.2zM192 .1C66.1.1-12.3 134.3 43.7 242.4 52.4 259.8 79 246.9 70 229 23.7 136.4 91 29.8 192 29.8c75.4 0 136.9 61.4 136.9 136.9 0 90.8-86.9 153.9-167.7 133.1-19.1-4.1-25.6 24.4-6.6 29.1 110.7 23.2 204-60 204-162.3C358.6 74.7 284 .1 192 .1z"
        ],
        "the-red-yeti": [
            512,
            512,
            [],
            "f69d",
            "M488.23 241.7l20.7 7.1c-9.6-23.9-23.9-37-31.7-44.8l7.1-18.2c.2 0 12.3-27.8-2.5-30.7-.6-11.3-6.6-27-18.4-27-7.6-10.6-17.7-12.3-30.7-5.9a122.2 122.2 0 0 0-25.3 16.5c-5.3-6.4-3 .4-3-29.8-37.1-24.3-45.4-11.7-74.8 3l.5.5a239.36 239.36 0 0 0-68.4-13.3c-5.5-8.7-18.6-19.1-25.1-25.1l24.8 7.1c-5.5-5.5-26.8-12.9-34.2-15.2 18.2-4.1 29.8-20.8 42.5-33-34.9-10.1-67.9-5.9-97.9 11.8l12-44.2L182 0c-31.6 24.2-33 41.9-33.7 45.5-.9-2.4-6.3-19.6-15.2-27a35.12 35.12 0 0 0-.5 25.3c3 8.4 5.9 14.8 8.4 18.9-16-3.3-28.3-4.9-49.2 0h-3.7l33 14.3a194.26 194.26 0 0 0-46.7 67.4l-1.7 8.4 1.7 1.7 7.6-4.7c-3.3 11.6-5.3 19.4-6.6 25.8a200.18 200.18 0 0 0-27.8 40.3c-15 1-31.8 10.8-40.3 14.3l3 3.4 28.8 1c-.5 1-.7 2.2-1.2 3.2-7.3 6.4-39.8 37.7-33 80.7l20.2-22.4c.5 1.7.7 3.4 1.2 5.2 0 25.5.4 89.6 64.9 150.5 43.6 40 96 60.2 157.5 60.2 121.7 0 223-87.3 223-211.5 6.8-9.7-1.2 3 16.7-25.1l13 14.3 2.5-.5A181.84 181.84 0 0 0 495 255a44.74 44.74 0 0 0-6.8-13.3zM398 111.2l-.5 21.9c5.5 18.1 16.9 17.2 22.4 17.2l-3.4-4.7 22.4-5.4a242.44 242.44 0 0 1-27 0c12.8-2.1 33.3-29 43-11.3 3.4 7.6 6.4 17.2 9.3 27.8l1.7-5.9a56.38 56.38 0 0 1-1.7-15.2c5.4.5 8.8 3.4 9.3 10.1.5 6.4 1.7 14.8 3.4 25.3l4.7-11.3c4.6 0 4.5-3.6-2.5 20.7-20.9-8.7-35.1-8.4-46.5-8.4l18.2-16c-25.3 8.2-33 10.8-54.8 20.9-1.1-5.4-5-13.5-16-19.9-3.2 3.8-2.8.9-.7 14.8h-2.5a62.32 62.32 0 0 0-8.4-23.1l4.2-3.4c8.4-7.1 11.8-14.3 10.6-21.9-.5-6.4-5.4-13.5-13.5-20.7 5.6-3.4 15.2-.4 28.3 8.5zm-39.6-10.1c2.7 1.9 11.4 5.4 18.9 17.2 4.2 8.4 4 9.8 3.4 11.1-.5 2.4-.5 4.3-3 7.1-1.7 2.5-5.4 4.7-11.8 7.6-7.6-13-16.5-23.6-27.8-31.2zM91 143.1l1.2-1.7c1.2-2.9 4.2-7.6 9.3-15.2l2.5-3.4-13 12.3 5.4-4.7-10.1 9.3-4.2 1.2c12.3-24.1 23.1-41.3 32.5-50.2 9.3-9.3 16-16 20.2-19.4l-6.4 1.2c-11.3-4.2-19.4-7.1-24.8-8.4 2.5-.5 3.7-.5 3.2-.5 10.3 0 17.5.5 20.9 1.2a52.35 52.35 0 0 0 16 2.5l.5-1.7-8.4-35.8 13.5 29a42.89 42.89 0 0 0 5.9-14.3c1.7-6.4 5.4-13 10.1-19.4s7.6-10.6 9.3-11.3a234.68 234.68 0 0 0-6.4 25.3l-1.7 7.1-.5 4.7 2.5 2.5C190.4 39.9 214 34 239.8 34.5l21.1.5c-11.8 13.5-27.8 21.9-48.5 24.8a201.26 201.26 0 0 1-23.4 2.9l-.2-.5-2.5-1.2a20.75 20.75 0 0 0-14 2c-2.5-.2-4.9-.5-7.1-.7l-2.5 1.7.5 1.2c2 .2 3.9.5 6.2.7l-2 3.4 3.4-.5-10.6 11.3c-4.2 3-5.4 6.4-4.2 9.3l5.4-3.4h1.2a39.4 39.4 0 0 1 25.3-15.2v-3c6.4.5 13 1 19.4 1.2 6.4 0 8.4.5 5.4 1.2a189.6 189.6 0 0 1 20.7 13.5c13.5 10.1 23.6 21.9 30 35.4 8.8 18.2 13.5 37.1 13.5 56.6a141.13 141.13 0 0 1-3 28.3 209.91 209.91 0 0 1-16 46l2.5.5c18.2-19.7 41.9-16 49.2-16l-6.4 5.9 22.4 17.7-1.7 30.7c-5.4-12.3-16.5-21.1-33-27.8 16.5 14.8 23.6 21.1 21.9 20.2-4.8-2.8-3.5-1.9-10.8-3.7 4.1 4.1 17.5 18.8 18.2 20.7l.2.2-.2.2c0 1.8 1.6-1.2-14 22.9-75.2-15.3-106.27-42.7-141.2-63.2l11.8 1.2c-11.8-18.5-15.6-17.7-38.4-26.1L149 225c-8.8-3-18.2-3-28.3.5l7.6-10.6-1.2-1.7c-14.9 4.3-19.8 9.2-22.6 11.3-1.1-5.5-2.8-12.4-12.3-28.8l-1.2 27-13.2-5c1.5-25.2 5.4-50.5 13.2-74.6zm276.5 330c-49.9 25-56.1 22.4-59 23.9-29.8-11.8-50.9-31.7-63.5-58.8l30 16.5c-9.8-9.3-18.3-16.5-38.4-44.3l11.8 23.1-17.7-7.6c14.2 21.1 23.5 51.7 66.6 73.5-120.8 24.2-199-72.1-200.9-74.3a262.57 262.57 0 0 0 35.4 24.8c3.4 1.7 7.1 2.5 10.1 1.2l-16-20.7c9.2 4.2 9.5 4.5 69.1 29-42.5-20.7-73.8-40.8-93.2-60.2-.5 6.4-1.2 10.1-1.2 10.1a80.25 80.25 0 0 1 20.7 26.6c-39-18.9-57.6-47.6-71.3-82.6 49.9 55.1 118.9 37.5 120.5 37.1 34.8 16.4 69.9 23.6 113.9 10.6 3.3 0 20.3 17 25.3 39.1l4.2-3-2.5-23.6c9 9 24.9 22.6 34.4 13-15.6-5.3-23.5-9.5-29.5-31.7 4.6 4.2 7.6 9 27.8 15l1.2-1.2-10.5-14.2c11.7-4.8-3.5 1 32-10.8 4.3 34.3 9 49.2.7 89.5zm115.3-214.4l-2.5.5 3 9.3c-3.5 5.9-23.7 44.3-71.6 79.7-39.5 29.8-76.6 39.1-80.9 40.3l-7.6-7.1-1.2 3 14.3 16-7.1-4.7 3.4 4.2h-1.2l-21.9-13.5 9.3 26.6-19-27.9-1.2 2.5 7.6 29c-6.1-8.2-21-32.6-56.8-39.6l32.5 21.2a214.82 214.82 0 0 1-93.2-6.4c-4.2-1.2-8.9-2.5-13.5-4.2l1.2-3-44.8-22.4 26.1 22.4c-57.7 9.1-113-25.4-126.4-83.4l-2.5-16.4-22.27 22.3c19.5-57.5 25.6-57.9 51.4-70.1-9.1-5.3-1.6-3.3-38.4-9.3 15.8-5.8 33-15.4 73 5.2a18.5 18.5 0 0 1 3.7-1.7c.6-3.2.4-.8 1-11.8 3.9 10 3.6 8.7 3 9.3l1.7.5c12.7-6.5 8.9-4.5 17-8.9l-5.4 13.5 22.3-5.8-8.4 8.4 2.5 2.5c4.5-1.8 30.3 3.4 40.8 16l-23.6-2.5c39.4 23 51.5 54 55.8 69.6l1.7-1.2c-2.8-22.3-12.4-33.9-16-40.1 4.2 5 39.2 34.6 110.4 46-11.3-.5-23.1 5.4-34.9 18.9l46.7-20.2-9.3 21.9c7.6-10.1 14.8-23.6 21.2-39.6v-.5l1.2-3-1.2 16c13.5-41.8 25.3-78.5 35.4-109.7l13.5-27.8v-2l-5.4-4.2h10.1l5.9 4.2 2.5-1.2-3.4-16 12.3 18.9 41.8-20.2-14.8 13 .5 2.9 17.7-.5a184 184 0 0 1 33 4.2l-23.6 2.5-1.2 3 26.6 23.1a254.21 254.21 0 0 1 27 32c-11.2-3.3-10.3-3.4-21.2-3.4l12.3 32.5zm-6.1-71.3l-3.9 13-14.3-11.8zm-254.8 7.1c1.7 10.6 4.7 17.7 8.8 21.9-9.3 6.6-27.5 13.9-46.5 16l.5 1.2a50.22 50.22 0 0 0 24.8-2.5l-7.1 13c4.2-1.7 10.1-7.1 17.7-14.8 11.9-5.5 12.7-5.1 20.2-16-12.7-6.4-15.7-13.7-18.4-18.8zm3.7-102.3c-6.4-3.4-10.6 3-12.3 18.9s2.5 29.5 11.8 39.6 18.2 10.6 26.1 3 3.4-23.6-11.3-47.7a39.57 39.57 0 0 0-14.27-13.8zm-4.7 46.3c5.4 2.2 10.5 1.9 12.3-10.6v-4.7l-1.2.5c-4.3-3.1-2.5-4.5-1.7-6.2l.5-.5c-.9-1.2-5-8.1-12.5 4.7-.5-13.5.5-21.9 3-24.8 1.2-2.5 4.7-1.2 11.3 4.2 6.4 5.4 11.3 16 15.2 32.5 6.5 28-19.8 26.2-26.9 4.9zm-45-5.5c1.6.3 9.3-1.1 9.3-14.8h-.5c-5.4-1.1-2.2-5.5-.7-5.9-1.7-3-3.4-4.2-5.4-4.7-8.1 0-11.6 12.7-8.1 21.2a7.51 7.51 0 0 0 5.43 4.2zM216 82.9l-2.5.5.5 3a48.94 48.94 0 0 1 26.1 5.9c-2.5-5.5-10-14.3-28.3-14.3l.5 2.5zm-71.8 49.4c21.7 16.8 16.5 21.4 46.5 23.6l-2.9-4.7a42.67 42.67 0 0 0 14.8-28.3c1.7-16-1.2-29.5-8.8-41.3l13-7.6a2.26 2.26 0 0 0-.5-1.7 14.21 14.21 0 0 0-13.5 1.7c-12.7 6.7-28 20.9-29 22.4-1.7 1.7-3.4 5.9-5.4 13.5a99.61 99.61 0 0 0-2.9 23.6c-4.7-8-10.5-6.4-19.9-5.9l7.1 7.6c-16.5 0-23.3 15.4-23.6 16 6.8 0 4.6-7.6 30-12.3-4.3-6.3-3.3-5-4.9-6.6zm18.7-18.7c1.2-7.6 3.4-13 6.4-17.2 5.4-6.4 10.6-10.1 16-11.8 4.2-1.7 7.1 1.2 10.1 9.3a72.14 72.14 0 0 1 3 25.3c-.5 9.3-3.4 17.2-8.4 23.1-2.9 3.4-5.4 5.9-6.4 7.6a39.21 39.21 0 0 1-11.3-.5l-7.1-3.4-5.4-6.4c.8-10 1.3-18.8 3.1-26zm42 56.1c-34.8 14.4-34.7 14-36.1 14.3-20.8 4.7-19-24.4-18.9-24.8l5.9-1.2-.5-2.5c-20.2-2.6-31 4.2-32.5 4.9.5.5 3 3.4 5.9 9.3 4.2-6.4 8.8-10.1 15.2-10.6a83.47 83.47 0 0 0 1.7 33.7c.1.5 2.6 17.4 27.5 24.1 11.3 3 27 1.2 48.9-5.4l-9.2.5c-4.2-14.8-6.4-24.8-5.9-29.5 11.3-8.8 21.9-11.3 30.7-7.6h2.5l-11.8-7.6-7.1.5c-5.9 1.2-12.3 4.2-19.4 8.4z"
        ],
        "themeco": [
            448,
            512,
            [],
            "f5c6",
            "M202.9 8.43c9.9-5.73 26-5.82 35.95-.21L430 115.85c10 5.6 18 19.44 18 30.86V364c0 11.44-8.06 25.29-18 31L238.81 503.74c-9.93 5.66-26 5.57-35.85-.21L17.86 395.12C8 389.34 0 375.38 0 364V146.71c0-11.44 8-25.36 17.91-31.08zm-77.4 199.83c-15.94 0-31.89.14-47.83.14v101.45H96.8V280h28.7c49.71 0 49.56-71.74 0-71.74zm140.14 100.29l-30.73-34.64c37-7.51 34.8-65.23-10.87-65.51-16.09 0-32.17-.14-48.26-.14v101.59h19.13v-33.91h18.41l29.56 33.91h22.76zm-41.59-82.32c23.34 0 23.26 32.46 0 32.46h-29.13v-32.46zm-95.56-1.6c21.18 0 21.11 38.85 0 38.85H96.18v-38.84zm192.65-18.25c-68.46 0-71 105.8 0 105.8 69.48-.01 69.41-105.8 0-105.8zm0 17.39c44.12 0 44.8 70.86 0 70.86s-44.43-70.86 0-70.86z"
        ],
        "themeisle": [
            512,
            512,
            [],
            "f2b2",
            "M208 88.286c0-10 6.286-21.714 17.715-21.714 11.142 0 17.714 11.714 17.714 21.714 0 10.285-6.572 21.714-17.714 21.714C214.286 110 208 98.571 208 88.286zm304 160c0 36.001-11.429 102.286-36.286 129.714-22.858 24.858-87.428 61.143-120.857 70.572l-1.143.286v32.571c0 16.286-12.572 30.571-29.143 30.571-10 0-19.429-5.714-24.572-14.286-5.427 8.572-14.856 14.286-24.856 14.286-10 0-19.429-5.714-24.858-14.286-5.142 8.572-14.571 14.286-24.57 14.286-10.286 0-19.429-5.714-24.858-14.286-5.143 8.572-14.571 14.286-24.571 14.286-18.857 0-29.429-15.714-29.429-32.857-16.286 12.285-35.715 19.428-56.571 19.428-22 0-43.429-8.285-60.286-22.857 10.285-.286 20.571-2.286 30.285-5.714-20.857-5.714-39.428-18.857-52-36.286 21.37 4.645 46.209 1.673 67.143-11.143-22-22-56.571-58.857-68.572-87.428C1.143 321.714 0 303.714 0 289.429c0-49.714 20.286-160 86.286-160 10.571 0 18.857 4.858 23.143 14.857a158.792 158.792 0 0 1 12-15.428c2-2.572 5.714-5.429 7.143-8.286 7.999-12.571 11.714-21.142 21.714-34C182.571 45.428 232 17.143 285.143 17.143c6 0 12 .285 17.714 1.143C313.714 6.571 328.857 0 344.572 0c14.571 0 29.714 6 40 16.286.857.858 1.428 2.286 1.428 3.428 0 3.714-10.285 13.429-12.857 16.286 4.286 1.429 15.714 6.858 15.714 12 0 2.857-2.857 5.143-4.571 7.143 31.429 27.714 49.429 67.143 56.286 108 4.286-5.143 10.285-8.572 17.143-8.572 10.571 0 20.857 7.144 28.571 14.001C507.143 187.143 512 221.714 512 248.286zM188 89.428c0 18.286 12.571 37.143 32.286 37.143 19.714 0 32.285-18.857 32.285-37.143 0-18-12.571-36.857-32.285-36.857-19.715 0-32.286 18.858-32.286 36.857zM237.714 194c0-19.714 3.714-39.143 8.571-58.286-52.039 79.534-13.531 184.571 68.858 184.571 21.428 0 42.571-7.714 60-20 2-7.429 3.714-14.857 3.714-22.572 0-14.286-6.286-21.428-20.572-21.428-4.571 0-9.143.857-13.429 1.714-63.343 12.668-107.142 3.669-107.142-63.999zm-41.142 254.858c0-11.143-8.858-20.857-20.286-20.857-11.429 0-20 9.715-20 20.857v32.571c0 11.143 8.571 21.142 20 21.142 11.428 0 20.286-9.715 20.286-21.142v-32.571zm49.143 0c0-11.143-8.572-20.857-20-20.857-11.429 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.857 21.142 20.286 21.142 11.428 0 20-10 20-21.142v-32.571zm49.713 0c0-11.143-8.857-20.857-20.285-20.857-11.429 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.857 21.142 20.286 21.142 11.428 0 20.285-9.715 20.285-21.142v-32.571zm49.715 0c0-11.143-8.857-20.857-20.286-20.857-11.428 0-20.286 9.715-20.286 20.857v32.571c0 11.143 8.858 21.142 20.286 21.142 11.429 0 20.286-10 20.286-21.142v-32.571zM421.714 286c-30.857 59.142-90.285 102.572-158.571 102.572-96.571 0-160.571-84.572-160.571-176.572 0-16.857 2-33.429 6-49.714-20 33.715-29.714 72.572-29.714 111.429 0 60.286 24.857 121.715 71.429 160.857 5.143-9.714 14.857-16.286 26-16.286 10 0 19.428 5.714 24.571 14.286 5.429-8.571 14.571-14.286 24.858-14.286 10 0 19.428 5.714 24.571 14.286 5.429-8.571 14.857-14.286 24.858-14.286 10 0 19.428 5.714 24.857 14.286 5.143-8.571 14.571-14.286 24.572-14.286 10.857 0 20.857 6.572 25.714 16 43.427-36.286 68.569-92 71.426-148.286zm10.572-99.714c0-53.714-34.571-105.714-92.572-105.714-30.285 0-58.571 15.143-78.857 36.857C240.862 183.812 233.41 254 302.286 254c28.805 0 97.357-28.538 84.286 36.857 28.857-26 45.714-65.714 45.714-104.571z"
        ],
        "think-peaks": [
            576,
            512,
            [],
            "f731",
            "M465.4 409.4l87.1-150.2-32-.3-55.1 95L259.2 0 23 407.4l32 .3L259.2 55.6zm-355.3-44.1h32.1l117.4-202.5L463 511.9l32.5.1-235.8-404.6z"
        ],
        "tiktok": [
            448,
            512,
            [],
            "e07b",
            "M448,209.91a210.06,210.06,0,0,1-122.77-39.25V349.38A162.55,162.55,0,1,1,185,188.31V278.2a74.62,74.62,0,1,0,52.23,71.18V0l88,0a121.18,121.18,0,0,0,1.86,22.17h0A122.18,122.18,0,0,0,381,102.39a121.43,121.43,0,0,0,67,20.14Z"
        ],
        "trade-federation": [
            496,
            512,
            [],
            "f513",
            "M248 8.8c-137 0-248 111-248 248s111 248 248 248 248-111 248-248-111-248-248-248zm0 482.8c-129.7 0-234.8-105.1-234.8-234.8S118.3 22 248 22s234.8 105.1 234.8 234.8S377.7 491.6 248 491.6zm155.1-328.5v-46.8H209.3V198H54.2l36.7 46h117.7v196.8h48.8V245h83.3v-47h-83.3v-34.8h145.7zm-73.3 45.1v23.9h-82.9v197.4h-26.8V232.1H96.3l-20.1-23.9h143.9v-80.6h171.8V152h-145v56.2zm-161.3-69l-12.4-20.7 2.1 23.8-23.5 5.4 23.3 5.4-2.1 24 12.3-20.5 22.2 9.5-15.7-18.1 15.8-18.1zm-29.6-19.7l9.3-11.5-12.7 5.9-8-12.4 1.7 13.9-14.3 3.8 13.7 2.7-.8 14.7 6.8-12.2 13.8 5.3zm165.4 145.2l-13.1 5.6-7.3-12.2 1.3 14.2-13.9 3.2 13.9 3.2-1.2 14.2 7.3-12.2 13.1 5.5-9.4-10.7zm106.9-77.2l-20.9 9.1-12-19.6 2.2 22.7-22.3 5.4 22.2 4.9-1.8 22.9 11.5-19.6 21.2 8.8-15.1-17zM248 29.9c-125.3 0-226.9 101.6-226.9 226.9S122.7 483.7 248 483.7s226.9-101.6 226.9-226.9S373.3 29.9 248 29.9zM342.6 196v51h-83.3v195.7h-52.7V245.9H89.9l-40-49.9h157.4v-81.6h197.8v50.7H259.4V196zM248 43.2c60.3 0 114.8 25 153.6 65.2H202.5V190H45.1C73.1 104.8 153.4 43.2 248 43.2zm0 427.1c-117.9 0-213.6-95.6-213.6-213.5 0-21.2 3.1-41.8 8.9-61.1L87.1 252h114.7v196.8h64.6V253h83.3v-62.7h-83.2v-19.2h145.6v-50.8c30.8 37 49.3 84.6 49.3 136.5.1 117.9-95.5 213.5-213.4 213.5zM178.8 275l-11-21.4 1.7 24.5-23.7 3.9 23.8 5.9-3.7 23.8 13-20.9 21.5 10.8-15.8-18.8 16.9-17.1z"
        ],
        "trello": [
            448,
            512,
            [],
            "f181",
            "M392.3 32H56.1C25.1 32 0 57.1 0 88c-.1 0 0-4 0 336 0 30.9 25.1 56 56 56h336.2c30.8-.2 55.7-25.2 55.7-56V88c.1-30.8-24.8-55.8-55.6-56zM197 371.3c-.2 14.7-12.1 26.6-26.9 26.6H87.4c-14.8.1-26.9-11.8-27-26.6V117.1c0-14.8 12-26.9 26.9-26.9h82.9c14.8 0 26.9 12 26.9 26.9v254.2zm193.1-112c0 14.8-12 26.9-26.9 26.9h-81c-14.8 0-26.9-12-26.9-26.9V117.2c0-14.8 12-26.9 26.8-26.9h81.1c14.8 0 26.9 12 26.9 26.9v142.1z"
        ],
        "tumblr": [
            320,
            512,
            [],
            "f173",
            "M309.8 480.3c-13.6 14.5-50 31.7-97.4 31.7-120.8 0-147-88.8-147-140.6v-144H17.9c-5.5 0-10-4.5-10-10v-68c0-7.2 4.5-13.6 11.3-16 62-21.8 81.5-76 84.3-117.1.8-11 6.5-16.3 16.1-16.3h70.9c5.5 0 10 4.5 10 10v115.2h83c5.5 0 10 4.4 10 9.9v81.7c0 5.5-4.5 10-10 10h-83.4V360c0 34.2 23.7 53.6 68 35.8 4.8-1.9 9-3.2 12.7-2.2 3.5.9 5.8 3.4 7.4 7.9l22 64.3c1.8 5 3.3 10.6-.4 14.5z"
        ],
        "tumblr-square": [
            448,
            512,
            [],
            "f174",
            "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-82.3 364.2c-8.5 9.1-31.2 19.8-60.9 19.8-75.5 0-91.9-55.5-91.9-87.9v-90h-29.7c-3.4 0-6.2-2.8-6.2-6.2v-42.5c0-4.5 2.8-8.5 7.1-10 38.8-13.7 50.9-47.5 52.7-73.2.5-6.9 4.1-10.2 10-10.2h44.3c3.4 0 6.2 2.8 6.2 6.2v72h51.9c3.4 0 6.2 2.8 6.2 6.2v51.1c0 3.4-2.8 6.2-6.2 6.2h-52.1V321c0 21.4 14.8 33.5 42.5 22.4 3-1.2 5.6-2 8-1.4 2.2.5 3.6 2.1 4.6 4.9l13.8 40.2c1 3.2 2 6.7-.3 9.1z"
        ],
        "twitch": [
            512,
            512,
            [],
            "f1e8",
            "M391.17,103.47H352.54v109.7h38.63ZM285,103H246.37V212.75H285ZM120.83,0,24.31,91.42V420.58H140.14V512l96.53-91.42h77.25L487.69,256V0ZM449.07,237.75l-77.22,73.12H294.61l-67.6,64v-64H140.14V36.58H449.07Z"
        ],
        "twitter": [
            512,
            512,
            [],
            "f099",
            "M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
        ],
        "twitter-square": [
            448,
            512,
            [],
            "f081",
            "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-48.9 158.8c.2 2.8.2 5.7.2 8.5 0 86.7-66 186.6-186.6 186.6-37.2 0-71.7-10.8-100.7-29.4 5.3.6 10.4.8 15.8.8 30.7 0 58.9-10.4 81.4-28-28.8-.6-53-19.5-61.3-45.5 10.1 1.5 19.2 1.5 29.6-1.2-30-6.1-52.5-32.5-52.5-64.4v-.8c8.7 4.9 18.9 7.9 29.6 8.3a65.447 65.447 0 0 1-29.2-54.6c0-12.2 3.2-23.4 8.9-33.1 32.3 39.8 80.8 65.8 135.2 68.6-9.3-44.5 24-80.6 64-80.6 18.9 0 35.9 7.9 47.9 20.7 14.8-2.8 29-8.3 41.6-15.8-4.9 15.2-15.2 28-28.8 36.1 13.2-1.4 26-5.1 37.8-10.2-8.9 13.1-20.1 24.7-32.9 34z"
        ],
        "typo3": [
            448,
            512,
            [],
            "f42b",
            "M178.7 78.4c0-24.7 5.4-32.4 13.9-39.4-69.5 8.5-149.3 34-176.3 66.4-5.4 7.7-9.3 20.8-9.3 37.1C7 246 113.8 480 191.1 480c36.3 0 97.3-59.5 146.7-139-7 2.3-11.6 2.3-18.5 2.3-57.2 0-140.6-198.5-140.6-264.9zM301.5 32c-30.1 0-41.7 5.4-41.7 36.3 0 66.4 53.8 198.5 101.7 198.5 26.3 0 78.8-99.7 78.8-182.3 0-40.9-67-52.5-138.8-52.5z"
        ],
        "uber": [
            448,
            512,
            [],
            "f402",
            "M414.1 32H33.9C15.2 32 0 47.2 0 65.9V446c0 18.8 15.2 34 33.9 34H414c18.7 0 33.9-15.2 33.9-33.9V65.9C448 47.2 432.8 32 414.1 32zM237.6 391.1C163 398.6 96.4 344.2 88.9 269.6h94.4V290c0 3.7 3 6.8 6.8 6.8H258c3.7 0 6.8-3 6.8-6.8v-67.9c0-3.7-3-6.8-6.8-6.8h-67.9c-3.7 0-6.8 3-6.8 6.8v20.4H88.9c7-69.4 65.4-122.2 135.1-122.2 69.7 0 128.1 52.8 135.1 122.2 7.5 74.5-46.9 141.1-121.5 148.6z"
        ],
        "ubuntu": [
            496,
            512,
            [],
            "f7df",
            "M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm52.7 93c8.8-15.2 28.3-20.5 43.5-11.7 15.3 8.8 20.5 28.3 11.7 43.6-8.8 15.2-28.3 20.5-43.5 11.7-15.3-8.9-20.5-28.4-11.7-43.6zM87.4 287.9c-17.6 0-31.9-14.3-31.9-31.9 0-17.6 14.3-31.9 31.9-31.9 17.6 0 31.9 14.3 31.9 31.9 0 17.6-14.3 31.9-31.9 31.9zm28.1 3.1c22.3-17.9 22.4-51.9 0-69.9 8.6-32.8 29.1-60.7 56.5-79.1l23.7 39.6c-51.5 36.3-51.5 112.5 0 148.8L172 370c-27.4-18.3-47.8-46.3-56.5-79zm228.7 131.7c-15.3 8.8-34.7 3.6-43.5-11.7-8.8-15.3-3.6-34.8 11.7-43.6 15.2-8.8 34.7-3.6 43.5 11.7 8.8 15.3 3.6 34.8-11.7 43.6zm.3-69.5c-26.7-10.3-56.1 6.6-60.5 35-5.2 1.4-48.9 14.3-96.7-9.4l22.5-40.3c57 26.5 123.4-11.7 128.9-74.4l46.1.7c-2.3 34.5-17.3 65.5-40.3 88.4zm-5.9-105.3c-5.4-62-71.3-101.2-128.9-74.4l-22.5-40.3c47.9-23.7 91.5-10.8 96.7-9.4 4.4 28.3 33.8 45.3 60.5 35 23.1 22.9 38 53.9 40.2 88.5l-46 .6z"
        ],
        "uikit": [
            448,
            512,
            [],
            "f403",
            "M443.9 128v256L218 512 0 384V169.7l87.6 45.1v117l133.5 75.5 135.8-75.5v-151l-101.1-57.6 87.6-53.1L443.9 128zM308.6 49.1L223.8 0l-88.6 54.8 86 47.3 87.4-53z"
        ],
        "umbraco": [
            510,
            512,
            [],
            "f8e8",
            "M255.35 8C118.36 7.83 7.14 118.72 7 255.68c-.07 137 111 248.2 248 248.27 136.85 0 247.82-110.7 248-247.67S392.34 8.17 255.35 8zm145 266q-1.14 40.68-14 65t-43.51 35q-30.61 10.7-85.45 10.47h-4.6q-54.78.22-85.44-10.47t-43.52-35q-12.85-24.36-14-65a224.81 224.81 0 0 1 0-30.71 418.37 418.37 0 0 1 3.6-43.88c1.88-13.39 3.57-22.58 5.4-32 1-4.88 1.28-6.42 1.82-8.45a5.09 5.09 0 0 1 4.9-3.89h.69l32 5a5.07 5.07 0 0 1 4.16 5 5 5 0 0 1 0 .77l-1.7 8.78q-2.41 13.25-4.84 33.68a380.62 380.62 0 0 0-2.64 42.15q-.28 40.43 8.13 59.83a43.87 43.87 0 0 0 31.31 25.18A243 243 0 0 0 250 340.6h10.25a242.64 242.64 0 0 0 57.27-5.16 43.86 43.86 0 0 0 31.15-25.23q8.53-19.42 8.13-59.78a388 388 0 0 0-2.6-42.15q-2.48-20.38-4.89-33.68l-1.69-8.78a5 5 0 0 1 0-.77 5 5 0 0 1 4.2-5l32-5h.82a5 5 0 0 1 4.9 3.89c.55 2.05.81 3.57 1.83 8.45 1.82 9.62 3.52 18.78 5.39 32a415.71 415.71 0 0 1 3.61 43.88 228.06 228.06 0 0 1-.04 30.73z"
        ],
        "uncharted": [
            448,
            512,
            [],
            "e084",
            "M171.73,232.813A5.381,5.381,0,0,0,176.7,229.5,48.081,48.081,0,0,1,191.6,204.244c1.243-.828,1.657-2.484,1.657-4.141a4.22,4.22,0,0,0-2.071-3.312L74.429,128.473,148.958,85a9.941,9.941,0,0,0,4.968-8.281,9.108,9.108,0,0,0-4.968-8.281L126.6,55.6a9.748,9.748,0,0,0-9.523,0l-100.2,57.966a9.943,9.943,0,0,0-4.969,8.281V236.954a9.109,9.109,0,0,0,4.969,8.281L39.235,258.07a8.829,8.829,0,0,0,4.968,1.242,9.4,9.4,0,0,0,6.625-2.484,10.8,10.8,0,0,0,2.9-7.039V164.5L169.66,232.4A4.5,4.5,0,0,0,171.73,232.813ZM323.272,377.73a12.478,12.478,0,0,0-4.969,1.242l-74.528,43.062V287.882c0-2.9-2.9-5.8-6.211-4.555a53.036,53.036,0,0,1-28.984.414,4.86,4.86,0,0,0-6.21,4.555V421.619l-74.529-43.061a8.83,8.83,0,0,0-4.969-1.242,9.631,9.631,0,0,0-9.523,9.523v26.085a9.107,9.107,0,0,0,4.969,8.281l100.2,57.553A8.829,8.829,0,0,0,223.486,480a11.027,11.027,0,0,0,4.969-1.242l100.2-57.553a9.941,9.941,0,0,0,4.968-8.281V386.839C332.8,382.285,328.24,377.73,323.272,377.73ZM286.007,78a23,23,0,1,0-23-23A23,23,0,0,0,286.007,78Zm63.627-10.086a23,23,0,1,0,23,23A23,23,0,0,0,349.634,67.914ZM412.816,151.6a23,23,0,1,0-23-23A23,23,0,0,0,412.816,151.6Zm-63.182-9.2a23,23,0,1,0,23,23A23,23,0,0,0,349.634,142.4Zm-63.627,83.244a23,23,0,1,0-23-23A23,23,0,0,0,286.007,225.648Zm-62.074,36.358a23,23,0,1,0-23-23A23,23,0,0,0,223.933,262.006Zm188.883-82.358a23,23,0,1,0,23,23A23,23,0,0,0,412.816,179.648Zm0,72.272a23,23,0,1,0,23,23A23,23,0,0,0,412.816,251.92Z"
        ],
        "uniregistry": [
            384,
            512,
            [],
            "f404",
            "M192 480c39.5 0 76.2-11.8 106.8-32.2H85.3C115.8 468.2 152.5 480 192 480zm-89.1-193.1v-12.4H0v12.4c0 2.5 0 5 .1 7.4h103.1c-.2-2.4-.3-4.9-.3-7.4zm20.5 57H8.5c2.6 8.5 5.8 16.8 9.6 24.8h138.3c-12.9-5.7-24.1-14.2-33-24.8zm-17.7-34.7H1.3c.9 7.6 2.2 15 3.9 22.3h109.7c-4-6.9-7.2-14.4-9.2-22.3zm-2.8-69.3H0v17.3h102.9zm0-173.2H0v4.9h102.9zm0-34.7H0v2.5h102.9zm0 69.3H0v7.4h102.9zm0 104H0v14.8h102.9zm0-69.3H0v9.9h102.9zm0 34.6H0V183h102.9zm166.2 160.9h109.7c1.8-7.3 3.1-14.7 3.9-22.3H278.3c-2.1 7.9-5.2 15.4-9.2 22.3zm12-185.7H384V136H281.1zm0 37.2H384v-12.4H281.1zm0-74.3H384v-7.4H281.1zm0-76.7v2.5H384V32zm-203 410.9h227.7c11.8-8.7 22.7-18.6 32.2-29.7H44.9c9.6 11 21.4 21 33.2 29.7zm203-371.3H384v-4.9H281.1zm0 148.5H384v-14.8H281.1zM38.8 405.7h305.3c6.7-8.5 12.6-17.6 17.8-27.2H23c5.2 9.6 9.2 18.7 15.8 27.2zm188.8-37.1H367c3.7-8 5.8-16.2 8.5-24.8h-115c-8.8 10.7-20.1 19.2-32.9 24.8zm53.5-81.7c0 2.5-.1 5-.4 7.4h103.1c.1-2.5.2-4.9.2-7.4v-12.4H281.1zm0-29.7H384v-17.3H281.1z"
        ],
        "unity": [
            576,
            512,
            [],
            "e049",
            "M498.11,206.4,445.31,14.72,248.2,66.08,219,116.14l-59.2-.43L15.54,256,159.82,396.32l59.17-.43,29.24,50,197.08,51.36,52.8-191.62-30-49.63ZM223.77,124.2,374.55,86.51,288,232.33H114.87Zm0,263.63L114.87,279.71H288l86.55,145.81Zm193,14L330.17,256l86.58-145.84L458.56,256Z"
        ],
        "unsplash": [
            448,
            512,
            [],
            "e07c",
            "M448,230.17V480H0V230.17H141.13V355.09H306.87V230.17ZM306.87,32H141.13V156.91H306.87Z"
        ],
        "untappd": [
            640,
            512,
            [],
            "f405",
            "M401.3 49.9c-79.8 160.1-84.6 152.5-87.9 173.2l-5.2 32.8c-1.9 12-6.6 23.5-13.7 33.4L145.6 497.1c-7.6 10.6-20.4 16.2-33.4 14.6-40.3-5-77.8-32.2-95.3-68.5-5.7-11.8-4.5-25.8 3.1-36.4l148.9-207.9c7.1-9.9 16.4-18 27.2-23.7l29.3-15.5c18.5-9.8 9.7-11.9 135.6-138.9 1-4.8 1-7.3 3.6-8 3-.7 6.6-1 6.3-4.6l-.4-4.6c-.2-1.9 1.3-3.6 3.2-3.6 4.5-.1 13.2 1.2 25.6 10 12.3 8.9 16.4 16.8 17.7 21.1.6 1.8-.6 3.7-2.4 4.2l-4.5 1.1c-3.4.9-2.5 4.4-2.3 7.4.1 2.8-2.3 3.6-6.5 6.1zM230.1 36.4c3.4.9 2.5 4.4 2.3 7.4-.2 2.7 2.1 3.5 6.4 6 7.9 15.9 15.3 30.5 22.2 44 .7 1.3 2.3 1.5 3.3.5 11.2-12 24.6-26.2 40.5-42.6 1.3-1.4 1.4-3.5.1-4.9-8-8.2-16.5-16.9-25.6-26.1-1-4.7-1-7.3-3.6-8-3-.8-6.6-1-6.3-4.6.3-3.3 1.4-8.1-2.8-8.2-4.5-.1-13.2 1.1-25.6 10-12.3 8.9-16.4 16.8-17.7 21.1-1.4 4.2 3.6 4.6 6.8 5.4zM620 406.7L471.2 198.8c-13.2-18.5-26.6-23.4-56.4-39.1-11.2-5.9-14.2-10.9-30.5-28.9-1-1.1-2.9-.9-3.6.5-46.3 88.8-47.1 82.8-49 94.8-1.7 10.7-1.3 20 .3 29.8 1.9 12 6.6 23.5 13.7 33.4l148.9 207.9c7.6 10.6 20.2 16.2 33.1 14.7 40.3-4.9 78-32 95.7-68.6 5.4-11.9 4.3-25.9-3.4-36.6z"
        ],
        "ups": [
            384,
            512,
            [],
            "f7e0",
            "M103.2 303c-5.2 3.6-32.6 13.1-32.6-19V180H37.9v102.6c0 74.9 80.2 51.1 97.9 39V180h-32.6zM4 74.82v220.9c0 103.7 74.9 135.2 187.7 184.1 112.4-48.9 187.7-80.2 187.7-184.1V74.82c-116.3-61.6-281.8-49.6-375.4 0zm358.1 220.9c0 86.6-53.2 113.6-170.4 165.3-117.5-51.8-170.5-78.7-170.5-165.3v-126.4c102.3-93.8 231.6-100 340.9-89.8zm-209.6-107.4v212.8h32.7v-68.7c24.4 7.3 71.7-2.6 71.7-78.5 0-97.4-80.7-80.92-104.4-65.6zm32.7 117.3v-100.3c8.4-4.2 38.4-12.7 38.4 49.3 0 67.9-36.4 51.8-38.4 51zm79.1-86.4c.1 47.3 51.6 42.5 52.2 70.4.6 23.5-30.4 23-50.8 4.9v30.1c36.2 21.5 81.9 8.1 83.2-33.5 1.7-51.5-54.1-46.6-53.4-73.2.6-20.3 30.6-20.5 48.5-2.2v-28.4c-28.5-22-79.9-9.2-79.7 31.9z"
        ],
        "usb": [
            640,
            512,
            [],
            "f287",
            "M641.5 256c0 3.1-1.7 6.1-4.5 7.5L547.9 317c-1.4.8-2.8 1.4-4.5 1.4-1.4 0-3.1-.3-4.5-1.1-2.8-1.7-4.5-4.5-4.5-7.8v-35.6H295.7c25.3 39.6 40.5 106.9 69.6 106.9H392V354c0-5 3.9-8.9 8.9-8.9H490c5 0 8.9 3.9 8.9 8.9v89.1c0 5-3.9 8.9-8.9 8.9h-89.1c-5 0-8.9-3.9-8.9-8.9v-26.7h-26.7c-75.4 0-81.1-142.5-124.7-142.5H140.3c-8.1 30.6-35.9 53.5-69 53.5C32 327.3 0 295.3 0 256s32-71.3 71.3-71.3c33.1 0 61 22.8 69 53.5 39.1 0 43.9 9.5 74.6-60.4C255 88.7 273 95.7 323.8 95.7c7.5-20.9 27-35.6 50.4-35.6 29.5 0 53.5 23.9 53.5 53.5s-23.9 53.5-53.5 53.5c-23.4 0-42.9-14.8-50.4-35.6H294c-29.1 0-44.3 67.4-69.6 106.9h310.1v-35.6c0-3.3 1.7-6.1 4.5-7.8 2.8-1.7 6.4-1.4 8.9.3l89.1 53.5c2.8 1.1 4.5 4.1 4.5 7.2z"
        ],
        "usps": [
            576,
            512,
            [],
            "f7e1",
            "M460.3 241.7c25.8-41.3 15.2-48.8-11.7-48.8h-27c-.1 0-1.5-1.4-10.9 8-11.2 5.6-37.9 6.3-37.9 8.7 0 4.5 70.3-3.1 88.1 0 9.5 1.5-1.5 20.4-4.4 32-.5 4.5 2.4 2.3 3.8.1zm-112.1 22.6c64-21.3 97.3-23.9 102-26.2 4.4-2.9-4.4-6.6-26.2-5.8-51.7 2.2-137.6 37.1-172.6 53.9l-30.7-93.3h196.6c-2.7-28.2-152.9-22.6-337.9-22.6L27 415.8c196.4-97.3 258.9-130.3 321.2-151.5zM94.7 96c253.3 53.7 330 65.7 332.1 85.2 36.4 0 45.9 0 52.4 6.6 21.1 19.7-14.6 67.7-14.6 67.7-4.4 2.9-406.4 160.2-406.4 160.2h423.1L549 96z"
        ],
        "ussunnah": [
            512,
            512,
            [],
            "f407",
            "M156.8 285.1l5.7 14.4h-8.2c-1.3-3.2-3.1-7.7-3.8-9.5-2.5-6.3-1.1-8.4 0-10 1.9-2.7 3.2-4.4 3.6-5.2 0 2.2.8 5.7 2.7 10.3zm297.3 18.8c-2.1 13.8-5.7 27.1-10.5 39.7l43 23.4-44.8-18.8c-5.3 13.2-12 25.6-19.9 37.2l34.2 30.2-36.8-26.4c-8.4 11.8-18 22.6-28.7 32.3l24.9 34.7-28.1-31.8c-11 9.6-23.1 18-36.1 25.1l15.7 37.2-19.3-35.3c-13.1 6.8-27 12.1-41.6 15.9l6.7 38.4-10.5-37.4c-14.3 3.4-29.2 5.3-44.5 5.4L256 512l-1.9-38.4c-15.3-.1-30.2-2-44.5-5.3L199 505.6l6.7-38.2c-14.6-3.7-28.6-9.1-41.7-15.8l-19.2 35.1 15.6-37c-13-7-25.2-15.4-36.2-25.1l-27.9 31.6 24.7-34.4c-10.7-9.7-20.4-20.5-28.8-32.3l-36.5 26.2 33.9-29.9c-7.9-11.6-14.6-24.1-20-37.3l-44.4 18.7L67.8 344c-4.8-12.7-8.4-26.1-10.5-39.9l-51 9 50.3-14.2c-1.1-8.5-1.7-17.1-1.7-25.9 0-4.7.2-9.4.5-14.1L0 256l56-2.8c1.3-13.1 3.8-25.8 7.5-38.1L6.4 199l58.9 10.4c4-12 9.1-23.5 15.2-34.4l-55.1-30 58.3 24.6C90 159 97.2 149.2 105.3 140L55.8 96.4l53.9 38.7c8.1-8.6 17-16.5 26.6-23.6l-40-55.6 45.6 51.6c9.5-6.6 19.7-12.3 30.3-17.2l-27.3-64.9 33.8 62.1c10.5-4.4 21.4-7.9 32.7-10.4L199 6.4l19.5 69.2c11-2.1 22.3-3.2 33.8-3.4L256 0l3.6 72.2c11.5.2 22.8 1.4 33.8 3.5L313 6.4l-12.4 70.7c11.3 2.6 22.2 6.1 32.6 10.5l33.9-62.2-27.4 65.1c10.6 4.9 20.7 10.7 30.2 17.2l45.8-51.8-40.1 55.9c9.5 7.1 18.4 15 26.5 23.6l54.2-38.9-49.7 43.9c8 9.1 15.2 18.9 21.5 29.4l58.7-24.7-55.5 30.2c6.1 10.9 11.1 22.3 15.1 34.3l59.3-10.4-57.5 16.2c3.7 12.2 6.2 24.9 7.5 37.9L512 256l-56 2.8c.3 4.6.5 9.3.5 14.1 0 8.7-.6 17.3-1.6 25.8l50.7 14.3-51.5-9.1zm-21.8-31c0-97.5-79-176.5-176.5-176.5s-176.5 79-176.5 176.5 79 176.5 176.5 176.5 176.5-79 176.5-176.5zm-24 0c0 84.3-68.3 152.6-152.6 152.6s-152.6-68.3-152.6-152.6 68.3-152.6 152.6-152.6 152.6 68.3 152.6 152.6zM195 241c0 2.1 1.3 3.8 3.6 5.1 3.3 1.9 6.2 4.6 8.2 8.2 2.8-5.7 4.3-9.5 4.3-11.2 0-2.2-1.1-4.4-3.2-7-2.1-2.5-3.2-5.2-3.3-7.7-6.5 6.8-9.6 10.9-9.6 12.6zm-40.7-19c0 2.1 1.3 3.8 3.6 5.1 3.5 1.9 6.2 4.6 8.2 8.2 2.8-5.7 4.3-9.5 4.3-11.2 0-2.2-1.1-4.4-3.2-7-2.1-2.5-3.2-5.2-3.3-7.7-6.5 6.8-9.6 10.9-9.6 12.6zm-19 0c0 2.1 1.3 3.8 3.6 5.1 3.3 1.9 6.2 4.6 8.2 8.2 2.8-5.7 4.3-9.5 4.3-11.2 0-2.2-1.1-4.4-3.2-7-2.1-2.5-3.2-5.2-3.3-7.7-6.4 6.8-9.6 10.9-9.6 12.6zm204.9 87.9c-8.4-3-8.7-6.8-8.7-15.6V182c-8.2 12.5-14.2 18.6-18 18.6 6.3 14.4 9.5 23.9 9.5 28.3v64.3c0 2.2-2.2 6.5-4.7 6.5h-18c-2.8-7.5-10.2-26.9-15.3-40.3-2 2.5-7.2 9.2-10.7 13.7 2.4 1.6 4.1 3.6 5.2 6.3 2.6 6.7 6.4 16.5 7.9 20.2h-9.2c-3.9-10.4-9.6-25.4-11.8-31.1-2 2.5-7.2 9.2-10.7 13.7 2.4 1.6 4.1 3.6 5.2 6.3.8 2 2.8 7.3 4.3 10.9H256c-1.5-4.1-5.6-14.6-8.4-22-2 2.5-7.2 9.2-10.7 13.7 2.5 1.6 4.3 3.6 5.2 6.3.2.6.5 1.4.6 1.7H225c-4.6-13.9-11.4-27.7-11.4-34.1 0-2.2.3-5.1 1.1-8.2-8.8 10.8-14 15.9-14 25 0 7.5 10.4 28.3 10.4 33.3 0 1.7-.5 3.3-1.4 4.9-9.6-12.7-15.5-20.7-18.8-20.7h-12l-11.2-28c-3.8-9.6-5.7-16-5.7-18.8 0-3.8.5-7.7 1.7-12.2-1 1.3-3.7 4.7-5.5 7.1-.8-2.1-3.1-7.7-4.6-11.5-2.1 2.5-7.5 9.1-11.2 13.6.9 2.3 3.3 8.1 4.9 12.2-2.5 3.3-9.1 11.8-13.6 17.7-4 5.3-5.8 13.3-2.7 21.8 2.5 6.7 2 7.9-1.7 14.1H191c5.5 0 14.3 14 15.5 22 13.2-16 15.4-19.6 16.8-21.6h107c3.9 0 7.2-1.9 9.9-5.8zm20.1-26.6V181.7c-9 12.5-15.9 18.6-20.7 18.6 7.1 14.4 10.7 23.9 10.7 28.3v66.3c0 17.5 8.6 20.4 24 20.4 8.1 0 12.5-.8 13.7-2.7-4.3-1.6-7.6-2.5-9.9-3.3-8.1-3.2-17.8-7.4-17.8-26z"
        ],
        "vaadin": [
            448,
            512,
            [],
            "f408",
            "M224.5 140.7c1.5-17.6 4.9-52.7 49.8-52.7h98.6c20.7 0 32.1-7.8 32.1-21.6V54.1c0-12.2 9.3-22.1 21.5-22.1S448 41.9 448 54.1v36.5c0 42.9-21.5 62-66.8 62H280.7c-30.1 0-33 14.7-33 27.1 0 1.3-.1 2.5-.2 3.7-.7 12.3-10.9 22.2-23.4 22.2s-22.7-9.8-23.4-22.2c-.1-1.2-.2-2.4-.2-3.7 0-12.3-3-27.1-33-27.1H66.8c-45.3 0-66.8-19.1-66.8-62V54.1C0 41.9 9.4 32 21.6 32s21.5 9.9 21.5 22.1v12.3C43.1 80.2 54.5 88 75.2 88h98.6c44.8 0 48.3 35.1 49.8 52.7h.9zM224 456c11.5 0 21.4-7 25.7-16.3 1.1-1.8 97.1-169.6 98.2-171.4 11.9-19.6-3.2-44.3-27.2-44.3-13.9 0-23.3 6.4-29.8 20.3L224 362l-66.9-117.7c-6.4-13.9-15.9-20.3-29.8-20.3-24 0-39.1 24.6-27.2 44.3 1.1 1.9 97.1 169.6 98.2 171.4 4.3 9.3 14.2 16.3 25.7 16.3z"
        ],
        "viacoin": [
            384,
            512,
            [],
            "f237",
            "M384 32h-64l-80.7 192h-94.5L64 32H0l48 112H0v48h68.5l13.8 32H0v48h102.8L192 480l89.2-208H384v-48h-82.3l13.8-32H384v-48h-48l48-112zM192 336l-27-64h54l-27 64z"
        ],
        "viadeo": [
            448,
            512,
            [],
            "f2a9",
            "M276.2 150.5v.7C258.3 98.6 233.6 47.8 205.4 0c43.3 29.2 67 100 70.8 150.5zm32.7 121.7c7.6 18.2 11 37.5 11 57 0 77.7-57.8 141-137.8 139.4l3.8-.3c74.2-46.7 109.3-118.6 109.3-205.1 0-38.1-6.5-75.9-18.9-112 1 11.7 1 23.7 1 35.4 0 91.8-18.1 241.6-116.6 280C95 455.2 49.4 398 49.4 329.2c0-75.6 57.4-142.3 135.4-142.3 16.8 0 33.7 3.1 49.1 9.6 1.7-15.1 6.5-29.9 13.4-43.3-19.9-7.2-41.2-10.7-62.5-10.7-161.5 0-238.7 195.9-129.9 313.7 67.9 74.6 192 73.9 259.8 0 56.6-61.3 60.9-142.4 36.4-201-12.7 8-27.1 13.9-42.2 17zM418.1 11.7c-31 66.5-81.3 47.2-115.8 80.1-12.4 12-20.6 34-20.6 50.5 0 14.1 4.5 27.1 12 38.8 47.4-11 98.3-46 118.2-90.7-.7 5.5-4.8 14.4-7.2 19.2-20.3 35.7-64.6 65.6-99.7 84.9 14.8 14.4 33.7 25.8 55 25.8 79 0 110.1-134.6 58.1-208.6z"
        ],
        "viadeo-square": [
            448,
            512,
            [],
            "f2aa",
            "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM280.7 381.2c-42.4 46.2-120 46.6-162.4 0-68-73.6-19.8-196.1 81.2-196.1 13.3 0 26.6 2.1 39.1 6.7-4.3 8.4-7.3 17.6-8.4 27.1-9.7-4.1-20.2-6-30.7-6-48.8 0-84.6 41.7-84.6 88.9 0 43 28.5 78.7 69.5 85.9 61.5-24 72.9-117.6 72.9-175 0-7.3 0-14.8-.6-22.1-11.2-32.9-26.6-64.6-44.2-94.5 27.1 18.3 41.9 62.5 44.2 94.1v.4c7.7 22.5 11.8 46.2 11.8 70 0 54.1-21.9 99-68.3 128.2l-2.4.2c50 1 86.2-38.6 86.2-87.2 0-12.2-2.1-24.3-6.9-35.7 9.5-1.9 18.5-5.6 26.4-10.5 15.3 36.6 12.6 87.3-22.8 125.6zM309 233.7c-13.3 0-25.1-7.1-34.4-16.1 21.9-12 49.6-30.7 62.3-53 1.5-3 4.1-8.6 4.5-12-12.5 27.9-44.2 49.8-73.9 56.7-4.7-7.3-7.5-15.5-7.5-24.3 0-10.3 5.2-24.1 12.9-31.6 21.6-20.5 53-8.5 72.4-50 32.5 46.2 13.1 130.3-36.3 130.3z"
        ],
        "viber": [
            512,
            512,
            [],
            "f409",
            "M444 49.9C431.3 38.2 379.9.9 265.3.4c0 0-135.1-8.1-200.9 52.3C27.8 89.3 14.9 143 13.5 209.5c-1.4 66.5-3.1 191.1 117 224.9h.1l-.1 51.6s-.8 20.9 13 25.1c16.6 5.2 26.4-10.7 42.3-27.8 8.7-9.4 20.7-23.2 29.8-33.7 82.2 6.9 145.3-8.9 152.5-11.2 16.6-5.4 110.5-17.4 125.7-142 15.8-128.6-7.6-209.8-49.8-246.5zM457.9 287c-12.9 104-89 110.6-103 115.1-6 1.9-61.5 15.7-131.2 11.2 0 0-52 62.7-68.2 79-5.3 5.3-11.1 4.8-11-5.7 0-6.9.4-85.7.4-85.7-.1 0-.1 0 0 0-101.8-28.2-95.8-134.3-94.7-189.8 1.1-55.5 11.6-101 42.6-131.6 55.7-50.5 170.4-43 170.4-43 96.9.4 143.3 29.6 154.1 39.4 35.7 30.6 53.9 103.8 40.6 211.1zm-139-80.8c.4 8.6-12.5 9.2-12.9.6-1.1-22-11.4-32.7-32.6-33.9-8.6-.5-7.8-13.4.7-12.9 27.9 1.5 43.4 17.5 44.8 46.2zm20.3 11.3c1-42.4-25.5-75.6-75.8-79.3-8.5-.6-7.6-13.5.9-12.9 58 4.2 88.9 44.1 87.8 92.5-.1 8.6-13.1 8.2-12.9-.3zm47 13.4c.1 8.6-12.9 8.7-12.9.1-.6-81.5-54.9-125.9-120.8-126.4-8.5-.1-8.5-12.9 0-12.9 73.7.5 133 51.4 133.7 139.2zM374.9 329v.2c-10.8 19-31 40-51.8 33.3l-.2-.3c-21.1-5.9-70.8-31.5-102.2-56.5-16.2-12.8-31-27.9-42.4-42.4-10.3-12.9-20.7-28.2-30.8-46.6-21.3-38.5-26-55.7-26-55.7-6.7-20.8 14.2-41 33.3-51.8h.2c9.2-4.8 18-3.2 23.9 3.9 0 0 12.4 14.8 17.7 22.1 5 6.8 11.7 17.7 15.2 23.8 6.1 10.9 2.3 22-3.7 26.6l-12 9.6c-6.1 4.9-5.3 14-5.3 14s17.8 67.3 84.3 84.3c0 0 9.1.8 14-5.3l9.6-12c4.6-6 15.7-9.8 26.6-3.7 14.7 8.3 33.4 21.2 45.8 32.9 7 5.7 8.6 14.4 3.8 23.6z"
        ],
        "vimeo": [
            448,
            512,
            [],
            "f40a",
            "M403.2 32H44.8C20.1 32 0 52.1 0 76.8v358.4C0 459.9 20.1 480 44.8 480h358.4c24.7 0 44.8-20.1 44.8-44.8V76.8c0-24.7-20.1-44.8-44.8-44.8zM377 180.8c-1.4 31.5-23.4 74.7-66 129.4-44 57.2-81.3 85.8-111.7 85.8-18.9 0-34.8-17.4-47.9-52.3-25.5-93.3-36.4-148-57.4-148-2.4 0-10.9 5.1-25.4 15.2l-15.2-19.6c37.3-32.8 72.9-69.2 95.2-71.2 25.2-2.4 40.7 14.8 46.5 51.7 20.7 131.2 29.9 151 67.6 91.6 13.5-21.4 20.8-37.7 21.8-48.9 3.5-33.2-25.9-30.9-45.8-22.4 15.9-52.1 46.3-77.4 91.2-76 33.3.9 49 22.5 47.1 64.7z"
        ],
        "vimeo-square": [
            448,
            512,
            [],
            "f194",
            "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-16.2 149.6c-1.4 31.1-23.2 73.8-65.3 127.9-43.5 56.5-80.3 84.8-110.4 84.8-18.7 0-34.4-17.2-47.3-51.6-25.2-92.3-35.9-146.4-56.7-146.4-2.4 0-10.8 5-25.1 15.1L64 192c36.9-32.4 72.1-68.4 94.1-70.4 24.9-2.4 40.2 14.6 46 51.1 20.5 129.6 29.6 149.2 66.8 90.5 13.4-21.2 20.6-37.2 21.5-48.3 3.4-32.8-25.6-30.6-45.2-22.2 15.7-51.5 45.8-76.5 90.1-75.1 32.9 1 48.4 22.4 46.5 64z"
        ],
        "vimeo-v": [
            448,
            512,
            [],
            "f27d",
            "M447.8 153.6c-2 43.6-32.4 103.3-91.4 179.1-60.9 79.2-112.4 118.8-154.6 118.8-26.1 0-48.2-24.1-66.3-72.3C100.3 250 85.3 174.3 56.2 174.3c-3.4 0-15.1 7.1-35.2 21.1L0 168.2c51.6-45.3 100.9-95.7 131.8-98.5 34.9-3.4 56.3 20.5 64.4 71.5 28.7 181.5 41.4 208.9 93.6 126.7 18.7-29.6 28.8-52.1 30.2-67.6 4.8-45.9-35.8-42.8-63.3-31 22-72.1 64.1-107.1 126.2-105.1 45.8 1.2 67.5 31.1 64.9 89.4z"
        ],
        "vine": [
            384,
            512,
            [],
            "f1ca",
            "M384 254.7v52.1c-18.4 4.2-36.9 6.1-52.1 6.1-36.9 77.4-103 143.8-125.1 156.2-14 7.9-27.1 8.4-42.7-.8C137 452 34.2 367.7 0 102.7h74.5C93.2 261.8 139 343.4 189.3 404.5c27.9-27.9 54.8-65.1 75.6-106.9-49.8-25.3-80.1-80.9-80.1-145.6 0-65.6 37.7-115.1 102.2-115.1 114.9 0 106.2 127.9 81.6 181.5 0 0-46.4 9.2-63.5-20.5 3.4-11.3 8.2-30.8 8.2-48.5 0-31.3-11.3-46.6-28.4-46.6-18.2 0-30.8 17.1-30.8 50 .1 79.2 59.4 118.7 129.9 101.9z"
        ],
        "vk": [
            576,
            512,
            [],
            "f189",
            "M545 117.7c3.7-12.5 0-21.7-17.8-21.7h-58.9c-15 0-21.9 7.9-25.6 16.7 0 0-30 73.1-72.4 120.5-13.7 13.7-20 18.1-27.5 18.1-3.7 0-9.4-4.4-9.4-16.9V117.7c0-15-4.2-21.7-16.6-21.7h-92.6c-9.4 0-15 7-15 13.5 0 14.2 21.2 17.5 23.4 57.5v86.8c0 19-3.4 22.5-10.9 22.5-20 0-68.6-73.4-97.4-157.4-5.8-16.3-11.5-22.9-26.6-22.9H38.8c-16.8 0-20.2 7.9-20.2 16.7 0 15.6 20 93.1 93.1 195.5C160.4 378.1 229 416 291.4 416c37.5 0 42.1-8.4 42.1-22.9 0-66.8-3.4-73.1 15.4-73.1 8.7 0 23.7 4.4 58.7 38.1 40 40 46.6 57.9 69 57.9h58.9c16.8 0 25.3-8.4 20.4-25-11.2-34.9-86.9-106.7-90.3-111.5-8.7-11.2-6.2-16.2 0-26.2.1-.1 72-101.3 79.4-135.6z"
        ],
        "vnv": [
            640,
            512,
            [],
            "f40b",
            "M104.9 352c-34.1 0-46.4-30.4-46.4-30.4L2.6 210.1S-7.8 192 13 192h32.8c10.4 0 13.2 8.7 18.8 18.1l36.7 74.5s5.2 13.1 21.1 13.1 21.1-13.1 21.1-13.1l36.7-74.5c5.6-9.5 8.4-18.1 18.8-18.1h32.8c20.8 0 10.4 18.1 10.4 18.1l-55.8 111.5S174.2 352 140 352h-35.1zm395 0c-34.1 0-46.4-30.4-46.4-30.4l-55.9-111.5S387.2 192 408 192h32.8c10.4 0 13.2 8.7 18.8 18.1l36.7 74.5s5.2 13.1 21.1 13.1 21.1-13.1 21.1-13.1l36.8-74.5c5.6-9.5 8.4-18.1 18.8-18.1H627c20.8 0 10.4 18.1 10.4 18.1l-55.9 111.5S569.3 352 535.1 352h-35.2zM337.6 192c34.1 0 46.4 30.4 46.4 30.4l55.9 111.5s10.4 18.1-10.4 18.1h-32.8c-10.4 0-13.2-8.7-18.8-18.1l-36.7-74.5s-5.2-13.1-21.1-13.1c-15.9 0-21.1 13.1-21.1 13.1l-36.7 74.5c-5.6 9.4-8.4 18.1-18.8 18.1h-32.9c-20.8 0-10.4-18.1-10.4-18.1l55.9-111.5s12.2-30.4 46.4-30.4h35.1z"
        ],
        "vuejs": [
            448,
            512,
            [],
            "f41f",
            "M356.9 64.3H280l-56 88.6-48-88.6H0L224 448 448 64.3h-91.1zm-301.2 32h53.8L224 294.5 338.4 96.3h53.8L224 384.5 55.7 96.3z"
        ],
        "watchman-monitoring": [
            512,
            512,
            [],
            "e087",
            "M256,16C123.452,16,16,123.452,16,256S123.452,496,256,496,496,388.548,496,256,388.548,16,256,16ZM121.69,429.122C70.056,388.972,36.741,326.322,36.741,256a218.519,218.519,0,0,1,9.587-64.122l102.9-17.895-.121,10.967-13.943,2.013s-.144,12.5-.144,19.549a12.778,12.778,0,0,0,4.887,10.349l9.468,7.4Zm105.692-283.27,8.48-7.618s6.934-5.38-.143-9.344c-7.188-4.024-39.53-34.5-39.53-34.5-5.348-5.477-8.257-7.347-15.46,0,0,0-32.342,30.474-39.529,34.5-7.078,3.964-.144,9.344-.144,9.344l8.481,7.618-.048,4.369L75.982,131.045c39.644-56.938,105.532-94.3,180.018-94.3A218.754,218.754,0,0,1,420.934,111.77l-193.512,37.7Zm34.063,329.269-33.9-250.857,9.467-7.4a12.778,12.778,0,0,0,4.888-10.349c0-7.044-.144-19.549-.144-19.549l-13.943-2.013-.116-10.474,241.711,31.391A218.872,218.872,0,0,1,475.259,256C475.259,375.074,379.831,472.212,261.445,475.121Z"
        ],
        "waze": [
            512,
            512,
            [],
            "f83f",
            "M502.17 201.67C516.69 287.53 471.23 369.59 389 409.8c13 34.1-12.4 70.2-48.32 70.2a51.68 51.68 0 0 1-51.57-49c-6.44.19-64.2 0-76.33-.64A51.69 51.69 0 0 1 159 479.92c-33.86-1.36-57.95-34.84-47-67.92-37.21-13.11-72.54-34.87-99.62-70.8-13-17.28-.48-41.8 20.84-41.8 46.31 0 32.22-54.17 43.15-110.26C94.8 95.2 193.12 32 288.09 32c102.48 0 197.15 70.67 214.08 169.67zM373.51 388.28c42-19.18 81.33-56.71 96.29-102.14 40.48-123.09-64.15-228-181.71-228-83.45 0-170.32 55.42-186.07 136-9.53 48.91 5 131.35-68.75 131.35C58.21 358.6 91.6 378.11 127 389.54c24.66-21.8 63.87-15.47 79.83 14.34 14.22 1 79.19 1.18 87.9.82a51.69 51.69 0 0 1 78.78-16.42zM205.12 187.13c0-34.74 50.84-34.75 50.84 0s-50.84 34.74-50.84 0zm116.57 0c0-34.74 50.86-34.75 50.86 0s-50.86 34.75-50.86 0zm-122.61 70.69c-3.44-16.94 22.18-22.18 25.62-5.21l.06.28c4.14 21.42 29.85 44 64.12 43.07 35.68-.94 59.25-22.21 64.11-42.77 4.46-16.05 28.6-10.36 25.47 6-5.23 22.18-31.21 62-91.46 62.9-42.55 0-80.88-27.84-87.9-64.25z"
        ],
        "weebly": [
            512,
            512,
            [],
            "f5cc",
            "M425.09 65.83c-39.88 0-73.28 25.73-83.66 64.33-18.16-58.06-65.5-64.33-84.95-64.33-19.78 0-66.8 6.28-85.28 64.33-10.38-38.6-43.45-64.33-83.66-64.33C38.59 65.83 0 99.72 0 143.03c0 28.96 4.18 33.27 77.17 233.48 22.37 60.57 67.77 69.35 92.74 69.35 39.23 0 70.04-19.46 85.93-53.98 15.89 34.83 46.69 54.29 85.93 54.29 24.97 0 70.36-9.1 92.74-69.67 76.55-208.65 77.5-205.58 77.5-227.2.63-48.32-36.01-83.47-86.92-83.47zm26.34 114.81l-65.57 176.44c-7.92 21.49-21.22 37.22-46.24 37.22-23.44 0-37.38-12.41-44.03-33.9l-39.28-117.42h-.95L216.08 360.4c-6.96 21.5-20.9 33.6-44.02 33.6-25.02 0-38.33-15.74-46.24-37.22L60.88 181.55c-5.38-14.83-7.92-23.91-7.92-34.5 0-16.34 15.84-29.36 38.33-29.36 18.69 0 31.99 11.8 36.11 29.05l44.03 139.82h.95l44.66-136.79c6.02-19.67 16.47-32.08 38.96-32.08s32.94 12.11 38.96 32.08l44.66 136.79h.95l44.03-139.82c4.12-17.25 17.42-29.05 36.11-29.05 22.17 0 38.33 13.32 38.33 35.71-.32 7.87-4.12 16.04-7.61 27.24z"
        ],
        "weibo": [
            512,
            512,
            [],
            "f18a",
            "M407 177.6c7.6-24-13.4-46.8-37.4-41.7-22 4.8-28.8-28.1-7.1-32.8 50.1-10.9 92.3 37.1 76.5 84.8-6.8 21.2-38.8 10.8-32-10.3zM214.8 446.7C108.5 446.7 0 395.3 0 310.4c0-44.3 28-95.4 76.3-143.7C176 67 279.5 65.8 249.9 161c-4 13.1 12.3 5.7 12.3 6 79.5-33.6 140.5-16.8 114 51.4-3.7 9.4 1.1 10.9 8.3 13.1 135.7 42.3 34.8 215.2-169.7 215.2zm143.7-146.3c-5.4-55.7-78.5-94-163.4-85.7-84.8 8.6-148.8 60.3-143.4 116s78.5 94 163.4 85.7c84.8-8.6 148.8-60.3 143.4-116zM347.9 35.1c-25.9 5.6-16.8 43.7 8.3 38.3 72.3-15.2 134.8 52.8 111.7 124-7.4 24.2 29.1 37 37.4 12 31.9-99.8-55.1-195.9-157.4-174.3zm-78.5 311c-17.1 38.8-66.8 60-109.1 46.3-40.8-13.1-58-53.4-40.3-89.7 17.7-35.4 63.1-55.4 103.4-45.1 42 10.8 63.1 50.2 46 88.5zm-86.3-30c-12.9-5.4-30 .3-38 12.9-8.3 12.9-4.3 28 8.6 34 13.1 6 30.8.3 39.1-12.9 8-13.1 3.7-28.3-9.7-34zm32.6-13.4c-5.1-1.7-11.4.6-14.3 5.4-2.9 5.1-1.4 10.6 3.7 12.9 5.1 2 11.7-.3 14.6-5.4 2.8-5.2 1.1-10.9-4-12.9z"
        ],
        "weixin": [
            576,
            512,
            [],
            "f1d7",
            "M385.2 167.6c6.4 0 12.6.3 18.8 1.1C387.4 90.3 303.3 32 207.7 32 100.5 32 13 104.8 13 197.4c0 53.4 29.3 97.5 77.9 131.6l-19.3 58.6 68-34.1c24.4 4.8 43.8 9.7 68.2 9.7 6.2 0 12.1-.3 18.3-.8-4-12.9-6.2-26.6-6.2-40.8-.1-84.9 72.9-154 165.3-154zm-104.5-52.9c14.5 0 24.2 9.7 24.2 24.4 0 14.5-9.7 24.2-24.2 24.2-14.8 0-29.3-9.7-29.3-24.2.1-14.7 14.6-24.4 29.3-24.4zm-136.4 48.6c-14.5 0-29.3-9.7-29.3-24.2 0-14.8 14.8-24.4 29.3-24.4 14.8 0 24.4 9.7 24.4 24.4 0 14.6-9.6 24.2-24.4 24.2zM563 319.4c0-77.9-77.9-141.3-165.4-141.3-92.7 0-165.4 63.4-165.4 141.3S305 460.7 397.6 460.7c19.3 0 38.9-5.1 58.6-9.9l53.4 29.3-14.8-48.6C534 402.1 563 363.2 563 319.4zm-219.1-24.5c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.8 0 24.4 9.7 24.4 19.3 0 10-9.7 19.6-24.4 19.6zm107.1 0c-9.7 0-19.3-9.7-19.3-19.6 0-9.7 9.7-19.3 19.3-19.3 14.5 0 24.4 9.7 24.4 19.3.1 10-9.9 19.6-24.4 19.6z"
        ],
        "whatsapp": [
            448,
            512,
            [],
            "f232",
            "M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"
        ],
        "whatsapp-square": [
            448,
            512,
            [],
            "f40c",
            "M224 122.8c-72.7 0-131.8 59.1-131.9 131.8 0 24.9 7 49.2 20.2 70.1l3.1 5-13.3 48.6 49.9-13.1 4.8 2.9c20.2 12 43.4 18.4 67.1 18.4h.1c72.6 0 133.3-59.1 133.3-131.8 0-35.2-15.2-68.3-40.1-93.2-25-25-58-38.7-93.2-38.7zm77.5 188.4c-3.3 9.3-19.1 17.7-26.7 18.8-12.6 1.9-22.4.9-47.5-9.9-39.7-17.2-65.7-57.2-67.7-59.8-2-2.6-16.2-21.5-16.2-41s10.2-29.1 13.9-33.1c3.6-4 7.9-5 10.6-5 2.6 0 5.3 0 7.6.1 2.4.1 5.7-.9 8.9 6.8 3.3 7.9 11.2 27.4 12.2 29.4s1.7 4.3.3 6.9c-7.6 15.2-15.7 14.6-11.6 21.6 15.3 26.3 30.6 35.4 53.9 47.1 4 2 6.3 1.7 8.6-1 2.3-2.6 9.9-11.6 12.5-15.5 2.6-4 5.3-3.3 8.9-2 3.6 1.3 23.1 10.9 27.1 12.9s6.6 3 7.6 4.6c.9 1.9.9 9.9-2.4 19.1zM400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM223.9 413.2c-26.6 0-52.7-6.7-75.8-19.3L64 416l22.5-82.2c-13.9-24-21.2-51.3-21.2-79.3C65.4 167.1 136.5 96 223.9 96c42.4 0 82.2 16.5 112.2 46.5 29.9 30 47.9 69.8 47.9 112.2 0 87.4-72.7 158.5-160.1 158.5z"
        ],
        "whmcs": [
            448,
            512,
            [],
            "f40d",
            "M448 161v-21.3l-28.5-8.8-2.2-10.4 20.1-20.7L427 80.4l-29 7.5-7.2-7.5 7.5-28.2-19.1-11.6-21.3 21-10.7-3.2-7-26.4h-22.6l-6.2 26.4-12.1 3.2-19.7-21-19.4 11 8.1 27.7-8.1 8.4-28.5-7.5-11 19.1 20.7 21-2.9 10.4-28.5 7.8-.3 21.7 28.8 7.5 2.4 12.1-20.1 19.9 10.4 18.5 29.6-7.5 7.2 8.6-8.1 26.9 19.9 11.6 19.4-20.4 11.6 2.9 6.7 28.5 22.6.3 6.7-28.8 11.6-3.5 20.7 21.6 20.4-12.1-8.8-28 7.8-8.1 28.8 8.8 10.3-20.1-20.9-18.8 2.2-12.1 29.1-7zm-119.2 45.2c-31.3 0-56.8-25.4-56.8-56.8s25.4-56.8 56.8-56.8 56.8 25.4 56.8 56.8c0 31.5-25.4 56.8-56.8 56.8zm72.3 16.4l46.9 14.5V277l-55.1 13.4-4.1 22.7 38.9 35.3-19.2 37.9-54-16.7-14.6 15.2 16.7 52.5-38.3 22.7-38.9-40.5-21.7 6.6-12.6 54-42.4-.5-12.6-53.6-21.7-5.6-36.4 38.4-37.4-21.7 15.2-50.5-13.7-16.1-55.5 14.1-19.7-34.8 37.9-37.4-4.8-22.8-54-14.1.5-40.9L54 219.9l5.7-19.7-38.9-39.4L41.5 125l53.6 14.1 15.2-15.7-15.2-52 36.4-20.7 36.8 39.4L191 84l11.6-52H245l11.6 45.9L234 72l-6.3-1.7-3.3 5.7-11 19.1-3.3 5.6 4.6 4.6 17.2 17.4-.3 1-23.8 6.5-6.2 1.7-.1 6.4-.2 12.9C153.8 161.6 118 204 118 254.7c0 58.3 47.3 105.7 105.7 105.7 50.5 0 92.7-35.4 103.2-82.8l13.2.2 6.9.1 1.6-6.7 5.6-24 1.9-.6 17.1 17.8 4.7 4.9 5.8-3.4 20.4-12.1 5.8-3.5-2-6.5-6.8-21.2z"
        ],
        "wikipedia-w": [
            640,
            512,
            [],
            "f266",
            "M640 51.2l-.3 12.2c-28.1.8-45 15.8-55.8 40.3-25 57.8-103.3 240-155.3 358.6H415l-81.9-193.1c-32.5 63.6-68.3 130-99.2 193.1-.3.3-15 0-15-.3C172 352.3 122.8 243.4 75.8 133.4 64.4 106.7 26.4 63.4.2 63.7c0-3.1-.3-10-.3-14.2h161.9v13.9c-19.2 1.1-52.8 13.3-43.3 34.2 21.9 49.7 103.6 240.3 125.6 288.6 15-29.7 57.8-109.2 75.3-142.8-13.9-28.3-58.6-133.9-72.8-160-9.7-17.8-36.1-19.4-55.8-19.7V49.8l142.5.3v13.1c-19.4.6-38.1 7.8-29.4 26.1 18.9 40 30.6 68.1 48.1 104.7 5.6-10.8 34.7-69.4 48.1-100.8 8.9-20.6-3.9-28.6-38.6-29.4.3-3.6 0-10.3.3-13.6 44.4-.3 111.1-.3 123.1-.6v13.6c-22.5.8-45.8 12.8-58.1 31.7l-59.2 122.8c6.4 16.1 63.3 142.8 69.2 156.7L559.2 91.8c-8.6-23.1-36.4-28.1-47.2-28.3V49.6l127.8 1.1.2.5z"
        ],
        "windows": [
            448,
            512,
            [],
            "f17a",
            "M0 93.7l183.6-25.3v177.4H0V93.7zm0 324.6l183.6 25.3V268.4H0v149.9zm203.8 28L448 480V268.4H203.8v177.9zm0-380.6v180.1H448V32L203.8 65.7z"
        ],
        "wix": [
            640,
            512,
            [],
            "f5cf",
            "M393.38 131.69c0 13.03 2.08 32.69-28.68 43.83-9.52 3.45-15.95 9.66-15.95 9.66 0-31 4.72-42.22 17.4-48.86 9.75-5.11 27.23-4.63 27.23-4.63zm-115.8 35.54l-34.24 132.66-28.48-108.57c-7.69-31.99-20.81-48.53-48.43-48.53-27.37 0-40.66 16.18-48.43 48.53L89.52 299.89 55.28 167.23C49.73 140.51 23.86 128.96 0 131.96l65.57 247.93s21.63 1.56 32.46-3.96c14.22-7.25 20.98-12.84 29.59-46.57 7.67-30.07 29.11-118.41 31.12-124.7 4.76-14.94 11.09-13.81 15.4 0 1.97 6.3 23.45 94.63 31.12 124.7 8.6 33.73 15.37 39.32 29.59 46.57 10.82 5.52 32.46 3.96 32.46 3.96l65.57-247.93c-24.42-3.07-49.82 8.93-55.3 35.27zm115.78 5.21s-4.1 6.34-13.46 11.57c-6.01 3.36-11.78 5.64-17.97 8.61-15.14 7.26-13.18 13.95-13.18 35.2v152.07s16.55 2.09 27.37-3.43c13.93-7.1 17.13-13.95 17.26-44.78V181.41l-.02.01v-8.98zm163.44 84.08L640 132.78s-35.11-5.98-52.5 9.85c-13.3 12.1-24.41 29.55-54.18 72.47-.47.73-6.25 10.54-13.07 0-29.29-42.23-40.8-60.29-54.18-72.47-17.39-15.83-52.5-9.85-52.5-9.85l83.2 123.74-82.97 123.36s36.57 4.62 53.95-11.21c11.49-10.46 17.58-20.37 52.51-70.72 6.81-10.52 12.57-.77 13.07 0 29.4 42.38 39.23 58.06 53.14 70.72 17.39 15.83 53.32 11.21 53.32 11.21L556.8 256.52z"
        ],
        "wizards-of-the-coast": [
            640,
            512,
            [],
            "f730",
            "M219.19 345.69c-1.9 1.38-11.07 8.44-.26 23.57 4.64 6.42 14.11 12.79 21.73 6.55 6.5-4.88 7.35-12.92.26-23.04-5.47-7.76-14.28-12.88-21.73-7.08zm336.75 75.94c-.34 1.7-.55 1.67.79 0 2.09-4.19 4.19-10.21 4.98-19.9 3.14-38.49-40.33-71.49-101.34-78.03-54.73-6.02-124.38 9.17-188.8 60.49l-.26 1.57c2.62 4.98 4.98 10.74 3.4 21.21l.79.26c63.89-58.4 131.19-77.25 184.35-73.85 58.4 3.67 100.03 34.04 100.03 68.08-.01 9.96-2.63 15.72-3.94 20.17zM392.28 240.42c.79 7.07 4.19 10.21 9.17 10.47 5.5.26 9.43-2.62 10.47-6.55.79-3.4 2.09-29.85 2.09-29.85s-11.26 6.55-14.93 10.47c-3.66 3.68-7.33 8.39-6.8 15.46zm-50.02-151.1C137.75 89.32 13.1 226.8.79 241.2c-1.05.52-1.31.79.79 1.31 60.49 16.5 155.81 81.18 196.13 202.16l1.05.26c55.25-69.92 140.88-128.05 236.99-128.05 80.92 0 130.15 42.16 130.15 80.39 0 18.33-6.55 33.52-22.26 46.35 0 .96-.2.79.79.79 14.66-10.74 27.5-28.8 27.5-48.18 0-22.78-12.05-38.23-12.05-38.23 7.07 7.07 10.74 16.24 10.74 16.24 5.76-40.85 26.97-62.32 26.97-62.32-2.36-9.69-6.81-17.81-6.81-17.81 7.59 8.12 14.4 27.5 14.4 41.37 0 10.47-3.4 22.78-12.57 31.95l.26.52c8.12-4.98 16.5-16.76 16.5-37.97 0-15.71-4.71-25.92-4.71-25.92 5.76-5.24 11.26-9.17 15.97-11.78.79 3.4 2.09 9.69 2.36 14.93 0 1.05.79 1.83 1.05 0 .79-5.76-.26-16.24-.26-16.5 6.02-3.14 9.69-4.45 9.69-4.45C617.74 176 489.43 89.32 342.26 89.32zm-99.24 289.62c-11.06 8.99-24.2 4.08-30.64-4.19-7.45-9.58-6.76-24.09 4.19-32.47 14.85-11.35 27.08-.49 31.16 5.5.28.39 12.13 16.57-4.71 31.16zm2.09-136.43l9.43-17.81 11.78 70.96-12.57 6.02-24.62-28.8 14.14-26.71 3.67 4.45-1.83-8.11zm18.59 117.58l-.26-.26c2.05-4.1-2.5-6.61-17.54-31.69-1.31-2.36-3.14-2.88-4.45-2.62l-.26-.52c7.86-5.76 15.45-10.21 25.4-15.71l.52.26c1.31 1.83 2.09 2.88 3.4 4.71l-.26.52c-1.05-.26-2.36-.79-5.24.26-2.09.79-7.86 3.67-12.31 7.59v1.31c1.57 2.36 3.93 6.55 5.76 9.69h.26c10.05-6.28 7.56-4.55 11.52-7.86h.26c.52 1.83.52 1.83 1.83 5.5l-.26.26c-3.06.61-4.65.34-11.52 5.5v.26c9.46 17.02 11.01 16.75 12.57 15.97l.26.26c-2.34 1.59-6.27 4.21-9.68 6.57zm55.26-32.47c-3.14 1.57-6.02 2.88-9.95 4.98l-.26-.26c1.29-2.59 1.16-2.71-11.78-32.47l-.26-.26c-.15 0-8.9 3.65-9.95 7.33h-.52l-1.05-5.76.26-.52c7.29-4.56 25.53-11.64 27.76-12.57l.52.26 3.14 4.98-.26.52c-3.53-1.76-7.35.76-12.31 2.62v.26c12.31 32.01 12.67 30.64 14.66 30.64v.25zm44.77-16.5c-4.19 1.05-5.24 1.31-9.69 2.88l-.26-.26.52-4.45c-1.05-3.4-3.14-11.52-3.67-13.62l-.26-.26c-3.4.79-8.9 2.62-12.83 3.93l-.26.26c.79 2.62 3.14 9.95 4.19 13.88.79 2.36 1.83 2.88 2.88 3.14v.52c-3.67 1.05-7.07 2.62-10.21 3.93l-.26-.26c1.05-1.31 1.05-2.88.26-4.98-1.05-3.14-8.12-23.83-9.17-27.23-.52-1.83-1.57-3.14-2.62-3.14v-.52c3.14-1.05 6.02-2.09 10.74-3.4l.26.26-.26 4.71c1.31 3.93 2.36 7.59 3.14 9.69h.26c3.93-1.31 9.43-2.88 12.83-3.93l.26-.26-2.62-9.43c-.52-1.83-1.05-3.4-2.62-3.93v-.26c4.45-1.05 7.33-1.83 10.74-2.36l.26.26c-1.05 1.31-1.05 2.88-.52 4.45 1.57 6.28 4.71 20.43 6.28 26.45.54 2.62 1.85 3.41 2.63 3.93zm32.21-6.81l-.26.26c-4.71.52-14.14 2.36-22.52 4.19l-.26-.26.79-4.19c-1.57-7.86-3.4-18.59-4.98-26.19-.26-1.83-.79-2.88-2.62-3.67l.79-.52c9.17-1.57 20.16-2.36 24.88-2.62l.26.26c.52 2.36.79 3.14 1.57 5.5l-.26.26c-1.14-1.14-3.34-3.2-16.24-.79l-.26.26c.26 1.57 1.05 6.55 1.57 9.95l.26.26c9.52-1.68 4.76-.06 10.74-2.36h.26c0 1.57-.26 1.83-.26 5.24h-.26c-4.81-1.03-2.15-.9-10.21 0l-.26.26c.26 2.09 1.57 9.43 2.09 12.57l.26.26c1.15.38 14.21-.65 16.24-4.71h.26c-.53 2.38-1.05 4.21-1.58 6.04zm10.74-44.51c-4.45 2.36-8.12 2.88-11 2.88-.25.02-11.41 1.09-17.54-9.95-6.74-10.79-.98-25.2 5.5-31.69 8.8-8.12 23.35-10.1 28.54-17.02 8.03-10.33-13.04-22.31-29.59-5.76l-2.62-2.88 5.24-16.24c25.59-1.57 45.2-3.04 50.02 16.24.79 3.14 0 9.43-.26 12.05 0 2.62-1.83 18.85-2.09 23.04-.52 4.19-.79 18.33-.79 20.69.26 2.36.52 4.19 1.57 5.5 1.57 1.83 5.76 1.83 5.76 1.83l-.79 4.71c-11.82-1.07-10.28-.59-20.43-1.05-3.22-5.15-2.23-3.28-4.19-7.86 0 .01-4.19 3.94-7.33 5.51zm37.18 21.21c-6.35-10.58-19.82-7.16-21.73 5.5-2.63 17.08 14.3 19.79 20.69 10.21l.26.26c-.52 1.83-1.83 6.02-1.83 6.28l-.52.52c-10.3 6.87-28.5-2.5-25.66-18.59 1.94-10.87 14.44-18.93 28.8-9.95l.26.52c0 1.06-.27 3.41-.27 5.25zm5.77-87.73v-6.55c.69 0 19.65 3.28 27.76 7.33l-1.57 17.54s10.21-9.43 15.45-10.74c5.24-1.57 14.93 7.33 14.93 7.33l-11.26 11.26c-12.07-6.35-19.59-.08-20.69.79-5.29 38.72-8.6 42.17 4.45 46.09l-.52 4.71c-17.55-4.29-18.53-4.5-36.92-7.33l.79-4.71c7.25 0 7.48-5.32 7.59-6.81 0 0 4.98-53.16 4.98-55.25-.02-2.87-4.99-3.66-4.99-3.66zm10.99 114.44c-8.12-2.09-14.14-11-10.74-20.69 3.14-9.43 12.31-12.31 18.85-10.21 9.17 2.62 12.83 11.78 10.74 19.38-2.61 8.9-9.42 13.87-18.85 11.52zm42.16 9.69c-2.36-.52-7.07-2.36-8.64-2.88v-.26l1.57-1.83c.59-8.24.59-7.27.26-7.59-4.82-1.81-6.66-2.36-7.07-2.36-1.31 1.83-2.88 4.45-3.67 5.5l-.79 3.4v.26c-1.31-.26-3.93-1.31-6.02-1.57v-.26l2.62-1.83c3.4-4.71 9.95-14.14 13.88-20.16v-2.09l.52-.26c2.09.79 5.5 2.09 7.59 2.88.48.48.18-1.87-1.05 25.14-.24 1.81.02 2.6.8 3.91zm-4.71-89.82c11.25-18.27 30.76-16.19 34.04-3.4L539.7 198c2.34-6.25-2.82-9.9-4.45-11.26l1.83-3.67c12.22 10.37 16.38 13.97 22.52 20.43-25.91 73.07-30.76 80.81-24.62 84.32l-1.83 4.45c-6.37-3.35-8.9-4.42-17.81-8.64l2.09-6.81c-.26-.26-3.93 3.93-9.69 3.67-19.06-1.3-22.89-31.75-9.67-52.9zm29.33 79.34c0-5.71-6.34-7.89-7.86-5.24-1.31 2.09 1.05 4.98 2.88 8.38 1.57 2.62 2.62 6.28 1.05 9.43-2.64 6.34-12.4 5.31-15.45-.79 0-.7-.27.09 1.83-4.71l.79-.26c-.57 5.66 6.06 9.61 8.38 4.98 1.05-2.09-.52-5.5-2.09-8.38-1.57-2.62-3.67-6.28-1.83-9.69 2.72-5.06 11.25-4.47 14.66 2.36v.52l-2.36 3.4zm21.21 13.36c-1.96-3.27-.91-2.14-4.45-4.71h-.26c-2.36 4.19-5.76 10.47-8.64 16.24-1.31 2.36-1.05 3.4-.79 3.93l-.26.26-5.76-4.45.26-.26 2.09-1.31c3.14-5.76 6.55-12.05 9.17-17.02v-.26c-2.64-1.98-1.22-1.51-6.02-1.83v-.26l3.14-3.4h.26c3.67 2.36 9.95 6.81 12.31 8.9l.26.26-1.31 3.91zm27.23-44.26l-2.88-2.88c.79-2.36 1.83-4.98 2.09-7.59.75-9.74-11.52-11.84-11.52-4.98 0 4.98 7.86 19.38 7.86 27.76 0 10.21-5.76 15.71-13.88 16.5-8.38.79-20.16-10.47-20.16-10.47l4.98-14.4 2.88 2.09c-2.97 17.8 17.68 20.37 13.35 5.24-1.06-4.02-18.75-34.2 2.09-38.23 13.62-2.36 23.04 16.5 23.04 16.5l-7.85 10.46zm35.62-10.21c-11-30.38-60.49-127.53-191.95-129.62-53.42-1.05-94.27 15.45-132.76 37.97l85.63-9.17-91.39 20.69 25.14 19.64-3.93-16.5c7.5-1.71 39.15-8.45 66.77-8.9l-22.26 80.39c13.61-.7 18.97-8.98 19.64-22.78l4.98-1.05.26 26.71c-22.46 3.21-37.3 6.69-49.49 9.95l13.09-43.21-61.54-36.66 2.36 8.12 10.21 4.98c6.28 18.59 19.38 56.56 20.43 58.66 1.95 4.28 3.16 5.78 12.05 4.45l1.05 4.98c-16.08 4.86-23.66 7.61-39.02 14.4l-2.36-4.71c4.4-2.94 8.73-3.94 5.5-12.83-23.7-62.5-21.48-58.14-22.78-59.44l2.36-4.45 33.52 67.3c-3.84-11.87 1.68 1.69-32.99-78.82l-41.9 88.51 4.71-13.88-35.88-42.16 27.76 93.48-11.78 8.38C95 228.58 101.05 231.87 93.23 231.52c-5.5-.26-13.62 5.5-13.62 5.5L74.63 231c30.56-23.53 31.62-24.33 58.4-42.68l4.19 7.07s-5.76 4.19-7.86 7.07c-5.9 9.28 1.67 13.28 61.8 75.68l-18.85-58.92 39.8-10.21 25.66 30.64 4.45-12.31-4.98-24.62 13.09-3.4.52 3.14 3.67-10.47-94.27 29.33 11.26-4.98-13.62-42.42 17.28-9.17 30.11 36.14 28.54-13.09c-1.41-7.47-2.47-14.5-4.71-19.64l17.28 13.88 4.71-2.09-59.18-42.68 23.08 11.5c18.98-6.07 25.23-7.47 32.21-9.69l2.62 11c-12.55 12.55 1.43 16.82 6.55 19.38l-13.62-61.01 12.05 28.28c4.19-1.31 7.33-2.09 7.33-2.09l2.62 8.64s-3.14 1.05-6.28 2.09l8.9 20.95 33.78-65.73-20.69 61.01c42.42-24.09 81.44-36.66 131.98-35.88 67.04 1.05 167.33 40.85 199.8 139.83.78 2.1-.01 2.63-.79.27zM203.48 152.43s1.83-.52 4.19-1.31l9.43 7.59c-.4 0-3.44-.25-11.26 2.36l-2.36-8.64zm143.76 38.5c-1.57-.6-26.46-4.81-33.26 20.69l21.73 17.02 11.53-37.71zM318.43 67.07c-58.4 0-106.05 12.05-114.96 14.4v.79c8.38 2.09 14.4 4.19 21.21 11.78l1.57.26c6.55-1.83 48.97-13.88 110.24-13.88 180.16 0 301.67 116.79 301.67 223.37v9.95c0 1.31.79 2.62 1.05.52.52-2.09.79-8.64.79-19.64.26-83.79-96.63-227.55-321.57-227.55zm211.06 169.68c1.31-5.76 0-12.31-7.33-13.09-9.62-1.13-16.14 23.79-17.02 33.52-.79 5.5-1.31 14.93 6.02 14.93 4.68-.01 9.72-.91 18.33-35.36zm-61.53 42.95c-2.62-.79-9.43-.79-12.57 10.47-1.83 6.81.52 13.35 6.02 14.66 3.67 1.05 8.9.52 11.78-10.74 2.62-9.94-1.83-13.61-5.23-14.39zM491 300.65c1.83.52 3.14 1.05 5.76 1.83 0-1.83.52-8.38.79-12.05-1.05 1.31-5.5 8.12-6.55 9.95v.27z"
        ],
        "wodu": [
            640,
            512,
            [],
            "e088",
            "M178.414 339.706H141.1L112.166 223.475h-.478L83.228 339.706H45.2L0 168.946H37.548L64.574 285.177h.478L94.707 168.946h35.157l29.178 117.667h.479L187.5 168.946h36.831zM271.4 212.713c38.984 0 64.1 25.828 64.1 65.291 0 39.222-25.111 65.05-64.1 65.05-38.743 0-63.855-25.828-63.855-65.05C207.547 238.541 232.659 212.713 271.4 212.713zm0 104.753c23.2 0 30.133-19.852 30.133-39.462 0-19.852-6.934-39.7-30.133-39.7-27.7 0-29.894 19.85-29.894 39.7C241.508 297.614 248.443 317.466 271.4 317.466zM435.084 323.922h-.478c-7.893 13.392-21.765 19.132-37.548 19.132-37.31 0-55.485-32.045-55.485-66.246 0-33.243 18.415-64.095 54.767-64.095 14.589 0 28.938 6.218 36.831 18.416h.24V168.946h33.96v170.76H435.084zM405.428 238.3c-22.24 0-29.894 19.134-29.894 39.463 0 19.371 8.848 39.7 29.894 39.7 22.482 0 29.178-19.613 29.178-39.94C434.606 257.436 427.432 238.3 405.428 238.3zM592.96 339.706H560.673V322.487h-.718c-8.609 13.87-23.436 20.567-37.786 20.567-36.113 0-45.2-20.328-45.2-50.941V216.061h33.959V285.9c0 20.329 5.979 30.372 21.765 30.372 18.415 0 26.306-10.283 26.306-35.393V216.061H592.96zM602.453 302.876H640v36.83H602.453z"
        ],
        "wolf-pack-battalion": [
            512,
            512,
            [],
            "f514",
            "M267.73 471.53l10.56 15.84 5.28-12.32 5.28 7V512c21.06-7.92 21.11-66.86 25.51-97.21 4.62-31.89-.88-92.81 81.37-149.11-8.88-23.61-12-49.43-2.64-80.05C421 189 447 196.21 456.43 239.73l-30.35 8.36c11.15 23 17 46.76 13.2 72.14L412 313.18l-6.16 33.43-18.47-7-8.8 33.39-19.35-7 26.39 21.11 8.8-28.15L419 364.2l7-35.63 26.39 14.52c.25-20 7-58.06-8.8-84.45l26.39 5.28c4-22.07-2.38-39.21-7.92-56.74l22.43 9.68c-.44-25.07-29.94-56.79-61.58-58.5-20.22-1.09-56.74-25.17-54.1-51.9 2-19.87 17.45-42.62 43.11-49.7-44 36.51-9.68 67.3 5.28 73.46 4.4-11.44 17.54-69.08 0-130.2-40.39 22.87-89.65 65.1-93.2 147.79l-58 38.71-3.52 93.25L369.78 220l7 7-17.59 3.52-44 38.71-15.84-5.28-28.1 49.25-3.52 119.64 21.11 15.84-32.55 15.84-32.55-15.84 21.11-15.84-3.52-119.64-28.15-49.26-15.84 5.28-44-38.71-17.58-3.51 7-7 107.33 59.82-3.52-93.25-58.06-38.71C185 65.1 135.77 22.87 95.3 0c-17.54 61.12-4.4 118.76 0 130.2 15-6.16 49.26-36.95 5.28-73.46 25.66 7.08 41.15 29.83 43.11 49.7 2.63 26.74-33.88 50.81-54.1 51.9-31.65 1.72-61.15 33.44-61.59 58.51l22.43-9.68c-5.54 17.53-11.91 34.67-7.92 56.74l26.39-5.28c-15.76 26.39-9.05 64.43-8.8 84.45l26.39-14.52 7 35.63 24.63-5.28 8.8 28.15L153.35 366 134 373l-8.8-33.43-18.47 7-6.16-33.43-27.27 7c-3.82-25.38 2-49.1 13.2-72.14l-30.35-8.36c9.4-43.52 35.47-50.77 63.34-54.1 9.36 30.62 6.24 56.45-2.64 80.05 82.25 56.3 76.75 117.23 81.37 149.11 4.4 30.35 4.45 89.29 25.51 97.21v-29.83l5.28-7 5.28 12.32 10.56-15.84 11.44 21.11 11.43-21.1zm79.17-95L331.06 366c7.47-4.36 13.76-8.42 19.35-12.32-.6 7.22-.27 13.84-3.51 22.84zm28.15-49.26c-.4 10.94-.9 21.66-1.76 31.67-7.85-1.86-15.57-3.8-21.11-7 8.24-7.94 15.55-16.32 22.87-24.68zm24.63 5.28c0-13.43-2.05-24.21-5.28-33.43a235 235 0 0 1-18.47 27.27zm3.52-80.94c19.44 12.81 27.8 33.66 29.91 56.3-12.32-4.53-24.63-9.31-36.95-10.56 5.06-12 6.65-28.14 7-45.74zm-1.76-45.74c.81 14.3 1.84 28.82 1.76 42.23 19.22-8.11 29.78-9.72 44-14.08-10.61-18.96-27.2-25.53-45.76-28.16zM165.68 376.52L181.52 366c-7.47-4.36-13.76-8.42-19.35-12.32.6 7.26.27 13.88 3.51 22.88zm-28.15-49.26c.4 10.94.9 21.66 1.76 31.67 7.85-1.86 15.57-3.8 21.11-7-8.24-7.93-15.55-16.31-22.87-24.67zm-24.64 5.28c0-13.43 2-24.21 5.28-33.43a235 235 0 0 0 18.47 27.27zm-3.52-80.94c-19.44 12.81-27.8 33.66-29.91 56.3 12.32-4.53 24.63-9.31 37-10.56-5-12-6.65-28.14-7-45.74zm1.76-45.74c-.81 14.3-1.84 28.82-1.76 42.23-19.22-8.11-29.78-9.72-44-14.08 10.63-18.95 27.23-25.52 45.76-28.15z"
        ],
        "wordpress": [
            512,
            512,
            [],
            "f19a",
            "M61.7 169.4l101.5 278C92.2 413 43.3 340.2 43.3 256c0-30.9 6.6-60.1 18.4-86.6zm337.9 75.9c0-26.3-9.4-44.5-17.5-58.7-10.8-17.5-20.9-32.4-20.9-49.9 0-19.6 14.8-37.8 35.7-37.8.9 0 1.8.1 2.8.2-37.9-34.7-88.3-55.9-143.7-55.9-74.3 0-139.7 38.1-177.8 95.9 5 .2 9.7.3 13.7.3 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l77.5 230.4L249.8 247l-33.1-90.8c-11.5-.7-22.3-2-22.3-2-11.5-.7-10.1-18.2 1.3-17.5 0 0 35.1 2.7 56 2.7 22.2 0 56.7-2.7 56.7-2.7 11.5-.7 12.8 16.2 1.4 17.5 0 0-11.5 1.3-24.3 2l76.9 228.7 21.2-70.9c9-29.4 16-50.5 16-68.7zm-139.9 29.3l-63.8 185.5c19.1 5.6 39.2 8.7 60.1 8.7 24.8 0 48.5-4.3 70.6-12.1-.6-.9-1.1-1.9-1.5-2.9l-65.4-179.2zm183-120.7c.9 6.8 1.4 14 1.4 21.9 0 21.6-4 45.8-16.2 76.2l-65 187.9C426.2 403 468.7 334.5 468.7 256c0-37-9.4-71.8-26-102.1zM504 256c0 136.8-111.3 248-248 248C119.2 504 8 392.7 8 256 8 119.2 119.2 8 256 8c136.7 0 248 111.2 248 248zm-11.4 0c0-130.5-106.2-236.6-236.6-236.6C125.5 19.4 19.4 125.5 19.4 256S125.6 492.6 256 492.6c130.5 0 236.6-106.1 236.6-236.6z"
        ],
        "wordpress-simple": [
            512,
            512,
            [],
            "f411",
            "M256 8C119.3 8 8 119.2 8 256c0 136.7 111.3 248 248 248s248-111.3 248-248C504 119.2 392.7 8 256 8zM33 256c0-32.3 6.9-63 19.3-90.7l106.4 291.4C84.3 420.5 33 344.2 33 256zm223 223c-21.9 0-43-3.2-63-9.1l66.9-194.4 68.5 187.8c.5 1.1 1 2.1 1.6 3.1-23.1 8.1-48 12.6-74 12.6zm30.7-327.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-21.9 0-58.7-2.8-58.7-2.8-12-.7-13.4 17.7-1.4 18.4 0 0 11.4 1.4 23.4 2.1l34.7 95.2L200.6 393l-81.2-241.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-4.2 0-9.1-.1-14.4-.3C109.6 73 178.1 33 256 33c58 0 110.9 22.2 150.6 58.5-1-.1-1.9-.2-2.9-.2-21.9 0-37.4 19.1-37.4 39.6 0 18.4 10.6 33.9 21.9 52.3 8.5 14.8 18.4 33.9 18.4 61.5 0 19.1-7.3 41.2-17 72.1l-22.2 74.3-80.7-239.6zm81.4 297.2l68.1-196.9c12.7-31.8 17-57.2 17-79.9 0-8.2-.5-15.8-1.5-22.9 17.4 31.8 27.3 68.2 27.3 107 0 82.3-44.6 154.1-110.9 192.7z"
        ],
        "wpbeginner": [
            512,
            512,
            [],
            "f297",
            "M462.799 322.374C519.01 386.682 466.961 480 370.944 480c-39.602 0-78.824-17.687-100.142-50.04-6.887.356-22.702.356-29.59 0C219.848 462.381 180.588 480 141.069 480c-95.49 0-148.348-92.996-91.855-157.626C-29.925 190.523 80.479 32 256.006 32c175.632 0 285.87 158.626 206.793 290.374zm-339.647-82.972h41.529v-58.075h-41.529v58.075zm217.18 86.072v-23.839c-60.506 20.915-132.355 9.198-187.589-33.971l.246 24.897c51.101 46.367 131.746 57.875 187.343 32.913zm-150.753-86.072h166.058v-58.075H189.579v58.075z"
        ],
        "wpexplorer": [
            512,
            512,
            [],
            "f2de",
            "M512 256c0 141.2-114.7 256-256 256C114.8 512 0 397.3 0 256S114.7 0 256 0s256 114.7 256 256zm-32 0c0-123.2-100.3-224-224-224C132.5 32 32 132.5 32 256s100.5 224 224 224 224-100.5 224-224zM160.9 124.6l86.9 37.1-37.1 86.9-86.9-37.1 37.1-86.9zm110 169.1l46.6 94h-14.6l-50-100-48.9 100h-14l51.1-106.9-22.3-9.4 6-14 68.6 29.1-6 14.3-16.5-7.1zm-11.8-116.3l68.6 29.4-29.4 68.3L230 246l29.1-68.6zm80.3 42.9l54.6 23.1-23.4 54.3-54.3-23.1 23.1-54.3z"
        ],
        "wpforms": [
            448,
            512,
            [],
            "f298",
            "M448 75.2v361.7c0 24.3-19 43.2-43.2 43.2H43.2C19.3 480 0 461.4 0 436.8V75.2C0 51.1 18.8 32 43.2 32h361.7c24 0 43.1 18.8 43.1 43.2zm-37.3 361.6V75.2c0-3-2.6-5.8-5.8-5.8h-9.3L285.3 144 224 94.1 162.8 144 52.5 69.3h-9.3c-3.2 0-5.8 2.8-5.8 5.8v361.7c0 3 2.6 5.8 5.8 5.8h361.7c3.2.1 5.8-2.7 5.8-5.8zM150.2 186v37H76.7v-37h73.5zm0 74.4v37.3H76.7v-37.3h73.5zm11.1-147.3l54-43.7H96.8l64.5 43.7zm210 72.9v37h-196v-37h196zm0 74.4v37.3h-196v-37.3h196zm-84.6-147.3l64.5-43.7H232.8l53.9 43.7zM371.3 335v37.3h-99.4V335h99.4z"
        ],
        "wpressr": [
            496,
            512,
            [],
            "f3e4",
            "M248 8C111.03 8 0 119.03 0 256s111.03 248 248 248 248-111.03 248-248S384.97 8 248 8zm171.33 158.6c-15.18 34.51-30.37 69.02-45.63 103.5-2.44 5.51-6.89 8.24-12.97 8.24-23.02-.01-46.03.06-69.05-.05-5.12-.03-8.25 1.89-10.34 6.72-10.19 23.56-20.63 47-30.95 70.5-1.54 3.51-4.06 5.29-7.92 5.29-45.94-.01-91.87-.02-137.81 0-3.13 0-5.63-1.15-7.72-3.45-11.21-12.33-22.46-24.63-33.68-36.94-2.69-2.95-2.79-6.18-1.21-9.73 8.66-19.54 17.27-39.1 25.89-58.66 12.93-29.35 25.89-58.69 38.75-88.08 1.7-3.88 4.28-5.68 8.54-5.65 14.24.1 28.48.02 42.72.05 6.24.01 9.2 4.84 6.66 10.59-13.6 30.77-27.17 61.55-40.74 92.33-5.72 12.99-11.42 25.99-17.09 39-3.91 8.95 7.08 11.97 10.95 5.6.23-.37-1.42 4.18 30.01-67.69 1.36-3.1 3.41-4.4 6.77-4.39 15.21.08 30.43.02 45.64.04 5.56.01 7.91 3.64 5.66 8.75-8.33 18.96-16.71 37.9-24.98 56.89-4.98 11.43 8.08 12.49 11.28 5.33.04-.08 27.89-63.33 32.19-73.16 2.02-4.61 5.44-6.51 10.35-6.5 26.43.05 52.86 0 79.29.05 12.44.02 13.93-13.65 3.9-13.64-25.26.03-50.52.02-75.78.02-6.27 0-7.84-2.47-5.27-8.27 5.78-13.06 11.59-26.11 17.3-39.21 1.73-3.96 4.52-5.79 8.84-5.78 23.09.06 25.98.02 130.78.03 6.08-.01 8.03 2.79 5.62 8.27z"
        ],
        "xbox": [
            512,
            512,
            [],
            "f412",
            "M369.9 318.2c44.3 54.3 64.7 98.8 54.4 118.7-7.9 15.1-56.7 44.6-92.6 55.9-29.6 9.3-68.4 13.3-100.4 10.2-38.2-3.7-76.9-17.4-110.1-39C93.3 445.8 87 438.3 87 423.4c0-29.9 32.9-82.3 89.2-142.1 32-33.9 76.5-73.7 81.4-72.6 9.4 2.1 84.3 75.1 112.3 109.5zM188.6 143.8c-29.7-26.9-58.1-53.9-86.4-63.4-15.2-5.1-16.3-4.8-28.7 8.1-29.2 30.4-53.5 79.7-60.3 122.4-5.4 34.2-6.1 43.8-4.2 60.5 5.6 50.5 17.3 85.4 40.5 120.9 9.5 14.6 12.1 17.3 9.3 9.9-4.2-11-.3-37.5 9.5-64 14.3-39 53.9-112.9 120.3-194.4zm311.6 63.5C483.3 127.3 432.7 77 425.6 77c-7.3 0-24.2 6.5-36 13.9-23.3 14.5-41 31.4-64.3 52.8C367.7 197 427.5 283.1 448.2 346c6.8 20.7 9.7 41.1 7.4 52.3-1.7 8.5-1.7 8.5 1.4 4.6 6.1-7.7 19.9-31.3 25.4-43.5 7.4-16.2 15-40.2 18.6-58.7 4.3-22.5 3.9-70.8-.8-93.4zM141.3 43C189 40.5 251 77.5 255.6 78.4c.7.1 10.4-4.2 21.6-9.7 63.9-31.1 94-25.8 107.4-25.2-63.9-39.3-152.7-50-233.9-11.7-23.4 11.1-24 11.9-9.4 11.2z"
        ],
        "xing": [
            384,
            512,
            [],
            "f168",
            "M162.7 210c-1.8 3.3-25.2 44.4-70.1 123.5-4.9 8.3-10.8 12.5-17.7 12.5H9.8c-7.7 0-12.1-7.5-8.5-14.4l69-121.3c.2 0 .2-.1 0-.3l-43.9-75.6c-4.3-7.8.3-14.1 8.5-14.1H100c7.3 0 13.3 4.1 18 12.2l44.7 77.5zM382.6 46.1l-144 253v.3L330.2 466c3.9 7.1.2 14.1-8.5 14.1h-65.2c-7.6 0-13.6-4-18-12.2l-92.4-168.5c3.3-5.8 51.5-90.8 144.8-255.2 4.6-8.1 10.4-12.2 17.5-12.2h65.7c8 0 12.3 6.7 8.5 14.1z"
        ],
        "xing-square": [
            448,
            512,
            [],
            "f169",
            "M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM140.4 320.2H93.8c-5.5 0-8.7-5.3-6-10.3l49.3-86.7c.1 0 .1-.1 0-.2l-31.4-54c-3-5.6.2-10.1 6-10.1h46.6c5.2 0 9.5 2.9 12.9 8.7l31.9 55.3c-1.3 2.3-18 31.7-50.1 88.2-3.5 6.2-7.7 9.1-12.6 9.1zm219.7-214.1L257.3 286.8v.2l65.5 119c2.8 5.1.1 10.1-6 10.1h-46.6c-5.5 0-9.7-2.9-12.9-8.7l-66-120.3c2.3-4.1 36.8-64.9 103.4-182.3 3.3-5.8 7.4-8.7 12.5-8.7h46.9c5.7-.1 8.8 4.7 6 10z"
        ],
        "y-combinator": [
            448,
            512,
            [],
            "f23b",
            "M448 32v448H0V32h448zM236 287.5L313.5 142h-32.7L235 233c-4.7 9.3-9 18.3-12.8 26.8L210 233l-45.2-91h-35l76.7 143.8v94.5H236v-92.8z"
        ],
        "yahoo": [
            512,
            512,
            [],
            "f19e",
            "M223.69,141.06,167,284.23,111,141.06H14.93L120.76,390.19,82.19,480h94.17L317.27,141.06Zm105.4,135.79a58.22,58.22,0,1,0,58.22,58.22A58.22,58.22,0,0,0,329.09,276.85ZM394.65,32l-93,223.47H406.44L499.07,32Z"
        ],
        "yammer": [
            512,
            512,
            [],
            "f840",
            "M421.78 152.17A23.06 23.06 0 0 0 400.9 112c-.83.43-1.71.9-2.63 1.4-15.25 8.4-118.33 80.62-106.69 88.77s82.04-23.61 130.2-50zm0 217.17c-48.16-26.38-118.64-58.1-130.2-50s91.42 80.35 106.69 88.74c.92.51 1.8 1 2.63 1.41a23.07 23.07 0 0 0 20.88-40.15zM464.21 237c-.95 0-1.95-.06-3-.06-17.4 0-142.52 13.76-136.24 26.51s83.3 18.74 138.21 18.76a23 23 0 0 0 1-45.21zM31 96.65a24.88 24.88 0 0 1 46.14-18.4l81 205.06h1.21l77-203.53a23.52 23.52 0 0 1 44.45 15.27L171.2 368.44C152.65 415.66 134.08 448 77.91 448a139.67 139.67 0 0 1-23.81-1.95 21.31 21.31 0 0 1 6.9-41.77c.66.06 10.91.66 13.86.66 30.47 0 43.74-18.94 58.07-59.41z"
        ],
        "yandex": [
            256,
            512,
            [],
            "f413",
            "M153.1 315.8L65.7 512H2l96-209.8c-45.1-22.9-75.2-64.4-75.2-141.1C22.7 53.7 90.8 0 171.7 0H254v512h-55.1V315.8h-45.8zm45.8-269.3h-29.4c-44.4 0-87.4 29.4-87.4 114.6 0 82.3 39.4 108.8 87.4 108.8h29.4V46.5z"
        ],
        "yandex-international": [
            320,
            512,
            [],
            "f414",
            "M129.5 512V345.9L18.5 48h55.8l81.8 229.7L250.2 0h51.3L180.8 347.8V512h-51.3z"
        ],
        "yarn": [
            496,
            512,
            [],
            "f7e3",
            "M393.9 345.2c-39 9.3-48.4 32.1-104 47.4 0 0-2.7 4-10.4 5.8-13.4 3.3-63.9 6-68.5 6.1-12.4.1-19.9-3.2-22-8.2-6.4-15.3 9.2-22 9.2-22-8.1-5-9-9.9-9.8-8.1-2.4 5.8-3.6 20.1-10.1 26.5-8.8 8.9-25.5 5.9-35.3.8-10.8-5.7.8-19.2.8-19.2s-5.8 3.4-10.5-3.6c-6-9.3-17.1-37.3 11.5-62-1.3-10.1-4.6-53.7 40.6-85.6 0 0-20.6-22.8-12.9-43.3 5-13.4 7-13.3 8.6-13.9 5.7-2.2 11.3-4.6 15.4-9.1 20.6-22.2 46.8-18 46.8-18s12.4-37.8 23.9-30.4c3.5 2.3 16.3 30.6 16.3 30.6s13.6-7.9 15.1-5c8.2 16 9.2 46.5 5.6 65.1-6.1 30.6-21.4 47.1-27.6 57.5-1.4 2.4 16.5 10 27.8 41.3 10.4 28.6 1.1 52.7 2.8 55.3.8 1.4 13.7.8 36.4-13.2 12.8-7.9 28.1-16.9 45.4-17 16.7-.5 17.6 19.2 4.9 22.2zM496 256c0 136.9-111.1 248-248 248S0 392.9 0 256 111.1 8 248 8s248 111.1 248 248zm-79.3 75.2c-1.7-13.6-13.2-23-28-22.8-22 .3-40.5 11.7-52.8 19.2-4.8 3-8.9 5.2-12.4 6.8 3.1-44.5-22.5-73.1-28.7-79.4 7.8-11.3 18.4-27.8 23.4-53.2 4.3-21.7 3-55.5-6.9-74.5-1.6-3.1-7.4-11.2-21-7.4-9.7-20-13-22.1-15.6-23.8-1.1-.7-23.6-16.4-41.4 28-12.2.9-31.3 5.3-47.5 22.8-2 2.2-5.9 3.8-10.1 5.4h.1c-8.4 3-12.3 9.9-16.9 22.3-6.5 17.4.2 34.6 6.8 45.7-17.8 15.9-37 39.8-35.7 82.5-34 36-11.8 73-5.6 79.6-1.6 11.1 3.7 19.4 12 23.8 12.6 6.7 30.3 9.6 43.9 2.8 4.9 5.2 13.8 10.1 30 10.1 6.8 0 58-2.9 72.6-6.5 6.8-1.6 11.5-4.5 14.6-7.1 9.8-3.1 36.8-12.3 62.2-28.7 18-11.7 24.2-14.2 37.6-17.4 12.9-3.2 21-15.1 19.4-28.2z"
        ],
        "yelp": [
            384,
            512,
            [],
            "f1e9",
            "M42.9 240.32l99.62 48.61c19.2 9.4 16.2 37.51-4.5 42.71L30.5 358.45a22.79 22.79 0 0 1-28.21-19.6 197.16 197.16 0 0 1 9-85.32 22.8 22.8 0 0 1 31.61-13.21zm44 239.25a199.45 199.45 0 0 0 79.42 32.11A22.78 22.78 0 0 0 192.94 490l3.9-110.82c.7-21.3-25.5-31.91-39.81-16.1l-74.21 82.4a22.82 22.82 0 0 0 4.09 34.09zm145.34-109.92l58.81 94a22.93 22.93 0 0 0 34 5.5 198.36 198.36 0 0 0 52.71-67.61A23 23 0 0 0 364.17 370l-105.42-34.26c-20.31-6.5-37.81 15.8-26.51 33.91zm148.33-132.23a197.44 197.44 0 0 0-50.41-69.31 22.85 22.85 0 0 0-34 4.4l-62 91.92c-11.9 17.7 4.7 40.61 25.2 34.71L366 268.63a23 23 0 0 0 14.61-31.21zM62.11 30.18a22.86 22.86 0 0 0-9.9 32l104.12 180.44c11.7 20.2 42.61 11.9 42.61-11.4V22.88a22.67 22.67 0 0 0-24.5-22.8 320.37 320.37 0 0 0-112.33 30.1z"
        ],
        "yoast": [
            448,
            512,
            [],
            "f2b1",
            "M91.3 76h186l-7 18.9h-179c-39.7 0-71.9 31.6-71.9 70.3v205.4c0 35.4 24.9 70.3 84 70.3V460H91.3C41.2 460 0 419.8 0 370.5V165.2C0 115.9 40.7 76 91.3 76zm229.1-56h66.5C243.1 398.1 241.2 418.9 202.2 459.3c-20.8 21.6-49.3 31.7-78.3 32.7v-51.1c49.2-7.7 64.6-49.9 64.6-75.3 0-20.1.6-12.6-82.1-223.2h61.4L218.2 299 320.4 20zM448 161.5V460H234c6.6-9.6 10.7-16.3 12.1-19.4h182.5V161.5c0-32.5-17.1-51.9-48.2-62.9l6.7-17.6c41.7 13.6 60.9 43.1 60.9 80.5z"
        ],
        "youtube": [
            576,
            512,
            [],
            "f167",
            "M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z"
        ],
        "youtube-square": [
            448,
            512,
            [],
            "f431",
            "M186.8 202.1l95.2 54.1-95.2 54.1V202.1zM448 80v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-42 176.3s0-59.6-7.6-88.2c-4.2-15.8-16.5-28.2-32.2-32.4C337.9 128 224 128 224 128s-113.9 0-142.2 7.7c-15.7 4.2-28 16.6-32.2 32.4-7.6 28.5-7.6 88.2-7.6 88.2s0 59.6 7.6 88.2c4.2 15.8 16.5 27.7 32.2 31.9C110.1 384 224 384 224 384s113.9 0 142.2-7.7c15.7-4.2 28-16.1 32.2-31.9 7.6-28.5 7.6-88.1 7.6-88.1z"
        ],
        "zhihu": [
            640,
            512,
            [],
            "f63f",
            "M170.54 148.13v217.54l23.43.01 7.71 26.37 42.01-26.37h49.53V148.13H170.54zm97.75 193.93h-27.94l-27.9 17.51-5.08-17.47-11.9-.04V171.75h72.82v170.31zm-118.46-94.39H97.5c1.74-27.1 2.2-51.59 2.2-73.46h51.16s1.97-22.56-8.58-22.31h-88.5c3.49-13.12 7.87-26.66 13.12-40.67 0 0-24.07 0-32.27 21.57-3.39 8.9-13.21 43.14-30.7 78.12 5.89-.64 25.37-1.18 36.84-22.21 2.11-5.89 2.51-6.66 5.14-14.53h28.87c0 10.5-1.2 66.88-1.68 73.44H20.83c-11.74 0-15.56 23.62-15.56 23.62h65.58C66.45 321.1 42.83 363.12 0 396.34c20.49 5.85 40.91-.93 51-9.9 0 0 22.98-20.9 35.59-69.25l53.96 64.94s7.91-26.89-1.24-39.99c-7.58-8.92-28.06-33.06-36.79-41.81L87.9 311.95c4.36-13.98 6.99-27.55 7.87-40.67h61.65s-.09-23.62-7.59-23.62v.01zm412.02-1.6c20.83-25.64 44.98-58.57 44.98-58.57s-18.65-14.8-27.38-4.06c-6 8.15-36.83 48.2-36.83 48.2l19.23 14.43zm-150.09-59.09c-9.01-8.25-25.91 2.13-25.91 2.13s39.52 55.04 41.12 57.45l19.46-13.73s-25.67-37.61-34.66-45.86h-.01zM640 258.35c-19.78 0-130.91.93-131.06.93v-101c4.81 0 12.42-.4 22.85-1.2 40.88-2.41 70.13-4 87.77-4.81 0 0 12.22-27.19-.59-33.44-3.07-1.18-23.17 4.58-23.17 4.58s-165.22 16.49-232.36 18.05c1.6 8.82 7.62 17.08 15.78 19.55 13.31 3.48 22.69 1.7 49.15.89 24.83-1.6 43.68-2.43 56.51-2.43v99.81H351.41s2.82 22.31 25.51 22.85h107.94v70.92c0 13.97-11.19 21.99-24.48 21.12-14.08.11-26.08-1.15-41.69-1.81 1.99 3.97 6.33 14.39 19.31 21.84 9.88 4.81 16.17 6.57 26.02 6.57 29.56 0 45.67-17.28 44.89-45.31v-73.32h122.36c9.68 0 8.7-23.78 8.7-23.78l.03-.01z"
        ]
    };
    bunker(function() {
        defineIcons("fab", icons);
    });
})();


0, {};
(0, (/*@__PURE__*/$parcel$interopDefault($b4ba1c853f6e1116$exports))).render(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).StrictMode, {
    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fe07e27ecf0fa1d7$export$14faa19a0f3bbeb2), {
        appearance: "dark",
        accentColor: "green",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6aaba76260e26777$export$2e2bcd8739ae039), {})
    })
}), document.getElementById("root"));


//# sourceMappingURL=index.5a67e28f.js.map
